import "core-js/modules/es.regexp.flags.js";
import * as Bn from "react";
import Nt, { forwardRef as Qn, useRef as vt, useCallback as pn, useId as ME, useState as rt, useEffect as Rt, createContext as Up, useMemo as ci, useImperativeHandle as jR, Children as AT, isValidElement as rR, cloneElement as FR, useContext as bs, Fragment as Qv, useLayoutEffect as NR, useReducer as MW, Component as oH, createElement as lH, lazy as kF, Suspense as TF, PureComponent as LW, useInsertionEffect as OW } from "react";
import './assets/main.css';
function sH(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function uH(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.keys(t).forEach(function (s) {
    var c = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(i, s, c.get ? c : {
      enumerable: !0,
      get: function () {
        return t[s];
      }
    });
  }), i;
}
var rj = {
    exports: {}
  },
  vT = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wz;
function PW() {
  if (Wz) return vT;
  Wz = 1;
  var t = Nt,
    e = Symbol.for("react.element"),
    i = Symbol.for("react.fragment"),
    s = Object.prototype.hasOwnProperty,
    c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function h(y, w, x) {
    var E,
      C = {},
      k = null,
      D = null;
    x !== void 0 && (k = "" + x), w.key !== void 0 && (k = "" + w.key), w.ref !== void 0 && (D = w.ref);
    for (E in w) s.call(w, E) && !p.hasOwnProperty(E) && (C[E] = w[E]);
    if (y && y.defaultProps) for (E in w = y.defaultProps, w) C[E] === void 0 && (C[E] = w[E]);
    return {
      $$typeof: e,
      type: y,
      key: k,
      ref: D,
      props: C,
      _owner: c.current
    };
  }
  return vT.Fragment = i, vT.jsx = h, vT.jsxs = h, vT;
}
var eM = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qz;
function AW() {
  return qz || (qz = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Nt,
      e = Symbol.for("react.element"),
      i = Symbol.for("react.portal"),
      s = Symbol.for("react.fragment"),
      c = Symbol.for("react.strict_mode"),
      p = Symbol.for("react.profiler"),
      h = Symbol.for("react.provider"),
      y = Symbol.for("react.context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = Symbol.iterator,
      L = "@@iterator";
    function P(Z) {
      if (Z === null || typeof Z != "object") return null;
      var Ne = I && Z[I] || Z[L];
      return typeof Ne == "function" ? Ne : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(Z) {
      {
        for (var Ne = arguments.length, Ye = new Array(Ne > 1 ? Ne - 1 : 0), xt = 1; xt < Ne; xt++) Ye[xt - 1] = arguments[xt];
        F("error", Z, Ye);
      }
    }
    function F(Z, Ne, Ye) {
      {
        var xt = N.ReactDebugCurrentFrame,
          rn = xt.getStackAddendum();
        rn !== "" && (Ne += "%s", Ye = Ye.concat([rn]));
        var $t = Ye.map(function (Ct) {
          return String(Ct);
        });
        $t.unshift("Warning: " + Ne), Function.prototype.apply.call(console[Z], console, $t);
      }
    }
    var j = !1,
      V = !1,
      K = !1,
      G = !1,
      Q = !1,
      te;
    te = Symbol.for("react.module.reference");
    function ie(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === s || Z === p || Q || Z === c || Z === x || Z === E || G || Z === D || j || V || K || typeof Z == "object" && Z !== null && (Z.$$typeof === k || Z.$$typeof === C || Z.$$typeof === h || Z.$$typeof === y || Z.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === te || Z.getModuleId !== void 0));
    }
    function Y(Z, Ne, Ye) {
      var xt = Z.displayName;
      if (xt) return xt;
      var rn = Ne.displayName || Ne.name || "";
      return rn !== "" ? Ye + "(" + rn + ")" : Ye;
    }
    function ee(Z) {
      return Z.displayName || "Context";
    }
    function ae(Z) {
      if (Z == null) return null;
      if (typeof Z.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Z == "function") return Z.displayName || Z.name || null;
      if (typeof Z == "string") return Z;
      switch (Z) {
        case s:
          return "Fragment";
        case i:
          return "Portal";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case y:
          var Ne = Z;
          return ee(Ne) + ".Consumer";
        case h:
          var Ye = Z;
          return ee(Ye._context) + ".Provider";
        case w:
          return Y(Z, Z.render, "ForwardRef");
        case C:
          var xt = Z.displayName || null;
          return xt !== null ? xt : ae(Z.type) || "Memo";
        case k:
          {
            var rn = Z,
              $t = rn._payload,
              Ct = rn._init;
            try {
              return ae(Ct($t));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var ne = Object.assign,
      le = 0,
      ce,
      W,
      $,
      de,
      H,
      se,
      ue;
    function Ee() {}
    Ee.__reactDisabledLog = !0;
    function Ce() {
      {
        if (le === 0) {
          ce = console.log, W = console.info, $ = console.warn, de = console.error, H = console.group, se = console.groupCollapsed, ue = console.groupEnd;
          var Z = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Z,
            log: Z,
            warn: Z,
            error: Z,
            group: Z,
            groupCollapsed: Z,
            groupEnd: Z
          });
        }
        le++;
      }
    }
    function fe() {
      {
        if (le--, le === 0) {
          var Z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ne({}, Z, {
              value: ce
            }),
            info: ne({}, Z, {
              value: W
            }),
            warn: ne({}, Z, {
              value: $
            }),
            error: ne({}, Z, {
              value: de
            }),
            group: ne({}, Z, {
              value: H
            }),
            groupCollapsed: ne({}, Z, {
              value: se
            }),
            groupEnd: ne({}, Z, {
              value: ue
            })
          });
        }
        le < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = N.ReactCurrentDispatcher,
      Se;
    function be(Z, Ne, Ye) {
      {
        if (Se === void 0) try {
          throw Error();
        } catch (rn) {
          var xt = rn.stack.trim().match(/\n( *(at )?)/);
          Se = xt && xt[1] || "";
        }
        return `
` + Se + Z;
      }
    }
    var Le = !1,
      Be;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Be = new Xe();
    }
    function ge(Z, Ne) {
      if (!Z || Le) return "";
      {
        var Ye = Be.get(Z);
        if (Ye !== void 0) return Ye;
      }
      var xt;
      Le = !0;
      var rn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = _e.current, _e.current = null, Ce();
      try {
        if (Ne) {
          var Ct = function () {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (Wi) {
              xt = Wi;
            }
            Reflect.construct(Z, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (Wi) {
              xt = Wi;
            }
            Z.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wi) {
            xt = Wi;
          }
          Z();
        }
      } catch (Wi) {
        if (Wi && xt && typeof Wi.stack == "string") {
          for (var qt = Wi.stack.split(`
`), yr = xt.stack.split(`
`), Tn = qt.length - 1, jn = yr.length - 1; Tn >= 1 && jn >= 0 && qt[Tn] !== yr[jn];) jn--;
          for (; Tn >= 1 && jn >= 0; Tn--, jn--) if (qt[Tn] !== yr[jn]) {
            if (Tn !== 1 || jn !== 1) do if (Tn--, jn--, jn < 0 || qt[Tn] !== yr[jn]) {
              var Or = `
` + qt[Tn].replace(" at new ", " at ");
              return Z.displayName && Or.includes("<anonymous>") && (Or = Or.replace("<anonymous>", Z.displayName)), typeof Z == "function" && Be.set(Z, Or), Or;
            } while (Tn >= 1 && jn >= 0);
            break;
          }
        }
      } finally {
        Le = !1, _e.current = $t, fe(), Error.prepareStackTrace = rn;
      }
      var Wa = Z ? Z.displayName || Z.name : "",
        Ru = Wa ? be(Wa) : "";
      return typeof Z == "function" && Be.set(Z, Ru), Ru;
    }
    function qe(Z, Ne, Ye) {
      return ge(Z, !1);
    }
    function Ae(Z) {
      var Ne = Z.prototype;
      return !!(Ne && Ne.isReactComponent);
    }
    function Mt(Z, Ne, Ye) {
      if (Z == null) return "";
      if (typeof Z == "function") return ge(Z, Ae(Z));
      if (typeof Z == "string") return be(Z);
      switch (Z) {
        case x:
          return be("Suspense");
        case E:
          return be("SuspenseList");
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case w:
          return qe(Z.render);
        case C:
          return Mt(Z.type, Ne, Ye);
        case k:
          {
            var xt = Z,
              rn = xt._payload,
              $t = xt._init;
            try {
              return Mt($t(rn), Ne, Ye);
            } catch {}
          }
      }
      return "";
    }
    var Ft = Object.prototype.hasOwnProperty,
      un = {},
      gt = N.ReactDebugCurrentFrame;
    function Pt(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        gt.setExtraStackFrame(Ye);
      } else gt.setExtraStackFrame(null);
    }
    function St(Z, Ne, Ye, xt, rn) {
      {
        var $t = Function.call.bind(Ft);
        for (var Ct in Z) if ($t(Z, Ct)) {
          var qt = void 0;
          try {
            if (typeof Z[Ct] != "function") {
              var yr = Error((xt || "React class") + ": " + Ye + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw yr.name = "Invariant Violation", yr;
            }
            qt = Z[Ct](Ne, Ct, xt, Ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (Tn) {
            qt = Tn;
          }
          qt && !(qt instanceof Error) && (Pt(rn), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xt || "React class", Ye, Ct, typeof qt), Pt(null)), qt instanceof Error && !(qt.message in un) && (un[qt.message] = !0, Pt(rn), O("Failed %s type: %s", Ye, qt.message), Pt(null));
        }
      }
    }
    var Dt = Array.isArray;
    function Kt(Z) {
      return Dt(Z);
    }
    function hn(Z) {
      {
        var Ne = typeof Symbol == "function" && Symbol.toStringTag,
          Ye = Ne && Z[Symbol.toStringTag] || Z.constructor.name || "Object";
        return Ye;
      }
    }
    function Lt(Z) {
      try {
        return Et(Z), !1;
      } catch {
        return !0;
      }
    }
    function Et(Z) {
      return "" + Z;
    }
    function Vt(Z) {
      if (Lt(Z)) return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(Z)), Et(Z);
    }
    var Xt = N.ReactCurrentOwner,
      vn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      ot,
      We;
    function ht(Z) {
      if (Ft.call(Z, "ref")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "ref").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.ref !== void 0;
    }
    function Ke(Z) {
      if (Ft.call(Z, "key")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "key").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.key !== void 0;
    }
    function yt(Z, Ne) {
      typeof Z.ref == "string" && Xt.current;
    }
    function je(Z, Ne) {
      {
        var Ye = function () {
          ot || (ot = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "key", {
          get: Ye,
          configurable: !0
        });
      }
    }
    function at(Z, Ne) {
      {
        var Ye = function () {
          We || (We = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "ref", {
          get: Ye,
          configurable: !0
        });
      }
    }
    var kt = function (Z, Ne, Ye, xt, rn, $t, Ct) {
      var qt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Z,
        key: Ne,
        ref: Ye,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return qt._store = {}, Object.defineProperty(qt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(qt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xt
      }), Object.defineProperty(qt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rn
      }), Object.freeze && (Object.freeze(qt.props), Object.freeze(qt)), qt;
    };
    function Bt(Z, Ne, Ye, xt, rn) {
      {
        var $t,
          Ct = {},
          qt = null,
          yr = null;
        Ye !== void 0 && (Vt(Ye), qt = "" + Ye), Ke(Ne) && (Vt(Ne.key), qt = "" + Ne.key), ht(Ne) && (yr = Ne.ref, yt(Ne));
        for ($t in Ne) Ft.call(Ne, $t) && !vn.hasOwnProperty($t) && (Ct[$t] = Ne[$t]);
        if (Z && Z.defaultProps) {
          var Tn = Z.defaultProps;
          for ($t in Tn) Ct[$t] === void 0 && (Ct[$t] = Tn[$t]);
        }
        if (qt || yr) {
          var jn = typeof Z == "function" ? Z.displayName || Z.name || "Unknown" : Z;
          qt && je(Ct, jn), yr && at(Ct, jn);
        }
        return kt(Z, qt, yr, rn, xt, Xt.current, Ct);
      }
    }
    var Ht = N.ReactCurrentOwner,
      sn = N.ReactDebugCurrentFrame;
    function en(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        sn.setExtraStackFrame(Ye);
      } else sn.setExtraStackFrame(null);
    }
    var Rr;
    Rr = !1;
    function Nr(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function Hi() {
      {
        if (Ht.current) {
          var Z = ae(Ht.current.type);
          if (Z) return `

Check the render method of \`` + Z + "`.";
        }
        return "";
      }
    }
    function ss(Z) {
      return "";
    }
    var yo = {};
    function _s(Z) {
      {
        var Ne = Hi();
        if (!Ne) {
          var Ye = typeof Z == "string" ? Z : Z.displayName || Z.name;
          Ye && (Ne = `

Check the top-level render call using <` + Ye + ">.");
        }
        return Ne;
      }
    }
    function Mo(Z, Ne) {
      {
        if (!Z._store || Z._store.validated || Z.key != null) return;
        Z._store.validated = !0;
        var Ye = _s(Ne);
        if (yo[Ye]) return;
        yo[Ye] = !0;
        var xt = "";
        Z && Z._owner && Z._owner !== Ht.current && (xt = " It was passed a child from " + ae(Z._owner.type) + "."), en(Z), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ye, xt), en(null);
      }
    }
    function bo(Z, Ne) {
      {
        if (typeof Z != "object") return;
        if (Kt(Z)) for (var Ye = 0; Ye < Z.length; Ye++) {
          var xt = Z[Ye];
          Nr(xt) && Mo(xt, Ne);
        } else if (Nr(Z)) Z._store && (Z._store.validated = !0);else if (Z) {
          var rn = P(Z);
          if (typeof rn == "function" && rn !== Z.entries) for (var $t = rn.call(Z), Ct; !(Ct = $t.next()).done;) Nr(Ct.value) && Mo(Ct.value, Ne);
        }
      }
    }
    function Tu(Z) {
      {
        var Ne = Z.type;
        if (Ne == null || typeof Ne == "string") return;
        var Ye;
        if (typeof Ne == "function") Ye = Ne.propTypes;else if (typeof Ne == "object" && (Ne.$$typeof === w ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ne.$$typeof === C)) Ye = Ne.propTypes;else return;
        if (Ye) {
          var xt = ae(Ne);
          St(Ye, Z.props, "prop", xt, Z);
        } else if (Ne.PropTypes !== void 0 && !Rr) {
          Rr = !0;
          var rn = ae(Ne);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rn || "Unknown");
        }
        typeof Ne.getDefaultProps == "function" && !Ne.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ha(Z) {
      {
        for (var Ne = Object.keys(Z.props), Ye = 0; Ye < Ne.length; Ye++) {
          var xt = Ne[Ye];
          if (xt !== "children" && xt !== "key") {
            en(Z), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xt), en(null);
            break;
          }
        }
        Z.ref !== null && (en(Z), O("Invalid attribute `ref` supplied to `React.Fragment`."), en(null));
      }
    }
    function $i(Z, Ne, Ye, xt, rn, $t) {
      {
        var Ct = ie(Z);
        if (!Ct) {
          var qt = "";
          (Z === void 0 || typeof Z == "object" && Z !== null && Object.keys(Z).length === 0) && (qt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yr = ss();
          yr ? qt += yr : qt += Hi();
          var Tn;
          Z === null ? Tn = "null" : Kt(Z) ? Tn = "array" : Z !== void 0 && Z.$$typeof === e ? (Tn = "<" + (ae(Z.type) || "Unknown") + " />", qt = " Did you accidentally export a JSX literal instead of a component?") : Tn = typeof Z, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tn, qt);
        }
        var jn = Bt(Z, Ne, Ye, rn, $t);
        if (jn == null) return jn;
        if (Ct) {
          var Or = Ne.children;
          if (Or !== void 0) if (xt) {
            if (Kt(Or)) {
              for (var Wa = 0; Wa < Or.length; Wa++) bo(Or[Wa], Z);
              Object.freeze && Object.freeze(Or);
            } else O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else bo(Or, Z);
        }
        return Z === s ? Ha(jn) : Tu(jn), jn;
      }
    }
    function oi(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !0);
    }
    function Lo(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !1);
    }
    var $a = Lo,
      Oo = oi;
    eM.Fragment = s, eM.jsx = $a, eM.jsxs = Oo;
  }()), eM;
}
var Yz;
function jW() {
  return Yz || (Yz = 1, process.env.NODE_ENV === "production" ? rj.exports = PW() : rj.exports = AW()), rj.exports;
}
var we = jW();
const up = "Accordion",
  tL = "AccordionItem",
  cH = "AccordionHeader",
  w2 = "AccordionTrigger",
  dH = "AccordionContent",
  FW = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
function LE(t, e = []) {
  let i = [];
  function s(p, h) {
    const y = Up(h),
      w = i.length;
    i = [...i, h];
    const x = C => {
      var k;
      const {
          scope: D,
          children: I,
          ...L
        } = C,
        P = ((k = D == null ? void 0 : D[t]) == null ? void 0 : k[w]) || y,
        N = ci(() => L, Object.values(L));
      return /* @__PURE__ */we.jsx(P.Provider, {
        value: N,
        children: I
      });
    };
    x.displayName = p + "Provider";
    function E(C, k) {
      var D;
      const I = ((D = k == null ? void 0 : k[t]) == null ? void 0 : D[w]) || y,
        L = bs(I);
      if (L) return L;
      if (h !== void 0) return h;
      throw new Error(`\`${C}\` must be used within \`${p}\``);
    }
    return [x, E];
  }
  const c = () => {
    const p = i.map(h => Up(h));
    return function (h) {
      const y = (h == null ? void 0 : h[t]) || p;
      return ci(() => ({
        [`__scope${t}`]: {
          ...h,
          [t]: y
        }
      }), [h, y]);
    };
  };
  return c.scopeName = t, [s, NW(c, ...e)];
}
function NW(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const i = () => {
    const s = t.map(c => ({
      useScope: c(),
      scopeName: c.scopeName
    }));
    return function (c) {
      const p = s.reduce((h, {
        useScope: y,
        scopeName: w
      }) => {
        const x = y(c)[`__scope${w}`];
        return {
          ...h,
          ...x
        };
      }, {});
      return ci(() => ({
        [`__scope${e.scopeName}`]: p
      }), [p]);
    };
  };
  return i.scopeName = e.scopeName, i;
}
function Gz(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
function zW(...t) {
  return e => {
    const i = t.map(s => Gz(s, e));
    if (i.some(s => typeof s == "function")) return () => {
      i.forEach((s, c) => {
        typeof s == "function" ? s() : Gz(t[c], null);
      });
    };
  };
}
function _E(...t) {
  return pn(zW(...t), t);
}
const VW = t => /^on[A-Z]/.test(t),
  BW = (t, e) => {
    const i = {
      ...e
    };
    return Object.entries(e).forEach(([s, c]) => {
      const p = t[s];
      VW(s) && p && c ? i[s] = (...h) => {
        const y = c(...h);
        return p(...h), y;
      } : s === "style" ? i[s] = {
        ...p,
        ...c
      } : s === "className" && (i[s] = [p, c].filter(Boolean).join(" "));
    }), {
      ...t,
      ...i
    };
  },
  UW = t => "ref" in t ? t.ref : t.props.ref,
  HW = t => rR(t) && typeof t.type == "function",
  $W = t => {
    const e = Qn((i, s) => {
      const {
        children: c,
        ...p
      } = i;
      if (!rR(c)) return AT.count(c) > 1 ? AT.only(null) : null;
      const h = UW(c),
        y = _E(h, s),
        w = BW(p, c.props);
      return c.type !== Qv && (w.ref = y), FR(c, w);
    });
    return e.displayName = `${t}SlotClone`, e;
  },
  nL = t => {
    const e = $W(t),
      i = Qn((s, c) => {
        const {
            children: p,
            ...h
          } = s,
          y = AT.toArray(p),
          w = y.find(HW);
        if (!w) return /* @__PURE__ */we.jsx(e, {
          ...h,
          ref: c,
          children: p
        });
        const x = w.props.children,
          E = y.map(C => C === w ? AT.count(x) > 1 ? AT.only(null) : rR(x) ? x.props.children : null : C);
        return /* @__PURE__ */we.jsx(e, {
          ...h,
          ref: c,
          children: rR(x) ? FR(x, void 0, E) : null
        });
      });
    return i.displayName = `${t}Slot`, i;
  };
nL("Base");
function fH(t) {
  const e = `${t}CollectionProvider`,
    [i, s] = LE(e),
    [c, p] = i(e, {
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    h = L => {
      const {
          scope: P,
          children: N
        } = L,
        O = vt(null),
        F = vt(/* @__PURE__ */new Map()).current;
      return /* @__PURE__ */we.jsx(c, {
        scope: P,
        itemMap: F,
        collectionRef: O,
        children: N
      });
    };
  h.displayName = e;
  const y = `${t}CollectionSlot`,
    w = nL(y),
    x = Qn((L, P) => {
      const {
          scope: N,
          children: O
        } = L,
        F = p(y, N),
        j = _E(P, F.collectionRef);
      return /* @__PURE__ */we.jsx(w, {
        ref: j,
        children: O
      });
    });
  x.displayName = y;
  const E = `${t}CollectionItemSlot`,
    C = "data-collection-item",
    k = nL(E),
    D = Qn((L, P) => {
      const {
          scope: N,
          children: O,
          ...F
        } = L,
        j = vt(null),
        V = _E(P, j),
        K = p(E, N);
      return Rt(() => (K.itemMap.set(j, {
        ref: j,
        ...F
      }), () => void K.itemMap.delete(j))), /* @__PURE__ */we.jsx(k, {
        ref: V,
        [C]: "",
        children: O
      });
    });
  D.displayName = E;
  function I(L) {
    const P = p(t + "CollectionConsumer", L);
    return pn(() => {
      const N = P == null ? void 0 : P.collectionRef,
        O = N && "current" in N ? N.current : null;
      if (!O) return [];
      const F = Array.from(O.querySelectorAll(C));
      return Array.from(P.itemMap.values()).sort((j, V) => F.indexOf(j.ref.current) - F.indexOf(V.ref.current));
    }, [P.collectionRef, P.itemMap]);
  }
  return [{
    Provider: h,
    Slot: x,
    ItemSlot: D
  }, I, s];
}
const [WW, pH] = LE("Disclosure"),
  [qW, hH] = WW("Disclosure"),
  [RF, YW, GW] = fH(up),
  DF = pH(),
  [VL, k_e] = LE(up, [GW, pH]),
  [mH, vH] = VL(up),
  [gH, XW] = VL(up, {
    collapsible: !1
  }),
  [KW, BL] = VL(up),
  [QW, IF] = VL(tL);
function OE(t) {
  return t ? "open" : "closed";
}
const ZW = ["a", "button", "div", "h1", "h2", "h3", "h4", "img", "input", "label", "li", "nav", "ol", "p", "section", "select", "span", "ul"],
  la = ZW.reduce((t, e) => {
    const i = nL(`BaseComponent.${e}`),
      s = Qn((c, p) => {
        const {
            asChild: h,
            ...y
          } = c,
          w = h ? i : e;
        return /* @__PURE__ */we.jsx(w, {
          ...y,
          ref: p
        });
      });
    return s.displayName = `BaseComponent.${e}`, {
      ...t,
      [e]: s
    };
  }, {}),
  yH = Qn((t, e) => {
    const {
        __scopeDisclosure: i,
        children: s,
        ...c
      } = t,
      p = hH("DisclosureContent", i),
      h = vt(null),
      y = _E(e, h),
      w = p.open;
    return /* @__PURE__ */we.jsx(la.div, {
      "data-state": OE(p.open),
      "data-disabled": p.disabled ? "" : void 0,
      id: p.contentId,
      hidden: !w,
      ...c,
      ref: y,
      children: s
    });
  });
yH.displayName = "DisclosureContent";
const bH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...s
    } = t,
    c = BL(up, i),
    p = IF(dH, i),
    h = DF(i);
  return /* @__PURE__ */we.jsx(yH, {
    role: "region",
    "aria-labelledby": p.triggerId,
    "data-orientation": c.orientation,
    ...h,
    ...s,
    ref: e
  });
});
bH.displayName = dH;
const wH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...s
    } = t,
    c = BL(up, i),
    p = IF(cH, i);
  return /* @__PURE__ */we.jsx(la.h3, {
    "data-orientation": c.orientation,
    "data-state": OE(p.open),
    "data-disabled": p.disabled ? "" : void 0,
    ...s,
    ref: e
  });
});
wH.displayName = cH;
function PE({
  prop: t,
  defaultProp: e,
  onChange: i = () => {}
}) {
  const [s, c, p] = JW({
      defaultProp: e,
      onChange: i
    }),
    h = t !== void 0,
    y = h ? t : s,
    w = pn(x => {
      var E;
      if (h) {
        const C = e9(x) ? x(t) : x;
        C !== t && ((E = p.current) == null || E.call(p, C));
      } else c(x);
    }, [h, t, c, p]);
  return [y, w];
}
function JW({
  defaultProp: t,
  onChange: e
}) {
  const [i, s] = rt(t),
    c = vt(i),
    p = vt(e);
  return Rt(() => {
    var h;
    c.current !== i && ((h = p.current) == null || h.call(p, i), c.current = i);
  }, [i, c]), [i, s, p];
}
function e9(t) {
  return typeof t == "function";
}
const _H = Qn((t, e) => {
  const {
      __scopeDisclosure: i,
      ...s
    } = t,
    c = hH("DisclosureTrigger", i);
  return /* @__PURE__ */we.jsx(la.button, {
    type: "button",
    "aria-controls": c.contentId,
    "aria-expanded": c.open || !1,
    "data-state": OE(c.open),
    "data-disabled": c.disabled,
    disabled: c.disabled,
    ...s,
    ref: e,
    onClick: c.onOpenToggle
  });
});
_H.displayName = "DisclosureTrigger";
const xH = Qn((t, e) => {
  const {
      __scopeDisclosure: i,
      open: s,
      defaultOpen: c,
      disabled: p,
      onOpenChange: h,
      ...y
    } = t,
    [w, x] = PE({
      prop: s,
      defaultProp: c ?? !1,
      onChange: h
    }),
    E = pn(() => {
      x(C => !C);
    }, [x]);
  return /* @__PURE__ */we.jsx(qW, {
    scope: i,
    disabled: p,
    contentId: ME(),
    open: w,
    onOpenToggle: E,
    children: /* @__PURE__ */we.jsx(la.div, {
      "data-state": OE(w),
      "data-disabled": p ? "" : void 0,
      ...y,
      ref: e
    })
  });
});
xH.displayName = "Disclosure";
const SH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      value: s,
      ...c
    } = t,
    p = BL(tL, i),
    h = vH(tL, i),
    y = DF(i),
    w = ME(),
    x = s && h.value.includes(s) || !1,
    E = p.disabled || t.disabled;
  return /* @__PURE__ */we.jsx(QW, {
    scope: i,
    open: x,
    disabled: E,
    triggerId: w,
    children: /* @__PURE__ */we.jsx(xH, {
      "data-orientation": p.orientation,
      "data-state": OE(x),
      ...y,
      ...c,
      ref: e,
      disabled: E,
      open: x,
      onOpenChange: C => {
        C ? h.onItemOpen(s) : h.onItemClose(s);
      }
    })
  });
});
SH.displayName = tL;
function zp(t, e, {
  isDefaultPrevented: i = !0
} = {}) {
  return function (s) {
    if (t == null || t(s), i === !1 || !s.defaultPrevented) return e == null ? void 0 : e(s);
  };
}
const MF = Nt.forwardRef((t, e) => {
  const {
      __scopeAccordion: i,
      disabled: s,
      dir: c,
      orientation: p = "vertical",
      ...h
    } = t,
    y = Nt.useRef(null),
    w = _E(y, e),
    x = YW(i),
    E = c === "ltr",
    C = zp(t.onKeyDown, k => {
      var D;
      if (!FW.includes(k.key)) return;
      const I = k.target,
        L = x().filter(Q => {
          var te;
          return !((te = Q.ref.current) != null && te.disabled);
        }),
        P = L.findIndex(Q => Q.ref.current === I),
        N = L.length;
      if (P === -1) return;
      k.preventDefault();
      let O = P;
      const F = 0,
        j = N - 1,
        V = () => {
          O = P + 1, O > j && (O = F);
        },
        K = () => {
          O = P - 1, O < F && (O = j);
        };
      switch (k.key) {
        case "Home":
          O = F;
          break;
        case "End":
          O = j;
          break;
        case "ArrowRight":
          p === "horizontal" && (E ? V() : K());
          break;
        case "ArrowDown":
          p === "vertical" && V();
          break;
        case "ArrowLeft":
          p === "horizontal" && (E ? K() : V());
          break;
        case "ArrowUp":
          p === "vertical" && K();
          break;
      }
      const G = O % N;
      (D = L[G].ref.current) == null || D.focus();
    });
  return /* @__PURE__ */we.jsx(KW, {
    scope: i,
    disabled: s,
    direction: c,
    orientation: p,
    children: /* @__PURE__ */we.jsx(RF.Slot, {
      scope: i,
      children: /* @__PURE__ */we.jsx(la.div, {
        ...h,
        "data-orientation": p,
        ref: w,
        onKeyDown: s ? void 0 : C
      })
    })
  });
});
MF.displayName = up + "Base";
const EH = Qn((t, e) => {
  const {
      value: i,
      defaultValue: s,
      onValueChange: c = () => {},
      collapsible: p = !1,
      ...h
    } = t,
    [y, w] = PE({
      prop: i,
      defaultProp: s ?? [],
      onChange: c
    }),
    x = Nt.useCallback(I => {
      w((L = []) => [...L, I]);
    }, [w]),
    E = Nt.useCallback(I => w((L = []) => L.filter(P => P !== I)), [w]),
    C = () => Nt.Children.toArray(t.children).filter(I => Nt.isValidElement(I) && I.props.value).map(I => I.props.value),
    k = Nt.useCallback(() => {
      const I = C();
      w(I);
    }, [w, t.children]),
    D = Nt.useCallback(() => {
      w([]);
    }, [w]);
  return /* @__PURE__ */we.jsx(mH, {
    scope: t.__scopeAccordion,
    value: y,
    onItemOpen: x,
    onItemClose: E,
    expandAll: k,
    collapseAll: D,
    children: /* @__PURE__ */we.jsx(gH, {
      scope: t.__scopeAccordion,
      collapsible: p,
      children: /* @__PURE__ */we.jsx(MF, {
        ...h,
        ref: e
      })
    })
  });
});
EH.displayName = up + "Multiple";
const CH = Qn(function (t, e) {
  const {
      value: i,
      defaultValue: s,
      onValueChange: c = () => {},
      collapsible: p = !1,
      ...h
    } = t,
    [y, w] = PE({
      prop: i,
      defaultProp: s ?? "",
      onChange: c
    });
  return /* @__PURE__ */we.jsx(mH, {
    scope: t.__scopeAccordion,
    value: Nt.useMemo(() => y ? [y] : [], [y]),
    onItemOpen: w,
    onItemClose: Nt.useCallback(() => p && w(""), [p, w]),
    children: /* @__PURE__ */we.jsx(gH, {
      scope: t.__scopeAccordion,
      collapsible: p,
      children: /* @__PURE__ */we.jsx(MF, {
        ...h,
        ref: e
      })
    })
  });
});
CH.displayName = up + "Single";
const kH = Qn(function (t, e) {
  const {
      __scopeAccordion: i,
      ...s
    } = t,
    c = BL(up, i),
    p = IF(w2, i),
    h = XW(w2, i),
    y = DF(i);
  return /* @__PURE__ */we.jsx(RF.ItemSlot, {
    scope: i,
    children: /* @__PURE__ */we.jsx(_H, {
      "aria-disabled": p.open && !h.collapsible || void 0,
      "data-orientation": c.orientation,
      id: p.triggerId,
      ...y,
      ...s,
      ref: e
    })
  });
});
kH.displayName = w2;
const t9 = Qn((t, e) => {
    const {
        __scopeAccordion: i,
        className: s,
        children: c,
        expandText: p = "Expand All",
        collapseText: h = "Collapse All"
      } = t,
      y = vH(up, i),
      [w, x] = rt(!1),
      E = () => {
        !y.expandAll || !y.collapseAll || (w ? y.collapseAll() : y.expandAll(), x(!w));
      };
    return /* @__PURE__ */we.jsxs(la.button, {
      type: "button",
      "data-state": OE(w),
      onClick: E,
      className: s,
      disabled: !y.expandAll || !y.collapseAll,
      ref: e,
      children: [w ? h : p, c]
    });
  }),
  TH = Qn(function ({
    __scopeAccordion: t,
    type: e = "single",
    ...i
  }, s) {
    const c = i,
      p = i;
    return /* @__PURE__ */we.jsx(RF.Provider, {
      scope: t,
      children: e === "multiple" ? /* @__PURE__ */we.jsx(EH, {
        ...p,
        ref: s
      }) : /* @__PURE__ */we.jsx(CH, {
        ...c,
        ref: s
      })
    });
  });
TH.displayName = up;
function RH(t) {
  var e,
    i,
    s = "";
  if (typeof t == "string" || typeof t == "number") s += t;else if (typeof t == "object") if (Array.isArray(t)) {
    var c = t.length;
    for (e = 0; e < c; e++) t[e] && (i = RH(t[e])) && (s && (s += " "), s += i);
  } else for (i in t) t[i] && (s && (s += " "), s += i);
  return s;
}
function Ze() {
  for (var t, e, i = 0, s = "", c = arguments.length; i < c; i++) (t = arguments[i]) && (e = RH(t)) && (s && (s += " "), s += e);
  return s;
}
const n9 = "_alert_1lo9d_1",
  r9 = "_alertBody_1lo9d_6",
  i9 = "_alertDismissibleButton_1lo9d_10",
  ij = {
    alert: n9,
    alertBody: r9,
    alertDismissibleButton: i9
  },
  DH = Qn(({
    className: t,
    classNames: e = {},
    children: i,
    dismissible: s = !0,
    dismissibleLabel: c = "Close alert",
    dismissibleIcon: p = "×",
    onDismiss: h = async () => await !0,
    ...y
  }, w) => {
    const [x, E] = rt(!0);
    if (!x) return null;
    const C = async () => {
      (await h()) && E(!1);
    };
    return /* @__PURE__ */we.jsxs("div", {
      ...y,
      role: "alert",
      className: Ze(ij.alert, t),
      ref: w,
      children: [/* @__PURE__ */we.jsx("div", {
        className: Ze(ij.alertBody, e.body),
        children: i
      }), s && /* @__PURE__ */we.jsx("button", {
        type: "button",
        className: Ze(ij.alertDismissibleButton, e.dismissibleButton),
        onClick: C,
        "aria-label": c,
        children: p
      })]
    });
  });
DH.displayName = "Alert";
const a9 = "_button_15y99_1",
  o9 = "_disabled_15y99_20",
  l9 = "_fullWidth_15y99_29",
  aj = {
    button: a9,
    disabled: o9,
    fullWidth: l9
  },
  _2 = Qn((t, e) => {
    const {
        as: i,
        type: s,
        className: c,
        classNames: p,
        disabled: h,
        fullWidth: y,
        leftSection: w,
        children: x,
        rightSection: E,
        renderLink: C,
        ...k
      } = t,
      D = Ze(c, aj.button, {
        [aj.disabled]: h,
        [aj.fullWidth]: y
      }),
      I = /* @__PURE__ */we.jsxs(we.Fragment, {
        children: [w && /* @__PURE__ */we.jsx("span", {
          className: p == null ? void 0 : p.leftSection,
          children: w
        }), x, E && /* @__PURE__ */we.jsx("span", {
          className: p == null ? void 0 : p.rightSection,
          children: E
        })]
      });
    if (i === "a") {
      const {
          href: P,
          ...N
        } = k,
        O = {
          ...N,
          className: D,
          children: I
        };
      return C ? C(P, O) : /* @__PURE__ */we.jsx("a", {
        ref: e,
        href: P,
        ...O
      });
    }
    const L = {
      ...k,
      disabled: h,
      className: D
    };
    return /* @__PURE__ */we.jsx("button", {
      ref: e,
      ...L,
      type: s ?? "button",
      children: I
    });
  });
_2.displayName = "Button";
const s9 = "_checkbox_uuvf2_2",
  u9 = "_ui_uuvf2_23",
  c9 = "_checkboxWrapper_uuvf2_69",
  d9 = "_checkboxLabel_uuvf2_73",
  f9 = "_checkboxLabelWrapper_uuvf2_83",
  p9 = "_checkboxHelperText_uuvf2_90",
  h9 = "_checkboxError_uuvf2_96",
  m9 = "_checkboxDisabled_uuvf2_100",
  ab = {
    checkbox: s9,
    ui: u9,
    checkboxWrapper: c9,
    checkboxLabel: d9,
    checkboxLabelWrapper: f9,
    checkboxHelperText: p9,
    checkboxError: h9,
    checkboxDisabled: m9
  },
  v9 = Qn(({
    id: t,
    label: e,
    helperText: i,
    isDisabled: s = !1,
    isSelected: c = !1,
    onChange: p,
    className: h,
    classNames: y,
    isRequired: w = !1,
    errorMessage: x,
    isError: E = !1,
    ...C
  }, k) => {
    const [D, I] = rt(c),
      L = P => {
        I(!D), p == null || p(P, !D, t);
      };
    return Rt(() => {
      I(c);
    }, [c]), /* @__PURE__ */we.jsx("div", {
      className: Ze(ab.checkbox, h, !s && !D && E && w && Ze(ab.checkboxError, y == null ? void 0 : y.error), s && Ze(ab.checkboxDisabled, y == null ? void 0 : y.disabled)),
      children: /* @__PURE__ */we.jsxs("div", {
        className: Ze(ab.checkboxWrapper, y == null ? void 0 : y.wrapper),
        children: [/* @__PURE__ */we.jsx("input", {
          ref: k,
          type: "checkbox",
          onChange: L,
          id: t,
          checked: D,
          disabled: s,
          required: w,
          ...C
        }), /* @__PURE__ */we.jsx("span", {
          className: Ze(ab.ui, y == null ? void 0 : y.ui)
        }), /* @__PURE__ */we.jsx("div", {
          className: Ze(ab.checkboxLabelWrapper, y == null ? void 0 : y.labelWrapper),
          children: /* @__PURE__ */we.jsx("label", {
            className: Ze(ab.checkboxLabel, y == null ? void 0 : y.label),
            htmlFor: t,
            children: e
          })
        }), (i || w && E && x) && /* @__PURE__ */we.jsx("div", {
          "data-disabled": !s,
          className: Ze(ab.checkboxHelperText, !D && !s && w && E && x && Ze(ab.checkboxErrorMsg, y == null ? void 0 : y.errorMsg), y == null ? void 0 : y.helperText),
          children: /* @__PURE__ */we.jsx("span", {
            children: !D && !s && E && w && x || i
          })
        })]
      })
    });
  }),
  nd = {
    breakpoint: {
      sm: {
        value: "576px"
      },
      "sm-max": {
        value: "575px"
      },
      md: {
        value: "768px"
      },
      "md-max": {
        value: "767px"
      },
      lg: {
        value: "992px"
      },
      "lg-max": {
        value: "991px"
      },
      xl: {
        value: "1200px",
        original: {
          value: "1200px"
        },
        name: "BreakpointXl",
        attributes: {
          category: "breakpoint",
          type: "xl",
          cssVariables: "--breakpoint-xl"
        }
      },
      "xl-max": {
        value: "1199px"
      }
    },
    color: {
      white: {
        default: {
          value: "#FFFFFF"
        }
      },
      black: {
        default: {
          value: "#000000"
        }
      }
    }
  },
  g9 = t => {
    const e = [],
      i = (s, c = 0) => {
        s.forEach(p => {
          p._level = c;
          const {
            items: h,
            ...y
          } = p;
          e.push(y), h != null && h.length && i(h, c + 1);
        });
      };
    return t.forEach(s => {
      var c;
      (c = s.items) != null && c.length && i(s.items, 0);
    }), e;
  };
function ip(t, e) {
  if (t == null) return {};
  var i = {};
  for (var s in t) if ({}.hasOwnProperty.call(t, s)) {
    if (e.includes(s)) continue;
    i[s] = t[s];
  }
  return i;
}
function Jn() {
  return Jn = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var s in i) ({}).hasOwnProperty.call(i, s) && (t[s] = i[s]);
    }
    return t;
  }, Jn.apply(null, arguments);
}
function x2(t, e) {
  return x2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, s) {
    return i.__proto__ = s, i;
  }, x2(t, e);
}
function y9(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, x2(t, e);
}
var tM = {
    exports: {}
  },
  oj = {
    exports: {}
  },
  pi = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xz;
function b9() {
  if (Xz) return pi;
  Xz = 1;
  var t = typeof Symbol == "function" && Symbol.for,
    e = t ? Symbol.for("react.element") : 60103,
    i = t ? Symbol.for("react.portal") : 60106,
    s = t ? Symbol.for("react.fragment") : 60107,
    c = t ? Symbol.for("react.strict_mode") : 60108,
    p = t ? Symbol.for("react.profiler") : 60114,
    h = t ? Symbol.for("react.provider") : 60109,
    y = t ? Symbol.for("react.context") : 60110,
    w = t ? Symbol.for("react.async_mode") : 60111,
    x = t ? Symbol.for("react.concurrent_mode") : 60111,
    E = t ? Symbol.for("react.forward_ref") : 60112,
    C = t ? Symbol.for("react.suspense") : 60113,
    k = t ? Symbol.for("react.suspense_list") : 60120,
    D = t ? Symbol.for("react.memo") : 60115,
    I = t ? Symbol.for("react.lazy") : 60116,
    L = t ? Symbol.for("react.block") : 60121,
    P = t ? Symbol.for("react.fundamental") : 60117,
    N = t ? Symbol.for("react.responder") : 60118,
    O = t ? Symbol.for("react.scope") : 60119;
  function F(V) {
    if (typeof V == "object" && V !== null) {
      var K = V.$$typeof;
      switch (K) {
        case e:
          switch (V = V.type, V) {
            case w:
            case x:
            case s:
            case p:
            case c:
            case C:
              return V;
            default:
              switch (V = V && V.$$typeof, V) {
                case y:
                case E:
                case I:
                case D:
                case h:
                  return V;
                default:
                  return K;
              }
          }
        case i:
          return K;
      }
    }
  }
  function j(V) {
    return F(V) === x;
  }
  return pi.AsyncMode = w, pi.ConcurrentMode = x, pi.ContextConsumer = y, pi.ContextProvider = h, pi.Element = e, pi.ForwardRef = E, pi.Fragment = s, pi.Lazy = I, pi.Memo = D, pi.Portal = i, pi.Profiler = p, pi.StrictMode = c, pi.Suspense = C, pi.isAsyncMode = function (V) {
    return j(V) || F(V) === w;
  }, pi.isConcurrentMode = j, pi.isContextConsumer = function (V) {
    return F(V) === y;
  }, pi.isContextProvider = function (V) {
    return F(V) === h;
  }, pi.isElement = function (V) {
    return typeof V == "object" && V !== null && V.$$typeof === e;
  }, pi.isForwardRef = function (V) {
    return F(V) === E;
  }, pi.isFragment = function (V) {
    return F(V) === s;
  }, pi.isLazy = function (V) {
    return F(V) === I;
  }, pi.isMemo = function (V) {
    return F(V) === D;
  }, pi.isPortal = function (V) {
    return F(V) === i;
  }, pi.isProfiler = function (V) {
    return F(V) === p;
  }, pi.isStrictMode = function (V) {
    return F(V) === c;
  }, pi.isSuspense = function (V) {
    return F(V) === C;
  }, pi.isValidElementType = function (V) {
    return typeof V == "string" || typeof V == "function" || V === s || V === x || V === p || V === c || V === C || V === k || typeof V == "object" && V !== null && (V.$$typeof === I || V.$$typeof === D || V.$$typeof === h || V.$$typeof === y || V.$$typeof === E || V.$$typeof === P || V.$$typeof === N || V.$$typeof === O || V.$$typeof === L);
  }, pi.typeOf = F, pi;
}
var zi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kz;
function w9() {
  return Kz || (Kz = 1, process.env.NODE_ENV !== "production" && function () {
    var t = typeof Symbol == "function" && Symbol.for,
      e = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      s = t ? Symbol.for("react.fragment") : 60107,
      c = t ? Symbol.for("react.strict_mode") : 60108,
      p = t ? Symbol.for("react.profiler") : 60114,
      h = t ? Symbol.for("react.provider") : 60109,
      y = t ? Symbol.for("react.context") : 60110,
      w = t ? Symbol.for("react.async_mode") : 60111,
      x = t ? Symbol.for("react.concurrent_mode") : 60111,
      E = t ? Symbol.for("react.forward_ref") : 60112,
      C = t ? Symbol.for("react.suspense") : 60113,
      k = t ? Symbol.for("react.suspense_list") : 60120,
      D = t ? Symbol.for("react.memo") : 60115,
      I = t ? Symbol.for("react.lazy") : 60116,
      L = t ? Symbol.for("react.block") : 60121,
      P = t ? Symbol.for("react.fundamental") : 60117,
      N = t ? Symbol.for("react.responder") : 60118,
      O = t ? Symbol.for("react.scope") : 60119;
    function F(ge) {
      return typeof ge == "string" || typeof ge == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ge === s || ge === x || ge === p || ge === c || ge === C || ge === k || typeof ge == "object" && ge !== null && (ge.$$typeof === I || ge.$$typeof === D || ge.$$typeof === h || ge.$$typeof === y || ge.$$typeof === E || ge.$$typeof === P || ge.$$typeof === N || ge.$$typeof === O || ge.$$typeof === L);
    }
    function j(ge) {
      if (typeof ge == "object" && ge !== null) {
        var qe = ge.$$typeof;
        switch (qe) {
          case e:
            var Ae = ge.type;
            switch (Ae) {
              case w:
              case x:
              case s:
              case p:
              case c:
              case C:
                return Ae;
              default:
                var Mt = Ae && Ae.$$typeof;
                switch (Mt) {
                  case y:
                  case E:
                  case I:
                  case D:
                  case h:
                    return Mt;
                  default:
                    return qe;
                }
            }
          case i:
            return qe;
        }
      }
    }
    var V = w,
      K = x,
      G = y,
      Q = h,
      te = e,
      ie = E,
      Y = s,
      ee = I,
      ae = D,
      ne = i,
      le = p,
      ce = c,
      W = C,
      $ = !1;
    function de(ge) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ge) || j(ge) === w;
    }
    function H(ge) {
      return j(ge) === x;
    }
    function se(ge) {
      return j(ge) === y;
    }
    function ue(ge) {
      return j(ge) === h;
    }
    function Ee(ge) {
      return typeof ge == "object" && ge !== null && ge.$$typeof === e;
    }
    function Ce(ge) {
      return j(ge) === E;
    }
    function fe(ge) {
      return j(ge) === s;
    }
    function _e(ge) {
      return j(ge) === I;
    }
    function Se(ge) {
      return j(ge) === D;
    }
    function be(ge) {
      return j(ge) === i;
    }
    function Le(ge) {
      return j(ge) === p;
    }
    function Be(ge) {
      return j(ge) === c;
    }
    function Xe(ge) {
      return j(ge) === C;
    }
    zi.AsyncMode = V, zi.ConcurrentMode = K, zi.ContextConsumer = G, zi.ContextProvider = Q, zi.Element = te, zi.ForwardRef = ie, zi.Fragment = Y, zi.Lazy = ee, zi.Memo = ae, zi.Portal = ne, zi.Profiler = le, zi.StrictMode = ce, zi.Suspense = W, zi.isAsyncMode = de, zi.isConcurrentMode = H, zi.isContextConsumer = se, zi.isContextProvider = ue, zi.isElement = Ee, zi.isForwardRef = Ce, zi.isFragment = fe, zi.isLazy = _e, zi.isMemo = Se, zi.isPortal = be, zi.isProfiler = Le, zi.isStrictMode = Be, zi.isSuspense = Xe, zi.isValidElementType = F, zi.typeOf = j;
  }()), zi;
}
var Qz;
function IH() {
  return Qz || (Qz = 1, process.env.NODE_ENV === "production" ? oj.exports = b9() : oj.exports = w9()), oj.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var lj, Zz;
function _9() {
  if (Zz) return lj;
  Zz = 1;
  var t = Object.getOwnPropertySymbols,
    e = Object.prototype.hasOwnProperty,
    i = Object.prototype.propertyIsEnumerable;
  function s(p) {
    if (p == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function c() {
    try {
      if (!Object.assign) return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5") return !1;
      for (var h = {}, y = 0; y < 10; y++) h["_" + String.fromCharCode(y)] = y;
      var w = Object.getOwnPropertyNames(h).map(function (E) {
        return h[E];
      });
      if (w.join("") !== "0123456789") return !1;
      var x = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (E) {
        x[E] = E;
      }), Object.keys(Object.assign({}, x)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return lj = c() ? Object.assign : function (p, h) {
    for (var y, w = s(p), x, E = 1; E < arguments.length; E++) {
      y = Object(arguments[E]);
      for (var C in y) e.call(y, C) && (w[C] = y[C]);
      if (t) {
        x = t(y);
        for (var k = 0; k < x.length; k++) i.call(y, x[k]) && (w[x[k]] = y[x[k]]);
      }
    }
    return w;
  }, lj;
}
var sj, Jz;
function LF() {
  if (Jz) return sj;
  Jz = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return sj = t, sj;
}
var eV, tV;
function MH() {
  return tV || (tV = 1, eV = Function.call.bind(Object.prototype.hasOwnProperty)), eV;
}
var uj, nV;
function x9() {
  if (nV) return uj;
  nV = 1;
  var t = function () {};
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */LF(),
      i = {},
      s = /* @__PURE__ */MH();
    t = function (p) {
      var h = "Warning: " + p;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {}
    };
  }
  function c(p, h, y, w, x) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in p) if (s(p, E)) {
        var C;
        try {
          if (typeof p[E] != "function") {
            var k = Error((w || "React class") + ": " + y + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw k.name = "Invariant Violation", k;
          }
          C = p[E](h, E, w, y, null, e);
        } catch (I) {
          C = I;
        }
        if (C && !(C instanceof Error) && t((w || "React class") + ": type specification of " + y + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), C instanceof Error && !(C.message in i)) {
          i[C.message] = !0;
          var D = x ? x() : "";
          t("Failed " + y + " type: " + C.message + (D ?? ""));
        }
      }
    }
  }
  return c.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (i = {});
  }, uj = c, uj;
}
var cj, rV;
function S9() {
  if (rV) return cj;
  rV = 1;
  var t = IH(),
    e = _9(),
    i = /* @__PURE__ */LF(),
    s = /* @__PURE__ */MH(),
    c = /* @__PURE__ */x9(),
    p = function () {};
  process.env.NODE_ENV !== "production" && (p = function (y) {
    var w = "Warning: " + y;
    typeof console < "u" && console.error(w);
    try {
      throw new Error(w);
    } catch {}
  });
  function h() {
    return null;
  }
  return cj = function (y, w) {
    var x = typeof Symbol == "function" && Symbol.iterator,
      E = "@@iterator";
    function C(H) {
      var se = H && (x && H[x] || H[E]);
      if (typeof se == "function") return se;
    }
    var k = "<<anonymous>>",
      D = {
        array: N("array"),
        bigint: N("bigint"),
        bool: N("boolean"),
        func: N("function"),
        number: N("number"),
        object: N("object"),
        string: N("string"),
        symbol: N("symbol"),
        any: O(),
        arrayOf: F,
        element: j(),
        elementType: V(),
        instanceOf: K,
        node: ie(),
        objectOf: Q,
        oneOf: G,
        oneOfType: te,
        shape: ee,
        exact: ae
      };
    function I(H, se) {
      return H === se ? H !== 0 || 1 / H === 1 / se : H !== H && se !== se;
    }
    function L(H, se) {
      this.message = H, this.data = se && typeof se == "object" ? se : {}, this.stack = "";
    }
    L.prototype = Error.prototype;
    function P(H) {
      if (process.env.NODE_ENV !== "production") var se = {},
        ue = 0;
      function Ee(fe, _e, Se, be, Le, Be, Xe) {
        if (be = be || k, Be = Be || Se, Xe !== i) {
          if (w) {
            var ge = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw ge.name = "Invariant Violation", ge;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var qe = be + ":" + Se;
            !se[qe] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            ue < 3 && (p("You are manually calling a React.PropTypes validation function for the `" + Be + "` prop on `" + be + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), se[qe] = !0, ue++);
          }
        }
        return _e[Se] == null ? fe ? _e[Se] === null ? new L("The " + Le + " `" + Be + "` is marked as required " + ("in `" + be + "`, but its value is `null`.")) : new L("The " + Le + " `" + Be + "` is marked as required in " + ("`" + be + "`, but its value is `undefined`.")) : null : H(_e, Se, be, Le, Be);
      }
      var Ce = Ee.bind(null, !1);
      return Ce.isRequired = Ee.bind(null, !0), Ce;
    }
    function N(H) {
      function se(ue, Ee, Ce, fe, _e, Se) {
        var be = ue[Ee],
          Le = ce(be);
        if (Le !== H) {
          var Be = W(be);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + Be + "` supplied to `" + Ce + "`, expected ") + ("`" + H + "`."), {
            expectedType: H
          });
        }
        return null;
      }
      return P(se);
    }
    function O() {
      return P(h);
    }
    function F(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (typeof H != "function") return new L("Property `" + _e + "` of component `" + Ce + "` has invalid PropType notation inside arrayOf.");
        var Se = ue[Ee];
        if (!Array.isArray(Se)) {
          var be = ce(Se);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected an array."));
        }
        for (var Le = 0; Le < Se.length; Le++) {
          var Be = H(Se, Le, Ce, fe, _e + "[" + Le + "]", i);
          if (Be instanceof Error) return Be;
        }
        return null;
      }
      return P(se);
    }
    function j() {
      function H(se, ue, Ee, Ce, fe) {
        var _e = se[ue];
        if (!y(_e)) {
          var Se = ce(_e);
          return new L("Invalid " + Ce + " `" + fe + "` of type " + ("`" + Se + "` supplied to `" + Ee + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(H);
    }
    function V() {
      function H(se, ue, Ee, Ce, fe) {
        var _e = se[ue];
        if (!t.isValidElementType(_e)) {
          var Se = ce(_e);
          return new L("Invalid " + Ce + " `" + fe + "` of type " + ("`" + Se + "` supplied to `" + Ee + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(H);
    }
    function K(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (!(ue[Ee] instanceof H)) {
          var Se = H.name || k,
            be = de(ue[Ee]);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected ") + ("instance of `" + Se + "`."));
        }
        return null;
      }
      return P(se);
    }
    function G(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? p("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : p("Invalid argument supplied to oneOf, expected an array.")), h;
      function se(ue, Ee, Ce, fe, _e) {
        for (var Se = ue[Ee], be = 0; be < H.length; be++) if (I(Se, H[be])) return null;
        var Le = JSON.stringify(H, function (Be, Xe) {
          var ge = W(Xe);
          return ge === "symbol" ? String(Xe) : Xe;
        });
        return new L("Invalid " + fe + " `" + _e + "` of value `" + String(Se) + "` " + ("supplied to `" + Ce + "`, expected one of " + Le + "."));
      }
      return P(se);
    }
    function Q(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (typeof H != "function") return new L("Property `" + _e + "` of component `" + Ce + "` has invalid PropType notation inside objectOf.");
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected an object."));
        for (var Le in Se) if (s(Se, Le)) {
          var Be = H(Se, Le, Ce, fe, _e + "." + Le, i);
          if (Be instanceof Error) return Be;
        }
        return null;
      }
      return P(se);
    }
    function te(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && p("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var se = 0; se < H.length; se++) {
        var ue = H[se];
        if (typeof ue != "function") return p("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(ue) + " at index " + se + "."), h;
      }
      function Ee(Ce, fe, _e, Se, be) {
        for (var Le = [], Be = 0; Be < H.length; Be++) {
          var Xe = H[Be],
            ge = Xe(Ce, fe, _e, Se, be, i);
          if (ge == null) return null;
          ge.data && s(ge.data, "expectedType") && Le.push(ge.data.expectedType);
        }
        var qe = Le.length > 0 ? ", expected one of type [" + Le.join(", ") + "]" : "";
        return new L("Invalid " + Se + " `" + be + "` supplied to " + ("`" + _e + "`" + qe + "."));
      }
      return P(Ee);
    }
    function ie() {
      function H(se, ue, Ee, Ce, fe) {
        return ne(se[ue]) ? null : new L("Invalid " + Ce + " `" + fe + "` supplied to " + ("`" + Ee + "`, expected a ReactNode."));
      }
      return P(H);
    }
    function Y(H, se, ue, Ee, Ce) {
      return new L((H || "React class") + ": " + se + " type `" + ue + "." + Ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ce + "`.");
    }
    function ee(H) {
      function se(ue, Ee, Ce, fe, _e) {
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type `" + be + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        for (var Le in H) {
          var Be = H[Le];
          if (typeof Be != "function") return Y(Ce, fe, _e, Le, W(Be));
          var Xe = Be(Se, Le, Ce, fe, _e + "." + Le, i);
          if (Xe) return Xe;
        }
        return null;
      }
      return P(se);
    }
    function ae(H) {
      function se(ue, Ee, Ce, fe, _e) {
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type `" + be + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        var Le = e({}, ue[Ee], H);
        for (var Be in Le) {
          var Xe = H[Be];
          if (s(H, Be) && typeof Xe != "function") return Y(Ce, fe, _e, Be, W(Xe));
          if (!Xe) return new L("Invalid " + fe + " `" + _e + "` key `" + Be + "` supplied to `" + Ce + "`.\nBad object: " + JSON.stringify(ue[Ee], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  "));
          var ge = Xe(Se, Be, Ce, fe, _e + "." + Be, i);
          if (ge) return ge;
        }
        return null;
      }
      return P(se);
    }
    function ne(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H)) return H.every(ne);
          if (H === null || y(H)) return !0;
          var se = C(H);
          if (se) {
            var ue = se.call(H),
              Ee;
            if (se !== H.entries) {
              for (; !(Ee = ue.next()).done;) if (!ne(Ee.value)) return !1;
            } else for (; !(Ee = ue.next()).done;) {
              var Ce = Ee.value;
              if (Ce && !ne(Ce[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function le(H, se) {
      return H === "symbol" ? !0 : se ? se["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && se instanceof Symbol : !1;
    }
    function ce(H) {
      var se = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : le(se, H) ? "symbol" : se;
    }
    function W(H) {
      if (typeof H > "u" || H === null) return "" + H;
      var se = ce(H);
      if (se === "object") {
        if (H instanceof Date) return "date";
        if (H instanceof RegExp) return "regexp";
      }
      return se;
    }
    function $(H) {
      var se = W(H);
      switch (se) {
        case "array":
        case "object":
          return "an " + se;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + se;
        default:
          return se;
      }
    }
    function de(H) {
      return !H.constructor || !H.constructor.name ? k : H.constructor.name;
    }
    return D.checkPropTypes = c, D.resetWarningCache = c.resetWarningCache, D.PropTypes = D, D;
  }, cj;
}
var dj, iV;
function E9() {
  if (iV) return dj;
  iV = 1;
  var t = /* @__PURE__ */LF();
  function e() {}
  function i() {}
  return i.resetWarningCache = e, dj = function () {
    function s(h, y, w, x, E, C) {
      if (C !== t) {
        var k = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw k.name = "Invariant Violation", k;
      }
    }
    s.isRequired = s;
    function c() {
      return s;
    }
    var p = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: c,
      element: s,
      elementType: s,
      instanceOf: c,
      node: s,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: i,
      resetWarningCache: e
    };
    return p.PropTypes = p, p;
  }, dj;
}
var aV;
function C9() {
  if (aV) return tM.exports;
  if (aV = 1, process.env.NODE_ENV !== "production") {
    var t = IH(),
      e = !0;
    tM.exports = /* @__PURE__ */S9()(t.isElement, e);
  } else tM.exports = /* @__PURE__ */E9()();
  return tM.exports;
}
var k9 = /* @__PURE__ */C9();
const Ot = /* @__PURE__ */sH(k9);
var fj = {
    exports: {}
  },
  hi = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oV;
function T9() {
  if (oV) return hi;
  oV = 1;
  var t = Symbol.for("react.element"),
    e = Symbol.for("react.portal"),
    i = Symbol.for("react.fragment"),
    s = Symbol.for("react.strict_mode"),
    c = Symbol.for("react.profiler"),
    p = Symbol.for("react.provider"),
    h = Symbol.for("react.context"),
    y = Symbol.for("react.server_context"),
    w = Symbol.for("react.forward_ref"),
    x = Symbol.for("react.suspense"),
    E = Symbol.for("react.suspense_list"),
    C = Symbol.for("react.memo"),
    k = Symbol.for("react.lazy"),
    D = Symbol.for("react.offscreen"),
    I;
  I = Symbol.for("react.module.reference");
  function L(P) {
    if (typeof P == "object" && P !== null) {
      var N = P.$$typeof;
      switch (N) {
        case t:
          switch (P = P.type, P) {
            case i:
            case c:
            case s:
            case x:
            case E:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case y:
                case h:
                case w:
                case k:
                case C:
                case p:
                  return P;
                default:
                  return N;
              }
          }
        case e:
          return N;
      }
    }
  }
  return hi.ContextConsumer = h, hi.ContextProvider = p, hi.Element = t, hi.ForwardRef = w, hi.Fragment = i, hi.Lazy = k, hi.Memo = C, hi.Portal = e, hi.Profiler = c, hi.StrictMode = s, hi.Suspense = x, hi.SuspenseList = E, hi.isAsyncMode = function () {
    return !1;
  }, hi.isConcurrentMode = function () {
    return !1;
  }, hi.isContextConsumer = function (P) {
    return L(P) === h;
  }, hi.isContextProvider = function (P) {
    return L(P) === p;
  }, hi.isElement = function (P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, hi.isForwardRef = function (P) {
    return L(P) === w;
  }, hi.isFragment = function (P) {
    return L(P) === i;
  }, hi.isLazy = function (P) {
    return L(P) === k;
  }, hi.isMemo = function (P) {
    return L(P) === C;
  }, hi.isPortal = function (P) {
    return L(P) === e;
  }, hi.isProfiler = function (P) {
    return L(P) === c;
  }, hi.isStrictMode = function (P) {
    return L(P) === s;
  }, hi.isSuspense = function (P) {
    return L(P) === x;
  }, hi.isSuspenseList = function (P) {
    return L(P) === E;
  }, hi.isValidElementType = function (P) {
    return typeof P == "string" || typeof P == "function" || P === i || P === c || P === s || P === x || P === E || P === D || typeof P == "object" && P !== null && (P.$$typeof === k || P.$$typeof === C || P.$$typeof === p || P.$$typeof === h || P.$$typeof === w || P.$$typeof === I || P.getModuleId !== void 0);
  }, hi.typeOf = L, hi;
}
var Vi = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lV;
function R9() {
  return lV || (lV = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Symbol.for("react.element"),
      e = Symbol.for("react.portal"),
      i = Symbol.for("react.fragment"),
      s = Symbol.for("react.strict_mode"),
      c = Symbol.for("react.profiler"),
      p = Symbol.for("react.provider"),
      h = Symbol.for("react.context"),
      y = Symbol.for("react.server_context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = !1,
      L = !1,
      P = !1,
      N = !1,
      O = !1,
      F;
    F = Symbol.for("react.module.reference");
    function j(Ae) {
      return !!(typeof Ae == "string" || typeof Ae == "function" || Ae === i || Ae === c || O || Ae === s || Ae === x || Ae === E || N || Ae === D || I || L || P || typeof Ae == "object" && Ae !== null && (Ae.$$typeof === k || Ae.$$typeof === C || Ae.$$typeof === p || Ae.$$typeof === h || Ae.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ae.$$typeof === F || Ae.getModuleId !== void 0));
    }
    function V(Ae) {
      if (typeof Ae == "object" && Ae !== null) {
        var Mt = Ae.$$typeof;
        switch (Mt) {
          case t:
            var Ft = Ae.type;
            switch (Ft) {
              case i:
              case c:
              case s:
              case x:
              case E:
                return Ft;
              default:
                var un = Ft && Ft.$$typeof;
                switch (un) {
                  case y:
                  case h:
                  case w:
                  case k:
                  case C:
                  case p:
                    return un;
                  default:
                    return Mt;
                }
            }
          case e:
            return Mt;
        }
      }
    }
    var K = h,
      G = p,
      Q = t,
      te = w,
      ie = i,
      Y = k,
      ee = C,
      ae = e,
      ne = c,
      le = s,
      ce = x,
      W = E,
      $ = !1,
      de = !1;
    function H(Ae) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function se(Ae) {
      return de || (de = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ue(Ae) {
      return V(Ae) === h;
    }
    function Ee(Ae) {
      return V(Ae) === p;
    }
    function Ce(Ae) {
      return typeof Ae == "object" && Ae !== null && Ae.$$typeof === t;
    }
    function fe(Ae) {
      return V(Ae) === w;
    }
    function _e(Ae) {
      return V(Ae) === i;
    }
    function Se(Ae) {
      return V(Ae) === k;
    }
    function be(Ae) {
      return V(Ae) === C;
    }
    function Le(Ae) {
      return V(Ae) === e;
    }
    function Be(Ae) {
      return V(Ae) === c;
    }
    function Xe(Ae) {
      return V(Ae) === s;
    }
    function ge(Ae) {
      return V(Ae) === x;
    }
    function qe(Ae) {
      return V(Ae) === E;
    }
    Vi.ContextConsumer = K, Vi.ContextProvider = G, Vi.Element = Q, Vi.ForwardRef = te, Vi.Fragment = ie, Vi.Lazy = Y, Vi.Memo = ee, Vi.Portal = ae, Vi.Profiler = ne, Vi.StrictMode = le, Vi.Suspense = ce, Vi.SuspenseList = W, Vi.isAsyncMode = H, Vi.isConcurrentMode = se, Vi.isContextConsumer = ue, Vi.isContextProvider = Ee, Vi.isElement = Ce, Vi.isForwardRef = fe, Vi.isFragment = _e, Vi.isLazy = Se, Vi.isMemo = be, Vi.isPortal = Le, Vi.isProfiler = Be, Vi.isStrictMode = Xe, Vi.isSuspense = ge, Vi.isSuspenseList = qe, Vi.isValidElementType = j, Vi.typeOf = V;
  }()), Vi;
}
var sV;
function D9() {
  return sV || (sV = 1, process.env.NODE_ENV === "production" ? fj.exports = T9() : fj.exports = R9()), fj.exports;
}
var uV = D9();
const cV = t => typeof t == "object" && t != null && t.nodeType === 1,
  dV = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip",
  nM = (t, e) => {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      const i = getComputedStyle(t, null);
      return dV(i.overflowY, e) || dV(i.overflowX, e) || (s => {
        const c = (p => {
          if (!p.ownerDocument || !p.ownerDocument.defaultView) return null;
          try {
            return p.ownerDocument.defaultView.frameElement;
          } catch {
            return null;
          }
        })(s);
        return !!c && (c.clientHeight < s.scrollHeight || c.clientWidth < s.scrollWidth);
      })(t);
    }
    return !1;
  },
  rM = (t, e, i, s, c, p, h, y) => p < t && h > e || p > t && h < e ? 0 : p <= t && y <= i || h >= e && y >= i ? p - t - s : h > e && y < i || p < t && y > i ? h - e + c : 0,
  I9 = t => t.parentElement ?? (t.getRootNode().host || null),
  M9 = (t, e) => {
    var i, s, c, p;
    if (typeof document > "u") return [];
    const {
        inline: h,
        boundary: y,
        skipOverflowHiddenElements: w
      } = e,
      x = typeof y == "function" ? y : ae => ae !== y;
    if (!cV(t)) throw new TypeError("Invalid target");
    const E = document.scrollingElement || document.documentElement,
      C = [];
    let k = t;
    for (; cV(k) && x(k);) {
      if (k = I9(k), k === E) {
        C.push(k);
        break;
      }
      k != null && k === document.body && nM(k) && !nM(document.documentElement) || k != null && nM(k, w) && C.push(k);
    }
    const D = (s = (i = window.visualViewport) == null ? void 0 : i.width) != null ? s : innerWidth,
      I = (p = (c = window.visualViewport) == null ? void 0 : c.height) != null ? p : innerHeight,
      {
        scrollX: L,
        scrollY: P
      } = window,
      {
        height: N,
        width: O,
        top: F,
        right: j,
        bottom: V,
        left: K
      } = t.getBoundingClientRect(),
      {
        top: G,
        right: Q,
        left: te
      } = (ae => {
        const ne = window.getComputedStyle(ae);
        return {
          top: parseFloat(ne.scrollMarginTop) || 0,
          right: parseFloat(ne.scrollMarginRight) || 0,
          bottom: parseFloat(ne.scrollMarginBottom) || 0,
          left: parseFloat(ne.scrollMarginLeft) || 0
        };
      })(t);
    let ie = F - G,
      Y = h === "center" ? K + O / 2 - te + Q : h === "end" ? j + Q : K - te;
    const ee = [];
    for (let ae = 0; ae < C.length; ae++) {
      const ne = C[ae],
        {
          height: le,
          width: ce,
          top: W,
          right: $,
          bottom: de,
          left: H
        } = ne.getBoundingClientRect();
      if (F >= 0 && K >= 0 && V <= I && j <= D && (ne === E && !nM(ne) || F >= W && V <= de && K >= H && j <= $)) return ee;
      const se = getComputedStyle(ne),
        ue = parseInt(se.borderLeftWidth, 10),
        Ee = parseInt(se.borderTopWidth, 10),
        Ce = parseInt(se.borderRightWidth, 10),
        fe = parseInt(se.borderBottomWidth, 10);
      let _e = 0,
        Se = 0;
      const be = "offsetWidth" in ne ? ne.offsetWidth - ne.clientWidth - ue - Ce : 0,
        Le = "offsetHeight" in ne ? ne.offsetHeight - ne.clientHeight - Ee - fe : 0,
        Be = "offsetWidth" in ne ? ne.offsetWidth === 0 ? 0 : ce / ne.offsetWidth : 0,
        Xe = "offsetHeight" in ne ? ne.offsetHeight === 0 ? 0 : le / ne.offsetHeight : 0;
      if (E === ne) _e = rM(P, P + I, I, Ee, fe, P + ie, P + ie + N, N), Se = h === "start" ? Y : h === "center" ? Y - D / 2 : h === "end" ? Y - D : rM(L, L + D, D, ue, Ce, L + Y, L + Y + O, O), _e = Math.max(0, _e + P), Se = Math.max(0, Se + L);else {
        _e = rM(W, de, le, Ee, fe + Le, ie, ie + N, N), Se = h === "start" ? Y - H - ue : h === "center" ? Y - (H + ce / 2) + be / 2 : h === "end" ? Y - $ + Ce + be : rM(H, $, ce, ue, Ce + be, Y, Y + O, O);
        const {
          scrollLeft: ge,
          scrollTop: qe
        } = ne;
        _e = Xe === 0 ? 0 : Math.max(0, Math.min(qe + _e / Xe, ne.scrollHeight - le / Xe + Le)), Se = Be === 0 ? 0 : Math.max(0, Math.min(ge + Se / Be, ne.scrollWidth - ce / Be + be)), ie += qe - _e, Y += ge - Se;
      }
      ee.push({
        el: ne,
        top: _e,
        left: Se
      });
    }
    return ee;
  };
var xE = function () {
    return xE = Object.assign || function (t) {
      for (var e, i = 1, s = arguments.length; i < s; i++) {
        e = arguments[i];
        for (var c in e) Object.prototype.hasOwnProperty.call(e, c) && (t[c] = e[c]);
      }
      return t;
    }, xE.apply(this, arguments);
  },
  L9 = 0;
function fV(t) {
  return typeof t == "function" ? t : rd;
}
function rd() {}
function LH(t, e) {
  if (t) {
    var i = M9(t, {
      boundary: e
    });
    i.forEach(function (s) {
      var c = s.el,
        p = s.top,
        h = s.left;
      c.scrollTop = p, c.scrollLeft = h;
    });
  }
}
function pV(t, e, i) {
  var s = t === e || e instanceof i.Node && t.contains && t.contains(e);
  return s;
}
function UL(t, e) {
  var i;
  function s() {
    i && clearTimeout(i);
  }
  function c() {
    for (var p = arguments.length, h = new Array(p), y = 0; y < p; y++) h[y] = arguments[y];
    s(), i = setTimeout(function () {
      i = null, t.apply(void 0, h);
    }, e);
  }
  return c.cancel = s, c;
}
function oa() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return function (s) {
    for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), h = 1; h < c; h++) p[h - 1] = arguments[h];
    return e.some(function (y) {
      return y && y.apply(void 0, [s].concat(p)), s.preventDownshiftDefault || s.hasOwnProperty("nativeEvent") && s.nativeEvent.preventDownshiftDefault;
    });
  };
}
function pb() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return function (s) {
    e.forEach(function (c) {
      typeof c == "function" ? c(s) : c && (c.current = s);
    });
  };
}
function OH() {
  return String(L9++);
}
function O9(t) {
  var e = t.isOpen,
    i = t.resultCount,
    s = t.previousResultCount;
  return e ? i ? i !== s ? i + " result" + (i === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function hV(t, e) {
  return t = Array.isArray(t) ? (/* istanbul ignore next (preact) */
  t[0]) : t, !t && e ? e : t;
}
function PH(t) {
  return typeof t.type == "string";
}
function AH(t) {
  return t.props;
}
function P9(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var A9 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function iM(t) {
  t === void 0 && (t = {});
  var e = {};
  return A9.forEach(function (i) {
    t.hasOwnProperty(i) && (e[i] = t[i]);
  }), e;
}
function iR(t, e) {
  return !t || !e ? t : Object.keys(t).reduce(function (i, s) {
    return i[s] = rL(e, s) ? e[s] : t[s], i;
  }, {});
}
function rL(t, e) {
  return t[e] !== void 0;
}
function iL(t) {
  var e = t.key,
    i = t.keyCode;
  return i >= 37 && i <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function j9(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function $m(t, e, i, s, c) {
  c === void 0 && (c = !1);
  var p = i.length;
  if (p === 0) return -1;
  var h = p - 1;
  (typeof t != "number" || t < 0 || t > h) && (t = e > 0 ? -1 : h + 1);
  var y = t + e;
  y < 0 ? y = c ? h : 0 : y > h && (y = c ? 0 : h);
  var w = aw(y, e < 0, i, s, c);
  return w === -1 ? t >= p ? -1 : t : w;
}
function aw(t, e, i, s, c) {
  c === void 0 && (c = !1);
  var p = i.length;
  if (e) {
    for (var h = t; h >= 0; h--) if (!s(i[h], h)) return h;
  } else for (var y = t; y < p; y++) if (!s(i[y], y)) return y;
  return c ? aw(e ? p - 1 : 0, e, i, s) : -1;
}
function aL(t, e, i, s) {
  return s === void 0 && (s = !0), i && e.some(function (c) {
    return c && (pV(c, t, i) || s && pV(c, i.document.activeElement, i));
  });
}
var OF = rd;
process.env.NODE_ENV !== "production" && (OF = function (t, e, i) {
  var s = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function (c) {
    e[c] !== void 0 && i[c] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + c + '" to be uncontrolled. ' + s) : e[c] === void 0 && i[c] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + c + '" to be controlled. ' + s);
  });
});
var F9 = UL(function (t) {
  jH(t).textContent = "";
}, 500);
function jH(t) {
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
function FH(t, e) {
  if (!(!t || !e)) {
    var i = jH(e);
    i.textContent = t, F9(e);
  }
}
function N9(t) {
  var e = t == null ? void 0 : t.getElementById("a11y-status-message");
  e && e.remove();
}
var NH = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0,
  zH = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1,
  VH = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2,
  FM = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3,
  NM = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4,
  BH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5,
  UH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6,
  HH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7,
  $H = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8,
  WH = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9,
  qH = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10,
  YH = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11,
  GH = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12,
  S2 = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13,
  XH = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14,
  KH = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15,
  QH = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16,
  z9 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    blurButton: XH,
    blurInput: qH,
    changeInput: YH,
    clickButton: S2,
    clickItem: WH,
    controlledPropUpdatedSelectedItem: KH,
    itemMouseEnter: VH,
    keyDownArrowDown: NM,
    keyDownArrowUp: FM,
    keyDownEnd: $H,
    keyDownEnter: UH,
    keyDownEscape: BH,
    keyDownHome: HH,
    keyDownSpaceButton: GH,
    mouseUp: zH,
    touchEnd: QH,
    unknown: NH
  }),
  V9 = ["refKey", "ref"],
  B9 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  U9 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  H9 = ["refKey", "ref"],
  $9 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
  W9 = /* @__PURE__ */function () {
    var t = /* @__PURE__ */function (e) {
      function i(c) {
        var p;
        p = e.call(this, c) || this, p.id = p.props.id || "downshift-" + OH(), p.menuId = p.props.menuId || p.id + "-menu", p.labelId = p.props.labelId || p.id + "-label", p.inputId = p.props.inputId || p.id + "-input", p.getItemId = p.props.getItemId || function (O) {
          return p.id + "-item-" + O;
        }, p.items = [], p.itemCount = null, p.previousResultCount = 0, p.timeoutIds = [], p.internalSetTimeout = function (O, F) {
          var j = setTimeout(function () {
            p.timeoutIds = p.timeoutIds.filter(function (V) {
              return V !== j;
            }), O();
          }, F);
          p.timeoutIds.push(j);
        }, p.setItemCount = function (O) {
          p.itemCount = O;
        }, p.unsetItemCount = function () {
          p.itemCount = null;
        }, p.isItemDisabled = function (O, F) {
          var j = p.getItemNodeFromIndex(F);
          return j && j.hasAttribute("disabled");
        }, p.setHighlightedIndex = function (O, F) {
          O === void 0 && (O = p.props.defaultHighlightedIndex), F === void 0 && (F = {}), F = iM(F), p.internalSetState(Jn({
            highlightedIndex: O
          }, F));
        }, p.clearSelection = function (O) {
          p.internalSetState({
            selectedItem: null,
            inputValue: "",
            highlightedIndex: p.props.defaultHighlightedIndex,
            isOpen: p.props.defaultIsOpen
          }, O);
        }, p.selectItem = function (O, F, j) {
          F = iM(F), p.internalSetState(Jn({
            isOpen: p.props.defaultIsOpen,
            highlightedIndex: p.props.defaultHighlightedIndex,
            selectedItem: O,
            inputValue: p.props.itemToString(O)
          }, F), j);
        }, p.selectItemAtIndex = function (O, F, j) {
          var V = p.items[O];
          V != null && p.selectItem(V, F, j);
        }, p.selectHighlightedItem = function (O, F) {
          return p.selectItemAtIndex(p.getState().highlightedIndex, O, F);
        }, p.internalSetState = function (O, F) {
          var j,
            V,
            K = {},
            G = typeof O == "function";
          return !G && O.hasOwnProperty("inputValue") && p.props.onInputValueChange(O.inputValue, Jn({}, p.getStateAndHelpers(), O)), p.setState(function (Q) {
            var te;
            Q = p.getState(Q);
            var ie = G ? O(Q) : O;
            ie = p.props.stateReducer(Q, ie), j = ie.hasOwnProperty("selectedItem");
            var Y = {};
            return j && ie.selectedItem !== Q.selectedItem && (V = ie.selectedItem), (te = ie).type || (te.type = NH), Object.keys(ie).forEach(function (ee) {
              Q[ee] !== ie[ee] && (K[ee] = ie[ee]), ee !== "type" && (ie[ee], rL(p.props, ee) || (Y[ee] = ie[ee]));
            }), G && ie.hasOwnProperty("inputValue") && p.props.onInputValueChange(ie.inputValue, Jn({}, p.getStateAndHelpers(), ie)), Y;
          }, function () {
            fV(F)();
            var Q = Object.keys(K).length > 1;
            Q && p.props.onStateChange(K, p.getStateAndHelpers()), j && p.props.onSelect(O.selectedItem, p.getStateAndHelpers()), V !== void 0 && p.props.onChange(V, p.getStateAndHelpers()), p.props.onUserAction(K, p.getStateAndHelpers());
          });
        }, p.rootRef = function (O) {
          return p._rootNode = O;
        }, p.getRootProps = function (O, F) {
          var j,
            V = O === void 0 ? {} : O,
            K = V.refKey,
            G = K === void 0 ? "ref" : K,
            Q = V.ref,
            te = ip(V, V9),
            ie = F === void 0 ? {} : F,
            Y = ie.suppressRefError,
            ee = Y === void 0 ? !1 : Y;
          p.getRootProps.called = !0, p.getRootProps.refKey = G, p.getRootProps.suppressRefError = ee;
          var ae = p.getState(),
            ne = ae.isOpen;
          return Jn((j = {}, j[G] = pb(Q, p.rootRef), j.role = "combobox", j["aria-expanded"] = ne, j["aria-haspopup"] = "listbox", j["aria-owns"] = ne ? p.menuId : void 0, j["aria-labelledby"] = p.labelId, j), te);
        }, p.keyDownHandlers = {
          ArrowDown: function (O) {
            var F = this;
            if (O.preventDefault(), this.getState().isOpen) {
              var j = O.shiftKey ? 5 : 1;
              this.moveHighlightedIndex(j, {
                type: NM
              });
            } else this.internalSetState({
              isOpen: !0,
              type: NM
            }, function () {
              var V = F.getItemCount();
              if (V > 0) {
                var K = F.getState(),
                  G = K.highlightedIndex,
                  Q = $m(G, 1, {
                    length: V
                  }, F.isItemDisabled, !0);
                F.setHighlightedIndex(Q, {
                  type: NM
                });
              }
            });
          },
          ArrowUp: function (O) {
            var F = this;
            if (O.preventDefault(), this.getState().isOpen) {
              var j = O.shiftKey ? -5 : -1;
              this.moveHighlightedIndex(j, {
                type: FM
              });
            } else this.internalSetState({
              isOpen: !0,
              type: FM
            }, function () {
              var V = F.getItemCount();
              if (V > 0) {
                var K = F.getState(),
                  G = K.highlightedIndex,
                  Q = $m(G, -1, {
                    length: V
                  }, F.isItemDisabled, !0);
                F.setHighlightedIndex(Q, {
                  type: FM
                });
              }
            });
          },
          Enter: function (O) {
            if (O.which !== 229) {
              var F = this.getState(),
                j = F.isOpen,
                V = F.highlightedIndex;
              if (j && V != null) {
                O.preventDefault();
                var K = this.items[V],
                  G = this.getItemNodeFromIndex(V);
                if (K == null || G && G.hasAttribute("disabled")) return;
                this.selectHighlightedItem({
                  type: UH
                });
              }
            }
          },
          Escape: function (O) {
            O.preventDefault(), this.reset(Jn({
              type: BH
            }, !this.state.isOpen && {
              selectedItem: null,
              inputValue: ""
            }));
          }
        }, p.buttonKeyDownHandlers = Jn({}, p.keyDownHandlers, {
          " ": function (O) {
            O.preventDefault(), this.toggleMenu({
              type: GH
            });
          }
        }), p.inputKeyDownHandlers = Jn({}, p.keyDownHandlers, {
          Home: function (O) {
            var F = this.getState(),
              j = F.isOpen;
            if (j) {
              O.preventDefault();
              var V = this.getItemCount();
              if (!(V <= 0 || !j)) {
                var K = aw(0, !1, {
                  length: V
                }, this.isItemDisabled);
                this.setHighlightedIndex(K, {
                  type: HH
                });
              }
            }
          },
          End: function (O) {
            var F = this.getState(),
              j = F.isOpen;
            if (j) {
              O.preventDefault();
              var V = this.getItemCount();
              if (!(V <= 0 || !j)) {
                var K = aw(V - 1, !0, {
                  length: V
                }, this.isItemDisabled);
                this.setHighlightedIndex(K, {
                  type: $H
                });
              }
            }
          }
        }), p.getToggleButtonProps = function (O) {
          var F = O === void 0 ? {} : O,
            j = F.onClick;
          F.onPress;
          var V = F.onKeyDown,
            K = F.onKeyUp,
            G = F.onBlur,
            Q = ip(F, B9),
            te = p.getState(),
            ie = te.isOpen,
            Y = {
              onClick: oa(j, p.buttonHandleClick),
              onKeyDown: oa(V, p.buttonHandleKeyDown),
              onKeyUp: oa(K, p.buttonHandleKeyUp),
              onBlur: oa(G, p.buttonHandleBlur)
            },
            ee = Q.disabled ? {} : Y;
          return Jn({
            type: "button",
            role: "button",
            "aria-label": ie ? "close menu" : "open menu",
            "aria-haspopup": !0,
            "data-toggle": !0
          }, ee, Q);
        }, p.buttonHandleKeyUp = function (O) {
          O.preventDefault();
        }, p.buttonHandleKeyDown = function (O) {
          var F = iL(O);
          p.buttonKeyDownHandlers[F] && p.buttonKeyDownHandlers[F].call(p, O);
        }, p.buttonHandleClick = function (O) {
          if (O.preventDefault(), p.props.environment) {
            var F = p.props.environment.document,
              j = F.body,
              V = F.activeElement;
            j && j === V && O.target.focus();
          }
          process.env.NODE_ENV === "test" ? p.toggleMenu({
            type: S2
          }) : p.internalSetTimeout(function () {
            return p.toggleMenu({
              type: S2
            });
          });
        }, p.buttonHandleBlur = function (O) {
          var F = O.target;
          p.internalSetTimeout(function () {
            if (!(p.isMouseDown || !p.props.environment)) {
              var j = p.props.environment.document.activeElement;
              (j == null || j.id !== p.inputId) && j !== F && p.reset({
                type: XH
              });
            }
          });
        }, p.getLabelProps = function (O) {
          return Jn({
            htmlFor: p.inputId,
            id: p.labelId
          }, O);
        }, p.getInputProps = function (O) {
          var F = O === void 0 ? {} : O,
            j = F.onKeyDown,
            V = F.onBlur,
            K = F.onChange,
            G = F.onInput;
          F.onChangeText;
          var Q = ip(F, U9),
            te,
            ie = {};
          te = "onChange";
          var Y = p.getState(),
            ee = Y.inputValue,
            ae = Y.isOpen,
            ne = Y.highlightedIndex;
          if (!Q.disabled) {
            var le;
            ie = (le = {}, le[te] = oa(K, G, p.inputHandleChange), le.onKeyDown = oa(j, p.inputHandleKeyDown), le.onBlur = oa(V, p.inputHandleBlur), le);
          }
          return Jn({
            "aria-autocomplete": "list",
            "aria-activedescendant": ae && typeof ne == "number" && ne >= 0 ? p.getItemId(ne) : void 0,
            "aria-controls": ae ? p.menuId : void 0,
            "aria-labelledby": Q && Q["aria-label"] ? void 0 : p.labelId,
            // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
            autoComplete: "off",
            value: ee,
            id: p.inputId
          }, ie, Q);
        }, p.inputHandleKeyDown = function (O) {
          var F = iL(O);
          F && p.inputKeyDownHandlers[F] && p.inputKeyDownHandlers[F].call(p, O);
        }, p.inputHandleChange = function (O) {
          p.internalSetState({
            type: YH,
            isOpen: !0,
            inputValue: O.target.value,
            highlightedIndex: p.props.defaultHighlightedIndex
          });
        }, p.inputHandleBlur = function () {
          p.internalSetTimeout(function () {
            var O;
            if (!(p.isMouseDown || !p.props.environment)) {
              var F = p.props.environment.document.activeElement,
                j = (F == null || (O = F.dataset) == null ? void 0 : O.toggle) && p._rootNode && p._rootNode.contains(F);
              j || p.reset({
                type: qH
              });
            }
          });
        }, p.menuRef = function (O) {
          p._menuNode = O;
        }, p.getMenuProps = function (O, F) {
          var j,
            V = O === void 0 ? {} : O,
            K = V.refKey,
            G = K === void 0 ? "ref" : K,
            Q = V.ref,
            te = ip(V, H9),
            ie = F === void 0 ? {} : F,
            Y = ie.suppressRefError,
            ee = Y === void 0 ? !1 : Y;
          return p.getMenuProps.called = !0, p.getMenuProps.refKey = G, p.getMenuProps.suppressRefError = ee, Jn((j = {}, j[G] = pb(Q, p.menuRef), j.role = "listbox", j["aria-labelledby"] = te && te["aria-label"] ? void 0 : p.labelId, j.id = p.menuId, j), te);
        }, p.getItemProps = function (O) {
          var F,
            j = O === void 0 ? {} : O,
            V = j.onMouseMove,
            K = j.onMouseDown,
            G = j.onClick;
          j.onPress;
          var Q = j.index,
            te = j.item,
            ie = te === void 0 ? process.env.NODE_ENV === "production" ? (/* istanbul ignore next */
            void 0) : P9("getItemProps", "item") : te,
            Y = ip(j, $9);
          Q === void 0 ? (p.items.push(ie), Q = p.items.indexOf(ie)) : p.items[Q] = ie;
          var ee = "onClick",
            ae = G,
            ne = (F = {
              // onMouseMove is used over onMouseEnter here. onMouseMove
              // is only triggered on actual mouse movement while onMouseEnter
              // can fire on DOM changes, interrupting keyboard navigation
              onMouseMove: oa(V, function () {
                Q !== p.getState().highlightedIndex && (p.setHighlightedIndex(Q, {
                  type: VH
                }), p.avoidScrolling = !0, p.internalSetTimeout(function () {
                  return p.avoidScrolling = !1;
                }, 250));
              }),
              onMouseDown: oa(K, function (ce) {
                ce.preventDefault();
              })
            }, F[ee] = oa(ae, function () {
              p.selectItemAtIndex(Q, {
                type: WH
              });
            }), F),
            le = Y.disabled ? {
              onMouseDown: ne.onMouseDown
            } : ne;
          return Jn({
            id: p.getItemId(Q),
            role: "option",
            "aria-selected": p.getState().highlightedIndex === Q
          }, le, Y);
        }, p.clearItems = function () {
          p.items = [];
        }, p.reset = function (O, F) {
          O === void 0 && (O = {}), O = iM(O), p.internalSetState(function (j) {
            var V = j.selectedItem;
            return Jn({
              isOpen: p.props.defaultIsOpen,
              highlightedIndex: p.props.defaultHighlightedIndex,
              inputValue: p.props.itemToString(V)
            }, O);
          }, F);
        }, p.toggleMenu = function (O, F) {
          O === void 0 && (O = {}), O = iM(O), p.internalSetState(function (j) {
            var V = j.isOpen;
            return Jn({
              isOpen: !V
            }, V && {
              highlightedIndex: p.props.defaultHighlightedIndex
            }, O);
          }, function () {
            var j = p.getState(),
              V = j.isOpen,
              K = j.highlightedIndex;
            V && p.getItemCount() > 0 && typeof K == "number" && p.setHighlightedIndex(K, O), fV(F)();
          });
        }, p.openMenu = function (O) {
          p.internalSetState({
            isOpen: !0
          }, O);
        }, p.closeMenu = function (O) {
          p.internalSetState({
            isOpen: !1
          }, O);
        }, p.updateStatus = UL(function () {
          var O;
          if ((O = p.props) != null && (O = O.environment) != null && O.document) {
            var F = p.getState(),
              j = p.items[F.highlightedIndex],
              V = p.getItemCount(),
              K = p.props.getA11yStatusMessage(Jn({
                itemToString: p.props.itemToString,
                previousResultCount: p.previousResultCount,
                resultCount: V,
                highlightedItem: j
              }, F));
            p.previousResultCount = V, FH(K, p.props.environment.document);
          }
        }, 200);
        var h = p.props,
          y = h.defaultHighlightedIndex,
          w = h.initialHighlightedIndex,
          x = w === void 0 ? y : w,
          E = h.defaultIsOpen,
          C = h.initialIsOpen,
          k = C === void 0 ? E : C,
          D = h.initialInputValue,
          I = D === void 0 ? "" : D,
          L = h.initialSelectedItem,
          P = L === void 0 ? null : L,
          N = p.getState({
            highlightedIndex: x,
            isOpen: k,
            inputValue: I,
            selectedItem: P
          });
        return N.selectedItem != null && p.props.initialInputValue === void 0 && (N.inputValue = p.props.itemToString(N.selectedItem)), p.state = N, p;
      }
      y9(i, e);
      var s = i.prototype;
      return s.internalClearTimeouts = function () {
        this.timeoutIds.forEach(function (c) {
          clearTimeout(c);
        }), this.timeoutIds = [];
      }, s.getState = function (c) {
        return c === void 0 && (c = this.state), iR(c, this.props);
      }, s.getItemCount = function () {
        var c = this.items.length;
        return this.itemCount != null ? c = this.itemCount : this.props.itemCount !== void 0 && (c = this.props.itemCount), c;
      }, s.getItemNodeFromIndex = function (c) {
        return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(c)) : null;
      }, s.scrollHighlightedItemIntoView = function () {
        {
          var c = this.getItemNodeFromIndex(this.getState().highlightedIndex);
          this.props.scrollIntoView(c, this._menuNode);
        }
      }, s.moveHighlightedIndex = function (c, p) {
        var h = this.getItemCount(),
          y = this.getState(),
          w = y.highlightedIndex;
        if (h > 0) {
          var x = $m(w, c, {
            length: h
          }, this.isItemDisabled, !0);
          this.setHighlightedIndex(x, p);
        }
      }, s.getStateAndHelpers = function () {
        var c = this.getState(),
          p = c.highlightedIndex,
          h = c.inputValue,
          y = c.selectedItem,
          w = c.isOpen,
          x = this.props.itemToString,
          E = this.id,
          C = this.getRootProps,
          k = this.getToggleButtonProps,
          D = this.getLabelProps,
          I = this.getMenuProps,
          L = this.getInputProps,
          P = this.getItemProps,
          N = this.openMenu,
          O = this.closeMenu,
          F = this.toggleMenu,
          j = this.selectItem,
          V = this.selectItemAtIndex,
          K = this.selectHighlightedItem,
          G = this.setHighlightedIndex,
          Q = this.clearSelection,
          te = this.clearItems,
          ie = this.reset,
          Y = this.setItemCount,
          ee = this.unsetItemCount,
          ae = this.internalSetState;
        return {
          // prop getters
          getRootProps: C,
          getToggleButtonProps: k,
          getLabelProps: D,
          getMenuProps: I,
          getInputProps: L,
          getItemProps: P,
          // actions
          reset: ie,
          openMenu: N,
          closeMenu: O,
          toggleMenu: F,
          selectItem: j,
          selectItemAtIndex: V,
          selectHighlightedItem: K,
          setHighlightedIndex: G,
          clearSelection: Q,
          clearItems: te,
          setItemCount: Y,
          unsetItemCount: ee,
          setState: ae,
          // props
          itemToString: x,
          // derived
          id: E,
          // state
          highlightedIndex: p,
          inputValue: h,
          isOpen: w,
          selectedItem: y
        };
      }, s.componentDidMount = function () {
        var c = this;
        if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && mV(this._menuNode, this.getMenuProps), !this.props.environment) this.cleanup = function () {
          c.internalClearTimeouts();
        };else {
          var p = function () {
              c.isMouseDown = !0;
            },
            h = function (C) {
              c.isMouseDown = !1;
              var k = aL(C.target, [c._rootNode, c._menuNode], c.props.environment);
              !k && c.getState().isOpen && c.reset({
                type: zH
              }, function () {
                return c.props.onOuterClick(c.getStateAndHelpers());
              });
            },
            y = function () {
              c.isTouchMove = !1;
            },
            w = function () {
              c.isTouchMove = !0;
            },
            x = function (C) {
              var k = aL(C.target, [c._rootNode, c._menuNode], c.props.environment, !1);
              !c.isTouchMove && !k && c.getState().isOpen && c.reset({
                type: QH
              }, function () {
                return c.props.onOuterClick(c.getStateAndHelpers());
              });
            },
            E = this.props.environment;
          E.addEventListener("mousedown", p), E.addEventListener("mouseup", h), E.addEventListener("touchstart", y), E.addEventListener("touchmove", w), E.addEventListener("touchend", x), this.cleanup = function () {
            c.internalClearTimeouts(), c.updateStatus.cancel(), E.removeEventListener("mousedown", p), E.removeEventListener("mouseup", h), E.removeEventListener("touchstart", y), E.removeEventListener("touchmove", w), E.removeEventListener("touchend", x);
          };
        }
      }, s.shouldScroll = function (c, p) {
        var h = this.props.highlightedIndex === void 0 ? this.getState() : this.props,
          y = h.highlightedIndex,
          w = p.highlightedIndex === void 0 ? c : p,
          x = w.highlightedIndex,
          E = y && this.getState().isOpen && !c.isOpen,
          C = y !== x;
        return E || C;
      }, s.componentDidUpdate = function (c, p) {
        process.env.NODE_ENV !== "production" && (OF(this.state, c, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && mV(this._menuNode, this.getMenuProps)), rL(this.props, "selectedItem") && this.props.selectedItemChanged(c.selectedItem, this.props.selectedItem) && this.internalSetState({
          type: KH,
          inputValue: this.props.itemToString(this.props.selectedItem)
        }), !this.avoidScrolling && this.shouldScroll(p, c) && this.scrollHighlightedItemIntoView(), this.updateStatus();
      }, s.componentWillUnmount = function () {
        this.cleanup();
      }, s.render = function () {
        var c = hV(this.props.children, rd);
        this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
        var p = hV(c(this.getStateAndHelpers()));
        if (!p) return null;
        if (this.getRootProps.called || this.props.suppressRefError) return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && q9(p, this.getRootProps), p;
        if (PH(p)) return /* @__PURE__ */FR(p, this.getRootProps(AH(p)));
        if (process.env.NODE_ENV !== "production") throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
      }, i;
    }(oH);
    return t.defaultProps = {
      defaultHighlightedIndex: null,
      defaultIsOpen: !1,
      getA11yStatusMessage: O9,
      itemToString: function (e) {
        return e == null ? "" : (process.env.NODE_ENV !== "production" && j9(e) && !e.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", e), String(e));
      },
      onStateChange: rd,
      onInputValueChange: rd,
      onUserAction: rd,
      onChange: rd,
      onSelect: rd,
      onOuterClick: rd,
      selectedItemChanged: function (e, i) {
        return e !== i;
      },
      environment: (/* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window),
      stateReducer: function (e, i) {
        return i;
      },
      suppressRefError: !1,
      scrollIntoView: LH
    }, t.stateChangeTypes = z9, t;
  }();
process.env.NODE_ENV !== "production" && (W9.propTypes = {
  children: Ot.func,
  defaultHighlightedIndex: Ot.number,
  defaultIsOpen: Ot.bool,
  initialHighlightedIndex: Ot.number,
  initialSelectedItem: Ot.any,
  initialInputValue: Ot.string,
  initialIsOpen: Ot.bool,
  getA11yStatusMessage: Ot.func,
  itemToString: Ot.func,
  onChange: Ot.func,
  onSelect: Ot.func,
  onStateChange: Ot.func,
  onInputValueChange: Ot.func,
  onUserAction: Ot.func,
  onOuterClick: Ot.func,
  selectedItemChanged: Ot.func,
  stateReducer: Ot.func,
  itemCount: Ot.number,
  id: Ot.string,
  environment: Ot.shape({
    addEventListener: Ot.func.isRequired,
    removeEventListener: Ot.func.isRequired,
    document: Ot.shape({
      createElement: Ot.func.isRequired,
      getElementById: Ot.func.isRequired,
      activeElement: Ot.any.isRequired,
      body: Ot.any.isRequired
    }).isRequired,
    Node: Ot.func.isRequired
  }),
  suppressRefError: Ot.bool,
  scrollIntoView: Ot.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: Ot.any,
  isOpen: Ot.bool,
  inputValue: Ot.string,
  highlightedIndex: Ot.number,
  labelId: Ot.string,
  inputId: Ot.string,
  menuId: Ot.string,
  getItemId: Ot.func
  /* eslint-enable react/no-unused-prop-types */
});
function mV(t, e) {
  var i = e.refKey;
  t || console.error('downshift: The ref prop "' + i + '" from getMenuProps was not applied correctly on your menu element.');
}
function q9(t, e) {
  var i = e.refKey,
    s = i !== "ref",
    c = !PH(t);
  c && !s && !uV.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !c && s && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + i + '"'), !uV.isForwardRef(t) && !AH(t)[i] && console.error('downshift: You must apply the ref prop "' + i + '" from getRootProps onto your root element.');
}
var ZH = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function Y9(t, e, i) {
  var s = t.props,
    c = t.type,
    p = {};
  Object.keys(e).forEach(function (h) {
    G9(h, t, e, i), i[h] !== e[h] && (p[h] = i[h]);
  }), s.onStateChange && Object.keys(p).length && s.onStateChange(Jn({
    type: c
  }, p));
}
function G9(t, e, i, s) {
  var c = e.props,
    p = e.type,
    h = "on" + PF(t) + "Change";
  c[h] && s[t] !== void 0 && s[t] !== i[t] && c[h](Jn({
    type: p
  }, s));
}
function X9(t, e) {
  return e.changes;
}
var vV = UL(function (t, e) {
    FH(t, e);
  }, 200),
  K9 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? NR : Rt,
  JH = "useId" in Nt ? function (t) {
    var e = t.id,
      i = t.labelId,
      s = t.menuId,
      c = t.getItemId,
      p = t.toggleButtonId,
      h = t.inputId,
      y = "downshift-" + Nt.useId();
    e || (e = y);
    var w = vt({
      labelId: i || e + "-label",
      menuId: s || e + "-menu",
      getItemId: c || function (x) {
        return e + "-item-" + x;
      },
      toggleButtonId: p || e + "-toggle-button",
      inputId: h || e + "-input"
    });
    return w.current;
  } : function (t) {
    var e = t.id,
      i = e === void 0 ? "downshift-" + OH() : e,
      s = t.labelId,
      c = t.menuId,
      p = t.getItemId,
      h = t.toggleButtonId,
      y = t.inputId,
      w = vt({
        labelId: s || i + "-label",
        menuId: c || i + "-menu",
        getItemId: p || function (x) {
          return i + "-item-" + x;
        },
        toggleButtonId: h || i + "-toggle-button",
        inputId: y || i + "-input"
      });
    return w.current;
  };
function e5(t, e, i, s) {
  var c, p;
  if (t === void 0) {
    if (e === void 0) throw new Error(s);
    c = i[e], p = e;
  } else p = e === void 0 ? i.indexOf(t) : e, c = t;
  return [c, p];
}
function Q9(t) {
  return /^\S{1}$/.test(t);
}
function PF(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function AF(t) {
  var e = vt(t);
  return e.current = t, e;
}
function t5(t, e, i, s) {
  var c = vt(),
    p = vt(),
    h = pn(function (D, I) {
      p.current = I, D = iR(D, I.props);
      var L = t(D, I),
        P = I.props.stateReducer(D, Jn({}, I, {
          changes: L
        }));
      return P;
    }, [t]),
    y = MW(h, e, i),
    w = y[0],
    x = y[1],
    E = AF(e),
    C = pn(function (D) {
      return x(Jn({
        props: E.current
      }, D));
    }, [E]),
    k = p.current;
  return Rt(function () {
    var D = iR(c.current, k == null ? void 0 : k.props),
      I = k && c.current && !s(D, w);
    I && Y9(k, D, w), c.current = w;
  }, [w, k, s]), [w, C];
}
function Z9(t, e, i, s) {
  var c = t5(t, e, i, s),
    p = c[0],
    h = c[1];
  return [iR(p, e), h];
}
var jT = {
  itemToString: function (t) {
    return t ? String(t) : "";
  },
  itemToKey: function (t) {
    return t;
  },
  stateReducer: X9,
  scrollIntoView: LH,
  environment: (/* istanbul ignore next (ssr) */
  typeof window > "u" ? void 0 : window)
};
function vb(t, e, i) {
  i === void 0 && (i = ZH);
  var s = t["default" + PF(e)];
  return s !== void 0 ? s : i[e];
}
function pE(t, e, i) {
  i === void 0 && (i = ZH);
  var s = t[e];
  if (s !== void 0) return s;
  var c = t["initial" + PF(e)];
  return c !== void 0 ? c : vb(t, e, i);
}
function n5(t) {
  var e = pE(t, "selectedItem"),
    i = pE(t, "isOpen"),
    s = J9(t),
    c = pE(t, "inputValue");
  return {
    highlightedIndex: s < 0 && e && i ? t.items.findIndex(function (p) {
      return t.itemToKey(p) === t.itemToKey(e);
    }) : s,
    isOpen: i,
    selectedItem: e,
    inputValue: c
  };
}
function qx(t, e, i) {
  var s = t.items,
    c = t.initialHighlightedIndex,
    p = t.defaultHighlightedIndex,
    h = t.isItemDisabled,
    y = t.itemToKey,
    w = e.selectedItem,
    x = e.highlightedIndex;
  return s.length === 0 ? -1 : c !== void 0 && x === c && !h(s[c], c) ? c : p !== void 0 && !h(s[p], p) ? p : w ? s.findIndex(function (E) {
    return y(w) === y(E);
  }) : i < 0 && !h(s[s.length - 1], s.length - 1) ? s.length - 1 : i > 0 && !h(s[0], 0) ? 0 : -1;
}
function r5(t, e, i) {
  var s = vt({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return Rt(function () {
    if (!t) return rd;
    var c = i.map(function (E) {
      return E.current;
    });
    function p() {
      s.current.isTouchEnd = !1, s.current.isMouseDown = !0;
    }
    function h(E) {
      s.current.isMouseDown = !1, aL(E.target, c, t) || e();
    }
    function y() {
      s.current.isTouchEnd = !1, s.current.isTouchMove = !1;
    }
    function w() {
      s.current.isTouchMove = !0;
    }
    function x(E) {
      s.current.isTouchEnd = !0, !s.current.isTouchMove && !aL(E.target, c, t, !1) && e();
    }
    return t.addEventListener("mousedown", p), t.addEventListener("mouseup", h), t.addEventListener("touchstart", y), t.addEventListener("touchmove", w), t.addEventListener("touchend", x), function () {
      t.removeEventListener("mousedown", p), t.removeEventListener("mouseup", h), t.removeEventListener("touchstart", y), t.removeEventListener("touchmove", w), t.removeEventListener("touchend", x);
    };
  }, [i, t, e]), s.current;
}
var jF = function () {
  return rd;
};
process.env.NODE_ENV !== "production" && (jF = function () {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  var s = vt(e.reduce(function (p, h) {
    return p[h] = {}, p;
  }, {}));
  Rt(function () {
    Object.keys(s.current).forEach(function (p) {
      var h = s.current[p];
      if (!Object.keys(h).length) {
        console.error("downshift: You forgot to call the " + p + " getter function on your component / element.");
        return;
      }
      var y = h.suppressRefError,
        w = h.refKey,
        x = h.elementRef;
      y || x != null && x.current || console.error('downshift: The ref prop "' + w + '" from ' + p + " was not applied correctly on your element.");
    });
  }, []);
  var c = pn(function (p, h, y, w) {
    s.current[p] = {
      suppressRefError: h,
      refKey: y,
      elementRef: w
    };
  }, []);
  return c;
});
function i5(t, e, i, s) {
  s === void 0 && (s = {});
  var c = s.document,
    p = HL();
  Rt(function () {
    if (!(!t || p || !c)) {
      var h = t(e);
      vV(h, c);
    }
  }, i), Rt(function () {
    return function () {
      vV.cancel(), N9(c);
    };
  }, [c]);
}
function a5(t) {
  var e = t.highlightedIndex,
    i = t.isOpen,
    s = t.itemRefs,
    c = t.getItemNodeFromIndex,
    p = t.menuElement,
    h = t.scrollIntoView,
    y = vt(!0);
  return K9(function () {
    e < 0 || !i || !Object.keys(s.current).length || (y.current === !1 ? y.current = !0 : h(c(e), p));
  }, [e]), y;
}
var FF = rd;
process.env.NODE_ENV !== "production" && (FF = function (t) {
  var e = t.props,
    i = t.state,
    s = vt(e),
    c = HL();
  Rt(function () {
    c || (OF(i, s.current, e), s.current = e);
  }, [i, e, c]);
});
function oL(t, e, i) {
  var s;
  i === void 0 && (i = !0);
  var c = ((s = t.items) == null ? void 0 : s.length) && e >= 0;
  return Jn({
    isOpen: !1,
    highlightedIndex: -1
  }, c && Jn({
    selectedItem: t.items[e],
    isOpen: vb(t, "isOpen"),
    highlightedIndex: vb(t, "highlightedIndex")
  }, i && {
    inputValue: t.itemToString(t.items[e])
  }));
}
function o5(t, e) {
  return t.isOpen === e.isOpen && t.inputValue === e.inputValue && t.highlightedIndex === e.highlightedIndex && t.selectedItem === e.selectedItem;
}
function HL() {
  var t = Nt.useRef(!0);
  return Nt.useEffect(function () {
    return t.current = !1, function () {
      t.current = !0;
    };
  }, []), t.current;
}
function lL(t) {
  var e = vb(t, "highlightedIndex");
  return e > -1 && t.isItemDisabled(t.items[e], e) ? -1 : e;
}
function J9(t) {
  var e = pE(t, "highlightedIndex");
  return e > -1 && t.isItemDisabled(t.items[e], e) ? -1 : e;
}
var zM = {
    environment: Ot.shape({
      addEventListener: Ot.func.isRequired,
      removeEventListener: Ot.func.isRequired,
      document: Ot.shape({
        createElement: Ot.func.isRequired,
        getElementById: Ot.func.isRequired,
        activeElement: Ot.any.isRequired,
        body: Ot.any.isRequired
      }).isRequired,
      Node: Ot.func.isRequired
    }),
    itemToString: Ot.func,
    itemToKey: Ot.func,
    stateReducer: Ot.func
  },
  l5 = Jn({}, zM, {
    getA11yStatusMessage: Ot.func,
    highlightedIndex: Ot.number,
    defaultHighlightedIndex: Ot.number,
    initialHighlightedIndex: Ot.number,
    isOpen: Ot.bool,
    defaultIsOpen: Ot.bool,
    initialIsOpen: Ot.bool,
    selectedItem: Ot.any,
    initialSelectedItem: Ot.any,
    defaultSelectedItem: Ot.any,
    id: Ot.string,
    labelId: Ot.string,
    menuId: Ot.string,
    getItemId: Ot.func,
    toggleButtonId: Ot.string,
    onSelectedItemChange: Ot.func,
    onHighlightedIndexChange: Ot.func,
    onStateChange: Ot.func,
    onIsOpenChange: Ot.func,
    scrollIntoView: Ot.func
  });
function s5(t, e, i) {
  var s = e.type,
    c = e.props,
    p;
  switch (s) {
    case i.ItemMouseMove:
      p = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case i.MenuMouseLeave:
      p = {
        highlightedIndex: -1
      };
      break;
    case i.ToggleButtonClick:
    case i.FunctionToggleMenu:
      p = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : qx(c, t, 0)
      };
      break;
    case i.FunctionOpenMenu:
      p = {
        isOpen: !0,
        highlightedIndex: qx(c, t, 0)
      };
      break;
    case i.FunctionCloseMenu:
      p = {
        isOpen: !1
      };
      break;
    case i.FunctionSetHighlightedIndex:
      p = {
        highlightedIndex: c.isItemDisabled(c.items[e.highlightedIndex], e.highlightedIndex) ? -1 : e.highlightedIndex
      };
      break;
    case i.FunctionSetInputValue:
      p = {
        inputValue: e.inputValue
      };
      break;
    case i.FunctionReset:
      p = {
        highlightedIndex: lL(c),
        isOpen: vb(c, "isOpen"),
        selectedItem: vb(c, "selectedItem"),
        inputValue: vb(c, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Jn({}, t, p);
}
function e7(t) {
  for (var e = t.keysSoFar, i = t.highlightedIndex, s = t.items, c = t.itemToString, p = t.isItemDisabled, h = e.toLowerCase(), y = 0; y < s.length; y++) {
    var w = (y + i + (e.length < 2 ? 1 : 0)) % s.length,
      x = s[w];
    if (x !== void 0 && c(x).toLowerCase().startsWith(h) && !p(x, w)) return w;
  }
  return i;
}
var t7 = xE(xE({}, l5), {
    items: Ot.array.isRequired,
    isItemDisabled: Ot.func
  }),
  n7 = xE(xE({}, jT), {
    isItemDisabled: function () {
      return !1;
    }
  }),
  u5 = rd;
process.env.NODE_ENV !== "production" && (u5 = function (t, e) {
  Ot.checkPropTypes(t7, t, "prop", e.name);
});
var VM = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0,
  NF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1,
  zF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2,
  sL = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3,
  VF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4,
  BF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5,
  UF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6,
  HF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7,
  $F = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8,
  WF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9,
  qF = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10,
  uL = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11,
  c5 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12,
  d5 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13,
  YF = process.env.NODE_ENV !== "production" ? "__item_click__" : 14,
  f5 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15,
  p5 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16,
  h5 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17,
  m5 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18,
  GF = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19,
  E2 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20,
  v5 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21,
  g5 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    FunctionCloseMenu: h5,
    FunctionOpenMenu: p5,
    FunctionReset: v5,
    FunctionSelectItem: GF,
    FunctionSetHighlightedIndex: m5,
    FunctionSetInputValue: E2,
    FunctionToggleMenu: f5,
    ItemClick: YF,
    ItemMouseMove: d5,
    MenuMouseLeave: c5,
    ToggleButtonBlur: uL,
    ToggleButtonClick: VM,
    ToggleButtonKeyDownArrowDown: NF,
    ToggleButtonKeyDownArrowUp: zF,
    ToggleButtonKeyDownCharacter: sL,
    ToggleButtonKeyDownEnd: UF,
    ToggleButtonKeyDownEnter: HF,
    ToggleButtonKeyDownEscape: VF,
    ToggleButtonKeyDownHome: BF,
    ToggleButtonKeyDownPageDown: qF,
    ToggleButtonKeyDownPageUp: WF,
    ToggleButtonKeyDownSpaceButton: $F
  });
function r7(t, e) {
  var i,
    s = e.type,
    c = e.props,
    p = e.altKey,
    h;
  switch (s) {
    case YF:
      h = {
        isOpen: vb(c, "isOpen"),
        highlightedIndex: lL(c),
        selectedItem: c.items[e.index]
      };
      break;
    case sL:
      {
        var y = e.key,
          w = "" + t.inputValue + y,
          x = !t.isOpen && t.selectedItem ? c.items.findIndex(function (D) {
            return c.itemToKey(D) === c.itemToKey(t.selectedItem);
          }) : t.highlightedIndex,
          E = e7({
            keysSoFar: w,
            highlightedIndex: x,
            items: c.items,
            itemToString: c.itemToString,
            isItemDisabled: c.isItemDisabled
          });
        h = {
          inputValue: w,
          highlightedIndex: E,
          isOpen: !0
        };
      }
      break;
    case NF:
      {
        var C = t.isOpen ? $m(t.highlightedIndex, 1, c.items, c.isItemDisabled) : p && t.selectedItem == null ? -1 : qx(c, t, 1);
        h = {
          highlightedIndex: C,
          isOpen: !0
        };
      }
      break;
    case zF:
      if (t.isOpen && p) h = oL(c, t.highlightedIndex, !1);else {
        var k = t.isOpen ? $m(t.highlightedIndex, -1, c.items, c.isItemDisabled) : qx(c, t, -1);
        h = {
          highlightedIndex: k,
          isOpen: !0
        };
      }
      break;
    // only triggered when menu is open.
    case HF:
    case $F:
      h = oL(c, t.highlightedIndex, !1);
      break;
    case BF:
      h = {
        highlightedIndex: aw(0, !1, c.items, c.isItemDisabled),
        isOpen: !0
      };
      break;
    case UF:
      h = {
        highlightedIndex: aw(c.items.length - 1, !0, c.items, c.isItemDisabled),
        isOpen: !0
      };
      break;
    case WF:
      h = {
        highlightedIndex: $m(t.highlightedIndex, -10, c.items, c.isItemDisabled)
      };
      break;
    case qF:
      h = {
        highlightedIndex: $m(t.highlightedIndex, 10, c.items, c.isItemDisabled)
      };
      break;
    case VF:
      h = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case uL:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((i = c.items) == null ? void 0 : i.length) && {
        selectedItem: c.items[t.highlightedIndex]
      });
      break;
    case GF:
      h = {
        selectedItem: e.selectedItem
      };
      break;
    default:
      return s5(t, e, g5);
  }
  return Jn({}, t, h);
}
var i7 = ["onClick"],
  a7 = ["onMouseLeave", "refKey", "ref"],
  o7 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"],
  l7 = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
jp.stateChangeTypes = g5;
function jp(t) {
  t === void 0 && (t = {}), u5(t, jp);
  var e = Jn({}, n7, t),
    i = e.scrollIntoView,
    s = e.environment,
    c = e.getA11yStatusMessage,
    p = Z9(r7, e, n5, o5),
    h = p[0],
    y = p[1],
    w = h.isOpen,
    x = h.highlightedIndex,
    E = h.selectedItem,
    C = h.inputValue,
    k = vt(null),
    D = vt(null),
    I = vt({}),
    L = vt(null),
    P = JH(e),
    N = AF({
      state: h,
      props: e
    }),
    O = pn(function ($) {
      return I.current[P.getItemId($)];
    }, [P]);
  i5(c, h, [w, x, E, C], s);
  var F = a5({
    menuElement: D.current,
    highlightedIndex: x,
    isOpen: w,
    itemRefs: I,
    scrollIntoView: i,
    getItemNodeFromIndex: O
  });
  Rt(function () {
    return L.current = UL(function ($) {
      $({
        type: E2,
        inputValue: ""
      });
    }, 500), function () {
      L.current.cancel();
    };
  }, []), Rt(function () {
    C && L.current(y);
  }, [y, C]), FF({
    props: e,
    state: h
  }), Rt(function () {
    var $ = pE(e, "isOpen");
    $ && k.current && k.current.focus();
  }, []);
  var j = r5(s, pn(function () {
      N.current.state.isOpen && y({
        type: uL
      });
    }, [y, N]), ci(function () {
      return [D, k];
    }, [D.current, k.current])),
    V = jF("getMenuProps", "getToggleButtonProps");
  Rt(function () {
    w || (I.current = {});
  }, [w]);
  var K = ci(function () {
      return {
        ArrowDown: function ($) {
          $.preventDefault(), y({
            type: NF,
            altKey: $.altKey
          });
        },
        ArrowUp: function ($) {
          $.preventDefault(), y({
            type: zF,
            altKey: $.altKey
          });
        },
        Home: function ($) {
          $.preventDefault(), y({
            type: BF
          });
        },
        End: function ($) {
          $.preventDefault(), y({
            type: UF
          });
        },
        Escape: function () {
          N.current.state.isOpen && y({
            type: VF
          });
        },
        Enter: function ($) {
          $.preventDefault(), y({
            type: N.current.state.isOpen ? HF : VM
          });
        },
        PageUp: function ($) {
          N.current.state.isOpen && ($.preventDefault(), y({
            type: WF
          }));
        },
        PageDown: function ($) {
          N.current.state.isOpen && ($.preventDefault(), y({
            type: qF
          }));
        },
        " ": function ($) {
          $.preventDefault();
          var de = N.current.state;
          if (!de.isOpen) {
            y({
              type: VM
            });
            return;
          }
          de.inputValue ? y({
            type: sL,
            key: " "
          }) : y({
            type: $F
          });
        }
      };
    }, [y, N]),
    G = pn(function () {
      y({
        type: f5
      });
    }, [y]),
    Q = pn(function () {
      y({
        type: h5
      });
    }, [y]),
    te = pn(function () {
      y({
        type: p5
      });
    }, [y]),
    ie = pn(function ($) {
      y({
        type: m5,
        highlightedIndex: $
      });
    }, [y]),
    Y = pn(function ($) {
      y({
        type: GF,
        selectedItem: $
      });
    }, [y]),
    ee = pn(function () {
      y({
        type: v5
      });
    }, [y]),
    ae = pn(function ($) {
      y({
        type: E2,
        inputValue: $
      });
    }, [y]),
    ne = pn(function ($) {
      var de = $ === void 0 ? {} : $,
        H = de.onClick,
        se = ip(de, i7),
        ue = function () {
          var Ee;
          (Ee = k.current) == null || Ee.focus();
        };
      return Jn({
        id: P.labelId,
        htmlFor: P.toggleButtonId,
        onClick: oa(H, ue)
      }, se);
    }, [P]),
    le = pn(function ($, de) {
      var H,
        se = $ === void 0 ? {} : $,
        ue = se.onMouseLeave,
        Ee = se.refKey,
        Ce = Ee === void 0 ? "ref" : Ee,
        fe = se.ref,
        _e = ip(se, a7),
        Se = de === void 0 ? {} : de,
        be = Se.suppressRefError,
        Le = be === void 0 ? !1 : be,
        Be = function () {
          y({
            type: c5
          });
        };
      return V("getMenuProps", Le, Ce, D), Jn((H = {}, H[Ce] = pb(fe, function (Xe) {
        D.current = Xe;
      }), H.id = P.menuId, H.role = "listbox", H["aria-labelledby"] = _e && _e["aria-label"] ? void 0 : "" + P.labelId, H.onMouseLeave = oa(ue, Be), H), _e);
    }, [y, V, P]),
    ce = pn(function ($, de) {
      var H,
        se = $ === void 0 ? {} : $,
        ue = se.onBlur,
        Ee = se.onClick;
      se.onPress;
      var Ce = se.onKeyDown,
        fe = se.refKey,
        _e = fe === void 0 ? "ref" : fe,
        Se = se.ref,
        be = ip(se, o7),
        Le = de === void 0 ? {} : de,
        Be = Le.suppressRefError,
        Xe = Be === void 0 ? !1 : Be,
        ge = N.current.state,
        qe = function () {
          y({
            type: VM
          });
        },
        Ae = function () {
          ge.isOpen && !j.isMouseDown && y({
            type: uL
          });
        },
        Mt = function (un) {
          var gt = iL(un);
          gt && K[gt] ? K[gt](un) : Q9(gt) && y({
            type: sL,
            key: gt
          });
        },
        Ft = Jn((H = {}, H[_e] = pb(Se, function (un) {
          k.current = un;
        }), H["aria-activedescendant"] = ge.isOpen && ge.highlightedIndex > -1 ? P.getItemId(ge.highlightedIndex) : "", H["aria-controls"] = P.menuId, H["aria-expanded"] = N.current.state.isOpen, H["aria-haspopup"] = "listbox", H["aria-labelledby"] = be && be["aria-label"] ? void 0 : "" + P.labelId, H.id = P.toggleButtonId, H.role = "combobox", H.tabIndex = 0, H.onBlur = oa(ue, Ae), H), be);
      return be.disabled || (Ft.onClick = oa(Ee, qe), Ft.onKeyDown = oa(Ce, Mt)), V("getToggleButtonProps", Xe, _e, k), Ft;
    }, [y, P, N, j, V, K]),
    W = pn(function ($) {
      var de,
        H = $ === void 0 ? {} : $,
        se = H.item,
        ue = H.index,
        Ee = H.onMouseMove,
        Ce = H.onClick,
        fe = H.onMouseDown;
      H.onPress;
      var _e = H.refKey,
        Se = _e === void 0 ? "ref" : _e,
        be = H.disabled,
        Le = H.ref,
        Be = ip(H, l7);
      be !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
      var Xe = N.current,
        ge = Xe.state,
        qe = Xe.props,
        Ae = e5(se, ue, qe.items, "Pass either item or index to getItemProps!"),
        Mt = Ae[0],
        Ft = Ae[1],
        un = qe.isItemDisabled(Mt, Ft),
        gt = function () {
          j.isTouchEnd || Ft === ge.highlightedIndex || (F.current = !1, y({
            type: d5,
            index: Ft,
            disabled: un
          }));
        },
        Pt = function () {
          y({
            type: YF,
            index: Ft
          });
        },
        St = function (Kt) {
          return Kt.preventDefault();
        },
        Dt = Jn((de = {}, de[Se] = pb(Le, function (Kt) {
          Kt && (I.current[P.getItemId(Ft)] = Kt);
        }), de["aria-disabled"] = un, de["aria-selected"] = Mt === ge.selectedItem, de.id = P.getItemId(Ft), de.role = "option", de), Be);
      return un || (Dt.onClick = oa(Ce, Pt)), Dt.onMouseMove = oa(Ee, gt), Dt.onMouseDown = oa(fe, St), Dt;
    }, [N, P, j, F, y]);
  return {
    // prop getters.
    getToggleButtonProps: ce,
    getLabelProps: ne,
    getMenuProps: le,
    getItemProps: W,
    // actions.
    toggleMenu: G,
    openMenu: te,
    closeMenu: Q,
    setHighlightedIndex: ie,
    selectItem: Y,
    reset: ee,
    setInputValue: ae,
    // state.
    highlightedIndex: x,
    isOpen: w,
    selectedItem: E,
    inputValue: C
  };
}
var XF = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0,
  KF = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1,
  QF = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2,
  ZF = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3,
  JF = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4,
  eN = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5,
  tN = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6,
  nN = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7,
  rN = process.env.NODE_ENV !== "production" ? "__input_change__" : 8,
  cL = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9,
  iN = process.env.NODE_ENV !== "production" ? "__input_click__" : 10,
  y5 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11,
  b5 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12,
  aN = process.env.NODE_ENV !== "production" ? "__item_click__" : 13,
  w5 = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14,
  _5 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15,
  x5 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16,
  S5 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17,
  E5 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18,
  oN = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19,
  C5 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20,
  k5 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21,
  lN = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22,
  T5 = /* @__PURE__ */Object.freeze({
    __proto__: null,
    ControlledPropUpdatedSelectedItem: lN,
    FunctionCloseMenu: S5,
    FunctionOpenMenu: x5,
    FunctionReset: k5,
    FunctionSelectItem: oN,
    FunctionSetHighlightedIndex: E5,
    FunctionSetInputValue: C5,
    FunctionToggleMenu: _5,
    InputBlur: cL,
    InputChange: rN,
    InputClick: iN,
    InputKeyDownArrowDown: XF,
    InputKeyDownArrowUp: KF,
    InputKeyDownEnd: JF,
    InputKeyDownEnter: nN,
    InputKeyDownEscape: QF,
    InputKeyDownHome: ZF,
    InputKeyDownPageDown: tN,
    InputKeyDownPageUp: eN,
    ItemClick: aN,
    ItemMouseMove: b5,
    MenuMouseLeave: y5,
    ToggleButtonClick: w5
  });
function s7(t) {
  var e = n5(t),
    i = e.selectedItem,
    s = e.inputValue;
  return s === "" && i && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (s = t.itemToString(i)), Jn({}, e, {
    inputValue: s
  });
}
var u7 = Jn({}, l5, {
  items: Ot.array.isRequired,
  isItemDisabled: Ot.func,
  inputValue: Ot.string,
  defaultInputValue: Ot.string,
  initialInputValue: Ot.string,
  inputId: Ot.string,
  onInputValueChange: Ot.func
});
function c7(t, e, i, s) {
  var c = vt(),
    p = t5(t, e, i, s),
    h = p[0],
    y = p[1],
    w = HL();
  return Rt(function () {
    if (rL(e, "selectedItem")) {
      if (!w) {
        var x = e.itemToKey(e.selectedItem) !== e.itemToKey(c.current);
        x && y({
          type: lN,
          inputValue: e.itemToString(e.selectedItem)
        });
      }
      c.current = h.selectedItem === c.current ? e.selectedItem : h.selectedItem;
    }
  }, [h.selectedItem, e.selectedItem]), [iR(h, e), y];
}
var R5 = rd;
process.env.NODE_ENV !== "production" && (R5 = function (t, e) {
  Ot.checkPropTypes(u7, t, "prop", e.name);
});
var d7 = Jn({}, jT, {
  isItemDisabled: function () {
    return !1;
  }
});
function f7(t, e) {
  var i,
    s = e.type,
    c = e.props,
    p = e.altKey,
    h;
  switch (s) {
    case aN:
      h = {
        isOpen: vb(c, "isOpen"),
        highlightedIndex: lL(c),
        selectedItem: c.items[e.index],
        inputValue: c.itemToString(c.items[e.index])
      };
      break;
    case XF:
      t.isOpen ? h = {
        highlightedIndex: $m(t.highlightedIndex, 1, c.items, c.isItemDisabled, !0)
      } : h = {
        highlightedIndex: p && t.selectedItem == null ? -1 : qx(c, t, 1),
        isOpen: c.items.length >= 0
      };
      break;
    case KF:
      t.isOpen ? p ? h = oL(c, t.highlightedIndex) : h = {
        highlightedIndex: $m(t.highlightedIndex, -1, c.items, c.isItemDisabled, !0)
      } : h = {
        highlightedIndex: qx(c, t, -1),
        isOpen: c.items.length >= 0
      };
      break;
    case nN:
      h = oL(c, t.highlightedIndex);
      break;
    case QF:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case eN:
      h = {
        highlightedIndex: $m(t.highlightedIndex, -10, c.items, c.isItemDisabled, !0)
      };
      break;
    case tN:
      h = {
        highlightedIndex: $m(t.highlightedIndex, 10, c.items, c.isItemDisabled, !0)
      };
      break;
    case ZF:
      h = {
        highlightedIndex: aw(0, !1, c.items, c.isItemDisabled)
      };
      break;
    case JF:
      h = {
        highlightedIndex: aw(c.items.length - 1, !0, c.items, c.isItemDisabled)
      };
      break;
    case cL:
      h = Jn({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((i = c.items) == null ? void 0 : i.length) && e.selectItem && {
        selectedItem: c.items[t.highlightedIndex],
        inputValue: c.itemToString(c.items[t.highlightedIndex])
      });
      break;
    case rN:
      h = {
        isOpen: !0,
        highlightedIndex: lL(c),
        inputValue: e.inputValue
      };
      break;
    case iN:
      h = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : qx(c, t, 0)
      };
      break;
    case oN:
      h = {
        selectedItem: e.selectedItem,
        inputValue: c.itemToString(e.selectedItem)
      };
      break;
    case lN:
      h = {
        inputValue: e.inputValue
      };
      break;
    default:
      return s5(t, e, T5);
  }
  return Jn({}, t, h);
}
var p7 = ["onMouseLeave", "refKey", "ref"],
  h7 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  m7 = ["onClick", "onPress", "refKey", "ref"],
  v7 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
iE.stateChangeTypes = T5;
function iE(t) {
  t === void 0 && (t = {}), R5(t, iE);
  var e = Jn({}, d7, t),
    i = e.items,
    s = e.scrollIntoView,
    c = e.environment,
    p = e.getA11yStatusMessage,
    h = c7(f7, e, s7, o5),
    y = h[0],
    w = h[1],
    x = y.isOpen,
    E = y.highlightedIndex,
    C = y.selectedItem,
    k = y.inputValue,
    D = vt(null),
    I = vt({}),
    L = vt(null),
    P = vt(null),
    N = HL(),
    O = JH(e),
    F = vt(),
    j = AF({
      state: y,
      props: e
    }),
    V = pn(function (ue) {
      return I.current[O.getItemId(ue)];
    }, [O]);
  i5(p, y, [x, E, C, k], c);
  var K = a5({
    menuElement: D.current,
    highlightedIndex: E,
    isOpen: x,
    itemRefs: I,
    scrollIntoView: s,
    getItemNodeFromIndex: V
  });
  FF({
    props: e,
    state: y
  }), Rt(function () {
    var ue = pE(e, "isOpen");
    ue && L.current && L.current.focus();
  }, []), Rt(function () {
    N || (F.current = i.length);
  });
  var G = r5(c, pn(function () {
      j.current.state.isOpen && w({
        type: cL,
        selectItem: !1
      });
    }, [w, j]), ci(function () {
      return [D, P, L];
    }, [D.current, P.current, L.current])),
    Q = jF("getInputProps", "getMenuProps");
  Rt(function () {
    x || (I.current = {});
  }, [x]), Rt(function () {
    var ue;
    !x || !(c != null && c.document) || !(L != null && (ue = L.current) != null && ue.focus) || c.document.activeElement !== L.current && L.current.focus();
  }, [x, c]);
  var te = ci(function () {
      return {
        ArrowDown: function (ue) {
          ue.preventDefault(), w({
            type: XF,
            altKey: ue.altKey
          });
        },
        ArrowUp: function (ue) {
          ue.preventDefault(), w({
            type: KF,
            altKey: ue.altKey
          });
        },
        Home: function (ue) {
          j.current.state.isOpen && (ue.preventDefault(), w({
            type: ZF
          }));
        },
        End: function (ue) {
          j.current.state.isOpen && (ue.preventDefault(), w({
            type: JF
          }));
        },
        Escape: function (ue) {
          var Ee = j.current.state;
          (Ee.isOpen || Ee.inputValue || Ee.selectedItem || Ee.highlightedIndex > -1) && (ue.preventDefault(), w({
            type: QF
          }));
        },
        Enter: function (ue) {
          var Ee = j.current.state;
          !Ee.isOpen || ue.which === 229 || (ue.preventDefault(), w({
            type: nN
          }));
        },
        PageUp: function (ue) {
          j.current.state.isOpen && (ue.preventDefault(), w({
            type: eN
          }));
        },
        PageDown: function (ue) {
          j.current.state.isOpen && (ue.preventDefault(), w({
            type: tN
          }));
        }
      };
    }, [w, j]),
    ie = pn(function (ue) {
      return Jn({
        id: O.labelId,
        htmlFor: O.inputId
      }, ue);
    }, [O]),
    Y = pn(function (ue, Ee) {
      var Ce,
        fe = ue === void 0 ? {} : ue,
        _e = fe.onMouseLeave,
        Se = fe.refKey,
        be = Se === void 0 ? "ref" : Se,
        Le = fe.ref,
        Be = ip(fe, p7),
        Xe = Ee === void 0 ? {} : Ee,
        ge = Xe.suppressRefError,
        qe = ge === void 0 ? !1 : ge;
      return Q("getMenuProps", qe, be, D), Jn((Ce = {}, Ce[be] = pb(Le, function (Ae) {
        D.current = Ae;
      }), Ce.id = O.menuId, Ce.role = "listbox", Ce["aria-labelledby"] = Be && Be["aria-label"] ? void 0 : "" + O.labelId, Ce.onMouseLeave = oa(_e, function () {
        w({
          type: y5
        });
      }), Ce), Be);
    }, [w, Q, O]),
    ee = pn(function (ue) {
      var Ee,
        Ce,
        fe = ue === void 0 ? {} : ue,
        _e = fe.item,
        Se = fe.index,
        be = fe.refKey,
        Le = be === void 0 ? "ref" : be,
        Be = fe.ref,
        Xe = fe.onMouseMove,
        ge = fe.onMouseDown,
        qe = fe.onClick;
      fe.onPress;
      var Ae = fe.disabled,
        Mt = ip(fe, h7);
      Ae !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
      var Ft = j.current,
        un = Ft.props,
        gt = Ft.state,
        Pt = e5(_e, Se, un.items, "Pass either item or index to getItemProps!"),
        St = Pt[0],
        Dt = Pt[1],
        Kt = un.isItemDisabled(St, Dt),
        hn = "onClick",
        Lt = qe,
        Et = function () {
          G.isTouchEnd || Dt === gt.highlightedIndex || (K.current = !1, w({
            type: b5,
            index: Dt,
            disabled: Kt
          }));
        },
        Vt = function () {
          w({
            type: aN,
            index: Dt
          });
        },
        Xt = function (vn) {
          return vn.preventDefault();
        };
      return Jn((Ee = {}, Ee[Le] = pb(Be, function (vn) {
        vn && (I.current[O.getItemId(Dt)] = vn);
      }), Ee["aria-disabled"] = Kt, Ee["aria-selected"] = Dt === gt.highlightedIndex, Ee.id = O.getItemId(Dt), Ee.role = "option", Ee), !Kt && (Ce = {}, Ce[hn] = oa(Lt, Vt), Ce), {
        onMouseMove: oa(Xe, Et),
        onMouseDown: oa(ge, Xt)
      }, Mt);
    }, [w, O, j, G, K]),
    ae = pn(function (ue) {
      var Ee,
        Ce = ue === void 0 ? {} : ue,
        fe = Ce.onClick;
      Ce.onPress;
      var _e = Ce.refKey,
        Se = _e === void 0 ? "ref" : _e,
        be = Ce.ref,
        Le = ip(Ce, m7),
        Be = j.current.state,
        Xe = function () {
          w({
            type: w5
          });
        };
      return Jn((Ee = {}, Ee[Se] = pb(be, function (ge) {
        P.current = ge;
      }), Ee["aria-controls"] = O.menuId, Ee["aria-expanded"] = Be.isOpen, Ee.id = O.toggleButtonId, Ee.tabIndex = -1, Ee), !Le.disabled && Jn({}, {
        onClick: oa(fe, Xe)
      }), Le);
    }, [w, j, O]),
    ne = pn(function (ue, Ee) {
      var Ce,
        fe = ue === void 0 ? {} : ue,
        _e = fe.onKeyDown,
        Se = fe.onChange,
        be = fe.onInput,
        Le = fe.onBlur;
      fe.onChangeText;
      var Be = fe.onClick,
        Xe = fe.refKey,
        ge = Xe === void 0 ? "ref" : Xe,
        qe = fe.ref,
        Ae = ip(fe, v7),
        Mt = Ee === void 0 ? {} : Ee,
        Ft = Mt.suppressRefError,
        un = Ft === void 0 ? !1 : Ft;
      Q("getInputProps", un, ge, L);
      var gt = j.current.state,
        Pt = function (Vt) {
          var Xt = iL(Vt);
          Xt && te[Xt] && te[Xt](Vt);
        },
        St = function (Vt) {
          w({
            type: rN,
            inputValue: Vt.target.value
          });
        },
        Dt = function (Vt) {
          if (c != null && c.document && gt.isOpen && !G.isMouseDown) {
            var Xt = Vt.relatedTarget === null && c.document.activeElement !== c.document.body;
            w({
              type: cL,
              selectItem: !Xt
            });
          }
        },
        Kt = function () {
          w({
            type: iN
          });
        },
        hn = "onChange",
        Lt = {};
      if (!Ae.disabled) {
        var Et;
        Lt = (Et = {}, Et[hn] = oa(Se, be, St), Et.onKeyDown = oa(_e, Pt), Et.onBlur = oa(Le, Dt), Et.onClick = oa(Be, Kt), Et);
      }
      return Jn((Ce = {}, Ce[ge] = pb(qe, function (Vt) {
        L.current = Vt;
      }), Ce["aria-activedescendant"] = gt.isOpen && gt.highlightedIndex > -1 ? O.getItemId(gt.highlightedIndex) : "", Ce["aria-autocomplete"] = "list", Ce["aria-controls"] = O.menuId, Ce["aria-expanded"] = gt.isOpen, Ce["aria-labelledby"] = Ae && Ae["aria-label"] ? void 0 : O.labelId, Ce.autoComplete = "off", Ce.id = O.inputId, Ce.role = "combobox", Ce.value = gt.inputValue, Ce), Lt, Ae);
    }, [w, O, c, te, j, G, Q]),
    le = pn(function () {
      w({
        type: _5
      });
    }, [w]),
    ce = pn(function () {
      w({
        type: S5
      });
    }, [w]),
    W = pn(function () {
      w({
        type: x5
      });
    }, [w]),
    $ = pn(function (ue) {
      w({
        type: E5,
        highlightedIndex: ue
      });
    }, [w]),
    de = pn(function (ue) {
      w({
        type: oN,
        selectedItem: ue
      });
    }, [w]),
    H = pn(function (ue) {
      w({
        type: C5,
        inputValue: ue
      });
    }, [w]),
    se = pn(function () {
      w({
        type: k5
      });
    }, [w]);
  return {
    // prop getters.
    getItemProps: ee,
    getLabelProps: ie,
    getMenuProps: Y,
    getInputProps: ne,
    getToggleButtonProps: ae,
    // actions.
    toggleMenu: le,
    openMenu: W,
    closeMenu: ce,
    setHighlightedIndex: $,
    setInputValue: H,
    selectItem: de,
    reset: se,
    // state.
    highlightedIndex: E,
    isOpen: x,
    selectedItem: C,
    inputValue: k
  };
}
zM.stateReducer, zM.itemToKey, zM.environment, Ot.array, Ot.array, Ot.array, Ot.func, Ot.number, Ot.number, Ot.number, Ot.func, Ot.func, Ot.string, Ot.string;
jT.itemToKey, jT.stateReducer, jT.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function g7(t) {
  if (Array.isArray(t)) {
    for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
    return i;
  } else return Array.from(t);
}
var sN = !1;
if (typeof window < "u") {
  var gV = {
    get passive() {
      sN = !0;
    }
  };
  window.addEventListener("testPassive", null, gV), window.removeEventListener("testPassive", null, gV);
}
var D5 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1),
  Z0 = [],
  dL = !1,
  I5 = -1,
  FT = void 0,
  NT = void 0,
  M5 = function (t) {
    return Z0.some(function (e) {
      return !!(e.options.allowTouchMove && e.options.allowTouchMove(t));
    });
  },
  uN = function (t) {
    var e = t || window.event;
    return M5(e.target) || e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
  },
  y7 = function (t) {
    if (NT === void 0) {
      var e = !!t && t.reserveScrollBarGap === !0,
        i = window.innerWidth - document.documentElement.clientWidth;
      e && i > 0 && (NT = document.body.style.paddingRight, document.body.style.paddingRight = i + "px");
    }
    FT === void 0 && (FT = document.body.style.overflow, document.body.style.overflow = "hidden");
  },
  b7 = function () {
    NT !== void 0 && (document.body.style.paddingRight = NT, NT = void 0), FT !== void 0 && (document.body.style.overflow = FT, FT = void 0);
  },
  w7 = function (t) {
    return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
  },
  _7 = function (t, e) {
    var i = t.targetTouches[0].clientY - I5;
    return M5(t.target) ? !1 : e && e.scrollTop === 0 && i > 0 || w7(e) && i < 0 ? uN(t) : (t.stopPropagation(), !0);
  },
  $L = function (t, e) {
    if (!t) {
      console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
      return;
    }
    if (!Z0.some(function (s) {
      return s.targetElement === t;
    })) {
      var i = {
        targetElement: t,
        options: e || {}
      };
      Z0 = [].concat(g7(Z0), [i]), D5 ? (t.ontouchstart = function (s) {
        s.targetTouches.length === 1 && (I5 = s.targetTouches[0].clientY);
      }, t.ontouchmove = function (s) {
        s.targetTouches.length === 1 && _7(s, t);
      }, dL || (document.addEventListener("touchmove", uN, sN ? {
        passive: !1
      } : void 0), dL = !0)) : y7(e);
    }
  },
  aR = function (t) {
    if (!t) {
      console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
      return;
    }
    Z0 = Z0.filter(function (e) {
      return e.targetElement !== t;
    }), D5 ? (t.ontouchstart = null, t.ontouchmove = null, dL && Z0.length === 0 && (document.removeEventListener("touchmove", uN, sN ? {
      passive: !1
    } : void 0), dL = !1)) : Z0.length || b7();
  };
const x7 = "_container_1wrr6_1",
  S7 = "_containerHelperText_1wrr6_22",
  E7 = "_containerErrorMesssage_1wrr6_22",
  C7 = "_containerInputLabel_1wrr6_26",
  V0 = {
    container: x7,
    containerHelperText: S7,
    containerErrorMesssage: E7,
    containerInputLabel: C7
  },
  AE = Qn(({
    id: t,
    label: e,
    labelId: i,
    isLabel: s = !0,
    isDisabled: c,
    errorMessage: p,
    helperText: h,
    messageId: y,
    isFocused: w,
    children: x,
    className: E,
    classNames: C
  }, k) => /* @__PURE__ */we.jsxs(we.Fragment, {
    children: [/* @__PURE__ */we.jsxs("div", {
      ref: k,
      className: Ze(E, V0.container, w && (C == null ? void 0 : C.focus), !c && p && [V0.error, V0.containerError, C == null ? void 0 : C.error], c && [V0.containerInputDisable, C == null ? void 0 : C.disabled]),
      children: [s ? e && /* @__PURE__ */we.jsx("label", {
        id: i || void 0,
        htmlFor: t,
        className: Ze(V0.containerInputLabel, C == null ? void 0 : C.label),
        children: e
      }) : e && /* @__PURE__ */we.jsx("span", {
        id: i || void 0,
        className: Ze(V0.containerInputLabel, C == null ? void 0 : C.label),
        children: e
      }), x]
    }), !p && h && /* @__PURE__ */we.jsx("div", {
      id: y || void 0,
      className: Ze(V0.containerHelperText, C == null ? void 0 : C.helperText),
      children: h
    }), p && /* @__PURE__ */we.jsx("div", {
      id: y || void 0,
      role: "alert",
      className: Ze(V0.containerErrorMesssage, C == null ? void 0 : C.errorText),
      children: p
    })]
  }));
function cN(t, e, i) {
  var s = i || {},
    c = s.noTrailing,
    p = c === void 0 ? !1 : c,
    h = s.noLeading,
    y = h === void 0 ? !1 : h,
    w = s.debounceMode,
    x = w === void 0 ? void 0 : w,
    E,
    C = !1,
    k = 0;
  function D() {
    E && clearTimeout(E);
  }
  function I(P) {
    var N = P || {},
      O = N.upcomingOnly,
      F = O === void 0 ? !1 : O;
    D(), C = !F;
  }
  function L() {
    for (var P = arguments.length, N = new Array(P), O = 0; O < P; O++) N[O] = arguments[O];
    var F = this,
      j = Date.now() - k;
    if (C) return;
    function V() {
      k = Date.now(), e.apply(F, N);
    }
    function K() {
      E = void 0;
    }
    !y && x && !E && V(), D(), x === void 0 && j > t ? y ? (k = Date.now(), p || (E = setTimeout(x ? K : V, t))) : V() : p !== !0 && (E = setTimeout(x ? K : V, x === void 0 ? t - j : t));
  }
  return L.cancel = I, L;
}
function k7(t, e, i) {
  var s = i || {},
    c = s.atBegin,
    p = c === void 0 ? !1 : c;
  return cN(t, e, {
    debounceMode: p !== !1
  });
}
function WL(t = 150) {
  const [e, i] = rt({
      isXs: !1,
      isSm: !1,
      isMd: !1,
      isLg: !1,
      isXl: !1
    }),
    s = cN(t, () => {
      window && i({
        isXs: window.matchMedia(`(max-width: ${nd.breakpoint["sm-max"].value})`).matches,
        isSm: window.matchMedia(`(min-width: ${nd.breakpoint.sm.value}) and (max-width: ${nd.breakpoint["md-max"].value})`).matches,
        isMd: window.matchMedia(`(min-width: ${nd.breakpoint.md.value}) and (max-width: ${nd.breakpoint["lg-max"].value})`).matches,
        isLg: window.matchMedia(`(min-width: ${nd.breakpoint.lg.value}) and (max-width: ${nd.breakpoint["xl-max"].value})`).matches,
        isXl: window.matchMedia(`(min-width: ${nd.breakpoint.xl})`).matches
      });
    });
  return Rt(() => (s(), window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  }), [t]), e;
}
const L5 = Up(void 0),
  T7 = t => {
    const {
      dir: e,
      children: i
    } = t;
    return /* @__PURE__ */we.jsx(L5.Provider, {
      value: e,
      children: i
    });
  };
function dN(t) {
  const e = bs(L5);
  return t || e || "ltr";
}
function R7(t) {
  const e = vt(t);
  return Rt(() => {
    e.current = t;
  }), ci(() => (...i) => {
    var s;
    return (s = e.current) == null ? void 0 : s.call(e, ...i);
  }, []);
}
const D7 = ({
    method: t = "debounce",
    delayTime: e = 0,
    breakpoint: i
  } = {}) => {
    const s = i ? typeof i == "string" ? parseFloat(i) : i : parseFloat(nd.breakpoint.lg.value),
      [c, p] = rt(() => typeof window < "u" ? window.innerWidth <= s : !1),
      h = t === "throttle" ? cN : k7,
      y = ci(() => h(e, () => {
        p(window.innerWidth <= s);
      }), [h, e, s]);
    return Rt(() => (y(), window.addEventListener("resize", y), () => {
      var w;
      window.removeEventListener("resize", y), (w = y.cancel) == null || w.call(y);
    }), [y]), c;
  },
  $1 = {
    small: 12,
    medium: 36,
    large: 77
  },
  hb = {
    small: "small",
    medium: "medium",
    large: "large"
  },
  jE = {
    vertical: "vertical"
  },
  Um = {
    loading: "loading",
    success: "success"
  },
  I7 = "_spinnerContainer_1m7io_1",
  M7 = "_vertical_1m7io_8",
  L7 = "_messageContainer_1m7io_12",
  O7 = "_horizontal_1m7io_16",
  P7 = "_spinnerLoader_1m7io_21",
  A7 = "_messageTitle_1m7io_32",
  j7 = "_message_1m7io_12",
  F7 = "_spinnerLoaderCircle_1m7io_47",
  N7 = "_spinnerLoaderCircleStatic_1m7io_52",
  z7 = "_spinnerLoaderCircleLoading_1m7io_56",
  V7 = "_spinnerLoaderCircleComplete_1m7io_56",
  B7 = "_spinnerLoaderIcon_1m7io_63",
  U7 = "_spinnerLoaderSvg_1m7io_70",
  H7 = "_spinnerLoaderCheck_1m7io_74",
  $7 = "_spinnerLoaderIntro_1m7io_82",
  W7 = "_spinnerLoaderMessage_1m7io_89",
  q7 = "_animated_1m7io_93",
  Y7 = "_large_1m7io_99",
  G7 = "_pulse_1m7io_1",
  X7 = "_success_1m7io_129",
  K7 = "_spinnerLoaderCircleStop_1m7io_129",
  Q7 = "_animate_1m7io_93",
  Z7 = "_medium_1m7io_179",
  J7 = "_small_1m7io_259",
  Do = {
    spinnerContainer: I7,
    vertical: M7,
    messageContainer: L7,
    horizontal: O7,
    spinnerLoader: P7,
    messageTitle: A7,
    message: j7,
    spinnerLoaderCircle: F7,
    spinnerLoaderCircleStatic: N7,
    spinnerLoaderCircleLoading: z7,
    spinnerLoaderCircleComplete: V7,
    spinnerLoaderIcon: B7,
    spinnerLoaderSvg: U7,
    spinnerLoaderCheck: H7,
    spinnerLoaderIntro: $7,
    spinnerLoaderMessage: W7,
    animated: q7,
    large: Y7,
    pulse: G7,
    "loading-large": "_loading-large_1m7io_1",
    success: X7,
    spinnerLoaderCircleStop: K7,
    "fade-in": "_fade-in_1m7io_1",
    "complete-large": "_complete-large_1m7io_1",
    animate: Q7,
    "checkmark-large": "_checkmark-large_1m7io_1",
    "intro-large": "_intro-large_1m7io_1",
    medium: Z7,
    "loading-medium": "_loading-medium_1m7io_1",
    "complete-medium": "_complete-medium_1m7io_1",
    "checkmark-medium": "_checkmark-medium_1m7io_1",
    "intro-medium": "_intro-medium_1m7io_1",
    small: J7,
    "loading-small": "_loading-small_1m7io_1",
    "complete-small": "_complete-small_1m7io_1",
    "checkmark-small": "_checkmark-small_1m7io_1",
    "intro-small": "_intro-small_1m7io_1"
  },
  FE = ({
    className: t,
    message: e,
    align: i = jE.vertical,
    size: s = hb.medium,
    status: c = Um.loading,
    responsive: p = !0,
    trackColor: h = nd.color.white.default.value,
    strokeColor: y = nd.color.black.default.value,
    disableLarge: w,
    title: x,
    classNames: E
  }) => {
    const {
        isXs: C,
        isSm: k,
        isMd: D
      } = WL(),
      I = vt(p),
      L = vt(s),
      [P, N] = rt(!1),
      [O, F] = rt(!1),
      [j, V] = rt(!1),
      [K, G] = rt(!1),
      Q = vt(0),
      te = vt(),
      ie = 100,
      Y = 2e3,
      ee = {
        [Do[i]]: i,
        [Do[c]]: c === Um.success
      };
    return Rt(() => {
      I.current && (C ? L.current = hb.small : k || D ? L.current = hb.medium : w || (L.current = hb.large));
    }, [C, k, D, I]), Rt(() => (te.current = window.setInterval(() => {
      Q.current += ie, Q.current % Y === 0 && c === Um.success && (F(!0), window.clearInterval(te.current), te.current = void 0, N(!0));
    }, ie), () => {
      te.current && (window.clearInterval(te.current), te.current = void 0);
    }), [c]), Rt(() => {
      c === Um.success && O && !j ? setTimeout(() => {
        V(!0);
      }, 1500) : c === Um.success && O && j ? setTimeout(() => {
        G(!0);
      }, 2e3) : c === Um.loading && (V(!1), G(!1));
    }, [j, O, c]), /* @__PURE__ */we.jsxs("div", {
      className: Ze(ee, Do[I.current ? L.current : s], Do.spinnerContainer, t),
      children: [/* @__PURE__ */we.jsx("div", {
        className: Do.spinnerLoader,
        children: /* @__PURE__ */we.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          className: Ze(Do.spinnerLoaderSvg, Do.spinnerLoaderIcon),
          children: [/* @__PURE__ */we.jsx("circle", {
            cx: $1[I.current ? L.current : s] + 2,
            cy: $1[I.current ? L.current : s] + 2,
            r: $1[I.current ? L.current : s],
            className: Ze(Do.spinnerLoaderCircle, Do.spinnerLoaderCircleStatic),
            stroke: h
          }), /* @__PURE__ */we.jsx("circle", {
            cx: $1[I.current ? L.current : s] + 2,
            cy: $1[I.current ? L.current : s] + 2,
            r: $1[I.current ? L.current : s],
            className: Ze(Do.spinnerLoaderCircle, (!j || !O) && Do.spinnerLoaderCircleLoading, O && !j && Do.spinnerLoaderCircleStop, j && Do.spinnerLoaderCircleComplete, K && Do.animated),
            strokeLinecap: "round",
            strokeLinejoin: "round",
            stroke: y
          }), /* @__PURE__ */we.jsxs("g", {
            children: [O && P && /* @__PURE__ */we.jsx("path", {
              className: Ze(Do.spinnerLoaderCheck, Do.animate, K && Do.animated),
              stroke: y,
              vectorEffect: "non-scaling-stroke",
              d: "M13.6667 30.3333L21.8333 39.6666L44 16.3333",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), O && !K && /* @__PURE__ */we.jsx("path", {
              className: Ze(Do.spinnerLoaderIntro, Do.animate),
              vectorEffect: "non-scaling-stroke",
              width: "72",
              height: "72",
              d: "M36 1C45 1 56 4.5 62.5 13.5L30 47.5",
              strokeLinecap: "round",
              stroke: y
            })]
          })]
        })
      }), (x || e) && /* @__PURE__ */we.jsxs("div", {
        className: Ze(Do.messageContainer, E == null ? void 0 : E.messageContainer),
        children: [x && /* @__PURE__ */we.jsx("div", {
          className: Ze(Do.messageTitle, E == null ? void 0 : E.title),
          children: x
        }), e && /* @__PURE__ */we.jsx("span", {
          className: Ze(Do.message, E == null ? void 0 : E.message),
          children: e
        })]
      })]
    });
  },
  eq = "_dropdown_10iq7_2",
  tq = "_selectedValue_10iq7_6",
  nq = "_dropdownOpen_10iq7_17",
  rq = "_dropdownFocus_10iq7_28",
  iq = "_dropdownInput_10iq7_41",
  aq = "_dropdownInputValue_10iq7_53",
  oq = "_dropdownIcon_10iq7_63",
  lq = "_dropdownIconDisabled_10iq7_75",
  sq = "_dropdownListbox_10iq7_79",
  uq = "_dropdownListboxOpen_10iq7_93",
  cq = "_list_10iq7_99",
  dq = "_item_10iq7_104",
  fq = "_disabled_10iq7_135",
  pq = "_noResults_10iq7_139",
  hq = "_srOnly_10iq7_144",
  Vn = {
    dropdown: eq,
    selectedValue: tq,
    dropdownOpen: nq,
    dropdownFocus: rq,
    dropdownInput: iq,
    dropdownInputValue: aq,
    dropdownIcon: oq,
    dropdownIconDisabled: lq,
    dropdownListbox: sq,
    dropdownListboxOpen: uq,
    list: cq,
    item: dq,
    disabled: fq,
    noResults: pq,
    srOnly: hq
  },
  mq = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"'
  },
  vq = Qn(({
    id: t,
    data: e = [],
    isDisabled: i = !1,
    errorMessage: s,
    initialSelectedItem: c,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: y,
    isAutoCloseMenu: w = !0,
    environment: x,
    children: E,
    className: C,
    classNames: k,
    onFocus: D,
    onBlur: I,
    onChange: L,
    onOpenDropdown: P,
    label: N,
    labels: O = {},
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    isLoading: G = !1,
    loaderConfig: Q
  }, te) => {
    const ie = {
        ...mq,
        ...O
      },
      [Y, ee] = rt(!1),
      ae = vt(null),
      ne = vt(null),
      le = typeof window < "u",
      [ce, W] = rt(!1),
      [$, de] = rt(""),
      [H, se] = rt(""),
      [ue, Ee] = rt(),
      Ce = (gt, Pt) => {
        const {
          type: St,
          changes: Dt
        } = Pt;
        return [jp.stateChangeTypes.ToggleButtonKeyDownEnter, jp.stateChangeTypes.ToggleButtonKeyDownSpaceButton, jp.stateChangeTypes.ItemClick].includes(St) ? {
          ...Dt,
          isOpen: !w
        } : Dt;
      },
      fe = gt => {
        let Pt = (gt == null ? void 0 : gt.label) ?? "";
        return V && gt && V(gt) && (Pt = V(gt)), Pt;
      },
      _e = g9(e),
      {
        isOpen: Se,
        closeMenu: be,
        selectItem: Le,
        highlightedIndex: Be,
        setHighlightedIndex: Xe,
        getMenuProps: ge,
        getToggleButtonProps: qe,
        getItemProps: Ae
      } = jp({
        id: t,
        labelId: t,
        stateReducer: Ce,
        items: _e,
        itemToString: fe,
        isItemDisabled: gt => gt != null && gt.disabled ? !!gt.disabled : !1,
        onHighlightedIndexChange: gt => {
          const Pt = gt.highlightedIndex - (Be ?? 0);
          gt.highlightedIndex === ue && gt.type !== jp.stateChangeTypes.ItemMouseMove && (ue + Pt >= 0 && ue + Pt <= _e.length - 1 ? Xe(ue + Pt) : Xe(ue - Pt));
        },
        onIsOpenChange: gt => {
          var Pt;
          const {
            matches: St
          } = window.matchMedia(`(max-width: ${nd.breakpoint.sm.value})`);
          gt.isOpen ? D == null || D() : (I == null || I(), (Pt = ae.current) == null || Pt.focus()), gt.isOpen && St && ne != null && ne.current ? ($L(ne.current), P == null || P(ne.current)) : ne.current && aR(ne.current);
        },
        onSelectedItemChange: gt => {
          var Pt, St;
          const Dt = gt.selectedItem ?? {};
          L == null || L(Dt), ee(!1), de(Dt.label);
          const Kt = _e.findIndex(hn => {
            var Lt;
            return hn.id === ((Lt = gt.selectedItem) == null ? void 0 : Lt.id);
          });
          Ee(Kt), gt.type !== "__function_select_item__" && ((Pt = gt.selectedItem) == null ? void 0 : Pt.value) !== (c == null ? void 0 : c.value) && (ee(!0), W(!0), (St = ae.current) == null || St.focus(), gt.isOpen && !w && Xe(Be));
        },
        environment: x ? {
          addEventListener: x.addEventListener.bind(x),
          removeEventListener: x.removeEventListener.bind(x),
          document: x != null && x.document ? x.document : document,
          Node: x.Node
        } : le ? window : void 0
      }),
      Mt = gt => {
        var Pt, St;
        if (ne) {
          if ((Pt = ne.current) != null && Pt.contains(gt == null ? void 0 : gt.target) || ae && (St = ae.current) != null && St.contains(gt == null ? void 0 : gt.target)) return;
          be(), W(!1);
        }
      },
      Ft = gt => gt.reduce((Pt, St, Dt) => {
        const Kt = [];
        if (St != null && St.title) {
          let Lt = (St == null ? void 0 : St.displayTitle) === void 0 ? !1 : St.displayTitle;
          St.displayTitle === void 0 && (e == null ? void 0 : e.length) <= 1 ? Lt = !1 : St.displayTitle === void 0 && (Lt = !0), Pt.sections.push(/* @__PURE__ */we.jsx("div", {
            id: `${t}-group-${Dt}`,
            role: "heading",
            "aria-level": 2,
            className: Ze(Vn.sectionHeading, !Lt && Vn.srOnly, k == null ? void 0 : k.listHeading),
            children: St.title
          }, `${t}-group-${Dt}`));
        }
        const hn = Lt => (Lt.forEach(Et => {
          ++Pt.itemIndex;
          const Vt = ((h == null ? void 0 : h.id) ?? "") === Et.id,
            Xt = {
              item: Et,
              index: Pt.itemIndex,
              "data-level": Et._level,
              className: Ze(Vn.item, k == null ? void 0 : k.listItem, Et.isGrouping && (k == null ? void 0 : k.itemGroup), Vt && (k == null ? void 0 : k.itemSelected), Be === Pt.itemIndex && (k == null ? void 0 : k.itemActive), Et.disabled && [Vn.disabled, k == null ? void 0 : k.itemDisabled]),
              "aria-selected": Vt,
              "aria-disabled": Et.disabled ? !0 : void 0,
              // Add this event to help limit the section heading accessibility fix
              onClick: vn => {
                vn.stopPropagation();
              }
            };
          if (j) {
            const vn = j(`item-${Pt.itemIndex}`, (h == null ? void 0 : h.id) ?? "", Et, Ae, Xt);
            Kt.push(/* @__PURE__ */we.jsx(Qv, {
              children: vn
            }, `item-${Pt.itemIndex}`));
          } else Kt.push(/* @__PURE__ */we.jsx("li", {
            ...Ae(Xt),
            children: fe(Et)
          }, `item-${Pt.itemIndex}`));
          Et && Et.items && Et.items.length > 0 && hn(Et.items);
        }), Kt);
        return St != null && St.items && St.items.length > 0 && (hn(St.items), Pt.sections.push(/* @__PURE__ */we.jsx("ul", {
          role: gt.length > 1 ? "group" : "listbox",
          "aria-labelledby": `${t}-group-${Dt}`,
          className: Vn.list,
          children: Kt
        }, `dropdown-ul-${Dt}`))), Pt;
      }, {
        sections: [],
        itemIndex: -1
      }).sections,
      un = () => !p && h != null && h.label ? `${fe(h)}` : !p && c != null && c.label ? `${fe(c)}` : "";
    return Rt(() => (window.addEventListener("mousedown", Mt, !1), () => {
      window.removeEventListener("mousedown", Mt, !1);
    }), []), Rt(() => {
      const gt = setTimeout(() => {
        se($);
      }, 200);
      return () => clearTimeout(gt);
    }, [$]), Rt(() => {
      c && Le(c);
    }, []), Rt(() => {
      h && Le(h);
    }, [h]), /* @__PURE__ */we.jsx(we.Fragment, {
      children: /* @__PURE__ */we.jsx(AE, {
        ref: te,
        className: Ze(Vn.dropdown, Se && !G && [Vn.dropdownOpen, k == null ? void 0 : k.inputWrapperOpen], !p && (Y || G || !!h) && [Vn.selectedValue, k == null ? void 0 : k.inputWrapperSelected], C, ce && Vn.dropdownFocus),
        classNames: {
          helperText: k == null ? void 0 : k.inputHelperText,
          errorText: Ze(!i && s && (k == null ? void 0 : k.inputErrorText)),
          focus: Ze(ce && (k == null ? void 0 : k.inputWrapperFocus)),
          error: Ze(!i && s && [Vn.dropdownError, k == null ? void 0 : k.inputWrapperError]),
          disabled: Ze(i && [Vn.dropdownInputDisabled, k == null ? void 0 : k.inputWrapperDisabled])
        },
        errorMessage: s,
        messageId: `${t}-message`,
        isDisabled: i,
        helperText: F,
        isFocused: ce && !G,
        children: /* @__PURE__ */we.jsxs(we.Fragment, {
          children: [/* @__PURE__ */we.jsxs("button", {
            disabled: i,
            type: "button",
            "aria-label": Se && !G ? ie.a11yCloseMenu : ie.a11yOpenMenu,
            "aria-describedby": F || s ? `${t}-message` : void 0,
            onFocusCapture: () => {
              W(!0);
            },
            onBlurCapture: () => {
              W(!1);
            },
            className: Ze(Vn.dropdownInput, G && (k == null ? void 0 : k.inputLoader), k == null ? void 0 : k.inputToggleButton),
            ...qe({
              ref: ae,
              "aria-labelledby": `${t}-label`,
              "aria-activedescendant": Be !== -1 ? `${t}-item-${Be}` : ue != null ? `${t}-item-${ue}` : void 0,
              onFocus: () => {
                D == null || D();
              },
              onBlur: () => {
                !Se && !i && (I == null || I());
              }
            }),
            children: [/* @__PURE__ */we.jsx("span", {
              className: Ze(k == null ? void 0 : k.inputLabel),
              id: `${t}-label`,
              children: K ? K(h || c, N) : N
            }), /* @__PURE__ */we.jsx("span", {
              className: Ze(Vn.dropdownInputValue, k == null ? void 0 : k.value),
              children: un()
            }), G && /* @__PURE__ */we.jsx(FE, {
              className: k == null ? void 0 : k.loader,
              size: hb.small,
              status: Um.loading,
              align: jE.vertical,
              responsive: !1,
              ...Q
            }), !i && !G && /* @__PURE__ */we.jsxs("span", {
              "aria-hidden": "true",
              className: Ze(k == null ? void 0 : k.icon, s ? [Vn.dropdownIcon, Vn.dropdownIconError, k == null ? void 0 : k.iconError] : Vn.dropdownIcon),
              children: [Se && ((y == null ? void 0 : y.open) || /* @__PURE__ */we.jsx(we.Fragment, {
                children: "▲"
              })), !Se && ((y == null ? void 0 : y.close) || /* @__PURE__ */we.jsx(we.Fragment, {
                children: "▼"
              }))]
            }), i && /* @__PURE__ */we.jsx("span", {
              "aria-hidden": "true",
              className: Ze(Vn.dropdownIcon, Vn.dropdownIconDisabled, k == null ? void 0 : k.icon, k == null ? void 0 : k.iconDisabled),
              children: (y == null ? void 0 : y.disabled) || /* @__PURE__ */we.jsx(we.Fragment, {
                children: "×"
              })
            })]
          }), /* @__PURE__ */we.jsx("span", {
            role: "presentation",
            className: Ze(k == null ? void 0 : k.inputBorder)
          }), E, /* @__PURE__ */we.jsx("div", {
            id: `${t}-selection-changes`,
            className: Vn.srOnly,
            "aria-live": "polite",
            "aria-atomic": "true",
            children: H && ie != null && ie.a11ySelectedLiveRegion ? ie.a11ySelectedLiveRegion.replace("{{ label }}", H) : H
          }), /* @__PURE__ */we.jsx("div", {
            ...ge({
              ref: ne,
              onBlur: () => {
                var gt;
                I == null || I(), (gt = ae.current) == null || gt.focus();
              },
              onClick: gt => {
                var Pt, St;
                const Dt = parseInt((Pt = gt.nativeEvent.target) == null ? void 0 : Pt.id.replace(`${t}-group-`, ""), 10);
                if (Dt !== null) {
                  let Kt = 0;
                  ((hn, Lt) => {
                    var Et;
                    const Vt = Xt => Xt.reduce((vn, ot) => ot.items && ot.items.length > 0 ? vn + 1 + Vt(ot.items) : vn + 1, 0);
                    for (let Xt = 0; Xt < Lt; Xt++) (Et = hn[Xt]) != null && Et.items && (Kt += Vt(hn[Xt].items));
                  })(e, Dt), Xe(Kt);
                }
                (St = ae.current) == null || St.focus();
              },
              role: e.length > 1 ? "listbox" : void 0,
              "aria-labelledby": void 0,
              "aria-expanded": void 0,
              tabIndex: Se ? 0 : -1
            }),
            className: Ze(Vn.dropdownListbox, Se && !G && Vn.dropdownListboxOpen, k == null ? void 0 : k.listBox),
            children: !G && (e.length ? Ft(e) : /* @__PURE__ */we.jsx("span", {
              className: Ze(Vn.noResults, k == null ? void 0 : k.noResults),
              children: ie.noResults
            }))
          })]
        })
      })
    });
  }),
  aE = ({
    number: t,
    locale: e = "en-CA",
    currency: i = "CAD",
    showCents: s = !1,
    className: c,
    renderCurrencyAsSup: p = !1
  }) => {
    if (t == null || t === "") return null;
    const h = Number(t);
    if (Number.isNaN(h)) return /* @__PURE__ */we.jsx(we.Fragment, {
      children: String(t)
    });
    const y = typeof s == "boolean" ? s : h % 1 !== 0,
      w = new Intl.NumberFormat(e, {
        style: "currency",
        currency: i,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: y ? 2 : 0,
        maximumFractionDigits: y ? 2 : 0
      }).format(h),
      x = w.match(/([^\d\s.,]+)/);
    if (!p || !x) return /* @__PURE__ */we.jsx("span", {
      className: c,
      children: w
    });
    const E = x[1],
      C = w.split(E);
    return /* @__PURE__ */we.jsxs("span", {
      className: c,
      children: [C[0], /* @__PURE__ */we.jsx("sup", {
        children: E
      }), C[1]]
    });
  },
  gq = "_grid_1wa4n_1",
  yq = "_gridItem_1wa4n_10",
  bq = "_gridItemNormal_1wa4n_16",
  wq = "_gridNoGap_1wa4n_20",
  zT = {
    grid: gq,
    gridItem: yq,
    gridItemNormal: bq,
    gridNoGap: wq
  },
  NE = ({
    className: t,
    cols: e = 1,
    minWidth: i,
    customCols: s,
    children: c,
    gap: p = !0
  }) => {
    const h = s || zT[`grid--${e}`],
      y = {
        ...(e && {
          "--_grid-cols": e
        }),
        ...(i && {
          "--_col-min-width": i
        })
      };
    return /* @__PURE__ */we.jsx("div", {
      "data-cols": s || e,
      style: y,
      className: Ze(zT.grid, h, t, {
        [zT.gridNoGap]: !p
      }),
      children: Nt.Children.map(c, w => {
        if (!rR(w) || w.type !== gb) throw new Error("Children of <Row> must be of type Cell");
        return w;
      })
    });
  };
NE.displayName = "Row";
const gb = ({
  className: t,
  children: e,
  cellNormal: i = !1
}) => /* @__PURE__ */we.jsx("div", {
  className: Ze(zT.gridItem, t, i && zT.gridItemNormal),
  children: e
});
gb.displayName = "Cell";
const T_e = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span",
    div: "div"
  },
  R_e = {
    normal: "normal",
    bold: "bold"
  },
  D_e = {
    left: "left",
    center: "center",
    right: "right"
  },
  Nx = {
    div: "div",
    span: "span",
    p: "p",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
  },
  _q = t => Object.keys(Nx).includes(t),
  gT = {
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs"
  },
  xq = t => {
    switch (!0) {
      case t === gT.xl:
        return Nx.h1;
      case t === gT.lg:
        return Nx.h2;
      case t == gT.md:
        return Nx.h3;
      case t === gT.sm:
        return Nx.h4;
      case t === gT.xs:
        return Nx.h5;
      default:
        return Nx.div;
    }
  },
  Sq = ({
    Tag: t,
    size: e,
    ...i
  }) => {
    const s = _q(t) ? t : xq(e);
    return /* @__PURE__ */we.jsx(s, {
      ...i
    });
  },
  Eq = "_container_bdgjx_2",
  Cq = "_input_bdgjx_15",
  kq = "_inputButtonActive_bdgjx_28",
  Tq = "_inputIcon_bdgjx_36",
  Rq = "_inputButton_bdgjx_28",
  Dq = "_show_bdgjx_54",
  Iq = "_hide_bdgjx_58",
  Am = {
    container: Eq,
    input: Cq,
    inputButtonActive: kq,
    inputIcon: Tq,
    inputButton: Rq,
    show: Dq,
    hide: Iq
  },
  Mq = {
    clear: "Clear",
    ariaClearLabel: "Clear entry",
    hide: "Hide",
    ariaHidePassword: "Hide your password",
    show: "Show",
    ariaShowPassword: "Show your password"
  },
  O5 = Qn(({
    id: t,
    label: e,
    name: i,
    disabled: s = !1,
    readOnly: c = !1,
    onChange: p,
    onBlur: h,
    onFocus: y,
    onKeyUp: w,
    helperText: x,
    errorMessage: E,
    value: C,
    type: k = "text",
    required: D,
    labels: I = {},
    enableClearButton: L = !1,
    displayClearLabel: P,
    iconOptions: N,
    isLoading: O = !1,
    loaderConfig: F,
    className: j,
    classNames: V,
    // Mask Props
    isMasked: K = !1,
    isMaskedValue: G = !1,
    maskedPattern: Q = "",
    onMaskUpdate: te,
    children: ie,
    // Catch-all prop for anything not exclusively specified
    ...Y
  }, ee) => {
    var ae;
    const ne = {
        ...Mq,
        ...I
      },
      [le, ce] = rt(K ? void 0 : ""),
      [W, $] = rt(!1),
      [de, H] = rt(!1),
      [se, ue] = rt(!1),
      Ee = vt(null),
      Ce = vt(null),
      fe = vt(null),
      [_e, Se] = rt(),
      [be, Le] = rt(!1),
      Be = St => {
        if (!(St instanceof Node)) throw new Error("Node expected");
      },
      Xe = () => {
        ue(!0);
      },
      ge = () => {
        ue(!1), H(!1);
      },
      qe = (St, Dt) => {
        var Kt;
        switch (St.preventDefault(), (Kt = fe.current) == null || Kt.focus(), Dt) {
          case "clear":
            if (K ? te == null || te("") : ce(""), H(!1), fe.current && !K) {
              const hn = new Event("input", {
                bubbles: !0
              });
              fe.current.value = "", fe.current.dispatchEvent(hn), Ae(hn);
            }
            break;
          case "password":
            Le(!be);
            break;
        }
      },
      Ae = St => {
        const Dt = St.target.value;
        if (!K) {
          ce(Dt);
          const Kt = St.target.validity;
          p == null || p(St, Dt, Kt.valid);
        }
        Se(_e);
      },
      Mt = St => {
        const Dt = St.target.value;
        K || ce(Dt), w == null || w(St);
      },
      Ft = St => {
        $(!1), h == null || h(St), Se(St.target.validity);
      },
      un = St => {
        $(!0), y == null || y(St);
      },
      gt = ci(() => k === "password" ? be ? ne.ariaHidePassword : ne.ariaShowPassword : P ? void 0 : ne.ariaClearLabel, [k, P, be, ne]),
      Pt = ci(() => !c && (W ||
      // The input is currently focused
      le || (
      // There is a value present
      _e == null ? void 0 : _e.badInput) ||
      // The current input is invalid
      G && le !== Q) || c && !!le && !!e || !!Q || O, [c, W, le, _e, e, O, G, Q]);
    return Rt(() => {
      K || ce(C);
    }, [C, K]), Rt(() => {
      const St = Dt => {
        var Kt, hn;
        Be(Dt.target), Ee.current && !((Kt = Ee.current) != null && Kt.contains(Dt.target)) && !((hn = fe.current) != null && hn.contains(Dt.target)) && !W && ge();
      };
      return window.document.addEventListener("click", St, !1), () => {
        window.document.removeEventListener("click", St, !1);
      };
    }, [t]), jR(ee, () => fe.current, []), /* @__PURE__ */we.jsx(AE, {
      id: t,
      isLabel: !0,
      label: e || "<Label is required>",
      errorMessage: E,
      helperText: x,
      messageId: `${t}-message`,
      className: V == null ? void 0 : V.wrapper,
      classNames: {
        label: Ze(Am.label, V == null ? void 0 : V.inputLabel, s && (V == null ? void 0 : V.inputLabelDisabled), Pt && (V == null ? void 0 : V.inputFocus)),
        helperText: V == null ? void 0 : V.inputHelperText,
        errorText: Ze(V == null ? void 0 : V.inputHelperText, (E || !_e) && (V == null ? void 0 : V.inputErrorText))
      },
      children: /* @__PURE__ */we.jsxs("div", {
        ref: Ce,
        className: Ze(Am.container, j, E && [Am.inputError, V == null ? void 0 : V.inputError]),
        children: [/* @__PURE__ */we.jsx("input", {
          style: {
            "--_button-width": `${((ae = Ee.current) == null ? void 0 : ae.clientWidth) || 16}px`
          },
          id: t,
          ref: fe,
          className: Ze(Am.input, V == null ? void 0 : V.input, le && [Am.inputValue, V == null ? void 0 : V.value], (ne == null ? void 0 : ne.clear) && !c && Am.inputButtonActive),
          type: k === "password" && be ? "text" : k,
          name: i || t,
          value: le,
          disabled: s,
          readOnly: O || c,
          onChange: Ae,
          onKeyUp: Mt,
          onFocus: un,
          onMouseEnter: Xe,
          onMouseLeave: () => !de && !W && ge(),
          onBlur: Ft,
          required: D,
          "data-masked-value": G,
          "data-masked-pattern": Q,
          ...Y,
          ...((x || E) && {
            "aria-describedby": `${t}-message`
          })
        }), /* @__PURE__ */we.jsx("span", {
          role: "presentation",
          className: Ze(V == null ? void 0 : V.inputBorder)
        }), (O && !K || O && K && !Q) && /* @__PURE__ */we.jsx(FE, {
          className: V == null ? void 0 : V.loader,
          size: hb.small,
          status: Um.loading,
          align: jE.vertical,
          responsive: !1,
          ...F
        }), s && /* @__PURE__ */we.jsx("div", {
          "aria-hidden": "true",
          className: Ze(Am.inputIcon, V == null ? void 0 : V.iconDisable),
          children: N != null && N.disabled ? N.disabled : /* @__PURE__ */we.jsx(we.Fragment, {
            children: "×"
          })
        }), k !== "number" && (le || G && le !== Q) && ((ne == null ? void 0 : ne.clear) || k === "password") && !c && !s && L && /* @__PURE__ */we.jsxs("button", {
          type: "button",
          "aria-label": gt,
          "aria-pressed": k === "password" ? be : void 0,
          "aria-controls": t,
          ref: Ee,
          className: Ze(Am.inputButton, V == null ? void 0 : V.inputButton, W || se ? Am.show : Am.hide),
          onClick: St => qe(St, k === "password" ? "password" : "clear"),
          onMouseEnter: Xe,
          onMouseLeave: () => !de && !W && ge(),
          onFocus: () => {
            H(!0), Xe();
          },
          onBlur: ge,
          children: [k === "password" && !be && (ne == null ? void 0 : ne.show), k === "password" && be && (ne == null ? void 0 : ne.hide), k !== "password" && L && /* @__PURE__ */we.jsx("div", {
            "aria-hidden": P ? void 0 : "true",
            className: Ze(Am.iconClear, V == null ? void 0 : V.iconClear),
            children: P && (ne == null ? void 0 : ne.clear) || (N == null ? void 0 : N.clear) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "×"
            })
          })]
        }), ie]
      })
    });
  });
function rw(t) {
  return typeof t == "string" || t instanceof String;
}
function yV(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function P5(t, e) {
  return Array.isArray(e) ? P5(t, (i, s) => e.includes(s)) : Object.entries(t).reduce((i, s) => {
    let [c, p] = s;
    return e(p, c) && (i[c] = p), i;
  }, {});
}
const kn = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function Lq(t) {
  switch (t) {
    case kn.LEFT:
      return kn.FORCE_LEFT;
    case kn.RIGHT:
      return kn.FORCE_RIGHT;
    default:
      return t;
  }
}
function pj(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function fL(t, e) {
  if (e === t) return !0;
  const i = Array.isArray(e),
    s = Array.isArray(t);
  let c;
  if (i && s) {
    if (e.length != t.length) return !1;
    for (c = 0; c < e.length; c++) if (!fL(e[c], t[c])) return !1;
    return !0;
  }
  if (i != s) return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const p = e instanceof Date,
      h = t instanceof Date;
    if (p && h) return e.getTime() == t.getTime();
    if (p != h) return !1;
    const y = e instanceof RegExp,
      w = t instanceof RegExp;
    if (y && w) return e.toString() == t.toString();
    if (y != w) return !1;
    const x = Object.keys(e);
    for (c = 0; c < x.length; c++) if (!Object.prototype.hasOwnProperty.call(t, x[c])) return !1;
    for (c = 0; c < x.length; c++) if (!fL(t[x[c]], e[x[c]])) return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function") return e.toString() === t.toString();
  return !1;
}
class Oq {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos);) --this.oldSelection.start;
    if (this.insertedCount) for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end);) this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos ||
    // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? kn.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
    // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? kn.RIGHT : kn.LEFT;
  }
}
function ar(t, e) {
  return new ar.InputMask(t, e);
}
function A5(t) {
  if (t == null) throw new Error("mask property should be defined");
  return t instanceof RegExp ? ar.MaskedRegExp : rw(t) ? ar.MaskedPattern : t === Date ? ar.MaskedDate : t === Number ? ar.MaskedNumber : Array.isArray(t) || t === Array ? ar.MaskedDynamic : ar.Masked && t.prototype instanceof ar.Masked ? t : ar.Masked && t instanceof ar.Masked ? t.constructor : t instanceof Function ? ar.MaskedFunction : (console.warn("Mask not found for mask", t), ar.Masked);
}
function oR(t) {
  if (!t) throw new Error("Options in not defined");
  if (ar.Masked) {
    if (t.prototype instanceof ar.Masked) return {
      mask: t
    };
    const {
      mask: e = void 0,
      ...i
    } = t instanceof ar.Masked ? {
      mask: t
    } : yV(t) && t.mask instanceof ar.Masked ? t : {};
    if (e) {
      const s = e.mask;
      return {
        ...P5(e, (c, p) => !p.startsWith("_")),
        mask: e.constructor,
        _mask: s,
        ...i
      };
    }
  }
  return yV(t) ? {
    ...t
  } : {
    mask: t
  };
}
function yb(t) {
  if (ar.Masked && t instanceof ar.Masked) return t;
  const e = oR(t),
    i = A5(e.mask);
  if (!i) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === i && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new i(e);
}
ar.createMask = yb;
class fN {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {}
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {}
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, i) {
    if (!(e == null || i == null || e === this.selectionStart && i === this.selectionEnd)) try {
      this._unsafeSelect(e, i);
    } catch {}
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
ar.MaskElement = fN;
const bV = 90,
  Pq = 89;
class qL extends fN {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, i, s;
    return (e = (i = (s = this.input).getRootNode) == null ? void 0 : i.call(s)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === bV && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === Pq && e.ctrlKey)) return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === bV && (e.metaKey || e.ctrlKey)) return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo) return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo) return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
ar.HTMLMaskElement = qL;
class Aq extends qL {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, i) {
    this.input.setSelectionRange(e, i);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
ar.HTMLMaskElement = qL;
class j5 extends qL {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement,
      i = e.getSelection && e.getSelection(),
      s = i && i.anchorOffset,
      c = i && i.focusOffset;
    return c == null || s == null || s < c ? s : c;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement,
      i = e.getSelection && e.getSelection(),
      s = i && i.anchorOffset,
      c = i && i.focusOffset;
    return c == null || s == null || s > c ? s : c;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, i) {
    if (!this.rootElement.createRange) return;
    const s = this.rootElement.createRange();
    s.setStart(this.input.firstChild || this.input, e), s.setEnd(this.input.lastChild || this.input, i);
    const c = this.rootElement,
      p = c.getSelection && c.getSelection();
    p && (p.removeAllRanges(), p.addRange(s));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
ar.HTMLContenteditableMaskElement = j5;
class YL {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > YL.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
YL.MAX_LENGTH = 100;
class jq {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, i) {
    this.el = e instanceof fN ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new j5(e) : new Aq(e), this.masked = yb(i), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new YL(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var i;
    return e == null || ((i = this.masked) == null ? void 0 : i.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof ar.Masked) && this.masked.constructor === A5(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const i = e instanceof ar.Masked ? e : yb({
      mask: e
    });
    i.unmaskedValue = this.masked.unmaskedValue, this.masked = i;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, i) {
    const s = this._listeners[e];
    s && s.forEach(c => c(i));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const i = this.masked.unmaskedValue,
      s = this.masked.value,
      c = this.masked.rawInputValue,
      p = this.displayValue,
      h = this.unmaskedValue !== i || this.value !== s || this._rawInputValue !== c;
    this._unmaskedValue = i, this._value = s, this._rawInputValue = c, this.el.value !== p && (this.el.value = p), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), h && this._fireChangeEvents(), !this._historyChanging && (h || this.history.isEmpty) && this.history.push({
      unmaskedValue: i,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
        mask: i,
        ...s
      } = e,
      c = !this.maskEquals(i),
      p = this.masked.optionsIsChanged(s);
    c && (this.mask = i), p && this.masked.updateOptions(s), (c || p) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, kn.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, i) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(i), this;
  }
  /** Removes custom event listener */
  off(e, i) {
    if (!this._listeners[e]) return this;
    if (!i) return delete this._listeners[e], this;
    const s = this._listeners[e].indexOf(i);
    return s >= 0 && this._listeners[e].splice(s, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const i = new Oq({
        // new state
        value: this.el.value,
        cursorPos: this.cursorPos,
        // old state
        oldValue: this.displayValue,
        oldSelection: this._selection
      }),
      s = this.masked.rawInputValue,
      c = this.masked.splice(i.startChangePos, i.removed.length, i.inserted, i.removeDirection, {
        input: !0,
        raw: !0
      }).offset,
      p = s === this.masked.rawInputValue ? i.removeDirection : kn.NONE;
    let h = this.masked.nearestInputPos(i.startChangePos + c, p);
    p !== kn.NONE && (h = this.masked.nearestInputPos(h, kn.NONE)), this.updateControl(h), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
ar.InputMask = jq;
class gr {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new gr()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
ar.ChangeDetails = gr;
class Yv {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, i, s) {
    e === void 0 && (e = ""), i === void 0 && (i = 0), this.value = e, this.from = i, this.stop = s;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const i = this.value[0];
    return this.value = this.value.slice(1), i;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class ku {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...ku.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, i) {
    i === void 0 && (i = {
      input: !0
    }), this.reset(), this.append(e, i, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, i) {
    return e;
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), Math.min(this.displayValue.length, i - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, i, s) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), this.displayValue.slice(e, i);
  }
  /** Extracts tail in range */
  extractTail(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), new Yv(this.extractInput(e, i), e);
  }
  /** Appends tail */
  appendTail(e) {
    return rw(e) && (e = new Yv(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, i) {
    return e ? (this._value += e, new gr({
      inserted: e,
      rawInserted: e
    })) : new gr();
  }
  /** Appends char */
  _appendChar(e, i, s) {
    i === void 0 && (i = {});
    const c = this.state;
    let p;
    if ([e, p] = this.doPrepareChar(e, i), e && (p = p.aggregate(this._appendCharRaw(e, i)), !p.rawInserted && this.autofix === "pad")) {
      const h = this.state;
      this.state = c;
      let y = this.pad(i);
      const w = this._appendCharRaw(e, i);
      y = y.aggregate(w), w.rawInserted || y.equals(p) ? p = y : this.state = h;
    }
    if (p.inserted) {
      let h,
        y = this.doValidate(i) !== !1;
      if (y && s != null) {
        const w = this.state;
        if (this.overwrite === !0) {
          h = s.state;
          for (let E = 0; E < p.rawInserted.length; ++E) s.unshift(this.displayValue.length - p.tailShift);
        }
        let x = this.appendTail(s);
        if (y = x.rawInserted.length === s.toString().length, !(y && x.inserted) && this.overwrite === "shift") {
          this.state = w, h = s.state;
          for (let E = 0; E < p.rawInserted.length; ++E) s.shift();
          x = this.appendTail(s), y = x.rawInserted.length === s.toString().length;
        }
        y && x.inserted && (this.state = w);
      }
      y || (p = new gr(), this.state = c, s && h && (s.state = h));
    }
    return p;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new gr();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new gr();
  }
  /** Appends symbols considering flags */
  append(e, i, s) {
    if (!rw(e)) throw new Error("value should be string");
    const c = rw(s) ? new Yv(String(s)) : s;
    i != null && i.tail && (i._beforeTailState = this.state);
    let p;
    [e, p] = this.doPrepare(e, i);
    for (let h = 0; h < e.length; ++h) {
      const y = this._appendChar(e[h], i, c);
      if (!y.rawInserted && !this.doSkipInvalid(e[h], i, c)) break;
      p.aggregate(y);
    }
    return (this.eager === !0 || this.eager === "append") && i != null && i.input && e && p.aggregate(this._appendEager()), c != null && (p.tailShift += this.appendTail(c).tailShift), p;
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(i), new gr();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const i = this.rawInputValue,
      s = this.value,
      c = e();
    return this.rawInputValue = i, this.value && this.value !== s && s.indexOf(this.value) === 0 && (this.append(s.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, c;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const i = this.state,
      s = e(this);
    return this.state = i, delete this._isolated, s;
  }
  doSkipInvalid(e, i, s) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, i) {
    return i === void 0 && (i = {}), gr.normalize(this.prepare ? this.prepare(e, this, i) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, i) {
    return i === void 0 && (i = {}), gr.normalize(this.prepareChar ? this.prepareChar(e, this, i) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, i, s, c, p) {
    s === void 0 && (s = ""), c === void 0 && (c = kn.NONE), p === void 0 && (p = {
      input: !0
    });
    const h = e + i,
      y = this.extractTail(h),
      w = this.eager === !0 || this.eager === "remove";
    let x;
    w && (c = Lq(c), x = this.extractInput(0, h, {
      raw: !0
    }));
    let E = e;
    const C = new gr();
    if (c !== kn.NONE && (E = this.nearestInputPos(e, i > 1 && e !== 0 && !w ? kn.NONE : c), C.tailShift = E - e), C.aggregate(this.remove(E)), w && c !== kn.NONE && x === this.rawInputValue) if (c === kn.FORCE_LEFT) {
      let k;
      for (; x === this.rawInputValue && (k = this.displayValue.length);) C.aggregate(new gr({
        tailShift: -1
      })).aggregate(this.remove(k - 1));
    } else c === kn.FORCE_RIGHT && y.unshift();
    return C.aggregate(this.append(s, p, y));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !fL(this, e);
  }
  typedValueEquals(e) {
    const i = this.typedValue;
    return e === i || ku.EMPTY_VALUES.includes(e) && ku.EMPTY_VALUES.includes(i) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new gr();
  }
}
ku.DEFAULTS = {
  skipInvalid: !0
};
ku.EMPTY_VALUES = [void 0, null, ""];
ar.Masked = ku;
class Hx {
  /** */
  constructor(e, i) {
    e === void 0 && (e = []), i === void 0 && (i = 0), this.chunks = e, this.from = i;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = rw(e) ? new Yv(String(e)) : e;
    const i = this.chunks[this.chunks.length - 1],
      s = i && (
      // if stops are same or tail has no stop
      i.stop === e.stop || e.stop == null) &&
      // if tail chunk goes just after last chunk
      e.from === i.from + i.toString().length;
    if (e instanceof Yv) s ? i.extend(e.toString()) : this.chunks.push(e);else if (e instanceof Hx) {
      if (e.stop == null) {
        let c;
        for (; e.chunks.length && e.chunks[0].stop == null;) c = e.chunks.shift(), c.from += e.from, this.extend(c);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof ar.MaskedPattern)) return new Yv(this.toString()).appendTo(e);
    const i = new gr();
    for (let s = 0; s < this.chunks.length; ++s) {
      const c = this.chunks[s],
        p = e._mapPosToBlock(e.displayValue.length),
        h = c.stop;
      let y;
      if (h != null && (
      // if block not found or stop is behind lastBlock
      !p || p.index <= h) && ((c instanceof Hx ||
      // for continuous block also check if stop is exist
      e._stops.indexOf(h) >= 0) && i.aggregate(e._appendPlaceholder(h)), y = c instanceof Hx && e._blocks[h]), y) {
        const w = y.appendTail(c);
        i.aggregate(w);
        const x = c.toString().slice(w.rawInserted.length);
        x && i.aggregate(e.append(x, {
          tail: !0
        }));
      } else i.aggregate(e.append(c.toString(), {
        tail: !0
      }));
    }
    return i;
  }
  get state() {
    return {
      chunks: this.chunks.map(e => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: i,
      ...s
    } = e;
    Object.assign(this, s), this.chunks = i.map(c => {
      const p = "chunks" in c ? new Hx() : new Yv();
      return p.state = c, p;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const i = e != null ? e - this.from : e;
    let s = 0;
    for (; s < this.chunks.length;) {
      const c = this.chunks[s],
        p = c.unshift(i);
      if (c.toString()) {
        if (!p) break;
        ++s;
      } else this.chunks.splice(s, 1);
      if (p) return p;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e;) {
      const i = this.chunks[e],
        s = i.shift();
      if (i.toString()) {
        if (!s) break;
        --e;
      } else this.chunks.splice(e, 1);
      if (s) return s;
    }
    return "";
  }
}
class Fq {
  constructor(e, i) {
    this.masked = e, this._log = [];
    const {
      offset: s,
      index: c
    } = e._mapPosToBlock(i) || (i < 0 ?
    // first
    {
      index: 0,
      offset: 0
    } :
    // last
    {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = s, this.index = c, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((i = this.block) == null ? void 0 : i.displayValue.length) || 0) {
      var i;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, kn.FORCE_LEFT), this.offset !== 0)) return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed) return this.offset = this.block.nearestInputPos(this.offset, kn.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value)) return this.offset = this.block.nearestInputPos(this.offset, kn.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, kn.FORCE_RIGHT), this.offset !== this.block.value.length)) return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed) return this.offset = this.block.nearestInputPos(this.offset, kn.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value)) return this.offset = this.block.nearestInputPos(this.offset, kn.NONE), !0;
    });
  }
}
class F5 {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(i), this._value || (this._isRawInput = !1), new gr();
  }
  nearestInputPos(e, i) {
    i === void 0 && (i = kn.NONE);
    const s = 0,
      c = this._value.length;
    switch (i) {
      case kn.LEFT:
      case kn.FORCE_LEFT:
        return s;
      case kn.NONE:
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
      default:
        return c;
    }
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), this._isRawInput ? i - e : 0;
  }
  extractInput(e, i, s) {
    return e === void 0 && (e = 0), i === void 0 && (i = this._value.length), s === void 0 && (s = {}), s.raw && this._isRawInput && this._value.slice(e, i) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, i) {
    if (i === void 0 && (i = {}), this.isFilled) return new gr();
    const s = this.eager === !0 || this.eager === "append",
      c = this.char === e && (this.isUnmasking || i.input || i.raw) && (!i.raw || !s) && !i.tail,
      p = new gr({
        inserted: this.char,
        rawInserted: c ? this.char : ""
      });
    return this._value = this.char, this._isRawInput = c && (i.raw || i.input), p;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new gr();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new Yv("");
  }
  appendTail(e) {
    return rw(e) && (e = new Yv(String(e))), e.appendTo(this);
  }
  append(e, i, s) {
    const c = this._appendChar(e[0], i);
    return s != null && (c.tailShift += this.appendTail(s).tailShift), c;
  }
  doCommit() {}
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class pL {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: i,
      isOptional: s,
      placeholderChar: c,
      displayChar: p,
      lazy: h,
      eager: y,
      ...w
    } = e;
    this.masked = yb(w), Object.assign(this, {
      parent: i,
      isOptional: s,
      placeholderChar: c,
      displayChar: p,
      lazy: h,
      eager: y
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), e === 0 && i >= 1 ? (this.isFilled = !1, this.masked.remove(e, i)) : new gr();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, i) {
    if (i === void 0 && (i = {}), this.isFilled) return new gr();
    const s = this.masked.state;
    let c = this.masked._appendChar(e, this.currentMaskFlags(i));
    return c.inserted && this.doValidate(i) === !1 && (c = new gr(), this.masked.state = s), !c.inserted && !this.isOptional && !this.lazy && !i.input && (c.inserted = this.placeholderChar), c.skip = !c.inserted && !this.isOptional, this.isFilled = !!c.inserted, c;
  }
  append(e, i, s) {
    return this.masked.append(e, this.currentMaskFlags(i), s);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new gr() : (this.isFilled = !0, new gr({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new gr();
  }
  extractTail(e, i) {
    return this.masked.extractTail(e, i);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, i, s) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), this.masked.extractInput(e, i, s);
  }
  nearestInputPos(e, i) {
    i === void 0 && (i = kn.NONE);
    const s = 0,
      c = this.value.length,
      p = Math.min(Math.max(e, s), c);
    switch (i) {
      case kn.LEFT:
      case kn.FORCE_LEFT:
        return this.isComplete ? p : s;
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
        return this.isComplete ? p : c;
      case kn.NONE:
      default:
        return p;
    }
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.value.length), this.value.slice(e, i).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var i;
    return {
      ...e,
      _beforeTailState: (e == null || (i = e._beforeTailState) == null ? void 0 : i.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new gr();
  }
}
pL.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class N5 extends ku {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const i = e.mask;
    i && (e.validate = s => s.search(i) >= 0), super._update(e);
  }
}
ar.MaskedRegExp = N5;
class uu extends ku {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...uu.DEFAULTS,
      ...e,
      definitions: Object.assign({}, pL.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const i = this.mask;
    if (!i || !e) return;
    let s = !1,
      c = !1;
    for (let p = 0; p < i.length; ++p) {
      if (this.blocks) {
        const x = i.slice(p),
          E = Object.keys(this.blocks).filter(k => x.indexOf(k) === 0);
        E.sort((k, D) => D.length - k.length);
        const C = E[0];
        if (C) {
          const {
              expose: k,
              repeat: D,
              ...I
            } = oR(this.blocks[C]),
            L = {
              lazy: this.lazy,
              eager: this.eager,
              placeholderChar: this.placeholderChar,
              displayChar: this.displayChar,
              overwrite: this.overwrite,
              autofix: this.autofix,
              ...I,
              repeat: D,
              parent: this
            },
            P = D != null ? new ar.RepeatBlock(L
            /* TODO */) : yb(L);
          P && (this._blocks.push(P), k && (this.exposeBlock = P), this._maskedBlocks[C] || (this._maskedBlocks[C] = []), this._maskedBlocks[C].push(this._blocks.length - 1)), p += C.length - 1;
          continue;
        }
      }
      let h = i[p],
        y = h in e;
      if (h === uu.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (h === "{" || h === "}") {
        s = !s;
        continue;
      }
      if (h === "[" || h === "]") {
        c = !c;
        continue;
      }
      if (h === uu.ESCAPE_CHAR) {
        if (++p, h = i[p], !h) break;
        y = !1;
      }
      const w = y ? new pL({
        isOptional: c,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...oR(e[h]),
        parent: this
      }) : new F5({
        char: h,
        eager: this.eager,
        isUnmasking: s
      });
      this._blocks.push(w);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map(e => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: i,
      ...s
    } = e;
    this._blocks.forEach((c, p) => c.state = i[p]), super.state = s;
  }
  reset() {
    super.reset(), this._blocks.forEach(e => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every(e => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every(e => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every(e => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every(e => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach(e => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, i) => e += i.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(i), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value :
    // TODO return _value when not in change?
    this._blocks.reduce((e, i) => e += i.value, "");
  }
  set value(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(i), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const i = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(i), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, i) => e += i.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const i = new gr();
    let s = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (s == null) return i;
    this._blocks[s].isFilled && ++s;
    for (let c = s; c < this._blocks.length; ++c) {
      const p = this._blocks[c]._appendEager();
      if (!p.inserted) break;
      i.aggregate(p);
    }
    return i;
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const s = this._mapPosToBlock(this.displayValue.length),
      c = new gr();
    if (!s) return c;
    for (let h = s.index, y; y = this._blocks[h]; ++h) {
      var p;
      const w = y._appendChar(e, {
        ...i,
        _beforeTailState: (p = i._beforeTailState) == null || (p = p._blocks) == null ? void 0 : p[h]
      });
      if (c.aggregate(w), w.consumed) break;
    }
    return c;
  }
  extractTail(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const s = new Hx();
    return e === i || this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      const w = c.extractTail(h, y);
      w.stop = this._findStopBefore(p), w.from = this._blockStartPos(p), w instanceof Hx && (w.blockIndex = p), s.extend(w);
    }), s;
  }
  extractInput(e, i, s) {
    if (e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), s === void 0 && (s = {}), e === i) return "";
    let c = "";
    return this._forEachBlocksInRange(e, i, (p, h, y, w) => {
      c += p.extractInput(y, w, s);
    }), c;
  }
  _findStopBefore(e) {
    let i;
    for (let s = 0; s < this._stops.length; ++s) {
      const c = this._stops[s];
      if (c <= e) i = c;else break;
    }
    return i;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const i = new gr();
    if (this.lazy && e == null) return i;
    const s = this._mapPosToBlock(this.displayValue.length);
    if (!s) return i;
    const c = s.index,
      p = e ?? this._blocks.length;
    return this._blocks.slice(c, p).forEach(h => {
      if (!h.lazy || e != null) {
        var y;
        i.aggregate(h._appendPlaceholder((y = h._blocks) == null ? void 0 : y.length));
      }
    }), i;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let i = "";
    for (let s = 0; s < this._blocks.length; ++s) {
      const c = this._blocks[s],
        p = i.length;
      if (i += c.displayValue, e <= i.length) return {
        index: s,
        offset: e - p
      };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((i, s) => i += s.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, i, s) {
    i === void 0 && (i = this.displayValue.length);
    const c = this._mapPosToBlock(e);
    if (c) {
      const p = this._mapPosToBlock(i),
        h = p && c.index === p.index,
        y = c.offset,
        w = p && h ? p.offset : this._blocks[c.index].displayValue.length;
      if (s(this._blocks[c.index], c.index, y, w), p && !h) {
        for (let x = c.index + 1; x < p.index; ++x) s(this._blocks[x], x, 0, this._blocks[x].displayValue.length);
        s(this._blocks[p.index], p.index, 0, p.offset);
      }
    }
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const s = super.remove(e, i);
    return this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      s.aggregate(c.remove(h, y));
    }), s;
  }
  nearestInputPos(e, i) {
    if (i === void 0 && (i = kn.NONE), !this._blocks.length) return 0;
    const s = new Fq(this, e);
    if (i === kn.NONE) return s.pushRightBeforeInput() || (s.popState(), s.pushLeftBeforeInput()) ? s.pos : this.displayValue.length;
    if (i === kn.LEFT || i === kn.FORCE_LEFT) {
      if (i === kn.LEFT) {
        if (s.pushRightBeforeFilled(), s.ok && s.pos === e) return e;
        s.popState();
      }
      if (s.pushLeftBeforeInput(), s.pushLeftBeforeRequired(), s.pushLeftBeforeFilled(), i === kn.LEFT) {
        if (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.ok && s.pos <= e || (s.popState(), s.ok && s.pos <= e)) return s.pos;
        s.popState();
      }
      return s.ok ? s.pos : i === kn.FORCE_LEFT ? 0 : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : 0);
    }
    return i === kn.RIGHT || i === kn.FORCE_RIGHT ? (s.pushRightBeforeInput(), s.pushRightBeforeRequired(), s.pushRightBeforeFilled() ? s.pos : i === kn.FORCE_RIGHT ? this.displayValue.length : (s.popState(), s.ok || (s.popState(), s.ok) ? s.pos : this.nearestInputPos(e, kn.LEFT))) : e;
  }
  totalInputPositions(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    let s = 0;
    return this._forEachBlocksInRange(e, i, (c, p, h, y) => {
      s += c.totalInputPositions(h, y);
    }), s;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const i = this._maskedBlocks[e];
    return i ? i.map(s => this._blocks[s]) : [];
  }
  pad(e) {
    const i = new gr();
    return this._forEachBlocksInRange(0, this.displayValue.length, s => i.aggregate(s.pad(e))), i;
  }
}
uu.DEFAULTS = {
  ...ku.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
uu.STOP_CHAR = "`";
uu.ESCAPE_CHAR = "\\";
uu.InputDefinition = pL;
uu.FixedDefinition = F5;
ar.MaskedPattern = uu;
class VT extends uu {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: i = this.to || 0,
      from: s = this.from || 0,
      maxLength: c = this.maxLength || 0,
      autofix: p = this.autofix,
      ...h
    } = e;
    this.to = i, this.from = s, this.maxLength = Math.max(String(i).length, c), this.autofix = p;
    const y = String(this.from).padStart(this.maxLength, "0"),
      w = String(this.to).padStart(this.maxLength, "0");
    let x = 0;
    for (; x < w.length && w[x] === y[x];) ++x;
    h.mask = w.slice(0, x).replace(/0/g, "\\0") + "0".repeat(this.maxLength - x), super._update(h);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let i = "",
      s = "";
    const [, c, p] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return p && (i = "0".repeat(c.length) + p, s = "9".repeat(c.length) + p), i = i.padEnd(this.maxLength, "0"), s = s.padEnd(this.maxLength, "9"), [i, s];
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    let s;
    return [e, s] = super.doPrepareChar(e.replace(/\D/g, ""), i), e || (s.skip = !this.isComplete), [e, s];
  }
  _appendCharRaw(e, i) {
    if (i === void 0 && (i = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, i);
    const s = String(this.from).padStart(this.maxLength, "0"),
      c = String(this.to).padStart(this.maxLength, "0"),
      [p, h] = this.boundaries(this.value + e);
    return Number(h) < this.from ? super._appendCharRaw(s[this.value.length], i) : Number(p) > this.to ? !i.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(s[this.value.length], i).aggregate(this._appendCharRaw(e, i)) : super._appendCharRaw(c[this.value.length], i) : super._appendCharRaw(e, i);
  }
  doValidate(e) {
    const i = this.value;
    if (i.search(/[^0]/) === -1 && i.length <= this._matchFrom) return !0;
    const [s, c] = this.boundaries(i);
    return this.from <= Number(c) && Number(s) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const i = new gr();
    if (this.value.length === this.maxLength) return i;
    const s = this.value,
      c = this.maxLength - this.value.length;
    if (c) {
      this.reset();
      for (let p = 0; p < c; ++p) i.aggregate(super._appendCharRaw("0", e));
      s.split("").forEach(p => this._appendCharRaw(p));
    }
    return i;
  }
}
ar.MaskedRange = VT;
const Nq = "d{.}`m{.}`Y";
class qv extends uu {
  static extractPatternOptions(e) {
    const {
      mask: i,
      pattern: s,
      ...c
    } = e;
    return {
      ...c,
      mask: rw(i) ? i : s
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(qv.extractPatternOptions({
      ...qv.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
        mask: i,
        pattern: s,
        blocks: c,
        ...p
      } = {
        ...qv.DEFAULTS,
        ...e
      },
      h = Object.assign({}, qv.GET_DEFAULT_BLOCKS());
    e.min && (h.Y.from = e.min.getFullYear()), e.max && (h.Y.to = e.max.getFullYear()), e.min && e.max && h.Y.from === h.Y.to && (h.m.from = e.min.getMonth() + 1, h.m.to = e.max.getMonth() + 1, h.m.from === h.m.to && (h.d.from = e.min.getDate(), h.d.to = e.max.getDate())), Object.assign(h, this.blocks, c), super._update({
      ...p,
      mask: rw(i) ? i : s,
      blocks: h
    });
  }
  doValidate(e) {
    const i = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && i != null && (this.min == null || this.min <= i) && (this.max == null || i <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(qv.extractPatternOptions(e));
  }
}
qv.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: VT,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: VT,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: VT,
    from: 1900,
    to: 9999
  }
});
qv.DEFAULTS = {
  ...uu.DEFAULTS,
  mask: Date,
  pattern: Nq,
  format: (t, e) => {
    if (!t) return "";
    const i = String(t.getDate()).padStart(2, "0"),
      s = String(t.getMonth() + 1).padStart(2, "0"),
      c = t.getFullYear();
    return [i, s, c].join(".");
  },
  parse: (t, e) => {
    const [i, s, c] = t.split(".").map(Number);
    return new Date(c, s - 1, i);
  }
};
ar.MaskedDate = qv;
class zR extends ku {
  constructor(e) {
    super({
      ...zR.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map(i => {
      const {
          expose: s,
          ...c
        } = oR(i),
        p = yb({
          overwrite: this._overwrite,
          eager: this._eager,
          skipInvalid: this._skipInvalid,
          ...c
        });
      return s && (this.exposeMask = p), p;
    }) : []);
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const s = this._applyDispatch(e, i);
    return this.currentMask && s.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(i))), s;
  }
  _applyDispatch(e, i, s) {
    e === void 0 && (e = ""), i === void 0 && (i = {}), s === void 0 && (s = "");
    const c = i.tail && i._beforeTailState != null ? i._beforeTailState._value : this.value,
      p = this.rawInputValue,
      h = i.tail && i._beforeTailState != null ? i._beforeTailState._rawInputValue : p,
      y = p.slice(h.length),
      w = this.currentMask,
      x = new gr(),
      E = w == null ? void 0 : w.state;
    return this.currentMask = this.doDispatch(e, {
      ...i
    }, s), this.currentMask && (this.currentMask !== w ? (this.currentMask.reset(), h && (this.currentMask.append(h, {
      raw: !0
    }), x.tailShift = this.currentMask.value.length - c.length), y && (x.tailShift += this.currentMask.append(y, {
      raw: !0,
      tail: !0
    }).tailShift)) : E && (this.currentMask.state = E)), x;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const i = new gr();
    return e && i.aggregate(this._applyDispatch("", {}, e)), i.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var i, s;
    return {
      ...e,
      _beforeTailState: ((i = e._beforeTailState) == null ? void 0 : i.currentMaskRef) === this.currentMask && ((s = e._beforeTailState) == null ? void 0 : s.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, i, s) {
    return i === void 0 && (i = {}), s === void 0 && (s = ""), this.dispatch(e, this, i, s);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, i) {
    i === void 0 && (i = {});
    let [s, c] = super.doPrepare(e, i);
    if (this.currentMask) {
      let p;
      [s, p] = super.doPrepare(s, this.currentMaskFlags(i)), c = c.aggregate(p);
    }
    return [s, c];
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    let [s, c] = super.doPrepareChar(e, i);
    if (this.currentMask) {
      let p;
      [s, p] = super.doPrepareChar(s, this.currentMaskFlags(i)), c = c.aggregate(p);
    }
    return [s, c];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach(i => i.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let i = String(e);
    this.currentMask && (this.currentMask.typedValue = e, i = this.currentMask.unmaskedValue), this.unmaskedValue = i;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, i) {
    const s = new gr();
    return this.currentMask && s.aggregate(this.currentMask.remove(e, i)).aggregate(this._applyDispatch()), s;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map(i => i.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: i,
      currentMaskRef: s,
      currentMask: c,
      ...p
    } = e;
    i && this.compiledMasks.forEach((h, y) => h.state = i[y]), s != null && (this.currentMask = s, this.currentMask.state = c), super.state = p;
  }
  extractInput(e, i, s) {
    return this.currentMask ? this.currentMask.extractInput(e, i, s) : "";
  }
  extractTail(e, i) {
    return this.currentMask ? this.currentMask.extractTail(e, i) : super.extractTail(e, i);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, i) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, i) : super.nearestInputPos(e, i);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((i, s) => {
      if (!e[s]) return;
      const {
        mask: c,
        ...p
      } = e[s];
      return fL(i, p) && i.maskEquals(c);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var i;
    return !!((i = this.currentMask) != null && i.typedValueEquals(e));
  }
}
zR.DEFAULTS = {
  ...ku.DEFAULTS,
  dispatch: (t, e, i, s) => {
    if (!e.compiledMasks.length) return;
    const c = e.rawInputValue,
      p = e.compiledMasks.map((h, y) => {
        const w = e.currentMask === h,
          x = w ? h.displayValue.length : h.nearestInputPos(h.displayValue.length, kn.FORCE_LEFT);
        return h.rawInputValue !== c ? (h.reset(), h.append(c, {
          raw: !0
        })) : w || h.remove(x), h.append(t, e.currentMaskFlags(i)), h.appendTail(s), {
          index: y,
          weight: h.rawInputValue.length,
          totalInputPositions: h.totalInputPositions(0, Math.max(x, h.nearestInputPos(h.displayValue.length, kn.FORCE_LEFT)))
        };
      });
    return p.sort((h, y) => y.weight - h.weight || y.totalInputPositions - h.totalInputPositions), e.compiledMasks[p[0].index];
  }
};
ar.MaskedDynamic = zR;
class VR extends uu {
  constructor(e) {
    super({
      ...VR.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: i,
      ...s
    } = e;
    if (i) {
      const c = i.map(y => y.length),
        p = Math.min(...c),
        h = Math.max(...c) - p;
      s.mask = "*".repeat(p), h && (s.mask += "[" + "*".repeat(h) + "]"), this.enum = i;
    }
    super._update(s);
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const s = Math.min(this.nearestInputPos(0, kn.FORCE_RIGHT), this.value.length),
      c = this.enum.filter(p => this.matchValue(p, this.unmaskedValue + e, s));
    if (c.length) {
      c.length === 1 && this._forEachBlocksInRange(0, this.value.length, (h, y) => {
        const w = c[0][y];
        y >= this.value.length || w === h.value || (h.reset(), h._appendChar(w, i));
      });
      const p = super._appendCharRaw(c[0][this.value.length], i);
      return c.length === 1 && c[0].slice(this.unmaskedValue.length).split("").forEach(h => p.aggregate(super._appendCharRaw(h))), p;
    }
    return new gr({
      skip: !this.isComplete
    });
  }
  extractTail(e, i) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), new Yv("", e);
  }
  remove(e, i) {
    if (e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), e === i) return new gr();
    const s = Math.min(super.nearestInputPos(0, kn.FORCE_RIGHT), this.value.length);
    let c;
    for (c = e; c >= 0 && !(this.enum.filter(h => this.matchValue(h, this.value.slice(s, c), s)).length > 1); --c);
    const p = super.remove(c, i);
    return p.tailShift += c - e, p;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
VR.DEFAULTS = {
  ...uu.DEFAULTS,
  matchValue: (t, e, i) => t.indexOf(e, i) === i
};
ar.MaskedEnum = VR;
class z5 extends ku {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
ar.MaskedFunction = z5;
var V5;
class id extends ku {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...id.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""),
      i = "\\d*",
      s = (this.scale ? "(" + pj(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + i + s), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(pj).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(pj(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const i = e.split(this.radix);
    return i[0] = i[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), i.join(this.radix);
  }
  doPrepareChar(e, i) {
    i === void 0 && (i = {});
    const [s, c] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (
    /*
    radix should be mapped when
    1) input is done from keyboard = flags.input && flags.raw
    2) unmasked value is set = !flags.input && !flags.raw
    and should not be mapped when
    1) value is set = flags.input && !flags.raw
    2) raw value is set = !flags.input && flags.raw
    */
    i.input && i.raw || !i.input && !i.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), i);
    return e && !s && (c.skip = !0), s && !this.allowPositive && !this.value && s !== "-" && c.aggregate(this._appendChar("-")), [s, c];
  }
  _separatorsCount(e, i) {
    i === void 0 && (i = !1);
    let s = 0;
    for (let c = 0; c < e; ++c) this._value.indexOf(this.thousandsSeparator, c) === c && (++s, i && (e += this.thousandsSeparator.length));
    return s;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, i, s) {
    return e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), [e, i] = this._adjustRangeWithSeparators(e, i), this._removeThousandsSeparators(super.extractInput(e, i, s));
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const s = i.tail && i._beforeTailState ? i._beforeTailState._value : this._value,
      c = this._separatorsCountFromSlice(s);
    this._value = this._removeThousandsSeparators(this.value);
    const p = this._value;
    this._value += e;
    const h = this.number;
    let y = !isNaN(h),
      w = !1;
    if (y) {
      let k;
      this.min != null && this.min < 0 && this.number < this.min && (k = this.min), this.max != null && this.max > 0 && this.number > this.max && (k = this.max), k != null && (this.autofix ? (this._value = this.format(k, this).replace(id.UNMASKED_RADIX, this.radix), w || (w = p === this._value && !i.tail)) : y = !1), y && (y = !!this._value.match(this._numberRegExp));
    }
    let x;
    y ? x = new gr({
      inserted: this._value.slice(p.length),
      rawInserted: w ? "" : e,
      skip: w
    }) : (this._value = p, x = new gr()), this._value = this._insertThousandsSeparators(this._value);
    const E = i.tail && i._beforeTailState ? i._beforeTailState._value : this._value,
      C = this._separatorsCountFromSlice(E);
    return x.tailShift += (C - c) * this.thousandsSeparator.length, x;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const i = e - this.thousandsSeparator.length + 1,
        s = this.value.indexOf(this.thousandsSeparator, i);
      if (s <= e) return s;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, i) {
    const s = this._findSeparatorAround(e);
    s >= 0 && (e = s);
    const c = this._findSeparatorAround(i);
    return c >= 0 && (i = c + this.thousandsSeparator.length), [e, i];
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length), [e, i] = this._adjustRangeWithSeparators(e, i);
    const s = this.value.slice(0, e),
      c = this.value.slice(i),
      p = this._separatorsCount(s.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(s + c));
    const h = this._separatorsCountFromSlice(s);
    return new gr({
      tailShift: (h - p) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, i) {
    if (!this.thousandsSeparator) return e;
    switch (i) {
      case kn.NONE:
      case kn.LEFT:
      case kn.FORCE_LEFT:
        {
          const s = this._findSeparatorAround(e - 1);
          if (s >= 0) {
            const c = s + this.thousandsSeparator.length;
            if (e < c || this.value.length <= c || i === kn.FORCE_LEFT) return s;
          }
          break;
        }
      case kn.RIGHT:
      case kn.FORCE_RIGHT:
        {
          const s = this._findSeparatorAround(e);
          if (s >= 0) return s + this.thousandsSeparator.length;
        }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let i = e;
      this.min != null && (i = Math.max(i, this.min)), this.max != null && (i = Math.min(i, this.max)), i !== e && (this.unmaskedValue = this.format(i, this));
      let s = this.value;
      this.normalizeZeros && (s = this._normalizeZeros(s)), this.padFractionalZeros && this.scale > 0 && (s = this._padFractionalZeros(s)), this._value = s;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const i = this._removeThousandsSeparators(e).split(this.radix);
    return i[0] = i[0].replace(/^(\D*)(0*)(\d*)/, (s, c, p, h) => c + h), e.length && !/\d$/.test(i[0]) && (i[0] = i[0] + "0"), i.length > 1 && (i[1] = i[1].replace(/0*$/, ""), i[1].length || (i.length = 1)), this._insertThousandsSeparators(i.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const i = e.split(this.radix);
    return i.length < 2 && i.push(""), i[1] = i[1].padEnd(this.scale, "0"), i.join(this.radix);
  }
  doSkipInvalid(e, i, s) {
    i === void 0 && (i = {});
    const c = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === id.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, i, s) && !c;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, id.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(id.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || id.EMPTY_VALUES.includes(e) && id.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
V5 = id;
id.UNMASKED_RADIX = ".";
id.EMPTY_VALUES = [...ku.EMPTY_VALUES, 0];
id.DEFAULTS = {
  ...ku.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [V5.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: t => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
ar.MaskedNumber = id;
const C2 = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function B5(t, e, i) {
  e === void 0 && (e = C2.MASKED), i === void 0 && (i = C2.MASKED);
  const s = yb(t);
  return c => s.runIsolated(p => (p[e] = c, p[i]));
}
function zq(t, e, i, s) {
  return B5(e, i, s)(t);
}
ar.PIPE_TYPE = C2;
ar.createPipe = B5;
ar.pipe = zq;
class Vq extends uu {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var i, s, c;
    const {
      repeat: p,
      ...h
    } = oR(e);
    this._blockOpts = Object.assign({}, this._blockOpts, h);
    const y = yb(this._blockOpts);
    this.repeat = (i = (s = p ?? y.repeat) != null ? s : this.repeat) != null ? i : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((c = this._blocks) == null ? void 0 : c.length) || 0, this.repeatFrom)),
      blocks: {
        m: y
      },
      eager: y.eager,
      overwrite: y.overwrite,
      skipInvalid: y.skipInvalid,
      lazy: y.lazy,
      placeholderChar: y.placeholderChar,
      displayChar: y.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo) return this._blocks.push(yb(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, i) {
    i === void 0 && (i = {});
    const s = new gr();
    for (let w = (c = (p = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : p.index) != null ? c : Math.max(this._blocks.length - 1, 0), x, E;
    // try to get a block or
    // try to allocate a new block if not allocated already
    x = (h = this._blocks[w]) != null ? h : E = !E && this._allocateBlock(w); ++w) {
      var c, p, h, y;
      const C = x._appendChar(e, {
        ...i,
        _beforeTailState: (y = i._beforeTailState) == null || (y = y._blocks) == null ? void 0 : y[w]
      });
      if (C.skip && E) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (s.aggregate(C), C.consumed) break;
    }
    return s;
  }
  _trimEmptyTail(e, i) {
    var s, c;
    e === void 0 && (e = 0);
    const p = Math.max(((s = this._mapPosToBlock(e)) == null ? void 0 : s.index) || 0, this.repeatFrom, 0);
    let h;
    i != null && (h = (c = this._mapPosToBlock(i)) == null ? void 0 : c.index), h == null && (h = this._blocks.length - 1);
    let y = 0;
    for (let w = h; p <= w && !this._blocks[w].unmaskedValue; --w, ++y);
    y && (this._blocks.splice(h - y + 1, y), this.mask = this.mask.slice(y));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, i) {
    e === void 0 && (e = 0), i === void 0 && (i = this.displayValue.length);
    const s = super.remove(e, i);
    return this._trimEmptyTail(e, i), s;
  }
  totalInputPositions(e, i) {
    return e === void 0 && (e = 0), i == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, i);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
ar.RepeatBlock = Vq;
try {
  globalThis.IMask = ar;
} catch {}
const Bq = Qn(({
  id: t,
  label: e,
  name: i,
  helperText: s,
  errorMessage: c,
  readOnly: p,
  required: h,
  disabled: y,
  labels: w,
  enableClearButton: x,
  displayClearLabel: E,
  iconOptions: C,
  isLoading: k = !1,
  loaderConfig: D,
  maskOptions: I,
  value: L = "",
  onAccept: P,
  className: N,
  classNames: O,
  children: F,
  // Catch-all prop for anything not exclusively specified
  ...j
}, V) => {
  const K = vt(null),
    G = vt(null),
    [Q, te] = rt(""),
    [ie, Y] = rt(""),
    [ee, ae] = rt(),
    [ne, le] = rt(!1);
  let ce = !0;
  const W = pn((ue, Ee = !1) => {
      var Ce;
      G.current && (P == null || P(G.current, Ee));
      const fe = ((Ce = ue == null ? void 0 : ue.target) == null ? void 0 : Ce.value) ?? "";
      (ue == null ? void 0 : ue.inputType) === "deleteContentBackward" ? te(fe === ie ? "" : fe) : te(fe);
    }, [ie, P]),
    $ = ue => {
      G.current && G.current.unmaskedValue !== ue && (G.current.unmaskedValue = ue, te(ue));
    },
    de = ue => {
      switch (ue == null ? void 0 : ue.mask) {
        case Number:
        case "MaskedNumber":
          ue.mask = id;
          break;
        case Date:
        case "MaskedDate":
          ue.mask = qv;
          break;
        case "MaskedDynamic":
          ue.mask = zR;
          break;
        case "MaskedEnum":
          ue.mask = VR;
          break;
        case "MaskedFunction":
          ue.mask = z5;
          break;
        case "MaskedPattern":
          ue.mask = uu;
          break;
        case "MaskedRange":
          ue.mask = VT;
          break;
        case RegExp:
        case "MaskedRegExp":
          ue.mask = N5;
          break;
      }
      return ue;
    },
    H = ue => (ue = de(ue), "blocks" in ue && ue != null && ue.blocks && typeof ue.blocks == "object" && (ue.blocks = Object.fromEntries(Object.entries(ue.blocks).map(([Ee, Ce]) => ("mask" in Ce && (Ce = de(Ce)), [Ee, Ce])))), "definitions" in ue && ue != null && ue.definitions && typeof ue.definitions == "object" && (ue.definitions = Object.fromEntries(Object.entries(ue.definitions).map(([Ee, Ce]) => ("mask" in Ce && (Ce = de(Ce)), [Ee, Ce])))), ue),
    se = async ue => {
      if (!I) ce = !1;else try {
        I = H(I);
        const Ee = ar(ue, I);
        G.current = Ee;
        let Ce = !0;
        Ee.on("accept", fe => {
          Ce || W(fe, !1);
        }), Ee.on("complete", fe => {
          Ce || W(fe, !0);
        }), L && Ee.unmaskedValue !== L ? (Ee.unmaskedValue = L, te(L)) : te(Ee.unmaskedValue), Y(Ee.value), Ce = !1;
      } catch (Ee) {
        console.error("[MaskedInput] Failed to initialize IMask:", Ee), ce = !1;
      }
    };
  return Rt(() => {
    Q && (I != null && I.lazy || Q !== ie && !(I != null && I.lazy)) ? ae(!0) : ae(!1);
  }, [Q, ie, I == null ? void 0 : I.lazy]), Rt(() => {
    le(!0);
  }, []), Rt(() => {
    if (!(!ne || !K.current || G.current)) return se(K.current), () => {
      G.current && (G.current.destroy(), G.current = null);
    };
  }, [ne]), jR(V, () => K.current, []), ne ? /* @__PURE__ */we.jsx(we.Fragment, {
    children: /* @__PURE__ */we.jsx(O5, {
      type: "text",
      id: t,
      label: e || "<Label is required>",
      name: i,
      helperText: s,
      errorMessage: c,
      readOnly: p,
      required: h,
      disabled: y,
      labels: w,
      enableClearButton: x,
      displayClearLabel: E,
      ref: K,
      iconOptions: C,
      isLoading: k,
      loaderConfig: D,
      isMasked: ce,
      isMaskedValue: ee,
      maskedPattern: ie,
      onMaskUpdate: $,
      className: N,
      classNames: O,
      children: F,
      ...j
    })
  }) : null;
});
var wV = {
  exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var _V;
function Uq() {
  return _V || (_V = 1, function (t) {
    (function () {
      var e = {}.hasOwnProperty;
      function i() {
        for (var p = "", h = 0; h < arguments.length; h++) {
          var y = arguments[h];
          y && (p = c(p, s(y)));
        }
        return p;
      }
      function s(p) {
        if (typeof p == "string" || typeof p == "number") return p;
        if (typeof p != "object") return "";
        if (Array.isArray(p)) return i.apply(null, p);
        if (p.toString !== Object.prototype.toString && !p.toString.toString().includes("[native code]")) return p.toString();
        var h = "";
        for (var y in p) e.call(p, y) && p[y] && (h = c(h, y));
        return h;
      }
      function c(p, h) {
        return h ? p ? p + " " + h : p + h : p;
      }
      t.exports ? (i.default = i, t.exports = i) : window.classNames = i;
    })();
  }(wV)), wV.exports;
}
var Hq = Uq();
const vs = /* @__PURE__ */sH(Hq),
  pN = "RovingFocusGroup",
  [k2, U5, $q] = fH(pN),
  [Wq, GL] = LE(pN, [$q]),
  [qq, Yq] = Wq(pN),
  Gq = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
function Xq(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Kq(t, e, i) {
  const s = Xq(t.key, i);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(s)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(s))) return Gq[s];
}
function H5(t, e = !1) {
  const i = document.activeElement;
  for (const s of t) if (s === i || (s.focus({
    preventScroll: e
  }), document.activeElement !== i)) return;
}
function Qq(t, e) {
  return t.map((i, s) => t[(e + s) % t.length]);
}
const hj = "rovingFocusGroup.onEntryFocus",
  Zq = {
    bubbles: !1,
    cancelable: !0
  },
  Jq = "RovingFocusGroup",
  eY = "RovingFocusGroupItem",
  tY = Nt.forwardRef((t, e) => {
    const {
        __scopeRovingFocusGroup: i,
        orientation: s,
        loop: c = !1,
        dir: p,
        currentTabStopId: h,
        defaultCurrentTabStopId: y,
        onCurrentTabStopIdChange: w,
        onEntryFocus: x,
        preventScrollOnEntryFocus: E = !1,
        ...C
      } = t,
      k = vt(null),
      D = _E(e, k),
      I = dN(p),
      [L, P] = PE({
        prop: h,
        defaultProp: y ?? null,
        onChange: w
      }),
      [N, O] = rt(!1),
      F = R7(x),
      j = U5(i),
      V = Nt.useRef(!1),
      [K, G] = rt(0),
      Q = pn(ae => P(ae), [P]),
      te = pn(() => O(!0), []),
      ie = pn(() => G(ae => ae + 1), []),
      Y = pn(() => G(ae => ae - 1), []),
      ee = zp(t.onFocus, ae => {
        const ne = !V.current;
        if (ae.target === ae.currentTarget && ne && !N) {
          const le = new CustomEvent(hj, Zq);
          if (ae.currentTarget.dispatchEvent(le), !le.defaultPrevented) {
            const ce = j().filter(H => H.focusable),
              W = ce.find(H => H.active),
              $ = ce.find(H => H.id === L),
              de = [W, $, ...ce].filter(Boolean).map(H => H.ref.current);
            H5(de, E);
          }
        }
        V.current = !1;
      });
    return Rt(() => {
      const ae = k.current;
      if (ae) return ae.addEventListener(hj, F), () => ae.removeEventListener(hj, F);
    }, [F]), /* @__PURE__ */we.jsx(qq, {
      scope: i,
      orientation: s,
      dir: I,
      loop: c,
      currentTabStopId: L,
      onItemFocus: Q,
      onItemShiftTab: te,
      onFocusableItemAdd: ie,
      onFocusableItemRemove: Y,
      children: /* @__PURE__ */we.jsx(la.div, {
        tabIndex: N || K === 0 ? -1 : 0,
        "data-orientation": s,
        ...C,
        ref: D,
        style: {
          outline: "none",
          ...t.style
        },
        onMouseDown: zp(t.onMouseDown, () => {
          V.current = !0;
        }),
        onFocus: ee,
        onBlur: zp(t.onBlur, () => O(!1))
      })
    });
  }),
  $5 = Qn((t, e) => {
    const {
        __scopeRovingFocusGroup: i,
        focusable: s = !0,
        active: c = !1,
        tabStopId: p,
        children: h,
        ...y
      } = t,
      w = ME(),
      x = p || w,
      E = Yq(eY, i),
      C = E.currentTabStopId === x,
      k = U5(i),
      {
        onFocusableItemAdd: D,
        onFocusableItemRemove: I,
        currentTabStopId: L
      } = E;
    return Rt(() => {
      if (s) return D(), () => I();
    }, [s, D, I]), /* @__PURE__ */we.jsx(k2.ItemSlot, {
      scope: i,
      id: x,
      focusable: s,
      active: c,
      children: /* @__PURE__ */we.jsx(la.span, {
        tabIndex: C ? 0 : -1,
        "data-orientation": E.orientation,
        ...y,
        ref: e,
        onMouseDown: zp(t.onMouseDown, P => {
          s ? E.onItemFocus(x) : P.preventDefault();
        }),
        onFocus: zp(t.onFocus, () => E.onItemFocus(x)),
        onKeyDown: zp(t.onKeyDown, P => {
          if (P.key === "Tab" && P.shiftKey) {
            E.onItemShiftTab();
            return;
          }
          if (P.target !== P.currentTarget) return;
          const N = Kq(P, E.orientation, E.dir);
          if (N !== void 0) {
            if (P.metaKey || P.ctrlKey || P.altKey || P.shiftKey) return;
            P.preventDefault();
            let O = k().filter(F => F.focusable).map(F => F.ref.current);
            if (N === "last") O.reverse();else if (N === "prev" || N === "next") {
              N === "prev" && O.reverse();
              const F = O.indexOf(P.currentTarget);
              O = E.loop ? Qq(O, F + 1) : O.slice(F + 1);
            }
            setTimeout(() => H5(O));
          }
        }),
        children: typeof h == "function" ? h({
          isCurrentTabStop: C,
          hasTabStop: L != null
        }) : h
      })
    });
  }),
  hN = Qn((t, e) => /* @__PURE__ */we.jsx(k2.Provider, {
    scope: t.__scopeRovingFocusGroup,
    children: /* @__PURE__ */we.jsx(k2.Slot, {
      scope: t.__scopeRovingFocusGroup,
      children: /* @__PURE__ */we.jsx(tY, {
        ...t,
        ref: e
      })
    })
  }));
hN.displayName = Jq;
const mN = "NavList",
  [nY, I_e] = LE(mN, [GL]),
  W5 = GL(),
  [rY, iY] = nY(mN),
  aY = Qn((t, e) => {
    const {
        __scopeNavList: i,
        disabled: s,
        value: c,
        ...p
      } = t,
      h = iY(mN, i),
      y = W5(i),
      w = c === h.value;
    return /* @__PURE__ */we.jsx($5, {
      asChild: !0,
      ...y,
      focusable: !s,
      children: /* @__PURE__ */we.jsx(la.a, {
        href: `#${c}`,
        "data-state": w ? "active" : "inactive",
        ...p,
        onMouseDown: zp(t.onMouseDown, x => {
          !s && x.button === 0 && x.ctrlKey === !1 ? h.onValueChange(c) : x.preventDefault();
        }),
        onKeyDown: zp(t.onKeyDown, x => {
          [" ", "Enter"].includes(x.key) && h.onValueChange(c);
        }),
        ref: e
      })
    });
  }),
  oY = Qn((t, e) => {
    const {
        __scopeNavList: i,
        value: s,
        onValueChange: c,
        defaultValue: p,
        loop: h = !0,
        dir: y,
        orientation: w,
        ...x
      } = t,
      E = W5(i),
      [C, k] = PE({
        prop: s,
        onChange: c,
        defaultProp: p ?? ""
      });
    return /* @__PURE__ */we.jsx(rY, {
      scope: i,
      baseId: ME(),
      value: C,
      onValueChange: k,
      orientation: "horizontal",
      dir: "ltr",
      children: /* @__PURE__ */we.jsx(hN, {
        asChild: !0,
        ...E,
        orientation: w,
        dir: y,
        loop: h,
        children: /* @__PURE__ */we.jsx(la.nav, {
          ...x,
          ref: e
        })
      })
    });
  }),
  lY = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected "{{ label }}"',
    a11yUnselectedLiveRegion: "No selected options",
    clearAll: "Clear All"
  },
  sY = Qn(({
    id: t,
    isLoading: e = !1,
    data: i = [],
    values: s,
    initialSelectedItem: c,
    onSelectChange: p,
    iconOptions: h,
    isAutoCloseMenu: y = !1,
    environment: w,
    children: x,
    className: E,
    classNames: C,
    valueClassName: k,
    iconClassName: D,
    onFocus: I = () => {},
    onBlur: L = () => {},
    handleClearAll: P = () => {},
    resetTrigger: N,
    onOpenDropdown: O,
    label: F,
    labels: j = {},
    onReset: V = () => {},
    clearAllOption: K = !0,
    isDisabled: G = !1,
    errorMessage: Q,
    helperText: te,
    renderCustomListItem: ie,
    loaderConfig: Y
  }, ee) => {
    const ae = {
        ...lY,
        ...j
      },
      ne = vt(null),
      le = vt(null),
      [ce, W] = rt(!1),
      [$, de] = rt(""),
      [H, se] = rt(""),
      ue = vt(null),
      Ee = typeof window < "u",
      [Ce, fe] = rt(),
      _e = (Lt, Et) => {
        const {
            type: Vt,
            changes: Xt
          } = Et,
          vn = [jp.stateChangeTypes.MenuMouseLeave, jp.stateChangeTypes.ToggleButtonKeyDownEscape, jp.stateChangeTypes.FunctionCloseMenu];
        return Vt === jp.stateChangeTypes.ToggleButtonClick ? Xt : !vn.includes(Vt) && !y && Xt.isOpen === !1 ? {
          ...Xt,
          isOpen: !0
        } : Xt;
      },
      Se = Lt => Lt ? Lt.label ?? "" : "",
      be = ci(() => i ? i.reduce((Lt, Et) => {
        Et.title && Lt.push({
          title: Et.title,
          label: Et.title,
          value: Et.title,
          isGroupTitle: !0
        });
        const Vt = Et.items.filter(Xt => Xt.label !== Et.title);
        return Lt.push(...Vt), Lt;
      }, []) : [], [i]),
      Le = ci(() => be.filter(Lt => Lt.title || Lt.isGroupTitle).length <= 1 ? be.filter(Lt => !Lt.isGroupTitle && !Lt.title) : be, [i]),
      Be = Lt => (s || []).some(Et => Et.value === Lt.value),
      Xe = Lt => {
        const Et = i.find(Xt => Xt.title === Lt);
        if (!Et) return !1;
        const Vt = Et.items.filter(Xt => Xt.label !== Et.title);
        return Vt.length === 0 ? !1 : Vt.every(Xt => (s || []).some(vn => vn.value === Xt.value));
      },
      ge = (Lt = "") => {
        var Et;
        const Vt = (s || []).filter(We => We.countryName || We.isGroupTitle);
        if (Vt.length === 0) return Lt;
        if (Vt.length === 1) return (Et = Vt[0]) == null ? void 0 : Et.label;
        const Xt = Vt.filter(We => We.isGroupTitle),
          vn = Vt.filter(We => !We.isGroupTitle),
          ot = Xt.filter(We => !vn.some(ht => ht.countryName === We.title));
        return `${F} (${ot.length + vn.length})`;
      },
      {
        isOpen: qe,
        closeMenu: Ae,
        selectItem: Mt,
        highlightedIndex: Ft,
        setHighlightedIndex: un,
        getMenuProps: gt,
        getToggleButtonProps: Pt,
        getItemProps: St
      } = jp({
        id: t,
        labelId: t,
        stateReducer: _e,
        items: Le,
        itemToString: Se,
        selectedItem: null,
        // Prevents single select behaviour
        onIsOpenChange: Lt => {
          var Et;
          const Vt = Ee ? window.matchMedia(`(max-width: ${nd.breakpoint.sm.value})`).matches : !1;
          Lt.isOpen ? I == null || I() : (L == null || L(), (Et = ne.current) == null || Et.focus()), Lt.isOpen && Vt && le != null && le.current ? ($L(le.current), O == null || O(le.current)) : le.current && aR(le.current);
        },
        onSelectedItemChange: Lt => {
          var Et, Vt;
          Lt.selectedItem && (p == null || p(Lt.selectedItem));
          const Xt = Le.findIndex(vn => {
            var ot;
            return vn.value === ((ot = Lt.selectedItem) == null ? void 0 : ot.value);
          });
          fe(Xt), Lt.type !== "__function_select_item__" && ((Et = Lt.selectedItem) == null ? void 0 : Et.value) !== (c == null ? void 0 : c.value) && (W(!0), (Vt = ne.current) == null || Vt.focus(), Lt.isOpen && !y && un(Ft));
        },
        environment: w ? {
          addEventListener: w.addEventListener.bind(w),
          removeEventListener: w.removeEventListener.bind(w),
          document: w != null && w.document ? w.document : document,
          Node: w.Node
        } : Ee ? window : void 0
      }),
      Dt = pn(Lt => {
        var Et, Vt;
        if (le) {
          if ((Et = le.current) != null && Et.contains(Lt == null ? void 0 : Lt.target) || ne && (Vt = ne.current) != null && Vt.contains(Lt == null ? void 0 : Lt.target)) return;
          Ae(), W(!1);
        }
      }, [Ae]),
      Kt = Lt => {
        var Et;
        const Vt = be.filter(ot => ot.title || ot.isGroupTitle).length;
        let Xt = -1;
        const vn = (ot, We) => {
          const ht = Be(ot),
            Ke = ot.isGroupTitle || !!ot.title,
            yt = Ke ? Xe(ot.title || ot.label || "") : !1,
            je = {
              item: ot,
              index: We,
              className: Ze(Vn.item, C == null ? void 0 : C.listItem, ht && (C == null ? void 0 : C.itemSelected), Ke && [Vn.group, C == null ? void 0 : C.itemGroup, C == null ? void 0 : C.listHeading], Ke && yt && Vn.groupSelected, Ft === We && [Vn.highlighted, C == null ? void 0 : C.itemActive], ot.disabled && [Vn.disabled, C == null ? void 0 : C.itemDisabled], ot.className),
              "aria-selected": ht || Ke && yt,
              "aria-disabled": ot.disabled ? !0 : void 0,
              onClick: at => {
                at.stopPropagation();
              }
            };
          if (ie) {
            const at = ie(`item-${We}`, ot, St, je);
            return /* @__PURE__ */we.jsx(Nt.Fragment, {
              children: at
            }, `item-${We}`);
          }
          return /* @__PURE__ */we.jsx("li", {
            ...St(je),
            children: ot.title ? ot.title : Se(ot)
          }, `item-${We}`);
        };
        return Vt > 1 ? /* @__PURE__ */we.jsx("ul", {
          role: "group",
          "aria-labelledby": `${t}-group`,
          className: Ze(Vn.list),
          children: be.map(ot => (Xt++, vn(ot, Xt)))
        }) : /* @__PURE__ */we.jsxs("ul", {
          role: "group",
          "aria-labelledby": `${t}-group`,
          className: Ze(Vn.list),
          children: [((Et = be[0]) == null ? void 0 : Et.title) && /* @__PURE__ */we.jsx("div", {
            className: Ze(Vn.group, C == null ? void 0 : C.listHeading),
            id: `${t}-group-0`,
            children: be[0].title
          }), Lt.map(ot => (Xt++, vn(ot, Xt)))]
        });
      },
      hn = () => {
        P(), V == null || V();
      };
    return Rt(() => (window.document.addEventListener("mousedown", Dt, !1), () => {
      window.document.removeEventListener("mousedown", Dt, !1);
    }), [Dt]), Rt(() => {
      const Lt = setTimeout(() => {
        se($);
      }, 200);
      return () => clearTimeout(Lt);
    }, [$]), Rt(() => {
      c && Mt(c);
    }, [Mt, c]), Rt(() => {
      N !== void 0 && N > 0 && P();
    }, [N, P]), Rt(() => () => {
      le.current && aR(le.current);
    }, []), Rt(() => {
      de((s == null ? void 0 : s.map(Lt => Lt.label).join(", ")) || "");
    }, [s]), /* @__PURE__ */we.jsx(AE, {
      ref: ee,
      className: Ze(Vn.dropdown, qe && !e && [Vn.dropdownOpen, C == null ? void 0 : C.inputWrapperOpen], (e || (s == null ? void 0 : s.length)) && [Vn.selectedValue, C == null ? void 0 : C.inputWrapperSelected], E, ce && Vn.dropdownFocus),
      classNames: {
        label: Ze(C == null ? void 0 : C.inputLabel),
        helperText: C == null ? void 0 : C.inputHelperText,
        errorText: Ze(!G && Q && (C == null ? void 0 : C.inputErrorText)),
        focus: Ze(ce && (C == null ? void 0 : C.inputWrapperFocus)),
        error: Ze(!G && Q && [Vn.dropdownError, C == null ? void 0 : C.inputWrapperError]),
        disabled: Ze(G && [Vn.dropdownInputDisabled, C == null ? void 0 : C.inputWrapperDisabled])
      },
      errorMessage: Q,
      messageId: `${t}-message`,
      isDisabled: G,
      helperText: te,
      isFocused: ce && !e,
      children: /* @__PURE__ */we.jsxs(we.Fragment, {
        children: [/* @__PURE__ */we.jsxs("button", {
          disabled: G,
          type: "button",
          "aria-label": qe && !e ? ae.a11yCloseMenu : ae.a11yOpenMenu,
          "aria-describedby": te || Q ? `${t}-message` : void 0,
          onFocusCapture: () => {
            W(!0);
          },
          onBlurCapture: () => {
            W(!1);
          },
          className: Ze(Vn.dropdownInput, e && (C == null ? void 0 : C.inputLoader), C == null ? void 0 : C.inputToggleButton),
          ...Pt({
            ref: ne,
            "aria-labelledby": `${t}-label`,
            "aria-activedescendant": Ft !== -1 ? `${t}-item-${Ft}` : Ce != null ? `${t}-item-${Ce}` : void 0,
            onFocus: () => {
              I == null || I();
            },
            onBlur: () => {
              !qe && !G && (L == null || L());
            }
          }),
          children: [/* @__PURE__ */we.jsx("label", {
            id: `${t}-label`,
            children: F
          }), /* @__PURE__ */we.jsx("span", {
            className: Ze(k, Vn.dropdownInputValue, C == null ? void 0 : C.value),
            children: ge()
          }), e && /* @__PURE__ */we.jsx(FE, {
            className: C == null ? void 0 : C.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1,
            ...Y
          }), !G && !e && /* @__PURE__ */we.jsxs("span", {
            "aria-hidden": "true",
            className: Ze(Vn.dropdownIcon, D, C == null ? void 0 : C.icon, Q ? [Vn.dropdownIcon, Vn.dropdownIconError, C == null ? void 0 : C.iconError] : Vn.dropdownIcon),
            ref: ue,
            children: [qe && ((h == null ? void 0 : h.open) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "▲"
            })), !qe && ((h == null ? void 0 : h.close) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "▼"
            }))]
          }), G && /* @__PURE__ */we.jsx("span", {
            "aria-hidden": "true",
            className: Ze(Vn.dropdownIcon, Vn.dropdownIconDisabled, D, C == null ? void 0 : C.icon, C == null ? void 0 : C.iconDisabled),
            children: (h == null ? void 0 : h.disabled) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "×"
            })
          })]
        }), x, /* @__PURE__ */we.jsx("div", {
          id: `${t}-live`,
          className: Vn.srOnly,
          "aria-live": "polite",
          "aria-atomic": "true",
          children: H ? ae.a11ySelectedLiveRegion.replace("{{ label }}", H) : ae.a11yUnselectedLiveRegion
        }), /* @__PURE__ */we.jsxs("div", {
          ...gt({
            ref: le,
            isOpen: qe,
            onBlur: () => {
              var Lt;
              L == null || L(), (Lt = ne.current) == null || Lt.focus();
            },
            onClick: Lt => {
              var Et, Vt;
              const Xt = parseInt((Et = Lt.nativeEvent.target) == null ? void 0 : Et.id.replace(`${t}-group-`, ""), 10);
              if (Xt !== null) {
                let vn = 0;
                ((ot, We) => {
                  var ht;
                  for (let Ke = 0; Ke < We; Ke++) (ht = ot[Ke]) != null && ht.items && (vn += ot[Ke].items.length);
                })(i, Xt), un(vn);
              }
              (Vt = ne.current) == null || Vt.focus();
            },
            role: "listbox",
            "aria-labelledby": void 0,
            "aria-expanded": void 0,
            tabIndex: qe ? 0 : -1
          }),
          className: Ze(Vn.dropdownListbox, qe && !e && [Vn.dropdownListboxOpen, Vn.open], C == null ? void 0 : C.listBox),
          children: [!e && (i.length > 0 && qe ? Kt(Le) : qe ? /* @__PURE__ */we.jsx("li", {
            className: Ze(Vn.noResults, C == null ? void 0 : C.noResults),
            children: ae.noResults
          }) : null), K && qe && /* @__PURE__ */we.jsx("button", {
            type: "button",
            className: Ze(Vn.clearAllBtn, C == null ? void 0 : C.clearAllBtn),
            onClick: () => {
              hn(), P();
            },
            children: ae.clearAll
          })]
        })]
      })
    });
  }),
  aM = "all",
  xV = "alert",
  SV = "offer",
  uY = {
    a11yCloseMenu: "Close notifications",
    a11yOpenLiveRegion: 'Showing "{{ filter }}" notifications',
    a11yClosedLiveRegion: "Notifications are hidden",
    a11yMenu: "Notification categories",
    a11yList: "Notifications list"
  };
var oM = {
  exports: {}
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var q5 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"],
  hL = /* @__PURE__ */q5.join(","),
  Y5 = typeof Element > "u",
  Zx = Y5 ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  mL = !Y5 && Element.prototype.getRootNode ? function (t) {
    var e;
    return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
  } : function (t) {
    return t == null ? void 0 : t.ownerDocument;
  },
  vL = function t(e, i) {
    var s;
    i === void 0 && (i = !0);
    var c = e == null || (s = e.getAttribute) === null || s === void 0 ? void 0 : s.call(e, "inert"),
      p = c === "" || c === "true",
      h = p || i && e && t(e.parentNode);
    return h;
  },
  cY = function (t) {
    var e,
      i = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
    return i === "" || i === "true";
  },
  G5 = function (t, e, i) {
    if (vL(t)) return [];
    var s = Array.prototype.slice.apply(t.querySelectorAll(hL));
    return e && Zx.call(t, hL) && s.unshift(t), s = s.filter(i), s;
  },
  X5 = function t(e, i, s) {
    for (var c = [], p = Array.from(e); p.length;) {
      var h = p.shift();
      if (!vL(h, !1)) if (h.tagName === "SLOT") {
        var y = h.assignedElements(),
          w = y.length ? y : h.children,
          x = t(w, !0, s);
        s.flatten ? c.push.apply(c, x) : c.push({
          scopeParent: h,
          candidates: x
        });
      } else {
        var E = Zx.call(h, hL);
        E && s.filter(h) && (i || !e.includes(h)) && c.push(h);
        var C = h.shadowRoot ||
          // check for an undisclosed shadow
          typeof s.getShadowRoot == "function" && s.getShadowRoot(h),
          k = !vL(C, !1) && (!s.shadowRootFilter || s.shadowRootFilter(h));
        if (C && k) {
          var D = t(C === !0 ? h.children : C.children, !0, s);
          s.flatten ? c.push.apply(c, D) : c.push({
            scopeParent: h,
            candidates: D
          });
        } else p.unshift.apply(p, h.children);
      }
    }
    return c;
  },
  K5 = function (t) {
    return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
  },
  K0 = function (t) {
    if (!t) throw new Error("No node provided");
    return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || cY(t)) && !K5(t) ? 0 : t.tabIndex;
  },
  dY = function (t, e) {
    var i = K0(t);
    return i < 0 && e && !K5(t) ? 0 : i;
  },
  fY = function (t, e) {
    return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
  },
  Q5 = function (t) {
    return t.tagName === "INPUT";
  },
  pY = function (t) {
    return Q5(t) && t.type === "hidden";
  },
  hY = function (t) {
    var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function (i) {
      return i.tagName === "SUMMARY";
    });
    return e;
  },
  mY = function (t, e) {
    for (var i = 0; i < t.length; i++) if (t[i].checked && t[i].form === e) return t[i];
  },
  vY = function (t) {
    if (!t.name) return !0;
    var e = t.form || mL(t),
      i = function (p) {
        return e.querySelectorAll('input[type="radio"][name="' + p + '"]');
      },
      s;
    if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") s = i(window.CSS.escape(t.name));else try {
      s = i(t.name);
    } catch (p) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", p.message), !1;
    }
    var c = mY(s, t.form);
    return !c || c === t;
  },
  gY = function (t) {
    return Q5(t) && t.type === "radio";
  },
  yY = function (t) {
    return gY(t) && !vY(t);
  },
  bY = function (t) {
    var e,
      i = t && mL(t),
      s = (e = i) === null || e === void 0 ? void 0 : e.host,
      c = !1;
    if (i && i !== t) {
      var p, h, y;
      for (c = !!((p = s) !== null && p !== void 0 && (h = p.ownerDocument) !== null && h !== void 0 && h.contains(s) || t != null && (y = t.ownerDocument) !== null && y !== void 0 && y.contains(t)); !c && s;) {
        var w, x, E;
        i = mL(s), s = (w = i) === null || w === void 0 ? void 0 : w.host, c = !!((x = s) !== null && x !== void 0 && (E = x.ownerDocument) !== null && E !== void 0 && E.contains(s));
      }
    }
    return c;
  },
  EV = function (t) {
    var e = t.getBoundingClientRect(),
      i = e.width,
      s = e.height;
    return i === 0 && s === 0;
  },
  wY = function (t, e) {
    var i = e.displayCheck,
      s = e.getShadowRoot;
    if (getComputedStyle(t).visibility === "hidden") return !0;
    var c = Zx.call(t, "details>summary:first-of-type"),
      p = c ? t.parentElement : t;
    if (Zx.call(p, "details:not([open]) *")) return !0;
    if (!i || i === "full" || i === "legacy-full") {
      if (typeof s == "function") {
        for (var h = t; t;) {
          var y = t.parentElement,
            w = mL(t);
          if (y && !y.shadowRoot && s(y) === !0) return EV(t);
          t.assignedSlot ? t = t.assignedSlot : !y && w !== t.ownerDocument ? t = w.host : t = y;
        }
        t = h;
      }
      if (bY(t)) return !t.getClientRects().length;
      if (i !== "legacy-full") return !0;
    } else if (i === "non-zero-area") return EV(t);
    return !1;
  },
  _Y = function (t) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName)) for (var e = t.parentElement; e;) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var i = 0; i < e.children.length; i++) {
          var s = e.children.item(i);
          if (s.tagName === "LEGEND") return Zx.call(e, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
    return !1;
  },
  gL = function (t, e) {
    return !(e.disabled ||
    // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    vL(e) || pY(e) || wY(e, t) ||
    // For a details element with a summary, the summary element gets the focus
    hY(e) || _Y(e));
  },
  T2 = function (t, e) {
    return !(yY(e) || K0(e) < 0 || !gL(t, e));
  },
  xY = function (t) {
    var e = parseInt(t.getAttribute("tabindex"), 10);
    return !!(isNaN(e) || e >= 0);
  },
  SY = function t(e) {
    var i = [],
      s = [];
    return e.forEach(function (c, p) {
      var h = !!c.scopeParent,
        y = h ? c.scopeParent : c,
        w = dY(y, h),
        x = h ? t(c.candidates) : y;
      w === 0 ? h ? i.push.apply(i, x) : i.push(y) : s.push({
        documentOrder: p,
        tabIndex: w,
        item: c,
        isScope: h,
        content: x
      });
    }), s.sort(fY).reduce(function (c, p) {
      return p.isScope ? c.push.apply(c, p.content) : c.push(p.content), c;
    }, []).concat(i);
  },
  Z5 = function (t, e) {
    e = e || {};
    var i;
    return e.getShadowRoot ? i = X5([t], e.includeContainer, {
      filter: T2.bind(null, e),
      flatten: !1,
      getShadowRoot: e.getShadowRoot,
      shadowRootFilter: xY
    }) : i = G5(t, e.includeContainer, T2.bind(null, e)), SY(i);
  },
  J5 = function (t, e) {
    e = e || {};
    var i;
    return e.getShadowRoot ? i = X5([t], e.includeContainer, {
      filter: gL.bind(null, e),
      flatten: !0,
      getShadowRoot: e.getShadowRoot
    }) : i = G5(t, e.includeContainer, gL.bind(null, e)), i;
  },
  zx = function (t, e) {
    if (e = e || {}, !t) throw new Error("No node provided");
    return Zx.call(t, hL) === !1 ? !1 : T2(e, t);
  },
  EY = /* @__PURE__ */q5.concat("iframe").join(","),
  BM = function (t, e) {
    if (e = e || {}, !t) throw new Error("No node provided");
    return Zx.call(t, EY) === !1 ? !1 : gL(e, t);
  };
const CY = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
  __proto__: null,
  focusable: J5,
  getTabIndex: K0,
  isFocusable: BM,
  isTabbable: zx,
  tabbable: Z5
}, Symbol.toStringTag, {
  value: "Module"
}));
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function R2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var i = 0, s = Array(e); i < e; i++) s[i] = t[i];
  return s;
}
function kY(t) {
  if (Array.isArray(t)) return R2(t);
}
function TY(t, e, i) {
  return (e = LY(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function RY(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function DY() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CV(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    e && (s = s.filter(function (c) {
      return Object.getOwnPropertyDescriptor(t, c).enumerable;
    })), i.push.apply(i, s);
  }
  return i;
}
function kV(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CV(Object(i), !0).forEach(function (s) {
      TY(t, s, i[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : CV(Object(i)).forEach(function (s) {
      Object.defineProperty(t, s, Object.getOwnPropertyDescriptor(i, s));
    });
  }
  return t;
}
function IY(t) {
  return kY(t) || RY(t) || OY(t) || DY();
}
function MY(t, e) {
  if (typeof t != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var s = i.call(t, e);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function LY(t) {
  var e = MY(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function OY(t, e) {
  if (t) {
    if (typeof t == "string") return R2(t, e);
    var i = {}.toString.call(t).slice(8, -1);
    return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? R2(t, e) : void 0;
  }
}
var TV = {
    activateTrap: function (t, e) {
      if (t.length > 0) {
        var i = t[t.length - 1];
        i !== e && i._setPausedState(!0);
      }
      var s = t.indexOf(e);
      s === -1 || t.splice(s, 1), t.push(e);
    },
    deactivateTrap: function (t, e) {
      var i = t.indexOf(e);
      i !== -1 && t.splice(i, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
    }
  },
  PY = function (t) {
    return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
  },
  AY = function (t) {
    return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
  },
  BT = function (t) {
    return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
  },
  jY = function (t) {
    return BT(t) && !t.shiftKey;
  },
  FY = function (t) {
    return BT(t) && t.shiftKey;
  },
  RV = function (t) {
    return setTimeout(t, 0);
  },
  yT = function (t) {
    for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), s = 1; s < e; s++) i[s - 1] = arguments[s];
    return typeof t == "function" ? t.apply(void 0, i) : t;
  },
  lM = function (t) {
    return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
  },
  NY = [],
  zY = function (t, e) {
    var i = (e == null ? void 0 : e.document) || document,
      s = (e == null ? void 0 : e.trapStack) || NY,
      c = kV({
        returnFocusOnDeactivate: !0,
        escapeDeactivates: !0,
        delayInitialFocus: !0,
        isKeyForward: jY,
        isKeyBackward: FY
      }, e),
      p = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        manuallyPaused: !1,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: void 0
      },
      h,
      y = function (Y, ee, ae) {
        return Y && Y[ee] !== void 0 ? Y[ee] : c[ae || ee];
      },
      w = function (Y, ee) {
        var ae = typeof (ee == null ? void 0 : ee.composedPath) == "function" ? ee.composedPath() : void 0;
        return p.containerGroups.findIndex(function (ne) {
          var le = ne.container,
            ce = ne.tabbableNodes;
          return le.contains(Y) || (
          // fall back to explicit tabbable search which will take into consideration any
          //  web components if the `tabbableOptions.getShadowRoot` option was used for
          //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
          //  look inside web components even if open)
          ae == null ? void 0 : ae.includes(le)) || ce.find(function (W) {
            return W === Y;
          });
        });
      },
      x = function (Y) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
          ae = ee.hasFallback,
          ne = ae === void 0 ? !1 : ae,
          le = ee.params,
          ce = le === void 0 ? [] : le,
          W = c[Y];
        if (typeof W == "function" && (W = W.apply(void 0, IY(ce))), W === !0 && (W = void 0), !W) {
          if (W === void 0 || W === !1) return W;
          throw new Error("`".concat(Y, "` was specified but was not a node, or did not return a node"));
        }
        var $ = W;
        if (typeof W == "string") {
          try {
            $ = i.querySelector(W);
          } catch (de) {
            throw new Error("`".concat(Y, '` appears to be an invalid selector; error="').concat(de.message, '"'));
          }
          if (!$ && !ne) throw new Error("`".concat(Y, "` as selector refers to no known node"));
        }
        return $;
      },
      E = function () {
        var Y = x("initialFocus", {
          hasFallback: !0
        });
        if (Y === !1) return !1;
        if (Y === void 0 || Y && !BM(Y, c.tabbableOptions)) {
          if (w(i.activeElement) >= 0) Y = i.activeElement;else {
            var ee = p.tabbableGroups[0],
              ae = ee && ee.firstTabbableNode;
            Y = ae || x("fallbackFocus");
          }
        } else Y === null && (Y = x("fallbackFocus"));
        if (!Y) throw new Error("Your focus-trap needs to have at least one focusable element");
        return Y;
      },
      C = function () {
        if (p.containerGroups = p.containers.map(function (Y) {
          var ee = Z5(Y, c.tabbableOptions),
            ae = J5(Y, c.tabbableOptions),
            ne = ee.length > 0 ? ee[0] : void 0,
            le = ee.length > 0 ? ee[ee.length - 1] : void 0,
            ce = ae.find(function (de) {
              return zx(de);
            }),
            W = ae.slice().reverse().find(function (de) {
              return zx(de);
            }),
            $ = !!ee.find(function (de) {
              return K0(de) > 0;
            });
          return {
            container: Y,
            tabbableNodes: ee,
            focusableNodes: ae,
            /** True if at least one node with positive `tabindex` was found in this container. */
            posTabIndexesFound: $,
            /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
            firstTabbableNode: ne,
            /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
            lastTabbableNode: le,
            // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
            //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
            //  because that API doesn't work with Shadow DOM as well as it should (@see
            //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
            //  to address an edge case related to positive tabindex support, this seems like a much easier,
            //  "close enough most of the time" alternative for positive tabindexes which should generally
            //  be avoided anyway...
            /** First tabbable node in container, __DOM__ order; `undefined` if none. */
            firstDomTabbableNode: ce,
            /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
            lastDomTabbableNode: W,
            /**
             * Finds the __tabbable__ node that follows the given node in the specified direction,
             *  in this container, if any.
             * @param {HTMLElement} node
             * @param {boolean} [forward] True if going in forward tab order; false if going
             *  in reverse.
             * @returns {HTMLElement|undefined} The next tabbable node, if any.
             */
            nextTabbableNode: function (de) {
              var H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                se = ee.indexOf(de);
              return se < 0 ? H ? ae.slice(ae.indexOf(de) + 1).find(function (ue) {
                return zx(ue);
              }) : ae.slice(0, ae.indexOf(de)).reverse().find(function (ue) {
                return zx(ue);
              }) : ee[se + (H ? 1 : -1)];
            }
          };
        }), p.tabbableGroups = p.containerGroups.filter(function (Y) {
          return Y.tabbableNodes.length > 0;
        }), p.tabbableGroups.length <= 0 && !x("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (p.containerGroups.find(function (Y) {
          return Y.posTabIndexesFound;
        }) && p.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
      },
      k = function (Y) {
        var ee = Y.activeElement;
        if (ee) return ee.shadowRoot && ee.shadowRoot.activeElement !== null ? k(ee.shadowRoot) : ee;
      },
      D = function (Y) {
        if (Y !== !1 && Y !== k(document)) {
          if (!Y || !Y.focus) {
            D(E());
            return;
          }
          Y.focus({
            preventScroll: !!c.preventScroll
          }), p.mostRecentlyFocusedNode = Y, PY(Y) && Y.select();
        }
      },
      I = function (Y) {
        var ee = x("setReturnFocus", {
          params: [Y]
        });
        return ee || (ee === !1 ? !1 : Y);
      },
      L = function (Y) {
        var ee = Y.target,
          ae = Y.event,
          ne = Y.isBackward,
          le = ne === void 0 ? !1 : ne;
        ee = ee || lM(ae), C();
        var ce = null;
        if (p.tabbableGroups.length > 0) {
          var W = w(ee, ae),
            $ = W >= 0 ? p.containerGroups[W] : void 0;
          if (W < 0) le ? ce = p.tabbableGroups[p.tabbableGroups.length - 1].lastTabbableNode : ce = p.tabbableGroups[0].firstTabbableNode;else if (le) {
            var de = p.tabbableGroups.findIndex(function (fe) {
              var _e = fe.firstTabbableNode;
              return ee === _e;
            });
            if (de < 0 && ($.container === ee || BM(ee, c.tabbableOptions) && !zx(ee, c.tabbableOptions) && !$.nextTabbableNode(ee, !1)) && (de = W), de >= 0) {
              var H = de === 0 ? p.tabbableGroups.length - 1 : de - 1,
                se = p.tabbableGroups[H];
              ce = K0(ee) >= 0 ? se.lastTabbableNode : se.lastDomTabbableNode;
            } else BT(ae) || (ce = $.nextTabbableNode(ee, !1));
          } else {
            var ue = p.tabbableGroups.findIndex(function (fe) {
              var _e = fe.lastTabbableNode;
              return ee === _e;
            });
            if (ue < 0 && ($.container === ee || BM(ee, c.tabbableOptions) && !zx(ee, c.tabbableOptions) && !$.nextTabbableNode(ee)) && (ue = W), ue >= 0) {
              var Ee = ue === p.tabbableGroups.length - 1 ? 0 : ue + 1,
                Ce = p.tabbableGroups[Ee];
              ce = K0(ee) >= 0 ? Ce.firstTabbableNode : Ce.firstDomTabbableNode;
            } else BT(ae) || (ce = $.nextTabbableNode(ee));
          }
        } else ce = x("fallbackFocus");
        return ce;
      },
      P = function (Y) {
        var ee = lM(Y);
        if (!(w(ee, Y) >= 0)) {
          if (yT(c.clickOutsideDeactivates, Y)) {
            h.deactivate({
              // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
              //  which will result in the outside click setting focus to the node
              //  that was clicked (and if not focusable, to "nothing"); by setting
              //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
              //  on activation (or the configured `setReturnFocus` node), whether the
              //  outside click was on a focusable node or not
              returnFocus: c.returnFocusOnDeactivate
            });
            return;
          }
          yT(c.allowOutsideClick, Y) || Y.preventDefault();
        }
      },
      N = function (Y) {
        var ee = lM(Y),
          ae = w(ee, Y) >= 0;
        if (ae || ee instanceof Document) ae && (p.mostRecentlyFocusedNode = ee);else {
          Y.stopImmediatePropagation();
          var ne,
            le = !0;
          if (p.mostRecentlyFocusedNode) {
            if (K0(p.mostRecentlyFocusedNode) > 0) {
              var ce = w(p.mostRecentlyFocusedNode),
                W = p.containerGroups[ce].tabbableNodes;
              if (W.length > 0) {
                var $ = W.findIndex(function (de) {
                  return de === p.mostRecentlyFocusedNode;
                });
                $ >= 0 && (c.isKeyForward(p.recentNavEvent) ? $ + 1 < W.length && (ne = W[$ + 1], le = !1) : $ - 1 >= 0 && (ne = W[$ - 1], le = !1));
              }
            } else p.containerGroups.some(function (de) {
              return de.tabbableNodes.some(function (H) {
                return K0(H) > 0;
              });
            }) || (le = !1);
          } else le = !1;
          le && (ne = L({
            // move FROM the MRU node, not event-related node (which will be the node that is
            //  outside the trap causing the focus escape we're trying to fix)
            target: p.mostRecentlyFocusedNode,
            isBackward: c.isKeyBackward(p.recentNavEvent)
          })), D(ne || p.mostRecentlyFocusedNode || E());
        }
        p.recentNavEvent = void 0;
      },
      O = function (Y) {
        var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        p.recentNavEvent = Y;
        var ae = L({
          event: Y,
          isBackward: ee
        });
        ae && (BT(Y) && Y.preventDefault(), D(ae));
      },
      F = function (Y) {
        (c.isKeyForward(Y) || c.isKeyBackward(Y)) && O(Y, c.isKeyBackward(Y));
      },
      j = function (Y) {
        AY(Y) && yT(c.escapeDeactivates, Y) !== !1 && (Y.preventDefault(), h.deactivate());
      },
      V = function (Y) {
        var ee = lM(Y);
        w(ee, Y) >= 0 || yT(c.clickOutsideDeactivates, Y) || yT(c.allowOutsideClick, Y) || (Y.preventDefault(), Y.stopImmediatePropagation());
      },
      K = function () {
        if (p.active) return TV.activateTrap(s, h), p.delayInitialFocusTimer = c.delayInitialFocus ? RV(function () {
          D(E());
        }) : D(E()), i.addEventListener("focusin", N, !0), i.addEventListener("mousedown", P, {
          capture: !0,
          passive: !1
        }), i.addEventListener("touchstart", P, {
          capture: !0,
          passive: !1
        }), i.addEventListener("click", V, {
          capture: !0,
          passive: !1
        }), i.addEventListener("keydown", F, {
          capture: !0,
          passive: !1
        }), i.addEventListener("keydown", j), h;
      },
      G = function () {
        if (p.active) return i.removeEventListener("focusin", N, !0), i.removeEventListener("mousedown", P, !0), i.removeEventListener("touchstart", P, !0), i.removeEventListener("click", V, !0), i.removeEventListener("keydown", F, !0), i.removeEventListener("keydown", j), h;
      },
      Q = function (Y) {
        var ee = Y.some(function (ae) {
          var ne = Array.from(ae.removedNodes);
          return ne.some(function (le) {
            return le === p.mostRecentlyFocusedNode;
          });
        });
        ee && D(E());
      },
      te = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Q) : void 0,
      ie = function () {
        te && (te.disconnect(), p.active && !p.paused && p.containers.map(function (Y) {
          te.observe(Y, {
            subtree: !0,
            childList: !0
          });
        }));
      };
    return h = {
      get active() {
        return p.active;
      },
      get paused() {
        return p.paused;
      },
      activate: function (Y) {
        if (p.active) return this;
        var ee = y(Y, "onActivate"),
          ae = y(Y, "onPostActivate"),
          ne = y(Y, "checkCanFocusTrap");
        ne || C(), p.active = !0, p.paused = !1, p.nodeFocusedBeforeActivation = k(i), ee == null || ee();
        var le = function () {
          ne && C(), K(), ie(), ae == null || ae();
        };
        return ne ? (ne(p.containers.concat()).then(le, le), this) : (le(), this);
      },
      deactivate: function (Y) {
        if (!p.active) return this;
        var ee = kV({
          onDeactivate: c.onDeactivate,
          onPostDeactivate: c.onPostDeactivate,
          checkCanReturnFocus: c.checkCanReturnFocus
        }, Y);
        clearTimeout(p.delayInitialFocusTimer), p.delayInitialFocusTimer = void 0, G(), p.active = !1, p.paused = !1, ie(), TV.deactivateTrap(s, h);
        var ae = y(ee, "onDeactivate"),
          ne = y(ee, "onPostDeactivate"),
          le = y(ee, "checkCanReturnFocus"),
          ce = y(ee, "returnFocus", "returnFocusOnDeactivate");
        ae == null || ae();
        var W = function () {
          RV(function () {
            ce && D(I(p.nodeFocusedBeforeActivation)), ne == null || ne();
          });
        };
        return ce && le ? (le(I(p.nodeFocusedBeforeActivation)).then(W, W), this) : (W(), this);
      },
      pause: function (Y) {
        return p.active ? (p.manuallyPaused = !0, this._setPausedState(!0, Y)) : this;
      },
      unpause: function (Y) {
        return p.active ? (p.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, Y)) : this;
      },
      updateContainerElements: function (Y) {
        var ee = [].concat(Y).filter(Boolean);
        return p.containers = ee.map(function (ae) {
          return typeof ae == "string" ? i.querySelector(ae) : ae;
        }), p.active && C(), ie(), this;
      }
    }, Object.defineProperties(h, {
      _isManuallyPaused: {
        value: function () {
          return p.manuallyPaused;
        }
      },
      _setPausedState: {
        value: function (Y, ee) {
          if (p.paused === Y) return this;
          if (p.paused = Y, Y) {
            var ae = y(ee, "onPause"),
              ne = y(ee, "onPostPause");
            ae == null || ae(), G(), ie(), ne == null || ne();
          } else {
            var le = y(ee, "onUnpause"),
              ce = y(ee, "onPostUnpause");
            le == null || le(), C(), K(), ie(), ce == null || ce();
          }
          return this;
        }
      }
    }), h.updateContainerElements(t), h;
  };
const VY = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    createFocusTrap: zY
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  BY = /* @__PURE__ */uH(VY),
  UY = /* @__PURE__ */uH(CY);
var DV;
function HY() {
  if (DV) return oM.exports;
  DV = 1;
  function t(G) {
    "@babel/helpers - typeof";

    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (Q) {
      return typeof Q;
    } : function (Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    }, t(G);
  }
  var e, i;
  function s(G, Q) {
    if (!(G instanceof Q)) throw new TypeError("Cannot call a class as a function");
  }
  function c(G, Q) {
    for (var te = 0; te < Q.length; te++) {
      var ie = Q[te];
      ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(G, I(ie.key), ie);
    }
  }
  function p(G, Q, te) {
    return Q && c(G.prototype, Q), Object.defineProperty(G, "prototype", {
      writable: !1
    }), G;
  }
  function h(G, Q, te) {
    return Q = E(Q), y(G, x() ? Reflect.construct(Q, te || [], E(G).constructor) : Q.apply(G, te));
  }
  function y(G, Q) {
    if (Q && (t(Q) == "object" || typeof Q == "function")) return Q;
    if (Q !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return w(G);
  }
  function w(G) {
    if (G === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return G;
  }
  function x() {
    try {
      var G = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch {}
    return (x = function () {
      return !!G;
    })();
  }
  function E(G) {
    return E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    }, E(G);
  }
  function C(G, Q) {
    if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
    G.prototype = Object.create(Q && Q.prototype, {
      constructor: {
        value: G,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(G, "prototype", {
      writable: !1
    }), Q && k(G, Q);
  }
  function k(G, Q) {
    return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (te, ie) {
      return te.__proto__ = ie, te;
    }, k(G, Q);
  }
  function D(G, Q, te) {
    return (Q = I(Q)) in G ? Object.defineProperty(G, Q, {
      value: te,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : G[Q] = te, G;
  }
  function I(G) {
    var Q = L(G, "string");
    return t(Q) == "symbol" ? Q : Q + "";
  }
  function L(G, Q) {
    if (t(G) != "object" || !G) return G;
    var te = G[Symbol.toPrimitive];
    if (te !== void 0) {
      var ie = te.call(G, Q);
      if (t(ie) != "object") return ie;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Q === "string" ? String : Number)(G);
  }
  var P = Nt,
    N = BY,
    O = N.createFocusTrap,
    F = UY,
    j = F.isFocusable,
    V = parseInt((e = (i = /^(\d+)\./.exec(P.version)) === null || i === void 0 ? void 0 : i[1]) !== null && e !== void 0 ? e : 0, 10),
    K = /* @__PURE__ */function (G) {
      function Q(te) {
        var ie;
        s(this, Q), ie = h(this, Q, [te]), D(ie, "getNodeForOption", function (ae) {
          var ne,
            le = (ne = this.internalOptions[ae]) !== null && ne !== void 0 ? ne : this.originalOptions[ae];
          if (typeof le == "function") {
            for (var ce = arguments.length, W = new Array(ce > 1 ? ce - 1 : 0), $ = 1; $ < ce; $++) W[$ - 1] = arguments[$];
            le = le.apply(void 0, W);
          }
          if (le === !0 && (le = void 0), !le) {
            if (le === void 0 || le === !1) return le;
            throw new Error("`".concat(ae, "` was specified but was not a node, or did not return a node"));
          }
          var de = le;
          if (typeof le == "string") {
            var H;
            if (de = (H = this.getDocument()) === null || H === void 0 ? void 0 : H.querySelector(le), !de) throw new Error("`".concat(ae, "` as selector refers to no known node"));
          }
          return de;
        }), ie.handleDeactivate = ie.handleDeactivate.bind(ie), ie.handlePostDeactivate = ie.handlePostDeactivate.bind(ie), ie.handleClickOutsideDeactivates = ie.handleClickOutsideDeactivates.bind(ie), ie.internalOptions = {
          // We need to hijack the returnFocusOnDeactivate option,
          // because React can move focus into the element before we arrived at
          // this lifecycle hook (e.g. with autoFocus inputs). So the component
          // captures the previouslyFocusedElement in componentWillMount,
          // then (optionally) returns focus to it in componentWillUnmount.
          returnFocusOnDeactivate: !1,
          // the rest of these are also related to deactivation of the trap, and we
          //  need to use them and control them as well
          checkCanReturnFocus: null,
          onDeactivate: ie.handleDeactivate,
          onPostDeactivate: ie.handlePostDeactivate,
          // we need to special-case this setting as well so that we can know if we should
          //  NOT return focus if the trap gets auto-deactivated as the result of an
          //  outside click (otherwise, we'll always think we should return focus because
          //  of how we manage that flag internally here)
          clickOutsideDeactivates: ie.handleClickOutsideDeactivates
        }, ie.originalOptions = {
          // because of the above `internalOptions`, we maintain our own flag for
          //  this option, and default it to `true` because that's focus-trap's default
          returnFocusOnDeactivate: !0,
          // because of the above `internalOptions`, we keep these separate since
          //  they're part of the deactivation process which we configure (internally) to
          //  be shared between focus-trap and focus-trap-react
          onDeactivate: null,
          onPostDeactivate: null,
          checkCanReturnFocus: null,
          // the user's setting, defaulted to false since focus-trap defaults this to false
          clickOutsideDeactivates: !1
        };
        var Y = te.focusTrapOptions;
        for (var ee in Y) if (Object.prototype.hasOwnProperty.call(Y, ee)) {
          if (ee === "returnFocusOnDeactivate" || ee === "onDeactivate" || ee === "onPostDeactivate" || ee === "checkCanReturnFocus" || ee === "clickOutsideDeactivates") {
            ie.originalOptions[ee] = Y[ee];
            continue;
          }
          ie.internalOptions[ee] = Y[ee];
        }
        return ie.outsideClick = null, ie.focusTrapElements = te.containerElements || [], ie.updatePreviousElement(), ie;
      }
      return C(Q, G), p(Q, [{
        key: "getDocument",
        value: function () {
          return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
        }
      }, {
        key: "getReturnFocusNode",
        value: function () {
          var te = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
          return te || (te === !1 ? !1 : this.previouslyFocusedElement);
        }
        /** Update the previously focused element with the currently focused element. */
      }, {
        key: "updatePreviousElement",
        value: function () {
          var te = this.getDocument();
          te && (this.previouslyFocusedElement = te.activeElement);
        }
      }, {
        key: "deactivateTrap",
        value: function () {
          !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
            // NOTE: we never let the trap return the focus since we do that ourselves
            returnFocus: !1,
            // we'll call this in our own post deactivate handler so make sure the trap doesn't
            //  do it prematurely
            checkCanReturnFocus: null,
            // let it call the user's original deactivate handler, if any, instead of
            //  our own which calls back into this function
            onDeactivate: this.originalOptions.onDeactivate
            // NOTE: for post deactivate, don't specify anything so that it calls the
            //  onPostDeactivate handler specified on `this.internalOptions`
            //  which will always be our own `handlePostDeactivate()` handler, which
            //  will finish things off by calling the user's provided onPostDeactivate
            //  handler, if any, at the right time
            // onPostDeactivate: NOTHING
          });
        }
      }, {
        key: "handleClickOutsideDeactivates",
        value: function (te) {
          var ie = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, te) : this.originalOptions.clickOutsideDeactivates;
          return ie && (this.outsideClick = {
            target: te.target,
            allowDeactivation: ie
          }), ie;
        }
      }, {
        key: "handleDeactivate",
        value: function () {
          this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
        }
      }, {
        key: "handlePostDeactivate",
        value: function () {
          var te = this,
            ie = function () {
              var Y = te.getReturnFocusNode(),
                ee = !!(
                // did the consumer allow it?
                te.originalOptions.returnFocusOnDeactivate &&
                // can we actually focus the node?
                Y !== null && Y !== void 0 && Y.focus && (
                // was there an outside click that allowed deactivation?
                !te.outsideClick ||
                // did the consumer allow deactivation when the outside node was clicked?
                te.outsideClick.allowDeactivation &&
                // is the outside node NOT focusable (implying that it did NOT receive focus
                //  as a result of the click-through) -- in which case do NOT restore focus
                //  to `returnFocusNode` because focus should remain on the outside node
                !j(te.outsideClick.target, te.internalOptions.tabbableOptions))),
                ae = te.internalOptions.preventScroll,
                ne = ae === void 0 ? !1 : ae;
              ee && Y.focus({
                preventScroll: ne
              }), te.originalOptions.onPostDeactivate && te.originalOptions.onPostDeactivate.call(null), te.outsideClick = null;
            };
          this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(ie, ie) : ie();
        }
      }, {
        key: "setupFocusTrap",
        value: function () {
          if (this.focusTrap) this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());else {
            var te = this.focusTrapElements.some(Boolean);
            te && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
          }
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.props.active && this.setupFocusTrap();
        }
      }, {
        key: "componentDidUpdate",
        value: function (te) {
          if (this.focusTrap) {
            te.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
            var ie = !te.active && this.props.active,
              Y = te.active && !this.props.active,
              ee = !te.paused && this.props.paused,
              ae = te.paused && !this.props.paused;
            if (ie && (this.updatePreviousElement(), this.focusTrap.activate()), Y) {
              this.deactivateTrap();
              return;
            }
            ee && this.focusTrap.pause(), ae && this.focusTrap.unpause();
          } else te.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.deactivateTrap();
        }
      }, {
        key: "render",
        value: function () {
          var te = this,
            ie = this.props.children ? P.Children.only(this.props.children) : void 0;
          if (ie) {
            if (ie.type && ie.type === P.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
            var Y = function (ae) {
                var ne = te.props.containerElements;
                ie && (V >= 19 ? typeof ie.props.ref == "function" ? ie.props.ref(ae) : ie.props.ref && (ie.props.ref.current = ae) : typeof ie.ref == "function" ? ie.ref(ae) : ie.ref && (ie.ref.current = ae)), te.focusTrapElements = ne || [ae];
              },
              ee = P.cloneElement(ie, {
                ref: Y
              });
            return ee;
          }
          return null;
        }
      }]);
    }(P.Component);
  return K.defaultProps = {
    active: !0,
    paused: !1,
    focusTrapOptions: {},
    _createFocusTrap: O
  }, oM.exports = K, oM.exports.FocusTrap = K, oM.exports;
}
var e4 = HY();
const $Y = "_alert_3baq8_1",
  WY = "_alertHeader_3baq8_5",
  qY = "_alertHeading_3baq8_11",
  YY = "_anchorTarget_3baq8_16",
  jm = {
    alert: $Y,
    alertHeader: WY,
    alertHeading: qY,
    anchorTarget: YY
  },
  GY = ({
    type: t,
    date: e,
    title: i,
    message: s,
    url: c,
    urlTarget: p = "_self",
    viewedIds: h,
    id: y,
    locale: w,
    renderNotificationLink: x,
    renderNotificationIcon: E,
    listItemClasses: C,
    handleClose: k
  }) => {
    const D = !h.includes(y),
      [I, L, P] = e.split("T")[0].split("-"),
      N = new Date(Number(I), Number(L) - 1, Number(P)).toLocaleDateString(w, {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    if (t === "alert" && c && i) {
      const O = /* @__PURE__ */we.jsxs("span", {
        onClick: k,
        className: Ze(jm.anchorTarget, C == null ? void 0 : C.anchorTarget),
        children: [/* @__PURE__ */we.jsxs("div", {
          className: Ze(jm.alertHeader, C == null ? void 0 : C.header),
          children: [/* @__PURE__ */we.jsxs("span", {
            className: Ze(jm.alertHeading, C == null ? void 0 : C.heading),
            children: [E && /* @__PURE__ */we.jsx("span", {
              className: Ze(jm.alertIcon, C == null ? void 0 : C.icon),
              children: E("warning")
            }), /* @__PURE__ */we.jsx("span", {
              className: Ze(jm.alertTitle, C == null ? void 0 : C.title),
              children: i
            })]
          }), e && /* @__PURE__ */we.jsx("time", {
            className: Ze(jm.alertDate, C == null ? void 0 : C.date),
            dateTime: e,
            children: N
          })]
        }), /* @__PURE__ */we.jsx("div", {
          className: Ze(jm.alertMessage, C == null ? void 0 : C.message),
          children: s
        })]
      });
      return /* @__PURE__ */we.jsx("div", {
        className: Ze(jm.alert, D && [jm.active, C == null ? void 0 : C.active], C == null ? void 0 : C.wrapper),
        "data-type": t,
        role: "listitem",
        children: typeof x == "function" ? x(c, O, Ze(jm.anchor, C == null ? void 0 : C.anchor), p) : /* @__PURE__ */we.jsx("a", {
          className: Ze(jm.anchor, C == null ? void 0 : C.anchor),
          href: c,
          target: p,
          children: O
        })
      });
    }
    return null;
  },
  XY = "_offer_19e6b_1",
  KY = "_offerHeader_19e6b_5",
  QY = "_offerHeading_19e6b_11",
  ZY = "_anchorTarget_19e6b_16",
  Tp = {
    offer: XY,
    offerHeader: KY,
    offerHeading: QY,
    anchorTarget: ZY
  },
  JY = ({
    type: t,
    date: e,
    title: i,
    heading: s,
    message: c,
    url: p = "#",
    urlTarget: h = "_self",
    viewedIds: y,
    id: w,
    locale: x,
    renderNotificationLink: E,
    renderNotificationIcon: C,
    listItemClasses: k,
    handleClose: D
  }) => {
    const I = !y.includes(w),
      [L, P, N] = e.split("T")[0].split("-"),
      O = new Date(Number(L), Number(P) - 1, Number(N)).toLocaleDateString(x, {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    if (t === "offer" && p && i) {
      const F = /* @__PURE__ */we.jsxs("span", {
        onClick: D,
        className: Ze(Tp.anchorTarget, k == null ? void 0 : k.anchorTarget),
        children: [/* @__PURE__ */we.jsxs("div", {
          className: Ze(Tp.offerHeader, k == null ? void 0 : k.header),
          children: [/* @__PURE__ */we.jsxs("span", {
            className: Ze(Tp.offerHeading, k == null ? void 0 : k.heading),
            children: [C && /* @__PURE__ */we.jsx("span", {
              className: Ze(Tp.offerIcon, k == null ? void 0 : k.icon),
              children: C("deal")
            }), /* @__PURE__ */we.jsx("span", {
              className: Ze(Tp.offerTitle, k == null ? void 0 : k.title),
              children: i
            })]
          }), e && /* @__PURE__ */we.jsx("time", {
            className: Ze(Tp.offerDate, k == null ? void 0 : k.date),
            dateTime: e,
            children: O
          })]
        }), s && /* @__PURE__ */we.jsx("div", {
          className: Ze(Tp.offerSubHeading, k == null ? void 0 : k.subHeading),
          children: s
        }), /* @__PURE__ */we.jsx("div", {
          className: Ze(Tp.offerMessage, k == null ? void 0 : k.message),
          children: c
        })]
      });
      return /* @__PURE__ */we.jsx("div", {
        className: Ze(Tp.offer, I && [Tp.active, k == null ? void 0 : k.active], k == null ? void 0 : k.wrapper),
        "data-type": t,
        role: "listitem",
        children: typeof E == "function" ? E(p, F, Ze(Tp.anchor, k == null ? void 0 : k.anchor), h) : /* @__PURE__ */we.jsx("a", {
          className: Ze(Tp.anchor, k == null ? void 0 : k.anchor),
          href: p,
          target: h,
          children: F
        })
      });
    }
    return null;
  },
  eG = "_menuWrapper_1whf1_1",
  tG = "_menuContainer_1whf1_5",
  nG = "_menuItem_1whf1_10",
  W1 = {
    menuWrapper: eG,
    menuContainer: tG,
    menuItem: nG
  },
  rG = ({
    setActiveFilterId: t,
    activeFilterId: e,
    menuConfig: i,
    a11yMenu: s,
    renderMenuIcon: c,
    menuClassNames: p = {}
  }) => {
    const [h, y] = rt(e),
      w = vt(null),
      x = C => {
        h !== C.filterId && (t(C.filterId), y(C.filterId));
      },
      E = pn(C => {
        var k;
        if (!w.current) return;
        const D = Array.from(w.current.querySelectorAll("button[role='tab']") || []),
          I = D.findIndex(N => N === document.activeElement);
        if (I === -1) return;
        let L = I;
        switch (C.key) {
          case "ArrowDown":
            C.preventDefault(), L = (I + 1) % D.length;
            break;
          case "ArrowUp":
            C.preventDefault(), L = (I - 1 + D.length) % D.length;
            break;
          case "Home":
            C.preventDefault(), L = 0;
            break;
          case "End":
            C.preventDefault(), L = D.length - 1;
            break;
          default:
            return;
        }
        const P = D[L];
        if (P) {
          P.focus();
          const N = ((k = P.dataset) == null ? void 0 : k.filterid) ?? "";
          t(N), y(N);
        }
      }, [t]);
    return Rt(() => {
      const C = w.current;
      if (C) return C.addEventListener("keydown", E), () => {
        C.removeEventListener("keydown", E);
      };
    }, [E]), /* @__PURE__ */we.jsx("div", {
      role: "group",
      className: Ze(W1.menuWrapper, p == null ? void 0 : p.wrapper),
      "aria-label": s,
      children: /* @__PURE__ */we.jsx("div", {
        className: Ze(W1.menuContainer, p == null ? void 0 : p.container),
        role: "tablist",
        "aria-orientation": "vertical",
        ref: w,
        children: i.map((C, k) => /* @__PURE__ */we.jsxs("button", {
          "data-filterid": C.filterId,
          id: `tab-${C.filterId}`,
          role: "tab",
          "aria-selected": h === C.filterId,
          "aria-controls": "panelList",
          tabIndex: h === C.filterId ? 0 : -1,
          type: "button",
          className: Ze(W1.menuItem, h === C.filterId && [W1.active, p == null ? void 0 : p.itemActive], p == null ? void 0 : p.item),
          onClick: () => x(C),
          children: [c && /* @__PURE__ */we.jsx("span", {
            className: Ze(W1.icon, p == null ? void 0 : p.icon),
            children: c(C.filterIcon)
          }), /* @__PURE__ */we.jsx("span", {
            className: Ze(W1.type, p == null ? void 0 : p.type),
            children: C.filterName
          })]
        }, k))
      })
    });
  },
  iG = "_notifications_unwp8_1",
  aG = "_listBody_unwp8_13",
  oG = "_listContainer_unwp8_17",
  lG = "_listHeader_unwp8_21",
  sG = "_listClose_unwp8_27",
  uG = "_srOnly_unwp8_31",
  Fm = {
    notifications: iG,
    listBody: aG,
    listContainer: oG,
    listHeader: lG,
    listClose: sG,
    srOnly: uG
  },
  cG = ({
    storageId: t = "notifications",
    locale: e = "en-CA",
    labels: i = {},
    data: s,
    triggerElement: c,
    menuSettings: p,
    onGetActiveTotal: h,
    renderMenuIcon: y,
    renderCloseIcon: w,
    renderFilterLink: x,
    renderNotificationLink: E,
    renderNotificationIcon: C,
    className: k,
    classNames: D
  }) => {
    var I, L;
    const P = {
        ...uY,
        ...i
      },
      N = vt(null),
      [O, F] = rt(!1),
      [j, V] = rt(!1),
      K = vt(p || []),
      [G, Q] = rt(((L = (I = K.current) == null ? void 0 : I[0]) == null ? void 0 : L.filterId) ?? ""),
      [te, ie] = rt(),
      [Y, ee] = rt(),
      [ae, ne] = rt(!1),
      [le, ce] = rt(),
      W = vt([]),
      $ = K.current.map(be => be == null ? void 0 : be.filterId),
      de = be => {
        if (!be) return !1;
        try {
          const Le = new Date(be);
          return !isNaN(Le.getTime()) && be === Le.toISOString() || be.startsWith(Le.toISOString().slice(0, 10));
        } catch {
          return !1;
        }
      },
      H = ((be = []) => {
        const Le = ["type", "date", "title", "message", "url", "id"];
        return be.filter(Be => !!(Be != null && Be.date) && de(Be.date) && Le.every(Xe => !!(Be != null && Be[Xe])));
      })(s),
      se = (H == null ? void 0 : H.filter(be => $.includes(be.type)).map(be => be == null ? void 0 : be.id)) ?? [],
      ue = be => $.includes(be),
      Ee = () => {
        var be, Le;
        F(!1), V(!1), (Le = (be = K.current) == null ? void 0 : be[0]) != null && Le.filterId && Q(K.current[0].filterId);
      },
      Ce = () => {
        var be, Le;
        !O && !j ? (V(!0), F(!0)) : j && !O && (V(!1), (Le = (be = K.current) == null ? void 0 : be[0]) != null && Le.filterId && Q(K.current[0].filterId)), c.current && (c.current.ariaExpanded = String(O));
      },
      fe = () => {
        const be = H.filter(Le => ((te == null ? void 0 : te.filterId) === aM || K.current.length > 1 || ue(Le.type)) && !W.current.includes(Le.id));
        le !== be.length && ce(be.length), be.length > 0 && ae && !O && (_e(se), ce(0), Se(), ne(!1));
      },
      _e = be => {
        const Le = be.join(",");
        localStorage.setItem(t, Le);
      },
      Se = () => {
        const be = localStorage.getItem(t);
        if (be && be.length) {
          const Le = be.split(",");
          W.current = Le;
        }
      };
    return Rt(() => {
      typeof h == "function" && h(le ?? 0);
    }, [le, h]), Rt(() => {
      se.length && (Se(), fe());
    }, [W, se]), Rt(() => {
      O && ne(!0);
    }, [O]), Rt(() => {
      var be;
      if (G) {
        const Le = (be = K.current.filter(Be => Be.filterId === G)) == null ? void 0 : be[0];
        Le && ie(Le);
      }
    }, [G]), Rt(() => {
      ((H == null ? void 0 : H.filter(be => be.type === G).length) ?? 0) && G || G === aM && se.length ? ee(!0) : ee(!1);
    }, [G, se]), Rt(() => {
      const be = c == null ? void 0 : c.current;
      if (!be) return;
      be.ariaExpanded = String(O);
      const Le = () => {
        Ce();
      };
      return be.addEventListener("click", Le), () => {
        be.removeEventListener("click", Le);
      };
    }, [c, Ce]), /* @__PURE__ */we.jsxs(we.Fragment, {
      children: [te && /* @__PURE__ */we.jsx("div", {
        "aria-live": "polite",
        className: Fm.srOnly,
        children: O ? P.a11yOpenLiveRegion.replace("{{ filter }}", te.filterName) : P.a11yClosedLiveRegion
      }), O && c.current && K.current.length > 0 && /* @__PURE__ */we.jsx(e4.FocusTrap, {
        focusTrapOptions: {
          onDeactivate: () => {
            var be;
            (be = c.current) == null || be.focus();
          },
          clickOutsideDeactivates: be => {
            var Le;
            return (Le = c.current) != null && Le.contains(be.target) ? F(!1) : Ee(), !0;
          },
          escapeDeactivates: () => (Ee(), !0)
        },
        children: /* @__PURE__ */we.jsxs("div", {
          ref: N,
          id: "notificationsPopover",
          className: Ze(Fm.notifications, k),
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "notificationsHeading",
          children: [/* @__PURE__ */we.jsx(rG, {
            setActiveFilterId: Q,
            activeFilterId: G,
            menuConfig: K.current,
            a11yMenu: P.a11yMenu,
            renderMenuIcon: y,
            menuClassNames: {
              wrapper: D == null ? void 0 : D.menuWrapper,
              container: D == null ? void 0 : D.menuContainer,
              item: D == null ? void 0 : D.menuItem,
              itemActive: D == null ? void 0 : D.menuItemActive,
              icon: D == null ? void 0 : D.menuItemIcon,
              type: D == null ? void 0 : D.menuItemType
            }
          }), /* @__PURE__ */we.jsxs("div", {
            className: Ze(Fm.listContainer, D == null ? void 0 : D.listContainer),
            children: [/* @__PURE__ */we.jsxs("div", {
              className: Ze(Fm.listHeader, D == null ? void 0 : D.listHeader),
              children: [(te == null ? void 0 : te.filterHeading) && /* @__PURE__ */we.jsx("h2", {
                id: "notificationsHeading",
                className: Ze(Fm.listHeading, D == null ? void 0 : D.listHeading),
                children: te.filterHeading
              }), w && /* @__PURE__ */we.jsx("div", {
                className: Ze(Fm.listClose, D == null ? void 0 : D.listClose),
                children: /* @__PURE__ */we.jsx("button", {
                  type: "button",
                  className: Ze(Fm.listCloseButton, D == null ? void 0 : D.listCloseButton),
                  "aria-label": P.a11yCloseMenu,
                  onClick: Ee,
                  children: w("close")
                })
              })]
            }), /* @__PURE__ */we.jsxs("div", {
              className: Ze(Fm.listBody, D == null ? void 0 : D.listBody),
              role: "tabpanel",
              id: "panelList",
              tabIndex: 0,
              "aria-labelledby": `tab-${G}`,
              children: [/* @__PURE__ */we.jsxs("div", {
                className: Ze(Fm.listContent, D == null ? void 0 : D.listContent),
                role: "list",
                "aria-label": P.a11yList,
                children: [H && H.map(be => /* @__PURE__ */we.jsxs(Qv, {
                  children: [be.type === xV && (G === xV || G === aM) && /* @__PURE__ */we.jsx(GY, {
                    type: be == null ? void 0 : be.type,
                    date: be == null ? void 0 : be.date,
                    title: be == null ? void 0 : be.title,
                    message: be == null ? void 0 : be.message,
                    url: be.url,
                    urlTarget: be == null ? void 0 : be.urlTarget,
                    id: be == null ? void 0 : be.id,
                    viewedIds: W.current,
                    locale: e,
                    renderNotificationLink: E,
                    renderNotificationIcon: C,
                    listItemClasses: {
                      wrapper: D == null ? void 0 : D.listItemWrapper,
                      active: D == null ? void 0 : D.listItemActive,
                      header: D == null ? void 0 : D.listItemHeader,
                      heading: D == null ? void 0 : D.listItemHeading,
                      icon: D == null ? void 0 : D.listItemIcon,
                      title: D == null ? void 0 : D.listItemTitle,
                      date: D == null ? void 0 : D.listItemDate,
                      message: D == null ? void 0 : D.listItemMessage,
                      anchor: D == null ? void 0 : D.listItemAnchor
                    },
                    handleClose: Ee
                  }), be.type === SV && (G === SV || G === aM) && /* @__PURE__ */we.jsx(JY, {
                    type: be == null ? void 0 : be.type,
                    date: be == null ? void 0 : be.date,
                    title: be == null ? void 0 : be.title,
                    heading: (be == null ? void 0 : be.heading) ?? "",
                    message: be == null ? void 0 : be.message,
                    url: be.url,
                    urlTarget: be == null ? void 0 : be.urlTarget,
                    id: be == null ? void 0 : be.id,
                    viewedIds: W.current,
                    locale: e,
                    renderNotificationLink: E,
                    renderNotificationIcon: C,
                    listItemClasses: {
                      wrapper: D == null ? void 0 : D.listItemWrapper,
                      active: D == null ? void 0 : D.listItemActive,
                      header: D == null ? void 0 : D.listItemHeader,
                      heading: D == null ? void 0 : D.listItemHeading,
                      icon: D == null ? void 0 : D.listItemIcon,
                      title: D == null ? void 0 : D.listItemTitle,
                      date: D == null ? void 0 : D.listItemDate,
                      subHeading: D == null ? void 0 : D.listItemSubHeading,
                      message: D == null ? void 0 : D.listItemMessage,
                      anchor: D == null ? void 0 : D.listItemAnchor
                    },
                    handleClose: Ee
                  })]
                }, be.id)), !Y && /* @__PURE__ */we.jsx("div", {
                  className: Ze(Fm.missingNotifications, D == null ? void 0 : D.listMissing),
                  children: te == null ? void 0 : te.noResults
                })]
              }), te && te.filterLink && te.filterLinkText && /* @__PURE__ */we.jsx("div", {
                className: Ze(Fm.listFooter, D == null ? void 0 : D.listFooter),
                children: typeof x == "function" && x(te, Ze(D == null ? void 0 : D.listFooterLink))
              })]
            })]
          })]
        })
      })]
    });
  };
function D2(t, e) {
  return D2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, s) {
    return i.__proto__ = s, i;
  }, D2(t, e);
}
function dG(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, D2(t, e);
}
function mj(t) {
  return t && t.stopPropagation && t.stopPropagation(), t && t.preventDefault && t.preventDefault(), !1;
}
function vj(t) {
  return t == null ? [] : Array.isArray(t) ? t.slice() : [t];
}
function sM(t) {
  return t !== null && t.length === 1 ? t[0] : t.slice();
}
function uM(t) {
  Object.keys(t).forEach(e => {
    typeof document < "u" && document.addEventListener(e, t[e], !1);
  });
}
function Mx(t, e) {
  return I2(function (i, s) {
    let c = i;
    return c <= s.min && (c = s.min), c >= s.max && (c = s.max), c;
  }(t, e), e);
}
function I2(t, e) {
  const i = (t - e.min) % e.step;
  let s = t - i;
  return 2 * Math.abs(i) >= e.step && (s += i > 0 ? e.step : -e.step), parseFloat(s.toFixed(5));
}
let M2 = function (t) {
  function e(s) {
    var c;
    (c = t.call(this, s) || this).onKeyUp = () => {
      c.onEnd();
    }, c.onMouseUp = () => {
      c.onEnd(c.getMouseEventMap());
    }, c.onTouchEnd = y => {
      y.preventDefault(), c.onEnd(c.getTouchEventMap());
    }, c.onBlur = () => {
      c.setState({
        index: -1
      }, c.onEnd(c.getKeyDownEventMap()));
    }, c.onMouseMove = y => {
      c.setState({
        pending: !0
      });
      const w = c.getMousePosition(y),
        x = c.getDiffPosition(w[0]),
        E = c.getValueFromPosition(x);
      c.move(E);
    }, c.onTouchMove = y => {
      if (y.touches.length > 1) return;
      c.setState({
        pending: !0
      });
      const w = c.getTouchPosition(y);
      if (c.isScrolling === void 0) {
        const C = w[0] - c.startPosition[0],
          k = w[1] - c.startPosition[1];
        c.isScrolling = Math.abs(k) > Math.abs(C);
      }
      if (c.isScrolling) return void c.setState({
        index: -1
      });
      const x = c.getDiffPosition(w[0]),
        E = c.getValueFromPosition(x);
      c.move(E);
    }, c.onKeyDown = y => {
      if (!(y.ctrlKey || y.shiftKey || y.altKey || y.metaKey)) switch (c.setState({
        pending: !0
      }), y.key) {
        case "ArrowLeft":
        case "ArrowDown":
        case "Left":
        case "Down":
          y.preventDefault(), c.moveDownByStep();
          break;
        case "ArrowRight":
        case "ArrowUp":
        case "Right":
        case "Up":
          y.preventDefault(), c.moveUpByStep();
          break;
        case "Home":
          y.preventDefault(), c.move(c.props.min);
          break;
        case "End":
          y.preventDefault(), c.move(c.props.max);
          break;
        case "PageDown":
          y.preventDefault(), c.moveDownByStep(c.props.pageFn(c.props.step));
          break;
        case "PageUp":
          y.preventDefault(), c.moveUpByStep(c.props.pageFn(c.props.step));
      }
    }, c.onSliderMouseDown = y => {
      if (!c.props.disabled && y.button !== 2) {
        if (c.setState({
          pending: !0
        }), !c.props.snapDragDisabled) {
          const w = c.getMousePosition(y);
          c.forceValueFromPosition(w[0], x => {
            c.start(x, w[0]), uM(c.getMouseEventMap());
          });
        }
        mj(y);
      }
    }, c.onSliderClick = y => {
      if (!c.props.disabled && c.props.onSliderClick && !c.hasMoved) {
        const w = c.getMousePosition(y),
          x = Mx(c.calcValue(c.calcOffsetFromPosition(w[0])), c.props);
        c.props.onSliderClick(x);
      }
    }, c.createOnKeyDown = y => w => {
      c.props.disabled || (c.start(y), uM(c.getKeyDownEventMap()), mj(w));
    }, c.createOnMouseDown = y => w => {
      if (c.props.disabled || w.button === 2) return;
      c.setState({
        pending: !0
      });
      const x = c.getMousePosition(w);
      c.start(y, x[0]), uM(c.getMouseEventMap()), mj(w);
    }, c.createOnTouchStart = y => w => {
      if (c.props.disabled || w.touches.length > 1) return;
      c.setState({
        pending: !0
      });
      const x = c.getTouchPosition(w);
      c.startPosition = x, c.isScrolling = void 0, c.start(y, x[0]), uM(c.getTouchEventMap()), function (E) {
        E.stopPropagation && E.stopPropagation();
      }(w);
    }, c.handleResize = () => {
      const y = window.setTimeout(() => {
        c.pendingResizeTimeouts.shift(), c.resize();
      }, 0);
      c.pendingResizeTimeouts.push(y);
    }, c.renderThumb = (y, w) => {
      const x = c.props.thumbClassName + " " + c.props.thumbClassName + "-" + w + " " + (c.state.index === w ? c.props.thumbActiveClassName : ""),
        E = {
          ref: k => {
            c["thumb" + w] = k;
          },
          key: c.props.thumbClassName + "-" + w,
          className: x,
          style: y,
          onMouseDown: c.createOnMouseDown(w),
          onTouchStart: c.createOnTouchStart(w),
          onFocus: c.createOnKeyDown(w),
          tabIndex: 0,
          role: "slider",
          "aria-orientation": c.props.orientation,
          "aria-valuenow": c.state.value[w],
          "aria-valuemin": c.props.min,
          "aria-valuemax": c.props.max,
          "aria-label": Array.isArray(c.props.ariaLabel) ? c.props.ariaLabel[w] : c.props.ariaLabel,
          "aria-labelledby": Array.isArray(c.props.ariaLabelledby) ? c.props.ariaLabelledby[w] : c.props.ariaLabelledby,
          "aria-disabled": c.props.disabled
        },
        C = {
          index: w,
          value: sM(c.state.value),
          valueNow: c.state.value[w]
        };
      return c.props.ariaValuetext && (E["aria-valuetext"] = typeof c.props.ariaValuetext == "string" ? c.props.ariaValuetext : c.props.ariaValuetext(C)), c.props.renderThumb(E, C);
    }, c.renderTrack = (y, w, x) => {
      const E = {
          key: c.props.trackClassName + "-" + y,
          className: c.props.trackClassName + " " + c.props.trackClassName + "-" + y,
          style: c.buildTrackStyle(w, c.state.upperBound - x)
        },
        C = {
          index: y,
          value: sM(c.state.value)
        };
      return c.props.renderTrack(E, C);
    };
    let p = vj(s.value);
    p.length || (p = vj(s.defaultValue)), c.pendingResizeTimeouts = [];
    const h = [];
    for (let y = 0; y < p.length; y += 1) p[y] = Mx(p[y], s), h.push(y);
    return c.resizeObserver = null, c.resizeElementRef = Nt.createRef(), c.state = {
      index: -1,
      upperBound: 0,
      sliderLength: 0,
      value: p,
      zIndices: h
    }, c;
  }
  dG(e, t);
  var i = e.prototype;
  return i.componentDidMount = function () {
    typeof window < "u" && (this.resizeObserver = new ResizeObserver(this.handleResize), this.resizeObserver.observe(this.resizeElementRef.current), this.resize());
  }, e.getDerivedStateFromProps = function (s, c) {
    const p = vj(s.value);
    return p.length ? c.pending ? null : {
      value: p.map(h => Mx(h, s))
    } : null;
  }, i.componentDidUpdate = function () {
    this.state.upperBound === 0 && this.resize();
  }, i.componentWillUnmount = function () {
    this.clearPendingResizeTimeouts(), this.resizeObserver && this.resizeObserver.disconnect();
  }, i.onEnd = function (s) {
    s && function (c) {
      Object.keys(c).forEach(p => {
        typeof document < "u" && document.removeEventListener(p, c[p], !1);
      });
    }(s), this.hasMoved && this.fireChangeEvent("onAfterChange"), this.setState({
      pending: !1
    }), this.hasMoved = !1;
  }, i.getValue = function () {
    return sM(this.state.value);
  }, i.getClosestIndex = function (s) {
    let c = Number.MAX_VALUE,
      p = -1;
    const {
        value: h
      } = this.state,
      y = h.length;
    for (let w = 0; w < y; w += 1) {
      const x = this.calcOffset(h[w]),
        E = Math.abs(s - x);
      E < c && (c = E, p = w);
    }
    return p;
  }, i.getMousePosition = function (s) {
    return [s["page" + this.axisKey()], s["page" + this.orthogonalAxisKey()]];
  }, i.getTouchPosition = function (s) {
    const c = s.touches[0];
    return [c["page" + this.axisKey()], c["page" + this.orthogonalAxisKey()]];
  }, i.getKeyDownEventMap = function () {
    return {
      keydown: this.onKeyDown,
      keyup: this.onKeyUp,
      focusout: this.onBlur
    };
  }, i.getMouseEventMap = function () {
    return {
      mousemove: this.onMouseMove,
      mouseup: this.onMouseUp
    };
  }, i.getTouchEventMap = function () {
    return {
      touchmove: this.onTouchMove,
      touchend: this.onTouchEnd
    };
  }, i.getValueFromPosition = function (s) {
    const c = s / (this.state.sliderLength - this.state.thumbSize) * (this.props.max - this.props.min);
    return Mx(this.state.startValue + c, this.props);
  }, i.getDiffPosition = function (s) {
    let c = s - this.state.startPosition;
    return this.props.invert && (c *= -1), c;
  }, i.resize = function () {
    const {
      slider: s,
      thumb0: c
    } = this;
    if (!s || !c) return;
    const p = this.sizeKey(),
      h = s.getBoundingClientRect(),
      y = s[p],
      w = h[this.posMaxKey()],
      x = h[this.posMinKey()],
      E = c.getBoundingClientRect()[p.replace("client", "").toLowerCase()],
      C = y - E,
      k = Math.abs(w - x);
    this.state.upperBound === C && this.state.sliderLength === k && this.state.thumbSize === E || this.setState({
      upperBound: C,
      sliderLength: k,
      thumbSize: E
    });
  }, i.calcOffset = function (s) {
    const c = this.props.max - this.props.min;
    return c === 0 ? 0 : (s - this.props.min) / c * this.state.upperBound;
  }, i.calcValue = function (s) {
    return s / this.state.upperBound * (this.props.max - this.props.min) + this.props.min;
  }, i.calcOffsetFromPosition = function (s) {
    const {
        slider: c
      } = this,
      p = c.getBoundingClientRect(),
      h = p[this.posMaxKey()],
      y = p[this.posMinKey()];
    let w = s - (window["page" + this.axisKey() + "Offset"] + (this.props.invert ? h : y));
    return this.props.invert && (w = this.state.sliderLength - w), w -= this.state.thumbSize / 2, w;
  }, i.forceValueFromPosition = function (s, c) {
    const p = this.calcOffsetFromPosition(s),
      h = this.getClosestIndex(p),
      y = Mx(this.calcValue(p), this.props),
      w = this.state.value.slice();
    w[h] = y;
    for (let x = 0; x < w.length - 1; x += 1) if (w[x + 1] - w[x] < this.props.minDistance) return;
    this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0, this.setState({
      value: w
    }, () => {
      c(h), this.fireChangeEvent("onChange");
    });
  }, i.clearPendingResizeTimeouts = function () {
    do {
      const s = this.pendingResizeTimeouts.shift();
      clearTimeout(s);
    } while (this.pendingResizeTimeouts.length);
  }, i.start = function (s, c) {
    const p = this["thumb" + s];
    p && p.focus();
    const {
      zIndices: h
    } = this.state;
    h.splice(h.indexOf(s), 1), h.push(s), this.setState(y => ({
      startValue: y.value[s],
      startPosition: c !== void 0 ? c : y.startPosition,
      index: s,
      zIndices: h
    }));
  }, i.moveUpByStep = function (s) {
    s === void 0 && (s = this.props.step);
    const c = this.state.value[this.state.index],
      p = Mx(this.props.invert && this.props.orientation === "horizontal" ? c - s : c + s, this.props);
    this.move(Math.min(p, this.props.max));
  }, i.moveDownByStep = function (s) {
    s === void 0 && (s = this.props.step);
    const c = this.state.value[this.state.index],
      p = Mx(this.props.invert && this.props.orientation === "horizontal" ? c + s : c - s, this.props);
    this.move(Math.max(p, this.props.min));
  }, i.move = function (s) {
    const c = this.state.value.slice(),
      {
        index: p
      } = this.state,
      {
        length: h
      } = c,
      y = c[p];
    if (s === y) return;
    this.hasMoved || this.fireChangeEvent("onBeforeChange"), this.hasMoved = !0;
    const {
      pearling: w,
      max: x,
      min: E,
      minDistance: C
    } = this.props;
    if (!w) {
      if (p > 0) {
        const k = c[p - 1];
        s < k + C && (s = k + C);
      }
      if (p < h - 1) {
        const k = c[p + 1];
        s > k - C && (s = k - C);
      }
    }
    c[p] = s, w && h > 1 && (s > y ? (this.pushSucceeding(c, C, p), function (k, D, I, L) {
      for (let P = 0; P < k; P += 1) {
        const N = L - P * I;
        D[k - 1 - P] > N && (D[k - 1 - P] = N);
      }
    }(h, c, C, x)) : s < y && (this.pushPreceding(c, C, p), function (k, D, I, L) {
      for (let P = 0; P < k; P += 1) {
        const N = L + P * I;
        D[P] < N && (D[P] = N);
      }
    }(h, c, C, E))), this.setState({
      value: c
    }, this.fireChangeEvent.bind(this, "onChange"));
  }, i.pushSucceeding = function (s, c, p) {
    let h, y;
    for (h = p, y = s[h] + c; s[h + 1] !== null && y > s[h + 1]; h += 1, y = s[h] + c) s[h + 1] = I2(y, this.props);
  }, i.pushPreceding = function (s, c, p) {
    for (let h = p, y = s[h] - c; s[h - 1] !== null && y < s[h - 1]; h -= 1, y = s[h] - c) s[h - 1] = I2(y, this.props);
  }, i.axisKey = function () {
    return this.props.orientation === "vertical" ? "Y" : "X";
  }, i.orthogonalAxisKey = function () {
    return this.props.orientation === "vertical" ? "X" : "Y";
  }, i.posMinKey = function () {
    return this.props.orientation === "vertical" ? this.props.invert ? "bottom" : "top" : this.props.invert ? "right" : "left";
  }, i.posMaxKey = function () {
    return this.props.orientation === "vertical" ? this.props.invert ? "top" : "bottom" : this.props.invert ? "left" : "right";
  }, i.sizeKey = function () {
    return this.props.orientation === "vertical" ? "clientHeight" : "clientWidth";
  }, i.fireChangeEvent = function (s) {
    this.props[s] && this.props[s](sM(this.state.value), this.state.index);
  }, i.buildThumbStyle = function (s, c) {
    const p = {
      position: "absolute",
      touchAction: "none",
      willChange: this.state.index >= 0 ? this.posMinKey() : void 0,
      zIndex: this.state.zIndices.indexOf(c) + 1
    };
    return p[this.posMinKey()] = s + "px", p;
  }, i.buildTrackStyle = function (s, c) {
    const p = {
      position: "absolute",
      willChange: this.state.index >= 0 ? this.posMinKey() + "," + this.posMaxKey() : void 0
    };
    return p[this.posMinKey()] = s, p[this.posMaxKey()] = c, p;
  }, i.buildMarkStyle = function (s) {
    var c;
    return (c = {
      position: "absolute"
    })[this.posMinKey()] = s, c;
  }, i.renderThumbs = function (s) {
    const {
        length: c
      } = s,
      p = [];
    for (let y = 0; y < c; y += 1) p[y] = this.buildThumbStyle(s[y], y);
    const h = [];
    for (let y = 0; y < c; y += 1) h[y] = this.renderThumb(p[y], y);
    return h;
  }, i.renderTracks = function (s) {
    const c = [],
      p = s.length - 1;
    c.push(this.renderTrack(0, 0, s[0]));
    for (let h = 0; h < p; h += 1) c.push(this.renderTrack(h + 1, s[h], s[h + 1]));
    return c.push(this.renderTrack(p + 1, s[p], this.state.upperBound)), c;
  }, i.renderMarks = function () {
    let {
      marks: s
    } = this.props;
    const c = this.props.max - this.props.min + 1;
    return typeof s == "boolean" ? s = Array.from({
      length: c
    }).map((p, h) => h) : typeof s == "number" && (s = Array.from({
      length: c
    }).map((p, h) => h).filter(p => p % s == 0)), s.map(parseFloat).sort((p, h) => p - h).map(p => {
      const h = this.calcOffset(p),
        y = {
          key: p,
          className: this.props.markClassName,
          style: this.buildMarkStyle(h)
        };
      return this.props.renderMark(y);
    });
  }, i.render = function () {
    const s = [],
      {
        value: c
      } = this.state,
      p = c.length;
    for (let x = 0; x < p; x += 1) s[x] = this.calcOffset(c[x], x);
    const h = this.props.withTracks ? this.renderTracks(s) : null,
      y = this.renderThumbs(s),
      w = this.props.marks ? this.renderMarks() : null;
    return Nt.createElement("div", {
      ref: x => {
        this.slider = x, this.resizeElementRef.current = x;
      },
      style: {
        position: "relative"
      },
      className: this.props.className + (this.props.disabled ? " disabled" : ""),
      onMouseDown: this.onSliderMouseDown,
      onClick: this.onSliderClick
    }, h, y, w);
  }, e;
}(Nt.Component);
M2.displayName = "ReactSlider", M2.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  pageFn: t => 10 * t,
  minDistance: 0,
  defaultValue: 0,
  orientation: "horizontal",
  className: "slider",
  thumbClassName: "thumb",
  thumbActiveClassName: "active",
  trackClassName: "track",
  markClassName: "mark",
  withTracks: !0,
  pearling: !1,
  disabled: !1,
  snapDragDisabled: !1,
  invert: !1,
  marks: [],
  renderThumb: t => Nt.createElement("div", t),
  renderTrack: t => Nt.createElement("div", t),
  renderMark: t => Nt.createElement("span", t)
};
var fG = M2;
const pG = "_rangeInner_1wga2_24",
  hG = "_rangeText_1wga2_28",
  mG = "_rangeTrack_1wga2_32",
  vG = "_rangeThumb_1wga2_49",
  gG = "_rangeValue_1wga2_68",
  q1 = {
    rangeInner: pG,
    rangeText: hG,
    rangeTrack: mG,
    rangeThumb: vG,
    rangeValue: gG
  },
  yG = ({
    id: t,
    className: e,
    classNames: i,
    ranges: s = [0, 1e4],
    rangeText: c = "Price Range",
    value: p,
    handleValueLabel: h = w => /* @__PURE__ */we.jsx("span", {
      children: w
    }),
    onHandleRangeChange: y
  }) => {
    const w = s ? s[0] : 0,
      x = s ? s[s.length - 1] : 1e4;
    return /* @__PURE__ */we.jsxs("div", {
      className: vs(q1.rangeInner, e),
      children: [/* @__PURE__ */we.jsx("div", {
        className: vs(q1.rangeText, i == null ? void 0 : i.rangeText),
        children: c
      }), /* @__PURE__ */we.jsxs("div", {
        children: [/* @__PURE__ */we.jsx(fG, {
          thumbClassName: vs(q1.rangeThumb, i == null ? void 0 : i.thumbClassName),
          trackClassName: vs(q1.rangeTrack, i == null ? void 0 : i.trackClassName),
          value: p,
          ariaLabelledby: [`${t}-first-slider-label`, `${t}-second-slider-label`],
          ariaValuetext: `thumb value between ${w}   and ${x}`,
          onChange: y,
          renderThumb: (E, C) => /* @__PURE__ */we.jsx("div", {
            ...E,
            children: C.valueNow
          }),
          pearling: !0,
          min: w,
          max: x,
          minDistance: 10
        }), /* @__PURE__ */we.jsx("span", {
          id: "first-slider-label",
          className: q1.rangeValue,
          children: h(p[0].toString())
        }), /* @__PURE__ */we.jsx("span", {
          id: "second-slider-label",
          className: q1.rangeValue,
          children: h(p[1].toString())
        })]
      })]
    });
  },
  bG = "fr-CA",
  wG = "_formattedNum_1so9e_1",
  IV = {
    formattedNum: wG
  },
  _G = ({
    number: t,
    locale: e
  }) => {
    switch (e) {
      case bG:
        return /* @__PURE__ */we.jsxs("span", {
          className: IV.formattedNum,
          children: [t, " $"]
        });
      default:
        return /* @__PURE__ */we.jsxs("span", {
          className: IV.formattedNum,
          children: ["$", t]
        });
    }
  },
  xG = ({
    locale: t,
    rangeText: e = "Price Range",
    ...i
  }) => {
    const s = c => /* @__PURE__ */we.jsx(_G, {
      number: c,
      locale: t
    });
    return /* @__PURE__ */we.jsx(yG, {
      ...i,
      rangeText: e,
      handleValueLabel: s
    });
  };
var ud = "top",
  Hp = "bottom",
  $p = "right",
  cd = "left",
  vN = "auto",
  BR = [ud, Hp, $p, cd],
  SE = "start",
  lR = "end",
  SG = "clippingParents",
  t4 = "viewport",
  bT = "popper",
  EG = "reference",
  MV = /* @__PURE__ */BR.reduce(function (t, e) {
    return t.concat([e + "-" + SE, e + "-" + lR]);
  }, []),
  n4 = /* @__PURE__ */[].concat(BR, [vN]).reduce(function (t, e) {
    return t.concat([e, e + "-" + SE, e + "-" + lR]);
  }, []),
  CG = "beforeRead",
  kG = "read",
  TG = "afterRead",
  RG = "beforeMain",
  DG = "main",
  IG = "afterMain",
  MG = "beforeWrite",
  LG = "write",
  OG = "afterWrite",
  PG = [CG, kG, TG, RG, DG, IG, MG, LG, OG];
function Zv(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function sp(t) {
  if (t == null) return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Jx(t) {
  var e = sp(t).Element;
  return t instanceof e || t instanceof Element;
}
function Vp(t) {
  var e = sp(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function gN(t) {
  if (typeof ShadowRoot > "u") return !1;
  var e = sp(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function AG(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function (i) {
    var s = e.styles[i] || {},
      c = e.attributes[i] || {},
      p = e.elements[i];
    !Vp(p) || !Zv(p) || (Object.assign(p.style, s), Object.keys(c).forEach(function (h) {
      var y = c[h];
      y === !1 ? p.removeAttribute(h) : p.setAttribute(h, y === !0 ? "" : y);
    }));
  });
}
function jG(t) {
  var e = t.state,
    i = {
      popper: {
        position: e.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
  return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow), function () {
    Object.keys(e.elements).forEach(function (s) {
      var c = e.elements[s],
        p = e.attributes[s] || {},
        h = Object.keys(e.styles.hasOwnProperty(s) ? e.styles[s] : i[s]),
        y = h.reduce(function (w, x) {
          return w[x] = "", w;
        }, {});
      !Vp(c) || !Zv(c) || (Object.assign(c.style, y), Object.keys(p).forEach(function (w) {
        c.removeAttribute(w);
      }));
    });
  };
}
const r4 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: AG,
  effect: jG,
  requires: ["computeStyles"]
};
function Gv(t) {
  return t.split("-")[0];
}
var Yx = Math.max,
  yL = Math.min,
  EE = Math.round;
function L2() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function (e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function i4() {
  return !/^((?!chrome|android).)*safari/i.test(L2());
}
function CE(t, e, i) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  var s = t.getBoundingClientRect(),
    c = 1,
    p = 1;
  e && Vp(t) && (c = t.offsetWidth > 0 && EE(s.width) / t.offsetWidth || 1, p = t.offsetHeight > 0 && EE(s.height) / t.offsetHeight || 1);
  var h = Jx(t) ? sp(t) : window,
    y = h.visualViewport,
    w = !i4() && i,
    x = (s.left + (w && y ? y.offsetLeft : 0)) / c,
    E = (s.top + (w && y ? y.offsetTop : 0)) / p,
    C = s.width / c,
    k = s.height / p;
  return {
    width: C,
    height: k,
    top: E,
    right: x + C,
    bottom: E + k,
    left: x,
    x,
    y: E
  };
}
function yN(t) {
  var e = CE(t),
    i = t.offsetWidth,
    s = t.offsetHeight;
  return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - s) <= 1 && (s = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: i,
    height: s
  };
}
function a4(t, e) {
  var i = e.getRootNode && e.getRootNode();
  if (t.contains(e)) return !0;
  if (i && gN(i)) {
    var s = e;
    do {
      if (s && t.isSameNode(s)) return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function bb(t) {
  return sp(t).getComputedStyle(t);
}
function FG(t) {
  return ["table", "td", "th"].indexOf(Zv(t)) >= 0;
}
function sw(t) {
  return ((Jx(t) ? t.ownerDocument :
  // $FlowFixMe[prop-missing]
  t.document) || window.document).documentElement;
}
function XL(t) {
  return Zv(t) === "html" ? t :
  // this is a quicker (but less type safe) way to save quite some bytes from the bundle
  // $FlowFixMe[incompatible-return]
  // $FlowFixMe[prop-missing]
  t.assignedSlot ||
  // step into the shadow DOM of the parent of a slotted node
  t.parentNode || (
  // DOM Element detected
  gN(t) ? t.host : null) ||
  // ShadowRoot detected
  // $FlowFixMe[incompatible-call]: HTMLElement is a Node
  sw(t);
}
function LV(t) {
  return !Vp(t) ||
  // https://github.com/popperjs/popper-core/issues/837
  bb(t).position === "fixed" ? null : t.offsetParent;
}
function NG(t) {
  var e = /firefox/i.test(L2()),
    i = /Trident/i.test(L2());
  if (i && Vp(t)) {
    var s = bb(t);
    if (s.position === "fixed") return null;
  }
  var c = XL(t);
  for (gN(c) && (c = c.host); Vp(c) && ["html", "body"].indexOf(Zv(c)) < 0;) {
    var p = bb(c);
    if (p.transform !== "none" || p.perspective !== "none" || p.contain === "paint" || ["transform", "perspective"].indexOf(p.willChange) !== -1 || e && p.willChange === "filter" || e && p.filter && p.filter !== "none") return c;
    c = c.parentNode;
  }
  return null;
}
function UR(t) {
  for (var e = sp(t), i = LV(t); i && FG(i) && bb(i).position === "static";) i = LV(i);
  return i && (Zv(i) === "html" || Zv(i) === "body" && bb(i).position === "static") ? e : i || NG(t) || e;
}
function bN(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function UT(t, e, i) {
  return Yx(t, yL(e, i));
}
function zG(t, e, i) {
  var s = UT(t, e, i);
  return s > i ? i : s;
}
function o4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function l4(t) {
  return Object.assign({}, o4(), t);
}
function s4(t, e) {
  return e.reduce(function (i, s) {
    return i[s] = t, i;
  }, {});
}
var VG = function (t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, l4(typeof t != "number" ? t : s4(t, BR));
};
function BG(t) {
  var e,
    i = t.state,
    s = t.name,
    c = t.options,
    p = i.elements.arrow,
    h = i.modifiersData.popperOffsets,
    y = Gv(i.placement),
    w = bN(y),
    x = [cd, $p].indexOf(y) >= 0,
    E = x ? "height" : "width";
  if (!(!p || !h)) {
    var C = VG(c.padding, i),
      k = yN(p),
      D = w === "y" ? ud : cd,
      I = w === "y" ? Hp : $p,
      L = i.rects.reference[E] + i.rects.reference[w] - h[w] - i.rects.popper[E],
      P = h[w] - i.rects.reference[w],
      N = UR(p),
      O = N ? w === "y" ? N.clientHeight || 0 : N.clientWidth || 0 : 0,
      F = L / 2 - P / 2,
      j = C[D],
      V = O - k[E] - C[I],
      K = O / 2 - k[E] / 2 + F,
      G = UT(j, K, V),
      Q = w;
    i.modifiersData[s] = (e = {}, e[Q] = G, e.centerOffset = G - K, e);
  }
}
function UG(t) {
  var e = t.state,
    i = t.options,
    s = i.element,
    c = s === void 0 ? "[data-popper-arrow]" : s;
  c != null && (typeof c == "string" && (c = e.elements.popper.querySelector(c), !c) || a4(e.elements.popper, c) && (e.elements.arrow = c));
}
const HG = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: BG,
  effect: UG,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function kE(t) {
  return t.split("-")[1];
}
var $G = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function WG(t, e) {
  var i = t.x,
    s = t.y,
    c = e.devicePixelRatio || 1;
  return {
    x: EE(i * c) / c || 0,
    y: EE(s * c) / c || 0
  };
}
function OV(t) {
  var e,
    i = t.popper,
    s = t.popperRect,
    c = t.placement,
    p = t.variation,
    h = t.offsets,
    y = t.position,
    w = t.gpuAcceleration,
    x = t.adaptive,
    E = t.roundOffsets,
    C = t.isFixed,
    k = h.x,
    D = k === void 0 ? 0 : k,
    I = h.y,
    L = I === void 0 ? 0 : I,
    P = typeof E == "function" ? E({
      x: D,
      y: L
    }) : {
      x: D,
      y: L
    };
  D = P.x, L = P.y;
  var N = h.hasOwnProperty("x"),
    O = h.hasOwnProperty("y"),
    F = cd,
    j = ud,
    V = window;
  if (x) {
    var K = UR(i),
      G = "clientHeight",
      Q = "clientWidth";
    if (K === sp(i) && (K = sw(i), bb(K).position !== "static" && y === "absolute" && (G = "scrollHeight", Q = "scrollWidth")), K = K, c === ud || (c === cd || c === $p) && p === lR) {
      j = Hp;
      var te = C && K === V && V.visualViewport ? V.visualViewport.height :
      // $FlowFixMe[prop-missing]
      K[G];
      L -= te - s.height, L *= w ? 1 : -1;
    }
    if (c === cd || (c === ud || c === Hp) && p === lR) {
      F = $p;
      var ie = C && K === V && V.visualViewport ? V.visualViewport.width :
      // $FlowFixMe[prop-missing]
      K[Q];
      D -= ie - s.width, D *= w ? 1 : -1;
    }
  }
  var Y = Object.assign({
      position: y
    }, x && $G),
    ee = E === !0 ? WG({
      x: D,
      y: L
    }, sp(i)) : {
      x: D,
      y: L
    };
  if (D = ee.x, L = ee.y, w) {
    var ae;
    return Object.assign({}, Y, (ae = {}, ae[j] = O ? "0" : "", ae[F] = N ? "0" : "", ae.transform = (V.devicePixelRatio || 1) <= 1 ? "translate(" + D + "px, " + L + "px)" : "translate3d(" + D + "px, " + L + "px, 0)", ae));
  }
  return Object.assign({}, Y, (e = {}, e[j] = O ? L + "px" : "", e[F] = N ? D + "px" : "", e.transform = "", e));
}
function qG(t) {
  var e = t.state,
    i = t.options,
    s = i.gpuAcceleration,
    c = s === void 0 ? !0 : s,
    p = i.adaptive,
    h = p === void 0 ? !0 : p,
    y = i.roundOffsets,
    w = y === void 0 ? !0 : y,
    x = {
      placement: Gv(e.placement),
      variation: kE(e.placement),
      popper: e.elements.popper,
      popperRect: e.rects.popper,
      gpuAcceleration: c,
      isFixed: e.options.strategy === "fixed"
    };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, OV(Object.assign({}, x, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: h,
    roundOffsets: w
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, OV(Object.assign({}, x, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: w
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const YG = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: qG,
  data: {}
};
var cM = {
  passive: !0
};
function GG(t) {
  var e = t.state,
    i = t.instance,
    s = t.options,
    c = s.scroll,
    p = c === void 0 ? !0 : c,
    h = s.resize,
    y = h === void 0 ? !0 : h,
    w = sp(e.elements.popper),
    x = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return p && x.forEach(function (E) {
    E.addEventListener("scroll", i.update, cM);
  }), y && w.addEventListener("resize", i.update, cM), function () {
    p && x.forEach(function (E) {
      E.removeEventListener("scroll", i.update, cM);
    }), y && w.removeEventListener("resize", i.update, cM);
  };
}
const XG = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function () {},
  effect: GG,
  data: {}
};
var KG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function UM(t) {
  return t.replace(/left|right|bottom|top/g, function (e) {
    return KG[e];
  });
}
var QG = {
  start: "end",
  end: "start"
};
function PV(t) {
  return t.replace(/start|end/g, function (e) {
    return QG[e];
  });
}
function wN(t) {
  var e = sp(t),
    i = e.pageXOffset,
    s = e.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: s
  };
}
function _N(t) {
  return CE(sw(t)).left + wN(t).scrollLeft;
}
function ZG(t, e) {
  var i = sp(t),
    s = sw(t),
    c = i.visualViewport,
    p = s.clientWidth,
    h = s.clientHeight,
    y = 0,
    w = 0;
  if (c) {
    p = c.width, h = c.height;
    var x = i4();
    (x || !x && e === "fixed") && (y = c.offsetLeft, w = c.offsetTop);
  }
  return {
    width: p,
    height: h,
    x: y + _N(t),
    y: w
  };
}
function JG(t) {
  var e,
    i = sw(t),
    s = wN(t),
    c = (e = t.ownerDocument) == null ? void 0 : e.body,
    p = Yx(i.scrollWidth, i.clientWidth, c ? c.scrollWidth : 0, c ? c.clientWidth : 0),
    h = Yx(i.scrollHeight, i.clientHeight, c ? c.scrollHeight : 0, c ? c.clientHeight : 0),
    y = -s.scrollLeft + _N(t),
    w = -s.scrollTop;
  return bb(c || i).direction === "rtl" && (y += Yx(i.clientWidth, c ? c.clientWidth : 0) - p), {
    width: p,
    height: h,
    x: y,
    y: w
  };
}
function xN(t) {
  var e = bb(t),
    i = e.overflow,
    s = e.overflowX,
    c = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + c + s);
}
function u4(t) {
  return ["html", "body", "#document"].indexOf(Zv(t)) >= 0 ? t.ownerDocument.body : Vp(t) && xN(t) ? t : u4(XL(t));
}
function HT(t, e) {
  var i;
  e === void 0 && (e = []);
  var s = u4(t),
    c = s === ((i = t.ownerDocument) == null ? void 0 : i.body),
    p = sp(s),
    h = c ? [p].concat(p.visualViewport || [], xN(s) ? s : []) : s,
    y = e.concat(h);
  return c ? y :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  y.concat(HT(XL(h)));
}
function O2(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function eX(t, e) {
  var i = CE(t, !1, e === "fixed");
  return i.top = i.top + t.clientTop, i.left = i.left + t.clientLeft, i.bottom = i.top + t.clientHeight, i.right = i.left + t.clientWidth, i.width = t.clientWidth, i.height = t.clientHeight, i.x = i.left, i.y = i.top, i;
}
function AV(t, e, i) {
  return e === t4 ? O2(ZG(t, i)) : Jx(e) ? eX(e, i) : O2(JG(sw(t)));
}
function tX(t) {
  var e = HT(XL(t)),
    i = ["absolute", "fixed"].indexOf(bb(t).position) >= 0,
    s = i && Vp(t) ? UR(t) : t;
  return Jx(s) ? e.filter(function (c) {
    return Jx(c) && a4(c, s) && Zv(c) !== "body";
  }) : [];
}
function nX(t, e, i, s) {
  var c = e === "clippingParents" ? tX(t) : [].concat(e),
    p = [].concat(c, [i]),
    h = p[0],
    y = p.reduce(function (w, x) {
      var E = AV(t, x, s);
      return w.top = Yx(E.top, w.top), w.right = yL(E.right, w.right), w.bottom = yL(E.bottom, w.bottom), w.left = Yx(E.left, w.left), w;
    }, AV(t, h, s));
  return y.width = y.right - y.left, y.height = y.bottom - y.top, y.x = y.left, y.y = y.top, y;
}
function c4(t) {
  var e = t.reference,
    i = t.element,
    s = t.placement,
    c = s ? Gv(s) : null,
    p = s ? kE(s) : null,
    h = e.x + e.width / 2 - i.width / 2,
    y = e.y + e.height / 2 - i.height / 2,
    w;
  switch (c) {
    case ud:
      w = {
        x: h,
        y: e.y - i.height
      };
      break;
    case Hp:
      w = {
        x: h,
        y: e.y + e.height
      };
      break;
    case $p:
      w = {
        x: e.x + e.width,
        y
      };
      break;
    case cd:
      w = {
        x: e.x - i.width,
        y
      };
      break;
    default:
      w = {
        x: e.x,
        y: e.y
      };
  }
  var x = c ? bN(c) : null;
  if (x != null) {
    var E = x === "y" ? "height" : "width";
    switch (p) {
      case SE:
        w[x] = w[x] - (e[E] / 2 - i[E] / 2);
        break;
      case lR:
        w[x] = w[x] + (e[E] / 2 - i[E] / 2);
        break;
    }
  }
  return w;
}
function sR(t, e) {
  e === void 0 && (e = {});
  var i = e,
    s = i.placement,
    c = s === void 0 ? t.placement : s,
    p = i.strategy,
    h = p === void 0 ? t.strategy : p,
    y = i.boundary,
    w = y === void 0 ? SG : y,
    x = i.rootBoundary,
    E = x === void 0 ? t4 : x,
    C = i.elementContext,
    k = C === void 0 ? bT : C,
    D = i.altBoundary,
    I = D === void 0 ? !1 : D,
    L = i.padding,
    P = L === void 0 ? 0 : L,
    N = l4(typeof P != "number" ? P : s4(P, BR)),
    O = k === bT ? EG : bT,
    F = t.rects.popper,
    j = t.elements[I ? O : k],
    V = nX(Jx(j) ? j : j.contextElement || sw(t.elements.popper), w, E, h),
    K = CE(t.elements.reference),
    G = c4({
      reference: K,
      element: F,
      placement: c
    }),
    Q = O2(Object.assign({}, F, G)),
    te = k === bT ? Q : K,
    ie = {
      top: V.top - te.top + N.top,
      bottom: te.bottom - V.bottom + N.bottom,
      left: V.left - te.left + N.left,
      right: te.right - V.right + N.right
    },
    Y = t.modifiersData.offset;
  if (k === bT && Y) {
    var ee = Y[c];
    Object.keys(ie).forEach(function (ae) {
      var ne = [$p, Hp].indexOf(ae) >= 0 ? 1 : -1,
        le = [ud, Hp].indexOf(ae) >= 0 ? "y" : "x";
      ie[ae] += ee[le] * ne;
    });
  }
  return ie;
}
function rX(t, e) {
  e === void 0 && (e = {});
  var i = e,
    s = i.placement,
    c = i.boundary,
    p = i.rootBoundary,
    h = i.padding,
    y = i.flipVariations,
    w = i.allowedAutoPlacements,
    x = w === void 0 ? n4 : w,
    E = kE(s),
    C = E ? y ? MV : MV.filter(function (I) {
      return kE(I) === E;
    }) : BR,
    k = C.filter(function (I) {
      return x.indexOf(I) >= 0;
    });
  k.length === 0 && (k = C);
  var D = k.reduce(function (I, L) {
    return I[L] = sR(t, {
      placement: L,
      boundary: c,
      rootBoundary: p,
      padding: h
    })[Gv(L)], I;
  }, {});
  return Object.keys(D).sort(function (I, L) {
    return D[I] - D[L];
  });
}
function iX(t) {
  if (Gv(t) === vN) return [];
  var e = UM(t);
  return [PV(t), e, PV(e)];
}
function aX(t) {
  var e = t.state,
    i = t.options,
    s = t.name;
  if (!e.modifiersData[s]._skip) {
    for (var c = i.mainAxis, p = c === void 0 ? !0 : c, h = i.altAxis, y = h === void 0 ? !0 : h, w = i.fallbackPlacements, x = i.padding, E = i.boundary, C = i.rootBoundary, k = i.altBoundary, D = i.flipVariations, I = D === void 0 ? !0 : D, L = i.allowedAutoPlacements, P = e.options.placement, N = Gv(P), O = N === P, F = w || (O || !I ? [UM(P)] : iX(P)), j = [P].concat(F).reduce(function (Ce, fe) {
        return Ce.concat(Gv(fe) === vN ? rX(e, {
          placement: fe,
          boundary: E,
          rootBoundary: C,
          padding: x,
          flipVariations: I,
          allowedAutoPlacements: L
        }) : fe);
      }, []), V = e.rects.reference, K = e.rects.popper, G = /* @__PURE__ */new Map(), Q = !0, te = j[0], ie = 0; ie < j.length; ie++) {
      var Y = j[ie],
        ee = Gv(Y),
        ae = kE(Y) === SE,
        ne = [ud, Hp].indexOf(ee) >= 0,
        le = ne ? "width" : "height",
        ce = sR(e, {
          placement: Y,
          boundary: E,
          rootBoundary: C,
          altBoundary: k,
          padding: x
        }),
        W = ne ? ae ? $p : cd : ae ? Hp : ud;
      V[le] > K[le] && (W = UM(W));
      var $ = UM(W),
        de = [];
      if (p && de.push(ce[ee] <= 0), y && de.push(ce[W] <= 0, ce[$] <= 0), de.every(function (Ce) {
        return Ce;
      })) {
        te = Y, Q = !1;
        break;
      }
      G.set(Y, de);
    }
    if (Q) for (var H = I ? 3 : 1, se = function (Ce) {
        var fe = j.find(function (_e) {
          var Se = G.get(_e);
          if (Se) return Se.slice(0, Ce).every(function (be) {
            return be;
          });
        });
        if (fe) return te = fe, "break";
      }, ue = H; ue > 0; ue--) {
      var Ee = se(ue);
      if (Ee === "break") break;
    }
    e.placement !== te && (e.modifiersData[s]._skip = !0, e.placement = te, e.reset = !0);
  }
}
const oX = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: aX,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function jV(t, e, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - i.y,
    right: t.right - e.width + i.x,
    bottom: t.bottom - e.height + i.y,
    left: t.left - e.width - i.x
  };
}
function FV(t) {
  return [ud, $p, Hp, cd].some(function (e) {
    return t[e] >= 0;
  });
}
function lX(t) {
  var e = t.state,
    i = t.name,
    s = e.rects.reference,
    c = e.rects.popper,
    p = e.modifiersData.preventOverflow,
    h = sR(e, {
      elementContext: "reference"
    }),
    y = sR(e, {
      altBoundary: !0
    }),
    w = jV(h, s),
    x = jV(y, c, p),
    E = FV(w),
    C = FV(x);
  e.modifiersData[i] = {
    referenceClippingOffsets: w,
    popperEscapeOffsets: x,
    isReferenceHidden: E,
    hasPopperEscaped: C
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": E,
    "data-popper-escaped": C
  });
}
const sX = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: lX
};
function uX(t, e, i) {
  var s = Gv(t),
    c = [cd, ud].indexOf(s) >= 0 ? -1 : 1,
    p = typeof i == "function" ? i(Object.assign({}, e, {
      placement: t
    })) : i,
    h = p[0],
    y = p[1];
  return h = h || 0, y = (y || 0) * c, [cd, $p].indexOf(s) >= 0 ? {
    x: y,
    y: h
  } : {
    x: h,
    y
  };
}
function cX(t) {
  var e = t.state,
    i = t.options,
    s = t.name,
    c = i.offset,
    p = c === void 0 ? [0, 0] : c,
    h = n4.reduce(function (E, C) {
      return E[C] = uX(C, e.rects, p), E;
    }, {}),
    y = h[e.placement],
    w = y.x,
    x = y.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += w, e.modifiersData.popperOffsets.y += x), e.modifiersData[s] = h;
}
const dX = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: cX
};
function fX(t) {
  var e = t.state,
    i = t.name;
  e.modifiersData[i] = c4({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const pX = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: fX,
  data: {}
};
function hX(t) {
  return t === "x" ? "y" : "x";
}
function mX(t) {
  var e = t.state,
    i = t.options,
    s = t.name,
    c = i.mainAxis,
    p = c === void 0 ? !0 : c,
    h = i.altAxis,
    y = h === void 0 ? !1 : h,
    w = i.boundary,
    x = i.rootBoundary,
    E = i.altBoundary,
    C = i.padding,
    k = i.tether,
    D = k === void 0 ? !0 : k,
    I = i.tetherOffset,
    L = I === void 0 ? 0 : I,
    P = sR(e, {
      boundary: w,
      rootBoundary: x,
      padding: C,
      altBoundary: E
    }),
    N = Gv(e.placement),
    O = kE(e.placement),
    F = !O,
    j = bN(N),
    V = hX(j),
    K = e.modifiersData.popperOffsets,
    G = e.rects.reference,
    Q = e.rects.popper,
    te = typeof L == "function" ? L(Object.assign({}, e.rects, {
      placement: e.placement
    })) : L,
    ie = typeof te == "number" ? {
      mainAxis: te,
      altAxis: te
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, te),
    Y = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null,
    ee = {
      x: 0,
      y: 0
    };
  if (K) {
    if (p) {
      var ae,
        ne = j === "y" ? ud : cd,
        le = j === "y" ? Hp : $p,
        ce = j === "y" ? "height" : "width",
        W = K[j],
        $ = W + P[ne],
        de = W - P[le],
        H = D ? -Q[ce] / 2 : 0,
        se = O === SE ? G[ce] : Q[ce],
        ue = O === SE ? -Q[ce] : -G[ce],
        Ee = e.elements.arrow,
        Ce = D && Ee ? yN(Ee) : {
          width: 0,
          height: 0
        },
        fe = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : o4(),
        _e = fe[ne],
        Se = fe[le],
        be = UT(0, G[ce], Ce[ce]),
        Le = F ? G[ce] / 2 - H - be - _e - ie.mainAxis : se - be - _e - ie.mainAxis,
        Be = F ? -G[ce] / 2 + H + be + Se + ie.mainAxis : ue + be + Se + ie.mainAxis,
        Xe = e.elements.arrow && UR(e.elements.arrow),
        ge = Xe ? j === "y" ? Xe.clientTop || 0 : Xe.clientLeft || 0 : 0,
        qe = (ae = Y == null ? void 0 : Y[j]) != null ? ae : 0,
        Ae = W + Le - qe - ge,
        Mt = W + Be - qe,
        Ft = UT(D ? yL($, Ae) : $, W, D ? Yx(de, Mt) : de);
      K[j] = Ft, ee[j] = Ft - W;
    }
    if (y) {
      var un,
        gt = j === "x" ? ud : cd,
        Pt = j === "x" ? Hp : $p,
        St = K[V],
        Dt = V === "y" ? "height" : "width",
        Kt = St + P[gt],
        hn = St - P[Pt],
        Lt = [ud, cd].indexOf(N) !== -1,
        Et = (un = Y == null ? void 0 : Y[V]) != null ? un : 0,
        Vt = Lt ? Kt : St - G[Dt] - Q[Dt] - Et + ie.altAxis,
        Xt = Lt ? St + G[Dt] + Q[Dt] - Et - ie.altAxis : hn,
        vn = D && Lt ? zG(Vt, St, Xt) : UT(D ? Vt : Kt, St, D ? Xt : hn);
      K[V] = vn, ee[V] = vn - St;
    }
    e.modifiersData[s] = ee;
  }
}
const vX = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mX,
  requiresIfExists: ["offset"]
};
function gX(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function yX(t) {
  return t === sp(t) || !Vp(t) ? wN(t) : gX(t);
}
function bX(t) {
  var e = t.getBoundingClientRect(),
    i = EE(e.width) / t.offsetWidth || 1,
    s = EE(e.height) / t.offsetHeight || 1;
  return i !== 1 || s !== 1;
}
function wX(t, e, i) {
  i === void 0 && (i = !1);
  var s = Vp(e),
    c = Vp(e) && bX(e),
    p = sw(e),
    h = CE(t, c, i),
    y = {
      scrollLeft: 0,
      scrollTop: 0
    },
    w = {
      x: 0,
      y: 0
    };
  return (s || !s && !i) && ((Zv(e) !== "body" ||
  // https://github.com/popperjs/popper-core/issues/1078
  xN(p)) && (y = yX(e)), Vp(e) ? (w = CE(e, !0), w.x += e.clientLeft, w.y += e.clientTop) : p && (w.x = _N(p))), {
    x: h.left + y.scrollLeft - w.x,
    y: h.top + y.scrollTop - w.y,
    width: h.width,
    height: h.height
  };
}
function _X(t) {
  var e = /* @__PURE__ */new Map(),
    i = /* @__PURE__ */new Set(),
    s = [];
  t.forEach(function (p) {
    e.set(p.name, p);
  });
  function c(p) {
    i.add(p.name);
    var h = [].concat(p.requires || [], p.requiresIfExists || []);
    h.forEach(function (y) {
      if (!i.has(y)) {
        var w = e.get(y);
        w && c(w);
      }
    }), s.push(p);
  }
  return t.forEach(function (p) {
    i.has(p.name) || c(p);
  }), s;
}
function xX(t) {
  var e = _X(t);
  return PG.reduce(function (i, s) {
    return i.concat(e.filter(function (c) {
      return c.phase === s;
    }));
  }, []);
}
function SX(t) {
  var e;
  return function () {
    return e || (e = new Promise(function (i) {
      Promise.resolve().then(function () {
        e = void 0, i(t());
      });
    })), e;
  };
}
function EX(t) {
  var e = t.reduce(function (i, s) {
    var c = i[s.name];
    return i[s.name] = c ? Object.assign({}, c, s, {
      options: Object.assign({}, c.options, s.options),
      data: Object.assign({}, c.data, s.data)
    }) : s, i;
  }, {});
  return Object.keys(e).map(function (i) {
    return e[i];
  });
}
var NV = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function zV() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
  return !e.some(function (s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function CX(t) {
  t === void 0 && (t = {});
  var e = t,
    i = e.defaultModifiers,
    s = i === void 0 ? [] : i,
    c = e.defaultOptions,
    p = c === void 0 ? NV : c;
  return function (h, y, w) {
    w === void 0 && (w = p);
    var x = {
        placement: "bottom",
        orderedModifiers: [],
        options: Object.assign({}, NV, p),
        modifiersData: {},
        elements: {
          reference: h,
          popper: y
        },
        attributes: {},
        styles: {}
      },
      E = [],
      C = !1,
      k = {
        state: x,
        setOptions: function (L) {
          var P = typeof L == "function" ? L(x.options) : L;
          I(), x.options = Object.assign({}, p, x.options, P), x.scrollParents = {
            reference: Jx(h) ? HT(h) : h.contextElement ? HT(h.contextElement) : [],
            popper: HT(y)
          };
          var N = xX(EX([].concat(s, x.options.modifiers)));
          return x.orderedModifiers = N.filter(function (O) {
            return O.enabled;
          }), D(), k.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function () {
          if (!C) {
            var L = x.elements,
              P = L.reference,
              N = L.popper;
            if (zV(P, N)) {
              x.rects = {
                reference: wX(P, UR(N), x.options.strategy === "fixed"),
                popper: yN(N)
              }, x.reset = !1, x.placement = x.options.placement, x.orderedModifiers.forEach(function (Q) {
                return x.modifiersData[Q.name] = Object.assign({}, Q.data);
              });
              for (var O = 0; O < x.orderedModifiers.length; O++) {
                if (x.reset === !0) {
                  x.reset = !1, O = -1;
                  continue;
                }
                var F = x.orderedModifiers[O],
                  j = F.fn,
                  V = F.options,
                  K = V === void 0 ? {} : V,
                  G = F.name;
                typeof j == "function" && (x = j({
                  state: x,
                  options: K,
                  name: G,
                  instance: k
                }) || x);
              }
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: SX(function () {
          return new Promise(function (L) {
            k.forceUpdate(), L(x);
          });
        }),
        destroy: function () {
          I(), C = !0;
        }
      };
    if (!zV(h, y)) return k;
    k.setOptions(w).then(function (L) {
      !C && w.onFirstUpdate && w.onFirstUpdate(L);
    });
    function D() {
      x.orderedModifiers.forEach(function (L) {
        var P = L.name,
          N = L.options,
          O = N === void 0 ? {} : N,
          F = L.effect;
        if (typeof F == "function") {
          var j = F({
              state: x,
              name: P,
              instance: k,
              options: O
            }),
            V = function () {};
          E.push(j || V);
        }
      });
    }
    function I() {
      E.forEach(function (L) {
        return L();
      }), E = [];
    }
    return k;
  };
}
var kX = [XG, pX, YG, r4, dX, oX, vX, HG, sX],
  TX = /* @__PURE__ */CX({
    defaultModifiers: kX
  }),
  RX = "tippy-box",
  d4 = "tippy-content",
  DX = "tippy-backdrop",
  f4 = "tippy-arrow",
  p4 = "tippy-svg-arrow",
  Vx = {
    passive: !0,
    capture: !0
  },
  h4 = function () {
    return document.body;
  };
function IX(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function gj(t, e, i) {
  if (Array.isArray(t)) {
    var s = t[e];
    return s ?? (Array.isArray(i) ? i[e] : i);
  }
  return t;
}
function SN(t, e) {
  var i = {}.toString.call(t);
  return i.indexOf("[object") === 0 && i.indexOf(e + "]") > -1;
}
function m4(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function VV(t, e) {
  if (e === 0) return t;
  var i;
  return function (s) {
    clearTimeout(i), i = setTimeout(function () {
      t(s);
    }, e);
  };
}
function MX(t, e) {
  var i = Object.assign({}, t);
  return e.forEach(function (s) {
    delete i[s];
  }), i;
}
function LX(t) {
  return t.split(/\s+/).filter(Boolean);
}
function rE(t) {
  return [].concat(t);
}
function BV(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function OX(t) {
  return t.filter(function (e, i) {
    return t.indexOf(e) === i;
  });
}
function PX(t) {
  return t.split("-")[0];
}
function bL(t) {
  return [].slice.call(t);
}
function UV(t) {
  return Object.keys(t).reduce(function (e, i) {
    return t[i] !== void 0 && (e[i] = t[i]), e;
  }, {});
}
function $T() {
  return document.createElement("div");
}
function uR(t) {
  return ["Element", "Fragment"].some(function (e) {
    return SN(t, e);
  });
}
function AX(t) {
  return SN(t, "NodeList");
}
function jX(t) {
  return SN(t, "MouseEvent");
}
function FX(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function NX(t) {
  return uR(t) ? [t] : AX(t) ? bL(t) : Array.isArray(t) ? t : bL(document.querySelectorAll(t));
}
function yj(t, e) {
  t.forEach(function (i) {
    i && (i.style.transitionDuration = e + "ms");
  });
}
function HV(t, e) {
  t.forEach(function (i) {
    i && i.setAttribute("data-state", e);
  });
}
function zX(t) {
  var e,
    i = rE(t),
    s = i[0];
  return s != null && (e = s.ownerDocument) != null && e.body ? s.ownerDocument : document;
}
function VX(t, e) {
  var i = e.clientX,
    s = e.clientY;
  return t.every(function (c) {
    var p = c.popperRect,
      h = c.popperState,
      y = c.props,
      w = y.interactiveBorder,
      x = PX(h.placement),
      E = h.modifiersData.offset;
    if (!E) return !0;
    var C = x === "bottom" ? E.top.y : 0,
      k = x === "top" ? E.bottom.y : 0,
      D = x === "right" ? E.left.x : 0,
      I = x === "left" ? E.right.x : 0,
      L = p.top - s + C > w,
      P = s - p.bottom - k > w,
      N = p.left - i + D > w,
      O = i - p.right - I > w;
    return L || P || N || O;
  });
}
function bj(t, e, i) {
  var s = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function (c) {
    t[s](c, i);
  });
}
function $V(t, e) {
  for (var i = e; i;) {
    var s;
    if (t.contains(i)) return !0;
    i = i.getRootNode == null || (s = i.getRootNode()) == null ? void 0 : s.host;
  }
  return !1;
}
var Wv = {
    isTouch: !1
  },
  WV = 0;
function BX() {
  Wv.isTouch || (Wv.isTouch = !0, window.performance && document.addEventListener("mousemove", v4));
}
function v4() {
  var t = performance.now();
  t - WV < 20 && (Wv.isTouch = !1, document.removeEventListener("mousemove", v4)), WV = t;
}
function UX() {
  var t = document.activeElement;
  if (FX(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function HX() {
  document.addEventListener("touchstart", BX, Vx), window.addEventListener("blur", UX);
}
var $X = typeof window < "u" && typeof document < "u",
  WX = $X ?
  // @ts-ignore
  !!window.msCrypto : !1;
function Y1(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function qV(t) {
  var e = /[ \t]{2,}/g,
    i = /^[ \t]*/gm;
  return t.replace(e, " ").replace(i, "").trim();
}
function qX(t) {
  return qV(`
  %ctippy.js

  %c` + qV(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function g4(t) {
  return [qX(t),
  // title
  "color: #00C584; font-size: 1.3em; font-weight: bold;",
  // message
  "line-height: 1.5",
  // footer
  "color: #a6a095;"];
}
var cR;
process.env.NODE_ENV !== "production" && YX();
function YX() {
  cR = /* @__PURE__ */new Set();
}
function cb(t, e) {
  if (t && !cR.has(e)) {
    var i;
    cR.add(e), (i = console).warn.apply(i, g4(e));
  }
}
function P2(t, e) {
  if (t && !cR.has(e)) {
    var i;
    cR.add(e), (i = console).error.apply(i, g4(e));
  }
}
function GX(t) {
  var e = !t,
    i = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  P2(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), P2(i, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var y4 = {
    animateFill: !1,
    followCursor: !1,
    inlinePositioning: !1,
    sticky: !1
  },
  XX = {
    allowHTML: !1,
    animation: "fade",
    arrow: !0,
    content: "",
    inertia: !1,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
  },
  ap = Object.assign({
    appendTo: h4,
    aria: {
      content: "auto",
      expanded: "auto"
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: !0,
    ignoreAttributes: !1,
    interactive: !1,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [0, 10],
    onAfterUpdate: function () {},
    onBeforeUpdate: function () {},
    onCreate: function () {},
    onDestroy: function () {},
    onHidden: function () {},
    onHide: function () {},
    onMount: function () {},
    onShow: function () {},
    onShown: function () {},
    onTrigger: function () {},
    onUntrigger: function () {},
    onClickOutside: function () {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: !1,
    touch: !0,
    trigger: "mouseenter focus",
    triggerTarget: null
  }, y4, XX),
  KX = Object.keys(ap),
  QX = function (t) {
    process.env.NODE_ENV !== "production" && w4(t, []);
    var e = Object.keys(t);
    e.forEach(function (i) {
      ap[i] = t[i];
    });
  };
function b4(t) {
  var e = t.plugins || [],
    i = e.reduce(function (s, c) {
      var p = c.name,
        h = c.defaultValue;
      if (p) {
        var y;
        s[p] = t[p] !== void 0 ? t[p] : (y = ap[p]) != null ? y : h;
      }
      return s;
    }, {});
  return Object.assign({}, t, i);
}
function ZX(t, e) {
  var i = e ? Object.keys(b4(Object.assign({}, ap, {
      plugins: e
    }))) : KX,
    s = i.reduce(function (c, p) {
      var h = (t.getAttribute("data-tippy-" + p) || "").trim();
      if (!h) return c;
      if (p === "content") c[p] = h;else try {
        c[p] = JSON.parse(h);
      } catch {
        c[p] = h;
      }
      return c;
    }, {});
  return s;
}
function YV(t, e) {
  var i = Object.assign({}, e, {
    content: m4(e.content, [t])
  }, e.ignoreAttributes ? {} : ZX(t, e.plugins));
  return i.aria = Object.assign({}, ap.aria, i.aria), i.aria = {
    expanded: i.aria.expanded === "auto" ? e.interactive : i.aria.expanded,
    content: i.aria.content === "auto" ? e.interactive ? null : "describedby" : i.aria.content
  }, i;
}
function w4(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var i = Object.keys(t);
  i.forEach(function (s) {
    var c = MX(ap, Object.keys(y4)),
      p = !IX(c, s);
    p && (p = e.filter(function (h) {
      return h.name === s;
    }).length === 0), cb(p, ["`" + s + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var JX = function () {
  return "innerHTML";
};
function A2(t, e) {
  t[JX()] = e;
}
function GV(t) {
  var e = $T();
  return t === !0 ? e.className = f4 : (e.className = p4, uR(t) ? e.appendChild(t) : A2(e, t)), e;
}
function XV(t, e) {
  uR(e.content) ? (A2(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? A2(t, e.content) : t.textContent = e.content);
}
function j2(t) {
  var e = t.firstElementChild,
    i = bL(e.children);
  return {
    box: e,
    content: i.find(function (s) {
      return s.classList.contains(d4);
    }),
    arrow: i.find(function (s) {
      return s.classList.contains(f4) || s.classList.contains(p4);
    }),
    backdrop: i.find(function (s) {
      return s.classList.contains(DX);
    })
  };
}
function _4(t) {
  var e = $T(),
    i = $T();
  i.className = RX, i.setAttribute("data-state", "hidden"), i.setAttribute("tabindex", "-1");
  var s = $T();
  s.className = d4, s.setAttribute("data-state", "hidden"), XV(s, t.props), e.appendChild(i), i.appendChild(s), c(t.props, t.props);
  function c(p, h) {
    var y = j2(e),
      w = y.box,
      x = y.content,
      E = y.arrow;
    h.theme ? w.setAttribute("data-theme", h.theme) : w.removeAttribute("data-theme"), typeof h.animation == "string" ? w.setAttribute("data-animation", h.animation) : w.removeAttribute("data-animation"), h.inertia ? w.setAttribute("data-inertia", "") : w.removeAttribute("data-inertia"), w.style.maxWidth = typeof h.maxWidth == "number" ? h.maxWidth + "px" : h.maxWidth, h.role ? w.setAttribute("role", h.role) : w.removeAttribute("role"), (p.content !== h.content || p.allowHTML !== h.allowHTML) && XV(x, t.props), h.arrow ? E ? p.arrow !== h.arrow && (w.removeChild(E), w.appendChild(GV(h.arrow))) : w.appendChild(GV(h.arrow)) : E && w.removeChild(E);
  }
  return {
    popper: e,
    onUpdate: c
  };
}
_4.$$tippy = !0;
var eK = 1,
  dM = [],
  wj = [];
function tK(t, e) {
  var i = YV(t, Object.assign({}, ap, b4(UV(e)))),
    s,
    c,
    p,
    h = !1,
    y = !1,
    w = !1,
    x = !1,
    E,
    C,
    k,
    D = [],
    I = VV(Ae, i.interactiveDebounce),
    L,
    P = eK++,
    N = null,
    O = OX(i.plugins),
    F = {
      // Is the instance currently enabled?
      isEnabled: !0,
      // Is the tippy currently showing and not transitioning out?
      isVisible: !1,
      // Has the instance been destroyed?
      isDestroyed: !1,
      // Is the tippy currently mounted to the DOM?
      isMounted: !1,
      // Has the tippy finished transitioning in?
      isShown: !1
    },
    j = {
      // properties
      id: P,
      reference: t,
      popper: $T(),
      popperInstance: N,
      props: i,
      state: F,
      plugins: O,
      // methods
      clearDelayTimeouts: Vt,
      setProps: Xt,
      setContent: vn,
      show: ot,
      hide: We,
      hideWithInteractivity: ht,
      enable: Lt,
      disable: Et,
      unmount: Ke,
      destroy: yt
    };
  if (!i.render) return process.env.NODE_ENV !== "production" && P2(!0, "render() function has not been supplied."), j;
  var V = i.render(j),
    K = V.popper,
    G = V.onUpdate;
  K.setAttribute("data-tippy-root", ""), K.id = "tippy-" + j.id, j.popper = K, t._tippy = j, K._tippy = j;
  var Q = O.map(function (je) {
      return je.fn(j);
    }),
    te = t.hasAttribute("aria-expanded");
  return Xe(), H(), W(), $("onCreate", [j]), i.showOnCreate && Kt(), K.addEventListener("mouseenter", function () {
    j.props.interactive && j.state.isVisible && j.clearDelayTimeouts();
  }), K.addEventListener("mouseleave", function () {
    j.props.interactive && j.props.trigger.indexOf("mouseenter") >= 0 && ne().addEventListener("mousemove", I);
  }), j;
  function ie() {
    var je = j.props.touch;
    return Array.isArray(je) ? je : [je, 0];
  }
  function Y() {
    return ie()[0] === "hold";
  }
  function ee() {
    var je;
    return !!((je = j.props.render) != null && je.$$tippy);
  }
  function ae() {
    return L || t;
  }
  function ne() {
    var je = ae().parentNode;
    return je ? zX(je) : document;
  }
  function le() {
    return j2(K);
  }
  function ce(je) {
    return j.state.isMounted && !j.state.isVisible || Wv.isTouch || E && E.type === "focus" ? 0 : gj(j.props.delay, je ? 0 : 1, ap.delay);
  }
  function W(je) {
    je === void 0 && (je = !1), K.style.pointerEvents = j.props.interactive && !je ? "" : "none", K.style.zIndex = "" + j.props.zIndex;
  }
  function $(je, at, kt) {
    if (kt === void 0 && (kt = !0), Q.forEach(function (Ht) {
      Ht[je] && Ht[je].apply(Ht, at);
    }), kt) {
      var Bt;
      (Bt = j.props)[je].apply(Bt, at);
    }
  }
  function de() {
    var je = j.props.aria;
    if (je.content) {
      var at = "aria-" + je.content,
        kt = K.id,
        Bt = rE(j.props.triggerTarget || t);
      Bt.forEach(function (Ht) {
        var sn = Ht.getAttribute(at);
        if (j.state.isVisible) Ht.setAttribute(at, sn ? sn + " " + kt : kt);else {
          var en = sn && sn.replace(kt, "").trim();
          en ? Ht.setAttribute(at, en) : Ht.removeAttribute(at);
        }
      });
    }
  }
  function H() {
    if (!(te || !j.props.aria.expanded)) {
      var je = rE(j.props.triggerTarget || t);
      je.forEach(function (at) {
        j.props.interactive ? at.setAttribute("aria-expanded", j.state.isVisible && at === ae() ? "true" : "false") : at.removeAttribute("aria-expanded");
      });
    }
  }
  function se() {
    ne().removeEventListener("mousemove", I), dM = dM.filter(function (je) {
      return je !== I;
    });
  }
  function ue(je) {
    if (!(Wv.isTouch && (w || je.type === "mousedown"))) {
      var at = je.composedPath && je.composedPath()[0] || je.target;
      if (!(j.props.interactive && $V(K, at))) {
        if (rE(j.props.triggerTarget || t).some(function (kt) {
          return $V(kt, at);
        })) {
          if (Wv.isTouch || j.state.isVisible && j.props.trigger.indexOf("click") >= 0) return;
        } else $("onClickOutside", [j, je]);
        j.props.hideOnClick === !0 && (j.clearDelayTimeouts(), j.hide(), y = !0, setTimeout(function () {
          y = !1;
        }), j.state.isMounted || _e());
      }
    }
  }
  function Ee() {
    w = !0;
  }
  function Ce() {
    w = !1;
  }
  function fe() {
    var je = ne();
    je.addEventListener("mousedown", ue, !0), je.addEventListener("touchend", ue, Vx), je.addEventListener("touchstart", Ce, Vx), je.addEventListener("touchmove", Ee, Vx);
  }
  function _e() {
    var je = ne();
    je.removeEventListener("mousedown", ue, !0), je.removeEventListener("touchend", ue, Vx), je.removeEventListener("touchstart", Ce, Vx), je.removeEventListener("touchmove", Ee, Vx);
  }
  function Se(je, at) {
    Le(je, function () {
      !j.state.isVisible && K.parentNode && K.parentNode.contains(K) && at();
    });
  }
  function be(je, at) {
    Le(je, at);
  }
  function Le(je, at) {
    var kt = le().box;
    function Bt(Ht) {
      Ht.target === kt && (bj(kt, "remove", Bt), at());
    }
    if (je === 0) return at();
    bj(kt, "remove", C), bj(kt, "add", Bt), C = Bt;
  }
  function Be(je, at, kt) {
    kt === void 0 && (kt = !1);
    var Bt = rE(j.props.triggerTarget || t);
    Bt.forEach(function (Ht) {
      Ht.addEventListener(je, at, kt), D.push({
        node: Ht,
        eventType: je,
        handler: at,
        options: kt
      });
    });
  }
  function Xe() {
    Y() && (Be("touchstart", qe, {
      passive: !0
    }), Be("touchend", Mt, {
      passive: !0
    })), LX(j.props.trigger).forEach(function (je) {
      if (je !== "manual") switch (Be(je, qe), je) {
        case "mouseenter":
          Be("mouseleave", Mt);
          break;
        case "focus":
          Be(WX ? "focusout" : "blur", Ft);
          break;
        case "focusin":
          Be("focusout", Ft);
          break;
      }
    });
  }
  function ge() {
    D.forEach(function (je) {
      var at = je.node,
        kt = je.eventType,
        Bt = je.handler,
        Ht = je.options;
      at.removeEventListener(kt, Bt, Ht);
    }), D = [];
  }
  function qe(je) {
    var at,
      kt = !1;
    if (!(!j.state.isEnabled || un(je) || y)) {
      var Bt = ((at = E) == null ? void 0 : at.type) === "focus";
      E = je, L = je.currentTarget, H(), !j.state.isVisible && jX(je) && dM.forEach(function (Ht) {
        return Ht(je);
      }), je.type === "click" && (j.props.trigger.indexOf("mouseenter") < 0 || h) && j.props.hideOnClick !== !1 && j.state.isVisible ? kt = !0 : Kt(je), je.type === "click" && (h = !kt), kt && !Bt && hn(je);
    }
  }
  function Ae(je) {
    var at = je.target,
      kt = ae().contains(at) || K.contains(at);
    if (!(je.type === "mousemove" && kt)) {
      var Bt = Dt().concat(K).map(function (Ht) {
        var sn,
          en = Ht._tippy,
          Rr = (sn = en.popperInstance) == null ? void 0 : sn.state;
        return Rr ? {
          popperRect: Ht.getBoundingClientRect(),
          popperState: Rr,
          props: i
        } : null;
      }).filter(Boolean);
      VX(Bt, je) && (se(), hn(je));
    }
  }
  function Mt(je) {
    var at = un(je) || j.props.trigger.indexOf("click") >= 0 && h;
    if (!at) {
      if (j.props.interactive) {
        j.hideWithInteractivity(je);
        return;
      }
      hn(je);
    }
  }
  function Ft(je) {
    j.props.trigger.indexOf("focusin") < 0 && je.target !== ae() || j.props.interactive && je.relatedTarget && K.contains(je.relatedTarget) || hn(je);
  }
  function un(je) {
    return Wv.isTouch ? Y() !== je.type.indexOf("touch") >= 0 : !1;
  }
  function gt() {
    Pt();
    var je = j.props,
      at = je.popperOptions,
      kt = je.placement,
      Bt = je.offset,
      Ht = je.getReferenceClientRect,
      sn = je.moveTransition,
      en = ee() ? j2(K).arrow : null,
      Rr = Ht ? {
        getBoundingClientRect: Ht,
        contextElement: Ht.contextElement || ae()
      } : t,
      Nr = {
        name: "$$tippy",
        enabled: !0,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: function (ss) {
          var yo = ss.state;
          if (ee()) {
            var _s = le(),
              Mo = _s.box;
            ["placement", "reference-hidden", "escaped"].forEach(function (bo) {
              bo === "placement" ? Mo.setAttribute("data-placement", yo.placement) : yo.attributes.popper["data-popper-" + bo] ? Mo.setAttribute("data-" + bo, "") : Mo.removeAttribute("data-" + bo);
            }), yo.attributes.popper = {};
          }
        }
      },
      Hi = [{
        name: "offset",
        options: {
          offset: Bt
        }
      }, {
        name: "preventOverflow",
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: "flip",
        options: {
          padding: 5
        }
      }, {
        name: "computeStyles",
        options: {
          adaptive: !sn
        }
      }, Nr];
    ee() && en && Hi.push({
      name: "arrow",
      options: {
        element: en,
        padding: 3
      }
    }), Hi.push.apply(Hi, (at == null ? void 0 : at.modifiers) || []), j.popperInstance = TX(Rr, K, Object.assign({}, at, {
      placement: kt,
      onFirstUpdate: k,
      modifiers: Hi
    }));
  }
  function Pt() {
    j.popperInstance && (j.popperInstance.destroy(), j.popperInstance = null);
  }
  function St() {
    var je = j.props.appendTo,
      at,
      kt = ae();
    j.props.interactive && je === h4 || je === "parent" ? at = kt.parentNode : at = m4(je, [kt]), at.contains(K) || at.appendChild(K), j.state.isMounted = !0, gt(), process.env.NODE_ENV !== "production" && cb(j.props.interactive && je === ap.appendTo && kt.nextElementSibling !== K, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Dt() {
    return bL(K.querySelectorAll("[data-tippy-root]"));
  }
  function Kt(je) {
    j.clearDelayTimeouts(), je && $("onTrigger", [j, je]), fe();
    var at = ce(!0),
      kt = ie(),
      Bt = kt[0],
      Ht = kt[1];
    Wv.isTouch && Bt === "hold" && Ht && (at = Ht), at ? s = setTimeout(function () {
      j.show();
    }, at) : j.show();
  }
  function hn(je) {
    if (j.clearDelayTimeouts(), $("onUntrigger", [j, je]), !j.state.isVisible) {
      _e();
      return;
    }
    if (!(j.props.trigger.indexOf("mouseenter") >= 0 && j.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(je.type) >= 0 && h)) {
      var at = ce(!1);
      at ? c = setTimeout(function () {
        j.state.isVisible && j.hide();
      }, at) : p = requestAnimationFrame(function () {
        j.hide();
      });
    }
  }
  function Lt() {
    j.state.isEnabled = !0;
  }
  function Et() {
    j.hide(), j.state.isEnabled = !1;
  }
  function Vt() {
    clearTimeout(s), clearTimeout(c), cancelAnimationFrame(p);
  }
  function Xt(je) {
    if (process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("setProps")), !j.state.isDestroyed) {
      $("onBeforeUpdate", [j, je]), ge();
      var at = j.props,
        kt = YV(t, Object.assign({}, at, UV(je), {
          ignoreAttributes: !0
        }));
      j.props = kt, Xe(), at.interactiveDebounce !== kt.interactiveDebounce && (se(), I = VV(Ae, kt.interactiveDebounce)), at.triggerTarget && !kt.triggerTarget ? rE(at.triggerTarget).forEach(function (Bt) {
        Bt.removeAttribute("aria-expanded");
      }) : kt.triggerTarget && t.removeAttribute("aria-expanded"), H(), W(), G && G(at, kt), j.popperInstance && (gt(), Dt().forEach(function (Bt) {
        requestAnimationFrame(Bt._tippy.popperInstance.forceUpdate);
      })), $("onAfterUpdate", [j, je]);
    }
  }
  function vn(je) {
    j.setProps({
      content: je
    });
  }
  function ot() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("show"));
    var je = j.state.isVisible,
      at = j.state.isDestroyed,
      kt = !j.state.isEnabled,
      Bt = Wv.isTouch && !j.props.touch,
      Ht = gj(j.props.duration, 0, ap.duration);
    if (!(je || at || kt || Bt) && !ae().hasAttribute("disabled") && ($("onShow", [j], !1), j.props.onShow(j) !== !1)) {
      if (j.state.isVisible = !0, ee() && (K.style.visibility = "visible"), W(), fe(), j.state.isMounted || (K.style.transition = "none"), ee()) {
        var sn = le(),
          en = sn.box,
          Rr = sn.content;
        yj([en, Rr], 0);
      }
      k = function () {
        var Nr;
        if (!(!j.state.isVisible || x)) {
          if (x = !0, K.offsetHeight, K.style.transition = j.props.moveTransition, ee() && j.props.animation) {
            var Hi = le(),
              ss = Hi.box,
              yo = Hi.content;
            yj([ss, yo], Ht), HV([ss, yo], "visible");
          }
          de(), H(), BV(wj, j), (Nr = j.popperInstance) == null || Nr.forceUpdate(), $("onMount", [j]), j.props.animation && ee() && be(Ht, function () {
            j.state.isShown = !0, $("onShown", [j]);
          });
        }
      }, St();
    }
  }
  function We() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("hide"));
    var je = !j.state.isVisible,
      at = j.state.isDestroyed,
      kt = !j.state.isEnabled,
      Bt = gj(j.props.duration, 1, ap.duration);
    if (!(je || at || kt) && ($("onHide", [j], !1), j.props.onHide(j) !== !1)) {
      if (j.state.isVisible = !1, j.state.isShown = !1, x = !1, h = !1, ee() && (K.style.visibility = "hidden"), se(), _e(), W(!0), ee()) {
        var Ht = le(),
          sn = Ht.box,
          en = Ht.content;
        j.props.animation && (yj([sn, en], Bt), HV([sn, en], "hidden"));
      }
      de(), H(), j.props.animation ? ee() && Se(Bt, j.unmount) : j.unmount();
    }
  }
  function ht(je) {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("hideWithInteractivity")), ne().addEventListener("mousemove", I), BV(dM, I), I(je);
  }
  function Ke() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("unmount")), j.state.isVisible && j.hide(), j.state.isMounted && (Pt(), Dt().forEach(function (je) {
      je._tippy.unmount();
    }), K.parentNode && K.parentNode.removeChild(K), wj = wj.filter(function (je) {
      return je !== j;
    }), j.state.isMounted = !1, $("onHidden", [j]));
  }
  function yt() {
    process.env.NODE_ENV !== "production" && cb(j.state.isDestroyed, Y1("destroy")), !j.state.isDestroyed && (j.clearDelayTimeouts(), j.unmount(), ge(), delete t._tippy, j.state.isDestroyed = !0, $("onDestroy", [j]));
  }
}
function HR(t, e) {
  e === void 0 && (e = {});
  var i = ap.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (GX(t), w4(e, i)), HX();
  var s = Object.assign({}, e, {
      plugins: i
    }),
    c = NX(t);
  if (process.env.NODE_ENV !== "production") {
    var p = uR(s.content),
      h = c.length > 1;
    cb(p && h, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var y = c.reduce(function (w, x) {
    var E = x && tK(x, s);
    return E && w.push(E), w;
  }, []);
  return uR(t) ? y[0] : y;
}
HR.defaultProps = ap;
HR.setDefaultProps = QX;
HR.currentInput = Wv;
Object.assign({}, r4, {
  effect: function (t) {
    var e = t.state,
      i = {
        popper: {
          position: e.options.strategy,
          left: "0",
          top: "0",
          margin: "0"
        },
        arrow: {
          position: "absolute"
        },
        reference: {}
      };
    Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow);
  }
});
HR.setDefaultProps({
  render: _4
});
var fM = {
    exports: {}
  },
  Qc = {},
  _j = {
    exports: {}
  },
  KV = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QV;
function nK() {
  return QV || (QV = 1, function (t) {
    function e($, de) {
      var H = $.length;
      $.push(de);
      e: for (; 0 < H;) {
        var se = H - 1 >>> 1,
          ue = $[se];
        if (0 < c(ue, de)) $[se] = de, $[H] = ue, H = se;else break e;
      }
    }
    function i($) {
      return $.length === 0 ? null : $[0];
    }
    function s($) {
      if ($.length === 0) return null;
      var de = $[0],
        H = $.pop();
      if (H !== de) {
        $[0] = H;
        e: for (var se = 0, ue = $.length, Ee = ue >>> 1; se < Ee;) {
          var Ce = 2 * (se + 1) - 1,
            fe = $[Ce],
            _e = Ce + 1,
            Se = $[_e];
          if (0 > c(fe, H)) _e < ue && 0 > c(Se, fe) ? ($[se] = Se, $[_e] = H, se = _e) : ($[se] = fe, $[Ce] = H, se = Ce);else if (_e < ue && 0 > c(Se, H)) $[se] = Se, $[_e] = H, se = _e;else break e;
        }
      }
      return de;
    }
    function c($, de) {
      var H = $.sortIndex - de.sortIndex;
      return H !== 0 ? H : $.id - de.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var p = performance;
      t.unstable_now = function () {
        return p.now();
      };
    } else {
      var h = Date,
        y = h.now();
      t.unstable_now = function () {
        return h.now() - y;
      };
    }
    var w = [],
      x = [],
      E = 1,
      C = null,
      k = 3,
      D = !1,
      I = !1,
      L = !1,
      P = typeof setTimeout == "function" ? setTimeout : null,
      N = typeof clearTimeout == "function" ? clearTimeout : null,
      O = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function F($) {
      for (var de = i(x); de !== null;) {
        if (de.callback === null) s(x);else if (de.startTime <= $) s(x), de.sortIndex = de.expirationTime, e(w, de);else break;
        de = i(x);
      }
    }
    function j($) {
      if (L = !1, F($), !I) if (i(w) !== null) I = !0, ce(V);else {
        var de = i(x);
        de !== null && W(j, de.startTime - $);
      }
    }
    function V($, de) {
      I = !1, L && (L = !1, N(Q), Q = -1), D = !0;
      var H = k;
      try {
        for (F(de), C = i(w); C !== null && (!(C.expirationTime > de) || $ && !Y());) {
          var se = C.callback;
          if (typeof se == "function") {
            C.callback = null, k = C.priorityLevel;
            var ue = se(C.expirationTime <= de);
            de = t.unstable_now(), typeof ue == "function" ? C.callback = ue : C === i(w) && s(w), F(de);
          } else s(w);
          C = i(w);
        }
        if (C !== null) var Ee = !0;else {
          var Ce = i(x);
          Ce !== null && W(j, Ce.startTime - de), Ee = !1;
        }
        return Ee;
      } finally {
        C = null, k = H, D = !1;
      }
    }
    var K = !1,
      G = null,
      Q = -1,
      te = 5,
      ie = -1;
    function Y() {
      return !(t.unstable_now() - ie < te);
    }
    function ee() {
      if (G !== null) {
        var $ = t.unstable_now();
        ie = $;
        var de = !0;
        try {
          de = G(!0, $);
        } finally {
          de ? ae() : (K = !1, G = null);
        }
      } else K = !1;
    }
    var ae;
    if (typeof O == "function") ae = function () {
      O(ee);
    };else if (typeof MessageChannel < "u") {
      var ne = new MessageChannel(),
        le = ne.port2;
      ne.port1.onmessage = ee, ae = function () {
        le.postMessage(null);
      };
    } else ae = function () {
      P(ee, 0);
    };
    function ce($) {
      G = $, K || (K = !0, ae());
    }
    function W($, de) {
      Q = P(function () {
        $(t.unstable_now());
      }, de);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function ($) {
      $.callback = null;
    }, t.unstable_continueExecution = function () {
      I || D || (I = !0, ce(V));
    }, t.unstable_forceFrameRate = function ($) {
      0 > $ || 125 < $ ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : te = 0 < $ ? Math.floor(1e3 / $) : 5;
    }, t.unstable_getCurrentPriorityLevel = function () {
      return k;
    }, t.unstable_getFirstCallbackNode = function () {
      return i(w);
    }, t.unstable_next = function ($) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var de = 3;
          break;
        default:
          de = k;
      }
      var H = k;
      k = de;
      try {
        return $();
      } finally {
        k = H;
      }
    }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = function () {}, t.unstable_runWithPriority = function ($, de) {
      switch ($) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          $ = 3;
      }
      var H = k;
      k = $;
      try {
        return de();
      } finally {
        k = H;
      }
    }, t.unstable_scheduleCallback = function ($, de, H) {
      var se = t.unstable_now();
      switch (typeof H == "object" && H !== null ? (H = H.delay, H = typeof H == "number" && 0 < H ? se + H : se) : H = se, $) {
        case 1:
          var ue = -1;
          break;
        case 2:
          ue = 250;
          break;
        case 5:
          ue = 1073741823;
          break;
        case 4:
          ue = 1e4;
          break;
        default:
          ue = 5e3;
      }
      return ue = H + ue, $ = {
        id: E++,
        callback: de,
        priorityLevel: $,
        startTime: H,
        expirationTime: ue,
        sortIndex: -1
      }, H > se ? ($.sortIndex = H, e(x, $), i(w) === null && $ === i(x) && (L ? (N(Q), Q = -1) : L = !0, W(j, H - se))) : ($.sortIndex = ue, e(w, $), I || D || (I = !0, ce(V))), $;
    }, t.unstable_shouldYield = Y, t.unstable_wrapCallback = function ($) {
      var de = k;
      return function () {
        var H = k;
        k = de;
        try {
          return $.apply(this, arguments);
        } finally {
          k = H;
        }
      };
    };
  }(KV)), KV;
}
var ZV = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JV;
function rK() {
  return JV || (JV = 1, function (t) {
    process.env.NODE_ENV !== "production" && function () {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1,
        i = 5;
      function s(ot, We) {
        var ht = ot.length;
        ot.push(We), h(ot, We, ht);
      }
      function c(ot) {
        return ot.length === 0 ? null : ot[0];
      }
      function p(ot) {
        if (ot.length === 0) return null;
        var We = ot[0],
          ht = ot.pop();
        return ht !== We && (ot[0] = ht, y(ot, ht, 0)), We;
      }
      function h(ot, We, ht) {
        for (var Ke = ht; Ke > 0;) {
          var yt = Ke - 1 >>> 1,
            je = ot[yt];
          if (w(je, We) > 0) ot[yt] = We, ot[Ke] = je, Ke = yt;else return;
        }
      }
      function y(ot, We, ht) {
        for (var Ke = ht, yt = ot.length, je = yt >>> 1; Ke < je;) {
          var at = (Ke + 1) * 2 - 1,
            kt = ot[at],
            Bt = at + 1,
            Ht = ot[Bt];
          if (w(kt, We) < 0) Bt < yt && w(Ht, kt) < 0 ? (ot[Ke] = Ht, ot[Bt] = We, Ke = Bt) : (ot[Ke] = kt, ot[at] = We, Ke = at);else if (Bt < yt && w(Ht, We) < 0) ot[Ke] = Ht, ot[Bt] = We, Ke = Bt;else return;
        }
      }
      function w(ot, We) {
        var ht = ot.sortIndex - We.sortIndex;
        return ht !== 0 ? ht : ot.id - We.id;
      }
      var x = 1,
        E = 2,
        C = 3,
        k = 4,
        D = 5,
        I = typeof performance == "object" && typeof performance.now == "function";
      if (I) {
        var L = performance;
        t.unstable_now = function () {
          return L.now();
        };
      } else {
        var P = Date,
          N = P.now();
        t.unstable_now = function () {
          return P.now() - N;
        };
      }
      var O = 1073741823,
        F = -1,
        j = 250,
        V = 5e3,
        K = 1e4,
        G = O,
        Q = [],
        te = [],
        ie = 1,
        Y = null,
        ee = C,
        ae = !1,
        ne = !1,
        le = !1,
        ce = typeof setTimeout == "function" ? setTimeout : null,
        W = typeof clearTimeout == "function" ? clearTimeout : null,
        $ = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function de(ot) {
        for (var We = c(te); We !== null;) {
          if (We.callback === null) p(te);else if (We.startTime <= ot) p(te), We.sortIndex = We.expirationTime, s(Q, We);else return;
          We = c(te);
        }
      }
      function H(ot) {
        if (le = !1, de(ot), !ne) if (c(Q) !== null) ne = !0, Lt(se);else {
          var We = c(te);
          We !== null && Et(H, We.startTime - ot);
        }
      }
      function se(ot, We) {
        ne = !1, le && (le = !1, Vt()), ae = !0;
        var ht = ee;
        try {
          var Ke;
          if (!e) return ue(ot, We);
        } finally {
          Y = null, ee = ht, ae = !1;
        }
      }
      function ue(ot, We) {
        var ht = We;
        for (de(ht), Y = c(Q); Y !== null && !(Y.expirationTime > ht && (!ot || un()));) {
          var Ke = Y.callback;
          if (typeof Ke == "function") {
            Y.callback = null, ee = Y.priorityLevel;
            var yt = Y.expirationTime <= ht,
              je = Ke(yt);
            ht = t.unstable_now(), typeof je == "function" ? Y.callback = je : Y === c(Q) && p(Q), de(ht);
          } else p(Q);
          Y = c(Q);
        }
        if (Y !== null) return !0;
        var at = c(te);
        return at !== null && Et(H, at.startTime - ht), !1;
      }
      function Ee(ot, We) {
        switch (ot) {
          case x:
          case E:
          case C:
          case k:
          case D:
            break;
          default:
            ot = C;
        }
        var ht = ee;
        ee = ot;
        try {
          return We();
        } finally {
          ee = ht;
        }
      }
      function Ce(ot) {
        var We;
        switch (ee) {
          case x:
          case E:
          case C:
            We = C;
            break;
          default:
            We = ee;
            break;
        }
        var ht = ee;
        ee = We;
        try {
          return ot();
        } finally {
          ee = ht;
        }
      }
      function fe(ot) {
        var We = ee;
        return function () {
          var ht = ee;
          ee = We;
          try {
            return ot.apply(this, arguments);
          } finally {
            ee = ht;
          }
        };
      }
      function _e(ot, We, ht) {
        var Ke = t.unstable_now(),
          yt;
        if (typeof ht == "object" && ht !== null) {
          var je = ht.delay;
          typeof je == "number" && je > 0 ? yt = Ke + je : yt = Ke;
        } else yt = Ke;
        var at;
        switch (ot) {
          case x:
            at = F;
            break;
          case E:
            at = j;
            break;
          case D:
            at = G;
            break;
          case k:
            at = K;
            break;
          case C:
          default:
            at = V;
            break;
        }
        var kt = yt + at,
          Bt = {
            id: ie++,
            callback: We,
            priorityLevel: ot,
            startTime: yt,
            expirationTime: kt,
            sortIndex: -1
          };
        return yt > Ke ? (Bt.sortIndex = yt, s(te, Bt), c(Q) === null && Bt === c(te) && (le ? Vt() : le = !0, Et(H, yt - Ke))) : (Bt.sortIndex = kt, s(Q, Bt), !ne && !ae && (ne = !0, Lt(se))), Bt;
      }
      function Se() {}
      function be() {
        !ne && !ae && (ne = !0, Lt(se));
      }
      function Le() {
        return c(Q);
      }
      function Be(ot) {
        ot.callback = null;
      }
      function Xe() {
        return ee;
      }
      var ge = !1,
        qe = null,
        Ae = -1,
        Mt = i,
        Ft = -1;
      function un() {
        var ot = t.unstable_now() - Ft;
        return !(ot < Mt);
      }
      function gt() {}
      function Pt(ot) {
        if (ot < 0 || ot > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        ot > 0 ? Mt = Math.floor(1e3 / ot) : Mt = i;
      }
      var St = function () {
          if (qe !== null) {
            var ot = t.unstable_now();
            Ft = ot;
            var We = !0,
              ht = !0;
            try {
              ht = qe(We, ot);
            } finally {
              ht ? Dt() : (ge = !1, qe = null);
            }
          } else ge = !1;
        },
        Dt;
      if (typeof $ == "function") Dt = function () {
        $(St);
      };else if (typeof MessageChannel < "u") {
        var Kt = new MessageChannel(),
          hn = Kt.port2;
        Kt.port1.onmessage = St, Dt = function () {
          hn.postMessage(null);
        };
      } else Dt = function () {
        ce(St, 0);
      };
      function Lt(ot) {
        qe = ot, ge || (ge = !0, Dt());
      }
      function Et(ot, We) {
        Ae = ce(function () {
          ot(t.unstable_now());
        }, We);
      }
      function Vt() {
        W(Ae), Ae = -1;
      }
      var Xt = gt,
        vn = null;
      t.unstable_IdlePriority = D, t.unstable_ImmediatePriority = x, t.unstable_LowPriority = k, t.unstable_NormalPriority = C, t.unstable_Profiling = vn, t.unstable_UserBlockingPriority = E, t.unstable_cancelCallback = Be, t.unstable_continueExecution = be, t.unstable_forceFrameRate = Pt, t.unstable_getCurrentPriorityLevel = Xe, t.unstable_getFirstCallbackNode = Le, t.unstable_next = Ce, t.unstable_pauseExecution = Se, t.unstable_requestPaint = Xt, t.unstable_runWithPriority = Ee, t.unstable_scheduleCallback = _e, t.unstable_shouldYield = un, t.unstable_wrapCallback = fe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(ZV)), ZV;
}
var eB;
function x4() {
  return eB || (eB = 1, process.env.NODE_ENV === "production" ? _j.exports = nK() : _j.exports = rK()), _j.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tB;
function iK() {
  if (tB) return Qc;
  tB = 1;
  var t = Nt,
    e = x4();
  function i(r) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, d = 1; d < arguments.length; d++) o += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + r + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var s = /* @__PURE__ */new Set(),
    c = {};
  function p(r, o) {
    h(r, o), h(r + "Capture", o);
  }
  function h(r, o) {
    for (c[r] = o, r = 0; r < o.length; r++) s.add(o[r]);
  }
  var y = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
    w = Object.prototype.hasOwnProperty,
    x = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    E = {},
    C = {};
  function k(r) {
    return w.call(C, r) ? !0 : w.call(E, r) ? !1 : x.test(r) ? C[r] = !0 : (E[r] = !0, !1);
  }
  function D(r, o, d, g) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return g ? !1 : d !== null ? !d.acceptsBooleans : (r = r.toLowerCase().slice(0, 5), r !== "data-" && r !== "aria-");
      default:
        return !1;
    }
  }
  function I(r, o, d, g) {
    if (o === null || typeof o > "u" || D(r, o, d, g)) return !0;
    if (g) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !o;
      case 4:
        return o === !1;
      case 5:
        return isNaN(o);
      case 6:
        return isNaN(o) || 1 > o;
    }
    return !1;
  }
  function L(r, o, d, g, S, R, A) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = g, this.attributeNamespace = S, this.mustUseProperty = d, this.propertyName = r, this.type = o, this.sanitizeURL = R, this.removeEmptyString = A;
  }
  var P = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (r) {
    P[r] = new L(r, 0, !1, r, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (r) {
    var o = r[0];
    P[o] = new L(o, 1, !1, r[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (r) {
    P[r] = new L(r, 2, !1, r.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (r) {
    P[r] = new L(r, 2, !1, r, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (r) {
    P[r] = new L(r, 3, !1, r.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (r) {
    P[r] = new L(r, 3, !0, r, null, !1, !1);
  }), ["capture", "download"].forEach(function (r) {
    P[r] = new L(r, 4, !1, r, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (r) {
    P[r] = new L(r, 6, !1, r, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function (r) {
    P[r] = new L(r, 5, !1, r.toLowerCase(), null, !1, !1);
  });
  var N = /[\-:]([a-z])/g;
  function O(r) {
    return r[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (r) {
    P[r] = new L(r, 1, !1, r.toLowerCase(), null, !1, !1);
  }), P.xlinkHref = new L("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (r) {
    P[r] = new L(r, 1, !1, r.toLowerCase(), null, !0, !0);
  });
  function F(r, o, d, g) {
    var S = P.hasOwnProperty(o) ? P[o] : null;
    (S !== null ? S.type !== 0 : g || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (I(o, d, S, g) && (d = null), g || S === null ? k(o) && (d === null ? r.removeAttribute(o) : r.setAttribute(o, "" + d)) : S.mustUseProperty ? r[S.propertyName] = d === null ? S.type === 3 ? !1 : "" : d : (o = S.attributeName, g = S.attributeNamespace, d === null ? r.removeAttribute(o) : (S = S.type, d = S === 3 || S === 4 && d === !0 ? "" : "" + d, g ? r.setAttributeNS(g, o, d) : r.setAttribute(o, d))));
  }
  var j = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    V = Symbol.for("react.element"),
    K = Symbol.for("react.portal"),
    G = Symbol.for("react.fragment"),
    Q = Symbol.for("react.strict_mode"),
    te = Symbol.for("react.profiler"),
    ie = Symbol.for("react.provider"),
    Y = Symbol.for("react.context"),
    ee = Symbol.for("react.forward_ref"),
    ae = Symbol.for("react.suspense"),
    ne = Symbol.for("react.suspense_list"),
    le = Symbol.for("react.memo"),
    ce = Symbol.for("react.lazy"),
    W = Symbol.for("react.offscreen"),
    $ = Symbol.iterator;
  function de(r) {
    return r === null || typeof r != "object" ? null : (r = $ && r[$] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var H = Object.assign,
    se;
  function ue(r) {
    if (se === void 0) try {
      throw Error();
    } catch (d) {
      var o = d.stack.trim().match(/\n( *(at )?)/);
      se = o && o[1] || "";
    }
    return `
` + se + r;
  }
  var Ee = !1;
  function Ce(r, o) {
    if (!r || Ee) return "";
    Ee = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o) {
        if (o = function () {
          throw Error();
        }, Object.defineProperty(o.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (ye) {
            var g = ye;
          }
          Reflect.construct(r, [], o);
        } else {
          try {
            o.call();
          } catch (ye) {
            g = ye;
          }
          r.call(o.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (ye) {
          g = ye;
        }
        r();
      }
    } catch (ye) {
      if (ye && g && typeof ye.stack == "string") {
        for (var S = ye.stack.split(`
`), R = g.stack.split(`
`), A = S.length - 1, q = R.length - 1; 1 <= A && 0 <= q && S[A] !== R[q];) q--;
        for (; 1 <= A && 0 <= q; A--, q--) if (S[A] !== R[q]) {
          if (A !== 1 || q !== 1) do if (A--, q--, 0 > q || S[A] !== R[q]) {
            var re = `
` + S[A].replace(" at new ", " at ");
            return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), re;
          } while (1 <= A && 0 <= q);
          break;
        }
      }
    } finally {
      Ee = !1, Error.prepareStackTrace = d;
    }
    return (r = r ? r.displayName || r.name : "") ? ue(r) : "";
  }
  function fe(r) {
    switch (r.tag) {
      case 5:
        return ue(r.type);
      case 16:
        return ue("Lazy");
      case 13:
        return ue("Suspense");
      case 19:
        return ue("SuspenseList");
      case 0:
      case 2:
      case 15:
        return r = Ce(r.type, !1), r;
      case 11:
        return r = Ce(r.type.render, !1), r;
      case 1:
        return r = Ce(r.type, !0), r;
      default:
        return "";
    }
  }
  function _e(r) {
    if (r == null) return null;
    if (typeof r == "function") return r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case G:
        return "Fragment";
      case K:
        return "Portal";
      case te:
        return "Profiler";
      case Q:
        return "StrictMode";
      case ae:
        return "Suspense";
      case ne:
        return "SuspenseList";
    }
    if (typeof r == "object") switch (r.$$typeof) {
      case Y:
        return (r.displayName || "Context") + ".Consumer";
      case ie:
        return (r._context.displayName || "Context") + ".Provider";
      case ee:
        var o = r.render;
        return r = r.displayName, r || (r = o.displayName || o.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
      case le:
        return o = r.displayName || null, o !== null ? o : _e(r.type) || "Memo";
      case ce:
        o = r._payload, r = r._init;
        try {
          return _e(r(o));
        } catch {}
    }
    return null;
  }
  function Se(r) {
    var o = r.type;
    switch (r.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return r = o.render, r = r.displayName || r.name || "", o.displayName || (r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return _e(o);
      case 8:
        return o === Q ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function") return o.displayName || o.name || null;
        if (typeof o == "string") return o;
    }
    return null;
  }
  function be(r) {
    switch (typeof r) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return r;
      case "object":
        return r;
      default:
        return "";
    }
  }
  function Le(r) {
    var o = r.type;
    return (r = r.nodeName) && r.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function Be(r) {
    var o = Le(r) ? "checked" : "value",
      d = Object.getOwnPropertyDescriptor(r.constructor.prototype, o),
      g = "" + r[o];
    if (!r.hasOwnProperty(o) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var S = d.get,
        R = d.set;
      return Object.defineProperty(r, o, {
        configurable: !0,
        get: function () {
          return S.call(this);
        },
        set: function (A) {
          g = "" + A, R.call(this, A);
        }
      }), Object.defineProperty(r, o, {
        enumerable: d.enumerable
      }), {
        getValue: function () {
          return g;
        },
        setValue: function (A) {
          g = "" + A;
        },
        stopTracking: function () {
          r._valueTracker = null, delete r[o];
        }
      };
    }
  }
  function Xe(r) {
    r._valueTracker || (r._valueTracker = Be(r));
  }
  function ge(r) {
    if (!r) return !1;
    var o = r._valueTracker;
    if (!o) return !0;
    var d = o.getValue(),
      g = "";
    return r && (g = Le(r) ? r.checked ? "true" : "false" : r.value), r = g, r !== d ? (o.setValue(r), !0) : !1;
  }
  function qe(r) {
    if (r = r || (typeof document < "u" ? document : void 0), typeof r > "u") return null;
    try {
      return r.activeElement || r.body;
    } catch {
      return r.body;
    }
  }
  function Ae(r, o) {
    var d = o.checked;
    return H({}, o, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: d ?? r._wrapperState.initialChecked
    });
  }
  function Mt(r, o) {
    var d = o.defaultValue == null ? "" : o.defaultValue,
      g = o.checked != null ? o.checked : o.defaultChecked;
    d = be(o.value != null ? o.value : d), r._wrapperState = {
      initialChecked: g,
      initialValue: d,
      controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null
    };
  }
  function Ft(r, o) {
    o = o.checked, o != null && F(r, "checked", o, !1);
  }
  function un(r, o) {
    Ft(r, o);
    var d = be(o.value),
      g = o.type;
    if (d != null) g === "number" ? (d === 0 && r.value === "" || r.value != d) && (r.value = "" + d) : r.value !== "" + d && (r.value = "" + d);else if (g === "submit" || g === "reset") {
      r.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? Pt(r, o.type, d) : o.hasOwnProperty("defaultValue") && Pt(r, o.type, be(o.defaultValue)), o.checked == null && o.defaultChecked != null && (r.defaultChecked = !!o.defaultChecked);
  }
  function gt(r, o, d) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var g = o.type;
      if (!(g !== "submit" && g !== "reset" || o.value !== void 0 && o.value !== null)) return;
      o = "" + r._wrapperState.initialValue, d || o === r.value || (r.value = o), r.defaultValue = o;
    }
    d = r.name, d !== "" && (r.name = ""), r.defaultChecked = !!r._wrapperState.initialChecked, d !== "" && (r.name = d);
  }
  function Pt(r, o, d) {
    (o !== "number" || qe(r.ownerDocument) !== r) && (d == null ? r.defaultValue = "" + r._wrapperState.initialValue : r.defaultValue !== "" + d && (r.defaultValue = "" + d));
  }
  var St = Array.isArray;
  function Dt(r, o, d, g) {
    if (r = r.options, o) {
      o = {};
      for (var S = 0; S < d.length; S++) o["$" + d[S]] = !0;
      for (d = 0; d < r.length; d++) S = o.hasOwnProperty("$" + r[d].value), r[d].selected !== S && (r[d].selected = S), S && g && (r[d].defaultSelected = !0);
    } else {
      for (d = "" + be(d), o = null, S = 0; S < r.length; S++) {
        if (r[S].value === d) {
          r[S].selected = !0, g && (r[S].defaultSelected = !0);
          return;
        }
        o !== null || r[S].disabled || (o = r[S]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Kt(r, o) {
    if (o.dangerouslySetInnerHTML != null) throw Error(i(91));
    return H({}, o, {
      value: void 0,
      defaultValue: void 0,
      children: "" + r._wrapperState.initialValue
    });
  }
  function hn(r, o) {
    var d = o.value;
    if (d == null) {
      if (d = o.children, o = o.defaultValue, d != null) {
        if (o != null) throw Error(i(92));
        if (St(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        o = d;
      }
      o == null && (o = ""), d = o;
    }
    r._wrapperState = {
      initialValue: be(d)
    };
  }
  function Lt(r, o) {
    var d = be(o.value),
      g = be(o.defaultValue);
    d != null && (d = "" + d, d !== r.value && (r.value = d), o.defaultValue == null && r.defaultValue !== d && (r.defaultValue = d)), g != null && (r.defaultValue = "" + g);
  }
  function Et(r) {
    var o = r.textContent;
    o === r._wrapperState.initialValue && o !== "" && o !== null && (r.value = o);
  }
  function Vt(r) {
    switch (r) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Xt(r, o) {
    return r == null || r === "http://www.w3.org/1999/xhtml" ? Vt(o) : r === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r;
  }
  var vn,
    ot = function (r) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (o, d, g, S) {
        MSApp.execUnsafeLocalFunction(function () {
          return r(o, d, g, S);
        });
      } : r;
    }(function (r, o) {
      if (r.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in r) r.innerHTML = o;else {
        for (vn = vn || document.createElement("div"), vn.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = vn.firstChild; r.firstChild;) r.removeChild(r.firstChild);
        for (; o.firstChild;) r.appendChild(o.firstChild);
      }
    });
  function We(r, o) {
    if (o) {
      var d = r.firstChild;
      if (d && d === r.lastChild && d.nodeType === 3) {
        d.nodeValue = o;
        return;
      }
    }
    r.textContent = o;
  }
  var ht = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    Ke = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ht).forEach(function (r) {
    Ke.forEach(function (o) {
      o = o + r.charAt(0).toUpperCase() + r.substring(1), ht[o] = ht[r];
    });
  });
  function yt(r, o, d) {
    return o == null || typeof o == "boolean" || o === "" ? "" : d || typeof o != "number" || o === 0 || ht.hasOwnProperty(r) && ht[r] ? ("" + o).trim() : o + "px";
  }
  function je(r, o) {
    r = r.style;
    for (var d in o) if (o.hasOwnProperty(d)) {
      var g = d.indexOf("--") === 0,
        S = yt(d, o[d], g);
      d === "float" && (d = "cssFloat"), g ? r.setProperty(d, S) : r[d] = S;
    }
  }
  var at = H({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });
  function kt(r, o) {
    if (o) {
      if (at[r] && (o.children != null || o.dangerouslySetInnerHTML != null)) throw Error(i(137, r));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null) throw Error(i(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (o.style != null && typeof o.style != "object") throw Error(i(62));
    }
  }
  function Bt(r, o) {
    if (r.indexOf("-") === -1) return typeof o.is == "string";
    switch (r) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ht = null;
  function sn(r) {
    return r = r.target || r.srcElement || window, r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === 3 ? r.parentNode : r;
  }
  var en = null,
    Rr = null,
    Nr = null;
  function Hi(r) {
    if (r = pt(r)) {
      if (typeof en != "function") throw Error(i(280));
      var o = r.stateNode;
      o && (o = Gn(o), en(r.stateNode, r.type, o));
    }
  }
  function ss(r) {
    Rr ? Nr ? Nr.push(r) : Nr = [r] : Rr = r;
  }
  function yo() {
    if (Rr) {
      var r = Rr,
        o = Nr;
      if (Nr = Rr = null, Hi(r), o) for (r = 0; r < o.length; r++) Hi(o[r]);
    }
  }
  function _s(r, o) {
    return r(o);
  }
  function Mo() {}
  var bo = !1;
  function Tu(r, o, d) {
    if (bo) return r(o, d);
    bo = !0;
    try {
      return _s(r, o, d);
    } finally {
      bo = !1, (Rr !== null || Nr !== null) && (Mo(), yo());
    }
  }
  function Ha(r, o) {
    var d = r.stateNode;
    if (d === null) return null;
    var g = Gn(d);
    if (g === null) return null;
    d = g[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (g = !g.disabled) || (r = r.type, g = !(r === "button" || r === "input" || r === "select" || r === "textarea")), r = !g;
        break e;
      default:
        r = !1;
    }
    if (r) return null;
    if (d && typeof d != "function") throw Error(i(231, o, typeof d));
    return d;
  }
  var $i = !1;
  if (y) try {
    var oi = {};
    Object.defineProperty(oi, "passive", {
      get: function () {
        $i = !0;
      }
    }), window.addEventListener("test", oi, oi), window.removeEventListener("test", oi, oi);
  } catch {
    $i = !1;
  }
  function Lo(r, o, d, g, S, R, A, q, re) {
    var ye = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(d, ye);
    } catch (Oe) {
      this.onError(Oe);
    }
  }
  var $a = !1,
    Oo = null,
    Z = !1,
    Ne = null,
    Ye = {
      onError: function (r) {
        $a = !0, Oo = r;
      }
    };
  function xt(r, o, d, g, S, R, A, q, re) {
    $a = !1, Oo = null, Lo.apply(Ye, arguments);
  }
  function rn(r, o, d, g, S, R, A, q, re) {
    if (xt.apply(this, arguments), $a) {
      if ($a) {
        var ye = Oo;
        $a = !1, Oo = null;
      } else throw Error(i(198));
      Z || (Z = !0, Ne = ye);
    }
  }
  function $t(r) {
    var o = r,
      d = r;
    if (r.alternate) for (; o.return;) o = o.return;else {
      r = o;
      do o = r, (o.flags & 4098) !== 0 && (d = o.return), r = o.return; while (r);
    }
    return o.tag === 3 ? d : null;
  }
  function Ct(r) {
    if (r.tag === 13) {
      var o = r.memoizedState;
      if (o === null && (r = r.alternate, r !== null && (o = r.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function qt(r) {
    if ($t(r) !== r) throw Error(i(188));
  }
  function yr(r) {
    var o = r.alternate;
    if (!o) {
      if (o = $t(r), o === null) throw Error(i(188));
      return o !== r ? null : r;
    }
    for (var d = r, g = o;;) {
      var S = d.return;
      if (S === null) break;
      var R = S.alternate;
      if (R === null) {
        if (g = S.return, g !== null) {
          d = g;
          continue;
        }
        break;
      }
      if (S.child === R.child) {
        for (R = S.child; R;) {
          if (R === d) return qt(S), r;
          if (R === g) return qt(S), o;
          R = R.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== g.return) d = S, g = R;else {
        for (var A = !1, q = S.child; q;) {
          if (q === d) {
            A = !0, d = S, g = R;
            break;
          }
          if (q === g) {
            A = !0, g = S, d = R;
            break;
          }
          q = q.sibling;
        }
        if (!A) {
          for (q = R.child; q;) {
            if (q === d) {
              A = !0, d = R, g = S;
              break;
            }
            if (q === g) {
              A = !0, g = R, d = S;
              break;
            }
            q = q.sibling;
          }
          if (!A) throw Error(i(189));
        }
      }
      if (d.alternate !== g) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? r : o;
  }
  function Tn(r) {
    return r = yr(r), r !== null ? jn(r) : null;
  }
  function jn(r) {
    if (r.tag === 5 || r.tag === 6) return r;
    for (r = r.child; r !== null;) {
      var o = jn(r);
      if (o !== null) return o;
      r = r.sibling;
    }
    return null;
  }
  var Or = e.unstable_scheduleCallback,
    Wa = e.unstable_cancelCallback,
    Ru = e.unstable_shouldYield,
    Wi = e.unstable_requestPaint,
    yn = e.unstable_now,
    Qt = e.unstable_getCurrentPriorityLevel,
    El = e.unstable_ImmediatePriority,
    Wp = e.unstable_UserBlockingPriority,
    Du = e.unstable_NormalPriority,
    tg = e.unstable_LowPriority,
    qp = e.unstable_IdlePriority,
    Iu = null,
    qi = null;
  function ng(r) {
    if (qi && typeof qi.onCommitFiberRoot == "function") try {
      qi.onCommitFiberRoot(Iu, r, void 0, (r.current.flags & 128) === 128);
    } catch {}
  }
  var gi = Math.clz32 ? Math.clz32 : Yp,
    cw = Math.log,
    dw = Math.LN2;
  function Yp(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (cw(r) / dw | 0) | 0;
  }
  var xs = 64,
    Yi = 4194304;
  function Cl(r) {
    switch (r & -r) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return r & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return r;
    }
  }
  function kl(r, o) {
    var d = r.pendingLanes;
    if (d === 0) return 0;
    var g = 0,
      S = r.suspendedLanes,
      R = r.pingedLanes,
      A = d & 268435455;
    if (A !== 0) {
      var q = A & ~S;
      q !== 0 ? g = Cl(q) : (R &= A, R !== 0 && (g = Cl(R)));
    } else A = d & ~S, A !== 0 ? g = Cl(A) : R !== 0 && (g = Cl(R));
    if (g === 0) return 0;
    if (o !== 0 && o !== g && (o & S) === 0 && (S = g & -g, R = o & -o, S >= R || S === 16 && (R & 4194240) !== 0)) return o;
    if ((g & 4) !== 0 && (g |= d & 16), o = r.entangledLanes, o !== 0) for (r = r.entanglements, o &= g; 0 < o;) d = 31 - gi(o), S = 1 << d, g |= r[d], o &= ~S;
    return g;
  }
  function fw(r, o) {
    switch (r) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Gp(r, o) {
    for (var d = r.suspendedLanes, g = r.pingedLanes, S = r.expirationTimes, R = r.pendingLanes; 0 < R;) {
      var A = 31 - gi(R),
        q = 1 << A,
        re = S[A];
      re === -1 ? ((q & d) === 0 || (q & g) !== 0) && (S[A] = fw(q, o)) : re <= o && (r.expiredLanes |= q), R &= ~q;
    }
  }
  function Xp(r) {
    return r = r.pendingLanes & -1073741825, r !== 0 ? r : r & 1073741824 ? 1073741824 : 0;
  }
  function fd() {
    var r = xs;
    return xs <<= 1, (xs & 4194240) === 0 && (xs = 64), r;
  }
  function Kp(r) {
    for (var o = [], d = 0; 31 > d; d++) o.push(r);
    return o;
  }
  function Tl(r, o, d) {
    r.pendingLanes |= o, o !== 536870912 && (r.suspendedLanes = 0, r.pingedLanes = 0), r = r.eventTimes, o = 31 - gi(o), r[o] = d;
  }
  function pw(r, o) {
    var d = r.pendingLanes & ~o;
    r.pendingLanes = o, r.suspendedLanes = 0, r.pingedLanes = 0, r.expiredLanes &= o, r.mutableReadLanes &= o, r.entangledLanes &= o, o = r.entanglements;
    var g = r.eventTimes;
    for (r = r.expirationTimes; 0 < d;) {
      var S = 31 - gi(d),
        R = 1 << S;
      o[S] = 0, g[S] = -1, r[S] = -1, d &= ~R;
    }
  }
  function pd(r, o) {
    var d = r.entangledLanes |= o;
    for (r = r.entanglements; d;) {
      var g = 31 - gi(d),
        S = 1 << g;
      S & o | r[g] & o && (r[g] |= o), d &= ~S;
    }
  }
  var gn = 0;
  function Qp(r) {
    return r &= -r, 1 < r ? 4 < r ? (r & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var bn,
    Zp,
    Jp,
    At,
    eh,
    Pr = !1,
    Po = [],
    yi = null,
    Ao = null,
    Un = null,
    Rn = /* @__PURE__ */new Map(),
    Mu = /* @__PURE__ */new Map(),
    br = [],
    bi = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function qa(r, o) {
    switch (r) {
      case "focusin":
      case "focusout":
        yi = null;
        break;
      case "dragenter":
      case "dragleave":
        Ao = null;
        break;
      case "mouseover":
      case "mouseout":
        Un = null;
        break;
      case "pointerover":
      case "pointerout":
        Rn.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Mu.delete(o.pointerId);
    }
  }
  function Lu(r, o, d, g, S, R) {
    return r === null || r.nativeEvent !== R ? (r = {
      blockedOn: o,
      domEventName: d,
      eventSystemFlags: g,
      nativeEvent: R,
      targetContainers: [S]
    }, o !== null && (o = pt(o), o !== null && Zp(o)), r) : (r.eventSystemFlags |= g, o = r.targetContainers, S !== null && o.indexOf(S) === -1 && o.push(S), r);
  }
  function th(r, o, d, g, S) {
    switch (o) {
      case "focusin":
        return yi = Lu(yi, r, o, d, g, S), !0;
      case "dragenter":
        return Ao = Lu(Ao, r, o, d, g, S), !0;
      case "mouseover":
        return Un = Lu(Un, r, o, d, g, S), !0;
      case "pointerover":
        var R = S.pointerId;
        return Rn.set(R, Lu(Rn.get(R) || null, r, o, d, g, S)), !0;
      case "gotpointercapture":
        return R = S.pointerId, Mu.set(R, Lu(Mu.get(R) || null, r, o, d, g, S)), !0;
    }
    return !1;
  }
  function nh(r) {
    var o = Fl(r.target);
    if (o !== null) {
      var d = $t(o);
      if (d !== null) {
        if (o = d.tag, o === 13) {
          if (o = Ct(d), o !== null) {
            r.blockedOn = o, eh(r.priority, function () {
              Jp(d);
            });
            return;
          }
        } else if (o === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          r.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    r.blockedOn = null;
  }
  function Ou(r) {
    if (r.blockedOn !== null) return !1;
    for (var o = r.targetContainers; 0 < o.length;) {
      var d = md(r.domEventName, r.eventSystemFlags, o[0], r.nativeEvent);
      if (d === null) {
        d = r.nativeEvent;
        var g = new d.constructor(d.type, d);
        Ht = g, d.target.dispatchEvent(g), Ht = null;
      } else return o = pt(d), o !== null && Zp(o), r.blockedOn = d, !1;
      o.shift();
    }
    return !0;
  }
  function rg(r, o, d) {
    Ou(r) && d.delete(o);
  }
  function hw() {
    Pr = !1, yi !== null && Ou(yi) && (yi = null), Ao !== null && Ou(Ao) && (Ao = null), Un !== null && Ou(Un) && (Un = null), Rn.forEach(rg), Mu.forEach(rg);
  }
  function Pu(r, o) {
    r.blockedOn === o && (r.blockedOn = null, Pr || (Pr = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, hw)));
  }
  function jo(r) {
    function o(S) {
      return Pu(S, r);
    }
    if (0 < Po.length) {
      Pu(Po[0], r);
      for (var d = 1; d < Po.length; d++) {
        var g = Po[d];
        g.blockedOn === r && (g.blockedOn = null);
      }
    }
    for (yi !== null && Pu(yi, r), Ao !== null && Pu(Ao, r), Un !== null && Pu(Un, r), Rn.forEach(o), Mu.forEach(o), d = 0; d < br.length; d++) g = br[d], g.blockedOn === r && (g.blockedOn = null);
    for (; 0 < br.length && (d = br[0], d.blockedOn === null);) nh(d), d.blockedOn === null && br.shift();
  }
  var Rl = j.ReactCurrentBatchConfig,
    Dl = !0;
  function ig(r, o, d, g) {
    var S = gn,
      R = Rl.transition;
    Rl.transition = null;
    try {
      gn = 1, hd(r, o, d, g);
    } finally {
      gn = S, Rl.transition = R;
    }
  }
  function ag(r, o, d, g) {
    var S = gn,
      R = Rl.transition;
    Rl.transition = null;
    try {
      gn = 4, hd(r, o, d, g);
    } finally {
      gn = S, Rl.transition = R;
    }
  }
  function hd(r, o, d, g) {
    if (Dl) {
      var S = md(r, o, d, g);
      if (S === null) Od(r, o, g, Au, d), qa(r, g);else if (th(S, r, o, d, g)) g.stopPropagation();else if (qa(r, g), o & 4 && -1 < bi.indexOf(r)) {
        for (; S !== null;) {
          var R = pt(S);
          if (R !== null && bn(R), R = md(r, o, d, g), R === null && Od(r, o, g, Au, d), R === S) break;
          S = R;
        }
        S !== null && g.stopPropagation();
      } else Od(r, o, g, null, d);
    }
  }
  var Au = null;
  function md(r, o, d, g) {
    if (Au = null, r = sn(g), r = Fl(r), r !== null) if (o = $t(r), o === null) r = null;else if (d = o.tag, d === 13) {
      if (r = Ct(o), r !== null) return r;
      r = null;
    } else if (d === 3) {
      if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
      r = null;
    } else o !== r && (r = null);
    return Au = r, null;
  }
  function vd(r) {
    switch (r) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Qt()) {
          case El:
            return 1;
          case Wp:
            return 4;
          case Du:
          case tg:
            return 16;
          case qp:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ya = null,
    gd = null,
    Ss = null;
  function rh() {
    if (Ss) return Ss;
    var r,
      o = gd,
      d = o.length,
      g,
      S = "value" in Ya ? Ya.value : Ya.textContent,
      R = S.length;
    for (r = 0; r < d && o[r] === S[r]; r++);
    var A = d - r;
    for (g = 1; g <= A && o[d - g] === S[R - g]; g++);
    return Ss = S.slice(r, 1 < g ? 1 - g : void 0);
  }
  function yd(r) {
    var o = r.keyCode;
    return "charCode" in r ? (r = r.charCode, r === 0 && o === 13 && (r = 13)) : r = o, r === 10 && (r = 13), 32 <= r || r === 13 ? r : 0;
  }
  function bd() {
    return !0;
  }
  function wd() {
    return !1;
  }
  function $r(r) {
    function o(d, g, S, R, A) {
      this._reactName = d, this._targetInst = S, this.type = g, this.nativeEvent = R, this.target = A, this.currentTarget = null;
      for (var q in r) r.hasOwnProperty(q) && (d = r[q], this[q] = d ? d(R) : R[q]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? bd : wd, this.isPropagationStopped = wd, this;
    }
    return H(o.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var d = this.nativeEvent;
        d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = bd);
      },
      stopPropagation: function () {
        var d = this.nativeEvent;
        d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = bd);
      },
      persist: function () {},
      isPersistent: bd
    }), o;
  }
  var Il = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (r) {
        return r.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    _d = $r(Il),
    Es = H({}, Il, {
      view: 0,
      detail: 0
    }),
    mw = $r(Es),
    ih,
    wr,
    Ml,
    ju = H({}, Es, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: uh,
      button: 0,
      buttons: 0,
      relatedTarget: function (r) {
        return r.relatedTarget === void 0 ? r.fromElement === r.srcElement ? r.toElement : r.fromElement : r.relatedTarget;
      },
      movementX: function (r) {
        return "movementX" in r ? r.movementX : (r !== Ml && (Ml && r.type === "mousemove" ? (ih = r.screenX - Ml.screenX, wr = r.screenY - Ml.screenY) : wr = ih = 0, Ml = r), ih);
      },
      movementY: function (r) {
        return "movementY" in r ? r.movementY : wr;
      }
    }),
    ah = $r(ju),
    vw = H({}, ju, {
      dataTransfer: 0
    }),
    Cs = $r(vw),
    oh = H({}, Es, {
      relatedTarget: 0
    }),
    xd = $r(oh),
    gw = H({}, Il, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    yw = $r(gw),
    bw = H({}, Il, {
      clipboardData: function (r) {
        return "clipboardData" in r ? r.clipboardData : window.clipboardData;
      }
    }),
    og = $r(bw),
    lh = H({}, Il, {
      data: 0
    }),
    sh = $r(lh),
    lg = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    sg = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    ww = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function Ga(r) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(r) : (r = ww[r]) ? !!o[r] : !1;
  }
  function uh() {
    return Ga;
  }
  var ch = H({}, Es, {
      key: function (r) {
        if (r.key) {
          var o = lg[r.key] || r.key;
          if (o !== "Unidentified") return o;
        }
        return r.type === "keypress" ? (r = yd(r), r === 13 ? "Enter" : String.fromCharCode(r)) : r.type === "keydown" || r.type === "keyup" ? sg[r.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: uh,
      charCode: function (r) {
        return r.type === "keypress" ? yd(r) : 0;
      },
      keyCode: function (r) {
        return r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      },
      which: function (r) {
        return r.type === "keypress" ? yd(r) : r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      }
    }),
    dh = $r(ch),
    fh = H({}, ju, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }),
    ug = $r(fh),
    Sd = H({}, Es, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: uh
    }),
    cg = $r(Sd),
    Wr = H({}, Il, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    Xa = $r(Wr),
    er = H({}, ju, {
      deltaX: function (r) {
        return "deltaX" in r ? r.deltaX : "wheelDeltaX" in r ? -r.wheelDeltaX : 0;
      },
      deltaY: function (r) {
        return "deltaY" in r ? r.deltaY : "wheelDeltaY" in r ? -r.wheelDeltaY : "wheelDelta" in r ? -r.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }),
    Ka = $r(er),
    ph = [9, 13, 27, 32],
    ks = y && "CompositionEvent" in window,
    Fu = null;
  y && "documentMode" in document && (Fu = document.documentMode);
  var Nu = y && "TextEvent" in window && !Fu,
    dg = y && (!ks || Fu && 8 < Fu && 11 >= Fu),
    fg = " ",
    Ed = !1;
  function pg(r, o) {
    switch (r) {
      case "keyup":
        return ph.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hg(r) {
    return r = r.detail, typeof r == "object" && "data" in r ? r.data : null;
  }
  var Ts = !1;
  function mg(r, o) {
    switch (r) {
      case "compositionend":
        return hg(o);
      case "keypress":
        return o.which !== 32 ? null : (Ed = !0, fg);
      case "textInput":
        return r = o.data, r === fg && Ed ? null : r;
      default:
        return null;
    }
  }
  function _w(r, o) {
    if (Ts) return r === "compositionend" || !ks && pg(r, o) ? (r = rh(), Ss = gd = Ya = null, Ts = !1, r) : null;
    switch (r) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length) return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return dg && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var xw = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function vg(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o === "input" ? !!xw[r.type] : o === "textarea";
  }
  function hh(r, o, d, g) {
    ss(g), o = $u(o, "onChange"), 0 < o.length && (d = new _d("onChange", "change", null, d, g), r.push({
      event: d,
      listeners: o
    }));
  }
  var pa = null,
    Ll = null;
  function gg(r) {
    Al(r, 0);
  }
  function zu(r) {
    var o = Xi(r);
    if (ge(o)) return r;
  }
  function Sw(r, o) {
    if (r === "change") return o;
  }
  var yg = !1;
  if (y) {
    var mh;
    if (y) {
      var vh = "oninput" in document;
      if (!vh) {
        var bg = document.createElement("div");
        bg.setAttribute("oninput", "return;"), vh = typeof bg.oninput == "function";
      }
      mh = vh;
    } else mh = !1;
    yg = mh && (!document.documentMode || 9 < document.documentMode);
  }
  function wg() {
    pa && (pa.detachEvent("onpropertychange", _g), Ll = pa = null);
  }
  function _g(r) {
    if (r.propertyName === "value" && zu(Ll)) {
      var o = [];
      hh(o, Ll, r, sn(r)), Tu(gg, o);
    }
  }
  function Ew(r, o, d) {
    r === "focusin" ? (wg(), pa = o, Ll = d, pa.attachEvent("onpropertychange", _g)) : r === "focusout" && wg();
  }
  function xg(r) {
    if (r === "selectionchange" || r === "keyup" || r === "keydown") return zu(Ll);
  }
  function Cw(r, o) {
    if (r === "click") return zu(o);
  }
  function Sg(r, o) {
    if (r === "input" || r === "change") return zu(o);
  }
  function kw(r, o) {
    return r === o && (r !== 0 || 1 / r === 1 / o) || r !== r && o !== o;
  }
  var Gi = typeof Object.is == "function" ? Object.is : kw;
  function Vu(r, o) {
    if (Gi(r, o)) return !0;
    if (typeof r != "object" || r === null || typeof o != "object" || o === null) return !1;
    var d = Object.keys(r),
      g = Object.keys(o);
    if (d.length !== g.length) return !1;
    for (g = 0; g < d.length; g++) {
      var S = d[g];
      if (!w.call(o, S) || !Gi(r[S], o[S])) return !1;
    }
    return !0;
  }
  function Eg(r) {
    for (; r && r.firstChild;) r = r.firstChild;
    return r;
  }
  function Cd(r, o) {
    var d = Eg(r);
    r = 0;
    for (var g; d;) {
      if (d.nodeType === 3) {
        if (g = r + d.textContent.length, r <= o && g >= o) return {
          node: d,
          offset: o - r
        };
        r = g;
      }
      e: {
        for (; d;) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = Eg(d);
    }
  }
  function Fo(r, o) {
    return r && o ? r === o ? !0 : r && r.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Fo(r, o.parentNode) : "contains" in r ? r.contains(o) : r.compareDocumentPosition ? !!(r.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function Bu() {
    for (var r = window, o = qe(); o instanceof r.HTMLIFrameElement;) {
      try {
        var d = typeof o.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) r = o.contentWindow;else break;
      o = qe(r.document);
    }
    return o;
  }
  function kd(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o && (o === "input" && (r.type === "text" || r.type === "search" || r.type === "tel" || r.type === "url" || r.type === "password") || o === "textarea" || r.contentEditable === "true");
  }
  function Rs(r) {
    var o = Bu(),
      d = r.focusedElem,
      g = r.selectionRange;
    if (o !== d && d && d.ownerDocument && Fo(d.ownerDocument.documentElement, d)) {
      if (g !== null && kd(d)) {
        if (o = g.start, r = g.end, r === void 0 && (r = o), "selectionStart" in d) d.selectionStart = o, d.selectionEnd = Math.min(r, d.value.length);else if (r = (o = d.ownerDocument || document) && o.defaultView || window, r.getSelection) {
          r = r.getSelection();
          var S = d.textContent.length,
            R = Math.min(g.start, S);
          g = g.end === void 0 ? R : Math.min(g.end, S), !r.extend && R > g && (S = g, g = R, R = S), S = Cd(d, R);
          var A = Cd(d, g);
          S && A && (r.rangeCount !== 1 || r.anchorNode !== S.node || r.anchorOffset !== S.offset || r.focusNode !== A.node || r.focusOffset !== A.offset) && (o = o.createRange(), o.setStart(S.node, S.offset), r.removeAllRanges(), R > g ? (r.addRange(o), r.extend(A.node, A.offset)) : (o.setEnd(A.node, A.offset), r.addRange(o)));
        }
      }
      for (o = [], r = d; r = r.parentNode;) r.nodeType === 1 && o.push({
        element: r,
        left: r.scrollLeft,
        top: r.scrollTop
      });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < o.length; d++) r = o[d], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
    }
  }
  var Tw = y && "documentMode" in document && 11 >= document.documentMode,
    Ds = null,
    gh = null,
    Uu = null,
    yh = !1;
  function bh(r, o, d) {
    var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    yh || Ds == null || Ds !== qe(g) || (g = Ds, "selectionStart" in g && kd(g) ? g = {
      start: g.selectionStart,
      end: g.selectionEnd
    } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = {
      anchorNode: g.anchorNode,
      anchorOffset: g.anchorOffset,
      focusNode: g.focusNode,
      focusOffset: g.focusOffset
    }), Uu && Vu(Uu, g) || (Uu = g, g = $u(gh, "onSelect"), 0 < g.length && (o = new _d("onSelect", "select", null, o, d), r.push({
      event: o,
      listeners: g
    }), o.target = Ds)));
  }
  function Td(r, o) {
    var d = {};
    return d[r.toLowerCase()] = o.toLowerCase(), d["Webkit" + r] = "webkit" + o, d["Moz" + r] = "moz" + o, d;
  }
  var Ol = {
      animationend: Td("Animation", "AnimationEnd"),
      animationiteration: Td("Animation", "AnimationIteration"),
      animationstart: Td("Animation", "AnimationStart"),
      transitionend: Td("Transition", "TransitionEnd")
    },
    _r = {},
    wh = {};
  y && (wh = document.createElement("div").style, "AnimationEvent" in window || (delete Ol.animationend.animation, delete Ol.animationiteration.animation, delete Ol.animationstart.animation), "TransitionEvent" in window || delete Ol.transitionend.transition);
  function Rd(r) {
    if (_r[r]) return _r[r];
    if (!Ol[r]) return r;
    var o = Ol[r],
      d;
    for (d in o) if (o.hasOwnProperty(d) && d in wh) return _r[r] = o[d];
    return r;
  }
  var Cg = Rd("animationend"),
    kg = Rd("animationiteration"),
    Tg = Rd("animationstart"),
    Rg = Rd("transitionend"),
    _h = /* @__PURE__ */new Map(),
    Dd = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function wi(r, o) {
    _h.set(r, o), p(o, [r]);
  }
  for (var xh = 0; xh < Dd.length; xh++) {
    var Pl = Dd[xh],
      Rw = Pl.toLowerCase(),
      Dw = Pl[0].toUpperCase() + Pl.slice(1);
    wi(Rw, "on" + Dw);
  }
  wi(Cg, "onAnimationEnd"), wi(kg, "onAnimationIteration"), wi(Tg, "onAnimationStart"), wi("dblclick", "onDoubleClick"), wi("focusin", "onFocus"), wi("focusout", "onBlur"), wi(Rg, "onTransitionEnd"), h("onMouseEnter", ["mouseout", "mouseover"]), h("onMouseLeave", ["mouseout", "mouseover"]), h("onPointerEnter", ["pointerout", "pointerover"]), h("onPointerLeave", ["pointerout", "pointerover"]), p("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), p("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), p("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), p("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Hu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Sh = new Set("cancel close invalid load scroll toggle".split(" ").concat(Hu));
  function Id(r, o, d) {
    var g = r.type || "unknown-event";
    r.currentTarget = d, rn(g, o, void 0, r), r.currentTarget = null;
  }
  function Al(r, o) {
    o = (o & 4) !== 0;
    for (var d = 0; d < r.length; d++) {
      var g = r[d],
        S = g.event;
      g = g.listeners;
      e: {
        var R = void 0;
        if (o) for (var A = g.length - 1; 0 <= A; A--) {
          var q = g[A],
            re = q.instance,
            ye = q.currentTarget;
          if (q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Id(S, q, ye), R = re;
        } else for (A = 0; A < g.length; A++) {
          if (q = g[A], re = q.instance, ye = q.currentTarget, q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Id(S, q, ye), R = re;
        }
      }
    }
    if (Z) throw r = Ne, Z = !1, Ne = null, r;
  }
  function mn(r, o) {
    var d = o[Yu];
    d === void 0 && (d = o[Yu] = /* @__PURE__ */new Set());
    var g = r + "__bubble";
    d.has(g) || (Dg(o, r, 2, !1), d.add(g));
  }
  function Md(r, o, d) {
    var g = 0;
    o && (g |= 4), Dg(d, r, g, o);
  }
  var Ld = "_reactListening" + Math.random().toString(36).slice(2);
  function Is(r) {
    if (!r[Ld]) {
      r[Ld] = !0, s.forEach(function (d) {
        d !== "selectionchange" && (Sh.has(d) || Md(d, !1, r), Md(d, !0, r));
      });
      var o = r.nodeType === 9 ? r : r.ownerDocument;
      o === null || o[Ld] || (o[Ld] = !0, Md("selectionchange", !1, o));
    }
  }
  function Dg(r, o, d, g) {
    switch (vd(o)) {
      case 1:
        var S = ig;
        break;
      case 4:
        S = ag;
        break;
      default:
        S = hd;
    }
    d = S.bind(null, o, d, r), S = void 0, !$i || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (S = !0), g ? S !== void 0 ? r.addEventListener(o, d, {
      capture: !0,
      passive: S
    }) : r.addEventListener(o, d, !0) : S !== void 0 ? r.addEventListener(o, d, {
      passive: S
    }) : r.addEventListener(o, d, !1);
  }
  function Od(r, o, d, g, S) {
    var R = g;
    if ((o & 1) === 0 && (o & 2) === 0 && g !== null) e: for (;;) {
      if (g === null) return;
      var A = g.tag;
      if (A === 3 || A === 4) {
        var q = g.stateNode.containerInfo;
        if (q === S || q.nodeType === 8 && q.parentNode === S) break;
        if (A === 4) for (A = g.return; A !== null;) {
          var re = A.tag;
          if ((re === 3 || re === 4) && (re = A.stateNode.containerInfo, re === S || re.nodeType === 8 && re.parentNode === S)) return;
          A = A.return;
        }
        for (; q !== null;) {
          if (A = Fl(q), A === null) return;
          if (re = A.tag, re === 5 || re === 6) {
            g = R = A;
            continue e;
          }
          q = q.parentNode;
        }
      }
      g = g.return;
    }
    Tu(function () {
      var ye = R,
        Oe = sn(d),
        ze = [];
      e: {
        var Me = _h.get(r);
        if (Me !== void 0) {
          var et = _d,
            it = r;
          switch (r) {
            case "keypress":
              if (yd(d) === 0) break e;
            case "keydown":
            case "keyup":
              et = dh;
              break;
            case "focusin":
              it = "focus", et = xd;
              break;
            case "focusout":
              it = "blur", et = xd;
              break;
            case "beforeblur":
            case "afterblur":
              et = xd;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              et = ah;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              et = Cs;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              et = cg;
              break;
            case Cg:
            case kg:
            case Tg:
              et = yw;
              break;
            case Rg:
              et = Xa;
              break;
            case "scroll":
              et = mw;
              break;
            case "wheel":
              et = Ka;
              break;
            case "copy":
            case "cut":
            case "paste":
              et = og;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              et = ug;
          }
          var lt = (o & 4) !== 0,
            Kn = !lt && r === "scroll",
            pe = lt ? Me !== null ? Me + "Capture" : null : Me;
          lt = [];
          for (var oe = ye, he; oe !== null;) {
            he = oe;
            var He = he.stateNode;
            if (he.tag === 5 && He !== null && (he = He, pe !== null && (He = Ha(oe, pe), He != null && lt.push(Ms(oe, He, he)))), Kn) break;
            oe = oe.return;
          }
          0 < lt.length && (Me = new et(Me, it, null, d, Oe), ze.push({
            event: Me,
            listeners: lt
          }));
        }
      }
      if ((o & 7) === 0) {
        e: {
          if (Me = r === "mouseover" || r === "pointerover", et = r === "mouseout" || r === "pointerout", Me && d !== Ht && (it = d.relatedTarget || d.fromElement) && (Fl(it) || it[Qa])) break e;
          if ((et || Me) && (Me = Oe.window === Oe ? Oe : (Me = Oe.ownerDocument) ? Me.defaultView || Me.parentWindow : window, et ? (it = d.relatedTarget || d.toElement, et = ye, it = it ? Fl(it) : null, it !== null && (Kn = $t(it), it !== Kn || it.tag !== 5 && it.tag !== 6) && (it = null)) : (et = null, it = ye), et !== it)) {
            if (lt = ah, He = "onMouseLeave", pe = "onMouseEnter", oe = "mouse", (r === "pointerout" || r === "pointerover") && (lt = ug, He = "onPointerLeave", pe = "onPointerEnter", oe = "pointer"), Kn = et == null ? Me : Xi(et), he = it == null ? Me : Xi(it), Me = new lt(He, oe + "leave", et, d, Oe), Me.target = Kn, Me.relatedTarget = he, He = null, Fl(Oe) === ye && (lt = new lt(pe, oe + "enter", it, d, Oe), lt.target = he, lt.relatedTarget = Kn, He = lt), Kn = He, et && it) t: {
              for (lt = et, pe = it, oe = 0, he = lt; he; he = No(he)) oe++;
              for (he = 0, He = pe; He; He = No(He)) he++;
              for (; 0 < oe - he;) lt = No(lt), oe--;
              for (; 0 < he - oe;) pe = No(pe), he--;
              for (; oe--;) {
                if (lt === pe || pe !== null && lt === pe.alternate) break t;
                lt = No(lt), pe = No(pe);
              }
              lt = null;
            } else lt = null;
            et !== null && Ig(ze, Me, et, lt, !1), it !== null && Kn !== null && Ig(ze, Kn, it, lt, !0);
          }
        }
        e: {
          if (Me = ye ? Xi(ye) : window, et = Me.nodeName && Me.nodeName.toLowerCase(), et === "select" || et === "input" && Me.type === "file") var ut = Sw;else if (vg(Me)) {
            if (yg) ut = Sg;else {
              ut = xg;
              var bt = Ew;
            }
          } else (et = Me.nodeName) && et.toLowerCase() === "input" && (Me.type === "checkbox" || Me.type === "radio") && (ut = Cw);
          if (ut && (ut = ut(r, ye))) {
            hh(ze, ut, d, Oe);
            break e;
          }
          bt && bt(r, Me, ye), r === "focusout" && (bt = Me._wrapperState) && bt.controlled && Me.type === "number" && Pt(Me, "number", Me.value);
        }
        switch (bt = ye ? Xi(ye) : window, r) {
          case "focusin":
            (vg(bt) || bt.contentEditable === "true") && (Ds = bt, gh = ye, Uu = null);
            break;
          case "focusout":
            Uu = gh = Ds = null;
            break;
          case "mousedown":
            yh = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            yh = !1, bh(ze, d, Oe);
            break;
          case "selectionchange":
            if (Tw) break;
          case "keydown":
          case "keyup":
            bh(ze, d, Oe);
        }
        var wt;
        if (ks) e: {
          switch (r) {
            case "compositionstart":
              var It = "onCompositionStart";
              break e;
            case "compositionend":
              It = "onCompositionEnd";
              break e;
            case "compositionupdate":
              It = "onCompositionUpdate";
              break e;
          }
          It = void 0;
        } else Ts ? pg(r, d) && (It = "onCompositionEnd") : r === "keydown" && d.keyCode === 229 && (It = "onCompositionStart");
        It && (dg && d.locale !== "ko" && (Ts || It !== "onCompositionStart" ? It === "onCompositionEnd" && Ts && (wt = rh()) : (Ya = Oe, gd = "value" in Ya ? Ya.value : Ya.textContent, Ts = !0)), bt = $u(ye, It), 0 < bt.length && (It = new sh(It, r, null, d, Oe), ze.push({
          event: It,
          listeners: bt
        }), wt ? It.data = wt : (wt = hg(d), wt !== null && (It.data = wt)))), (wt = Nu ? mg(r, d) : _w(r, d)) && (ye = $u(ye, "onBeforeInput"), 0 < ye.length && (Oe = new sh("onBeforeInput", "beforeinput", null, d, Oe), ze.push({
          event: Oe,
          listeners: ye
        }), Oe.data = wt));
      }
      Al(ze, o);
    });
  }
  function Ms(r, o, d) {
    return {
      instance: r,
      listener: o,
      currentTarget: d
    };
  }
  function $u(r, o) {
    for (var d = o + "Capture", g = []; r !== null;) {
      var S = r,
        R = S.stateNode;
      S.tag === 5 && R !== null && (S = R, R = Ha(r, d), R != null && g.unshift(Ms(r, R, S)), R = Ha(r, o), R != null && g.push(Ms(r, R, S))), r = r.return;
    }
    return g;
  }
  function No(r) {
    if (r === null) return null;
    do r = r.return; while (r && r.tag !== 5);
    return r || null;
  }
  function Ig(r, o, d, g, S) {
    for (var R = o._reactName, A = []; d !== null && d !== g;) {
      var q = d,
        re = q.alternate,
        ye = q.stateNode;
      if (re !== null && re === g) break;
      q.tag === 5 && ye !== null && (q = ye, S ? (re = Ha(d, R), re != null && A.unshift(Ms(d, re, q))) : S || (re = Ha(d, R), re != null && A.push(Ms(d, re, q)))), d = d.return;
    }
    A.length !== 0 && r.push({
      event: o,
      listeners: A
    });
  }
  var Mg = /\r\n?/g,
    Iw = /\u0000|\uFFFD/g;
  function Lg(r) {
    return (typeof r == "string" ? r : "" + r).replace(Mg, `
`).replace(Iw, "");
  }
  function Pd(r, o, d) {
    if (o = Lg(o), Lg(r) !== o && d) throw Error(i(425));
  }
  function zo() {}
  var Wu = null,
    jl = null;
  function Ad(r, o) {
    return r === "textarea" || r === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var jd = typeof setTimeout == "function" ? setTimeout : void 0,
    Eh = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Og = typeof Promise == "function" ? Promise : void 0,
    Ls = typeof queueMicrotask == "function" ? queueMicrotask : typeof Og < "u" ? function (r) {
      return Og.resolve(null).then(r).catch(Fd);
    } : jd;
  function Fd(r) {
    setTimeout(function () {
      throw r;
    });
  }
  function Os(r, o) {
    var d = o,
      g = 0;
    do {
      var S = d.nextSibling;
      if (r.removeChild(d), S && S.nodeType === 8) if (d = S.data, d === "/$") {
        if (g === 0) {
          r.removeChild(S), jo(o);
          return;
        }
        g--;
      } else d !== "$" && d !== "$?" && d !== "$!" || g++;
      d = S;
    } while (d);
    jo(o);
  }
  function ha(r) {
    for (; r != null; r = r.nextSibling) {
      var o = r.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = r.data, o === "$" || o === "$!" || o === "$?") break;
        if (o === "/$") return null;
      }
    }
    return r;
  }
  function Pg(r) {
    r = r.previousSibling;
    for (var o = 0; r;) {
      if (r.nodeType === 8) {
        var d = r.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (o === 0) return r;
          o--;
        } else d === "/$" && o++;
      }
      r = r.previousSibling;
    }
    return null;
  }
  var Vo = Math.random().toString(36).slice(2),
    ma = "__reactFiber$" + Vo,
    qu = "__reactProps$" + Vo,
    Qa = "__reactContainer$" + Vo,
    Yu = "__reactEvents$" + Vo,
    Ps = "__reactListeners$" + Vo,
    Mw = "__reactHandles$" + Vo;
  function Fl(r) {
    var o = r[ma];
    if (o) return o;
    for (var d = r.parentNode; d;) {
      if (o = d[Qa] || d[ma]) {
        if (d = o.alternate, o.child !== null || d !== null && d.child !== null) for (r = Pg(r); r !== null;) {
          if (d = r[ma]) return d;
          r = Pg(r);
        }
        return o;
      }
      r = d, d = r.parentNode;
    }
    return null;
  }
  function pt(r) {
    return r = r[ma] || r[Qa], !r || r.tag !== 5 && r.tag !== 6 && r.tag !== 13 && r.tag !== 3 ? null : r;
  }
  function Xi(r) {
    if (r.tag === 5 || r.tag === 6) return r.stateNode;
    throw Error(i(33));
  }
  function Gn(r) {
    return r[qu] || null;
  }
  var tn = [],
    _i = -1;
  function Ki(r) {
    return {
      current: r
    };
  }
  function Sn(r) {
    0 > _i || (r.current = tn[_i], tn[_i] = null, _i--);
  }
  function ft(r, o) {
    _i++, tn[_i] = r.current, r.current = o;
  }
  var qr = {},
    Hn = Ki(qr),
    or = Ki(!1),
    Yr = qr;
  function xi(r, o) {
    var d = r.type.contextTypes;
    if (!d) return qr;
    var g = r.stateNode;
    if (g && g.__reactInternalMemoizedUnmaskedChildContext === o) return g.__reactInternalMemoizedMaskedChildContext;
    var S = {},
      R;
    for (R in d) S[R] = o[R];
    return g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = o, r.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function tr(r) {
    return r = r.childContextTypes, r != null;
  }
  function As() {
    Sn(or), Sn(Hn);
  }
  function Ag(r, o, d) {
    if (Hn.current !== qr) throw Error(i(168));
    ft(Hn, o), ft(or, d);
  }
  function Gu(r, o, d) {
    var g = r.stateNode;
    if (o = o.childContextTypes, typeof g.getChildContext != "function") return d;
    g = g.getChildContext();
    for (var S in g) if (!(S in o)) throw Error(i(108, Se(r) || "Unknown", S));
    return H({}, d, g);
  }
  function Gr(r) {
    return r = (r = r.stateNode) && r.__reactInternalMemoizedMergedChildContext || qr, Yr = Hn.current, ft(Hn, r), ft(or, or.current), !0;
  }
  function Nd(r, o, d) {
    var g = r.stateNode;
    if (!g) throw Error(i(169));
    d ? (r = Gu(r, o, Yr), g.__reactInternalMemoizedMergedChildContext = r, Sn(or), Sn(Hn), ft(Hn, r)) : Sn(or), ft(or, d);
  }
  var va = null,
    js = !1,
    Za = !1;
  function zd(r) {
    va === null ? va = [r] : va.push(r);
  }
  function Bo(r) {
    js = !0, zd(r);
  }
  function ga() {
    if (!Za && va !== null) {
      Za = !0;
      var r = 0,
        o = gn;
      try {
        var d = va;
        for (gn = 1; r < d.length; r++) {
          var g = d[r];
          do g = g(!0); while (g !== null);
        }
        va = null, js = !1;
      } catch (S) {
        throw va !== null && (va = va.slice(r + 1)), Or(El, ga), S;
      } finally {
        gn = o, Za = !1;
      }
    }
    return null;
  }
  var Uo = [],
    Ho = 0,
    $o = null,
    Ja = 0,
    nr = [],
    Si = 0,
    li = null,
    ya = 1,
    ba = "";
  function Nl(r, o) {
    Uo[Ho++] = Ja, Uo[Ho++] = $o, $o = r, Ja = o;
  }
  function jg(r, o, d) {
    nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = li, li = r;
    var g = ya;
    r = ba;
    var S = 32 - gi(g) - 1;
    g &= ~(1 << S), d += 1;
    var R = 32 - gi(o) + S;
    if (30 < R) {
      var A = S - S % 5;
      R = (g & (1 << A) - 1).toString(32), g >>= A, S -= A, ya = 1 << 32 - gi(o) + S | d << S | g, ba = R + r;
    } else ya = 1 << R | d << S | g, ba = r;
  }
  function Vd(r) {
    r.return !== null && (Nl(r, 1), jg(r, 1, 0));
  }
  function Bd(r) {
    for (; r === $o;) $o = Uo[--Ho], Uo[Ho] = null, Ja = Uo[--Ho], Uo[Ho] = null;
    for (; r === li;) li = nr[--Si], nr[Si] = null, ba = nr[--Si], nr[Si] = null, ya = nr[--Si], nr[Si] = null;
  }
  var Xr = null,
    Kr = null,
    In = !1,
    Ei = null;
  function Ch(r, o) {
    var d = Oi(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = o, d.return = r, o = r.deletions, o === null ? (r.deletions = [d], r.flags |= 16) : o.push(d);
  }
  function Fg(r, o) {
    switch (r.tag) {
      case 5:
        var d = r.type;
        return o = o.nodeType !== 1 || d.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = ha(o.firstChild), !0) : !1;
      case 6:
        return o = r.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (d = li !== null ? {
          id: ya,
          overflow: ba
        } : null, r.memoizedState = {
          dehydrated: o,
          treeContext: d,
          retryLane: 1073741824
        }, d = Oi(18, null, null, 0), d.stateNode = o, d.return = r, r.child = d, Xr = r, Kr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function kh(r) {
    return (r.mode & 1) !== 0 && (r.flags & 128) === 0;
  }
  function Th(r) {
    if (In) {
      var o = Kr;
      if (o) {
        var d = o;
        if (!Fg(r, o)) {
          if (kh(r)) throw Error(i(418));
          o = ha(d.nextSibling);
          var g = Xr;
          o && Fg(r, o) ? Ch(g, d) : (r.flags = r.flags & -4097 | 2, In = !1, Xr = r);
        }
      } else {
        if (kh(r)) throw Error(i(418));
        r.flags = r.flags & -4097 | 2, In = !1, Xr = r;
      }
    }
  }
  function lr(r) {
    for (r = r.return; r !== null && r.tag !== 5 && r.tag !== 3 && r.tag !== 13;) r = r.return;
    Xr = r;
  }
  function Ud(r) {
    if (r !== Xr) return !1;
    if (!In) return lr(r), In = !0, !1;
    var o;
    if ((o = r.tag !== 3) && !(o = r.tag !== 5) && (o = r.type, o = o !== "head" && o !== "body" && !Ad(r.type, r.memoizedProps)), o && (o = Kr)) {
      if (kh(r)) throw Xu(), Error(i(418));
      for (; o;) Ch(r, o), o = ha(o.nextSibling);
    }
    if (lr(r), r.tag === 13) {
      if (r = r.memoizedState, r = r !== null ? r.dehydrated : null, !r) throw Error(i(317));
      e: {
        for (r = r.nextSibling, o = 0; r;) {
          if (r.nodeType === 8) {
            var d = r.data;
            if (d === "/$") {
              if (o === 0) {
                Kr = ha(r.nextSibling);
                break e;
              }
              o--;
            } else d !== "$" && d !== "$!" && d !== "$?" || o++;
          }
          r = r.nextSibling;
        }
        Kr = null;
      }
    } else Kr = Xr ? ha(r.stateNode.nextSibling) : null;
    return !0;
  }
  function Xu() {
    for (var r = Kr; r;) r = ha(r.nextSibling);
  }
  function Wo() {
    Kr = Xr = null, In = !1;
  }
  function eo(r) {
    Ei === null ? Ei = [r] : Ei.push(r);
  }
  var Lw = j.ReactCurrentBatchConfig;
  function si(r, o) {
    if (r && r.defaultProps) {
      o = H({}, o), r = r.defaultProps;
      for (var d in r) o[d] === void 0 && (o[d] = r[d]);
      return o;
    }
    return o;
  }
  var Hd = Ki(null),
    $d = null,
    Qi = null,
    dr = null;
  function Ge() {
    dr = Qi = $d = null;
  }
  function Ci(r) {
    var o = Hd.current;
    Sn(Hd), r._currentValue = o;
  }
  function ui(r, o, d) {
    for (; r !== null;) {
      var g = r.alternate;
      if ((r.childLanes & o) !== o ? (r.childLanes |= o, g !== null && (g.childLanes |= o)) : g !== null && (g.childLanes & o) !== o && (g.childLanes |= o), r === d) break;
      r = r.return;
    }
  }
  function Fs(r, o) {
    $d = r, dr = Qi = null, r = r.dependencies, r !== null && r.firstContext !== null && ((r.lanes & o) !== 0 && (Dr = !0), r.firstContext = null);
  }
  function ki(r) {
    var o = r._currentValue;
    if (dr !== r) if (r = {
      context: r,
      memoizedValue: o,
      next: null
    }, Qi === null) {
      if ($d === null) throw Error(i(308));
      Qi = r, $d.dependencies = {
        lanes: 0,
        firstContext: r
      };
    } else Qi = Qi.next = r;
    return o;
  }
  var zl = null;
  function Rh(r) {
    zl === null ? zl = [r] : zl.push(r);
  }
  function Ng(r, o, d, g) {
    var S = o.interleaved;
    return S === null ? (d.next = d, Rh(o)) : (d.next = S.next, S.next = d), o.interleaved = d, En(r, g);
  }
  function En(r, o) {
    r.lanes |= o;
    var d = r.alternate;
    for (d !== null && (d.lanes |= o), d = r, r = r.return; r !== null;) r.childLanes |= o, d = r.alternate, d !== null && (d.childLanes |= o), d = r, r = r.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var qo = !1;
  function Dh(r) {
    r.updateQueue = {
      baseState: r.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        interleaved: null,
        lanes: 0
      },
      effects: null
    };
  }
  function zg(r, o) {
    r = r.updateQueue, o.updateQueue === r && (o.updateQueue = {
      baseState: r.baseState,
      firstBaseUpdate: r.firstBaseUpdate,
      lastBaseUpdate: r.lastBaseUpdate,
      shared: r.shared,
      effects: r.effects
    });
  }
  function wa(r, o) {
    return {
      eventTime: r,
      lane: o,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function Ti(r, o, d) {
    var g = r.updateQueue;
    if (g === null) return null;
    if (g = g.shared, (on & 2) !== 0) {
      var S = g.pending;
      return S === null ? o.next = o : (o.next = S.next, S.next = o), g.pending = o, En(r, d);
    }
    return S = g.interleaved, S === null ? (o.next = o, Rh(g)) : (o.next = S.next, S.next = o), g.interleaved = o, En(r, d);
  }
  function to(r, o, d) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (d & 4194240) !== 0)) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, pd(r, d);
    }
  }
  function Vg(r, o) {
    var d = r.updateQueue,
      g = r.alternate;
    if (g !== null && (g = g.updateQueue, d === g)) {
      var S = null,
        R = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var A = {
            eventTime: d.eventTime,
            lane: d.lane,
            tag: d.tag,
            payload: d.payload,
            callback: d.callback,
            next: null
          };
          R === null ? S = R = A : R = R.next = A, d = d.next;
        } while (d !== null);
        R === null ? S = R = o : R = R.next = o;
      } else S = R = o;
      d = {
        baseState: g.baseState,
        firstBaseUpdate: S,
        lastBaseUpdate: R,
        shared: g.shared,
        effects: g.effects
      }, r.updateQueue = d;
      return;
    }
    r = d.lastBaseUpdate, r === null ? d.firstBaseUpdate = o : r.next = o, d.lastBaseUpdate = o;
  }
  function Wd(r, o, d, g) {
    var S = r.updateQueue;
    qo = !1;
    var R = S.firstBaseUpdate,
      A = S.lastBaseUpdate,
      q = S.shared.pending;
    if (q !== null) {
      S.shared.pending = null;
      var re = q,
        ye = re.next;
      re.next = null, A === null ? R = ye : A.next = ye, A = re;
      var Oe = r.alternate;
      Oe !== null && (Oe = Oe.updateQueue, q = Oe.lastBaseUpdate, q !== A && (q === null ? Oe.firstBaseUpdate = ye : q.next = ye, Oe.lastBaseUpdate = re));
    }
    if (R !== null) {
      var ze = S.baseState;
      A = 0, Oe = ye = re = null, q = R;
      do {
        var Me = q.lane,
          et = q.eventTime;
        if ((g & Me) === Me) {
          Oe !== null && (Oe = Oe.next = {
            eventTime: et,
            lane: 0,
            tag: q.tag,
            payload: q.payload,
            callback: q.callback,
            next: null
          });
          e: {
            var it = r,
              lt = q;
            switch (Me = o, et = d, lt.tag) {
              case 1:
                if (it = lt.payload, typeof it == "function") {
                  ze = it.call(et, ze, Me);
                  break e;
                }
                ze = it;
                break e;
              case 3:
                it.flags = it.flags & -65537 | 128;
              case 0:
                if (it = lt.payload, Me = typeof it == "function" ? it.call(et, ze, Me) : it, Me == null) break e;
                ze = H({}, ze, Me);
                break e;
              case 2:
                qo = !0;
            }
          }
          q.callback !== null && q.lane !== 0 && (r.flags |= 64, Me = S.effects, Me === null ? S.effects = [q] : Me.push(q));
        } else et = {
          eventTime: et,
          lane: Me,
          tag: q.tag,
          payload: q.payload,
          callback: q.callback,
          next: null
        }, Oe === null ? (ye = Oe = et, re = ze) : Oe = Oe.next = et, A |= Me;
        if (q = q.next, q === null) {
          if (q = S.shared.pending, q === null) break;
          Me = q, q = Me.next, Me.next = null, S.lastBaseUpdate = Me, S.shared.pending = null;
        }
      } while (!0);
      if (Oe === null && (re = ze), S.baseState = re, S.firstBaseUpdate = ye, S.lastBaseUpdate = Oe, o = S.shared.interleaved, o !== null) {
        S = o;
        do A |= S.lane, S = S.next; while (S !== o);
      } else R === null && (S.shared.lanes = 0);
      xo |= A, r.lanes = A, r.memoizedState = ze;
    }
  }
  function Bg(r, o, d) {
    if (r = o.effects, o.effects = null, r !== null) for (o = 0; o < r.length; o++) {
      var g = r[o],
        S = g.callback;
      if (S !== null) {
        if (g.callback = null, g = d, typeof S != "function") throw Error(i(191, S));
        S.call(g);
      }
    }
  }
  var Ug = new t.Component().refs;
  function Ih(r, o, d, g) {
    o = r.memoizedState, d = d(g, o), d = d == null ? o : H({}, o, d), r.memoizedState = d, r.lanes === 0 && (r.updateQueue.baseState = d);
  }
  var qd = {
    isMounted: function (r) {
      return (r = r._reactInternals) ? $t(r) === r : !1;
    },
    enqueueSetState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Li(o, r, S, g), to(o, r, S));
    },
    enqueueReplaceState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.tag = 1, R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Li(o, r, S, g), to(o, r, S));
    },
    enqueueForceUpdate: function (r, o) {
      r = r._reactInternals;
      var d = hr(),
        g = Ca(r),
        S = wa(d, g);
      S.tag = 2, o != null && (S.callback = o), o = Ti(r, S, g), o !== null && (Li(o, r, g, d), to(o, r, g));
    }
  };
  function Mh(r, o, d, g, S, R, A) {
    return r = r.stateNode, typeof r.shouldComponentUpdate == "function" ? r.shouldComponentUpdate(g, R, A) : o.prototype && o.prototype.isPureReactComponent ? !Vu(d, g) || !Vu(S, R) : !0;
  }
  function Lh(r, o, d) {
    var g = !1,
      S = qr,
      R = o.contextType;
    return typeof R == "object" && R !== null ? R = ki(R) : (S = tr(o) ? Yr : Hn.current, g = o.contextTypes, R = (g = g != null) ? xi(r, S) : qr), o = new o(d, R), r.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = qd, r.stateNode = o, o._reactInternals = r, g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = S, r.__reactInternalMemoizedMaskedChildContext = R), o;
  }
  function Hg(r, o, d, g) {
    r = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, g), o.state !== r && qd.enqueueReplaceState(o, o.state, null);
  }
  function Oh(r, o, d, g) {
    var S = r.stateNode;
    S.props = d, S.state = r.memoizedState, S.refs = Ug, Dh(r);
    var R = o.contextType;
    typeof R == "object" && R !== null ? S.context = ki(R) : (R = tr(o) ? Yr : Hn.current, S.context = xi(r, R)), S.state = r.memoizedState, R = o.getDerivedStateFromProps, typeof R == "function" && (Ih(r, o, R, d), S.state = r.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (o = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), o !== S.state && qd.enqueueReplaceState(S, S.state, null), Wd(r, d, S, g), S.state = r.memoizedState), typeof S.componentDidMount == "function" && (r.flags |= 4194308);
  }
  function Ku(r, o, d) {
    if (r = d.ref, r !== null && typeof r != "function" && typeof r != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var g = d.stateNode;
        }
        if (!g) throw Error(i(147, r));
        var S = g,
          R = "" + r;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === R ? o.ref : (o = function (A) {
          var q = S.refs;
          q === Ug && (q = S.refs = {}), A === null ? delete q[R] : q[R] = A;
        }, o._stringRef = R, o);
      }
      if (typeof r != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, r));
    }
    return r;
  }
  function Yd(r, o) {
    throw r = Object.prototype.toString.call(o), Error(i(31, r === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : r));
  }
  function $g(r) {
    var o = r._init;
    return o(r._payload);
  }
  function Wg(r) {
    function o(pe, oe) {
      if (r) {
        var he = pe.deletions;
        he === null ? (pe.deletions = [oe], pe.flags |= 16) : he.push(oe);
      }
    }
    function d(pe, oe) {
      if (!r) return null;
      for (; oe !== null;) o(pe, oe), oe = oe.sibling;
      return null;
    }
    function g(pe, oe) {
      for (pe = /* @__PURE__ */new Map(); oe !== null;) oe.key !== null ? pe.set(oe.key, oe) : pe.set(oe.index, oe), oe = oe.sibling;
      return pe;
    }
    function S(pe, oe) {
      return pe = La(pe, oe), pe.index = 0, pe.sibling = null, pe;
    }
    function R(pe, oe, he) {
      return pe.index = he, r ? (he = pe.alternate, he !== null ? (he = he.index, he < oe ? (pe.flags |= 2, oe) : he) : (pe.flags |= 2, oe)) : (pe.flags |= 1048576, oe);
    }
    function A(pe) {
      return r && pe.alternate === null && (pe.flags |= 2), pe;
    }
    function q(pe, oe, he, He) {
      return oe === null || oe.tag !== 6 ? (oe = gf(he, pe.mode, He), oe.return = pe, oe) : (oe = S(oe, he), oe.return = pe, oe);
    }
    function re(pe, oe, he, He) {
      var ut = he.type;
      return ut === G ? Oe(pe, oe, he.props.children, He, he.key) : oe !== null && (oe.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ce && $g(ut) === oe.type) ? (He = S(oe, he.props), He.ref = Ku(pe, oe, he), He.return = pe, He) : (He = Jl(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, oe, he), He.return = pe, He);
    }
    function ye(pe, oe, he, He) {
      return oe === null || oe.tag !== 4 || oe.stateNode.containerInfo !== he.containerInfo || oe.stateNode.implementation !== he.implementation ? (oe = yf(he, pe.mode, He), oe.return = pe, oe) : (oe = S(oe, he.children || []), oe.return = pe, oe);
    }
    function Oe(pe, oe, he, He, ut) {
      return oe === null || oe.tag !== 7 ? (oe = oo(he, pe.mode, He, ut), oe.return = pe, oe) : (oe = S(oe, he), oe.return = pe, oe);
    }
    function ze(pe, oe, he) {
      if (typeof oe == "string" && oe !== "" || typeof oe == "number") return oe = gf("" + oe, pe.mode, he), oe.return = pe, oe;
      if (typeof oe == "object" && oe !== null) {
        switch (oe.$$typeof) {
          case V:
            return he = Jl(oe.type, oe.key, oe.props, null, pe.mode, he), he.ref = Ku(pe, null, oe), he.return = pe, he;
          case K:
            return oe = yf(oe, pe.mode, he), oe.return = pe, oe;
          case ce:
            var He = oe._init;
            return ze(pe, He(oe._payload), he);
        }
        if (St(oe) || de(oe)) return oe = oo(oe, pe.mode, he, null), oe.return = pe, oe;
        Yd(pe, oe);
      }
      return null;
    }
    function Me(pe, oe, he, He) {
      var ut = oe !== null ? oe.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number") return ut !== null ? null : q(pe, oe, "" + he, He);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            return he.key === ut ? re(pe, oe, he, He) : null;
          case K:
            return he.key === ut ? ye(pe, oe, he, He) : null;
          case ce:
            return ut = he._init, Me(pe, oe, ut(he._payload), He);
        }
        if (St(he) || de(he)) return ut !== null ? null : Oe(pe, oe, he, He, null);
        Yd(pe, he);
      }
      return null;
    }
    function et(pe, oe, he, He, ut) {
      if (typeof He == "string" && He !== "" || typeof He == "number") return pe = pe.get(he) || null, q(oe, pe, "" + He, ut);
      if (typeof He == "object" && He !== null) {
        switch (He.$$typeof) {
          case V:
            return pe = pe.get(He.key === null ? he : He.key) || null, re(oe, pe, He, ut);
          case K:
            return pe = pe.get(He.key === null ? he : He.key) || null, ye(oe, pe, He, ut);
          case ce:
            var bt = He._init;
            return et(pe, oe, he, bt(He._payload), ut);
        }
        if (St(He) || de(He)) return pe = pe.get(he) || null, Oe(oe, pe, He, ut, null);
        Yd(oe, He);
      }
      return null;
    }
    function it(pe, oe, he, He) {
      for (var ut = null, bt = null, wt = oe, It = oe = 0, mr = null; wt !== null && It < he.length; It++) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var cn = Me(pe, wt, he[It], He);
        if (cn === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && cn.alternate === null && o(pe, wt), oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn, wt = mr;
      }
      if (It === he.length) return d(pe, wt), In && Nl(pe, It), ut;
      if (wt === null) {
        for (; It < he.length; It++) wt = ze(pe, he[It], He), wt !== null && (oe = R(wt, oe, It), bt === null ? ut = wt : bt.sibling = wt, bt = wt);
        return In && Nl(pe, It), ut;
      }
      for (wt = g(pe, wt); It < he.length; It++) mr = et(wt, pe, It, he[It], He), mr !== null && (r && mr.alternate !== null && wt.delete(mr.key === null ? It : mr.key), oe = R(mr, oe, It), bt === null ? ut = mr : bt.sibling = mr, bt = mr);
      return r && wt.forEach(function (lo) {
        return o(pe, lo);
      }), In && Nl(pe, It), ut;
    }
    function lt(pe, oe, he, He) {
      var ut = de(he);
      if (typeof ut != "function") throw Error(i(150));
      if (he = ut.call(he), he == null) throw Error(i(151));
      for (var bt = ut = null, wt = oe, It = oe = 0, mr = null, cn = he.next(); wt !== null && !cn.done; It++, cn = he.next()) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var lo = Me(pe, wt, cn.value, He);
        if (lo === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && lo.alternate === null && o(pe, wt), oe = R(lo, oe, It), bt === null ? ut = lo : bt.sibling = lo, bt = lo, wt = mr;
      }
      if (cn.done) return d(pe, wt), In && Nl(pe, It), ut;
      if (wt === null) {
        for (; !cn.done; It++, cn = he.next()) cn = ze(pe, cn.value, He), cn !== null && (oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
        return In && Nl(pe, It), ut;
      }
      for (wt = g(pe, wt); !cn.done; It++, cn = he.next()) cn = et(wt, pe, It, cn.value, He), cn !== null && (r && cn.alternate !== null && wt.delete(cn.key === null ? It : cn.key), oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
      return r && wt.forEach(function (Pb) {
        return o(pe, Pb);
      }), In && Nl(pe, It), ut;
    }
    function Kn(pe, oe, he, He) {
      if (typeof he == "object" && he !== null && he.type === G && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            e: {
              for (var ut = he.key, bt = oe; bt !== null;) {
                if (bt.key === ut) {
                  if (ut = he.type, ut === G) {
                    if (bt.tag === 7) {
                      d(pe, bt.sibling), oe = S(bt, he.props.children), oe.return = pe, pe = oe;
                      break e;
                    }
                  } else if (bt.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ce && $g(ut) === bt.type) {
                    d(pe, bt.sibling), oe = S(bt, he.props), oe.ref = Ku(pe, bt, he), oe.return = pe, pe = oe;
                    break e;
                  }
                  d(pe, bt);
                  break;
                } else o(pe, bt);
                bt = bt.sibling;
              }
              he.type === G ? (oe = oo(he.props.children, pe.mode, He, he.key), oe.return = pe, pe = oe) : (He = Jl(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, oe, he), He.return = pe, pe = He);
            }
            return A(pe);
          case K:
            e: {
              for (bt = he.key; oe !== null;) {
                if (oe.key === bt) {
                  if (oe.tag === 4 && oe.stateNode.containerInfo === he.containerInfo && oe.stateNode.implementation === he.implementation) {
                    d(pe, oe.sibling), oe = S(oe, he.children || []), oe.return = pe, pe = oe;
                    break e;
                  } else {
                    d(pe, oe);
                    break;
                  }
                } else o(pe, oe);
                oe = oe.sibling;
              }
              oe = yf(he, pe.mode, He), oe.return = pe, pe = oe;
            }
            return A(pe);
          case ce:
            return bt = he._init, Kn(pe, oe, bt(he._payload), He);
        }
        if (St(he)) return it(pe, oe, he, He);
        if (de(he)) return lt(pe, oe, he, He);
        Yd(pe, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" ? (he = "" + he, oe !== null && oe.tag === 6 ? (d(pe, oe.sibling), oe = S(oe, he), oe.return = pe, pe = oe) : (d(pe, oe), oe = gf(he, pe.mode, He), oe.return = pe, pe = oe), A(pe)) : d(pe, oe);
    }
    return Kn;
  }
  var Vl = Wg(!0),
    qg = Wg(!1),
    Ns = {},
    _a = Ki(Ns),
    Qu = Ki(Ns),
    Bl = Ki(Ns);
  function dt(r) {
    if (r === Ns) throw Error(i(174));
    return r;
  }
  function Wt(r, o) {
    switch (ft(Bl, o), ft(Qu, r), ft(_a, Ns), r = o.nodeType, r) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : Xt(null, "");
        break;
      default:
        r = r === 8 ? o.parentNode : o, o = r.namespaceURI || null, r = r.tagName, o = Xt(o, r);
    }
    Sn(_a), ft(_a, o);
  }
  function nn() {
    Sn(_a), Sn(Qu), Sn(Bl);
  }
  function Xn(r) {
    dt(Bl.current);
    var o = dt(_a.current),
      d = Xt(o, r.type);
    o !== d && (ft(Qu, r), ft(_a, d));
  }
  function Ri(r) {
    Qu.current === r && (Sn(_a), Sn(Qu));
  }
  var Mn = Ki(0);
  function Gd(r) {
    for (var o = r; o !== null;) {
      if (o.tag === 13) {
        var d = o.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if ((o.flags & 128) !== 0) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === r) break;
      for (; o.sibling === null;) {
        if (o.return === null || o.return === r) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Ph = [];
  function Ah() {
    for (var r = 0; r < Ph.length; r++) Ph[r]._workInProgressVersionPrimary = null;
    Ph.length = 0;
  }
  var zs = j.ReactCurrentDispatcher,
    Re = j.ReactCurrentBatchConfig,
    Ln = 0,
    Je = null,
    On = null,
    Cn = null,
    xa = !1,
    Qr = !1,
    no = 0,
    Vs = 0;
  function rr() {
    throw Error(i(321));
  }
  function Zu(r, o) {
    if (o === null) return !1;
    for (var d = 0; d < o.length && d < r.length; d++) if (!Gi(r[d], o[d])) return !1;
    return !0;
  }
  function Ju(r, o, d, g, S, R) {
    if (Ln = R, Je = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, zs.current = r === null || r.memoizedState === null ? Pw : Fh, r = d(g, S), Qr) {
      R = 0;
      do {
        if (Qr = !1, no = 0, 25 <= R) throw Error(i(301));
        R += 1, Cn = On = null, o.updateQueue = null, zs.current = Qg, r = d(g, S);
      } while (Qr);
    }
    if (zs.current = qs, o = On !== null && On.next !== null, Ln = 0, Cn = On = Je = null, xa = !1, o) throw Error(i(300));
    return r;
  }
  function ec() {
    var r = no !== 0;
    return no = 0, r;
  }
  function Di() {
    var r = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r, Cn;
  }
  function Zr() {
    if (On === null) {
      var r = Je.alternate;
      r = r !== null ? r.memoizedState : null;
    } else r = On.next;
    var o = Cn === null ? Je.memoizedState : Cn.next;
    if (o !== null) Cn = o, On = r;else {
      if (r === null) throw Error(i(310));
      On = r, r = {
        memoizedState: On.memoizedState,
        baseState: On.baseState,
        baseQueue: On.baseQueue,
        queue: On.queue,
        next: null
      }, Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r;
    }
    return Cn;
  }
  function Ul(r, o) {
    return typeof o == "function" ? o(r) : o;
  }
  function tc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = On,
      S = g.baseQueue,
      R = d.pending;
    if (R !== null) {
      if (S !== null) {
        var A = S.next;
        S.next = R.next, R.next = A;
      }
      g.baseQueue = S = R, d.pending = null;
    }
    if (S !== null) {
      R = S.next, g = g.baseState;
      var q = A = null,
        re = null,
        ye = R;
      do {
        var Oe = ye.lane;
        if ((Ln & Oe) === Oe) re !== null && (re = re.next = {
          lane: 0,
          action: ye.action,
          hasEagerState: ye.hasEagerState,
          eagerState: ye.eagerState,
          next: null
        }), g = ye.hasEagerState ? ye.eagerState : r(g, ye.action);else {
          var ze = {
            lane: Oe,
            action: ye.action,
            hasEagerState: ye.hasEagerState,
            eagerState: ye.eagerState,
            next: null
          };
          re === null ? (q = re = ze, A = g) : re = re.next = ze, Je.lanes |= Oe, xo |= Oe;
        }
        ye = ye.next;
      } while (ye !== null && ye !== R);
      re === null ? A = g : re.next = q, Gi(g, o.memoizedState) || (Dr = !0), o.memoizedState = g, o.baseState = A, o.baseQueue = re, d.lastRenderedState = g;
    }
    if (r = d.interleaved, r !== null) {
      S = r;
      do R = S.lane, Je.lanes |= R, xo |= R, S = S.next; while (S !== r);
    } else S === null && (d.lanes = 0);
    return [o.memoizedState, d.dispatch];
  }
  function nc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = d.dispatch,
      S = d.pending,
      R = o.memoizedState;
    if (S !== null) {
      d.pending = null;
      var A = S = S.next;
      do R = r(R, A.action), A = A.next; while (A !== S);
      Gi(R, o.memoizedState) || (Dr = !0), o.memoizedState = R, o.baseQueue === null && (o.baseState = R), d.lastRenderedState = R;
    }
    return [R, g];
  }
  function Xd() {}
  function Kd(r, o) {
    var d = Je,
      g = Zr(),
      S = o(),
      R = !Gi(g.memoizedState, S);
    if (R && (g.memoizedState = S, Dr = !0), g = g.queue, af(Jd.bind(null, d, g, r), [r]), g.getSnapshot !== o || R || Cn !== null && Cn.memoizedState.tag & 1) {
      if (d.flags |= 2048, Sa(9, Zd.bind(null, d, g, S, o), void 0, null), pr === null) throw Error(i(349));
      (Ln & 30) !== 0 || Qd(d, o, S);
    }
    return S;
  }
  function Qd(r, o, d) {
    r.flags |= 16384, r = {
      getSnapshot: o,
      value: d
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.stores = [r]) : (d = o.stores, d === null ? o.stores = [r] : d.push(r));
  }
  function Zd(r, o, d, g) {
    o.value = d, o.getSnapshot = g, ef(o) && tf(r);
  }
  function Jd(r, o, d) {
    return d(function () {
      ef(o) && tf(r);
    });
  }
  function ef(r) {
    var o = r.getSnapshot;
    r = r.value;
    try {
      var d = o();
      return !Gi(r, d);
    } catch {
      return !0;
    }
  }
  function tf(r) {
    var o = En(r, 1);
    o !== null && Li(o, r, 1, -1);
  }
  function rc(r) {
    var o = Di();
    return typeof r == "function" && (r = r()), o.memoizedState = o.baseState = r, r = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Ul,
      lastRenderedState: r
    }, o.queue = r, r = r.dispatch = Ow.bind(null, Je, r), [o.memoizedState, r];
  }
  function Sa(r, o, d, g) {
    return r = {
      tag: r,
      create: o,
      destroy: d,
      deps: g,
      next: null
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.lastEffect = r.next = r) : (d = o.lastEffect, d === null ? o.lastEffect = r.next = r : (g = d.next, d.next = r, r.next = g, o.lastEffect = r)), r;
  }
  function nf() {
    return Zr().memoizedState;
  }
  function Bs(r, o, d, g) {
    var S = Di();
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, void 0, g === void 0 ? null : g);
  }
  function Us(r, o, d, g) {
    var S = Zr();
    g = g === void 0 ? null : g;
    var R = void 0;
    if (On !== null) {
      var A = On.memoizedState;
      if (R = A.destroy, g !== null && Zu(g, A.deps)) {
        S.memoizedState = Sa(o, d, R, g);
        return;
      }
    }
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, R, g);
  }
  function rf(r, o) {
    return Bs(8390656, 8, r, o);
  }
  function af(r, o) {
    return Us(2048, 8, r, o);
  }
  function Hs(r, o) {
    return Us(4, 2, r, o);
  }
  function jh(r, o) {
    return Us(4, 4, r, o);
  }
  function $s(r, o) {
    if (typeof o == "function") return r = r(), o(r), function () {
      o(null);
    };
    if (o != null) return r = r(), o.current = r, function () {
      o.current = null;
    };
  }
  function Yo(r, o, d) {
    return d = d != null ? d.concat([r]) : null, Us(4, 4, $s.bind(null, o, r), d);
  }
  function Jr() {}
  function Yg(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (d.memoizedState = [r, o], r);
  }
  function wn(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (r = r(), d.memoizedState = [r, o], r);
  }
  function ic(r, o, d) {
    return (Ln & 21) === 0 ? (r.baseState && (r.baseState = !1, Dr = !0), r.memoizedState = d) : (Gi(d, o) || (d = fd(), Je.lanes |= d, xo |= d, r.baseState = !0), o);
  }
  function of(r, o) {
    var d = gn;
    gn = d !== 0 && 4 > d ? d : 4, r(!0);
    var g = Re.transition;
    Re.transition = {};
    try {
      r(!1), o();
    } finally {
      gn = d, Re.transition = g;
    }
  }
  function Ws() {
    return Zr().memoizedState;
  }
  function lf(r, o, d) {
    var g = Ca(r);
    if (d = {
      lane: g,
      action: d,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Gg(r)) Xg(o, d);else if (d = Ng(r, o, d, g), d !== null) {
      var S = hr();
      Li(d, r, g, S), Kg(d, o, g);
    }
  }
  function Ow(r, o, d) {
    var g = Ca(r),
      S = {
        lane: g,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
    if (Gg(r)) Xg(o, S);else {
      var R = r.alternate;
      if (r.lanes === 0 && (R === null || R.lanes === 0) && (R = o.lastRenderedReducer, R !== null)) try {
        var A = o.lastRenderedState,
          q = R(A, d);
        if (S.hasEagerState = !0, S.eagerState = q, Gi(q, A)) {
          var re = o.interleaved;
          re === null ? (S.next = S, Rh(o)) : (S.next = re.next, re.next = S), o.interleaved = S;
          return;
        }
      } catch {} finally {}
      d = Ng(r, o, S, g), d !== null && (S = hr(), Li(d, r, g, S), Kg(d, o, g));
    }
  }
  function Gg(r) {
    var o = r.alternate;
    return r === Je || o !== null && o === Je;
  }
  function Xg(r, o) {
    Qr = xa = !0;
    var d = r.pending;
    d === null ? o.next = o : (o.next = d.next, d.next = o), r.pending = o;
  }
  function Kg(r, o, d) {
    if ((d & 4194240) !== 0) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, pd(r, d);
    }
  }
  var qs = {
      readContext: ki,
      useCallback: rr,
      useContext: rr,
      useEffect: rr,
      useImperativeHandle: rr,
      useInsertionEffect: rr,
      useLayoutEffect: rr,
      useMemo: rr,
      useReducer: rr,
      useRef: rr,
      useState: rr,
      useDebugValue: rr,
      useDeferredValue: rr,
      useTransition: rr,
      useMutableSource: rr,
      useSyncExternalStore: rr,
      useId: rr,
      unstable_isNewReconciler: !1
    },
    Pw = {
      readContext: ki,
      useCallback: function (r, o) {
        return Di().memoizedState = [r, o === void 0 ? null : o], r;
      },
      useContext: ki,
      useEffect: rf,
      useImperativeHandle: function (r, o, d) {
        return d = d != null ? d.concat([r]) : null, Bs(4194308, 4, $s.bind(null, o, r), d);
      },
      useLayoutEffect: function (r, o) {
        return Bs(4194308, 4, r, o);
      },
      useInsertionEffect: function (r, o) {
        return Bs(4, 2, r, o);
      },
      useMemo: function (r, o) {
        var d = Di();
        return o = o === void 0 ? null : o, r = r(), d.memoizedState = [r, o], r;
      },
      useReducer: function (r, o, d) {
        var g = Di();
        return o = d !== void 0 ? d(o) : o, g.memoizedState = g.baseState = o, r = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: r,
          lastRenderedState: o
        }, g.queue = r, r = r.dispatch = lf.bind(null, Je, r), [g.memoizedState, r];
      },
      useRef: function (r) {
        var o = Di();
        return r = {
          current: r
        }, o.memoizedState = r;
      },
      useState: rc,
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        return Di().memoizedState = r;
      },
      useTransition: function () {
        var r = rc(!1),
          o = r[0];
        return r = of.bind(null, r[1]), Di().memoizedState = r, [o, r];
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (r, o, d) {
        var g = Je,
          S = Di();
        if (In) {
          if (d === void 0) throw Error(i(407));
          d = d();
        } else {
          if (d = o(), pr === null) throw Error(i(349));
          (Ln & 30) !== 0 || Qd(g, o, d);
        }
        S.memoizedState = d;
        var R = {
          value: d,
          getSnapshot: o
        };
        return S.queue = R, rf(Jd.bind(null, g, R, r), [r]), g.flags |= 2048, Sa(9, Zd.bind(null, g, R, d, o), void 0, null), d;
      },
      useId: function () {
        var r = Di(),
          o = pr.identifierPrefix;
        if (In) {
          var d = ba,
            g = ya;
          d = (g & ~(1 << 32 - gi(g) - 1)).toString(32) + d, o = ":" + o + "R" + d, d = no++, 0 < d && (o += "H" + d.toString(32)), o += ":";
        } else d = Vs++, o = ":" + o + "r" + d.toString(32) + ":";
        return r.memoizedState = o;
      },
      unstable_isNewReconciler: !1
    },
    Fh = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: af,
      useImperativeHandle: Yo,
      useInsertionEffect: Hs,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: tc,
      useRef: nf,
      useState: function () {
        return tc(Ul);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return ic(o, On.memoizedState, r);
      },
      useTransition: function () {
        var r = tc(Ul)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Xd,
      useSyncExternalStore: Kd,
      useId: Ws,
      unstable_isNewReconciler: !1
    },
    Qg = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: af,
      useImperativeHandle: Yo,
      useInsertionEffect: Hs,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: nc,
      useRef: nf,
      useState: function () {
        return nc(Ul);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return On === null ? o.memoizedState = r : ic(o, On.memoizedState, r);
      },
      useTransition: function () {
        var r = nc(Ul)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Xd,
      useSyncExternalStore: Kd,
      useId: Ws,
      unstable_isNewReconciler: !1
    };
  function Ys(r, o) {
    try {
      var d = "",
        g = o;
      do d += fe(g), g = g.return; while (g);
      var S = d;
    } catch (R) {
      S = `
Error generating stack: ` + R.message + `
` + R.stack;
    }
    return {
      value: r,
      source: o,
      stack: S,
      digest: null
    };
  }
  function Nh(r, o, d) {
    return {
      value: r,
      source: null,
      stack: d ?? null,
      digest: o ?? null
    };
  }
  function Gs(r, o) {
    try {
      console.error(o.value);
    } catch (d) {
      setTimeout(function () {
        throw d;
      });
    }
  }
  var Aw = typeof WeakMap == "function" ? WeakMap : Map;
  function zh(r, o, d) {
    d = wa(-1, d), d.tag = 3, d.payload = {
      element: null
    };
    var g = o.value;
    return d.callback = function () {
      Ks || (Ks = !0, Yh = g), Gs(r, o);
    }, d;
  }
  function Vh(r, o, d) {
    d = wa(-1, d), d.tag = 3;
    var g = r.type.getDerivedStateFromError;
    if (typeof g == "function") {
      var S = o.value;
      d.payload = function () {
        return g(S);
      }, d.callback = function () {
        Gs(r, o);
      };
    }
    var R = r.stateNode;
    return R !== null && typeof R.componentDidCatch == "function" && (d.callback = function () {
      Gs(r, o), typeof g != "function" && (So === null ? So = /* @__PURE__ */new Set([this]) : So.add(this));
      var A = o.stack;
      this.componentDidCatch(o.value, {
        componentStack: A !== null ? A : ""
      });
    }), d;
  }
  function Zg(r, o, d) {
    var g = r.pingCache;
    if (g === null) {
      g = r.pingCache = new Aw();
      var S = /* @__PURE__ */new Set();
      g.set(o, S);
    } else S = g.get(o), S === void 0 && (S = /* @__PURE__ */new Set(), g.set(o, S));
    S.has(d) || (S.add(d), r = Nw.bind(null, r, o, d), o.then(r, r));
  }
  function Go(r) {
    do {
      var o;
      if ((o = r.tag === 13) && (o = r.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o) return r;
      r = r.return;
    } while (r !== null);
    return null;
  }
  function Xs(r, o, d, g, S) {
    return (r.mode & 1) === 0 ? (r === o ? r.flags |= 65536 : (r.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (o = wa(-1, 1), o.tag = 2, Ti(d, o, 1))), d.lanes |= 1), r) : (r.flags |= 65536, r.lanes = S, r);
  }
  var Hl = j.ReactCurrentOwner,
    Dr = !1;
  function _n(r, o, d, g) {
    o.child = r === null ? qg(o, null, d, g) : Vl(o, r.child, d, g);
  }
  function $l(r, o, d, g, S) {
    d = d.render;
    var R = o.ref;
    return Fs(o, S), g = Ju(r, o, d, g, R, S), d = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && d && Vd(o), o.flags |= 1, _n(r, o, g, S), o.child);
  }
  function jt(r, o, d, g, S) {
    if (r === null) {
      var R = d.type;
      return typeof R == "function" && !Zh(R) && R.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (o.tag = 15, o.type = R, ac(r, o, R, g, S)) : (r = Jl(d.type, null, g, o, o.mode, S), r.ref = o.ref, r.return = o, o.child = r);
    }
    if (R = r.child, (r.lanes & S) === 0) {
      var A = R.memoizedProps;
      if (d = d.compare, d = d !== null ? d : Vu, d(A, g) && r.ref === o.ref) return Ir(r, o, S);
    }
    return o.flags |= 1, r = La(R, g), r.ref = o.ref, r.return = o, o.child = r;
  }
  function ac(r, o, d, g, S) {
    if (r !== null) {
      var R = r.memoizedProps;
      if (Vu(R, g) && r.ref === o.ref) if (Dr = !1, o.pendingProps = g = R, (r.lanes & S) !== 0) (r.flags & 131072) !== 0 && (Dr = !0);else return o.lanes = r.lanes, Ir(r, o, S);
    }
    return sf(r, o, d, g, S);
  }
  function Bh(r, o, d) {
    var g = o.pendingProps,
      S = g.children,
      R = r !== null ? r.memoizedState : null;
    if (g.mode === "hidden") {
      if ((o.mode & 1) === 0) o.memoizedState = {
        baseLanes: 0,
        cachePool: null,
        transitions: null
      }, ft(Yl, ei), ei |= d;else {
        if ((d & 1073741824) === 0) return r = R !== null ? R.baseLanes | d : d, o.lanes = o.childLanes = 1073741824, o.memoizedState = {
          baseLanes: r,
          cachePool: null,
          transitions: null
        }, o.updateQueue = null, ft(Yl, ei), ei |= r, null;
        o.memoizedState = {
          baseLanes: 0,
          cachePool: null,
          transitions: null
        }, g = R !== null ? R.baseLanes : d, ft(Yl, ei), ei |= g;
      }
    } else R !== null ? (g = R.baseLanes | d, o.memoizedState = null) : g = d, ft(Yl, ei), ei |= g;
    return _n(r, o, S, d), o.child;
  }
  function Sb(r, o) {
    var d = o.ref;
    (r === null && d !== null || r !== null && r.ref !== d) && (o.flags |= 512, o.flags |= 2097152);
  }
  function sf(r, o, d, g, S) {
    var R = tr(d) ? Yr : Hn.current;
    return R = xi(o, R), Fs(o, S), d = Ju(r, o, d, g, R, S), g = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && g && Vd(o), o.flags |= 1, _n(r, o, d, S), o.child);
  }
  function oc(r, o, d, g, S) {
    if (tr(d)) {
      var R = !0;
      Gr(o);
    } else R = !1;
    if (Fs(o, S), o.stateNode === null) ll(r, o), Lh(o, d, g), Oh(o, d, g, S), g = !0;else if (r === null) {
      var A = o.stateNode,
        q = o.memoizedProps;
      A.props = q;
      var re = A.context,
        ye = d.contextType;
      typeof ye == "object" && ye !== null ? ye = ki(ye) : (ye = tr(d) ? Yr : Hn.current, ye = xi(o, ye));
      var Oe = d.getDerivedStateFromProps,
        ze = typeof Oe == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      ze || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== g || re !== ye) && Hg(o, A, g, ye), qo = !1;
      var Me = o.memoizedState;
      A.state = Me, Wd(o, g, A, S), re = o.memoizedState, q !== g || Me !== re || or.current || qo ? (typeof Oe == "function" && (Ih(o, d, Oe, g), re = o.memoizedState), (q = qo || Mh(o, d, q, g, Me, re, ye)) ? (ze || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = g, o.memoizedState = re), A.props = g, A.state = re, A.context = ye, g = q) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), g = !1);
    } else {
      A = o.stateNode, zg(r, o), q = o.memoizedProps, ye = o.type === o.elementType ? q : si(o.type, q), A.props = ye, ze = o.pendingProps, Me = A.context, re = d.contextType, typeof re == "object" && re !== null ? re = ki(re) : (re = tr(d) ? Yr : Hn.current, re = xi(o, re));
      var et = d.getDerivedStateFromProps;
      (Oe = typeof et == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== ze || Me !== re) && Hg(o, A, g, re), qo = !1, Me = o.memoizedState, A.state = Me, Wd(o, g, A, S);
      var it = o.memoizedState;
      q !== ze || Me !== it || or.current || qo ? (typeof et == "function" && (Ih(o, d, et, g), it = o.memoizedState), (ye = qo || Mh(o, d, ye, g, Me, it, re) || !1) ? (Oe || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(g, it, re), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(g, it, re)), typeof A.componentDidUpdate == "function" && (o.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 1024), o.memoizedProps = g, o.memoizedState = it), A.props = g, A.state = it, A.context = re, g = ye) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 1024), g = !1);
    }
    return lc(r, o, d, g, R, S);
  }
  function lc(r, o, d, g, S, R) {
    Sb(r, o);
    var A = (o.flags & 128) !== 0;
    if (!g && !A) return S && Nd(o, d, !1), Ir(r, o, R);
    g = o.stateNode, Hl.current = o;
    var q = A && typeof d.getDerivedStateFromError != "function" ? null : g.render();
    return o.flags |= 1, r !== null && A ? (o.child = Vl(o, r.child, null, R), o.child = Vl(o, null, q, R)) : _n(r, o, q, R), o.memoizedState = g.state, S && Nd(o, d, !0), o.child;
  }
  function Km(r) {
    var o = r.stateNode;
    o.pendingContext ? Ag(r, o.pendingContext, o.pendingContext !== o.context) : o.context && Ag(r, o.context, !1), Wt(r, o.containerInfo);
  }
  function Qm(r, o, d, g, S) {
    return Wo(), eo(S), o.flags |= 256, _n(r, o, d, g), o.child;
  }
  var uf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
  };
  function cf(r) {
    return {
      baseLanes: r,
      cachePool: null,
      transitions: null
    };
  }
  function Zm(r, o, d) {
    var g = o.pendingProps,
      S = Mn.current,
      R = !1,
      A = (o.flags & 128) !== 0,
      q;
    if ((q = A) || (q = r !== null && r.memoizedState === null ? !1 : (S & 2) !== 0), q ? (R = !0, o.flags &= -129) : (r === null || r.memoizedState !== null) && (S |= 1), ft(Mn, S & 1), r === null) return Th(o), r = o.memoizedState, r !== null && (r = r.dehydrated, r !== null) ? ((o.mode & 1) === 0 ? o.lanes = 1 : r.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824, null) : (A = g.children, r = g.fallback, R ? (g = o.mode, R = o.child, A = {
      mode: "hidden",
      children: A
    }, (g & 1) === 0 && R !== null ? (R.childLanes = 0, R.pendingProps = A) : R = jc(A, g, 0, null), r = oo(r, g, d, null), R.return = o, r.return = o, R.sibling = r, o.child = R, o.child.memoizedState = cf(d), o.memoizedState = uf, r) : df(o, A));
    if (S = r.memoizedState, S !== null && (q = S.dehydrated, q !== null)) return al(r, o, A, g, q, S, d);
    if (R) {
      R = g.fallback, A = o.mode, S = r.child, q = S.sibling;
      var re = {
        mode: "hidden",
        children: g.children
      };
      return (A & 1) === 0 && o.child !== S ? (g = o.child, g.childLanes = 0, g.pendingProps = re, o.deletions = null) : (g = La(S, re), g.subtreeFlags = S.subtreeFlags & 14680064), q !== null ? R = La(q, R) : (R = oo(R, A, d, null), R.flags |= 2), R.return = o, g.return = o, g.sibling = R, o.child = g, g = R, R = o.child, A = r.child.memoizedState, A = A === null ? cf(d) : {
        baseLanes: A.baseLanes | d,
        cachePool: null,
        transitions: A.transitions
      }, R.memoizedState = A, R.childLanes = r.childLanes & ~d, o.memoizedState = uf, g;
    }
    return R = r.child, r = R.sibling, g = La(R, {
      mode: "visible",
      children: g.children
    }), (o.mode & 1) === 0 && (g.lanes = d), g.return = o, g.sibling = null, r !== null && (d = o.deletions, d === null ? (o.deletions = [r], o.flags |= 16) : d.push(r)), o.child = g, o.memoizedState = null, g;
  }
  function df(r, o) {
    return o = jc({
      mode: "visible",
      children: o
    }, r.mode, 0, null), o.return = r, r.child = o;
  }
  function sc(r, o, d, g) {
    return g !== null && eo(g), Vl(o, r.child, null, d), r = df(o, o.pendingProps.children), r.flags |= 2, o.memoizedState = null, r;
  }
  function al(r, o, d, g, S, R, A) {
    if (d) return o.flags & 256 ? (o.flags &= -257, g = Nh(Error(i(422))), sc(r, o, A, g)) : o.memoizedState !== null ? (o.child = r.child, o.flags |= 128, null) : (R = g.fallback, S = o.mode, g = jc({
      mode: "visible",
      children: g.children
    }, S, 0, null), R = oo(R, S, A, null), R.flags |= 2, g.return = o, R.return = o, g.sibling = R, o.child = g, (o.mode & 1) !== 0 && Vl(o, r.child, null, A), o.child.memoizedState = cf(A), o.memoizedState = uf, R);
    if ((o.mode & 1) === 0) return sc(r, o, A, null);
    if (S.data === "$!") {
      if (g = S.nextSibling && S.nextSibling.dataset, g) var q = g.dgst;
      return g = q, R = Error(i(419)), g = Nh(R, g, void 0), sc(r, o, A, g);
    }
    if (q = (A & r.childLanes) !== 0, Dr || q) {
      if (g = pr, g !== null) {
        switch (A & -A) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = (S & (g.suspendedLanes | A)) !== 0 ? 0 : S, S !== 0 && S !== R.retryLane && (R.retryLane = S, En(r, S), Li(g, r, S, -1));
      }
      return Kh(), g = Nh(Error(i(421))), sc(r, o, A, g);
    }
    return S.data === "$?" ? (o.flags |= 128, o.child = r.child, o = Rb.bind(null, r), S._reactRetry = o, null) : (r = R.treeContext, Kr = ha(S.nextSibling), Xr = o, In = !0, Ei = null, r !== null && (nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = li, ya = r.id, ba = r.overflow, li = o), o = df(o, g.children), o.flags |= 4096, o);
  }
  function Ii(r, o, d) {
    r.lanes |= o;
    var g = r.alternate;
    g !== null && (g.lanes |= o), ui(r.return, o, d);
  }
  function Zi(r, o, d, g, S) {
    var R = r.memoizedState;
    R === null ? r.memoizedState = {
      isBackwards: o,
      rendering: null,
      renderingStartTime: 0,
      last: g,
      tail: d,
      tailMode: S
    } : (R.isBackwards = o, R.rendering = null, R.renderingStartTime = 0, R.last = g, R.tail = d, R.tailMode = S);
  }
  function ol(r, o, d) {
    var g = o.pendingProps,
      S = g.revealOrder,
      R = g.tail;
    if (_n(r, o, g.children, d), g = Mn.current, (g & 2) !== 0) g = g & 1 | 2, o.flags |= 128;else {
      if (r !== null && (r.flags & 128) !== 0) e: for (r = o.child; r !== null;) {
        if (r.tag === 13) r.memoizedState !== null && Ii(r, d, o);else if (r.tag === 19) Ii(r, d, o);else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === o) break e;
        for (; r.sibling === null;) {
          if (r.return === null || r.return === o) break e;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      g &= 1;
    }
    if (ft(Mn, g), (o.mode & 1) === 0) o.memoizedState = null;else switch (S) {
      case "forwards":
        for (d = o.child, S = null; d !== null;) r = d.alternate, r !== null && Gd(r) === null && (S = d), d = d.sibling;
        d = S, d === null ? (S = o.child, o.child = null) : (S = d.sibling, d.sibling = null), Zi(o, !1, S, d, R);
        break;
      case "backwards":
        for (d = null, S = o.child, o.child = null; S !== null;) {
          if (r = S.alternate, r !== null && Gd(r) === null) {
            o.child = S;
            break;
          }
          r = S.sibling, S.sibling = d, d = S, S = r;
        }
        Zi(o, !0, d, null, R);
        break;
      case "together":
        Zi(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function ll(r, o) {
    (o.mode & 1) === 0 && r !== null && (r.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function Ir(r, o, d) {
    if (r !== null && (o.dependencies = r.dependencies), xo |= o.lanes, (d & o.childLanes) === 0) return null;
    if (r !== null && o.child !== r.child) throw Error(i(153));
    if (o.child !== null) {
      for (r = o.child, d = La(r, r.pendingProps), o.child = d, d.return = o; r.sibling !== null;) r = r.sibling, d = d.sibling = La(r, r.pendingProps), d.return = o;
      d.sibling = null;
    }
    return o.child;
  }
  function zr(r, o, d) {
    switch (o.tag) {
      case 3:
        Km(o), Wo();
        break;
      case 5:
        Xn(o);
        break;
      case 1:
        tr(o.type) && Gr(o);
        break;
      case 4:
        Wt(o, o.stateNode.containerInfo);
        break;
      case 10:
        var g = o.type._context,
          S = o.memoizedProps.value;
        ft(Hd, g._currentValue), g._currentValue = S;
        break;
      case 13:
        if (g = o.memoizedState, g !== null) return g.dehydrated !== null ? (ft(Mn, Mn.current & 1), o.flags |= 128, null) : (d & o.child.childLanes) !== 0 ? Zm(r, o, d) : (ft(Mn, Mn.current & 1), r = Ir(r, o, d), r !== null ? r.sibling : null);
        ft(Mn, Mn.current & 1);
        break;
      case 19:
        if (g = (d & o.childLanes) !== 0, (r.flags & 128) !== 0) {
          if (g) return ol(r, o, d);
          o.flags |= 128;
        }
        if (S = o.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), ft(Mn, Mn.current), g) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Bh(r, o, d);
    }
    return Ir(r, o, d);
  }
  var sa, Uh, Jg, Hh;
  sa = function (r, o) {
    for (var d = o.child; d !== null;) {
      if (d.tag === 5 || d.tag === 6) r.appendChild(d.stateNode);else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === o) break;
      for (; d.sibling === null;) {
        if (d.return === null || d.return === o) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, Uh = function () {}, Jg = function (r, o, d, g) {
    var S = r.memoizedProps;
    if (S !== g) {
      r = o.stateNode, dt(_a.current);
      var R = null;
      switch (d) {
        case "input":
          S = Ae(r, S), g = Ae(r, g), R = [];
          break;
        case "select":
          S = H({}, S, {
            value: void 0
          }), g = H({}, g, {
            value: void 0
          }), R = [];
          break;
        case "textarea":
          S = Kt(r, S), g = Kt(r, g), R = [];
          break;
        default:
          typeof S.onClick != "function" && typeof g.onClick == "function" && (r.onclick = zo);
      }
      kt(d, g);
      var A;
      d = null;
      for (ye in S) if (!g.hasOwnProperty(ye) && S.hasOwnProperty(ye) && S[ye] != null) if (ye === "style") {
        var q = S[ye];
        for (A in q) q.hasOwnProperty(A) && (d || (d = {}), d[A] = "");
      } else ye !== "dangerouslySetInnerHTML" && ye !== "children" && ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && ye !== "autoFocus" && (c.hasOwnProperty(ye) ? R || (R = []) : (R = R || []).push(ye, null));
      for (ye in g) {
        var re = g[ye];
        if (q = S != null ? S[ye] : void 0, g.hasOwnProperty(ye) && re !== q && (re != null || q != null)) if (ye === "style") {
          if (q) {
            for (A in q) !q.hasOwnProperty(A) || re && re.hasOwnProperty(A) || (d || (d = {}), d[A] = "");
            for (A in re) re.hasOwnProperty(A) && q[A] !== re[A] && (d || (d = {}), d[A] = re[A]);
          } else d || (R || (R = []), R.push(ye, d)), d = re;
        } else ye === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, q = q ? q.__html : void 0, re != null && q !== re && (R = R || []).push(ye, re)) : ye === "children" ? typeof re != "string" && typeof re != "number" || (R = R || []).push(ye, "" + re) : ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && (c.hasOwnProperty(ye) ? (re != null && ye === "onScroll" && mn("scroll", r), R || q === re || (R = [])) : (R = R || []).push(ye, re));
      }
      d && (R = R || []).push("style", d);
      var ye = R;
      (o.updateQueue = ye) && (o.flags |= 4);
    }
  }, Hh = function (r, o, d, g) {
    d !== g && (o.flags |= 4);
  };
  function us(r, o) {
    if (!In) switch (r.tailMode) {
      case "hidden":
        o = r.tail;
        for (var d = null; o !== null;) o.alternate !== null && (d = o), o = o.sibling;
        d === null ? r.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = r.tail;
        for (var g = null; d !== null;) d.alternate !== null && (g = d), d = d.sibling;
        g === null ? o || r.tail === null ? r.tail = null : r.tail.sibling = null : g.sibling = null;
    }
  }
  function fr(r) {
    var o = r.alternate !== null && r.alternate.child === r.child,
      d = 0,
      g = 0;
    if (o) for (var S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags & 14680064, g |= S.flags & 14680064, S.return = r, S = S.sibling;else for (S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags, g |= S.flags, S.return = r, S = S.sibling;
    return r.subtreeFlags |= g, r.childLanes = d, o;
  }
  function $h(r, o, d) {
    var g = o.pendingProps;
    switch (Bd(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return fr(o), null;
      case 1:
        return tr(o.type) && As(), fr(o), null;
      case 3:
        return g = o.stateNode, nn(), Sn(or), Sn(Hn), Ah(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), (r === null || r.child === null) && (Ud(o) ? o.flags |= 4 : r === null || r.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, Ei !== null && (Pc(Ei), Ei = null))), Uh(r, o), fr(o), null;
      case 5:
        Ri(o);
        var S = dt(Bl.current);
        if (d = o.type, r !== null && o.stateNode != null) Jg(r, o, d, g, S), r.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);else {
          if (!g) {
            if (o.stateNode === null) throw Error(i(166));
            return fr(o), null;
          }
          if (r = dt(_a.current), Ud(o)) {
            g = o.stateNode, d = o.type;
            var R = o.memoizedProps;
            switch (g[ma] = o, g[qu] = R, r = (o.mode & 1) !== 0, d) {
              case "dialog":
                mn("cancel", g), mn("close", g);
                break;
              case "iframe":
              case "object":
              case "embed":
                mn("load", g);
                break;
              case "video":
              case "audio":
                for (S = 0; S < Hu.length; S++) mn(Hu[S], g);
                break;
              case "source":
                mn("error", g);
                break;
              case "img":
              case "image":
              case "link":
                mn("error", g), mn("load", g);
                break;
              case "details":
                mn("toggle", g);
                break;
              case "input":
                Mt(g, R), mn("invalid", g);
                break;
              case "select":
                g._wrapperState = {
                  wasMultiple: !!R.multiple
                }, mn("invalid", g);
                break;
              case "textarea":
                hn(g, R), mn("invalid", g);
            }
            kt(d, R), S = null;
            for (var A in R) if (R.hasOwnProperty(A)) {
              var q = R[A];
              A === "children" ? typeof q == "string" ? g.textContent !== q && (R.suppressHydrationWarning !== !0 && Pd(g.textContent, q, r), S = ["children", q]) : typeof q == "number" && g.textContent !== "" + q && (R.suppressHydrationWarning !== !0 && Pd(g.textContent, q, r), S = ["children", "" + q]) : c.hasOwnProperty(A) && q != null && A === "onScroll" && mn("scroll", g);
            }
            switch (d) {
              case "input":
                Xe(g), gt(g, R, !0);
                break;
              case "textarea":
                Xe(g), Et(g);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof R.onClick == "function" && (g.onclick = zo);
            }
            g = S, o.updateQueue = g, g !== null && (o.flags |= 4);
          } else {
            A = S.nodeType === 9 ? S : S.ownerDocument, r === "http://www.w3.org/1999/xhtml" && (r = Vt(d)), r === "http://www.w3.org/1999/xhtml" ? d === "script" ? (r = A.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(r.firstChild)) : typeof g.is == "string" ? r = A.createElement(d, {
              is: g.is
            }) : (r = A.createElement(d), d === "select" && (A = r, g.multiple ? A.multiple = !0 : g.size && (A.size = g.size))) : r = A.createElementNS(r, d), r[ma] = o, r[qu] = g, sa(r, o, !1, !1), o.stateNode = r;
            e: {
              switch (A = Bt(d, g), d) {
                case "dialog":
                  mn("cancel", r), mn("close", r), S = g;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  mn("load", r), S = g;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < Hu.length; S++) mn(Hu[S], r);
                  S = g;
                  break;
                case "source":
                  mn("error", r), S = g;
                  break;
                case "img":
                case "image":
                case "link":
                  mn("error", r), mn("load", r), S = g;
                  break;
                case "details":
                  mn("toggle", r), S = g;
                  break;
                case "input":
                  Mt(r, g), S = Ae(r, g), mn("invalid", r);
                  break;
                case "option":
                  S = g;
                  break;
                case "select":
                  r._wrapperState = {
                    wasMultiple: !!g.multiple
                  }, S = H({}, g, {
                    value: void 0
                  }), mn("invalid", r);
                  break;
                case "textarea":
                  hn(r, g), S = Kt(r, g), mn("invalid", r);
                  break;
                default:
                  S = g;
              }
              kt(d, S), q = S;
              for (R in q) if (q.hasOwnProperty(R)) {
                var re = q[R];
                R === "style" ? je(r, re) : R === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, re != null && ot(r, re)) : R === "children" ? typeof re == "string" ? (d !== "textarea" || re !== "") && We(r, re) : typeof re == "number" && We(r, "" + re) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (c.hasOwnProperty(R) ? re != null && R === "onScroll" && mn("scroll", r) : re != null && F(r, R, re, A));
              }
              switch (d) {
                case "input":
                  Xe(r), gt(r, g, !1);
                  break;
                case "textarea":
                  Xe(r), Et(r);
                  break;
                case "option":
                  g.value != null && r.setAttribute("value", "" + be(g.value));
                  break;
                case "select":
                  r.multiple = !!g.multiple, R = g.value, R != null ? Dt(r, !!g.multiple, R, !1) : g.defaultValue != null && Dt(r, !!g.multiple, g.defaultValue, !0);
                  break;
                default:
                  typeof S.onClick == "function" && (r.onclick = zo);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  g = !!g.autoFocus;
                  break e;
                case "img":
                  g = !0;
                  break e;
                default:
                  g = !1;
              }
            }
            g && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return fr(o), null;
      case 6:
        if (r && o.stateNode != null) Hh(r, o, r.memoizedProps, g);else {
          if (typeof g != "string" && o.stateNode === null) throw Error(i(166));
          if (d = dt(Bl.current), dt(_a.current), Ud(o)) {
            if (g = o.stateNode, d = o.memoizedProps, g[ma] = o, (R = g.nodeValue !== d) && (r = Xr, r !== null)) switch (r.tag) {
              case 3:
                Pd(g.nodeValue, d, (r.mode & 1) !== 0);
                break;
              case 5:
                r.memoizedProps.suppressHydrationWarning !== !0 && Pd(g.nodeValue, d, (r.mode & 1) !== 0);
            }
            R && (o.flags |= 4);
          } else g = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(g), g[ma] = o, o.stateNode = g;
        }
        return fr(o), null;
      case 13:
        if (Sn(Mn), g = o.memoizedState, r === null || r.memoizedState !== null && r.memoizedState.dehydrated !== null) {
          if (In && Kr !== null && (o.mode & 1) !== 0 && (o.flags & 128) === 0) Xu(), Wo(), o.flags |= 98560, R = !1;else if (R = Ud(o), g !== null && g.dehydrated !== null) {
            if (r === null) {
              if (!R) throw Error(i(318));
              if (R = o.memoizedState, R = R !== null ? R.dehydrated : null, !R) throw Error(i(317));
              R[ma] = o;
            } else Wo(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
            fr(o), R = !1;
          } else Ei !== null && (Pc(Ei), Ei = null), R = !0;
          if (!R) return o.flags & 65536 ? o : null;
        }
        return (o.flags & 128) !== 0 ? (o.lanes = d, o) : (g = g !== null, g !== (r !== null && r.memoizedState !== null) && g && (o.child.flags |= 8192, (o.mode & 1) !== 0 && (r === null || (Mn.current & 1) !== 0 ? Zn === 0 && (Zn = 3) : Kh())), o.updateQueue !== null && (o.flags |= 4), fr(o), null);
      case 4:
        return nn(), Uh(r, o), r === null && Is(o.stateNode.containerInfo), fr(o), null;
      case 10:
        return Ci(o.type._context), fr(o), null;
      case 17:
        return tr(o.type) && As(), fr(o), null;
      case 19:
        if (Sn(Mn), R = o.memoizedState, R === null) return fr(o), null;
        if (g = (o.flags & 128) !== 0, A = R.rendering, A === null) {
          if (g) us(R, !1);else {
            if (Zn !== 0 || r !== null && (r.flags & 128) !== 0) for (r = o.child; r !== null;) {
              if (A = Gd(r), A !== null) {
                for (o.flags |= 128, us(R, !1), g = A.updateQueue, g !== null && (o.updateQueue = g, o.flags |= 4), o.subtreeFlags = 0, g = d, d = o.child; d !== null;) R = d, r = g, R.flags &= 14680066, A = R.alternate, A === null ? (R.childLanes = 0, R.lanes = r, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = A.childLanes, R.lanes = A.lanes, R.child = A.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = A.memoizedProps, R.memoizedState = A.memoizedState, R.updateQueue = A.updateQueue, R.type = A.type, r = A.dependencies, R.dependencies = r === null ? null : {
                  lanes: r.lanes,
                  firstContext: r.firstContext
                }), d = d.sibling;
                return ft(Mn, Mn.current & 1 | 2), o.child;
              }
              r = r.sibling;
            }
            R.tail !== null && yn() > ao && (o.flags |= 128, g = !0, us(R, !1), o.lanes = 4194304);
          }
        } else {
          if (!g) if (r = Gd(A), r !== null) {
            if (o.flags |= 128, g = !0, d = r.updateQueue, d !== null && (o.updateQueue = d, o.flags |= 4), us(R, !0), R.tail === null && R.tailMode === "hidden" && !A.alternate && !In) return fr(o), null;
          } else 2 * yn() - R.renderingStartTime > ao && d !== 1073741824 && (o.flags |= 128, g = !0, us(R, !1), o.lanes = 4194304);
          R.isBackwards ? (A.sibling = o.child, o.child = A) : (d = R.last, d !== null ? d.sibling = A : o.child = A, R.last = A);
        }
        return R.tail !== null ? (o = R.tail, R.rendering = o, R.tail = o.sibling, R.renderingStartTime = yn(), o.sibling = null, d = Mn.current, ft(Mn, g ? d & 1 | 2 : d & 1), o) : (fr(o), null);
      case 22:
      case 23:
        return vf(), g = o.memoizedState !== null, r !== null && r.memoizedState !== null !== g && (o.flags |= 8192), g && (o.mode & 1) !== 0 ? (ei & 1073741824) !== 0 && (fr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : fr(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function Eb(r, o) {
    switch (Bd(o), o.tag) {
      case 1:
        return tr(o.type) && As(), r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 3:
        return nn(), Sn(or), Sn(Hn), Ah(), r = o.flags, (r & 65536) !== 0 && (r & 128) === 0 ? (o.flags = r & -65537 | 128, o) : null;
      case 5:
        return Ri(o), null;
      case 13:
        if (Sn(Mn), r = o.memoizedState, r !== null && r.dehydrated !== null) {
          if (o.alternate === null) throw Error(i(340));
          Wo();
        }
        return r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 19:
        return Sn(Mn), null;
      case 4:
        return nn(), null;
      case 10:
        return Ci(o.type._context), null;
      case 22:
      case 23:
        return vf(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var ff = !1,
    xr = !1,
    ey = typeof WeakSet == "function" ? WeakSet : Set,
    tt = null;
  function cs(r, o) {
    var d = r.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (g) {
      $n(r, o, g);
    } else d.current = null;
  }
  function Wh(r, o, d) {
    try {
      d();
    } catch (g) {
      $n(r, o, g);
    }
  }
  var Jm = !1;
  function Cb(r, o) {
    if (Wu = Dl, r = Bu(), kd(r)) {
      if ("selectionStart" in r) var d = {
        start: r.selectionStart,
        end: r.selectionEnd
      };else e: {
        d = (d = r.ownerDocument) && d.defaultView || window;
        var g = d.getSelection && d.getSelection();
        if (g && g.rangeCount !== 0) {
          d = g.anchorNode;
          var S = g.anchorOffset,
            R = g.focusNode;
          g = g.focusOffset;
          try {
            d.nodeType, R.nodeType;
          } catch {
            d = null;
            break e;
          }
          var A = 0,
            q = -1,
            re = -1,
            ye = 0,
            Oe = 0,
            ze = r,
            Me = null;
          t: for (;;) {
            for (var et; ze !== d || S !== 0 && ze.nodeType !== 3 || (q = A + S), ze !== R || g !== 0 && ze.nodeType !== 3 || (re = A + g), ze.nodeType === 3 && (A += ze.nodeValue.length), (et = ze.firstChild) !== null;) Me = ze, ze = et;
            for (;;) {
              if (ze === r) break t;
              if (Me === d && ++ye === S && (q = A), Me === R && ++Oe === g && (re = A), (et = ze.nextSibling) !== null) break;
              ze = Me, Me = ze.parentNode;
            }
            ze = et;
          }
          d = q === -1 || re === -1 ? null : {
            start: q,
            end: re
          };
        } else d = null;
      }
      d = d || {
        start: 0,
        end: 0
      };
    } else d = null;
    for (jl = {
      focusedElem: r,
      selectionRange: d
    }, Dl = !1, tt = o; tt !== null;) if (o = tt, r = o.child, (o.subtreeFlags & 1028) !== 0 && r !== null) r.return = o, tt = r;else for (; tt !== null;) {
      o = tt;
      try {
        var it = o.alternate;
        if ((o.flags & 1024) !== 0) switch (o.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (it !== null) {
              var lt = it.memoizedProps,
                Kn = it.memoizedState,
                pe = o.stateNode,
                oe = pe.getSnapshotBeforeUpdate(o.elementType === o.type ? lt : si(o.type, lt), Kn);
              pe.__reactInternalSnapshotBeforeUpdate = oe;
            }
            break;
          case 3:
            var he = o.stateNode.containerInfo;
            he.nodeType === 1 ? he.textContent = "" : he.nodeType === 9 && he.documentElement && he.removeChild(he.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (He) {
        $n(o, o.return, He);
      }
      if (r = o.sibling, r !== null) {
        r.return = o.return, tt = r;
        break;
      }
      tt = o.return;
    }
    return it = Jm, Jm = !1, it;
  }
  function du(r, o, d) {
    var g = o.updateQueue;
    if (g = g !== null ? g.lastEffect : null, g !== null) {
      var S = g = g.next;
      do {
        if ((S.tag & r) === r) {
          var R = S.destroy;
          S.destroy = void 0, R !== void 0 && Wh(o, d, R);
        }
        S = S.next;
      } while (S !== g);
    }
  }
  function uc(r, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var d = o = o.next;
      do {
        if ((d.tag & r) === r) {
          var g = d.create;
          d.destroy = g();
        }
        d = d.next;
      } while (d !== o);
    }
  }
  function fu(r) {
    var o = r.ref;
    if (o !== null) {
      var d = r.stateNode;
      switch (r.tag) {
        case 5:
          r = d;
          break;
        default:
          r = d;
      }
      typeof o == "function" ? o(r) : o.current = r;
    }
  }
  function Wl(r) {
    var o = r.alternate;
    o !== null && (r.alternate = null, Wl(o)), r.child = null, r.deletions = null, r.sibling = null, r.tag === 5 && (o = r.stateNode, o !== null && (delete o[ma], delete o[qu], delete o[Yu], delete o[Ps], delete o[Mw])), r.stateNode = null, r.return = null, r.dependencies = null, r.memoizedProps = null, r.memoizedState = null, r.pendingProps = null, r.stateNode = null, r.updateQueue = null;
  }
  function ro(r) {
    return r.tag === 5 || r.tag === 3 || r.tag === 4;
  }
  function io(r) {
    e: for (;;) {
      for (; r.sibling === null;) {
        if (r.return === null || ro(r.return)) return null;
        r = r.return;
      }
      for (r.sibling.return = r.return, r = r.sibling; r.tag !== 5 && r.tag !== 6 && r.tag !== 18;) {
        if (r.flags & 2 || r.child === null || r.tag === 4) continue e;
        r.child.return = r, r = r.child;
      }
      if (!(r.flags & 2)) return r.stateNode;
    }
  }
  function wo(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.nodeType === 8 ? d.parentNode.insertBefore(r, o) : d.insertBefore(r, o) : (d.nodeType === 8 ? (o = d.parentNode, o.insertBefore(r, d)) : (o = d, o.appendChild(r)), d = d._reactRootContainer, d != null || o.onclick !== null || (o.onclick = zo));else if (g !== 4 && (r = r.child, r !== null)) for (wo(r, o, d), r = r.sibling; r !== null;) wo(r, o, d), r = r.sibling;
  }
  function ql(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.insertBefore(r, o) : d.appendChild(r);else if (g !== 4 && (r = r.child, r !== null)) for (ql(r, o, d), r = r.sibling; r !== null;) ql(r, o, d), r = r.sibling;
  }
  var Nn = null,
    Vr = !1;
  function Xo(r, o, d) {
    for (d = d.child; d !== null;) ty(r, o, d), d = d.sibling;
  }
  function ty(r, o, d) {
    if (qi && typeof qi.onCommitFiberUnmount == "function") try {
      qi.onCommitFiberUnmount(Iu, d);
    } catch {}
    switch (d.tag) {
      case 5:
        xr || cs(d, o);
      case 6:
        var g = Nn,
          S = Vr;
        Nn = null, Xo(r, o, d), Nn = g, Vr = S, Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? r.parentNode.removeChild(d) : r.removeChild(d)) : Nn.removeChild(d.stateNode));
        break;
      case 18:
        Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? Os(r.parentNode, d) : r.nodeType === 1 && Os(r, d), jo(r)) : Os(Nn, d.stateNode));
        break;
      case 4:
        g = Nn, S = Vr, Nn = d.stateNode.containerInfo, Vr = !0, Xo(r, o, d), Nn = g, Vr = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!xr && (g = d.updateQueue, g !== null && (g = g.lastEffect, g !== null))) {
          S = g = g.next;
          do {
            var R = S,
              A = R.destroy;
            R = R.tag, A !== void 0 && ((R & 2) !== 0 || (R & 4) !== 0) && Wh(d, o, A), S = S.next;
          } while (S !== g);
        }
        Xo(r, o, d);
        break;
      case 1:
        if (!xr && (cs(d, o), g = d.stateNode, typeof g.componentWillUnmount == "function")) try {
          g.props = d.memoizedProps, g.state = d.memoizedState, g.componentWillUnmount();
        } catch (q) {
          $n(d, o, q);
        }
        Xo(r, o, d);
        break;
      case 21:
        Xo(r, o, d);
        break;
      case 22:
        d.mode & 1 ? (xr = (g = xr) || d.memoizedState !== null, Xo(r, o, d), xr = g) : Xo(r, o, d);
        break;
      default:
        Xo(r, o, d);
    }
  }
  function ev(r) {
    var o = r.updateQueue;
    if (o !== null) {
      r.updateQueue = null;
      var d = r.stateNode;
      d === null && (d = r.stateNode = new ey()), o.forEach(function (g) {
        var S = zw.bind(null, r, g);
        d.has(g) || (d.add(g), g.then(S, S));
      });
    }
  }
  function ri(r, o) {
    var d = o.deletions;
    if (d !== null) for (var g = 0; g < d.length; g++) {
      var S = d[g];
      try {
        var R = r,
          A = o,
          q = A;
        e: for (; q !== null;) {
          switch (q.tag) {
            case 5:
              Nn = q.stateNode, Vr = !1;
              break e;
            case 3:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
            case 4:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
          }
          q = q.return;
        }
        if (Nn === null) throw Error(i(160));
        ty(R, A, S), Nn = null, Vr = !1;
        var re = S.alternate;
        re !== null && (re.return = null), S.return = null;
      } catch (ye) {
        $n(S, o, ye);
      }
    }
    if (o.subtreeFlags & 12854) for (o = o.child; o !== null;) pf(o, r), o = o.sibling;
  }
  function pf(r, o) {
    var d = r.alternate,
      g = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ri(o, r), ua(r), g & 4) {
          try {
            du(3, r, r.return), uc(3, r);
          } catch (lt) {
            $n(r, r.return, lt);
          }
          try {
            du(5, r, r.return);
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 1:
        ri(o, r), ua(r), g & 512 && d !== null && cs(d, d.return);
        break;
      case 5:
        if (ri(o, r), ua(r), g & 512 && d !== null && cs(d, d.return), r.flags & 32) {
          var S = r.stateNode;
          try {
            We(S, "");
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        if (g & 4 && (S = r.stateNode, S != null)) {
          var R = r.memoizedProps,
            A = d !== null ? d.memoizedProps : R,
            q = r.type,
            re = r.updateQueue;
          if (r.updateQueue = null, re !== null) try {
            q === "input" && R.type === "radio" && R.name != null && Ft(S, R), Bt(q, A);
            var ye = Bt(q, R);
            for (A = 0; A < re.length; A += 2) {
              var Oe = re[A],
                ze = re[A + 1];
              Oe === "style" ? je(S, ze) : Oe === "dangerouslySetInnerHTML" ? ot(S, ze) : Oe === "children" ? We(S, ze) : F(S, Oe, ze, ye);
            }
            switch (q) {
              case "input":
                un(S, R);
                break;
              case "textarea":
                Lt(S, R);
                break;
              case "select":
                var Me = S._wrapperState.wasMultiple;
                S._wrapperState.wasMultiple = !!R.multiple;
                var et = R.value;
                et != null ? Dt(S, !!R.multiple, et, !1) : Me !== !!R.multiple && (R.defaultValue != null ? Dt(S, !!R.multiple, R.defaultValue, !0) : Dt(S, !!R.multiple, R.multiple ? [] : "", !1));
            }
            S[qu] = R;
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 6:
        if (ri(o, r), ua(r), g & 4) {
          if (r.stateNode === null) throw Error(i(162));
          S = r.stateNode, R = r.memoizedProps;
          try {
            S.nodeValue = R;
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 3:
        if (ri(o, r), ua(r), g & 4 && d !== null && d.memoizedState.isDehydrated) try {
          jo(o.containerInfo);
        } catch (lt) {
          $n(r, r.return, lt);
        }
        break;
      case 4:
        ri(o, r), ua(r);
        break;
      case 13:
        ri(o, r), ua(r), S = r.child, S.flags & 8192 && (R = S.memoizedState !== null, S.stateNode.isHidden = R, !R || S.alternate !== null && S.alternate.memoizedState !== null || (fc = yn())), g & 4 && ev(r);
        break;
      case 22:
        if (Oe = d !== null && d.memoizedState !== null, r.mode & 1 ? (xr = (ye = xr) || Oe, ri(o, r), xr = ye) : ri(o, r), ua(r), g & 8192) {
          if (ye = r.memoizedState !== null, (r.stateNode.isHidden = ye) && !Oe && (r.mode & 1) !== 0) for (tt = r, Oe = r.child; Oe !== null;) {
            for (ze = tt = Oe; tt !== null;) {
              switch (Me = tt, et = Me.child, Me.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  du(4, Me, Me.return);
                  break;
                case 1:
                  cs(Me, Me.return);
                  var it = Me.stateNode;
                  if (typeof it.componentWillUnmount == "function") {
                    g = Me, d = Me.return;
                    try {
                      o = g, it.props = o.memoizedProps, it.state = o.memoizedState, it.componentWillUnmount();
                    } catch (lt) {
                      $n(g, d, lt);
                    }
                  }
                  break;
                case 5:
                  cs(Me, Me.return);
                  break;
                case 22:
                  if (Me.memoizedState !== null) {
                    tv(ze);
                    continue;
                  }
              }
              et !== null ? (et.return = Me, tt = et) : tv(ze);
            }
            Oe = Oe.sibling;
          }
          e: for (Oe = null, ze = r;;) {
            if (ze.tag === 5) {
              if (Oe === null) {
                Oe = ze;
                try {
                  S = ze.stateNode, ye ? (R = S.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (q = ze.stateNode, re = ze.memoizedProps.style, A = re != null && re.hasOwnProperty("display") ? re.display : null, q.style.display = yt("display", A));
                } catch (lt) {
                  $n(r, r.return, lt);
                }
              }
            } else if (ze.tag === 6) {
              if (Oe === null) try {
                ze.stateNode.nodeValue = ye ? "" : ze.memoizedProps;
              } catch (lt) {
                $n(r, r.return, lt);
              }
            } else if ((ze.tag !== 22 && ze.tag !== 23 || ze.memoizedState === null || ze === r) && ze.child !== null) {
              ze.child.return = ze, ze = ze.child;
              continue;
            }
            if (ze === r) break e;
            for (; ze.sibling === null;) {
              if (ze.return === null || ze.return === r) break e;
              Oe === ze && (Oe = null), ze = ze.return;
            }
            Oe === ze && (Oe = null), ze.sibling.return = ze.return, ze = ze.sibling;
          }
        }
        break;
      case 19:
        ri(o, r), ua(r), g & 4 && ev(r);
        break;
      case 21:
        break;
      default:
        ri(o, r), ua(r);
    }
  }
  function ua(r) {
    var o = r.flags;
    if (o & 2) {
      try {
        e: {
          for (var d = r.return; d !== null;) {
            if (ro(d)) {
              var g = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (g.tag) {
          case 5:
            var S = g.stateNode;
            g.flags & 32 && (We(S, ""), g.flags &= -33);
            var R = io(r);
            ql(r, R, S);
            break;
          case 3:
          case 4:
            var A = g.stateNode.containerInfo,
              q = io(r);
            wo(r, q, A);
            break;
          default:
            throw Error(i(161));
        }
      } catch (re) {
        $n(r, r.return, re);
      }
      r.flags &= -3;
    }
    o & 4096 && (r.flags &= -4097);
  }
  function kb(r, o, d) {
    tt = r, cp(r);
  }
  function cp(r, o, d) {
    for (var g = (r.mode & 1) !== 0; tt !== null;) {
      var S = tt,
        R = S.child;
      if (S.tag === 22 && g) {
        var A = S.memoizedState !== null || ff;
        if (!A) {
          var q = S.alternate,
            re = q !== null && q.memoizedState !== null || xr;
          q = ff;
          var ye = xr;
          if (ff = A, (xr = re) && !ye) for (tt = S; tt !== null;) A = tt, re = A.child, A.tag === 22 && A.memoizedState !== null ? mf(S) : re !== null ? (re.return = A, tt = re) : mf(S);
          for (; R !== null;) tt = R, cp(R), R = R.sibling;
          tt = S, ff = q, xr = ye;
        }
        hf(r);
      } else (S.subtreeFlags & 8772) !== 0 && R !== null ? (R.return = S, tt = R) : hf(r);
    }
  }
  function hf(r) {
    for (; tt !== null;) {
      var o = tt;
      if ((o.flags & 8772) !== 0) {
        var d = o.alternate;
        try {
          if ((o.flags & 8772) !== 0) switch (o.tag) {
            case 0:
            case 11:
            case 15:
              xr || uc(5, o);
              break;
            case 1:
              var g = o.stateNode;
              if (o.flags & 4 && !xr) if (d === null) g.componentDidMount();else {
                var S = o.elementType === o.type ? d.memoizedProps : si(o.type, d.memoizedProps);
                g.componentDidUpdate(S, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
              }
              var R = o.updateQueue;
              R !== null && Bg(o, R, g);
              break;
            case 3:
              var A = o.updateQueue;
              if (A !== null) {
                if (d = null, o.child !== null) switch (o.child.tag) {
                  case 5:
                    d = o.child.stateNode;
                    break;
                  case 1:
                    d = o.child.stateNode;
                }
                Bg(o, A, d);
              }
              break;
            case 5:
              var q = o.stateNode;
              if (d === null && o.flags & 4) {
                d = q;
                var re = o.memoizedProps;
                switch (o.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    re.autoFocus && d.focus();
                    break;
                  case "img":
                    re.src && (d.src = re.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (o.memoizedState === null) {
                var ye = o.alternate;
                if (ye !== null) {
                  var Oe = ye.memoizedState;
                  if (Oe !== null) {
                    var ze = Oe.dehydrated;
                    ze !== null && jo(ze);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          xr || o.flags & 512 && fu(o);
        } catch (Me) {
          $n(o, o.return, Me);
        }
      }
      if (o === r) {
        tt = null;
        break;
      }
      if (d = o.sibling, d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function tv(r) {
    for (; tt !== null;) {
      var o = tt;
      if (o === r) {
        tt = null;
        break;
      }
      var d = o.sibling;
      if (d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function mf(r) {
    for (; tt !== null;) {
      var o = tt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var d = o.return;
            try {
              uc(4, o);
            } catch (re) {
              $n(o, d, re);
            }
            break;
          case 1:
            var g = o.stateNode;
            if (typeof g.componentDidMount == "function") {
              var S = o.return;
              try {
                g.componentDidMount();
              } catch (re) {
                $n(o, S, re);
              }
            }
            var R = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, R, re);
            }
            break;
          case 5:
            var A = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, A, re);
            }
        }
      } catch (re) {
        $n(o, o.return, re);
      }
      if (o === r) {
        tt = null;
        break;
      }
      var q = o.sibling;
      if (q !== null) {
        q.return = o.return, tt = q;
        break;
      }
      tt = o.return;
    }
  }
  var cc = Math.ceil,
    _o = j.ReactCurrentDispatcher,
    ds = j.ReactCurrentOwner,
    ii = j.ReactCurrentBatchConfig,
    on = 0,
    pr = null,
    ir = null,
    Sr = 0,
    ei = 0,
    Yl = Ki(0),
    Zn = 0,
    sl = null,
    xo = 0,
    Oc = 0,
    qh = 0,
    dc = null,
    ti = null,
    fc = 0,
    ao = 1 / 0,
    Mi = null,
    Ks = !1,
    Yh = null,
    So = null,
    pc = !1,
    Ea = null,
    Gl = 0,
    Xl = 0,
    Ma = null,
    di = -1,
    ul = 0;
  function hr() {
    return (on & 6) !== 0 ? yn() : di !== -1 ? di : di = yn();
  }
  function Ca(r) {
    return (r.mode & 1) === 0 ? 1 : (on & 2) !== 0 && Sr !== 0 ? Sr & -Sr : Lw.transition !== null ? (ul === 0 && (ul = fd()), ul) : (r = gn, r !== 0 || (r = window.event, r = r === void 0 ? 16 : vd(r.type)), r);
  }
  function Li(r, o, d, g) {
    if (50 < Xl) throw Xl = 0, Ma = null, Error(i(185));
    Tl(r, d, g), ((on & 2) === 0 || r !== pr) && (r === pr && ((on & 2) === 0 && (Oc |= d), Zn === 4 && Eo(r, Sr)), Mr(r, g), d === 1 && on === 0 && (o.mode & 1) === 0 && (ao = yn() + 500, js && ga()));
  }
  function Mr(r, o) {
    var d = r.callbackNode;
    Gp(r, o);
    var g = kl(r, r === pr ? Sr : 0);
    if (g === 0) d !== null && Wa(d), r.callbackNode = null, r.callbackPriority = 0;else if (o = g & -g, r.callbackPriority !== o) {
      if (d != null && Wa(d), o === 1) r.tag === 0 ? Bo(ny.bind(null, r)) : zd(ny.bind(null, r)), Ls(function () {
        (on & 6) === 0 && ga();
      }), d = null;else {
        switch (Qp(g)) {
          case 1:
            d = El;
            break;
          case 4:
            d = Wp;
            break;
          case 16:
            d = Du;
            break;
          case 536870912:
            d = qp;
            break;
          default:
            d = Du;
        }
        d = sy(d, hc.bind(null, r));
      }
      r.callbackPriority = o, r.callbackNode = d;
    }
  }
  function hc(r, o) {
    if (di = -1, ul = 0, (on & 6) !== 0) throw Error(i(327));
    var d = r.callbackNode;
    if (Zl() && r.callbackNode !== d) return null;
    var g = kl(r, r === pr ? Sr : 0);
    if (g === 0) return null;
    if ((g & 30) !== 0 || (g & r.expiredLanes) !== 0 || o) o = Ac(r, g);else {
      o = g;
      var S = on;
      on |= 2;
      var R = iy();
      (pr !== r || Sr !== o) && (Mi = null, ao = yn() + 500, Kl(r, o));
      do try {
        jw();
        break;
      } catch (q) {
        ry(r, q);
      } while (!0);
      Ge(), _o.current = R, on = S, ir !== null ? o = 0 : (pr = null, Sr = 0, o = Zn);
    }
    if (o !== 0) {
      if (o === 2 && (S = Xp(r), S !== 0 && (g = S, o = mc(r, S))), o === 1) throw d = sl, Kl(r, 0), Eo(r, g), Mr(r, yn()), d;
      if (o === 6) Eo(r, g);else {
        if (S = r.current.alternate, (g & 30) === 0 && !Gh(S) && (o = Ac(r, g), o === 2 && (R = Xp(r), R !== 0 && (g = R, o = mc(r, R))), o === 1)) throw d = sl, Kl(r, 0), Eo(r, g), Mr(r, yn()), d;
        switch (r.finishedWork = S, r.finishedLanes = g, o) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            Ql(r, ti, Mi);
            break;
          case 3:
            if (Eo(r, g), (g & 130023424) === g && (o = fc + 500 - yn(), 10 < o)) {
              if (kl(r, 0) !== 0) break;
              if (S = r.suspendedLanes, (S & g) !== g) {
                hr(), r.pingedLanes |= r.suspendedLanes & S;
                break;
              }
              r.timeoutHandle = jd(Ql.bind(null, r, ti, Mi), o);
              break;
            }
            Ql(r, ti, Mi);
            break;
          case 4:
            if (Eo(r, g), (g & 4194240) === g) break;
            for (o = r.eventTimes, S = -1; 0 < g;) {
              var A = 31 - gi(g);
              R = 1 << A, A = o[A], A > S && (S = A), g &= ~R;
            }
            if (g = S, g = yn() - g, g = (120 > g ? 120 : 480 > g ? 480 : 1080 > g ? 1080 : 1920 > g ? 1920 : 3e3 > g ? 3e3 : 4320 > g ? 4320 : 1960 * cc(g / 1960)) - g, 10 < g) {
              r.timeoutHandle = jd(Ql.bind(null, r, ti, Mi), g);
              break;
            }
            Ql(r, ti, Mi);
            break;
          case 5:
            Ql(r, ti, Mi);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return Mr(r, yn()), r.callbackNode === d ? hc.bind(null, r) : null;
  }
  function mc(r, o) {
    var d = dc;
    return r.current.memoizedState.isDehydrated && (Kl(r, o).flags |= 256), r = Ac(r, o), r !== 2 && (o = ti, ti = d, o !== null && Pc(o)), r;
  }
  function Pc(r) {
    ti === null ? ti = r : ti.push.apply(ti, r);
  }
  function Gh(r) {
    for (var o = r;;) {
      if (o.flags & 16384) {
        var d = o.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var g = 0; g < d.length; g++) {
          var S = d[g],
            R = S.getSnapshot;
          S = S.value;
          try {
            if (!Gi(R(), S)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = o.child, o.subtreeFlags & 16384 && d !== null) d.return = o, o = d;else {
        if (o === r) break;
        for (; o.sibling === null;) {
          if (o.return === null || o.return === r) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function Eo(r, o) {
    for (o &= ~qh, o &= ~Oc, r.suspendedLanes |= o, r.pingedLanes &= ~o, r = r.expirationTimes; 0 < o;) {
      var d = 31 - gi(o),
        g = 1 << d;
      r[d] = -1, o &= ~g;
    }
  }
  function ny(r) {
    if ((on & 6) !== 0) throw Error(i(327));
    Zl();
    var o = kl(r, 0);
    if ((o & 1) === 0) return Mr(r, yn()), null;
    var d = Ac(r, o);
    if (r.tag !== 0 && d === 2) {
      var g = Xp(r);
      g !== 0 && (o = g, d = mc(r, g));
    }
    if (d === 1) throw d = sl, Kl(r, 0), Eo(r, o), Mr(r, yn()), d;
    if (d === 6) throw Error(i(345));
    return r.finishedWork = r.current.alternate, r.finishedLanes = o, Ql(r, ti, Mi), Mr(r, yn()), null;
  }
  function Xh(r, o) {
    var d = on;
    on |= 1;
    try {
      return r(o);
    } finally {
      on = d, on === 0 && (ao = yn() + 500, js && ga());
    }
  }
  function Ko(r) {
    Ea !== null && Ea.tag === 0 && (on & 6) === 0 && Zl();
    var o = on;
    on |= 1;
    var d = ii.transition,
      g = gn;
    try {
      if (ii.transition = null, gn = 1, r) return r();
    } finally {
      gn = g, ii.transition = d, on = o, (on & 6) === 0 && ga();
    }
  }
  function vf() {
    ei = Yl.current, Sn(Yl);
  }
  function Kl(r, o) {
    r.finishedWork = null, r.finishedLanes = 0;
    var d = r.timeoutHandle;
    if (d !== -1 && (r.timeoutHandle = -1, Eh(d)), ir !== null) for (d = ir.return; d !== null;) {
      var g = d;
      switch (Bd(g), g.tag) {
        case 1:
          g = g.type.childContextTypes, g != null && As();
          break;
        case 3:
          nn(), Sn(or), Sn(Hn), Ah();
          break;
        case 5:
          Ri(g);
          break;
        case 4:
          nn();
          break;
        case 13:
          Sn(Mn);
          break;
        case 19:
          Sn(Mn);
          break;
        case 10:
          Ci(g.type._context);
          break;
        case 22:
        case 23:
          vf();
      }
      d = d.return;
    }
    if (pr = r, ir = r = La(r.current, null), Sr = ei = o, Zn = 0, sl = null, qh = Oc = xo = 0, ti = dc = null, zl !== null) {
      for (o = 0; o < zl.length; o++) if (d = zl[o], g = d.interleaved, g !== null) {
        d.interleaved = null;
        var S = g.next,
          R = d.pending;
        if (R !== null) {
          var A = R.next;
          R.next = S, g.next = A;
        }
        d.pending = g;
      }
      zl = null;
    }
    return r;
  }
  function ry(r, o) {
    do {
      var d = ir;
      try {
        if (Ge(), zs.current = qs, xa) {
          for (var g = Je.memoizedState; g !== null;) {
            var S = g.queue;
            S !== null && (S.pending = null), g = g.next;
          }
          xa = !1;
        }
        if (Ln = 0, Cn = On = Je = null, Qr = !1, no = 0, ds.current = null, d === null || d.return === null) {
          Zn = 1, sl = o, ir = null;
          break;
        }
        e: {
          var R = r,
            A = d.return,
            q = d,
            re = o;
          if (o = Sr, q.flags |= 32768, re !== null && typeof re == "object" && typeof re.then == "function") {
            var ye = re,
              Oe = q,
              ze = Oe.tag;
            if ((Oe.mode & 1) === 0 && (ze === 0 || ze === 11 || ze === 15)) {
              var Me = Oe.alternate;
              Me ? (Oe.updateQueue = Me.updateQueue, Oe.memoizedState = Me.memoizedState, Oe.lanes = Me.lanes) : (Oe.updateQueue = null, Oe.memoizedState = null);
            }
            var et = Go(A);
            if (et !== null) {
              et.flags &= -257, Xs(et, A, q, R, o), et.mode & 1 && Zg(R, ye, o), o = et, re = ye;
              var it = o.updateQueue;
              if (it === null) {
                var lt = /* @__PURE__ */new Set();
                lt.add(re), o.updateQueue = lt;
              } else it.add(re);
              break e;
            } else {
              if ((o & 1) === 0) {
                Zg(R, ye, o), Kh();
                break e;
              }
              re = Error(i(426));
            }
          } else if (In && q.mode & 1) {
            var Kn = Go(A);
            if (Kn !== null) {
              (Kn.flags & 65536) === 0 && (Kn.flags |= 256), Xs(Kn, A, q, R, o), eo(Ys(re, q));
              break e;
            }
          }
          R = re = Ys(re, q), Zn !== 4 && (Zn = 2), dc === null ? dc = [R] : dc.push(R), R = A;
          do {
            switch (R.tag) {
              case 3:
                R.flags |= 65536, o &= -o, R.lanes |= o;
                var pe = zh(R, re, o);
                Vg(R, pe);
                break e;
              case 1:
                q = re;
                var oe = R.type,
                  he = R.stateNode;
                if ((R.flags & 128) === 0 && (typeof oe.getDerivedStateFromError == "function" || he !== null && typeof he.componentDidCatch == "function" && (So === null || !So.has(he)))) {
                  R.flags |= 65536, o &= -o, R.lanes |= o;
                  var He = Vh(R, q, o);
                  Vg(R, He);
                  break e;
                }
            }
            R = R.return;
          } while (R !== null);
        }
        oy(d);
      } catch (ut) {
        o = ut, ir === d && d !== null && (ir = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function iy() {
    var r = _o.current;
    return _o.current = qs, r === null ? qs : r;
  }
  function Kh() {
    (Zn === 0 || Zn === 3 || Zn === 2) && (Zn = 4), pr === null || (xo & 268435455) === 0 && (Oc & 268435455) === 0 || Eo(pr, Sr);
  }
  function Ac(r, o) {
    var d = on;
    on |= 2;
    var g = iy();
    (pr !== r || Sr !== o) && (Mi = null, Kl(r, o));
    do try {
      Tb();
      break;
    } catch (S) {
      ry(r, S);
    } while (!0);
    if (Ge(), on = d, _o.current = g, ir !== null) throw Error(i(261));
    return pr = null, Sr = 0, Zn;
  }
  function Tb() {
    for (; ir !== null;) ay(ir);
  }
  function jw() {
    for (; ir !== null && !Ru();) ay(ir);
  }
  function ay(r) {
    var o = ly(r.alternate, r, ei);
    r.memoizedProps = r.pendingProps, o === null ? oy(r) : ir = o, ds.current = null;
  }
  function oy(r) {
    var o = r;
    do {
      var d = o.alternate;
      if (r = o.return, (o.flags & 32768) === 0) {
        if (d = $h(d, o, ei), d !== null) {
          ir = d;
          return;
        }
      } else {
        if (d = Eb(d, o), d !== null) {
          d.flags &= 32767, ir = d;
          return;
        }
        if (r !== null) r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null;else {
          Zn = 6, ir = null;
          return;
        }
      }
      if (o = o.sibling, o !== null) {
        ir = o;
        return;
      }
      ir = o = r;
    } while (o !== null);
    Zn === 0 && (Zn = 5);
  }
  function Ql(r, o, d) {
    var g = gn,
      S = ii.transition;
    try {
      ii.transition = null, gn = 1, Fw(r, o, d, g);
    } finally {
      ii.transition = S, gn = g;
    }
    return null;
  }
  function Fw(r, o, d, g) {
    do Zl(); while (Ea !== null);
    if ((on & 6) !== 0) throw Error(i(327));
    d = r.finishedWork;
    var S = r.finishedLanes;
    if (d === null) return null;
    if (r.finishedWork = null, r.finishedLanes = 0, d === r.current) throw Error(i(177));
    r.callbackNode = null, r.callbackPriority = 0;
    var R = d.lanes | d.childLanes;
    if (pw(r, R), r === pr && (ir = pr = null, Sr = 0), (d.subtreeFlags & 2064) === 0 && (d.flags & 2064) === 0 || pc || (pc = !0, sy(Du, function () {
      return Zl(), null;
    })), R = (d.flags & 15990) !== 0, (d.subtreeFlags & 15990) !== 0 || R) {
      R = ii.transition, ii.transition = null;
      var A = gn;
      gn = 1;
      var q = on;
      on |= 4, ds.current = null, Cb(r, d), pf(d, r), Rs(jl), Dl = !!Wu, jl = Wu = null, r.current = d, kb(d), Wi(), on = q, gn = A, ii.transition = R;
    } else r.current = d;
    if (pc && (pc = !1, Ea = r, Gl = S), R = r.pendingLanes, R === 0 && (So = null), ng(d.stateNode), Mr(r, yn()), o !== null) for (g = r.onRecoverableError, d = 0; d < o.length; d++) S = o[d], g(S.value, {
      componentStack: S.stack,
      digest: S.digest
    });
    if (Ks) throw Ks = !1, r = Yh, Yh = null, r;
    return (Gl & 1) !== 0 && r.tag !== 0 && Zl(), R = r.pendingLanes, (R & 1) !== 0 ? r === Ma ? Xl++ : (Xl = 0, Ma = r) : Xl = 0, ga(), null;
  }
  function Zl() {
    if (Ea !== null) {
      var r = Qp(Gl),
        o = ii.transition,
        d = gn;
      try {
        if (ii.transition = null, gn = 16 > r ? 16 : r, Ea === null) var g = !1;else {
          if (r = Ea, Ea = null, Gl = 0, (on & 6) !== 0) throw Error(i(331));
          var S = on;
          for (on |= 4, tt = r.current; tt !== null;) {
            var R = tt,
              A = R.child;
            if ((tt.flags & 16) !== 0) {
              var q = R.deletions;
              if (q !== null) {
                for (var re = 0; re < q.length; re++) {
                  var ye = q[re];
                  for (tt = ye; tt !== null;) {
                    var Oe = tt;
                    switch (Oe.tag) {
                      case 0:
                      case 11:
                      case 15:
                        du(8, Oe, R);
                    }
                    var ze = Oe.child;
                    if (ze !== null) ze.return = Oe, tt = ze;else for (; tt !== null;) {
                      Oe = tt;
                      var Me = Oe.sibling,
                        et = Oe.return;
                      if (Wl(Oe), Oe === ye) {
                        tt = null;
                        break;
                      }
                      if (Me !== null) {
                        Me.return = et, tt = Me;
                        break;
                      }
                      tt = et;
                    }
                  }
                }
                var it = R.alternate;
                if (it !== null) {
                  var lt = it.child;
                  if (lt !== null) {
                    it.child = null;
                    do {
                      var Kn = lt.sibling;
                      lt.sibling = null, lt = Kn;
                    } while (lt !== null);
                  }
                }
                tt = R;
              }
            }
            if ((R.subtreeFlags & 2064) !== 0 && A !== null) A.return = R, tt = A;else e: for (; tt !== null;) {
              if (R = tt, (R.flags & 2048) !== 0) switch (R.tag) {
                case 0:
                case 11:
                case 15:
                  du(9, R, R.return);
              }
              var pe = R.sibling;
              if (pe !== null) {
                pe.return = R.return, tt = pe;
                break e;
              }
              tt = R.return;
            }
          }
          var oe = r.current;
          for (tt = oe; tt !== null;) {
            A = tt;
            var he = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && he !== null) he.return = A, tt = he;else e: for (A = oe; tt !== null;) {
              if (q = tt, (q.flags & 2048) !== 0) try {
                switch (q.tag) {
                  case 0:
                  case 11:
                  case 15:
                    uc(9, q);
                }
              } catch (ut) {
                $n(q, q.return, ut);
              }
              if (q === A) {
                tt = null;
                break e;
              }
              var He = q.sibling;
              if (He !== null) {
                He.return = q.return, tt = He;
                break e;
              }
              tt = q.return;
            }
          }
          if (on = S, ga(), qi && typeof qi.onPostCommitFiberRoot == "function") try {
            qi.onPostCommitFiberRoot(Iu, r);
          } catch {}
          g = !0;
        }
        return g;
      } finally {
        gn = d, ii.transition = o;
      }
    }
    return !1;
  }
  function Qh(r, o, d) {
    o = Ys(d, o), o = zh(r, o, 1), r = Ti(r, o, 1), o = hr(), r !== null && (Tl(r, 1, o), Mr(r, o));
  }
  function $n(r, o, d) {
    if (r.tag === 3) Qh(r, r, d);else for (; o !== null;) {
      if (o.tag === 3) {
        Qh(o, r, d);
        break;
      } else if (o.tag === 1) {
        var g = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (So === null || !So.has(g))) {
          r = Ys(d, r), r = Vh(o, r, 1), o = Ti(o, r, 1), r = hr(), o !== null && (Tl(o, 1, r), Mr(o, r));
          break;
        }
      }
      o = o.return;
    }
  }
  function Nw(r, o, d) {
    var g = r.pingCache;
    g !== null && g.delete(o), o = hr(), r.pingedLanes |= r.suspendedLanes & d, pr === r && (Sr & d) === d && (Zn === 4 || Zn === 3 && (Sr & 130023424) === Sr && 500 > yn() - fc ? Kl(r, 0) : qh |= d), Mr(r, o);
  }
  function nv(r, o) {
    o === 0 && ((r.mode & 1) === 0 ? o = 1 : (o = Yi, Yi <<= 1, (Yi & 130023424) === 0 && (Yi = 4194304)));
    var d = hr();
    r = En(r, o), r !== null && (Tl(r, o, d), Mr(r, d));
  }
  function Rb(r) {
    var o = r.memoizedState,
      d = 0;
    o !== null && (d = o.retryLane), nv(r, d);
  }
  function zw(r, o) {
    var d = 0;
    switch (r.tag) {
      case 13:
        var g = r.stateNode,
          S = r.memoizedState;
        S !== null && (d = S.retryLane);
        break;
      case 19:
        g = r.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    g !== null && g.delete(o), nv(r, d);
  }
  var ly;
  ly = function (r, o, d) {
    if (r !== null) {
      if (r.memoizedProps !== o.pendingProps || or.current) Dr = !0;else {
        if ((r.lanes & d) === 0 && (o.flags & 128) === 0) return Dr = !1, zr(r, o, d);
        Dr = (r.flags & 131072) !== 0;
      }
    } else Dr = !1, In && (o.flags & 1048576) !== 0 && jg(o, Ja, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var g = o.type;
        ll(r, o), r = o.pendingProps;
        var S = xi(o, Hn.current);
        Fs(o, d), S = Ju(null, o, g, r, S, d);
        var R = ec();
        return o.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, tr(g) ? (R = !0, Gr(o)) : R = !1, o.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, Dh(o), S.updater = qd, o.stateNode = S, S._reactInternals = o, Oh(o, g, r, d), o = lc(null, o, g, !0, R, d)) : (o.tag = 0, In && R && Vd(o), _n(null, o, S, d), o = o.child), o;
      case 16:
        g = o.elementType;
        e: {
          switch (ll(r, o), r = o.pendingProps, S = g._init, g = S(g._payload), o.type = g, S = o.tag = Db(g), r = si(g, r), S) {
            case 0:
              o = sf(null, o, g, r, d);
              break e;
            case 1:
              o = oc(null, o, g, r, d);
              break e;
            case 11:
              o = $l(null, o, g, r, d);
              break e;
            case 14:
              o = jt(null, o, g, si(g.type, r), d);
              break e;
          }
          throw Error(i(306, g, ""));
        }
        return o;
      case 0:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), sf(r, o, g, S, d);
      case 1:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), oc(r, o, g, S, d);
      case 3:
        e: {
          if (Km(o), r === null) throw Error(i(387));
          g = o.pendingProps, R = o.memoizedState, S = R.element, zg(r, o), Wd(o, g, null, d);
          var A = o.memoizedState;
          if (g = A.element, R.isDehydrated) {
            if (R = {
              element: g,
              isDehydrated: !1,
              cache: A.cache,
              pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
              transitions: A.transitions
            }, o.updateQueue.baseState = R, o.memoizedState = R, o.flags & 256) {
              S = Ys(Error(i(423)), o), o = Qm(r, o, g, d, S);
              break e;
            } else if (g !== S) {
              S = Ys(Error(i(424)), o), o = Qm(r, o, g, d, S);
              break e;
            } else for (Kr = ha(o.stateNode.containerInfo.firstChild), Xr = o, In = !0, Ei = null, d = qg(o, null, g, d), o.child = d; d;) d.flags = d.flags & -3 | 4096, d = d.sibling;
          } else {
            if (Wo(), g === S) {
              o = Ir(r, o, d);
              break e;
            }
            _n(r, o, g, d);
          }
          o = o.child;
        }
        return o;
      case 5:
        return Xn(o), r === null && Th(o), g = o.type, S = o.pendingProps, R = r !== null ? r.memoizedProps : null, A = S.children, Ad(g, S) ? A = null : R !== null && Ad(g, R) && (o.flags |= 32), Sb(r, o), _n(r, o, A, d), o.child;
      case 6:
        return r === null && Th(o), null;
      case 13:
        return Zm(r, o, d);
      case 4:
        return Wt(o, o.stateNode.containerInfo), g = o.pendingProps, r === null ? o.child = Vl(o, null, g, d) : _n(r, o, g, d), o.child;
      case 11:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), $l(r, o, g, S, d);
      case 7:
        return _n(r, o, o.pendingProps, d), o.child;
      case 8:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 12:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 10:
        e: {
          if (g = o.type._context, S = o.pendingProps, R = o.memoizedProps, A = S.value, ft(Hd, g._currentValue), g._currentValue = A, R !== null) if (Gi(R.value, A)) {
            if (R.children === S.children && !or.current) {
              o = Ir(r, o, d);
              break e;
            }
          } else for (R = o.child, R !== null && (R.return = o); R !== null;) {
            var q = R.dependencies;
            if (q !== null) {
              A = R.child;
              for (var re = q.firstContext; re !== null;) {
                if (re.context === g) {
                  if (R.tag === 1) {
                    re = wa(-1, d & -d), re.tag = 2;
                    var ye = R.updateQueue;
                    if (ye !== null) {
                      ye = ye.shared;
                      var Oe = ye.pending;
                      Oe === null ? re.next = re : (re.next = Oe.next, Oe.next = re), ye.pending = re;
                    }
                  }
                  R.lanes |= d, re = R.alternate, re !== null && (re.lanes |= d), ui(R.return, d, o), q.lanes |= d;
                  break;
                }
                re = re.next;
              }
            } else if (R.tag === 10) A = R.type === o.type ? null : R.child;else if (R.tag === 18) {
              if (A = R.return, A === null) throw Error(i(341));
              A.lanes |= d, q = A.alternate, q !== null && (q.lanes |= d), ui(A, d, o), A = R.sibling;
            } else A = R.child;
            if (A !== null) A.return = R;else for (A = R; A !== null;) {
              if (A === o) {
                A = null;
                break;
              }
              if (R = A.sibling, R !== null) {
                R.return = A.return, A = R;
                break;
              }
              A = A.return;
            }
            R = A;
          }
          _n(r, o, S.children, d), o = o.child;
        }
        return o;
      case 9:
        return S = o.type, g = o.pendingProps.children, Fs(o, d), S = ki(S), g = g(S), o.flags |= 1, _n(r, o, g, d), o.child;
      case 14:
        return g = o.type, S = si(g, o.pendingProps), S = si(g.type, S), jt(r, o, g, S, d);
      case 15:
        return ac(r, o, o.type, o.pendingProps, d);
      case 17:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), ll(r, o), o.tag = 1, tr(g) ? (r = !0, Gr(o)) : r = !1, Fs(o, d), Lh(o, g, S), Oh(o, g, S, d), lc(null, o, g, !0, r, d);
      case 19:
        return ol(r, o, d);
      case 22:
        return Bh(r, o, d);
    }
    throw Error(i(156, o.tag));
  };
  function sy(r, o) {
    return Or(r, o);
  }
  function Vw(r, o, d, g) {
    this.tag = r, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Oi(r, o, d, g) {
    return new Vw(r, o, d, g);
  }
  function Zh(r) {
    return r = r.prototype, !(!r || !r.isReactComponent);
  }
  function Db(r) {
    if (typeof r == "function") return Zh(r) ? 1 : 0;
    if (r != null) {
      if (r = r.$$typeof, r === ee) return 11;
      if (r === le) return 14;
    }
    return 2;
  }
  function La(r, o) {
    var d = r.alternate;
    return d === null ? (d = Oi(r.tag, o, r.key, r.mode), d.elementType = r.elementType, d.type = r.type, d.stateNode = r.stateNode, d.alternate = r, r.alternate = d) : (d.pendingProps = o, d.type = r.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = r.flags & 14680064, d.childLanes = r.childLanes, d.lanes = r.lanes, d.child = r.child, d.memoizedProps = r.memoizedProps, d.memoizedState = r.memoizedState, d.updateQueue = r.updateQueue, o = r.dependencies, d.dependencies = o === null ? null : {
      lanes: o.lanes,
      firstContext: o.firstContext
    }, d.sibling = r.sibling, d.index = r.index, d.ref = r.ref, d;
  }
  function Jl(r, o, d, g, S, R) {
    var A = 2;
    if (g = r, typeof r == "function") Zh(r) && (A = 1);else if (typeof r == "string") A = 5;else e: switch (r) {
      case G:
        return oo(d.children, S, R, o);
      case Q:
        A = 8, S |= 8;
        break;
      case te:
        return r = Oi(12, d, o, S | 2), r.elementType = te, r.lanes = R, r;
      case ae:
        return r = Oi(13, d, o, S), r.elementType = ae, r.lanes = R, r;
      case ne:
        return r = Oi(19, d, o, S), r.elementType = ne, r.lanes = R, r;
      case W:
        return jc(d, S, R, o);
      default:
        if (typeof r == "object" && r !== null) switch (r.$$typeof) {
          case ie:
            A = 10;
            break e;
          case Y:
            A = 9;
            break e;
          case ee:
            A = 11;
            break e;
          case le:
            A = 14;
            break e;
          case ce:
            A = 16, g = null;
            break e;
        }
        throw Error(i(130, r == null ? r : typeof r, ""));
    }
    return o = Oi(A, d, o, S), o.elementType = r, o.type = g, o.lanes = R, o;
  }
  function oo(r, o, d, g) {
    return r = Oi(7, r, g, o), r.lanes = d, r;
  }
  function jc(r, o, d, g) {
    return r = Oi(22, r, g, o), r.elementType = W, r.lanes = d, r.stateNode = {
      isHidden: !1
    }, r;
  }
  function gf(r, o, d) {
    return r = Oi(6, r, null, o), r.lanes = d, r;
  }
  function yf(r, o, d) {
    return o = Oi(4, r.children !== null ? r.children : [], r.key, o), o.lanes = d, o.stateNode = {
      containerInfo: r.containerInfo,
      pendingChildren: null,
      implementation: r.implementation
    }, o;
  }
  function Ib(r, o, d, g, S) {
    this.tag = o, this.containerInfo = r, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Kp(0), this.expirationTimes = Kp(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kp(0), this.identifierPrefix = g, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function dp(r, o, d, g, S, R, A, q, re) {
    return r = new Ib(r, o, d, q, re), o === 1 ? (o = 1, R === !0 && (o |= 8)) : o = 0, R = Oi(3, null, null, o), r.current = R, R.stateNode = r, R.memoizedState = {
      element: g,
      isDehydrated: d,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null
    }, Dh(R), r;
  }
  function Mb(r, o, d) {
    var g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: K,
      key: g == null ? null : "" + g,
      children: r,
      containerInfo: o,
      implementation: d
    };
  }
  function uy(r) {
    if (!r) return qr;
    r = r._reactInternals;
    e: {
      if ($t(r) !== r || r.tag !== 1) throw Error(i(170));
      var o = r;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (tr(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(i(171));
    }
    if (r.tag === 1) {
      var d = r.type;
      if (tr(d)) return Gu(r, d, o);
    }
    return o;
  }
  function cy(r, o, d, g, S, R, A, q, re) {
    return r = dp(d, g, !0, r, S, R, A, q, re), r.context = uy(null), d = r.current, g = hr(), S = Ca(d), R = wa(g, S), R.callback = o ?? null, Ti(d, R, S), r.current.lanes = S, Tl(r, S, g), Mr(r, g), r;
  }
  function Fc(r, o, d, g) {
    var S = o.current,
      R = hr(),
      A = Ca(S);
    return d = uy(d), o.context === null ? o.context = d : o.pendingContext = d, o = wa(R, A), o.payload = {
      element: r
    }, g = g === void 0 ? null : g, g !== null && (o.callback = g), r = Ti(S, o, A), r !== null && (Li(r, S, A, R), to(r, S, A)), A;
  }
  function vc(r) {
    if (r = r.current, !r.child) return null;
    switch (r.child.tag) {
      case 5:
        return r.child.stateNode;
      default:
        return r.child.stateNode;
    }
  }
  function Jh(r, o) {
    if (r = r.memoizedState, r !== null && r.dehydrated !== null) {
      var d = r.retryLane;
      r.retryLane = d !== 0 && d < o ? d : o;
    }
  }
  function Qs(r, o) {
    Jh(r, o), (r = r.alternate) && Jh(r, o);
  }
  function fp() {
    return null;
  }
  var dy = typeof reportError == "function" ? reportError : function (r) {
    console.error(r);
  };
  function em(r) {
    this._internalRoot = r;
  }
  bf.prototype.render = em.prototype.render = function (r) {
    var o = this._internalRoot;
    if (o === null) throw Error(i(409));
    Fc(r, o, null, null);
  }, bf.prototype.unmount = em.prototype.unmount = function () {
    var r = this._internalRoot;
    if (r !== null) {
      this._internalRoot = null;
      var o = r.containerInfo;
      Ko(function () {
        Fc(null, r, null, null);
      }), o[Qa] = null;
    }
  };
  function bf(r) {
    this._internalRoot = r;
  }
  bf.prototype.unstable_scheduleHydration = function (r) {
    if (r) {
      var o = At();
      r = {
        blockedOn: null,
        target: r,
        priority: o
      };
      for (var d = 0; d < br.length && o !== 0 && o < br[d].priority; d++);
      br.splice(d, 0, r), d === 0 && nh(r);
    }
  };
  function tm(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11);
  }
  function wf(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11 && (r.nodeType !== 8 || r.nodeValue !== " react-mount-point-unstable "));
  }
  function rv() {}
  function Lb(r, o, d, g, S) {
    if (S) {
      if (typeof g == "function") {
        var R = g;
        g = function () {
          var ye = vc(A);
          R.call(ye);
        };
      }
      var A = cy(o, g, r, 0, null, !1, !1, "", rv);
      return r._reactRootContainer = A, r[Qa] = A.current, Is(r.nodeType === 8 ? r.parentNode : r), Ko(), A;
    }
    for (; S = r.lastChild;) r.removeChild(S);
    if (typeof g == "function") {
      var q = g;
      g = function () {
        var ye = vc(re);
        q.call(ye);
      };
    }
    var re = dp(r, 0, !1, null, null, !1, !1, "", rv);
    return r._reactRootContainer = re, r[Qa] = re.current, Is(r.nodeType === 8 ? r.parentNode : r), Ko(function () {
      Fc(o, re, d, g);
    }), re;
  }
  function _f(r, o, d, g, S) {
    var R = d._reactRootContainer;
    if (R) {
      var A = R;
      if (typeof S == "function") {
        var q = S;
        S = function () {
          var re = vc(A);
          q.call(re);
        };
      }
      Fc(o, A, r, S);
    } else A = Lb(d, o, r, S, g);
    return vc(A);
  }
  bn = function (r) {
    switch (r.tag) {
      case 3:
        var o = r.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var d = Cl(o.pendingLanes);
          d !== 0 && (pd(o, d | 1), Mr(o, yn()), (on & 6) === 0 && (ao = yn() + 500, ga()));
        }
        break;
      case 13:
        Ko(function () {
          var g = En(r, 1);
          if (g !== null) {
            var S = hr();
            Li(g, r, 1, S);
          }
        }), Qs(r, 1);
    }
  }, Zp = function (r) {
    if (r.tag === 13) {
      var o = En(r, 134217728);
      if (o !== null) {
        var d = hr();
        Li(o, r, 134217728, d);
      }
      Qs(r, 134217728);
    }
  }, Jp = function (r) {
    if (r.tag === 13) {
      var o = Ca(r),
        d = En(r, o);
      if (d !== null) {
        var g = hr();
        Li(d, r, o, g);
      }
      Qs(r, o);
    }
  }, At = function () {
    return gn;
  }, eh = function (r, o) {
    var d = gn;
    try {
      return gn = r, o();
    } finally {
      gn = d;
    }
  }, en = function (r, o, d) {
    switch (o) {
      case "input":
        if (un(r, d), o = d.name, d.type === "radio" && o != null) {
          for (d = r; d.parentNode;) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < d.length; o++) {
            var g = d[o];
            if (g !== r && g.form === r.form) {
              var S = Gn(g);
              if (!S) throw Error(i(90));
              ge(g), un(g, S);
            }
          }
        }
        break;
      case "textarea":
        Lt(r, d);
        break;
      case "select":
        o = d.value, o != null && Dt(r, !!d.multiple, o, !1);
    }
  }, _s = Xh, Mo = Ko;
  var Ob = {
      usingClientEntryPoint: !1,
      Events: [pt, Xi, Gn, ss, yo, Xh]
    },
    cl = {
      findFiberByHostInstance: Fl,
      bundleType: 0,
      version: "18.2.0",
      rendererPackageName: "react-dom"
    },
    gc = {
      bundleType: cl.bundleType,
      version: cl.version,
      rendererPackageName: cl.rendererPackageName,
      rendererConfig: cl.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: j.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (r) {
        return r = Tn(r), r === null ? null : r.stateNode;
      },
      findFiberByHostInstance: cl.findFiberByHostInstance || fp,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
    };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Zs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Zs.isDisabled && Zs.supportsFiber) try {
      Iu = Zs.inject(gc), qi = Zs;
    } catch {}
  }
  return Qc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ob, Qc.createPortal = function (r, o) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tm(o)) throw Error(i(200));
    return Mb(r, o, null, d);
  }, Qc.createRoot = function (r, o) {
    if (!tm(r)) throw Error(i(299));
    var d = !1,
      g = "",
      S = dy;
    return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (g = o.identifierPrefix), o.onRecoverableError !== void 0 && (S = o.onRecoverableError)), o = dp(r, 1, !1, null, null, d, !1, g, S), r[Qa] = o.current, Is(r.nodeType === 8 ? r.parentNode : r), new em(o);
  }, Qc.findDOMNode = function (r) {
    if (r == null) return null;
    if (r.nodeType === 1) return r;
    var o = r._reactInternals;
    if (o === void 0) throw typeof r.render == "function" ? Error(i(188)) : (r = Object.keys(r).join(","), Error(i(268, r)));
    return r = Tn(o), r = r === null ? null : r.stateNode, r;
  }, Qc.flushSync = function (r) {
    return Ko(r);
  }, Qc.hydrate = function (r, o, d) {
    if (!wf(o)) throw Error(i(200));
    return _f(null, r, o, !0, d);
  }, Qc.hydrateRoot = function (r, o, d) {
    if (!tm(r)) throw Error(i(405));
    var g = d != null && d.hydratedSources || null,
      S = !1,
      R = "",
      A = dy;
    if (d != null && (d.unstable_strictMode === !0 && (S = !0), d.identifierPrefix !== void 0 && (R = d.identifierPrefix), d.onRecoverableError !== void 0 && (A = d.onRecoverableError)), o = cy(o, null, r, 1, d ?? null, S, !1, R, A), r[Qa] = o.current, Is(r), g) for (r = 0; r < g.length; r++) d = g[r], S = d._getVersion, S = S(d._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [d, S] : o.mutableSourceEagerHydrationData.push(d, S);
    return new bf(o);
  }, Qc.render = function (r, o, d) {
    if (!wf(o)) throw Error(i(200));
    return _f(null, r, o, !1, d);
  }, Qc.unmountComponentAtNode = function (r) {
    if (!wf(r)) throw Error(i(40));
    return r._reactRootContainer ? (Ko(function () {
      _f(null, null, r, !1, function () {
        r._reactRootContainer = null, r[Qa] = null;
      });
    }), !0) : !1;
  }, Qc.unstable_batchedUpdates = Xh, Qc.unstable_renderSubtreeIntoContainer = function (r, o, d, g) {
    if (!wf(d)) throw Error(i(200));
    if (r == null || r._reactInternals === void 0) throw Error(i(38));
    return _f(r, o, d, !1, g);
  }, Qc.version = "18.2.0-next-9e3b772b8-20220608", Qc;
}
var Jf = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nB;
function aK() {
  return nB || (nB = 1, process.env.NODE_ENV !== "production" && function () {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Nt,
      e = x4(),
      i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      s = !1;
    function c(l) {
      s = l;
    }
    function p(l) {
      if (!s) {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), _ = 1; _ < u; _++) v[_ - 1] = arguments[_];
        y("warn", l, v);
      }
    }
    function h(l) {
      if (!s) {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), _ = 1; _ < u; _++) v[_ - 1] = arguments[_];
        y("error", l, v);
      }
    }
    function y(l, u, v) {
      {
        var _ = i.ReactDebugCurrentFrame,
          n = _.getStackAddendum();
        n !== "" && (u += "%s", v = v.concat([n]));
        var a = v.map(function (f) {
          return String(f);
        });
        a.unshift("Warning: " + u), Function.prototype.apply.call(console[l], console, a);
      }
    }
    var w = 0,
      x = 1,
      E = 2,
      C = 3,
      k = 4,
      D = 5,
      I = 6,
      L = 7,
      P = 8,
      N = 9,
      O = 10,
      F = 11,
      j = 12,
      V = 13,
      K = 14,
      G = 15,
      Q = 16,
      te = 17,
      ie = 18,
      Y = 19,
      ee = 21,
      ae = 22,
      ne = 23,
      le = 24,
      ce = 25,
      W = !0,
      $ = !1,
      de = !1,
      H = !1,
      se = !1,
      ue = !1,
      Ee = !0,
      Ce = !0,
      fe = !0,
      _e = /* @__PURE__ */new Set(),
      Se = {},
      be = {};
    function Le(l, u) {
      Be(l, u), Be(l + "Capture", u);
    }
    function Be(l, u) {
      Se[l] && h("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", l), Se[l] = u;
      {
        var v = l.toLowerCase();
        be[v] = l, l === "onDoubleClick" && (be.ondblclick = l);
      }
      for (var _ = 0; _ < u.length; _++) _e.add(u[_]);
    }
    var Xe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u",
      ge = Object.prototype.hasOwnProperty;
    function qe(l) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag,
          v = u && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return v;
      }
    }
    function Ae(l) {
      try {
        return Mt(l), !1;
      } catch {
        return !0;
      }
    }
    function Mt(l) {
      return "" + l;
    }
    function Ft(l, u) {
      if (Ae(l)) return h("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(l)), Mt(l);
    }
    function un(l) {
      if (Ae(l)) return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(l)), Mt(l);
    }
    function gt(l, u) {
      if (Ae(l)) return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(l)), Mt(l);
    }
    function Pt(l, u) {
      if (Ae(l)) return h("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", u, qe(l)), Mt(l);
    }
    function St(l) {
      if (Ae(l)) return h("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", qe(l)), Mt(l);
    }
    function Dt(l) {
      if (Ae(l)) return h("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", qe(l)), Mt(l);
    }
    var Kt = 0,
      hn = 1,
      Lt = 2,
      Et = 3,
      Vt = 4,
      Xt = 5,
      vn = 6,
      ot = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
      We = ot + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
      ht = new RegExp("^[" + ot + "][" + We + "]*$"),
      Ke = {},
      yt = {};
    function je(l) {
      return ge.call(yt, l) ? !0 : ge.call(Ke, l) ? !1 : ht.test(l) ? (yt[l] = !0, !0) : (Ke[l] = !0, h("Invalid attribute name: `%s`", l), !1);
    }
    function at(l, u, v) {
      return u !== null ? u.type === Kt : v ? !1 : l.length > 2 && (l[0] === "o" || l[0] === "O") && (l[1] === "n" || l[1] === "N");
    }
    function kt(l, u, v, _) {
      if (v !== null && v.type === Kt) return !1;
      switch (typeof u) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean":
          {
            if (_) return !1;
            if (v !== null) return !v.acceptsBooleans;
            var n = l.toLowerCase().slice(0, 5);
            return n !== "data-" && n !== "aria-";
          }
        default:
          return !1;
      }
    }
    function Bt(l, u, v, _) {
      if (u === null || typeof u > "u" || kt(l, u, v, _)) return !0;
      if (_) return !1;
      if (v !== null) switch (v.type) {
        case Et:
          return !u;
        case Vt:
          return u === !1;
        case Xt:
          return isNaN(u);
        case vn:
          return isNaN(u) || u < 1;
      }
      return !1;
    }
    function Ht(l) {
      return en.hasOwnProperty(l) ? en[l] : null;
    }
    function sn(l, u, v, _, n, a, f) {
      this.acceptsBooleans = u === Lt || u === Et || u === Vt, this.attributeName = _, this.attributeNamespace = n, this.mustUseProperty = v, this.propertyName = l, this.type = u, this.sanitizeURL = a, this.removeEmptyString = f;
    }
    var en = {},
      Rr = ["children", "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
    Rr.forEach(function (l) {
      en[l] = new sn(l, Kt, !1,
      // mustUseProperty
      l,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (l) {
      var u = l[0],
        v = l[1];
      en[u] = new sn(u, hn, !1,
      // mustUseProperty
      v,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (l) {
      en[l] = new sn(l, Lt, !1,
      // mustUseProperty
      l.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (l) {
      en[l] = new sn(l, Lt, !1,
      // mustUseProperty
      l,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["allowFullScreen", "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless",
    // Microdata
    "itemScope"].forEach(function (l) {
      en[l] = new sn(l, Et, !1,
      // mustUseProperty
      l.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple", "muted", "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      en[l] = new sn(l, Et, !0,
      // mustUseProperty
      l,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["capture", "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      en[l] = new sn(l, Vt, !1,
      // mustUseProperty
      l,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["cols", "rows", "size", "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      en[l] = new sn(l, vn, !1,
      // mustUseProperty
      l,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["rowSpan", "start"].forEach(function (l) {
      en[l] = new sn(l, Xt, !1,
      // mustUseProperty
      l.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var Nr = /[\-\:]([a-z])/g,
      Hi = function (l) {
        return l[1].toUpperCase();
      };
    ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      var u = l.replace(Nr, Hi);
      en[u] = new sn(u, hn, !1,
      // mustUseProperty
      l, null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      var u = l.replace(Nr, Hi);
      en[u] = new sn(u, hn, !1,
      // mustUseProperty
      l, "http://www.w3.org/1999/xlink", !1,
      // sanitizeURL
      !1);
    }), ["xml:base", "xml:lang", "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (l) {
      var u = l.replace(Nr, Hi);
      en[u] = new sn(u, hn, !1,
      // mustUseProperty
      l, "http://www.w3.org/XML/1998/namespace", !1,
      // sanitizeURL
      !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (l) {
      en[l] = new sn(l, hn, !1,
      // mustUseProperty
      l.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var ss = "xlinkHref";
    en[ss] = new sn("xlinkHref", hn, !1,
    // mustUseProperty
    "xlink:href", "http://www.w3.org/1999/xlink", !0,
    // sanitizeURL
    !1), ["src", "href", "action", "formAction"].forEach(function (l) {
      en[l] = new sn(l, hn, !1,
      // mustUseProperty
      l.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0);
    });
    var yo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
      _s = !1;
    function Mo(l) {
      !_s && yo.test(l) && (_s = !0, h("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(l)));
    }
    function bo(l, u, v, _) {
      if (_.mustUseProperty) {
        var n = _.propertyName;
        return l[n];
      } else {
        Ft(v, u), _.sanitizeURL && Mo("" + v);
        var a = _.attributeName,
          f = null;
        if (_.type === Vt) {
          if (l.hasAttribute(a)) {
            var m = l.getAttribute(a);
            return m === "" ? !0 : Bt(u, v, _, !1) ? m : m === "" + v ? v : m;
          }
        } else if (l.hasAttribute(a)) {
          if (Bt(u, v, _, !1)) return l.getAttribute(a);
          if (_.type === Et) return v;
          f = l.getAttribute(a);
        }
        return Bt(u, v, _, !1) ? f === null ? v : f : f === "" + v ? v : f;
      }
    }
    function Tu(l, u, v, _) {
      {
        if (!je(u)) return;
        if (!l.hasAttribute(u)) return v === void 0 ? void 0 : null;
        var n = l.getAttribute(u);
        return Ft(v, u), n === "" + v ? v : n;
      }
    }
    function Ha(l, u, v, _) {
      var n = Ht(u);
      if (!at(u, n, _)) {
        if (Bt(u, v, n, _) && (v = null), _ || n === null) {
          if (je(u)) {
            var a = u;
            v === null ? l.removeAttribute(a) : (Ft(v, u), l.setAttribute(a, "" + v));
          }
          return;
        }
        var f = n.mustUseProperty;
        if (f) {
          var m = n.propertyName;
          if (v === null) {
            var b = n.type;
            l[m] = b === Et ? !1 : "";
          } else l[m] = v;
          return;
        }
        var T = n.attributeName,
          M = n.attributeNamespace;
        if (v === null) l.removeAttribute(T);else {
          var z = n.type,
            U;
          z === Et || z === Vt && v === !0 ? U = "" : (Ft(v, T), U = "" + v, n.sanitizeURL && Mo(U.toString())), M ? l.setAttributeNS(M, T, U) : l.setAttribute(T, U);
        }
      }
    }
    var $i = Symbol.for("react.element"),
      oi = Symbol.for("react.portal"),
      Lo = Symbol.for("react.fragment"),
      $a = Symbol.for("react.strict_mode"),
      Oo = Symbol.for("react.profiler"),
      Z = Symbol.for("react.provider"),
      Ne = Symbol.for("react.context"),
      Ye = Symbol.for("react.forward_ref"),
      xt = Symbol.for("react.suspense"),
      rn = Symbol.for("react.suspense_list"),
      $t = Symbol.for("react.memo"),
      Ct = Symbol.for("react.lazy"),
      qt = Symbol.for("react.scope"),
      yr = Symbol.for("react.debug_trace_mode"),
      Tn = Symbol.for("react.offscreen"),
      jn = Symbol.for("react.legacy_hidden"),
      Or = Symbol.for("react.cache"),
      Wa = Symbol.for("react.tracing_marker"),
      Ru = Symbol.iterator,
      Wi = "@@iterator";
    function yn(l) {
      if (l === null || typeof l != "object") return null;
      var u = Ru && l[Ru] || l[Wi];
      return typeof u == "function" ? u : null;
    }
    var Qt = Object.assign,
      El = 0,
      Wp,
      Du,
      tg,
      qp,
      Iu,
      qi,
      ng;
    function gi() {}
    gi.__reactDisabledLog = !0;
    function cw() {
      {
        if (El === 0) {
          Wp = console.log, Du = console.info, tg = console.warn, qp = console.error, Iu = console.group, qi = console.groupCollapsed, ng = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: gi,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        El++;
      }
    }
    function dw() {
      {
        if (El--, El === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Qt({}, l, {
              value: Wp
            }),
            info: Qt({}, l, {
              value: Du
            }),
            warn: Qt({}, l, {
              value: tg
            }),
            error: Qt({}, l, {
              value: qp
            }),
            group: Qt({}, l, {
              value: Iu
            }),
            groupCollapsed: Qt({}, l, {
              value: qi
            }),
            groupEnd: Qt({}, l, {
              value: ng
            })
          });
        }
        El < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Yp = i.ReactCurrentDispatcher,
      xs;
    function Yi(l, u, v) {
      {
        if (xs === void 0) try {
          throw Error();
        } catch (n) {
          var _ = n.stack.trim().match(/\n( *(at )?)/);
          xs = _ && _[1] || "";
        }
        return `
` + xs + l;
      }
    }
    var Cl = !1,
      kl;
    {
      var fw = typeof WeakMap == "function" ? WeakMap : Map;
      kl = new fw();
    }
    function Gp(l, u) {
      if (!l || Cl) return "";
      {
        var v = kl.get(l);
        if (v !== void 0) return v;
      }
      var _;
      Cl = !0;
      var n = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var a;
      a = Yp.current, Yp.current = null, cw();
      try {
        if (u) {
          var f = function () {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (J) {
              _ = J;
            }
            Reflect.construct(l, [], f);
          } else {
            try {
              f.call();
            } catch (J) {
              _ = J;
            }
            l.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            _ = J;
          }
          l();
        }
      } catch (J) {
        if (J && _ && typeof J.stack == "string") {
          for (var m = J.stack.split(`
`), b = _.stack.split(`
`), T = m.length - 1, M = b.length - 1; T >= 1 && M >= 0 && m[T] !== b[M];) M--;
          for (; T >= 1 && M >= 0; T--, M--) if (m[T] !== b[M]) {
            if (T !== 1 || M !== 1) do if (T--, M--, M < 0 || m[T] !== b[M]) {
              var z = `
` + m[T].replace(" at new ", " at ");
              return l.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", l.displayName)), typeof l == "function" && kl.set(l, z), z;
            } while (T >= 1 && M >= 0);
            break;
          }
        }
      } finally {
        Cl = !1, Yp.current = a, dw(), Error.prepareStackTrace = n;
      }
      var U = l ? l.displayName || l.name : "",
        X = U ? Yi(U) : "";
      return typeof l == "function" && kl.set(l, X), X;
    }
    function Xp(l, u, v) {
      return Gp(l, !0);
    }
    function fd(l, u, v) {
      return Gp(l, !1);
    }
    function Kp(l) {
      var u = l.prototype;
      return !!(u && u.isReactComponent);
    }
    function Tl(l, u, v) {
      if (l == null) return "";
      if (typeof l == "function") return Gp(l, Kp(l));
      if (typeof l == "string") return Yi(l);
      switch (l) {
        case xt:
          return Yi("Suspense");
        case rn:
          return Yi("SuspenseList");
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case Ye:
          return fd(l.render);
        case $t:
          return Tl(l.type, u, v);
        case Ct:
          {
            var _ = l,
              n = _._payload,
              a = _._init;
            try {
              return Tl(a(n), u, v);
            } catch {}
          }
      }
      return "";
    }
    function pw(l) {
      switch (l._debugOwner && l._debugOwner.type, l._debugSource, l.tag) {
        case D:
          return Yi(l.type);
        case Q:
          return Yi("Lazy");
        case V:
          return Yi("Suspense");
        case Y:
          return Yi("SuspenseList");
        case w:
        case E:
        case G:
          return fd(l.type);
        case F:
          return fd(l.type.render);
        case x:
          return Xp(l.type);
        default:
          return "";
      }
    }
    function pd(l) {
      try {
        var u = "",
          v = l;
        do u += pw(v), v = v.return; while (v);
        return u;
      } catch (_) {
        return `
Error generating stack: ` + _.message + `
` + _.stack;
      }
    }
    function gn(l, u, v) {
      var _ = l.displayName;
      if (_) return _;
      var n = u.displayName || u.name || "";
      return n !== "" ? v + "(" + n + ")" : v;
    }
    function Qp(l) {
      return l.displayName || "Context";
    }
    function bn(l) {
      if (l == null) return null;
      if (typeof l.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function") return l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case Lo:
          return "Fragment";
        case oi:
          return "Portal";
        case Oo:
          return "Profiler";
        case $a:
          return "StrictMode";
        case xt:
          return "Suspense";
        case rn:
          return "SuspenseList";
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case Ne:
          var u = l;
          return Qp(u) + ".Consumer";
        case Z:
          var v = l;
          return Qp(v._context) + ".Provider";
        case Ye:
          return gn(l, l.render, "ForwardRef");
        case $t:
          var _ = l.displayName || null;
          return _ !== null ? _ : bn(l.type) || "Memo";
        case Ct:
          {
            var n = l,
              a = n._payload,
              f = n._init;
            try {
              return bn(f(a));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    function Zp(l, u, v) {
      var _ = u.displayName || u.name || "";
      return l.displayName || (_ !== "" ? v + "(" + _ + ")" : v);
    }
    function Jp(l) {
      return l.displayName || "Context";
    }
    function At(l) {
      var u = l.tag,
        v = l.type;
      switch (u) {
        case le:
          return "Cache";
        case N:
          var _ = v;
          return Jp(_) + ".Consumer";
        case O:
          var n = v;
          return Jp(n._context) + ".Provider";
        case ie:
          return "DehydratedFragment";
        case F:
          return Zp(v, v.render, "ForwardRef");
        case L:
          return "Fragment";
        case D:
          return v;
        case k:
          return "Portal";
        case C:
          return "Root";
        case I:
          return "Text";
        case Q:
          return bn(v);
        case P:
          return v === $a ? "StrictMode" : "Mode";
        case ae:
          return "Offscreen";
        case j:
          return "Profiler";
        case ee:
          return "Scope";
        case V:
          return "Suspense";
        case Y:
          return "SuspenseList";
        case ce:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case x:
        case w:
        case te:
        case E:
        case K:
        case G:
          if (typeof v == "function") return v.displayName || v.name || null;
          if (typeof v == "string") return v;
          break;
      }
      return null;
    }
    var eh = i.ReactDebugCurrentFrame,
      Pr = null,
      Po = !1;
    function yi() {
      {
        if (Pr === null) return null;
        var l = Pr._debugOwner;
        if (l !== null && typeof l < "u") return At(l);
      }
      return null;
    }
    function Ao() {
      return Pr === null ? "" : pd(Pr);
    }
    function Un() {
      eh.getCurrentStack = null, Pr = null, Po = !1;
    }
    function Rn(l) {
      eh.getCurrentStack = l === null ? null : Ao, Pr = l, Po = !1;
    }
    function Mu() {
      return Pr;
    }
    function br(l) {
      Po = l;
    }
    function bi(l) {
      return "" + l;
    }
    function qa(l) {
      switch (typeof l) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return l;
        case "object":
          return Dt(l), l;
        default:
          return "";
      }
    }
    var Lu = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function th(l, u) {
      Lu[u.type] || u.onChange || u.onInput || u.readOnly || u.disabled || u.value == null || h("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), u.onChange || u.readOnly || u.disabled || u.checked == null || h("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function nh(l) {
      var u = l.type,
        v = l.nodeName;
      return v && v.toLowerCase() === "input" && (u === "checkbox" || u === "radio");
    }
    function Ou(l) {
      return l._valueTracker;
    }
    function rg(l) {
      l._valueTracker = null;
    }
    function hw(l) {
      var u = "";
      return l && (nh(l) ? u = l.checked ? "true" : "false" : u = l.value), u;
    }
    function Pu(l) {
      var u = nh(l) ? "checked" : "value",
        v = Object.getOwnPropertyDescriptor(l.constructor.prototype, u);
      Dt(l[u]);
      var _ = "" + l[u];
      if (!(l.hasOwnProperty(u) || typeof v > "u" || typeof v.get != "function" || typeof v.set != "function")) {
        var n = v.get,
          a = v.set;
        Object.defineProperty(l, u, {
          configurable: !0,
          get: function () {
            return n.call(this);
          },
          set: function (m) {
            Dt(m), _ = "" + m, a.call(this, m);
          }
        }), Object.defineProperty(l, u, {
          enumerable: v.enumerable
        });
        var f = {
          getValue: function () {
            return _;
          },
          setValue: function (m) {
            Dt(m), _ = "" + m;
          },
          stopTracking: function () {
            rg(l), delete l[u];
          }
        };
        return f;
      }
    }
    function jo(l) {
      Ou(l) || (l._valueTracker = Pu(l));
    }
    function Rl(l) {
      if (!l) return !1;
      var u = Ou(l);
      if (!u) return !0;
      var v = u.getValue(),
        _ = hw(l);
      return _ !== v ? (u.setValue(_), !0) : !1;
    }
    function Dl(l) {
      if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
      try {
        return l.activeElement || l.body;
      } catch {
        return l.body;
      }
    }
    var ig = !1,
      ag = !1,
      hd = !1,
      Au = !1;
    function md(l) {
      var u = l.type === "checkbox" || l.type === "radio";
      return u ? l.checked != null : l.value != null;
    }
    function vd(l, u) {
      var v = l,
        _ = u.checked,
        n = Qt({}, u, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: _ ?? v._wrapperState.initialChecked
        });
      return n;
    }
    function Ya(l, u) {
      th("input", u), u.checked !== void 0 && u.defaultChecked !== void 0 && !ag && (h("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", u.type), ag = !0), u.value !== void 0 && u.defaultValue !== void 0 && !ig && (h("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", u.type), ig = !0);
      var v = l,
        _ = u.defaultValue == null ? "" : u.defaultValue;
      v._wrapperState = {
        initialChecked: u.checked != null ? u.checked : u.defaultChecked,
        initialValue: qa(u.value != null ? u.value : _),
        controlled: md(u)
      };
    }
    function gd(l, u) {
      var v = l,
        _ = u.checked;
      _ != null && Ha(v, "checked", _, !1);
    }
    function Ss(l, u) {
      var v = l;
      {
        var _ = md(u);
        !v._wrapperState.controlled && _ && !Au && (h("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Au = !0), v._wrapperState.controlled && !_ && !hd && (h("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), hd = !0);
      }
      gd(l, u);
      var n = qa(u.value),
        a = u.type;
      if (n != null) a === "number" ? (n === 0 && v.value === "" ||
      // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      v.value != n) && (v.value = bi(n)) : v.value !== bi(n) && (v.value = bi(n));else if (a === "submit" || a === "reset") {
        v.removeAttribute("value");
        return;
      }
      u.hasOwnProperty("value") ? wd(v, u.type, n) : u.hasOwnProperty("defaultValue") && wd(v, u.type, qa(u.defaultValue)), u.checked == null && u.defaultChecked != null && (v.defaultChecked = !!u.defaultChecked);
    }
    function rh(l, u, v) {
      var _ = l;
      if (u.hasOwnProperty("value") || u.hasOwnProperty("defaultValue")) {
        var n = u.type,
          a = n === "submit" || n === "reset";
        if (a && (u.value === void 0 || u.value === null)) return;
        var f = bi(_._wrapperState.initialValue);
        v || f !== _.value && (_.value = f), _.defaultValue = f;
      }
      var m = _.name;
      m !== "" && (_.name = ""), _.defaultChecked = !_.defaultChecked, _.defaultChecked = !!_._wrapperState.initialChecked, m !== "" && (_.name = m);
    }
    function yd(l, u) {
      var v = l;
      Ss(v, u), bd(v, u);
    }
    function bd(l, u) {
      var v = u.name;
      if (u.type === "radio" && v != null) {
        for (var _ = l; _.parentNode;) _ = _.parentNode;
        Ft(v, "name");
        for (var n = _.querySelectorAll("input[name=" + JSON.stringify("" + v) + '][type="radio"]'), a = 0; a < n.length; a++) {
          var f = n[a];
          if (!(f === l || f.form !== l.form)) {
            var m = Sf(f);
            if (!m) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Rl(f), Ss(f, m);
          }
        }
      }
    }
    function wd(l, u, v) {
      (u !== "number" || Dl(l.ownerDocument) !== l) && (v == null ? l.defaultValue = bi(l._wrapperState.initialValue) : l.defaultValue !== bi(v) && (l.defaultValue = bi(v)));
    }
    var $r = !1,
      Il = !1,
      _d = !1;
    function Es(l, u) {
      u.value == null && (typeof u.children == "object" && u.children !== null ? t.Children.forEach(u.children, function (v) {
        v != null && (typeof v == "string" || typeof v == "number" || Il || (Il = !0, h("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : u.dangerouslySetInnerHTML != null && (_d || (_d = !0, h("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), u.selected != null && !$r && (h("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), $r = !0);
    }
    function mw(l, u) {
      u.value != null && l.setAttribute("value", bi(qa(u.value)));
    }
    var ih = Array.isArray;
    function wr(l) {
      return ih(l);
    }
    var Ml;
    Ml = !1;
    function ju() {
      var l = yi();
      return l ? `

Check the render method of \`` + l + "`." : "";
    }
    var ah = ["value", "defaultValue"];
    function vw(l) {
      {
        th("select", l);
        for (var u = 0; u < ah.length; u++) {
          var v = ah[u];
          if (l[v] != null) {
            var _ = wr(l[v]);
            l.multiple && !_ ? h("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", v, ju()) : !l.multiple && _ && h("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", v, ju());
          }
        }
      }
    }
    function Cs(l, u, v, _) {
      var n = l.options;
      if (u) {
        for (var a = v, f = {}, m = 0; m < a.length; m++) f["$" + a[m]] = !0;
        for (var b = 0; b < n.length; b++) {
          var T = f.hasOwnProperty("$" + n[b].value);
          n[b].selected !== T && (n[b].selected = T), T && _ && (n[b].defaultSelected = !0);
        }
      } else {
        for (var M = bi(qa(v)), z = null, U = 0; U < n.length; U++) {
          if (n[U].value === M) {
            n[U].selected = !0, _ && (n[U].defaultSelected = !0);
            return;
          }
          z === null && !n[U].disabled && (z = n[U]);
        }
        z !== null && (z.selected = !0);
      }
    }
    function oh(l, u) {
      return Qt({}, u, {
        value: void 0
      });
    }
    function xd(l, u) {
      var v = l;
      vw(u), v._wrapperState = {
        wasMultiple: !!u.multiple
      }, u.value !== void 0 && u.defaultValue !== void 0 && !Ml && (h("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ml = !0);
    }
    function gw(l, u) {
      var v = l;
      v.multiple = !!u.multiple;
      var _ = u.value;
      _ != null ? Cs(v, !!u.multiple, _, !1) : u.defaultValue != null && Cs(v, !!u.multiple, u.defaultValue, !0);
    }
    function yw(l, u) {
      var v = l,
        _ = v._wrapperState.wasMultiple;
      v._wrapperState.wasMultiple = !!u.multiple;
      var n = u.value;
      n != null ? Cs(v, !!u.multiple, n, !1) : _ !== !!u.multiple && (u.defaultValue != null ? Cs(v, !!u.multiple, u.defaultValue, !0) : Cs(v, !!u.multiple, u.multiple ? [] : "", !1));
    }
    function bw(l, u) {
      var v = l,
        _ = u.value;
      _ != null && Cs(v, !!u.multiple, _, !1);
    }
    var og = !1;
    function lh(l, u) {
      var v = l;
      if (u.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var _ = Qt({}, u, {
        value: void 0,
        defaultValue: void 0,
        children: bi(v._wrapperState.initialValue)
      });
      return _;
    }
    function sh(l, u) {
      var v = l;
      th("textarea", u), u.value !== void 0 && u.defaultValue !== void 0 && !og && (h("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component"), og = !0);
      var _ = u.value;
      if (_ == null) {
        var n = u.children,
          a = u.defaultValue;
        if (n != null) {
          h("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (a != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (wr(n)) {
              if (n.length > 1) throw new Error("<textarea> can only have at most one child.");
              n = n[0];
            }
            a = n;
          }
        }
        a == null && (a = ""), _ = a;
      }
      v._wrapperState = {
        initialValue: qa(_)
      };
    }
    function lg(l, u) {
      var v = l,
        _ = qa(u.value),
        n = qa(u.defaultValue);
      if (_ != null) {
        var a = bi(_);
        a !== v.value && (v.value = a), u.defaultValue == null && v.defaultValue !== a && (v.defaultValue = a);
      }
      n != null && (v.defaultValue = bi(n));
    }
    function sg(l, u) {
      var v = l,
        _ = v.textContent;
      _ === v._wrapperState.initialValue && _ !== "" && _ !== null && (v.value = _);
    }
    function ww(l, u) {
      lg(l, u);
    }
    var Ga = "http://www.w3.org/1999/xhtml",
      uh = "http://www.w3.org/1998/Math/MathML",
      ch = "http://www.w3.org/2000/svg";
    function dh(l) {
      switch (l) {
        case "svg":
          return ch;
        case "math":
          return uh;
        default:
          return Ga;
      }
    }
    function fh(l, u) {
      return l == null || l === Ga ? dh(u) : l === ch && u === "foreignObject" ? Ga : l;
    }
    var ug = function (l) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (u, v, _, n) {
          MSApp.execUnsafeLocalFunction(function () {
            return l(u, v, _, n);
          });
        } : l;
      },
      Sd,
      cg = ug(function (l, u) {
        if (l.namespaceURI === ch && !("innerHTML" in l)) {
          Sd = Sd || document.createElement("div"), Sd.innerHTML = "<svg>" + u.valueOf().toString() + "</svg>";
          for (var v = Sd.firstChild; l.firstChild;) l.removeChild(l.firstChild);
          for (; v.firstChild;) l.appendChild(v.firstChild);
          return;
        }
        l.innerHTML = u;
      }),
      Wr = 1,
      Xa = 3,
      er = 8,
      Ka = 9,
      ph = 11,
      ks = function (l, u) {
        if (u) {
          var v = l.firstChild;
          if (v && v === l.lastChild && v.nodeType === Xa) {
            v.nodeValue = u;
            return;
          }
        }
        l.textContent = u;
      },
      Fu = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      },
      Nu = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
    function dg(l, u) {
      return l + u.charAt(0).toUpperCase() + u.substring(1);
    }
    var fg = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Nu).forEach(function (l) {
      fg.forEach(function (u) {
        Nu[dg(u, l)] = Nu[l];
      });
    });
    function Ed(l, u, v) {
      var _ = u == null || typeof u == "boolean" || u === "";
      return _ ? "" : !v && typeof u == "number" && u !== 0 && !(Nu.hasOwnProperty(l) && Nu[l]) ? u + "px" : (Pt(u, l), ("" + u).trim());
    }
    var pg = /([A-Z])/g,
      hg = /^ms-/;
    function Ts(l) {
      return l.replace(pg, "-$1").toLowerCase().replace(hg, "-ms-");
    }
    var mg = function () {};
    {
      var _w = /^(?:webkit|moz|o)[A-Z]/,
        xw = /^-ms-/,
        vg = /-(.)/g,
        hh = /;\s*$/,
        pa = {},
        Ll = {},
        gg = !1,
        zu = !1,
        Sw = function (l) {
          return l.replace(vg, function (u, v) {
            return v.toUpperCase();
          });
        },
        yg = function (l) {
          pa.hasOwnProperty(l) && pa[l] || (pa[l] = !0, h("Unsupported style property %s. Did you mean %s?", l,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Sw(l.replace(xw, "ms-"))));
        },
        mh = function (l) {
          pa.hasOwnProperty(l) && pa[l] || (pa[l] = !0, h("Unsupported vendor-prefixed style property %s. Did you mean %s?", l, l.charAt(0).toUpperCase() + l.slice(1)));
        },
        vh = function (l, u) {
          Ll.hasOwnProperty(u) && Ll[u] || (Ll[u] = !0, h(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, l, u.replace(hh, "")));
        },
        bg = function (l, u) {
          gg || (gg = !0, h("`NaN` is an invalid value for the `%s` css style property.", l));
        },
        wg = function (l, u) {
          zu || (zu = !0, h("`Infinity` is an invalid value for the `%s` css style property.", l));
        };
      mg = function (l, u) {
        l.indexOf("-") > -1 ? yg(l) : _w.test(l) ? mh(l) : hh.test(u) && vh(l, u), typeof u == "number" && (isNaN(u) ? bg(l, u) : isFinite(u) || wg(l, u));
      };
    }
    var _g = mg;
    function Ew(l) {
      {
        var u = "",
          v = "";
        for (var _ in l) if (l.hasOwnProperty(_)) {
          var n = l[_];
          if (n != null) {
            var a = _.indexOf("--") === 0;
            u += v + (a ? _ : Ts(_)) + ":", u += Ed(_, n, a), v = ";";
          }
        }
        return u || null;
      }
    }
    function xg(l, u) {
      var v = l.style;
      for (var _ in u) if (u.hasOwnProperty(_)) {
        var n = _.indexOf("--") === 0;
        n || _g(_, u[_]);
        var a = Ed(_, u[_], n);
        _ === "float" && (_ = "cssFloat"), n ? v.setProperty(_, a) : v[_] = a;
      }
    }
    function Cw(l) {
      return l == null || typeof l == "boolean" || l === "";
    }
    function Sg(l) {
      var u = {};
      for (var v in l) for (var _ = Fu[v] || [v], n = 0; n < _.length; n++) u[_[n]] = v;
      return u;
    }
    function kw(l, u) {
      {
        if (!u) return;
        var v = Sg(l),
          _ = Sg(u),
          n = {};
        for (var a in v) {
          var f = v[a],
            m = _[a];
          if (m && f !== m) {
            var b = f + "," + m;
            if (n[b]) continue;
            n[b] = !0, h("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Cw(l[f]) ? "Removing" : "Updating", f, m);
          }
        }
      }
    }
    var Gi = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      },
      Vu = Qt({
        menuitem: !0
      }, Gi),
      Eg = "__html";
    function Cd(l, u) {
      if (u) {
        if (Vu[l] && (u.children != null || u.dangerouslySetInnerHTML != null)) throw new Error(l + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (u.dangerouslySetInnerHTML != null) {
          if (u.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof u.dangerouslySetInnerHTML != "object" || !(Eg in u.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!u.suppressContentEditableWarning && u.contentEditable && u.children != null && h("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), u.style != null && typeof u.style != "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Fo(l, u) {
      if (l.indexOf("-") === -1) return typeof u.is == "string";
      switch (l) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Bu = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      },
      kd = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      },
      Rs = {},
      Tw = new RegExp("^(aria)-[" + We + "]*$"),
      Ds = new RegExp("^(aria)[A-Z][" + We + "]*$");
    function gh(l, u) {
      {
        if (ge.call(Rs, u) && Rs[u]) return !0;
        if (Ds.test(u)) {
          var v = "aria-" + u.slice(4).toLowerCase(),
            _ = kd.hasOwnProperty(v) ? v : null;
          if (_ == null) return h("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", u), Rs[u] = !0, !0;
          if (u !== _) return h("Invalid ARIA attribute `%s`. Did you mean `%s`?", u, _), Rs[u] = !0, !0;
        }
        if (Tw.test(u)) {
          var n = u.toLowerCase(),
            a = kd.hasOwnProperty(n) ? n : null;
          if (a == null) return Rs[u] = !0, !1;
          if (u !== a) return h("Unknown ARIA attribute `%s`. Did you mean `%s`?", u, a), Rs[u] = !0, !0;
        }
      }
      return !0;
    }
    function Uu(l, u) {
      {
        var v = [];
        for (var _ in u) {
          var n = gh(l, _);
          n || v.push(_);
        }
        var a = v.map(function (f) {
          return "`" + f + "`";
        }).join(", ");
        v.length === 1 ? h("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", a, l) : v.length > 1 && h("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", a, l);
      }
    }
    function yh(l, u) {
      Fo(l, u) || Uu(l, u);
    }
    var bh = !1;
    function Td(l, u) {
      {
        if (l !== "input" && l !== "textarea" && l !== "select") return;
        u != null && u.value === null && !bh && (bh = !0, l === "select" && u.multiple ? h("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", l) : h("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", l));
      }
    }
    var Ol = function () {};
    {
      var _r = {},
        wh = /^on./,
        Rd = /^on[^A-Z]/,
        Cg = new RegExp("^(aria)-[" + We + "]*$"),
        kg = new RegExp("^(aria)[A-Z][" + We + "]*$");
      Ol = function (l, u, v, _) {
        if (ge.call(_r, u) && _r[u]) return !0;
        var n = u.toLowerCase();
        if (n === "onfocusin" || n === "onfocusout") return h("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _r[u] = !0, !0;
        if (_ != null) {
          var a = _.registrationNameDependencies,
            f = _.possibleRegistrationNames;
          if (a.hasOwnProperty(u)) return !0;
          var m = f.hasOwnProperty(n) ? f[n] : null;
          if (m != null) return h("Invalid event handler property `%s`. Did you mean `%s`?", u, m), _r[u] = !0, !0;
          if (wh.test(u)) return h("Unknown event handler property `%s`. It will be ignored.", u), _r[u] = !0, !0;
        } else if (wh.test(u)) return Rd.test(u) && h("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", u), _r[u] = !0, !0;
        if (Cg.test(u) || kg.test(u)) return !0;
        if (n === "innerhtml") return h("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _r[u] = !0, !0;
        if (n === "aria") return h("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _r[u] = !0, !0;
        if (n === "is" && v !== null && v !== void 0 && typeof v != "string") return h("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof v), _r[u] = !0, !0;
        if (typeof v == "number" && isNaN(v)) return h("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", u), _r[u] = !0, !0;
        var b = Ht(u),
          T = b !== null && b.type === Kt;
        if (Bu.hasOwnProperty(n)) {
          var M = Bu[n];
          if (M !== u) return h("Invalid DOM property `%s`. Did you mean `%s`?", u, M), _r[u] = !0, !0;
        } else if (!T && u !== n) return h("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", u, n), _r[u] = !0, !0;
        return typeof v == "boolean" && kt(u, v, b, !1) ? (v ? h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', v, u, u, v, u) : h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', v, u, u, v, u, u, u), _r[u] = !0, !0) : T ? !0 : kt(u, v, b, !1) ? (_r[u] = !0, !1) : ((v === "false" || v === "true") && b !== null && b.type === Et && (h("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", v, u, v === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', u, v), _r[u] = !0), !0);
      };
    }
    var Tg = function (l, u, v) {
      {
        var _ = [];
        for (var n in u) {
          var a = Ol(l, n, u[n], v);
          a || _.push(n);
        }
        var f = _.map(function (m) {
          return "`" + m + "`";
        }).join(", ");
        _.length === 1 ? h("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, l) : _.length > 1 && h("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", f, l);
      }
    };
    function Rg(l, u, v) {
      Fo(l, u) || Tg(l, u, v);
    }
    var _h = 1,
      Dd = 2,
      wi = 4,
      xh = _h | Dd | wi,
      Pl = null;
    function Rw(l) {
      Pl !== null && h("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Pl = l;
    }
    function Dw() {
      Pl === null && h("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Pl = null;
    }
    function Hu(l) {
      return l === Pl;
    }
    function Sh(l) {
      var u = l.target || l.srcElement || window;
      return u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === Xa ? u.parentNode : u;
    }
    var Id = null,
      Al = null,
      mn = null;
    function Md(l) {
      var u = Nc(l);
      if (u) {
        if (typeof Id != "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var v = u.stateNode;
        if (v) {
          var _ = Sf(v);
          Id(u.stateNode, u.type, _);
        }
      }
    }
    function Ld(l) {
      Id = l;
    }
    function Is(l) {
      Al ? mn ? mn.push(l) : mn = [l] : Al = l;
    }
    function Dg() {
      return Al !== null || mn !== null;
    }
    function Od() {
      if (Al) {
        var l = Al,
          u = mn;
        if (Al = null, mn = null, Md(l), u) for (var v = 0; v < u.length; v++) Md(u[v]);
      }
    }
    var Ms = function (l, u) {
        return l(u);
      },
      $u = function () {},
      No = !1;
    function Ig() {
      var l = Dg();
      l && ($u(), Od());
    }
    function Mg(l, u, v) {
      if (No) return l(u, v);
      No = !0;
      try {
        return Ms(l, u, v);
      } finally {
        No = !1, Ig();
      }
    }
    function Iw(l, u, v) {
      Ms = l, $u = v;
    }
    function Lg(l) {
      return l === "button" || l === "input" || l === "select" || l === "textarea";
    }
    function Pd(l, u, v) {
      switch (l) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(v.disabled && Lg(u));
        default:
          return !1;
      }
    }
    function zo(l, u) {
      var v = l.stateNode;
      if (v === null) return null;
      var _ = Sf(v);
      if (_ === null) return null;
      var n = _[u];
      if (Pd(u, l.type, _)) return null;
      if (n && typeof n != "function") throw new Error("Expected `" + u + "` listener to be a function, instead got a value of `" + typeof n + "` type.");
      return n;
    }
    var Wu = !1;
    if (Xe) try {
      var jl = {};
      Object.defineProperty(jl, "passive", {
        get: function () {
          Wu = !0;
        }
      }), window.addEventListener("test", jl, jl), window.removeEventListener("test", jl, jl);
    } catch {
      Wu = !1;
    }
    function Ad(l, u, v, _, n, a, f, m, b) {
      var T = Array.prototype.slice.call(arguments, 3);
      try {
        u.apply(v, T);
      } catch (M) {
        this.onError(M);
      }
    }
    var jd = Ad;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Eh = document.createElement("react");
      jd = function (l, u, v, _, n, a, f, m, b) {
        if (typeof document > "u" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var T = document.createEvent("Event"),
          M = !1,
          z = !0,
          U = window.event,
          X = Object.getOwnPropertyDescriptor(window, "event");
        function J() {
          Eh.removeEventListener(Te, xe, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = U);
        }
        var me = Array.prototype.slice.call(arguments, 3);
        function xe() {
          M = !0, J(), u.apply(v, me), z = !1;
        }
        var Ie,
          Pe = !1,
          $e = !1;
        function mt(Ue) {
          if (Ie = Ue.error, Pe = !0, Ie === null && Ue.colno === 0 && Ue.lineno === 0 && ($e = !0), Ue.defaultPrevented && Ie != null && typeof Ie == "object") try {
            Ie._suppressLogging = !0;
          } catch {}
        }
        var Te = "react-" + (l || "invokeguardedcallback");
        if (window.addEventListener("error", mt), Eh.addEventListener(Te, xe, !1), T.initEvent(Te, !1, !1), Eh.dispatchEvent(T), X && Object.defineProperty(window, "event", X), M && z && (Pe ? $e && (Ie = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ie = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ie)), window.removeEventListener("error", mt), !M) return J(), Ad.apply(this, arguments);
      };
    }
    var Og = jd,
      Ls = !1,
      Fd = null,
      Os = !1,
      ha = null,
      Pg = {
        onError: function (l) {
          Ls = !0, Fd = l;
        }
      };
    function Vo(l, u, v, _, n, a, f, m, b) {
      Ls = !1, Fd = null, Og.apply(Pg, arguments);
    }
    function ma(l, u, v, _, n, a, f, m, b) {
      if (Vo.apply(this, arguments), Ls) {
        var T = Yu();
        Os || (Os = !0, ha = T);
      }
    }
    function qu() {
      if (Os) {
        var l = ha;
        throw Os = !1, ha = null, l;
      }
    }
    function Qa() {
      return Ls;
    }
    function Yu() {
      if (Ls) {
        var l = Fd;
        return Ls = !1, Fd = null, l;
      } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ps(l) {
      return l._reactInternals;
    }
    function Mw(l) {
      return l._reactInternals !== void 0;
    }
    function Fl(l, u) {
      l._reactInternals = u;
    }
    var pt = /*                      */
      0,
      Xi = /*                */
      1,
      Gn = /*                    */
      2,
      tn = /*                       */
      4,
      _i = /*                */
      16,
      Ki = /*                 */
      32,
      Sn = /*                     */
      64,
      ft = /*                   */
      128,
      qr = /*            */
      256,
      Hn = /*                          */
      512,
      or = /*                     */
      1024,
      Yr = /*                      */
      2048,
      xi = /*                    */
      4096,
      tr = /*                   */
      8192,
      As = /*             */
      16384,
      Ag = /*               */
      32767,
      Gu = /*                   */
      32768,
      Gr = /*                */
      65536,
      Nd = /* */
      131072,
      va = /*                       */
      1048576,
      js = /*                    */
      2097152,
      Za = /*                 */
      4194304,
      zd = /*                */
      8388608,
      Bo = /*               */
      16777216,
      ga = /*              */
      33554432,
      Uo =
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tn | or | 0,
      Ho = Gn | tn | _i | Ki | Hn | xi | tr,
      $o = tn | Sn | Hn | tr,
      Ja = Yr | _i,
      nr = Za | zd | js,
      Si = i.ReactCurrentOwner;
    function li(l) {
      var u = l,
        v = l;
      if (l.alternate) for (; u.return;) u = u.return;else {
        var _ = u;
        do u = _, (u.flags & (Gn | xi)) !== pt && (v = u.return), _ = u.return; while (_);
      }
      return u.tag === C ? v : null;
    }
    function ya(l) {
      if (l.tag === V) {
        var u = l.memoizedState;
        if (u === null) {
          var v = l.alternate;
          v !== null && (u = v.memoizedState);
        }
        if (u !== null) return u.dehydrated;
      }
      return null;
    }
    function ba(l) {
      return l.tag === C ? l.stateNode.containerInfo : null;
    }
    function Nl(l) {
      return li(l) === l;
    }
    function jg(l) {
      {
        var u = Si.current;
        if (u !== null && u.tag === x) {
          var v = u,
            _ = v.stateNode;
          _._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", At(v) || "A component"), _._warnedAboutRefsInRender = !0;
        }
      }
      var n = Ps(l);
      return n ? li(n) === n : !1;
    }
    function Vd(l) {
      if (li(l) !== l) throw new Error("Unable to find node on an unmounted component.");
    }
    function Bd(l) {
      var u = l.alternate;
      if (!u) {
        var v = li(l);
        if (v === null) throw new Error("Unable to find node on an unmounted component.");
        return v !== l ? null : l;
      }
      for (var _ = l, n = u;;) {
        var a = _.return;
        if (a === null) break;
        var f = a.alternate;
        if (f === null) {
          var m = a.return;
          if (m !== null) {
            _ = n = m;
            continue;
          }
          break;
        }
        if (a.child === f.child) {
          for (var b = a.child; b;) {
            if (b === _) return Vd(a), l;
            if (b === n) return Vd(a), u;
            b = b.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (_.return !== n.return) _ = a, n = f;else {
          for (var T = !1, M = a.child; M;) {
            if (M === _) {
              T = !0, _ = a, n = f;
              break;
            }
            if (M === n) {
              T = !0, n = a, _ = f;
              break;
            }
            M = M.sibling;
          }
          if (!T) {
            for (M = f.child; M;) {
              if (M === _) {
                T = !0, _ = f, n = a;
                break;
              }
              if (M === n) {
                T = !0, n = f, _ = a;
                break;
              }
              M = M.sibling;
            }
            if (!T) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (_.alternate !== n) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (_.tag !== C) throw new Error("Unable to find node on an unmounted component.");
      return _.stateNode.current === _ ? l : u;
    }
    function Xr(l) {
      var u = Bd(l);
      return u !== null ? Kr(u) : null;
    }
    function Kr(l) {
      if (l.tag === D || l.tag === I) return l;
      for (var u = l.child; u !== null;) {
        var v = Kr(u);
        if (v !== null) return v;
        u = u.sibling;
      }
      return null;
    }
    function In(l) {
      var u = Bd(l);
      return u !== null ? Ei(u) : null;
    }
    function Ei(l) {
      if (l.tag === D || l.tag === I) return l;
      for (var u = l.child; u !== null;) {
        if (u.tag !== k) {
          var v = Ei(u);
          if (v !== null) return v;
        }
        u = u.sibling;
      }
      return null;
    }
    var Ch = e.unstable_scheduleCallback,
      Fg = e.unstable_cancelCallback,
      kh = e.unstable_shouldYield,
      Th = e.unstable_requestPaint,
      lr = e.unstable_now,
      Ud = e.unstable_getCurrentPriorityLevel,
      Xu = e.unstable_ImmediatePriority,
      Wo = e.unstable_UserBlockingPriority,
      eo = e.unstable_NormalPriority,
      Lw = e.unstable_LowPriority,
      si = e.unstable_IdlePriority,
      Hd = e.unstable_yieldValue,
      $d = e.unstable_setDisableYieldValue,
      Qi = null,
      dr = null,
      Ge = null,
      Ci = !1,
      ui = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Fs(l) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var u = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (u.isDisabled) return !0;
      if (!u.supportsFiber) return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ee && (l = Qt({}, l, {
          getLaneLabelMap: Dh,
          injectProfilingHooks: qo
        })), Qi = u.inject(l), dr = u;
      } catch (v) {
        h("React instrumentation encountered an error: %s.", v);
      }
      return !!u.checkDCE;
    }
    function ki(l, u) {
      if (dr && typeof dr.onScheduleFiberRoot == "function") try {
        dr.onScheduleFiberRoot(Qi, l, u);
      } catch (v) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", v));
      }
    }
    function zl(l, u) {
      if (dr && typeof dr.onCommitFiberRoot == "function") try {
        var v = (l.current.flags & ft) === ft;
        if (Ce) {
          var _;
          switch (u) {
            case al:
              _ = Xu;
              break;
            case Ii:
              _ = Wo;
              break;
            case Zi:
              _ = eo;
              break;
            case ol:
              _ = si;
              break;
            default:
              _ = eo;
              break;
          }
          dr.onCommitFiberRoot(Qi, l, _, v);
        }
      } catch (n) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", n));
      }
    }
    function Rh(l) {
      if (dr && typeof dr.onPostCommitFiberRoot == "function") try {
        dr.onPostCommitFiberRoot(Qi, l);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function Ng(l) {
      if (dr && typeof dr.onCommitFiberUnmount == "function") try {
        dr.onCommitFiberUnmount(Qi, l);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function En(l) {
      if (typeof Hd == "function" && ($d(l), c(l)), dr && typeof dr.setStrictMode == "function") try {
        dr.setStrictMode(Qi, l);
      } catch (u) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", u));
      }
    }
    function qo(l) {
      Ge = l;
    }
    function Dh() {
      {
        for (var l = /* @__PURE__ */new Map(), u = 1, v = 0; v < zs; v++) {
          var _ = Yg(u);
          l.set(u, _), u *= 2;
        }
        return l;
      }
    }
    function zg(l) {
      Ge !== null && typeof Ge.markCommitStarted == "function" && Ge.markCommitStarted(l);
    }
    function wa() {
      Ge !== null && typeof Ge.markCommitStopped == "function" && Ge.markCommitStopped();
    }
    function Ti(l) {
      Ge !== null && typeof Ge.markComponentRenderStarted == "function" && Ge.markComponentRenderStarted(l);
    }
    function to() {
      Ge !== null && typeof Ge.markComponentRenderStopped == "function" && Ge.markComponentRenderStopped();
    }
    function Vg(l) {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStarted == "function" && Ge.markComponentPassiveEffectMountStarted(l);
    }
    function Wd() {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStopped == "function" && Ge.markComponentPassiveEffectMountStopped();
    }
    function Bg(l) {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStarted == "function" && Ge.markComponentPassiveEffectUnmountStarted(l);
    }
    function Ug() {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStopped == "function" && Ge.markComponentPassiveEffectUnmountStopped();
    }
    function Ih(l) {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStarted == "function" && Ge.markComponentLayoutEffectMountStarted(l);
    }
    function qd() {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStopped == "function" && Ge.markComponentLayoutEffectMountStopped();
    }
    function Mh(l) {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStarted == "function" && Ge.markComponentLayoutEffectUnmountStarted(l);
    }
    function Lh() {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStopped == "function" && Ge.markComponentLayoutEffectUnmountStopped();
    }
    function Hg(l, u, v) {
      Ge !== null && typeof Ge.markComponentErrored == "function" && Ge.markComponentErrored(l, u, v);
    }
    function Oh(l, u, v) {
      Ge !== null && typeof Ge.markComponentSuspended == "function" && Ge.markComponentSuspended(l, u, v);
    }
    function Ku(l) {
      Ge !== null && typeof Ge.markLayoutEffectsStarted == "function" && Ge.markLayoutEffectsStarted(l);
    }
    function Yd() {
      Ge !== null && typeof Ge.markLayoutEffectsStopped == "function" && Ge.markLayoutEffectsStopped();
    }
    function $g(l) {
      Ge !== null && typeof Ge.markPassiveEffectsStarted == "function" && Ge.markPassiveEffectsStarted(l);
    }
    function Wg() {
      Ge !== null && typeof Ge.markPassiveEffectsStopped == "function" && Ge.markPassiveEffectsStopped();
    }
    function Vl(l) {
      Ge !== null && typeof Ge.markRenderStarted == "function" && Ge.markRenderStarted(l);
    }
    function qg() {
      Ge !== null && typeof Ge.markRenderYielded == "function" && Ge.markRenderYielded();
    }
    function Ns() {
      Ge !== null && typeof Ge.markRenderStopped == "function" && Ge.markRenderStopped();
    }
    function _a(l) {
      Ge !== null && typeof Ge.markRenderScheduled == "function" && Ge.markRenderScheduled(l);
    }
    function Qu(l, u) {
      Ge !== null && typeof Ge.markForceUpdateScheduled == "function" && Ge.markForceUpdateScheduled(l, u);
    }
    function Bl(l, u) {
      Ge !== null && typeof Ge.markStateUpdateScheduled == "function" && Ge.markStateUpdateScheduled(l, u);
    }
    var dt = /*                         */
      0,
      Wt = /*                 */
      1,
      nn = /*                    */
      2,
      Xn = /*               */
      8,
      Ri = /*              */
      16,
      Mn = Math.clz32 ? Math.clz32 : Ah,
      Gd = Math.log,
      Ph = Math.LN2;
    function Ah(l) {
      var u = l >>> 0;
      return u === 0 ? 32 : 31 - (Gd(u) / Ph | 0) | 0;
    }
    var zs = 31,
      Re = /*                        */
      0,
      Ln = /*                          */
      0,
      Je = /*                        */
      1,
      On = /*    */
      2,
      Cn = /*             */
      4,
      xa = /*            */
      8,
      Qr = /*                     */
      16,
      no = /*                */
      32,
      Vs = /*                       */
      4194240,
      rr = /*                        */
      64,
      Zu = /*                        */
      128,
      Ju = /*                        */
      256,
      ec = /*                        */
      512,
      Di = /*                        */
      1024,
      Zr = /*                        */
      2048,
      Ul = /*                        */
      4096,
      tc = /*                        */
      8192,
      nc = /*                        */
      16384,
      Xd = /*                       */
      32768,
      Kd = /*                       */
      65536,
      Qd = /*                       */
      131072,
      Zd = /*                       */
      262144,
      Jd = /*                       */
      524288,
      ef = /*                       */
      1048576,
      tf = /*                       */
      2097152,
      rc = /*                            */
      130023424,
      Sa = /*                             */
      4194304,
      nf = /*                             */
      8388608,
      Bs = /*                             */
      16777216,
      Us = /*                             */
      33554432,
      rf = /*                             */
      67108864,
      af = Sa,
      Hs = /*          */
      134217728,
      jh = /*                          */
      268435455,
      $s = /*               */
      268435456,
      Yo = /*                        */
      536870912,
      Jr = /*                   */
      1073741824;
    function Yg(l) {
      {
        if (l & Je) return "Sync";
        if (l & On) return "InputContinuousHydration";
        if (l & Cn) return "InputContinuous";
        if (l & xa) return "DefaultHydration";
        if (l & Qr) return "Default";
        if (l & no) return "TransitionHydration";
        if (l & Vs) return "Transition";
        if (l & rc) return "Retry";
        if (l & Hs) return "SelectiveHydration";
        if (l & $s) return "IdleHydration";
        if (l & Yo) return "Idle";
        if (l & Jr) return "Offscreen";
      }
    }
    var wn = -1,
      ic = rr,
      of = Sa;
    function Ws(l) {
      switch (Go(l)) {
        case Je:
          return Je;
        case On:
          return On;
        case Cn:
          return Cn;
        case xa:
          return xa;
        case Qr:
          return Qr;
        case no:
          return no;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
          return l & Vs;
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          return l & rc;
        case Hs:
          return Hs;
        case $s:
          return $s;
        case Yo:
          return Yo;
        case Jr:
          return Jr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), l;
      }
    }
    function lf(l, u) {
      var v = l.pendingLanes;
      if (v === Re) return Re;
      var _ = Re,
        n = l.suspendedLanes,
        a = l.pingedLanes,
        f = v & jh;
      if (f !== Re) {
        var m = f & ~n;
        if (m !== Re) _ = Ws(m);else {
          var b = f & a;
          b !== Re && (_ = Ws(b));
        }
      } else {
        var T = v & ~n;
        T !== Re ? _ = Ws(T) : a !== Re && (_ = Ws(a));
      }
      if (_ === Re) return Re;
      if (u !== Re && u !== _ &&
      // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (u & n) === Re) {
        var M = Go(_),
          z = Go(u);
        if (
        // Tests whether the next lane is equal or lower priority than the wip
        // one. This works because the bits decrease in priority as you go left.
        M >= z ||
        // Default priority updates should not interrupt transition updates. The
        // only difference between default updates and transition updates is that
        // default updates do not support refresh transitions.
        M === Qr && (z & Vs) !== Re) return u;
      }
      (_ & Cn) !== Re && (_ |= v & Qr);
      var U = l.entangledLanes;
      if (U !== Re) for (var X = l.entanglements, J = _ & U; J > 0;) {
        var me = Hl(J),
          xe = 1 << me;
        _ |= X[me], J &= ~xe;
      }
      return _;
    }
    function Ow(l, u) {
      for (var v = l.eventTimes, _ = wn; u > 0;) {
        var n = Hl(u),
          a = 1 << n,
          f = v[n];
        f > _ && (_ = f), u &= ~a;
      }
      return _;
    }
    function Gg(l, u) {
      switch (l) {
        case Je:
        case On:
        case Cn:
          return u + 250;
        case xa:
        case Qr:
        case no:
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
          return u + 5e3;
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          return wn;
        case Hs:
        case $s:
        case Yo:
        case Jr:
          return wn;
        default:
          return h("Should have found matching lanes. This is a bug in React."), wn;
      }
    }
    function Xg(l, u) {
      for (var v = l.pendingLanes, _ = l.suspendedLanes, n = l.pingedLanes, a = l.expirationTimes, f = v; f > 0;) {
        var m = Hl(f),
          b = 1 << m,
          T = a[m];
        T === wn ? ((b & _) === Re || (b & n) !== Re) && (a[m] = Gg(b, u)) : T <= u && (l.expiredLanes |= b), f &= ~b;
      }
    }
    function Kg(l) {
      return Ws(l.pendingLanes);
    }
    function qs(l) {
      var u = l.pendingLanes & -1073741825;
      return u !== Re ? u : u & Jr ? Jr : Re;
    }
    function Pw(l) {
      return (l & Je) !== Re;
    }
    function Fh(l) {
      return (l & jh) !== Re;
    }
    function Qg(l) {
      return (l & rc) === l;
    }
    function Ys(l) {
      var u = Je | Cn | Qr;
      return (l & u) === Re;
    }
    function Nh(l) {
      return (l & Vs) === l;
    }
    function Gs(l, u) {
      var v = On | Cn | xa | Qr;
      return (u & v) !== Re;
    }
    function Aw(l, u) {
      return (u & l.expiredLanes) !== Re;
    }
    function zh(l) {
      return (l & Vs) !== Re;
    }
    function Vh() {
      var l = ic;
      return ic <<= 1, (ic & Vs) === Re && (ic = rr), l;
    }
    function Zg() {
      var l = of;
      return of <<= 1, (of & rc) === Re && (of = Sa), l;
    }
    function Go(l) {
      return l & -l;
    }
    function Xs(l) {
      return Go(l);
    }
    function Hl(l) {
      return 31 - Mn(l);
    }
    function Dr(l) {
      return Hl(l);
    }
    function _n(l, u) {
      return (l & u) !== Re;
    }
    function $l(l, u) {
      return (l & u) === u;
    }
    function jt(l, u) {
      return l | u;
    }
    function ac(l, u) {
      return l & ~u;
    }
    function Bh(l, u) {
      return l & u;
    }
    function Sb(l, u) {
      return l !== Ln && l < u ? l : u;
    }
    function sf(l) {
      for (var u = [], v = 0; v < zs; v++) u.push(l);
      return u;
    }
    function oc(l, u, v) {
      l.pendingLanes |= u, u !== Yo && (l.suspendedLanes = Re, l.pingedLanes = Re);
      var _ = l.eventTimes,
        n = Dr(u);
      _[n] = v;
    }
    function lc(l, u) {
      l.suspendedLanes |= u, l.pingedLanes &= ~u;
      for (var v = l.expirationTimes, _ = u; _ > 0;) {
        var n = Hl(_),
          a = 1 << n;
        v[n] = wn, _ &= ~a;
      }
    }
    function Km(l, u, v) {
      l.pingedLanes |= l.suspendedLanes & u;
    }
    function Qm(l, u) {
      var v = l.pendingLanes & ~u;
      l.pendingLanes = u, l.suspendedLanes = Re, l.pingedLanes = Re, l.expiredLanes &= u, l.mutableReadLanes &= u, l.entangledLanes &= u;
      for (var _ = l.entanglements, n = l.eventTimes, a = l.expirationTimes, f = v; f > 0;) {
        var m = Hl(f),
          b = 1 << m;
        _[m] = Re, n[m] = wn, a[m] = wn, f &= ~b;
      }
    }
    function uf(l, u) {
      for (var v = l.entangledLanes |= u, _ = l.entanglements, n = v; n;) {
        var a = Hl(n),
          f = 1 << a;
        f & u |
        // Is this lane transitively entangled with the newly entangled lanes?
        _[a] & u && (_[a] |= u), n &= ~f;
      }
    }
    function cf(l, u) {
      var v = Go(u),
        _;
      switch (v) {
        case Cn:
          _ = On;
          break;
        case Qr:
          _ = xa;
          break;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          _ = no;
          break;
        case Yo:
          _ = $s;
          break;
        default:
          _ = Ln;
          break;
      }
      return (_ & (l.suspendedLanes | u)) !== Ln ? Ln : _;
    }
    function Zm(l, u, v) {
      if (ui) for (var _ = l.pendingUpdatersLaneMap; v > 0;) {
        var n = Dr(v),
          a = 1 << n,
          f = _[n];
        f.add(u), v &= ~a;
      }
    }
    function df(l, u) {
      if (ui) for (var v = l.pendingUpdatersLaneMap, _ = l.memoizedUpdaters; u > 0;) {
        var n = Dr(u),
          a = 1 << n,
          f = v[n];
        f.size > 0 && (f.forEach(function (m) {
          var b = m.alternate;
          (b === null || !_.has(b)) && _.add(m);
        }), f.clear()), u &= ~a;
      }
    }
    function sc(l, u) {
      return null;
    }
    var al = Je,
      Ii = Cn,
      Zi = Qr,
      ol = Yo,
      ll = Ln;
    function Ir() {
      return ll;
    }
    function zr(l) {
      ll = l;
    }
    function sa(l, u) {
      var v = ll;
      try {
        return ll = l, u();
      } finally {
        ll = v;
      }
    }
    function Uh(l, u) {
      return l !== 0 && l < u ? l : u;
    }
    function Jg(l, u) {
      return l > u ? l : u;
    }
    function Hh(l, u) {
      return l !== 0 && l < u;
    }
    function us(l) {
      var u = Go(l);
      return Hh(al, u) ? Hh(Ii, u) ? Fh(u) ? Zi : ol : Ii : al;
    }
    function fr(l) {
      var u = l.current.memoizedState;
      return u.isDehydrated;
    }
    var $h;
    function Eb(l) {
      $h = l;
    }
    function ff(l) {
      $h(l);
    }
    var xr;
    function ey(l) {
      xr = l;
    }
    var tt;
    function cs(l) {
      tt = l;
    }
    var Wh;
    function Jm(l) {
      Wh = l;
    }
    var Cb;
    function du(l) {
      Cb = l;
    }
    var uc = !1,
      fu = [],
      Wl = null,
      ro = null,
      io = null,
      wo = /* @__PURE__ */new Map(),
      ql = /* @__PURE__ */new Map(),
      Nn = [],
      Vr = ["mousedown", "mouseup", "touchcancel", "touchend", "touchstart", "auxclick", "dblclick", "pointercancel", "pointerdown", "pointerup", "dragend", "dragstart", "drop", "compositionend", "compositionstart", "keydown", "keypress", "keyup", "input", "textInput",
      // Intentionally camelCase
      "copy", "cut", "paste", "click", "change", "contextmenu", "reset", "submit"];
    function Xo(l) {
      return Vr.indexOf(l) > -1;
    }
    function ty(l, u, v, _, n) {
      return {
        blockedOn: l,
        domEventName: u,
        eventSystemFlags: v,
        nativeEvent: n,
        targetContainers: [_]
      };
    }
    function ev(l, u) {
      switch (l) {
        case "focusin":
        case "focusout":
          Wl = null;
          break;
        case "dragenter":
        case "dragleave":
          ro = null;
          break;
        case "mouseover":
        case "mouseout":
          io = null;
          break;
        case "pointerover":
        case "pointerout":
          {
            var v = u.pointerId;
            wo.delete(v);
            break;
          }
        case "gotpointercapture":
        case "lostpointercapture":
          {
            var _ = u.pointerId;
            ql.delete(_);
            break;
          }
      }
    }
    function ri(l, u, v, _, n, a) {
      if (l === null || l.nativeEvent !== a) {
        var f = ty(u, v, _, n, a);
        if (u !== null) {
          var m = Nc(u);
          m !== null && xr(m);
        }
        return f;
      }
      l.eventSystemFlags |= _;
      var b = l.targetContainers;
      return n !== null && b.indexOf(n) === -1 && b.push(n), l;
    }
    function pf(l, u, v, _, n) {
      switch (u) {
        case "focusin":
          {
            var a = n;
            return Wl = ri(Wl, l, u, v, _, a), !0;
          }
        case "dragenter":
          {
            var f = n;
            return ro = ri(ro, l, u, v, _, f), !0;
          }
        case "mouseover":
          {
            var m = n;
            return io = ri(io, l, u, v, _, m), !0;
          }
        case "pointerover":
          {
            var b = n,
              T = b.pointerId;
            return wo.set(T, ri(wo.get(T) || null, l, u, v, _, b)), !0;
          }
        case "gotpointercapture":
          {
            var M = n,
              z = M.pointerId;
            return ql.set(z, ri(ql.get(z) || null, l, u, v, _, M)), !0;
          }
      }
      return !1;
    }
    function ua(l) {
      var u = hv(l.target);
      if (u !== null) {
        var v = li(u);
        if (v !== null) {
          var _ = v.tag;
          if (_ === V) {
            var n = ya(v);
            if (n !== null) {
              l.blockedOn = n, Cb(l.priority, function () {
                tt(v);
              });
              return;
            }
          } else if (_ === C) {
            var a = v.stateNode;
            if (fr(a)) {
              l.blockedOn = ba(v);
              return;
            }
          }
        }
      }
      l.blockedOn = null;
    }
    function kb(l) {
      for (var u = Wh(), v = {
          blockedOn: null,
          target: l,
          priority: u
        }, _ = 0; _ < Nn.length && Hh(u, Nn[_].priority); _++);
      Nn.splice(_, 0, v), _ === 0 && ua(v);
    }
    function cp(l) {
      if (l.blockedOn !== null) return !1;
      for (var u = l.targetContainers; u.length > 0;) {
        var v = u[0],
          _ = sl(l.domEventName, l.eventSystemFlags, v, l.nativeEvent);
        if (_ === null) {
          var n = l.nativeEvent,
            a = new n.constructor(n.type, n);
          Rw(a), n.target.dispatchEvent(a), Dw();
        } else {
          var f = Nc(_);
          return f !== null && xr(f), l.blockedOn = _, !1;
        }
        u.shift();
      }
      return !0;
    }
    function hf(l, u, v) {
      cp(l) && v.delete(u);
    }
    function tv() {
      uc = !1, Wl !== null && cp(Wl) && (Wl = null), ro !== null && cp(ro) && (ro = null), io !== null && cp(io) && (io = null), wo.forEach(hf), ql.forEach(hf);
    }
    function mf(l, u) {
      l.blockedOn === u && (l.blockedOn = null, uc || (uc = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, tv)));
    }
    function cc(l) {
      if (fu.length > 0) {
        mf(fu[0], l);
        for (var u = 1; u < fu.length; u++) {
          var v = fu[u];
          v.blockedOn === l && (v.blockedOn = null);
        }
      }
      Wl !== null && mf(Wl, l), ro !== null && mf(ro, l), io !== null && mf(io, l);
      var _ = function (m) {
        return mf(m, l);
      };
      wo.forEach(_), ql.forEach(_);
      for (var n = 0; n < Nn.length; n++) {
        var a = Nn[n];
        a.blockedOn === l && (a.blockedOn = null);
      }
      for (; Nn.length > 0;) {
        var f = Nn[0];
        if (f.blockedOn !== null) break;
        ua(f), f.blockedOn === null && Nn.shift();
      }
    }
    var _o = i.ReactCurrentBatchConfig,
      ds = !0;
    function ii(l) {
      ds = !!l;
    }
    function on() {
      return ds;
    }
    function pr(l, u, v) {
      var _ = xo(u),
        n;
      switch (_) {
        case al:
          n = ir;
          break;
        case Ii:
          n = Sr;
          break;
        case Zi:
        default:
          n = ei;
          break;
      }
      return n.bind(null, u, v, l);
    }
    function ir(l, u, v, _) {
      var n = Ir(),
        a = _o.transition;
      _o.transition = null;
      try {
        zr(al), ei(l, u, v, _);
      } finally {
        zr(n), _o.transition = a;
      }
    }
    function Sr(l, u, v, _) {
      var n = Ir(),
        a = _o.transition;
      _o.transition = null;
      try {
        zr(Ii), ei(l, u, v, _);
      } finally {
        zr(n), _o.transition = a;
      }
    }
    function ei(l, u, v, _) {
      ds && Yl(l, u, v, _);
    }
    function Yl(l, u, v, _) {
      var n = sl(l, u, v, _);
      if (n === null) {
        sS(l, u, _, Zn, v), ev(l, _);
        return;
      }
      if (pf(n, l, u, v, _)) {
        _.stopPropagation();
        return;
      }
      if (ev(l, _), u & wi && Xo(l)) {
        for (; n !== null;) {
          var a = Nc(n);
          a !== null && ff(a);
          var f = sl(l, u, v, _);
          if (f === null && sS(l, u, _, Zn, v), f === n) break;
          n = f;
        }
        n !== null && _.stopPropagation();
        return;
      }
      sS(l, u, _, null, v);
    }
    var Zn = null;
    function sl(l, u, v, _) {
      Zn = null;
      var n = Sh(_),
        a = hv(n);
      if (a !== null) {
        var f = li(a);
        if (f === null) a = null;else {
          var m = f.tag;
          if (m === V) {
            var b = ya(f);
            if (b !== null) return b;
            a = null;
          } else if (m === C) {
            var T = f.stateNode;
            if (fr(T)) return ba(f);
            a = null;
          } else f !== a && (a = null);
        }
      }
      return Zn = a, null;
    }
    function xo(l) {
      switch (l) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return al;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ii;
        case "message":
          {
            var u = Ud();
            switch (u) {
              case Xu:
                return al;
              case Wo:
                return Ii;
              case eo:
              case Lw:
                return Zi;
              case si:
                return ol;
              default:
                return Zi;
            }
          }
        default:
          return Zi;
      }
    }
    function Oc(l, u, v) {
      return l.addEventListener(u, v, !1), v;
    }
    function qh(l, u, v) {
      return l.addEventListener(u, v, !0), v;
    }
    function dc(l, u, v, _) {
      return l.addEventListener(u, v, {
        capture: !0,
        passive: _
      }), v;
    }
    function ti(l, u, v, _) {
      return l.addEventListener(u, v, {
        passive: _
      }), v;
    }
    var fc = null,
      ao = null,
      Mi = null;
    function Ks(l) {
      return fc = l, ao = pc(), !0;
    }
    function Yh() {
      fc = null, ao = null, Mi = null;
    }
    function So() {
      if (Mi) return Mi;
      var l,
        u = ao,
        v = u.length,
        _,
        n = pc(),
        a = n.length;
      for (l = 0; l < v && u[l] === n[l]; l++);
      var f = v - l;
      for (_ = 1; _ <= f && u[v - _] === n[a - _]; _++);
      var m = _ > 1 ? 1 - _ : void 0;
      return Mi = n.slice(l, m), Mi;
    }
    function pc() {
      return "value" in fc ? fc.value : fc.textContent;
    }
    function Ea(l) {
      var u,
        v = l.keyCode;
      return "charCode" in l ? (u = l.charCode, u === 0 && v === 13 && (u = 13)) : u = v, u === 10 && (u = 13), u >= 32 || u === 13 ? u : 0;
    }
    function Gl() {
      return !0;
    }
    function Xl() {
      return !1;
    }
    function Ma(l) {
      function u(v, _, n, a, f) {
        this._reactName = v, this._targetInst = n, this.type = _, this.nativeEvent = a, this.target = f, this.currentTarget = null;
        for (var m in l) if (l.hasOwnProperty(m)) {
          var b = l[m];
          b ? this[m] = b(a) : this[m] = a[m];
        }
        var T = a.defaultPrevented != null ? a.defaultPrevented : a.returnValue === !1;
        return T ? this.isDefaultPrevented = Gl : this.isDefaultPrevented = Xl, this.isPropagationStopped = Xl, this;
      }
      return Qt(u.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var v = this.nativeEvent;
          v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = Gl);
        },
        stopPropagation: function () {
          var v = this.nativeEvent;
          v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = Gl);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function () {},
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Gl
      }), u;
    }
    var di = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (l) {
          return l.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      ul = Ma(di),
      hr = Qt({}, di, {
        view: 0,
        detail: 0
      }),
      Ca = Ma(hr),
      Li,
      Mr,
      hc;
    function mc(l) {
      l !== hc && (hc && l.type === "mousemove" ? (Li = l.screenX - hc.screenX, Mr = l.screenY - hc.screenY) : (Li = 0, Mr = 0), hc = l);
    }
    var Pc = Qt({}, hr, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Zl,
        button: 0,
        buttons: 0,
        relatedTarget: function (l) {
          return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
        },
        movementX: function (l) {
          return "movementX" in l ? l.movementX : (mc(l), Li);
        },
        movementY: function (l) {
          return "movementY" in l ? l.movementY : Mr;
        }
      }),
      Gh = Ma(Pc),
      Eo = Qt({}, Pc, {
        dataTransfer: 0
      }),
      ny = Ma(Eo),
      Xh = Qt({}, hr, {
        relatedTarget: 0
      }),
      Ko = Ma(Xh),
      vf = Qt({}, di, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      Kl = Ma(vf),
      ry = Qt({}, di, {
        clipboardData: function (l) {
          return "clipboardData" in l ? l.clipboardData : window.clipboardData;
        }
      }),
      iy = Ma(ry),
      Kh = Qt({}, di, {
        data: 0
      }),
      Ac = Ma(Kh),
      Tb = Ac,
      jw = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      ay = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
    function oy(l) {
      if (l.key) {
        var u = jw[l.key] || l.key;
        if (u !== "Unidentified") return u;
      }
      if (l.type === "keypress") {
        var v = Ea(l);
        return v === 13 ? "Enter" : String.fromCharCode(v);
      }
      return l.type === "keydown" || l.type === "keyup" ? ay[l.keyCode] || "Unidentified" : "";
    }
    var Ql = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Fw(l) {
      var u = this,
        v = u.nativeEvent;
      if (v.getModifierState) return v.getModifierState(l);
      var _ = Ql[l];
      return _ ? !!v[_] : !1;
    }
    function Zl(l) {
      return Fw;
    }
    var Qh = Qt({}, hr, {
        key: oy,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Zl,
        // Legacy Interface
        charCode: function (l) {
          return l.type === "keypress" ? Ea(l) : 0;
        },
        keyCode: function (l) {
          return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
        },
        which: function (l) {
          return l.type === "keypress" ? Ea(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
        }
      }),
      $n = Ma(Qh),
      Nw = Qt({}, Pc, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }),
      nv = Ma(Nw),
      Rb = Qt({}, hr, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Zl
      }),
      zw = Ma(Rb),
      ly = Qt({}, di, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      sy = Ma(ly),
      Vw = Qt({}, Pc, {
        deltaX: function (l) {
          return "deltaX" in l ? l.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
        },
        deltaY: function (l) {
          return "deltaY" in l ? l.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in l ? -l.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          "wheelDelta" in l ? -l.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }),
      Oi = Ma(Vw),
      Zh = [9, 13, 27, 32],
      Db = 229,
      La = Xe && "CompositionEvent" in window,
      Jl = null;
    Xe && "documentMode" in document && (Jl = document.documentMode);
    var oo = Xe && "TextEvent" in window && !Jl,
      jc = Xe && (!La || Jl && Jl > 8 && Jl <= 11),
      gf = 32,
      yf = String.fromCharCode(gf);
    function Ib() {
      Le("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Le("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Le("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Le("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var dp = !1;
    function Mb(l) {
      return (l.ctrlKey || l.altKey || l.metaKey) &&
      // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(l.ctrlKey && l.altKey);
    }
    function uy(l) {
      switch (l) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function cy(l, u) {
      return l === "keydown" && u.keyCode === Db;
    }
    function Fc(l, u) {
      switch (l) {
        case "keyup":
          return Zh.indexOf(u.keyCode) !== -1;
        case "keydown":
          return u.keyCode !== Db;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function vc(l) {
      var u = l.detail;
      return typeof u == "object" && "data" in u ? u.data : null;
    }
    function Jh(l) {
      return l.locale === "ko";
    }
    var Qs = !1;
    function fp(l, u, v, _, n) {
      var a, f;
      if (La ? a = uy(u) : Qs ? Fc(u, _) && (a = "onCompositionEnd") : cy(u, _) && (a = "onCompositionStart"), !a) return null;
      jc && !Jh(_) && (!Qs && a === "onCompositionStart" ? Qs = Ks(n) : a === "onCompositionEnd" && Qs && (f = So()));
      var m = uS(v, a);
      if (m.length > 0) {
        var b = new Ac(a, u, null, _, n);
        if (l.push({
          event: b,
          listeners: m
        }), f) b.data = f;else {
          var T = vc(_);
          T !== null && (b.data = T);
        }
      }
    }
    function dy(l, u) {
      switch (l) {
        case "compositionend":
          return vc(u);
        case "keypress":
          var v = u.which;
          return v !== gf ? null : (dp = !0, yf);
        case "textInput":
          var _ = u.data;
          return _ === yf && dp ? null : _;
        default:
          return null;
      }
    }
    function em(l, u) {
      if (Qs) {
        if (l === "compositionend" || !La && Fc(l, u)) {
          var v = So();
          return Yh(), Qs = !1, v;
        }
        return null;
      }
      switch (l) {
        case "paste":
          return null;
        case "keypress":
          if (!Mb(u)) {
            if (u.char && u.char.length > 1) return u.char;
            if (u.which) return String.fromCharCode(u.which);
          }
          return null;
        case "compositionend":
          return jc && !Jh(u) ? null : u.data;
        default:
          return null;
      }
    }
    function bf(l, u, v, _, n) {
      var a;
      if (oo ? a = dy(u, _) : a = em(u, _), !a) return null;
      var f = uS(v, "onBeforeInput");
      if (f.length > 0) {
        var m = new Tb("onBeforeInput", "beforeinput", null, _, n);
        l.push({
          event: m,
          listeners: f
        }), m.data = a;
      }
    }
    function tm(l, u, v, _, n, a, f) {
      fp(l, u, v, _, n), bf(l, u, v, _, n);
    }
    var wf = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function rv(l) {
      var u = l && l.nodeName && l.nodeName.toLowerCase();
      return u === "input" ? !!wf[l.type] : u === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Lb(l) {
      if (!Xe) return !1;
      var u = "on" + l,
        v = u in document;
      if (!v) {
        var _ = document.createElement("div");
        _.setAttribute(u, "return;"), v = typeof _[u] == "function";
      }
      return v;
    }
    function _f() {
      Le("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Ob(l, u, v, _) {
      Is(_);
      var n = uS(u, "onChange");
      if (n.length > 0) {
        var a = new ul("onChange", "change", null, v, _);
        l.push({
          event: a,
          listeners: n
        });
      }
    }
    var cl = null,
      gc = null;
    function Zs(l) {
      var u = l.nodeName && l.nodeName.toLowerCase();
      return u === "select" || u === "input" && l.type === "file";
    }
    function r(l) {
      var u = [];
      Ob(u, gc, l, Sh(l)), Mg(o, u);
    }
    function o(l) {
      tD(l, 0);
    }
    function d(l) {
      var u = zc(l);
      if (Rl(u)) return l;
    }
    function g(l, u) {
      if (l === "change") return u;
    }
    var S = !1;
    Xe && (S = Lb("input") && (!document.documentMode || document.documentMode > 9));
    function R(l, u) {
      cl = l, gc = u, cl.attachEvent("onpropertychange", q);
    }
    function A() {
      cl && (cl.detachEvent("onpropertychange", q), cl = null, gc = null);
    }
    function q(l) {
      l.propertyName === "value" && d(gc) && r(l);
    }
    function re(l, u, v) {
      l === "focusin" ? (A(), R(u, v)) : l === "focusout" && A();
    }
    function ye(l, u) {
      if (l === "selectionchange" || l === "keyup" || l === "keydown") return d(gc);
    }
    function Oe(l) {
      var u = l.nodeName;
      return u && u.toLowerCase() === "input" && (l.type === "checkbox" || l.type === "radio");
    }
    function ze(l, u) {
      if (l === "click") return d(u);
    }
    function Me(l, u) {
      if (l === "input" || l === "change") return d(u);
    }
    function et(l) {
      var u = l._wrapperState;
      !u || !u.controlled || l.type !== "number" || wd(l, "number", l.value);
    }
    function it(l, u, v, _, n, a, f) {
      var m = v ? zc(v) : window,
        b,
        T;
      if (Zs(m) ? b = g : rv(m) ? S ? b = Me : (b = ye, T = re) : Oe(m) && (b = ze), b) {
        var M = b(u, v);
        if (M) {
          Ob(l, M, _, n);
          return;
        }
      }
      T && T(u, m, v), u === "focusout" && et(m);
    }
    function lt() {
      Be("onMouseEnter", ["mouseout", "mouseover"]), Be("onMouseLeave", ["mouseout", "mouseover"]), Be("onPointerEnter", ["pointerout", "pointerover"]), Be("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Kn(l, u, v, _, n, a, f) {
      var m = u === "mouseover" || u === "pointerover",
        b = u === "mouseout" || u === "pointerout";
      if (m && !Hu(_)) {
        var T = _.relatedTarget || _.fromElement;
        if (T && (hv(T) || pv(T))) return;
      }
      if (!(!b && !m)) {
        var M;
        if (n.window === n) M = n;else {
          var z = n.ownerDocument;
          z ? M = z.defaultView || z.parentWindow : M = window;
        }
        var U, X;
        if (b) {
          var J = _.relatedTarget || _.toElement;
          if (U = v, X = J ? hv(J) : null, X !== null) {
            var me = li(X);
            (X !== me || X.tag !== D && X.tag !== I) && (X = null);
          }
        } else U = null, X = v;
        if (U !== X) {
          var xe = Gh,
            Ie = "onMouseLeave",
            Pe = "onMouseEnter",
            $e = "mouse";
          (u === "pointerout" || u === "pointerover") && (xe = nv, Ie = "onPointerLeave", Pe = "onPointerEnter", $e = "pointer");
          var mt = U == null ? M : zc(U),
            Te = X == null ? M : zc(X),
            Ue = new xe(Ie, $e + "leave", U, _, n);
          Ue.target = mt, Ue.relatedTarget = Te;
          var Ve = null,
            nt = hv(n);
          if (nt === v) {
            var ke = new xe(Pe, $e + "enter", X, _, n);
            ke.target = Te, ke.relatedTarget = mt, Ve = ke;
          }
          iD(l, Ue, Ve, U, X);
        }
      }
    }
    function pe(l, u) {
      return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
    }
    var oe = typeof Object.is == "function" ? Object.is : pe;
    function he(l, u) {
      if (oe(l, u)) return !0;
      if (typeof l != "object" || l === null || typeof u != "object" || u === null) return !1;
      var v = Object.keys(l),
        _ = Object.keys(u);
      if (v.length !== _.length) return !1;
      for (var n = 0; n < v.length; n++) {
        var a = v[n];
        if (!ge.call(u, a) || !oe(l[a], u[a])) return !1;
      }
      return !0;
    }
    function He(l) {
      for (; l && l.firstChild;) l = l.firstChild;
      return l;
    }
    function ut(l) {
      for (; l;) {
        if (l.nextSibling) return l.nextSibling;
        l = l.parentNode;
      }
    }
    function bt(l, u) {
      for (var v = He(l), _ = 0, n = 0; v;) {
        if (v.nodeType === Xa) {
          if (n = _ + v.textContent.length, _ <= u && n >= u) return {
            node: v,
            offset: u - _
          };
          _ = n;
        }
        v = He(ut(v));
      }
    }
    function wt(l) {
      var u = l.ownerDocument,
        v = u && u.defaultView || window,
        _ = v.getSelection && v.getSelection();
      if (!_ || _.rangeCount === 0) return null;
      var n = _.anchorNode,
        a = _.anchorOffset,
        f = _.focusNode,
        m = _.focusOffset;
      try {
        n.nodeType, f.nodeType;
      } catch {
        return null;
      }
      return It(l, n, a, f, m);
    }
    function It(l, u, v, _, n) {
      var a = 0,
        f = -1,
        m = -1,
        b = 0,
        T = 0,
        M = l,
        z = null;
      e: for (;;) {
        for (var U = null; M === u && (v === 0 || M.nodeType === Xa) && (f = a + v), M === _ && (n === 0 || M.nodeType === Xa) && (m = a + n), M.nodeType === Xa && (a += M.nodeValue.length), (U = M.firstChild) !== null;) z = M, M = U;
        for (;;) {
          if (M === l) break e;
          if (z === u && ++b === v && (f = a), z === _ && ++T === n && (m = a), (U = M.nextSibling) !== null) break;
          M = z, z = M.parentNode;
        }
        M = U;
      }
      return f === -1 || m === -1 ? null : {
        start: f,
        end: m
      };
    }
    function mr(l, u) {
      var v = l.ownerDocument || document,
        _ = v && v.defaultView || window;
      if (_.getSelection) {
        var n = _.getSelection(),
          a = l.textContent.length,
          f = Math.min(u.start, a),
          m = u.end === void 0 ? f : Math.min(u.end, a);
        if (!n.extend && f > m) {
          var b = m;
          m = f, f = b;
        }
        var T = bt(l, f),
          M = bt(l, m);
        if (T && M) {
          if (n.rangeCount === 1 && n.anchorNode === T.node && n.anchorOffset === T.offset && n.focusNode === M.node && n.focusOffset === M.offset) return;
          var z = v.createRange();
          z.setStart(T.node, T.offset), n.removeAllRanges(), f > m ? (n.addRange(z), n.extend(M.node, M.offset)) : (z.setEnd(M.node, M.offset), n.addRange(z));
        }
      }
    }
    function cn(l) {
      return l && l.nodeType === Xa;
    }
    function lo(l, u) {
      return !l || !u ? !1 : l === u ? !0 : cn(l) ? !1 : cn(u) ? lo(l, u.parentNode) : "contains" in l ? l.contains(u) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(u) & 16) : !1;
    }
    function Pb(l) {
      return l && l.ownerDocument && lo(l.ownerDocument.documentElement, l);
    }
    function cO(l) {
      try {
        return typeof l.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function QR() {
      for (var l = window, u = Dl(); u instanceof l.HTMLIFrameElement;) {
        if (cO(u)) l = u.contentWindow;else return u;
        u = Dl(l.document);
      }
      return u;
    }
    function iS(l) {
      var u = l && l.nodeName && l.nodeName.toLowerCase();
      return u && (u === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || u === "textarea" || l.contentEditable === "true");
    }
    function WE() {
      var l = QR();
      return {
        focusedElem: l,
        selectionRange: iS(l) ? fO(l) : null
      };
    }
    function dO(l) {
      var u = QR(),
        v = l.focusedElem,
        _ = l.selectionRange;
      if (u !== v && Pb(v)) {
        _ !== null && iS(v) && pO(v, _);
        for (var n = [], a = v; a = a.parentNode;) a.nodeType === Wr && n.push({
          element: a,
          left: a.scrollLeft,
          top: a.scrollTop
        });
        typeof v.focus == "function" && v.focus();
        for (var f = 0; f < n.length; f++) {
          var m = n[f];
          m.element.scrollLeft = m.left, m.element.scrollTop = m.top;
        }
      }
    }
    function fO(l) {
      var u;
      return "selectionStart" in l ? u = {
        start: l.selectionStart,
        end: l.selectionEnd
      } : u = wt(l), u || {
        start: 0,
        end: 0
      };
    }
    function pO(l, u) {
      var v = u.start,
        _ = u.end;
      _ === void 0 && (_ = v), "selectionStart" in l ? (l.selectionStart = v, l.selectionEnd = Math.min(_, l.value.length)) : mr(l, u);
    }
    var hO = Xe && "documentMode" in document && document.documentMode <= 11;
    function mO() {
      Le("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Ab = null,
      iv = null,
      fy = null,
      py = !1;
    function qE(l) {
      if ("selectionStart" in l && iS(l)) return {
        start: l.selectionStart,
        end: l.selectionEnd
      };
      var u = l.ownerDocument && l.ownerDocument.defaultView || window,
        v = u.getSelection();
      return {
        anchorNode: v.anchorNode,
        anchorOffset: v.anchorOffset,
        focusNode: v.focusNode,
        focusOffset: v.focusOffset
      };
    }
    function vO(l) {
      return l.window === l ? l.document : l.nodeType === Ka ? l : l.ownerDocument;
    }
    function ZR(l, u, v) {
      var _ = vO(v);
      if (!(py || Ab == null || Ab !== Dl(_))) {
        var n = qE(Ab);
        if (!fy || !he(fy, n)) {
          fy = n;
          var a = uS(iv, "onSelect");
          if (a.length > 0) {
            var f = new ul("onSelect", "select", null, u, v);
            l.push({
              event: f,
              listeners: a
            }), f.target = Ab;
          }
        }
      }
    }
    function JR(l, u, v, _, n, a, f) {
      var m = v ? zc(v) : window;
      switch (u) {
        // Track the input node that has focus.
        case "focusin":
          (rv(m) || m.contentEditable === "true") && (Ab = m, iv = v, fy = null);
          break;
        case "focusout":
          Ab = null, iv = null, fy = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          py = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          py = !1, ZR(l, _, n);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (hO) break;
        // falls through
        case "keydown":
        case "keyup":
          ZR(l, _, n);
      }
    }
    function aS(l, u) {
      var v = {};
      return v[l.toLowerCase()] = u.toLowerCase(), v["Webkit" + l] = "webkit" + u, v["Moz" + l] = "moz" + u, v;
    }
    var nm = {
        animationend: aS("Animation", "AnimationEnd"),
        animationiteration: aS("Animation", "AnimationIteration"),
        animationstart: aS("Animation", "AnimationStart"),
        transitionend: aS("Transition", "TransitionEnd")
      },
      av = {},
      oS = {};
    Xe && (oS = document.createElement("div").style, "AnimationEvent" in window || (delete nm.animationend.animation, delete nm.animationiteration.animation, delete nm.animationstart.animation), "TransitionEvent" in window || delete nm.transitionend.transition);
    function Bw(l) {
      if (av[l]) return av[l];
      if (!nm[l]) return l;
      var u = nm[l];
      for (var v in u) if (u.hasOwnProperty(v) && v in oS) return av[l] = u[v];
      return l;
    }
    var Uw = Bw("animationend"),
      YE = Bw("animationiteration"),
      GE = Bw("animationstart"),
      XE = Bw("transitionend"),
      KE = /* @__PURE__ */new Map(),
      QE = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function rm(l, u) {
      KE.set(l, u), Le(u, [l]);
    }
    function ov() {
      for (var l = 0; l < QE.length; l++) {
        var u = QE[l],
          v = u.toLowerCase(),
          _ = u[0].toUpperCase() + u.slice(1);
        rm(v, "on" + _);
      }
      rm(Uw, "onAnimationEnd"), rm(YE, "onAnimationIteration"), rm(GE, "onAnimationStart"), rm("dblclick", "onDoubleClick"), rm("focusin", "onFocus"), rm("focusout", "onBlur"), rm(XE, "onTransitionEnd");
    }
    function gO(l, u, v, _, n, a, f) {
      var m = KE.get(u);
      if (m !== void 0) {
        var b = ul,
          T = u;
        switch (u) {
          case "keypress":
            if (Ea(_) === 0) return;
          /* falls through */
          case "keydown":
          case "keyup":
            b = $n;
            break;
          case "focusin":
            T = "focus", b = Ko;
            break;
          case "focusout":
            T = "blur", b = Ko;
            break;
          case "beforeblur":
          case "afterblur":
            b = Ko;
            break;
          case "click":
            if (_.button === 2) return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            b = Gh;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            b = ny;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            b = zw;
            break;
          case Uw:
          case YE:
          case GE:
            b = Kl;
            break;
          case XE:
            b = sy;
            break;
          case "scroll":
            b = Ca;
            break;
          case "wheel":
            b = Oi;
            break;
          case "copy":
          case "cut":
          case "paste":
            b = iy;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            b = nv;
            break;
        }
        var M = (a & wi) !== 0;
        {
          var z = !M &&
            // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            u === "scroll",
            U = $w(v, m, _.type, M, z);
          if (U.length > 0) {
            var X = new b(m, T, null, _, n);
            l.push({
              event: X,
              listeners: U
            });
          }
        }
      }
    }
    ov(), lt(), _f(), mO(), Ib();
    function yO(l, u, v, _, n, a, f) {
      gO(l, u, v, _, n, a);
      var m = (a & xh) === 0;
      m && (Kn(l, u, v, _, n), it(l, u, v, _, n), JR(l, u, v, _, n), tm(l, u, v, _, n));
    }
    var Hw = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
      hy = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Hw));
    function lS(l, u, v) {
      var _ = l.type || "unknown-event";
      l.currentTarget = v, ma(_, u, void 0, l), l.currentTarget = null;
    }
    function eD(l, u, v) {
      var _;
      if (v) for (var n = u.length - 1; n >= 0; n--) {
        var a = u[n],
          f = a.instance,
          m = a.currentTarget,
          b = a.listener;
        if (f !== _ && l.isPropagationStopped()) return;
        lS(l, b, m), _ = f;
      } else for (var T = 0; T < u.length; T++) {
        var M = u[T],
          z = M.instance,
          U = M.currentTarget,
          X = M.listener;
        if (z !== _ && l.isPropagationStopped()) return;
        lS(l, X, U), _ = z;
      }
    }
    function tD(l, u) {
      for (var v = (u & wi) !== 0, _ = 0; _ < l.length; _++) {
        var n = l[_],
          a = n.event,
          f = n.listeners;
        eD(a, f, v);
      }
      qu();
    }
    function nD(l, u, v, _, n) {
      var a = Sh(v),
        f = [];
      yO(f, l, _, v, a, u), tD(f, u);
    }
    function Ji(l, u) {
      hy.has(l) || h('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', l);
      var v = !1,
        _ = vS(u),
        n = bO(l);
      _.has(n) || (Fb(u, l, Dd, v), _.add(n));
    }
    function Pi(l, u, v) {
      hy.has(l) && !u && h('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', l);
      var _ = 0;
      u && (_ |= wi), Fb(v, l, _, u);
    }
    var jb = "_reactListening" + Math.random().toString(36).slice(2);
    function lv(l) {
      if (!l[jb]) {
        l[jb] = !0, _e.forEach(function (v) {
          v !== "selectionchange" && (hy.has(v) || Pi(v, !1, l), Pi(v, !0, l));
        });
        var u = l.nodeType === Ka ? l : l.ownerDocument;
        u !== null && (u[jb] || (u[jb] = !0, Pi("selectionchange", !1, u)));
      }
    }
    function Fb(l, u, v, _, n) {
      var a = pr(l, u, v),
        f = void 0;
      Wu && (u === "touchstart" || u === "touchmove" || u === "wheel") && (f = !0), l = l, _ ? f !== void 0 ? dc(l, u, a, f) : qh(l, u, a) : f !== void 0 ? ti(l, u, a, f) : Oc(l, u, a);
    }
    function ZE(l, u) {
      return l === u || l.nodeType === er && l.parentNode === u;
    }
    function sS(l, u, v, _, n) {
      var a = _;
      if ((u & _h) === 0 && (u & Dd) === 0) {
        var f = n;
        if (_ !== null) {
          var m = _;
          e: for (;;) {
            if (m === null) return;
            var b = m.tag;
            if (b === C || b === k) {
              var T = m.stateNode.containerInfo;
              if (ZE(T, f)) break;
              if (b === k) for (var M = m.return; M !== null;) {
                var z = M.tag;
                if (z === C || z === k) {
                  var U = M.stateNode.containerInfo;
                  if (ZE(U, f)) return;
                }
                M = M.return;
              }
              for (; T !== null;) {
                var X = hv(T);
                if (X === null) return;
                var J = X.tag;
                if (J === D || J === I) {
                  m = a = X;
                  continue e;
                }
                T = T.parentNode;
              }
            }
            m = m.return;
          }
        }
      }
      Mg(function () {
        return nD(l, u, v, a);
      });
    }
    function my(l, u, v) {
      return {
        instance: l,
        listener: u,
        currentTarget: v
      };
    }
    function $w(l, u, v, _, n, a) {
      for (var f = u !== null ? u + "Capture" : null, m = _ ? f : u, b = [], T = l, M = null; T !== null;) {
        var z = T,
          U = z.stateNode,
          X = z.tag;
        if (X === D && U !== null && (M = U, m !== null)) {
          var J = zo(T, m);
          J != null && b.push(my(T, J, M));
        }
        if (n) break;
        T = T.return;
      }
      return b;
    }
    function uS(l, u) {
      for (var v = u + "Capture", _ = [], n = l; n !== null;) {
        var a = n,
          f = a.stateNode,
          m = a.tag;
        if (m === D && f !== null) {
          var b = f,
            T = zo(n, v);
          T != null && _.unshift(my(n, T, b));
          var M = zo(n, u);
          M != null && _.push(my(n, M, b));
        }
        n = n.return;
      }
      return _;
    }
    function im(l) {
      if (l === null) return null;
      do l = l.return; while (l && l.tag !== D);
      return l || null;
    }
    function Nb(l, u) {
      for (var v = l, _ = u, n = 0, a = v; a; a = im(a)) n++;
      for (var f = 0, m = _; m; m = im(m)) f++;
      for (; n - f > 0;) v = im(v), n--;
      for (; f - n > 0;) _ = im(_), f--;
      for (var b = n; b--;) {
        if (v === _ || _ !== null && v === _.alternate) return v;
        v = im(v), _ = im(_);
      }
      return null;
    }
    function rD(l, u, v, _, n) {
      for (var a = u._reactName, f = [], m = v; m !== null && m !== _;) {
        var b = m,
          T = b.alternate,
          M = b.stateNode,
          z = b.tag;
        if (T !== null && T === _) break;
        if (z === D && M !== null) {
          var U = M;
          if (n) {
            var X = zo(m, a);
            X != null && f.unshift(my(m, X, U));
          } else if (!n) {
            var J = zo(m, a);
            J != null && f.push(my(m, J, U));
          }
        }
        m = m.return;
      }
      f.length !== 0 && l.push({
        event: u,
        listeners: f
      });
    }
    function iD(l, u, v, _, n) {
      var a = _ && n ? Nb(_, n) : null;
      _ !== null && rD(l, u, _, a, !1), n !== null && v !== null && rD(l, v, n, a, !0);
    }
    function bO(l, u) {
      return l + "__bubble";
    }
    var pu = !1,
      dl = "dangerouslySetInnerHTML",
      sv = "suppressContentEditableWarning",
      xf = "suppressHydrationWarning",
      am = "autoFocus",
      uv = "children",
      yc = "style",
      pp = "__html",
      zb,
      Vb,
      cv,
      Bb,
      Ww,
      qw,
      JE;
    zb = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Vb = function (l, u) {
      yh(l, u), Td(l, u), Rg(l, u, {
        registrationNameDependencies: Se,
        possibleRegistrationNames: be
      });
    }, qw = Xe && !document.documentMode, cv = function (l, u, v) {
      if (!pu) {
        var _ = cS(v),
          n = cS(u);
        n !== _ && (pu = !0, h("Prop `%s` did not match. Server: %s Client: %s", l, JSON.stringify(n), JSON.stringify(_)));
      }
    }, Bb = function (l) {
      if (!pu) {
        pu = !0;
        var u = [];
        l.forEach(function (v) {
          u.push(v);
        }), h("Extra attributes from the server: %s", u);
      }
    }, Ww = function (l, u) {
      u === !1 ? h("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", l, l, l) : h("Expected `%s` listener to be a function, instead got a value of `%s` type.", l, typeof u);
    }, JE = function (l, u) {
      var v = l.namespaceURI === Ga ? l.ownerDocument.createElement(l.tagName) : l.ownerDocument.createElementNS(l.namespaceURI, l.tagName);
      return v.innerHTML = u, v.innerHTML;
    };
    var aD = /\r\n?/g,
      wO = /\u0000|\uFFFD/g;
    function cS(l) {
      St(l);
      var u = typeof l == "string" ? l : "" + l;
      return u.replace(aD, `
`).replace(wO, "");
    }
    function vy(l, u, v, _) {
      var n = cS(u),
        a = cS(l);
      if (a !== n && (_ && (pu || (pu = !0, h('Text content did not match. Server: "%s" Client: "%s"', a, n))), v && W)) throw new Error("Text content does not match server-rendered HTML.");
    }
    function Yw(l) {
      return l.nodeType === Ka ? l : l.ownerDocument;
    }
    function oD() {}
    function dS(l) {
      l.onclick = oD;
    }
    function fS(l, u, v, _, n) {
      for (var a in _) if (_.hasOwnProperty(a)) {
        var f = _[a];
        if (a === yc) f && Object.freeze(f), xg(u, f);else if (a === dl) {
          var m = f ? f[pp] : void 0;
          m != null && cg(u, m);
        } else if (a === uv) {
          if (typeof f == "string") {
            var b = l !== "textarea" || f !== "";
            b && ks(u, f);
          } else typeof f == "number" && ks(u, "" + f);
        } else a === sv || a === xf || a === am || (Se.hasOwnProperty(a) ? f != null && (typeof f != "function" && Ww(a, f), a === "onScroll" && Ji("scroll", u)) : f != null && Ha(u, a, f, n));
      }
    }
    function _O(l, u, v, _) {
      for (var n = 0; n < u.length; n += 2) {
        var a = u[n],
          f = u[n + 1];
        a === yc ? xg(l, f) : a === dl ? cg(l, f) : a === uv ? ks(l, f) : Ha(l, a, f, _);
      }
    }
    function xO(l, u, v, _) {
      var n,
        a = Yw(v),
        f,
        m = _;
      if (m === Ga && (m = dh(l)), m === Ga) {
        if (n = Fo(l, u), !n && l !== l.toLowerCase() && h("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", l), l === "script") {
          var b = a.createElement("div");
          b.innerHTML = "<script><\/script>";
          var T = b.firstChild;
          f = b.removeChild(T);
        } else if (typeof u.is == "string") f = a.createElement(l, {
          is: u.is
        });else if (f = a.createElement(l), l === "select") {
          var M = f;
          u.multiple ? M.multiple = !0 : u.size && (M.size = u.size);
        }
      } else f = a.createElementNS(m, l);
      return m === Ga && !n && Object.prototype.toString.call(f) === "[object HTMLUnknownElement]" && !ge.call(zb, l) && (zb[l] = !0, h("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", l)), f;
    }
    function SO(l, u) {
      return Yw(u).createTextNode(l);
    }
    function EO(l, u, v, _) {
      var n = Fo(u, v);
      Vb(u, v);
      var a;
      switch (u) {
        case "dialog":
          Ji("cancel", l), Ji("close", l), a = v;
          break;
        case "iframe":
        case "object":
        case "embed":
          Ji("load", l), a = v;
          break;
        case "video":
        case "audio":
          for (var f = 0; f < Hw.length; f++) Ji(Hw[f], l);
          a = v;
          break;
        case "source":
          Ji("error", l), a = v;
          break;
        case "img":
        case "image":
        case "link":
          Ji("error", l), Ji("load", l), a = v;
          break;
        case "details":
          Ji("toggle", l), a = v;
          break;
        case "input":
          Ya(l, v), a = vd(l, v), Ji("invalid", l);
          break;
        case "option":
          Es(l, v), a = v;
          break;
        case "select":
          xd(l, v), a = oh(l, v), Ji("invalid", l);
          break;
        case "textarea":
          sh(l, v), a = lh(l, v), Ji("invalid", l);
          break;
        default:
          a = v;
      }
      switch (Cd(u, a), fS(u, l, _, a, n), u) {
        case "input":
          jo(l), rh(l, v, !1);
          break;
        case "textarea":
          jo(l), sg(l);
          break;
        case "option":
          mw(l, v);
          break;
        case "select":
          gw(l, v);
          break;
        default:
          typeof a.onClick == "function" && dS(l);
          break;
      }
    }
    function CO(l, u, v, _, n) {
      Vb(u, _);
      var a = null,
        f,
        m;
      switch (u) {
        case "input":
          f = vd(l, v), m = vd(l, _), a = [];
          break;
        case "select":
          f = oh(l, v), m = oh(l, _), a = [];
          break;
        case "textarea":
          f = lh(l, v), m = lh(l, _), a = [];
          break;
        default:
          f = v, m = _, typeof f.onClick != "function" && typeof m.onClick == "function" && dS(l);
          break;
      }
      Cd(u, m);
      var b,
        T,
        M = null;
      for (b in f) if (!(m.hasOwnProperty(b) || !f.hasOwnProperty(b) || f[b] == null)) if (b === yc) {
        var z = f[b];
        for (T in z) z.hasOwnProperty(T) && (M || (M = {}), M[T] = "");
      } else b === dl || b === uv || b === sv || b === xf || b === am || (Se.hasOwnProperty(b) ? a || (a = []) : (a = a || []).push(b, null));
      for (b in m) {
        var U = m[b],
          X = f != null ? f[b] : void 0;
        if (!(!m.hasOwnProperty(b) || U === X || U == null && X == null)) if (b === yc) {
          if (U && Object.freeze(U), X) {
            for (T in X) X.hasOwnProperty(T) && (!U || !U.hasOwnProperty(T)) && (M || (M = {}), M[T] = "");
            for (T in U) U.hasOwnProperty(T) && X[T] !== U[T] && (M || (M = {}), M[T] = U[T]);
          } else M || (a || (a = []), a.push(b, M)), M = U;
        } else if (b === dl) {
          var J = U ? U[pp] : void 0,
            me = X ? X[pp] : void 0;
          J != null && me !== J && (a = a || []).push(b, J);
        } else b === uv ? (typeof U == "string" || typeof U == "number") && (a = a || []).push(b, "" + U) : b === sv || b === xf || (Se.hasOwnProperty(b) ? (U != null && (typeof U != "function" && Ww(b, U), b === "onScroll" && Ji("scroll", l)), !a && X !== U && (a = [])) : (a = a || []).push(b, U));
      }
      return M && (kw(M, m[yc]), (a = a || []).push(yc, M)), a;
    }
    function kO(l, u, v, _, n) {
      v === "input" && n.type === "radio" && n.name != null && gd(l, n);
      var a = Fo(v, _),
        f = Fo(v, n);
      switch (_O(l, u, a, f), v) {
        case "input":
          Ss(l, n);
          break;
        case "textarea":
          lg(l, n);
          break;
        case "select":
          yw(l, n);
          break;
      }
    }
    function TO(l) {
      {
        var u = l.toLowerCase();
        return Bu.hasOwnProperty(u) && Bu[u] || null;
      }
    }
    function RO(l, u, v, _, n, a, f) {
      var m, b;
      switch (m = Fo(u, v), Vb(u, v), u) {
        case "dialog":
          Ji("cancel", l), Ji("close", l);
          break;
        case "iframe":
        case "object":
        case "embed":
          Ji("load", l);
          break;
        case "video":
        case "audio":
          for (var T = 0; T < Hw.length; T++) Ji(Hw[T], l);
          break;
        case "source":
          Ji("error", l);
          break;
        case "img":
        case "image":
        case "link":
          Ji("error", l), Ji("load", l);
          break;
        case "details":
          Ji("toggle", l);
          break;
        case "input":
          Ya(l, v), Ji("invalid", l);
          break;
        case "option":
          Es(l, v);
          break;
        case "select":
          xd(l, v), Ji("invalid", l);
          break;
        case "textarea":
          sh(l, v), Ji("invalid", l);
          break;
      }
      Cd(u, v);
      {
        b = /* @__PURE__ */new Set();
        for (var M = l.attributes, z = 0; z < M.length; z++) {
          var U = M[z].name.toLowerCase();
          switch (U) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              b.add(M[z].name);
          }
        }
      }
      var X = null;
      for (var J in v) if (v.hasOwnProperty(J)) {
        var me = v[J];
        if (J === uv) typeof me == "string" ? l.textContent !== me && (v[xf] !== !0 && vy(l.textContent, me, a, f), X = [uv, me]) : typeof me == "number" && l.textContent !== "" + me && (v[xf] !== !0 && vy(l.textContent, me, a, f), X = [uv, "" + me]);else if (Se.hasOwnProperty(J)) me != null && (typeof me != "function" && Ww(J, me), J === "onScroll" && Ji("scroll", l));else if (f &&
        // Convince Flow we've calculated it (it's DEV-only in this method.)
        typeof m == "boolean") {
          var xe = void 0,
            Ie = Ht(J);
          if (v[xf] !== !0 && !(J === sv || J === xf ||
          // Controlled attributes are not validated
          // TODO: Only ignore them on controlled tags.
          J === "value" || J === "checked" || J === "selected")) {
            if (J === dl) {
              var Pe = l.innerHTML,
                $e = me ? me[pp] : void 0;
              if ($e != null) {
                var mt = JE(l, $e);
                mt !== Pe && cv(J, Pe, mt);
              }
            } else if (J === yc) {
              if (b.delete(J), qw) {
                var Te = Ew(me);
                xe = l.getAttribute("style"), Te !== xe && cv(J, xe, Te);
              }
            } else if (m) b.delete(J.toLowerCase()), xe = Tu(l, J, me), me !== xe && cv(J, xe, me);else if (!at(J, Ie, m) && !Bt(J, me, Ie, m)) {
              var Ue = !1;
              if (Ie !== null) b.delete(Ie.attributeName), xe = bo(l, J, me, Ie);else {
                var Ve = _;
                if (Ve === Ga && (Ve = dh(u)), Ve === Ga) b.delete(J.toLowerCase());else {
                  var nt = TO(J);
                  nt !== null && nt !== J && (Ue = !0, b.delete(nt)), b.delete(J);
                }
                xe = Tu(l, J, me);
              }
              var ke = se;
              !ke && me !== xe && !Ue && cv(J, xe, me);
            }
          }
        }
      }
      switch (f &&
      // $FlowFixMe - Should be inferred as not undefined.
      b.size > 0 && v[xf] !== !0 && Bb(b), u) {
        case "input":
          jo(l), rh(l, v, !0);
          break;
        case "textarea":
          jo(l), sg(l);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof v.onClick == "function" && dS(l);
          break;
      }
      return X;
    }
    function DO(l, u, v) {
      var _ = l.nodeValue !== u;
      return _;
    }
    function eC(l, u) {
      {
        if (pu) return;
        pu = !0, h("Did not expect server HTML to contain a <%s> in <%s>.", u.nodeName.toLowerCase(), l.nodeName.toLowerCase());
      }
    }
    function Gw(l, u) {
      {
        if (pu) return;
        pu = !0, h('Did not expect server HTML to contain the text node "%s" in <%s>.', u.nodeValue, l.nodeName.toLowerCase());
      }
    }
    function Xw(l, u, v) {
      {
        if (pu) return;
        pu = !0, h("Expected server HTML to contain a matching <%s> in <%s>.", u, l.nodeName.toLowerCase());
      }
    }
    function Kw(l, u) {
      {
        if (u === "" || pu) return;
        pu = !0, h('Expected server HTML to contain a matching text node for "%s" in <%s>.', u, l.nodeName.toLowerCase());
      }
    }
    function tC(l, u, v) {
      switch (u) {
        case "input":
          yd(l, v);
          return;
        case "textarea":
          ww(l, v);
          return;
        case "select":
          bw(l, v);
          return;
      }
    }
    var Qw = function () {},
      om = function () {};
    {
      var Zw = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"],
        lD = ["applet", "caption", "html", "table", "td", "th", "marquee", "object", "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject", "desc", "title"],
        sD = lD.concat(["button"]),
        IO = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
        uD = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
      om = function (l, u) {
        var v = Qt({}, l || uD),
          _ = {
            tag: u
          };
        return lD.indexOf(u) !== -1 && (v.aTagInScope = null, v.buttonTagInScope = null, v.nobrTagInScope = null), sD.indexOf(u) !== -1 && (v.pTagInButtonScope = null), Zw.indexOf(u) !== -1 && u !== "address" && u !== "div" && u !== "p" && (v.listItemTagAutoclosing = null, v.dlItemTagAutoclosing = null), v.current = _, u === "form" && (v.formTag = _), u === "a" && (v.aTagInScope = _), u === "button" && (v.buttonTagInScope = _), u === "nobr" && (v.nobrTagInScope = _), u === "p" && (v.pTagInButtonScope = _), u === "li" && (v.listItemTagAutoclosing = _), (u === "dd" || u === "dt") && (v.dlItemTagAutoclosing = _), v;
      };
      var cD = function (l, u) {
          switch (u) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return l === "option" || l === "optgroup" || l === "#text";
            case "optgroup":
              return l === "option" || l === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return l === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return l === "th" || l === "td" || l === "style" || l === "script" || l === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return l === "tr" || l === "style" || l === "script" || l === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return l === "col" || l === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return l === "caption" || l === "colgroup" || l === "tbody" || l === "tfoot" || l === "thead" || l === "style" || l === "script" || l === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return l === "base" || l === "basefont" || l === "bgsound" || l === "link" || l === "meta" || l === "title" || l === "noscript" || l === "noframes" || l === "style" || l === "script" || l === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return l === "head" || l === "body" || l === "frameset";
            case "frameset":
              return l === "frame";
            case "#document":
              return l === "html";
          }
          switch (l) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return u !== "h1" && u !== "h2" && u !== "h3" && u !== "h4" && u !== "h5" && u !== "h6";
            case "rp":
            case "rt":
              return IO.indexOf(u) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return u == null;
          }
          return !0;
        },
        MO = function (l, u) {
          switch (l) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return u.pTagInButtonScope;
            case "form":
              return u.formTag || u.pTagInButtonScope;
            case "li":
              return u.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return u.dlItemTagAutoclosing;
            case "button":
              return u.buttonTagInScope;
            case "a":
              return u.aTagInScope;
            case "nobr":
              return u.nobrTagInScope;
          }
          return null;
        },
        dD = {};
      Qw = function (l, u, v) {
        v = v || uD;
        var _ = v.current,
          n = _ && _.tag;
        u != null && (l != null && h("validateDOMNesting: when childText is passed, childTag should be null"), l = "#text");
        var a = cD(l, n) ? null : _,
          f = a ? null : MO(l, v),
          m = a || f;
        if (m) {
          var b = m.tag,
            T = !!a + "|" + l + "|" + b;
          if (!dD[T]) {
            dD[T] = !0;
            var M = l,
              z = "";
            if (l === "#text" ? /\S/.test(u) ? M = "Text nodes" : (M = "Whitespace text nodes", z = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : M = "<" + l + ">", a) {
              var U = "";
              b === "table" && l === "tr" && (U += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), h("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", M, b, z, U);
            } else h("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", M, b);
          }
        }
      };
    }
    var Jw = "suppressHydrationWarning",
      gy = "$",
      yy = "/$",
      dv = "$?",
      lm = "$!",
      e_ = "style",
      nC = null,
      t_ = null;
    function rC(l) {
      var u,
        v,
        _ = l.nodeType;
      switch (_) {
        case Ka:
        case ph:
          {
            u = _ === Ka ? "#document" : "#fragment";
            var n = l.documentElement;
            v = n ? n.namespaceURI : fh(null, "");
            break;
          }
        default:
          {
            var a = _ === er ? l.parentNode : l,
              f = a.namespaceURI || null;
            u = a.tagName, v = fh(f, u);
            break;
          }
      }
      {
        var m = u.toLowerCase(),
          b = om(null, m);
        return {
          namespace: v,
          ancestorInfo: b
        };
      }
    }
    function LO(l, u, v) {
      {
        var _ = l,
          n = fh(_.namespace, u),
          a = om(_.ancestorInfo, u);
        return {
          namespace: n,
          ancestorInfo: a
        };
      }
    }
    function OO(l) {
      nC = on(), t_ = WE();
      var u = null;
      return ii(!1), u;
    }
    function $z(l) {
      dO(t_), ii(nC), nC = null, t_ = null;
    }
    function PO(l, u, v, _, n) {
      var a;
      {
        var f = _;
        if (Qw(l, null, f.ancestorInfo), typeof u.children == "string" || typeof u.children == "number") {
          var m = "" + u.children,
            b = om(f.ancestorInfo, l);
          Qw(null, m, b);
        }
        a = f.namespace;
      }
      var T = xO(l, u, v, a);
      return l_(n, T), mv(T, u), T;
    }
    function AO(l, u) {
      l.appendChild(u);
    }
    function jO(l, u, v, _, n) {
      switch (EO(l, u, v, _), u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!v.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function FO(l, u, v, _, n, a) {
      {
        var f = a;
        if (typeof _.children != typeof v.children && (typeof _.children == "string" || typeof _.children == "number")) {
          var m = "" + _.children,
            b = om(f.ancestorInfo, u);
          Qw(null, m, b);
        }
      }
      return CO(l, u, v, _);
    }
    function iC(l, u) {
      return l === "textarea" || l === "noscript" || typeof u.children == "string" || typeof u.children == "number" || typeof u.dangerouslySetInnerHTML == "object" && u.dangerouslySetInnerHTML !== null && u.dangerouslySetInnerHTML.__html != null;
    }
    function NO(l, u, v, _) {
      {
        var n = v;
        Qw(null, l, n.ancestorInfo);
      }
      var a = SO(l, u);
      return l_(_, a), a;
    }
    function aC() {
      var l = window.event;
      return l === void 0 ? Zi : xo(l.type);
    }
    var oC = typeof setTimeout == "function" ? setTimeout : void 0,
      zO = typeof clearTimeout == "function" ? clearTimeout : void 0,
      n_ = -1,
      fD = typeof Promise == "function" ? Promise : void 0,
      lC = typeof queueMicrotask == "function" ? queueMicrotask : typeof fD < "u" ? function (l) {
        return fD.resolve(null).then(l).catch(pD);
      } : oC;
    function pD(l) {
      setTimeout(function () {
        throw l;
      });
    }
    function VO(l, u, v, _) {
      switch (u) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          v.autoFocus && l.focus();
          return;
        case "img":
          {
            v.src && (l.src = v.src);
            return;
          }
      }
    }
    function BO(l, u, v, _, n, a) {
      kO(l, u, v, _, n), mv(l, n);
    }
    function hD(l) {
      ks(l, "");
    }
    function UO(l, u, v) {
      l.nodeValue = v;
    }
    function mD(l, u) {
      l.appendChild(u);
    }
    function HO(l, u) {
      var v;
      l.nodeType === er ? (v = l.parentNode, v.insertBefore(u, l)) : (v = l, v.appendChild(u));
      var _ = l._reactRootContainer;
      _ == null && v.onclick === null && dS(v);
    }
    function $O(l, u, v) {
      l.insertBefore(u, v);
    }
    function WO(l, u, v) {
      l.nodeType === er ? l.parentNode.insertBefore(u, v) : l.insertBefore(u, v);
    }
    function qO(l, u) {
      l.removeChild(u);
    }
    function YO(l, u) {
      l.nodeType === er ? l.parentNode.removeChild(u) : l.removeChild(u);
    }
    function sC(l, u) {
      var v = u,
        _ = 0;
      do {
        var n = v.nextSibling;
        if (l.removeChild(v), n && n.nodeType === er) {
          var a = n.data;
          if (a === yy) {
            if (_ === 0) {
              l.removeChild(n), cc(u);
              return;
            } else _--;
          } else (a === gy || a === dv || a === lm) && _++;
        }
        v = n;
      } while (v);
      cc(u);
    }
    function GO(l, u) {
      l.nodeType === er ? sC(l.parentNode, u) : l.nodeType === Wr && sC(l, u), cc(l);
    }
    function uC(l) {
      l = l;
      var u = l.style;
      typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none";
    }
    function XO(l) {
      l.nodeValue = "";
    }
    function KO(l, u) {
      l = l;
      var v = u[e_],
        _ = v != null && v.hasOwnProperty("display") ? v.display : null;
      l.style.display = Ed("display", _);
    }
    function QO(l, u) {
      l.nodeValue = u;
    }
    function ZO(l) {
      l.nodeType === Wr ? l.textContent = "" : l.nodeType === Ka && l.documentElement && l.removeChild(l.documentElement);
    }
    function JO(l, u, v) {
      return l.nodeType !== Wr || u.toLowerCase() !== l.nodeName.toLowerCase() ? null : l;
    }
    function eP(l, u) {
      return u === "" || l.nodeType !== Xa ? null : l;
    }
    function tP(l) {
      return l.nodeType !== er ? null : l;
    }
    function vD(l) {
      return l.data === dv;
    }
    function cC(l) {
      return l.data === lm;
    }
    function gD(l) {
      var u = l.nextSibling && l.nextSibling.dataset,
        v,
        _,
        n;
      return u && (v = u.dgst, _ = u.msg, n = u.stck), {
        message: _,
        digest: v,
        stack: n
      };
    }
    function dC(l, u) {
      l._reactRetry = u;
    }
    function pS(l) {
      for (; l != null; l = l.nextSibling) {
        var u = l.nodeType;
        if (u === Wr || u === Xa) break;
        if (u === er) {
          var v = l.data;
          if (v === gy || v === lm || v === dv) break;
          if (v === yy) return null;
        }
      }
      return l;
    }
    function r_(l) {
      return pS(l.nextSibling);
    }
    function hS(l) {
      return pS(l.firstChild);
    }
    function i_(l) {
      return pS(l.firstChild);
    }
    function nP(l) {
      return pS(l.nextSibling);
    }
    function rP(l, u, v, _, n, a, f) {
      l_(a, l), mv(l, v);
      var m;
      {
        var b = n;
        m = b.namespace;
      }
      var T = (a.mode & Wt) !== dt;
      return RO(l, u, v, m, _, T, f);
    }
    function iP(l, u, v, _) {
      return l_(v, l), v.mode & Wt, DO(l, u);
    }
    function aP(l, u) {
      l_(u, l);
    }
    function oP(l) {
      for (var u = l.nextSibling, v = 0; u;) {
        if (u.nodeType === er) {
          var _ = u.data;
          if (_ === yy) {
            if (v === 0) return r_(u);
            v--;
          } else (_ === gy || _ === lm || _ === dv) && v++;
        }
        u = u.nextSibling;
      }
      return null;
    }
    function yD(l) {
      for (var u = l.previousSibling, v = 0; u;) {
        if (u.nodeType === er) {
          var _ = u.data;
          if (_ === gy || _ === lm || _ === dv) {
            if (v === 0) return u;
            v--;
          } else _ === yy && v++;
        }
        u = u.previousSibling;
      }
      return null;
    }
    function lP(l) {
      cc(l);
    }
    function bD(l) {
      cc(l);
    }
    function sP(l) {
      return l !== "head" && l !== "body";
    }
    function uP(l, u, v, _) {
      var n = !0;
      vy(u.nodeValue, v, _, n);
    }
    function cP(l, u, v, _, n, a) {
      if (u[Jw] !== !0) {
        var f = !0;
        vy(_.nodeValue, n, a, f);
      }
    }
    function dP(l, u) {
      u.nodeType === Wr ? eC(l, u) : u.nodeType === er || Gw(l, u);
    }
    function fP(l, u) {
      {
        var v = l.parentNode;
        v !== null && (u.nodeType === Wr ? eC(v, u) : u.nodeType === er || Gw(v, u));
      }
    }
    function pP(l, u, v, _, n) {
      (n || u[Jw] !== !0) && (_.nodeType === Wr ? eC(v, _) : _.nodeType === er || Gw(v, _));
    }
    function hP(l, u, v) {
      Xw(l, u);
    }
    function mP(l, u) {
      Kw(l, u);
    }
    function vP(l, u, v) {
      {
        var _ = l.parentNode;
        _ !== null && Xw(_, u);
      }
    }
    function gP(l, u) {
      {
        var v = l.parentNode;
        v !== null && Kw(v, u);
      }
    }
    function yP(l, u, v, _, n, a) {
      (a || u[Jw] !== !0) && Xw(v, _);
    }
    function bP(l, u, v, _, n) {
      (n || u[Jw] !== !0) && Kw(v, _);
    }
    function wP(l) {
      h("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", l.nodeName.toLowerCase());
    }
    function _P(l) {
      lv(l);
    }
    var Ub = Math.random().toString(36).slice(2),
      Hb = "__reactFiber$" + Ub,
      fv = "__reactProps$" + Ub,
      hp = "__reactContainer$" + Ub,
      a_ = "__reactEvents$" + Ub,
      o_ = "__reactListeners$" + Ub,
      fC = "__reactHandles$" + Ub;
    function xP(l) {
      delete l[Hb], delete l[fv], delete l[a_], delete l[o_], delete l[fC];
    }
    function l_(l, u) {
      u[Hb] = l;
    }
    function mS(l, u) {
      u[hp] = l;
    }
    function $b(l) {
      l[hp] = null;
    }
    function pv(l) {
      return !!l[hp];
    }
    function hv(l) {
      var u = l[Hb];
      if (u) return u;
      for (var v = l.parentNode; v;) {
        if (u = v[hp] || v[Hb], u) {
          var _ = u.alternate;
          if (u.child !== null || _ !== null && _.child !== null) for (var n = yD(l); n !== null;) {
            var a = n[Hb];
            if (a) return a;
            n = yD(n);
          }
          return u;
        }
        l = v, v = l.parentNode;
      }
      return null;
    }
    function Nc(l) {
      var u = l[Hb] || l[hp];
      return u && (u.tag === D || u.tag === I || u.tag === V || u.tag === C) ? u : null;
    }
    function zc(l) {
      if (l.tag === D || l.tag === I) return l.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Sf(l) {
      return l[fv] || null;
    }
    function mv(l, u) {
      l[fv] = u;
    }
    function vS(l) {
      var u = l[a_];
      return u === void 0 && (u = l[a_] = /* @__PURE__ */new Set()), u;
    }
    var gS = {},
      wD = i.ReactDebugCurrentFrame;
    function s_(l) {
      if (l) {
        var u = l._owner,
          v = Tl(l.type, l._source, u ? u.type : null);
        wD.setExtraStackFrame(v);
      } else wD.setExtraStackFrame(null);
    }
    function Vc(l, u, v, _, n) {
      {
        var a = Function.call.bind(ge);
        for (var f in l) if (a(l, f)) {
          var m = void 0;
          try {
            if (typeof l[f] != "function") {
              var b = Error((_ || "React class") + ": " + v + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw b.name = "Invariant Violation", b;
            }
            m = l[f](u, f, _, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (T) {
            m = T;
          }
          m && !(m instanceof Error) && (s_(n), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", v, f, typeof m), s_(null)), m instanceof Error && !(m.message in gS) && (gS[m.message] = !0, s_(n), h("Failed %s type: %s", v, m.message), s_(null));
        }
      }
    }
    var Wb = [],
      hu;
    hu = [];
    var Ef = -1;
    function Cf(l) {
      return {
        current: l
      };
    }
    function ca(l, u) {
      if (Ef < 0) {
        h("Unexpected pop.");
        return;
      }
      u !== hu[Ef] && h("Unexpected Fiber popped."), l.current = Wb[Ef], Wb[Ef] = null, hu[Ef] = null, Ef--;
    }
    function ka(l, u, v) {
      Ef++, Wb[Ef] = l.current, hu[Ef] = v, l.current = u;
    }
    var fl;
    fl = {};
    var fi = {};
    Object.freeze(fi);
    var kf = Cf(fi),
      Oa = Cf(!1),
      Tf = fi;
    function Js(l, u, v) {
      return v && eu(u) ? Tf : kf.current;
    }
    function yS(l, u, v) {
      {
        var _ = l.stateNode;
        _.__reactInternalMemoizedUnmaskedChildContext = u, _.__reactInternalMemoizedMaskedChildContext = v;
      }
    }
    function Rf(l, u) {
      {
        var v = l.type,
          _ = v.contextTypes;
        if (!_) return fi;
        var n = l.stateNode;
        if (n && n.__reactInternalMemoizedUnmaskedChildContext === u) return n.__reactInternalMemoizedMaskedChildContext;
        var a = {};
        for (var f in _) a[f] = u[f];
        {
          var m = At(l) || "Unknown";
          Vc(_, a, "context", m);
        }
        return n && yS(l, u, a), a;
      }
    }
    function u_() {
      return Oa.current;
    }
    function eu(l) {
      {
        var u = l.childContextTypes;
        return u != null;
      }
    }
    function by(l) {
      ca(Oa, l), ca(kf, l);
    }
    function Bc(l) {
      ca(Oa, l), ca(kf, l);
    }
    function c_(l, u, v) {
      {
        if (kf.current !== fi) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ka(kf, u, l), ka(Oa, v, l);
      }
    }
    function bS(l, u, v) {
      {
        var _ = l.stateNode,
          n = u.childContextTypes;
        if (typeof _.getChildContext != "function") {
          {
            var a = At(l) || "Unknown";
            fl[a] || (fl[a] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", a, a));
          }
          return v;
        }
        var f = _.getChildContext();
        for (var m in f) if (!(m in n)) throw new Error((At(l) || "Unknown") + '.getChildContext(): key "' + m + '" is not defined in childContextTypes.');
        {
          var b = At(l) || "Unknown";
          Vc(n, f, "child context", b);
        }
        return Qt({}, v, f);
      }
    }
    function d_(l) {
      {
        var u = l.stateNode,
          v = u && u.__reactInternalMemoizedMergedChildContext || fi;
        return Tf = kf.current, ka(kf, v, l), ka(Oa, Oa.current, l), !0;
      }
    }
    function pC(l, u, v) {
      {
        var _ = l.stateNode;
        if (!_) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (v) {
          var n = bS(l, u, Tf);
          _.__reactInternalMemoizedMergedChildContext = n, ca(Oa, l), ca(kf, l), ka(kf, n, l), ka(Oa, v, l);
        } else ca(Oa, l), ka(Oa, v, l);
      }
    }
    function wS(l) {
      {
        if (!Nl(l) || l.tag !== x) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var u = l;
        do {
          switch (u.tag) {
            case C:
              return u.stateNode.context;
            case x:
              {
                var v = u.type;
                if (eu(v)) return u.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
          }
          u = u.return;
        } while (u !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var sm = 0,
      _S = 1,
      fs = null,
      qb = !1,
      Df = !1;
    function xS(l) {
      fs === null ? fs = [l] : fs.push(l);
    }
    function hC(l) {
      qb = !0, xS(l);
    }
    function mC() {
      qb && vv();
    }
    function vv() {
      if (!Df && fs !== null) {
        Df = !0;
        var l = 0,
          u = Ir();
        try {
          var v = !0,
            _ = fs;
          for (zr(al); l < _.length; l++) {
            var n = _[l];
            do n = n(v); while (n !== null);
          }
          fs = null, qb = !1;
        } catch (a) {
          throw fs !== null && (fs = fs.slice(l + 1)), Ch(Xu, vv), a;
        } finally {
          zr(u), Df = !1;
        }
      }
      return null;
    }
    var wy = [],
      bc = 0,
      um = null,
      cm = 0,
      tu = [],
      nu = 0,
      pl = null,
      Co = 1,
      ru = "";
    function dm(l) {
      return xy(), (l.flags & va) !== pt;
    }
    function fm(l) {
      return xy(), cm;
    }
    function SP() {
      var l = ru,
        u = Co,
        v = u & ~vC(u);
      return v.toString(32) + l;
    }
    function _y(l, u) {
      xy(), wy[bc++] = cm, wy[bc++] = um, um = l, cm = u;
    }
    function _D(l, u, v) {
      xy(), tu[nu++] = Co, tu[nu++] = ru, tu[nu++] = pl, pl = l;
      var _ = Co,
        n = ru,
        a = f_(_) - 1,
        f = _ & ~(1 << a),
        m = v + 1,
        b = f_(u) + a;
      if (b > 30) {
        var T = a - a % 5,
          M = (1 << T) - 1,
          z = (f & M).toString(32),
          U = f >> T,
          X = a - T,
          J = f_(u) + X,
          me = m << X,
          xe = me | U,
          Ie = z + n;
        Co = 1 << J | xe, ru = Ie;
      } else {
        var Pe = m << a,
          $e = Pe | f,
          mt = n;
        Co = 1 << b | $e, ru = mt;
      }
    }
    function pm(l) {
      xy();
      var u = l.return;
      if (u !== null) {
        var v = 1,
          _ = 0;
        _y(l, v), _D(l, v, _);
      }
    }
    function f_(l) {
      return 32 - Mn(l);
    }
    function vC(l) {
      return 1 << f_(l) - 1;
    }
    function Yb(l) {
      for (; l === um;) um = wy[--bc], wy[bc] = null, cm = wy[--bc], wy[bc] = null;
      for (; l === pl;) pl = tu[--nu], tu[nu] = null, ru = tu[--nu], tu[nu] = null, Co = tu[--nu], tu[nu] = null;
    }
    function EP() {
      return xy(), pl !== null ? {
        id: Co,
        overflow: ru
      } : null;
    }
    function gC(l, u) {
      xy(), tu[nu++] = Co, tu[nu++] = ru, tu[nu++] = pl, Co = u.id, ru = u.overflow, pl = l;
    }
    function xy() {
      Pa() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var es = null,
      hl = null,
      Ai = !1,
      ml = !1,
      vl = null;
    function Sy() {
      Ai && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function hm() {
      ml = !0;
    }
    function CP() {
      return ml;
    }
    function xD(l) {
      var u = l.stateNode.containerInfo;
      return hl = i_(u), es = l, Ai = !0, vl = null, ml = !1, !0;
    }
    function kP(l, u, v) {
      return hl = nP(u), es = l, Ai = !0, vl = null, ml = !1, v !== null && gC(l, v), !0;
    }
    function SD(l, u) {
      switch (l.tag) {
        case C:
          {
            dP(l.stateNode.containerInfo, u);
            break;
          }
        case D:
          {
            var v = (l.mode & Wt) !== dt;
            pP(l.type, l.memoizedProps, l.stateNode, u,
            // TODO: Delete this argument when we remove the legacy root API.
            v);
            break;
          }
        case V:
          {
            var _ = l.memoizedState;
            _.dehydrated !== null && fP(_.dehydrated, u);
            break;
          }
      }
    }
    function ED(l, u) {
      SD(l, u);
      var v = VA();
      v.stateNode = u, v.return = l;
      var _ = l.deletions;
      _ === null ? (l.deletions = [v], l.flags |= _i) : _.push(v);
    }
    function SS(l, u) {
      {
        if (ml) return;
        switch (l.tag) {
          case C:
            {
              var v = l.stateNode.containerInfo;
              switch (u.tag) {
                case D:
                  var _ = u.type;
                  u.pendingProps, hP(v, _);
                  break;
                case I:
                  var n = u.pendingProps;
                  mP(v, n);
                  break;
              }
              break;
            }
          case D:
            {
              var a = l.type,
                f = l.memoizedProps,
                m = l.stateNode;
              switch (u.tag) {
                case D:
                  {
                    var b = u.type,
                      T = u.pendingProps,
                      M = (l.mode & Wt) !== dt;
                    yP(a, f, m, b, T,
                    // TODO: Delete this argument when we remove the legacy root API.
                    M);
                    break;
                  }
                case I:
                  {
                    var z = u.pendingProps,
                      U = (l.mode & Wt) !== dt;
                    bP(a, f, m, z,
                    // TODO: Delete this argument when we remove the legacy root API.
                    U);
                    break;
                  }
              }
              break;
            }
          case V:
            {
              var X = l.memoizedState,
                J = X.dehydrated;
              if (J !== null) switch (u.tag) {
                case D:
                  var me = u.type;
                  u.pendingProps, vP(J, me);
                  break;
                case I:
                  var xe = u.pendingProps;
                  gP(J, xe);
                  break;
              }
              break;
            }
          default:
            return;
        }
      }
    }
    function yC(l, u) {
      u.flags = u.flags & -4097 | Gn, SS(l, u);
    }
    function ES(l, u) {
      switch (l.tag) {
        case D:
          {
            var v = l.type;
            l.pendingProps;
            var _ = JO(u, v);
            return _ !== null ? (l.stateNode = _, es = l, hl = hS(_), !0) : !1;
          }
        case I:
          {
            var n = l.pendingProps,
              a = eP(u, n);
            return a !== null ? (l.stateNode = a, es = l, hl = null, !0) : !1;
          }
        case V:
          {
            var f = tP(u);
            if (f !== null) {
              var m = {
                dehydrated: f,
                treeContext: EP(),
                retryLane: Jr
              };
              l.memoizedState = m;
              var b = BA(f);
              return b.return = l, l.child = b, es = l, hl = null, !0;
            }
            return !1;
          }
        default:
          return !1;
      }
    }
    function CS(l) {
      return (l.mode & Wt) !== dt && (l.flags & ft) === pt;
    }
    function kS(l) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function p_(l) {
      if (Ai) {
        var u = hl;
        if (!u) {
          CS(l) && (SS(es, l), kS()), yC(es, l), Ai = !1, es = l;
          return;
        }
        var v = u;
        if (!ES(l, u)) {
          CS(l) && (SS(es, l), kS()), u = r_(v);
          var _ = es;
          if (!u || !ES(l, u)) {
            yC(es, l), Ai = !1, es = l;
            return;
          }
          ED(_, v);
        }
      }
    }
    function bC(l, u, v) {
      var _ = l.stateNode,
        n = !ml,
        a = rP(_, l.type, l.memoizedProps, u, v, l, n);
      return l.updateQueue = a, a !== null;
    }
    function wC(l) {
      var u = l.stateNode,
        v = l.memoizedProps,
        _ = iP(u, v, l);
      if (_) {
        var n = es;
        if (n !== null) switch (n.tag) {
          case C:
            {
              var a = n.stateNode.containerInfo,
                f = (n.mode & Wt) !== dt;
              uP(a, u, v,
              // TODO: Delete this argument when we remove the legacy root API.
              f);
              break;
            }
          case D:
            {
              var m = n.type,
                b = n.memoizedProps,
                T = n.stateNode,
                M = (n.mode & Wt) !== dt;
              cP(m, b, T, u, v,
              // TODO: Delete this argument when we remove the legacy root API.
              M);
              break;
            }
        }
      }
      return _;
    }
    function TP(l) {
      var u = l.memoizedState,
        v = u !== null ? u.dehydrated : null;
      if (!v) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      aP(v, l);
    }
    function RP(l) {
      var u = l.memoizedState,
        v = u !== null ? u.dehydrated : null;
      if (!v) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return oP(v);
    }
    function CD(l) {
      for (var u = l.return; u !== null && u.tag !== D && u.tag !== C && u.tag !== V;) u = u.return;
      es = u;
    }
    function TS(l) {
      if (l !== es) return !1;
      if (!Ai) return CD(l), Ai = !0, !1;
      if (l.tag !== C && (l.tag !== D || sP(l.type) && !iC(l.type, l.memoizedProps))) {
        var u = hl;
        if (u) if (CS(l)) h_(l), kS();else for (; u;) ED(l, u), u = r_(u);
      }
      return CD(l), l.tag === V ? hl = RP(l) : hl = es ? r_(l.stateNode) : null, !0;
    }
    function kD() {
      return Ai && hl !== null;
    }
    function h_(l) {
      for (var u = hl; u;) SD(l, u), u = r_(u);
    }
    function Gb() {
      es = null, hl = null, Ai = !1, ml = !1;
    }
    function _C() {
      vl !== null && (_I(vl), vl = null);
    }
    function Pa() {
      return Ai;
    }
    function RS(l) {
      vl === null ? vl = [l] : vl.push(l);
    }
    var ts = i.ReactCurrentBatchConfig,
      xC = null;
    function DP() {
      return ts.transition;
    }
    var If = {
      recordUnsafeLifecycleWarnings: function (l, u) {},
      flushPendingUnsafeLifecycleWarnings: function () {},
      recordLegacyContextWarning: function (l, u) {},
      flushLegacyContextWarning: function () {},
      discardPendingWarnings: function () {}
    };
    {
      var IP = function (l) {
          for (var u = null, v = l; v !== null;) v.mode & Xn && (u = v), v = v.return;
          return u;
        },
        ns = function (l) {
          var u = [];
          return l.forEach(function (v) {
            u.push(v);
          }), u.sort().join(", ");
        },
        m_ = [],
        Mf = [],
        mm = [],
        vm = [],
        gm = [],
        ym = [],
        Lf = /* @__PURE__ */new Set();
      If.recordUnsafeLifecycleWarnings = function (l, u) {
        Lf.has(l.type) || (typeof u.componentWillMount == "function" &&
        // Don't warn about react-lifecycles-compat polyfilled components.
        u.componentWillMount.__suppressDeprecationWarning !== !0 && m_.push(l), l.mode & Xn && typeof u.UNSAFE_componentWillMount == "function" && Mf.push(l), typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && mm.push(l), l.mode & Xn && typeof u.UNSAFE_componentWillReceiveProps == "function" && vm.push(l), typeof u.componentWillUpdate == "function" && u.componentWillUpdate.__suppressDeprecationWarning !== !0 && gm.push(l), l.mode & Xn && typeof u.UNSAFE_componentWillUpdate == "function" && ym.push(l));
      }, If.flushPendingUnsafeLifecycleWarnings = function () {
        var l = /* @__PURE__ */new Set();
        m_.length > 0 && (m_.forEach(function (U) {
          l.add(At(U) || "Component"), Lf.add(U.type);
        }), m_ = []);
        var u = /* @__PURE__ */new Set();
        Mf.length > 0 && (Mf.forEach(function (U) {
          u.add(At(U) || "Component"), Lf.add(U.type);
        }), Mf = []);
        var v = /* @__PURE__ */new Set();
        mm.length > 0 && (mm.forEach(function (U) {
          v.add(At(U) || "Component"), Lf.add(U.type);
        }), mm = []);
        var _ = /* @__PURE__ */new Set();
        vm.length > 0 && (vm.forEach(function (U) {
          _.add(At(U) || "Component"), Lf.add(U.type);
        }), vm = []);
        var n = /* @__PURE__ */new Set();
        gm.length > 0 && (gm.forEach(function (U) {
          n.add(At(U) || "Component"), Lf.add(U.type);
        }), gm = []);
        var a = /* @__PURE__ */new Set();
        if (ym.length > 0 && (ym.forEach(function (U) {
          a.add(At(U) || "Component"), Lf.add(U.type);
        }), ym = []), u.size > 0) {
          var f = ns(u);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, f);
        }
        if (_.size > 0) {
          var m = ns(_);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, m);
        }
        if (a.size > 0) {
          var b = ns(a);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, b);
        }
        if (l.size > 0) {
          var T = ns(l);
          p(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, T);
        }
        if (v.size > 0) {
          var M = ns(v);
          p(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (n.size > 0) {
          var z = ns(n);
          p(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, z);
        }
      };
      var gv = /* @__PURE__ */new Map(),
        yv = /* @__PURE__ */new Set();
      If.recordLegacyContextWarning = function (l, u) {
        var v = IP(l);
        if (v === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!yv.has(l.type)) {
          var _ = gv.get(v);
          (l.type.contextTypes != null || l.type.childContextTypes != null || u !== null && typeof u.getChildContext == "function") && (_ === void 0 && (_ = [], gv.set(v, _)), _.push(l));
        }
      }, If.flushLegacyContextWarning = function () {
        gv.forEach(function (l, u) {
          if (l.length !== 0) {
            var v = l[0],
              _ = /* @__PURE__ */new Set();
            l.forEach(function (a) {
              _.add(At(a) || "Component"), yv.add(a.type);
            });
            var n = ns(_);
            try {
              Rn(v), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, n);
            } finally {
              Un();
            }
          }
        });
      }, If.discardPendingWarnings = function () {
        m_ = [], Mf = [], mm = [], vm = [], gm = [], ym = [], gv = /* @__PURE__ */new Map();
      };
    }
    function mu(l, u) {
      if (l && l.defaultProps) {
        var v = Qt({}, u),
          _ = l.defaultProps;
        for (var n in _) v[n] === void 0 && (v[n] = _[n]);
        return v;
      }
      return u;
    }
    var DS = Cf(null),
      wc;
    wc = {};
    var Xb = null,
      bv = null,
      Kb = null,
      bm = !1;
    function Qb() {
      Xb = null, bv = null, Kb = null, bm = !1;
    }
    function v_() {
      bm = !0;
    }
    function g_() {
      bm = !1;
    }
    function SC(l, u, v) {
      ka(DS, u._currentValue, l), u._currentValue = v, u._currentRenderer !== void 0 && u._currentRenderer !== null && u._currentRenderer !== wc && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), u._currentRenderer = wc;
    }
    function IS(l, u) {
      var v = DS.current;
      ca(DS, u), l._currentValue = v;
    }
    function MS(l, u, v) {
      for (var _ = l; _ !== null;) {
        var n = _.alternate;
        if ($l(_.childLanes, u) ? n !== null && !$l(n.childLanes, u) && (n.childLanes = jt(n.childLanes, u)) : (_.childLanes = jt(_.childLanes, u), n !== null && (n.childLanes = jt(n.childLanes, u))), _ === v) break;
        _ = _.return;
      }
      _ !== v && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function EC(l, u, v) {
      CC(l, u, v);
    }
    function CC(l, u, v) {
      var _ = l.child;
      for (_ !== null && (_.return = l); _ !== null;) {
        var n = void 0,
          a = _.dependencies;
        if (a !== null) {
          n = _.child;
          for (var f = a.firstContext; f !== null;) {
            if (f.context === u) {
              if (_.tag === x) {
                var m = Xs(v),
                  b = Of(wn, m);
                b.tag = b_;
                var T = _.updateQueue;
                if (T !== null) {
                  var M = T.shared,
                    z = M.pending;
                  z === null ? b.next = b : (b.next = z.next, z.next = b), M.pending = b;
                }
              }
              _.lanes = jt(_.lanes, v);
              var U = _.alternate;
              U !== null && (U.lanes = jt(U.lanes, v)), MS(_.return, v, l), a.lanes = jt(a.lanes, v);
              break;
            }
            f = f.next;
          }
        } else if (_.tag === O) n = _.type === l.type ? null : _.child;else if (_.tag === ie) {
          var X = _.return;
          if (X === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          X.lanes = jt(X.lanes, v);
          var J = X.alternate;
          J !== null && (J.lanes = jt(J.lanes, v)), MS(X, v, l), n = _.sibling;
        } else n = _.child;
        if (n !== null) n.return = _;else for (n = _; n !== null;) {
          if (n === l) {
            n = null;
            break;
          }
          var me = n.sibling;
          if (me !== null) {
            me.return = n.return, n = me;
            break;
          }
          n = n.return;
        }
        _ = n;
      }
    }
    function Zb(l, u) {
      Xb = l, bv = null, Kb = null;
      var v = l.dependencies;
      if (v !== null) {
        var _ = v.firstContext;
        _ !== null && (_n(v.lanes, u) && x0(), v.firstContext = null);
      }
    }
    function ko(l) {
      bm && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var u = l._currentValue;
      if (Kb !== l) {
        var v = {
          context: l,
          memoizedValue: u,
          next: null
        };
        if (bv === null) {
          if (Xb === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          bv = v, Xb.dependencies = {
            lanes: Re,
            firstContext: v
          };
        } else bv = bv.next = v;
      }
      return u;
    }
    var Uc = null;
    function Aa(l) {
      Uc === null ? Uc = [l] : Uc.push(l);
    }
    function Ey() {
      if (Uc !== null) {
        for (var l = 0; l < Uc.length; l++) {
          var u = Uc[l],
            v = u.interleaved;
          if (v !== null) {
            u.interleaved = null;
            var _ = v.next,
              n = u.pending;
            if (n !== null) {
              var a = n.next;
              n.next = _, v.next = a;
            }
            u.pending = v;
          }
        }
        Uc = null;
      }
    }
    function LS(l, u, v, _) {
      var n = u.interleaved;
      return n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v, rs(l, _);
    }
    function MP(l, u, v, _) {
      var n = u.interleaved;
      n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v;
    }
    function TD(l, u, v, _) {
      var n = u.interleaved;
      return n === null ? (v.next = v, Aa(u)) : (v.next = n.next, n.next = v), u.interleaved = v, rs(l, _);
    }
    function vu(l, u) {
      return rs(l, u);
    }
    var LP = rs;
    function rs(l, u) {
      l.lanes = jt(l.lanes, u);
      var v = l.alternate;
      v !== null && (v.lanes = jt(v.lanes, u)), v === null && (l.flags & (Gn | xi)) !== pt && LI(l);
      for (var _ = l, n = l.return; n !== null;) n.childLanes = jt(n.childLanes, u), v = n.alternate, v !== null ? v.childLanes = jt(v.childLanes, u) : (n.flags & (Gn | xi)) !== pt && LI(l), _ = n, n = n.return;
      if (_.tag === C) {
        var a = _.stateNode;
        return a;
      } else return null;
    }
    var RD = 0,
      y_ = 1,
      b_ = 2,
      OS = 3,
      Cy = !1,
      w_,
      ky;
    w_ = !1, ky = null;
    function __(l) {
      var u = {
        baseState: l.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Re
        },
        effects: null
      };
      l.updateQueue = u;
    }
    function x_(l, u) {
      var v = u.updateQueue,
        _ = l.updateQueue;
      if (v === _) {
        var n = {
          baseState: _.baseState,
          firstBaseUpdate: _.firstBaseUpdate,
          lastBaseUpdate: _.lastBaseUpdate,
          shared: _.shared,
          effects: _.effects
        };
        u.updateQueue = n;
      }
    }
    function Of(l, u) {
      var v = {
        eventTime: l,
        lane: u,
        tag: RD,
        payload: null,
        callback: null,
        next: null
      };
      return v;
    }
    function wm(l, u, v) {
      var _ = l.updateQueue;
      if (_ === null) return null;
      var n = _.shared;
      if (ky === n && !w_ && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), w_ = !0), jv()) {
        var a = n.pending;
        return a === null ? u.next = u : (u.next = a.next, a.next = u), n.pending = u, LP(l, v);
      } else return TD(l, n, u, v);
    }
    function Hc(l, u, v) {
      var _ = u.updateQueue;
      if (_ !== null) {
        var n = _.shared;
        if (zh(v)) {
          var a = n.lanes;
          a = Bh(a, l.pendingLanes);
          var f = jt(a, v);
          n.lanes = f, uf(l, f);
        }
      }
    }
    function mp(l, u) {
      var v = l.updateQueue,
        _ = l.alternate;
      if (_ !== null) {
        var n = _.updateQueue;
        if (v === n) {
          var a = null,
            f = null,
            m = v.firstBaseUpdate;
          if (m !== null) {
            var b = m;
            do {
              var T = {
                eventTime: b.eventTime,
                lane: b.lane,
                tag: b.tag,
                payload: b.payload,
                callback: b.callback,
                next: null
              };
              f === null ? a = f = T : (f.next = T, f = T), b = b.next;
            } while (b !== null);
            f === null ? a = f = u : (f.next = u, f = u);
          } else a = f = u;
          v = {
            baseState: n.baseState,
            firstBaseUpdate: a,
            lastBaseUpdate: f,
            shared: n.shared,
            effects: n.effects
          }, l.updateQueue = v;
          return;
        }
      }
      var M = v.lastBaseUpdate;
      M === null ? v.firstBaseUpdate = u : M.next = u, v.lastBaseUpdate = u;
    }
    function PS(l, u, v, _, n, a) {
      switch (v.tag) {
        case y_:
          {
            var f = v.payload;
            if (typeof f == "function") {
              v_();
              var m = f.call(a, _, n);
              {
                if (l.mode & Xn) {
                  En(!0);
                  try {
                    f.call(a, _, n);
                  } finally {
                    En(!1);
                  }
                }
                g_();
              }
              return m;
            }
            return f;
          }
        case OS:
          l.flags = l.flags & -65537 | ft;
        // Intentional fallthrough
        case RD:
          {
            var b = v.payload,
              T;
            if (typeof b == "function") {
              v_(), T = b.call(a, _, n);
              {
                if (l.mode & Xn) {
                  En(!0);
                  try {
                    b.call(a, _, n);
                  } finally {
                    En(!1);
                  }
                }
                g_();
              }
            } else T = b;
            return T == null ? _ : Qt({}, _, T);
          }
        case b_:
          return Cy = !0, _;
      }
      return _;
    }
    function Jb(l, u, v, _) {
      var n = l.updateQueue;
      Cy = !1, ky = n.shared;
      var a = n.firstBaseUpdate,
        f = n.lastBaseUpdate,
        m = n.shared.pending;
      if (m !== null) {
        n.shared.pending = null;
        var b = m,
          T = b.next;
        b.next = null, f === null ? a = T : f.next = T, f = b;
        var M = l.alternate;
        if (M !== null) {
          var z = M.updateQueue,
            U = z.lastBaseUpdate;
          U !== f && (U === null ? z.firstBaseUpdate = T : U.next = T, z.lastBaseUpdate = b);
        }
      }
      if (a !== null) {
        var X = n.baseState,
          J = Re,
          me = null,
          xe = null,
          Ie = null,
          Pe = a;
        do {
          var $e = Pe.lane,
            mt = Pe.eventTime;
          if ($l(_, $e)) {
            if (Ie !== null) {
              var Te = {
                eventTime: mt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ln,
                tag: Pe.tag,
                payload: Pe.payload,
                callback: Pe.callback,
                next: null
              };
              Ie = Ie.next = Te;
            }
            X = PS(l, n, Pe, X, u, v);
            var Ue = Pe.callback;
            if (Ue !== null &&
            // If the update was already committed, we should not queue its
            // callback again.
            Pe.lane !== Ln) {
              l.flags |= Sn;
              var Ve = n.effects;
              Ve === null ? n.effects = [Pe] : Ve.push(Pe);
            }
          } else {
            var nt = {
              eventTime: mt,
              lane: $e,
              tag: Pe.tag,
              payload: Pe.payload,
              callback: Pe.callback,
              next: null
            };
            Ie === null ? (xe = Ie = nt, me = X) : Ie = Ie.next = nt, J = jt(J, $e);
          }
          if (Pe = Pe.next, Pe === null) {
            if (m = n.shared.pending, m === null) break;
            var ke = m,
              Fe = ke.next;
            ke.next = null, Pe = Fe, n.lastBaseUpdate = ke, n.shared.pending = null;
          }
        } while (!0);
        Ie === null && (me = X), n.baseState = me, n.firstBaseUpdate = xe, n.lastBaseUpdate = Ie;
        var De = n.shared.interleaved;
        if (De !== null) {
          var Qe = De;
          do J = jt(J, Qe.lane), Qe = Qe.next; while (Qe !== De);
        } else a === null && (n.shared.lanes = Re);
        O0(J), l.lanes = J, l.memoizedState = X;
      }
      ky = null;
    }
    function OP(l, u) {
      if (typeof l != "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + l));
      l.call(u);
    }
    function S_() {
      Cy = !1;
    }
    function AS() {
      return Cy;
    }
    function kC(l, u, v) {
      var _ = u.effects;
      if (u.effects = null, _ !== null) for (var n = 0; n < _.length; n++) {
        var a = _[n],
          f = a.callback;
        f !== null && (a.callback = null, OP(f, v));
      }
    }
    var e0 = {},
      TC = new t.Component().refs,
      E_,
      jS,
      C_,
      k_,
      T_,
      FS,
      t0,
      NS,
      n0,
      R_;
    {
      E_ = /* @__PURE__ */new Set(), jS = /* @__PURE__ */new Set(), C_ = /* @__PURE__ */new Set(), k_ = /* @__PURE__ */new Set(), NS = /* @__PURE__ */new Set(), T_ = /* @__PURE__ */new Set(), n0 = /* @__PURE__ */new Set(), R_ = /* @__PURE__ */new Set();
      var zS = /* @__PURE__ */new Set();
      t0 = function (l, u) {
        if (!(l === null || typeof l == "function")) {
          var v = u + "_" + l;
          zS.has(v) || (zS.add(v), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, l));
        }
      }, FS = function (l, u) {
        if (u === void 0) {
          var v = bn(l) || "Component";
          T_.has(v) || (T_.add(v), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", v));
        }
      }, Object.defineProperty(e0, "_processChildContext", {
        enumerable: !1,
        value: function () {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(e0);
    }
    function D_(l, u, v, _) {
      var n = l.memoizedState,
        a = v(_, n);
      {
        if (l.mode & Xn) {
          En(!0);
          try {
            a = v(_, n);
          } finally {
            En(!1);
          }
        }
        FS(u, a);
      }
      var f = a == null ? n : Qt({}, n, a);
      if (l.memoizedState = f, l.lanes === Re) {
        var m = l.updateQueue;
        m.baseState = f;
      }
    }
    var VS = {
      isMounted: jg,
      enqueueSetState: function (l, u, v) {
        var _ = Ps(l),
          n = el(),
          a = Zf(_),
          f = Of(n, a);
        f.payload = u, v != null && (t0(v, "setState"), f.callback = v);
        var m = wm(_, f, a);
        m !== null && (Ba(m, _, a, n), Hc(m, _, a)), Bl(_, a);
      },
      enqueueReplaceState: function (l, u, v) {
        var _ = Ps(l),
          n = el(),
          a = Zf(_),
          f = Of(n, a);
        f.tag = y_, f.payload = u, v != null && (t0(v, "replaceState"), f.callback = v);
        var m = wm(_, f, a);
        m !== null && (Ba(m, _, a, n), Hc(m, _, a)), Bl(_, a);
      },
      enqueueForceUpdate: function (l, u) {
        var v = Ps(l),
          _ = el(),
          n = Zf(v),
          a = Of(_, n);
        a.tag = b_, u != null && (t0(u, "forceUpdate"), a.callback = u);
        var f = wm(v, a, n);
        f !== null && (Ba(f, v, n, _), Hc(f, v, n)), Qu(v, n);
      }
    };
    function BS(l, u, v, _, n, a, f) {
      var m = l.stateNode;
      if (typeof m.shouldComponentUpdate == "function") {
        var b = m.shouldComponentUpdate(_, a, f);
        {
          if (l.mode & Xn) {
            En(!0);
            try {
              b = m.shouldComponentUpdate(_, a, f);
            } finally {
              En(!1);
            }
          }
          b === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", bn(u) || "Component");
        }
        return b;
      }
      return u.prototype && u.prototype.isPureReactComponent ? !he(v, _) || !he(n, a) : !0;
    }
    function RC(l, u, v) {
      var _ = l.stateNode;
      {
        var n = bn(u) || "Component",
          a = _.render;
        a || (u.prototype && typeof u.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", n) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", n)), _.getInitialState && !_.getInitialState.isReactClassApproved && !_.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", n), _.getDefaultProps && !_.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", n), _.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", n), _.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", n), _.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", n), u.contextType && u.contextTypes && !n0.has(u) && (n0.add(u), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", n)), typeof _.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", n), u.prototype && u.prototype.isPureReactComponent && typeof _.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", bn(u) || "A pure component"), typeof _.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", n), typeof _.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", n), typeof _.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", n), typeof _.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", n);
        var f = _.props !== v;
        _.props !== void 0 && f && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", n, n), _.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", n, n), typeof _.getSnapshotBeforeUpdate == "function" && typeof _.componentDidUpdate != "function" && !C_.has(u) && (C_.add(u), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", bn(u))), typeof _.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", n), typeof _.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", n), typeof u.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", n);
        var m = _.state;
        m && (typeof m != "object" || wr(m)) && h("%s.state: must be set to an object or null", n), typeof _.getChildContext == "function" && typeof u.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", n);
      }
    }
    function DC(l, u) {
      u.updater = VS, l.stateNode = u, Fl(u, l), u._reactInternalInstance = e0;
    }
    function DD(l, u, v) {
      var _ = !1,
        n = fi,
        a = fi,
        f = u.contextType;
      if ("contextType" in u) {
        var m =
        // Allow null for conditional declaration
        f === null || f !== void 0 && f.$$typeof === Ne && f._context === void 0;
        if (!m && !R_.has(u)) {
          R_.add(u);
          var b = "";
          f === void 0 ? b = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof f != "object" ? b = " However, it is set to a " + typeof f + "." : f.$$typeof === Z ? b = " Did you accidentally pass the Context.Provider instead?" : f._context !== void 0 ? b = " Did you accidentally pass the Context.Consumer instead?" : b = " However, it is set to an object with keys {" + Object.keys(f).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", bn(u) || "Component", b);
        }
      }
      if (typeof f == "object" && f !== null) a = ko(f);else {
        n = Js(l, u, !0);
        var T = u.contextTypes;
        _ = T != null, a = _ ? Rf(l, n) : fi;
      }
      var M = new u(v, a);
      if (l.mode & Xn) {
        En(!0);
        try {
          M = new u(v, a);
        } finally {
          En(!1);
        }
      }
      var z = l.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
      DC(l, M);
      {
        if (typeof u.getDerivedStateFromProps == "function" && z === null) {
          var U = bn(u) || "Component";
          jS.has(U) || (jS.add(U), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", U, M.state === null ? "null" : "undefined", U));
        }
        if (typeof u.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function") {
          var X = null,
            J = null,
            me = null;
          if (typeof M.componentWillMount == "function" && M.componentWillMount.__suppressDeprecationWarning !== !0 ? X = "componentWillMount" : typeof M.UNSAFE_componentWillMount == "function" && (X = "UNSAFE_componentWillMount"), typeof M.componentWillReceiveProps == "function" && M.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? J = "componentWillReceiveProps" : typeof M.UNSAFE_componentWillReceiveProps == "function" && (J = "UNSAFE_componentWillReceiveProps"), typeof M.componentWillUpdate == "function" && M.componentWillUpdate.__suppressDeprecationWarning !== !0 ? me = "componentWillUpdate" : typeof M.UNSAFE_componentWillUpdate == "function" && (me = "UNSAFE_componentWillUpdate"), X !== null || J !== null || me !== null) {
            var xe = bn(u) || "Component",
              Ie = typeof u.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            k_.has(xe) || (k_.add(xe), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, xe, Ie, X !== null ? `
  ` + X : "", J !== null ? `
  ` + J : "", me !== null ? `
  ` + me : ""));
          }
        }
      }
      return _ && yS(l, n, a), M;
    }
    function ID(l, u) {
      var v = u.state;
      typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), v !== u.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", At(l) || "Component"), VS.enqueueReplaceState(u, u.state, null));
    }
    function IC(l, u, v, _) {
      var n = u.state;
      if (typeof u.componentWillReceiveProps == "function" && u.componentWillReceiveProps(v, _), typeof u.UNSAFE_componentWillReceiveProps == "function" && u.UNSAFE_componentWillReceiveProps(v, _), u.state !== n) {
        {
          var a = At(l) || "Component";
          E_.has(a) || (E_.add(a), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", a));
        }
        VS.enqueueReplaceState(u, u.state, null);
      }
    }
    function MC(l, u, v, _) {
      RC(l, u, v);
      var n = l.stateNode;
      n.props = v, n.state = l.memoizedState, n.refs = TC, __(l);
      var a = u.contextType;
      if (typeof a == "object" && a !== null) n.context = ko(a);else {
        var f = Js(l, u, !0);
        n.context = Rf(l, f);
      }
      {
        if (n.state === v) {
          var m = bn(u) || "Component";
          NS.has(m) || (NS.add(m), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", m));
        }
        l.mode & Xn && If.recordLegacyContextWarning(l, n), If.recordUnsafeLifecycleWarnings(l, n);
      }
      n.state = l.memoizedState;
      var b = u.getDerivedStateFromProps;
      if (typeof b == "function" && (D_(l, u, b, v), n.state = l.memoizedState), typeof u.getDerivedStateFromProps != "function" && typeof n.getSnapshotBeforeUpdate != "function" && (typeof n.UNSAFE_componentWillMount == "function" || typeof n.componentWillMount == "function") && (ID(l, n), Jb(l, v, n, _), n.state = l.memoizedState), typeof n.componentDidMount == "function") {
        var T = tn;
        T |= Za, (l.mode & Ri) !== dt && (T |= Bo), l.flags |= T;
      }
    }
    function MD(l, u, v, _) {
      var n = l.stateNode,
        a = l.memoizedProps;
      n.props = a;
      var f = n.context,
        m = u.contextType,
        b = fi;
      if (typeof m == "object" && m !== null) b = ko(m);else {
        var T = Js(l, u, !0);
        b = Rf(l, T);
      }
      var M = u.getDerivedStateFromProps,
        z = typeof M == "function" || typeof n.getSnapshotBeforeUpdate == "function";
      !z && (typeof n.UNSAFE_componentWillReceiveProps == "function" || typeof n.componentWillReceiveProps == "function") && (a !== v || f !== b) && IC(l, n, v, b), S_();
      var U = l.memoizedState,
        X = n.state = U;
      if (Jb(l, v, n, _), X = l.memoizedState, a === v && U === X && !u_() && !AS()) {
        if (typeof n.componentDidMount == "function") {
          var J = tn;
          J |= Za, (l.mode & Ri) !== dt && (J |= Bo), l.flags |= J;
        }
        return !1;
      }
      typeof M == "function" && (D_(l, u, M, v), X = l.memoizedState);
      var me = AS() || BS(l, u, a, v, U, X, b);
      if (me) {
        if (!z && (typeof n.UNSAFE_componentWillMount == "function" || typeof n.componentWillMount == "function") && (typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount()), typeof n.componentDidMount == "function") {
          var xe = tn;
          xe |= Za, (l.mode & Ri) !== dt && (xe |= Bo), l.flags |= xe;
        }
      } else {
        if (typeof n.componentDidMount == "function") {
          var Ie = tn;
          Ie |= Za, (l.mode & Ri) !== dt && (Ie |= Bo), l.flags |= Ie;
        }
        l.memoizedProps = v, l.memoizedState = X;
      }
      return n.props = v, n.state = X, n.context = b, me;
    }
    function LC(l, u, v, _, n) {
      var a = u.stateNode;
      x_(l, u);
      var f = u.memoizedProps,
        m = u.type === u.elementType ? f : mu(u.type, f);
      a.props = m;
      var b = u.pendingProps,
        T = a.context,
        M = v.contextType,
        z = fi;
      if (typeof M == "object" && M !== null) z = ko(M);else {
        var U = Js(u, v, !0);
        z = Rf(u, U);
      }
      var X = v.getDerivedStateFromProps,
        J = typeof X == "function" || typeof a.getSnapshotBeforeUpdate == "function";
      !J && (typeof a.UNSAFE_componentWillReceiveProps == "function" || typeof a.componentWillReceiveProps == "function") && (f !== b || T !== z) && IC(u, a, _, z), S_();
      var me = u.memoizedState,
        xe = a.state = me;
      if (Jb(u, _, a, n), xe = u.memoizedState, f === b && me === xe && !u_() && !AS()) return typeof a.componentDidUpdate == "function" && (f !== l.memoizedProps || me !== l.memoizedState) && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (f !== l.memoizedProps || me !== l.memoizedState) && (u.flags |= or), !1;
      typeof X == "function" && (D_(u, v, X, _), xe = u.memoizedState);
      var Ie = AS() || BS(u, v, m, _, me, xe, z) ||
      // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      de;
      return Ie ? (!J && (typeof a.UNSAFE_componentWillUpdate == "function" || typeof a.componentWillUpdate == "function") && (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(_, xe, z), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(_, xe, z)), typeof a.componentDidUpdate == "function" && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (u.flags |= or)) : (typeof a.componentDidUpdate == "function" && (f !== l.memoizedProps || me !== l.memoizedState) && (u.flags |= tn), typeof a.getSnapshotBeforeUpdate == "function" && (f !== l.memoizedProps || me !== l.memoizedState) && (u.flags |= or), u.memoizedProps = _, u.memoizedState = xe), a.props = _, a.state = xe, a.context = z, Ie;
    }
    var OC,
      PC,
      I_,
      M_,
      L_,
      US = function (l, u) {};
    OC = !1, PC = !1, I_ = {}, M_ = {}, L_ = {}, US = function (l, u) {
      if (!(l === null || typeof l != "object") && !(!l._store || l._store.validated || l.key != null)) {
        if (typeof l._store != "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        l._store.validated = !0;
        var v = At(u) || "Component";
        M_[v] || (M_[v] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function Ty(l, u, v) {
      var _ = v.ref;
      if (_ !== null && typeof _ != "function" && typeof _ != "object") {
        if ((l.mode & Xn || ue) &&
        // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(v._owner && v._self && v._owner.stateNode !== v._self)) {
          var n = At(l) || "Component";
          I_[n] || (h('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _), I_[n] = !0);
        }
        if (v._owner) {
          var a = v._owner,
            f;
          if (a) {
            var m = a;
            if (m.tag !== x) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            f = m.stateNode;
          }
          if (!f) throw new Error("Missing owner for string ref " + _ + ". This error is likely caused by a bug in React. Please file an issue.");
          var b = f;
          gt(_, "ref");
          var T = "" + _;
          if (u !== null && u.ref !== null && typeof u.ref == "function" && u.ref._stringRef === T) return u.ref;
          var M = function (z) {
            var U = b.refs;
            U === TC && (U = b.refs = {}), z === null ? delete U[T] : U[T] = z;
          };
          return M._stringRef = T, M;
        } else {
          if (typeof _ != "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!v._owner) throw new Error("Element ref was specified as a string (" + _ + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return _;
    }
    function O_(l, u) {
      var v = Object.prototype.toString.call(u);
      throw new Error("Objects are not valid as a React child (found: " + (v === "[object Object]" ? "object with keys {" + Object.keys(u).join(", ") + "}" : v) + "). If you meant to render a collection of children, use an array instead.");
    }
    function wv(l) {
      {
        var u = At(l) || "Component";
        if (L_[u]) return;
        L_[u] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function P_(l) {
      var u = l._payload,
        v = l._init;
      return v(u);
    }
    function A_(l) {
      function u(Te, Ue) {
        if (l) {
          var Ve = Te.deletions;
          Ve === null ? (Te.deletions = [Ue], Te.flags |= _i) : Ve.push(Ue);
        }
      }
      function v(Te, Ue) {
        if (!l) return null;
        for (var Ve = Ue; Ve !== null;) u(Te, Ve), Ve = Ve.sibling;
        return null;
      }
      function _(Te, Ue) {
        for (var Ve = /* @__PURE__ */new Map(), nt = Ue; nt !== null;) nt.key !== null ? Ve.set(nt.key, nt) : Ve.set(nt.index, nt), nt = nt.sibling;
        return Ve;
      }
      function n(Te, Ue) {
        var Ve = tl(Te, Ue);
        return Ve.index = 0, Ve.sibling = null, Ve;
      }
      function a(Te, Ue, Ve) {
        if (Te.index = Ve, !l) return Te.flags |= va, Ue;
        var nt = Te.alternate;
        if (nt !== null) {
          var ke = nt.index;
          return ke < Ue ? (Te.flags |= Gn, Ue) : ke;
        } else return Te.flags |= Gn, Ue;
      }
      function f(Te) {
        return l && Te.alternate === null && (Te.flags |= Gn), Te;
      }
      function m(Te, Ue, Ve, nt) {
        if (Ue === null || Ue.tag !== I) {
          var ke = qk(Ve, Te.mode, nt);
          return ke.return = Te, ke;
        } else {
          var Fe = n(Ue, Ve);
          return Fe.return = Te, Fe;
        }
      }
      function b(Te, Ue, Ve, nt) {
        var ke = Ve.type;
        if (ke === Lo) return M(Te, Ue, Ve.props.children, nt, Ve.key);
        if (Ue !== null && (Ue.elementType === ke ||
        // Keep this check inline so it only runs on the false path:
        PI(Ue, Ve) ||
        // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof ke == "object" && ke !== null && ke.$$typeof === Ct && P_(ke) === Ue.type)) {
          var Fe = n(Ue, Ve.props);
          return Fe.ref = Ty(Te, Ue, Ve), Fe.return = Te, Fe._debugSource = Ve._source, Fe._debugOwner = Ve._owner, Fe;
        }
        var De = Lm(Ve, Te.mode, nt);
        return De.ref = Ty(Te, Ue, Ve), De.return = Te, De;
      }
      function T(Te, Ue, Ve, nt) {
        if (Ue === null || Ue.tag !== k || Ue.stateNode.containerInfo !== Ve.containerInfo || Ue.stateNode.implementation !== Ve.implementation) {
          var ke = M1(Ve, Te.mode, nt);
          return ke.return = Te, ke;
        } else {
          var Fe = n(Ue, Ve.children || []);
          return Fe.return = Te, Fe;
        }
      }
      function M(Te, Ue, Ve, nt, ke) {
        if (Ue === null || Ue.tag !== L) {
          var Fe = zv(Ve, Te.mode, nt, ke);
          return Fe.return = Te, Fe;
        } else {
          var De = n(Ue, Ve);
          return De.return = Te, De;
        }
      }
      function z(Te, Ue, Ve) {
        if (typeof Ue == "string" && Ue !== "" || typeof Ue == "number") {
          var nt = qk("" + Ue, Te.mode, Ve);
          return nt.return = Te, nt;
        }
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case $i:
              {
                var ke = Lm(Ue, Te.mode, Ve);
                return ke.ref = Ty(Te, null, Ue), ke.return = Te, ke;
              }
            case oi:
              {
                var Fe = M1(Ue, Te.mode, Ve);
                return Fe.return = Te, Fe;
              }
            case Ct:
              {
                var De = Ue._payload,
                  Qe = Ue._init;
                return z(Te, Qe(De), Ve);
              }
          }
          if (wr(Ue) || yn(Ue)) {
            var Tt = zv(Ue, Te.mode, Ve, null);
            return Tt.return = Te, Tt;
          }
          O_(Te, Ue);
        }
        return typeof Ue == "function" && wv(Te), null;
      }
      function U(Te, Ue, Ve, nt) {
        var ke = Ue !== null ? Ue.key : null;
        if (typeof Ve == "string" && Ve !== "" || typeof Ve == "number") return ke !== null ? null : m(Te, Ue, "" + Ve, nt);
        if (typeof Ve == "object" && Ve !== null) {
          switch (Ve.$$typeof) {
            case $i:
              return Ve.key === ke ? b(Te, Ue, Ve, nt) : null;
            case oi:
              return Ve.key === ke ? T(Te, Ue, Ve, nt) : null;
            case Ct:
              {
                var Fe = Ve._payload,
                  De = Ve._init;
                return U(Te, Ue, De(Fe), nt);
              }
          }
          if (wr(Ve) || yn(Ve)) return ke !== null ? null : M(Te, Ue, Ve, nt, null);
          O_(Te, Ve);
        }
        return typeof Ve == "function" && wv(Te), null;
      }
      function X(Te, Ue, Ve, nt, ke) {
        if (typeof nt == "string" && nt !== "" || typeof nt == "number") {
          var Fe = Te.get(Ve) || null;
          return m(Ue, Fe, "" + nt, ke);
        }
        if (typeof nt == "object" && nt !== null) {
          switch (nt.$$typeof) {
            case $i:
              {
                var De = Te.get(nt.key === null ? Ve : nt.key) || null;
                return b(Ue, De, nt, ke);
              }
            case oi:
              {
                var Qe = Te.get(nt.key === null ? Ve : nt.key) || null;
                return T(Ue, Qe, nt, ke);
              }
            case Ct:
              var Tt = nt._payload,
                _t = nt._init;
              return X(Te, Ue, Ve, _t(Tt), ke);
          }
          if (wr(nt) || yn(nt)) {
            var an = Te.get(Ve) || null;
            return M(Ue, an, nt, ke, null);
          }
          O_(Ue, nt);
        }
        return typeof nt == "function" && wv(Ue), null;
      }
      function J(Te, Ue, Ve) {
        {
          if (typeof Te != "object" || Te === null) return Ue;
          switch (Te.$$typeof) {
            case $i:
            case oi:
              US(Te, Ve);
              var nt = Te.key;
              if (typeof nt != "string") break;
              if (Ue === null) {
                Ue = /* @__PURE__ */new Set(), Ue.add(nt);
                break;
              }
              if (!Ue.has(nt)) {
                Ue.add(nt);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", nt);
              break;
            case Ct:
              var ke = Te._payload,
                Fe = Te._init;
              J(Fe(ke), Ue, Ve);
              break;
          }
        }
        return Ue;
      }
      function me(Te, Ue, Ve, nt) {
        for (var ke = null, Fe = 0; Fe < Ve.length; Fe++) {
          var De = Ve[Fe];
          ke = J(De, ke, Te);
        }
        for (var Qe = null, Tt = null, _t = Ue, an = 0, Gt = 0, Pn = null; _t !== null && Gt < Ve.length; Gt++) {
          _t.index > Gt ? (Pn = _t, _t = null) : Pn = _t.sibling;
          var Fn = U(Te, _t, Ve[Gt], nt);
          if (Fn === null) {
            _t === null && (_t = Pn);
            break;
          }
          l && _t && Fn.alternate === null && u(Te, _t), an = a(Fn, an, Gt), Tt === null ? Qe = Fn : Tt.sibling = Fn, Tt = Fn, _t = Pn;
        }
        if (Gt === Ve.length) {
          if (v(Te, _t), Pa()) {
            var kr = Gt;
            _y(Te, kr);
          }
          return Qe;
        }
        if (_t === null) {
          for (; Gt < Ve.length; Gt++) {
            var qn = z(Te, Ve[Gt], nt);
            qn !== null && (an = a(qn, an, Gt), Tt === null ? Qe = qn : Tt.sibling = qn, Tt = qn);
          }
          if (Pa()) {
            var Tr = Gt;
            _y(Te, Tr);
          }
          return Qe;
        }
        for (var ai = _(Te, _t); Gt < Ve.length; Gt++) {
          var Br = X(ai, Te, Gt, Ve[Gt], nt);
          Br !== null && (l && Br.alternate !== null && ai.delete(Br.key === null ? Gt : Br.key), an = a(Br, an, Gt), Tt === null ? Qe = Br : Tt.sibling = Br, Tt = Br);
        }
        if (l && ai.forEach(function (Ro) {
          return u(Te, Ro);
        }), Pa()) {
          var ho = Gt;
          _y(Te, ho);
        }
        return Qe;
      }
      function xe(Te, Ue, Ve, nt) {
        var ke = yn(Ve);
        if (typeof ke != "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" &&
          // $FlowFixMe Flow doesn't know about toStringTag
          Ve[Symbol.toStringTag] === "Generator" && (PC || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), PC = !0), Ve.entries === ke && (OC || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), OC = !0);
          var Fe = ke.call(Ve);
          if (Fe) for (var De = null, Qe = Fe.next(); !Qe.done; Qe = Fe.next()) {
            var Tt = Qe.value;
            De = J(Tt, De, Te);
          }
        }
        var _t = ke.call(Ve);
        if (_t == null) throw new Error("An iterable object provided no iterator.");
        for (var an = null, Gt = null, Pn = Ue, Fn = 0, kr = 0, qn = null, Tr = _t.next(); Pn !== null && !Tr.done; kr++, Tr = _t.next()) {
          Pn.index > kr ? (qn = Pn, Pn = null) : qn = Pn.sibling;
          var ai = U(Te, Pn, Tr.value, nt);
          if (ai === null) {
            Pn === null && (Pn = qn);
            break;
          }
          l && Pn && ai.alternate === null && u(Te, Pn), Fn = a(ai, Fn, kr), Gt === null ? an = ai : Gt.sibling = ai, Gt = ai, Pn = qn;
        }
        if (Tr.done) {
          if (v(Te, Pn), Pa()) {
            var Br = kr;
            _y(Te, Br);
          }
          return an;
        }
        if (Pn === null) {
          for (; !Tr.done; kr++, Tr = _t.next()) {
            var ho = z(Te, Tr.value, nt);
            ho !== null && (Fn = a(ho, Fn, kr), Gt === null ? an = ho : Gt.sibling = ho, Gt = ho);
          }
          if (Pa()) {
            var Ro = kr;
            _y(Te, Ro);
          }
          return an;
        }
        for (var nl = _(Te, Pn); !Tr.done; kr++, Tr = _t.next()) {
          var ta = X(nl, Te, kr, Tr.value, nt);
          ta !== null && (l && ta.alternate !== null && nl.delete(ta.key === null ? kr : ta.key), Fn = a(ta, Fn, kr), Gt === null ? an = ta : Gt.sibling = ta, Gt = ta);
        }
        if (l && nl.forEach(function (z0) {
          return u(Te, z0);
        }), Pa()) {
          var Pm = kr;
          _y(Te, Pm);
        }
        return an;
      }
      function Ie(Te, Ue, Ve, nt) {
        if (Ue !== null && Ue.tag === I) {
          v(Te, Ue.sibling);
          var ke = n(Ue, Ve);
          return ke.return = Te, ke;
        }
        v(Te, Ue);
        var Fe = qk(Ve, Te.mode, nt);
        return Fe.return = Te, Fe;
      }
      function Pe(Te, Ue, Ve, nt) {
        for (var ke = Ve.key, Fe = Ue; Fe !== null;) {
          if (Fe.key === ke) {
            var De = Ve.type;
            if (De === Lo) {
              if (Fe.tag === L) {
                v(Te, Fe.sibling);
                var Qe = n(Fe, Ve.props.children);
                return Qe.return = Te, Qe._debugSource = Ve._source, Qe._debugOwner = Ve._owner, Qe;
              }
            } else if (Fe.elementType === De ||
            // Keep this check inline so it only runs on the false path:
            PI(Fe, Ve) ||
            // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof De == "object" && De !== null && De.$$typeof === Ct && P_(De) === Fe.type) {
              v(Te, Fe.sibling);
              var Tt = n(Fe, Ve.props);
              return Tt.ref = Ty(Te, Fe, Ve), Tt.return = Te, Tt._debugSource = Ve._source, Tt._debugOwner = Ve._owner, Tt;
            }
            v(Te, Fe);
            break;
          } else u(Te, Fe);
          Fe = Fe.sibling;
        }
        if (Ve.type === Lo) {
          var _t = zv(Ve.props.children, Te.mode, nt, Ve.key);
          return _t.return = Te, _t;
        } else {
          var an = Lm(Ve, Te.mode, nt);
          return an.ref = Ty(Te, Ue, Ve), an.return = Te, an;
        }
      }
      function $e(Te, Ue, Ve, nt) {
        for (var ke = Ve.key, Fe = Ue; Fe !== null;) {
          if (Fe.key === ke) {
            if (Fe.tag === k && Fe.stateNode.containerInfo === Ve.containerInfo && Fe.stateNode.implementation === Ve.implementation) {
              v(Te, Fe.sibling);
              var De = n(Fe, Ve.children || []);
              return De.return = Te, De;
            } else {
              v(Te, Fe);
              break;
            }
          } else u(Te, Fe);
          Fe = Fe.sibling;
        }
        var Qe = M1(Ve, Te.mode, nt);
        return Qe.return = Te, Qe;
      }
      function mt(Te, Ue, Ve, nt) {
        var ke = typeof Ve == "object" && Ve !== null && Ve.type === Lo && Ve.key === null;
        if (ke && (Ve = Ve.props.children), typeof Ve == "object" && Ve !== null) {
          switch (Ve.$$typeof) {
            case $i:
              return f(Pe(Te, Ue, Ve, nt));
            case oi:
              return f($e(Te, Ue, Ve, nt));
            case Ct:
              var Fe = Ve._payload,
                De = Ve._init;
              return mt(Te, Ue, De(Fe), nt);
          }
          if (wr(Ve)) return me(Te, Ue, Ve, nt);
          if (yn(Ve)) return xe(Te, Ue, Ve, nt);
          O_(Te, Ve);
        }
        return typeof Ve == "string" && Ve !== "" || typeof Ve == "number" ? f(Ie(Te, Ue, "" + Ve, nt)) : (typeof Ve == "function" && wv(Te), v(Te, Ue));
      }
      return mt;
    }
    var Ry = A_(!0),
      AC = A_(!1);
    function r0(l, u) {
      if (l !== null && u.child !== l.child) throw new Error("Resuming work not yet implemented.");
      if (u.child !== null) {
        var v = u.child,
          _ = tl(v, v.pendingProps);
        for (u.child = _, _.return = u; v.sibling !== null;) v = v.sibling, _ = _.sibling = tl(v, v.pendingProps), _.return = u;
        _.sibling = null;
      }
    }
    function LD(l, u) {
      for (var v = l.child; v !== null;) Uk(v, u), v = v.sibling;
    }
    var j_ = {},
      _v = Cf(j_),
      _m = Cf(j_),
      Pf = Cf(j_);
    function xv(l) {
      if (l === j_) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return l;
    }
    function F_() {
      var l = xv(Pf.current);
      return l;
    }
    function i0(l, u) {
      ka(Pf, u, l), ka(_m, l, l), ka(_v, j_, l);
      var v = rC(u);
      ca(_v, l), ka(_v, v, l);
    }
    function Dy(l) {
      ca(_v, l), ca(_m, l), ca(Pf, l);
    }
    function N_() {
      var l = xv(_v.current);
      return l;
    }
    function Iy(l) {
      xv(Pf.current);
      var u = xv(_v.current),
        v = LO(u, l.type);
      u !== v && (ka(_m, l, l), ka(_v, v, l));
    }
    function z_(l) {
      _m.current === l && (ca(_v, l), ca(_m, l));
    }
    var OD = 0,
      HS = 1,
      PD = 1,
      a0 = 2,
      $c = Cf(OD);
    function My(l, u) {
      return (l & u) !== 0;
    }
    function ps(l) {
      return l & HS;
    }
    function V_(l, u) {
      return l & HS | u;
    }
    function o0(l, u) {
      return l | u;
    }
    function vp(l, u) {
      ka($c, u, l);
    }
    function l0(l) {
      ca($c, l);
    }
    function Sv(l, u) {
      var v = l.memoizedState;
      return v !== null ? v.dehydrated !== null : (l.memoizedProps, !0);
    }
    function xm(l) {
      for (var u = l; u !== null;) {
        if (u.tag === V) {
          var v = u.memoizedState;
          if (v !== null) {
            var _ = v.dehydrated;
            if (_ === null || vD(_) || cC(_)) return u;
          }
        } else if (u.tag === Y &&
        // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        u.memoizedProps.revealOrder !== void 0) {
          var n = (u.flags & ft) !== pt;
          if (n) return u;
        } else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === l) return null;
        for (; u.sibling === null;) {
          if (u.return === null || u.return === l) return null;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return null;
    }
    var gu = /*   */
      0,
      ja = /* */
      1,
      Ta = /*  */
      2,
      Er = /*    */
      4,
      Ui = /*   */
      8,
      so = [];
    function Qo() {
      for (var l = 0; l < so.length; l++) {
        var u = so[l];
        u._workInProgressVersionPrimary = null;
      }
      so.length = 0;
    }
    function jC(l, u) {
      var v = u._getVersion,
        _ = v(u._source);
      l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [u, _] : l.mutableSourceEagerHydrationData.push(u, _);
    }
    var Zt = i.ReactCurrentDispatcher,
      B_ = i.ReactCurrentBatchConfig,
      Jt,
      gp;
    Jt = /* @__PURE__ */new Set();
    var Sm = Re,
      Lr = null,
      ea = null,
      zn = null,
      Fa = !1,
      Ra = !1,
      Ev = 0,
      U_ = 0,
      H_ = 25,
      ct = null,
      Wc = null,
      st = -1,
      yu = !1;
    function vr() {
      {
        var l = ct;
        Wc === null ? Wc = [l] : Wc.push(l);
      }
    }
    function Ut() {
      {
        var l = ct;
        Wc !== null && (st++, Wc[st] !== l && Yt(l));
      }
    }
    function Cr(l) {
      l != null && !wr(l) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ct, typeof l);
    }
    function Yt(l) {
      {
        var u = At(Lr);
        if (!Jt.has(u) && (Jt.add(u), Wc !== null)) {
          for (var v = "", _ = 30, n = 0; n <= st; n++) {
            for (var a = Wc[n], f = n === st ? l : a, m = n + 1 + ". " + a; m.length < _;) m += " ";
            m += f + `
`, v += m;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, u, v);
        }
      }
    }
    function uo() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function FC(l, u) {
      if (yu) return !1;
      if (u === null) return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ct), !1;
      l.length !== u.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ct, "[" + u.join(", ") + "]", "[" + l.join(", ") + "]");
      for (var v = 0; v < u.length && v < l.length; v++) if (!oe(l[v], u[v])) return !1;
      return !0;
    }
    function co(l, u, v, _, n, a) {
      Sm = a, Lr = u, Wc = l !== null ? l._debugHookTypes : null, st = -1, yu = l !== null && l.type !== u.type, u.memoizedState = null, u.updateQueue = null, u.lanes = Re, l !== null && l.memoizedState !== null ? Zt.current = qC : Wc !== null ? Zt.current = WC : Zt.current = $C;
      var f = v(_, n);
      if (Ra) {
        var m = 0;
        do {
          if (Ra = !1, Ev = 0, m >= H_) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          m += 1, yu = !1, ea = null, zn = null, u.updateQueue = null, st = -1, Zt.current = rx, f = v(_, n);
        } while (Ra);
      }
      Zt.current = nx, u._debugHookTypes = Wc;
      var b = ea !== null && ea.next !== null;
      if (Sm = Re, Lr = null, ea = null, zn = null, ct = null, Wc = null, st = -1, l !== null && (l.flags & nr) !== (u.flags & nr) &&
      // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (l.mode & Wt) !== dt && h("Internal React error: Expected static flag was missing. Please notify the React team."), Fa = !1, b) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return f;
    }
    function Cv() {
      var l = Ev !== 0;
      return Ev = 0, l;
    }
    function Ly(l, u, v) {
      u.updateQueue = l.updateQueue, (u.mode & Ri) !== dt ? u.flags &= -50333701 : u.flags &= -2053, l.lanes = ac(l.lanes, v);
    }
    function Oy() {
      if (Zt.current = nx, Fa) {
        for (var l = Lr.memoizedState; l !== null;) {
          var u = l.queue;
          u !== null && (u.pending = null), l = l.next;
        }
        Fa = !1;
      }
      Sm = Re, Lr = null, ea = null, zn = null, Wc = null, st = -1, ct = null, AD = !1, Ra = !1, Ev = 0;
    }
    function Af() {
      var l = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return zn === null ? Lr.memoizedState = zn = l : zn = zn.next = l, zn;
    }
    function _c() {
      var l;
      if (ea === null) {
        var u = Lr.alternate;
        u !== null ? l = u.memoizedState : l = null;
      } else l = ea.next;
      var v;
      if (zn === null ? v = Lr.memoizedState : v = zn.next, v !== null) zn = v, v = zn.next, ea = l;else {
        if (l === null) throw new Error("Rendered more hooks than during the previous render.");
        ea = l;
        var _ = {
          memoizedState: ea.memoizedState,
          baseState: ea.baseState,
          baseQueue: ea.baseQueue,
          queue: ea.queue,
          next: null
        };
        zn === null ? Lr.memoizedState = zn = _ : zn = zn.next = _;
      }
      return zn;
    }
    function jf() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function bu(l, u) {
      return typeof u == "function" ? u(l) : u;
    }
    function $S(l, u, v) {
      var _ = Af(),
        n;
      v !== void 0 ? n = v(u) : n = u, _.memoizedState = _.baseState = n;
      var a = {
        pending: null,
        interleaved: null,
        lanes: Re,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: n
      };
      _.queue = a;
      var f = a.dispatch = jD.bind(null, Lr, a);
      return [_.memoizedState, f];
    }
    function $_(l, u, v) {
      var _ = _c(),
        n = _.queue;
      if (n === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      n.lastRenderedReducer = l;
      var a = ea,
        f = a.baseQueue,
        m = n.pending;
      if (m !== null) {
        if (f !== null) {
          var b = f.next,
            T = m.next;
          f.next = T, m.next = b;
        }
        a.baseQueue !== f && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), a.baseQueue = f = m, n.pending = null;
      }
      if (f !== null) {
        var M = f.next,
          z = a.baseState,
          U = null,
          X = null,
          J = null,
          me = M;
        do {
          var xe = me.lane;
          if ($l(Sm, xe)) {
            if (J !== null) {
              var Ie = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ln,
                action: me.action,
                hasEagerState: me.hasEagerState,
                eagerState: me.eagerState,
                next: null
              };
              J = J.next = Ie;
            }
            if (me.hasEagerState) z = me.eagerState;else {
              var Pe = me.action;
              z = l(z, Pe);
            }
          } else {
            var $e = {
              lane: xe,
              action: me.action,
              hasEagerState: me.hasEagerState,
              eagerState: me.eagerState,
              next: null
            };
            J === null ? (X = J = $e, U = z) : J = J.next = $e, Lr.lanes = jt(Lr.lanes, xe), O0(xe);
          }
          me = me.next;
        } while (me !== null && me !== M);
        J === null ? U = z : J.next = X, oe(z, _.memoizedState) || x0(), _.memoizedState = z, _.baseState = U, _.baseQueue = J, n.lastRenderedState = z;
      }
      var mt = n.interleaved;
      if (mt !== null) {
        var Te = mt;
        do {
          var Ue = Te.lane;
          Lr.lanes = jt(Lr.lanes, Ue), O0(Ue), Te = Te.next;
        } while (Te !== mt);
      } else f === null && (n.lanes = Re);
      var Ve = n.dispatch;
      return [_.memoizedState, Ve];
    }
    function W_(l, u, v) {
      var _ = _c(),
        n = _.queue;
      if (n === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      n.lastRenderedReducer = l;
      var a = n.dispatch,
        f = n.pending,
        m = _.memoizedState;
      if (f !== null) {
        n.pending = null;
        var b = f.next,
          T = b;
        do {
          var M = T.action;
          m = l(m, M), T = T.next;
        } while (T !== b);
        oe(m, _.memoizedState) || x0(), _.memoizedState = m, _.baseQueue === null && (_.baseState = m), n.lastRenderedState = m;
      }
      return [m, a];
    }
    function q_(l, u, v) {
      var _ = Lr,
        n = Af(),
        a,
        f = Pa();
      if (f) {
        if (v === void 0) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        a = v(), gp || a !== v() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), gp = !0);
      } else {
        if (a = u(), !gp) {
          var m = u();
          oe(a, m) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), gp = !0);
        }
        var b = Zy();
        if (b === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gs(b, Sm) || PP(_, u, a);
      }
      n.memoizedState = a;
      var T = {
        value: a,
        getSnapshot: u
      };
      return n.queue = T, f0(WS.bind(null, _, T, l), [l]), _.flags |= Yr, u0(ja | Ui, AP.bind(null, _, T, a, u), void 0, null), a;
    }
    function s0(l, u, v) {
      var _ = Lr,
        n = _c(),
        a = u();
      if (!gp) {
        var f = u();
        oe(a, f) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), gp = !0);
      }
      var m = n.memoizedState,
        b = !oe(m, a);
      b && (n.memoizedState = a, x0());
      var T = n.queue;
      if (Tv(WS.bind(null, _, T, l), [l]), T.getSnapshot !== u || b ||
      // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      zn !== null && zn.memoizedState.tag & ja) {
        _.flags |= Yr, u0(ja | Ui, AP.bind(null, _, T, a, u), void 0, null);
        var M = Zy();
        if (M === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gs(M, Sm) || PP(_, u, a);
      }
      return a;
    }
    function PP(l, u, v) {
      l.flags |= As;
      var _ = {
          getSnapshot: u,
          value: v
        },
        n = Lr.updateQueue;
      if (n === null) n = jf(), Lr.updateQueue = n, n.stores = [_];else {
        var a = n.stores;
        a === null ? n.stores = [_] : a.push(_);
      }
    }
    function AP(l, u, v, _) {
      u.value = v, u.getSnapshot = _, Y_(u) && NC(l);
    }
    function WS(l, u, v) {
      var _ = function () {
        Y_(u) && NC(l);
      };
      return v(_);
    }
    function Y_(l) {
      var u = l.getSnapshot,
        v = l.value;
      try {
        var _ = u();
        return !oe(v, _);
      } catch {
        return !0;
      }
    }
    function NC(l) {
      var u = vu(l, Je);
      u !== null && Ba(u, l, Je, wn);
    }
    function G_(l) {
      var u = Af();
      typeof l == "function" && (l = l()), u.memoizedState = u.baseState = l;
      var v = {
        pending: null,
        interleaved: null,
        lanes: Re,
        dispatch: null,
        lastRenderedReducer: bu,
        lastRenderedState: l
      };
      u.queue = v;
      var _ = v.dispatch = jP.bind(null, Lr, v);
      return [u.memoizedState, _];
    }
    function qS(l) {
      return $_(bu);
    }
    function YS(l) {
      return W_(bu);
    }
    function u0(l, u, v, _) {
      var n = {
          tag: l,
          create: u,
          destroy: v,
          deps: _,
          // Circular
          next: null
        },
        a = Lr.updateQueue;
      if (a === null) a = jf(), Lr.updateQueue = a, a.lastEffect = n.next = n;else {
        var f = a.lastEffect;
        if (f === null) a.lastEffect = n.next = n;else {
          var m = f.next;
          f.next = n, n.next = m, a.lastEffect = n;
        }
      }
      return n;
    }
    function c0(l) {
      var u = Af();
      {
        var v = {
          current: l
        };
        return u.memoizedState = v, v;
      }
    }
    function d0(l) {
      var u = _c();
      return u.memoizedState;
    }
    function Py(l, u, v, _) {
      var n = Af(),
        a = _ === void 0 ? null : _;
      Lr.flags |= l, n.memoizedState = u0(ja | u, v, void 0, a);
    }
    function kv(l, u, v, _) {
      var n = _c(),
        a = _ === void 0 ? null : _,
        f = void 0;
      if (ea !== null) {
        var m = ea.memoizedState;
        if (f = m.destroy, a !== null) {
          var b = m.deps;
          if (FC(a, b)) {
            n.memoizedState = u0(u, v, f, a);
            return;
          }
        }
      }
      Lr.flags |= l, n.memoizedState = u0(ja | u, v, f, a);
    }
    function f0(l, u) {
      return (Lr.mode & Ri) !== dt ? Py(ga | Yr | zd, Ui, l, u) : Py(Yr | zd, Ui, l, u);
    }
    function Tv(l, u) {
      return kv(Yr, Ui, l, u);
    }
    function Ay(l, u) {
      return Py(tn, Ta, l, u);
    }
    function jy(l, u) {
      return kv(tn, Ta, l, u);
    }
    function p0(l, u) {
      var v = tn;
      return v |= Za, (Lr.mode & Ri) !== dt && (v |= Bo), Py(v, Er, l, u);
    }
    function Rv(l, u) {
      return kv(tn, Er, l, u);
    }
    function GS(l, u) {
      if (typeof u == "function") {
        var v = u,
          _ = l();
        return v(_), function () {
          v(null);
        };
      } else if (u != null) {
        var n = u;
        n.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(n).join(", ") + "}");
        var a = l();
        return n.current = a, function () {
          n.current = null;
        };
      }
    }
    function h0(l, u, v) {
      typeof u != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var _ = v != null ? v.concat([l]) : null,
        n = tn;
      return n |= Za, (Lr.mode & Ri) !== dt && (n |= Bo), Py(n, Er, GS.bind(null, u, l), _);
    }
    function m0(l, u, v) {
      typeof u != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", u !== null ? typeof u : "null");
      var _ = v != null ? v.concat([l]) : null;
      return kv(tn, Er, GS.bind(null, u, l), _);
    }
    function XS(l, u) {}
    var X_ = XS;
    function K_(l, u) {
      var v = Af(),
        _ = u === void 0 ? null : u;
      return v.memoizedState = [l, _], l;
    }
    function Fy(l, u) {
      var v = _c(),
        _ = u === void 0 ? null : u,
        n = v.memoizedState;
      if (n !== null && _ !== null) {
        var a = n[1];
        if (FC(_, a)) return n[0];
      }
      return v.memoizedState = [l, _], l;
    }
    function zC(l, u) {
      var v = Af(),
        _ = u === void 0 ? null : u,
        n = l();
      return v.memoizedState = [n, _], n;
    }
    function Ny(l, u) {
      var v = _c(),
        _ = u === void 0 ? null : u,
        n = v.memoizedState;
      if (n !== null && _ !== null) {
        var a = n[1];
        if (FC(_, a)) return n[0];
      }
      var f = l();
      return v.memoizedState = [f, _], f;
    }
    function Q_(l) {
      var u = Af();
      return u.memoizedState = l, l;
    }
    function Z_(l) {
      var u = _c(),
        v = ea,
        _ = v.memoizedState;
      return J_(u, _, l);
    }
    function KS(l) {
      var u = _c();
      if (ea === null) return u.memoizedState = l, l;
      var v = ea.memoizedState;
      return J_(u, v, l);
    }
    function J_(l, u, v) {
      var _ = !Ys(Sm);
      if (_) {
        if (!oe(v, u)) {
          var n = Vh();
          Lr.lanes = jt(Lr.lanes, n), O0(n), l.baseState = !0;
        }
        return u;
      } else return l.baseState && (l.baseState = !1, x0()), l.memoizedState = v, v;
    }
    function VC(l, u, v) {
      var _ = Ir();
      zr(Uh(_, Ii)), l(!0);
      var n = B_.transition;
      B_.transition = {};
      var a = B_.transition;
      B_.transition._updatedFibers = /* @__PURE__ */new Set();
      try {
        l(!1), u();
      } finally {
        if (zr(_), B_.transition = n, n === null && a._updatedFibers) {
          var f = a._updatedFibers.size;
          f > 10 && p("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), a._updatedFibers.clear();
        }
      }
    }
    function QS() {
      var l = G_(!1),
        u = l[0],
        v = l[1],
        _ = VC.bind(null, v),
        n = Af();
      return n.memoizedState = _, [u, _];
    }
    function BC() {
      var l = qS(),
        u = l[0],
        v = _c(),
        _ = v.memoizedState;
      return [u, _];
    }
    function UC() {
      var l = YS(),
        u = l[0],
        v = _c(),
        _ = v.memoizedState;
      return [u, _];
    }
    var AD = !1;
    function HC() {
      return AD;
    }
    function ZS() {
      var l = Af(),
        u = Zy(),
        v = u.identifierPrefix,
        _;
      if (Pa()) {
        var n = SP();
        _ = ":" + v + "R" + n;
        var a = Ev++;
        a > 0 && (_ += "H" + a.toString(32)), _ += ":";
      } else {
        var f = U_++;
        _ = ":" + v + "r" + f.toString(32) + ":";
      }
      return l.memoizedState = _, _;
    }
    function ex() {
      var l = _c(),
        u = l.memoizedState;
      return u;
    }
    function jD(l, u, v) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var _ = Zf(l),
        n = {
          lane: _,
          action: v,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (JS(l)) tx(u, n);else {
        var a = LS(l, u, n, _);
        if (a !== null) {
          var f = el();
          Ba(a, l, _, f), FD(a, u, _);
        }
      }
      ND(l, _);
    }
    function jP(l, u, v) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var _ = Zf(l),
        n = {
          lane: _,
          action: v,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (JS(l)) tx(u, n);else {
        var a = l.alternate;
        if (l.lanes === Re && (a === null || a.lanes === Re)) {
          var f = u.lastRenderedReducer;
          if (f !== null) {
            var m;
            m = Zt.current, Zt.current = qc;
            try {
              var b = u.lastRenderedState,
                T = f(b, v);
              if (n.hasEagerState = !0, n.eagerState = T, oe(T, b)) {
                MP(l, u, n, _);
                return;
              }
            } catch {} finally {
              Zt.current = m;
            }
          }
        }
        var M = LS(l, u, n, _);
        if (M !== null) {
          var z = el();
          Ba(M, l, _, z), FD(M, u, _);
        }
      }
      ND(l, _);
    }
    function JS(l) {
      var u = l.alternate;
      return l === Lr || u !== null && u === Lr;
    }
    function tx(l, u) {
      Ra = Fa = !0;
      var v = l.pending;
      v === null ? u.next = u : (u.next = v.next, v.next = u), l.pending = u;
    }
    function FD(l, u, v) {
      if (zh(v)) {
        var _ = u.lanes;
        _ = Bh(_, l.pendingLanes);
        var n = jt(_, v);
        u.lanes = n, uf(l, n);
      }
    }
    function ND(l, u, v) {
      Bl(l, u);
    }
    var nx = {
        readContext: ko,
        useCallback: uo,
        useContext: uo,
        useEffect: uo,
        useImperativeHandle: uo,
        useInsertionEffect: uo,
        useLayoutEffect: uo,
        useMemo: uo,
        useReducer: uo,
        useRef: uo,
        useState: uo,
        useDebugValue: uo,
        useDeferredValue: uo,
        useTransition: uo,
        useMutableSource: uo,
        useSyncExternalStore: uo,
        useId: uo,
        unstable_isNewReconciler: $
      },
      $C = null,
      WC = null,
      qC = null,
      rx = null,
      Ff = null,
      qc = null,
      ix = null;
    {
      var e1 = function () {
          h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        },
        xn = function () {
          h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
      $C = {
        readContext: function (l) {
          return ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", vr(), Cr(u), K_(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", vr(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", vr(), Cr(u), f0(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", vr(), Cr(v), h0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", vr(), Cr(u), Ay(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", vr(), Cr(u), p0(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", vr(), Cr(u);
          var v = Zt.current;
          Zt.current = Ff;
          try {
            return zC(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", vr();
          var _ = Zt.current;
          Zt.current = Ff;
          try {
            return $S(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", vr(), c0(l);
        },
        useState: function (l) {
          ct = "useState", vr();
          var u = Zt.current;
          Zt.current = Ff;
          try {
            return G_(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", vr(), void 0;
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", vr(), Q_(l);
        },
        useTransition: function () {
          return ct = "useTransition", vr(), QS();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", vr(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", vr(), q_(l, u, v);
        },
        useId: function () {
          return ct = "useId", vr(), ZS();
        },
        unstable_isNewReconciler: $
      }, WC = {
        readContext: function (l) {
          return ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", Ut(), K_(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", Ut(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", Ut(), f0(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", Ut(), h0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", Ut(), Ay(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", Ut(), p0(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = Ff;
          try {
            return zC(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = Ff;
          try {
            return $S(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", Ut(), c0(l);
        },
        useState: function (l) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = Ff;
          try {
            return G_(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", Ut(), void 0;
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", Ut(), Q_(l);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), QS();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", Ut(), q_(l, u, v);
        },
        useId: function () {
          return ct = "useId", Ut(), ZS();
        },
        unstable_isNewReconciler: $
      }, qC = {
        readContext: function (l) {
          return ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", Ut(), Fy(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", Ut(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", Ut(), Tv(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", Ut(), m0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", Ut(), jy(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", Ut(), Rv(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return $_(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", Ut(), d0();
        },
        useState: function (l) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return qS(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", Ut(), X_();
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", Ut(), Z_(l);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), BC();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", Ut(), s0(l, u);
        },
        useId: function () {
          return ct = "useId", Ut(), ex();
        },
        unstable_isNewReconciler: $
      }, rx = {
        readContext: function (l) {
          return ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", Ut(), Fy(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", Ut(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", Ut(), Tv(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", Ut(), m0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", Ut(), jy(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", Ut(), Rv(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", Ut();
          var v = Zt.current;
          Zt.current = ix;
          try {
            return Ny(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", Ut();
          var _ = Zt.current;
          Zt.current = ix;
          try {
            return W_(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", Ut(), d0();
        },
        useState: function (l) {
          ct = "useState", Ut();
          var u = Zt.current;
          Zt.current = ix;
          try {
            return YS(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", Ut(), X_();
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", Ut(), KS(l);
        },
        useTransition: function () {
          return ct = "useTransition", Ut(), UC();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", Ut(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", Ut(), s0(l, u);
        },
        useId: function () {
          return ct = "useId", Ut(), ex();
        },
        unstable_isNewReconciler: $
      }, Ff = {
        readContext: function (l) {
          return e1(), ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", xn(), vr(), K_(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", xn(), vr(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", xn(), vr(), f0(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", xn(), vr(), h0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", xn(), vr(), Ay(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", xn(), vr(), p0(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", xn(), vr();
          var v = Zt.current;
          Zt.current = Ff;
          try {
            return zC(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", xn(), vr();
          var _ = Zt.current;
          Zt.current = Ff;
          try {
            return $S(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", xn(), vr(), c0(l);
        },
        useState: function (l) {
          ct = "useState", xn(), vr();
          var u = Zt.current;
          Zt.current = Ff;
          try {
            return G_(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", xn(), vr(), void 0;
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", xn(), vr(), Q_(l);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), vr(), QS();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", xn(), vr(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", xn(), vr(), q_(l, u, v);
        },
        useId: function () {
          return ct = "useId", xn(), vr(), ZS();
        },
        unstable_isNewReconciler: $
      }, qc = {
        readContext: function (l) {
          return e1(), ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", xn(), Ut(), Fy(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", xn(), Ut(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", xn(), Ut(), Tv(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", xn(), Ut(), m0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", xn(), Ut(), jy(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", xn(), Ut(), Rv(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", xn(), Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", xn(), Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return $_(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", xn(), Ut(), d0();
        },
        useState: function (l) {
          ct = "useState", xn(), Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return qS(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", xn(), Ut(), X_();
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", xn(), Ut(), Z_(l);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), Ut(), BC();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", xn(), Ut(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", xn(), Ut(), s0(l, u);
        },
        useId: function () {
          return ct = "useId", xn(), Ut(), ex();
        },
        unstable_isNewReconciler: $
      }, ix = {
        readContext: function (l) {
          return e1(), ko(l);
        },
        useCallback: function (l, u) {
          return ct = "useCallback", xn(), Ut(), Fy(l, u);
        },
        useContext: function (l) {
          return ct = "useContext", xn(), Ut(), ko(l);
        },
        useEffect: function (l, u) {
          return ct = "useEffect", xn(), Ut(), Tv(l, u);
        },
        useImperativeHandle: function (l, u, v) {
          return ct = "useImperativeHandle", xn(), Ut(), m0(l, u, v);
        },
        useInsertionEffect: function (l, u) {
          return ct = "useInsertionEffect", xn(), Ut(), jy(l, u);
        },
        useLayoutEffect: function (l, u) {
          return ct = "useLayoutEffect", xn(), Ut(), Rv(l, u);
        },
        useMemo: function (l, u) {
          ct = "useMemo", xn(), Ut();
          var v = Zt.current;
          Zt.current = qc;
          try {
            return Ny(l, u);
          } finally {
            Zt.current = v;
          }
        },
        useReducer: function (l, u, v) {
          ct = "useReducer", xn(), Ut();
          var _ = Zt.current;
          Zt.current = qc;
          try {
            return W_(l, u, v);
          } finally {
            Zt.current = _;
          }
        },
        useRef: function (l) {
          return ct = "useRef", xn(), Ut(), d0();
        },
        useState: function (l) {
          ct = "useState", xn(), Ut();
          var u = Zt.current;
          Zt.current = qc;
          try {
            return YS(l);
          } finally {
            Zt.current = u;
          }
        },
        useDebugValue: function (l, u) {
          return ct = "useDebugValue", xn(), Ut(), X_();
        },
        useDeferredValue: function (l) {
          return ct = "useDeferredValue", xn(), Ut(), KS(l);
        },
        useTransition: function () {
          return ct = "useTransition", xn(), Ut(), UC();
        },
        useMutableSource: function (l, u, v) {
          return ct = "useMutableSource", xn(), Ut(), void 0;
        },
        useSyncExternalStore: function (l, u, v) {
          return ct = "useSyncExternalStore", xn(), Ut(), s0(l, u);
        },
        useId: function () {
          return ct = "useId", xn(), Ut(), ex();
        },
        unstable_isNewReconciler: $
      };
    }
    var gl = e.unstable_now,
      ax = 0,
      v0 = -1,
      Dn = -1,
      Nf = -1,
      t1 = !1,
      zy = !1;
    function g0() {
      return t1;
    }
    function n1() {
      zy = !0;
    }
    function YC() {
      t1 = !1, zy = !1;
    }
    function r1() {
      t1 = zy, zy = !1;
    }
    function GC() {
      return ax;
    }
    function zD() {
      ax = gl();
    }
    function XC(l) {
      Dn = gl(), l.actualStartTime < 0 && (l.actualStartTime = gl());
    }
    function VD(l) {
      Dn = -1;
    }
    function ox(l, u) {
      if (Dn >= 0) {
        var v = gl() - Dn;
        l.actualDuration += v, u && (l.selfBaseDuration = v), Dn = -1;
      }
    }
    function zf(l) {
      if (v0 >= 0) {
        var u = gl() - v0;
        v0 = -1;
        for (var v = l.return; v !== null;) {
          switch (v.tag) {
            case C:
              var _ = v.stateNode;
              _.effectDuration += u;
              return;
            case j:
              var n = v.stateNode;
              n.effectDuration += u;
              return;
          }
          v = v.return;
        }
      }
    }
    function lx(l) {
      if (Nf >= 0) {
        var u = gl() - Nf;
        Nf = -1;
        for (var v = l.return; v !== null;) {
          switch (v.tag) {
            case C:
              var _ = v.stateNode;
              _ !== null && (_.passiveEffectDuration += u);
              return;
            case j:
              var n = v.stateNode;
              n !== null && (n.passiveEffectDuration += u);
              return;
          }
          v = v.return;
        }
      }
    }
    function Vf() {
      v0 = gl();
    }
    function y0() {
      Nf = gl();
    }
    function Yc(l) {
      for (var u = l.child; u;) l.actualDuration += u.actualDuration, u = u.sibling;
    }
    function Em(l, u) {
      return {
        value: l,
        source: u,
        stack: pd(u),
        digest: null
      };
    }
    function Gc(l, u, v) {
      return {
        value: l,
        source: null,
        stack: v ?? null,
        digest: u ?? null
      };
    }
    function KC(l, u) {
      return !0;
    }
    function sx(l, u) {
      try {
        var v = KC(l, u);
        if (v === !1) return;
        var _ = u.value,
          n = u.source,
          a = u.stack,
          f = a !== null ? a : "";
        if (_ != null && _._suppressLogging) {
          if (l.tag === x) return;
          console.error(_);
        }
        var m = n ? At(n) : null,
          b = m ? "The above error occurred in the <" + m + "> component:" : "The above error occurred in one of your React components:",
          T;
        if (l.tag === C) T = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;else {
          var M = At(l) || "Anonymous";
          T = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + M + ".");
        }
        var z = b + `
` + f + `

` + ("" + T);
        console.error(z);
      } catch (U) {
        setTimeout(function () {
          throw U;
        });
      }
    }
    var Vy = typeof WeakMap == "function" ? WeakMap : Map;
    function i1(l, u, v) {
      var _ = Of(wn, v);
      _.tag = OS, _.payload = {
        element: null
      };
      var n = u.value;
      return _.callback = function () {
        IA(n), sx(l, u);
      }, _;
    }
    function QC(l, u, v) {
      var _ = Of(wn, v);
      _.tag = OS;
      var n = l.type.getDerivedStateFromError;
      if (typeof n == "function") {
        var a = u.value;
        _.payload = function () {
          return n(a);
        }, _.callback = function () {
          nb(l), sx(l, u);
        };
      }
      var f = l.stateNode;
      return f !== null && typeof f.componentDidCatch == "function" && (_.callback = function () {
        nb(l), sx(l, u), typeof n != "function" && Mm(this);
        var m = u.value,
          b = u.stack;
        this.componentDidCatch(m, {
          componentStack: b !== null ? b : ""
        }), typeof n != "function" && (_n(l.lanes, Je) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", At(l) || "Unknown"));
      }), _;
    }
    function a1(l, u, v) {
      var _ = l.pingCache,
        n;
      if (_ === null ? (_ = l.pingCache = new Vy(), n = /* @__PURE__ */new Set(), _.set(u, n)) : (n = _.get(u), n === void 0 && (n = /* @__PURE__ */new Set(), _.set(u, n))), !n.has(v)) {
        n.add(v);
        var a = MA.bind(null, l, u, v);
        ui && kx(l, v), u.then(a, a);
      }
    }
    function FP(l, u, v, _) {
      var n = l.updateQueue;
      if (n === null) {
        var a = /* @__PURE__ */new Set();
        a.add(v), l.updateQueue = a;
      } else n.add(v);
    }
    function BD(l, u) {
      var v = l.tag;
      if ((l.mode & Wt) === dt && (v === w || v === F || v === G)) {
        var _ = l.alternate;
        _ ? (l.updateQueue = _.updateQueue, l.memoizedState = _.memoizedState, l.lanes = _.lanes) : (l.updateQueue = null, l.memoizedState = null);
      }
    }
    function o1(l) {
      var u = l;
      do {
        if (u.tag === V && Sv(u)) return u;
        u = u.return;
      } while (u !== null);
      return null;
    }
    function ZC(l, u, v, _, n) {
      if ((l.mode & Wt) === dt) {
        if (l === u) l.flags |= Gr;else {
          if (l.flags |= ft, v.flags |= Nd, v.flags &= -52805, v.tag === x) {
            var a = v.alternate;
            if (a === null) v.tag = te;else {
              var f = Of(wn, Je);
              f.tag = b_, wm(v, f, Je);
            }
          }
          v.lanes = jt(v.lanes, Je);
        }
        return l;
      }
      return l.flags |= Gr, l.lanes = n, l;
    }
    function NP(l, u, v, _, n) {
      if (v.flags |= Gu, ui && kx(l, n), _ !== null && typeof _ == "object" && typeof _.then == "function") {
        var a = _;
        BD(v), Pa() && v.mode & Wt && hm();
        var f = o1(u);
        if (f !== null) {
          f.flags &= -257, ZC(f, u, v, l, n), f.mode & Wt && a1(l, a, n), FP(f, l, a);
          return;
        } else {
          if (!Pw(n)) {
            a1(l, a, n), x1();
            return;
          }
          var m = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          _ = m;
        }
      } else if (Pa() && v.mode & Wt) {
        hm();
        var b = o1(u);
        if (b !== null) {
          (b.flags & Gr) === pt && (b.flags |= qr), ZC(b, u, v, l, n), RS(Em(_, v));
          return;
        }
      }
      _ = Em(_, v), CA(_);
      var T = u;
      do {
        switch (T.tag) {
          case C:
            {
              var M = _;
              T.flags |= Gr;
              var z = Xs(n);
              T.lanes = jt(T.lanes, z);
              var U = i1(T, M, z);
              mp(T, U);
              return;
            }
          case x:
            var X = _,
              J = T.type,
              me = T.stateNode;
            if ((T.flags & ft) === pt && (typeof J.getDerivedStateFromError == "function" || me !== null && typeof me.componentDidCatch == "function" && !TI(me))) {
              T.flags |= Gr;
              var xe = Xs(n);
              T.lanes = jt(T.lanes, xe);
              var Ie = QC(T, X, xe);
              mp(T, Ie);
              return;
            }
            break;
        }
        T = T.return;
      } while (T !== null);
    }
    function zP() {
      return null;
    }
    var b0 = i.ReactCurrentOwner,
      Xc = !1,
      JC,
      ux,
      By,
      xc,
      cx,
      Bf,
      dx,
      w0;
    JC = {}, ux = {}, By = {}, xc = {}, cx = {}, Bf = !1, dx = {}, w0 = {};
    function is(l, u, v, _) {
      l === null ? u.child = AC(u, null, v, _) : u.child = Ry(u, l.child, v, _);
    }
    function Uy(l, u, v, _) {
      u.child = Ry(u, l.child, null, _), u.child = Ry(u, null, v, _);
    }
    function l1(l, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = v.propTypes;
        a && Vc(a, _,
        // Resolved props
        "prop", bn(v));
      }
      var f = v.render,
        m = u.ref,
        b,
        T;
      Zb(u, n), Ti(u);
      {
        if (b0.current = u, br(!0), b = co(l, u, f, _, m, n), T = Cv(), u.mode & Xn) {
          En(!0);
          try {
            b = co(l, u, f, _, m, n), T = Cv();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), l !== null && !Xc ? (Ly(l, u, n), yp(l, u, n)) : (Pa() && T && pm(u), u.flags |= Xi, is(l, u, b, n), u.child);
    }
    function fx(l, u, v, _, n) {
      if (l === null) {
        var a = v.type;
        if (FI(a) && v.compare === null &&
        // SimpleMemoComponent codepath doesn't resolve outer props either.
        v.defaultProps === void 0) {
          var f = a;
          return f = kp(a), u.tag = G, u.type = f, lk(u, a), hs(l, u, f, _, n);
        }
        {
          var m = a.propTypes;
          m && Vc(m, _,
          // Resolved props
          "prop", bn(a));
        }
        var b = Hk(v.type, null, _, u, u.mode, n);
        return b.ref = u.ref, b.return = u, u.child = b, b;
      }
      {
        var T = v.type,
          M = T.propTypes;
        M && Vc(M, _,
        // Resolved props
        "prop", bn(T));
      }
      var z = l.child,
        U = Hy(l, n);
      if (!U) {
        var X = z.memoizedProps,
          J = v.compare;
        if (J = J !== null ? J : he, J(X, _) && l.ref === u.ref) return yp(l, u, n);
      }
      u.flags |= Xi;
      var me = tl(z, _);
      return me.ref = u.ref, me.return = u, u.child = me, me;
    }
    function hs(l, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = u.elementType;
        if (a.$$typeof === Ct) {
          var f = a,
            m = f._payload,
            b = f._init;
          try {
            a = b(m);
          } catch {
            a = null;
          }
          var T = a && a.propTypes;
          T && Vc(T, _,
          // Resolved (SimpleMemoComponent has no defaultProps)
          "prop", bn(a));
        }
      }
      if (l !== null) {
        var M = l.memoizedProps;
        if (he(M, _) && l.ref === u.ref &&
        // Prevent bailout if the implementation changed due to hot reload.
        u.type === l.type) if (Xc = !1, u.pendingProps = _ = M, Hy(l, n)) (l.flags & Nd) !== pt && (Xc = !0);else return u.lanes = l.lanes, yp(l, u, n);
      }
      return tk(l, u, v, _, n);
    }
    function UD(l, u, v) {
      var _ = u.pendingProps,
        n = _.children,
        a = l !== null ? l.memoizedState : null;
      if (_.mode === "hidden" || H) {
        if ((u.mode & Wt) === dt) {
          var f = {
            baseLanes: Re,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = f, L0(u, v);
        } else if (_n(v, Jr)) {
          var m = {
            baseLanes: Re,
            cachePool: null,
            transitions: null
          };
          u.memoizedState = m;
          var b = a !== null ? a.baseLanes : v;
          L0(u, b);
        } else {
          var T = null,
            M;
          if (a !== null) {
            var z = a.baseLanes;
            M = jt(z, v);
          } else M = v;
          u.lanes = u.childLanes = Jr;
          var U = {
            baseLanes: M,
            cachePool: T,
            transitions: null
          };
          return u.memoizedState = U, u.updateQueue = null, L0(u, M), null;
        }
      } else {
        var X;
        a !== null ? (X = jt(a.baseLanes, v), u.memoizedState = null) : X = v, L0(u, X);
      }
      return is(l, u, n, v), u.child;
    }
    function HD(l, u, v) {
      var _ = u.pendingProps;
      return is(l, u, _, v), u.child;
    }
    function $D(l, u, v) {
      var _ = u.pendingProps.children;
      return is(l, u, _, v), u.child;
    }
    function WD(l, u, v) {
      {
        u.flags |= tn;
        {
          var _ = u.stateNode;
          _.effectDuration = 0, _.passiveEffectDuration = 0;
        }
      }
      var n = u.pendingProps,
        a = n.children;
      return is(l, u, a, v), u.child;
    }
    function ek(l, u) {
      var v = u.ref;
      (l === null && v !== null || l !== null && l.ref !== v) && (u.flags |= Hn, u.flags |= js);
    }
    function tk(l, u, v, _, n) {
      if (u.type !== u.elementType) {
        var a = v.propTypes;
        a && Vc(a, _,
        // Resolved props
        "prop", bn(v));
      }
      var f;
      {
        var m = Js(u, v, !0);
        f = Rf(u, m);
      }
      var b, T;
      Zb(u, n), Ti(u);
      {
        if (b0.current = u, br(!0), b = co(l, u, v, _, f, n), T = Cv(), u.mode & Xn) {
          En(!0);
          try {
            b = co(l, u, v, _, f, n), T = Cv();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), l !== null && !Xc ? (Ly(l, u, n), yp(l, u, n)) : (Pa() && T && pm(u), u.flags |= Xi, is(l, u, b, n), u.child);
    }
    function qD(l, u, v, _, n) {
      {
        switch (WA(u)) {
          case !1:
            {
              var a = u.stateNode,
                f = u.type,
                m = new f(u.memoizedProps, a.context),
                b = m.state;
              a.updater.enqueueSetState(a, b, null);
              break;
            }
          case !0:
            {
              u.flags |= ft, u.flags |= Gr;
              var T = new Error("Simulated error coming from DevTools"),
                M = Xs(n);
              u.lanes = jt(u.lanes, M);
              var z = QC(u, Em(T, u), M);
              mp(u, z);
              break;
            }
        }
        if (u.type !== u.elementType) {
          var U = v.propTypes;
          U && Vc(U, _,
          // Resolved props
          "prop", bn(v));
        }
      }
      var X;
      eu(v) ? (X = !0, d_(u)) : X = !1, Zb(u, n);
      var J = u.stateNode,
        me;
      J === null ? (u1(l, u), DD(u, v, _), MC(u, v, _, n), me = !0) : l === null ? me = MD(u, v, _, n) : me = LC(l, u, v, _, n);
      var xe = nk(l, u, v, me, X, n);
      {
        var Ie = u.stateNode;
        me && Ie.props !== _ && (Bf || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", At(u) || "a component"), Bf = !0);
      }
      return xe;
    }
    function nk(l, u, v, _, n, a) {
      ek(l, u);
      var f = (u.flags & ft) !== pt;
      if (!_ && !f) return n && pC(u, v, !1), yp(l, u, a);
      var m = u.stateNode;
      b0.current = u;
      var b;
      if (f && typeof v.getDerivedStateFromError != "function") b = null, VD();else {
        Ti(u);
        {
          if (br(!0), b = m.render(), u.mode & Xn) {
            En(!0);
            try {
              m.render();
            } finally {
              En(!1);
            }
          }
          br(!1);
        }
        to();
      }
      return u.flags |= Xi, l !== null && f ? Uy(l, u, b, a) : is(l, u, b, a), u.memoizedState = m.state, n && pC(u, v, !0), u.child;
    }
    function rk(l) {
      var u = l.stateNode;
      u.pendingContext ? c_(l, u.pendingContext, u.pendingContext !== u.context) : u.context && c_(l, u.context, !1), i0(l, u.containerInfo);
    }
    function ik(l, u, v) {
      if (rk(u), l === null) throw new Error("Should have a current fiber. This is a bug in React.");
      var _ = u.pendingProps,
        n = u.memoizedState,
        a = n.element;
      x_(l, u), Jb(u, _, null, v);
      var f = u.memoizedState;
      u.stateNode;
      var m = f.element;
      if (n.isDehydrated) {
        var b = {
            element: m,
            isDehydrated: !1,
            cache: f.cache,
            pendingSuspenseBoundaries: f.pendingSuspenseBoundaries,
            transitions: f.transitions
          },
          T = u.updateQueue;
        if (T.baseState = b, u.memoizedState = b, u.flags & qr) {
          var M = Em(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), u);
          return ak(l, u, m, v, M);
        } else if (m !== a) {
          var z = Em(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), u);
          return ak(l, u, m, v, z);
        } else {
          xD(u);
          var U = AC(u, null, m, v);
          u.child = U;
          for (var X = U; X;) X.flags = X.flags & -3 | xi, X = X.sibling;
        }
      } else {
        if (Gb(), m === a) return yp(l, u, v);
        is(l, u, m, v);
      }
      return u.child;
    }
    function ak(l, u, v, _, n) {
      return Gb(), RS(n), u.flags |= qr, is(l, u, v, _), u.child;
    }
    function ok(l, u, v) {
      Iy(u), l === null && p_(u);
      var _ = u.type,
        n = u.pendingProps,
        a = l !== null ? l.memoizedProps : null,
        f = n.children,
        m = iC(_, n);
      return m ? f = null : a !== null && iC(_, a) && (u.flags |= Ki), ek(l, u), is(l, u, f, v), u.child;
    }
    function YD(l, u) {
      return l === null && p_(u), null;
    }
    function VP(l, u, v, _) {
      u1(l, u);
      var n = u.pendingProps,
        a = v,
        f = a._payload,
        m = a._init,
        b = m(f);
      u.type = b;
      var T = u.tag = FA(b),
        M = mu(b, n),
        z;
      switch (T) {
        case w:
          return lk(u, b), u.type = b = kp(b), z = tk(null, u, b, M, _), z;
        case x:
          return u.type = b = Su(b), z = qD(null, u, b, M, _), z;
        case F:
          return u.type = b = Nv(b), z = l1(null, u, b, M, _), z;
        case K:
          {
            if (u.type !== u.elementType) {
              var U = b.propTypes;
              U && Vc(U, M,
              // Resolved for outer only
              "prop", bn(b));
            }
            return z = fx(null, u, b, mu(b.type, M),
            // The inner type can have defaults too
            _), z;
          }
      }
      var X = "";
      throw b !== null && typeof b == "object" && b.$$typeof === Ct && (X = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + b + ". " + ("Lazy element type must resolve to a class or function." + X));
    }
    function GD(l, u, v, _, n) {
      u1(l, u), u.tag = x;
      var a;
      return eu(v) ? (a = !0, d_(u)) : a = !1, Zb(u, n), DD(u, v, _), MC(u, v, _, n), nk(null, u, v, !0, a, n);
    }
    function BP(l, u, v, _) {
      u1(l, u);
      var n = u.pendingProps,
        a;
      {
        var f = Js(u, v, !1);
        a = Rf(u, f);
      }
      Zb(u, _);
      var m, b;
      Ti(u);
      {
        if (v.prototype && typeof v.prototype.render == "function") {
          var T = bn(v) || "Unknown";
          JC[T] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", T, T), JC[T] = !0);
        }
        u.mode & Xn && If.recordLegacyContextWarning(u, null), br(!0), b0.current = u, m = co(null, u, v, n, a, _), b = Cv(), br(!1);
      }
      if (to(), u.flags |= Xi, typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0) {
        var M = bn(v) || "Unknown";
        ux[M] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", M, M, M), ux[M] = !0);
      }
      if (
      // Run these checks in production only if the flag is off.
      // Eventually we'll delete this branch altogether.
      typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0) {
        {
          var z = bn(v) || "Unknown";
          ux[z] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", z, z, z), ux[z] = !0);
        }
        u.tag = x, u.memoizedState = null, u.updateQueue = null;
        var U = !1;
        return eu(v) ? (U = !0, d_(u)) : U = !1, u.memoizedState = m.state !== null && m.state !== void 0 ? m.state : null, __(u), DC(u, m), MC(u, v, n, _), nk(null, u, v, !0, U, _);
      } else {
        if (u.tag = w, u.mode & Xn) {
          En(!0);
          try {
            m = co(null, u, v, n, a, _), b = Cv();
          } finally {
            En(!1);
          }
        }
        return Pa() && b && pm(u), is(null, u, m, _), lk(u, v), u.child;
      }
    }
    function lk(l, u) {
      {
        if (u && u.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", u.displayName || u.name || "Component"), l.ref !== null) {
          var v = "",
            _ = yi();
          _ && (v += `

Check the render method of \`` + _ + "`.");
          var n = _ || "",
            a = l._debugSource;
          a && (n = a.fileName + ":" + a.lineNumber), cx[n] || (cx[n] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", v));
        }
        if (typeof u.getDerivedStateFromProps == "function") {
          var f = bn(u) || "Unknown";
          xc[f] || (h("%s: Function components do not support getDerivedStateFromProps.", f), xc[f] = !0);
        }
        if (typeof u.contextType == "object" && u.contextType !== null) {
          var m = bn(u) || "Unknown";
          By[m] || (h("%s: Function components do not support contextType.", m), By[m] = !0);
        }
      }
    }
    var sk = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ln
    };
    function uk(l) {
      return {
        baseLanes: l,
        cachePool: zP(),
        transitions: null
      };
    }
    function UP(l, u) {
      var v = null;
      return {
        baseLanes: jt(l.baseLanes, u),
        cachePool: v,
        transitions: l.transitions
      };
    }
    function ck(l, u, v, _) {
      if (u !== null) {
        var n = u.memoizedState;
        if (n === null) return !1;
      }
      return My(l, a0);
    }
    function dk(l, u) {
      return ac(l.childLanes, u);
    }
    function s1(l, u, v) {
      var _ = u.pendingProps;
      UI(u) && (u.flags |= ft);
      var n = $c.current,
        a = !1,
        f = (u.flags & ft) !== pt;
      if (f || ck(n, l) ? (a = !0, u.flags &= -129) : (l === null || l.memoizedState !== null) && (n = o0(n, PD)), n = ps(n), vp(u, n), l === null) {
        p_(u);
        var m = u.memoizedState;
        if (m !== null) {
          var b = m.dehydrated;
          if (b !== null) return WP(u, b);
        }
        var T = _.children,
          M = _.fallback;
        if (a) {
          var z = HP(u, T, M, v),
            U = u.child;
          return U.memoizedState = uk(v), u.memoizedState = sk, z;
        } else return fk(u, T);
      } else {
        var X = l.memoizedState;
        if (X !== null) {
          var J = X.dehydrated;
          if (J !== null) return qP(l, u, f, _, J, X, v);
        }
        if (a) {
          var me = _.fallback,
            xe = _.children,
            Ie = $P(l, u, xe, me, v),
            Pe = u.child,
            $e = l.child.memoizedState;
          return Pe.memoizedState = $e === null ? uk(v) : UP($e, v), Pe.childLanes = dk(l, v), u.memoizedState = sk, Ie;
        } else {
          var mt = _.children,
            Te = mk(l, u, mt, v);
          return u.memoizedState = null, Te;
        }
      }
    }
    function fk(l, u, v) {
      var _ = l.mode,
        n = {
          mode: "visible",
          children: u
        },
        a = pk(n, _);
      return a.return = l, l.child = a, a;
    }
    function HP(l, u, v, _) {
      var n = l.mode,
        a = l.child,
        f = {
          mode: "hidden",
          children: u
        },
        m,
        b;
      return (n & Wt) === dt && a !== null ? (m = a, m.childLanes = Re, m.pendingProps = f, l.mode & nn && (m.actualDuration = 0, m.actualStartTime = -1, m.selfBaseDuration = 0, m.treeBaseDuration = 0), b = zv(v, n, _, null)) : (m = pk(f, n), b = zv(v, n, _, null)), m.return = l, b.return = l, m.sibling = b, l.child = m, b;
    }
    function pk(l, u, v) {
      return Om(l, u, Re, null);
    }
    function hk(l, u) {
      return tl(l, u);
    }
    function mk(l, u, v, _) {
      var n = l.child,
        a = n.sibling,
        f = hk(n, {
          mode: "visible",
          children: v
        });
      if ((u.mode & Wt) === dt && (f.lanes = _), f.return = u, f.sibling = null, a !== null) {
        var m = u.deletions;
        m === null ? (u.deletions = [a], u.flags |= _i) : m.push(a);
      }
      return u.child = f, f;
    }
    function $P(l, u, v, _, n) {
      var a = u.mode,
        f = l.child,
        m = f.sibling,
        b = {
          mode: "hidden",
          children: v
        },
        T;
      if (
      // In legacy mode, we commit the primary tree as if it successfully
      // completed, even though it's in an inconsistent state.
      (a & Wt) === dt &&
      // Make sure we're on the second pass, i.e. the primary child fragment was
      // already cloned. In legacy mode, the only case where this isn't true is
      // when DevTools forces us to display a fallback; we skip the first render
      // pass entirely and go straight to rendering the fallback. (In Concurrent
      // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
      // only codepath.)
      u.child !== f) {
        var M = u.child;
        T = M, T.childLanes = Re, T.pendingProps = b, u.mode & nn && (T.actualDuration = 0, T.actualStartTime = -1, T.selfBaseDuration = f.selfBaseDuration, T.treeBaseDuration = f.treeBaseDuration), u.deletions = null;
      } else T = hk(f, b), T.subtreeFlags = f.subtreeFlags & nr;
      var z;
      return m !== null ? z = tl(m, _) : (z = zv(_, a, n, null), z.flags |= Gn), z.return = u, T.return = u, T.sibling = z, u.child = T, z;
    }
    function _0(l, u, v, _) {
      _ !== null && RS(_), Ry(u, l.child, null, v);
      var n = u.pendingProps,
        a = n.children,
        f = fk(u, a);
      return f.flags |= Gn, u.memoizedState = null, f;
    }
    function XD(l, u, v, _, n) {
      var a = u.mode,
        f = {
          mode: "visible",
          children: v
        },
        m = pk(f, a),
        b = zv(_, a, n, null);
      return b.flags |= Gn, m.return = u, b.return = u, m.sibling = b, u.child = m, (u.mode & Wt) !== dt && Ry(u, l.child, null, n), b;
    }
    function WP(l, u, v) {
      return (l.mode & Wt) === dt ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), l.lanes = Je) : cC(u) ? l.lanes = xa : l.lanes = Jr, null;
    }
    function qP(l, u, v, _, n, a, f) {
      if (v) {
        if (u.flags & qr) {
          u.flags &= -257;
          var m = Gc(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return _0(l, u, f, m);
        } else {
          if (u.memoizedState !== null) return u.child = l.child, u.flags |= ft, null;
          var b = _.children,
            T = _.fallback,
            M = XD(l, u, b, T, f),
            z = u.child;
          return z.memoizedState = uk(f), u.memoizedState = sk, M;
        }
      } else {
        if (Sy(), (u.mode & Wt) === dt) return _0(l, u, f,
        // TODO: When we delete legacy mode, we should make this error argument
        // required — every concurrent mode path that causes hydration to
        // de-opt to client rendering should have an error message.
        null);
        if (cC(n)) {
          var U, X, J;
          {
            var me = gD(n);
            U = me.digest, X = me.message, J = me.stack;
          }
          var xe;
          X ? xe = new Error(X) : xe = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Ie = Gc(xe, U, J);
          return _0(l, u, f, Ie);
        }
        var Pe = _n(f, l.childLanes);
        if (Xc || Pe) {
          var $e = Zy();
          if ($e !== null) {
            var mt = cf($e, f);
            if (mt !== Ln && mt !== a.retryLane) {
              a.retryLane = mt;
              var Te = wn;
              vu(l, mt), Ba($e, l, mt, Te);
            }
          }
          x1();
          var Ue = Gc(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return _0(l, u, f, Ue);
        } else if (vD(n)) {
          u.flags |= ft, u.child = l.child;
          var Ve = DI.bind(null, l);
          return dC(n, Ve), null;
        } else {
          kP(u, n, a.treeContext);
          var nt = _.children,
            ke = fk(u, nt);
          return ke.flags |= xi, ke;
        }
      }
    }
    function px(l, u, v) {
      l.lanes = jt(l.lanes, u);
      var _ = l.alternate;
      _ !== null && (_.lanes = jt(_.lanes, u)), MS(l.return, u, v);
    }
    function YP(l, u, v) {
      for (var _ = u; _ !== null;) {
        if (_.tag === V) {
          var n = _.memoizedState;
          n !== null && px(_, v, l);
        } else if (_.tag === Y) px(_, v, l);else if (_.child !== null) {
          _.child.return = _, _ = _.child;
          continue;
        }
        if (_ === l) return;
        for (; _.sibling === null;) {
          if (_.return === null || _.return === l) return;
          _ = _.return;
        }
        _.sibling.return = _.return, _ = _.sibling;
      }
    }
    function GP(l) {
      for (var u = l, v = null; u !== null;) {
        var _ = u.alternate;
        _ !== null && xm(_) === null && (v = u), u = u.sibling;
      }
      return v;
    }
    function XP(l) {
      if (l !== void 0 && l !== "forwards" && l !== "backwards" && l !== "together" && !dx[l]) if (dx[l] = !0, typeof l == "string") switch (l.toLowerCase()) {
        case "together":
        case "forwards":
        case "backwards":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', l, l.toLowerCase());
            break;
          }
        case "forward":
        case "backward":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', l, l.toLowerCase());
            break;
          }
        default:
          h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', l);
          break;
      } else h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', l);
    }
    function KD(l, u) {
      l !== void 0 && !w0[l] && (l !== "collapsed" && l !== "hidden" ? (w0[l] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', l)) : u !== "forwards" && u !== "backwards" && (w0[l] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', l)));
    }
    function QD(l, u) {
      {
        var v = wr(l),
          _ = !v && typeof yn(l) == "function";
        if (v || _) {
          var n = v ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", n, u, n), !1;
        }
      }
      return !0;
    }
    function KP(l, u) {
      if ((u === "forwards" || u === "backwards") && l !== void 0 && l !== null && l !== !1) if (wr(l)) {
        for (var v = 0; v < l.length; v++) if (!QD(l[v], v)) return;
      } else {
        var _ = yn(l);
        if (typeof _ == "function") {
          var n = _.call(l);
          if (n) for (var a = n.next(), f = 0; !a.done; a = n.next()) {
            if (!QD(a.value, f)) return;
            f++;
          }
        } else h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', u);
      }
    }
    function vk(l, u, v, _, n) {
      var a = l.memoizedState;
      a === null ? l.memoizedState = {
        isBackwards: u,
        rendering: null,
        renderingStartTime: 0,
        last: _,
        tail: v,
        tailMode: n
      } : (a.isBackwards = u, a.rendering = null, a.renderingStartTime = 0, a.last = _, a.tail = v, a.tailMode = n);
    }
    function ZD(l, u, v) {
      var _ = u.pendingProps,
        n = _.revealOrder,
        a = _.tail,
        f = _.children;
      XP(n), KD(a, n), KP(f, n), is(l, u, f, v);
      var m = $c.current,
        b = My(m, a0);
      if (b) m = V_(m, a0), u.flags |= ft;else {
        var T = l !== null && (l.flags & ft) !== pt;
        T && YP(u, u.child, v), m = ps(m);
      }
      if (vp(u, m), (u.mode & Wt) === dt) u.memoizedState = null;else switch (n) {
        case "forwards":
          {
            var M = GP(u.child),
              z;
            M === null ? (z = u.child, u.child = null) : (z = M.sibling, M.sibling = null), vk(u, !1,
            // isBackwards
            z, M, a);
            break;
          }
        case "backwards":
          {
            var U = null,
              X = u.child;
            for (u.child = null; X !== null;) {
              var J = X.alternate;
              if (J !== null && xm(J) === null) {
                u.child = X;
                break;
              }
              var me = X.sibling;
              X.sibling = U, U = X, X = me;
            }
            vk(u, !0,
            // isBackwards
            U, null,
            // last
            a);
            break;
          }
        case "together":
          {
            vk(u, !1,
            // isBackwards
            null,
            // tail
            null,
            // last
            void 0);
            break;
          }
        default:
          u.memoizedState = null;
      }
      return u.child;
    }
    function JD(l, u, v) {
      i0(u, u.stateNode.containerInfo);
      var _ = u.pendingProps;
      return l === null ? u.child = Ry(u, null, _, v) : is(l, u, _, v), u.child;
    }
    var eI = !1;
    function gk(l, u, v) {
      var _ = u.type,
        n = _._context,
        a = u.pendingProps,
        f = u.memoizedProps,
        m = a.value;
      {
        "value" in a || eI || (eI = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var b = u.type.propTypes;
        b && Vc(b, a, "prop", "Context.Provider");
      }
      if (SC(u, n, m), f !== null) {
        var T = f.value;
        if (oe(T, m)) {
          if (f.children === a.children && !u_()) return yp(l, u, v);
        } else EC(u, n, v);
      }
      var M = a.children;
      return is(l, u, M, v), u.child;
    }
    var yk = !1;
    function QP(l, u, v) {
      var _ = u.type;
      _._context === void 0 ? _ !== _.Consumer && (yk || (yk = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : _ = _._context;
      var n = u.pendingProps,
        a = n.children;
      typeof a != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Zb(u, v);
      var f = ko(_);
      Ti(u);
      var m;
      return b0.current = u, br(!0), m = a(f), br(!1), to(), u.flags |= Xi, is(l, u, m, v), u.child;
    }
    function x0() {
      Xc = !0;
    }
    function u1(l, u) {
      (u.mode & Wt) === dt && l !== null && (l.alternate = null, u.alternate = null, u.flags |= Gn);
    }
    function yp(l, u, v) {
      return l !== null && (u.dependencies = l.dependencies), VD(), O0(u.lanes), _n(v, u.childLanes) ? (r0(l, u), u.child) : null;
    }
    function ZP(l, u, v) {
      {
        var _ = u.return;
        if (_ === null) throw new Error("Cannot swap the root fiber.");
        if (l.alternate = null, u.alternate = null, v.index = u.index, v.sibling = u.sibling, v.return = u.return, v.ref = u.ref, u === _.child) _.child = v;else {
          var n = _.child;
          if (n === null) throw new Error("Expected parent to have a child.");
          for (; n.sibling !== u;) if (n = n.sibling, n === null) throw new Error("Expected to find the previous sibling.");
          n.sibling = v;
        }
        var a = _.deletions;
        return a === null ? (_.deletions = [l], _.flags |= _i) : a.push(l), v.flags |= Gn, v;
      }
    }
    function Hy(l, u) {
      var v = l.lanes;
      return !!_n(v, u);
    }
    function c1(l, u, v) {
      switch (u.tag) {
        case C:
          rk(u), u.stateNode, Gb();
          break;
        case D:
          Iy(u);
          break;
        case x:
          {
            var _ = u.type;
            eu(_) && d_(u);
            break;
          }
        case k:
          i0(u, u.stateNode.containerInfo);
          break;
        case O:
          {
            var n = u.memoizedProps.value,
              a = u.type._context;
            SC(u, a, n);
            break;
          }
        case j:
          {
            var f = _n(v, u.childLanes);
            f && (u.flags |= tn);
            {
              var m = u.stateNode;
              m.effectDuration = 0, m.passiveEffectDuration = 0;
            }
          }
          break;
        case V:
          {
            var b = u.memoizedState;
            if (b !== null) {
              if (b.dehydrated !== null) return vp(u, ps($c.current)), u.flags |= ft, null;
              var T = u.child,
                M = T.childLanes;
              if (_n(v, M)) return s1(l, u, v);
              vp(u, ps($c.current));
              var z = yp(l, u, v);
              return z !== null ? z.sibling : null;
            } else vp(u, ps($c.current));
            break;
          }
        case Y:
          {
            var U = (l.flags & ft) !== pt,
              X = _n(v, u.childLanes);
            if (U) {
              if (X) return ZD(l, u, v);
              u.flags |= ft;
            }
            var J = u.memoizedState;
            if (J !== null && (J.rendering = null, J.tail = null, J.lastEffect = null), vp(u, $c.current), X) break;
            return null;
          }
        case ae:
        case ne:
          return u.lanes = Re, UD(l, u, v);
      }
      return yp(l, u, v);
    }
    function bp(l, u, v) {
      if (u._debugNeedsRemount && l !== null) return ZP(l, u, Hk(u.type, u.key, u.pendingProps, u._debugOwner || null, u.mode, u.lanes));
      if (l !== null) {
        var _ = l.memoizedProps,
          n = u.pendingProps;
        if (_ !== n || u_() ||
        // Force a re-render if the implementation changed due to hot reload:
        u.type !== l.type) Xc = !0;else {
          var a = Hy(l, v);
          if (!a &&
          // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (u.flags & ft) === pt) return Xc = !1, c1(l, u, v);
          (l.flags & Nd) !== pt ? Xc = !0 : Xc = !1;
        }
      } else if (Xc = !1, Pa() && dm(u)) {
        var f = u.index,
          m = fm();
        _D(u, m, f);
      }
      switch (u.lanes = Re, u.tag) {
        case E:
          return BP(l, u, u.type, v);
        case Q:
          {
            var b = u.elementType;
            return VP(l, u, b, v);
          }
        case w:
          {
            var T = u.type,
              M = u.pendingProps,
              z = u.elementType === T ? M : mu(T, M);
            return tk(l, u, T, z, v);
          }
        case x:
          {
            var U = u.type,
              X = u.pendingProps,
              J = u.elementType === U ? X : mu(U, X);
            return qD(l, u, U, J, v);
          }
        case C:
          return ik(l, u, v);
        case D:
          return ok(l, u, v);
        case I:
          return YD(l, u);
        case V:
          return s1(l, u, v);
        case k:
          return JD(l, u, v);
        case F:
          {
            var me = u.type,
              xe = u.pendingProps,
              Ie = u.elementType === me ? xe : mu(me, xe);
            return l1(l, u, me, Ie, v);
          }
        case L:
          return HD(l, u, v);
        case P:
          return $D(l, u, v);
        case j:
          return WD(l, u, v);
        case O:
          return gk(l, u, v);
        case N:
          return QP(l, u, v);
        case K:
          {
            var Pe = u.type,
              $e = u.pendingProps,
              mt = mu(Pe, $e);
            if (u.type !== u.elementType) {
              var Te = Pe.propTypes;
              Te && Vc(Te, mt,
              // Resolved for outer only
              "prop", bn(Pe));
            }
            return mt = mu(Pe.type, mt), fx(l, u, Pe, mt, v);
          }
        case G:
          return hs(l, u, u.type, u.pendingProps, v);
        case te:
          {
            var Ue = u.type,
              Ve = u.pendingProps,
              nt = u.elementType === Ue ? Ve : mu(Ue, Ve);
            return GD(l, u, Ue, nt, v);
          }
        case Y:
          return ZD(l, u, v);
        case ee:
          break;
        case ae:
          return UD(l, u, v);
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function S0(l) {
      l.flags |= tn;
    }
    function d1(l) {
      l.flags |= Hn, l.flags |= js;
    }
    var tI, f1, $y, bk;
    tI = function (l, u, v, _) {
      for (var n = u.child; n !== null;) {
        if (n.tag === D || n.tag === I) AO(l, n.stateNode);else if (n.tag !== k && n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === u) return;
        for (; n.sibling === null;) {
          if (n.return === null || n.return === u) return;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
    }, f1 = function (l, u) {}, $y = function (l, u, v, _, n) {
      var a = l.memoizedProps;
      if (a !== _) {
        var f = u.stateNode,
          m = N_(),
          b = FO(f, v, a, _, n, m);
        u.updateQueue = b, b && S0(u);
      }
    }, bk = function (l, u, v, _) {
      v !== _ && S0(u);
    };
    function E0(l, u) {
      if (!Pa()) switch (l.tailMode) {
        case "hidden":
          {
            for (var v = l.tail, _ = null; v !== null;) v.alternate !== null && (_ = v), v = v.sibling;
            _ === null ? l.tail = null : _.sibling = null;
            break;
          }
        case "collapsed":
          {
            for (var n = l.tail, a = null; n !== null;) n.alternate !== null && (a = n), n = n.sibling;
            a === null ? !u && l.tail !== null ? l.tail.sibling = null : l.tail = null : a.sibling = null;
            break;
          }
      }
    }
    function Zo(l) {
      var u = l.alternate !== null && l.alternate.child === l.child,
        v = Re,
        _ = pt;
      if (u) {
        if ((l.mode & nn) !== dt) {
          for (var n = l.selfBaseDuration, a = l.child; a !== null;) v = jt(v, jt(a.lanes, a.childLanes)), _ |= a.subtreeFlags & nr, _ |= a.flags & nr, n += a.treeBaseDuration, a = a.sibling;
          l.treeBaseDuration = n;
        } else for (var f = l.child; f !== null;) v = jt(v, jt(f.lanes, f.childLanes)), _ |= f.subtreeFlags & nr, _ |= f.flags & nr, f.return = l, f = f.sibling;
        l.subtreeFlags |= _;
      } else {
        if ((l.mode & nn) !== dt) {
          for (var m = l.actualDuration, b = l.selfBaseDuration, T = l.child; T !== null;) v = jt(v, jt(T.lanes, T.childLanes)), _ |= T.subtreeFlags, _ |= T.flags, m += T.actualDuration, b += T.treeBaseDuration, T = T.sibling;
          l.actualDuration = m, l.treeBaseDuration = b;
        } else for (var M = l.child; M !== null;) v = jt(v, jt(M.lanes, M.childLanes)), _ |= M.subtreeFlags, _ |= M.flags, M.return = l, M = M.sibling;
        l.subtreeFlags |= _;
      }
      return l.childLanes = v, u;
    }
    function nI(l, u, v) {
      if (kD() && (u.mode & Wt) !== dt && (u.flags & ft) === pt) return h_(u), Gb(), u.flags |= qr | Gu | Gr, !1;
      var _ = TS(u);
      if (v !== null && v.dehydrated !== null) {
        if (l === null) {
          if (!_) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (TP(u), Zo(u), (u.mode & nn) !== dt) {
            var n = v !== null;
            if (n) {
              var a = u.child;
              a !== null && (u.treeBaseDuration -= a.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Gb(), (u.flags & ft) === pt && (u.memoizedState = null), u.flags |= tn, Zo(u), (u.mode & nn) !== dt) {
            var f = v !== null;
            if (f) {
              var m = u.child;
              m !== null && (u.treeBaseDuration -= m.treeBaseDuration);
            }
          }
          return !1;
        }
      } else return _C(), !0;
    }
    function wk(l, u, v) {
      var _ = u.pendingProps;
      switch (Yb(u), u.tag) {
        case E:
        case Q:
        case G:
        case w:
        case F:
        case L:
        case P:
        case j:
        case N:
        case K:
          return Zo(u), null;
        case x:
          {
            var n = u.type;
            return eu(n) && by(u), Zo(u), null;
          }
        case C:
          {
            var a = u.stateNode;
            if (Dy(u), Bc(u), Qo(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), l === null || l.child === null) {
              var f = TS(u);
              if (f) S0(u);else if (l !== null) {
                var m = l.memoizedState;
                (!m.isDehydrated ||
                // Check if we reverted to client rendering (e.g. due to an error)
                (u.flags & qr) !== pt) && (u.flags |= or, _C());
              }
            }
            return f1(l, u), Zo(u), null;
          }
        case D:
          {
            z_(u);
            var b = F_(),
              T = u.type;
            if (l !== null && u.stateNode != null) $y(l, u, T, _, b), l.ref !== u.ref && d1(u);else {
              if (!_) {
                if (u.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return Zo(u), null;
              }
              var M = N_(),
                z = TS(u);
              if (z) bC(u, b, M) && S0(u);else {
                var U = PO(T, _, b, M, u);
                tI(U, u, !1, !1), u.stateNode = U, jO(U, T, _, b) && S0(u);
              }
              u.ref !== null && d1(u);
            }
            return Zo(u), null;
          }
        case I:
          {
            var X = _;
            if (l && u.stateNode != null) {
              var J = l.memoizedProps;
              bk(l, u, J, X);
            } else {
              if (typeof X != "string" && u.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var me = F_(),
                xe = N_(),
                Ie = TS(u);
              Ie ? wC(u) && S0(u) : u.stateNode = NO(X, me, xe, u);
            }
            return Zo(u), null;
          }
        case V:
          {
            l0(u);
            var Pe = u.memoizedState;
            if (l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
              var $e = nI(l, u, Pe);
              if (!$e) return u.flags & Gr ? u : null;
            }
            if ((u.flags & ft) !== pt) return u.lanes = v, (u.mode & nn) !== dt && Yc(u), u;
            var mt = Pe !== null,
              Te = l !== null && l.memoizedState !== null;
            if (mt !== Te && mt) {
              var Ue = u.child;
              if (Ue.flags |= tr, (u.mode & Wt) !== dt) {
                var Ve = l === null && (u.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                Ve || My($c.current, PD) ? EI() : x1();
              }
            }
            var nt = u.updateQueue;
            if (nt !== null && (u.flags |= tn), Zo(u), (u.mode & nn) !== dt && mt) {
              var ke = u.child;
              ke !== null && (u.treeBaseDuration -= ke.treeBaseDuration);
            }
            return null;
          }
        case k:
          return Dy(u), f1(l, u), l === null && _P(u.stateNode.containerInfo), Zo(u), null;
        case O:
          var Fe = u.type._context;
          return IS(Fe, u), Zo(u), null;
        case te:
          {
            var De = u.type;
            return eu(De) && by(u), Zo(u), null;
          }
        case Y:
          {
            l0(u);
            var Qe = u.memoizedState;
            if (Qe === null) return Zo(u), null;
            var Tt = (u.flags & ft) !== pt,
              _t = Qe.rendering;
            if (_t === null) {
              if (Tt) E0(Qe, !1);else {
                var an = Sx() && (l === null || (l.flags & ft) === pt);
                if (!an) for (var Gt = u.child; Gt !== null;) {
                  var Pn = xm(Gt);
                  if (Pn !== null) {
                    Tt = !0, u.flags |= ft, E0(Qe, !1);
                    var Fn = Pn.updateQueue;
                    return Fn !== null && (u.updateQueue = Fn, u.flags |= tn), u.subtreeFlags = pt, LD(u, v), vp(u, V_($c.current, a0)), u.child;
                  }
                  Gt = Gt.sibling;
                }
                Qe.tail !== null && lr() > kk() && (u.flags |= ft, Tt = !0, E0(Qe, !1), u.lanes = af);
              }
            } else {
              if (!Tt) {
                var kr = xm(_t);
                if (kr !== null) {
                  u.flags |= ft, Tt = !0;
                  var qn = kr.updateQueue;
                  if (qn !== null && (u.updateQueue = qn, u.flags |= tn), E0(Qe, !0), Qe.tail === null && Qe.tailMode === "hidden" && !_t.alternate && !Pa()) return Zo(u), null;
                } else lr() * 2 - Qe.renderingStartTime > kk() && v !== Jr && (u.flags |= ft, Tt = !0, E0(Qe, !1), u.lanes = af);
              }
              if (Qe.isBackwards) _t.sibling = u.child, u.child = _t;else {
                var Tr = Qe.last;
                Tr !== null ? Tr.sibling = _t : u.child = _t, Qe.last = _t;
              }
            }
            if (Qe.tail !== null) {
              var ai = Qe.tail;
              Qe.rendering = ai, Qe.tail = ai.sibling, Qe.renderingStartTime = lr(), ai.sibling = null;
              var Br = $c.current;
              return Tt ? Br = V_(Br, a0) : Br = ps(Br), vp(u, Br), ai;
            }
            return Zo(u), null;
          }
        case ee:
          break;
        case ae:
        case ne:
          {
            Ik(u);
            var ho = u.memoizedState,
              Ro = ho !== null;
            if (l !== null) {
              var nl = l.memoizedState,
                ta = nl !== null;
              ta !== Ro && (u.flags |= tr);
            }
            return !Ro || (u.mode & Wt) === dt ? Zo(u) : _n(Wn, Jr) && (Zo(u), u.subtreeFlags & (Gn | tn) && (u.flags |= tr)), null;
          }
        case le:
          return null;
        case ce:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + u.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function hx(l, u, v) {
      switch (Yb(u), u.tag) {
        case x:
          {
            var _ = u.type;
            eu(_) && by(u);
            var n = u.flags;
            return n & Gr ? (u.flags = n & -65537 | ft, (u.mode & nn) !== dt && Yc(u), u) : null;
          }
        case C:
          {
            u.stateNode, Dy(u), Bc(u), Qo();
            var a = u.flags;
            return (a & Gr) !== pt && (a & ft) === pt ? (u.flags = a & -65537 | ft, u) : null;
          }
        case D:
          return z_(u), null;
        case V:
          {
            l0(u);
            var f = u.memoizedState;
            if (f !== null && f.dehydrated !== null) {
              if (u.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              Gb();
            }
            var m = u.flags;
            return m & Gr ? (u.flags = m & -65537 | ft, (u.mode & nn) !== dt && Yc(u), u) : null;
          }
        case Y:
          return l0(u), null;
        case k:
          return Dy(u), null;
        case O:
          var b = u.type._context;
          return IS(b, u), null;
        case ae:
        case ne:
          return Ik(u), null;
        case le:
          return null;
        default:
          return null;
      }
    }
    function yl(l, u, v) {
      switch (Yb(u), u.tag) {
        case x:
          {
            var _ = u.type.childContextTypes;
            _ != null && by(u);
            break;
          }
        case C:
          {
            u.stateNode, Dy(u), Bc(u), Qo();
            break;
          }
        case D:
          {
            z_(u);
            break;
          }
        case k:
          Dy(u);
          break;
        case V:
          l0(u);
          break;
        case Y:
          l0(u);
          break;
        case O:
          var n = u.type._context;
          IS(n, u);
          break;
        case ae:
        case ne:
          Ik(u);
          break;
      }
    }
    var rI = null;
    rI = /* @__PURE__ */new Set();
    var mx = !1,
      as = !1,
      iI = typeof WeakSet == "function" ? WeakSet : Set,
      dn = null,
      Cm = null,
      Na = null;
    function JP(l) {
      Vo(null, function () {
        throw l;
      }), Yu();
    }
    var fn = function (l, u) {
      if (u.props = l.memoizedProps, u.state = l.memoizedState, l.mode & nn) try {
        Vf(), u.componentWillUnmount();
      } finally {
        zf(l);
      } else u.componentWillUnmount();
    };
    function Wy(l, u) {
      try {
        Iv(Er, l);
      } catch (v) {
        Fi(l, u, v);
      }
    }
    function Dv(l, u, v) {
      try {
        fn(l, v);
      } catch (_) {
        Fi(l, u, _);
      }
    }
    function eA(l, u, v) {
      try {
        v.componentDidMount();
      } catch (_) {
        Fi(l, u, _);
      }
    }
    function aI(l, u) {
      try {
        uI(l);
      } catch (v) {
        Fi(l, u, v);
      }
    }
    function qy(l, u) {
      var v = l.ref;
      if (v !== null) if (typeof v == "function") {
        var _;
        try {
          if (Ce && fe && l.mode & nn) try {
            Vf(), _ = v(null);
          } finally {
            zf(l);
          } else _ = v(null);
        } catch (n) {
          Fi(l, u, n);
        }
        typeof _ == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(l));
      } else v.current = null;
    }
    function C0(l, u, v) {
      try {
        v();
      } catch (_) {
        Fi(l, u, _);
      }
    }
    var oI = !1;
    function lI(l, u) {
      OO(l.containerInfo), dn = u, k0();
      var v = oI;
      return oI = !1, v;
    }
    function k0() {
      for (; dn !== null;) {
        var l = dn,
          u = l.child;
        (l.subtreeFlags & Uo) !== pt && u !== null ? (u.return = l, dn = u) : p1();
      }
    }
    function p1() {
      for (; dn !== null;) {
        var l = dn;
        Rn(l);
        try {
          sI(l);
        } catch (v) {
          Fi(l, l.return, v);
        }
        Un();
        var u = l.sibling;
        if (u !== null) {
          u.return = l.return, dn = u;
          return;
        }
        dn = l.return;
      }
    }
    function sI(l) {
      var u = l.alternate,
        v = l.flags;
      if ((v & or) !== pt) {
        switch (Rn(l), l.tag) {
          case w:
          case F:
          case G:
            break;
          case x:
            {
              if (u !== null) {
                var _ = u.memoizedProps,
                  n = u.memoizedState,
                  a = l.stateNode;
                l.type === l.elementType && !Bf && (a.props !== l.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(l) || "instance"), a.state !== l.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(l) || "instance"));
                var f = a.getSnapshotBeforeUpdate(l.elementType === l.type ? _ : mu(l.type, _), n);
                {
                  var m = rI;
                  f === void 0 && !m.has(l.type) && (m.add(l.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", At(l)));
                }
                a.__reactInternalSnapshotBeforeUpdate = f;
              }
              break;
            }
          case C:
            {
              {
                var b = l.stateNode;
                ZO(b.containerInfo);
              }
              break;
            }
          case D:
          case I:
          case k:
          case te:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Un();
      }
    }
    function Uf(l, u, v) {
      var _ = u.updateQueue,
        n = _ !== null ? _.lastEffect : null;
      if (n !== null) {
        var a = n.next,
          f = a;
        do {
          if ((f.tag & l) === l) {
            var m = f.destroy;
            f.destroy = void 0, m !== void 0 && ((l & Ui) !== gu ? Bg(u) : (l & Er) !== gu && Mh(u), (l & Ta) !== gu && A0(!0), C0(u, v, m), (l & Ta) !== gu && A0(!1), (l & Ui) !== gu ? Ug() : (l & Er) !== gu && Lh());
          }
          f = f.next;
        } while (f !== a);
      }
    }
    function Iv(l, u) {
      var v = u.updateQueue,
        _ = v !== null ? v.lastEffect : null;
      if (_ !== null) {
        var n = _.next,
          a = n;
        do {
          if ((a.tag & l) === l) {
            (l & Ui) !== gu ? Vg(u) : (l & Er) !== gu && Ih(u);
            var f = a.create;
            (l & Ta) !== gu && A0(!0), a.destroy = f(), (l & Ta) !== gu && A0(!1), (l & Ui) !== gu ? Wd() : (l & Er) !== gu && qd();
            {
              var m = a.destroy;
              if (m !== void 0 && typeof m != "function") {
                var b = void 0;
                (a.tag & Er) !== pt ? b = "useLayoutEffect" : (a.tag & Ta) !== pt ? b = "useInsertionEffect" : b = "useEffect";
                var T = void 0;
                m === null ? T = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof m.then == "function" ? T = `

It looks like you wrote ` + b + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + b + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : T = " You returned: " + m, h("%s must not return anything besides a function, which is used for clean-up.%s", b, T);
              }
            }
          }
          a = a.next;
        } while (a !== n);
      }
    }
    function tA(l, u) {
      if ((u.flags & tn) !== pt) switch (u.tag) {
        case j:
          {
            var v = u.stateNode.passiveEffectDuration,
              _ = u.memoizedProps,
              n = _.id,
              a = _.onPostCommit,
              f = GC(),
              m = u.alternate === null ? "mount" : "update";
            g0() && (m = "nested-update"), typeof a == "function" && a(n, m, v, f);
            var b = u.return;
            e: for (; b !== null;) {
              switch (b.tag) {
                case C:
                  var T = b.stateNode;
                  T.passiveEffectDuration += v;
                  break e;
                case j:
                  var M = b.stateNode;
                  M.passiveEffectDuration += v;
                  break e;
              }
              b = b.return;
            }
            break;
          }
      }
    }
    function nA(l, u, v, _) {
      if ((v.flags & $o) !== pt) switch (v.tag) {
        case w:
        case F:
        case G:
          {
            if (!as) if (v.mode & nn) try {
              Vf(), Iv(Er | ja, v);
            } finally {
              zf(v);
            } else Iv(Er | ja, v);
            break;
          }
        case x:
          {
            var n = v.stateNode;
            if (v.flags & tn && !as) if (u === null) {
              if (v.type === v.elementType && !Bf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), v.mode & nn) try {
                Vf(), n.componentDidMount();
              } finally {
                zf(v);
              } else n.componentDidMount();
            } else {
              var a = v.elementType === v.type ? u.memoizedProps : mu(v.type, u.memoizedProps),
                f = u.memoizedState;
              if (v.type === v.elementType && !Bf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), v.mode & nn) try {
                Vf(), n.componentDidUpdate(a, f, n.__reactInternalSnapshotBeforeUpdate);
              } finally {
                zf(v);
              } else n.componentDidUpdate(a, f, n.__reactInternalSnapshotBeforeUpdate);
            }
            var m = v.updateQueue;
            m !== null && (v.type === v.elementType && !Bf && (n.props !== v.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(v) || "instance"), n.state !== v.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(v) || "instance")), kC(v, m, n));
            break;
          }
        case C:
          {
            var b = v.updateQueue;
            if (b !== null) {
              var T = null;
              if (v.child !== null) switch (v.child.tag) {
                case D:
                  T = v.child.stateNode;
                  break;
                case x:
                  T = v.child.stateNode;
                  break;
              }
              kC(v, b, T);
            }
            break;
          }
        case D:
          {
            var M = v.stateNode;
            if (u === null && v.flags & tn) {
              var z = v.type,
                U = v.memoizedProps;
              VO(M, z, U);
            }
            break;
          }
        case I:
          break;
        case k:
          break;
        case j:
          {
            {
              var X = v.memoizedProps,
                J = X.onCommit,
                me = X.onRender,
                xe = v.stateNode.effectDuration,
                Ie = GC(),
                Pe = u === null ? "mount" : "update";
              g0() && (Pe = "nested-update"), typeof me == "function" && me(v.memoizedProps.id, Pe, v.actualDuration, v.treeBaseDuration, v.actualStartTime, Ie);
              {
                typeof J == "function" && J(v.memoizedProps.id, Pe, xe, Ie), kI(v);
                var $e = v.return;
                e: for (; $e !== null;) {
                  switch ($e.tag) {
                    case C:
                      var mt = $e.stateNode;
                      mt.effectDuration += xe;
                      break e;
                    case j:
                      var Te = $e.stateNode;
                      Te.effectDuration += xe;
                      break e;
                  }
                  $e = $e.return;
                }
              }
            }
            break;
          }
        case V:
          {
            aA(l, v);
            break;
          }
        case Y:
        case te:
        case ee:
        case ae:
        case ne:
        case ce:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      as || v.flags & Hn && uI(v);
    }
    function Hf(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            if (l.mode & nn) try {
              Vf(), Wy(l, l.return);
            } finally {
              zf(l);
            } else Wy(l, l.return);
            break;
          }
        case x:
          {
            var u = l.stateNode;
            typeof u.componentDidMount == "function" && eA(l, l.return, u), aI(l, l.return);
            break;
          }
        case D:
          {
            aI(l, l.return);
            break;
          }
      }
    }
    function Mv(l, u) {
      for (var v = null, _ = l;;) {
        if (_.tag === D) {
          if (v === null) {
            v = _;
            try {
              var n = _.stateNode;
              u ? uC(n) : KO(_.stateNode, _.memoizedProps);
            } catch (f) {
              Fi(l, l.return, f);
            }
          }
        } else if (_.tag === I) {
          if (v === null) try {
            var a = _.stateNode;
            u ? XO(a) : QO(a, _.memoizedProps);
          } catch (f) {
            Fi(l, l.return, f);
          }
        } else if (!((_.tag === ae || _.tag === ne) && _.memoizedState !== null && _ !== l) && _.child !== null) {
          _.child.return = _, _ = _.child;
          continue;
        }
        if (_ === l) return;
        for (; _.sibling === null;) {
          if (_.return === null || _.return === l) return;
          v === _ && (v = null), _ = _.return;
        }
        v === _ && (v = null), _.sibling.return = _.return, _ = _.sibling;
      }
    }
    function uI(l) {
      var u = l.ref;
      if (u !== null) {
        var v = l.stateNode,
          _;
        switch (l.tag) {
          case D:
            _ = v;
            break;
          default:
            _ = v;
        }
        if (typeof u == "function") {
          var n;
          if (l.mode & nn) try {
            Vf(), n = u(_);
          } finally {
            zf(l);
          } else n = u(_);
          typeof n == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(l));
        } else u.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", At(l)), u.current = _;
      }
    }
    function rA(l) {
      var u = l.alternate;
      u !== null && (u.return = null), l.return = null;
    }
    function cI(l) {
      var u = l.alternate;
      u !== null && (l.alternate = null, cI(u));
      {
        if (l.child = null, l.deletions = null, l.sibling = null, l.tag === D) {
          var v = l.stateNode;
          v !== null && xP(v);
        }
        l.stateNode = null, l._debugOwner = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
      }
    }
    function iA(l) {
      for (var u = l.return; u !== null;) {
        if (_k(u)) return u;
        u = u.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function _k(l) {
      return l.tag === D || l.tag === C || l.tag === k;
    }
    function dI(l) {
      var u = l;
      e: for (;;) {
        for (; u.sibling === null;) {
          if (u.return === null || _k(u.return)) return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== D && u.tag !== I && u.tag !== ie;) {
          if (u.flags & Gn || u.child === null || u.tag === k) continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & Gn)) return u.stateNode;
      }
    }
    function fI(l) {
      var u = iA(l);
      switch (u.tag) {
        case D:
          {
            var v = u.stateNode;
            u.flags & Ki && (hD(v), u.flags &= -33);
            var _ = dI(l);
            h1(l, _, v);
            break;
          }
        case C:
        case k:
          {
            var n = u.stateNode.containerInfo,
              a = dI(l);
            xk(l, a, n);
            break;
          }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function xk(l, u, v) {
      var _ = l.tag,
        n = _ === D || _ === I;
      if (n) {
        var a = l.stateNode;
        u ? WO(v, a, u) : HO(v, a);
      } else if (_ !== k) {
        var f = l.child;
        if (f !== null) {
          xk(f, u, v);
          for (var m = f.sibling; m !== null;) xk(m, u, v), m = m.sibling;
        }
      }
    }
    function h1(l, u, v) {
      var _ = l.tag,
        n = _ === D || _ === I;
      if (n) {
        var a = l.stateNode;
        u ? $O(v, a, u) : mD(v, a);
      } else if (_ !== k) {
        var f = l.child;
        if (f !== null) {
          h1(f, u, v);
          for (var m = f.sibling; m !== null;) h1(m, u, v), m = m.sibling;
        }
      }
    }
    var bl = null,
      $f = !1;
    function Sk(l, u, v) {
      {
        var _ = u;
        e: for (; _ !== null;) {
          switch (_.tag) {
            case D:
              {
                bl = _.stateNode, $f = !1;
                break e;
              }
            case C:
              {
                bl = _.stateNode.containerInfo, $f = !0;
                break e;
              }
            case k:
              {
                bl = _.stateNode.containerInfo, $f = !0;
                break e;
              }
          }
          _ = _.return;
        }
        if (bl === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        wl(l, u, v), bl = null, $f = !1;
      }
      rA(v);
    }
    function wp(l, u, v) {
      for (var _ = v.child; _ !== null;) wl(l, u, _), _ = _.sibling;
    }
    function wl(l, u, v) {
      switch (Ng(v), v.tag) {
        case D:
          as || qy(v, u);
        // eslint-disable-next-line-no-fallthrough
        case I:
          {
            {
              var _ = bl,
                n = $f;
              bl = null, wp(l, u, v), bl = _, $f = n, bl !== null && ($f ? YO(bl, v.stateNode) : qO(bl, v.stateNode));
            }
            return;
          }
        case ie:
          {
            bl !== null && ($f ? GO(bl, v.stateNode) : sC(bl, v.stateNode));
            return;
          }
        case k:
          {
            {
              var a = bl,
                f = $f;
              bl = v.stateNode.containerInfo, $f = !0, wp(l, u, v), bl = a, $f = f;
            }
            return;
          }
        case w:
        case F:
        case K:
        case G:
          {
            if (!as) {
              var m = v.updateQueue;
              if (m !== null) {
                var b = m.lastEffect;
                if (b !== null) {
                  var T = b.next,
                    M = T;
                  do {
                    var z = M,
                      U = z.destroy,
                      X = z.tag;
                    U !== void 0 && ((X & Ta) !== gu ? C0(v, u, U) : (X & Er) !== gu && (Mh(v), v.mode & nn ? (Vf(), C0(v, u, U), zf(v)) : C0(v, u, U), Lh())), M = M.next;
                  } while (M !== T);
                }
              }
            }
            wp(l, u, v);
            return;
          }
        case x:
          {
            if (!as) {
              qy(v, u);
              var J = v.stateNode;
              typeof J.componentWillUnmount == "function" && Dv(v, u, J);
            }
            wp(l, u, v);
            return;
          }
        case ee:
          {
            wp(l, u, v);
            return;
          }
        case ae:
          {
            if (
            // TODO: Remove this dead flag
            v.mode & Wt) {
              var me = as;
              as = me || v.memoizedState !== null, wp(l, u, v), as = me;
            } else wp(l, u, v);
            break;
          }
        default:
          {
            wp(l, u, v);
            return;
          }
      }
    }
    function Wf(l) {
      l.memoizedState;
    }
    function aA(l, u) {
      var v = u.memoizedState;
      if (v === null) {
        var _ = u.alternate;
        if (_ !== null) {
          var n = _.memoizedState;
          if (n !== null) {
            var a = n.dehydrated;
            a !== null && bD(a);
          }
        }
      }
    }
    function km(l) {
      var u = l.updateQueue;
      if (u !== null) {
        l.updateQueue = null;
        var v = l.stateNode;
        v === null && (v = l.stateNode = new iI()), u.forEach(function (_) {
          var n = Ni.bind(null, l, _);
          if (!v.has(_)) {
            if (v.add(_), ui) if (Cm !== null && Na !== null) kx(Na, Cm);else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            _.then(n, n);
          }
        });
      }
    }
    function pI(l, u, v) {
      Cm = v, Na = l, Rn(u), hI(u, l), Rn(u), Cm = null, Na = null;
    }
    function qf(l, u, v) {
      var _ = u.deletions;
      if (_ !== null) for (var n = 0; n < _.length; n++) {
        var a = _[n];
        try {
          Sk(l, u, a);
        } catch (b) {
          Fi(a, u, b);
        }
      }
      var f = Mu();
      if (u.subtreeFlags & Ho) for (var m = u.child; m !== null;) Rn(m), hI(m, l), m = m.sibling;
      Rn(f);
    }
    function hI(l, u, v) {
      var _ = l.alternate,
        n = l.flags;
      switch (l.tag) {
        case w:
        case F:
        case K:
        case G:
          {
            if (qf(u, l), Yf(l), n & tn) {
              try {
                Uf(Ta | ja, l, l.return), Iv(Ta | ja, l);
              } catch (De) {
                Fi(l, l.return, De);
              }
              if (l.mode & nn) {
                try {
                  Vf(), Uf(Er | ja, l, l.return);
                } catch (De) {
                  Fi(l, l.return, De);
                }
                zf(l);
              } else try {
                Uf(Er | ja, l, l.return);
              } catch (De) {
                Fi(l, l.return, De);
              }
            }
            return;
          }
        case x:
          {
            qf(u, l), Yf(l), n & Hn && _ !== null && qy(_, _.return);
            return;
          }
        case D:
          {
            qf(u, l), Yf(l), n & Hn && _ !== null && qy(_, _.return);
            {
              if (l.flags & Ki) {
                var a = l.stateNode;
                try {
                  hD(a);
                } catch (De) {
                  Fi(l, l.return, De);
                }
              }
              if (n & tn) {
                var f = l.stateNode;
                if (f != null) {
                  var m = l.memoizedProps,
                    b = _ !== null ? _.memoizedProps : m,
                    T = l.type,
                    M = l.updateQueue;
                  if (l.updateQueue = null, M !== null) try {
                    BO(f, M, T, b, m, l);
                  } catch (De) {
                    Fi(l, l.return, De);
                  }
                }
              }
            }
            return;
          }
        case I:
          {
            if (qf(u, l), Yf(l), n & tn) {
              if (l.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var z = l.stateNode,
                U = l.memoizedProps,
                X = _ !== null ? _.memoizedProps : U;
              try {
                UO(z, X, U);
              } catch (De) {
                Fi(l, l.return, De);
              }
            }
            return;
          }
        case C:
          {
            if (qf(u, l), Yf(l), n & tn && _ !== null) {
              var J = _.memoizedState;
              if (J.isDehydrated) try {
                lP(u.containerInfo);
              } catch (De) {
                Fi(l, l.return, De);
              }
            }
            return;
          }
        case k:
          {
            qf(u, l), Yf(l);
            return;
          }
        case V:
          {
            qf(u, l), Yf(l);
            var me = l.child;
            if (me.flags & tr) {
              var xe = me.stateNode,
                Ie = me.memoizedState,
                Pe = Ie !== null;
              if (xe.isHidden = Pe, Pe) {
                var $e = me.alternate !== null && me.alternate.memoizedState !== null;
                $e || Jy();
              }
            }
            if (n & tn) {
              try {
                Wf(l);
              } catch (De) {
                Fi(l, l.return, De);
              }
              km(l);
            }
            return;
          }
        case ae:
          {
            var mt = _ !== null && _.memoizedState !== null;
            if (
            // TODO: Remove this dead flag
            l.mode & Wt) {
              var Te = as;
              as = Te || mt, qf(u, l), as = Te;
            } else qf(u, l);
            if (Yf(l), n & tr) {
              var Ue = l.stateNode,
                Ve = l.memoizedState,
                nt = Ve !== null,
                ke = l;
              if (Ue.isHidden = nt, nt && !mt && (ke.mode & Wt) !== dt) {
                dn = ke;
                for (var Fe = ke.child; Fe !== null;) dn = Fe, _p(Fe), Fe = Fe.sibling;
              }
              Mv(ke, nt);
            }
            return;
          }
        case Y:
          {
            qf(u, l), Yf(l), n & tn && km(l);
            return;
          }
        case ee:
          return;
        default:
          {
            qf(u, l), Yf(l);
            return;
          }
      }
    }
    function Yf(l) {
      var u = l.flags;
      if (u & Gn) {
        try {
          fI(l);
        } catch (v) {
          Fi(l, l.return, v);
        }
        l.flags &= -3;
      }
      u & xi && (l.flags &= -4097);
    }
    function oA(l, u, v) {
      Cm = v, Na = u, dn = l, Kc(l, u, v), Cm = null, Na = null;
    }
    function Kc(l, u, v) {
      for (var _ = (l.mode & Wt) !== dt; dn !== null;) {
        var n = dn,
          a = n.child;
        if (n.tag === ae && _) {
          var f = n.memoizedState !== null,
            m = f || mx;
          if (m) {
            m1(l, u, v);
            continue;
          } else {
            var b = n.alternate,
              T = b !== null && b.memoizedState !== null,
              M = T || as,
              z = mx,
              U = as;
            mx = m, as = M, as && !U && (dn = n, vI(n));
            for (var X = a; X !== null;) dn = X, Kc(X,
            // New root; bubble back up to here and stop.
            u, v), X = X.sibling;
            dn = n, mx = z, as = U, m1(l, u, v);
            continue;
          }
        }
        (n.subtreeFlags & $o) !== pt && a !== null ? (a.return = n, dn = a) : m1(l, u, v);
      }
    }
    function m1(l, u, v) {
      for (; dn !== null;) {
        var _ = dn;
        if ((_.flags & $o) !== pt) {
          var n = _.alternate;
          Rn(_);
          try {
            nA(u, n, _, v);
          } catch (f) {
            Fi(_, _.return, f);
          }
          Un();
        }
        if (_ === l) {
          dn = null;
          return;
        }
        var a = _.sibling;
        if (a !== null) {
          a.return = _.return, dn = a;
          return;
        }
        dn = _.return;
      }
    }
    function _p(l) {
      for (; dn !== null;) {
        var u = dn,
          v = u.child;
        switch (u.tag) {
          case w:
          case F:
          case K:
          case G:
            {
              if (u.mode & nn) try {
                Vf(), Uf(Er, u, u.return);
              } finally {
                zf(u);
              } else Uf(Er, u, u.return);
              break;
            }
          case x:
            {
              qy(u, u.return);
              var _ = u.stateNode;
              typeof _.componentWillUnmount == "function" && Dv(u, u.return, _);
              break;
            }
          case D:
            {
              qy(u, u.return);
              break;
            }
          case ae:
            {
              var n = u.memoizedState !== null;
              if (n) {
                mI(l);
                continue;
              }
              break;
            }
        }
        v !== null ? (v.return = u, dn = v) : mI(l);
      }
    }
    function mI(l) {
      for (; dn !== null;) {
        var u = dn;
        if (u === l) {
          dn = null;
          return;
        }
        var v = u.sibling;
        if (v !== null) {
          v.return = u.return, dn = v;
          return;
        }
        dn = u.return;
      }
    }
    function vI(l) {
      for (; dn !== null;) {
        var u = dn,
          v = u.child;
        if (u.tag === ae) {
          var _ = u.memoizedState !== null;
          if (_) {
            v1(l);
            continue;
          }
        }
        v !== null ? (v.return = u, dn = v) : v1(l);
      }
    }
    function v1(l) {
      for (; dn !== null;) {
        var u = dn;
        Rn(u);
        try {
          Hf(u);
        } catch (_) {
          Fi(u, u.return, _);
        }
        if (Un(), u === l) {
          dn = null;
          return;
        }
        var v = u.sibling;
        if (v !== null) {
          v.return = u.return, dn = v;
          return;
        }
        dn = u.return;
      }
    }
    function lA(l, u, v, _) {
      dn = u, gI(u, l, v, _);
    }
    function gI(l, u, v, _) {
      for (; dn !== null;) {
        var n = dn,
          a = n.child;
        (n.subtreeFlags & Ja) !== pt && a !== null ? (a.return = n, dn = a) : sA(l, u, v, _);
      }
    }
    function sA(l, u, v, _) {
      for (; dn !== null;) {
        var n = dn;
        if ((n.flags & Yr) !== pt) {
          Rn(n);
          try {
            yI(u, n, v, _);
          } catch (f) {
            Fi(n, n.return, f);
          }
          Un();
        }
        if (n === l) {
          dn = null;
          return;
        }
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, dn = a;
          return;
        }
        dn = n.return;
      }
    }
    function yI(l, u, v, _) {
      switch (u.tag) {
        case w:
        case F:
        case G:
          {
            if (u.mode & nn) {
              y0();
              try {
                Iv(Ui | ja, u);
              } finally {
                lx(u);
              }
            } else Iv(Ui | ja, u);
            break;
          }
      }
    }
    function uA(l) {
      dn = l, cA();
    }
    function cA() {
      for (; dn !== null;) {
        var l = dn,
          u = l.child;
        if ((dn.flags & _i) !== pt) {
          var v = l.deletions;
          if (v !== null) {
            for (var _ = 0; _ < v.length; _++) {
              var n = v[_];
              dn = n, pA(n, l);
            }
            {
              var a = l.alternate;
              if (a !== null) {
                var f = a.child;
                if (f !== null) {
                  a.child = null;
                  do {
                    var m = f.sibling;
                    f.sibling = null, f = m;
                  } while (f !== null);
                }
              }
            }
            dn = l;
          }
        }
        (l.subtreeFlags & Ja) !== pt && u !== null ? (u.return = l, dn = u) : dA();
      }
    }
    function dA() {
      for (; dn !== null;) {
        var l = dn;
        (l.flags & Yr) !== pt && (Rn(l), fA(l), Un());
        var u = l.sibling;
        if (u !== null) {
          u.return = l.return, dn = u;
          return;
        }
        dn = l.return;
      }
    }
    function fA(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            l.mode & nn ? (y0(), Uf(Ui | ja, l, l.return), lx(l)) : Uf(Ui | ja, l, l.return);
            break;
          }
      }
    }
    function pA(l, u) {
      for (; dn !== null;) {
        var v = dn;
        Rn(v), mA(v, u), Un();
        var _ = v.child;
        _ !== null ? (_.return = v, dn = _) : hA(l);
      }
    }
    function hA(l) {
      for (; dn !== null;) {
        var u = dn,
          v = u.sibling,
          _ = u.return;
        if (cI(u), u === l) {
          dn = null;
          return;
        }
        if (v !== null) {
          v.return = _, dn = v;
          return;
        }
        dn = _;
      }
    }
    function mA(l, u) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            l.mode & nn ? (y0(), Uf(Ui, l, u), lx(l)) : Uf(Ui, l, u);
            break;
          }
      }
    }
    function vA(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Iv(Er | ja, l);
            } catch (v) {
              Fi(l, l.return, v);
            }
            break;
          }
        case x:
          {
            var u = l.stateNode;
            try {
              u.componentDidMount();
            } catch (v) {
              Fi(l, l.return, v);
            }
            break;
          }
      }
    }
    function gA(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Iv(Ui | ja, l);
            } catch (u) {
              Fi(l, l.return, u);
            }
            break;
          }
      }
    }
    function yA(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Uf(Er | ja, l, l.return);
            } catch (v) {
              Fi(l, l.return, v);
            }
            break;
          }
        case x:
          {
            var u = l.stateNode;
            typeof u.componentWillUnmount == "function" && Dv(l, l.return, u);
            break;
          }
      }
    }
    function bA(l) {
      switch (l.tag) {
        case w:
        case F:
        case G:
          try {
            Uf(Ui | ja, l, l.return);
          } catch (u) {
            Fi(l, l.return, u);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var vx = Symbol.for;
      vx("selector.component"), vx("selector.has_pseudo_class"), vx("selector.role"), vx("selector.test_id"), vx("selector.text");
    }
    var wA = [];
    function _A() {
      wA.forEach(function (l) {
        return l();
      });
    }
    var xA = i.ReactCurrentActQueue;
    function gx(l) {
      {
        var u =
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
          v = typeof jest < "u";
        return v && u !== !1;
      }
    }
    function bI() {
      {
        var l =
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
        return !l && xA.current !== null && h("The current testing environment is not configured to support act(...)"), l;
      }
    }
    var SA = Math.ceil,
      Ek = i.ReactCurrentDispatcher,
      Ck = i.ReactCurrentOwner,
      _l = i.ReactCurrentBatchConfig,
      Gf = i.ReactCurrentActQueue,
      fo = /*             */
      0,
      g1 = /*               */
      1,
      Ar = /*                */
      2,
      za = /*                */
      4,
      ji = 0,
      T0 = 1,
      Da = 2,
      iu = 3,
      Sc = 4,
      R0 = 5,
      Tm = 6,
      cr = fo,
      Jo = null,
      da = null,
      po = Re,
      Wn = Re,
      os = Cf(Re),
      sr = ji,
      Ia = null,
      Ec = Re,
      Yy = Re,
      Va = Re,
      Rm = null,
      ls = null,
      Gy = 0,
      yx = 500,
      D0 = 1 / 0,
      wu = 500,
      Xf = null;
    function I0() {
      D0 = lr() + wu;
    }
    function kk() {
      return D0;
    }
    var y1 = !1,
      Kf = null,
      xp = null,
      Lv = !1,
      Qf = null,
      Xy = Re,
      Ov = [],
      Dm = null,
      Pv = 50,
      Im = 0,
      bx = null,
      wx = !1,
      b1 = !1,
      _x = 50,
      Av = 0,
      M0 = null,
      Ky = wn,
      w1 = Re,
      Qy = !1;
    function Zy() {
      return Jo;
    }
    function el() {
      return (cr & (Ar | za)) !== fo ? lr() : (Ky !== wn || (Ky = lr()), Ky);
    }
    function Zf(l) {
      var u = l.mode;
      if ((u & Wt) === dt) return Je;
      if ((cr & Ar) !== fo && po !== Re) return Xs(po);
      var v = DP() !== xC;
      if (v) {
        if (_l.transition !== null) {
          var _ = _l.transition;
          _._updatedFibers || (_._updatedFibers = /* @__PURE__ */new Set()), _._updatedFibers.add(l);
        }
        return w1 === Ln && (w1 = Vh()), w1;
      }
      var n = Ir();
      if (n !== Ln) return n;
      var a = aC();
      return a;
    }
    function wI(l) {
      var u = l.mode;
      return (u & Wt) === dt ? Je : Zg();
    }
    function Ba(l, u, v, _) {
      II(), Qy && h("useInsertionEffect must not schedule updates."), wx && (b1 = !0), oc(l, v, _), (cr & Ar) !== Re && l === Jo ? Pk(u) : (ui && Zm(l, u, v), Ak(u), l === Jo && ((cr & Ar) === fo && (Yy = jt(Yy, v)), sr === Sc && Sp(l, po)), _u(l, _), v === Je && cr === fo && (u.mode & Wt) === dt &&
      // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Gf.isBatchingLegacy && (I0(), mC()));
    }
    function au(l, u, v) {
      var _ = l.current;
      _.lanes = u, oc(l, u, v), _u(l, v);
    }
    function jv(l) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (cr & Ar) !== fo
      );
    }
    function _u(l, u) {
      var v = l.callbackNode;
      Xg(l, u);
      var _ = lf(l, l === Jo ? po : Re);
      if (_ === Re) {
        v !== null && OI(v), l.callbackNode = null, l.callbackPriority = Ln;
        return;
      }
      var n = Go(_),
        a = l.callbackPriority;
      if (a === n &&
      // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Gf.current !== null && v !== D1)) {
        v == null && a !== Je && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      v != null && OI(v);
      var f;
      if (n === Je) l.tag === sm ? (Gf.isBatchingLegacy !== null && (Gf.didScheduleLegacyUpdate = !0), hC(Rk.bind(null, l))) : xS(Rk.bind(null, l)), Gf.current !== null ? Gf.current.push(vv) : lC(function () {
        (cr & (Ar | za)) === fo && vv();
      }), f = null;else {
        var m;
        switch (us(_)) {
          case al:
            m = Xu;
            break;
          case Ii:
            m = Wo;
            break;
          case Zi:
            m = eo;
            break;
          case ol:
            m = si;
            break;
          default:
            m = eo;
            break;
        }
        f = Tx(m, To.bind(null, l));
      }
      l.callbackPriority = n, l.callbackNode = f;
    }
    function To(l, u) {
      if (YC(), Ky = wn, w1 = Re, (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      var v = l.callbackNode,
        _ = Cp();
      if (_ && l.callbackNode !== v) return null;
      var n = lf(l, l === Jo ? po : Re);
      if (n === Re) return null;
      var a = !Gs(l, n) && !Aw(l, n) && !u,
        f = a ? kA(l, n) : S1(l, n);
      if (f !== ji) {
        if (f === Da) {
          var m = qs(l);
          m !== Re && (n = m, f = Tk(l, m));
        }
        if (f === T0) {
          var b = Ia;
          throw ou(l, Re), Sp(l, n), _u(l, lr()), b;
        }
        if (f === Tm) Sp(l, n);else {
          var T = !Gs(l, n),
            M = l.current.alternate;
          if (T && !xI(M)) {
            if (f = S1(l, n), f === Da) {
              var z = qs(l);
              z !== Re && (n = z, f = Tk(l, z));
            }
            if (f === T0) {
              var U = Ia;
              throw ou(l, Re), Sp(l, n), _u(l, lr()), U;
            }
          }
          l.finishedWork = M, l.finishedLanes = n, xu(l, f, n);
        }
      }
      return _u(l, lr()), l.callbackNode === v ? To.bind(null, l) : null;
    }
    function Tk(l, u) {
      var v = Rm;
      if (fr(l)) {
        var _ = ou(l, u);
        _.flags |= qr, wP(l.containerInfo);
      }
      var n = S1(l, u);
      if (n !== Da) {
        var a = ls;
        ls = v, a !== null && _I(a);
      }
      return n;
    }
    function _I(l) {
      ls === null ? ls = l : ls.push.apply(ls, l);
    }
    function xu(l, u, v) {
      switch (u) {
        case ji:
        case T0:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Da:
          {
            eb(l, ls, Xf);
            break;
          }
        case iu:
          {
            if (Sp(l, v), Qg(v) &&
            // do not delay if we're inside an act() scope
            !P0()) {
              var _ = Gy + yx - lr();
              if (_ > 10) {
                var n = lf(l, Re);
                if (n !== Re) break;
                var a = l.suspendedLanes;
                if (!$l(a, v)) {
                  el(), Km(l, a);
                  break;
                }
                l.timeoutHandle = oC(eb.bind(null, l, ls, Xf), _);
                break;
              }
            }
            eb(l, ls, Xf);
            break;
          }
        case Sc:
          {
            if (Sp(l, v), Nh(v)) break;
            if (!P0()) {
              var f = Ow(l, v),
                m = f,
                b = lr() - m,
                T = LA(b) - b;
              if (T > 10) {
                l.timeoutHandle = oC(eb.bind(null, l, ls, Xf), T);
                break;
              }
            }
            eb(l, ls, Xf);
            break;
          }
        case R0:
          {
            eb(l, ls, Xf);
            break;
          }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function xI(l) {
      for (var u = l;;) {
        if (u.flags & As) {
          var v = u.updateQueue;
          if (v !== null) {
            var _ = v.stores;
            if (_ !== null) for (var n = 0; n < _.length; n++) {
              var a = _[n],
                f = a.getSnapshot,
                m = a.value;
              try {
                if (!oe(f(), m)) return !1;
              } catch {
                return !1;
              }
            }
          }
        }
        var b = u.child;
        if (u.subtreeFlags & As && b !== null) {
          b.return = u, u = b;
          continue;
        }
        if (u === l) return !0;
        for (; u.sibling === null;) {
          if (u.return === null || u.return === l) return !0;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !0;
    }
    function Sp(l, u) {
      u = ac(u, Va), u = ac(u, Yy), lc(l, u);
    }
    function Rk(l) {
      if (r1(), (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      Cp();
      var u = lf(l, Re);
      if (!_n(u, Je)) return _u(l, lr()), null;
      var v = S1(l, u);
      if (l.tag !== sm && v === Da) {
        var _ = qs(l);
        _ !== Re && (u = _, v = Tk(l, _));
      }
      if (v === T0) {
        var n = Ia;
        throw ou(l, Re), Sp(l, u), _u(l, lr()), n;
      }
      if (v === Tm) throw new Error("Root did not complete. This is a bug in React.");
      var a = l.current.alternate;
      return l.finishedWork = a, l.finishedLanes = u, eb(l, ls, Xf), _u(l, lr()), null;
    }
    function EA(l, u) {
      u !== Re && (uf(l, jt(u, Je)), _u(l, lr()), (cr & (Ar | za)) === fo && (I0(), vv()));
    }
    function Dk(l, u) {
      var v = cr;
      cr |= g1;
      try {
        return l(u);
      } finally {
        cr = v, cr === fo &&
        // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Gf.isBatchingLegacy && (I0(), mC());
      }
    }
    function Fv(l, u, v, _, n) {
      var a = Ir(),
        f = _l.transition;
      try {
        return _l.transition = null, zr(al), l(u, v, _, n);
      } finally {
        zr(a), _l.transition = f, cr === fo && I0();
      }
    }
    function Ep(l) {
      Qf !== null && Qf.tag === sm && (cr & (Ar | za)) === fo && Cp();
      var u = cr;
      cr |= g1;
      var v = _l.transition,
        _ = Ir();
      try {
        return _l.transition = null, zr(al), l ? l() : void 0;
      } finally {
        zr(_), _l.transition = v, cr = u, (cr & (Ar | za)) === fo && vv();
      }
    }
    function SI() {
      return (cr & (Ar | za)) !== fo;
    }
    function L0(l, u) {
      ka(os, Wn, l), Wn = jt(Wn, u);
    }
    function Ik(l) {
      Wn = os.current, ca(os, l);
    }
    function ou(l, u) {
      l.finishedWork = null, l.finishedLanes = Re;
      var v = l.timeoutHandle;
      if (v !== n_ && (l.timeoutHandle = n_, zO(v)), da !== null) for (var _ = da.return; _ !== null;) {
        var n = _.alternate;
        yl(n, _), _ = _.return;
      }
      Jo = l;
      var a = tl(l.current, null);
      return da = a, po = Wn = u, sr = ji, Ia = null, Ec = Re, Yy = Re, Va = Re, Rm = null, ls = null, Ey(), If.discardPendingWarnings(), a;
    }
    function Mk(l, u) {
      do {
        var v = da;
        try {
          if (Qb(), Oy(), Un(), Ck.current = null, v === null || v.return === null) {
            sr = T0, Ia = u, da = null;
            return;
          }
          if (Ce && v.mode & nn && ox(v, !0), Ee) if (to(), u !== null && typeof u == "object" && typeof u.then == "function") {
            var _ = u;
            Oh(v, _, po);
          } else Hg(v, u, po);
          NP(l, v.return, v, u, po), CI(v);
        } catch (n) {
          u = n, da === v && v !== null ? (v = v.return, da = v) : v = da;
          continue;
        }
        return;
      } while (!0);
    }
    function xx() {
      var l = Ek.current;
      return Ek.current = nx, l === null ? nx : l;
    }
    function _1(l) {
      Ek.current = l;
    }
    function Jy() {
      Gy = lr();
    }
    function O0(l) {
      Ec = jt(l, Ec);
    }
    function EI() {
      sr === ji && (sr = iu);
    }
    function x1() {
      (sr === ji || sr === iu || sr === Da) && (sr = Sc), Jo !== null && (Fh(Ec) || Fh(Yy)) && Sp(Jo, po);
    }
    function CA(l) {
      sr !== Sc && (sr = Da), Rm === null ? Rm = [l] : Rm.push(l);
    }
    function Sx() {
      return sr === ji;
    }
    function S1(l, u) {
      var v = cr;
      cr |= Ar;
      var _ = xx();
      if (Jo !== l || po !== u) {
        if (ui) {
          var n = l.memoizedUpdaters;
          n.size > 0 && (kx(l, po), n.clear()), df(l, u);
        }
        Xf = sc(), ou(l, u);
      }
      Vl(u);
      do try {
        Lk();
        break;
      } catch (a) {
        Mk(l, a);
      } while (!0);
      if (Qb(), cr = v, _1(_), da !== null) throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Ns(), Jo = null, po = Re, sr;
    }
    function Lk() {
      for (; da !== null;) Ex(da);
    }
    function kA(l, u) {
      var v = cr;
      cr |= Ar;
      var _ = xx();
      if (Jo !== l || po !== u) {
        if (ui) {
          var n = l.memoizedUpdaters;
          n.size > 0 && (kx(l, po), n.clear()), df(l, u);
        }
        Xf = sc(), I0(), ou(l, u);
      }
      Vl(u);
      do try {
        TA();
        break;
      } catch (a) {
        Mk(l, a);
      } while (!0);
      return Qb(), _1(_), cr = v, da !== null ? (qg(), ji) : (Ns(), Jo = null, po = Re, sr);
    }
    function TA() {
      for (; da !== null && !kh();) Ex(da);
    }
    function Ex(l) {
      var u = l.alternate;
      Rn(l);
      var v;
      (l.mode & nn) !== dt ? (XC(l), v = k1(u, l, Wn), ox(l, !0)) : v = k1(u, l, Wn), Un(), l.memoizedProps = l.pendingProps, v === null ? CI(l) : da = v, Ck.current = null;
    }
    function CI(l) {
      var u = l;
      do {
        var v = u.alternate,
          _ = u.return;
        if ((u.flags & Gu) === pt) {
          Rn(u);
          var n = void 0;
          if ((u.mode & nn) === dt ? n = wk(v, u, Wn) : (XC(u), n = wk(v, u, Wn), ox(u, !1)), Un(), n !== null) {
            da = n;
            return;
          }
        } else {
          var a = hx(v, u);
          if (a !== null) {
            a.flags &= Ag, da = a;
            return;
          }
          if ((u.mode & nn) !== dt) {
            ox(u, !1);
            for (var f = u.actualDuration, m = u.child; m !== null;) f += m.actualDuration, m = m.sibling;
            u.actualDuration = f;
          }
          if (_ !== null) _.flags |= Gu, _.subtreeFlags = pt, _.deletions = null;else {
            sr = Tm, da = null;
            return;
          }
        }
        var b = u.sibling;
        if (b !== null) {
          da = b;
          return;
        }
        u = _, da = u;
      } while (u !== null);
      sr === ji && (sr = R0);
    }
    function eb(l, u, v) {
      var _ = Ir(),
        n = _l.transition;
      try {
        _l.transition = null, zr(al), RA(l, u, v, _);
      } finally {
        _l.transition = n, zr(_);
      }
      return null;
    }
    function RA(l, u, v, _) {
      do Cp(); while (Qf !== null);
      if (OA(), (cr & (Ar | za)) !== fo) throw new Error("Should not already be working.");
      var n = l.finishedWork,
        a = l.finishedLanes;
      if (zg(a), n === null) return wa(), null;
      if (a === Re && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), l.finishedWork = null, l.finishedLanes = Re, n === l.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      l.callbackNode = null, l.callbackPriority = Ln;
      var f = jt(n.lanes, n.childLanes);
      Qm(l, f), l === Jo && (Jo = null, da = null, po = Re), ((n.subtreeFlags & Ja) !== pt || (n.flags & Ja) !== pt) && (Lv || (Lv = !0, Dm = v, Tx(eo, function () {
        return Cp(), null;
      })));
      var m = (n.subtreeFlags & (Uo | Ho | $o | Ja)) !== pt,
        b = (n.flags & (Uo | Ho | $o | Ja)) !== pt;
      if (m || b) {
        var T = _l.transition;
        _l.transition = null;
        var M = Ir();
        zr(al);
        var z = cr;
        cr |= za, Ck.current = null, lI(l, n), zD(), pI(l, n, a), $z(l.containerInfo), l.current = n, Ku(a), oA(n, l, a), Yd(), Th(), cr = z, zr(M), _l.transition = T;
      } else l.current = n, zD();
      var U = Lv;
      if (Lv ? (Lv = !1, Qf = l, Xy = a) : (Av = 0, M0 = null), f = l.pendingLanes, f === Re && (xp = null), U || MI(l.current, !1), zl(n.stateNode, _), ui && l.memoizedUpdaters.clear(), _A(), _u(l, lr()), u !== null) for (var X = l.onRecoverableError, J = 0; J < u.length; J++) {
        var me = u[J],
          xe = me.stack,
          Ie = me.digest;
        X(me.value, {
          componentStack: xe,
          digest: Ie
        });
      }
      if (y1) {
        y1 = !1;
        var Pe = Kf;
        throw Kf = null, Pe;
      }
      return _n(Xy, Je) && l.tag !== sm && Cp(), f = l.pendingLanes, _n(f, Je) ? (n1(), l === bx ? Im++ : (Im = 0, bx = l)) : Im = 0, vv(), wa(), null;
    }
    function Cp() {
      if (Qf !== null) {
        var l = us(Xy),
          u = Jg(Zi, l),
          v = _l.transition,
          _ = Ir();
        try {
          return _l.transition = null, zr(u), tb();
        } finally {
          zr(_), _l.transition = v;
        }
      }
      return !1;
    }
    function kI(l) {
      Ov.push(l), Lv || (Lv = !0, Tx(eo, function () {
        return Cp(), null;
      }));
    }
    function tb() {
      if (Qf === null) return !1;
      var l = Dm;
      Dm = null;
      var u = Qf,
        v = Xy;
      if (Qf = null, Xy = Re, (cr & (Ar | za)) !== fo) throw new Error("Cannot flush passive effects while already rendering.");
      wx = !0, b1 = !1, $g(v);
      var _ = cr;
      cr |= za, uA(u.current), lA(u, u.current, v, l);
      {
        var n = Ov;
        Ov = [];
        for (var a = 0; a < n.length; a++) {
          var f = n[a];
          tA(u, f);
        }
      }
      Wg(), MI(u.current, !0), cr = _, vv(), b1 ? u === M0 ? Av++ : (Av = 0, M0 = u) : Av = 0, wx = !1, b1 = !1, Rh(u);
      {
        var m = u.current.stateNode;
        m.effectDuration = 0, m.passiveEffectDuration = 0;
      }
      return !0;
    }
    function TI(l) {
      return xp !== null && xp.has(l);
    }
    function Mm(l) {
      xp === null ? xp = /* @__PURE__ */new Set([l]) : xp.add(l);
    }
    function DA(l) {
      y1 || (y1 = !0, Kf = l);
    }
    var IA = DA;
    function Ok(l, u, v) {
      var _ = Em(v, u),
        n = i1(l, _, Je),
        a = wm(l, n, Je),
        f = el();
      a !== null && (oc(a, Je, f), _u(a, f));
    }
    function Fi(l, u, v) {
      if (JP(v), A0(!1), l.tag === C) {
        Ok(l, l, v);
        return;
      }
      var _ = null;
      for (_ = u; _ !== null;) {
        if (_.tag === C) {
          Ok(_, l, v);
          return;
        } else if (_.tag === x) {
          var n = _.type,
            a = _.stateNode;
          if (typeof n.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && !TI(a)) {
            var f = Em(v, l),
              m = QC(_, f, Je),
              b = wm(_, m, Je),
              T = el();
            b !== null && (oc(b, Je, T), _u(b, T));
            return;
          }
        }
        _ = _.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, v);
    }
    function MA(l, u, v) {
      var _ = l.pingCache;
      _ !== null && _.delete(u);
      var n = el();
      Km(l, v), jk(l), Jo === l && $l(po, v) && (sr === Sc || sr === iu && Qg(po) && lr() - Gy < yx ? ou(l, Re) : Va = jt(Va, v)), _u(l, n);
    }
    function RI(l, u) {
      u === Ln && (u = wI(l));
      var v = el(),
        _ = vu(l, u);
      _ !== null && (oc(_, u, v), _u(_, v));
    }
    function DI(l) {
      var u = l.memoizedState,
        v = Ln;
      u !== null && (v = u.retryLane), RI(l, v);
    }
    function Ni(l, u) {
      var v = Ln,
        _;
      switch (l.tag) {
        case V:
          _ = l.stateNode;
          var n = l.memoizedState;
          n !== null && (v = n.retryLane);
          break;
        case Y:
          _ = l.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      _ !== null && _.delete(u), RI(l, v);
    }
    function LA(l) {
      return l < 120 ? 120 : l < 480 ? 480 : l < 1080 ? 1080 : l < 1920 ? 1920 : l < 3e3 ? 3e3 : l < 4320 ? 4320 : SA(l / 1960) * 1960;
    }
    function II() {
      if (Im > Pv) throw Im = 0, bx = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Av > _x && (Av = 0, M0 = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function OA() {
      If.flushLegacyContextWarning(), If.flushPendingUnsafeLifecycleWarnings();
    }
    function MI(l, u) {
      Rn(l), E1(l, Bo, yA), u && E1(l, ga, bA), E1(l, Bo, vA), u && E1(l, ga, gA), Un();
    }
    function E1(l, u, v) {
      for (var _ = l, n = null; _ !== null;) {
        var a = _.subtreeFlags & u;
        _ !== n && _.child !== null && a !== pt ? _ = _.child : ((_.flags & u) !== pt && v(_), _.sibling !== null ? _ = _.sibling : _ = n = _.return);
      }
    }
    var C1 = null;
    function LI(l) {
      {
        if ((cr & Ar) !== fo || !(l.mode & Wt)) return;
        var u = l.tag;
        if (u !== E && u !== C && u !== x && u !== w && u !== F && u !== K && u !== G) return;
        var v = At(l) || "ReactComponent";
        if (C1 !== null) {
          if (C1.has(v)) return;
          C1.add(v);
        } else C1 = /* @__PURE__ */new Set([v]);
        var _ = Pr;
        try {
          Rn(l), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          _ ? Rn(l) : Un();
        }
      }
    }
    var k1;
    {
      var T1 = null;
      k1 = function (l, u, v) {
        var _ = L1(T1, u);
        try {
          return bp(l, u, v);
        } catch (a) {
          if (CP() || a !== null && typeof a == "object" && typeof a.then == "function") throw a;
          if (Qb(), Oy(), yl(l, u), L1(u, _), u.mode & nn && XC(u), Vo(null, bp, null, l, u, v), Qa()) {
            var n = Yu();
            typeof n == "object" && n !== null && n._suppressLogging && typeof a == "object" && a !== null && !a._suppressLogging && (a._suppressLogging = !0);
          }
          throw a;
        }
      };
    }
    var Cx = !1,
      R1;
    R1 = /* @__PURE__ */new Set();
    function Pk(l) {
      if (Po && !HC()) switch (l.tag) {
        case w:
        case F:
        case G:
          {
            var u = da && At(da) || "Unknown",
              v = u;
            if (!R1.has(v)) {
              R1.add(v);
              var _ = At(l) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", _, u, u);
            }
            break;
          }
        case x:
          {
            Cx || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Cx = !0);
            break;
          }
      }
    }
    function kx(l, u) {
      if (ui) {
        var v = l.memoizedUpdaters;
        v.forEach(function (_) {
          Zm(l, _, u);
        });
      }
    }
    var D1 = {};
    function Tx(l, u) {
      {
        var v = Gf.current;
        return v !== null ? (v.push(u), D1) : Ch(l, u);
      }
    }
    function OI(l) {
      if (l !== D1) return Fg(l);
    }
    function P0() {
      return Gf.current !== null;
    }
    function Ak(l) {
      {
        if (l.mode & Wt) {
          if (!bI()) return;
        } else if (!gx() || cr !== fo || l.tag !== w && l.tag !== F && l.tag !== G) return;
        if (Gf.current === null) {
          var u = Pr;
          try {
            Rn(l), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, At(l));
          } finally {
            u ? Rn(l) : Un();
          }
        }
      }
    }
    function jk(l) {
      l.tag !== sm && bI() && Gf.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function A0(l) {
      Qy = l;
    }
    var Cc = null,
      j0 = null,
      PA = function (l) {
        Cc = l;
      };
    function kp(l) {
      {
        if (Cc === null) return l;
        var u = Cc(l);
        return u === void 0 ? l : u.current;
      }
    }
    function Su(l) {
      return kp(l);
    }
    function Nv(l) {
      {
        if (Cc === null) return l;
        var u = Cc(l);
        if (u === void 0) {
          if (l != null && typeof l.render == "function") {
            var v = kp(l.render);
            if (l.render !== v) {
              var _ = {
                $$typeof: Ye,
                render: v
              };
              return l.displayName !== void 0 && (_.displayName = l.displayName), _;
            }
          }
          return l;
        }
        return u.current;
      }
    }
    function PI(l, u) {
      {
        if (Cc === null) return !1;
        var v = l.elementType,
          _ = u.type,
          n = !1,
          a = typeof _ == "object" && _ !== null ? _.$$typeof : null;
        switch (l.tag) {
          case x:
            {
              typeof _ == "function" && (n = !0);
              break;
            }
          case w:
            {
              (typeof _ == "function" || a === Ct) && (n = !0);
              break;
            }
          case F:
            {
              (a === Ye || a === Ct) && (n = !0);
              break;
            }
          case K:
          case G:
            {
              (a === $t || a === Ct) && (n = !0);
              break;
            }
          default:
            return !1;
        }
        if (n) {
          var f = Cc(v);
          if (f !== void 0 && f === Cc(_)) return !0;
        }
        return !1;
      }
    }
    function nb(l) {
      {
        if (Cc === null || typeof WeakSet != "function") return;
        j0 === null && (j0 = /* @__PURE__ */new WeakSet()), j0.add(l);
      }
    }
    var Fk = function (l, u) {
        {
          if (Cc === null) return;
          var v = u.staleFamilies,
            _ = u.updatedFamilies;
          Cp(), Ep(function () {
            I1(l.current, _, v);
          });
        }
      },
      Nk = function (l, u) {
        {
          if (l.context !== fi) return;
          Cp(), Ep(function () {
            F0(u, l, null, null);
          });
        }
      };
    function I1(l, u, v) {
      {
        var _ = l.alternate,
          n = l.child,
          a = l.sibling,
          f = l.tag,
          m = l.type,
          b = null;
        switch (f) {
          case w:
          case G:
          case x:
            b = m;
            break;
          case F:
            b = m.render;
            break;
        }
        if (Cc === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var T = !1,
          M = !1;
        if (b !== null) {
          var z = Cc(b);
          z !== void 0 && (v.has(z) ? M = !0 : u.has(z) && (f === x ? M = !0 : T = !0));
        }
        if (j0 !== null && (j0.has(l) || _ !== null && j0.has(_)) && (M = !0), M && (l._debugNeedsRemount = !0), M || T) {
          var U = vu(l, Je);
          U !== null && Ba(U, l, Je, wn);
        }
        n !== null && !M && I1(n, u, v), a !== null && I1(a, u, v);
      }
    }
    var AI = function (l, u) {
      {
        var v = /* @__PURE__ */new Set(),
          _ = new Set(u.map(function (n) {
            return n.current;
          }));
        return zk(l.current, _, v), v;
      }
    };
    function zk(l, u, v) {
      {
        var _ = l.child,
          n = l.sibling,
          a = l.tag,
          f = l.type,
          m = null;
        switch (a) {
          case w:
          case G:
          case x:
            m = f;
            break;
          case F:
            m = f.render;
            break;
        }
        var b = !1;
        m !== null && u.has(m) && (b = !0), b ? AA(l, v) : _ !== null && zk(_, u, v), n !== null && zk(n, u, v);
      }
    }
    function AA(l, u) {
      {
        var v = Vk(l, u);
        if (v) return;
        for (var _ = l;;) {
          switch (_.tag) {
            case D:
              u.add(_.stateNode);
              return;
            case k:
              u.add(_.stateNode.containerInfo);
              return;
            case C:
              u.add(_.stateNode.containerInfo);
              return;
          }
          if (_.return === null) throw new Error("Expected to reach root first.");
          _ = _.return;
        }
      }
    }
    function Vk(l, u) {
      for (var v = l, _ = !1;;) {
        if (v.tag === D) _ = !0, u.add(v.stateNode);else if (v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === l) return _;
        for (; v.sibling === null;) {
          if (v.return === null || v.return === l) return _;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
      return !1;
    }
    var Bk;
    {
      Bk = !1;
      try {
        var jI = Object.preventExtensions({});
      } catch {
        Bk = !0;
      }
    }
    function jA(l, u, v, _) {
      this.tag = l, this.key = v, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = u, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = _, this.flags = pt, this.subtreeFlags = pt, this.deletions = null, this.lanes = Re, this.childLanes = Re, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Bk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var kc = function (l, u, v, _) {
      return new jA(l, u, v, _);
    };
    function Rx(l) {
      var u = l.prototype;
      return !!(u && u.isReactComponent);
    }
    function FI(l) {
      return typeof l == "function" && !Rx(l) && l.defaultProps === void 0;
    }
    function FA(l) {
      if (typeof l == "function") return Rx(l) ? x : w;
      if (l != null) {
        var u = l.$$typeof;
        if (u === Ye) return F;
        if (u === $t) return K;
      }
      return E;
    }
    function tl(l, u) {
      var v = l.alternate;
      v === null ? (v = kc(l.tag, u, l.key, l.mode), v.elementType = l.elementType, v.type = l.type, v.stateNode = l.stateNode, v._debugSource = l._debugSource, v._debugOwner = l._debugOwner, v._debugHookTypes = l._debugHookTypes, v.alternate = l, l.alternate = v) : (v.pendingProps = u, v.type = l.type, v.flags = pt, v.subtreeFlags = pt, v.deletions = null, v.actualDuration = 0, v.actualStartTime = -1), v.flags = l.flags & nr, v.childLanes = l.childLanes, v.lanes = l.lanes, v.child = l.child, v.memoizedProps = l.memoizedProps, v.memoizedState = l.memoizedState, v.updateQueue = l.updateQueue;
      var _ = l.dependencies;
      switch (v.dependencies = _ === null ? null : {
        lanes: _.lanes,
        firstContext: _.firstContext
      }, v.sibling = l.sibling, v.index = l.index, v.ref = l.ref, v.selfBaseDuration = l.selfBaseDuration, v.treeBaseDuration = l.treeBaseDuration, v._debugNeedsRemount = l._debugNeedsRemount, v.tag) {
        case E:
        case w:
        case G:
          v.type = kp(l.type);
          break;
        case x:
          v.type = Su(l.type);
          break;
        case F:
          v.type = Nv(l.type);
          break;
      }
      return v;
    }
    function Uk(l, u) {
      l.flags &= nr | Gn;
      var v = l.alternate;
      if (v === null) l.childLanes = Re, l.lanes = u, l.child = null, l.subtreeFlags = pt, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null, l.selfBaseDuration = 0, l.treeBaseDuration = 0;else {
        l.childLanes = v.childLanes, l.lanes = v.lanes, l.child = v.child, l.subtreeFlags = pt, l.deletions = null, l.memoizedProps = v.memoizedProps, l.memoizedState = v.memoizedState, l.updateQueue = v.updateQueue, l.type = v.type;
        var _ = v.dependencies;
        l.dependencies = _ === null ? null : {
          lanes: _.lanes,
          firstContext: _.firstContext
        }, l.selfBaseDuration = v.selfBaseDuration, l.treeBaseDuration = v.treeBaseDuration;
      }
      return l;
    }
    function NA(l, u, v) {
      var _;
      return l === _S ? (_ = Wt, u === !0 && (_ |= Xn, _ |= Ri)) : _ = dt, ui && (_ |= nn), kc(C, null, null, _);
    }
    function Hk(l, u, v, _, n, a) {
      var f = E,
        m = l;
      if (typeof l == "function") Rx(l) ? (f = x, m = Su(m)) : m = kp(m);else if (typeof l == "string") f = D;else e: switch (l) {
        case Lo:
          return zv(v.children, n, a, u);
        case $a:
          f = P, n |= Xn, (n & Wt) !== dt && (n |= Ri);
          break;
        case Oo:
          return zA(v, n, a, u);
        case xt:
          return $k(v, n, a, u);
        case rn:
          return Wk(v, n, a, u);
        case Tn:
          return Om(v, n, a, u);
        case jn:
        // eslint-disable-next-line no-fallthrough
        case qt:
        // eslint-disable-next-line no-fallthrough
        case Or:
        // eslint-disable-next-line no-fallthrough
        case Wa:
        // eslint-disable-next-line no-fallthrough
        case yr:
        // eslint-disable-next-line no-fallthrough
        default:
          {
            if (typeof l == "object" && l !== null) switch (l.$$typeof) {
              case Z:
                f = O;
                break e;
              case Ne:
                f = N;
                break e;
              case Ye:
                f = F, m = Nv(m);
                break e;
              case $t:
                f = K;
                break e;
              case Ct:
                f = Q, m = null;
                break e;
            }
            var b = "";
            {
              (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var T = _ ? At(_) : null;
              T && (b += `

Check the render method of \`` + T + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (l == null ? l : typeof l) + "." + b));
          }
      }
      var M = kc(f, v, u, n);
      return M.elementType = l, M.type = m, M.lanes = a, M._debugOwner = _, M;
    }
    function Lm(l, u, v) {
      var _ = null;
      _ = l._owner;
      var n = l.type,
        a = l.key,
        f = l.props,
        m = Hk(n, a, f, _, u, v);
      return m._debugSource = l._source, m._debugOwner = l._owner, m;
    }
    function zv(l, u, v, _) {
      var n = kc(L, l, _, u);
      return n.lanes = v, n;
    }
    function zA(l, u, v, _) {
      typeof l.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof l.id);
      var n = kc(j, l, _, u | nn);
      return n.elementType = Oo, n.lanes = v, n.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, n;
    }
    function $k(l, u, v, _) {
      var n = kc(V, l, _, u);
      return n.elementType = xt, n.lanes = v, n;
    }
    function Wk(l, u, v, _) {
      var n = kc(Y, l, _, u);
      return n.elementType = rn, n.lanes = v, n;
    }
    function Om(l, u, v, _) {
      var n = kc(ae, l, _, u);
      n.elementType = Tn, n.lanes = v;
      var a = {
        isHidden: !1
      };
      return n.stateNode = a, n;
    }
    function qk(l, u, v) {
      var _ = kc(I, l, null, u);
      return _.lanes = v, _;
    }
    function VA() {
      var l = kc(D, null, null, dt);
      return l.elementType = "DELETED", l;
    }
    function BA(l) {
      var u = kc(ie, null, null, dt);
      return u.stateNode = l, u;
    }
    function M1(l, u, v) {
      var _ = l.children !== null ? l.children : [],
        n = kc(k, _, l.key, u);
      return n.lanes = v, n.stateNode = {
        containerInfo: l.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: l.implementation
      }, n;
    }
    function L1(l, u) {
      return l === null && (l = kc(E, null, null, dt)), l.tag = u.tag, l.key = u.key, l.elementType = u.elementType, l.type = u.type, l.stateNode = u.stateNode, l.return = u.return, l.child = u.child, l.sibling = u.sibling, l.index = u.index, l.ref = u.ref, l.pendingProps = u.pendingProps, l.memoizedProps = u.memoizedProps, l.updateQueue = u.updateQueue, l.memoizedState = u.memoizedState, l.dependencies = u.dependencies, l.mode = u.mode, l.flags = u.flags, l.subtreeFlags = u.subtreeFlags, l.deletions = u.deletions, l.lanes = u.lanes, l.childLanes = u.childLanes, l.alternate = u.alternate, l.actualDuration = u.actualDuration, l.actualStartTime = u.actualStartTime, l.selfBaseDuration = u.selfBaseDuration, l.treeBaseDuration = u.treeBaseDuration, l._debugSource = u._debugSource, l._debugOwner = u._debugOwner, l._debugNeedsRemount = u._debugNeedsRemount, l._debugHookTypes = u._debugHookTypes, l;
    }
    function UA(l, u, v, _, n) {
      this.tag = u, this.containerInfo = l, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = n_, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ln, this.eventTimes = sf(Re), this.expirationTimes = sf(wn), this.pendingLanes = Re, this.suspendedLanes = Re, this.pingedLanes = Re, this.expiredLanes = Re, this.mutableReadLanes = Re, this.finishedLanes = Re, this.entangledLanes = Re, this.entanglements = sf(Re), this.identifierPrefix = _, this.onRecoverableError = n, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */new Set();
        for (var a = this.pendingUpdatersLaneMap = [], f = 0; f < zs; f++) a.push(/* @__PURE__ */new Set());
      }
      switch (u) {
        case _S:
          this._debugRootType = v ? "hydrateRoot()" : "createRoot()";
          break;
        case sm:
          this._debugRootType = v ? "hydrate()" : "render()";
          break;
      }
    }
    function NI(l, u, v, _, n, a, f, m, b, T) {
      var M = new UA(l, u, v, m, b),
        z = NA(u, a);
      M.current = z, z.stateNode = M;
      {
        var U = {
          element: _,
          isDehydrated: v,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        z.memoizedState = U;
      }
      return __(z), M;
    }
    var Dx = "18.2.0";
    function zI(l, u, v) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return un(_), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: oi,
        key: _ == null ? null : "" + _,
        children: l,
        containerInfo: u,
        implementation: v
      };
    }
    var Yk, O1;
    Yk = !1, O1 = {};
    function P1(l) {
      if (!l) return fi;
      var u = Ps(l),
        v = wS(u);
      if (u.tag === x) {
        var _ = u.type;
        if (eu(_)) return bS(u, _, v);
      }
      return v;
    }
    function HA(l, u) {
      {
        var v = Ps(l);
        if (v === void 0) {
          if (typeof l.render == "function") throw new Error("Unable to find node on an unmounted component.");
          var _ = Object.keys(l).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + _);
        }
        var n = Xr(v);
        if (n === null) return null;
        if (n.mode & Xn) {
          var a = At(v) || "Component";
          if (!O1[a]) {
            O1[a] = !0;
            var f = Pr;
            try {
              Rn(n), v.mode & Xn ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, a) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", u, u, a);
            } finally {
              f ? Rn(f) : Un();
            }
          }
        }
        return n.stateNode;
      }
    }
    function A1(l, u, v, _, n, a, f, m) {
      var b = !1,
        T = null;
      return NI(l, u, b, T, v, _, n, a, f);
    }
    function j1(l, u, v, _, n, a, f, m, b, T) {
      var M = !0,
        z = NI(v, _, M, l, n, a, f, m, b);
      z.context = P1(null);
      var U = z.current,
        X = el(),
        J = Zf(U),
        me = Of(X, J);
      return me.callback = u ?? null, wm(U, me, J), au(z, J, X), z;
    }
    function F0(l, u, v, _) {
      ki(u, l);
      var n = u.current,
        a = el(),
        f = Zf(n);
      _a(f);
      var m = P1(v);
      u.context === null ? u.context = m : u.pendingContext = m, Po && Pr !== null && !Yk && (Yk = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, At(Pr) || "Unknown"));
      var b = Of(a, f);
      b.payload = {
        element: l
      }, _ = _ === void 0 ? null : _, _ !== null && (typeof _ != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", _), b.callback = _);
      var T = wm(n, b, f);
      return T !== null && (Ba(T, n, f, a), Hc(T, n, f)), f;
    }
    function F1(l) {
      var u = l.current;
      if (!u.child) return null;
      switch (u.child.tag) {
        case D:
          return u.child.stateNode;
        default:
          return u.child.stateNode;
      }
    }
    function VI(l) {
      switch (l.tag) {
        case C:
          {
            var u = l.stateNode;
            if (fr(u)) {
              var v = Kg(u);
              EA(u, v);
            }
            break;
          }
        case V:
          {
            Ep(function () {
              var n = vu(l, Je);
              if (n !== null) {
                var a = el();
                Ba(n, l, Je, a);
              }
            });
            var _ = Je;
            rb(l, _);
            break;
          }
      }
    }
    function Gk(l, u) {
      var v = l.memoizedState;
      v !== null && v.dehydrated !== null && (v.retryLane = Sb(v.retryLane, u));
    }
    function rb(l, u) {
      Gk(l, u);
      var v = l.alternate;
      v && Gk(v, u);
    }
    function N1(l) {
      if (l.tag === V) {
        var u = Hs,
          v = vu(l, u);
        if (v !== null) {
          var _ = el();
          Ba(v, l, u, _);
        }
        rb(l, u);
      }
    }
    function $A(l) {
      if (l.tag === V) {
        var u = Zf(l),
          v = vu(l, u);
        if (v !== null) {
          var _ = el();
          Ba(v, l, u, _);
        }
        rb(l, u);
      }
    }
    function Xk(l) {
      var u = In(l);
      return u === null ? null : u.stateNode;
    }
    var z1 = function (l) {
      return null;
    };
    function WA(l) {
      return z1(l);
    }
    var BI = function (l) {
      return !1;
    };
    function UI(l) {
      return BI(l);
    }
    var Kk = null,
      HI = null,
      Qk = null,
      $I = null,
      Zk = null,
      Jk = null,
      eT = null,
      tT = null,
      nT = null;
    {
      var rT = function (l, u, v) {
          var _ = u[v],
            n = wr(l) ? l.slice() : Qt({}, l);
          return v + 1 === u.length ? (wr(n) ? n.splice(_, 1) : delete n[_], n) : (n[_] = rT(l[_], u, v + 1), n);
        },
        iT = function (l, u) {
          return rT(l, u, 0);
        },
        aT = function (l, u, v, _) {
          var n = u[_],
            a = wr(l) ? l.slice() : Qt({}, l);
          if (_ + 1 === u.length) {
            var f = v[_];
            a[f] = a[n], wr(a) ? a.splice(n, 1) : delete a[n];
          } else a[n] = aT(
          // $FlowFixMe number or string is fine here
          l[n], u, v, _ + 1);
          return a;
        },
        oT = function (l, u, v) {
          if (u.length !== v.length) {
            p("copyWithRename() expects paths of the same length");
            return;
          } else for (var _ = 0; _ < v.length - 1; _++) if (u[_] !== v[_]) {
            p("copyWithRename() expects paths to be the same except for the deepest key");
            return;
          }
          return aT(l, u, v, 0);
        },
        lT = function (l, u, v, _) {
          if (v >= u.length) return _;
          var n = u[v],
            a = wr(l) ? l.slice() : Qt({}, l);
          return a[n] = lT(l[n], u, v + 1, _), a;
        },
        sT = function (l, u, v) {
          return lT(l, u, 0, v);
        },
        V1 = function (l, u) {
          for (var v = l.memoizedState; v !== null && u > 0;) v = v.next, u--;
          return v;
        };
      Kk = function (l, u, v, _) {
        var n = V1(l, u);
        if (n !== null) {
          var a = sT(n.memoizedState, v, _);
          n.memoizedState = a, n.baseState = a, l.memoizedProps = Qt({}, l.memoizedProps);
          var f = vu(l, Je);
          f !== null && Ba(f, l, Je, wn);
        }
      }, HI = function (l, u, v) {
        var _ = V1(l, u);
        if (_ !== null) {
          var n = iT(_.memoizedState, v);
          _.memoizedState = n, _.baseState = n, l.memoizedProps = Qt({}, l.memoizedProps);
          var a = vu(l, Je);
          a !== null && Ba(a, l, Je, wn);
        }
      }, Qk = function (l, u, v, _) {
        var n = V1(l, u);
        if (n !== null) {
          var a = oT(n.memoizedState, v, _);
          n.memoizedState = a, n.baseState = a, l.memoizedProps = Qt({}, l.memoizedProps);
          var f = vu(l, Je);
          f !== null && Ba(f, l, Je, wn);
        }
      }, $I = function (l, u, v) {
        l.pendingProps = sT(l.memoizedProps, u, v), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var _ = vu(l, Je);
        _ !== null && Ba(_, l, Je, wn);
      }, Zk = function (l, u) {
        l.pendingProps = iT(l.memoizedProps, u), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var v = vu(l, Je);
        v !== null && Ba(v, l, Je, wn);
      }, Jk = function (l, u, v) {
        l.pendingProps = oT(l.memoizedProps, u, v), l.alternate && (l.alternate.pendingProps = l.pendingProps);
        var _ = vu(l, Je);
        _ !== null && Ba(_, l, Je, wn);
      }, eT = function (l) {
        var u = vu(l, Je);
        u !== null && Ba(u, l, Je, wn);
      }, tT = function (l) {
        z1 = l;
      }, nT = function (l) {
        BI = l;
      };
    }
    function WI(l) {
      var u = Xr(l);
      return u === null ? null : u.stateNode;
    }
    function qI(l) {
      return null;
    }
    function YI() {
      return Pr;
    }
    function uT(l) {
      var u = l.findFiberByHostInstance,
        v = i.ReactCurrentDispatcher;
      return Fs({
        bundleType: l.bundleType,
        version: l.version,
        rendererPackageName: l.rendererPackageName,
        rendererConfig: l.rendererConfig,
        overrideHookState: Kk,
        overrideHookStateDeletePath: HI,
        overrideHookStateRenamePath: Qk,
        overrideProps: $I,
        overridePropsDeletePath: Zk,
        overridePropsRenamePath: Jk,
        setErrorHandler: tT,
        setSuspenseHandler: nT,
        scheduleUpdate: eT,
        currentDispatcherRef: v,
        findHostInstanceByFiber: WI,
        findFiberByHostInstance: u || qI,
        // React Refresh
        findHostInstancesForRefresh: AI,
        scheduleRefresh: Fk,
        scheduleRoot: Nk,
        setRefreshHandler: PA,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: YI,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: Dx
      });
    }
    var GI = typeof reportError == "function" ?
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : function (l) {
      console.error(l);
    };
    function cT(l) {
      this._internalRoot = l;
    }
    B1.prototype.render = cT.prototype.render = function (l) {
      var u = this._internalRoot;
      if (u === null) throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? h("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : U1(arguments[1]) ? h("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && h("You passed a second argument to root.render(...) but it only accepts one argument.");
        var v = u.containerInfo;
        if (v.nodeType !== er) {
          var _ = Xk(u.current);
          _ && _.parentNode !== v && h("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      F0(l, u, null, null);
    }, B1.prototype.unmount = cT.prototype.unmount = function () {
      typeof arguments[0] == "function" && h("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var l = this._internalRoot;
      if (l !== null) {
        this._internalRoot = null;
        var u = l.containerInfo;
        SI() && h("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Ep(function () {
          F0(null, l, null, null);
        }), $b(u);
      }
    };
    function qA(l, u) {
      if (!U1(l)) throw new Error("createRoot(...): Target container is not a DOM element.");
      KI(l);
      var v = !1,
        _ = !1,
        n = "",
        a = GI;
      u != null && (u.hydrate ? p("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof u == "object" && u !== null && u.$$typeof === $i && h(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), u.unstable_strictMode === !0 && (v = !0), u.identifierPrefix !== void 0 && (n = u.identifierPrefix), u.onRecoverableError !== void 0 && (a = u.onRecoverableError), u.transitionCallbacks !== void 0 && u.transitionCallbacks);
      var f = A1(l, _S, null, v, _, n, a);
      mS(f.current, l);
      var m = l.nodeType === er ? l.parentNode : l;
      return lv(m), new cT(f);
    }
    function B1(l) {
      this._internalRoot = l;
    }
    function XI(l) {
      l && kb(l);
    }
    B1.prototype.unstable_scheduleHydration = XI;
    function dT(l, u, v) {
      if (!U1(l)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      KI(l), u === void 0 && h("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var _ = v ?? null,
        n = v != null && v.hydratedSources || null,
        a = !1,
        f = !1,
        m = "",
        b = GI;
      v != null && (v.unstable_strictMode === !0 && (a = !0), v.identifierPrefix !== void 0 && (m = v.identifierPrefix), v.onRecoverableError !== void 0 && (b = v.onRecoverableError));
      var T = j1(u, null, l, _S, _, a, f, m, b);
      if (mS(T.current, l), lv(l), n) for (var M = 0; M < n.length; M++) {
        var z = n[M];
        jC(T, z);
      }
      return new B1(T);
    }
    function U1(l) {
      return !!(l && (l.nodeType === Wr || l.nodeType === Ka || l.nodeType === ph));
    }
    function Vv(l) {
      return !!(l && (l.nodeType === Wr || l.nodeType === Ka || l.nodeType === ph || l.nodeType === er && l.nodeValue === " react-mount-point-unstable "));
    }
    function KI(l) {
      l.nodeType === Wr && l.tagName && l.tagName.toUpperCase() === "BODY" && h("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), pv(l) && (l._reactRootContainer ? h("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : h("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var YA = i.ReactCurrentOwner,
      Ix;
    Ix = function (l) {
      if (l._reactRootContainer && l.nodeType !== er) {
        var u = Xk(l._reactRootContainer.current);
        u && u.parentNode !== l && h("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var v = !!l._reactRootContainer,
        _ = ib(l),
        n = !!(_ && Nc(_));
      n && !v && h("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), l.nodeType === Wr && l.tagName && l.tagName.toUpperCase() === "BODY" && h("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function ib(l) {
      return l ? l.nodeType === Ka ? l.documentElement : l.firstChild : null;
    }
    function fT() {}
    function GA(l, u, v, _, n) {
      if (n) {
        if (typeof _ == "function") {
          var a = _;
          _ = function () {
            var U = F1(f);
            a.call(U);
          };
        }
        var f = j1(u, _, l, sm, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        fT);
        l._reactRootContainer = f, mS(f.current, l);
        var m = l.nodeType === er ? l.parentNode : l;
        return lv(m), Ep(), f;
      } else {
        for (var b; b = l.lastChild;) l.removeChild(b);
        if (typeof _ == "function") {
          var T = _;
          _ = function () {
            var U = F1(M);
            T.call(U);
          };
        }
        var M = A1(l, sm, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        fT);
        l._reactRootContainer = M, mS(M.current, l);
        var z = l.nodeType === er ? l.parentNode : l;
        return lv(z), Ep(function () {
          F0(u, M, v, _);
        }), M;
      }
    }
    function QI(l, u) {
      l !== null && typeof l != "function" && h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u, l);
    }
    function N0(l, u, v, _, n) {
      Ix(v), QI(n === void 0 ? null : n, "render");
      var a = v._reactRootContainer,
        f;
      if (!a) f = GA(v, u, l, n, _);else {
        if (f = a, typeof n == "function") {
          var m = n;
          n = function () {
            var b = F1(f);
            m.call(b);
          };
        }
        F0(u, f, l, n);
      }
      return F1(f);
    }
    function ZI(l) {
      {
        var u = YA.current;
        if (u !== null && u.stateNode !== null) {
          var v = u.stateNode._warnedAboutRefsInRender;
          v || h("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", bn(u.type) || "A component"), u.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return l == null ? null : l.nodeType === Wr ? l : HA(l, "findDOMNode");
    }
    function XA(l, u, v) {
      if (h("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(u)) throw new Error("Target container is not a DOM element.");
      {
        var _ = pv(u) && u._reactRootContainer === void 0;
        _ && h("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return N0(null, l, u, !0, v);
    }
    function KA(l, u, v) {
      if (h("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(u)) throw new Error("Target container is not a DOM element.");
      {
        var _ = pv(u) && u._reactRootContainer === void 0;
        _ && h("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return N0(null, l, u, !1, v);
    }
    function H1(l, u, v, _) {
      if (h("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vv(v)) throw new Error("Target container is not a DOM element.");
      if (l == null || !Mw(l)) throw new Error("parentComponent must be a valid React Component");
      return N0(l, u, v, !1, _);
    }
    function QA(l) {
      if (!Vv(l)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var u = pv(l) && l._reactRootContainer === void 0;
        u && h("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (l._reactRootContainer) {
        {
          var v = ib(l),
            _ = v && !Nc(v);
          _ && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Ep(function () {
          N0(null, null, l, !1, function () {
            l._reactRootContainer = null, $b(l);
          });
        }), !0;
      } else {
        {
          var n = ib(l),
            a = !!(n && Nc(n)),
            f = l.nodeType === Wr && Vv(l.parentNode) && !!l.parentNode._reactRootContainer;
          a && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", f ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Eb(VI), ey(N1), cs($A), Jm(Ir), du(sa), (typeof Map != "function" ||
    // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" ||
    // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && h("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ld(tC), Iw(Dk, Fv, Ep);
    function ZA(l, u) {
      var v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!U1(u)) throw new Error("Target container is not a DOM element.");
      return zI(l, u, null, v);
    }
    function JA(l, u, v, _) {
      return H1(l, u, v, _);
    }
    var pT = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Nc, zc, Sf, Is, Od, Dk]
    };
    function ej(l, u) {
      return pT.usingClientEntryPoint || h('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), qA(l, u);
    }
    function tj(l, u, v) {
      return pT.usingClientEntryPoint || h('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), dT(l, u, v);
    }
    function nj(l) {
      return SI() && h("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Ep(l);
    }
    var hT = uT({
      findFiberByHostInstance: hv,
      bundleType: 1,
      version: Dx,
      rendererPackageName: "react-dom"
    });
    if (!hT && Xe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var JI = window.location.protocol;
      /^(https?|file):$/.test(JI) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (JI === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Jf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pT, Jf.createPortal = ZA, Jf.createRoot = ej, Jf.findDOMNode = ZI, Jf.flushSync = nj, Jf.hydrate = XA, Jf.hydrateRoot = tj, Jf.render = KA, Jf.unmountComponentAtNode = QA, Jf.unstable_batchedUpdates = Dk, Jf.unstable_renderSubtreeIntoContainer = JA, Jf.version = Dx, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Jf;
}
var rB;
function oK() {
  if (rB) return fM.exports;
  rB = 1;
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (t(), fM.exports = iK()) : fM.exports = aK(), fM.exports;
}
var lK = oK();
function S4(t, e) {
  if (t == null) return {};
  var i = {},
    s = Object.keys(t),
    c,
    p;
  for (p = 0; p < s.length; p++) c = s[p], !(e.indexOf(c) >= 0) && (i[c] = t[c]);
  return i;
}
var E4 = typeof window < "u" && typeof document < "u";
function F2(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function iB() {
  return E4 && document.createElement("div");
}
function sK(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function C4(t, e) {
  if (t === e) return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length) return !1;
    for (var i in t) if (e.hasOwnProperty(i)) {
      if (!C4(t[i], e[i])) return !1;
    } else return !1;
    return !0;
  } else return !1;
}
function uK(t) {
  var e = [];
  return t.forEach(function (i) {
    e.find(function (s) {
      return C4(i, s);
    }) || e.push(i);
  }), e;
}
function cK(t, e) {
  var i, s;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: uK([].concat(((i = t.popperOptions) == null ? void 0 : i.modifiers) || [], ((s = e.popperOptions) == null ? void 0 : s.modifiers) || []))
    })
  });
}
var xj = E4 ? NR : Rt;
function dK(t) {
  var e = vt();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function aB(t, e, i) {
  i.split(/\s+/).forEach(function (s) {
    s && t.classList[e](s);
  });
}
var fK = {
  name: "className",
  defaultValue: "",
  fn: function (t) {
    var e = t.popper.firstElementChild,
      i = function () {
        var p;
        return !!((p = t.props.render) != null && p.$$tippy);
      };
    function s() {
      if (t.props.className && !i()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      aB(e, "add", t.props.className);
    }
    function c() {
      i() && aB(e, "remove", t.props.className);
    }
    return {
      onCreate: s,
      onBeforeUpdate: c,
      onAfterUpdate: s
    };
  }
};
function pK(t) {
  function e(i) {
    var s = i.children,
      c = i.content,
      p = i.visible,
      h = i.singleton,
      y = i.render,
      w = i.reference,
      x = i.disabled,
      E = x === void 0 ? !1 : x,
      C = i.ignoreAttributes,
      k = C === void 0 ? !0 : C;
    i.__source, i.__self;
    var D = S4(i, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]),
      I = p !== void 0,
      L = h !== void 0,
      P = rt(!1),
      N = P[0],
      O = P[1],
      F = rt({}),
      j = F[0],
      V = F[1],
      K = rt(),
      G = K[0],
      Q = K[1],
      te = dK(function () {
        return {
          container: iB(),
          renders: 1
        };
      }),
      ie = Object.assign({
        ignoreAttributes: k
      }, D, {
        content: te.container
      });
    I && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function (ne) {
      ie[ne] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + ne + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), ie.trigger = "manual", ie.hideOnClick = !1), L && (E = !0);
    var Y = ie,
      ee = ie.plugins || [];
    y && (Y = Object.assign({}, ie, {
      plugins: L && h.data != null ? [].concat(ee, [{
        fn: function () {
          return {
            onTrigger: function (ne, le) {
              var ce = h.data.children.find(function (W) {
                var $ = W.instance;
                return $.reference === le.currentTarget;
              });
              ne.state.$$activeSingletonInstance = ce.instance, Q(ce.content);
            }
          };
        }
      }]) : ee,
      render: function () {
        return {
          popper: te.container
        };
      }
    }));
    var ae = [w].concat(s ? [s.type] : []);
    return xj(function () {
      var ne = w;
      w && w.hasOwnProperty("current") && (ne = w.current);
      var le = t(ne || te.ref || iB(), Object.assign({}, Y, {
        plugins: [fK].concat(ie.plugins || [])
      }));
      return te.instance = le, E && le.disable(), p && le.show(), L && h.hook({
        instance: le,
        content: c,
        props: Y,
        setSingletonContent: Q
      }), O(!0), function () {
        le.destroy(), h == null || h.cleanup(le);
      };
    }, ae), xj(function () {
      var ne;
      if (te.renders === 1) {
        te.renders++;
        return;
      }
      var le = te.instance;
      le.setProps(cK(le.props, Y)), (ne = le.popperInstance) == null || ne.forceUpdate(), E ? le.disable() : le.enable(), I && (p ? le.show() : le.hide()), L && h.hook({
        instance: le,
        content: c,
        props: Y,
        setSingletonContent: Q
      });
    }), xj(function () {
      var ne;
      if (y) {
        var le = te.instance;
        le.setProps({
          popperOptions: Object.assign({}, le.props.popperOptions, {
            modifiers: [].concat((((ne = le.props.popperOptions) == null ? void 0 : ne.modifiers) || []).filter(function (ce) {
              var W = ce.name;
              return W !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function (ce) {
                var W,
                  $ = ce.state,
                  de = (W = $.modifiersData) == null ? void 0 : W.hide;
                (j.placement !== $.placement || j.referenceHidden !== (de == null ? void 0 : de.isReferenceHidden) || j.escaped !== (de == null ? void 0 : de.hasPopperEscaped)) && V({
                  placement: $.placement,
                  referenceHidden: de == null ? void 0 : de.isReferenceHidden,
                  escaped: de == null ? void 0 : de.hasPopperEscaped
                }), $.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [j.placement, j.referenceHidden, j.escaped].concat(ae)), /* @__PURE__ */Nt.createElement(Nt.Fragment, null, s ? /* @__PURE__ */FR(s, {
      ref: function (ne) {
        te.ref = ne, F2(s.ref, ne);
      }
    }) : null, N && /* @__PURE__ */lK.createPortal(y ? y(sK(j), G, te.instance) : c, te.container));
  }
  return e;
}
var hK = function (t, e) {
    return /* @__PURE__ */Qn(function (i, s) {
      var c = i.children,
        p = S4(i, ["children"]);
      return (
        // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        /* @__PURE__ */
        Nt.createElement(t, Object.assign({}, e, p), c ? /* @__PURE__ */FR(c, {
          ref: function (h) {
            F2(s, h), F2(c.ref, h);
          }
        }) : null)
      );
    });
  },
  mK = /* @__PURE__ */hK(/* @__PURE__ */pK(HR));
const vK = /* @__PURE__ */new Set(["key", "ref", "children", "dangerouslySetInnerHTML"]),
  gK = (t, e) => {
    if (!t) return null;
    const i = c => {
        const {
          className: p,
          ...h
        } = c;
        return {
          safeData: Object.fromEntries(Object.entries(h).filter(([y]) => !vK.has(y))),
          dataClassName: p
        };
      },
      s = (c, p, h) => Nt.cloneElement(c, {
        ...p,
        className: Ze(h, c.props.className)
      });
    if (typeof t == "function") {
      const c = t(e);
      if (Nt.isValidElement(c)) {
        const {
          safeData: p,
          dataClassName: h
        } = i(e);
        return s(c, p, h);
      }
      if (Nt.Children.count(c)) {
        const p = Nt.Children.toArray(c).filter(w => Nt.isValidElement(w)),
          {
            safeData: h,
            dataClassName: y
          } = i(e);
        return p.map((w, x) => s(w, {
          key: w.key || x,
          ...h
        }, y));
      }
      return c;
    }
    if (Nt.isValidElement(t)) {
      const {
        safeData: c,
        dataClassName: p
      } = i(e);
      return s(t, c, p);
    }
    if (Nt.Children.count(t)) {
      const c = Nt.Children.toArray(t).filter(y => Nt.isValidElement(y)),
        {
          safeData: p,
          dataClassName: h
        } = i(e);
      return c.map((y, w) => s(y, {
        key: y.key || w,
        ...p
      }, h));
    }
    return null;
  },
  yK = "_popover_fibcz_2",
  bK = "_selectedValue_fibcz_15",
  wK = "_popoverInput_fibcz_30",
  _K = "_popoverInputValue_fibcz_42",
  xK = "_dropdownIcon_fibcz_64",
  SK = "_dropdownIconDisabled_fibcz_76",
  Rp = {
    popover: yK,
    selectedValue: bK,
    popoverInput: wK,
    popoverInputValue: _K,
    dropdownIcon: xK,
    dropdownIconDisabled: SK
  },
  EK = {
    noResults: "No results found",
    a11yOpenMenu: "Open menu",
    a11yCloseMenu: "Close menu",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"'
  },
  CK = ({
    id: t,
    isDisabled: e = !1,
    errorMessage: i,
    className: s,
    classNames: c,
    iconOptions: p,
    label: h,
    labels: y = {},
    value: w,
    children: x,
    onChange: E,
    onClose: C = () => !0,
    defaultCloseIcon: k = !0,
    helperText: D,
    isLoading: I = !1
  }) => {
    const L = {
        ...EK,
        ...y
      },
      P = vt(null),
      [N, O] = rt(!1),
      [F, j] = rt(!1);
    Rt(() => {
      let G = null;
      if (N && P != null && P.current) return G = P.current, j(!0), $L(P.current, {
        reserveScrollBarGap: !0,
        allowTouchMove: Q => {
          let te = Q;
          for (; te && te.parentElement;) {
            if (te.hasAttribute("body-scroll-lock-ignore")) return !0;
            te = te.parentElement;
          }
          return !1;
        }
      }), () => {
        G && aR(G);
      };
    }, [N]);
    const V = () => C() === !1 ? !1 : (O(!1), j(!1), !0),
      K = () => {
        O(!N);
      };
    return /* @__PURE__ */we.jsx(AE, {
      ref: P,
      className: vs(Rp.popover, N && !I && [c == null ? void 0 : c.inputWrapperOpen], (!!w || I) && [Rp.selectedValue, c == null ? void 0 : c.inputWrapperSelected], s, F && Rp.popoverFocus),
      classNames: {
        label: vs(c == null ? void 0 : c.inputLabel),
        helperText: c == null ? void 0 : c.inputHelperText,
        errorText: vs(!e && i && (c == null ? void 0 : c.inputErrorText)),
        focus: vs(F && (c == null ? void 0 : c.inputWrapperFocus)),
        error: vs(!e && i && [Rp.popoverError, c == null ? void 0 : c.inputWrapperError]),
        disabled: vs(e && [Rp.popoverInputDisabled, c == null ? void 0 : c.inputWrapperDisabled])
      },
      errorMessage: i,
      messageId: `${t}-message`,
      isDisabled: e,
      helperText: D,
      isFocused: F && !I,
      children: /* @__PURE__ */we.jsxs("div", {
        className: vs(c == null ? void 0 : c.inputContainer),
        children: [/* @__PURE__ */we.jsxs("button", {
          disabled: e,
          type: "button",
          "aria-label": N && !I ? L.a11yCloseMenu : L.a11yOpenMenu,
          "aria-describedby": D || i ? `${t}-message` : void 0,
          onFocusCapture: () => {
            j(!0);
          },
          onBlurCapture: () => {
            j(!1);
          },
          className: vs(Rp.popoverInput, I && (c == null ? void 0 : c.inputLoader), c == null ? void 0 : c.inputToggleButton),
          id: `${t}-input`,
          onClick: K,
          onKeyDown: G => {
            (G.key === "Enter" || G.key === " " || G.key === "Spacebar") && (G.preventDefault(), K());
          },
          children: [/* @__PURE__ */we.jsx("label", {
            id: `${t}-label`,
            children: h
          }), /* @__PURE__ */we.jsx("span", {
            className: vs(Rp.popoverInputValue, c == null ? void 0 : c.value),
            children: w
          }), I && /* @__PURE__ */we.jsx(FE, {
            className: c == null ? void 0 : c.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1
          }), !e && !I && /* @__PURE__ */we.jsxs("span", {
            "aria-hidden": "true",
            className: vs(c == null ? void 0 : c.icon, i ? [Rp.dropdownIcon, Rp.dropdownIconError, c == null ? void 0 : c.iconError] : Rp.dropdownIcon),
            children: [N && ((p == null ? void 0 : p.open) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "▲"
            })), !N && ((p == null ? void 0 : p.close) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "▼"
            }))]
          }), e && /* @__PURE__ */we.jsx("span", {
            "aria-hidden": "true",
            className: vs(Rp.dropdownIcon, Rp.dropdownIconDisabled, c == null ? void 0 : c.icon, c == null ? void 0 : c.iconDisabled),
            children: (p == null ? void 0 : p.disabled) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "×"
            })
          })]
        }), N && /* @__PURE__ */we.jsx(mK, {
          reference: P.current,
          visible: N,
          interactive: !0,
          appendTo: P.current || void 0,
          placement: "bottom-start",
          popperOptions: {
            strategy: "absolute",
            modifiers: [{
              name: "flip",
              enabled: !1
            }, {
              name: "offset",
              enabled: !1
            }, {
              name: "preventOverflow",
              enabled: !0,
              options: {
                padding: 0,
                boundary: typeof window < "u" ? window : "scrollParent"
              }
            }, {
              name: "maxHeight",
              enabled: !0,
              phase: "afterMain",
              requiresIfExists: ["offset"],
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              fn({
                state: G
              }) {
                const Q = window.innerHeight - G.elements.popper.getBoundingClientRect().top - 16;
                G.styles.popper = {
                  ...G.styles.popper,
                  maxHeight: `${Q}px`,
                  width: "100%",
                  boxShadow: "-5px 9px 16px rgba(0, 0, 0, 0.29)"
                };
              }
            }]
          },
          render: G => {
            const Q = {
              isOpen: N,
              handleClose: V,
              handleUpdateValue: te => {
                E(te), V();
              }
            };
            return /* @__PURE__ */we.jsx(e4.FocusTrap, {
              active: N,
              paused: !N,
              focusTrapOptions: {
                allowOutsideClick: te => {
                  var ie;
                  return (ie = te.target.closest("label")) != null && ie.contains(P.current) ? !0 : C() === !1 ? (te.stopPropagation(), !1) : (V(), !0);
                },
                clickOutsideDeactivates: !0,
                onDeactivate: V
              },
              children: /* @__PURE__ */we.jsx("div", {
                ...G,
                className: vs(c == null ? void 0 : c.popover),
                children: /* @__PURE__ */we.jsxs("div", {
                  className: vs(c == null ? void 0 : c.popoverContainer, N && [c == null ? void 0 : c.popoverContainerOpen]),
                  children: [k && /* @__PURE__ */we.jsx("button", {
                    type: "button",
                    className: vs(c == null ? void 0 : c.closeButton),
                    id: t,
                    onClick: V,
                    children: /* @__PURE__ */we.jsx(Qv, {
                      children: k
                    })
                  }), gK(x, Q)]
                })
              })
            });
          }
        })]
      })
    });
  },
  kK = "_wrapper_tdghy_1",
  TK = "_input_tdghy_17",
  RK = "_error_tdghy_101",
  DK = "_disabled_tdghy_126",
  IK = "_label_tdghy_143",
  MK = "_helperText_tdghy_154",
  G1 = {
    wrapper: kK,
    input: TK,
    error: RK,
    disabled: DK,
    label: IK,
    helperText: MK
  },
  k4 = Qn(({
    id: t,
    label: e,
    name: i,
    value: s,
    isSelected: c = !1,
    isError: p = !1,
    isRequired: h = !1,
    isDisabled: y = !1,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: k,
    isInteractive: D = !0,
    renderLabel: I
  }, L) => {
    const [P, N] = rt(c),
      O = {
        label: e,
        id: t,
        value: s
      },
      F = {
        label: x == null ? void 0 : x.label,
        id: x == null ? void 0 : x.id,
        value: x == null ? void 0 : x.value
      },
      j = Ze(G1.wrapper, C, !P && p && Ze(G1.error, k == null ? void 0 : k.error), y && Ze(G1.disabled, k == null ? void 0 : k.disabled), k == null ? void 0 : k.wrapper),
      V = Q => {
        O.id !== F.id && (N(!0), E == null || E(Q, !0, O));
      },
      K = Q => {
        O.id !== F.id ? (N(!0), E == null || E(Q, !0, O)) : O.id === F.id && (N(!1), E == null || E(Q, !1, void 0));
      },
      G = Q => {
        ["Space", "Enter"].includes(Q.code) && (O.id !== F.id ? (N(!0), E == null || E(Q, !0, O)) : O.id === F.id && (N(!1), E == null || E(Q, !1, void 0)));
      };
    return Rt(() => {
      O.id !== F.id ? N(!1) : (O.id === F.id || c) && N(!0);
    }, [x, c]), /* @__PURE__ */we.jsxs("div", {
      className: j,
      children: [/* @__PURE__ */we.jsx("input", {
        ref: L,
        className: Ze(G1.input, k == null ? void 0 : k.input),
        type: "radio",
        id: t,
        name: i,
        value: s,
        checked: !y && (O.id === F.id || c || !F && P),
        onChange: V,
        onClick: K,
        onKeyUp: G,
        required: h,
        disabled: D ? y : !0,
        "aria-describedby": w ? `${t}-message` : void 0
      }), /* @__PURE__ */we.jsx("span", {
        "aria-hidden": "true"
      }), /* @__PURE__ */we.jsx("label", {
        htmlFor: t,
        className: Ze(G1.label, k == null ? void 0 : k.label),
        children: I ? I(O) : e
      }), w && /* @__PURE__ */we.jsx("div", {
        id: `${t}-message`,
        className: Ze(G1.helperText, k == null ? void 0 : k.helperText),
        children: w
      })]
    });
  }),
  LK = "_fieldset_kog2t_1",
  OK = "_hideLabel_kog2t_9",
  PK = "_label_kog2t_21",
  AK = "_stacked_kog2t_32",
  jK = "_options_kog2t_32",
  FK = "_inline_kog2t_40",
  NK = "_wrapper_kog2t_49",
  Nm = {
    fieldset: LK,
    hideLabel: OK,
    label: PK,
    stacked: AK,
    options: jK,
    inline: FK,
    wrapper: NK
  },
  zK = ({
    id: t,
    name: e,
    description: i,
    displayStacked: s = !1,
    options: c,
    label: p,
    hideLabel: h = !1,
    selectedOption: y,
    errorMessage: w,
    onChange: x,
    allowDeselect: E = !0,
    className: C,
    classNames: k,
    renderLabel: D
  }) => {
    const [I, L] = rt(y),
      P = (N, O, F) => {
        (E || F) && (L(F), x == null || x(N, O, F));
      };
    return /* @__PURE__ */we.jsx("div", {
      id: t,
      className: Ze(s ? Nm.stacked : Nm.inline, {
        [C]: C
      }),
      children: /* @__PURE__ */we.jsxs("fieldset", {
        className: Ze(Nm.fieldset, k == null ? void 0 : k.fieldset),
        "aria-describedby": Ze(i ? `${t}-description` : void 0, w ? `${t}-error` : void 0),
        children: [/* @__PURE__ */we.jsxs("div", {
          className: Ze((i || !h) && Nm.label, k == null ? void 0 : k.groupLabel),
          children: [/* @__PURE__ */we.jsx("legend", {
            className: Ze(h && Nm.hideLabel),
            children: p
          }), i && /* @__PURE__ */we.jsx("span", {
            id: `${t}-description`,
            className: Ze(Nm.description, k == null ? void 0 : k.description),
            children: i
          })]
        }), /* @__PURE__ */we.jsx("div", {
          className: Ze(Nm.options, k == null ? void 0 : k.options),
          children: c.map(N => /* @__PURE__ */we.jsx(k4, {
            label: N.label,
            id: N.id,
            name: e,
            value: N.value,
            isSelected: I === N,
            isDisabled: N.isDisabled,
            isRequired: N.isRequired,
            isError: !!w && I === void 0,
            helperText: N.helperText,
            selectedOption: I,
            onChange: P,
            renderLabel: D,
            classNames: {
              wrapper: Ze(Nm.wrapper, k == null ? void 0 : k.wrapper),
              label: Ze(k == null ? void 0 : k.label),
              input: Ze(k == null ? void 0 : k.input),
              error: Ze(Nm.error, k == null ? void 0 : k.error),
              disabled: Ze(Nm.disabled, k == null ? void 0 : k.disabled),
              helperText: Ze(Nm.helperText, k == null ? void 0 : k.helperText)
            }
          }, N.id))
        }), !!w && I === void 0 && /* @__PURE__ */we.jsx("div", {
          role: "alert",
          id: `${t}-error`,
          className: Ze(k == null ? void 0 : k.errorMessage),
          children: /* @__PURE__ */we.jsx("span", {
            children: w
          })
        })]
      })
    });
  },
  VK = "_container_1bg47_1",
  BK = "_col_1bg47_7",
  oB = {
    container: VK,
    col: BK
  },
  M_e = ({
    columns: t,
    renderComponent: e
  }) => /* @__PURE__ */we.jsx("div", {
    className: oB.container,
    children: t == null ? void 0 : t.map((i, s) => {
      var c;
      return /* @__PURE__ */we.jsx("div", {
        className: oB.col,
        style: {
          "--_mobile-cols": i.columnSizes.mobile.value,
          "--_tablet-cols": i.columnSizes.tablet.value,
          "--_desktop-cols": i.columnSizes.desktop.value
        },
        children: (c = i.components) == null ? void 0 : c.map((p, h) => e(p, h))
      }, s);
    })
  }),
  UK = "_rating_1poqx_1",
  HK = "_ratingText_1poqx_14",
  lB = {
    rating: UK,
    ratingText: HK
  },
  $K = ({
    rating: t = 0,
    ratingText: e,
    maximum: i = 5,
    simple: s = !1,
    classNames: c,
    renderSolidIcon: p = /* @__PURE__ */we.jsx(we.Fragment, {
      children: "★"
    }),
    renderPartialIcon: h = /* @__PURE__ */we.jsx(we.Fragment, {
      children: "½"
    }),
    renderOutlineIcon: y = /* @__PURE__ */we.jsx(we.Fragment, {
      children: "☆"
    })
  }) => {
    const w = i <= 0 ? 0 : Math.floor(i);
    let x = t >= w ? w : t;
    return x = x < 0 ? 0 : x, /* @__PURE__ */we.jsxs("div", {
      className: Ze(lB.rating, c == null ? void 0 : c.container),
      children: [w > 0 && [...Array(Math.floor(s ? 1 : x))].map((E, C) => /* @__PURE__ */we.jsx(Qv, {
        children: p
      }, `${C}-solid`)), w > 0 && !s && x % 1 !== 0 && /* @__PURE__ */we.jsx(we.Fragment, {
        children: h
      }), w > 0 && !s && Math.round(x) < w && [...Array(w > 0 ? w - Math.ceil(x) : 1)].map((E, C) => /* @__PURE__ */we.jsx(Qv, {
        children: y
      }, `${C}-outline`)), /* @__PURE__ */we.jsx("span", {
        className: Ze(lB.ratingText, c == null ? void 0 : c.rating),
        children: e ?? x.toFixed(1)
      })]
    });
  },
  T4 = "Tabs",
  R4 = "TabsList",
  D4 = "TabsTrigger",
  I4 = "TabsContent",
  [WK, L_e] = LE(T4, [GL]),
  M4 = GL(),
  [qK, zE] = WK(T4),
  L4 = Qn((t, e) => {
    const {
        __scopeTabs: i,
        loop: s = !0,
        ...c
      } = t,
      p = zE(R4, i),
      h = M4(i);
    return /* @__PURE__ */we.jsx(hN, {
      asChild: !0,
      ...h,
      orientation: p.orientation,
      dir: p.dir,
      loop: s,
      children: /* @__PURE__ */we.jsx(la.div, {
        role: "tablist",
        "aria-orientation": p.orientation,
        ...c,
        ref: e
      })
    });
  });
L4.displayName = R4;
function O4(t, e) {
  return `${t}-trigger-${e}`;
}
function P4(t, e) {
  return `${t}-content-${e}`;
}
const A4 = Qn((t, e) => {
  const {
      __scopeTabs: i,
      value: s,
      children: c,
      ...p
    } = t,
    h = zE(I4, i),
    y = O4(h.baseId, s),
    w = P4(h.baseId, s),
    x = s === h.value,
    E = vt(x);
  return Rt(() => {
    const C = requestAnimationFrame(() => E.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), /* @__PURE__ */we.jsx(la.div, {
    "data-state": x ? "active" : "inactive",
    "data-orientation": h.orientation,
    role: "tabpanel",
    "aria-labelledby": y,
    hidden: !x,
    id: w,
    tabIndex: 0,
    ...p,
    ref: e,
    style: {
      animationDuration: E.current ? "0s" : void 0
    },
    children: c
  });
});
A4.displayName = I4;
const j4 = Qn((t, e) => {
  const {
      __scopeTabs: i,
      value: s,
      disabled: c = !1,
      ...p
    } = t,
    h = zE(D4, i),
    y = M4(i),
    w = O4(h.baseId, s),
    x = P4(h.baseId, s),
    E = s === h.value;
  return /* @__PURE__ */we.jsx($5, {
    asChild: !0,
    ...y,
    focusable: !c,
    active: E,
    children: /* @__PURE__ */we.jsx(la.button, {
      type: "button",
      role: "tab",
      "aria-selected": E,
      "aria-controls": x,
      "data-state": E ? "active" : "inactive",
      "data-disabled": c ? "" : void 0,
      disabled: c,
      id: w,
      ...p,
      ref: e,
      onMouseDown: zp(t.onMouseDown, C => {
        !c && C.button === 0 && C.ctrlKey === !1 ? h.onValueChange(s) : C.preventDefault();
      }),
      onKeyDown: zp(t.onKeyDown, C => {
        [" ", "Enter"].includes(C.key) && h.onValueChange(s);
      }),
      onFocus: zp(t.onFocus, () => {
        const C = h.activationMode !== "manual";
        !E && !c && C && h.onValueChange(s);
      })
    })
  });
});
j4.displayName = D4;
const YK = Qn((t, e) => {
    const {
        __scopeTabs: i,
        value: s,
        onValueChange: c,
        defaultValue: p,
        orientation: h = "horizontal",
        dir: y,
        activationMode: w = "automatic",
        ...x
      } = t,
      E = dN(y),
      [C, k] = PE({
        prop: s,
        onChange: c,
        defaultProp: p ?? ""
      });
    return /* @__PURE__ */we.jsx(qK, {
      scope: i,
      baseId: ME(),
      value: C,
      onValueChange: k,
      orientation: h,
      dir: E,
      activationMode: w,
      children: /* @__PURE__ */we.jsx(la.div, {
        dir: E,
        "data-orientation": h,
        ...x,
        ref: e
      })
    });
  }),
  GK = "_tag_11kiq_1",
  XK = {
    tag: GK
  },
  F4 = ({
    icon: t,
    label: e,
    className: i
  }) => /* @__PURE__ */we.jsx(we.Fragment, {
    children: e && /* @__PURE__ */we.jsxs("span", {
      className: Ze(XK.tag, i),
      children: [t && t, e]
    })
  }),
  KK = "_wrapper_184bp_1",
  QK = "_input_184bp_14",
  ZK = "_inputIcon_184bp_26",
  Sj = {
    wrapper: KK,
    input: QK,
    inputIcon: ZK
  },
  JK = Qn(({
    id: t,
    label: e,
    name: i,
    disabled: s = !1,
    readOnly: c = !1,
    onChange: p,
    onBlur: h,
    onFocus: y,
    errorMessage: w,
    value: x,
    showCounter: E = !0,
    renderCounterText: C,
    required: k,
    iconOptions: D,
    className: I,
    classNames: L,
    ...P
  }, N) => {
    const [O, F] = rt(x ?? ""),
      [j, V] = rt(!1),
      K = vt(null),
      [G, Q] = rt(!0),
      te = pn((ne, le) => {
        if (!(!E || !le)) return C ? C(ne, le) : "{{ count }}/{{ maxLength }}".replace("{{ count }}", ne.toString()).replace("{{ maxLength }}", le.toString());
      }, [E, P.maxLength]),
      ie = ne => {
        const le = ne.target.value;
        F(le), p == null || p(ne, le, ne.target.validity.valid), Q(ne.target.validity.valid);
      },
      Y = ne => {
        V(!1), h == null || h(ne);
      },
      ee = ne => {
        V(!0), y == null || y(ne);
      },
      ae = ci(() => !c && (j ||
      // The input is currently focused
      O ||
      // There is a value present
      !G) || c && !!O && !!e, [c, j, O, G, e]);
    return Rt(() => {
      F(x ?? "");
    }, [x]), jR(N, () => K.current, []), /* @__PURE__ */we.jsx(AE, {
      id: t,
      isLabel: !0,
      label: e || "<Label is required>",
      errorMessage: w,
      helperText: te(O.length, P.maxLength),
      messageId: `${t}-message`,
      className: I,
      classNames: {
        label: Ze(L == null ? void 0 : L.inputLabel, s && (L == null ? void 0 : L.inputLabelDisabled), ae && (L == null ? void 0 : L.inputFocus)),
        helperText: L == null ? void 0 : L.inputHelperText,
        errorText: Ze((w || !G) && (L == null ? void 0 : L.inputErrorText))
      },
      children: /* @__PURE__ */we.jsxs("div", {
        className: Ze(Sj.wrapper, L == null ? void 0 : L.inputWrapper, w && (L == null ? void 0 : L.inputError)),
        children: [/* @__PURE__ */we.jsx("textarea", {
          id: t,
          ref: K,
          className: Ze(Sj.input, L == null ? void 0 : L.input, O && (L == null ? void 0 : L.value)),
          name: i || t,
          value: O,
          disabled: s,
          readOnly: c,
          onChange: ie,
          onFocus: ee,
          onBlur: Y,
          required: k,
          ...P,
          ...((E || w) && {
            "aria-describedby": `${t}-message`
          })
        }), /* @__PURE__ */we.jsx("span", {
          role: "presentation",
          className: Ze(L == null ? void 0 : L.inputBorder)
        }), s && /* @__PURE__ */we.jsx("div", {
          "aria-hidden": "true",
          className: Ze(Sj.inputIcon, L == null ? void 0 : L.iconDisable),
          children: D != null && D.disabled ? D.disabled : /* @__PURE__ */we.jsx(we.Fragment, {
            children: "×"
          })
        })]
      })
    });
  }),
  eQ = {
    noResults: "No results found",
    searchLabel: "Search",
    clearSelection: "Clear the selection",
    a11ySelectedLiveRegion: 'Selected option changed to "{{ label }}"',
    a11yNoResultsLiveRegion: "No results found"
  },
  tQ = "_wrapper_1dw9q_1",
  nQ = "_input_1dw9q_13",
  rQ = "_listBox_1dw9q_17",
  iQ = "_listBoxOpen_1dw9q_26",
  aQ = "_overlay_1dw9q_31",
  oQ = "_listItem_1dw9q_39",
  lQ = "_noResults_1dw9q_48",
  sQ = "_srOnly_1dw9q_52",
  Zc = {
    wrapper: tQ,
    input: nQ,
    listBox: rQ,
    listBoxOpen: iQ,
    overlay: aQ,
    listItem: oQ,
    noResults: lQ,
    srOnly: sQ
  },
  uQ = Qn(({
    id: t,
    label: e,
    isLoading: i = !1,
    loaderConfig: s,
    isReadOnly: c,
    isDisabled: p,
    isInlineMode: h = !1,
    helperText: y,
    errorMessage: w,
    iconOptions: x,
    data: E,
    selectedItem: C = null,
    initialSelectedItem: k = null,
    environment: D,
    children: I,
    className: L,
    classNames: P,
    onFocus: N,
    onBlur: O,
    onChange: F,
    onInput: j,
    onOpenTypeahead: V,
    renderCustomListItem: K,
    labels: G,
    onSearch: Q,
    template: te = "default"
  }, ie) => {
    const Y = {
        ...eQ,
        ...G
      },
      [ee, ae] = rt(E),
      ne = vt(null),
      le = vt(null),
      ce = vt(null),
      W = typeof window < "u",
      [$, de] = rt(!1),
      [H, se] = rt(""),
      [ue, Ee] = rt(k),
      [Ce, fe] = rt(!1),
      [_e, Se] = rt(!1),
      be = vt(),
      Le = vt(),
      Be = Ke => Ke.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
      Xe = (Ke, yt) => {
        if (!yt) return Ke;
        const je = Be(yt),
          at = new RegExp(`(${je})`, "ig");
        return Ke.split(at).map((kt, Bt) => (at.lastIndex = 0, Bt % 2 === 1 ? /* @__PURE__ */we.jsx("span", {
          className: P == null ? void 0 : P.listItemHighlightedText,
          children: kt
        }, `filter-group-${Bt}`) : kt));
      },
      ge = Ke => Ke ? Ke.label : "",
      qe = Ke => Ke && Ke.reduce((yt, je) => (yt.push(...je.items), yt), []),
      Ae = pn(Ke => Ke != null && Ke.trim() ? E.map(yt => ({
        title: (yt == null ? void 0 : yt.title) ?? "",
        items: yt.items.filter(je => {
          var at, kt;
          return ((at = je == null ? void 0 : je.label) == null ? void 0 : at.toLowerCase().includes(Ke == null ? void 0 : Ke.toLowerCase())) || ((kt = je == null ? void 0 : je.value) == null ? void 0 : kt.toLowerCase().includes(Ke == null ? void 0 : Ke.toLowerCase()));
        })
      })).filter(yt => yt.items.length > 0) : E, [E]),
      Mt = (Ke, yt) => {
        const {
          type: je,
          changes: at
        } = yt;
        return je === iE.stateChangeTypes.InputKeyDownEscape ? {
          ...at,
          selectedItem: null
        } : je === iE.stateChangeTypes.InputBlur ? {
          ...at,
          inputValue: ge(at.selectedItem || null)
        } : at;
      },
      Ft = qe(ee),
      {
        setHighlightedIndex: un,
        inputValue: gt,
        highlightedIndex: Pt,
        getMenuProps: St,
        getInputProps: Dt,
        getItemProps: Kt,
        reset: hn,
        setInputValue: Lt
      } = iE({
        id: t,
        labelId: t,
        stateReducer: Mt,
        items: Ft,
        itemToString: ge,
        initialSelectedItem: k,
        isOpen: _e && $,
        onStateChange: Ke => {
          var yt;
          c || i || p || ((Ke == null ? void 0 : Ke.isOpen) !== void 0 && $ && Se(Ke.isOpen), Ke.type === iE.stateChangeTypes.InputBlur && (O == null || O()), Ke.inputValue && Ke.inputValue === ((yt = Ke.selectedItem) == null ? void 0 : yt.label) && ae(E));
        },
        onIsOpenChange: Ke => {
          const {
            matches: yt
          } = window.matchMedia(`(max-width: ${nd.breakpoint.sm.value})`);
          ne != null && ne.current && (Ke.isOpen && yt ? ($L(ne.current), V == null || V(ne.current)) : aR(ne.current));
        },
        onInputValueChange: async Ke => {
          const yt = Ke.inputValue ?? "",
            je = j == null ? void 0 : j(yt);
          try {
            const at = await Promise.resolve(je);
            Array.isArray(at) ? ae(at) : ae(Ae(yt));
          } catch (at) {
            console.error("Typeahead: Failed to resolve onInput:", at), ae(Ae(yt));
          }
          yt === "" ? (de(!1), Se(!1)) : Ke != null && Ke.isOpen && Se(Ke.isOpen);
        },
        onSelectedItemChange: Ke => {
          var yt;
          Le.current = void 0, (yt = le.current) == null || yt.focus();
          const je = Ke.selectedItem ?? null;
          Ee(je), je && (F == null || F(je)), se((je == null ? void 0 : je.label) ?? ""), je === null && hn();
        },
        environment: D ? {
          addEventListener: D.addEventListener.bind(D),
          removeEventListener: D.removeEventListener.bind(D),
          document: (D == null ? void 0 : D.document) ?? document,
          Node: D.Node
        } : W ? window : void 0
      }),
      Et = Ke => Ke.reduce((yt, je, at) => (yt.sections.push(/* @__PURE__ */we.jsx("ul", {
        role: "group",
        className: P == null ? void 0 : P.listItemGroup,
        children: je.items.map((kt, Bt) => {
          yt.itemIndex += 1;
          const Ht = typeof ue == "object" && (ue == null ? void 0 : ue.id) === kt.id,
            sn = {
              item: kt,
              index: yt.itemIndex,
              className: Ze(Zc.listItem, P == null ? void 0 : P.listItem, Ht && (P == null ? void 0 : P.listItemSelected), Pt === yt.itemIndex && (P == null ? void 0 : P.listItemActive)),
              "aria-selected": Ht,
              // Add this event to help limit the section heading accessibility fix
              onClick: en => {
                en.stopPropagation();
              }
            };
          return K ? K(`item-${yt.itemIndex}`, (ue == null ? void 0 : ue.id) ?? "", at, kt, Bt, Kt, sn, je, P) : /* @__PURE__ */we.jsxs(Qv, {
            children: [je.displayTitle && Bt === 0 && (je == null ? void 0 : je.title) && /* @__PURE__ */we.jsx("li", {
              "aria-hidden": "true",
              id: `separator-${at}`,
              role: "separator",
              className: P == null ? void 0 : P.listHeading,
              children: je.title
            }, `heading-${at}`), /* @__PURE__ */we.jsx("li", {
              ...Kt(sn),
              children: Xe(kt.label, gt)
            }, `item-${yt.itemIndex}`)]
          }, `fragment-${yt.itemIndex}`);
        })
      }, `${t}-group-${at}`)), yt), {
        sections: [],
        itemIndex: -1
      }).sections,
      Vt = Ke => {
        var yt;
        fe(!1);
        const je = Ke == null ? void 0 : Ke.target,
          at = Ke == null ? void 0 : Ke.relatedTarget;
        !((yt = je == null ? void 0 : je.value) != null && yt.trim()) && ue && Lt(ue.label), O == null || O(), (!at || be.current === "mouse") && (Le.current = void 0);
      },
      Xt = () => {
        fe(!0), N == null || N();
      },
      vn = ci(() => !i && (!c && Ce || c && ue && !!e), [c, Ce, ue, e, i]),
      ot = Ke => {
        var yt;
        Ke.type === "mousedown" && Ke.preventDefault(), hn(), Ee(null), fe(!0), (yt = le.current) == null || yt.focus(), Le.current = void 0, O == null || O();
      },
      We = Ke => {
        Le.current = Ke.shiftKey ? `Shift+${Ke.key}` : Ke.key, be.current = "keyboard";
      },
      ht = () => be.current = "mouse";
    return Rt(() => {
      var Ke, yt;
      E && gt && (ae(Ae(gt)), gt && !k && Le != null && Le.current && (Le.current !== "Tab" ? (Ke = le.current) == null || Ke.focus() : Le.current === "Tab" && ((yt = ce.current) == null || yt.focus())));
    }, [E, gt]), Rt(() => {
      C !== null && Ee(C);
    }, [C]), Rt(() => {
      E.length && de(ee.some(Ke => Ke.items.length > 0));
    }, [E, ee]), Rt(() => (le != null && le.current && (window.addEventListener("mousedown", ht), le.current.addEventListener("keydown", We)), () => {
      var Ke;
      window.removeEventListener("mousedown", ht), (Ke = le.current) == null || Ke.removeEventListener("keydown", We);
    }), []), /* @__PURE__ */we.jsx(we.Fragment, {
      children: /* @__PURE__ */we.jsxs(AE, {
        ref: ie,
        label: e,
        id: t,
        messageId: `${t}-message`,
        helperText: y,
        errorMessage: w,
        isDisabled: p,
        isFocused: Ce && !i,
        classNames: {
          label: Ze(P == null ? void 0 : P.inputLabel, te === "search" && (x == null ? void 0 : x.input) && !vn && !gt && (P == null ? void 0 : P.inputLabelIconSearch), (vn || ue || gt) && [Zc.inputFocus, P == null ? void 0 : P.inputFocus]),
          helperText: P == null ? void 0 : P.inputHelperText,
          errorText: Ze(!p && w && (P == null ? void 0 : P.inputErrorText)),
          disabled: Ze(p && [P == null ? void 0 : P.inputWrapperDisabled])
        },
        children: [/* @__PURE__ */we.jsxs("div", {
          className: Ze(Zc.wrapper, L, w && [Zc.inputError, P == null ? void 0 : P.inputError], i && (P == null ? void 0 : P.inputWrapperLoading)),
          children: [te === "search" && (x == null ? void 0 : x.input) && /* @__PURE__ */we.jsx("div", {
            className: Ze(P == null ? void 0 : P.inputIcon, (vn || gt) && (P == null ? void 0 : P.inputIconHide), !vn && !gt && (P == null ? void 0 : P.inputIconShow)),
            children: x.input
          }), /* @__PURE__ */we.jsx("input", {
            ...Dt({
              ref: le,
              id: t,
              readOnly: i || c,
              "aria-controls": $ || gt.length ? `${t}-menu` : void 0,
              "aria-activedescendant": _e && Pt !== -1 ? `${t}-item-${Pt}` : void 0,
              "aria-describedby": y || w ? `${t}-message ${t}-live` : void 0,
              className: Ze(Zc == null ? void 0 : Zc.input, P == null ? void 0 : P.input),
              disabled: p,
              onFocus: Xt,
              onBlur: Vt,
              onKeyUp: Ke => {
                (Ke.code === "Enter" || Ke.code === "NumpadEnter") && (Ke.stopPropagation(), ue && !w && (Q == null || Q(ue)), $ || hn());
              },
              "aria-labelledby": void 0
            })
          }), /* @__PURE__ */we.jsx("span", {
            role: "presentation",
            className: Ze(Zc.border, P == null ? void 0 : P.inputBorder)
          }), gt.length > 0 && !i && (x == null ? void 0 : x.clear) && !c && /* @__PURE__ */we.jsx("button", {
            ref: ce,
            tabIndex: ue || !$ ? 0 : -1,
            type: "button",
            className: P == null ? void 0 : P.iconClear,
            onClick: ot,
            onMouseDown: ot,
            "aria-label": Y.clearSelection,
            children: x.clear
          }), !i && te === "search" && (x == null ? void 0 : x.search) && /* @__PURE__ */we.jsx("button", {
            type: "button",
            className: P == null ? void 0 : P.iconSearch,
            onClick: ue && !w && Q ? () => Q(ue) : void 0,
            "aria-label": Y == null ? void 0 : Y.searchLabel,
            children: x.search
          }), p && /* @__PURE__ */we.jsx("span", {
            "aria-hidden": "true",
            className: P == null ? void 0 : P.inputIconDisabled,
            children: (x == null ? void 0 : x.disabled) || /* @__PURE__ */we.jsx(we.Fragment, {
              children: "×"
            })
          }), i && /* @__PURE__ */we.jsx(FE, {
            className: P == null ? void 0 : P.loader,
            size: hb.small,
            status: Um.loading,
            align: jE.vertical,
            responsive: !1,
            ...s
          })]
        }), I, /* @__PURE__ */we.jsx("div", {
          id: `${t}-live`,
          className: Zc.srOnly,
          "aria-live": "polite",
          "aria-atomic": "true",
          role: "status",
          children: H && Y != null && Y.a11ySelectedLiveRegion ? Y.a11ySelectedLiveRegion.replace("{{ label }}", H) : Y.a11yNoResultsLiveRegion
        }), /* @__PURE__ */we.jsx("div", {
          ...St({
            ref: ne,
            "aria-hidden": !_e,
            onClick: Ke => {
              var yt, je;
              const at = ((yt = Ke.nativeEvent.target) == null ? void 0 : yt.id) || "";
              if (!at.startsWith("separator-")) return;
              const kt = parseInt(at.replace("separator-", ""), 10);
              if (kt !== null) {
                let Bt = 0;
                ((Ht, sn) => {
                  var en;
                  for (let Rr = 0; Rr < sn; Rr++) (en = Ht[Rr]) != null && en.items && (Bt += Ht[Rr].items.length);
                })(ee, kt), un(Bt);
              }
              (je = le.current) == null || je.focus();
            }
          }),
          className: Ze(Zc.listBox, P == null ? void 0 : P.listBox, _e && typeof $ == "boolean" && [Zc == null ? void 0 : Zc.listBoxOpen, P == null ? void 0 : P.listBoxOpen], {
            [Zc == null ? void 0 : Zc.overlay]: !h
          }),
          children: _e && ($ ? Et(ee) : !i && /* @__PURE__ */we.jsx("div", {
            className: Ze(Zc.noResults, P == null ? void 0 : P.noResults),
            role: "option",
            "aria-disabled": "true",
            children: Y.noResults
          }))
        })]
      })
    });
  }),
  N4 = (t = "en-CA") => {
    var e;
    return ((e = t == null ? void 0 : t.split("-")) == null ? void 0 : e[0]) || "en";
  };
function KL(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function cQ(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.keys(t).forEach(function (s) {
    var c = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(i, s, c.get ? c : {
      enumerable: !0,
      get: function () {
        return t[s];
      }
    });
  }), i;
}
var pM = {
    exports: {}
  },
  wT = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sB;
function dQ() {
  if (sB) return wT;
  sB = 1;
  var t = Nt,
    e = Symbol.for("react.element"),
    i = Symbol.for("react.fragment"),
    s = Object.prototype.hasOwnProperty,
    c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function h(y, w, x) {
    var E,
      C = {},
      k = null,
      D = null;
    x !== void 0 && (k = "" + x), w.key !== void 0 && (k = "" + w.key), w.ref !== void 0 && (D = w.ref);
    for (E in w) s.call(w, E) && !p.hasOwnProperty(E) && (C[E] = w[E]);
    if (y && y.defaultProps) for (E in w = y.defaultProps, w) C[E] === void 0 && (C[E] = w[E]);
    return {
      $$typeof: e,
      type: y,
      key: k,
      ref: D,
      props: C,
      _owner: c.current
    };
  }
  return wT.Fragment = i, wT.jsx = h, wT.jsxs = h, wT;
}
var _T = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uB;
function fQ() {
  return uB || (uB = 1, process.env.NODE_ENV !== "production" && function () {
    var t = Nt,
      e = Symbol.for("react.element"),
      i = Symbol.for("react.portal"),
      s = Symbol.for("react.fragment"),
      c = Symbol.for("react.strict_mode"),
      p = Symbol.for("react.profiler"),
      h = Symbol.for("react.provider"),
      y = Symbol.for("react.context"),
      w = Symbol.for("react.forward_ref"),
      x = Symbol.for("react.suspense"),
      E = Symbol.for("react.suspense_list"),
      C = Symbol.for("react.memo"),
      k = Symbol.for("react.lazy"),
      D = Symbol.for("react.offscreen"),
      I = Symbol.iterator,
      L = "@@iterator";
    function P(Z) {
      if (Z === null || typeof Z != "object") return null;
      var Ne = I && Z[I] || Z[L];
      return typeof Ne == "function" ? Ne : null;
    }
    var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(Z) {
      {
        for (var Ne = arguments.length, Ye = new Array(Ne > 1 ? Ne - 1 : 0), xt = 1; xt < Ne; xt++) Ye[xt - 1] = arguments[xt];
        F("error", Z, Ye);
      }
    }
    function F(Z, Ne, Ye) {
      {
        var xt = N.ReactDebugCurrentFrame,
          rn = xt.getStackAddendum();
        rn !== "" && (Ne += "%s", Ye = Ye.concat([rn]));
        var $t = Ye.map(function (Ct) {
          return String(Ct);
        });
        $t.unshift("Warning: " + Ne), Function.prototype.apply.call(console[Z], console, $t);
      }
    }
    var j = !1,
      V = !1,
      K = !1,
      G = !1,
      Q = !1,
      te;
    te = Symbol.for("react.module.reference");
    function ie(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === s || Z === p || Q || Z === c || Z === x || Z === E || G || Z === D || j || V || K || typeof Z == "object" && Z !== null && (Z.$$typeof === k || Z.$$typeof === C || Z.$$typeof === h || Z.$$typeof === y || Z.$$typeof === w ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === te || Z.getModuleId !== void 0));
    }
    function Y(Z, Ne, Ye) {
      var xt = Z.displayName;
      if (xt) return xt;
      var rn = Ne.displayName || Ne.name || "";
      return rn !== "" ? Ye + "(" + rn + ")" : Ye;
    }
    function ee(Z) {
      return Z.displayName || "Context";
    }
    function ae(Z) {
      if (Z == null) return null;
      if (typeof Z.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Z == "function") return Z.displayName || Z.name || null;
      if (typeof Z == "string") return Z;
      switch (Z) {
        case s:
          return "Fragment";
        case i:
          return "Portal";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case y:
          var Ne = Z;
          return ee(Ne) + ".Consumer";
        case h:
          var Ye = Z;
          return ee(Ye._context) + ".Provider";
        case w:
          return Y(Z, Z.render, "ForwardRef");
        case C:
          var xt = Z.displayName || null;
          return xt !== null ? xt : ae(Z.type) || "Memo";
        case k:
          {
            var rn = Z,
              $t = rn._payload,
              Ct = rn._init;
            try {
              return ae(Ct($t));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var ne = Object.assign,
      le = 0,
      ce,
      W,
      $,
      de,
      H,
      se,
      ue;
    function Ee() {}
    Ee.__reactDisabledLog = !0;
    function Ce() {
      {
        if (le === 0) {
          ce = console.log, W = console.info, $ = console.warn, de = console.error, H = console.group, se = console.groupCollapsed, ue = console.groupEnd;
          var Z = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Z,
            log: Z,
            warn: Z,
            error: Z,
            group: Z,
            groupCollapsed: Z,
            groupEnd: Z
          });
        }
        le++;
      }
    }
    function fe() {
      {
        if (le--, le === 0) {
          var Z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ne({}, Z, {
              value: ce
            }),
            info: ne({}, Z, {
              value: W
            }),
            warn: ne({}, Z, {
              value: $
            }),
            error: ne({}, Z, {
              value: de
            }),
            group: ne({}, Z, {
              value: H
            }),
            groupCollapsed: ne({}, Z, {
              value: se
            }),
            groupEnd: ne({}, Z, {
              value: ue
            })
          });
        }
        le < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var _e = N.ReactCurrentDispatcher,
      Se;
    function be(Z, Ne, Ye) {
      {
        if (Se === void 0) try {
          throw Error();
        } catch (rn) {
          var xt = rn.stack.trim().match(/\n( *(at )?)/);
          Se = xt && xt[1] || "";
        }
        return `
` + Se + Z;
      }
    }
    var Le = !1,
      Be;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Be = new Xe();
    }
    function ge(Z, Ne) {
      if (!Z || Le) return "";
      {
        var Ye = Be.get(Z);
        if (Ye !== void 0) return Ye;
      }
      var xt;
      Le = !0;
      var rn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $t;
      $t = _e.current, _e.current = null, Ce();
      try {
        if (Ne) {
          var Ct = function () {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (Wi) {
              xt = Wi;
            }
            Reflect.construct(Z, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (Wi) {
              xt = Wi;
            }
            Z.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Wi) {
            xt = Wi;
          }
          Z();
        }
      } catch (Wi) {
        if (Wi && xt && typeof Wi.stack == "string") {
          for (var qt = Wi.stack.split(`
`), yr = xt.stack.split(`
`), Tn = qt.length - 1, jn = yr.length - 1; Tn >= 1 && jn >= 0 && qt[Tn] !== yr[jn];) jn--;
          for (; Tn >= 1 && jn >= 0; Tn--, jn--) if (qt[Tn] !== yr[jn]) {
            if (Tn !== 1 || jn !== 1) do if (Tn--, jn--, jn < 0 || qt[Tn] !== yr[jn]) {
              var Or = `
` + qt[Tn].replace(" at new ", " at ");
              return Z.displayName && Or.includes("<anonymous>") && (Or = Or.replace("<anonymous>", Z.displayName)), typeof Z == "function" && Be.set(Z, Or), Or;
            } while (Tn >= 1 && jn >= 0);
            break;
          }
        }
      } finally {
        Le = !1, _e.current = $t, fe(), Error.prepareStackTrace = rn;
      }
      var Wa = Z ? Z.displayName || Z.name : "",
        Ru = Wa ? be(Wa) : "";
      return typeof Z == "function" && Be.set(Z, Ru), Ru;
    }
    function qe(Z, Ne, Ye) {
      return ge(Z, !1);
    }
    function Ae(Z) {
      var Ne = Z.prototype;
      return !!(Ne && Ne.isReactComponent);
    }
    function Mt(Z, Ne, Ye) {
      if (Z == null) return "";
      if (typeof Z == "function") return ge(Z, Ae(Z));
      if (typeof Z == "string") return be(Z);
      switch (Z) {
        case x:
          return be("Suspense");
        case E:
          return be("SuspenseList");
      }
      if (typeof Z == "object") switch (Z.$$typeof) {
        case w:
          return qe(Z.render);
        case C:
          return Mt(Z.type, Ne, Ye);
        case k:
          {
            var xt = Z,
              rn = xt._payload,
              $t = xt._init;
            try {
              return Mt($t(rn), Ne, Ye);
            } catch {}
          }
      }
      return "";
    }
    var Ft = Object.prototype.hasOwnProperty,
      un = {},
      gt = N.ReactDebugCurrentFrame;
    function Pt(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        gt.setExtraStackFrame(Ye);
      } else gt.setExtraStackFrame(null);
    }
    function St(Z, Ne, Ye, xt, rn) {
      {
        var $t = Function.call.bind(Ft);
        for (var Ct in Z) if ($t(Z, Ct)) {
          var qt = void 0;
          try {
            if (typeof Z[Ct] != "function") {
              var yr = Error((xt || "React class") + ": " + Ye + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw yr.name = "Invariant Violation", yr;
            }
            qt = Z[Ct](Ne, Ct, xt, Ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (Tn) {
            qt = Tn;
          }
          qt && !(qt instanceof Error) && (Pt(rn), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xt || "React class", Ye, Ct, typeof qt), Pt(null)), qt instanceof Error && !(qt.message in un) && (un[qt.message] = !0, Pt(rn), O("Failed %s type: %s", Ye, qt.message), Pt(null));
        }
      }
    }
    var Dt = Array.isArray;
    function Kt(Z) {
      return Dt(Z);
    }
    function hn(Z) {
      {
        var Ne = typeof Symbol == "function" && Symbol.toStringTag,
          Ye = Ne && Z[Symbol.toStringTag] || Z.constructor.name || "Object";
        return Ye;
      }
    }
    function Lt(Z) {
      try {
        return Et(Z), !1;
      } catch {
        return !0;
      }
    }
    function Et(Z) {
      return "" + Z;
    }
    function Vt(Z) {
      if (Lt(Z)) return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(Z)), Et(Z);
    }
    var Xt = N.ReactCurrentOwner,
      vn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      ot,
      We;
    function ht(Z) {
      if (Ft.call(Z, "ref")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "ref").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.ref !== void 0;
    }
    function Ke(Z) {
      if (Ft.call(Z, "key")) {
        var Ne = Object.getOwnPropertyDescriptor(Z, "key").get;
        if (Ne && Ne.isReactWarning) return !1;
      }
      return Z.key !== void 0;
    }
    function yt(Z, Ne) {
      typeof Z.ref == "string" && Xt.current;
    }
    function je(Z, Ne) {
      {
        var Ye = function () {
          ot || (ot = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "key", {
          get: Ye,
          configurable: !0
        });
      }
    }
    function at(Z, Ne) {
      {
        var Ye = function () {
          We || (We = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ne));
        };
        Ye.isReactWarning = !0, Object.defineProperty(Z, "ref", {
          get: Ye,
          configurable: !0
        });
      }
    }
    var kt = function (Z, Ne, Ye, xt, rn, $t, Ct) {
      var qt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Z,
        key: Ne,
        ref: Ye,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: $t
      };
      return qt._store = {}, Object.defineProperty(qt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(qt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xt
      }), Object.defineProperty(qt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rn
      }), Object.freeze && (Object.freeze(qt.props), Object.freeze(qt)), qt;
    };
    function Bt(Z, Ne, Ye, xt, rn) {
      {
        var $t,
          Ct = {},
          qt = null,
          yr = null;
        Ye !== void 0 && (Vt(Ye), qt = "" + Ye), Ke(Ne) && (Vt(Ne.key), qt = "" + Ne.key), ht(Ne) && (yr = Ne.ref, yt(Ne, rn));
        for ($t in Ne) Ft.call(Ne, $t) && !vn.hasOwnProperty($t) && (Ct[$t] = Ne[$t]);
        if (Z && Z.defaultProps) {
          var Tn = Z.defaultProps;
          for ($t in Tn) Ct[$t] === void 0 && (Ct[$t] = Tn[$t]);
        }
        if (qt || yr) {
          var jn = typeof Z == "function" ? Z.displayName || Z.name || "Unknown" : Z;
          qt && je(Ct, jn), yr && at(Ct, jn);
        }
        return kt(Z, qt, yr, rn, xt, Xt.current, Ct);
      }
    }
    var Ht = N.ReactCurrentOwner,
      sn = N.ReactDebugCurrentFrame;
    function en(Z) {
      if (Z) {
        var Ne = Z._owner,
          Ye = Mt(Z.type, Z._source, Ne ? Ne.type : null);
        sn.setExtraStackFrame(Ye);
      } else sn.setExtraStackFrame(null);
    }
    var Rr;
    Rr = !1;
    function Nr(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function Hi() {
      {
        if (Ht.current) {
          var Z = ae(Ht.current.type);
          if (Z) return `

Check the render method of \`` + Z + "`.";
        }
        return "";
      }
    }
    function ss(Z) {
      return "";
    }
    var yo = {};
    function _s(Z) {
      {
        var Ne = Hi();
        if (!Ne) {
          var Ye = typeof Z == "string" ? Z : Z.displayName || Z.name;
          Ye && (Ne = `

Check the top-level render call using <` + Ye + ">.");
        }
        return Ne;
      }
    }
    function Mo(Z, Ne) {
      {
        if (!Z._store || Z._store.validated || Z.key != null) return;
        Z._store.validated = !0;
        var Ye = _s(Ne);
        if (yo[Ye]) return;
        yo[Ye] = !0;
        var xt = "";
        Z && Z._owner && Z._owner !== Ht.current && (xt = " It was passed a child from " + ae(Z._owner.type) + "."), en(Z), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ye, xt), en(null);
      }
    }
    function bo(Z, Ne) {
      {
        if (typeof Z != "object") return;
        if (Kt(Z)) for (var Ye = 0; Ye < Z.length; Ye++) {
          var xt = Z[Ye];
          Nr(xt) && Mo(xt, Ne);
        } else if (Nr(Z)) Z._store && (Z._store.validated = !0);else if (Z) {
          var rn = P(Z);
          if (typeof rn == "function" && rn !== Z.entries) for (var $t = rn.call(Z), Ct; !(Ct = $t.next()).done;) Nr(Ct.value) && Mo(Ct.value, Ne);
        }
      }
    }
    function Tu(Z) {
      {
        var Ne = Z.type;
        if (Ne == null || typeof Ne == "string") return;
        var Ye;
        if (typeof Ne == "function") Ye = Ne.propTypes;else if (typeof Ne == "object" && (Ne.$$typeof === w ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ne.$$typeof === C)) Ye = Ne.propTypes;else return;
        if (Ye) {
          var xt = ae(Ne);
          St(Ye, Z.props, "prop", xt, Z);
        } else if (Ne.PropTypes !== void 0 && !Rr) {
          Rr = !0;
          var rn = ae(Ne);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rn || "Unknown");
        }
        typeof Ne.getDefaultProps == "function" && !Ne.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ha(Z) {
      {
        for (var Ne = Object.keys(Z.props), Ye = 0; Ye < Ne.length; Ye++) {
          var xt = Ne[Ye];
          if (xt !== "children" && xt !== "key") {
            en(Z), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xt), en(null);
            break;
          }
        }
        Z.ref !== null && (en(Z), O("Invalid attribute `ref` supplied to `React.Fragment`."), en(null));
      }
    }
    function $i(Z, Ne, Ye, xt, rn, $t) {
      {
        var Ct = ie(Z);
        if (!Ct) {
          var qt = "";
          (Z === void 0 || typeof Z == "object" && Z !== null && Object.keys(Z).length === 0) && (qt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yr = ss();
          yr ? qt += yr : qt += Hi();
          var Tn;
          Z === null ? Tn = "null" : Kt(Z) ? Tn = "array" : Z !== void 0 && Z.$$typeof === e ? (Tn = "<" + (ae(Z.type) || "Unknown") + " />", qt = " Did you accidentally export a JSX literal instead of a component?") : Tn = typeof Z, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tn, qt);
        }
        var jn = Bt(Z, Ne, Ye, rn, $t);
        if (jn == null) return jn;
        if (Ct) {
          var Or = Ne.children;
          if (Or !== void 0) if (xt) {
            if (Kt(Or)) {
              for (var Wa = 0; Wa < Or.length; Wa++) bo(Or[Wa], Z);
              Object.freeze && Object.freeze(Or);
            } else O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else bo(Or, Z);
        }
        return Z === s ? Ha(jn) : Tu(jn), jn;
      }
    }
    function oi(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !0);
    }
    function Lo(Z, Ne, Ye) {
      return $i(Z, Ne, Ye, !1);
    }
    var $a = Lo,
      Oo = oi;
    _T.Fragment = s, _T.jsx = $a, _T.jsxs = Oo;
  }()), _T;
}
var cB;
function pQ() {
  return cB || (cB = 1, process.env.NODE_ENV === "production" ? pM.exports = dQ() : pM.exports = fQ()), pM.exports;
}
var B = pQ();
function z4(t) {
  var e,
    i,
    s = "";
  if (typeof t == "string" || typeof t == "number") s += t;else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (i = z4(t[e])) && (s && (s += " "), s += i);else for (e in t) t[e] && (s && (s += " "), s += e);
  return s;
}
function hQ() {
  for (var t, e, i = 0, s = ""; i < arguments.length;) (t = arguments[i++]) && (e = z4(t)) && (s && (s += " "), s += e);
  return s;
}
var ln = function (e) {
  var i,
    s = e.iconPrefix,
    c = s === void 0 ? "wvi-icon" : s,
    p = e.name,
    h = e.className,
    y = e.title,
    w = e.hidden,
    x = w === void 0 ? !0 : w,
    E = e.fixedWidth,
    C = e.rotate,
    k = e.size,
    D = e.animate;
  return Nt.createElement("span", {
    className: hQ(c, c + "-" + p, h, (i = {}, i[c + "--" + k] = k, i[c + "--fw"] = E, i[c + "--r-" + C] = C, i[c + "--" + D] = D, i)),
    "aria-label": y,
    "aria-hidden": x
  });
};
ln.displayName = "Icon";
function V4(t) {
  var e,
    i,
    s = "";
  if (typeof t == "string" || typeof t == "number") s += t;else if (typeof t == "object") if (Array.isArray(t)) {
    var c = t.length;
    for (e = 0; e < c; e++) t[e] && (i = V4(t[e])) && (s && (s += " "), s += i);
  } else for (i in t) t[i] && (s && (s += " "), s += i);
  return s;
}
function ve() {
  for (var t, e, i = 0, s = "", c = arguments.length; i < c; i++) (t = arguments[i]) && (e = V4(t)) && (s && (s += " "), s += e);
  return s;
}
const mQ = "_button_vauy9_1",
  vQ = "_expandCollapseButton_vauy9_1",
  gQ = "_icon_vauy9_6",
  yQ = "_heading_vauy9_37",
  bQ = "_image_vauy9_44",
  wQ = "_trigger_vauy9_72",
  _Q = "_headings_vauy9_90",
  xQ = "_label_vauy9_102",
  SQ = "_description_vauy9_109",
  EQ = "_item_vauy9_117",
  CQ = "_content_vauy9_124",
  kQ = "_borderlessTop_vauy9_171",
  TQ = "_contentParagraph_vauy9_191",
  od = {
    button: mQ,
    expandCollapseButton: vQ,
    icon: gQ,
    heading: yQ,
    image: bQ,
    trigger: wQ,
    headings: _Q,
    label: xQ,
    description: SQ,
    item: EQ,
    content: CQ,
    borderlessTop: kQ,
    contentParagraph: TQ
  },
  rS = t => {
    const {
      ...e
    } = t;
    return /* @__PURE__ */B.jsx(TH, {
      ...e
    });
  },
  RQ = t => {
    const {
      className: e,
      children: i,
      disabled: s,
      image: c,
      ...p
    } = t;
    return /* @__PURE__ */B.jsx(wH, {
      className: ve(od.heading, e),
      children: /* @__PURE__ */B.jsxs(kH, {
        "data-slot": "accordion-trigger",
        className: ve(od.trigger, od.button),
        ...p,
        children: [c && /* @__PURE__ */B.jsx("img", {
          src: c,
          className: od.image
        }), /* @__PURE__ */B.jsx(B4, {
          className: od.headings,
          children: i
        }), !s && /* @__PURE__ */B.jsx(ln, {
          name: "chevron-down",
          className: od.icon,
          "aria-hidden": !0
        })]
      })
    });
  },
  B4 = t => {
    const {
      className: e,
      children: i,
      ...s
    } = t;
    return /* @__PURE__ */B.jsx(la.div, {
      className: e,
      ...s,
      children: i
    });
  },
  DQ = t => {
    const {
      children: e,
      className: i,
      ...s
    } = t;
    return /* @__PURE__ */B.jsx(la.h4, {
      className: ve(od.label, i),
      ...s,
      children: e
    });
  },
  IQ = t => {
    const {
      children: e,
      ...i
    } = t;
    return /* @__PURE__ */B.jsx(la.p, {
      className: od.description,
      ...i,
      children: e
    });
  },
  MQ = t => {
    const {
      value: e,
      className: i,
      borderlessTop: s,
      ...c
    } = t;
    return /* @__PURE__ */B.jsx(SH, {
      "data-slot": "accordion-item",
      value: e,
      className: ve(od.item, s && od.borderlessTop, i),
      ...c
    });
  },
  LQ = t => {
    const {
        className: e,
        children: i,
        ...s
      } = t,
      c = typeof i == "string" ? /* @__PURE__ */B.jsx(la.p, {
        className: ve(od.contentParagraph, e),
        children: i
      }) : i;
    return /* @__PURE__ */B.jsx(bH, {
      "data-slot": "accordion-content",
      className: ve(od.content, e),
      ...s,
      children: c
    });
  },
  OQ = t => {
    const {
      className: e,
      expandText: i = "Expand all",
      collapseText: s = "Collapse all",
      ...c
    } = t;
    return /* @__PURE__ */B.jsx(t9, {
      expandText: i,
      collapseText: s,
      ...c,
      className: ve(od.expandCollapseButton, e),
      children: /* @__PURE__ */B.jsx(ln, {
        name: "double-chevron-down-micro",
        className: od.icon,
        "aria-hidden": !0
      })
    });
  };
rS.Content = LQ;
rS.Description = IQ;
rS.Heading = B4;
rS.Item = MQ;
rS.Label = DQ;
rS.Trigger = RQ;
rS.ExpandCollapseButton = OQ;
const O_e = {
    success: "success",
    error: "error",
    warning: "warning",
    info: "info",
    general: "general"
  },
  PQ = {
    light: "light",
    dark: "dark"
  },
  AQ = "_heading_14fgq_1",
  jQ = "_eyebrow_14fgq_9",
  FQ = "_xl_14fgq_18",
  NQ = "_lg_14fgq_24",
  zQ = "_md_14fgq_30",
  VQ = "_sm_14fgq_36",
  BQ = "_xs_14fgq_42",
  UQ = "_micro_14fgq_48",
  HQ = "_standard_14fgq_55",
  $Q = "_nano_14fgq_61",
  WQ = "_left_14fgq_67",
  qQ = "_center_14fgq_71",
  YQ = "_right_14fgq_75",
  GQ = "_italic_14fgq_79",
  XQ = "_bold_14fgq_83",
  Ej = {
    heading: AQ,
    eyebrow: jQ,
    xl: FQ,
    lg: NQ,
    md: zQ,
    sm: VQ,
    xs: BQ,
    micro: UQ,
    standard: HQ,
    nano: $Q,
    left: WQ,
    center: qQ,
    right: YQ,
    italic: GQ,
    bold: XQ
  },
  cu = ({
    id: t,
    className: e,
    size: i,
    align: s,
    Tag: c,
    children: p
  }) => {
    const h = ve(Ej.heading, {
      [Ej[i ?? ""]]: i,
      [Ej[s ?? ""]]: s
    }, e);
    return /* @__PURE__ */B.jsx(Sq, {
      id: t,
      Tag: c,
      className: h,
      children: p
    });
  };
cu.displayName = "Heading";
const P_e = {
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs",
    micro: "micro",
    eyebrow: "eyebrow"
  },
  KQ = (t = "info") => {
    switch (t) {
      case "error":
        return "error-solid";
      case "success":
        return "success-solid";
      case "warning":
        return "alert-solid";
      case "info":
      case "general":
      default:
        return "info-solid";
    }
  },
  QQ = (t = 0, e = !1) => ({
    open: {
      opacity: 1,
      visibility: "visible",
      transition: {
        delay: t,
        type: "spring",
        stiffness: 220,
        damping: 40
      }
    },
    closed: {
      opacity: e ? 1 : 0,
      visibility: e ? "visible" : "hidden",
      transition: e ? void 0 : {
        delay: 0.2,
        type: "spring",
        stiffness: 800,
        damping: 40
      }
    }
  }),
  ZQ = (t = !1) => ({
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          stiffness: 1e3,
          velocity: -100
        }
      }
    },
    closed: {
      y: t ? 0 : 20,
      opacity: t ? 1 : 0,
      transition: {
        y: {
          stiffness: 1e3
        }
      }
    }
  }),
  JQ = {
    brand: "wvi",
    url: "https://hotelinfoservice.sunwingtravelgroup.com",
    options: {}
  },
  eZ = (t, e, i) => {
    const {
        url: s,
        brand: c,
        options: p
      } = {
        ...JQ,
        ...i
      },
      h = N4(t),
      y = `${s}/${c}/${h}/hotelNameCode/${e}`;
    return fetch(y, p).then(w => w.json());
  };
var xT = {
    exports: {}
  },
  dB;
function tZ() {
  if (dB) return xT.exports;
  dB = 1;
  var t = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      Ấ: "A",
      Ắ: "A",
      Ẳ: "A",
      Ẵ: "A",
      Ặ: "A",
      Æ: "AE",
      Ầ: "A",
      Ằ: "A",
      Ȃ: "A",
      Ả: "A",
      Ạ: "A",
      Ẩ: "A",
      Ẫ: "A",
      Ậ: "A",
      Ç: "C",
      Ḉ: "C",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      Ế: "E",
      Ḗ: "E",
      Ề: "E",
      Ḕ: "E",
      Ḝ: "E",
      Ȇ: "E",
      Ẻ: "E",
      Ẽ: "E",
      Ẹ: "E",
      Ể: "E",
      Ễ: "E",
      Ệ: "E",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      Ḯ: "I",
      Ȋ: "I",
      Ỉ: "I",
      Ị: "I",
      Ð: "D",
      Ñ: "N",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      Ố: "O",
      Ṍ: "O",
      Ṓ: "O",
      Ȏ: "O",
      Ỏ: "O",
      Ọ: "O",
      Ổ: "O",
      Ỗ: "O",
      Ộ: "O",
      Ờ: "O",
      Ở: "O",
      Ỡ: "O",
      Ớ: "O",
      Ợ: "O",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      Ủ: "U",
      Ụ: "U",
      Ử: "U",
      Ữ: "U",
      Ự: "U",
      Ý: "Y",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      ấ: "a",
      ắ: "a",
      ẳ: "a",
      ẵ: "a",
      ặ: "a",
      æ: "ae",
      ầ: "a",
      ằ: "a",
      ȃ: "a",
      ả: "a",
      ạ: "a",
      ẩ: "a",
      ẫ: "a",
      ậ: "a",
      ç: "c",
      ḉ: "c",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      ế: "e",
      ḗ: "e",
      ề: "e",
      ḕ: "e",
      ḝ: "e",
      ȇ: "e",
      ẻ: "e",
      ẽ: "e",
      ẹ: "e",
      ể: "e",
      ễ: "e",
      ệ: "e",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      ḯ: "i",
      ȋ: "i",
      ỉ: "i",
      ị: "i",
      ð: "d",
      ñ: "n",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      ố: "o",
      ṍ: "o",
      ṓ: "o",
      ȏ: "o",
      ỏ: "o",
      ọ: "o",
      ổ: "o",
      ỗ: "o",
      ộ: "o",
      ờ: "o",
      ở: "o",
      ỡ: "o",
      ớ: "o",
      ợ: "o",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      ủ: "u",
      ụ: "u",
      ử: "u",
      ữ: "u",
      ự: "u",
      ý: "y",
      ÿ: "y",
      Ā: "A",
      ā: "a",
      Ă: "A",
      ă: "a",
      Ą: "A",
      ą: "a",
      Ć: "C",
      ć: "c",
      Ĉ: "C",
      ĉ: "c",
      Ċ: "C",
      ċ: "c",
      Č: "C",
      č: "c",
      C̆: "C",
      c̆: "c",
      Ď: "D",
      ď: "d",
      Đ: "D",
      đ: "d",
      Ē: "E",
      ē: "e",
      Ĕ: "E",
      ĕ: "e",
      Ė: "E",
      ė: "e",
      Ę: "E",
      ę: "e",
      Ě: "E",
      ě: "e",
      Ĝ: "G",
      Ǵ: "G",
      ĝ: "g",
      ǵ: "g",
      Ğ: "G",
      ğ: "g",
      Ġ: "G",
      ġ: "g",
      Ģ: "G",
      ģ: "g",
      Ĥ: "H",
      ĥ: "h",
      Ħ: "H",
      ħ: "h",
      Ḫ: "H",
      ḫ: "h",
      Ĩ: "I",
      ĩ: "i",
      Ī: "I",
      ī: "i",
      Ĭ: "I",
      ĭ: "i",
      Į: "I",
      į: "i",
      İ: "I",
      ı: "i",
      Ĳ: "IJ",
      ĳ: "ij",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      Ḱ: "K",
      ḱ: "k",
      K̆: "K",
      k̆: "k",
      Ĺ: "L",
      ĺ: "l",
      Ļ: "L",
      ļ: "l",
      Ľ: "L",
      ľ: "l",
      Ŀ: "L",
      ŀ: "l",
      Ł: "l",
      ł: "l",
      Ḿ: "M",
      ḿ: "m",
      M̆: "M",
      m̆: "m",
      Ń: "N",
      ń: "n",
      Ņ: "N",
      ņ: "n",
      Ň: "N",
      ň: "n",
      ŉ: "n",
      N̆: "N",
      n̆: "n",
      Ō: "O",
      ō: "o",
      Ŏ: "O",
      ŏ: "o",
      Ő: "O",
      ő: "o",
      Œ: "OE",
      œ: "oe",
      P̆: "P",
      p̆: "p",
      Ŕ: "R",
      ŕ: "r",
      Ŗ: "R",
      ŗ: "r",
      Ř: "R",
      ř: "r",
      R̆: "R",
      r̆: "r",
      Ȓ: "R",
      ȓ: "r",
      Ś: "S",
      ś: "s",
      Ŝ: "S",
      ŝ: "s",
      Ş: "S",
      Ș: "S",
      ș: "s",
      ş: "s",
      Š: "S",
      š: "s",
      Ţ: "T",
      ţ: "t",
      ț: "t",
      Ț: "T",
      Ť: "T",
      ť: "t",
      Ŧ: "T",
      ŧ: "t",
      T̆: "T",
      t̆: "t",
      Ũ: "U",
      ũ: "u",
      Ū: "U",
      ū: "u",
      Ŭ: "U",
      ŭ: "u",
      Ů: "U",
      ů: "u",
      Ű: "U",
      ű: "u",
      Ų: "U",
      ų: "u",
      Ȗ: "U",
      ȗ: "u",
      V̆: "V",
      v̆: "v",
      Ŵ: "W",
      ŵ: "w",
      Ẃ: "W",
      ẃ: "w",
      X̆: "X",
      x̆: "x",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Y̆: "Y",
      y̆: "y",
      Ź: "Z",
      ź: "z",
      Ż: "Z",
      ż: "z",
      Ž: "Z",
      ž: "z",
      ſ: "s",
      ƒ: "f",
      Ơ: "O",
      ơ: "o",
      Ư: "U",
      ư: "u",
      Ǎ: "A",
      ǎ: "a",
      Ǐ: "I",
      ǐ: "i",
      Ǒ: "O",
      ǒ: "o",
      Ǔ: "U",
      ǔ: "u",
      Ǖ: "U",
      ǖ: "u",
      Ǘ: "U",
      ǘ: "u",
      Ǚ: "U",
      ǚ: "u",
      Ǜ: "U",
      ǜ: "u",
      Ứ: "U",
      ứ: "u",
      Ṹ: "U",
      ṹ: "u",
      Ǻ: "A",
      ǻ: "a",
      Ǽ: "AE",
      ǽ: "ae",
      Ǿ: "O",
      ǿ: "o",
      Þ: "TH",
      þ: "th",
      Ṕ: "P",
      ṕ: "p",
      Ṥ: "S",
      ṥ: "s",
      X́: "X",
      x́: "x",
      Ѓ: "Г",
      ѓ: "г",
      Ќ: "К",
      ќ: "к",
      A̋: "A",
      a̋: "a",
      E̋: "E",
      e̋: "e",
      I̋: "I",
      i̋: "i",
      Ǹ: "N",
      ǹ: "n",
      Ồ: "O",
      ồ: "o",
      Ṑ: "O",
      ṑ: "o",
      Ừ: "U",
      ừ: "u",
      Ẁ: "W",
      ẁ: "w",
      Ỳ: "Y",
      ỳ: "y",
      Ȁ: "A",
      ȁ: "a",
      Ȅ: "E",
      ȅ: "e",
      Ȉ: "I",
      ȉ: "i",
      Ȍ: "O",
      ȍ: "o",
      Ȑ: "R",
      ȑ: "r",
      Ȕ: "U",
      ȕ: "u",
      B̌: "B",
      b̌: "b",
      Č̣: "C",
      č̣: "c",
      Ê̌: "E",
      ê̌: "e",
      F̌: "F",
      f̌: "f",
      Ǧ: "G",
      ǧ: "g",
      Ȟ: "H",
      ȟ: "h",
      J̌: "J",
      ǰ: "j",
      Ǩ: "K",
      ǩ: "k",
      M̌: "M",
      m̌: "m",
      P̌: "P",
      p̌: "p",
      Q̌: "Q",
      q̌: "q",
      Ř̩: "R",
      ř̩: "r",
      Ṧ: "S",
      ṧ: "s",
      V̌: "V",
      v̌: "v",
      W̌: "W",
      w̌: "w",
      X̌: "X",
      x̌: "x",
      Y̌: "Y",
      y̌: "y",
      A̧: "A",
      a̧: "a",
      B̧: "B",
      b̧: "b",
      Ḑ: "D",
      ḑ: "d",
      Ȩ: "E",
      ȩ: "e",
      Ɛ̧: "E",
      ɛ̧: "e",
      Ḩ: "H",
      ḩ: "h",
      I̧: "I",
      i̧: "i",
      Ɨ̧: "I",
      ɨ̧: "i",
      M̧: "M",
      m̧: "m",
      O̧: "O",
      o̧: "o",
      Q̧: "Q",
      q̧: "q",
      U̧: "U",
      u̧: "u",
      X̧: "X",
      x̧: "x",
      Z̧: "Z",
      z̧: "z",
      й: "и",
      Й: "И",
      ё: "е",
      Ё: "Е"
    },
    e = Object.keys(t).join("|"),
    i = new RegExp(e, "g"),
    s = new RegExp(e, "");
  function c(y) {
    return t[y];
  }
  var p = function (y) {
      return y.replace(i, c);
    },
    h = function (y) {
      return !!y.match(s);
    };
  return xT.exports = p, xT.exports.has = h, xT.exports.remove = p, xT.exports;
}
var nZ = tZ();
const rZ = /* @__PURE__ */KL(nZ),
  iZ = t => t.split("/").map(e => {
    let i = e;
    return i = rZ(i), i = i.replace(/^\s+|\s+$/g, ""), i = i.replace(/[-,;_=\s]+/g, "-"), i = i.replace(/[^-\w\s]/g, ""), i = i.toLowerCase(), i;
  }).join("/"),
  aZ = (t = "en", e, i, s) => `/${t}/hotels${e && `/${e}`}${i && `/${i}`}/${s}`,
  oZ = (t, e, i, s) => iZ(aZ(N4(t), e, i, s)),
  lZ = t => t == null ? void 0 : t.replace("/#", "#"),
  sZ = t => {
    const e = /* @__PURE__ */new Map();
    return Nt.Children.forEach(t, i => {
      var c, p, h;
      if (!Nt.isValidElement(i)) return;
      const s = (c = i == null ? void 0 : i.props) == null ? void 0 : c.slot;
      if (s) {
        const {
            ...y
          } = i.props,
          w = lH(i.type, {
            ...y,
            key: (p = e.get(s)) != null && p.length ? `${s}-${(h = e.get(s)) == null ? void 0 : h.length}` : `${s}-0`
          });
        e.has(s) ? e.set(s, [...e.get(s), w]) : e.set(s, [w]);
      }
    }), {
      get(i, s) {
        const c = e.get(i);
        return c ? s ? s(c) : c : null;
      }
    };
  },
  uZ = "_link_zwv9e_1",
  cZ = "_inverse_zwv9e_10",
  dZ = "_linkIcon_zwv9e_22",
  fZ = "_dark_zwv9e_33",
  pZ = "_disabled_zwv9e_53",
  hZ = "_sm_zwv9e_61",
  mZ = "_md_zwv9e_61",
  vZ = "_lg_zwv9e_64",
  B0 = {
    link: uZ,
    inverse: cZ,
    linkIcon: dZ,
    dark: fZ,
    disabled: pZ,
    sm: hZ,
    md: mZ,
    lg: vZ
  },
  dd = ({
    href: t,
    children: e,
    className: i,
    renderLink: s = (C, {
      children: k,
      ...D
    }) => /* @__PURE__ */B.jsx("a", {
      href: C,
      ...D,
      children: k
    }),
    icon: c,
    variant: p = "primary",
    size: h = "lg",
    noStyle: y = !1,
    disabled: w,
    theme: x,
    ...E
  }) => {
    const C = /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [e, c && !y && /* @__PURE__ */B.jsx(ln, {
        name: c,
        className: B0.linkIcon
      })]
    });
    return s(lZ(t), {
      children: C,
      className: ve(i, {
        [B0.link]: !y,
        [B0[p]]: p && B0[p],
        [B0[h]]: h && B0[h],
        [B0.disabled]: w,
        [B0[x ?? ""]]: x
      }),
      ...E
    });
  };
dd.displayName = "Link";
const gZ = "_alert_1pdyx_134",
  yZ = "_alertIcon_1pdyx_145",
  bZ = "_warning_1pdyx_148",
  wZ = "_info_1pdyx_152",
  _Z = "_general_1pdyx_152",
  xZ = "_success_1pdyx_156",
  SZ = "_error_1pdyx_160",
  EZ = "_alertHeadingContainer_1pdyx_164",
  CZ = "_alertBody_1pdyx_173",
  kZ = "_alertHeading_1pdyx_164",
  TZ = "_alertChildren_1pdyx_181",
  RZ = "_alertClose_1pdyx_188",
  DZ = "_dismissible_1pdyx_205",
  IZ = "_dark_1pdyx_208",
  MZ = "_noChildren_1pdyx_218",
  LZ = "_buttonLink_1pdyx_218",
  Dp = {
    alert: gZ,
    alertIcon: yZ,
    warning: bZ,
    info: wZ,
    general: _Z,
    success: xZ,
    error: SZ,
    alertHeadingContainer: EZ,
    alertBody: CZ,
    alertHeading: kZ,
    alertChildren: TZ,
    alertClose: RZ,
    dismissible: DZ,
    dark: IZ,
    noChildren: MZ,
    buttonLink: LZ
  },
  U4 = Qn(({
    className: t,
    classNames: e = {},
    heading: i,
    headingAs: s = "p",
    headingSize: c = "sm",
    children: p,
    variant: h = "warning",
    dismissible: y = !0,
    theme: w = PQ.light,
    dismissibleLabel: x = "Close alert",
    noIcon: E = !1,
    icon: C,
    renderLink: k,
    link: D,
    ...I
  }, L) => {
    const P = {
        body: Dp.alertBody,
        dismissibleButton: Dp.alertClose,
        ...e
      },
      N = ve(Dp.alert, Dp[h], t, {
        [Dp.dismissible]: y,
        [Dp.noChildren]: !p,
        [Dp[w]]: !!w
      });
    return /* @__PURE__ */B.jsxs(DH, {
      ref: L,
      className: N,
      classNames: P,
      dismissible: y,
      dismissibleLabel: x,
      dismissibleIcon: /* @__PURE__ */B.jsx(ln, {
        name: "close"
      }),
      ...I,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: Dp.alertHeadingContainer,
        children: [!E && /* @__PURE__ */B.jsx(ln, {
          className: Dp.alertIcon,
          name: h === "general" && C ? C : KQ(h)
        }), /* @__PURE__ */B.jsx(cu, {
          Tag: s,
          size: c,
          align: "left",
          className: Dp.alertHeading,
          children: i
        })]
      }), !!p && /* @__PURE__ */B.jsx("div", {
        className: Dp.alertChildren,
        children: p
      }), !!D && /* @__PURE__ */B.jsx(dd, {
        renderLink: k,
        href: D.href,
        className: Dp.buttonLink,
        icon: "arrow-right-micro",
        size: "md",
        theme: w,
        children: D.linkText
      })]
    });
  });
U4.displayName = "Alert";
const OZ = "_btn_8pdej_1",
  PZ = "_btnIcon_8pdej_17",
  AZ = "_disabled_8pdej_26",
  jZ = "_primary_8pdej_42",
  FZ = "_iconOnly_8pdej_54",
  NZ = "_outline_8pdej_55",
  zZ = "_utility_8pdej_56",
  VZ = "_inverse_8pdej_83",
  BZ = "_actionOutline_8pdej_88",
  UZ = "_actionInverseFilled_8pdej_120",
  HZ = "_actionInverse_8pdej_120",
  $Z = "_action_8pdej_88",
  WZ = "_noStyle_8pdej_236",
  qZ = "_center_8pdej_245",
  YZ = "_right_8pdej_249",
  GZ = "_sm_8pdej_253",
  XZ = "_lg_8pdej_259",
  KZ = "_xl_8pdej_265",
  ob = {
    btn: OZ,
    btnIcon: PZ,
    disabled: AZ,
    primary: jZ,
    iconOnly: FZ,
    outline: NZ,
    utility: zZ,
    inverse: VZ,
    actionOutline: BZ,
    actionInverseFilled: UZ,
    actionInverse: HZ,
    action: $Z,
    noStyle: WZ,
    center: qZ,
    right: YZ,
    sm: GZ,
    lg: XZ,
    xl: KZ
  },
  op = Qn((t, e) => {
    const {
        className: i,
        variant: s = "primary",
        defaultStyle: c = !0,
        disabled: p,
        icon: h,
        iconPlacement: y = "left",
        align: w = "left",
        size: x = "md",
        children: E,
        ...C
      } = t,
      k = {
        className: ve(i, {
          [ob.disabled]: p,
          [ob.btn]: c && s !== "noStyle",
          [ob[s]]: s && ob[s],
          [ob[x]]: x && ob[x]
        }),
        disabled: p,
        leftSection: h && y === "left" ? /* @__PURE__ */B.jsx(ln, {
          name: h,
          className: ob.btnIcon
        }) : void 0,
        children: s === "iconOnly" ? null : E,
        rightSection: h && y === "right" ? /* @__PURE__ */B.jsx(ln, {
          name: h,
          className: ob.btnIcon
        }) : void 0,
        ...C
      };
    return w === "center" || w === "right" ? /* @__PURE__ */B.jsx("div", {
      className: ob[w],
      children: /* @__PURE__ */B.jsx(_2, {
        ref: e,
        ...k
      })
    }) : /* @__PURE__ */B.jsx(_2, {
      ref: e,
      ...k
    });
  });
op.displayName = "Button";
const A_e = {
    solid: "solid",
    transparent: "transparent"
  },
  j_e = {
    light: "light",
    dark: "dark"
  },
  Ym = ({
    wrapperClassName: t,
    source: e,
    alt: i,
    src: s,
    srcSet: c,
    sizes: p,
    ...h
  }) => {
    const y = ci(() => {
        var C;
        return (C = e == null ? void 0 : e.sources) == null ? void 0 : C.slice().reverse();
      }, [e]),
      w = (e == null ? void 0 : e.src) || s,
      x = (e == null ? void 0 : e.srcSet) || c,
      E = (e == null ? void 0 : e.sizes) || p;
    return /* @__PURE__ */B.jsxs("picture", {
      children: [y && y.map((C, k) => /* @__PURE__ */B.jsx("source", {
        media: C.media,
        srcSet: C.srcSet
      }, k)), /* @__PURE__ */B.jsx("img", {
        className: t,
        src: w,
        srcSet: x,
        sizes: E,
        alt: i,
        ...h
      })]
    });
  },
  QZ = "_theme_1odt6_1",
  ZZ = "_ratingText_1odt6_5",
  JZ = "_dark_1odt6_9",
  ST = {
    theme: QZ,
    ratingText: ZZ,
    dark: JZ
  },
  wL = ({
    rating: t = 0,
    ratingText: e,
    maximum: i = 5,
    simple: s = !1,
    theme: c = "light",
    classNames: p
  }) => {
    const h = {
      container: ve(p == null ? void 0 : p.container, ST.theme, ST == null ? void 0 : ST[c]),
      rating: ve(p == null ? void 0 : p.rating, ST.ratingText)
    };
    return /* @__PURE__ */B.jsx($K, {
      rating: t,
      ratingText: e,
      maximum: i,
      simple: s,
      classNames: h,
      renderSolidIcon: /* @__PURE__ */B.jsx(ln, {
        name: "rating-solid"
      }),
      renderPartialIcon: /* @__PURE__ */B.jsx(ln, {
        name: "rating-partial"
      }),
      renderOutlineIcon: /* @__PURE__ */B.jsx(ln, {
        name: "rating"
      })
    });
  },
  eJ = "_hotelCard_t455t_1",
  tJ = "_cardLink_t455t_9",
  nJ = "_hotelCardImage_t455t_37",
  rJ = "_hotelCardContainer_t455t_52",
  iJ = "_hotelCardHeading_t455t_57",
  aJ = "_hotelCardSubHeading_t455t_65",
  oJ = "_hotelCardDetails_t455t_88",
  lJ = "_hotelCardRatingsContainer_t455t_93",
  sJ = "_hotelCardDetailsLink_t455t_98",
  Uv = {
    hotelCard: eJ,
    cardLink: tJ,
    hotelCardImage: nJ,
    hotelCardContainer: rJ,
    hotelCardHeading: iJ,
    hotelCardSubHeading: aJ,
    hotelCardDetails: oJ,
    hotelCardRatingsContainer: lJ,
    hotelCardDetailsLink: sJ
  },
  F_e = ({
    image: t,
    header: e,
    subheader: i,
    link: s,
    stars: c,
    labels: p,
    headerAs: h = "h2",
    className: y,
    renderLink: w,
    theme: x = "light"
  }) => {
    var E, C, k;
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(Uv.hotelCard, y),
      "data-theme": x,
      children: [t && /* @__PURE__ */B.jsx("div", {
        className: Uv.hotelCardImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (E = t == null ? void 0 : t.source) == null ? void 0 : E.src,
          srcSet: (C = t == null ? void 0 : t.source) == null ? void 0 : C.srcSet,
          sizes: (k = t == null ? void 0 : t.source) == null ? void 0 : k.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Uv.hotelCardContainer,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: Uv.hotelCardBody,
          children: [e && /* @__PURE__ */B.jsx(cu, {
            size: "eyebrow",
            className: Uv.hotelCardHeading,
            Tag: i ? "div" : h,
            children: e
          }), i && /* @__PURE__ */B.jsx(cu, {
            className: Uv.hotelCardSubHeading,
            Tag: h,
            size: "md",
            children: i
          }), /* @__PURE__ */B.jsx("div", {
            className: ve(Uv.hotelCardDetails),
            children: /* @__PURE__ */B.jsx("span", {
              children: p == null ? void 0 : p.allInc
            })
          }), c && /* @__PURE__ */B.jsx("div", {
            className: Uv.hotelCardRatingsContainer,
            children: /* @__PURE__ */B.jsx(wL, {
              rating: c,
              theme: x
            })
          })]
        }), !!s && /* @__PURE__ */B.jsx("div", {
          className: Uv.hotelCardDetailsLink,
          children: /* @__PURE__ */B.jsx(dd, {
            className: Uv.cardLink,
            href: s.href,
            variant: x,
            target: s == null ? void 0 : s.target,
            renderLink: w,
            icon: (s == null ? void 0 : s.icon) ?? "arrow-right",
            children: s == null ? void 0 : s.children
          })
        })]
      })]
    });
  },
  uJ = "_info_v0v6h_1",
  cJ = "_transparent_v0v6h_13",
  dJ = "_cardLink_v0v6h_21",
  fJ = "_infoCardLink_v0v6h_45",
  pJ = "_linkSrOnly_v0v6h_60",
  hJ = "_infoContent_v0v6h_71",
  mJ = "_infoHeading_v0v6h_79",
  vJ = "_defaultHeaderSize_v0v6h_83",
  gJ = "_horizontal_v0v6h_83",
  yJ = "_infoIcon_v0v6h_88",
  bJ = "_infoImage_v0v6h_101",
  wJ = "_infoDesc_v0v6h_107",
  _J = "_infoFooter_v0v6h_110",
  xJ = "_infoLink_v0v6h_118",
  SJ = "_infoPrice_v0v6h_135",
  EJ = "_horizontalNoIcon_v0v6h_145",
  CJ = "_from_v0v6h_193",
  kJ = "_to_v0v6h_194",
  TJ = "_connector_v0v6h_198",
  RJ = "_label_v0v6h_206",
  DJ = "_price_v0v6h_216",
  IJ = "_message_v0v6h_229",
  MJ = "_pricing_v0v6h_234",
  fa = {
    info: uJ,
    transparent: cJ,
    cardLink: dJ,
    infoCardLink: fJ,
    linkSrOnly: pJ,
    infoContent: hJ,
    infoHeading: mJ,
    defaultHeaderSize: vJ,
    horizontal: gJ,
    default: "_default_v0v6h_83",
    infoIcon: yJ,
    infoImage: bJ,
    infoDesc: wJ,
    infoFooter: _J,
    infoLink: xJ,
    infoPrice: SJ,
    horizontalNoIcon: EJ,
    from: CJ,
    to: kJ,
    connector: TJ,
    label: RJ,
    price: DJ,
    message: IJ,
    pricing: MJ
  },
  dR = (t, e = "en-CA") => {
    if (t == null || t === "") return null;
    const i = Number(t);
    if (Number.isNaN(i)) return t.toString();
    const s = i % 1 !== 0;
    return new Intl.NumberFormat(e, {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: s ? 2 : 0,
      maximumFractionDigits: 2
    }).formatToParts(i).map((p, h) => p.type === "currency" ? /* @__PURE__ */B.jsx("sup", {
      children: p.value
    }, h) : p.type === "fraction" || p.type === "decimal" ? /* @__PURE__ */B.jsx("sup", {
      children: p.value
    }, h) : /* @__PURE__ */B.jsx("span", {
      children: p.value
    }, h));
  },
  LJ = {
    default: "default",
    horizontal: "horizontal",
    horizontalNoIcon: "horizontalNoIcon"
  },
  N_e = ({
    icon: t,
    image: e,
    header: i,
    headerAs: s = "h2",
    variant: c,
    content: p,
    link: h,
    renderLink: y,
    className: w,
    classNames: x,
    labels: E,
    fromPrice: C,
    toPrice: k,
    theme: D = "light",
    backgroundType: I,
    priceMessage: L,
    linkSrOnly: P = !1,
    locale: N = "en-CA"
  }) => {
    var F, j, V;
    const O = c ?? "default";
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(fa.info, w, I && fa[I], {
        [fa[O]]: O,
        [fa.defaultHeaderSize]: s === "h2"
      }),
      "data-theme": D,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: ve(fa.infoContent, x == null ? void 0 : x.cardContent),
        children: [t && (!e || !e.source) && c !== LJ.horizontalNoIcon && /* @__PURE__ */B.jsx(ln, {
          name: t,
          className: ve(fa.infoIcon, x == null ? void 0 : x.cardIcon)
        }), e && (e == null ? void 0 : e.source) && /* @__PURE__ */B.jsx("div", {
          className: ve(fa.infoImage, x == null ? void 0 : x.cardImage),
          children: /* @__PURE__ */B.jsx(Ym, {
            src: (F = e == null ? void 0 : e.source) == null ? void 0 : F.src,
            srcSet: (j = e == null ? void 0 : e.source) == null ? void 0 : j.srcSet,
            sizes: (V = e == null ? void 0 : e.source) == null ? void 0 : V.sizes,
            source: e.source,
            alt: e.alt,
            loading: "lazy"
          })
        }), i && /* @__PURE__ */B.jsx(cu, {
          Tag: s,
          className: ve(fa.infoHeading, x == null ? void 0 : x.cardHeading),
          children: i
        }), Array.isArray(p) && p.length > 0 ? /* @__PURE__ */B.jsx("ul", {
          children: p.map((K, G) => /* @__PURE__ */B.jsx("li", {
            children: K
          }, G))
        }) : p ? /* @__PURE__ */B.jsx("div", {
          className: fa == null ? void 0 : fa.infoDesc,
          children: p
        }) : null, (C || k || L) && /* @__PURE__ */B.jsxs("div", {
          className: fa == null ? void 0 : fa.infoPrice,
          children: [(C || C && k) && /* @__PURE__ */B.jsxs("div", {
            className: fa.pricing,
            children: [C && /* @__PURE__ */B.jsxs("div", {
              className: fa.from,
              children: [/* @__PURE__ */B.jsx("span", {
                className: fa.label,
                children: k ? E == null ? void 0 : E.from : E == null ? void 0 : E.price
              }), /* @__PURE__ */B.jsx("span", {
                className: fa.price,
                children: dR(C, N)
              })]
            }), k && /* @__PURE__ */B.jsxs(B.Fragment, {
              children: [/* @__PURE__ */B.jsx("span", {
                className: fa.connector,
                children: "–"
              }), /* @__PURE__ */B.jsxs("div", {
                className: fa.to,
                children: [/* @__PURE__ */B.jsx("span", {
                  className: fa.label,
                  children: E == null ? void 0 : E.to
                }), /* @__PURE__ */B.jsx("span", {
                  className: fa.price,
                  children: dR(k, N)
                })]
              })]
            })]
          }), L && /* @__PURE__ */B.jsx("div", {
            className: fa.message,
            children: L
          })]
        })]
      }), !!h && /* @__PURE__ */B.jsx("div", {
        className: fa.infoFooter,
        children: /* @__PURE__ */B.jsx(dd, {
          icon: (h == null ? void 0 : h.icon) ?? "arrow-right-micro",
          href: h.href,
          target: h == null ? void 0 : h.target,
          className: ve(fa.cardLink, P && fa.linkSrOnly),
          theme: D,
          renderLink: y,
          children: /* @__PURE__ */B.jsx("span", {
            children: h == null ? void 0 : h.children
          })
        })
      })]
    });
  },
  OJ = "_card_q8ft8_1",
  PJ = "_cardLink_q8ft8_15",
  AJ = "_cardCtaBtn_q8ft8_40",
  jJ = "_subTextWrapper_q8ft8_46",
  FJ = "_tag_q8ft8_51",
  NJ = "_icon_q8ft8_63",
  zJ = "_price_q8ft8_77",
  VJ = "_priceValue_q8ft8_83",
  BJ = "_priceSubtext_q8ft8_96",
  UJ = "_priceDescription_q8ft8_100",
  HJ = "_priceDiscount_q8ft8_107",
  $J = "_priceContent_q8ft8_119",
  WJ = "_LPC_q8ft8_125",
  ep = {
    card: OJ,
    cardLink: PJ,
    cardCtaBtn: AJ,
    subTextWrapper: jJ,
    tag: FJ,
    icon: NJ,
    price: zJ,
    priceValue: VJ,
    priceSubtext: BJ,
    priceDescription: UJ,
    priceDiscount: HJ,
    priceContent: $J,
    LPC: WJ
  },
  z_e = ({
    link: t,
    price: e,
    tag: i,
    locale: s = "en-CA",
    ariaLabel: c
  }) => /* @__PURE__ */B.jsxs("div", {
    "aria-label": c,
    className: ep.card,
    children: [/* @__PURE__ */B.jsx("span", {
      children: /* @__PURE__ */B.jsx(F4, {
        className: ep.tag,
        label: i,
        icon: /* @__PURE__ */B.jsx(ln, {
          className: ep.icon,
          name: "deal-solid",
          size: "md"
        })
      })
    }), /* @__PURE__ */B.jsxs("div", {
      className: ep.subTextWrapper,
      children: [/* @__PURE__ */B.jsx("div", {
        className: ep.priceSubtext,
        children: e.subtext
      }), /* @__PURE__ */B.jsxs("div", {
        className: ep.price,
        children: [/* @__PURE__ */B.jsx("span", {
          className: ep.priceDescription,
          children: e.description
        }), /* @__PURE__ */B.jsxs("div", {
          className: ep.priceContent,
          children: [/* @__PURE__ */B.jsx("span", {
            className: ep.priceDiscount,
            children: dR(e.discount, s)
          }), /* @__PURE__ */B.jsx("span", {
            className: ep.priceValue,
            children: dR(e.value, s)
          })]
        })]
      }), t && /* @__PURE__ */B.jsx("div", {
        className: ep.cardCtaBtn,
        children: /* @__PURE__ */B.jsx(dd, {
          icon: (t == null ? void 0 : t.icon) ?? "arrow-right-micro",
          target: t == null ? void 0 : t.target,
          ...t,
          size: "md",
          className: ve(ep.cardLink, ep.LPC)
        })
      })]
    })]
  }),
  qJ = "_tag_1eozx_1",
  YJ = "_tagIcon_1eozx_11",
  fB = {
    tag: qJ,
    tagIcon: YJ
  },
  GJ = ({
    icon: t = "deal-solid",
    label: e,
    className: i
  }) => /* @__PURE__ */B.jsx(F4, {
    className: ve(fB.tag, i),
    label: e,
    icon: /* @__PURE__ */B.jsx(ln, {
      className: fB.tagIcon,
      name: t
    })
  }),
  XJ = "_merchCard_glrgo_1",
  KJ = "_merchCardLink_glrgo_13",
  QJ = "_merchCardImage_glrgo_52",
  ZJ = "_merchCardBody_glrgo_67",
  JJ = "_merchCardContentContainer_glrgo_73",
  eee = "_merchCardHeading_glrgo_82",
  tee = "_merchCardSubheading_glrgo_98",
  nee = "_merchCardRatingsContainer_glrgo_110",
  ree = "_merchCardDetailsDays_glrgo_114",
  iee = "_merchCardDetailsDaysInfo_glrgo_119",
  aee = "_merchCardDetailsPrice_glrgo_126",
  oee = "_merchCardDetailsSave_glrgo_137",
  lee = "_merchCardDetailsAmount_glrgo_143",
  see = "_merchCardDetailsPrevAmount_glrgo_157",
  Tc = {
    merchCard: XJ,
    merchCardLink: KJ,
    merchCardImage: QJ,
    merchCardBody: ZJ,
    merchCardContentContainer: JJ,
    merchCardHeading: eee,
    merchCardSubheading: tee,
    merchCardRatingsContainer: nee,
    merchCardDetailsDays: ree,
    merchCardDetailsDaysInfo: iee,
    merchCardDetailsPrice: aee,
    merchCardDetailsSave: oee,
    merchCardDetailsAmount: lee,
    merchCardDetailsPrevAmount: see
  },
  uee = {
    adultsOnly: "Adults only",
    departure: "Dep.",
    return: "Ret.",
    perAdult: "Per adult",
    taxAndFees: "Taxes and fees incl.",
    from: "Toronto",
    dayOfWeek: "Thursday",
    departureDate: "Dec 9, 2024",
    returnDate: "Dec 16, 2024",
    allInc: "All inclusive",
    was: "was"
  },
  cee = ({
    labels: t,
    image: e,
    header: i,
    link: s,
    className: c,
    subheader: p,
    stars: h,
    minAge: y,
    days: w,
    save: x,
    regPrice: E,
    price: C,
    locale: k = "en-CA",
    headerAs: D = "h2",
    theme: I = "light",
    renderLink: L
  }) => {
    var N, O, F, j;
    const P = {
      ...uee,
      ...t
    };
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(Tc.merchCard, c),
      "data-theme": I,
      children: [((N = e == null ? void 0 : e.source) == null ? void 0 : N.src) && /* @__PURE__ */B.jsx("div", {
        className: Tc.merchCardImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (O = e == null ? void 0 : e.source) == null ? void 0 : O.src,
          srcSet: (F = e == null ? void 0 : e.source) == null ? void 0 : F.srcSet,
          sizes: (j = e == null ? void 0 : e.source) == null ? void 0 : j.sizes,
          source: e == null ? void 0 : e.source,
          alt: e.alt || i,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Tc.merchCardBody,
        children: [/* @__PURE__ */B.jsxs("div", {
          children: [/* @__PURE__ */B.jsx(cu, {
            className: Tc.merchCardHeading,
            Tag: D,
            children: i
          }), (p || w) && /* @__PURE__ */B.jsx(cu, {
            Tag: "div",
            size: "md",
            className: Tc.merchCardSubheading,
            children: p
          }), h && /* @__PURE__ */B.jsx(wL, {
            rating: h,
            theme: I,
            classNames: {
              container: Tc.merchCardRatingsContainer
            }
          })]
        }), typeof y == "number" && y >= 16 && /* @__PURE__ */B.jsx("p", {
          children: `${P.adultsOnly} ${y}`
        }), C && x && /* @__PURE__ */B.jsx(GJ, {
          className: Tc.merchCardDetailsSave,
          label: x
        }), /* @__PURE__ */B.jsxs("div", {
          className: Tc.merchCardContentContainer,
          children: [w && /* @__PURE__ */B.jsx("div", {
            className: Tc.merchCardDetailsDays,
            children: /* @__PURE__ */B.jsxs("div", {
              className: Tc.merchCardDetailsDaysInfo,
              children: [/* @__PURE__ */B.jsx("span", {
                children: P == null ? void 0 : P.departureDate
              }), /* @__PURE__ */B.jsx("span", {
                children: w
              }), (P == null ? void 0 : P.allInc) && /* @__PURE__ */B.jsx("span", {
                children: P.allInc
              })]
            })
          }), C !== void 0 && /* @__PURE__ */B.jsxs("div", {
            className: Tc.merchCardDetailsPrice,
            children: [E !== void 0 && x && /* @__PURE__ */B.jsx("div", {
              className: Tc.merchCardDetailsPrevAmount,
              children: /* @__PURE__ */B.jsx(aE, {
                renderCurrencyAsSup: !1,
                number: E,
                locale: k
              })
            }), /* @__PURE__ */B.jsx("div", {
              className: Tc.merchCardDetailsAmount,
              children: /* @__PURE__ */B.jsx(aE, {
                renderCurrencyAsSup: !0,
                number: C,
                locale: k
              })
            }), /* @__PURE__ */B.jsxs("div", {
              className: Tc.merchCardDetailsDaysInfo,
              children: [/* @__PURE__ */B.jsx("span", {
                children: P.perAdult
              }), /* @__PURE__ */B.jsx("span", {
                children: P.taxAndFees
              })]
            })]
          })]
        })]
      }), !!s && /* @__PURE__ */B.jsx(dd, {
        className: Tc.merchCardLink,
        href: s.href,
        target: s.target ?? "_blank",
        renderLink: L,
        children: /* @__PURE__ */B.jsx("span", {
          children: s == null ? void 0 : s.children
        })
      })]
    });
  },
  dee = "_header_8t6ye_1",
  fee = "_headerImage_8t6ye_5",
  pee = "_headerHeading_8t6ye_18",
  hee = "_headerContent_8t6ye_28",
  mee = "_headerLogo_8t6ye_37",
  vee = "_headerBody_8t6ye_82",
  X1 = {
    header: dee,
    headerImage: fee,
    headerHeading: pee,
    headerContent: hee,
    headerLogo: mee,
    headerBody: vee
  },
  V_e = ({
    image: t,
    logo: e,
    header: i,
    content: s,
    headerAs: c = "h1",
    className: p,
    role: h
  }) => {
    var y, w, x;
    return /* @__PURE__ */B.jsxs("div", {
      role: h,
      className: ve(X1.header, p),
      children: [t && /* @__PURE__ */B.jsxs("div", {
        className: X1.headerImage,
        children: [/* @__PURE__ */B.jsx(Ym, {
          src: (y = t == null ? void 0 : t.source) == null ? void 0 : y.src,
          srcSet: (w = t == null ? void 0 : t.source) == null ? void 0 : w.srcSet,
          sizes: (x = t == null ? void 0 : t.source) == null ? void 0 : x.sizes,
          alt: t.alt ?? "",
          source: t.source,
          loading: "lazy"
        }), !!e && /* @__PURE__ */B.jsx("div", {
          className: X1.headerLogo,
          children: /* @__PURE__ */B.jsx(Ym, {
            src: e.src,
            alt: e == null ? void 0 : e.alt,
            loading: "lazy"
          })
        })]
      }), /* @__PURE__ */B.jsxs("div", {
        className: X1.headerBody,
        children: [/* @__PURE__ */B.jsx(cu, {
          size: "md",
          Tag: c,
          className: X1.headerHeading,
          children: i
        }), /* @__PURE__ */B.jsx("div", {
          className: X1.headerContent,
          children: s
        })]
      })]
    });
  },
  gee = "_primary_erzcl_1",
  yee = "_cardLink_erzcl_31",
  bee = "_transparent_erzcl_38",
  wee = "_primaryImage_erzcl_45",
  _ee = "_primaryBody_erzcl_58",
  xee = "_primaryHeading_erzcl_67",
  See = "_primaryContent_erzcl_72",
  Eee = "_primarySubheading_erzcl_75",
  Cee = "_primaryHeader_erzcl_78",
  kee = "_primaryFooter_erzcl_82",
  Tee = "_primaryButton_erzcl_91",
  Ree = "_primaryLogo_erzcl_94",
  Dee = "_square_erzcl_112",
  Iee = "_landscape_erzcl_116",
  Mee = "_wide_erzcl_119",
  Lee = "_logoOffset_erzcl_128",
  Oee = "_hasLimit_erzcl_140",
  Pee = "_evenSplit_erzcl_199",
  Aee = "_clickable_erzcl_279",
  Rc = {
    primary: gee,
    cardLink: yee,
    transparent: bee,
    primaryImage: wee,
    primaryBody: _ee,
    primaryHeading: xee,
    primaryContent: See,
    primarySubheading: Eee,
    primaryHeader: Cee,
    primaryFooter: kee,
    primaryButton: Tee,
    primaryLogo: Ree,
    square: Dee,
    landscape: Iee,
    wide: Mee,
    logoOffset: Lee,
    hasLimit: Oee,
    evenSplit: Pee,
    clickable: Aee
  },
  B_e = {
    default: "default",
    evenSplit: "evenSplit",
    logoOffset: "logoOffset"
  },
  pB = {
    link: "link",
    button: "button"
  },
  jee = (t, e) => {
    if (!t || !e || e === 0) return;
    const i = t / e;
    return i === 1 ? "square" : i <= 2 && i > 1 ? "landscape" : (i > 2, "wide");
  },
  U_e = ({
    image: t,
    logo: e,
    subheading: i,
    header: s,
    variant: c,
    content: p,
    contentLimit: h,
    link: y,
    headerAs: w = "h1",
    backgroundType: x,
    ctaVariant: E,
    className: C,
    renderLink: k,
    theme: D = "light"
  }) => {
    var L, P, N;
    const I = jee(Number(e == null ? void 0 : e.width), Number(e == null ? void 0 : e.height));
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(Rc.primary, C, c && Rc[c], x && Rc[x]),
      "data-theme": D,
      children: [t && /* @__PURE__ */B.jsx("div", {
        className: Rc.primaryImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (L = t == null ? void 0 : t.source) == null ? void 0 : L.src,
          srcSet: (P = t == null ? void 0 : t.source) == null ? void 0 : P.srcSet,
          sizes: (N = t == null ? void 0 : t.source) == null ? void 0 : N.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      }), /* @__PURE__ */B.jsxs("div", {
        className: Rc.primaryBody,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: Rc.primaryHeader,
          children: [!!i && /* @__PURE__ */B.jsx(cu, {
            Tag: "div",
            size: "eyebrow",
            className: Rc.primarySubheading,
            children: i
          }), !!s && /* @__PURE__ */B.jsx(cu, {
            size: "md",
            Tag: w,
            className: Rc.primaryHeading,
            children: s
          }), !!p && /* @__PURE__ */B.jsx("div", {
            className: ve(Rc.primaryContent, {
              [Rc.hasLimit]: h
            }),
            children: p
          })]
        }), /* @__PURE__ */B.jsxs("div", {
          className: Rc.primaryFooter,
          children: [!!y && /* @__PURE__ */B.jsx("div", {
            children: E === pB.button ? /* @__PURE__ */B.jsx(op, {
              as: "a",
              size: "md",
              variant: "action",
              href: y.href,
              renderLink: k,
              className: Rc.cardLink,
              children: y == null ? void 0 : y.children
            }) : /* @__PURE__ */B.jsx(dd, {
              renderLink: k,
              icon: (y == null ? void 0 : y.icon) ?? "arrow-right-micro",
              href: y.href,
              target: y == null ? void 0 : y.target,
              variant: D,
              className: Rc.cardLink,
              children: y == null ? void 0 : y.children
            })
          }), !!e && E !== pB.button && /* @__PURE__ */B.jsx("div", {
            className: ve(Rc.primaryLogo, I && Rc[I]),
            children: /* @__PURE__ */B.jsx(Ym, {
              src: e.src,
              alt: e == null ? void 0 : e.alt,
              loading: "lazy"
            })
          })]
        })]
      })]
    });
  },
  EN = {
    openModalLabel: "Gallery",
    firstSlideMessage: "This is the first slide",
    lastSlideMessage: "This is the last slide",
    prevSlideMessage: "Previous slide",
    nextSlideMessage: "Next slide",
    paginationBulletMessage: "Go to slide {{index}}",
    slideLabelMessage: "{{index}}/{{slidesLength}}",
    closeModal: "Close",
    playVideo: "Play video",
    viewImage: "View image"
  },
  hB = {
    "10:4": "10:4",
    "16:9": "16:9",
    "1:1": "1:1"
  },
  Fee = (t, e) => {
    let i, s;
    switch (t) {
      case "10:4":
        i = 10 / 4, s = e || "t_WVI-ar10x4";
        break;
      case "16:9":
        i = 16 / 9, s = e || "t_WVI-ar16x9";
        break;
      case "1:1":
        i = 1, s = e || "t_WVI-ar1x1";
        break;
      case "2:3":
        i = 2 / 3, s = e || "t_WVI-ar2x3";
        break;
      case "3:2":
        i = 3 / 2, s = e || "t_WVI-ar3x2";
        break;
      default:
        {
          try {
            const p = /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?)$/.exec(t);
            if (p) {
              const [, h, y] = p;
              i = parseFloat(h) / parseFloat(y);
            } else console.warn(`Invalid aspect ratio format: ${t}`), i = 16 / 9;
          } catch {
            console.warn(`Unable to parse provided aspect ratio: ${t}.  Expected format is "number:number"`), i = 16 / 9;
          }
          s = e || "t_WVI-ar16x9";
          break;
        }
    }
    return [i, s];
  },
  H4 = (t, {
    className: e,
    wrapperClassName: i
  }) => /* @__PURE__ */B.jsx(Ym, {
    wrapperClassName: i,
    title: t.title,
    source: t.source,
    src: t.src,
    className: e,
    alt: t.alt ?? "Image",
    loading: "lazy"
  });
function mB(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function CN(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter(s => i.indexOf(s) < 0).forEach(s => {
    typeof t[s] > "u" ? t[s] = e[s] : mB(e[s]) && mB(t[s]) && Object.keys(e[s]).length > 0 && CN(t[s], e[s]);
  });
}
const $4 = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Gm() {
  const t = typeof document < "u" ? document : {};
  return CN(t, $4), t;
}
const Nee = {
  document: $4,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function ws() {
  const t = typeof window < "u" ? window : {};
  return CN(t, Nee), t;
}
function zee(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter(e => !!e.trim());
}
function Vee(t) {
  const e = t;
  Object.keys(e).forEach(i => {
    try {
      e[i] = null;
    } catch {}
    try {
      delete e[i];
    } catch {}
  });
}
function kN(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function _L() {
  return Date.now();
}
function Bee(t) {
  const e = ws();
  let i;
  return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
}
function N2(t, e) {
  e === void 0 && (e = "x");
  const i = ws();
  let s, c, p;
  const h = Bee(t);
  return i.WebKitCSSMatrix ? (c = h.transform || h.webkitTransform, c.split(",").length > 6 && (c = c.split(", ").map(y => y.replace(",", ".")).join(", ")), p = new i.WebKitCSSMatrix(c === "none" ? "" : c)) : (p = h.MozTransform || h.OTransform || h.MsTransform || h.msTransform || h.transform || h.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = p.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? c = p.m41 : s.length === 16 ? c = parseFloat(s[12]) : c = parseFloat(s[4])), e === "y" && (i.WebKitCSSMatrix ? c = p.m42 : s.length === 16 ? c = parseFloat(s[13]) : c = parseFloat(s[5])), c || 0;
}
function hM(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Uee(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function rp() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (s != null && !Uee(s)) {
      const c = Object.keys(Object(s)).filter(p => e.indexOf(p) < 0);
      for (let p = 0, h = c.length; p < h; p += 1) {
        const y = c[p],
          w = Object.getOwnPropertyDescriptor(s, y);
        w !== void 0 && w.enumerable && (hM(t[y]) && hM(s[y]) ? s[y].__swiper__ ? t[y] = s[y] : rp(t[y], s[y]) : !hM(t[y]) && hM(s[y]) ? (t[y] = {}, s[y].__swiper__ ? t[y] = s[y] : rp(t[y], s[y])) : t[y] = s[y]);
      }
    }
  }
  return t;
}
function mM(t, e, i) {
  t.style.setProperty(e, i);
}
function W4(t) {
  let {
    swiper: e,
    targetPosition: i,
    side: s
  } = t;
  const c = ws(),
    p = -e.translate;
  let h = null,
    y;
  const w = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", c.cancelAnimationFrame(e.cssModeFrameID);
  const x = i > p ? "next" : "prev",
    E = (k, D) => x === "next" && k >= D || x === "prev" && k <= D,
    C = () => {
      y = (/* @__PURE__ */new Date()).getTime(), h === null && (h = y);
      const k = Math.max(Math.min((y - h) / w, 1), 0),
        D = 0.5 - Math.cos(k * Math.PI) / 2;
      let I = p + D * (i - p);
      if (E(I, i) && (I = i), e.wrapperEl.scrollTo({
        [s]: I
      }), E(I, i)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
            [s]: I
          });
        }), c.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = c.requestAnimationFrame(C);
    };
  C();
}
function Np(t, e) {
  e === void 0 && (e = "");
  const i = ws(),
    s = [...t.children];
  return i.HTMLSlotElement && t instanceof HTMLSlotElement && s.push(...t.assignedElements()), e ? s.filter(c => c.matches(e)) : s;
}
function Hee(t, e) {
  const i = [e];
  for (; i.length > 0;) {
    const s = i.shift();
    if (t === s) return !0;
    i.push(...s.children, ...(s.shadowRoot ? s.shadowRoot.children : []), ...(s.assignedElements ? s.assignedElements() : []));
  }
}
function $ee(t, e) {
  const i = ws();
  let s = e.contains(t);
  return !s && i.HTMLSlotElement && e instanceof HTMLSlotElement && (s = [...e.assignedElements()].includes(t), s || (s = Hee(t, e))), s;
}
function xL(t) {
  try {
    console.warn(t);
    return;
  } catch {}
}
function fR(t, e) {
  e === void 0 && (e = []);
  const i = document.createElement(t);
  return i.classList.add(...(Array.isArray(e) ? e : zee(e))), i;
}
function z2(t) {
  const e = ws(),
    i = Gm(),
    s = t.getBoundingClientRect(),
    c = i.body,
    p = t.clientTop || c.clientTop || 0,
    h = t.clientLeft || c.clientLeft || 0,
    y = t === e ? e.scrollY : t.scrollTop,
    w = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: s.top + y - p,
    left: s.left + w - h
  };
}
function Wee(t, e) {
  const i = [];
  for (; t.previousElementSibling;) {
    const s = t.previousElementSibling;
    e ? s.matches(e) && i.push(s) : i.push(s), t = s;
  }
  return i;
}
function qee(t, e) {
  const i = [];
  for (; t.nextElementSibling;) {
    const s = t.nextElementSibling;
    e ? s.matches(e) && i.push(s) : i.push(s), t = s;
  }
  return i;
}
function J0(t, e) {
  return ws().getComputedStyle(t, null).getPropertyValue(e);
}
function pR(t) {
  let e = t,
    i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null;) e.nodeType === 1 && (i += 1);
    return i;
  }
}
function Gx(t, e) {
  const i = [];
  let s = t.parentElement;
  for (; s;) e ? s.matches(e) && i.push(s) : i.push(s), s = s.parentElement;
  return i;
}
function Yee(t, e) {
  function i(s) {
    s.target === t && (e.call(t, s), t.removeEventListener("transitionend", i));
  }
  e && t.addEventListener("transitionend", i);
}
function V2(t, e, i) {
  const s = ws();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function aa(t) {
  return (Array.isArray(t) ? t : [t]).filter(e => !!e);
}
function hR(t, e) {
  e === void 0 && (e = ""), typeof trustedTypes < "u" ? t.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: i => i
  }).createHTML(e) : t.innerHTML = e;
}
function q4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s,
    emit: c
  } = t;
  const p = Gm(),
    h = ws();
  e.keyboard = {
    enabled: !1
  }, i({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function y(E) {
    if (!e.enabled) return;
    const {
      rtlTranslate: C
    } = e;
    let k = E;
    k.originalEvent && (k = k.originalEvent);
    const D = k.keyCode || k.charCode,
      I = e.params.keyboard.pageUpDown,
      L = I && D === 33,
      P = I && D === 34,
      N = D === 37,
      O = D === 39,
      F = D === 38,
      j = D === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && O || e.isVertical() && j || P) || !e.allowSlidePrev && (e.isHorizontal() && N || e.isVertical() && F || L)) return !1;
    if (!(k.shiftKey || k.altKey || k.ctrlKey || k.metaKey) && !(p.activeElement && (p.activeElement.isContentEditable || p.activeElement.nodeName && (p.activeElement.nodeName.toLowerCase() === "input" || p.activeElement.nodeName.toLowerCase() === "textarea")))) {
      if (e.params.keyboard.onlyInViewport && (L || P || N || O || F || j)) {
        let V = !1;
        if (Gx(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Gx(e.el, `.${e.params.slideActiveClass}`).length === 0) return;
        const K = e.el,
          G = K.clientWidth,
          Q = K.clientHeight,
          te = h.innerWidth,
          ie = h.innerHeight,
          Y = z2(K);
        C && (Y.left -= K.scrollLeft);
        const ee = [[Y.left, Y.top], [Y.left + G, Y.top], [Y.left, Y.top + Q], [Y.left + G, Y.top + Q]];
        for (let ae = 0; ae < ee.length; ae += 1) {
          const ne = ee[ae];
          if (ne[0] >= 0 && ne[0] <= te && ne[1] >= 0 && ne[1] <= ie) {
            if (ne[0] === 0 && ne[1] === 0) continue;
            V = !0;
          }
        }
        if (!V) return;
      }
      e.isHorizontal() ? ((L || P || N || O) && (k.preventDefault ? k.preventDefault() : k.returnValue = !1), ((P || O) && !C || (L || N) && C) && e.slideNext(), ((L || N) && !C || (P || O) && C) && e.slidePrev()) : ((L || P || F || j) && (k.preventDefault ? k.preventDefault() : k.returnValue = !1), (P || j) && e.slideNext(), (L || F) && e.slidePrev()), c("keyPress", D);
    }
  }
  function w() {
    e.keyboard.enabled || (p.addEventListener("keydown", y), e.keyboard.enabled = !0);
  }
  function x() {
    e.keyboard.enabled && (p.removeEventListener("keydown", y), e.keyboard.enabled = !1);
  }
  s("init", () => {
    e.params.keyboard.enabled && w();
  }), s("destroy", () => {
    e.keyboard.enabled && x();
  }), Object.assign(e.keyboard, {
    enable: w,
    disable: x
  });
}
function Gee(t, e, i, s) {
  return t.params.createElements && Object.keys(s).forEach(c => {
    if (!i[c] && i.auto === !0) {
      let p = Np(t.el, `.${s[c]}`)[0];
      p || (p = fR("div", s[c]), p.className = s[c], t.el.append(p)), i[c] = p, e[c] = p;
    }
  }), i;
}
function Q0(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
}
function Y4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s,
    emit: c
  } = t;
  const p = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: O => O,
      formatFractionTotal: O => O,
      bulletClass: `${p}-bullet`,
      bulletActiveClass: `${p}-bullet-active`,
      modifierClass: `${p}-`,
      currentClass: `${p}-current`,
      totalClass: `${p}-total`,
      hiddenClass: `${p}-hidden`,
      progressbarFillClass: `${p}-progressbar-fill`,
      progressbarOppositeClass: `${p}-progressbar-opposite`,
      clickableClass: `${p}-clickable`,
      lockClass: `${p}-lock`,
      horizontalClass: `${p}-horizontal`,
      verticalClass: `${p}-vertical`,
      paginationDisabledClass: `${p}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let h,
    y = 0;
  function w() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function x(O, F) {
    const {
      bulletActiveClass: j
    } = e.params.pagination;
    O && (O = O[`${F === "prev" ? "previous" : "next"}ElementSibling`], O && (O.classList.add(`${j}-${F}`), O = O[`${F === "prev" ? "previous" : "next"}ElementSibling`], O && O.classList.add(`${j}-${F}-${F}`)));
  }
  function E(O, F, j) {
    if (O = O % j, F = F % j, F === O + 1) return "next";
    if (F === O - 1) return "previous";
  }
  function C(O) {
    const F = O.target.closest(Q0(e.params.pagination.bulletClass));
    if (!F) return;
    O.preventDefault();
    const j = pR(F) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === j) return;
      const V = E(e.realIndex, j, e.slides.length);
      V === "next" ? e.slideNext() : V === "previous" ? e.slidePrev() : e.slideToLoop(j);
    } else e.slideTo(j);
  }
  function k() {
    const O = e.rtl,
      F = e.params.pagination;
    if (w()) return;
    let j = e.pagination.el;
    j = aa(j);
    let V, K;
    const G = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
      Q = e.params.loop ? Math.ceil(G / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (K = e.previousRealIndex || 0, V = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (V = e.snapIndex, K = e.previousSnapIndex) : (K = e.previousIndex || 0, V = e.activeIndex || 0), F.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const te = e.pagination.bullets;
      let ie, Y, ee;
      if (F.dynamicBullets && (h = V2(te[0], e.isHorizontal() ? "width" : "height"), j.forEach(ae => {
        ae.style[e.isHorizontal() ? "width" : "height"] = `${h * (F.dynamicMainBullets + 4)}px`;
      }), F.dynamicMainBullets > 1 && K !== void 0 && (y += V - (K || 0), y > F.dynamicMainBullets - 1 ? y = F.dynamicMainBullets - 1 : y < 0 && (y = 0)), ie = Math.max(V - y, 0), Y = ie + (Math.min(te.length, F.dynamicMainBullets) - 1), ee = (Y + ie) / 2), te.forEach(ae => {
        const ne = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(le => `${F.bulletActiveClass}${le}`)].map(le => typeof le == "string" && le.includes(" ") ? le.split(" ") : le).flat();
        ae.classList.remove(...ne);
      }), j.length > 1) te.forEach(ae => {
        const ne = pR(ae);
        ne === V ? ae.classList.add(...F.bulletActiveClass.split(" ")) : e.isElement && ae.setAttribute("part", "bullet"), F.dynamicBullets && (ne >= ie && ne <= Y && ae.classList.add(...`${F.bulletActiveClass}-main`.split(" ")), ne === ie && x(ae, "prev"), ne === Y && x(ae, "next"));
      });else {
        const ae = te[V];
        if (ae && ae.classList.add(...F.bulletActiveClass.split(" ")), e.isElement && te.forEach((ne, le) => {
          ne.setAttribute("part", le === V ? "bullet-active" : "bullet");
        }), F.dynamicBullets) {
          const ne = te[ie],
            le = te[Y];
          for (let ce = ie; ce <= Y; ce += 1) te[ce] && te[ce].classList.add(...`${F.bulletActiveClass}-main`.split(" "));
          x(ne, "prev"), x(le, "next");
        }
      }
      if (F.dynamicBullets) {
        const ae = Math.min(te.length, F.dynamicMainBullets + 4),
          ne = (h * ae - h) / 2 - ee * h,
          le = O ? "right" : "left";
        te.forEach(ce => {
          ce.style[e.isHorizontal() ? le : "top"] = `${ne}px`;
        });
      }
    }
    j.forEach((te, ie) => {
      if (F.type === "fraction" && (te.querySelectorAll(Q0(F.currentClass)).forEach(Y => {
        Y.textContent = F.formatFractionCurrent(V + 1);
      }), te.querySelectorAll(Q0(F.totalClass)).forEach(Y => {
        Y.textContent = F.formatFractionTotal(Q);
      })), F.type === "progressbar") {
        let Y;
        F.progressbarOpposite ? Y = e.isHorizontal() ? "vertical" : "horizontal" : Y = e.isHorizontal() ? "horizontal" : "vertical";
        const ee = (V + 1) / Q;
        let ae = 1,
          ne = 1;
        Y === "horizontal" ? ae = ee : ne = ee, te.querySelectorAll(Q0(F.progressbarFillClass)).forEach(le => {
          le.style.transform = `translate3d(0,0,0) scaleX(${ae}) scaleY(${ne})`, le.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      F.type === "custom" && F.renderCustom ? (hR(te, F.renderCustom(e, V + 1, Q)), ie === 0 && c("paginationRender", te)) : (ie === 0 && c("paginationRender", te), c("paginationUpdate", te)), e.params.watchOverflow && e.enabled && te.classList[e.isLocked ? "add" : "remove"](F.lockClass);
    });
  }
  function D() {
    const O = e.params.pagination;
    if (w()) return;
    const F = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let j = e.pagination.el;
    j = aa(j);
    let V = "";
    if (O.type === "bullets") {
      let K = e.params.loop ? Math.ceil(F / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && K > F && (K = F);
      for (let G = 0; G < K; G += 1) O.renderBullet ? V += O.renderBullet.call(e, G, O.bulletClass) : V += `<${O.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${O.bulletClass}"></${O.bulletElement}>`;
    }
    O.type === "fraction" && (O.renderFraction ? V = O.renderFraction.call(e, O.currentClass, O.totalClass) : V = `<span class="${O.currentClass}"></span> / <span class="${O.totalClass}"></span>`), O.type === "progressbar" && (O.renderProgressbar ? V = O.renderProgressbar.call(e, O.progressbarFillClass) : V = `<span class="${O.progressbarFillClass}"></span>`), e.pagination.bullets = [], j.forEach(K => {
      O.type !== "custom" && hR(K, V || ""), O.type === "bullets" && e.pagination.bullets.push(...K.querySelectorAll(Q0(O.bulletClass)));
    }), O.type !== "custom" && c("paginationRender", j[0]);
  }
  function I() {
    e.params.pagination = Gee(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const O = e.params.pagination;
    if (!O.el) return;
    let F;
    typeof O.el == "string" && e.isElement && (F = e.el.querySelector(O.el)), !F && typeof O.el == "string" && (F = [...document.querySelectorAll(O.el)]), F || (F = O.el), !(!F || F.length === 0) && (e.params.uniqueNavElements && typeof O.el == "string" && Array.isArray(F) && F.length > 1 && (F = [...e.el.querySelectorAll(O.el)], F.length > 1 && (F = F.find(j => Gx(j, ".swiper")[0] === e.el))), Array.isArray(F) && F.length === 1 && (F = F[0]), Object.assign(e.pagination, {
      el: F
    }), F = aa(F), F.forEach(j => {
      O.type === "bullets" && O.clickable && j.classList.add(...(O.clickableClass || "").split(" ")), j.classList.add(O.modifierClass + O.type), j.classList.add(e.isHorizontal() ? O.horizontalClass : O.verticalClass), O.type === "bullets" && O.dynamicBullets && (j.classList.add(`${O.modifierClass}${O.type}-dynamic`), y = 0, O.dynamicMainBullets < 1 && (O.dynamicMainBullets = 1)), O.type === "progressbar" && O.progressbarOpposite && j.classList.add(O.progressbarOppositeClass), O.clickable && j.addEventListener("click", C), e.enabled || j.classList.add(O.lockClass);
    }));
  }
  function L() {
    const O = e.params.pagination;
    if (w()) return;
    let F = e.pagination.el;
    F && (F = aa(F), F.forEach(j => {
      j.classList.remove(O.hiddenClass), j.classList.remove(O.modifierClass + O.type), j.classList.remove(e.isHorizontal() ? O.horizontalClass : O.verticalClass), O.clickable && (j.classList.remove(...(O.clickableClass || "").split(" ")), j.removeEventListener("click", C));
    })), e.pagination.bullets && e.pagination.bullets.forEach(j => j.classList.remove(...O.bulletActiveClass.split(" ")));
  }
  s("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const O = e.params.pagination;
    let {
      el: F
    } = e.pagination;
    F = aa(F), F.forEach(j => {
      j.classList.remove(O.horizontalClass, O.verticalClass), j.classList.add(e.isHorizontal() ? O.horizontalClass : O.verticalClass);
    });
  }), s("init", () => {
    e.params.pagination.enabled === !1 ? N() : (I(), D(), k());
  }), s("activeIndexChange", () => {
    typeof e.snapIndex > "u" && k();
  }), s("snapIndexChange", () => {
    k();
  }), s("snapGridLengthChange", () => {
    D(), k();
  }), s("destroy", () => {
    L();
  }), s("enable disable", () => {
    let {
      el: O
    } = e.pagination;
    O && (O = aa(O), O.forEach(F => F.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), s("lock unlock", () => {
    k();
  }), s("click", (O, F) => {
    const j = F.target,
      V = aa(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && V && V.length > 0 && !j.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && j === e.navigation.nextEl || e.navigation.prevEl && j === e.navigation.prevEl)) return;
      const K = V[0].classList.contains(e.params.pagination.hiddenClass);
      c(K === !0 ? "paginationShow" : "paginationHide"), V.forEach(G => G.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const P = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let {
        el: O
      } = e.pagination;
      O && (O = aa(O), O.forEach(F => F.classList.remove(e.params.pagination.paginationDisabledClass))), I(), D(), k();
    },
    N = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let {
        el: O
      } = e.pagination;
      O && (O = aa(O), O.forEach(F => F.classList.add(e.params.pagination.paginationDisabledClass))), L();
    };
  Object.assign(e.pagination, {
    enable: P,
    disable: N,
    render: D,
    update: k,
    init: I,
    destroy: L
  });
}
function G4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s,
    emit: c
  } = t;
  const p = ws();
  i({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let h = 1,
    y = !1,
    w = !1,
    x = {
      x: 0,
      y: 0
    };
  const E = -3;
  let C, k;
  const D = [],
    I = {
      originX: 0,
      originY: 0,
      slideEl: void 0,
      slideWidth: void 0,
      slideHeight: void 0,
      imageEl: void 0,
      imageWrapEl: void 0,
      maxRatio: 3
    },
    L = {
      isTouched: void 0,
      isMoved: void 0,
      currentX: void 0,
      currentY: void 0,
      minX: void 0,
      minY: void 0,
      maxX: void 0,
      maxY: void 0,
      width: void 0,
      height: void 0,
      startX: void 0,
      startY: void 0,
      touchesStart: {},
      touchesCurrent: {}
    },
    P = {
      x: void 0,
      y: void 0,
      prevPositionX: void 0,
      prevPositionY: void 0,
      prevTime: void 0
    };
  let N = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return N;
    },
    set(fe) {
      if (N !== fe) {
        const _e = I.imageEl,
          Se = I.slideEl;
        c("zoomChange", fe, _e, Se);
      }
      N = fe;
    }
  });
  function O() {
    if (D.length < 2) return 1;
    const fe = D[0].pageX,
      _e = D[0].pageY,
      Se = D[1].pageX,
      be = D[1].pageY;
    return Math.sqrt((Se - fe) ** 2 + (be - _e) ** 2);
  }
  function F() {
    const fe = e.params.zoom,
      _e = I.imageWrapEl.getAttribute("data-swiper-zoom") || fe.maxRatio;
    if (fe.limitToOriginalSize && I.imageEl && I.imageEl.naturalWidth) {
      const Se = I.imageEl.naturalWidth / I.imageEl.offsetWidth;
      return Math.min(Se, _e);
    }
    return _e;
  }
  function j() {
    if (D.length < 2) return {
      x: null,
      y: null
    };
    const fe = I.imageEl.getBoundingClientRect();
    return [(D[0].pageX + (D[1].pageX - D[0].pageX) / 2 - fe.x - p.scrollX) / h, (D[0].pageY + (D[1].pageY - D[0].pageY) / 2 - fe.y - p.scrollY) / h];
  }
  function V() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function K(fe) {
    const _e = V();
    return !!(fe.target.matches(_e) || e.slides.filter(Se => Se.contains(fe.target)).length > 0);
  }
  function G(fe) {
    const _e = `.${e.params.zoom.containerClass}`;
    return !!(fe.target.matches(_e) || [...e.hostEl.querySelectorAll(_e)].filter(Se => Se.contains(fe.target)).length > 0);
  }
  function Q(fe) {
    if (fe.pointerType === "mouse" && D.splice(0, D.length), !K(fe)) return;
    const _e = e.params.zoom;
    if (C = !1, k = !1, D.push(fe), !(D.length < 2)) {
      if (C = !0, I.scaleStart = O(), !I.slideEl) {
        I.slideEl = fe.target.closest(`.${e.params.slideClass}, swiper-slide`), I.slideEl || (I.slideEl = e.slides[e.activeIndex]);
        let Se = I.slideEl.querySelector(`.${_e.containerClass}`);
        if (Se && (Se = Se.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = Se, Se ? I.imageWrapEl = Gx(I.imageEl, `.${_e.containerClass}`)[0] : I.imageWrapEl = void 0, !I.imageWrapEl) {
          I.imageEl = void 0;
          return;
        }
        I.maxRatio = F();
      }
      if (I.imageEl) {
        const [Se, be] = j();
        I.originX = Se, I.originY = be, I.imageEl.style.transitionDuration = "0ms";
      }
      y = !0;
    }
  }
  function te(fe) {
    if (!K(fe)) return;
    const _e = e.params.zoom,
      Se = e.zoom,
      be = D.findIndex(Le => Le.pointerId === fe.pointerId);
    be >= 0 && (D[be] = fe), !(D.length < 2) && (k = !0, I.scaleMove = O(), I.imageEl && (Se.scale = I.scaleMove / I.scaleStart * h, Se.scale > I.maxRatio && (Se.scale = I.maxRatio - 1 + (Se.scale - I.maxRatio + 1) ** 0.5), Se.scale < _e.minRatio && (Se.scale = _e.minRatio + 1 - (_e.minRatio - Se.scale + 1) ** 0.5), I.imageEl.style.transform = `translate3d(0,0,0) scale(${Se.scale})`));
  }
  function ie(fe) {
    if (!K(fe) || fe.pointerType === "mouse" && fe.type === "pointerout") return;
    const _e = e.params.zoom,
      Se = e.zoom,
      be = D.findIndex(Le => Le.pointerId === fe.pointerId);
    be >= 0 && D.splice(be, 1), !(!C || !k) && (C = !1, k = !1, I.imageEl && (Se.scale = Math.max(Math.min(Se.scale, I.maxRatio), _e.minRatio), I.imageEl.style.transitionDuration = `${e.params.speed}ms`, I.imageEl.style.transform = `translate3d(0,0,0) scale(${Se.scale})`, h = Se.scale, y = !1, Se.scale > 1 && I.slideEl ? I.slideEl.classList.add(`${_e.zoomedSlideClass}`) : Se.scale <= 1 && I.slideEl && I.slideEl.classList.remove(`${_e.zoomedSlideClass}`), Se.scale === 1 && (I.originX = 0, I.originY = 0, I.slideEl = void 0)));
  }
  let Y;
  function ee() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function ae() {
    clearTimeout(Y), e.touchEventsData.preventTouchMoveFromPointerMove = !0, Y = setTimeout(() => {
      e.destroyed || ee();
    });
  }
  function ne(fe) {
    const _e = e.device;
    if (!I.imageEl || L.isTouched) return;
    _e.android && fe.cancelable && fe.preventDefault(), L.isTouched = !0;
    const Se = D.length > 0 ? D[0] : fe;
    L.touchesStart.x = Se.pageX, L.touchesStart.y = Se.pageY;
  }
  function le(fe) {
    const Se = fe.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!K(fe) || !G(fe)) return;
    const be = e.zoom;
    if (!I.imageEl) return;
    if (!L.isTouched || !I.slideEl) {
      Se && $(fe);
      return;
    }
    if (Se) {
      $(fe);
      return;
    }
    L.isMoved || (L.width = I.imageEl.offsetWidth || I.imageEl.clientWidth, L.height = I.imageEl.offsetHeight || I.imageEl.clientHeight, L.startX = N2(I.imageWrapEl, "x") || 0, L.startY = N2(I.imageWrapEl, "y") || 0, I.slideWidth = I.slideEl.offsetWidth, I.slideHeight = I.slideEl.offsetHeight, I.imageWrapEl.style.transitionDuration = "0ms");
    const Le = L.width * be.scale,
      Be = L.height * be.scale;
    if (L.minX = Math.min(I.slideWidth / 2 - Le / 2, 0), L.maxX = -L.minX, L.minY = Math.min(I.slideHeight / 2 - Be / 2, 0), L.maxY = -L.minY, L.touchesCurrent.x = D.length > 0 ? D[0].pageX : fe.pageX, L.touchesCurrent.y = D.length > 0 ? D[0].pageY : fe.pageY, Math.max(Math.abs(L.touchesCurrent.x - L.touchesStart.x), Math.abs(L.touchesCurrent.y - L.touchesStart.y)) > 5 && (e.allowClick = !1), !L.isMoved && !y) {
      if (e.isHorizontal() && (Math.floor(L.minX) === Math.floor(L.startX) && L.touchesCurrent.x < L.touchesStart.x || Math.floor(L.maxX) === Math.floor(L.startX) && L.touchesCurrent.x > L.touchesStart.x)) {
        L.isTouched = !1, ee();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(L.minY) === Math.floor(L.startY) && L.touchesCurrent.y < L.touchesStart.y || Math.floor(L.maxY) === Math.floor(L.startY) && L.touchesCurrent.y > L.touchesStart.y)) {
        L.isTouched = !1, ee();
        return;
      }
    }
    fe.cancelable && fe.preventDefault(), fe.stopPropagation(), ae(), L.isMoved = !0;
    const ge = (be.scale - h) / (I.maxRatio - e.params.zoom.minRatio),
      {
        originX: qe,
        originY: Ae
      } = I;
    L.currentX = L.touchesCurrent.x - L.touchesStart.x + L.startX + ge * (L.width - qe * 2), L.currentY = L.touchesCurrent.y - L.touchesStart.y + L.startY + ge * (L.height - Ae * 2), L.currentX < L.minX && (L.currentX = L.minX + 1 - (L.minX - L.currentX + 1) ** 0.8), L.currentX > L.maxX && (L.currentX = L.maxX - 1 + (L.currentX - L.maxX + 1) ** 0.8), L.currentY < L.minY && (L.currentY = L.minY + 1 - (L.minY - L.currentY + 1) ** 0.8), L.currentY > L.maxY && (L.currentY = L.maxY - 1 + (L.currentY - L.maxY + 1) ** 0.8), P.prevPositionX || (P.prevPositionX = L.touchesCurrent.x), P.prevPositionY || (P.prevPositionY = L.touchesCurrent.y), P.prevTime || (P.prevTime = Date.now()), P.x = (L.touchesCurrent.x - P.prevPositionX) / (Date.now() - P.prevTime) / 2, P.y = (L.touchesCurrent.y - P.prevPositionY) / (Date.now() - P.prevTime) / 2, Math.abs(L.touchesCurrent.x - P.prevPositionX) < 2 && (P.x = 0), Math.abs(L.touchesCurrent.y - P.prevPositionY) < 2 && (P.y = 0), P.prevPositionX = L.touchesCurrent.x, P.prevPositionY = L.touchesCurrent.y, P.prevTime = Date.now(), I.imageWrapEl.style.transform = `translate3d(${L.currentX}px, ${L.currentY}px,0)`;
  }
  function ce() {
    const fe = e.zoom;
    if (D.length = 0, !I.imageEl) return;
    if (!L.isTouched || !L.isMoved) {
      L.isTouched = !1, L.isMoved = !1;
      return;
    }
    L.isTouched = !1, L.isMoved = !1;
    let _e = 300,
      Se = 300;
    const be = P.x * _e,
      Le = L.currentX + be,
      Be = P.y * Se,
      Xe = L.currentY + Be;
    P.x !== 0 && (_e = Math.abs((Le - L.currentX) / P.x)), P.y !== 0 && (Se = Math.abs((Xe - L.currentY) / P.y));
    const ge = Math.max(_e, Se);
    L.currentX = Le, L.currentY = Xe;
    const qe = L.width * fe.scale,
      Ae = L.height * fe.scale;
    L.minX = Math.min(I.slideWidth / 2 - qe / 2, 0), L.maxX = -L.minX, L.minY = Math.min(I.slideHeight / 2 - Ae / 2, 0), L.maxY = -L.minY, L.currentX = Math.max(Math.min(L.currentX, L.maxX), L.minX), L.currentY = Math.max(Math.min(L.currentY, L.maxY), L.minY), I.imageWrapEl.style.transitionDuration = `${ge}ms`, I.imageWrapEl.style.transform = `translate3d(${L.currentX}px, ${L.currentY}px,0)`;
  }
  function W() {
    const fe = e.zoom;
    I.slideEl && e.activeIndex !== e.slides.indexOf(I.slideEl) && (I.imageEl && (I.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), I.imageWrapEl && (I.imageWrapEl.style.transform = "translate3d(0,0,0)"), I.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), fe.scale = 1, h = 1, I.slideEl = void 0, I.imageEl = void 0, I.imageWrapEl = void 0, I.originX = 0, I.originY = 0);
  }
  function $(fe) {
    if (h <= 1 || !I.imageWrapEl || !K(fe) || !G(fe)) return;
    const _e = p.getComputedStyle(I.imageWrapEl).transform,
      Se = new p.DOMMatrix(_e);
    if (!w) {
      w = !0, x.x = fe.clientX, x.y = fe.clientY, L.startX = Se.e, L.startY = Se.f, L.width = I.imageEl.offsetWidth || I.imageEl.clientWidth, L.height = I.imageEl.offsetHeight || I.imageEl.clientHeight, I.slideWidth = I.slideEl.offsetWidth, I.slideHeight = I.slideEl.offsetHeight;
      return;
    }
    const be = (fe.clientX - x.x) * E,
      Le = (fe.clientY - x.y) * E,
      Be = L.width * h,
      Xe = L.height * h,
      ge = I.slideWidth,
      qe = I.slideHeight,
      Ae = Math.min(ge / 2 - Be / 2, 0),
      Mt = -Ae,
      Ft = Math.min(qe / 2 - Xe / 2, 0),
      un = -Ft,
      gt = Math.max(Math.min(L.startX + be, Mt), Ae),
      Pt = Math.max(Math.min(L.startY + Le, un), Ft);
    I.imageWrapEl.style.transitionDuration = "0ms", I.imageWrapEl.style.transform = `translate3d(${gt}px, ${Pt}px, 0)`, x.x = fe.clientX, x.y = fe.clientY, L.startX = gt, L.startY = Pt, L.currentX = gt, L.currentY = Pt;
  }
  function de(fe) {
    const _e = e.zoom,
      Se = e.params.zoom;
    if (!I.slideEl) {
      fe && fe.target && (I.slideEl = fe.target.closest(`.${e.params.slideClass}, swiper-slide`)), I.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? I.slideEl = Np(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : I.slideEl = e.slides[e.activeIndex]);
      let ot = I.slideEl.querySelector(`.${Se.containerClass}`);
      ot && (ot = ot.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = ot, ot ? I.imageWrapEl = Gx(I.imageEl, `.${Se.containerClass}`)[0] : I.imageWrapEl = void 0;
    }
    if (!I.imageEl || !I.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), I.slideEl.classList.add(`${Se.zoomedSlideClass}`);
    let be, Le, Be, Xe, ge, qe, Ae, Mt, Ft, un, gt, Pt, St, Dt, Kt, hn, Lt, Et;
    typeof L.touchesStart.x > "u" && fe ? (be = fe.pageX, Le = fe.pageY) : (be = L.touchesStart.x, Le = L.touchesStart.y);
    const Vt = h,
      Xt = typeof fe == "number" ? fe : null;
    h === 1 && Xt && (be = void 0, Le = void 0, L.touchesStart.x = void 0, L.touchesStart.y = void 0);
    const vn = F();
    _e.scale = Xt || vn, h = Xt || vn, fe && !(h === 1 && Xt) ? (Lt = I.slideEl.offsetWidth, Et = I.slideEl.offsetHeight, Be = z2(I.slideEl).left + p.scrollX, Xe = z2(I.slideEl).top + p.scrollY, ge = Be + Lt / 2 - be, qe = Xe + Et / 2 - Le, Ft = I.imageEl.offsetWidth || I.imageEl.clientWidth, un = I.imageEl.offsetHeight || I.imageEl.clientHeight, gt = Ft * _e.scale, Pt = un * _e.scale, St = Math.min(Lt / 2 - gt / 2, 0), Dt = Math.min(Et / 2 - Pt / 2, 0), Kt = -St, hn = -Dt, Vt > 0 && Xt && typeof L.currentX == "number" && typeof L.currentY == "number" ? (Ae = L.currentX * _e.scale / Vt, Mt = L.currentY * _e.scale / Vt) : (Ae = ge * _e.scale, Mt = qe * _e.scale), Ae < St && (Ae = St), Ae > Kt && (Ae = Kt), Mt < Dt && (Mt = Dt), Mt > hn && (Mt = hn)) : (Ae = 0, Mt = 0), Xt && _e.scale === 1 && (I.originX = 0, I.originY = 0), L.currentX = Ae, L.currentY = Mt, I.imageWrapEl.style.transitionDuration = "300ms", I.imageWrapEl.style.transform = `translate3d(${Ae}px, ${Mt}px,0)`, I.imageEl.style.transitionDuration = "300ms", I.imageEl.style.transform = `translate3d(0,0,0) scale(${_e.scale})`;
  }
  function H() {
    const fe = e.zoom,
      _e = e.params.zoom;
    if (!I.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? I.slideEl = Np(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : I.slideEl = e.slides[e.activeIndex];
      let Se = I.slideEl.querySelector(`.${_e.containerClass}`);
      Se && (Se = Se.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), I.imageEl = Se, Se ? I.imageWrapEl = Gx(I.imageEl, `.${_e.containerClass}`)[0] : I.imageWrapEl = void 0;
    }
    !I.imageEl || !I.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), fe.scale = 1, h = 1, L.currentX = void 0, L.currentY = void 0, L.touchesStart.x = void 0, L.touchesStart.y = void 0, I.imageWrapEl.style.transitionDuration = "300ms", I.imageWrapEl.style.transform = "translate3d(0,0,0)", I.imageEl.style.transitionDuration = "300ms", I.imageEl.style.transform = "translate3d(0,0,0) scale(1)", I.slideEl.classList.remove(`${_e.zoomedSlideClass}`), I.slideEl = void 0, I.originX = 0, I.originY = 0, e.params.zoom.panOnMouseMove && (x = {
      x: 0,
      y: 0
    }, w && (w = !1, L.startX = 0, L.startY = 0)));
  }
  function se(fe) {
    const _e = e.zoom;
    _e.scale && _e.scale !== 1 ? H() : de(fe);
  }
  function ue() {
    const fe = e.params.passiveListeners ? {
        passive: !0,
        capture: !1
      } : !1,
      _e = e.params.passiveListeners ? {
        passive: !1,
        capture: !0
      } : !0;
    return {
      passiveListener: fe,
      activeListenerWithCapture: _e
    };
  }
  function Ee() {
    const fe = e.zoom;
    if (fe.enabled) return;
    fe.enabled = !0;
    const {
      passiveListener: _e,
      activeListenerWithCapture: Se
    } = ue();
    e.wrapperEl.addEventListener("pointerdown", Q, _e), e.wrapperEl.addEventListener("pointermove", te, Se), ["pointerup", "pointercancel", "pointerout"].forEach(be => {
      e.wrapperEl.addEventListener(be, ie, _e);
    }), e.wrapperEl.addEventListener("pointermove", le, Se);
  }
  function Ce() {
    const fe = e.zoom;
    if (!fe.enabled) return;
    fe.enabled = !1;
    const {
      passiveListener: _e,
      activeListenerWithCapture: Se
    } = ue();
    e.wrapperEl.removeEventListener("pointerdown", Q, _e), e.wrapperEl.removeEventListener("pointermove", te, Se), ["pointerup", "pointercancel", "pointerout"].forEach(be => {
      e.wrapperEl.removeEventListener(be, ie, _e);
    }), e.wrapperEl.removeEventListener("pointermove", le, Se);
  }
  s("init", () => {
    e.params.zoom.enabled && Ee();
  }), s("destroy", () => {
    Ce();
  }), s("touchStart", (fe, _e) => {
    e.zoom.enabled && ne(_e);
  }), s("touchEnd", (fe, _e) => {
    e.zoom.enabled && ce();
  }), s("doubleTap", (fe, _e) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && se(_e);
  }), s("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && W();
  }), s("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && W();
  }), Object.assign(e.zoom, {
    enable: Ee,
    disable: Ce,
    in: de,
    out: H,
    toggle: se
  });
}
function X4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s
  } = t;
  i({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function c(x, E) {
    const C = /* @__PURE__ */function () {
      let L, P, N;
      return (O, F) => {
        for (P = -1, L = O.length; L - P > 1;) N = L + P >> 1, O[N] <= F ? P = N : L = N;
        return L;
      };
    }();
    this.x = x, this.y = E, this.lastIndex = x.length - 1;
    let k, D;
    return this.interpolate = function (L) {
      return L ? (D = C(this.x, L), k = D - 1, (L - this.x[k]) * (this.y[D] - this.y[k]) / (this.x[D] - this.x[k]) + this.y[k]) : 0;
    }, this;
  }
  function p(x) {
    e.controller.spline = e.params.loop ? new c(e.slidesGrid, x.slidesGrid) : new c(e.snapGrid, x.snapGrid);
  }
  function h(x, E) {
    const C = e.controller.control;
    let k, D;
    const I = e.constructor;
    function L(P) {
      if (P.destroyed) return;
      const N = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (p(P), D = -e.controller.spline.interpolate(-N)), (!D || e.params.controller.by === "container") && (k = (P.maxTranslate() - P.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(k) || !Number.isFinite(k)) && (k = 1), D = (N - e.minTranslate()) * k + P.minTranslate()), e.params.controller.inverse && (D = P.maxTranslate() - D), P.updateProgress(D), P.setTranslate(D, e), P.updateActiveIndex(), P.updateSlidesClasses();
    }
    if (Array.isArray(C)) for (let P = 0; P < C.length; P += 1) C[P] !== E && C[P] instanceof I && L(C[P]);else C instanceof I && E !== C && L(C);
  }
  function y(x, E) {
    const C = e.constructor,
      k = e.controller.control;
    let D;
    function I(L) {
      L.destroyed || (L.setTransition(x, e), x !== 0 && (L.transitionStart(), L.params.autoHeight && kN(() => {
        L.updateAutoHeight();
      }), Yee(L.wrapperEl, () => {
        k && L.transitionEnd();
      })));
    }
    if (Array.isArray(k)) for (D = 0; D < k.length; D += 1) k[D] !== E && k[D] instanceof C && I(k[D]);else k instanceof C && E !== k && I(k);
  }
  function w() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  s("beforeInit", () => {
    if (typeof window < "u" && (
    // eslint-disable-line
    typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach(E => {
        if (e.controller.control || (e.controller.control = []), E && E.swiper) e.controller.control.push(E.swiper);else if (E) {
          const C = `${e.params.eventsPrefix}init`,
            k = D => {
              e.controller.control.push(D.detail[0]), e.update(), E.removeEventListener(C, k);
            };
          E.addEventListener(C, k);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), s("update", () => {
    w();
  }), s("resize", () => {
    w();
  }), s("observerUpdate", () => {
    w();
  }), s("setTranslate", (x, E, C) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(E, C);
  }), s("setTransition", (x, E, C) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(E, C);
  }), Object.assign(e.controller, {
    setTranslate: h,
    setTransition: y
  });
}
function K4(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s
  } = t;
  i({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let c = null,
    p,
    h,
    y = (/* @__PURE__ */new Date()).getTime();
  function w(W) {
    const $ = c;
    $.length !== 0 && hR($, W);
  }
  function x(W) {
    const $ = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(W).replace(/x/g, $);
  }
  function E(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("tabIndex", "0");
    });
  }
  function C(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("tabIndex", "-1");
    });
  }
  function k(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("role", $);
    });
  }
  function D(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("aria-roledescription", $);
    });
  }
  function I(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("aria-controls", $);
    });
  }
  function L(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("aria-label", $);
    });
  }
  function P(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("id", $);
    });
  }
  function N(W, $) {
    W = aa(W), W.forEach(de => {
      de.setAttribute("aria-live", $);
    });
  }
  function O(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("aria-disabled", !0);
    });
  }
  function F(W) {
    W = aa(W), W.forEach($ => {
      $.setAttribute("aria-disabled", !1);
    });
  }
  function j(W) {
    if (W.keyCode !== 13 && W.keyCode !== 32) return;
    const $ = e.params.a11y,
      de = W.target;
    if (!(e.pagination && e.pagination.el && (de === e.pagination.el || e.pagination.el.contains(W.target)) && !W.target.matches(Q0(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const H = aa(e.navigation.prevEl);
        aa(e.navigation.nextEl).includes(de) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? w($.lastSlideMessage) : w($.nextSlideMessage)), H.includes(de) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? w($.firstSlideMessage) : w($.prevSlideMessage));
      }
      e.pagination && de.matches(Q0(e.params.pagination.bulletClass)) && de.click();
    }
  }
  function V() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: W,
      prevEl: $
    } = e.navigation;
    $ && (e.isBeginning ? (O($), C($)) : (F($), E($))), W && (e.isEnd ? (O(W), C(W)) : (F(W), E(W)));
  }
  function K() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function G() {
    return K() && e.params.pagination.clickable;
  }
  function Q() {
    const W = e.params.a11y;
    K() && e.pagination.bullets.forEach($ => {
      e.params.pagination.clickable && (E($), e.params.pagination.renderBullet || (k($, "button"), L($, W.paginationBulletMessage.replace(/\{\{index\}\}/, pR($) + 1)))), $.matches(Q0(e.params.pagination.bulletActiveClass)) ? $.setAttribute("aria-current", "true") : $.removeAttribute("aria-current");
    });
  }
  const te = (W, $, de) => {
      E(W), W.tagName !== "BUTTON" && (k(W, "button"), W.addEventListener("keydown", j)), L(W, de), I(W, $);
    },
    ie = W => {
      h && h !== W.target && !h.contains(W.target) && (p = !0), e.a11y.clicked = !0;
    },
    Y = () => {
      p = !1, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          e.destroyed || (e.a11y.clicked = !1);
        });
      });
    },
    ee = W => {
      y = (/* @__PURE__ */new Date()).getTime();
    },
    ae = W => {
      if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */new Date()).getTime() - y < 100) return;
      const $ = W.target.closest(`.${e.params.slideClass}, swiper-slide`);
      if (!$ || !e.slides.includes($)) return;
      h = $;
      const de = e.slides.indexOf($) === e.activeIndex,
        H = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes($);
      de || H || W.sourceCapabilities && W.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
        p || (e.params.loop ? e.slideToLoop(e.getSlideIndexWhenGrid(parseInt($.getAttribute("data-swiper-slide-index"))), 0) : e.slideTo(e.getSlideIndexWhenGrid(e.slides.indexOf($)), 0), p = !1);
      }));
    },
    ne = () => {
      const W = e.params.a11y;
      W.itemRoleDescriptionMessage && D(e.slides, W.itemRoleDescriptionMessage), W.slideRole && k(e.slides, W.slideRole);
      const $ = e.slides.length;
      W.slideLabelMessage && e.slides.forEach((de, H) => {
        const se = e.params.loop ? parseInt(de.getAttribute("data-swiper-slide-index"), 10) : H,
          ue = W.slideLabelMessage.replace(/\{\{index\}\}/, se + 1).replace(/\{\{slidesLength\}\}/, $);
        L(de, ue);
      });
    },
    le = () => {
      const W = e.params.a11y;
      e.el.append(c);
      const $ = e.el;
      W.containerRoleDescriptionMessage && D($, W.containerRoleDescriptionMessage), W.containerMessage && L($, W.containerMessage), W.containerRole && k($, W.containerRole);
      const de = e.wrapperEl,
        H = W.id || de.getAttribute("id") || `swiper-wrapper-${x(16)}`,
        se = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
      P(de, H), N(de, se), ne();
      let {
        nextEl: ue,
        prevEl: Ee
      } = e.navigation ? e.navigation : {};
      ue = aa(ue), Ee = aa(Ee), ue && ue.forEach(fe => te(fe, H, W.nextSlideMessage)), Ee && Ee.forEach(fe => te(fe, H, W.prevSlideMessage)), G() && aa(e.pagination.el).forEach(_e => {
        _e.addEventListener("keydown", j);
      }), Gm().addEventListener("visibilitychange", ee), e.el.addEventListener("focus", ae, !0), e.el.addEventListener("focus", ae, !0), e.el.addEventListener("pointerdown", ie, !0), e.el.addEventListener("pointerup", Y, !0);
    };
  function ce() {
    c && c.remove();
    let {
      nextEl: W,
      prevEl: $
    } = e.navigation ? e.navigation : {};
    W = aa(W), $ = aa($), W && W.forEach(H => H.removeEventListener("keydown", j)), $ && $.forEach(H => H.removeEventListener("keydown", j)), G() && aa(e.pagination.el).forEach(se => {
      se.removeEventListener("keydown", j);
    }), Gm().removeEventListener("visibilitychange", ee), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", ae, !0), e.el.removeEventListener("pointerdown", ie, !0), e.el.removeEventListener("pointerup", Y, !0));
  }
  s("beforeInit", () => {
    c = fR("span", e.params.a11y.notificationClass), c.setAttribute("aria-live", "assertive"), c.setAttribute("aria-atomic", "true");
  }), s("afterInit", () => {
    e.params.a11y.enabled && le();
  }), s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && ne();
  }), s("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && V();
  }), s("paginationUpdate", () => {
    e.params.a11y.enabled && Q();
  }), s("destroy", () => {
    e.params.a11y.enabled && ce();
  });
}
let Cj;
function Xee() {
  const t = ws(),
    e = Gm();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Q4() {
  return Cj || (Cj = Xee()), Cj;
}
let kj;
function Kee(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const i = Q4(),
    s = ws(),
    c = s.navigator.platform,
    p = e || s.navigator.userAgent,
    h = {
      ios: !1,
      android: !1
    },
    y = s.screen.width,
    w = s.screen.height,
    x = p.match(/(Android);?[\s\/]+([\d.]+)?/);
  let E = p.match(/(iPad).*OS\s([\d_]+)/);
  const C = p.match(/(iPod)(.*OS\s([\d_]+))?/),
    k = !E && p.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    D = c === "Win32";
  let I = c === "MacIntel";
  const L = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !E && I && i.touch && L.indexOf(`${y}x${w}`) >= 0 && (E = p.match(/(Version)\/([\d.]+)/), E || (E = [0, 1, "13_0_0"]), I = !1), x && !D && (h.os = "android", h.android = !0), (E || k || C) && (h.os = "ios", h.ios = !0), h;
}
function Z4(t) {
  return t === void 0 && (t = {}), kj || (kj = Kee(t)), kj;
}
let Tj;
function Qee() {
  const t = ws(),
    e = Z4();
  let i = !1;
  function s() {
    const y = t.navigator.userAgent.toLowerCase();
    return y.indexOf("safari") >= 0 && y.indexOf("chrome") < 0 && y.indexOf("android") < 0;
  }
  if (s()) {
    const y = String(t.navigator.userAgent);
    if (y.includes("Version/")) {
      const [w, x] = y.split("Version/")[1].split(" ")[0].split(".").map(E => Number(E));
      i = w < 16 || w === 16 && x < 2;
    }
  }
  const c = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
    p = s(),
    h = p || c && e.ios;
  return {
    isSafari: i || p,
    needPerspectiveFix: i,
    need3dFix: h,
    isWebView: c
  };
}
function J4() {
  return Tj || (Tj = Qee()), Tj;
}
function Zee(t) {
  let {
    swiper: e,
    on: i,
    emit: s
  } = t;
  const c = ws();
  let p = null,
    h = null;
  const y = () => {
      !e || e.destroyed || !e.initialized || (s("beforeResize"), s("resize"));
    },
    w = () => {
      !e || e.destroyed || !e.initialized || (p = new ResizeObserver(C => {
        h = c.requestAnimationFrame(() => {
          const {
            width: k,
            height: D
          } = e;
          let I = k,
            L = D;
          C.forEach(P => {
            let {
              contentBoxSize: N,
              contentRect: O,
              target: F
            } = P;
            F && F !== e.el || (I = O ? O.width : (N[0] || N).inlineSize, L = O ? O.height : (N[0] || N).blockSize);
          }), (I !== k || L !== D) && y();
        });
      }), p.observe(e.el));
    },
    x = () => {
      h && c.cancelAnimationFrame(h), p && p.unobserve && e.el && (p.unobserve(e.el), p = null);
    },
    E = () => {
      !e || e.destroyed || !e.initialized || s("orientationchange");
    };
  i("init", () => {
    if (e.params.resizeObserver && typeof c.ResizeObserver < "u") {
      w();
      return;
    }
    c.addEventListener("resize", y), c.addEventListener("orientationchange", E);
  }), i("destroy", () => {
    x(), c.removeEventListener("resize", y), c.removeEventListener("orientationchange", E);
  });
}
function Jee(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s,
    emit: c
  } = t;
  const p = [],
    h = ws(),
    y = function (E, C) {
      C === void 0 && (C = {});
      const k = h.MutationObserver || h.WebkitMutationObserver,
        D = new k(I => {
          if (e.__preventObserver__) return;
          if (I.length === 1) {
            c("observerUpdate", I[0]);
            return;
          }
          const L = function () {
            c("observerUpdate", I[0]);
          };
          h.requestAnimationFrame ? h.requestAnimationFrame(L) : h.setTimeout(L, 0);
        });
      D.observe(E, {
        attributes: typeof C.attributes > "u" ? !0 : C.attributes,
        childList: e.isElement || (typeof C.childList > "u" ? !0 : C).childList,
        characterData: typeof C.characterData > "u" ? !0 : C.characterData
      }), p.push(D);
    },
    w = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const E = Gx(e.hostEl);
          for (let C = 0; C < E.length; C += 1) y(E[C]);
        }
        y(e.hostEl, {
          childList: e.params.observeSlideChildren
        }), y(e.wrapperEl, {
          attributes: !1
        });
      }
    },
    x = () => {
      p.forEach(E => {
        E.disconnect();
      }), p.splice(0, p.length);
    };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", w), s("destroy", x);
}
var ete = {
  on(t, e, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    const c = i ? "unshift" : "push";
    return t.split(" ").forEach(p => {
      s.eventsListeners[p] || (s.eventsListeners[p] = []), s.eventsListeners[p][c](e);
    }), s;
  },
  once(t, e, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    function c() {
      s.off(t, c), c.__emitterProxy && delete c.__emitterProxy;
      for (var p = arguments.length, h = new Array(p), y = 0; y < p; y++) h[y] = arguments[y];
      e.apply(s, h);
    }
    return c.__emitterProxy = e, s.on(t, c, i);
  },
  onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const s = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[s](t), i;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  },
  off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach(s => {
      typeof e > "u" ? i.eventsListeners[s] = [] : i.eventsListeners[s] && i.eventsListeners[s].forEach((c, p) => {
        (c === e || c.__emitterProxy && c.__emitterProxy === e) && i.eventsListeners[s].splice(p, 1);
      });
    }), i;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, i, s;
    for (var c = arguments.length, p = new Array(c), h = 0; h < c; h++) p[h] = arguments[h];
    return typeof p[0] == "string" || Array.isArray(p[0]) ? (e = p[0], i = p.slice(1, p.length), s = t) : (e = p[0].events, i = p[0].data, s = p[0].context || t), i.unshift(s), (Array.isArray(e) ? e : e.split(" ")).forEach(w => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach(x => {
        x.apply(s, [w, ...i]);
      }), t.eventsListeners && t.eventsListeners[w] && t.eventsListeners[w].forEach(x => {
        x.apply(s, i);
      });
    }), t;
  }
};
function tte() {
  const t = this;
  let e, i;
  const s = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = s.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? i = t.params.height : i = s.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(J0(s, "padding-left") || 0, 10) - parseInt(J0(s, "padding-right") || 0, 10), i = i - parseInt(J0(s, "padding-top") || 0, 10) - parseInt(J0(s, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
    width: e,
    height: i,
    size: t.isHorizontal() ? e : i
  }));
}
function nte() {
  const t = this;
  function e(ie, Y) {
    return parseFloat(ie.getPropertyValue(t.getDirectionLabel(Y)) || 0);
  }
  const i = t.params,
    {
      wrapperEl: s,
      slidesEl: c,
      size: p,
      rtlTranslate: h,
      wrongRTL: y
    } = t,
    w = t.virtual && i.virtual.enabled,
    x = w ? t.virtual.slides.length : t.slides.length,
    E = Np(c, `.${t.params.slideClass}, swiper-slide`),
    C = w ? t.virtual.slides.length : E.length;
  let k = [];
  const D = [],
    I = [];
  let L = i.slidesOffsetBefore;
  typeof L == "function" && (L = i.slidesOffsetBefore.call(t));
  let P = i.slidesOffsetAfter;
  typeof P == "function" && (P = i.slidesOffsetAfter.call(t));
  const N = t.snapGrid.length,
    O = t.slidesGrid.length;
  let F = i.spaceBetween,
    j = -L,
    V = 0,
    K = 0;
  if (typeof p > "u") return;
  typeof F == "string" && F.indexOf("%") >= 0 ? F = parseFloat(F.replace("%", "")) / 100 * p : typeof F == "string" && (F = parseFloat(F)), t.virtualSize = -F, E.forEach(ie => {
    h ? ie.style.marginLeft = "" : ie.style.marginRight = "", ie.style.marginBottom = "", ie.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (mM(s, "--swiper-centered-offset-before", ""), mM(s, "--swiper-centered-offset-after", ""));
  const G = i.grid && i.grid.rows > 1 && t.grid;
  G ? t.grid.initSlides(E) : t.grid && t.grid.unsetSlides();
  let Q;
  const te = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter(ie => typeof i.breakpoints[ie].slidesPerView < "u").length > 0;
  for (let ie = 0; ie < C; ie += 1) {
    Q = 0;
    let Y;
    if (E[ie] && (Y = E[ie]), G && t.grid.updateSlide(ie, Y, E), !(E[ie] && J0(Y, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        te && (E[ie].style[t.getDirectionLabel("width")] = "");
        const ee = getComputedStyle(Y),
          ae = Y.style.transform,
          ne = Y.style.webkitTransform;
        if (ae && (Y.style.transform = "none"), ne && (Y.style.webkitTransform = "none"), i.roundLengths) Q = t.isHorizontal() ? V2(Y, "width") : V2(Y, "height");else {
          const le = e(ee, "width"),
            ce = e(ee, "padding-left"),
            W = e(ee, "padding-right"),
            $ = e(ee, "margin-left"),
            de = e(ee, "margin-right"),
            H = ee.getPropertyValue("box-sizing");
          if (H && H === "border-box") Q = le + $ + de;else {
            const {
              clientWidth: se,
              offsetWidth: ue
            } = Y;
            Q = le + ce + W + $ + de + (ue - se);
          }
        }
        ae && (Y.style.transform = ae), ne && (Y.style.webkitTransform = ne), i.roundLengths && (Q = Math.floor(Q));
      } else Q = (p - (i.slidesPerView - 1) * F) / i.slidesPerView, i.roundLengths && (Q = Math.floor(Q)), E[ie] && (E[ie].style[t.getDirectionLabel("width")] = `${Q}px`);
      E[ie] && (E[ie].swiperSlideSize = Q), I.push(Q), i.centeredSlides ? (j = j + Q / 2 + V / 2 + F, V === 0 && ie !== 0 && (j = j - p / 2 - F), ie === 0 && (j = j - p / 2 - F), Math.abs(j) < 1 / 1e3 && (j = 0), i.roundLengths && (j = Math.floor(j)), K % i.slidesPerGroup === 0 && k.push(j), D.push(j)) : (i.roundLengths && (j = Math.floor(j)), (K - Math.min(t.params.slidesPerGroupSkip, K)) % t.params.slidesPerGroup === 0 && k.push(j), D.push(j), j = j + Q + F), t.virtualSize += Q + F, V = Q, K += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, p) + P, h && y && (i.effect === "slide" || i.effect === "coverflow") && (s.style.width = `${t.virtualSize + F}px`), i.setWrapperSize && (s.style[t.getDirectionLabel("width")] = `${t.virtualSize + F}px`), G && t.grid.updateWrapperSize(Q, k), !i.centeredSlides) {
    const ie = [];
    for (let Y = 0; Y < k.length; Y += 1) {
      let ee = k[Y];
      i.roundLengths && (ee = Math.floor(ee)), k[Y] <= t.virtualSize - p && ie.push(ee);
    }
    k = ie, Math.floor(t.virtualSize - p) - Math.floor(k[k.length - 1]) > 1 && k.push(t.virtualSize - p);
  }
  if (w && i.loop) {
    const ie = I[0] + F;
    if (i.slidesPerGroup > 1) {
      const Y = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup),
        ee = ie * i.slidesPerGroup;
      for (let ae = 0; ae < Y; ae += 1) k.push(k[k.length - 1] + ee);
    }
    for (let Y = 0; Y < t.virtual.slidesBefore + t.virtual.slidesAfter; Y += 1) i.slidesPerGroup === 1 && k.push(k[k.length - 1] + ie), D.push(D[D.length - 1] + ie), t.virtualSize += ie;
  }
  if (k.length === 0 && (k = [0]), F !== 0) {
    const ie = t.isHorizontal() && h ? "marginLeft" : t.getDirectionLabel("marginRight");
    E.filter((Y, ee) => !i.cssMode || i.loop ? !0 : ee !== E.length - 1).forEach(Y => {
      Y.style[ie] = `${F}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let ie = 0;
    I.forEach(ee => {
      ie += ee + (F || 0);
    }), ie -= F;
    const Y = ie > p ? ie - p : 0;
    k = k.map(ee => ee <= 0 ? -L : ee > Y ? Y + P : ee);
  }
  if (i.centerInsufficientSlides) {
    let ie = 0;
    I.forEach(ee => {
      ie += ee + (F || 0);
    }), ie -= F;
    const Y = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (ie + Y < p) {
      const ee = (p - ie - Y) / 2;
      k.forEach((ae, ne) => {
        k[ne] = ae - ee;
      }), D.forEach((ae, ne) => {
        D[ne] = ae + ee;
      });
    }
  }
  if (Object.assign(t, {
    slides: E,
    snapGrid: k,
    slidesGrid: D,
    slidesSizesGrid: I
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    mM(s, "--swiper-centered-offset-before", `${-k[0]}px`), mM(s, "--swiper-centered-offset-after", `${t.size / 2 - I[I.length - 1] / 2}px`);
    const ie = -t.snapGrid[0],
      Y = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map(ee => ee + ie), t.slidesGrid = t.slidesGrid.map(ee => ee + Y);
  }
  if (C !== x && t.emit("slidesLengthChange"), k.length !== N && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), D.length !== O && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !w && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const ie = `${i.containerModifierClass}backface-hidden`,
      Y = t.el.classList.contains(ie);
    C <= i.maxBackfaceHiddenSlides ? Y || t.el.classList.add(ie) : Y && t.el.classList.remove(ie);
  }
}
function rte(t) {
  const e = this,
    i = [],
    s = e.virtual && e.params.virtual.enabled;
  let c = 0,
    p;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const h = y => s ? e.slides[e.getSlideIndexByData(y)] : e.slides[y];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1) {
    if (e.params.centeredSlides) (e.visibleSlides || []).forEach(y => {
      i.push(y);
    });else for (p = 0; p < Math.ceil(e.params.slidesPerView); p += 1) {
      const y = e.activeIndex + p;
      if (y > e.slides.length && !s) break;
      i.push(h(y));
    }
  } else i.push(h(e.activeIndex));
  for (p = 0; p < i.length; p += 1) if (typeof i[p] < "u") {
    const y = i[p].offsetHeight;
    c = y > c ? y : c;
  }
  (c || c === 0) && (e.wrapperEl.style.height = `${c}px`);
}
function ite() {
  const t = this,
    e = t.slides,
    i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let s = 0; s < e.length; s += 1) e[s].swiperSlideOffset = (t.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) - i - t.cssOverflowAdjustment();
}
const vB = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function ate(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this,
    i = e.params,
    {
      slides: s,
      rtlTranslate: c,
      snapGrid: p
    } = e;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let h = -t;
  c && (h = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let y = i.spaceBetween;
  typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * e.size : typeof y == "string" && (y = parseFloat(y));
  for (let w = 0; w < s.length; w += 1) {
    const x = s[w];
    let E = x.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (E -= s[0].swiperSlideOffset);
    const C = (h + (i.centeredSlides ? e.minTranslate() : 0) - E) / (x.swiperSlideSize + y),
      k = (h - p[0] + (i.centeredSlides ? e.minTranslate() : 0) - E) / (x.swiperSlideSize + y),
      D = -(h - E),
      I = D + e.slidesSizesGrid[w],
      L = D >= 0 && D <= e.size - e.slidesSizesGrid[w],
      P = D >= 0 && D < e.size - 1 || I > 1 && I <= e.size || D <= 0 && I >= e.size;
    P && (e.visibleSlides.push(x), e.visibleSlidesIndexes.push(w)), vB(x, P, i.slideVisibleClass), vB(x, L, i.slideFullyVisibleClass), x.progress = c ? -C : C, x.originalProgress = c ? -k : k;
  }
}
function ote(t) {
  const e = this;
  if (typeof t > "u") {
    const E = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * E || 0;
  }
  const i = e.params,
    s = e.maxTranslate() - e.minTranslate();
  let {
    progress: c,
    isBeginning: p,
    isEnd: h,
    progressLoop: y
  } = e;
  const w = p,
    x = h;
  if (s === 0) c = 0, p = !0, h = !0;else {
    c = (t - e.minTranslate()) / s;
    const E = Math.abs(t - e.minTranslate()) < 1,
      C = Math.abs(t - e.maxTranslate()) < 1;
    p = E || c <= 0, h = C || c >= 1, E && (c = 0), C && (c = 1);
  }
  if (i.loop) {
    const E = e.getSlideIndexByData(0),
      C = e.getSlideIndexByData(e.slides.length - 1),
      k = e.slidesGrid[E],
      D = e.slidesGrid[C],
      I = e.slidesGrid[e.slidesGrid.length - 1],
      L = Math.abs(t);
    L >= k ? y = (L - k) / I : y = (L + I - D) / I, y > 1 && (y -= 1);
  }
  Object.assign(e, {
    progress: c,
    progressLoop: y,
    isBeginning: p,
    isEnd: h
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), p && !w && e.emit("reachBeginning toEdge"), h && !x && e.emit("reachEnd toEdge"), (w && !p || x && !h) && e.emit("fromEdge"), e.emit("progress", c);
}
const Rj = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function lte() {
  const t = this,
    {
      slides: e,
      params: i,
      slidesEl: s,
      activeIndex: c
    } = t,
    p = t.virtual && i.virtual.enabled,
    h = t.grid && i.grid && i.grid.rows > 1,
    y = C => Np(s, `.${i.slideClass}${C}, swiper-slide${C}`)[0];
  let w, x, E;
  if (p) {
    if (i.loop) {
      let C = c - t.virtual.slidesBefore;
      C < 0 && (C = t.virtual.slides.length + C), C >= t.virtual.slides.length && (C -= t.virtual.slides.length), w = y(`[data-swiper-slide-index="${C}"]`);
    } else w = y(`[data-swiper-slide-index="${c}"]`);
  } else h ? (w = e.find(C => C.column === c), E = e.find(C => C.column === c + 1), x = e.find(C => C.column === c - 1)) : w = e[c];
  w && (h || (E = qee(w, `.${i.slideClass}, swiper-slide`)[0], i.loop && !E && (E = e[0]), x = Wee(w, `.${i.slideClass}, swiper-slide`)[0], i.loop && !x === 0 && (x = e[e.length - 1]))), e.forEach(C => {
    Rj(C, C === w, i.slideActiveClass), Rj(C, C === E, i.slideNextClass), Rj(C, C === x, i.slidePrevClass);
  }), t.emitSlidesClasses();
}
const HM = (t, e) => {
    if (!t || t.destroyed || !t.params) return;
    const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`,
      s = e.closest(i());
    if (s) {
      let c = s.querySelector(`.${t.params.lazyPreloaderClass}`);
      !c && t.isElement && (s.shadowRoot ? c = s.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        s.shadowRoot && (c = s.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), c && c.remove());
      })), c && c.remove();
    }
  },
  Dj = (t, e) => {
    if (!t.slides[e]) return;
    const i = t.slides[e].querySelector('[loading="lazy"]');
    i && i.removeAttribute("loading");
  },
  B2 = t => {
    if (!t || t.destroyed || !t.params) return;
    let e = t.params.lazyPreloadPrevNext;
    const i = t.slides.length;
    if (!i || !e || e < 0) return;
    e = Math.min(e, i);
    const s = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView),
      c = t.activeIndex;
    if (t.params.grid && t.params.grid.rows > 1) {
      const h = c,
        y = [h - e];
      y.push(...Array.from({
        length: e
      }).map((w, x) => h + s + x)), t.slides.forEach((w, x) => {
        y.includes(w.column) && Dj(t, x);
      });
      return;
    }
    const p = c + s - 1;
    if (t.params.rewind || t.params.loop) for (let h = c - e; h <= p + e; h += 1) {
      const y = (h % i + i) % i;
      (y < c || y > p) && Dj(t, y);
    } else for (let h = Math.max(c - e, 0); h <= Math.min(p + e, i - 1); h += 1) h !== c && (h > p || h < c) && Dj(t, h);
  };
function ste(t) {
  const {
      slidesGrid: e,
      params: i
    } = t,
    s = t.rtlTranslate ? t.translate : -t.translate;
  let c;
  for (let p = 0; p < e.length; p += 1) typeof e[p + 1] < "u" ? s >= e[p] && s < e[p + 1] - (e[p + 1] - e[p]) / 2 ? c = p : s >= e[p] && s < e[p + 1] && (c = p + 1) : s >= e[p] && (c = p);
  return i.normalizeSlideIndex && (c < 0 || typeof c > "u") && (c = 0), c;
}
function ute(t) {
  const e = this,
    i = e.rtlTranslate ? e.translate : -e.translate,
    {
      snapGrid: s,
      params: c,
      activeIndex: p,
      realIndex: h,
      snapIndex: y
    } = e;
  let w = t,
    x;
  const E = D => {
    let I = D - e.virtual.slidesBefore;
    return I < 0 && (I = e.virtual.slides.length + I), I >= e.virtual.slides.length && (I -= e.virtual.slides.length), I;
  };
  if (typeof w > "u" && (w = ste(e)), s.indexOf(i) >= 0) x = s.indexOf(i);else {
    const D = Math.min(c.slidesPerGroupSkip, w);
    x = D + Math.floor((w - D) / c.slidesPerGroup);
  }
  if (x >= s.length && (x = s.length - 1), w === p && !e.params.loop) {
    x !== y && (e.snapIndex = x, e.emit("snapIndexChange"));
    return;
  }
  if (w === p && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = E(w);
    return;
  }
  const C = e.grid && c.grid && c.grid.rows > 1;
  let k;
  if (e.virtual && c.virtual.enabled && c.loop) k = E(w);else if (C) {
    const D = e.slides.find(L => L.column === w);
    let I = parseInt(D.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(I) && (I = Math.max(e.slides.indexOf(D), 0)), k = Math.floor(I / c.grid.rows);
  } else if (e.slides[w]) {
    const D = e.slides[w].getAttribute("data-swiper-slide-index");
    D ? k = parseInt(D, 10) : k = w;
  } else k = w;
  Object.assign(e, {
    previousSnapIndex: y,
    snapIndex: x,
    previousRealIndex: h,
    realIndex: k,
    previousIndex: p,
    activeIndex: w
  }), e.initialized && B2(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (h !== k && e.emit("realIndexChange"), e.emit("slideChange"));
}
function cte(t, e) {
  const i = this,
    s = i.params;
  let c = t.closest(`.${s.slideClass}, swiper-slide`);
  !c && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach(y => {
    !c && y.matches && y.matches(`.${s.slideClass}, swiper-slide`) && (c = y);
  });
  let p = !1,
    h;
  if (c) {
    for (let y = 0; y < i.slides.length; y += 1) if (i.slides[y] === c) {
      p = !0, h = y;
      break;
    }
  }
  if (c && p) i.clickedSlide = c, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(c.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = h;else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var dte = {
  updateSize: tte,
  updateSlides: nte,
  updateAutoHeight: rte,
  updateSlidesOffset: ite,
  updateSlidesProgress: ate,
  updateProgress: ote,
  updateSlidesClasses: lte,
  updateActiveIndex: ute,
  updateClickedSlide: cte
};
function fte(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this,
    {
      params: i,
      rtlTranslate: s,
      translate: c,
      wrapperEl: p
    } = e;
  if (i.virtualTranslate) return s ? -c : c;
  if (i.cssMode) return c;
  let h = N2(p, t);
  return h += e.cssOverflowAdjustment(), s && (h = -h), h || 0;
}
function pte(t, e) {
  const i = this,
    {
      rtlTranslate: s,
      params: c,
      wrapperEl: p,
      progress: h
    } = i;
  let y = 0,
    w = 0;
  const x = 0;
  i.isHorizontal() ? y = s ? -t : t : w = t, c.roundLengths && (y = Math.floor(y), w = Math.floor(w)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? y : w, c.cssMode ? p[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -y : -w : c.virtualTranslate || (i.isHorizontal() ? y -= i.cssOverflowAdjustment() : w -= i.cssOverflowAdjustment(), p.style.transform = `translate3d(${y}px, ${w}px, ${x}px)`);
  let E;
  const C = i.maxTranslate() - i.minTranslate();
  C === 0 ? E = 0 : E = (t - i.minTranslate()) / C, E !== h && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
}
function hte() {
  return -this.snapGrid[0];
}
function mte() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function vte(t, e, i, s, c) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), i === void 0 && (i = !0), s === void 0 && (s = !0);
  const p = this,
    {
      params: h,
      wrapperEl: y
    } = p;
  if (p.animating && h.preventInteractionOnTransition) return !1;
  const w = p.minTranslate(),
    x = p.maxTranslate();
  let E;
  if (s && t > w ? E = w : s && t < x ? E = x : E = t, p.updateProgress(E), h.cssMode) {
    const C = p.isHorizontal();
    if (e === 0) y[C ? "scrollLeft" : "scrollTop"] = -E;else {
      if (!p.support.smoothScroll) return W4({
        swiper: p,
        targetPosition: -E,
        side: C ? "left" : "top"
      }), !0;
      y.scrollTo({
        [C ? "left" : "top"]: -E,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (p.setTransition(0), p.setTranslate(E), i && (p.emit("beforeTransitionStart", e, c), p.emit("transitionEnd"))) : (p.setTransition(e), p.setTranslate(E), i && (p.emit("beforeTransitionStart", e, c), p.emit("transitionStart")), p.animating || (p.animating = !0, p.onTranslateToWrapperTransitionEnd || (p.onTranslateToWrapperTransitionEnd = function (k) {
    !p || p.destroyed || k.target === this && (p.wrapperEl.removeEventListener("transitionend", p.onTranslateToWrapperTransitionEnd), p.onTranslateToWrapperTransitionEnd = null, delete p.onTranslateToWrapperTransitionEnd, p.animating = !1, i && p.emit("transitionEnd"));
  }), p.wrapperEl.addEventListener("transitionend", p.onTranslateToWrapperTransitionEnd))), !0;
}
var gte = {
  getTranslate: fte,
  setTranslate: pte,
  minTranslate: hte,
  maxTranslate: mte,
  translateTo: vte
};
function yte(t, e) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
}
function e$(t) {
  let {
    swiper: e,
    runCallbacks: i,
    direction: s,
    step: c
  } = t;
  const {
    activeIndex: p,
    previousIndex: h
  } = e;
  let y = s;
  y || (p > h ? y = "next" : p < h ? y = "prev" : y = "reset"), e.emit(`transition${c}`), i && y === "reset" ? e.emit(`slideResetTransition${c}`) : i && p !== h && (e.emit(`slideChangeTransition${c}`), y === "next" ? e.emit(`slideNextTransition${c}`) : e.emit(`slidePrevTransition${c}`));
}
function bte(t, e) {
  t === void 0 && (t = !0);
  const i = this,
    {
      params: s
    } = i;
  s.cssMode || (s.autoHeight && i.updateAutoHeight(), e$({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function wte(t, e) {
  t === void 0 && (t = !0);
  const i = this,
    {
      params: s
    } = i;
  i.animating = !1, !s.cssMode && (i.setTransition(0), e$({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var _te = {
  setTransition: yte,
  transitionStart: bte,
  transitionEnd: wte
};
function xte(t, e, i, s, c) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const p = this;
  let h = t;
  h < 0 && (h = 0);
  const {
    params: y,
    snapGrid: w,
    slidesGrid: x,
    previousIndex: E,
    activeIndex: C,
    rtlTranslate: k,
    wrapperEl: D,
    enabled: I
  } = p;
  if (!I && !s && !c || p.destroyed || p.animating && y.preventInteractionOnTransition) return !1;
  typeof e > "u" && (e = p.params.speed);
  const L = Math.min(p.params.slidesPerGroupSkip, h);
  let P = L + Math.floor((h - L) / p.params.slidesPerGroup);
  P >= w.length && (P = w.length - 1);
  const N = -w[P];
  if (y.normalizeSlideIndex) for (let G = 0; G < x.length; G += 1) {
    const Q = -Math.floor(N * 100),
      te = Math.floor(x[G] * 100),
      ie = Math.floor(x[G + 1] * 100);
    typeof x[G + 1] < "u" ? Q >= te && Q < ie - (ie - te) / 2 ? h = G : Q >= te && Q < ie && (h = G + 1) : Q >= te && (h = G);
  }
  if (p.initialized && h !== C && (!p.allowSlideNext && (k ? N > p.translate && N > p.minTranslate() : N < p.translate && N < p.minTranslate()) || !p.allowSlidePrev && N > p.translate && N > p.maxTranslate() && (C || 0) !== h)) return !1;
  h !== (E || 0) && i && p.emit("beforeSlideChangeStart"), p.updateProgress(N);
  let O;
  h > C ? O = "next" : h < C ? O = "prev" : O = "reset";
  const F = p.virtual && p.params.virtual.enabled;
  if (!(F && c) && (k && -N === p.translate || !k && N === p.translate)) return p.updateActiveIndex(h), y.autoHeight && p.updateAutoHeight(), p.updateSlidesClasses(), y.effect !== "slide" && p.setTranslate(N), O !== "reset" && (p.transitionStart(i, O), p.transitionEnd(i, O)), !1;
  if (y.cssMode) {
    const G = p.isHorizontal(),
      Q = k ? N : -N;
    if (e === 0) F && (p.wrapperEl.style.scrollSnapType = "none", p._immediateVirtual = !0), F && !p._cssModeVirtualInitialSet && p.params.initialSlide > 0 ? (p._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
      D[G ? "scrollLeft" : "scrollTop"] = Q;
    })) : D[G ? "scrollLeft" : "scrollTop"] = Q, F && requestAnimationFrame(() => {
      p.wrapperEl.style.scrollSnapType = "", p._immediateVirtual = !1;
    });else {
      if (!p.support.smoothScroll) return W4({
        swiper: p,
        targetPosition: Q,
        side: G ? "left" : "top"
      }), !0;
      D.scrollTo({
        [G ? "left" : "top"]: Q,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const K = J4().isSafari;
  return F && !c && K && p.isElement && p.virtual.update(!1, !1, h), p.setTransition(e), p.setTranslate(N), p.updateActiveIndex(h), p.updateSlidesClasses(), p.emit("beforeTransitionStart", e, s), p.transitionStart(i, O), e === 0 ? p.transitionEnd(i, O) : p.animating || (p.animating = !0, p.onSlideToWrapperTransitionEnd || (p.onSlideToWrapperTransitionEnd = function (Q) {
    !p || p.destroyed || Q.target === this && (p.wrapperEl.removeEventListener("transitionend", p.onSlideToWrapperTransitionEnd), p.onSlideToWrapperTransitionEnd = null, delete p.onSlideToWrapperTransitionEnd, p.transitionEnd(i, O));
  }), p.wrapperEl.addEventListener("transitionend", p.onSlideToWrapperTransitionEnd)), !0;
}
function Ste(t, e, i, s) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const c = this;
  if (c.destroyed) return;
  typeof e > "u" && (e = c.params.speed);
  const p = c.grid && c.params.grid && c.params.grid.rows > 1;
  let h = t;
  if (c.params.loop) if (c.virtual && c.params.virtual.enabled) h = h + c.virtual.slidesBefore;else {
    let y;
    if (p) {
      const k = h * c.params.grid.rows;
      y = c.slides.find(D => D.getAttribute("data-swiper-slide-index") * 1 === k).column;
    } else y = c.getSlideIndexByData(h);
    const w = p ? Math.ceil(c.slides.length / c.params.grid.rows) : c.slides.length,
      {
        centeredSlides: x
      } = c.params;
    let E = c.params.slidesPerView;
    E === "auto" ? E = c.slidesPerViewDynamic() : (E = Math.ceil(parseFloat(c.params.slidesPerView, 10)), x && E % 2 === 0 && (E = E + 1));
    let C = w - y < E;
    if (x && (C = C || y < Math.ceil(E / 2)), s && x && c.params.slidesPerView !== "auto" && !p && (C = !1), C) {
      const k = x ? y < c.activeIndex ? "prev" : "next" : y - c.activeIndex - 1 < c.params.slidesPerView ? "next" : "prev";
      c.loopFix({
        direction: k,
        slideTo: !0,
        activeSlideIndex: k === "next" ? y + 1 : y - w + 1,
        slideRealIndex: k === "next" ? c.realIndex : void 0
      });
    }
    if (p) {
      const k = h * c.params.grid.rows;
      h = c.slides.find(D => D.getAttribute("data-swiper-slide-index") * 1 === k).column;
    } else h = c.getSlideIndexByData(h);
  }
  return requestAnimationFrame(() => {
    c.slideTo(h, e, i, s);
  }), c;
}
function Ete(t, e, i) {
  e === void 0 && (e = !0);
  const s = this,
    {
      enabled: c,
      params: p,
      animating: h
    } = s;
  if (!c || s.destroyed) return s;
  typeof t > "u" && (t = s.params.speed);
  let y = p.slidesPerGroup;
  p.slidesPerView === "auto" && p.slidesPerGroup === 1 && p.slidesPerGroupAuto && (y = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const w = s.activeIndex < p.slidesPerGroupSkip ? 1 : y,
    x = s.virtual && p.virtual.enabled;
  if (p.loop) {
    if (h && !x && p.loopPreventsSliding) return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && p.cssMode) return requestAnimationFrame(() => {
      s.slideTo(s.activeIndex + w, t, e, i);
    }), !0;
  }
  return p.rewind && s.isEnd ? s.slideTo(0, t, e, i) : s.slideTo(s.activeIndex + w, t, e, i);
}
function Cte(t, e, i) {
  e === void 0 && (e = !0);
  const s = this,
    {
      params: c,
      snapGrid: p,
      slidesGrid: h,
      rtlTranslate: y,
      enabled: w,
      animating: x
    } = s;
  if (!w || s.destroyed) return s;
  typeof t > "u" && (t = s.params.speed);
  const E = s.virtual && c.virtual.enabled;
  if (c.loop) {
    if (x && !E && c.loopPreventsSliding) return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const C = y ? s.translate : -s.translate;
  function k(O) {
    return O < 0 ? -Math.floor(Math.abs(O)) : Math.floor(O);
  }
  const D = k(C),
    I = p.map(O => k(O)),
    L = c.freeMode && c.freeMode.enabled;
  let P = p[I.indexOf(D) - 1];
  if (typeof P > "u" && (c.cssMode || L)) {
    let O;
    p.forEach((F, j) => {
      D >= F && (O = j);
    }), typeof O < "u" && (P = L ? p[O] : p[O > 0 ? O - 1 : O]);
  }
  let N = 0;
  if (typeof P < "u" && (N = h.indexOf(P), N < 0 && (N = s.activeIndex - 1), c.slidesPerView === "auto" && c.slidesPerGroup === 1 && c.slidesPerGroupAuto && (N = N - s.slidesPerViewDynamic("previous", !0) + 1, N = Math.max(N, 0))), c.rewind && s.isBeginning) {
    const O = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(O, t, e, i);
  } else if (c.loop && s.activeIndex === 0 && c.cssMode) return requestAnimationFrame(() => {
    s.slideTo(N, t, e, i);
  }), !0;
  return s.slideTo(N, t, e, i);
}
function kte(t, e, i) {
  e === void 0 && (e = !0);
  const s = this;
  if (!s.destroyed) return typeof t > "u" && (t = s.params.speed), s.slideTo(s.activeIndex, t, e, i);
}
function Tte(t, e, i, s) {
  e === void 0 && (e = !0), s === void 0 && (s = 0.5);
  const c = this;
  if (c.destroyed) return;
  typeof t > "u" && (t = c.params.speed);
  let p = c.activeIndex;
  const h = Math.min(c.params.slidesPerGroupSkip, p),
    y = h + Math.floor((p - h) / c.params.slidesPerGroup),
    w = c.rtlTranslate ? c.translate : -c.translate;
  if (w >= c.snapGrid[y]) {
    const x = c.snapGrid[y],
      E = c.snapGrid[y + 1];
    w - x > (E - x) * s && (p += c.params.slidesPerGroup);
  } else {
    const x = c.snapGrid[y - 1],
      E = c.snapGrid[y];
    w - x <= (E - x) * s && (p -= c.params.slidesPerGroup);
  }
  return p = Math.max(p, 0), p = Math.min(p, c.slidesGrid.length - 1), c.slideTo(p, t, e, i);
}
function Rte() {
  const t = this;
  if (t.destroyed) return;
  const {
      params: e,
      slidesEl: i
    } = t,
    s = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let c = t.getSlideIndexWhenGrid(t.clickedIndex),
    p;
  const h = t.isElement ? "swiper-slide" : `.${e.slideClass}`,
    y = t.grid && t.params.grid && t.params.grid.rows > 1;
  if (e.loop) {
    if (t.animating) return;
    p = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? t.slideToLoop(p) : c > (y ? (t.slides.length - s) / 2 - (t.params.grid.rows - 1) : t.slides.length - s) ? (t.loopFix(), c = t.getSlideIndex(Np(i, `${h}[data-swiper-slide-index="${p}"]`)[0]), kN(() => {
      t.slideTo(c);
    })) : t.slideTo(c);
  } else t.slideTo(c);
}
var Dte = {
  slideTo: xte,
  slideToLoop: Ste,
  slideNext: Ete,
  slidePrev: Cte,
  slideReset: kte,
  slideToClosest: Tte,
  slideToClickedSlide: Rte
};
function Ite(t, e) {
  const i = this,
    {
      params: s,
      slidesEl: c
    } = i;
  if (!s.loop || i.virtual && i.params.virtual.enabled) return;
  const p = () => {
      Np(c, `.${s.slideClass}, swiper-slide`).forEach((D, I) => {
        D.setAttribute("data-swiper-slide-index", I);
      });
    },
    h = () => {
      const k = Np(c, `.${s.slideBlankClass}`);
      k.forEach(D => {
        D.remove();
      }), k.length > 0 && (i.recalcSlides(), i.updateSlides());
    },
    y = i.grid && s.grid && s.grid.rows > 1;
  s.loopAddBlankSlides && (s.slidesPerGroup > 1 || y) && h();
  const w = s.slidesPerGroup * (y ? s.grid.rows : 1),
    x = i.slides.length % w !== 0,
    E = y && i.slides.length % s.grid.rows !== 0,
    C = k => {
      for (let D = 0; D < k; D += 1) {
        const I = i.isElement ? fR("swiper-slide", [s.slideBlankClass]) : fR("div", [s.slideClass, s.slideBlankClass]);
        i.slidesEl.append(I);
      }
    };
  if (x) {
    if (s.loopAddBlankSlides) {
      const k = w - i.slides.length % w;
      C(k), i.recalcSlides(), i.updateSlides();
    } else xL("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    p();
  } else if (E) {
    if (s.loopAddBlankSlides) {
      const k = s.grid.rows - i.slides.length % s.grid.rows;
      C(k), i.recalcSlides(), i.updateSlides();
    } else xL("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    p();
  } else p();
  i.loopFix({
    slideRealIndex: t,
    direction: s.centeredSlides ? void 0 : "next",
    initial: e
  });
}
function Mte(t) {
  let {
    slideRealIndex: e,
    slideTo: i = !0,
    direction: s,
    setTranslate: c,
    activeSlideIndex: p,
    initial: h,
    byController: y,
    byMousewheel: w
  } = t === void 0 ? {} : t;
  const x = this;
  if (!x.params.loop) return;
  x.emit("beforeLoopFix");
  const {
      slides: E,
      allowSlidePrev: C,
      allowSlideNext: k,
      slidesEl: D,
      params: I
    } = x,
    {
      centeredSlides: L,
      initialSlide: P
    } = I;
  if (x.allowSlidePrev = !0, x.allowSlideNext = !0, x.virtual && I.virtual.enabled) {
    i && (!I.centeredSlides && x.snapIndex === 0 ? x.slideTo(x.virtual.slides.length, 0, !1, !0) : I.centeredSlides && x.snapIndex < I.slidesPerView ? x.slideTo(x.virtual.slides.length + x.snapIndex, 0, !1, !0) : x.snapIndex === x.snapGrid.length - 1 && x.slideTo(x.virtual.slidesBefore, 0, !1, !0)), x.allowSlidePrev = C, x.allowSlideNext = k, x.emit("loopFix");
    return;
  }
  let N = I.slidesPerView;
  N === "auto" ? N = x.slidesPerViewDynamic() : (N = Math.ceil(parseFloat(I.slidesPerView, 10)), L && N % 2 === 0 && (N = N + 1));
  const O = I.slidesPerGroupAuto ? N : I.slidesPerGroup;
  let F = L ? Math.max(O, Math.ceil(N / 2)) : O;
  F % O !== 0 && (F += O - F % O), F += I.loopAdditionalSlides, x.loopedSlides = F;
  const j = x.grid && I.grid && I.grid.rows > 1;
  E.length < N + F || x.params.effect === "cards" && E.length < N + F * 2 ? xL("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : j && I.grid.fill === "row" && xL("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const V = [],
    K = [],
    G = j ? Math.ceil(E.length / I.grid.rows) : E.length,
    Q = h && G - P < N && !L;
  let te = Q ? P : x.activeIndex;
  typeof p > "u" ? p = x.getSlideIndex(E.find(ce => ce.classList.contains(I.slideActiveClass))) : te = p;
  const ie = s === "next" || !s,
    Y = s === "prev" || !s;
  let ee = 0,
    ae = 0;
  const le = (j ? E[p].column : p) + (L && typeof c > "u" ? -N / 2 + 0.5 : 0);
  if (le < F) {
    ee = Math.max(F - le, O);
    for (let ce = 0; ce < F - le; ce += 1) {
      const W = ce - Math.floor(ce / G) * G;
      if (j) {
        const $ = G - W - 1;
        for (let de = E.length - 1; de >= 0; de -= 1) E[de].column === $ && V.push(de);
      } else V.push(G - W - 1);
    }
  } else if (le + N > G - F) {
    ae = Math.max(le - (G - F * 2), O), Q && (ae = Math.max(ae, N - G + P + 1));
    for (let ce = 0; ce < ae; ce += 1) {
      const W = ce - Math.floor(ce / G) * G;
      j ? E.forEach(($, de) => {
        $.column === W && K.push(de);
      }) : K.push(W);
    }
  }
  if (x.__preventObserver__ = !0, requestAnimationFrame(() => {
    x.__preventObserver__ = !1;
  }), x.params.effect === "cards" && E.length < N + F * 2 && (K.includes(p) && K.splice(K.indexOf(p), 1), V.includes(p) && V.splice(V.indexOf(p), 1)), Y && V.forEach(ce => {
    E[ce].swiperLoopMoveDOM = !0, D.prepend(E[ce]), E[ce].swiperLoopMoveDOM = !1;
  }), ie && K.forEach(ce => {
    E[ce].swiperLoopMoveDOM = !0, D.append(E[ce]), E[ce].swiperLoopMoveDOM = !1;
  }), x.recalcSlides(), I.slidesPerView === "auto" ? x.updateSlides() : j && (V.length > 0 && Y || K.length > 0 && ie) && x.slides.forEach((ce, W) => {
    x.grid.updateSlide(W, ce, x.slides);
  }), I.watchSlidesProgress && x.updateSlidesOffset(), i) {
    if (V.length > 0 && Y) {
      if (typeof e > "u") {
        const ce = x.slidesGrid[te],
          $ = x.slidesGrid[te + ee] - ce;
        w ? x.setTranslate(x.translate - $) : (x.slideTo(te + Math.ceil(ee), 0, !1, !0), c && (x.touchEventsData.startTranslate = x.touchEventsData.startTranslate - $, x.touchEventsData.currentTranslate = x.touchEventsData.currentTranslate - $));
      } else if (c) {
        const ce = j ? V.length / I.grid.rows : V.length;
        x.slideTo(x.activeIndex + ce, 0, !1, !0), x.touchEventsData.currentTranslate = x.translate;
      }
    } else if (K.length > 0 && ie) if (typeof e > "u") {
      const ce = x.slidesGrid[te],
        $ = x.slidesGrid[te - ae] - ce;
      w ? x.setTranslate(x.translate - $) : (x.slideTo(te - ae, 0, !1, !0), c && (x.touchEventsData.startTranslate = x.touchEventsData.startTranslate - $, x.touchEventsData.currentTranslate = x.touchEventsData.currentTranslate - $));
    } else {
      const ce = j ? K.length / I.grid.rows : K.length;
      x.slideTo(x.activeIndex - ce, 0, !1, !0);
    }
  }
  if (x.allowSlidePrev = C, x.allowSlideNext = k, x.controller && x.controller.control && !y) {
    const ce = {
      slideRealIndex: e,
      direction: s,
      setTranslate: c,
      activeSlideIndex: p,
      byController: !0
    };
    Array.isArray(x.controller.control) ? x.controller.control.forEach(W => {
      !W.destroyed && W.params.loop && W.loopFix({
        ...ce,
        slideTo: W.params.slidesPerView === I.slidesPerView ? i : !1
      });
    }) : x.controller.control instanceof x.constructor && x.controller.control.params.loop && x.controller.control.loopFix({
      ...ce,
      slideTo: x.controller.control.params.slidesPerView === I.slidesPerView ? i : !1
    });
  }
  x.emit("loopFix");
}
function Lte() {
  const t = this,
    {
      params: e,
      slidesEl: i
    } = t;
  if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const s = [];
  t.slides.forEach(c => {
    const p = typeof c.swiperSlideIndex > "u" ? c.getAttribute("data-swiper-slide-index") * 1 : c.swiperSlideIndex;
    s[p] = c;
  }), t.slides.forEach(c => {
    c.removeAttribute("data-swiper-slide-index");
  }), s.forEach(c => {
    i.append(c);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var Ote = {
  loopCreate: Ite,
  loopFix: Mte,
  loopDestroy: Lte
};
function Pte(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function Ate() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var jte = {
  setGrabCursor: Pte,
  unsetGrabCursor: Ate
};
function Fte(t, e) {
  e === void 0 && (e = this);
  function i(s) {
    if (!s || s === Gm() || s === ws()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const c = s.closest(t);
    return !c && !s.getRootNode ? null : c || i(s.getRootNode().host);
  }
  return i(e);
}
function gB(t, e, i) {
  const s = ws(),
    {
      params: c
    } = t,
    p = c.edgeSwipeDetection,
    h = c.edgeSwipeThreshold;
  return p && (i <= h || i >= s.innerWidth - h) ? p === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function Nte(t) {
  const e = this,
    i = Gm();
  let s = t;
  s.originalEvent && (s = s.originalEvent);
  const c = e.touchEventsData;
  if (s.type === "pointerdown") {
    if (c.pointerId !== null && c.pointerId !== s.pointerId) return;
    c.pointerId = s.pointerId;
  } else s.type === "touchstart" && s.targetTouches.length === 1 && (c.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    gB(e, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: p,
    touches: h,
    enabled: y
  } = e;
  if (!y || !p.simulateTouch && s.pointerType === "mouse" || e.animating && p.preventInteractionOnTransition) return;
  !e.animating && p.cssMode && p.loop && e.loopFix();
  let w = s.target;
  if (p.touchEventsTarget === "wrapper" && !$ee(w, e.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || c.isTouched && c.isMoved) return;
  const x = !!p.noSwipingClass && p.noSwipingClass !== "",
    E = s.composedPath ? s.composedPath() : s.path;
  x && s.target && s.target.shadowRoot && E && (w = E[0]);
  const C = p.noSwipingSelector ? p.noSwipingSelector : `.${p.noSwipingClass}`,
    k = !!(s.target && s.target.shadowRoot);
  if (p.noSwiping && (k ? Fte(C, w) : w.closest(C))) {
    e.allowClick = !0;
    return;
  }
  if (p.swipeHandler && !w.closest(p.swipeHandler)) return;
  h.currentX = s.pageX, h.currentY = s.pageY;
  const D = h.currentX,
    I = h.currentY;
  if (!gB(e, s, D)) return;
  Object.assign(c, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), h.startX = D, h.startY = I, c.touchStartTime = _L(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, p.threshold > 0 && (c.allowThresholdMove = !1);
  let L = !0;
  w.matches(c.focusableElements) && (L = !1, w.nodeName === "SELECT" && (c.isTouched = !1)), i.activeElement && i.activeElement.matches(c.focusableElements) && i.activeElement !== w && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !w.matches(c.focusableElements)) && i.activeElement.blur();
  const P = L && e.allowTouchMove && p.touchStartPreventDefault;
  (p.touchStartForcePreventDefault || P) && !w.isContentEditable && s.preventDefault(), p.freeMode && p.freeMode.enabled && e.freeMode && e.animating && !p.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", s);
}
function zte(t) {
  const e = Gm(),
    i = this,
    s = i.touchEventsData,
    {
      params: c,
      touches: p,
      rtlTranslate: h,
      enabled: y
    } = i;
  if (!y || !c.simulateTouch && t.pointerType === "mouse") return;
  let w = t;
  if (w.originalEvent && (w = w.originalEvent), w.type === "pointermove" && (s.touchId !== null || w.pointerId !== s.pointerId)) return;
  let x;
  if (w.type === "touchmove") {
    if (x = [...w.changedTouches].find(V => V.identifier === s.touchId), !x || x.identifier !== s.touchId) return;
  } else x = w;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", w);
    return;
  }
  const E = x.pageX,
    C = x.pageY;
  if (w.preventedByNestedSwiper) {
    p.startX = E, p.startY = C;
    return;
  }
  if (!i.allowTouchMove) {
    w.target.matches(s.focusableElements) || (i.allowClick = !1), s.isTouched && (Object.assign(p, {
      startX: E,
      startY: C,
      currentX: E,
      currentY: C
    }), s.touchStartTime = _L());
    return;
  }
  if (c.touchReleaseOnEdges && !c.loop) if (i.isVertical()) {
    if (C < p.startY && i.translate <= i.maxTranslate() || C > p.startY && i.translate >= i.minTranslate()) {
      s.isTouched = !1, s.isMoved = !1;
      return;
    }
  } else {
    if (h && (E > p.startX && -i.translate <= i.maxTranslate() || E < p.startX && -i.translate >= i.minTranslate())) return;
    if (!h && (E < p.startX && i.translate <= i.maxTranslate() || E > p.startX && i.translate >= i.minTranslate())) return;
  }
  if (e.activeElement && e.activeElement.matches(s.focusableElements) && e.activeElement !== w.target && w.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && w.target === e.activeElement && w.target.matches(s.focusableElements)) {
    s.isMoved = !0, i.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && i.emit("touchMove", w), p.previousX = p.currentX, p.previousY = p.currentY, p.currentX = E, p.currentY = C;
  const k = p.currentX - p.startX,
    D = p.currentY - p.startY;
  if (i.params.threshold && Math.sqrt(k ** 2 + D ** 2) < i.params.threshold) return;
  if (typeof s.isScrolling > "u") {
    let V;
    i.isHorizontal() && p.currentY === p.startY || i.isVertical() && p.currentX === p.startX ? s.isScrolling = !1 : k * k + D * D >= 25 && (V = Math.atan2(Math.abs(D), Math.abs(k)) * 180 / Math.PI, s.isScrolling = i.isHorizontal() ? V > c.touchAngle : 90 - V > c.touchAngle);
  }
  if (s.isScrolling && i.emit("touchMoveOpposite", w), typeof s.startMoving > "u" && (p.currentX !== p.startX || p.currentY !== p.startY) && (s.startMoving = !0), s.isScrolling || w.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving) return;
  i.allowClick = !1, !c.cssMode && w.cancelable && w.preventDefault(), c.touchMoveStopPropagation && !c.nested && w.stopPropagation();
  let I = i.isHorizontal() ? k : D,
    L = i.isHorizontal() ? p.currentX - p.previousX : p.currentY - p.previousY;
  c.oneWayMovement && (I = Math.abs(I) * (h ? 1 : -1), L = Math.abs(L) * (h ? 1 : -1)), p.diff = I, I *= c.touchRatio, h && (I = -I, L = -L);
  const P = i.touchesDirection;
  i.swipeDirection = I > 0 ? "prev" : "next", i.touchesDirection = L > 0 ? "prev" : "next";
  const N = i.params.loop && !c.cssMode,
    O = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!s.isMoved) {
    if (N && O && i.loopFix({
      direction: i.swipeDirection
    }), s.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const V = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(V);
    }
    s.allowMomentumBounce = !1, c.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", w);
  }
  if ((/* @__PURE__ */new Date()).getTime(), c._loopSwapReset !== !1 && s.isMoved && s.allowThresholdMove && P !== i.touchesDirection && N && O && Math.abs(I) >= 1) {
    Object.assign(p, {
      startX: E,
      startY: C,
      currentX: E,
      currentY: C,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  i.emit("sliderMove", w), s.isMoved = !0, s.currentTranslate = I + s.startTranslate;
  let F = !0,
    j = c.resistanceRatio;
  if (c.touchReleaseOnEdges && (j = 0), I > 0 ? (N && O && s.allowThresholdMove && s.currentTranslate > (c.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (c.slidesPerView !== "auto" && i.slides.length - c.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > i.minTranslate() && (F = !1, c.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + I) ** j))) : I < 0 && (N && O && s.allowThresholdMove && s.currentTranslate < (c.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (c.slidesPerView !== "auto" && i.slides.length - c.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (c.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(c.slidesPerView, 10)))
  }), s.currentTranslate < i.maxTranslate() && (F = !1, c.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - I) ** j))), F && (w.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (s.currentTranslate = s.startTranslate), c.threshold > 0) if (Math.abs(I) > c.threshold || s.allowThresholdMove) {
    if (!s.allowThresholdMove) {
      s.allowThresholdMove = !0, p.startX = p.currentX, p.startY = p.currentY, s.currentTranslate = s.startTranslate, p.diff = i.isHorizontal() ? p.currentX - p.startX : p.currentY - p.startY;
      return;
    }
  } else {
    s.currentTranslate = s.startTranslate;
    return;
  }
  !c.followFinger || c.cssMode || ((c.freeMode && c.freeMode.enabled && i.freeMode || c.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), c.freeMode && c.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(s.currentTranslate), i.setTranslate(s.currentTranslate));
}
function Vte(t) {
  const e = this,
    i = e.touchEventsData;
  let s = t;
  s.originalEvent && (s = s.originalEvent);
  let c;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (c = [...s.changedTouches].find(V => V.identifier === i.touchId), !c || c.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || s.pointerId !== i.pointerId) return;
    c = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (e.browser.isSafari || e.browser.isWebView))) return;
  i.pointerId = null, i.touchId = null;
  const {
    params: h,
    touches: y,
    rtlTranslate: w,
    slidesGrid: x,
    enabled: E
  } = e;
  if (!E || !h.simulateTouch && s.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && e.emit("touchEnd", s), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && h.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  h.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const C = _L(),
    k = C - i.touchStartTime;
  if (e.allowClick) {
    const V = s.path || s.composedPath && s.composedPath();
    e.updateClickedSlide(V && V[0] || s.target, V), e.emit("tap click", s), k < 300 && C - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", s);
  }
  if (i.lastClickTime = _L(), kN(() => {
    e.destroyed || (e.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !e.swipeDirection || y.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let D;
  if (h.followFinger ? D = w ? e.translate : -e.translate : D = -i.currentTranslate, h.cssMode) return;
  if (h.freeMode && h.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: D
    });
    return;
  }
  const I = D >= -e.maxTranslate() && !e.params.loop;
  let L = 0,
    P = e.slidesSizesGrid[0];
  for (let V = 0; V < x.length; V += V < h.slidesPerGroupSkip ? 1 : h.slidesPerGroup) {
    const K = V < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
    typeof x[V + K] < "u" ? (I || D >= x[V] && D < x[V + K]) && (L = V, P = x[V + K] - x[V]) : (I || D >= x[V]) && (L = V, P = x[x.length - 1] - x[x.length - 2]);
  }
  let N = null,
    O = null;
  h.rewind && (e.isBeginning ? O = h.virtual && h.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (N = 0));
  const F = (D - x[L]) / P,
    j = L < h.slidesPerGroupSkip - 1 ? 1 : h.slidesPerGroup;
  if (k > h.longSwipesMs) {
    if (!h.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (F >= h.longSwipesRatio ? e.slideTo(h.rewind && e.isEnd ? N : L + j) : e.slideTo(L)), e.swipeDirection === "prev" && (F > 1 - h.longSwipesRatio ? e.slideTo(L + j) : O !== null && F < 0 && Math.abs(F) > h.longSwipesRatio ? e.slideTo(O) : e.slideTo(L));
  } else {
    if (!h.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl) ? s.target === e.navigation.nextEl ? e.slideTo(L + j) : e.slideTo(L) : (e.swipeDirection === "next" && e.slideTo(N !== null ? N : L + j), e.swipeDirection === "prev" && e.slideTo(O !== null ? O : L));
  }
}
function yB() {
  const t = this,
    {
      params: e,
      el: i
    } = t;
  if (i && i.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
      allowSlideNext: s,
      allowSlidePrev: c,
      snapGrid: p
    } = t,
    h = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const y = h && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !y ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !h ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = c, t.allowSlideNext = s, t.params.watchOverflow && p !== t.snapGrid && t.checkOverflow();
}
function Bte(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Ute() {
  const t = this,
    {
      wrapperEl: e,
      rtlTranslate: i,
      enabled: s
    } = t;
  if (!s) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let c;
  const p = t.maxTranslate() - t.minTranslate();
  p === 0 ? c = 0 : c = (t.translate - t.minTranslate()) / p, c !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function Hte(t) {
  const e = this;
  HM(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function $te() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const t$ = (t, e) => {
  const i = Gm(),
    {
      params: s,
      el: c,
      wrapperEl: p,
      device: h
    } = t,
    y = !!s.nested,
    w = e === "on" ? "addEventListener" : "removeEventListener",
    x = e;
  !c || typeof c == "string" || (i[w]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: y
  }), c[w]("touchstart", t.onTouchStart, {
    passive: !1
  }), c[w]("pointerdown", t.onTouchStart, {
    passive: !1
  }), i[w]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: y
  }), i[w]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: y
  }), i[w]("touchend", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerup", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), i[w]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerout", t.onTouchEnd, {
    passive: !0
  }), i[w]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), i[w]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && c[w]("click", t.onClick, !0), s.cssMode && p[w]("scroll", t.onScroll), s.updateOnWindowResize ? t[x](h.ios || h.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", yB, !0) : t[x]("observerUpdate", yB, !0), c[w]("load", t.onLoad, {
    capture: !0
  }));
};
function Wte() {
  const t = this,
    {
      params: e
    } = t;
  t.onTouchStart = Nte.bind(t), t.onTouchMove = zte.bind(t), t.onTouchEnd = Vte.bind(t), t.onDocumentTouchStart = $te.bind(t), e.cssMode && (t.onScroll = Ute.bind(t)), t.onClick = Bte.bind(t), t.onLoad = Hte.bind(t), t$(t, "on");
}
function qte() {
  t$(this, "off");
}
var Yte = {
  attachEvents: Wte,
  detachEvents: qte
};
const bB = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function Gte() {
  const t = this,
    {
      realIndex: e,
      initialized: i,
      params: s,
      el: c
    } = t,
    p = s.breakpoints;
  if (!p || p && Object.keys(p).length === 0) return;
  const h = Gm(),
    y = s.breakpointsBase === "window" || !s.breakpointsBase ? s.breakpointsBase : "container",
    w = ["window", "container"].includes(s.breakpointsBase) || !s.breakpointsBase ? t.el : h.querySelector(s.breakpointsBase),
    x = t.getBreakpoint(p, y, w);
  if (!x || t.currentBreakpoint === x) return;
  const C = (x in p ? p[x] : void 0) || t.originalParams,
    k = bB(t, s),
    D = bB(t, C),
    I = t.params.grabCursor,
    L = C.grabCursor,
    P = s.enabled;
  k && !D ? (c.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), t.emitContainerClasses()) : !k && D && (c.classList.add(`${s.containerModifierClass}grid`), (C.grid.fill && C.grid.fill === "column" || !C.grid.fill && s.grid.fill === "column") && c.classList.add(`${s.containerModifierClass}grid-column`), t.emitContainerClasses()), I && !L ? t.unsetGrabCursor() : !I && L && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(K => {
    if (typeof C[K] > "u") return;
    const G = s[K] && s[K].enabled,
      Q = C[K] && C[K].enabled;
    G && !Q && t[K].disable(), !G && Q && t[K].enable();
  });
  const N = C.direction && C.direction !== s.direction,
    O = s.loop && (C.slidesPerView !== s.slidesPerView || N),
    F = s.loop;
  N && i && t.changeDirection(), rp(t.params, C);
  const j = t.params.enabled,
    V = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), P && !j ? t.disable() : !P && j && t.enable(), t.currentBreakpoint = x, t.emit("_beforeBreakpoint", C), i && (O ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !F && V ? (t.loopCreate(e), t.updateSlides()) : F && !V && t.loopDestroy()), t.emit("breakpoint", C);
}
function Xte(t, e, i) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !i) return;
  let s = !1;
  const c = ws(),
    p = e === "window" ? c.innerHeight : i.clientHeight,
    h = Object.keys(t).map(y => {
      if (typeof y == "string" && y.indexOf("@") === 0) {
        const w = parseFloat(y.substr(1));
        return {
          value: p * w,
          point: y
        };
      }
      return {
        value: y,
        point: y
      };
    });
  h.sort((y, w) => parseInt(y.value, 10) - parseInt(w.value, 10));
  for (let y = 0; y < h.length; y += 1) {
    const {
      point: w,
      value: x
    } = h[y];
    e === "window" ? c.matchMedia(`(min-width: ${x}px)`).matches && (s = w) : x <= i.clientWidth && (s = w);
  }
  return s || "max";
}
var Kte = {
  setBreakpoint: Gte,
  getBreakpoint: Xte
};
function Qte(t, e) {
  const i = [];
  return t.forEach(s => {
    typeof s == "object" ? Object.keys(s).forEach(c => {
      s[c] && i.push(e + c);
    }) : typeof s == "string" && i.push(e + s);
  }), i;
}
function Zte() {
  const t = this,
    {
      classNames: e,
      params: i,
      rtl: s,
      el: c,
      device: p
    } = t,
    h = Qte(["initialized", i.direction, {
      "free-mode": t.params.freeMode && i.freeMode.enabled
    }, {
      autoheight: i.autoHeight
    }, {
      rtl: s
    }, {
      grid: i.grid && i.grid.rows > 1
    }, {
      "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
    }, {
      android: p.android
    }, {
      ios: p.ios
    }, {
      "css-mode": i.cssMode
    }, {
      centered: i.cssMode && i.centeredSlides
    }, {
      "watch-progress": i.watchSlidesProgress
    }], i.containerModifierClass);
  e.push(...h), c.classList.add(...e), t.emitContainerClasses();
}
function Jte() {
  const t = this,
    {
      el: e,
      classNames: i
    } = t;
  !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
}
var ene = {
  addClasses: Zte,
  removeClasses: Jte
};
function tne() {
  const t = this,
    {
      isLocked: e,
      params: i
    } = t,
    {
      slidesOffsetBefore: s
    } = i;
  if (s) {
    const c = t.slides.length - 1,
      p = t.slidesGrid[c] + t.slidesSizesGrid[c] + s * 2;
    t.isLocked = t.size > p;
  } else t.isLocked = t.snapGrid.length === 1;
  i.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var nne = {
    checkOverflow: tne
  },
  U2 = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: !1,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: !1,
    // Set wrapper width
    setWrapperSize: !1,
    // Virtual Translate
    virtualTranslate: !1,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: void 0,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: !0,
    // Round length
    roundLengths: !1,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    // Unique Navigation Elements
    uniqueNavElements: !0,
    // Resistance
    resistance: !0,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: !1,
    // Cursor
    grabCursor: !1,
    // Clicks
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    // loop
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    // rewind
    rewind: !1,
    // Swiping/no swiping
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: !0,
    // Internals
    _emitClasses: !1
  };
function rne(t, e) {
  return function (s) {
    s === void 0 && (s = {});
    const c = Object.keys(s)[0],
      p = s[c];
    if (typeof p != "object" || p === null) {
      rp(e, s);
      return;
    }
    if (t[c] === !0 && (t[c] = {
      enabled: !0
    }), c === "navigation" && t[c] && t[c].enabled && !t[c].prevEl && !t[c].nextEl && (t[c].auto = !0), ["pagination", "scrollbar"].indexOf(c) >= 0 && t[c] && t[c].enabled && !t[c].el && (t[c].auto = !0), !(c in t && "enabled" in p)) {
      rp(e, s);
      return;
    }
    typeof t[c] == "object" && !("enabled" in t[c]) && (t[c].enabled = !0), t[c] || (t[c] = {
      enabled: !1
    }), rp(e, s);
  };
}
const Ij = {
    eventsEmitter: ete,
    update: dte,
    translate: gte,
    transition: _te,
    slide: Dte,
    loop: Ote,
    grabCursor: jte,
    events: Yte,
    breakpoints: Kte,
    checkOverflow: nne,
    classes: ene
  },
  Mj = {};
let TN = class ub {
  constructor() {
    let e, i;
    for (var s = arguments.length, c = new Array(s), p = 0; p < s; p++) c[p] = arguments[p];
    c.length === 1 && c[0].constructor && Object.prototype.toString.call(c[0]).slice(8, -1) === "Object" ? i = c[0] : [e, i] = c, i || (i = {}), i = rp({}, i), e && !i.el && (i.el = e);
    const h = Gm();
    if (i.el && typeof i.el == "string" && h.querySelectorAll(i.el).length > 1) {
      const E = [];
      return h.querySelectorAll(i.el).forEach(C => {
        const k = rp({}, i, {
          el: C
        });
        E.push(new ub(k));
      }), E;
    }
    const y = this;
    y.__swiper__ = !0, y.support = Q4(), y.device = Z4({
      userAgent: i.userAgent
    }), y.browser = J4(), y.eventsListeners = {}, y.eventsAnyListeners = [], y.modules = [...y.__modules__], i.modules && Array.isArray(i.modules) && y.modules.push(...i.modules);
    const w = {};
    y.modules.forEach(E => {
      E({
        params: i,
        swiper: y,
        extendParams: rne(i, w),
        on: y.on.bind(y),
        once: y.once.bind(y),
        off: y.off.bind(y),
        emit: y.emit.bind(y)
      });
    });
    const x = rp({}, U2, w);
    return y.params = rp({}, x, Mj, i), y.originalParams = rp({}, y.params), y.passedParams = rp({}, i), y.params && y.params.on && Object.keys(y.params.on).forEach(E => {
      y.on(E, y.params.on[E]);
    }), y.params && y.params.onAny && y.onAny(y.params.onAny), Object.assign(y, {
      enabled: y.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return y.params.direction === "horizontal";
      },
      isVertical() {
        return y.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: y.params.allowSlideNext,
      allowSlidePrev: y.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: y.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: y.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), y.emit("_swiper"), y.params.init && y.init(), y;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
        slidesEl: i,
        params: s
      } = this,
      c = Np(i, `.${s.slideClass}, swiper-slide`),
      p = pR(c[0]);
    return pR(e) - p;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find(i => i.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  getSlideIndexWhenGrid(e) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
  }
  recalcSlides() {
    const e = this,
      {
        slidesEl: i,
        params: s
      } = e;
    e.slides = Np(i, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, i) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const c = s.minTranslate(),
      h = (s.maxTranslate() - c) * e + c;
    s.translateTo(h, typeof i > "u" ? 0 : i), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = e.el.className.split(" ").filter(s => s.indexOf("swiper") === 0 || s.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(e) {
    const i = this;
    return i.destroyed ? "" : e.className.split(" ").filter(s => s.indexOf("swiper-slide") === 0 || s.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = [];
    e.slides.forEach(s => {
      const c = e.getSlideClasses(s);
      i.push({
        slideEl: s,
        classNames: c
      }), e.emit("_slideClass", s, c);
    }), e.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(e, i) {
    e === void 0 && (e = "current"), i === void 0 && (i = !1);
    const s = this,
      {
        params: c,
        slides: p,
        slidesGrid: h,
        slidesSizesGrid: y,
        size: w,
        activeIndex: x
      } = s;
    let E = 1;
    if (typeof c.slidesPerView == "number") return c.slidesPerView;
    if (c.centeredSlides) {
      let C = p[x] ? Math.ceil(p[x].swiperSlideSize) : 0,
        k;
      for (let D = x + 1; D < p.length; D += 1) p[D] && !k && (C += Math.ceil(p[D].swiperSlideSize), E += 1, C > w && (k = !0));
      for (let D = x - 1; D >= 0; D -= 1) p[D] && !k && (C += p[D].swiperSlideSize, E += 1, C > w && (k = !0));
    } else if (e === "current") for (let C = x + 1; C < p.length; C += 1) (i ? h[C] + y[C] - h[x] < w : h[C] - h[x] < w) && (E += 1);else for (let C = x - 1; C >= 0; C -= 1) h[x] - h[C] < w && (E += 1);
    return E;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: i,
      params: s
    } = e;
    s.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach(h => {
      h.complete && HM(e, h);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function c() {
      const h = e.rtlTranslate ? e.translate * -1 : e.translate,
        y = Math.min(Math.max(h, e.maxTranslate()), e.minTranslate());
      e.setTranslate(y), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let p;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode) c(), s.autoHeight && e.updateAutoHeight();else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
        const h = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
        p = e.slideTo(h.length - 1, 0, !1, !0);
      } else p = e.slideTo(e.activeIndex, 0, !1, !0);
      p || c();
    }
    s.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, i) {
    i === void 0 && (i = !0);
    const s = this,
      c = s.params.direction;
    return e || (e = c === "horizontal" ? "vertical" : "horizontal"), e === c || e !== "horizontal" && e !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${c}`), s.el.classList.add(`${s.params.containerModifierClass}${e}`), s.emitContainerClasses(), s.params.direction = e, s.slides.forEach(p => {
      e === "vertical" ? p.style.width = "" : p.style.height = "";
    }), s.emit("changeDirection"), i && s.update()), s;
  }
  changeLanguageDirection(e) {
    const i = this;
    i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(e) {
    const i = this;
    if (i.mounted) return !0;
    let s = e || i.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s) return !1;
    s.swiper = i, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const c = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let h = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(c()) : Np(s, c())[0];
    return !h && i.params.createElements && (h = fR("div", i.params.wrapperClass), s.append(h), Np(s, `.${i.params.slideClass}`).forEach(y => {
      h.append(y);
    })), Object.assign(i, {
      el: s,
      wrapperEl: h,
      slidesEl: i.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : h,
      hostEl: i.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || J0(s, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || J0(s, "direction") === "rtl"),
      wrongRTL: J0(h, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const i = this;
    if (i.initialized || i.mount(e) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const c = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && c.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), c.forEach(p => {
      p.complete ? HM(i, p) : p.addEventListener("load", h => {
        HM(i, h.target);
      });
    }), B2(i), i.initialized = !0, B2(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(e, i) {
    e === void 0 && (e = !0), i === void 0 && (i = !0);
    const s = this,
      {
        params: c,
        el: p,
        wrapperEl: h,
        slides: y
      } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), c.loop && s.loopDestroy(), i && (s.removeClasses(), p && typeof p != "string" && p.removeAttribute("style"), h && h.removeAttribute("style"), y && y.length && y.forEach(w => {
      w.classList.remove(c.slideVisibleClass, c.slideFullyVisibleClass, c.slideActiveClass, c.slideNextClass, c.slidePrevClass), w.removeAttribute("style"), w.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach(w => {
      s.off(w);
    }), e !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), Vee(s)), s.destroyed = !0), null;
  }
  static extendDefaults(e) {
    rp(Mj, e);
  }
  static get extendedDefaults() {
    return Mj;
  }
  static get defaults() {
    return U2;
  }
  static installModule(e) {
    ub.prototype.__modules__ || (ub.prototype.__modules__ = []);
    const i = ub.prototype.__modules__;
    typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach(i => ub.installModule(i)), ub) : (ub.installModule(e), ub);
  }
};
Object.keys(Ij).forEach(t => {
  Object.keys(Ij[t]).forEach(e => {
    TN.prototype[e] = Ij[t][e];
  });
});
TN.use([Zee, Jee]);
const n$ = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren",
// modules
"a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function eS(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function hE(t, e) {
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter(s => i.indexOf(s) < 0).forEach(s => {
    typeof t[s] > "u" ? t[s] = e[s] : eS(e[s]) && eS(t[s]) && Object.keys(e[s]).length > 0 ? e[s].__swiper__ ? t[s] = e[s] : hE(t[s], e[s]) : t[s] = e[s];
  });
}
function r$(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function i$(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function a$(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function o$(t) {
  t === void 0 && (t = "");
  const e = t.split(" ").map(s => s.trim()).filter(s => !!s),
    i = [];
  return e.forEach(s => {
    i.indexOf(s) < 0 && i.push(s);
  }), i.join(" ");
}
function ine(t) {
  return t === void 0 && (t = ""), t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
function ane(t) {
  let {
    swiper: e,
    slides: i,
    passedParams: s,
    changedParams: c,
    nextEl: p,
    prevEl: h,
    scrollbarEl: y,
    paginationEl: w
  } = t;
  const x = c.filter(te => te !== "children" && te !== "direction" && te !== "wrapperClass"),
    {
      params: E,
      pagination: C,
      navigation: k,
      scrollbar: D,
      virtual: I,
      thumbs: L
    } = e;
  let P, N, O, F, j, V, K, G;
  c.includes("thumbs") && s.thumbs && s.thumbs.swiper && !s.thumbs.swiper.destroyed && E.thumbs && (!E.thumbs.swiper || E.thumbs.swiper.destroyed) && (P = !0), c.includes("controller") && s.controller && s.controller.control && E.controller && !E.controller.control && (N = !0), c.includes("pagination") && s.pagination && (s.pagination.el || w) && (E.pagination || E.pagination === !1) && C && !C.el && (O = !0), c.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || y) && (E.scrollbar || E.scrollbar === !1) && D && !D.el && (F = !0), c.includes("navigation") && s.navigation && (s.navigation.prevEl || h) && (s.navigation.nextEl || p) && (E.navigation || E.navigation === !1) && k && !k.prevEl && !k.nextEl && (j = !0);
  const Q = te => {
    e[te] && (e[te].destroy(), te === "navigation" ? (e.isElement && (e[te].prevEl.remove(), e[te].nextEl.remove()), E[te].prevEl = void 0, E[te].nextEl = void 0, e[te].prevEl = void 0, e[te].nextEl = void 0) : (e.isElement && e[te].el.remove(), E[te].el = void 0, e[te].el = void 0));
  };
  c.includes("loop") && e.isElement && (E.loop && !s.loop ? V = !0 : !E.loop && s.loop ? K = !0 : G = !0), x.forEach(te => {
    if (eS(E[te]) && eS(s[te])) Object.assign(E[te], s[te]), (te === "navigation" || te === "pagination" || te === "scrollbar") && "enabled" in s[te] && !s[te].enabled && Q(te);else {
      const ie = s[te];
      (ie === !0 || ie === !1) && (te === "navigation" || te === "pagination" || te === "scrollbar") ? ie === !1 && Q(te) : E[te] = s[te];
    }
  }), x.includes("controller") && !N && e.controller && e.controller.control && E.controller && E.controller.control && (e.controller.control = E.controller.control), c.includes("children") && i && I && E.virtual.enabled ? (I.slides = i, I.update(!0)) : c.includes("virtual") && I && E.virtual.enabled && (i && (I.slides = i), I.update(!0)), c.includes("children") && i && E.loop && (G = !0), P && L.init() && L.update(!0), N && (e.controller.control = E.controller.control), O && (e.isElement && (!w || typeof w == "string") && (w = document.createElement("div"), w.classList.add("swiper-pagination"), w.part.add("pagination"), e.el.appendChild(w)), w && (E.pagination.el = w), C.init(), C.render(), C.update()), F && (e.isElement && (!y || typeof y == "string") && (y = document.createElement("div"), y.classList.add("swiper-scrollbar"), y.part.add("scrollbar"), e.el.appendChild(y)), y && (E.scrollbar.el = y), D.init(), D.updateSize(), D.setTranslate()), j && (e.isElement && ((!p || typeof p == "string") && (p = document.createElement("div"), p.classList.add("swiper-button-next"), hR(p, e.hostEl.constructor.nextButtonSvg), p.part.add("button-next"), e.el.appendChild(p)), (!h || typeof h == "string") && (h = document.createElement("div"), h.classList.add("swiper-button-prev"), hR(h, e.hostEl.constructor.prevButtonSvg), h.part.add("button-prev"), e.el.appendChild(h))), p && (E.navigation.nextEl = p), h && (E.navigation.prevEl = h), k.init(), k.update()), c.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext), c.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev), c.includes("direction") && e.changeDirection(s.direction, !1), (V || G) && e.loopDestroy(), (K || G) && e.loopCreate(), e.update();
}
function one(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = !0);
  const i = {
      on: {}
    },
    s = {},
    c = {};
  hE(i, U2), i._emitClasses = !0, i.init = !1;
  const p = {},
    h = n$.map(w => w.replace(/_/, "")),
    y = Object.assign({}, t);
  return Object.keys(y).forEach(w => {
    typeof t[w] > "u" || (h.indexOf(w) >= 0 ? eS(t[w]) ? (i[w] = {}, c[w] = {}, hE(i[w], t[w]), hE(c[w], t[w])) : (i[w] = t[w], c[w] = t[w]) : w.search(/on[A-Z]/) === 0 && typeof t[w] == "function" ? e ? s[`${w[2].toLowerCase()}${w.substr(3)}`] = t[w] : i.on[`${w[2].toLowerCase()}${w.substr(3)}`] = t[w] : p[w] = t[w]);
  }), ["navigation", "pagination", "scrollbar"].forEach(w => {
    i[w] === !0 && (i[w] = {}), i[w] === !1 && delete i[w];
  }), {
    params: i,
    passedParams: c,
    rest: p,
    events: s
  };
}
function lne(t, e) {
  let {
    el: i,
    nextEl: s,
    prevEl: c,
    paginationEl: p,
    scrollbarEl: h,
    swiper: y
  } = t;
  r$(e) && s && c && (y.params.navigation.nextEl = s, y.originalParams.navigation.nextEl = s, y.params.navigation.prevEl = c, y.originalParams.navigation.prevEl = c), i$(e) && p && (y.params.pagination.el = p, y.originalParams.pagination.el = p), a$(e) && h && (y.params.scrollbar.el = h, y.originalParams.scrollbar.el = h), y.init(i);
}
function sne(t, e, i, s, c) {
  const p = [];
  if (!e) return p;
  const h = w => {
    p.indexOf(w) < 0 && p.push(w);
  };
  if (i && s) {
    const w = s.map(c),
      x = i.map(c);
    w.join("") !== x.join("") && h("children"), s.length !== i.length && h("children");
  }
  return n$.filter(w => w[0] === "_").map(w => w.replace(/_/, "")).forEach(w => {
    if (w in t && w in e) if (eS(t[w]) && eS(e[w])) {
      const x = Object.keys(t[w]),
        E = Object.keys(e[w]);
      x.length !== E.length ? h(w) : (x.forEach(C => {
        t[w][C] !== e[w][C] && h(w);
      }), E.forEach(C => {
        t[w][C] !== e[w][C] && h(w);
      }));
    } else t[w] !== e[w] && h(w);
  }), p;
}
const une = t => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.emit("_virtualUpdated"), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function SL() {
  return SL = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
    }
    return t;
  }, SL.apply(this, arguments);
}
function l$(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function s$(t) {
  const e = [];
  return Nt.Children.toArray(t).forEach(i => {
    l$(i) ? e.push(i) : i.props && i.props.children && s$(i.props.children).forEach(s => e.push(s));
  }), e;
}
function cne(t) {
  const e = [],
    i = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return Nt.Children.toArray(t).forEach(s => {
    if (l$(s)) e.push(s);else if (s.props && s.props.slot && i[s.props.slot]) i[s.props.slot].push(s);else if (s.props && s.props.children) {
      const c = s$(s.props.children);
      c.length > 0 ? c.forEach(p => e.push(p)) : i["container-end"].push(s);
    } else i["container-end"].push(s);
  }), {
    slides: e,
    slots: i
  };
}
function dne(t, e, i) {
  if (!i) return null;
  const s = E => {
      let C = E;
      return E < 0 ? C = e.length + E : C >= e.length && (C = C - e.length), C;
    },
    c = t.isHorizontal() ? {
      [t.rtlTranslate ? "right" : "left"]: `${i.offset}px`
    } : {
      top: `${i.offset}px`
    },
    {
      from: p,
      to: h
    } = i,
    y = t.params.loop ? -e.length : 0,
    w = t.params.loop ? e.length * 2 : e.length,
    x = [];
  for (let E = y; E < w; E += 1) E >= p && E <= h && x.push(e[s(E)]);
  return x.map((E, C) => /* @__PURE__ */Nt.cloneElement(E, {
    swiper: t,
    style: c,
    key: E.props.virtualIndex || E.key || `slide-${C}`
  }));
}
function WT(t, e) {
  return typeof window > "u" ? Rt(t, e) : NR(t, e);
}
const wB = /* @__PURE__ */Up(null),
  fne = /* @__PURE__ */Up(null),
  RN = /* @__PURE__ */Qn(function (t, e) {
    let {
        className: i,
        tag: s = "div",
        wrapperTag: c = "div",
        children: p,
        onSwiper: h,
        ...y
      } = t === void 0 ? {} : t,
      w = !1;
    const [x, E] = rt("swiper"),
      [C, k] = rt(null),
      [D, I] = rt(!1),
      L = vt(!1),
      P = vt(null),
      N = vt(null),
      O = vt(null),
      F = vt(null),
      j = vt(null),
      V = vt(null),
      K = vt(null),
      G = vt(null),
      {
        params: Q,
        passedParams: te,
        rest: ie,
        events: Y
      } = one(y),
      {
        slides: ee,
        slots: ae
      } = cne(p),
      ne = () => {
        I(!D);
      };
    Object.assign(Q.on, {
      _containerClasses(de, H) {
        E(H);
      }
    });
    const le = () => {
      Object.assign(Q.on, Y), w = !0;
      const de = {
        ...Q
      };
      if (delete de.wrapperClass, N.current = new TN(de), N.current.virtual && N.current.params.virtual.enabled) {
        N.current.virtual.slides = ee;
        const H = {
          cache: !1,
          slides: ee,
          renderExternal: k,
          renderExternalUpdate: !1
        };
        hE(N.current.params.virtual, H), hE(N.current.originalParams.virtual, H);
      }
    };
    P.current || le(), N.current && N.current.on("_beforeBreakpoint", ne);
    const ce = () => {
        w || !Y || !N.current || Object.keys(Y).forEach(de => {
          N.current.on(de, Y[de]);
        });
      },
      W = () => {
        !Y || !N.current || Object.keys(Y).forEach(de => {
          N.current.off(de, Y[de]);
        });
      };
    Rt(() => () => {
      N.current && N.current.off("_beforeBreakpoint", ne);
    }), Rt(() => {
      !L.current && N.current && (N.current.emitSlidesClasses(), L.current = !0);
    }), WT(() => {
      if (e && (e.current = P.current), !!P.current) return N.current.destroyed && le(), lne({
        el: P.current,
        nextEl: j.current,
        prevEl: V.current,
        paginationEl: K.current,
        scrollbarEl: G.current,
        swiper: N.current
      }, Q), h && !N.current.destroyed && h(N.current), () => {
        N.current && !N.current.destroyed && N.current.destroy(!0, !1);
      };
    }, []), WT(() => {
      ce();
      const de = sne(te, O.current, ee, F.current, H => H.key);
      return O.current = te, F.current = ee, de.length && N.current && !N.current.destroyed && ane({
        swiper: N.current,
        slides: ee,
        passedParams: te,
        changedParams: de,
        nextEl: j.current,
        prevEl: V.current,
        scrollbarEl: G.current,
        paginationEl: K.current
      }), () => {
        W();
      };
    }), WT(() => {
      une(N.current);
    }, [C]);
    function $() {
      return Q.virtual ? dne(N.current, ee, C) : ee.map((de, H) => /* @__PURE__ */Nt.cloneElement(de, {
        swiper: N.current,
        swiperSlideIndex: H
      }));
    }
    return /* @__PURE__ */Nt.createElement(s, SL({
      ref: P,
      className: o$(`${x}${i ? ` ${i}` : ""}`)
    }, ie), /* @__PURE__ */Nt.createElement(fne.Provider, {
      value: N.current
    }, ae["container-start"], /* @__PURE__ */Nt.createElement(c, {
      className: ine(Q.wrapperClass)
    }, ae["wrapper-start"], $(), ae["wrapper-end"]), r$(Q) && /* @__PURE__ */Nt.createElement(Nt.Fragment, null, /* @__PURE__ */Nt.createElement("div", {
      ref: V,
      className: "swiper-button-prev"
    }), /* @__PURE__ */Nt.createElement("div", {
      ref: j,
      className: "swiper-button-next"
    })), a$(Q) && /* @__PURE__ */Nt.createElement("div", {
      ref: G,
      className: "swiper-scrollbar"
    }), i$(Q) && /* @__PURE__ */Nt.createElement("div", {
      ref: K,
      className: "swiper-pagination"
    }), ae["container-end"]));
  });
RN.displayName = "Swiper";
const DN = /* @__PURE__ */Qn(function (t, e) {
  let {
    tag: i = "div",
    children: s,
    className: c = "",
    swiper: p,
    zoom: h,
    lazy: y,
    virtualIndex: w,
    swiperSlideIndex: x,
    ...E
  } = t === void 0 ? {} : t;
  const C = vt(null),
    [k, D] = rt("swiper-slide"),
    [I, L] = rt(!1);
  function P(j, V, K) {
    V === C.current && D(K);
  }
  WT(() => {
    if (typeof x < "u" && (C.current.swiperSlideIndex = x), e && (e.current = C.current), !(!C.current || !p)) {
      if (p.destroyed) {
        k !== "swiper-slide" && D("swiper-slide");
        return;
      }
      return p.on("_slideClass", P), () => {
        p && p.off("_slideClass", P);
      };
    }
  }), WT(() => {
    p && C.current && !p.destroyed && D(p.getSlideClasses(C.current));
  }, [p]);
  const N = {
      isActive: k.indexOf("swiper-slide-active") >= 0,
      isVisible: k.indexOf("swiper-slide-visible") >= 0,
      isPrev: k.indexOf("swiper-slide-prev") >= 0,
      isNext: k.indexOf("swiper-slide-next") >= 0
    },
    O = () => typeof s == "function" ? s(N) : s,
    F = () => {
      L(!0);
    };
  return /* @__PURE__ */Nt.createElement(i, SL({
    ref: C,
    className: o$(`${k}${c ? ` ${c}` : ""}`),
    "data-swiper-slide-index": w,
    onLoad: F
  }, E), h && /* @__PURE__ */Nt.createElement(wB.Provider, {
    value: N
  }, /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof h == "number" ? h : void 0
  }, O(), y && !I && /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !h && /* @__PURE__ */Nt.createElement(wB.Provider, {
    value: N
  }, O(), y && !I && /* @__PURE__ */Nt.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
DN.displayName = "SwiperSlide";
const pne = "_galleryContainer_1gdu6_1",
  hne = "_footerContainer_1gdu6_5",
  mne = "_swiperSlide_1gdu6_12",
  vne = "_swiper_1gdu6_8",
  gne = "_slideImage_1gdu6_30",
  yne = "_navigationButton_1gdu6_61",
  bne = "_navigationButtonPrev_1gdu6_95",
  wne = "_navigationButtonNext_1gdu6_99",
  _ne = "_navigationButtonIcon_1gdu6_110",
  xne = "_navigationButtonDisabled_1gdu6_115",
  Sne = "_pagination_1gdu6_147",
  Dc = {
    galleryContainer: pne,
    footerContainer: hne,
    swiperSlide: mne,
    swiper: vne,
    slideImage: gne,
    navigationButton: yne,
    navigationButtonPrev: bne,
    navigationButtonNext: wne,
    navigationButtonIcon: _ne,
    navigationButtonDisabled: xne,
    pagination: Sne
  },
  Ene = ({
    setSwiperInstance: t,
    className: e,
    classNames: i,
    labels: s,
    images: c,
    aspectRatio: p = 16 / 9,
    cloudinaryNamedTransformation: h = "t_WVI-ar16x9",
    cloudinaryTransformation: y,
    renderImage: w = H4,
    onSlideClick: x,
    modalMode: E = !1,
    showPagination: C,
    swiperProps: k = {},
    children: D
  }) => {
    var de, H;
    const I = vt(null),
      L = vt(null),
      P = vt(null),
      N = vt(null),
      [O, F] = rt(!0),
      [j, V] = rt(!1),
      K = () => {
        var se, ue, Ee, Ce;
        (Ce = (Ee = (ue = (se = N.current) == null ? void 0 : se.swiper) == null ? void 0 : ue.keyboard) == null ? void 0 : Ee.enable) == null || Ce.call(Ee);
      },
      G = () => {
        var se, ue, Ee, Ce;
        (Ce = (Ee = (ue = (se = N.current) == null ? void 0 : se.swiper) == null ? void 0 : ue.keyboard) == null ? void 0 : Ee.disable) == null || Ce.call(Ee);
      },
      [Q, te] = rt(0),
      [ie, Y] = rt(!1),
      {
        onSlideChange: ee,
        ...ae
      } = k,
      ne = (ae == null ? void 0 : ae.slidesPerView) ?? 1,
      le = (ae == null ? void 0 : ae.spaceBetween) || 32;
    Rt(() => {
      const se = ue => {
        const Ee = L.current;
        !I.current || !Ee || ue.key === "Tab" && I.current.contains(document.activeElement) && (!ue.shiftKey && Ee.activeIndex < c.length - 1 ? (Ee.slideNext(), ue.preventDefault()) : ue.shiftKey && Ee.activeIndex > 0 && (Ee.slidePrev(), ue.preventDefault()));
      };
      return document.addEventListener("keydown", se), () => document.removeEventListener("keydown", se);
    }, [c.length]);
    const ce = {
        ...EN,
        ...s
      },
      [W, $] = rt(!1);
    return Rt(() => {
      const se = () => {
        $(window.matchMedia("(min-width: 992px)").matches);
      };
      return se(), window.addEventListener("resize", se), () => {
        window.removeEventListener("resize", se);
      };
    }, []), Rt(() => {
      if (E && L.current) {
        const se = L.current;
        requestAnimationFrame(() => {
          se.update(), se.slideTo(se.activeIndex, 0), F(se.isBeginning), V(se.isEnd);
        });
      }
    }, [E]), /* @__PURE__ */B.jsxs("div", {
      className: ve(Dc.galleryContainer, e),
      "data-zoom": ie,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: i == null ? void 0 : i.swiperContainer,
        children: [/* @__PURE__ */B.jsxs(RN, {
          ref: N,
          onSwiper: se => {
            L.current = se, t == null || t(se), F(se.isBeginning), V(se.isEnd);
          },
          className: ve(Dc.swiper, i == null ? void 0 : i.swiper),
          onSlideChange: se => {
            ee == null || ee(se), te(se.activeIndex), F(se.isBeginning), V(se.isEnd);
          },
          modules: [K4, X4, Y4, q4, ...(E ? [G4] : [])],
          pagination: C ? {
            el: P.current,
            dynamicBullets: !0,
            dynamicMainBullets: 3,
            clickable: !0,
            type: "bullets"
          } : !1,
          a11y: {
            firstSlideMessage: ce.firstSlideMessage,
            lastSlideMessage: ce.lastSlideMessage,
            prevSlideMessage: ce.prevSlideMessage,
            nextSlideMessage: ce.nextSlideMessage,
            paginationBulletMessage: ce.paginationBulletMessage,
            slideLabelMessage: ce.slideLabelMessage
          },
          keyboard: {
            enabled: !0
          },
          ...(E ? {
            zoom: {
              maxRatio: 1.5,
              limitToOriginalSize: !0
            }
          } : {}),
          onZoomChange: (se, ue) => {
            Y(ue > 1);
          },
          grabCursor: !0,
          slidesPerView: ne,
          spaceBetween: le,
          onMouseEnter: K,
          onMouseLeave: G,
          onFocus: K,
          ...ae,
          children: [c.map((se, ue) => /* @__PURE__ */B.jsx(DN, {
            zoom: E && !W,
            onClick: x,
            className: E ? Dc.swiperSlide : void 0,
            children: w(se, {
              className: Dc.slideImage,
              aspectRatio: p,
              namedTransformation: h,
              transformation: y
            })
          }, se.id || ue)), D]
        }), c.length > 1 && /* @__PURE__ */B.jsxs(B.Fragment, {
          children: [/* @__PURE__ */B.jsx("button", {
            type: "button",
            className: ve(Dc.navigationButton, Dc.navigationButtonPrev, i == null ? void 0 : i.navigationButton, i == null ? void 0 : i.navigationButtonPrev, {
              [Dc.navigationButtonDisabled]: O,
              [(i == null ? void 0 : i.navigationButtonDisabled) ?? ""]: O
            }),
            "aria-label": ce.prevSlideMessage,
            "aria-disabled": O,
            "aria-hidden": O,
            disabled: O,
            onClick: se => {
              var ue;
              se.stopPropagation(), (ue = L.current) == null || ue.slidePrev();
            },
            children: /* @__PURE__ */B.jsx(ln, {
              name: "chevron-left",
              className: ve(Dc.navigationButtonIcon, i == null ? void 0 : i.navigationButtonIcon)
            })
          }), /* @__PURE__ */B.jsx("button", {
            type: "button",
            className: ve(Dc.navigationButton, Dc.navigationButtonNext, i == null ? void 0 : i.navigationButton, i == null ? void 0 : i.navigationButtonNext, {
              [Dc.navigationButtonDisabled]: j,
              [(i == null ? void 0 : i.navigationButtonDisabled) ?? ""]: j
            }),
            "aria-label": ce.nextSlideMessage,
            "aria-disabled": j,
            "aria-hidden": j,
            disabled: j,
            onClick: se => {
              var ue;
              se.stopPropagation(), (ue = L.current) == null || ue.slideNext();
            },
            children: /* @__PURE__ */B.jsx(ln, {
              name: "chevron-right",
              className: ve(Dc.navigationButtonIcon, i == null ? void 0 : i.navigationButtonIcon)
            })
          })]
        })]
      }), (E || C) && /* @__PURE__ */B.jsxs("div", {
        className: Dc.footerContainer,
        children: [E && /* @__PURE__ */B.jsx("span", {
          className: Dc.slideLabelMessage,
          style: {
            "--_slidesPerView": ne,
            "--_spaceBetween": `${le}px`
          },
          children: (H = (de = ce.slideLabelMessage) == null ? void 0 : de.replace("{{index}}", `${Q + 1}`)) == null ? void 0 : H.replace("{{slidesLength}}", `${c.length}`)
        }), C && /* @__PURE__ */B.jsx("div", {
          ref: P,
          className: ve("swiper-pagination", Dc.pagination, i == null ? void 0 : i.pagination)
        })]
      })]
    });
  },
  Cne = "_tagsContainer_1mpvn_1",
  kne = "_tag_1mpvn_1",
  Tne = "_tagLabel_1mpvn_26",
  Rne = "_tagIcon_1mpvn_29",
  Dne = "_tagImage_1mpvn_36",
  Ine = "_tagContent_1mpvn_44",
  Lx = {
    tagsContainer: Cne,
    tag: kne,
    tagLabel: Tne,
    tagIcon: Rne,
    tagImage: Dne,
    tagContent: Ine
  },
  u$ = ({
    tags: t,
    className: e
  }) => /* @__PURE__ */B.jsx("div", {
    className: ve(Lx.tagsContainer, e),
    "data-gallery-tags": !0,
    children: t == null ? void 0 : t.map((i, s) => {
      var p, h, y, w, x, E, C, k, D;
      const c = !!((p = i == null ? void 0 : i.image) != null && p.source);
      return /* @__PURE__ */B.jsxs("div", {
        className: Lx.tag,
        children: [/* @__PURE__ */B.jsxs("span", {
          className: Lx.tagLabel,
          children: [i.icon && (!i.image || !i.image.source) && /* @__PURE__ */B.jsx(ln, {
            className: Lx.tagIcon,
            name: i == null ? void 0 : i.icon
          }), c && /* @__PURE__ */B.jsx("span", {
            className: ve(Lx.tagIcon, Lx.tagImage),
            children: /* @__PURE__ */B.jsx(Ym, {
              src: (y = (h = i.image) == null ? void 0 : h.source) == null ? void 0 : y.src,
              srcSet: (x = (w = i.image) == null ? void 0 : w.source) == null ? void 0 : x.srcSet,
              sizes: (C = (E = i.image) == null ? void 0 : E.source) == null ? void 0 : C.sizes,
              source: (k = i.image) == null ? void 0 : k.source,
              alt: ((D = i.image) == null ? void 0 : D.alt) ?? "",
              loading: "lazy"
            })
          }), /* @__PURE__ */B.jsx("strong", {
            children: i.label
          })]
        }), (i == null ? void 0 : i.content) && /* @__PURE__ */B.jsx("div", {
          className: Lx.tagContent,
          children: i.content
        })]
      }, s);
    })
  }),
  Mne = "_galleryWrapper_1iwbj_2",
  Lne = "_galleryButton_1iwbj_11",
  One = "_galleryButtonLabel_1iwbj_35",
  Pne = "_galleryIconCircle_1iwbj_40",
  Ane = "_galleryIcon_1iwbj_40",
  jne = "_slideCount_1iwbj_69",
  Fne = "_modal_1iwbj_81",
  Nne = "_modalNav_1iwbj_122",
  zne = "_closeButton_1iwbj_126",
  Vne = "_modalCloseButton_1iwbj_135",
  Bne = "_modalGalleryContainer_1iwbj_144",
  Une = "_swiperContainer_1iwbj_164",
  Hne = "_swiper_1iwbj_164",
  $ne = "_navigationButton_1iwbj_174",
  Wne = "_embedded_1iwbj_193",
  qne = "_loader_1iwbj_197",
  Yne = "_spinning_1iwbj_1",
  U0 = {
    galleryWrapper: Mne,
    default: "_default_1iwbj_2",
    galleryButton: Lne,
    galleryButtonLabel: One,
    galleryIconCircle: Pne,
    galleryIcon: Ane,
    slideCount: jne,
    modal: Fne,
    modalNav: Nne,
    closeButton: zne,
    modalCloseButton: Vne,
    modalGalleryContainer: Bne,
    swiperContainer: Une,
    swiper: Hne,
    navigationButton: $ne,
    embedded: Wne,
    loader: qne,
    spinning: Yne
  },
  Gne = kF(() => import("./GalleryModal-CZP1RW9Q.js").then(t => ({
    default: t.GalleryModal
  }))),
  Xne = ({
    labels: t,
    tags: e,
    images: i = [],
    renderImage: s,
    className: c,
    modalImages: p,
    variant: h = "default",
    isClickDisabled: y = !1,
    isNested: w = !1,
    aspectRatio: x = hB["16:9"],
    cloudinaryNamedTransformation: E,
    cloudinaryTransformation: C,
    modalAspectRatio: k,
    modalCloudinaryNamedTransformation: D,
    modalCloudinaryTransformation: I,
    onImageChange: L,
    initialImage: P
  }) => {
    const N = {
        ...EN,
        ...t
      },
      O = p || i,
      F = {
        firstSlideMessage: N.firstSlideMessage,
        lastSlideMessage: N.lastSlideMessage,
        prevSlideMessage: N.prevSlideMessage,
        nextSlideMessage: N.nextSlideMessage,
        paginationBulletMessage: N.paginationBulletMessage,
        slideLabelMessage: N.slideLabelMessage
      },
      {
        isXs: j,
        isSm: V
      } = WL(),
      [K, G] = rt(!1),
      [Q, te] = rt(0),
      [ie, Y] = Fee(j || V ? hB["1:1"] : x, E);
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs(Ene, {
        labels: F,
        images: i,
        aspectRatio: ie,
        cloudinaryNamedTransformation: Y,
        cloudinaryTransformation: C,
        renderImage: s || H4,
        ...(h === "clickable" && !y ? {
          onSlideClick: () => G(!0)
        } : {}),
        modalMode: !1,
        className: ve(U0.galleryWrapper, h && U0[h], c),
        showPagination: h !== "embedded",
        swiperProps: {
          enabled: i.length > 1,
          onSlideChange: ee => {
            te(ee.activeIndex), L == null || L(ee.activeIndex);
          },
          initialSlide: P
        },
        children: [e && e.length > 0 && /* @__PURE__ */B.jsx(u$, {
          tags: e
        }), i.length > 1 && h === "default" && /* @__PURE__ */B.jsxs("button", {
          slot: "container-start",
          type: "button",
          "aria-label": N.openModalLabel,
          className: U0.galleryButton,
          onClick: () => {
            G(!0);
          },
          children: [K ? /* @__PURE__ */B.jsx("span", {
            className: U0.loader
          }) : /* @__PURE__ */B.jsx("span", {
            className: U0.galleryIconCircle,
            children: /* @__PURE__ */B.jsx(ln, {
              className: U0.galleryIcon,
              name: "copy-micro"
            })
          }), /* @__PURE__ */B.jsx("span", {
            className: U0.galleryButtonLabel,
            children: N.openModalLabel
          })]
        }), i.length > 1 && h === "clickable" && /* @__PURE__ */B.jsx("span", {
          slot: "container-start",
          className: U0.slideCount,
          children: `${Q + 1}/${i.length}`
        })]
      }, i == null ? void 0 : i.length), h !== "embedded" && K && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx(Gne, {
          labels: N,
          images: O,
          isOpen: K,
          onClose: ee => {
            w && ee && ee.stopPropagation(), G(!1);
          },
          initialSlide: Q,
          aspectRatio: k,
          cloudinaryNamedTransformation: D,
          cloudinaryTransformation: I,
          isNested: w
        })
      })]
    });
  },
  Kne = "_galleryWrapper_ywarp_1",
  Qne = "_galleryButton_ywarp_4",
  Zne = "_gallery_ywarp_1",
  Jne = "_galleryVideo_ywarp_80",
  ere = "_galleryVideoIcon_ywarp_90",
  tre = "_galleryIconCircle_ywarp_129",
  nre = "_galleryIcon_ywarp_129",
  H0 = {
    galleryWrapper: Kne,
    galleryButton: Qne,
    gallery: Zne,
    galleryVideo: Jne,
    galleryVideoIcon: ere,
    galleryIconCircle: tre,
    galleryIcon: nre
  },
  rre = kF(() => import("./GalleryModal-CZP1RW9Q.js").then(t => ({
    default: t.GalleryModal
  }))),
  H_e = ({
    labels: t,
    images: e = [],
    tags: i,
    modalImages: s,
    modalAspectRatio: c,
    modalCloudinaryNamedTransformation: p,
    modalCloudinaryTransformation: h,
    className: y
  }) => {
    const w = s || e,
      [x, E] = rt(!1),
      [C, k] = rt(0),
      D = {
        ...EN,
        ...t
      };
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(H0.galleryWrapper, y),
      children: [/* @__PURE__ */B.jsx("div", {
        className: H0.gallery,
        children: e.map((I, L) => {
          var N, O, F;
          const P = I.type === "video";
          return /* @__PURE__ */B.jsxs("div", {
            className: ve(P && H0.galleryVideo),
            onClick: () => {
              E(!0), k(L);
            },
            onKeyDown: j => {
              (j.key === "Enter" || j.key === " ") && (j.preventDefault(), E(!0), k(L));
            },
            role: "button",
            "aria-label": P ? D.playVideo : `${D.viewImage} ${L + 1}`,
            tabIndex: 0,
            children: [/* @__PURE__ */B.jsx(Ym, {
              src: P ? I.poster : (N = I.source) == null ? void 0 : N.src,
              srcSet: P || (O = I.source) == null ? void 0 : O.srcSet,
              sizes: P || (F = I.source) == null ? void 0 : F.sizes,
              source: P ? void 0 : I.source,
              alt: I.alt ?? `Image ${L + 1}`,
              loading: "lazy"
            }), P && /* @__PURE__ */B.jsx(ln, {
              name: "play-micro",
              className: H0.galleryVideoIcon
            })]
          }, I.id ?? `${I.type}-${L}`);
        })
      }), i && i.length > 0 && /* @__PURE__ */B.jsx(u$, {
        tags: i
      }), e.length > 0 && /* @__PURE__ */B.jsxs("button", {
        type: "button",
        className: H0.galleryButton,
        onClick: () => E(!0),
        children: [x ? /* @__PURE__ */B.jsx("span", {
          className: H0.loader
        }) : /* @__PURE__ */B.jsx("span", {
          className: H0.galleryIconCircle,
          children: /* @__PURE__ */B.jsx(ln, {
            className: H0.galleryIcon,
            name: "copy-micro"
          })
        }), D.openModalLabel]
      }), x && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx(rre, {
          labels: D,
          images: w,
          isOpen: x,
          onClose: () => E(!1),
          initialSlide: C,
          aspectRatio: c,
          cloudinaryNamedTransformation: p,
          cloudinaryTransformation: h
        })
      })]
    });
  },
  ire = "_roomCard_1ovad_1",
  are = "_cardLink_1ovad_9",
  ore = "_roomCardGallery_1ovad_37",
  lre = "_roomCardImage_1ovad_40",
  sre = "_roomCardContainer_1ovad_43",
  ure = "_roomCardHeading_1ovad_48",
  cre = "_roomCardDetails_1ovad_66",
  dre = "_roomCardDetailsIcon_1ovad_88",
  fre = "_roomCardExtra_1ovad_96",
  pre = "_roomCardDetailsLink_1ovad_107",
  hre = "_roomCardSubTitle_1ovad_111",
  mre = "_galleryButton_1ovad_115",
  vre = "_galleryIconCircle_1ovad_129",
  gre = "_galleryIcon_1ovad_129",
  yre = "_modal_1ovad_148",
  bre = "_modalGalleryContainer_1ovad_177",
  wre = "_modalContent_1ovad_185",
  _re = "_roomCardModalBody_1ovad_189",
  xre = "_modalHeader_1ovad_196",
  Sre = "_closeButton_1ovad_203",
  tp = {
    roomCard: ire,
    cardLink: are,
    roomCardGallery: ore,
    roomCardImage: lre,
    roomCardContainer: sre,
    roomCardHeading: ure,
    roomCardDetails: cre,
    roomCardDetailsIcon: dre,
    roomCardExtra: fre,
    roomCardDetailsLink: pre,
    roomCardSubTitle: hre,
    galleryButton: mre,
    galleryIconCircle: vre,
    galleryIcon: gre,
    modal: yre,
    modalGalleryContainer: bre,
    modalContent: wre,
    roomCardModalBody: _re,
    modalHeader: xre,
    closeButton: Sre
  },
  Ere = kF(() => import("./RoomCardModal-B9szk8Yv.js").then(t => ({
    default: t.RoomCardModal
  }))),
  $_e = ({
    images: t,
    header: e,
    link: i,
    labels: s,
    roomDetails: c,
    modalImages: p,
    headerAs: h = "h2",
    className: y,
    theme: w = "light"
  }) => {
    const [x, E] = rt(!1),
      [C, k] = rt(0),
      D = p || t;
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs("div", {
        className: ve(tp.roomCard, y),
        "data-theme": w,
        children: [t && t.length > 0 && /* @__PURE__ */B.jsxs("div", {
          className: tp.roomCardImage,
          children: [/* @__PURE__ */B.jsx(Xne, {
            images: t,
            variant: "embedded",
            className: tp.roomCardGallery,
            onImageChange: k
          }), !!i && /* @__PURE__ */B.jsx("button", {
            type: "button",
            "aria-label": s == null ? void 0 : s.openModalLabel,
            className: tp.galleryButton,
            onClick: () => E(!0),
            children: /* @__PURE__ */B.jsx("span", {
              className: tp.galleryIconCircle,
              children: /* @__PURE__ */B.jsx(ln, {
                hidden: !0,
                className: tp.galleryIcon,
                name: "copy-micro"
              })
            })
          })]
        }), /* @__PURE__ */B.jsxs("div", {
          className: tp.roomCardContainer,
          children: [/* @__PURE__ */B.jsxs("div", {
            className: tp.roomCardBody,
            children: [e && /* @__PURE__ */B.jsx(cu, {
              size: "sm",
              className: tp.roomCardHeading,
              Tag: h,
              children: e
            }), (c == null ? void 0 : c.primary) && c.primary.length > 0 && /* @__PURE__ */B.jsx("div", {
              className: tp.roomCardDetails,
              children: /* @__PURE__ */B.jsx("ul", {
                children: c.primary.map((I, L) => /* @__PURE__ */B.jsxs("li", {
                  children: [I.icon && /* @__PURE__ */B.jsx(ln, {
                    name: I.icon,
                    title: I.label,
                    className: tp.roomCardDetailsIcon
                  }), I.label]
                }, L))
              })
            })]
          }), !!i && /* @__PURE__ */B.jsx("div", {
            className: tp.roomCardDetailsLink,
            children: /* @__PURE__ */B.jsx(dd, {
              className: tp.cardLink,
              href: i.href,
              target: i == null ? void 0 : i.target,
              variant: w,
              size: "md",
              onClick: I => {
                I.preventDefault(), E(!0);
              },
              icon: (i == null ? void 0 : i.icon) ?? "arrow-right-micro",
              children: i == null ? void 0 : i.children
            })
          })]
        })]
      }), x && D && /* @__PURE__ */B.jsx(TF, {
        fallback: null,
        children: /* @__PURE__ */B.jsx(Ere, {
          labels: {
            ...s,
            closeModal: (s == null ? void 0 : s.closeModal) ?? "Close"
          },
          roomDetails: c,
          header: e,
          images: D,
          isOpen: x,
          initialImage: C,
          onClose: () => E(!1)
        })
      })]
    });
  },
  Cre = "_theme_1x4et_1",
  kre = "_themeUi_1x4et_9",
  Tre = "_themeLabel_1x4et_19",
  Rre = "_themeHelperText_1x4et_26",
  Dre = "_themeError_1x4et_33",
  Ire = "_themeErrorMsg_1x4et_44",
  Mre = "_themeDisabled_1x4et_47",
  $0 = {
    theme: Cre,
    themeUi: kre,
    themeLabel: Tre,
    themeHelperText: Rre,
    themeError: Dre,
    themeErrorMsg: Ire,
    themeDisabled: Mre
  },
  H2 = ({
    id: t,
    label: e,
    helperText: i,
    isDisabled: s = !1,
    isSelected: c = !1,
    onChange: p,
    className: h,
    classNames: y,
    isRequired: w = !1,
    errorMessage: x,
    isError: E = !1
  }) => {
    const C = (k, D, I) => {
      p == null || p(k, D, I);
    };
    return /* @__PURE__ */B.jsx(v9, {
      id: t,
      label: e,
      helperText: i,
      isDisabled: s,
      isSelected: c,
      onChange: C,
      className: ve($0.theme, h),
      classNames: {
        disabled: ve($0.themeDisabled, y == null ? void 0 : y.disabled),
        error: ve($0.themeError, y == null ? void 0 : y.error),
        wrapper: ve($0.themeWrapper, y == null ? void 0 : y.wrapper),
        labelWrapper: y == null ? void 0 : y.labelWrapper,
        label: ve($0.themeLabel, y == null ? void 0 : y.label),
        helperText: ve($0.themeHelperText, y == null ? void 0 : y.helperText),
        errorMsg: ve($0.themeErrorMsg, y == null ? void 0 : y.errorMsg),
        ui: ve($0.themeUi, y == null ? void 0 : y.ui)
      },
      isRequired: w,
      errorMessage: s ? "" : x,
      isError: s ? !1 : E
    });
  },
  K1 = {
    default: "default",
    extended: "extended",
    noControls: "no-controls"
  },
  Lre = "_pagination_c5x11_1",
  Ore = "_paginationBtn_c5x11_13",
  Pre = "_text_c5x11_32",
  Are = "_btnIcon_c5x11_46",
  jre = "_text__label_c5x11_53",
  Fre = "_active_c5x11_57",
  Nre = "_paginationList_c5x11_72",
  zre = "_paginationList__Mobile_c5x11_131",
  ms = {
    pagination: Lre,
    paginationBtn: Ore,
    text: Pre,
    btnIcon: Are,
    text__label: jre,
    active: Fre,
    paginationList: Nre,
    paginationList__Mobile: zre
  },
  Vre = {
    first: "First",
    back: "Back",
    last: "Last",
    next: "Next",
    of: "of"
  },
  Bre = ({
    labels: t,
    variant: e = K1.default,
    totalItems: i,
    currentPageIndex: s,
    visibleRange: c = {
      start: 1,
      end: 4
    },
    handleSlideTo: p,
    theme: h = "light",
    pageSize: y = 10
  }) => {
    const w = {
        ...Vre,
        ...t
      },
      x = ci(() => {
        if (e === K1.noControls && c) return c;
        const P = c.end - c.start + 1,
          N = Math.floor(P / 2);
        let O = Math.max(1, s - N),
          F = O + P - 1;
        return F > i && (F = i, O = Math.max(1, F - P + 1)), O < 1 && (O = 1, F = P), {
          start: O,
          end: F
        };
      }, [c, s, i, e]),
      E = Math.ceil(i / y),
      C = Array.from({
        length: E
      }, (P, N) => ({
        key: N + 1,
        label: N + 1
      })),
      k = s === 1,
      D = s === E,
      I = e !== K1.noControls,
      L = e === K1.extended;
    return /* @__PURE__ */B.jsxs("nav", {
      className: ms.pagination,
      "data-variant": e,
      "data-theme": h,
      children: [L && /* @__PURE__ */B.jsxs(vM, {
        className: ms.text,
        onClick: () => p(1),
        disabled: k,
        children: [/* @__PURE__ */B.jsx(ln, {
          name: "ends-start-micro",
          className: ms.btnIcon
        }), /* @__PURE__ */B.jsx("span", {
          className: ms.text__label,
          children: w.first
        })]
      }), I && /* @__PURE__ */B.jsxs(vM, {
        className: ms.text,
        onClick: () => p(s - 1),
        disabled: k,
        children: [/* @__PURE__ */B.jsx(ln, {
          name: e !== K1.extended && k ? "nope" : "chevron-left-micro",
          className: ms.btnIcon
        }), " ", /* @__PURE__ */B.jsx("span", {
          className: ms.text__label,
          children: w.back
        })]
      }), /* @__PURE__ */B.jsxs("ul", {
        className: ms.paginationList,
        children: [/* @__PURE__ */B.jsx(Ure, {
          items: C.slice(x.start - 1, x.end),
          currentPageIndex: s,
          handleSlideTo: p
        }), /* @__PURE__ */B.jsxs("li", {
          className: ms.paginationList__Mobile,
          children: [s, " ", w.of, " ", E]
        })]
      }), I && /* @__PURE__ */B.jsxs(vM, {
        className: ms.text,
        onClick: () => p(s + 1),
        disabled: D,
        children: [/* @__PURE__ */B.jsx("span", {
          className: ms.text__label,
          children: w.next
        }), /* @__PURE__ */B.jsx(ln, {
          name: e !== K1.extended && D ? "nope" : "chevron-right-micro",
          className: ms.btnIcon
        })]
      }), L && /* @__PURE__ */B.jsxs(vM, {
        className: ms.text,
        onClick: () => p(E),
        disabled: D,
        children: [/* @__PURE__ */B.jsx("span", {
          className: ms.text__label,
          children: w.last
        }), /* @__PURE__ */B.jsx(ln, {
          name: "ends-end-micro",
          className: ms.btnIcon
        })]
      })]
    });
  },
  vM = ({
    children: t,
    onClick: e,
    disabled: i,
    className: s,
    ...c
  }) => /* @__PURE__ */B.jsx("button", {
    className: ve(ms.paginationBtn, s),
    type: "button",
    onClick: e,
    disabled: i,
    ...c,
    children: t
  }),
  Ure = ({
    items: t,
    currentPageIndex: e,
    handleSlideTo: i
  }) => t.map(s => {
    const c = e === s.key;
    return /* @__PURE__ */B.jsx("li", {
      children: /* @__PURE__ */B.jsx("button", {
        className: ve(ms.paginationBtn, {
          [ms.active]: c
        }),
        type: "button",
        onClick: () => i(s.key),
        children: s.label
      })
    }, s.key);
  }),
  Hre = "_paginationWrapper_13g7w_1",
  $re = {
    paginationWrapper: Hre
  },
  Wre = {
    first: "First",
    last: "Last",
    back: "Prev",
    next: "Next",
    of: "of"
  },
  W_e = ({
    labels: t,
    cardsPerPage: e = 3,
    items: i,
    colWidth: s = "220px",
    paginationVariant: c = "default",
    numberOfPaginationToDisplay: p = 5,
    theme: h = "light"
  }) => {
    var Q;
    const y = {
        ...Wre,
        ...t
      },
      {
        isXs: w,
        isSm: x,
        isMd: E
      } = WL(),
      [C, k] = rt(1),
      [D, I] = rt([]),
      [L, P] = rt({
        start: 1,
        end: p
      }),
      N = vt(0),
      O = ci(() => w ? 3 : p, [w, p]),
      F = Math.min(C, D.length || 1),
      j = pn(() => w ? 1 : x ? 2 : E ? 3 : e, [w, x, E, e]),
      V = pn(() => {
        const te = j(),
          ie = [];
        for (let ae = 0; ae < i.length; ae += te) ie.push(i.slice(ae, ae + te));
        I(ie);
        const Y = N.current,
          ee = Math.floor(Y / te) + 1;
        ee > ie.length ? k(1) : k(ee);
      }, [i, j]),
      K = pn((te, ie, Y) => {
        let ee = te - Math.floor(Y / 2);
        ee = Math.max(ee, 1);
        let ae = ee + (Y - 1);
        return ae > ie && (ae = ie, ee = Math.max(ae - (Y - 1), 1)), {
          start: ee,
          end: ae
        };
      }, []);
    Rt(() => {
      const te = j();
      N.current = (C - 1) * te, V();
    }, [i, w, x, E, V, j, C]), Rt(() => {
      P(K(C, D.length, O));
    }, [C, D.length, O, K]);
    const G = D.length;
    return /* @__PURE__ */B.jsxs("div", {
      className: $re.paginationWrapper,
      children: [G > 0 && /* @__PURE__ */B.jsx(NE, {
        cols: j(),
        minWidth: s,
        children: (Q = D[C - 1]) == null ? void 0 : Q.map(te => /* @__PURE__ */B.jsx(gb, {
          children: te.content
        }, te.id))
      }), G > 1 && /* @__PURE__ */B.jsx(Bre, {
        totalItems: i.length,
        currentPageIndex: F,
        handleSlideTo: k,
        variant: c,
        visibleRange: L,
        labels: y,
        pageSize: j(),
        theme: h
      })]
    });
  },
  qre = "_wrapper_a4qu4_1",
  Yre = {
    wrapper: qre
  },
  q_e = ({
    items: t,
    itemsPerRow: e = 3
  }) => /* @__PURE__ */B.jsx(NE, {
    cols: e,
    className: Yre.wrapper,
    children: t.map(i => /* @__PURE__ */B.jsx(gb, {
      children: i.content
    }, i.id))
  }),
  Gre = t => {
    switch (t) {
      case 2:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        };
      case 3:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        };
      case 4:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        };
      default:
        return {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          769: {
            slidesPerView: 1,
            spaceBetween: 16
          }
        };
    }
  },
  Xre = "_sliderContainer_knerz_1",
  Kre = "_paddingForNavigationButton_knerz_9",
  Qre = "_hide_knerz_14",
  Zre = "_desktopOnly_knerz_18",
  Jre = "_swiper_knerz_5",
  eie = "_swiperPadding_knerz_33",
  tie = "_swiperSlide_knerz_37",
  nie = "_slideImage_knerz_41",
  rie = "_navigationButton_knerz_46",
  iie = "_navigationButtonPrev_knerz_63",
  aie = "_navigationButtonNext_knerz_71",
  oie = "_active_knerz_87",
  lie = "_navigationButtonIcon_knerz_91",
  sie = "_pagination_knerz_100",
  uie = "_slideLabelMessage_knerz_125",
  Ic = {
    sliderContainer: Xre,
    paddingForNavigationButton: Kre,
    hide: Qre,
    desktopOnly: Zre,
    swiper: Jre,
    swiperPadding: eie,
    swiperSlide: tie,
    slideImage: nie,
    navigationButton: rie,
    navigationButtonPrev: iie,
    navigationButtonNext: aie,
    active: oie,
    navigationButtonIcon: lie,
    pagination: sie,
    slideLabelMessage: uie
  },
  cie = {
    firstSlideMessage: "This is the first slide",
    lastSlideMessage: "This is the last slide",
    prevSlideMessage: "Previous slide",
    nextSlideMessage: "Next slide",
    paginationBulletMessage: "Go to slide {{index}}",
    slideLabelMessage: "{{index}} of {{slidesLength}}"
  },
  Y_e = ({
    id: t,
    slides: e,
    link: i,
    theme: s,
    renderLink: c,
    labels: p,
    className: h,
    slidesPerView: y = 3,
    breakpoints: w = Gre(y),
    navigationType: x,
    paginationType: E
  }) => {
    const C = {
        ...cie,
        ...p
      },
      k = vt(null),
      [D, I] = rt(!0),
      [L, P] = rt(!1),
      N = vt(null),
      O = () => {
        var V, K, G, Q;
        (Q = (G = (K = (V = N.current) == null ? void 0 : V.swiper) == null ? void 0 : K.keyboard) == null ? void 0 : G.enable) == null || Q.call(G);
      },
      F = () => {
        var V, K, G, Q;
        (Q = (G = (K = (V = N.current) == null ? void 0 : V.swiper) == null ? void 0 : K.keyboard) == null ? void 0 : G.disable) == null || Q.call(G);
      },
      j = (V, K) => typeof V == "function" ? V({
        theme: K
      }) : V;
    return /* @__PURE__ */B.jsx(B.Fragment, {
      children: e.length > 1 ? /* @__PURE__ */B.jsxs("div", {
        className: ve(Ic.sliderContainer, Ic.paddingForNavigationButton, x && Ic[x], h),
        onMouseEnter: O,
        onMouseLeave: F,
        onFocus: O,
        onBlur: F,
        "data-theme": s,
        children: [/* @__PURE__ */B.jsxs(B.Fragment, {
          children: [/* @__PURE__ */B.jsx("button", {
            className: ve(Ic.navigationButton, Ic.navigationButtonPrev),
            type: "button",
            "aria-label": C.prevSlideMessage,
            "aria-disabled": D,
            onClick: () => {
              var V;
              return (V = k.current) == null ? void 0 : V.slidePrev();
            },
            disabled: D,
            children: /* @__PURE__ */B.jsx(ln, {
              name: "chevron-left",
              className: Ic.navigationButtonIcon
            })
          }, "navigationButtonPrev"), /* @__PURE__ */B.jsx("button", {
            id: t,
            className: ve(Ic.navigationButton, Ic.navigationButtonNext),
            type: "button",
            "aria-label": C.nextSlideMessage,
            "aria-disabled": L,
            disabled: L,
            onClick: () => {
              var V;
              return (V = k.current) == null ? void 0 : V.slideNext();
            },
            children: /* @__PURE__ */B.jsx(ln, {
              name: "chevron-right",
              className: Ic.navigationButtonIcon
            })
          }, "navigationButtonNext")]
        }), /* @__PURE__ */B.jsx("div", {
          children: /* @__PURE__ */B.jsx(RN, {
            onSwiper: V => {
              k.current = V, I(V.isBeginning), P(V.isEnd);
            },
            onSlideChange: V => {
              I(V.isBeginning), P(V.isEnd);
            },
            ref: N,
            className: ve(Ic.swiper, Ic.swiperPadding),
            modules: [K4, X4, q4, Y4, G4],
            pagination: {
              el: `.swiper-pagination-${t}`,
              dynamicBullets: !0,
              dynamicMainBullets: 3,
              clickable: !0,
              type: "bullets"
            },
            a11y: {
              firstSlideMessage: C.firstSlideMessage,
              lastSlideMessage: C.lastSlideMessage,
              prevSlideMessage: C.prevSlideMessage,
              nextSlideMessage: C.nextSlideMessage,
              paginationBulletMessage: C.paginationBulletMessage,
              slideLabelMessage: C.slideLabelMessage
            },
            keyboard: {
              enabled: !1
            },
            centeredSlides: !1,
            grabCursor: !0,
            slidesPerView: y,
            breakpoints: w,
            children: e.map((V, K) => /* @__PURE__ */B.jsx(DN, {
              className: Ic.swiperSlide,
              children: j(V.view)
            }, V.id || K))
          }, t)
        }), /* @__PURE__ */B.jsx("div", {
          className: ve("swiper-pagination", `swiper-pagination-${t}`, Ic.pagination, E && Ic[E])
        })]
      }) : /* @__PURE__ */B.jsxs(B.Fragment, {
        children: [/* @__PURE__ */B.jsx(NE, {
          cols: 3,
          children: /* @__PURE__ */B.jsx(gb, {
            children: e.map(V => j(V.view, s))
          })
        }), !!i && /* @__PURE__ */B.jsx(dd, {
          renderLink: c,
          icon: "arrow-right-micro",
          href: i.href,
          variant: s,
          className: Ic.cardLink,
          children: i == null ? void 0 : i.children
        })]
      })
    });
  };
var $M = {
  exports: {}
};
/*! Case - v1.6.2 - 2020-03-24
* Copyright (c) 2020 Nathan Bubna; Licensed MIT, GPL */
var die = $M.exports,
  _B;
function fie() {
  return _B || (_B = 1, function (t) {
    (function () {
      var e = function (D, I) {
          return I = I || "", D.replace(/(^|-)/g, "$1\\u" + I).replace(/,/g, "\\u" + I);
        },
        i = e("20-26,28-2F,3A-40,5B-60,7B-7E,A0-BF,D7,F7", "00"),
        s = "a-z" + e("DF-F6,F8-FF", "00"),
        c = "A-Z" + e("C0-D6,D8-DE", "00"),
        p = "A|An|And|As|At|But|By|En|For|If|In|Of|On|Or|The|To|Vs?\\.?|Via",
        h = function (D, I, L, P) {
          return D = D || i, I = I || s, L = L || c, P = P || p, {
            capitalize: new RegExp("(^|[" + D + "])([" + I + "])", "g"),
            pascal: new RegExp("(^|[" + D + "])+([" + I + L + "])", "g"),
            fill: new RegExp("[" + D + "]+(.|$)", "g"),
            sentence: new RegExp('(^\\s*|[\\?\\!\\.]+"?\\s+"?|,\\s+")([' + I + "])", "g"),
            improper: new RegExp("\\b(" + P + ")\\b", "g"),
            relax: new RegExp("([^" + L + "])([" + L + "]*)([" + L + "])(?=[^" + L + "]|$)", "g"),
            upper: new RegExp("^[^" + I + "]+$"),
            hole: /[^\s]\s[^\s]/,
            apostrophe: /'/g,
            room: new RegExp("[" + D + "]")
          };
        },
        y = h(),
        w = {
          re: y,
          unicodes: e,
          regexps: h,
          types: [],
          up: String.prototype.toUpperCase,
          low: String.prototype.toLowerCase,
          cap: function (D) {
            return w.up.call(D.charAt(0)) + D.slice(1);
          },
          decap: function (D) {
            return w.low.call(D.charAt(0)) + D.slice(1);
          },
          deapostrophe: function (D) {
            return D.replace(y.apostrophe, "");
          },
          fill: function (D, I, L) {
            return I != null && (D = D.replace(y.fill, function (P, N) {
              return N ? I + N : "";
            })), L && (D = w.deapostrophe(D)), D;
          },
          prep: function (D, I, L, P) {
            if (D = D == null ? "" : D + "", !P && y.upper.test(D) && (D = w.low.call(D)), !I && !y.hole.test(D)) {
              var N = w.fill(D, " ");
              y.hole.test(N) && (D = N);
            }
            return !L && !y.room.test(D) && (D = D.replace(y.relax, w.relax)), D;
          },
          relax: function (D, I, L, P) {
            return I + " " + (L ? L + " " : "") + P;
          }
        },
        x = {
          _: w,
          of: function (D) {
            for (var I = 0, L = w.types.length; I < L; I++) if (x[w.types[I]].apply(x, arguments) === D) return w.types[I];
          },
          flip: function (D) {
            return D.replace(/\w/g, function (I) {
              return (I == w.up.call(I) ? w.low : w.up).call(I);
            });
          },
          random: function (D) {
            return D.replace(/\w/g, function (I) {
              return (Math.round(Math.random()) ? w.up : w.low).call(I);
            });
          },
          type: function (D, I) {
            x[D] = I, w.types.push(D);
          }
        },
        E = {
          lower: function (D, I, L) {
            return w.fill(w.low.call(w.prep(D, I)), I, L);
          },
          snake: function (D) {
            return x.lower(D, "_", !0);
          },
          constant: function (D) {
            return x.upper(D, "_", !0);
          },
          camel: function (D) {
            return w.decap(x.pascal(D));
          },
          kebab: function (D) {
            return x.lower(D, "-", !0);
          },
          upper: function (D, I, L) {
            return w.fill(w.up.call(w.prep(D, I, !1, !0)), I, L);
          },
          capital: function (D, I, L) {
            return w.fill(w.prep(D).replace(y.capitalize, function (P, N, O) {
              return N + w.up.call(O);
            }), I, L);
          },
          header: function (D) {
            return x.capital(D, "-", !0);
          },
          pascal: function (D) {
            return w.fill(w.prep(D, !1, !0).replace(y.pascal, function (I, L, P) {
              return w.up.call(P);
            }), "", !0);
          },
          title: function (D) {
            return x.capital(D).replace(y.improper, function (I, L, P, N) {
              return P > 0 && P < N.lastIndexOf(" ") ? w.low.call(I) : I;
            });
          },
          sentence: function (D, I, L) {
            return D = x.lower(D).replace(y.sentence, function (P, N, O) {
              return N + w.up.call(O);
            }), I && I.forEach(function (P) {
              D = D.replace(new RegExp("\\b" + x.lower(P) + "\\b", "g"), w.cap);
            }), L && L.forEach(function (P) {
              D = D.replace(new RegExp("(\\b" + x.lower(P) + "\\. +)(\\w)"), function (N, O, F) {
                return O + w.low.call(F);
              });
            }), D;
          }
        };
      E.squish = E.pascal, x.default = x;
      for (var C in E) x.type(C, E[C]);
      var k = typeof k == "function" ? k : function () {};
      k(t.exports ? t.exports = x : this.Case = x);
    }).call(die);
  }($M)), $M.exports;
}
var oE = fie();
const gs = {
    color: {
      white: {
        value: "#FFFFFF"
      },
      teal: {
        500: {
          value: "#00AAA6"
        }
      },
      gray: {
        400: {
          value: "#DBDCDC"
        },
        500: {
          value: "#F0F0F0"
        }
      }
    }
  },
  pie = "_container_q5fpq_1",
  hie = "_inputBorder_q5fpq_5",
  mie = "_inputHelperText_q5fpq_13",
  vie = "_inputErrorText_q5fpq_22",
  gie = "_input_q5fpq_5",
  yie = "_inputWrapperFocus_q5fpq_31",
  bie = "_inputWrapperOpen_q5fpq_38",
  wie = "_listBox_q5fpq_44",
  _ie = "_inputWrapperError_q5fpq_48",
  xie = "_inputLabel_q5fpq_54",
  Sie = "_inputWrapperDisabled_q5fpq_58",
  Eie = "_inputWrapperSelected_q5fpq_87",
  Cie = "_value_q5fpq_98",
  kie = "_loader_q5fpq_106",
  Tie = "_icon_q5fpq_112",
  Rie = "_iconError_q5fpq_120",
  Die = "_iconDisabled_q5fpq_124",
  Iie = "_listHeading_q5fpq_142",
  Mie = "_listItem_q5fpq_156",
  Lie = "_itemGroup_q5fpq_162",
  Oie = "_itemActive_q5fpq_167",
  Pie = "_itemDisabled_q5fpq_167",
  Aie = "_itemSelected_q5fpq_167",
  jie = "_noResults_q5fpq_184",
  Fie = "_inputLoader_q5fpq_190",
  Nie = "_themeDefault_q5fpq_194",
  zie = "_themeGrey_q5fpq_203",
  na = {
    container: pie,
    inputBorder: hie,
    inputHelperText: mie,
    inputErrorText: vie,
    input: gie,
    inputWrapperFocus: yie,
    inputWrapperOpen: bie,
    listBox: wie,
    inputWrapperError: _ie,
    inputLabel: xie,
    inputWrapperDisabled: Sie,
    inputWrapperSelected: Eie,
    value: Cie,
    loader: kie,
    icon: Tie,
    iconError: Rie,
    iconDisabled: Die,
    listHeading: Iie,
    listItem: Mie,
    itemGroup: Lie,
    itemActive: Oie,
    itemDisabled: Pie,
    itemSelected: Aie,
    noResults: jie,
    inputLoader: Fie,
    themeDefault: Nie,
    themeGrey: zie
  },
  qT = ({
    id: t,
    data: e,
    isDisabled: i,
    errorMessage: s,
    initialSelectedItem: c,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: y,
    isAutoCloseMenu: w,
    environment: x,
    children: E,
    className: C,
    classNames: k,
    onFocus: D,
    onBlur: I,
    onChange: L,
    onOpenDropdown: P,
    label: N,
    labels: O,
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    theme: G = "default",
    isLoading: Q
  }) => /* @__PURE__ */B.jsx(vq, {
    id: t,
    label: N,
    data: e,
    isDisabled: i,
    errorMessage: s,
    initialSelectedItem: c ?? h,
    hideDisplayValue: p,
    selectedItem: h,
    iconOptions: {
      open: (y == null ? void 0 : y.open) || /* @__PURE__ */B.jsx(ln, {
        name: "chevron-up"
      }),
      close: (y == null ? void 0 : y.close) || /* @__PURE__ */B.jsx(ln, {
        name: "chevron-down"
      }),
      disabled: (y == null ? void 0 : y.disabled) || /* @__PURE__ */B.jsx(ln, {
        name: "nope"
      })
    },
    isAutoCloseMenu: w,
    environment: x,
    children: E,
    className: ve(na.container, C),
    classNames: {
      icon: ve(na.icon, k == null ? void 0 : k.icon),
      iconDisabled: ve(na.iconDisabled, k == null ? void 0 : k.iconDisabled),
      iconError: ve(na.iconError, k == null ? void 0 : k.iconError),
      inputToggleButton: ve(na.input, G && na[`theme${oE.pascal(G)}`], k == null ? void 0 : k.inputToggleButton),
      inputWrapperFocus: ve(na.inputWrapperFocus, k == null ? void 0 : k.inputWrapperFocus),
      inputWrapperOpen: ve(na.inputWrapperOpen, k == null ? void 0 : k.inputWrapperOpen),
      inputWrapperSelected: ve(na.inputWrapperSelected, k == null ? void 0 : k.inputWrapperSelected),
      inputWrapperError: ve(na.inputWrapperError, k == null ? void 0 : k.inputWrapperError),
      inputWrapperDisabled: ve(na.inputWrapperDisabled, k == null ? void 0 : k.inputWrapperDisabled),
      inputLabel: ve(na.inputLabel, k == null ? void 0 : k.inputLabel),
      inputBorder: ve(na.inputBorder, k == null ? void 0 : k.inputBorder),
      inputLoader: ve(na.inputLoader, k == null ? void 0 : k.inputLoader),
      inputErrorText: ve(na.inputHelperText, na.inputErrorText, k == null ? void 0 : k.inputErrorText),
      inputHelperText: ve(na.inputHelperText, k == null ? void 0 : k.inputHelperText),
      value: ve(na.value, k == null ? void 0 : k.value),
      loader: ve(na.loader, k == null ? void 0 : k.loader),
      listBox: ve(na.listBox, k == null ? void 0 : k.listBox),
      listHeading: ve(na.listHeading, k == null ? void 0 : k.listHeading),
      listItem: ve(na.listItem, k == null ? void 0 : k.listItem),
      itemActive: ve(na.itemActive, k == null ? void 0 : k.itemActive),
      itemDisabled: ve(na.itemDisabled, k == null ? void 0 : k.itemDisabled),
      itemGroup: ve(na.itemGroup, k == null ? void 0 : k.itemGroup),
      itemSelected: ve(na.itemSelected, k == null ? void 0 : k.itemSelected),
      noResults: ve(na.noResults, k == null ? void 0 : k.noResults)
    },
    onFocus: D,
    onBlur: I,
    onChange: L,
    onOpenDropdown: P,
    labels: O,
    helperText: F,
    renderCustomListItem: j,
    renderCustomItemContent: V,
    renderCustomLabel: K,
    isLoading: Q,
    loaderConfig: {
      strokeColor: gs.color.teal[500].value,
      trackColor: gs.color.gray[500].value
    }
  }),
  lu = [];
for (let t = 0; t < 256; ++t) lu.push((t + 256).toString(16).slice(1));
function Vie(t, e = 0) {
  return (lu[t[e + 0]] + lu[t[e + 1]] + lu[t[e + 2]] + lu[t[e + 3]] + "-" + lu[t[e + 4]] + lu[t[e + 5]] + "-" + lu[t[e + 6]] + lu[t[e + 7]] + "-" + lu[t[e + 8]] + lu[t[e + 9]] + "-" + lu[t[e + 10]] + lu[t[e + 11]] + lu[t[e + 12]] + lu[t[e + 13]] + lu[t[e + 14]] + lu[t[e + 15]]).toLowerCase();
}
let Lj;
const Bie = new Uint8Array(16);
function Uie() {
  if (!Lj) {
    if (typeof crypto > "u" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Lj = crypto.getRandomValues.bind(crypto);
  }
  return Lj(Bie);
}
const Hie = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  xB = {
    randomUUID: Hie
  };
function SB(t, e, i) {
  var c;
  if (xB.randomUUID && !t) return xB.randomUUID();
  t = t || {};
  const s = t.random ?? ((c = t.rng) == null ? void 0 : c.call(t)) ?? Uie();
  if (s.length < 16) throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, Vie(s);
}
const $ie = "_footer_4gsp9_2",
  Wie = "_footer__section__container_4gsp9_10",
  qie = "_footer__sections_4gsp9_35",
  Yie = "_footer__body_4gsp9_61",
  Gie = "_noLogo_4gsp9_78",
  Xie = "_footer__logo_4gsp9_87",
  Kie = "_footer__corporateLogo_4gsp9_98",
  Qie = "_logoImage_4gsp9_106",
  Zie = "_footer__corporateMessage_4gsp9_110",
  Jie = "_footer__section_4gsp9_10",
  eae = "_footer__section__title_4gsp9_143",
  tae = "_footer__copyright_4gsp9_152",
  nae = "_footer__bottomContainer_4gsp9_167",
  rae = "_footer__bottom_4gsp9_167",
  iae = "_footer__lang_4gsp9_195",
  aae = "_footer__links_4gsp9_205",
  oae = "_langToggle__current_4gsp9_222",
  lae = "_langToggle__alternative_4gsp9_228",
  sae = "_tab__label_4gsp9_232",
  uae = "_tab_4gsp9_232",
  cae = "_tab__label__chevron_4gsp9_255",
  dae = "_tab__content_4gsp9_314",
  mo = {
    footer: $ie,
    footer__section__container: Wie,
    footer__sections: qie,
    footer__body: Yie,
    noLogo: Gie,
    footer__logo: Xie,
    footer__corporateLogo: Kie,
    logoImage: Qie,
    footer__corporateMessage: Zie,
    footer__section: Jie,
    footer__section__title: eae,
    footer__copyright: tae,
    footer__bottomContainer: nae,
    footer__bottom: rae,
    footer__lang: iae,
    footer__links: aae,
    langToggle__current: oae,
    langToggle__alternative: lae,
    tab__label: sae,
    tab: uae,
    tab__label__chevron: cae,
    tab__content: dae
  },
  EB = ({
    renderLinks: t,
    columnData: e
  }) => {
    var i;
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(mo.footer__section, mo.tab),
      children: [/* @__PURE__ */B.jsx("input", {
        type: "checkbox",
        id: e.id
      }), /* @__PURE__ */B.jsxs("label", {
        htmlFor: e.id,
        className: ve(mo.footer__section__title, mo.tab__label),
        children: [e.title, /* @__PURE__ */B.jsx("span", {
          className: mo.tab__label__chevron
        })]
      }), /* @__PURE__ */B.jsx("div", {
        className: mo.tab__content,
        children: /* @__PURE__ */B.jsx("ul", {
          children: (i = e.links) == null ? void 0 : i.map(s => /* @__PURE__ */B.jsx("li", {
            children: t(s, mo.footer__links)
          }, s.id))
        })
      })]
    }, `column-section-${e.id}`);
  },
  G_e = ({
    className: t,
    classNames: e,
    columns: i,
    copyrightText: s,
    altLangPages: c,
    locale: p,
    langLabel: h = "Language preference",
    renderLanguageToggle: y,
    renderLinks: w = (C, k) => /* @__PURE__ */B.jsx("a", {
      className: k,
      href: C.href,
      target: C.target,
      children: C.title
    }),
    renderImage: x = C => /* @__PURE__ */B.jsx("img", {
      ...C
    }),
    logoData: E
  }) => /* @__PURE__ */B.jsxs("footer", {
    className: ve(mo.footer, t, e == null ? void 0 : e.footer),
    children: [(!!(i != null && i.length) || (E == null ? void 0 : E.logoImage) || (E == null ? void 0 : E.logoMessage)) && /* @__PURE__ */B.jsxs("div", {
      className: ve(mo.footer__body, e == null ? void 0 : e.footerBody, !(E != null && E.logoImage) && !(E != null && E.logoMessage) && mo.noLogo),
      children: [!!(i != null && i.length) && /* @__PURE__ */B.jsx("div", {
        className: mo.footer__sections,
        children: i == null ? void 0 : i.map(C => Array.isArray(C) ? /* @__PURE__ */B.jsx("div", {
          className: mo.footer__section__container,
          children: C.map(k => /* @__PURE__ */B.jsx(EB, {
            renderLinks: w,
            columnData: k
          }, k.id))
        }, SB()) : /* @__PURE__ */B.jsx("div", {
          className: mo.footer__section__container,
          children: /* @__PURE__ */B.jsx(EB, {
            renderLinks: w,
            columnData: C
          }, C.id)
        }, SB()))
      }), ((E == null ? void 0 : E.logoImage) || (E == null ? void 0 : E.logoMessage)) && /* @__PURE__ */B.jsxs("div", {
        className: mo.footer__logo,
        children: [(E == null ? void 0 : E.logoImage) && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__corporateLogo,
          children: x({
            ...E.logoImage,
            className: mo.logoImage
          })
        }), (E == null ? void 0 : E.logoMessage) && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__corporateMessage,
          children: E.logoMessage
        })]
      })]
    }), /* @__PURE__ */B.jsx("div", {
      className: ve(mo.footer__bottomContainer, e == null ? void 0 : e.footerBottomContainer),
      children: /* @__PURE__ */B.jsxs("div", {
        className: ve(mo.footer__bottom, e == null ? void 0 : e.footerBottom),
        children: [s && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__copyright,
          children: /* @__PURE__ */B.jsx("p", {
            children: s
          })
        }), y && /* @__PURE__ */B.jsx("div", {
          className: mo.footer__lang,
          children: y(c, {
            classNames: {
              currentLanguage: mo.langToggle__current,
              altLanguage: mo.langToggle__alternative
            },
            locale: p,
            select: {
              label: h
            }
          })
        })]
      })
    })]
  }),
  fae = "_headerContainer_1p01n_8",
  pae = "_headerTop_1p01n_12",
  hae = "_wrapper_1p01n_27",
  mae = "_header_1p01n_8",
  vae = "_headerWrapper_1p01n_40",
  gae = "_imageContainer_1p01n_44",
  yae = "_image_1p01n_44",
  bae = "_imageContainerMobile_1p01n_71",
  wae = "_imageContainerDesktop_1p01n_75",
  _ae = "_imageContainerMobileImage_1p01n_99",
  xae = "_nav_1p01n_104",
  Sae = "_ul_1p01n_115",
  Eae = "_li_1p01n_141",
  Cae = "_navLink_1p01n_147",
  kae = "_navLinkText_1p01n_161",
  Tae = "_menu_1p01n_181",
  Rae = "_menuButton_1p01n_186",
  Dae = "_menuIcon_1p01n_200",
  Iae = "_backToHome_1p01n_218",
  Mae = "_backToHomeMessage_1p01n_223",
  Lae = "_backToHomeIcon_1p01n_237",
  Oae = "_backToHomeText_1p01n_241",
  ni = {
    headerContainer: fae,
    headerTop: pae,
    wrapper: hae,
    header: mae,
    headerWrapper: vae,
    imageContainer: gae,
    image: yae,
    imageContainerMobile: bae,
    imageContainerDesktop: wae,
    imageContainerMobileImage: _ae,
    nav: xae,
    ul: Sae,
    li: Eae,
    navLink: Cae,
    navLinkText: kae,
    menu: Tae,
    menuButton: Rae,
    menuIcon: Dae,
    backToHome: Iae,
    backToHomeMessage: Mae,
    backToHomeIcon: Lae,
    backToHomeText: Oae
  };
var ld = function () {
  return ld = Object.assign || function (e) {
    for (var i, s = 1, c = arguments.length; s < c; s++) {
      i = arguments[s];
      for (var p in i) Object.prototype.hasOwnProperty.call(i, p) && (e[p] = i[p]);
    }
    return e;
  }, ld.apply(this, arguments);
};
function EL(t, e) {
  var i = {};
  for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && e.indexOf(s) < 0 && (i[s] = t[s]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var c = 0, s = Object.getOwnPropertySymbols(t); c < s.length; c++) e.indexOf(s[c]) < 0 && Object.prototype.propertyIsEnumerable.call(t, s[c]) && (i[s[c]] = t[s[c]]);
  return i;
}
function Pae() {
  for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
  for (var s = Array(t), c = 0, e = 0; e < i; e++) for (var p = arguments[e], h = 0, y = p.length; h < y; h++, c++) s[c] = p[h];
  return s;
}
function Aae(t, e, i) {
  if (i || arguments.length === 2) for (var s = 0, c = e.length, p; s < c; s++) (p || !(s in e)) && (p || (p = Array.prototype.slice.call(e, 0, s)), p[s] = e[s]);
  return t.concat(p || Array.prototype.slice.call(e));
}
var WM = "right-scroll-bar-position",
  qM = "width-before-scroll-bar",
  jae = "with-scroll-bars-hidden",
  Fae = "--removed-body-scroll-bar-size";
function Oj(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Nae(t, e) {
  var i = rt(function () {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return i.value;
        },
        set current(s) {
          var c = i.value;
          c !== s && (i.value = s, i.callback(s, c));
        }
      }
    };
  })[0];
  return i.callback = e, i.facade;
}
var zae = typeof window < "u" ? Bn.useLayoutEffect : Bn.useEffect,
  CB = /* @__PURE__ */new WeakMap();
function c$(t, e) {
  var i = Nae(null, function (s) {
    return t.forEach(function (c) {
      return Oj(c, s);
    });
  });
  return zae(function () {
    var s = CB.get(i);
    if (s) {
      var c = new Set(s),
        p = new Set(t),
        h = i.current;
      c.forEach(function (y) {
        p.has(y) || Oj(y, null);
      }), p.forEach(function (y) {
        c.has(y) || Oj(y, h);
      });
    }
    CB.set(i, t);
  }, [t]), i;
}
function d$(t) {
  return t;
}
function f$(t, e) {
  e === void 0 && (e = d$);
  var i = [],
    s = !1,
    c = {
      read: function () {
        if (s) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return i.length ? i[i.length - 1] : t;
      },
      useMedium: function (p) {
        var h = e(p, s);
        return i.push(h), function () {
          i = i.filter(function (y) {
            return y !== h;
          });
        };
      },
      assignSyncMedium: function (p) {
        for (s = !0; i.length;) {
          var h = i;
          i = [], h.forEach(p);
        }
        i = {
          push: function (y) {
            return p(y);
          },
          filter: function () {
            return i;
          }
        };
      },
      assignMedium: function (p) {
        s = !0;
        var h = [];
        if (i.length) {
          var y = i;
          i = [], y.forEach(p), h = i;
        }
        var w = function () {
            var E = h;
            h = [], E.forEach(p);
          },
          x = function () {
            return Promise.resolve().then(w);
          };
        x(), i = {
          push: function (E) {
            h.push(E), x();
          },
          filter: function (E) {
            return h = h.filter(E), i;
          }
        };
      }
    };
  return c;
}
function IN(t, e) {
  return e === void 0 && (e = d$), f$(t, e);
}
function MN(t) {
  t === void 0 && (t = {});
  var e = f$(null);
  return e.options = ld({
    async: !0,
    ssr: !1
  }, t), e;
}
var p$ = function (t) {
  var e = t.sideCar,
    i = EL(t, ["sideCar"]);
  if (!e) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var s = e.read();
  if (!s) throw new Error("Sidecar medium not found");
  return Bn.createElement(s, ld({}, i));
};
p$.isSideCarExport = !0;
function LN(t, e) {
  return t.useMedium(e), p$;
}
var h$ = MN(),
  Pj = function () {},
  ON = Bn.forwardRef(function (t, e) {
    var i = Bn.useRef(null),
      s = Bn.useState({
        onScrollCapture: Pj,
        onWheelCapture: Pj,
        onTouchMoveCapture: Pj
      }),
      c = s[0],
      p = s[1],
      h = t.forwardProps,
      y = t.children,
      w = t.className,
      x = t.removeScrollBar,
      E = t.enabled,
      C = t.shards,
      k = t.sideCar,
      D = t.noRelative,
      I = t.noIsolation,
      L = t.inert,
      P = t.allowPinchZoom,
      N = t.as,
      O = N === void 0 ? "div" : N,
      F = t.gapMode,
      j = EL(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]),
      V = k,
      K = c$([i, e]),
      G = ld(ld({}, j), c);
    return Bn.createElement(Bn.Fragment, null, E && Bn.createElement(V, {
      sideCar: h$,
      removeScrollBar: x,
      shards: C,
      noRelative: D,
      noIsolation: I,
      inert: L,
      setCallbacks: p,
      allowPinchZoom: !!P,
      lockRef: i,
      gapMode: F
    }), h ? Bn.cloneElement(Bn.Children.only(y), ld(ld({}, G), {
      ref: K
    })) : Bn.createElement(O, ld({}, G, {
      className: w,
      ref: K
    }), y));
  });
ON.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ON.classNames = {
  fullWidth: qM,
  zeroRight: WM
};
function CL() {
  return CL = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var s in i) ({}).hasOwnProperty.call(i, s) && (t[s] = i[s]);
    }
    return t;
  }, CL.apply(null, arguments);
}
var gM = {
    exports: {}
  },
  yM = {
    exports: {}
  },
  mi = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kB;
function Vae() {
  if (kB) return mi;
  kB = 1;
  var t = typeof Symbol == "function" && Symbol.for,
    e = t ? Symbol.for("react.element") : 60103,
    i = t ? Symbol.for("react.portal") : 60106,
    s = t ? Symbol.for("react.fragment") : 60107,
    c = t ? Symbol.for("react.strict_mode") : 60108,
    p = t ? Symbol.for("react.profiler") : 60114,
    h = t ? Symbol.for("react.provider") : 60109,
    y = t ? Symbol.for("react.context") : 60110,
    w = t ? Symbol.for("react.async_mode") : 60111,
    x = t ? Symbol.for("react.concurrent_mode") : 60111,
    E = t ? Symbol.for("react.forward_ref") : 60112,
    C = t ? Symbol.for("react.suspense") : 60113,
    k = t ? Symbol.for("react.suspense_list") : 60120,
    D = t ? Symbol.for("react.memo") : 60115,
    I = t ? Symbol.for("react.lazy") : 60116,
    L = t ? Symbol.for("react.block") : 60121,
    P = t ? Symbol.for("react.fundamental") : 60117,
    N = t ? Symbol.for("react.responder") : 60118,
    O = t ? Symbol.for("react.scope") : 60119;
  function F(V) {
    if (typeof V == "object" && V !== null) {
      var K = V.$$typeof;
      switch (K) {
        case e:
          switch (V = V.type, V) {
            case w:
            case x:
            case s:
            case p:
            case c:
            case C:
              return V;
            default:
              switch (V = V && V.$$typeof, V) {
                case y:
                case E:
                case I:
                case D:
                case h:
                  return V;
                default:
                  return K;
              }
          }
        case i:
          return K;
      }
    }
  }
  function j(V) {
    return F(V) === x;
  }
  return mi.AsyncMode = w, mi.ConcurrentMode = x, mi.ContextConsumer = y, mi.ContextProvider = h, mi.Element = e, mi.ForwardRef = E, mi.Fragment = s, mi.Lazy = I, mi.Memo = D, mi.Portal = i, mi.Profiler = p, mi.StrictMode = c, mi.Suspense = C, mi.isAsyncMode = function (V) {
    return j(V) || F(V) === w;
  }, mi.isConcurrentMode = j, mi.isContextConsumer = function (V) {
    return F(V) === y;
  }, mi.isContextProvider = function (V) {
    return F(V) === h;
  }, mi.isElement = function (V) {
    return typeof V == "object" && V !== null && V.$$typeof === e;
  }, mi.isForwardRef = function (V) {
    return F(V) === E;
  }, mi.isFragment = function (V) {
    return F(V) === s;
  }, mi.isLazy = function (V) {
    return F(V) === I;
  }, mi.isMemo = function (V) {
    return F(V) === D;
  }, mi.isPortal = function (V) {
    return F(V) === i;
  }, mi.isProfiler = function (V) {
    return F(V) === p;
  }, mi.isStrictMode = function (V) {
    return F(V) === c;
  }, mi.isSuspense = function (V) {
    return F(V) === C;
  }, mi.isValidElementType = function (V) {
    return typeof V == "string" || typeof V == "function" || V === s || V === x || V === p || V === c || V === C || V === k || typeof V == "object" && V !== null && (V.$$typeof === I || V.$$typeof === D || V.$$typeof === h || V.$$typeof === y || V.$$typeof === E || V.$$typeof === P || V.$$typeof === N || V.$$typeof === O || V.$$typeof === L);
  }, mi.typeOf = F, mi;
}
var vi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TB;
function Bae() {
  return TB || (TB = 1, process.env.NODE_ENV !== "production" && function () {
    var t = typeof Symbol == "function" && Symbol.for,
      e = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      s = t ? Symbol.for("react.fragment") : 60107,
      c = t ? Symbol.for("react.strict_mode") : 60108,
      p = t ? Symbol.for("react.profiler") : 60114,
      h = t ? Symbol.for("react.provider") : 60109,
      y = t ? Symbol.for("react.context") : 60110,
      w = t ? Symbol.for("react.async_mode") : 60111,
      x = t ? Symbol.for("react.concurrent_mode") : 60111,
      E = t ? Symbol.for("react.forward_ref") : 60112,
      C = t ? Symbol.for("react.suspense") : 60113,
      k = t ? Symbol.for("react.suspense_list") : 60120,
      D = t ? Symbol.for("react.memo") : 60115,
      I = t ? Symbol.for("react.lazy") : 60116,
      L = t ? Symbol.for("react.block") : 60121,
      P = t ? Symbol.for("react.fundamental") : 60117,
      N = t ? Symbol.for("react.responder") : 60118,
      O = t ? Symbol.for("react.scope") : 60119;
    function F(ge) {
      return typeof ge == "string" || typeof ge == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ge === s || ge === x || ge === p || ge === c || ge === C || ge === k || typeof ge == "object" && ge !== null && (ge.$$typeof === I || ge.$$typeof === D || ge.$$typeof === h || ge.$$typeof === y || ge.$$typeof === E || ge.$$typeof === P || ge.$$typeof === N || ge.$$typeof === O || ge.$$typeof === L);
    }
    function j(ge) {
      if (typeof ge == "object" && ge !== null) {
        var qe = ge.$$typeof;
        switch (qe) {
          case e:
            var Ae = ge.type;
            switch (Ae) {
              case w:
              case x:
              case s:
              case p:
              case c:
              case C:
                return Ae;
              default:
                var Mt = Ae && Ae.$$typeof;
                switch (Mt) {
                  case y:
                  case E:
                  case I:
                  case D:
                  case h:
                    return Mt;
                  default:
                    return qe;
                }
            }
          case i:
            return qe;
        }
      }
    }
    var V = w,
      K = x,
      G = y,
      Q = h,
      te = e,
      ie = E,
      Y = s,
      ee = I,
      ae = D,
      ne = i,
      le = p,
      ce = c,
      W = C,
      $ = !1;
    function de(ge) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(ge) || j(ge) === w;
    }
    function H(ge) {
      return j(ge) === x;
    }
    function se(ge) {
      return j(ge) === y;
    }
    function ue(ge) {
      return j(ge) === h;
    }
    function Ee(ge) {
      return typeof ge == "object" && ge !== null && ge.$$typeof === e;
    }
    function Ce(ge) {
      return j(ge) === E;
    }
    function fe(ge) {
      return j(ge) === s;
    }
    function _e(ge) {
      return j(ge) === I;
    }
    function Se(ge) {
      return j(ge) === D;
    }
    function be(ge) {
      return j(ge) === i;
    }
    function Le(ge) {
      return j(ge) === p;
    }
    function Be(ge) {
      return j(ge) === c;
    }
    function Xe(ge) {
      return j(ge) === C;
    }
    vi.AsyncMode = V, vi.ConcurrentMode = K, vi.ContextConsumer = G, vi.ContextProvider = Q, vi.Element = te, vi.ForwardRef = ie, vi.Fragment = Y, vi.Lazy = ee, vi.Memo = ae, vi.Portal = ne, vi.Profiler = le, vi.StrictMode = ce, vi.Suspense = W, vi.isAsyncMode = de, vi.isConcurrentMode = H, vi.isContextConsumer = se, vi.isContextProvider = ue, vi.isElement = Ee, vi.isForwardRef = Ce, vi.isFragment = fe, vi.isLazy = _e, vi.isMemo = Se, vi.isPortal = be, vi.isProfiler = Le, vi.isStrictMode = Be, vi.isSuspense = Xe, vi.isValidElementType = F, vi.typeOf = j;
  }()), vi;
}
var RB;
function m$() {
  return RB || (RB = 1, process.env.NODE_ENV === "production" ? yM.exports = Vae() : yM.exports = Bae()), yM.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Aj, DB;
function Uae() {
  if (DB) return Aj;
  DB = 1;
  var t = Object.getOwnPropertySymbols,
    e = Object.prototype.hasOwnProperty,
    i = Object.prototype.propertyIsEnumerable;
  function s(p) {
    if (p == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(p);
  }
  function c() {
    try {
      if (!Object.assign) return !1;
      var p = new String("abc");
      if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5") return !1;
      for (var h = {}, y = 0; y < 10; y++) h["_" + String.fromCharCode(y)] = y;
      var w = Object.getOwnPropertyNames(h).map(function (E) {
        return h[E];
      });
      if (w.join("") !== "0123456789") return !1;
      var x = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (E) {
        x[E] = E;
      }), Object.keys(Object.assign({}, x)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Aj = c() ? Object.assign : function (p, h) {
    for (var y, w = s(p), x, E = 1; E < arguments.length; E++) {
      y = Object(arguments[E]);
      for (var C in y) e.call(y, C) && (w[C] = y[C]);
      if (t) {
        x = t(y);
        for (var k = 0; k < x.length; k++) i.call(y, x[k]) && (w[x[k]] = y[x[k]]);
      }
    }
    return w;
  }, Aj;
}
var jj, IB;
function PN() {
  if (IB) return jj;
  IB = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return jj = t, jj;
}
var Fj, MB;
function v$() {
  return MB || (MB = 1, Fj = Function.call.bind(Object.prototype.hasOwnProperty)), Fj;
}
var Nj, LB;
function Hae() {
  if (LB) return Nj;
  LB = 1;
  var t = function () {};
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */PN(),
      i = {},
      s = /* @__PURE__ */v$();
    t = function (p) {
      var h = "Warning: " + p;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {}
    };
  }
  function c(p, h, y, w, x) {
    if (process.env.NODE_ENV !== "production") {
      for (var E in p) if (s(p, E)) {
        var C;
        try {
          if (typeof p[E] != "function") {
            var k = Error((w || "React class") + ": " + y + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof p[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw k.name = "Invariant Violation", k;
          }
          C = p[E](h, E, w, y, null, e);
        } catch (I) {
          C = I;
        }
        if (C && !(C instanceof Error) && t((w || "React class") + ": type specification of " + y + " `" + E + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), C instanceof Error && !(C.message in i)) {
          i[C.message] = !0;
          var D = x ? x() : "";
          t("Failed " + y + " type: " + C.message + (D ?? ""));
        }
      }
    }
  }
  return c.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (i = {});
  }, Nj = c, Nj;
}
var zj, OB;
function $ae() {
  if (OB) return zj;
  OB = 1;
  var t = m$(),
    e = Uae(),
    i = /* @__PURE__ */PN(),
    s = /* @__PURE__ */v$(),
    c = /* @__PURE__ */Hae(),
    p = function () {};
  process.env.NODE_ENV !== "production" && (p = function (y) {
    var w = "Warning: " + y;
    typeof console < "u" && console.error(w);
    try {
      throw new Error(w);
    } catch {}
  });
  function h() {
    return null;
  }
  return zj = function (y, w) {
    var x = typeof Symbol == "function" && Symbol.iterator,
      E = "@@iterator";
    function C(H) {
      var se = H && (x && H[x] || H[E]);
      if (typeof se == "function") return se;
    }
    var k = "<<anonymous>>",
      D = {
        array: N("array"),
        bigint: N("bigint"),
        bool: N("boolean"),
        func: N("function"),
        number: N("number"),
        object: N("object"),
        string: N("string"),
        symbol: N("symbol"),
        any: O(),
        arrayOf: F,
        element: j(),
        elementType: V(),
        instanceOf: K,
        node: ie(),
        objectOf: Q,
        oneOf: G,
        oneOfType: te,
        shape: ee,
        exact: ae
      };
    function I(H, se) {
      return H === se ? H !== 0 || 1 / H === 1 / se : H !== H && se !== se;
    }
    function L(H, se) {
      this.message = H, this.data = se && typeof se == "object" ? se : {}, this.stack = "";
    }
    L.prototype = Error.prototype;
    function P(H) {
      if (process.env.NODE_ENV !== "production") var se = {},
        ue = 0;
      function Ee(fe, _e, Se, be, Le, Be, Xe) {
        if (be = be || k, Be = Be || Se, Xe !== i) {
          if (w) {
            var ge = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw ge.name = "Invariant Violation", ge;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var qe = be + ":" + Se;
            !se[qe] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            ue < 3 && (p("You are manually calling a React.PropTypes validation function for the `" + Be + "` prop on `" + be + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), se[qe] = !0, ue++);
          }
        }
        return _e[Se] == null ? fe ? _e[Se] === null ? new L("The " + Le + " `" + Be + "` is marked as required " + ("in `" + be + "`, but its value is `null`.")) : new L("The " + Le + " `" + Be + "` is marked as required in " + ("`" + be + "`, but its value is `undefined`.")) : null : H(_e, Se, be, Le, Be);
      }
      var Ce = Ee.bind(null, !1);
      return Ce.isRequired = Ee.bind(null, !0), Ce;
    }
    function N(H) {
      function se(ue, Ee, Ce, fe, _e, Se) {
        var be = ue[Ee],
          Le = ce(be);
        if (Le !== H) {
          var Be = W(be);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + Be + "` supplied to `" + Ce + "`, expected ") + ("`" + H + "`."), {
            expectedType: H
          });
        }
        return null;
      }
      return P(se);
    }
    function O() {
      return P(h);
    }
    function F(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (typeof H != "function") return new L("Property `" + _e + "` of component `" + Ce + "` has invalid PropType notation inside arrayOf.");
        var Se = ue[Ee];
        if (!Array.isArray(Se)) {
          var be = ce(Se);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected an array."));
        }
        for (var Le = 0; Le < Se.length; Le++) {
          var Be = H(Se, Le, Ce, fe, _e + "[" + Le + "]", i);
          if (Be instanceof Error) return Be;
        }
        return null;
      }
      return P(se);
    }
    function j() {
      function H(se, ue, Ee, Ce, fe) {
        var _e = se[ue];
        if (!y(_e)) {
          var Se = ce(_e);
          return new L("Invalid " + Ce + " `" + fe + "` of type " + ("`" + Se + "` supplied to `" + Ee + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(H);
    }
    function V() {
      function H(se, ue, Ee, Ce, fe) {
        var _e = se[ue];
        if (!t.isValidElementType(_e)) {
          var Se = ce(_e);
          return new L("Invalid " + Ce + " `" + fe + "` of type " + ("`" + Se + "` supplied to `" + Ee + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(H);
    }
    function K(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (!(ue[Ee] instanceof H)) {
          var Se = H.name || k,
            be = de(ue[Ee]);
          return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected ") + ("instance of `" + Se + "`."));
        }
        return null;
      }
      return P(se);
    }
    function G(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? p("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : p("Invalid argument supplied to oneOf, expected an array.")), h;
      function se(ue, Ee, Ce, fe, _e) {
        for (var Se = ue[Ee], be = 0; be < H.length; be++) if (I(Se, H[be])) return null;
        var Le = JSON.stringify(H, function (Xe, ge) {
          var qe = W(ge);
          return qe === "symbol" ? String(ge) : ge;
        });
        return new L("Invalid " + fe + " `" + _e + "` of value `" + String(Se) + "` " + ("supplied to `" + Ce + "`, expected one of " + Le + "."));
      }
      return P(se);
    }
    function Q(H) {
      function se(ue, Ee, Ce, fe, _e) {
        if (typeof H != "function") return new L("Property `" + _e + "` of component `" + Ce + "` has invalid PropType notation inside objectOf.");
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type " + ("`" + be + "` supplied to `" + Ce + "`, expected an object."));
        for (var Le in Se) if (s(Se, Le)) {
          var Be = H(Se, Le, Ce, fe, _e + "." + Le, i);
          if (Be instanceof Error) return Be;
        }
        return null;
      }
      return P(se);
    }
    function te(H) {
      if (!Array.isArray(H)) return process.env.NODE_ENV !== "production" && p("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var se = 0; se < H.length; se++) {
        var ue = H[se];
        if (typeof ue != "function") return p("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(ue) + " at index " + se + "."), h;
      }
      function Ee(Ce, fe, _e, Se, be) {
        for (var Le = [], Be = 0; Be < H.length; Be++) {
          var Xe = H[Be],
            ge = Xe(Ce, fe, _e, Se, be, i);
          if (ge == null) return null;
          ge.data && s(ge.data, "expectedType") && Le.push(ge.data.expectedType);
        }
        var qe = Le.length > 0 ? ", expected one of type [" + Le.join(", ") + "]" : "";
        return new L("Invalid " + Se + " `" + be + "` supplied to " + ("`" + _e + "`" + qe + "."));
      }
      return P(Ee);
    }
    function ie() {
      function H(se, ue, Ee, Ce, fe) {
        return ne(se[ue]) ? null : new L("Invalid " + Ce + " `" + fe + "` supplied to " + ("`" + Ee + "`, expected a ReactNode."));
      }
      return P(H);
    }
    function Y(H, se, ue, Ee, Ce) {
      return new L((H || "React class") + ": " + se + " type `" + ue + "." + Ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ce + "`.");
    }
    function ee(H) {
      function se(ue, Ee, Ce, fe, _e) {
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type `" + be + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        for (var Le in H) {
          var Be = H[Le];
          if (typeof Be != "function") return Y(Ce, fe, _e, Le, W(Be));
          var Xe = Be(Se, Le, Ce, fe, _e + "." + Le, i);
          if (Xe) return Xe;
        }
        return null;
      }
      return P(se);
    }
    function ae(H) {
      function se(ue, Ee, Ce, fe, _e) {
        var Se = ue[Ee],
          be = ce(Se);
        if (be !== "object") return new L("Invalid " + fe + " `" + _e + "` of type `" + be + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        var Le = e({}, ue[Ee], H);
        for (var Be in Le) {
          var Xe = H[Be];
          if (s(H, Be) && typeof Xe != "function") return Y(Ce, fe, _e, Be, W(Xe));
          if (!Xe) return new L("Invalid " + fe + " `" + _e + "` key `" + Be + "` supplied to `" + Ce + "`.\nBad object: " + JSON.stringify(ue[Ee], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  "));
          var ge = Xe(Se, Be, Ce, fe, _e + "." + Be, i);
          if (ge) return ge;
        }
        return null;
      }
      return P(se);
    }
    function ne(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H)) return H.every(ne);
          if (H === null || y(H)) return !0;
          var se = C(H);
          if (se) {
            var ue = se.call(H),
              Ee;
            if (se !== H.entries) {
              for (; !(Ee = ue.next()).done;) if (!ne(Ee.value)) return !1;
            } else for (; !(Ee = ue.next()).done;) {
              var Ce = Ee.value;
              if (Ce && !ne(Ce[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function le(H, se) {
      return H === "symbol" ? !0 : se ? se["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && se instanceof Symbol : !1;
    }
    function ce(H) {
      var se = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : le(se, H) ? "symbol" : se;
    }
    function W(H) {
      if (typeof H > "u" || H === null) return "" + H;
      var se = ce(H);
      if (se === "object") {
        if (H instanceof Date) return "date";
        if (H instanceof RegExp) return "regexp";
      }
      return se;
    }
    function $(H) {
      var se = W(H);
      switch (se) {
        case "array":
        case "object":
          return "an " + se;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + se;
        default:
          return se;
      }
    }
    function de(H) {
      return !H.constructor || !H.constructor.name ? k : H.constructor.name;
    }
    return D.checkPropTypes = c, D.resetWarningCache = c.resetWarningCache, D.PropTypes = D, D;
  }, zj;
}
var Vj, PB;
function Wae() {
  if (PB) return Vj;
  PB = 1;
  var t = /* @__PURE__ */PN();
  function e() {}
  function i() {}
  return i.resetWarningCache = e, Vj = function () {
    function s(h, y, w, x, E, C) {
      if (C !== t) {
        var k = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw k.name = "Invariant Violation", k;
      }
    }
    s.isRequired = s;
    function c() {
      return s;
    }
    var p = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: c,
      element: s,
      elementType: s,
      instanceOf: c,
      node: s,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: i,
      resetWarningCache: e
    };
    return p.PropTypes = p, p;
  }, Vj;
}
var AB;
function AN() {
  if (AB) return gM.exports;
  if (AB = 1, process.env.NODE_ENV !== "production") {
    var t = m$(),
      e = !0;
    gM.exports = /* @__PURE__ */$ae()(t.isElement, e);
  } else gM.exports = /* @__PURE__ */Wae()();
  return gM.exports;
}
var ia = /* @__PURE__ */AN();
const g$ = /* @__PURE__ */KL(ia);
var $2 = "data-focus-lock",
  y$ = "data-focus-lock-disabled",
  qae = "data-no-focus-lock",
  Yae = "data-autofocus-inside",
  Gae = "data-no-autofocus",
  Bj = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
  };
process.env.NODE_ENV !== "production" && g$.node;
var b$ = IN({}, function (t) {
    var e = t.target,
      i = t.currentTarget;
    return {
      target: e,
      currentTarget: i
    };
  }),
  w$ = IN(),
  Xae = IN(),
  _$ = MN({
    async: !0,
    ssr: typeof document < "u"
  }),
  Kae = /* @__PURE__ */Up(void 0),
  Qae = [],
  x$ = /* @__PURE__ */Qn(function (e, i) {
    var s,
      c = rt(),
      p = c[0],
      h = c[1],
      y = vt(),
      w = vt(!1),
      x = vt(null),
      E = rt({}),
      C = E[1],
      k = e.children,
      D = e.disabled,
      I = D === void 0 ? !1 : D,
      L = e.noFocusGuards,
      P = L === void 0 ? !1 : L,
      N = e.persistentFocus,
      O = N === void 0 ? !1 : N,
      F = e.crossFrame,
      j = F === void 0 ? !0 : F,
      V = e.autoFocus,
      K = V === void 0 ? !0 : V,
      G = e.allowTextSelection,
      Q = e.group,
      te = e.className,
      ie = e.whiteList,
      Y = e.hasPositiveIndices,
      ee = e.shards,
      ae = ee === void 0 ? Qae : ee,
      ne = e.as,
      le = ne === void 0 ? "div" : ne,
      ce = e.lockProps,
      W = ce === void 0 ? {} : ce,
      $ = e.sideCar,
      de = e.returnFocus,
      H = de === void 0 ? !1 : de,
      se = e.focusOptions,
      ue = e.onActivation,
      Ee = e.onDeactivation,
      Ce = rt({}),
      fe = Ce[0],
      _e = pn(function (un) {
        var gt = un.captureFocusRestore;
        if (!x.current) {
          var Pt,
            St = (Pt = document) == null ? void 0 : Pt.activeElement;
          x.current = St, St !== document.body && (x.current = gt(St));
        }
        y.current && ue && ue(y.current), w.current = !0, C();
      }, [ue]),
      Se = pn(function () {
        w.current = !1, Ee && Ee(y.current), C();
      }, [Ee]),
      be = pn(function (un) {
        var gt = x.current;
        if (gt) {
          var Pt = (typeof gt == "function" ? gt() : gt) || document.body,
            St = typeof H == "function" ? H(Pt) : H;
          if (St) {
            var Dt = typeof St == "object" ? St : void 0;
            x.current = null, un ? Promise.resolve().then(function () {
              return Pt.focus(Dt);
            }) : Pt.focus(Dt);
          }
        }
      }, [H]),
      Le = pn(function (un) {
        w.current && b$.useMedium(un);
      }, []),
      Be = w$.useMedium,
      Xe = pn(function (un) {
        y.current !== un && (y.current = un, h(un));
      }, []);
    process.env.NODE_ENV !== "production" && (typeof G < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Rt(function () {
      !y.current && typeof le != "string" && console.error("FocusLock: could not obtain ref to internal node");
    }, []));
    var ge = CL((s = {}, s[y$] = I && "disabled", s[$2] = Q, s), W),
      qe = P !== !0,
      Ae = qe && P !== "tail",
      Mt = c$([i, Xe]),
      Ft = ci(function () {
        return {
          observed: y,
          shards: ae,
          enabled: !I,
          active: w.current
        };
      }, [I, w.current, ae, p]);
    return /* @__PURE__ */Nt.createElement(Qv, null, qe && [/* @__PURE__ */Nt.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 0,
      style: Bj
    }), Y ? /* @__PURE__ */Nt.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 1,
      style: Bj
    }) : null], !I && /* @__PURE__ */Nt.createElement($, {
      id: fe,
      sideCar: _$,
      observed: p,
      disabled: I,
      persistentFocus: O,
      crossFrame: j,
      autoFocus: K,
      whiteList: ie,
      shards: ae,
      onActivation: _e,
      onDeactivation: Se,
      returnFocus: be,
      focusOptions: se,
      noFocusGuards: P
    }), /* @__PURE__ */Nt.createElement(le, CL({
      ref: Mt
    }, ge, {
      className: te,
      onBlur: Be,
      onFocus: Le
    }), /* @__PURE__ */Nt.createElement(Kae.Provider, {
      value: Ft
    }, k)), Ae && /* @__PURE__ */Nt.createElement("div", {
      "data-focus-guard": !0,
      tabIndex: I ? -1 : 0,
      style: Bj
    }));
  });
x$.propTypes = process.env.NODE_ENV !== "production" ? {
  children: ia.node,
  disabled: ia.bool,
  returnFocus: ia.oneOfType([ia.bool, ia.object, ia.func]),
  focusOptions: ia.object,
  noFocusGuards: ia.bool,
  hasPositiveIndices: ia.bool,
  allowTextSelection: ia.bool,
  autoFocus: ia.bool,
  persistentFocus: ia.bool,
  crossFrame: ia.bool,
  group: ia.string,
  className: ia.string,
  whiteList: ia.func,
  shards: ia.arrayOf(ia.any),
  as: ia.oneOfType([ia.string, ia.func, ia.object]),
  lockProps: ia.object,
  onActivation: ia.func,
  onDeactivation: ia.func,
  sideCar: ia.any.isRequired
} : {};
function jN(t) {
  setTimeout(t, 1);
}
var Zae = function (e) {
    return e && "current" in e ? e.current : e;
  },
  S$ = MN(),
  E$ = "data-focus-on-hidden",
  Jae = {
    preventScroll: !0
  },
  eoe = Bn.forwardRef(function (t, e) {
    var i = Bn.useState(!1),
      s = i[0],
      c = i[1],
      p = t.children,
      h = t.autoFocus,
      y = t.shards,
      w = t.crossFrame,
      x = t.enabled,
      E = x === void 0 ? !0 : x,
      C = t.scrollLock,
      k = C === void 0 ? !0 : C,
      D = t.focusLock,
      I = D === void 0 ? !0 : D,
      L = t.returnFocus,
      P = L === void 0 ? !0 : L,
      N = t.inert,
      O = t.allowPinchZoom,
      F = t.sideCar,
      j = t.className,
      V = t.shouldIgnore,
      K = t.preventScrollOnFocus,
      G = t.style,
      Q = t.as,
      te = t.gapMode,
      ie = EL(t, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]),
      Y = F,
      ee = s.onActivation,
      ae = s.onDeactivation,
      ne = EL(s, ["onActivation", "onDeactivation"]),
      le = ld(ld({}, ne), {
        as: Q,
        style: G,
        sideCar: F,
        shards: y,
        allowPinchZoom: O,
        gapMode: te,
        inert: N,
        enabled: E && k
      });
    return Bn.createElement(Bn.Fragment, null, Bn.createElement(x$, {
      ref: e,
      sideCar: F,
      disabled: !(s && E && I),
      returnFocus: P,
      autoFocus: h,
      shards: y,
      crossFrame: w,
      onActivation: ee,
      onDeactivation: ae,
      className: j,
      whiteList: V,
      lockProps: le,
      focusOptions: K ? Jae : void 0,
      as: ON
    }, p), E && Bn.createElement(Y, ld({}, ie, {
      sideCar: S$,
      setLockProps: c,
      shards: y
    })));
  });
function W2(t, e) {
  return W2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (i, s) {
    return i.__proto__ = s, i;
  }, W2(t, e);
}
function toe(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, W2(t, e);
}
function mR(t) {
  "@babel/helpers - typeof";

  return mR = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mR(t);
}
function noe(t, e) {
  if (mR(t) != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var s = i.call(t, e);
    if (mR(s) != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function roe(t) {
  var e = noe(t, "string");
  return mR(e) == "symbol" ? e : e + "";
}
function ioe(t, e, i) {
  return (e = roe(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function aoe(t, e) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof t != "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof e != "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function i(s) {
    return s.displayName || s.name || "Component";
  }
  return function (c) {
    if (process.env.NODE_ENV !== "production" && typeof c != "function") throw new Error("Expected WrappedComponent to be a React component.");
    var p = [],
      h;
    function y() {
      h = t(p.map(function (x) {
        return x.props;
      })), e(h);
    }
    var w = /* @__PURE__ */function (x) {
      toe(E, x);
      function E() {
        return x.apply(this, arguments) || this;
      }
      E.peek = function () {
        return h;
      };
      var C = E.prototype;
      return C.componentDidMount = function () {
        p.push(this), y();
      }, C.componentDidUpdate = function () {
        y();
      }, C.componentWillUnmount = function () {
        var D = p.indexOf(this);
        p.splice(D, 1), y();
      }, C.render = function () {
        return /* @__PURE__ */Nt.createElement(c, this.props);
      }, E;
    }(LW);
    return ioe(w, "displayName", "SideEffect(" + i(c) + ")"), w;
  };
}
var eg = function (t) {
    for (var e = Array(t.length), i = 0; i < t.length; ++i) e[i] = t[i];
    return e;
  },
  tS = function (t) {
    return Array.isArray(t) ? t : [t];
  },
  C$ = function (t) {
    return Array.isArray(t) ? t[0] : t;
  },
  ooe = function (t) {
    if (t.nodeType !== Node.ELEMENT_NODE) return !1;
    var e = window.getComputedStyle(t, null);
    return !e || !e.getPropertyValue ? !1 : e.getPropertyValue("display") === "none" || e.getPropertyValue("visibility") === "hidden";
  },
  k$ = function (t) {
    return t.parentNode && t.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t.parentNode.host : t.parentNode;
  },
  T$ = function (t) {
    return t === document || t && t.nodeType === Node.DOCUMENT_NODE;
  },
  loe = function (t) {
    return t.hasAttribute("inert");
  },
  soe = function (t, e) {
    return !t || T$(t) || !ooe(t) && !loe(t) && e(k$(t));
  },
  R$ = function (t, e) {
    var i = t.get(e);
    if (i !== void 0) return i;
    var s = soe(e, R$.bind(void 0, t));
    return t.set(e, s), s;
  },
  uoe = function (t, e) {
    return t && !T$(t) ? foe(t) ? e(k$(t)) : !1 : !0;
  },
  D$ = function (t, e) {
    var i = t.get(e);
    if (i !== void 0) return i;
    var s = uoe(e, D$.bind(void 0, t));
    return t.set(e, s), s;
  },
  I$ = function (t) {
    return t.dataset;
  },
  coe = function (t) {
    return t.tagName === "BUTTON";
  },
  M$ = function (t) {
    return t.tagName === "INPUT";
  },
  L$ = function (t) {
    return M$(t) && t.type === "radio";
  },
  doe = function (t) {
    return !((M$(t) || coe(t)) && (t.type === "hidden" || t.disabled));
  },
  foe = function (t) {
    var e = t.getAttribute(Gae);
    return ![!0, "true", ""].includes(e);
  },
  FN = function (t) {
    var e;
    return !!(t && !((e = I$(t)) === null || e === void 0) && e.focusGuard);
  },
  q2 = function (t) {
    return !FN(t);
  },
  poe = function (t) {
    return !!t;
  },
  hoe = function (t, e) {
    var i = Math.max(0, t.tabIndex),
      s = Math.max(0, e.tabIndex),
      c = i - s,
      p = t.index - e.index;
    if (c) {
      if (!i) return 1;
      if (!s) return -1;
    }
    return c || p;
  },
  moe = function (t) {
    return t.tabIndex < 0 && !t.hasAttribute("tabindex") ? 0 : t.tabIndex;
  },
  NN = function (t, e, i) {
    return eg(t).map(function (s, c) {
      var p = moe(s);
      return {
        node: s,
        index: c,
        tabIndex: i && p === -1 ? (s.dataset || {}).focusGuard ? 0 : -1 : p
      };
    }).filter(function (s) {
      return !e || s.tabIndex >= 0;
    }).sort(hoe);
  },
  voe = ["button:enabled", "select:enabled", "textarea:enabled", "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", "[tabindex]", "[contenteditable]", "[autofocus]"],
  zN = voe.join(","),
  goe = "".concat(zN, ", [data-focus-guard]"),
  O$ = function (t, e) {
    return eg((t.shadowRoot || t).children).reduce(function (i, s) {
      return i.concat(s.matches(e ? goe : zN) ? [s] : [], O$(s));
    }, []);
  },
  yoe = function (t, e) {
    var i;
    return t instanceof HTMLIFrameElement && !((i = t.contentDocument) === null || i === void 0) && i.body ? TE([t.contentDocument.body], e) : [t];
  },
  TE = function (t, e) {
    return t.reduce(function (i, s) {
      var c,
        p = O$(s, e),
        h = (c = []).concat.apply(c, p.map(function (y) {
          return yoe(y, e);
        }));
      return i.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      h,
      // add if node is tabbable itself
      s.parentNode ? eg(s.parentNode.querySelectorAll(zN)).filter(function (y) {
        return y === s;
      }) : []);
    }, []);
  },
  boe = function (t) {
    var e = t.querySelectorAll("[".concat(Yae, "]"));
    return eg(e).map(function (i) {
      return TE([i]);
    }).reduce(function (i, s) {
      return i.concat(s);
    }, []);
  },
  VN = function (t, e) {
    return eg(t).filter(function (i) {
      return R$(e, i);
    }).filter(function (i) {
      return doe(i);
    });
  },
  jB = function (t, e) {
    return e === void 0 && (e = /* @__PURE__ */new Map()), eg(t).filter(function (i) {
      return D$(e, i);
    });
  },
  BN = function (t, e, i) {
    return NN(VN(TE(t, i), e), !0, i);
  },
  vR = function (t, e) {
    return NN(VN(TE(t), e), !1);
  },
  woe = function (t, e) {
    return VN(boe(t), e);
  },
  Xx = function (t, e) {
    return t.shadowRoot ? Xx(t.shadowRoot, e) : Object.getPrototypeOf(t).contains !== void 0 && Object.getPrototypeOf(t).contains.call(t, e) ? !0 : eg(t.children).some(function (i) {
      var s;
      if (i instanceof HTMLIFrameElement) {
        var c = (s = i.contentDocument) === null || s === void 0 ? void 0 : s.body;
        return c ? Xx(c, e) : !1;
      }
      return Xx(i, e);
    });
  },
  _oe = function (t) {
    for (var e = /* @__PURE__ */new Set(), i = t.length, s = 0; s < i; s += 1) for (var c = s + 1; c < i; c += 1) {
      var p = t[s].compareDocumentPosition(t[c]);
      (p & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && e.add(c), (p & Node.DOCUMENT_POSITION_CONTAINS) > 0 && e.add(s);
    }
    return t.filter(function (h, y) {
      return !e.has(y);
    });
  },
  P$ = function (t) {
    return t.parentNode ? P$(t.parentNode) : t;
  },
  UN = function (t) {
    var e = tS(t);
    return e.filter(Boolean).reduce(function (i, s) {
      var c = s.getAttribute($2);
      return i.push.apply(i, c ? _oe(eg(P$(s).querySelectorAll("[".concat($2, '="').concat(c, '"]:not([').concat(y$, '="disabled"])')))) : [s]), i;
    }, []);
  },
  xoe = function (t) {
    try {
      return t();
    } catch {
      return;
    }
  },
  gR = function (t) {
    if (t === void 0 && (t = document), !(!t || !t.activeElement)) {
      var e = t.activeElement;
      return e.shadowRoot ? gR(e.shadowRoot) : e instanceof HTMLIFrameElement && xoe(function () {
        return e.contentWindow.document;
      }) ? gR(e.contentWindow.document) : e;
    }
  },
  Soe = function (t, e) {
    return t === e;
  },
  Eoe = function (t, e) {
    return !!eg(t.querySelectorAll("iframe")).some(function (i) {
      return Soe(i, e);
    });
  },
  A$ = function (t, e) {
    return e === void 0 && (e = gR(C$(t).ownerDocument)), !e || e.dataset && e.dataset.focusGuard ? !1 : UN(t).some(function (i) {
      return Xx(i, e) || Eoe(i, e);
    });
  },
  Coe = function (t) {
    t === void 0 && (t = document);
    var e = gR(t);
    return e ? eg(t.querySelectorAll("[".concat(qae, "]"))).some(function (i) {
      return Xx(i, e);
    }) : !1;
  },
  koe = function (t, e) {
    return e.filter(L$).filter(function (i) {
      return i.name === t.name;
    }).filter(function (i) {
      return i.checked;
    })[0] || t;
  },
  HN = function (t, e) {
    return L$(t) && t.name ? koe(t, e) : t;
  },
  Toe = function (t) {
    var e = /* @__PURE__ */new Set();
    return t.forEach(function (i) {
      return e.add(HN(i, t));
    }), t.filter(function (i) {
      return e.has(i);
    });
  },
  FB = function (t) {
    return t[0] && t.length > 1 ? HN(t[0], t) : t[0];
  },
  NB = function (t, e) {
    return t.indexOf(HN(e, t));
  },
  Y2 = "NEW_FOCUS",
  Roe = function (t, e, i, s, c) {
    var p = t.length,
      h = t[0],
      y = t[p - 1],
      w = FN(s);
    if (!(s && t.indexOf(s) >= 0)) {
      var x = s !== void 0 ? i.indexOf(s) : -1,
        E = c ? i.indexOf(c) : x,
        C = c ? t.indexOf(c) : -1;
      if (x === -1) return C !== -1 ? C : Y2;
      if (C === -1) return Y2;
      var k = x - E,
        D = i.indexOf(h),
        I = i.indexOf(y),
        L = Toe(i),
        P = s !== void 0 ? L.indexOf(s) : -1,
        N = c ? L.indexOf(c) : P,
        O = L.filter(function (Q) {
          return Q.tabIndex >= 0;
        }),
        F = s !== void 0 ? O.indexOf(s) : -1,
        j = c ? O.indexOf(c) : F,
        V = F >= 0 && j >= 0 ?
        // old/new are tabbables, measure distance in tabbable space
        j - F :
        // or else measure in focusable space
        N - P;
      if (!k && C >= 0 || e.length === 0) return C;
      var K = NB(t, e[0]),
        G = NB(t, e[e.length - 1]);
      if (x <= D && w && Math.abs(k) > 1) return G;
      if (x >= I && w && Math.abs(k) > 1) return K;
      if (k && Math.abs(V) > 1) return C;
      if (x <= D) return G;
      if (x > I) return K;
      if (k) return Math.abs(k) > 1 ? C : (p + C + k) % p;
    }
  },
  Doe = function (t) {
    return function (e) {
      var i,
        s = (i = I$(e)) === null || i === void 0 ? void 0 : i.autofocus;
      return (
        // @ts-expect-error
        e.autofocus ||
        //
        s !== void 0 && s !== "false" ||
        //
        t.indexOf(e) >= 0
      );
    };
  },
  zB = function (t, e, i) {
    var s = t.map(function (p) {
        var h = p.node;
        return h;
      }),
      c = jB(s.filter(Doe(i)));
    return c && c.length ? FB(c) : FB(jB(e));
  },
  G2 = function (t, e) {
    return e === void 0 && (e = []), e.push(t), t.parentNode && G2(t.parentNode.host || t.parentNode, e), e;
  },
  Uj = function (t, e) {
    for (var i = G2(t), s = G2(e), c = 0; c < i.length; c += 1) {
      var p = i[c];
      if (s.indexOf(p) >= 0) return p;
    }
    return !1;
  },
  j$ = function (t, e, i) {
    var s = tS(t),
      c = tS(e),
      p = s[0],
      h = !1;
    return c.filter(Boolean).forEach(function (y) {
      h = Uj(h || y, y) || h, i.filter(Boolean).forEach(function (w) {
        var x = Uj(p, w);
        x && (!h || Xx(x, h) ? h = x : h = Uj(x, h));
      });
    }), h;
  },
  VB = function (t, e) {
    return t.reduce(function (i, s) {
      return i.concat(woe(s, e));
    }, []);
  },
  Ioe = function (t, e) {
    var i = /* @__PURE__ */new Map();
    return e.forEach(function (s) {
      return i.set(s.node, s);
    }), t.map(function (s) {
      return i.get(s);
    }).filter(poe);
  },
  Moe = function (t, e) {
    var i = gR(tS(t).length > 0 ? document : C$(t).ownerDocument),
      s = UN(t).filter(q2),
      c = j$(i || t, t, s),
      p = /* @__PURE__ */new Map(),
      h = vR(s, p),
      y = h.filter(function (I) {
        var L = I.node;
        return q2(L);
      });
    if (y[0]) {
      var w = vR([c], p).map(function (I) {
          var L = I.node;
          return L;
        }),
        x = Ioe(w, y),
        E = x.map(function (I) {
          var L = I.node;
          return L;
        }),
        C = x.filter(function (I) {
          var L = I.tabIndex;
          return L >= 0;
        }).map(function (I) {
          var L = I.node;
          return L;
        }),
        k = Roe(E, C, w, i, e);
      if (k === Y2) {
        var D =
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        zB(h, C, VB(s, p)) || zB(h, E, VB(s, p));
        if (D) return {
          node: D
        };
        console.warn("focus-lock: cannot find any node to move focus into");
        return;
      }
      return k === void 0 ? k : x[k];
    }
  },
  Loe = function (t) {
    var e = UN(t).filter(q2),
      i = j$(t, t, e),
      s = NN(TE([i], !0), !0, !0),
      c = TE(e, !1);
    return s.map(function (p) {
      var h = p.node,
        y = p.index;
      return {
        node: h,
        index: y,
        lockItem: c.indexOf(h) >= 0,
        guard: FN(h)
      };
    });
  },
  $N = function (t, e) {
    t && ("focus" in t && t.focus(e), "contentWindow" in t && t.contentWindow && t.contentWindow.focus());
  },
  Hj = 0,
  $j = !1,
  F$ = function (t, e, i) {
    i === void 0 && (i = {});
    var s = Moe(t, e);
    if (!$j && s) {
      if (Hj > 2) {
        console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), $j = !0, setTimeout(function () {
          $j = !1;
        }, 1);
        return;
      }
      Hj++, $N(s.node, i.focusOptions), Hj--;
    }
  };
function ET(t) {
  if (!t) return null;
  if (typeof WeakRef > "u") return function () {
    return t || null;
  };
  var e = t ? new WeakRef(t) : null;
  return function () {
    return (e == null ? void 0 : e.deref()) || null;
  };
}
var Ooe = function (t) {
    if (!t) return null;
    for (var e = [], i = t; i && i !== document.body;) e.push({
      current: ET(i),
      parent: ET(i.parentElement),
      left: ET(i.previousElementSibling),
      right: ET(i.nextElementSibling)
    }), i = i.parentElement;
    return {
      element: ET(t),
      stack: e,
      ownerDocument: t.ownerDocument
    };
  },
  Poe = function (t) {
    var e, i, s, c, p;
    if (t) for (var h = t.stack, y = t.ownerDocument, w = /* @__PURE__ */new Map(), x = 0, E = h; x < E.length; x++) {
      var C = E[x],
        k = (e = C.parent) === null || e === void 0 ? void 0 : e.call(C);
      if (k && y.contains(k)) {
        for (var D = (i = C.left) === null || i === void 0 ? void 0 : i.call(C), I = C.current(), L = k.contains(I) ? I : void 0, P = (s = C.right) === null || s === void 0 ? void 0 : s.call(C), N = BN([k], w), O =
          // that is element itself
          (p = (c = L ?? (
          // or something in it's place
          D == null ? void 0 : D.nextElementSibling)) !== null && c !== void 0 ? c :
          // or somebody to the right, still close enough
          P) !== null && p !== void 0 ? p :
          // or somebody to the left, something?
          D; O;) {
          for (var F = 0, j = N; F < j.length; F++) {
            var V = j[F];
            if (O != null && O.contains(V.node)) return V.node;
          }
          O = O.nextElementSibling;
        }
        if (N.length) return N[0].node;
      }
    }
  },
  N$ = function (t) {
    var e = Ooe(t);
    return function () {
      return Poe(e);
    };
  },
  Aoe = function (t, e, i) {
    if (!t || !e) return console.error("no element or scope given"), {};
    var s = tS(e);
    if (s.every(function (h) {
      return !Xx(h, t);
    })) return console.error("Active element is not contained in the scope"), {};
    var c = i ? BN(s, /* @__PURE__ */new Map()) : vR(s, /* @__PURE__ */new Map()),
      p = c.findIndex(function (h) {
        var y = h.node;
        return y === t;
      });
    if (p !== -1) return {
      prev: c[p - 1],
      next: c[p + 1],
      first: c[0],
      last: c[c.length - 1]
    };
  },
  joe = function (t, e) {
    var i = e ? BN(tS(t), /* @__PURE__ */new Map()) : vR(tS(t), /* @__PURE__ */new Map());
    return {
      first: i[0],
      last: i[i.length - 1]
    };
  },
  Foe = function (t) {
    return Object.assign({
      scope: document.body,
      cycle: !0,
      onlyTabbable: !0
    }, t);
  },
  z$ = function (t, e, i) {
    e === void 0 && (e = {});
    var s = Foe(e),
      c = Aoe(t, s.scope, s.onlyTabbable);
    if (c) {
      var p = i(c, s.cycle);
      p && $N(p.node, s.focusOptions);
    }
  },
  Noe = function (t, e) {
    e === void 0 && (e = {}), z$(t, e, function (i, s) {
      var c = i.next,
        p = i.first;
      return c || s && p;
    });
  },
  zoe = function (t, e) {
    e === void 0 && (e = {}), z$(t, e, function (i, s) {
      var c = i.prev,
        p = i.last;
      return c || s && p;
    });
  },
  V$ = function (t, e, i) {
    var s,
      c = joe(t, (s = e.onlyTabbable) !== null && s !== void 0 ? s : !0),
      p = c[i];
    p && $N(p.node, e.focusOptions);
  },
  Voe = function (t, e) {
    e === void 0 && (e = {}), V$(t, e, "first");
  },
  Boe = function (t, e) {
    e === void 0 && (e = {}), V$(t, e, "last");
  },
  B$ = function () {
    return document && document.activeElement === document.body;
  },
  Uoe = function () {
    return B$() || Coe();
  },
  mE = null,
  td = null,
  BB = function () {
    return null;
  },
  vE = null,
  yR = !1,
  WN = !1,
  Hoe = function () {
    return !0;
  },
  $oe = function (e) {
    return (mE.whiteList || Hoe)(e);
  },
  Woe = function (e, i) {
    vE = {
      observerNode: e,
      portaledElement: i
    };
  },
  qoe = function (e) {
    return vE && vE.portaledElement === e;
  };
function UB(t, e, i, s) {
  var c = null,
    p = t;
  do {
    var h = s[p];
    if (h.guard) h.node.dataset.focusAutoGuard && (c = h);else if (h.lockItem) {
      if (p !== t) return;
      c = null;
    } else break;
  } while ((p += i) !== e);
  c && (c.node.tabIndex = 0);
}
var Yoe = function (e) {
    return e ? !!yR : yR === "meanwhile";
  },
  Goe = function t(e, i, s) {
    return i && (i.host === e && (!i.activeElement || s.contains(i.activeElement)) || i.parentNode && t(e, i.parentNode, s));
  },
  Xoe = function (e, i) {
    return i.some(function (s) {
      return Goe(e, s, s);
    });
  },
  U$ = function (e) {
    return vR(e, /* @__PURE__ */new Map());
  },
  Koe = function (e) {
    return !U$([e.parentNode]).some(function (i) {
      return i.node === e;
    });
  },
  kL = function () {
    var e = !1;
    if (mE) {
      var i = mE,
        s = i.observed,
        c = i.persistentFocus,
        p = i.autoFocus,
        h = i.shards,
        y = i.crossFrame,
        w = i.focusOptions,
        x = i.noFocusGuards,
        E = s || vE && vE.portaledElement;
      if (B$() && td && td !== document.body && (!document.body.contains(td) || Koe(td))) {
        var C = BB();
        C && C.focus();
      }
      var k = document && document.activeElement;
      if (E) {
        var D = [E].concat(h.map(Zae).filter(Boolean)),
          I = function () {
            if (!Yoe(y) || !x || !td || WN) return !1;
            var F = U$(D),
              j = F.findIndex(function (V) {
                var K = V.node;
                return K === td;
              });
            return j === 0 || j === F.length - 1;
          };
        if ((!k || $oe(k)) && (c || I() || !Uoe() || !td && p) && (E && !(A$(D) || k && Xoe(k, D) || qoe(k)) && (document && !td && k && !p ? (k.blur && k.blur(), document.body.focus()) : (e = F$(D, td, {
          focusOptions: w
        }), vE = {})), td = document && document.activeElement, td !== document.body && (BB = N$(td)), yR = !1), document && k !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
          var L = document && document.activeElement,
            P = Loe(D),
            N = P.map(function (O) {
              var F = O.node;
              return F;
            }).indexOf(L);
          N > -1 && (P.filter(function (O) {
            var F = O.guard,
              j = O.node;
            return F && j.dataset.focusAutoGuard;
          }).forEach(function (O) {
            var F = O.node;
            return F.removeAttribute("tabIndex");
          }), UB(N, P.length, 1, P), UB(N, -1, -1, P));
        }
      }
    }
    return e;
  },
  H$ = function (e) {
    kL() && e && (e.stopPropagation(), e.preventDefault());
  },
  qN = function () {
    return jN(kL);
  },
  Qoe = function (e) {
    var i = e.target,
      s = e.currentTarget;
    s.contains(i) || Woe(s, i);
  },
  Zoe = function () {
    return null;
  };
process.env.NODE_ENV !== "production" && g$.node.isRequired;
var $$ = function () {
    WN = !0;
  },
  W$ = function () {
    WN = !1, yR = "just", jN(function () {
      yR = "meanwhile";
    });
  },
  Joe = function () {
    document.addEventListener("focusin", H$), document.addEventListener("focusout", qN), window.addEventListener("focus", $$), window.addEventListener("blur", W$);
  },
  ele = function () {
    document.removeEventListener("focusin", H$), document.removeEventListener("focusout", qN), window.removeEventListener("focus", $$), window.removeEventListener("blur", W$);
  };
function tle(t) {
  return t.filter(function (e) {
    var i = e.disabled;
    return !i;
  });
}
var q$ = {
  moveFocusInside: F$,
  focusInside: A$,
  focusNextElement: Noe,
  focusPrevElement: zoe,
  focusFirstElement: Voe,
  focusLastElement: Boe,
  captureFocusRestore: N$
};
function nle(t) {
  var e = t.slice(-1)[0];
  e && !mE && Joe();
  var i = mE,
    s = i && e && e.id === i.id;
  mE = e, i && !s && (i.onDeactivation(), t.filter(function (c) {
    var p = c.id;
    return p === i.id;
  }).length || i.returnFocus(!e)), e ? (td = null, (!s || i.observed !== e.observed) && e.onActivation(q$), kL(), jN(kL)) : (ele(), td = null);
}
b$.assignSyncMedium(Qoe);
w$.assignMedium(qN);
Xae.assignMedium(function (t) {
  return t(q$);
});
const rle = aoe(tle, nle)(Zoe);
LN(_$, rle);
var ile = function () {
  if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
function ale() {
  if (!document) return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = ile();
  return e && t.setAttribute("nonce", e), t;
}
function ole(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function lle(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var sle = function () {
    var t = 0,
      e = null;
    return {
      add: function (i) {
        t == 0 && (e = ale()) && (ole(e, i), lle(e)), t++;
      },
      remove: function () {
        t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
      }
    };
  },
  ule = function () {
    var t = sle();
    return function (e, i) {
      Bn.useEffect(function () {
        return t.add(e), function () {
          t.remove();
        };
      }, [e && i]);
    };
  },
  YN = function () {
    var t = ule(),
      e = function (i) {
        var s = i.styles,
          c = i.dynamic;
        return t(s, c), null;
      };
    return e;
  },
  cle = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  Wj = function (t) {
    return parseInt(t || "", 10) || 0;
  },
  dle = function (t) {
    var e = window.getComputedStyle(document.body),
      i = e[t === "padding" ? "paddingLeft" : "marginLeft"],
      s = e[t === "padding" ? "paddingTop" : "marginTop"],
      c = e[t === "padding" ? "paddingRight" : "marginRight"];
    return [Wj(i), Wj(s), Wj(c)];
  },
  fle = function (t) {
    if (t === void 0 && (t = "margin"), typeof window > "u") return cle;
    var e = dle(t),
      i = document.documentElement.clientWidth,
      s = window.innerWidth;
    return {
      left: e[0],
      top: e[1],
      right: e[2],
      gap: Math.max(0, s - i + e[2] - e[0])
    };
  },
  ple = YN(),
  gE = "data-scroll-locked",
  hle = function (t, e, i, s) {
    var c = t.left,
      p = t.top,
      h = t.right,
      y = t.gap;
    return i === void 0 && (i = "margin"), `
  .`.concat(jae, ` {
   overflow: hidden `).concat(s, `;
   padding-right: `).concat(y, "px ").concat(s, `;
  }
  body[`).concat(gE, `] {
    overflow: hidden `).concat(s, `;
    overscroll-behavior: contain;
    `).concat([e && "position: relative ".concat(s, ";"), i === "margin" && `
    padding-left: `.concat(c, `px;
    padding-top: `).concat(p, `px;
    padding-right: `).concat(h, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(y, "px ").concat(s, `;
    `), i === "padding" && "padding-right: ".concat(y, "px ").concat(s, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(WM, ` {
    right: `).concat(y, "px ").concat(s, `;
  }
  
  .`).concat(qM, ` {
    margin-right: `).concat(y, "px ").concat(s, `;
  }
  
  .`).concat(WM, " .").concat(WM, ` {
    right: 0 `).concat(s, `;
  }
  
  .`).concat(qM, " .").concat(qM, ` {
    margin-right: 0 `).concat(s, `;
  }
  
  body[`).concat(gE, `] {
    `).concat(Fae, ": ").concat(y, `px;
  }
`);
  },
  HB = function () {
    var t = parseInt(document.body.getAttribute(gE) || "0", 10);
    return isFinite(t) ? t : 0;
  },
  mle = function () {
    Bn.useEffect(function () {
      return document.body.setAttribute(gE, (HB() + 1).toString()), function () {
        var t = HB() - 1;
        t <= 0 ? document.body.removeAttribute(gE) : document.body.setAttribute(gE, t.toString());
      };
    }, []);
  },
  vle = function (t) {
    var e = t.noRelative,
      i = t.noImportant,
      s = t.gapMode,
      c = s === void 0 ? "margin" : s;
    mle();
    var p = Bn.useMemo(function () {
      return fle(c);
    }, [c]);
    return Bn.createElement(ple, {
      styles: hle(p, !e, c, i ? "" : "!important")
    });
  },
  X2 = !1;
if (typeof window < "u") try {
  var bM = Object.defineProperty({}, "passive", {
    get: function () {
      return X2 = !0, !0;
    }
  });
  window.addEventListener("test", bM, bM), window.removeEventListener("test", bM, bM);
} catch {
  X2 = !1;
}
var Q1 = X2 ? {
    passive: !1
  } : !1,
  gle = function (t) {
    return t.tagName === "TEXTAREA";
  },
  Y$ = function (t, e) {
    if (!(t instanceof Element)) return !1;
    var i = window.getComputedStyle(t);
    return (
      // not-not-scrollable
      i[e] !== "hidden" &&
      // contains scroll inside self
      !(i.overflowY === i.overflowX && !gle(t) && i[e] === "visible")
    );
  },
  yle = function (t) {
    return Y$(t, "overflowY");
  },
  ble = function (t) {
    return Y$(t, "overflowX");
  },
  $B = function (t, e) {
    var i = e.ownerDocument,
      s = e;
    do {
      typeof ShadowRoot < "u" && s instanceof ShadowRoot && (s = s.host);
      var c = G$(t, s);
      if (c) {
        var p = X$(t, s),
          h = p[1],
          y = p[2];
        if (h > y) return !0;
      }
      s = s.parentNode;
    } while (s && s !== i.body);
    return !1;
  },
  wle = function (t) {
    var e = t.scrollTop,
      i = t.scrollHeight,
      s = t.clientHeight;
    return [e, i, s];
  },
  _le = function (t) {
    var e = t.scrollLeft,
      i = t.scrollWidth,
      s = t.clientWidth;
    return [e, i, s];
  },
  G$ = function (t, e) {
    return t === "v" ? yle(e) : ble(e);
  },
  X$ = function (t, e) {
    return t === "v" ? wle(e) : _le(e);
  },
  xle = function (t, e) {
    return t === "h" && e === "rtl" ? -1 : 1;
  },
  Sle = function (t, e, i, s, c) {
    var p = xle(t, window.getComputedStyle(e).direction),
      h = p * s,
      y = i.target,
      w = e.contains(y),
      x = !1,
      E = h > 0,
      C = 0,
      k = 0;
    do {
      if (!y) break;
      var D = X$(t, y),
        I = D[0],
        L = D[1],
        P = D[2],
        N = L - P - p * I;
      (I || N) && G$(t, y) && (C += N, k += I);
      var O = y.parentNode;
      y = O && O.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? O.host : O;
    } while (
    // portaled content
    !w && y !== document.body ||
    // self content
    w && (e.contains(y) || e === y));
    return (E && Math.abs(C) < 1 || !E && Math.abs(k) < 1) && (x = !0), x;
  },
  wM = function (t) {
    return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
  },
  WB = function (t) {
    return [t.deltaX, t.deltaY];
  },
  qB = function (t) {
    return t && "current" in t ? t.current : t;
  },
  Ele = function (t, e) {
    return t[0] === e[0] && t[1] === e[1];
  },
  Cle = function (t) {
    return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
  },
  kle = 0,
  Z1 = [];
function Tle(t) {
  var e = Bn.useRef([]),
    i = Bn.useRef([0, 0]),
    s = Bn.useRef(),
    c = Bn.useState(kle++)[0],
    p = Bn.useState(YN)[0],
    h = Bn.useRef(t);
  Bn.useEffect(function () {
    h.current = t;
  }, [t]), Bn.useEffect(function () {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(c));
      var L = Aae([t.lockRef.current], (t.shards || []).map(qB), !0).filter(Boolean);
      return L.forEach(function (P) {
        return P.classList.add("allow-interactivity-".concat(c));
      }), function () {
        document.body.classList.remove("block-interactivity-".concat(c)), L.forEach(function (P) {
          return P.classList.remove("allow-interactivity-".concat(c));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var y = Bn.useCallback(function (L, P) {
      if ("touches" in L && L.touches.length === 2 || L.type === "wheel" && L.ctrlKey) return !h.current.allowPinchZoom;
      var N = wM(L),
        O = i.current,
        F = "deltaX" in L ? L.deltaX : O[0] - N[0],
        j = "deltaY" in L ? L.deltaY : O[1] - N[1],
        V,
        K = L.target,
        G = Math.abs(F) > Math.abs(j) ? "h" : "v";
      if ("touches" in L && G === "h" && K.type === "range") return !1;
      var Q = $B(G, K);
      if (!Q) return !0;
      if (Q ? V = G : (V = G === "v" ? "h" : "v", Q = $B(G, K)), !Q) return !1;
      if (!s.current && "changedTouches" in L && (F || j) && (s.current = V), !V) return !0;
      var te = s.current || V;
      return Sle(te, P, L, te === "h" ? F : j);
    }, []),
    w = Bn.useCallback(function (L) {
      var P = L;
      if (!(!Z1.length || Z1[Z1.length - 1] !== p)) {
        var N = "deltaY" in P ? WB(P) : wM(P),
          O = e.current.filter(function (V) {
            return V.name === P.type && (V.target === P.target || P.target === V.shadowParent) && Ele(V.delta, N);
          })[0];
        if (O && O.should) {
          P.cancelable && P.preventDefault();
          return;
        }
        if (!O) {
          var F = (h.current.shards || []).map(qB).filter(Boolean).filter(function (V) {
              return V.contains(P.target);
            }),
            j = F.length > 0 ? y(P, F[0]) : !h.current.noIsolation;
          j && P.cancelable && P.preventDefault();
        }
      }
    }, []),
    x = Bn.useCallback(function (L, P, N, O) {
      var F = {
        name: L,
        delta: P,
        target: N,
        should: O,
        shadowParent: Rle(N)
      };
      e.current.push(F), setTimeout(function () {
        e.current = e.current.filter(function (j) {
          return j !== F;
        });
      }, 1);
    }, []),
    E = Bn.useCallback(function (L) {
      i.current = wM(L), s.current = void 0;
    }, []),
    C = Bn.useCallback(function (L) {
      x(L.type, WB(L), L.target, y(L, t.lockRef.current));
    }, []),
    k = Bn.useCallback(function (L) {
      x(L.type, wM(L), L.target, y(L, t.lockRef.current));
    }, []);
  Bn.useEffect(function () {
    return Z1.push(p), t.setCallbacks({
      onScrollCapture: C,
      onWheelCapture: C,
      onTouchMoveCapture: k
    }), document.addEventListener("wheel", w, Q1), document.addEventListener("touchmove", w, Q1), document.addEventListener("touchstart", E, Q1), function () {
      Z1 = Z1.filter(function (L) {
        return L !== p;
      }), document.removeEventListener("wheel", w, Q1), document.removeEventListener("touchmove", w, Q1), document.removeEventListener("touchstart", E, Q1);
    };
  }, []);
  var D = t.removeScrollBar,
    I = t.inert;
  return Bn.createElement(Bn.Fragment, null, I ? Bn.createElement(p, {
    styles: Cle(c)
  }) : null, D ? Bn.createElement(vle, {
    noRelative: t.noRelative,
    gapMode: t.gapMode
  }) : null);
}
function Rle(t) {
  for (var e = null; t !== null;) t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
LN(h$, Tle);
var Dle = function (t) {
    if (typeof document > "u") return null;
    var e = Array.isArray(t) ? t[0] : t;
    return e.ownerDocument.body;
  },
  J1 = /* @__PURE__ */new WeakMap(),
  _M = /* @__PURE__ */new WeakMap(),
  xM = {},
  qj = 0,
  K$ = function (t) {
    return t && (t.host || K$(t.parentNode));
  },
  Ile = function (t, e) {
    return e.map(function (i) {
      if (t.contains(i)) return i;
      var s = K$(i);
      return s && t.contains(s) ? s : (console.error("aria-hidden", i, "in not contained inside", t, ". Doing nothing"), null);
    }).filter(function (i) {
      return !!i;
    });
  },
  Mle = function (t, e, i, s) {
    var c = Ile(e, Array.isArray(t) ? t : [t]);
    xM[i] || (xM[i] = /* @__PURE__ */new WeakMap());
    var p = xM[i],
      h = [],
      y = /* @__PURE__ */new Set(),
      w = new Set(c),
      x = function (C) {
        !C || y.has(C) || (y.add(C), x(C.parentNode));
      };
    c.forEach(x);
    var E = function (C) {
      !C || w.has(C) || Array.prototype.forEach.call(C.children, function (k) {
        if (y.has(k)) E(k);else try {
          var D = k.getAttribute(s),
            I = D !== null && D !== "false",
            L = (J1.get(k) || 0) + 1,
            P = (p.get(k) || 0) + 1;
          J1.set(k, L), p.set(k, P), h.push(k), L === 1 && I && _M.set(k, !0), P === 1 && k.setAttribute(i, "true"), I || k.setAttribute(s, "true");
        } catch (N) {
          console.error("aria-hidden: cannot operate on ", k, N);
        }
      });
    };
    return E(e), y.clear(), qj++, function () {
      h.forEach(function (C) {
        var k = J1.get(C) - 1,
          D = p.get(C) - 1;
        J1.set(C, k), p.set(C, D), k || (_M.has(C) || C.removeAttribute(s), _M.delete(C)), D || C.removeAttribute(i);
      }), qj--, qj || (J1 = /* @__PURE__ */new WeakMap(), J1 = /* @__PURE__ */new WeakMap(), _M = /* @__PURE__ */new WeakMap(), xM = {});
    };
  },
  Lle = function (t, e, i) {
    var s = Array.from(Array.isArray(t) ? t : [t]),
      c = e || Dle(t);
    return c ? (s.push.apply(s, Array.from(c.querySelectorAll("[aria-live], script"))), Mle(s, c, i, "aria-hidden")) : function () {
      return null;
    };
  },
  Ole = YN(),
  Ple = `
 [` + E$ + `] {
   pointer-events: none !important;
 }
`,
  Ale = function () {
    return Bn.createElement(Ole, {
      styles: Ple
    });
  },
  YB = function (t) {
    return "current" in t ? t.current : t;
  };
function jle(t) {
  var e = t.setLockProps,
    i = t.onEscapeKey,
    s = t.onClickOutside,
    c = t.shards,
    p = t.onActivation,
    h = t.onDeactivation,
    y = t.noIsolation,
    w = rt(void 0),
    x = w[0],
    E = w[1],
    C = vt(null),
    k = vt(0);
  return Bn.useEffect(function () {
    var D = function (N) {
        N.defaultPrevented || (N.code === "Escape" || N.key === "Escape" || N.keyCode === 27) && i && i(N);
      },
      I = function (N) {
        N.defaultPrevented || N.target === C.current || N instanceof MouseEvent && N.button !== 0 || c && c.map(YB).some(function (O) {
          return O && O.contains(N.target) || O === N.target;
        }) || s && s(N);
      },
      L = function (N) {
        I(N), k.current = N.touches.length;
      },
      P = function (N) {
        k.current = N.touches.length;
      };
    if (x) return x.ownerDocument.addEventListener("keydown", D), x.ownerDocument.addEventListener("mousedown", I), x.ownerDocument.addEventListener("touchstart", L), x.ownerDocument.addEventListener("touchend", P), function () {
      x.ownerDocument.removeEventListener("keydown", D), x.ownerDocument.removeEventListener("mousedown", I), x.ownerDocument.removeEventListener("touchstart", L), x.ownerDocument.removeEventListener("touchend", P);
    };
  }, [x, s, i]), Rt(function () {
    if (x) return p && p(x), function () {
      h && h();
    };
  }, [!!x]), Rt(function () {
    var D = function () {
        return null;
      },
      I = !1,
      L = function (N) {
        y || (D = Lle(Pae([N], (c || []).map(YB)), N.ownerDocument.body, E$)), E(function () {
          return N;
        });
      },
      P = function () {
        D(), I || E(null);
      };
    return e({
      onMouseDown: function (N) {
        C.current = N.target;
      },
      onTouchStart: function (N) {
        C.current = N.target;
      },
      onActivation: L,
      onDeactivation: P
    }), function () {
      I = !0, e(!1);
    };
  }, []), Bn.createElement(Ale, null);
}
const Fle = LN(S$, jle);
var Nle = function (t) {
    return Bn.createElement(Fle, ld({}, t));
  },
  GN = Bn.forwardRef(function (t, e) {
    return Bn.createElement(eoe, ld({}, t, {
      ref: e,
      sideCar: Nle
    }));
  });
const Q$ = Up({});
function zle(t) {
  const e = vt(null);
  return e.current === null && (e.current = t()), e.current;
}
const XN = typeof window < "u",
  Vle = XN ? NR : Rt,
  KN = /* @__PURE__ */Up(null);
function QN(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function ZN(t, e) {
  const i = t.indexOf(e);
  i > -1 && t.splice(i, 1);
}
const wb = (t, e, i) => i > e ? e : i < t ? t : i;
function K2(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let VE = () => {},
  _b = () => {};
process.env.NODE_ENV !== "production" && (VE = (t, e, i) => {
  !t && typeof console < "u" && console.warn(K2(e, i));
}, _b = (t, e, i) => {
  if (!t) throw new Error(K2(e, i));
});
const xb = {},
  Z$ = t => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function J$(t) {
  return typeof t == "object" && t !== null;
}
const e6 = t => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function JN(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Bp = /* @__NO_SIDE_EFFECTS__ */t => t,
  Ble = (t, e) => i => e(t(i)),
  $R = (...t) => t.reduce(Ble),
  bR = /* @__NO_SIDE_EFFECTS__ */(t, e, i) => {
    const s = e - t;
    return s === 0 ? 1 : (i - t) / s;
  };
class ez {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return QN(this.subscriptions, e), () => ZN(this.subscriptions, e);
  }
  notify(e, i, s) {
    const c = this.subscriptions.length;
    if (c) if (c === 1) this.subscriptions[0](e, i, s);else for (let p = 0; p < c; p++) {
      const h = this.subscriptions[p];
      h && h(e, i, s);
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const qm = /* @__NO_SIDE_EFFECTS__ */t => t * 1e3,
  Xv = /* @__NO_SIDE_EFFECTS__ */t => t / 1e3;
function t6(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const GB = /* @__PURE__ */new Set();
function QL(t, e, i) {
  t || GB.has(e) || (console.warn(K2(e, i)), GB.add(e));
}
const n6 = (t, e, i) => (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t + 3 * e) * t,
  Ule = 1e-7,
  Hle = 12;
function $le(t, e, i, s, c) {
  let p,
    h,
    y = 0;
  do h = e + (i - e) / 2, p = n6(h, s, c) - t, p > 0 ? i = h : e = h; while (Math.abs(p) > Ule && ++y < Hle);
  return h;
}
function WR(t, e, i, s) {
  if (t === e && i === s) return Bp;
  const c = p => $le(p, 0, 1, t, i);
  return p => p === 0 || p === 1 ? p : n6(c(p), e, s);
}
const r6 = t => e => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2,
  i6 = t => e => 1 - t(1 - e),
  a6 = /* @__PURE__ */WR(0.33, 1.53, 0.69, 0.99),
  tz = /* @__PURE__ */i6(a6),
  o6 = /* @__PURE__ */r6(tz),
  l6 = t => (t *= 2) < 1 ? 0.5 * tz(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))),
  nz = t => 1 - Math.sin(Math.acos(t)),
  s6 = i6(nz),
  u6 = r6(nz),
  Wle = /* @__PURE__ */WR(0.42, 0, 1, 1),
  qle = /* @__PURE__ */WR(0, 0, 0.58, 1),
  c6 = /* @__PURE__ */WR(0.42, 0, 0.58, 1),
  Yle = t => Array.isArray(t) && typeof t[0] != "number",
  d6 = t => Array.isArray(t) && typeof t[0] == "number",
  XB = {
    linear: Bp,
    easeIn: Wle,
    easeInOut: c6,
    easeOut: qle,
    circIn: nz,
    circInOut: u6,
    circOut: s6,
    backIn: tz,
    backInOut: o6,
    backOut: a6,
    anticipate: l6
  },
  Gle = t => typeof t == "string",
  KB = t => {
    if (d6(t)) {
      _b(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
      const [e, i, s, c] = t;
      return WR(e, i, s, c);
    } else if (Gle(t)) return _b(XB[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), XB[t];
    return t;
  },
  SM = ["setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
  ];
function Xle(t, e) {
  let i = /* @__PURE__ */new Set(),
    s = /* @__PURE__ */new Set(),
    c = !1,
    p = !1;
  const h = /* @__PURE__ */new WeakSet();
  let y = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function w(E) {
    h.has(E) && (x.schedule(E), t()), E(y);
  }
  const x = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (E, C = !1, k = !1) => {
      const I = k && c ? i : s;
      return C && h.add(E), I.has(E) || I.add(E), E;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: E => {
      s.delete(E), h.delete(E);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: E => {
      if (y = E, c) {
        p = !0;
        return;
      }
      c = !0, [i, s] = [s, i], i.forEach(w), i.clear(), c = !1, p && (p = !1, x.process(E));
    }
  };
  return x;
}
const Kle = 40;
function f6(t, e) {
  let i = !1,
    s = !0;
  const c = {
      delta: 0,
      timestamp: 0,
      isProcessing: !1
    },
    p = () => i = !0,
    h = SM.reduce((F, j) => (F[j] = Xle(p), F), {}),
    {
      setup: y,
      read: w,
      resolveKeyframes: x,
      preUpdate: E,
      update: C,
      preRender: k,
      render: D,
      postRender: I
    } = h,
    L = () => {
      const F = xb.useManualTiming ? c.timestamp : performance.now();
      i = !1, xb.useManualTiming || (c.delta = s ? 1e3 / 60 : Math.max(Math.min(F - c.timestamp, Kle), 1)), c.timestamp = F, c.isProcessing = !0, y.process(c), w.process(c), x.process(c), E.process(c), C.process(c), k.process(c), D.process(c), I.process(c), c.isProcessing = !1, i && e && (s = !1, t(L));
    },
    P = () => {
      i = !0, s = !0, c.isProcessing || t(L);
    };
  return {
    schedule: SM.reduce((F, j) => {
      const V = h[j];
      return F[j] = (K, G = !1, Q = !1) => (i || P(), V.schedule(K, G, Q)), F;
    }, {}),
    cancel: F => {
      for (let j = 0; j < SM.length; j++) h[SM[j]].cancel(F);
    },
    state: c,
    steps: h
  };
}
const {
  schedule: Ua,
  cancel: ow,
  state: su,
  steps: Yj
} = /* @__PURE__ */f6(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Bp, !0);
let YM;
function Qle() {
  YM = void 0;
}
const sd = {
    now: () => (YM === void 0 && sd.set(su.isProcessing || xb.useManualTiming ? su.timestamp : performance.now()), YM),
    set: t => {
      YM = t, queueMicrotask(Qle);
    }
  },
  p6 = t => e => typeof e == "string" && e.startsWith(t),
  rz = /* @__PURE__ */p6("--"),
  Zle = /* @__PURE__ */p6("var(--"),
  iz = t => Zle(t) ? Jle.test(t.split("/*")[0].trim()) : !1,
  Jle = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
  BE = {
    test: t => typeof t == "number",
    parse: parseFloat,
    transform: t => t
  },
  wR = {
    ...BE,
    transform: t => wb(0, 1, t)
  },
  EM = {
    ...BE,
    default: 1
  },
  YT = t => Math.round(t * 1e5) / 1e5,
  az = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function ese(t) {
  return t == null;
}
const tse = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  oz = (t, e) => i => !!(typeof i == "string" && tse.test(i) && i.startsWith(t) || e && !ese(i) && Object.prototype.hasOwnProperty.call(i, e)),
  h6 = (t, e, i) => s => {
    if (typeof s != "string") return s;
    const [c, p, h, y] = s.match(az);
    return {
      [t]: parseFloat(c),
      [e]: parseFloat(p),
      [i]: parseFloat(h),
      alpha: y !== void 0 ? parseFloat(y) : 1
    };
  },
  nse = t => wb(0, 255, t),
  Gj = {
    ...BE,
    transform: t => Math.round(nse(t))
  },
  $x = {
    test: /* @__PURE__ */oz("rgb", "red"),
    parse: /* @__PURE__ */h6("red", "green", "blue"),
    transform: ({
      red: t,
      green: e,
      blue: i,
      alpha: s = 1
    }) => "rgba(" + Gj.transform(t) + ", " + Gj.transform(e) + ", " + Gj.transform(i) + ", " + YT(wR.transform(s)) + ")"
  };
function rse(t) {
  let e = "",
    i = "",
    s = "",
    c = "";
  return t.length > 5 ? (e = t.substring(1, 3), i = t.substring(3, 5), s = t.substring(5, 7), c = t.substring(7, 9)) : (e = t.substring(1, 2), i = t.substring(2, 3), s = t.substring(3, 4), c = t.substring(4, 5), e += e, i += i, s += s, c += c), {
    red: parseInt(e, 16),
    green: parseInt(i, 16),
    blue: parseInt(s, 16),
    alpha: c ? parseInt(c, 16) / 255 : 1
  };
}
const Q2 = {
    test: /* @__PURE__ */oz("#"),
    parse: rse,
    transform: $x.transform
  },
  qR = /* @__NO_SIDE_EFFECTS__ */t => ({
    test: e => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: e => `${e}${t}`
  }),
  X0 = /* @__PURE__ */qR("deg"),
  Kv = /* @__PURE__ */qR("%"),
  Yn = /* @__PURE__ */qR("px"),
  ise = /* @__PURE__ */qR("vh"),
  ase = /* @__PURE__ */qR("vw"),
  QB = {
    ...Kv,
    parse: t => Kv.parse(t) / 100,
    transform: t => Kv.transform(t * 100)
  },
  lE = {
    test: /* @__PURE__ */oz("hsl", "hue"),
    parse: /* @__PURE__ */h6("hue", "saturation", "lightness"),
    transform: ({
      hue: t,
      saturation: e,
      lightness: i,
      alpha: s = 1
    }) => "hsla(" + Math.round(t) + ", " + Kv.transform(YT(e)) + ", " + Kv.transform(YT(i)) + ", " + YT(wR.transform(s)) + ")"
  },
  Sl = {
    test: t => $x.test(t) || Q2.test(t) || lE.test(t),
    parse: t => $x.test(t) ? $x.parse(t) : lE.test(t) ? lE.parse(t) : Q2.parse(t),
    transform: t => typeof t == "string" ? t : t.hasOwnProperty("red") ? $x.transform(t) : lE.transform(t),
    getAnimatableNone: t => {
      const e = Sl.parse(t);
      return e.alpha = 0, Sl.transform(e);
    }
  },
  ose = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function lse(t) {
  var e, i;
  return isNaN(t) && typeof t == "string" && (((e = t.match(az)) == null ? void 0 : e.length) || 0) + (((i = t.match(ose)) == null ? void 0 : i.length) || 0) > 0;
}
const m6 = "number",
  v6 = "color",
  sse = "var",
  use = "var(",
  ZB = "${}",
  cse = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function _R(t) {
  const e = t.toString(),
    i = [],
    s = {
      color: [],
      number: [],
      var: []
    },
    c = [];
  let p = 0;
  const y = e.replace(cse, w => (Sl.test(w) ? (s.color.push(p), c.push(v6), i.push(Sl.parse(w))) : w.startsWith(use) ? (s.var.push(p), c.push(sse), i.push(w)) : (s.number.push(p), c.push(m6), i.push(parseFloat(w))), ++p, ZB)).split(ZB);
  return {
    values: i,
    split: y,
    indexes: s,
    types: c
  };
}
function g6(t) {
  return _R(t).values;
}
function y6(t) {
  const {
      split: e,
      types: i
    } = _R(t),
    s = e.length;
  return c => {
    let p = "";
    for (let h = 0; h < s; h++) if (p += e[h], c[h] !== void 0) {
      const y = i[h];
      y === m6 ? p += YT(c[h]) : y === v6 ? p += Sl.transform(c[h]) : p += c[h];
    }
    return p;
  };
}
const dse = t => typeof t == "number" ? 0 : Sl.test(t) ? Sl.getAnimatableNone(t) : t;
function fse(t) {
  const e = g6(t);
  return y6(t)(e.map(dse));
}
const lw = {
  test: lse,
  parse: g6,
  createTransformer: y6,
  getAnimatableNone: fse
};
function Xj(t, e, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + (e - t) * 6 * i : i < 1 / 2 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
function pse({
  hue: t,
  saturation: e,
  lightness: i,
  alpha: s
}) {
  t /= 360, e /= 100, i /= 100;
  let c = 0,
    p = 0,
    h = 0;
  if (!e) c = p = h = i;else {
    const y = i < 0.5 ? i * (1 + e) : i + e - i * e,
      w = 2 * i - y;
    c = Xj(w, y, t + 1 / 3), p = Xj(w, y, t), h = Xj(w, y, t - 1 / 3);
  }
  return {
    red: Math.round(c * 255),
    green: Math.round(p * 255),
    blue: Math.round(h * 255),
    alpha: s
  };
}
function TL(t, e) {
  return i => i > 0 ? e : t;
}
const go = (t, e, i) => t + (e - t) * i,
  Kj = (t, e, i) => {
    const s = t * t,
      c = i * (e * e - s) + s;
    return c < 0 ? 0 : Math.sqrt(c);
  },
  hse = [Q2, $x, lE],
  mse = t => hse.find(e => e.test(t));
function JB(t) {
  const e = mse(t);
  if (VE(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e) return !1;
  let i = e.parse(t);
  return e === lE && (i = pse(i)), i;
}
const e3 = (t, e) => {
    const i = JB(t),
      s = JB(e);
    if (!i || !s) return TL(t, e);
    const c = {
      ...i
    };
    return p => (c.red = Kj(i.red, s.red, p), c.green = Kj(i.green, s.green, p), c.blue = Kj(i.blue, s.blue, p), c.alpha = go(i.alpha, s.alpha, p), $x.transform(c));
  },
  Z2 = /* @__PURE__ */new Set(["none", "hidden"]);
function vse(t, e) {
  return Z2.has(t) ? i => i <= 0 ? t : e : i => i >= 1 ? e : t;
}
function gse(t, e) {
  return i => go(t, e, i);
}
function lz(t) {
  return typeof t == "number" ? gse : typeof t == "string" ? iz(t) ? TL : Sl.test(t) ? e3 : wse : Array.isArray(t) ? b6 : typeof t == "object" ? Sl.test(t) ? e3 : yse : TL;
}
function b6(t, e) {
  const i = [...t],
    s = i.length,
    c = t.map((p, h) => lz(p)(p, e[h]));
  return p => {
    for (let h = 0; h < s; h++) i[h] = c[h](p);
    return i;
  };
}
function yse(t, e) {
  const i = {
      ...t,
      ...e
    },
    s = {};
  for (const c in i) t[c] !== void 0 && e[c] !== void 0 && (s[c] = lz(t[c])(t[c], e[c]));
  return c => {
    for (const p in s) i[p] = s[p](c);
    return i;
  };
}
function bse(t, e) {
  const i = [],
    s = {
      color: 0,
      var: 0,
      number: 0
    };
  for (let c = 0; c < e.values.length; c++) {
    const p = e.types[c],
      h = t.indexes[p][s[p]],
      y = t.values[h] ?? 0;
    i[c] = y, s[p]++;
  }
  return i;
}
const wse = (t, e) => {
  const i = lw.createTransformer(e),
    s = _R(t),
    c = _R(e);
  return s.indexes.var.length === c.indexes.var.length && s.indexes.color.length === c.indexes.color.length && s.indexes.number.length >= c.indexes.number.length ? Z2.has(t) && !c.values.length || Z2.has(e) && !s.values.length ? vse(t, e) : $R(b6(bse(s, c), c.values), i) : (VE(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), TL(t, e));
};
function w6(t, e, i) {
  return typeof t == "number" && typeof e == "number" && typeof i == "number" ? go(t, e, i) : lz(t)(t, e);
}
const _se = t => {
    const e = ({
      timestamp: i
    }) => t(i);
    return {
      start: (i = !0) => Ua.update(e, i),
      stop: () => ow(e),
      /**
       * If we're processing this frame we can use the
       * framelocked timestamp to keep things in sync.
       */
      now: () => su.isProcessing ? su.timestamp : sd.now()
    };
  },
  _6 = (t, e, i = 10) => {
    let s = "";
    const c = Math.max(Math.round(e / i), 2);
    for (let p = 0; p < c; p++) s += Math.round(t(p / (c - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${s.substring(0, s.length - 2)})`;
  },
  RL = 2e4;
function sz(t) {
  let e = 0;
  const i = 50;
  let s = t.next(e);
  for (; !s.done && e < RL;) e += i, s = t.next(e);
  return e >= RL ? 1 / 0 : e;
}
function xse(t, e = 100, i) {
  const s = i({
      ...t,
      keyframes: [0, e]
    }),
    c = Math.min(sz(s), RL);
  return {
    type: "keyframes",
    ease: p => s.next(c * p).value / e,
    duration: /* @__PURE__ */Xv(c)
  };
}
const Sse = 5;
function x6(t, e, i) {
  const s = Math.max(e - Sse, 0);
  return t6(i - t(s), e - s);
}
const vo = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    // Default duration/bounce-based options
    duration: 800,
    // in ms
    bounce: 0.3,
    visualDuration: 0.3,
    // in seconds
    // Rest thresholds
    restSpeed: {
      granular: 0.01,
      default: 2
    },
    restDelta: {
      granular: 5e-3,
      default: 0.5
    },
    // Limits
    minDuration: 0.01,
    // in seconds
    maxDuration: 10,
    // in seconds
    minDamping: 0.05,
    maxDamping: 1
  },
  t3 = 1e-3;
function Ese({
  duration: t = vo.duration,
  bounce: e = vo.bounce,
  velocity: i = vo.velocity,
  mass: s = vo.mass
}) {
  let c, p;
  VE(t <= /* @__PURE__ */qm(vo.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let h = 1 - e;
  h = wb(vo.minDamping, vo.maxDamping, h), t = wb(vo.minDuration, vo.maxDuration, /* @__PURE__ */Xv(t)), h < 1 ? (c = x => {
    const E = x * h,
      C = E * t,
      k = E - i,
      D = J2(x, h),
      I = Math.exp(-C);
    return t3 - k / D * I;
  }, p = x => {
    const C = x * h * t,
      k = C * i + i,
      D = Math.pow(h, 2) * Math.pow(x, 2) * t,
      I = Math.exp(-C),
      L = J2(Math.pow(x, 2), h);
    return (-c(x) + t3 > 0 ? -1 : 1) * ((k - D) * I) / L;
  }) : (c = x => {
    const E = Math.exp(-x * t),
      C = (x - i) * t + 1;
    return -1e-3 + E * C;
  }, p = x => {
    const E = Math.exp(-x * t),
      C = (i - x) * (t * t);
    return E * C;
  });
  const y = 5 / t,
    w = kse(c, p, y);
  if (t = /* @__PURE__ */qm(t), isNaN(w)) return {
    stiffness: vo.stiffness,
    damping: vo.damping,
    duration: t
  };
  {
    const x = Math.pow(w, 2) * s;
    return {
      stiffness: x,
      damping: h * 2 * Math.sqrt(s * x),
      duration: t
    };
  }
}
const Cse = 12;
function kse(t, e, i) {
  let s = i;
  for (let c = 1; c < Cse; c++) s = s - t(s) / e(s);
  return s;
}
function J2(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Tse = ["duration", "bounce"],
  Rse = ["stiffness", "damping", "mass"];
function n3(t, e) {
  return e.some(i => t[i] !== void 0);
}
function Dse(t) {
  let e = {
    velocity: vo.velocity,
    stiffness: vo.stiffness,
    damping: vo.damping,
    mass: vo.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!n3(t, Rse) && n3(t, Tse)) if (t.visualDuration) {
    const i = t.visualDuration,
      s = 2 * Math.PI / (i * 1.2),
      c = s * s,
      p = 2 * wb(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(c);
    e = {
      ...e,
      mass: vo.mass,
      stiffness: c,
      damping: p
    };
  } else {
    const i = Ese(t);
    e = {
      ...e,
      ...i,
      mass: vo.mass
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function DL(t = vo.visualDuration, e = vo.bounce) {
  const i = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let {
    restSpeed: s,
    restDelta: c
  } = i;
  const p = i.keyframes[0],
    h = i.keyframes[i.keyframes.length - 1],
    y = {
      done: !1,
      value: p
    },
    {
      stiffness: w,
      damping: x,
      mass: E,
      duration: C,
      velocity: k,
      isResolvedFromDuration: D
    } = Dse({
      ...i,
      velocity: - /* @__PURE__ */Xv(i.velocity || 0)
    }),
    I = k || 0,
    L = x / (2 * Math.sqrt(w * E)),
    P = h - p,
    N = /* @__PURE__ */Xv(Math.sqrt(w / E)),
    O = Math.abs(P) < 5;
  s || (s = O ? vo.restSpeed.granular : vo.restSpeed.default), c || (c = O ? vo.restDelta.granular : vo.restDelta.default);
  let F;
  if (L < 1) {
    const V = J2(N, L);
    F = K => {
      const G = Math.exp(-L * N * K);
      return h - G * ((I + L * N * P) / V * Math.sin(V * K) + P * Math.cos(V * K));
    };
  } else if (L === 1) F = V => h - Math.exp(-N * V) * (P + (I + N * P) * V);else {
    const V = N * Math.sqrt(L * L - 1);
    F = K => {
      const G = Math.exp(-L * N * K),
        Q = Math.min(V * K, 300);
      return h - G * ((I + L * N * P) * Math.sinh(Q) + V * P * Math.cosh(Q)) / V;
    };
  }
  const j = {
    calculatedDuration: D && C || null,
    next: V => {
      const K = F(V);
      if (D) y.done = V >= C;else {
        let G = V === 0 ? I : 0;
        L < 1 && (G = V === 0 ? /* @__PURE__ */qm(I) : x6(F, V, K));
        const Q = Math.abs(G) <= s,
          te = Math.abs(h - K) <= c;
        y.done = Q && te;
      }
      return y.value = y.done ? h : K, y;
    },
    toString: () => {
      const V = Math.min(sz(j), RL),
        K = _6(G => j.next(V * G).value, V, 30);
      return V + "ms " + K;
    },
    toTransition: () => {}
  };
  return j;
}
DL.applyToOptions = t => {
  const e = xse(t, 100, DL);
  return t.ease = e.ease, t.duration = /* @__PURE__ */qm(e.duration), t.type = "keyframes", t;
};
function eF({
  keyframes: t,
  velocity: e = 0,
  power: i = 0.8,
  timeConstant: s = 325,
  bounceDamping: c = 10,
  bounceStiffness: p = 500,
  modifyTarget: h,
  min: y,
  max: w,
  restDelta: x = 0.5,
  restSpeed: E
}) {
  const C = t[0],
    k = {
      done: !1,
      value: C
    },
    D = Q => y !== void 0 && Q < y || w !== void 0 && Q > w,
    I = Q => y === void 0 ? w : w === void 0 || Math.abs(y - Q) < Math.abs(w - Q) ? y : w;
  let L = i * e;
  const P = C + L,
    N = h === void 0 ? P : h(P);
  N !== P && (L = N - C);
  const O = Q => -L * Math.exp(-Q / s),
    F = Q => N + O(Q),
    j = Q => {
      const te = O(Q),
        ie = F(Q);
      k.done = Math.abs(te) <= x, k.value = k.done ? N : ie;
    };
  let V, K;
  const G = Q => {
    D(k.value) && (V = Q, K = DL({
      keyframes: [k.value, I(k.value)],
      velocity: x6(F, Q, k.value),
      // TODO: This should be passing * 1000
      damping: c,
      stiffness: p,
      restDelta: x,
      restSpeed: E
    }));
  };
  return G(0), {
    calculatedDuration: null,
    next: Q => {
      let te = !1;
      return !K && V === void 0 && (te = !0, j(Q), G(Q)), V !== void 0 && Q >= V ? K.next(Q - V) : (!te && j(Q), k);
    }
  };
}
function Ise(t, e, i) {
  const s = [],
    c = i || xb.mix || w6,
    p = t.length - 1;
  for (let h = 0; h < p; h++) {
    let y = c(t[h], t[h + 1]);
    if (e) {
      const w = Array.isArray(e) ? e[h] || Bp : e;
      y = $R(w, y);
    }
    s.push(y);
  }
  return s;
}
function Mse(t, e, {
  clamp: i = !0,
  ease: s,
  mixer: c
} = {}) {
  const p = t.length;
  if (_b(p === e.length, "Both input and output ranges must be the same length", "range-length"), p === 1) return () => e[0];
  if (p === 2 && e[0] === e[1]) return () => e[1];
  const h = t[0] === t[1];
  t[0] > t[p - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const y = Ise(e, s, c),
    w = y.length,
    x = E => {
      if (h && E < t[0]) return e[0];
      let C = 0;
      if (w > 1) for (; C < t.length - 2 && !(E < t[C + 1]); C++);
      const k = /* @__PURE__ */bR(t[C], t[C + 1], E);
      return y[C](k);
    };
  return i ? E => x(wb(t[0], t[p - 1], E)) : x;
}
function Lse(t, e) {
  const i = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const c = /* @__PURE__ */bR(0, e, s);
    t.push(go(i, 1, c));
  }
}
function Ose(t) {
  const e = [0];
  return Lse(e, t.length - 1), e;
}
function Pse(t, e) {
  return t.map(i => i * e);
}
function Ase(t, e) {
  return t.map(() => e || c6).splice(0, t.length - 1);
}
function sE({
  duration: t = 300,
  keyframes: e,
  times: i,
  ease: s = "easeInOut"
}) {
  const c = Yle(s) ? s.map(KB) : KB(s),
    p = {
      done: !1,
      value: e[0]
    },
    h = Pse(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    i && i.length === e.length ? i : Ose(e), t),
    y = Mse(h, e, {
      ease: Array.isArray(c) ? c : Ase(e, c)
    });
  return {
    calculatedDuration: t,
    next: w => (p.value = y(w), p.done = w >= t, p)
  };
}
const jse = t => t !== null;
function uz(t, {
  repeat: e,
  repeatType: i = "loop"
}, s, c = 1) {
  const p = t.filter(jse),
    y = c < 0 || e && i !== "loop" && e % 2 === 1 ? 0 : p.length - 1;
  return !y || s === void 0 ? p[y] : s;
}
const Fse = {
  decay: eF,
  inertia: eF,
  tween: sE,
  keyframes: sE,
  spring: DL
};
function S6(t) {
  typeof t.type == "string" && (t.type = Fse[t.type]);
}
class cz {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise(e => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, i) {
    return this.finished.then(e, i);
  }
}
const Nse = t => t / 100;
class dz extends cz {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var s, c;
      const {
        motionValue: i
      } = this.options;
      i && i.updatedAt !== sd.now() && this.tick(sd.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (c = (s = this.options).onStop) == null || c.call(s));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const {
      options: e
    } = this;
    S6(e);
    const {
      type: i = sE,
      repeat: s = 0,
      repeatDelay: c = 0,
      repeatType: p,
      velocity: h = 0
    } = e;
    let {
      keyframes: y
    } = e;
    const w = i || sE;
    process.env.NODE_ENV !== "production" && w !== sE && _b(y.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${y}`, "spring-two-frames"), w !== sE && typeof y[0] != "number" && (this.mixKeyframes = $R(Nse, w6(y[0], y[1])), y = [0, 100]);
    const x = w({
      ...e,
      keyframes: y
    });
    p === "mirror" && (this.mirroredGenerator = w({
      ...e,
      keyframes: [...y].reverse(),
      velocity: -h
    })), x.calculatedDuration === null && (x.calculatedDuration = sz(x));
    const {
      calculatedDuration: E
    } = x;
    this.calculatedDuration = E, this.resolvedDuration = E + c, this.totalDuration = this.resolvedDuration * (s + 1) - c, this.generator = x;
  }
  updateTime(e) {
    const i = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = i;
  }
  tick(e, i = !1) {
    const {
      generator: s,
      totalDuration: c,
      mixKeyframes: p,
      mirroredGenerator: h,
      resolvedDuration: y,
      calculatedDuration: w
    } = this;
    if (this.startTime === null) return s.next(0);
    const {
      delay: x = 0,
      keyframes: E,
      repeat: C,
      repeatType: k,
      repeatDelay: D,
      type: I,
      onUpdate: L,
      finalKeyframe: P
    } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)), i ? this.currentTime = e : this.updateTime(e);
    const N = this.currentTime - x * (this.playbackSpeed >= 0 ? 1 : -1),
      O = this.playbackSpeed >= 0 ? N < 0 : N > c;
    this.currentTime = Math.max(N, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let F = this.currentTime,
      j = s;
    if (C) {
      const Q = Math.min(this.currentTime, c) / y;
      let te = Math.floor(Q),
        ie = Q % 1;
      !ie && Q >= 1 && (ie = 1), ie === 1 && te--, te = Math.min(te, C + 1), !!(te % 2) && (k === "reverse" ? (ie = 1 - ie, D && (ie -= D / y)) : k === "mirror" && (j = h)), F = wb(0, 1, ie) * y;
    }
    const V = O ? {
      done: !1,
      value: E[0]
    } : j.next(F);
    p && (V.value = p(V.value));
    let {
      done: K
    } = V;
    !O && w !== null && (K = this.playbackSpeed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const G = this.holdTime === null && (this.state === "finished" || this.state === "running" && K);
    return G && I !== eF && (V.value = uz(E, this.options, P, this.speed)), L && L(V.value), G && this.finish(), V;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, i) {
    return this.finished.then(e, i);
  }
  get duration() {
    return /* @__PURE__ */Xv(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */Xv(this.currentTime);
  }
  set time(e) {
    var i;
    e = /* @__PURE__ */qm(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (i = this.driver) == null || i.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(sd.now());
    const i = this.playbackSpeed !== e;
    this.playbackSpeed = e, i && (this.time = /* @__PURE__ */Xv(this.currentTime));
  }
  play() {
    var c, p;
    if (this.isStopped) return;
    const {
      driver: e = _se,
      startTime: i
    } = this.options;
    this.driver || (this.driver = e(h => this.tick(h))), (p = (c = this.options).onPlay) == null || p.call(c);
    const s = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = s) : this.holdTime !== null ? this.startTime = s - this.holdTime : this.startTime || (this.startTime = i ?? s), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(sd.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, i;
    this.notifyFinished(), this.teardown(), this.state = "finished", (i = (e = this.options).onComplete) == null || i.call(e);
  }
  cancel() {
    var e, i;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (i = (e = this.options).onCancel) == null || i.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var i;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (i = this.driver) == null || i.stop(), e.observe(this);
  }
}
function zse(t) {
  for (let e = 1; e < t.length; e++) t[e] ?? (t[e] = t[e - 1]);
}
const Wx = t => t * 180 / Math.PI,
  tF = t => {
    const e = Wx(Math.atan2(t[1], t[0]));
    return nF(e);
  },
  Vse = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: t => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
    rotate: tF,
    rotateZ: tF,
    skewX: t => Wx(Math.atan(t[1])),
    skewY: t => Wx(Math.atan(t[2])),
    skew: t => (Math.abs(t[1]) + Math.abs(t[2])) / 2
  },
  nF = t => (t = t % 360, t < 0 && (t += 360), t),
  r3 = tF,
  i3 = t => Math.sqrt(t[0] * t[0] + t[1] * t[1]),
  a3 = t => Math.sqrt(t[4] * t[4] + t[5] * t[5]),
  Bse = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: i3,
    scaleY: a3,
    scale: t => (i3(t) + a3(t)) / 2,
    rotateX: t => nF(Wx(Math.atan2(t[6], t[5]))),
    rotateY: t => nF(Wx(Math.atan2(-t[2], t[0]))),
    rotateZ: r3,
    rotate: r3,
    skewX: t => Wx(Math.atan(t[4])),
    skewY: t => Wx(Math.atan(t[1])),
    skew: t => (Math.abs(t[1]) + Math.abs(t[4])) / 2
  };
function rF(t) {
  return t.includes("scale") ? 1 : 0;
}
function iF(t, e) {
  if (!t || t === "none") return rF(e);
  const i = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let s, c;
  if (i) s = Bse, c = i;else {
    const y = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    s = Vse, c = y;
  }
  if (!c) return rF(e);
  const p = s[e],
    h = c[1].split(",").map(Hse);
  return typeof p == "function" ? p(h) : h[p];
}
const Use = (t, e) => {
  const {
    transform: i = "none"
  } = getComputedStyle(t);
  return iF(i, e);
};
function Hse(t) {
  return parseFloat(t.trim());
}
const UE = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"],
  HE = new Set(UE),
  o3 = t => t === BE || t === Yn,
  $se = /* @__PURE__ */new Set(["x", "y", "z"]),
  Wse = UE.filter(t => !$se.has(t));
function qse(t) {
  const e = [];
  return Wse.forEach(i => {
    const s = t.getValue(i);
    s !== void 0 && (e.push([i, s.get()]), s.set(i.startsWith("scale") ? 1 : 0));
  }), e;
}
const Kx = {
  // Dimensions
  width: ({
    x: t
  }, {
    paddingLeft: e = "0",
    paddingRight: i = "0"
  }) => t.max - t.min - parseFloat(e) - parseFloat(i),
  height: ({
    y: t
  }, {
    paddingTop: e = "0",
    paddingBottom: i = "0"
  }) => t.max - t.min - parseFloat(e) - parseFloat(i),
  top: (t, {
    top: e
  }) => parseFloat(e),
  left: (t, {
    left: e
  }) => parseFloat(e),
  bottom: ({
    y: t
  }, {
    top: e
  }) => parseFloat(e) + (t.max - t.min),
  right: ({
    x: t
  }, {
    left: e
  }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, {
    transform: e
  }) => iF(e, "x"),
  y: (t, {
    transform: e
  }) => iF(e, "y")
};
Kx.translateX = Kx.x;
Kx.translateY = Kx.y;
const Qx = /* @__PURE__ */new Set();
let aF = !1,
  oF = !1,
  lF = !1;
function E6() {
  if (oF) {
    const t = Array.from(Qx).filter(s => s.needsMeasurement),
      e = new Set(t.map(s => s.element)),
      i = /* @__PURE__ */new Map();
    e.forEach(s => {
      const c = qse(s);
      c.length && (i.set(s, c), s.render());
    }), t.forEach(s => s.measureInitialState()), e.forEach(s => {
      s.render();
      const c = i.get(s);
      c && c.forEach(([p, h]) => {
        var y;
        (y = s.getValue(p)) == null || y.set(h);
      });
    }), t.forEach(s => s.measureEndState()), t.forEach(s => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  oF = !1, aF = !1, Qx.forEach(t => t.complete(lF)), Qx.clear();
}
function C6() {
  Qx.forEach(t => {
    t.readKeyframes(), t.needsMeasurement && (oF = !0);
  });
}
function Yse() {
  lF = !0, C6(), E6(), lF = !1;
}
class fz {
  constructor(e, i, s, c, p, h = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = i, this.name = s, this.motionValue = c, this.element = p, this.isAsync = h;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Qx.add(this), aF || (aF = !0, Ua.read(C6), Ua.resolveKeyframes(E6))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: e,
      name: i,
      element: s,
      motionValue: c
    } = this;
    if (e[0] === null) {
      const p = c == null ? void 0 : c.get(),
        h = e[e.length - 1];
      if (p !== void 0) e[0] = p;else if (s && i) {
        const y = s.readValue(i, h);
        y != null && (e[0] = y);
      }
      e[0] === void 0 && (e[0] = h), c && p === void 0 && c.set(e[0]);
    }
    zse(e);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Qx.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Qx.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const Gse = t => t.startsWith("--");
function Xse(t, e, i) {
  Gse(e) ? t.style.setProperty(e, i) : t.style[e] = i;
}
const Kse = /* @__PURE__ */JN(() => window.ScrollTimeline !== void 0),
  Qse = {};
function Zse(t, e) {
  const i = /* @__PURE__ */JN(t);
  return () => Qse[e] ?? i();
}
const k6 = /* @__PURE__ */Zse(() => {
    try {
      document.createElement("div").animate({
        opacity: 0
      }, {
        easing: "linear(0, 1)"
      });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  OT = ([t, e, i, s]) => `cubic-bezier(${t}, ${e}, ${i}, ${s})`,
  l3 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /* @__PURE__ */OT([0, 0.65, 0.55, 1]),
    circOut: /* @__PURE__ */OT([0.55, 0, 1, 0.45]),
    backIn: /* @__PURE__ */OT([0.31, 0.01, 0.66, -0.59]),
    backOut: /* @__PURE__ */OT([0.33, 1.53, 0.69, 0.99])
  };
function T6(t, e) {
  if (t) return typeof t == "function" ? k6() ? _6(t, e) : "ease-out" : d6(t) ? OT(t) : Array.isArray(t) ? t.map(i => T6(i, e) || l3.easeOut) : l3[t];
}
function Jse(t, e, i, {
  delay: s = 0,
  duration: c = 300,
  repeat: p = 0,
  repeatType: h = "loop",
  ease: y = "easeOut",
  times: w
} = {}, x = void 0) {
  const E = {
    [e]: i
  };
  w && (E.offset = w);
  const C = T6(y, c);
  Array.isArray(C) && (E.easing = C);
  const k = {
    delay: s,
    duration: c,
    easing: Array.isArray(C) ? "linear" : C,
    fill: "both",
    iterations: p + 1,
    direction: h === "reverse" ? "alternate" : "normal"
  };
  return x && (k.pseudoElement = x), t.animate(E, k);
}
function R6(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function eue({
  type: t,
  ...e
}) {
  return R6(t) && k6() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class tue extends cz {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e) return;
    const {
      element: i,
      name: s,
      keyframes: c,
      pseudoElement: p,
      allowFlatten: h = !1,
      finalKeyframe: y,
      onComplete: w
    } = e;
    this.isPseudoElement = !!p, this.allowFlatten = h, this.options = e, _b(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const x = eue(e);
    this.animation = Jse(i, s, c, x, p), x.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !p) {
        const E = uz(c, this.options, y, this.speed);
        this.updateMotionValue ? this.updateMotionValue(E) : Xse(i, s, E), this.animation.cancel();
      }
      w == null || w(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, i;
    (i = (e = this.animation).finish) == null || i.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const {
      state: e
    } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, i;
    this.isPseudoElement || (i = (e = this.animation).commitStyles) == null || i.call(e);
  }
  get duration() {
    var i, s;
    const e = ((s = (i = this.animation.effect) == null ? void 0 : i.getComputedTiming) == null ? void 0 : s.call(i).duration) || 0;
    return /* @__PURE__ */Xv(Number(e));
  }
  get time() {
    return /* @__PURE__ */Xv(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */qm(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({
    timeline: e,
    observe: i
  }) {
    var s;
    return this.allowFlatten && ((s = this.animation.effect) == null || s.updateTiming({
      easing: "linear"
    })), this.animation.onfinish = null, e && Kse() ? (this.animation.timeline = e, Bp) : i(this);
  }
}
const D6 = {
  anticipate: l6,
  backInOut: o6,
  circInOut: u6
};
function nue(t) {
  return t in D6;
}
function rue(t) {
  typeof t.ease == "string" && nue(t.ease) && (t.ease = D6[t.ease]);
}
const s3 = 10;
class iue extends tue {
  constructor(e) {
    rue(e), S6(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const {
      motionValue: i,
      onUpdate: s,
      onComplete: c,
      element: p,
      ...h
    } = this.options;
    if (!i) return;
    if (e !== void 0) {
      i.set(e);
      return;
    }
    const y = new dz({
        ...h,
        autoplay: !1
      }),
      w = /* @__PURE__ */qm(this.finishedTime ?? this.time);
    i.setWithVelocity(y.sample(w - s3).value, y.sample(w).value, s3), y.stop();
  }
}
const u3 = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && (
// It's animatable if we have a string
lw.test(t) || t === "0") &&
// And it contains numbers and/or colors
!t.startsWith("url("));
function aue(t) {
  const e = t[0];
  if (t.length === 1) return !0;
  for (let i = 0; i < t.length; i++) if (t[i] !== e) return !0;
}
function oue(t, e, i, s) {
  const c = t[0];
  if (c === null) return !1;
  if (e === "display" || e === "visibility") return !0;
  const p = t[t.length - 1],
    h = u3(c, e),
    y = u3(p, e);
  return VE(h === y, `You are trying to animate ${e} from "${c}" to "${p}". "${h ? p : c}" is not an animatable value.`, "value-not-animatable"), !h || !y ? !1 : aue(t) || (i === "spring" || R6(i)) && s;
}
function sF(t) {
  t.duration = 0, t.type;
}
const lue = /* @__PURE__ */new Set(["opacity", "clipPath", "filter", "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
  ]),
  sue = /* @__PURE__ */JN(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function uue(t) {
  var E;
  const {
    motionValue: e,
    name: i,
    repeatDelay: s,
    repeatType: c,
    damping: p,
    type: h
  } = t;
  if (!(((E = e == null ? void 0 : e.owner) == null ? void 0 : E.current) instanceof HTMLElement)) return !1;
  const {
    onUpdate: w,
    transformTemplate: x
  } = e.owner.getProps();
  return sue() && i && lue.has(i) && (i !== "transform" || !x) &&
  /**
  * If we're outputting values to onUpdate then we can't use WAAPI as there's
  * no way to read the value from WAAPI every frame.
  */
  !w && !s && c !== "mirror" && p !== 0 && h !== "inertia";
}
const cue = 40;
class due extends cz {
  constructor({
    autoplay: e = !0,
    delay: i = 0,
    type: s = "keyframes",
    repeat: c = 0,
    repeatDelay: p = 0,
    repeatType: h = "loop",
    keyframes: y,
    name: w,
    motionValue: x,
    element: E,
    ...C
  }) {
    var I;
    super(), this.stop = () => {
      var L, P;
      this._animation && (this._animation.stop(), (L = this.stopTimeline) == null || L.call(this)), (P = this.keyframeResolver) == null || P.cancel();
    }, this.createdAt = sd.now();
    const k = {
        autoplay: e,
        delay: i,
        type: s,
        repeat: c,
        repeatDelay: p,
        repeatType: h,
        name: w,
        motionValue: x,
        element: E,
        ...C
      },
      D = (E == null ? void 0 : E.KeyframeResolver) || fz;
    this.keyframeResolver = new D(y, (L, P, N) => this.onKeyframesResolved(L, P, k, !N), w, x, E), (I = this.keyframeResolver) == null || I.scheduleResolve();
  }
  onKeyframesResolved(e, i, s, c) {
    this.keyframeResolver = void 0;
    const {
      name: p,
      type: h,
      velocity: y,
      delay: w,
      isHandoff: x,
      onUpdate: E
    } = s;
    this.resolvedAt = sd.now(), oue(e, p, h, y) || ((xb.instantAnimations || !w) && (E == null || E(uz(e, s, i))), e[0] = e[e.length - 1], sF(s), s.repeat = 0);
    const k = {
        startTime: c ? this.resolvedAt ? this.resolvedAt - this.createdAt > cue ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
        finalKeyframe: i,
        ...s,
        keyframes: e
      },
      D = !x && uue(k) ? new iue({
        ...k,
        element: k.motionValue.owner.current
      }) : new dz(k);
    D.finished.then(() => this.notifyFinished()).catch(Bp), this.pendingTimeline && (this.stopTimeline = D.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = D;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, i) {
    return this.finished.finally(e).then(() => {});
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), Yse()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
const fue =
// eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function pue(t) {
  const e = fue.exec(t);
  if (!e) return [,];
  const [, i, s, c] = e;
  return [`--${i ?? s}`, c];
}
const hue = 4;
function I6(t, e, i = 1) {
  _b(i <= hue, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [s, c] = pue(t);
  if (!s) return;
  const p = window.getComputedStyle(e).getPropertyValue(s);
  if (p) {
    const h = p.trim();
    return Z$(h) ? parseFloat(h) : h;
  }
  return iz(c) ? I6(c, e, i + 1) : c;
}
function pz(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const M6 = /* @__PURE__ */new Set(["width", "height", "top", "left", "right", "bottom", ...UE]),
  mue = {
    test: t => t === "auto",
    parse: t => t
  },
  L6 = t => e => e.test(t),
  O6 = [BE, Yn, Kv, X0, ase, ise, mue],
  c3 = t => O6.find(L6(t));
function vue(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || e6(t) : !0;
}
const gue = /* @__PURE__ */new Set(["brightness", "contrast", "saturate", "opacity"]);
function yue(t) {
  const [e, i] = t.slice(0, -1).split("(");
  if (e === "drop-shadow") return t;
  const [s] = i.match(az) || [];
  if (!s) return t;
  const c = i.replace(s, "");
  let p = gue.has(e) ? 1 : 0;
  return s !== i && (p *= 100), e + "(" + p + c + ")";
}
const bue = /\b([a-z-]*)\(.*?\)/gu,
  uF = {
    ...lw,
    getAnimatableNone: t => {
      const e = t.match(bue);
      return e ? e.map(yue).join(" ") : t;
    }
  },
  d3 = {
    ...BE,
    transform: Math.round
  },
  wue = {
    rotate: X0,
    rotateX: X0,
    rotateY: X0,
    rotateZ: X0,
    scale: EM,
    scaleX: EM,
    scaleY: EM,
    scaleZ: EM,
    skew: X0,
    skewX: X0,
    skewY: X0,
    distance: Yn,
    translateX: Yn,
    translateY: Yn,
    translateZ: Yn,
    x: Yn,
    y: Yn,
    z: Yn,
    perspective: Yn,
    transformPerspective: Yn,
    opacity: wR,
    originX: QB,
    originY: QB,
    originZ: Yn
  },
  hz = {
    // Border props
    borderWidth: Yn,
    borderTopWidth: Yn,
    borderRightWidth: Yn,
    borderBottomWidth: Yn,
    borderLeftWidth: Yn,
    borderRadius: Yn,
    radius: Yn,
    borderTopLeftRadius: Yn,
    borderTopRightRadius: Yn,
    borderBottomRightRadius: Yn,
    borderBottomLeftRadius: Yn,
    // Positioning props
    width: Yn,
    maxWidth: Yn,
    height: Yn,
    maxHeight: Yn,
    top: Yn,
    right: Yn,
    bottom: Yn,
    left: Yn,
    // Spacing props
    padding: Yn,
    paddingTop: Yn,
    paddingRight: Yn,
    paddingBottom: Yn,
    paddingLeft: Yn,
    margin: Yn,
    marginTop: Yn,
    marginRight: Yn,
    marginBottom: Yn,
    marginLeft: Yn,
    // Misc
    backgroundPositionX: Yn,
    backgroundPositionY: Yn,
    ...wue,
    zIndex: d3,
    // SVG
    fillOpacity: wR,
    strokeOpacity: wR,
    numOctaves: d3
  },
  _ue = {
    ...hz,
    // Color props
    color: Sl,
    backgroundColor: Sl,
    outlineColor: Sl,
    fill: Sl,
    stroke: Sl,
    // Border props
    borderColor: Sl,
    borderTopColor: Sl,
    borderRightColor: Sl,
    borderBottomColor: Sl,
    borderLeftColor: Sl,
    filter: uF,
    WebkitFilter: uF
  },
  P6 = t => _ue[t];
function A6(t, e) {
  let i = P6(t);
  return i !== uF && (i = lw), i.getAnimatableNone ? i.getAnimatableNone(e) : void 0;
}
const xue = /* @__PURE__ */new Set(["auto", "none", "0"]);
function Sue(t, e, i) {
  let s = 0,
    c;
  for (; s < t.length && !c;) {
    const p = t[s];
    typeof p == "string" && !xue.has(p) && _R(p).values.length && (c = t[s]), s++;
  }
  if (c && i) for (const p of e) t[p] = A6(i, c);
}
class Eue extends fz {
  constructor(e, i, s, c, p) {
    super(e, i, s, c, p, !0);
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: e,
      element: i,
      name: s
    } = this;
    if (!i || !i.current) return;
    super.readKeyframes();
    for (let w = 0; w < e.length; w++) {
      let x = e[w];
      if (typeof x == "string" && (x = x.trim(), iz(x))) {
        const E = I6(x, i.current);
        E !== void 0 && (e[w] = E), w === e.length - 1 && (this.finalKeyframe = x);
      }
    }
    if (this.resolveNoneKeyframes(), !M6.has(s) || e.length !== 2) return;
    const [c, p] = e,
      h = c3(c),
      y = c3(p);
    if (h !== y) if (o3(h) && o3(y)) for (let w = 0; w < e.length; w++) {
      const x = e[w];
      typeof x == "string" && (e[w] = parseFloat(x));
    } else Kx[s] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const {
        unresolvedKeyframes: e,
        name: i
      } = this,
      s = [];
    for (let c = 0; c < e.length; c++) (e[c] === null || vue(e[c])) && s.push(c);
    s.length && Sue(e, s, i);
  }
  measureInitialState() {
    const {
      element: e,
      unresolvedKeyframes: i,
      name: s
    } = this;
    if (!e || !e.current) return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Kx[s](e.measureViewportBox(), window.getComputedStyle(e.current)), i[0] = this.measuredOrigin;
    const c = i[i.length - 1];
    c !== void 0 && e.getValue(s, c).jump(c, !1);
  }
  measureEndState() {
    var y;
    const {
      element: e,
      name: i,
      unresolvedKeyframes: s
    } = this;
    if (!e || !e.current) return;
    const c = e.getValue(i);
    c && c.jump(this.measuredOrigin, !1);
    const p = s.length - 1,
      h = s[p];
    s[p] = Kx[i](e.measureViewportBox(), window.getComputedStyle(e.current)), h !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = h), (y = this.removedTransforms) != null && y.length && this.removedTransforms.forEach(([w, x]) => {
      e.getValue(w).set(x);
    }), this.resolveNoneKeyframes();
  }
}
function Cue(t, e, i) {
  if (t instanceof EventTarget) return [t];
  if (typeof t == "string") {
    let s = document;
    const c = (i == null ? void 0 : i[t]) ?? s.querySelectorAll(t);
    return c ? Array.from(c) : [];
  }
  return Array.from(t);
}
const j6 = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function kue(t) {
  return J$(t) && "offsetHeight" in t;
}
const f3 = 30,
  Tue = t => !isNaN(parseFloat(t));
class Rue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, i = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = s => {
      var p;
      const c = sd.now();
      if (this.updatedAt !== c && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && ((p = this.events.change) == null || p.notify(this.current), this.dependents)) for (const h of this.dependents) h.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = i.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = sd.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Tue(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && QL(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, i) {
    this.events[e] || (this.events[e] = new ez());
    const s = this.events[e].add(i);
    return e === "change" ? () => {
      s(), Ua.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events) this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, i) {
    this.passiveEffect = e, this.stopPassiveEffect = i;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, i, s) {
    this.set(i), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, i = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, i && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = sd.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > f3) return 0;
    const i = Math.min(this.updatedAt - this.prevUpdatedAt, f3);
    return t6(parseFloat(this.current) - parseFloat(this.prevFrameValue), i);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise(i => {
      this.hasAnimated = !0, this.animation = e(i), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, i;
    (e = this.dependents) == null || e.clear(), (i = this.events.destroy) == null || i.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function RE(t, e) {
  return new Rue(t, e);
}
const {
    schedule: mz
  } = /* @__PURE__ */f6(queueMicrotask, !1),
  Bm = {
    x: !1,
    y: !1
  };
function F6() {
  return Bm.x || Bm.y;
}
function Due(t) {
  return t === "x" || t === "y" ? Bm[t] ? null : (Bm[t] = !0, () => {
    Bm[t] = !1;
  }) : Bm.x || Bm.y ? null : (Bm.x = Bm.y = !0, () => {
    Bm.x = Bm.y = !1;
  });
}
function N6(t, e) {
  const i = Cue(t),
    s = new AbortController(),
    c = {
      passive: !0,
      ...e,
      signal: s.signal
    };
  return [i, c, () => s.abort()];
}
function p3(t) {
  return !(t.pointerType === "touch" || F6());
}
function Iue(t, e, i = {}) {
  const [s, c, p] = N6(t, i),
    h = y => {
      if (!p3(y)) return;
      const {
          target: w
        } = y,
        x = e(w, y);
      if (typeof x != "function" || !w) return;
      const E = C => {
        p3(C) && (x(C), w.removeEventListener("pointerleave", E));
      };
      w.addEventListener("pointerleave", E, c);
    };
  return s.forEach(y => {
    y.addEventListener("pointerenter", h, c);
  }), p;
}
const z6 = (t, e) => e ? t === e ? !0 : z6(t, e.parentElement) : !1,
  vz = t => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1,
  Mue = /* @__PURE__ */new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function Lue(t) {
  return Mue.has(t.tagName) || t.tabIndex !== -1;
}
const GM = /* @__PURE__ */new WeakSet();
function h3(t) {
  return e => {
    e.key === "Enter" && t(e);
  };
}
function Qj(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, {
    isPrimary: !0,
    bubbles: !0
  }));
}
const Oue = (t, e) => {
  const i = t.currentTarget;
  if (!i) return;
  const s = h3(() => {
    if (GM.has(i)) return;
    Qj(i, "down");
    const c = h3(() => {
        Qj(i, "up");
      }),
      p = () => Qj(i, "cancel");
    i.addEventListener("keyup", c, e), i.addEventListener("blur", p, e);
  });
  i.addEventListener("keydown", s, e), i.addEventListener("blur", () => i.removeEventListener("keydown", s), e);
};
function m3(t) {
  return vz(t) && !F6();
}
function Pue(t, e, i = {}) {
  const [s, c, p] = N6(t, i),
    h = y => {
      const w = y.currentTarget;
      if (!m3(y)) return;
      GM.add(w);
      const x = e(w, y),
        E = (D, I) => {
          window.removeEventListener("pointerup", C), window.removeEventListener("pointercancel", k), GM.has(w) && GM.delete(w), m3(D) && typeof x == "function" && x(D, {
            success: I
          });
        },
        C = D => {
          E(D, w === window || w === document || i.useGlobalTarget || z6(w, D.target));
        },
        k = D => {
          E(D, !1);
        };
      window.addEventListener("pointerup", C, c), window.addEventListener("pointercancel", k, c);
    };
  return s.forEach(y => {
    (i.useGlobalTarget ? window : y).addEventListener("pointerdown", h, c), kue(y) && (y.addEventListener("focus", x => Oue(x, c)), !Lue(y) && !y.hasAttribute("tabindex") && (y.tabIndex = 0));
  }), p;
}
function V6(t) {
  return J$(t) && "ownerSVGElement" in t;
}
function Aue(t) {
  return V6(t) && t.tagName === "svg";
}
const Cu = t => !!(t && t.getVelocity),
  jue = [...O6, Sl, lw],
  Fue = t => jue.find(L6(t)),
  B6 = Up({
    transformPagePoint: t => t,
    isStatic: !1,
    reducedMotion: "never"
  });
function Nue(t = !0) {
  const e = bs(KN);
  if (e === null) return [!0, null];
  const {
      isPresent: i,
      onExitComplete: s,
      register: c
    } = e,
    p = ME();
  Rt(() => {
    if (t) return c(p);
  }, [t]);
  const h = pn(() => t && s && s(p), [p, s, t]);
  return !i && s ? [!1, h] : [!0];
}
const U6 = Up({
    strict: !1
  }),
  v3 = {
    animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"]
  },
  DE = {};
for (const t in v3) DE[t] = {
  isEnabled: e => v3[t].some(i => !!e[i])
};
function zue(t) {
  for (const e in t) DE[e] = {
    ...DE[e],
    ...t[e]
  };
}
const Vue = /* @__PURE__ */new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);
function IL(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Vue.has(t);
}
let H6 = t => !IL(t);
function Bue(t) {
  typeof t == "function" && (H6 = e => e.startsWith("on") ? !IL(e) : t(e));
}
try {
  Bue(require("@emotion/is-prop-valid").default);
} catch {}
function Uue(t, e, i) {
  const s = {};
  for (const c in t) c === "values" && typeof t.values == "object" || (H6(c) || i === !0 && IL(c) || !e && !IL(c) ||
  // If trying to use native HTML drag events, forward drag listeners
  t.draggable && c.startsWith("onDrag")) && (s[c] = t[c]);
  return s;
}
const ZL = /* @__PURE__ */Up({});
function JL(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function xR(t) {
  return typeof t == "string" || Array.isArray(t);
}
const gz = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
  yz = ["initial", ...gz];
function eO(t) {
  return JL(t.animate) || yz.some(e => xR(t[e]));
}
function $6(t) {
  return !!(eO(t) || t.variants);
}
function Hue(t, e) {
  if (eO(t)) {
    const {
      initial: i,
      animate: s
    } = t;
    return {
      initial: i === !1 || xR(i) ? i : void 0,
      animate: xR(s) ? s : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function $ue(t) {
  const {
    initial: e,
    animate: i
  } = Hue(t, bs(ZL));
  return ci(() => ({
    initial: e,
    animate: i
  }), [g3(e), g3(i)]);
}
function g3(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const SR = {};
function Wue(t) {
  for (const e in t) SR[e] = t[e], rz(e) && (SR[e].isCSSVariable = !0);
}
function W6(t, {
  layout: e,
  layoutId: i
}) {
  return HE.has(t) || t.startsWith("origin") || (e || i !== void 0) && (!!SR[t] || t === "opacity");
}
const que = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  },
  Yue = UE.length;
function Gue(t, e, i) {
  let s = "",
    c = !0;
  for (let p = 0; p < Yue; p++) {
    const h = UE[p],
      y = t[h];
    if (y === void 0) continue;
    let w = !0;
    if (typeof y == "number" ? w = y === (h.startsWith("scale") ? 1 : 0) : w = parseFloat(y) === 0, !w || i) {
      const x = j6(y, hz[h]);
      if (!w) {
        c = !1;
        const E = que[h] || h;
        s += `${E}(${x}) `;
      }
      i && (e[h] = x);
    }
  }
  return s = s.trim(), i ? s = i(e, c ? "" : s) : c && (s = "none"), s;
}
function bz(t, e, i) {
  const {
    style: s,
    vars: c,
    transformOrigin: p
  } = t;
  let h = !1,
    y = !1;
  for (const w in e) {
    const x = e[w];
    if (HE.has(w)) {
      h = !0;
      continue;
    } else if (rz(w)) {
      c[w] = x;
      continue;
    } else {
      const E = j6(x, hz[w]);
      w.startsWith("origin") ? (y = !0, p[w] = E) : s[w] = E;
    }
  }
  if (e.transform || (h || i ? s.transform = Gue(e, t.transform, i) : s.transform && (s.transform = "none")), y) {
    const {
      originX: w = "50%",
      originY: x = "50%",
      originZ: E = 0
    } = p;
    s.transformOrigin = `${w} ${x} ${E}`;
  }
}
const wz = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function q6(t, e, i) {
  for (const s in e) !Cu(e[s]) && !W6(s, i) && (t[s] = e[s]);
}
function Xue({
  transformTemplate: t
}, e) {
  return ci(() => {
    const i = wz();
    return bz(i, e, t), Object.assign({}, i.vars, i.style);
  }, [e]);
}
function Kue(t, e) {
  const i = t.style || {},
    s = {};
  return q6(s, i, t), Object.assign(s, Xue(t, e)), s;
}
function Que(t, e) {
  const i = {},
    s = Kue(t, e);
  return t.drag && t.dragListener !== !1 && (i.draggable = !1, s.userSelect = s.WebkitUserSelect = s.WebkitTouchCallout = "none", s.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (i.tabIndex = 0), i.style = s, i;
}
const Zue = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
  Jue = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };
function ece(t, e, i = 1, s = 0, c = !0) {
  t.pathLength = 1;
  const p = c ? Zue : Jue;
  t[p.offset] = Yn.transform(-s);
  const h = Yn.transform(e),
    y = Yn.transform(i);
  t[p.array] = `${h} ${y}`;
}
function Y6(t, {
  attrX: e,
  attrY: i,
  attrScale: s,
  pathLength: c,
  pathSpacing: p = 1,
  pathOffset: h = 0,
  // This is object creation, which we try to avoid per-frame.
  ...y
}, w, x, E) {
  if (bz(t, y, x), w) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const {
    attrs: C,
    style: k
  } = t;
  C.transform && (k.transform = C.transform, delete C.transform), (k.transform || C.transformOrigin) && (k.transformOrigin = C.transformOrigin ?? "50% 50%", delete C.transformOrigin), k.transform && (k.transformBox = (E == null ? void 0 : E.transformBox) ?? "fill-box", delete C.transformBox), e !== void 0 && (C.x = e), i !== void 0 && (C.y = i), s !== void 0 && (C.scale = s), c !== void 0 && ece(C, c, p, h, !1);
}
const G6 = () => ({
    ...wz(),
    attrs: {}
  }),
  X6 = t => typeof t == "string" && t.toLowerCase() === "svg";
function tce(t, e, i, s) {
  const c = ci(() => {
    const p = G6();
    return Y6(p, e, X6(s), t.transformTemplate, t.style), {
      ...p.attrs,
      style: {
        ...p.style
      }
    };
  }, [e]);
  if (t.style) {
    const p = {};
    q6(p, t.style, t), c.style = {
      ...p,
      ...c.style
    };
  }
  return c;
}
const nce = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function _z(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" ||
    /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    t.includes("-") ? !1 : (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    !!(nce.indexOf(t) > -1 ||
    /**
    * If it contains a capital letter, it's an SVG component
    */
    /[A-Z]/u.test(t)))
  );
}
function rce(t, e, i, {
  latestValues: s
}, c, p = !1) {
  const y = (_z(t) ? tce : Que)(e, s, c, t),
    w = Uue(e, typeof t == "string", p),
    x = t !== Qv ? {
      ...w,
      ...y,
      ref: i
    } : {},
    {
      children: E
    } = e,
    C = ci(() => Cu(E) ? E.get() : E, [E]);
  return lH(t, {
    ...x,
    children: C
  });
}
function y3(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((i, s) => {
    e[0][s] = i.get(), e[1][s] = i.getVelocity();
  }), e;
}
function xz(t, e, i, s) {
  if (typeof e == "function") {
    const [c, p] = y3(s);
    e = e(i !== void 0 ? i : t.custom, c, p);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [c, p] = y3(s);
    e = e(i !== void 0 ? i : t.custom, c, p);
  }
  return e;
}
function XM(t) {
  return Cu(t) ? t.get() : t;
}
function ice({
  scrapeMotionValuesFromProps: t,
  createRenderState: e
}, i, s, c) {
  return {
    latestValues: ace(i, s, c, t),
    renderState: e()
  };
}
function ace(t, e, i, s) {
  const c = {},
    p = s(t, {});
  for (const k in p) c[k] = XM(p[k]);
  let {
    initial: h,
    animate: y
  } = t;
  const w = eO(t),
    x = $6(t);
  e && x && !w && t.inherit !== !1 && (h === void 0 && (h = e.initial), y === void 0 && (y = e.animate));
  let E = i ? i.initial === !1 : !1;
  E = E || h === !1;
  const C = E ? y : h;
  if (C && typeof C != "boolean" && !JL(C)) {
    const k = Array.isArray(C) ? C : [C];
    for (let D = 0; D < k.length; D++) {
      const I = xz(t, k[D]);
      if (I) {
        const {
          transitionEnd: L,
          transition: P,
          ...N
        } = I;
        for (const O in N) {
          let F = N[O];
          if (Array.isArray(F)) {
            const j = E ? F.length - 1 : 0;
            F = F[j];
          }
          F !== null && (c[O] = F);
        }
        for (const O in L) c[O] = L[O];
      }
    }
  }
  return c;
}
const K6 = t => (e, i) => {
  const s = bs(ZL),
    c = bs(KN),
    p = () => ice(t, e, s, c);
  return i ? p() : zle(p);
};
function Sz(t, e, i) {
  var p;
  const {
      style: s
    } = t,
    c = {};
  for (const h in s) (Cu(s[h]) || e.style && Cu(e.style[h]) || W6(h, t) || ((p = i == null ? void 0 : i.getValue(h)) == null ? void 0 : p.liveStyle) !== void 0) && (c[h] = s[h]);
  return c;
}
const oce = /* @__PURE__ */K6({
  scrapeMotionValuesFromProps: Sz,
  createRenderState: wz
});
function Q6(t, e, i) {
  const s = Sz(t, e, i);
  for (const c in t) if (Cu(t[c]) || Cu(e[c])) {
    const p = UE.indexOf(c) !== -1 ? "attr" + c.charAt(0).toUpperCase() + c.substring(1) : c;
    s[p] = t[c];
  }
  return s;
}
const lce = /* @__PURE__ */K6({
    scrapeMotionValuesFromProps: Q6,
    createRenderState: G6
  }),
  sce = Symbol.for("motionComponentSymbol");
function uE(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function uce(t, e, i) {
  return pn(s => {
    s && t.onMount && t.onMount(s), e && (s ? e.mount(s) : e.unmount()), i && (typeof i == "function" ? i(s) : uE(i) && (i.current = s));
  },
  /**
   * Only pass a new ref callback to React if we've received a visual element
   * factory. Otherwise we'll be mounting/remounting every time externalRef
   * or other dependencies change.
   */
  [e]);
}
const Ez = t => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
  cce = "framerAppearId",
  Z6 = "data-" + Ez(cce),
  J6 = Up({});
function dce(t, e, i, s, c) {
  var L, P;
  const {
      visualElement: p
    } = bs(ZL),
    h = bs(U6),
    y = bs(KN),
    w = bs(B6).reducedMotion,
    x = vt(null);
  s = s || h.renderer, !x.current && s && (x.current = s(t, {
    visualState: e,
    parent: p,
    props: i,
    presenceContext: y,
    blockInitialAnimation: y ? y.initial === !1 : !1,
    reducedMotionConfig: w
  }));
  const E = x.current,
    C = bs(J6);
  E && !E.projection && c && (E.type === "html" || E.type === "svg") && fce(x.current, i, c, C);
  const k = vt(!1);
  OW(() => {
    E && k.current && E.update(i, y);
  });
  const D = i[Z6],
    I = vt(!!D && !((L = window.MotionHandoffIsComplete) != null && L.call(window, D)) && ((P = window.MotionHasOptimisedAnimation) == null ? void 0 : P.call(window, D)));
  return Vle(() => {
    E && (k.current = !0, window.MotionIsMounted = !0, E.updateFeatures(), E.scheduleRenderMicrotask(), I.current && E.animationState && E.animationState.animateChanges());
  }), Rt(() => {
    E && (!I.current && E.animationState && E.animationState.animateChanges(), I.current && (queueMicrotask(() => {
      var N;
      (N = window.MotionHandoffMarkAsComplete) == null || N.call(window, D);
    }), I.current = !1), E.enteringChildren = void 0);
  }), E;
}
function fce(t, e, i, s) {
  const {
    layoutId: c,
    layout: p,
    drag: h,
    dragConstraints: y,
    layoutScroll: w,
    layoutRoot: x,
    layoutCrossfade: E
  } = e;
  t.projection = new i(t.latestValues, e["data-framer-portal-id"] ? void 0 : e8(t.parent)), t.projection.setOptions({
    layoutId: c,
    layout: p,
    alwaysMeasureLayout: !!h || y && uE(y),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof p == "string" ? p : "both",
    initialPromotionConfig: s,
    crossfade: E,
    layoutScroll: w,
    layoutRoot: x
  });
}
function e8(t) {
  if (t) return t.options.allowProjection !== !1 ? t.projection : e8(t.parent);
}
function Zj(t, {
  forwardMotionProps: e = !1
} = {}, i, s) {
  i && zue(i);
  const c = _z(t) ? lce : oce;
  function p(y, w) {
    let x;
    const E = {
        ...bs(B6),
        ...y,
        layoutId: pce(y)
      },
      {
        isStatic: C
      } = E,
      k = $ue(y),
      D = c(y, C);
    if (!C && XN) {
      hce(E, i);
      const I = mce(E);
      x = I.MeasureLayout, k.visualElement = dce(t, D, E, s, I.ProjectionNode);
    }
    return B.jsxs(ZL.Provider, {
      value: k,
      children: [x && k.visualElement ? B.jsx(x, {
        visualElement: k.visualElement,
        ...E
      }) : null, rce(t, y, uce(D, k.visualElement, w), D, C, e)]
    });
  }
  p.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const h = Qn(p);
  return h[sce] = t, h;
}
function pce({
  layoutId: t
}) {
  const e = bs(Q$).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function hce(t, e) {
  const i = bs(U6).strict;
  if (process.env.NODE_ENV !== "production" && e && i) {
    const s = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? VE(!1, s, "lazy-strict-mode") : _b(!1, s, "lazy-strict-mode");
  }
}
function mce(t) {
  const {
    drag: e,
    layout: i
  } = DE;
  if (!e && !i) return {};
  const s = {
    ...e,
    ...i
  };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || i != null && i.isEnabled(t) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
function vce(t, e) {
  if (typeof Proxy > "u") return Zj;
  const i = /* @__PURE__ */new Map(),
    s = (p, h) => Zj(p, h, t, e),
    c = (p, h) => (process.env.NODE_ENV !== "production" && QL(!1, "motion() is deprecated. Use motion.create() instead."), s(p, h));
  return new Proxy(c, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (p, h) => h === "create" ? s : (i.has(h) || i.set(h, Zj(h, void 0, t, e)), i.get(h))
  });
}
function t8({
  top: t,
  left: e,
  right: i,
  bottom: s
}) {
  return {
    x: {
      min: e,
      max: i
    },
    y: {
      min: t,
      max: s
    }
  };
}
function gce({
  x: t,
  y: e
}) {
  return {
    top: e.min,
    right: t.max,
    bottom: e.max,
    left: t.min
  };
}
function yce(t, e) {
  if (!e) return t;
  const i = e({
      x: t.left,
      y: t.top
    }),
    s = e({
      x: t.right,
      y: t.bottom
    });
  return {
    top: i.y,
    left: i.x,
    bottom: s.y,
    right: s.x
  };
}
function Jj(t) {
  return t === void 0 || t === 1;
}
function cF({
  scale: t,
  scaleX: e,
  scaleY: i
}) {
  return !Jj(t) || !Jj(e) || !Jj(i);
}
function Bx(t) {
  return cF(t) || n8(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function n8(t) {
  return b3(t.x) || b3(t.y);
}
function b3(t) {
  return t && t !== "0%";
}
function ML(t, e, i) {
  const s = t - i,
    c = e * s;
  return i + c;
}
function w3(t, e, i, s, c) {
  return c !== void 0 && (t = ML(t, c, s)), ML(t, i, s) + e;
}
function dF(t, e = 0, i = 1, s, c) {
  t.min = w3(t.min, e, i, s, c), t.max = w3(t.max, e, i, s, c);
}
function r8(t, {
  x: e,
  y: i
}) {
  dF(t.x, e.translate, e.scale, e.originPoint), dF(t.y, i.translate, i.scale, i.originPoint);
}
const _3 = 0.999999999999,
  x3 = 1.0000000000001;
function bce(t, e, i, s = !1) {
  const c = i.length;
  if (!c) return;
  e.x = e.y = 1;
  let p, h;
  for (let y = 0; y < c; y++) {
    p = i[y], h = p.projectionDelta;
    const {
      visualElement: w
    } = p.options;
    w && w.props.style && w.props.style.display === "contents" || (s && p.options.layoutScroll && p.scroll && p !== p.root && dE(t, {
      x: -p.scroll.offset.x,
      y: -p.scroll.offset.y
    }), h && (e.x *= h.x.scale, e.y *= h.y.scale, r8(t, h)), s && Bx(p.latestValues) && dE(t, p.latestValues));
  }
  e.x < x3 && e.x > _3 && (e.x = 1), e.y < x3 && e.y > _3 && (e.y = 1);
}
function cE(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function S3(t, e, i, s, c = 0.5) {
  const p = go(t.min, t.max, c);
  dF(t, e, i, p, s);
}
function dE(t, e) {
  S3(t.x, e.x, e.scaleX, e.scale, e.originX), S3(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function i8(t, e) {
  return t8(yce(t.getBoundingClientRect(), e));
}
function wce(t, e, i) {
  const s = i8(t, i),
    {
      scroll: c
    } = e;
  return c && (cE(s.x, c.offset.x), cE(s.y, c.offset.y)), s;
}
const E3 = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  }),
  fE = () => ({
    x: E3(),
    y: E3()
  }),
  C3 = () => ({
    min: 0,
    max: 0
  }),
  il = () => ({
    x: C3(),
    y: C3()
  }),
  LL = {
    current: null
  },
  Cz = {
    current: !1
  };
function a8() {
  if (Cz.current = !0, !!XN) if (window.matchMedia) {
    const t = window.matchMedia("(prefers-reduced-motion)"),
      e = () => LL.current = t.matches;
    t.addEventListener("change", e), e();
  } else LL.current = !1;
}
const _ce = /* @__PURE__ */new WeakMap();
function xce(t, e, i) {
  for (const s in e) {
    const c = e[s],
      p = i[s];
    if (Cu(c)) t.addValue(s, c);else if (Cu(p)) t.addValue(s, RE(c, {
      owner: t
    }));else if (p !== c) if (t.hasValue(s)) {
      const h = t.getValue(s);
      h.liveStyle === !0 ? h.jump(c) : h.hasAnimated || h.set(c);
    } else {
      const h = t.getStaticValue(s);
      t.addValue(s, RE(h !== void 0 ? h : c, {
        owner: t
      }));
    }
  }
  for (const s in i) e[s] === void 0 && t.removeValue(s);
  return e;
}
const k3 = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
class Sce {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, i, s) {
    return {};
  }
  constructor({
    parent: e,
    props: i,
    presenceContext: s,
    reducedMotionConfig: c,
    blockInitialAnimation: p,
    visualState: h
  }, y = {}) {
    this.current = null, this.children = /* @__PURE__ */new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */new Map(), this.KeyframeResolver = fz, this.features = {}, this.valueSubscriptions = /* @__PURE__ */new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const k = sd.now();
      this.renderScheduledAt < k && (this.renderScheduledAt = k, Ua.render(this.render, !1, !0));
    };
    const {
      latestValues: w,
      renderState: x
    } = h;
    this.latestValues = w, this.baseTarget = {
      ...w
    }, this.initialValues = i.initial ? {
      ...w
    } : {}, this.renderState = x, this.parent = e, this.props = i, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = c, this.options = y, this.blockInitialAnimation = !!p, this.isControllingVariants = eO(i), this.isVariantNode = $6(i), this.isVariantNode && (this.variantChildren = /* @__PURE__ */new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const {
      willChange: E,
      ...C
    } = this.scrapeMotionValuesFromProps(i, {}, this);
    for (const k in C) {
      const D = C[k];
      w[k] !== void 0 && Cu(D) && D.set(w[k]);
    }
  }
  mount(e) {
    var i;
    this.current = e, _ce.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((s, c) => this.bindToMotionValue(c, s)), Cz.current || a8(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : LL.current, process.env.NODE_ENV !== "production" && QL(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (i = this.parent) == null || i.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), ow(this.notifyUpdate), ow(this.render), this.valueSubscriptions.forEach(i => i()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const i in this.events) this.events[i].clear();
    for (const i in this.features) {
      const s = this.features[i];
      s && (s.unmount(), s.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, i) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const s = HE.has(e);
    s && this.onBindTransform && this.onBindTransform();
    const c = i.on("change", h => {
      this.latestValues[e] = h, this.props.onUpdate && Ua.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let p;
    window.MotionCheckAppearSync && (p = window.MotionCheckAppearSync(this, e, i)), this.valueSubscriptions.set(e, () => {
      c(), p && p(), i.owner && i.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in DE) {
      const i = DE[e];
      if (!i) continue;
      const {
        isEnabled: s,
        Feature: c
      } = i;
      if (!this.features[e] && c && s(this.props) && (this.features[e] = new c(this)), this.features[e]) {
        const p = this.features[e];
        p.isMounted ? p.update() : (p.mount(), p.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : il();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, i) {
    this.latestValues[e] = i;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, i) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = i;
    for (let s = 0; s < k3.length; s++) {
      const c = k3[s];
      this.propEventSubscriptions[c] && (this.propEventSubscriptions[c](), delete this.propEventSubscriptions[c]);
      const p = "on" + c,
        h = e[p];
      h && (this.propEventSubscriptions[c] = this.on(c, h));
    }
    this.prevMotionValues = xce(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const i = this.getClosestVariantNode();
    if (i) return i.variantChildren && i.variantChildren.add(e), () => i.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, i) {
    const s = this.values.get(e);
    i !== s && (s && this.removeValue(e), this.bindToMotionValue(e, i), this.values.set(e, i), this.latestValues[e] = i.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const i = this.valueSubscriptions.get(e);
    i && (i(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, i) {
    if (this.props.values && this.props.values[e]) return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && i !== void 0 && (s = RE(i === null ? void 0 : i, {
      owner: this
    }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, i) {
    let s = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return s != null && (typeof s == "string" && (Z$(s) || e6(s)) ? s = parseFloat(s) : !Fue(s) && lw.test(i) && (s = A6(e, i)), this.setBaseTarget(e, Cu(s) ? s.get() : s)), Cu(s) ? s.get() : s;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, i) {
    this.baseTarget[e] = i;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var p;
    const {
      initial: i
    } = this.props;
    let s;
    if (typeof i == "string" || typeof i == "object") {
      const h = xz(this.props, i, (p = this.presenceContext) == null ? void 0 : p.custom);
      h && (s = h[e]);
    }
    if (i && s !== void 0) return s;
    const c = this.getBaseTargetFromProps(this.props, e);
    return c !== void 0 && !Cu(c) ? c : this.initialValues[e] !== void 0 && s === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, i) {
    return this.events[e] || (this.events[e] = new ez()), this.events[e].add(i);
  }
  notify(e, ...i) {
    this.events[e] && this.events[e].notify(...i);
  }
  scheduleRenderMicrotask() {
    mz.render(this.render);
  }
}
class o8 extends Sce {
  constructor() {
    super(...arguments), this.KeyframeResolver = Eue;
  }
  sortInstanceNodePosition(e, i) {
    return e.compareDocumentPosition(i) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, i) {
    return e.style ? e.style[i] : void 0;
  }
  removeValueFromRenderState(e, {
    vars: i,
    style: s
  }) {
    delete i[e], delete s[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const {
      children: e
    } = this.props;
    Cu(e) && (this.childSubscription = e.on("change", i => {
      this.current && (this.current.textContent = `${i}`);
    }));
  }
}
function l8(t, {
  style: e,
  vars: i
}, s, c) {
  const p = t.style;
  let h;
  for (h in e) p[h] = e[h];
  c == null || c.applyProjectionStyles(p, s);
  for (h in i) p.setProperty(h, i[h]);
}
function Ece(t) {
  return window.getComputedStyle(t);
}
class Cce extends o8 {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = l8;
  }
  readValueFromInstance(e, i) {
    var s;
    if (HE.has(i)) return (s = this.projection) != null && s.isProjecting ? rF(i) : Use(e, i);
    {
      const c = Ece(e),
        p = (rz(i) ? c.getPropertyValue(i) : c[i]) || 0;
      return typeof p == "string" ? p.trim() : p;
    }
  }
  measureInstanceViewportBox(e, {
    transformPagePoint: i
  }) {
    return i8(e, i);
  }
  build(e, i, s) {
    bz(e, i, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, i, s) {
    return Sz(e, i, s);
  }
}
const s8 = /* @__PURE__ */new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function kce(t, e, i, s) {
  l8(t, e, void 0, s);
  for (const c in e.attrs) t.setAttribute(s8.has(c) ? c : Ez(c), e.attrs[c]);
}
class Tce extends o8 {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = il;
  }
  getBaseTargetFromProps(e, i) {
    return e[i];
  }
  readValueFromInstance(e, i) {
    if (HE.has(i)) {
      const s = P6(i);
      return s && s.default || 0;
    }
    return i = s8.has(i) ? i : Ez(i), e.getAttribute(i);
  }
  scrapeMotionValuesFromProps(e, i, s) {
    return Q6(e, i, s);
  }
  build(e, i, s) {
    Y6(e, i, this.isSVGTag, s.transformTemplate, s.style);
  }
  renderInstance(e, i, s, c) {
    kce(e, i, s, c);
  }
  mount(e) {
    this.isSVGTag = X6(e.tagName), super.mount(e);
  }
}
const Rce = (t, e) => _z(t) ? new Tce(e) : new Cce(e, {
  allowProjection: t !== Qv
});
function yE(t, e, i) {
  const s = t.getProps();
  return xz(s, e, i !== void 0 ? i : s.custom, t);
}
const fF = t => Array.isArray(t);
function Dce(t, e, i) {
  t.hasValue(e) ? t.getValue(e).set(i) : t.addValue(e, RE(i));
}
function Ice(t) {
  return fF(t) ? t[t.length - 1] || 0 : t;
}
function Mce(t, e) {
  const i = yE(t, e);
  let {
    transitionEnd: s = {},
    transition: c = {},
    ...p
  } = i || {};
  p = {
    ...p,
    ...s
  };
  for (const h in p) {
    const y = Ice(p[h]);
    Dce(t, h, y);
  }
}
function Lce(t) {
  return !!(Cu(t) && t.add);
}
function pF(t, e) {
  const i = t.getValue("willChange");
  if (Lce(i)) return i.add(e);
  if (!i && xb.WillChange) {
    const s = new xb.WillChange("auto");
    t.addValue("willChange", s), s.add(e);
  }
}
function u8(t) {
  return t.props[Z6];
}
const Oce = t => t !== null;
function Pce(t, {
  repeat: e,
  repeatType: i = "loop"
}, s) {
  const c = t.filter(Oce),
    p = e && i !== "loop" && e % 2 === 1 ? 0 : c.length - 1;
  return c[p];
}
const Ace = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  },
  jce = t => ({
    type: "spring",
    stiffness: 550,
    damping: t === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  }),
  Fce = {
    type: "keyframes",
    duration: 0.8
  },
  Nce = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3
  },
  zce = (t, {
    keyframes: e
  }) => e.length > 2 ? Fce : HE.has(t) ? t.startsWith("scale") ? jce(e[1]) : Ace : Nce;
function Vce({
  when: t,
  delay: e,
  delayChildren: i,
  staggerChildren: s,
  staggerDirection: c,
  repeat: p,
  repeatType: h,
  repeatDelay: y,
  from: w,
  elapsed: x,
  ...E
}) {
  return !!Object.keys(E).length;
}
const kz = (t, e, i, s = {}, c, p) => h => {
  const y = pz(s, t) || {},
    w = y.delay || s.delay || 0;
  let {
    elapsed: x = 0
  } = s;
  x = x - /* @__PURE__ */qm(w);
  const E = {
    keyframes: Array.isArray(i) ? i : [null, i],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...y,
    delay: -x,
    onUpdate: k => {
      e.set(k), y.onUpdate && y.onUpdate(k);
    },
    onComplete: () => {
      h(), y.onComplete && y.onComplete();
    },
    name: t,
    motionValue: e,
    element: p ? void 0 : c
  };
  Vce(y) || Object.assign(E, zce(t, E)), E.duration && (E.duration = /* @__PURE__ */qm(E.duration)), E.repeatDelay && (E.repeatDelay = /* @__PURE__ */qm(E.repeatDelay)), E.from !== void 0 && (E.keyframes[0] = E.from);
  let C = !1;
  if ((E.type === !1 || E.duration === 0 && !E.repeatDelay) && (sF(E), E.delay === 0 && (C = !0)), (xb.instantAnimations || xb.skipAnimations) && (C = !0, sF(E), E.delay = 0), E.allowFlatten = !y.type && !y.ease, C && !p && e.get() !== void 0) {
    const k = Pce(E.keyframes, y);
    if (k !== void 0) {
      Ua.update(() => {
        E.onUpdate(k), E.onComplete();
      });
      return;
    }
  }
  return y.isSync ? new dz(E) : new due(E);
};
function Bce({
  protectedKeys: t,
  needsAnimating: e
}, i) {
  const s = t.hasOwnProperty(i) && e[i] !== !0;
  return e[i] = !1, s;
}
function c8(t, e, {
  delay: i = 0,
  transitionOverride: s,
  type: c
} = {}) {
  let {
    transition: p = t.getDefaultTransition(),
    transitionEnd: h,
    ...y
  } = e;
  s && (p = s);
  const w = [],
    x = c && t.animationState && t.animationState.getState()[c];
  for (const E in y) {
    const C = t.getValue(E, t.latestValues[E] ?? null),
      k = y[E];
    if (k === void 0 || x && Bce(x, E)) continue;
    const D = {
        delay: i,
        ...pz(p || {}, E)
      },
      I = C.get();
    if (I !== void 0 && !C.isAnimating && !Array.isArray(k) && k === I && !D.velocity) continue;
    let L = !1;
    if (window.MotionHandoffAnimation) {
      const N = u8(t);
      if (N) {
        const O = window.MotionHandoffAnimation(N, E, Ua);
        O !== null && (D.startTime = O, L = !0);
      }
    }
    pF(t, E), C.start(kz(E, C, k, t.shouldReduceMotion && M6.has(E) ? {
      type: !1
    } : D, t, L));
    const P = C.animation;
    P && w.push(P);
  }
  return h && Promise.all(w).then(() => {
    Ua.update(() => {
      h && Mce(t, h);
    });
  }), w;
}
function d8(t, e, i, s = 0, c = 1) {
  const p = Array.from(t).sort((x, E) => x.sortNodePosition(E)).indexOf(e),
    h = t.size,
    y = (h - 1) * s;
  return typeof i == "function" ? i(p, h) : c === 1 ? p * s : y - p * s;
}
function hF(t, e, i = {}) {
  var w;
  const s = yE(t, e, i.type === "exit" ? (w = t.presenceContext) == null ? void 0 : w.custom : void 0);
  let {
    transition: c = t.getDefaultTransition() || {}
  } = s || {};
  i.transitionOverride && (c = i.transitionOverride);
  const p = s ? () => Promise.all(c8(t, s, i)) : () => Promise.resolve(),
    h = t.variantChildren && t.variantChildren.size ? (x = 0) => {
      const {
        delayChildren: E = 0,
        staggerChildren: C,
        staggerDirection: k
      } = c;
      return Uce(t, e, x, E, C, k, i);
    } : () => Promise.resolve(),
    {
      when: y
    } = c;
  if (y) {
    const [x, E] = y === "beforeChildren" ? [p, h] : [h, p];
    return x().then(() => E());
  } else return Promise.all([p(), h(i.delay)]);
}
function Uce(t, e, i = 0, s = 0, c = 0, p = 1, h) {
  const y = [];
  for (const w of t.variantChildren) w.notify("AnimationStart", e), y.push(hF(w, e, {
    ...h,
    delay: i + (typeof s == "function" ? 0 : s) + d8(t.variantChildren, w, s, c, p)
  }).then(() => w.notify("AnimationComplete", e)));
  return Promise.all(y);
}
function Hce(t, e, i = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const c = e.map(p => hF(t, p, i));
    s = Promise.all(c);
  } else if (typeof e == "string") s = hF(t, e, i);else {
    const c = typeof e == "function" ? yE(t, e, i.custom) : e;
    s = Promise.all(c8(t, c, i));
  }
  return s.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function f8(t, e) {
  if (!Array.isArray(e)) return !1;
  const i = e.length;
  if (i !== t.length) return !1;
  for (let s = 0; s < i; s++) if (e[s] !== t[s]) return !1;
  return !0;
}
const $ce = yz.length;
function p8(t) {
  if (!t) return;
  if (!t.isControllingVariants) {
    const i = t.parent ? p8(t.parent) || {} : {};
    return t.props.initial !== void 0 && (i.initial = t.props.initial), i;
  }
  const e = {};
  for (let i = 0; i < $ce; i++) {
    const s = yz[i],
      c = t.props[s];
    (xR(c) || c === !1) && (e[s] = c);
  }
  return e;
}
const Wce = [...gz].reverse(),
  qce = gz.length;
function Yce(t) {
  return e => Promise.all(e.map(({
    animation: i,
    options: s
  }) => Hce(t, i, s)));
}
function Gce(t) {
  let e = Yce(t),
    i = T3(),
    s = !0;
  const c = w => (x, E) => {
    var k;
    const C = yE(t, E, w === "exit" ? (k = t.presenceContext) == null ? void 0 : k.custom : void 0);
    if (C) {
      const {
        transition: D,
        transitionEnd: I,
        ...L
      } = C;
      x = {
        ...x,
        ...L,
        ...I
      };
    }
    return x;
  };
  function p(w) {
    e = w(t);
  }
  function h(w) {
    const {
        props: x
      } = t,
      E = p8(t.parent) || {},
      C = [],
      k = /* @__PURE__ */new Set();
    let D = {},
      I = 1 / 0;
    for (let P = 0; P < qce; P++) {
      const N = Wce[P],
        O = i[N],
        F = x[N] !== void 0 ? x[N] : E[N],
        j = xR(F),
        V = N === w ? O.isActive : null;
      V === !1 && (I = P);
      let K = F === E[N] && F !== x[N] && j;
      if (K && s && t.manuallyAnimateOnMount && (K = !1), O.protectedKeys = {
        ...D
      },
      // If it isn't active and hasn't *just* been set as inactive
      !O.isActive && V === null ||
      // If we didn't and don't have any defined prop for this animation type
      !F && !O.prevProp ||
      // Or if the prop doesn't define an animation
      JL(F) || typeof F == "boolean") continue;
      const G = Xce(O.prevProp, F);
      let Q = G ||
        // If we're making this variant active, we want to always make it active
        N === w && O.isActive && !K && j ||
        // If we removed a higher-priority variant (i is in reverse order)
        P > I && j,
        te = !1;
      const ie = Array.isArray(F) ? F : [F];
      let Y = ie.reduce(c(N), {});
      V === !1 && (Y = {});
      const {
          prevResolvedValues: ee = {}
        } = O,
        ae = {
          ...ee,
          ...Y
        },
        ne = W => {
          Q = !0, k.has(W) && (te = !0, k.delete(W)), O.needsAnimating[W] = !0;
          const $ = t.getValue(W);
          $ && ($.liveStyle = !1);
        };
      for (const W in ae) {
        const $ = Y[W],
          de = ee[W];
        if (D.hasOwnProperty(W)) continue;
        let H = !1;
        fF($) && fF(de) ? H = !f8($, de) : H = $ !== de, H ? $ != null ? ne(W) : k.add(W) : $ !== void 0 && k.has(W) ? ne(W) : O.protectedKeys[W] = !0;
      }
      O.prevProp = F, O.prevResolvedValues = Y, O.isActive && (D = {
        ...D,
        ...Y
      }), s && t.blockInitialAnimation && (Q = !1);
      const le = K && G;
      Q && (!le || te) && C.push(...ie.map(W => {
        const $ = {
          type: N
        };
        if (typeof W == "string" && s && !le && t.manuallyAnimateOnMount && t.parent) {
          const {
              parent: de
            } = t,
            H = yE(de, W);
          if (de.enteringChildren && H) {
            const {
              delayChildren: se
            } = H.transition || {};
            $.delay = d8(de.enteringChildren, t, se);
          }
        }
        return {
          animation: W,
          options: $
        };
      }));
    }
    if (k.size) {
      const P = {};
      if (typeof x.initial != "boolean") {
        const N = yE(t, Array.isArray(x.initial) ? x.initial[0] : x.initial);
        N && N.transition && (P.transition = N.transition);
      }
      k.forEach(N => {
        const O = t.getBaseTarget(N),
          F = t.getValue(N);
        F && (F.liveStyle = !0), P[N] = O ?? null;
      }), C.push({
        animation: P
      });
    }
    let L = !!C.length;
    return s && (x.initial === !1 || x.initial === x.animate) && !t.manuallyAnimateOnMount && (L = !1), s = !1, L ? e(C) : Promise.resolve();
  }
  function y(w, x) {
    var C;
    if (i[w].isActive === x) return Promise.resolve();
    (C = t.variantChildren) == null || C.forEach(k => {
      var D;
      return (D = k.animationState) == null ? void 0 : D.setActive(w, x);
    }), i[w].isActive = x;
    const E = h(w);
    for (const k in i) i[k].protectedKeys = {};
    return E;
  }
  return {
    animateChanges: h,
    setActive: y,
    setAnimateFunction: p,
    getState: () => i,
    reset: () => {
      i = T3(), s = !0;
    }
  };
}
function Xce(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !f8(e, t) : !1;
}
function Ox(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function T3() {
  return {
    animate: Ox(!0),
    whileInView: Ox(),
    whileHover: Ox(),
    whileTap: Ox(),
    whileDrag: Ox(),
    whileFocus: Ox(),
    exit: Ox()
  };
}
class uw {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {}
}
class Kce extends uw {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Gce(e));
  }
  updateAnimationControlsSubscription() {
    const {
      animate: e
    } = this.node.getProps();
    JL(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const {
        animate: e
      } = this.node.getProps(),
      {
        animate: i
      } = this.node.prevProps || {};
    e !== i && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let Qce = 0;
class Zce extends uw {
  constructor() {
    super(...arguments), this.id = Qce++;
  }
  update() {
    if (!this.node.presenceContext) return;
    const {
        isPresent: e,
        onExitComplete: i
      } = this.node.presenceContext,
      {
        isPresent: s
      } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s) return;
    const c = this.node.animationState.setActive("exit", !e);
    i && !e && c.then(() => {
      i(this.id);
    });
  }
  mount() {
    const {
      register: e,
      onExitComplete: i
    } = this.node.presenceContext || {};
    i && i(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {}
}
const Jce = {
  animation: {
    Feature: Kce
  },
  exit: {
    Feature: Zce
  }
};
function ER(t, e, i, s = {
  passive: !0
}) {
  return t.addEventListener(e, i, s), () => t.removeEventListener(e, i);
}
function YR(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const ede = t => e => vz(e) && t(e, YR(e));
function GT(t, e, i, s) {
  return ER(t, e, ede(i), s);
}
const h8 = 1e-4,
  tde = 1 - h8,
  nde = 1 + h8,
  m8 = 0.01,
  rde = 0 - m8,
  ide = 0 + m8;
function Mc(t) {
  return t.max - t.min;
}
function ade(t, e, i) {
  return Math.abs(t - e) <= i;
}
function R3(t, e, i, s = 0.5) {
  t.origin = s, t.originPoint = go(e.min, e.max, t.origin), t.scale = Mc(i) / Mc(e), t.translate = go(i.min, i.max, t.origin) - t.originPoint, (t.scale >= tde && t.scale <= nde || isNaN(t.scale)) && (t.scale = 1), (t.translate >= rde && t.translate <= ide || isNaN(t.translate)) && (t.translate = 0);
}
function XT(t, e, i, s) {
  R3(t.x, e.x, i.x, s ? s.originX : void 0), R3(t.y, e.y, i.y, s ? s.originY : void 0);
}
function D3(t, e, i) {
  t.min = i.min + e.min, t.max = t.min + Mc(e);
}
function ode(t, e, i) {
  D3(t.x, e.x, i.x), D3(t.y, e.y, i.y);
}
function I3(t, e, i) {
  t.min = e.min - i.min, t.max = t.min + Mc(e);
}
function KT(t, e, i) {
  I3(t.x, e.x, i.x), I3(t.y, e.y, i.y);
}
function Op(t) {
  return [t("x"), t("y")];
}
const v8 = ({
    current: t
  }) => t ? t.ownerDocument.defaultView : null,
  M3 = (t, e) => Math.abs(t - e);
function lde(t, e) {
  const i = M3(t.x, e.x),
    s = M3(t.y, e.y);
  return Math.sqrt(i ** 2 + s ** 2);
}
class g8 {
  constructor(e, i, {
    transformPagePoint: s,
    contextWindow: c = window,
    dragSnapToOrigin: p = !1,
    distanceThreshold: h = 3
  } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const k = t2(this.lastMoveEventInfo, this.history),
        D = this.startEvent !== null,
        I = lde(k.offset, {
          x: 0,
          y: 0
        }) >= this.distanceThreshold;
      if (!D && !I) return;
      const {
          point: L
        } = k,
        {
          timestamp: P
        } = su;
      this.history.push({
        ...L,
        timestamp: P
      });
      const {
        onStart: N,
        onMove: O
      } = this.handlers;
      D || (N && N(this.lastMoveEvent, k), this.startEvent = this.lastMoveEvent), O && O(this.lastMoveEvent, k);
    }, this.handlePointerMove = (k, D) => {
      this.lastMoveEvent = k, this.lastMoveEventInfo = e2(D, this.transformPagePoint), Ua.update(this.updatePoint, !0);
    }, this.handlePointerUp = (k, D) => {
      this.end();
      const {
        onEnd: I,
        onSessionEnd: L,
        resumeAnimation: P
      } = this.handlers;
      if (this.dragSnapToOrigin && P && P(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const N = t2(k.type === "pointercancel" ? this.lastMoveEventInfo : e2(D, this.transformPagePoint), this.history);
      this.startEvent && I && I(k, N), L && L(k, N);
    }, !vz(e)) return;
    this.dragSnapToOrigin = p, this.handlers = i, this.transformPagePoint = s, this.distanceThreshold = h, this.contextWindow = c || window;
    const y = YR(e),
      w = e2(y, this.transformPagePoint),
      {
        point: x
      } = w,
      {
        timestamp: E
      } = su;
    this.history = [{
      ...x,
      timestamp: E
    }];
    const {
      onSessionStart: C
    } = i;
    C && C(e, t2(w, this.history)), this.removeListeners = $R(GT(this.contextWindow, "pointermove", this.handlePointerMove), GT(this.contextWindow, "pointerup", this.handlePointerUp), GT(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), ow(this.updatePoint);
  }
}
function e2(t, e) {
  return e ? {
    point: e(t.point)
  } : t;
}
function L3(t, e) {
  return {
    x: t.x - e.x,
    y: t.y - e.y
  };
}
function t2({
  point: t
}, e) {
  return {
    point: t,
    delta: L3(t, y8(e)),
    offset: L3(t, sde(e)),
    velocity: ude(e, 0.1)
  };
}
function sde(t) {
  return t[0];
}
function y8(t) {
  return t[t.length - 1];
}
function ude(t, e) {
  if (t.length < 2) return {
    x: 0,
    y: 0
  };
  let i = t.length - 1,
    s = null;
  const c = y8(t);
  for (; i >= 0 && (s = t[i], !(c.timestamp - s.timestamp > /* @__PURE__ */qm(e)));) i--;
  if (!s) return {
    x: 0,
    y: 0
  };
  const p = /* @__PURE__ */Xv(c.timestamp - s.timestamp);
  if (p === 0) return {
    x: 0,
    y: 0
  };
  const h = {
    x: (c.x - s.x) / p,
    y: (c.y - s.y) / p
  };
  return h.x === 1 / 0 && (h.x = 0), h.y === 1 / 0 && (h.y = 0), h;
}
function cde(t, {
  min: e,
  max: i
}, s) {
  return e !== void 0 && t < e ? t = s ? go(e, t, s.min) : Math.max(t, e) : i !== void 0 && t > i && (t = s ? go(i, t, s.max) : Math.min(t, i)), t;
}
function O3(t, e, i) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: i !== void 0 ? t.max + i - (t.max - t.min) : void 0
  };
}
function dde(t, {
  top: e,
  left: i,
  bottom: s,
  right: c
}) {
  return {
    x: O3(t.x, i, c),
    y: O3(t.y, e, s)
  };
}
function P3(t, e) {
  let i = e.min - t.min,
    s = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([i, s] = [s, i]), {
    min: i,
    max: s
  };
}
function fde(t, e) {
  return {
    x: P3(t.x, e.x),
    y: P3(t.y, e.y)
  };
}
function pde(t, e) {
  let i = 0.5;
  const s = Mc(t),
    c = Mc(e);
  return c > s ? i = /* @__PURE__ */bR(e.min, e.max - s, t.min) : s > c && (i = /* @__PURE__ */bR(t.min, t.max - c, e.min)), wb(0, 1, i);
}
function hde(t, e) {
  const i = {};
  return e.min !== void 0 && (i.min = e.min - t.min), e.max !== void 0 && (i.max = e.max - t.min), i;
}
const mF = 0.35;
function mde(t = mF) {
  return t === !1 ? t = 0 : t === !0 && (t = mF), {
    x: A3(t, "left", "right"),
    y: A3(t, "top", "bottom")
  };
}
function A3(t, e, i) {
  return {
    min: j3(t, e),
    max: j3(t, i)
  };
}
function j3(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const vde = /* @__PURE__ */new WeakMap();
class gde {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
      x: 0,
      y: 0
    }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = il(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, {
    snapToCursor: i = !1,
    distanceThreshold: s
  } = {}) {
    const {
      presenceContext: c
    } = this.visualElement;
    if (c && c.isPresent === !1) return;
    const p = C => {
        const {
          dragSnapToOrigin: k
        } = this.getProps();
        k ? this.pauseAnimation() : this.stopAnimation(), i && this.snapToCursor(YR(C).point);
      },
      h = (C, k) => {
        const {
          drag: D,
          dragPropagation: I,
          onDragStart: L
        } = this.getProps();
        if (D && !I && (this.openDragLock && this.openDragLock(), this.openDragLock = Due(D), !this.openDragLock)) return;
        this.latestPointerEvent = C, this.latestPanInfo = k, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Op(N => {
          let O = this.getAxisMotionValue(N).get() || 0;
          if (Kv.test(O)) {
            const {
              projection: F
            } = this.visualElement;
            if (F && F.layout) {
              const j = F.layout.layoutBox[N];
              j && (O = Mc(j) * (parseFloat(O) / 100));
            }
          }
          this.originPoint[N] = O;
        }), L && Ua.postRender(() => L(C, k)), pF(this.visualElement, "transform");
        const {
          animationState: P
        } = this.visualElement;
        P && P.setActive("whileDrag", !0);
      },
      y = (C, k) => {
        this.latestPointerEvent = C, this.latestPanInfo = k;
        const {
          dragPropagation: D,
          dragDirectionLock: I,
          onDirectionLock: L,
          onDrag: P
        } = this.getProps();
        if (!D && !this.openDragLock) return;
        const {
          offset: N
        } = k;
        if (I && this.currentDirection === null) {
          this.currentDirection = yde(N), this.currentDirection !== null && L && L(this.currentDirection);
          return;
        }
        this.updateAxis("x", k.point, N), this.updateAxis("y", k.point, N), this.visualElement.render(), P && P(C, k);
      },
      w = (C, k) => {
        this.latestPointerEvent = C, this.latestPanInfo = k, this.stop(C, k), this.latestPointerEvent = null, this.latestPanInfo = null;
      },
      x = () => Op(C => {
        var k;
        return this.getAnimationState(C) === "paused" && ((k = this.getAxisMotionValue(C).animation) == null ? void 0 : k.play());
      }),
      {
        dragSnapToOrigin: E
      } = this.getProps();
    this.panSession = new g8(e, {
      onSessionStart: p,
      onStart: h,
      onMove: y,
      onSessionEnd: w,
      resumeAnimation: x
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: E,
      distanceThreshold: s,
      contextWindow: v8(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(e, i) {
    const s = e || this.latestPointerEvent,
      c = i || this.latestPanInfo,
      p = this.isDragging;
    if (this.cancel(), !p || !c || !s) return;
    const {
      velocity: h
    } = c;
    this.startAnimation(h);
    const {
      onDragEnd: y
    } = this.getProps();
    y && Ua.postRender(() => y(s, c));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const {
      projection: e,
      animationState: i
    } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const {
      dragPropagation: s
    } = this.getProps();
    !s && this.openDragLock && (this.openDragLock(), this.openDragLock = null), i && i.setActive("whileDrag", !1);
  }
  updateAxis(e, i, s) {
    const {
      drag: c
    } = this.getProps();
    if (!s || !CM(e, c, this.currentDirection)) return;
    const p = this.getAxisMotionValue(e);
    let h = this.originPoint[e] + s[e];
    this.constraints && this.constraints[e] && (h = cde(h, this.constraints[e], this.elastic[e])), p.set(h);
  }
  resolveConstraints() {
    var p;
    const {
        dragConstraints: e,
        dragElastic: i
      } = this.getProps(),
      s = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (p = this.visualElement.projection) == null ? void 0 : p.layout,
      c = this.constraints;
    e && uE(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && s ? this.constraints = dde(s.layoutBox, e) : this.constraints = !1, this.elastic = mde(i), c !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && Op(h => {
      this.constraints !== !1 && this.getAxisMotionValue(h) && (this.constraints[h] = hde(s.layoutBox[h], this.constraints[h]));
    });
  }
  resolveRefConstraints() {
    const {
      dragConstraints: e,
      onMeasureDragConstraints: i
    } = this.getProps();
    if (!e || !uE(e)) return !1;
    const s = e.current;
    _b(s !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const {
      projection: c
    } = this.visualElement;
    if (!c || !c.layout) return !1;
    const p = wce(s, c.root, this.visualElement.getTransformPagePoint());
    let h = fde(c.layout.layoutBox, p);
    if (i) {
      const y = i(gce(h));
      this.hasMutatedConstraints = !!y, y && (h = t8(y));
    }
    return h;
  }
  startAnimation(e) {
    const {
        drag: i,
        dragMomentum: s,
        dragElastic: c,
        dragTransition: p,
        dragSnapToOrigin: h,
        onDragTransitionEnd: y
      } = this.getProps(),
      w = this.constraints || {},
      x = Op(E => {
        if (!CM(E, i, this.currentDirection)) return;
        let C = w && w[E] || {};
        h && (C = {
          min: 0,
          max: 0
        });
        const k = c ? 200 : 1e6,
          D = c ? 40 : 1e7,
          I = {
            type: "inertia",
            velocity: s ? e[E] : 0,
            bounceStiffness: k,
            bounceDamping: D,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...p,
            ...C
          };
        return this.startAxisValueAnimation(E, I);
      });
    return Promise.all(x).then(y);
  }
  startAxisValueAnimation(e, i) {
    const s = this.getAxisMotionValue(e);
    return pF(this.visualElement, e), s.start(kz(e, s, 0, i, this.visualElement, !1));
  }
  stopAnimation() {
    Op(e => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Op(e => {
      var i;
      return (i = this.getAxisMotionValue(e).animation) == null ? void 0 : i.pause();
    });
  }
  getAnimationState(e) {
    var i;
    return (i = this.getAxisMotionValue(e).animation) == null ? void 0 : i.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const i = `_drag${e.toUpperCase()}`,
      s = this.visualElement.getProps(),
      c = s[i];
    return c || this.visualElement.getValue(e, (s.initial ? s.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Op(i => {
      const {
        drag: s
      } = this.getProps();
      if (!CM(i, s, this.currentDirection)) return;
      const {
          projection: c
        } = this.visualElement,
        p = this.getAxisMotionValue(i);
      if (c && c.layout) {
        const {
          min: h,
          max: y
        } = c.layout.layoutBox[i];
        p.set(e[i] - go(h, y, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const {
        drag: e,
        dragConstraints: i
      } = this.getProps(),
      {
        projection: s
      } = this.visualElement;
    if (!uE(i) || !s || !this.constraints) return;
    this.stopAnimation();
    const c = {
      x: 0,
      y: 0
    };
    Op(h => {
      const y = this.getAxisMotionValue(h);
      if (y && this.constraints !== !1) {
        const w = y.get();
        c[h] = pde({
          min: w,
          max: w
        }, this.constraints[h]);
      }
    });
    const {
      transformTemplate: p
    } = this.visualElement.getProps();
    this.visualElement.current.style.transform = p ? p({}, "") : "none", s.root && s.root.updateScroll(), s.updateLayout(), this.resolveConstraints(), Op(h => {
      if (!CM(h, e, null)) return;
      const y = this.getAxisMotionValue(h),
        {
          min: w,
          max: x
        } = this.constraints[h];
      y.set(go(w, x, c[h]));
    });
  }
  addListeners() {
    if (!this.visualElement.current) return;
    vde.set(this.visualElement, this);
    const e = this.visualElement.current,
      i = GT(e, "pointerdown", w => {
        const {
          drag: x,
          dragListener: E = !0
        } = this.getProps();
        x && E && this.start(w);
      }),
      s = () => {
        const {
          dragConstraints: w
        } = this.getProps();
        uE(w) && w.current && (this.constraints = this.resolveRefConstraints());
      },
      {
        projection: c
      } = this.visualElement,
      p = c.addEventListener("measure", s);
    c && !c.layout && (c.root && c.root.updateScroll(), c.updateLayout()), Ua.read(s);
    const h = ER(window, "resize", () => this.scalePositionWithinConstraints()),
      y = c.addEventListener("didUpdate", ({
        delta: w,
        hasLayoutChanged: x
      }) => {
        this.isDragging && x && (Op(E => {
          const C = this.getAxisMotionValue(E);
          C && (this.originPoint[E] += w[E].translate, C.set(C.get() + w[E].translate));
        }), this.visualElement.render());
      });
    return () => {
      h(), i(), p(), y && y();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(),
      {
        drag: i = !1,
        dragDirectionLock: s = !1,
        dragPropagation: c = !1,
        dragConstraints: p = !1,
        dragElastic: h = mF,
        dragMomentum: y = !0
      } = e;
    return {
      ...e,
      drag: i,
      dragDirectionLock: s,
      dragPropagation: c,
      dragConstraints: p,
      dragElastic: h,
      dragMomentum: y
    };
  }
}
function CM(t, e, i) {
  return (e === !0 || e === t) && (i === null || i === t);
}
function yde(t, e = 10) {
  let i = null;
  return Math.abs(t.y) > e ? i = "y" : Math.abs(t.x) > e && (i = "x"), i;
}
class bde extends uw {
  constructor(e) {
    super(e), this.removeGroupControls = Bp, this.removeListeners = Bp, this.controls = new gde(e);
  }
  mount() {
    const {
      dragControls: e
    } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Bp;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const F3 = t => (e, i) => {
  t && Ua.postRender(() => t(e, i));
};
class wde extends uw {
  constructor() {
    super(...arguments), this.removePointerDownListener = Bp;
  }
  onPointerDown(e) {
    this.session = new g8(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: v8(this.node)
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart: e,
      onPanStart: i,
      onPan: s,
      onPanEnd: c
    } = this.node.getProps();
    return {
      onSessionStart: F3(e),
      onStart: F3(i),
      onMove: s,
      onEnd: (p, h) => {
        delete this.session, c && Ua.postRender(() => c(p, h));
      }
    };
  }
  mount() {
    this.removePointerDownListener = GT(this.node.current, "pointerdown", e => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const KM = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function N3(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const CT = {
    correct: (t, e) => {
      if (!e.target) return t;
      if (typeof t == "string") if (Yn.test(t)) t = parseFloat(t);else return t;
      const i = N3(t, e.target.x),
        s = N3(t, e.target.y);
      return `${i}% ${s}%`;
    }
  },
  _de = {
    correct: (t, {
      treeScale: e,
      projectionDelta: i
    }) => {
      const s = t,
        c = lw.parse(t);
      if (c.length > 5) return s;
      const p = lw.createTransformer(t),
        h = typeof c[0] != "number" ? 1 : 0,
        y = i.x.scale * e.x,
        w = i.y.scale * e.y;
      c[0 + h] /= y, c[1 + h] /= w;
      const x = go(y, w, 0.5);
      return typeof c[2 + h] == "number" && (c[2 + h] /= x), typeof c[3 + h] == "number" && (c[3 + h] /= x), p(c);
    }
  };
let n2 = !1;
class xde extends oH {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const {
        visualElement: e,
        layoutGroup: i,
        switchLayoutGroup: s,
        layoutId: c
      } = this.props,
      {
        projection: p
      } = e;
    Wue(Sde), p && (i.group && i.group.add(p), s && s.register && c && s.register(p), n2 && p.root.didUpdate(), p.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), p.setOptions({
      ...p.options,
      onExitComplete: () => this.safeToRemove()
    })), KM.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const {
        layoutDependency: i,
        visualElement: s,
        drag: c,
        isPresent: p
      } = this.props,
      {
        projection: h
      } = s;
    return h && (h.isPresent = p, n2 = !0, c || e.layoutDependency !== i || i === void 0 || e.isPresent !== p ? h.willUpdate() : this.safeToRemove(), e.isPresent !== p && (p ? h.promote() : h.relegate() || Ua.postRender(() => {
      const y = h.getStack();
      (!y || !y.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const {
      projection: e
    } = this.props.visualElement;
    e && (e.root.didUpdate(), mz.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const {
        visualElement: e,
        layoutGroup: i,
        switchLayoutGroup: s
      } = this.props,
      {
        projection: c
      } = e;
    n2 = !0, c && (c.scheduleCheckAfterUnmount(), i && i.group && i.group.remove(c), s && s.deregister && s.deregister(c));
  }
  safeToRemove() {
    const {
      safeToRemove: e
    } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function b8(t) {
  const [e, i] = Nue(),
    s = bs(Q$);
  return B.jsx(xde, {
    ...t,
    layoutGroup: s,
    switchLayoutGroup: bs(J6),
    isPresent: e,
    safeToRemove: i
  });
}
const Sde = {
  borderRadius: {
    ...CT,
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  },
  borderTopLeftRadius: CT,
  borderTopRightRadius: CT,
  borderBottomLeftRadius: CT,
  borderBottomRightRadius: CT,
  boxShadow: _de
};
function Ede(t, e, i) {
  const s = Cu(t) ? t : RE(t);
  return s.start(kz("", s, e, i)), s.animation;
}
const Cde = (t, e) => t.depth - e.depth;
class kde {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    QN(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    ZN(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(Cde), this.isDirty = !1, this.children.forEach(e);
  }
}
function Tde(t, e) {
  const i = sd.now(),
    s = ({
      timestamp: c
    }) => {
      const p = c - i;
      p >= e && (ow(s), t(p - e));
    };
  return Ua.setup(s, !0), () => ow(s);
}
const w8 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  Rde = w8.length,
  z3 = t => typeof t == "string" ? parseFloat(t) : t,
  V3 = t => typeof t == "number" || Yn.test(t);
function Dde(t, e, i, s, c, p) {
  c ? (t.opacity = go(0, i.opacity ?? 1, Ide(s)), t.opacityExit = go(e.opacity ?? 1, 0, Mde(s))) : p && (t.opacity = go(e.opacity ?? 1, i.opacity ?? 1, s));
  for (let h = 0; h < Rde; h++) {
    const y = `border${w8[h]}Radius`;
    let w = B3(e, y),
      x = B3(i, y);
    if (w === void 0 && x === void 0) continue;
    w || (w = 0), x || (x = 0), w === 0 || x === 0 || V3(w) === V3(x) ? (t[y] = Math.max(go(z3(w), z3(x), s), 0), (Kv.test(x) || Kv.test(w)) && (t[y] += "%")) : t[y] = x;
  }
  (e.rotate || i.rotate) && (t.rotate = go(e.rotate || 0, i.rotate || 0, s));
}
function B3(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const Ide = /* @__PURE__ */_8(0, 0.5, s6),
  Mde = /* @__PURE__ */_8(0.5, 0.95, Bp);
function _8(t, e, i) {
  return s => s < t ? 0 : s > e ? 1 : i(/* @__PURE__ */bR(t, e, s));
}
function U3(t, e) {
  t.min = e.min, t.max = e.max;
}
function Ip(t, e) {
  U3(t.x, e.x), U3(t.y, e.y);
}
function H3(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function $3(t, e, i, s, c) {
  return t -= e, t = ML(t, 1 / i, s), c !== void 0 && (t = ML(t, 1 / c, s)), t;
}
function Lde(t, e = 0, i = 1, s = 0.5, c, p = t, h = t) {
  if (Kv.test(e) && (e = parseFloat(e), e = go(h.min, h.max, e / 100) - h.min), typeof e != "number") return;
  let y = go(p.min, p.max, s);
  t === p && (y -= e), t.min = $3(t.min, e, i, y, c), t.max = $3(t.max, e, i, y, c);
}
function W3(t, e, [i, s, c], p, h) {
  Lde(t, e[i], e[s], e[c], e.scale, p, h);
}
const Ode = ["x", "scaleX", "originX"],
  Pde = ["y", "scaleY", "originY"];
function q3(t, e, i, s) {
  W3(t.x, e, Ode, i ? i.x : void 0, s ? s.x : void 0), W3(t.y, e, Pde, i ? i.y : void 0, s ? s.y : void 0);
}
function Y3(t) {
  return t.translate === 0 && t.scale === 1;
}
function x8(t) {
  return Y3(t.x) && Y3(t.y);
}
function G3(t, e) {
  return t.min === e.min && t.max === e.max;
}
function Ade(t, e) {
  return G3(t.x, e.x) && G3(t.y, e.y);
}
function X3(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function S8(t, e) {
  return X3(t.x, e.x) && X3(t.y, e.y);
}
function K3(t) {
  return Mc(t.x) / Mc(t.y);
}
function Q3(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class jde {
  constructor() {
    this.members = [];
  }
  add(e) {
    QN(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (ZN(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const i = this.members[this.members.length - 1];
      i && this.promote(i);
    }
  }
  relegate(e) {
    const i = this.members.findIndex(c => e === c);
    if (i === 0) return !1;
    let s;
    for (let c = i; c >= 0; c--) {
      const p = this.members[c];
      if (p.isPresent !== !1) {
        s = p;
        break;
      }
    }
    return s ? (this.promote(s), !0) : !1;
  }
  promote(e, i) {
    const s = this.lead;
    if (e !== s && (this.prevLead = s, this.lead = e, e.show(), s)) {
      s.instance && s.scheduleRender(), e.scheduleRender(), e.resumeFrom = s, i && (e.resumeFrom.preserveOpacity = !0), s.snapshot && (e.snapshot = s.snapshot, e.snapshot.latestValues = s.animationValues || s.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const {
        crossfade: c
      } = e.options;
      c === !1 && s.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach(e => {
      const {
        options: i,
        resumingFrom: s
      } = e;
      i.onExitComplete && i.onExitComplete(), s && s.options.onExitComplete && s.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach(e => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Fde(t, e, i) {
  let s = "";
  const c = t.x.translate / e.x,
    p = t.y.translate / e.y,
    h = (i == null ? void 0 : i.z) || 0;
  if ((c || p || h) && (s = `translate3d(${c}px, ${p}px, ${h}px) `), (e.x !== 1 || e.y !== 1) && (s += `scale(${1 / e.x}, ${1 / e.y}) `), i) {
    const {
      transformPerspective: x,
      rotate: E,
      rotateX: C,
      rotateY: k,
      skewX: D,
      skewY: I
    } = i;
    x && (s = `perspective(${x}px) ${s}`), E && (s += `rotate(${E}deg) `), C && (s += `rotateX(${C}deg) `), k && (s += `rotateY(${k}deg) `), D && (s += `skewX(${D}deg) `), I && (s += `skewY(${I}deg) `);
  }
  const y = t.x.scale * e.x,
    w = t.y.scale * e.y;
  return (y !== 1 || w !== 1) && (s += `scale(${y}, ${w})`), s || "none";
}
const r2 = ["", "X", "Y", "Z"],
  Nde = 1e3;
let zde = 0;
function i2(t, e, i, s) {
  const {
    latestValues: c
  } = e;
  c[t] && (i[t] = c[t], e.setStaticValue(t, 0), s && (s[t] = 0));
}
function E8(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t) return;
  const {
    visualElement: e
  } = t.options;
  if (!e) return;
  const i = u8(e);
  if (window.MotionHasOptimisedAnimation(i, "transform")) {
    const {
      layout: c,
      layoutId: p
    } = t.options;
    window.MotionCancelOptimisedAnimation(i, "transform", Ua, !(c || p));
  }
  const {
    parent: s
  } = t;
  s && !s.hasCheckedOptimisedAppear && E8(s);
}
function C8({
  attachResizeListener: t,
  defaultParent: e,
  measureScroll: i,
  checkIsScrollRoot: s,
  resetTransform: c
}) {
  return class {
    constructor(h = {}, y = e == null ? void 0 : e()) {
      this.id = zde++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
        x: 1,
        y: 1
      }, this.eventHandlers = /* @__PURE__ */new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Ude), this.nodes.forEach(qde), this.nodes.forEach(Yde), this.nodes.forEach(Hde);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */new Map(), this.latestValues = h, this.root = y ? y.root || y : this, this.path = y ? [...y.path, y] : [], this.parent = y, this.depth = y ? y.depth + 1 : 0;
      for (let w = 0; w < this.path.length; w++) this.path[w].shouldResetTransform = !0;
      this.root === this && (this.nodes = new kde());
    }
    addEventListener(h, y) {
      return this.eventHandlers.has(h) || this.eventHandlers.set(h, new ez()), this.eventHandlers.get(h).add(y);
    }
    notifyListeners(h, ...y) {
      const w = this.eventHandlers.get(h);
      w && w.notify(...y);
    }
    hasListeners(h) {
      return this.eventHandlers.has(h);
    }
    /**
     * Lifecycles
     */
    mount(h) {
      if (this.instance) return;
      this.isSVG = V6(h) && !Aue(h), this.instance = h;
      const {
        layoutId: y,
        layout: w,
        visualElement: x
      } = this.options;
      if (x && !x.current && x.mount(h), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (w || y) && (this.isLayoutDirty = !0), t) {
        let E,
          C = 0;
        const k = () => this.root.updateBlockedByResize = !1;
        Ua.read(() => {
          C = window.innerWidth;
        }), t(h, () => {
          const D = window.innerWidth;
          D !== C && (C = D, this.root.updateBlockedByResize = !0, E && E(), E = Tde(k, 250), KM.hasAnimatedSinceResize && (KM.hasAnimatedSinceResize = !1, this.nodes.forEach(eU)));
        });
      }
      y && this.root.registerSharedNode(y, this), this.options.animate !== !1 && x && (y || w) && this.addEventListener("didUpdate", ({
        delta: E,
        hasLayoutChanged: C,
        hasRelativeLayoutChanged: k,
        layout: D
      }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const I = this.options.transition || x.getDefaultTransition() || Zde,
          {
            onLayoutAnimationStart: L,
            onLayoutAnimationComplete: P
          } = x.getProps(),
          N = !this.targetLayout || !S8(this.targetLayout, D),
          O = !C && k;
        if (this.options.layoutRoot || this.resumeFrom || O || C && (N || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const F = {
            ...pz(I, "layout"),
            onPlay: L,
            onComplete: P
          };
          (x.shouldReduceMotion || this.options.layoutRoot) && (F.delay = 0, F.type = !1), this.startAnimation(F), this.setAnimationOrigin(E, O);
        } else C || eU(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = D;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const h = this.getStack();
      h && h.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), ow(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Gde), this.animationId++);
    }
    getTransformTemplate() {
      const {
        visualElement: h
      } = this.options;
      return h && h.getProps().transformTemplate;
    }
    willUpdate(h = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && E8(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
      this.isLayoutDirty = !0;
      for (let E = 0; E < this.path.length; E++) {
        const C = this.path[E];
        C.shouldResetTransform = !0, C.updateScroll("snapshot"), C.options.layoutRoot && C.willUpdate(!1);
      }
      const {
        layoutId: y,
        layout: w
      } = this.options;
      if (y === void 0 && !w) return;
      const x = this.getTransformTemplate();
      this.prevTransformTemplateValue = x ? x(this.latestValues, "") : void 0, this.updateSnapshot(), h && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Z3);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(J3);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(Wde), this.nodes.forEach(Vde), this.nodes.forEach(Bde)) : this.nodes.forEach(J3), this.clearAllSnapshots();
      const y = sd.now();
      su.delta = wb(0, 1e3 / 60, y - su.timestamp), su.timestamp = y, su.isProcessing = !0, Yj.update.process(su), Yj.preRender.process(su), Yj.render.process(su), su.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, mz.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach($de), this.sharedNodes.forEach(Xde);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Ua.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Ua.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Mc(this.snapshot.measuredBox.x) && !Mc(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
      if (this.resumeFrom && !this.resumeFrom.instance) for (let w = 0; w < this.path.length; w++) this.path[w].updateScroll();
      const h = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = il(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const {
        visualElement: y
      } = this.options;
      y && y.notify("LayoutMeasure", this.layout.layoutBox, h ? h.layoutBox : void 0);
    }
    updateScroll(h = "measure") {
      let y = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === h && (y = !1), y && this.instance) {
        const w = s(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: h,
          isRoot: w,
          offset: i(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : w
        };
      }
    }
    resetTransform() {
      if (!c) return;
      const h = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout,
        y = this.projectionDelta && !x8(this.projectionDelta),
        w = this.getTransformTemplate(),
        x = w ? w(this.latestValues, "") : void 0,
        E = x !== this.prevTransformTemplateValue;
      h && this.instance && (y || Bx(this.latestValues) || E) && (c(this.instance, x), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(h = !0) {
      const y = this.measurePageBox();
      let w = this.removeElementScroll(y);
      return h && (w = this.removeTransform(w)), Jde(w), {
        animationId: this.root.animationId,
        measuredBox: y,
        layoutBox: w,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var x;
      const {
        visualElement: h
      } = this.options;
      if (!h) return il();
      const y = h.measureViewportBox();
      if (!(((x = this.scroll) == null ? void 0 : x.wasRoot) || this.path.some(efe))) {
        const {
          scroll: E
        } = this.root;
        E && (cE(y.x, E.offset.x), cE(y.y, E.offset.y));
      }
      return y;
    }
    removeElementScroll(h) {
      var w;
      const y = il();
      if (Ip(y, h), (w = this.scroll) != null && w.wasRoot) return y;
      for (let x = 0; x < this.path.length; x++) {
        const E = this.path[x],
          {
            scroll: C,
            options: k
          } = E;
        E !== this.root && C && k.layoutScroll && (C.wasRoot && Ip(y, h), cE(y.x, C.offset.x), cE(y.y, C.offset.y));
      }
      return y;
    }
    applyTransform(h, y = !1) {
      const w = il();
      Ip(w, h);
      for (let x = 0; x < this.path.length; x++) {
        const E = this.path[x];
        !y && E.options.layoutScroll && E.scroll && E !== E.root && dE(w, {
          x: -E.scroll.offset.x,
          y: -E.scroll.offset.y
        }), Bx(E.latestValues) && dE(w, E.latestValues);
      }
      return Bx(this.latestValues) && dE(w, this.latestValues), w;
    }
    removeTransform(h) {
      const y = il();
      Ip(y, h);
      for (let w = 0; w < this.path.length; w++) {
        const x = this.path[w];
        if (!x.instance || !Bx(x.latestValues)) continue;
        cF(x.latestValues) && x.updateSnapshot();
        const E = il(),
          C = x.measurePageBox();
        Ip(E, C), q3(y, x.latestValues, x.snapshot ? x.snapshot.layoutBox : void 0, E);
      }
      return Bx(this.latestValues) && q3(y, this.latestValues), y;
    }
    setTargetDelta(h) {
      this.targetDelta = h, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(h) {
      this.options = {
        ...this.options,
        ...h,
        crossfade: h.crossfade !== void 0 ? h.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== su.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(h = !1) {
      var k;
      const y = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = y.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = y.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = y.isSharedProjectionDirty);
      const w = !!this.resumingFrom || this !== y;
      if (!(h || w && this.isSharedProjectionDirty || this.isProjectionDirty || (k = this.parent) != null && k.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
      const {
        layout: E,
        layoutId: C
      } = this.options;
      if (!(!this.layout || !(E || C))) {
        if (this.resolvedRelativeTargetAt = su.timestamp, !this.targetDelta && !this.relativeTarget) {
          const D = this.getClosestProjectingParent();
          D && D.layout && this.animationProgress !== 1 ? (this.relativeParent = D, this.forceRelativeParentToResolveTarget(), this.relativeTarget = il(), this.relativeTargetOrigin = il(), KT(this.relativeTargetOrigin, this.layout.layoutBox, D.layout.layoutBox), Ip(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = il(), this.targetWithTransforms = il()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), ode(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ip(this.target, this.layout.layoutBox), r8(this.target, this.targetDelta)) : Ip(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const D = this.getClosestProjectingParent();
          D && !!D.resumingFrom == !!this.resumingFrom && !D.options.layoutScroll && D.target && this.animationProgress !== 1 ? (this.relativeParent = D, this.forceRelativeParentToResolveTarget(), this.relativeTarget = il(), this.relativeTargetOrigin = il(), KT(this.relativeTargetOrigin, this.target, D.target), Ip(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || cF(this.parent.latestValues) || n8(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var I;
      const h = this.getLead(),
        y = !!this.resumingFrom || this !== h;
      let w = !0;
      if ((this.isProjectionDirty || (I = this.parent) != null && I.isProjectionDirty) && (w = !1), y && (this.isSharedProjectionDirty || this.isTransformDirty) && (w = !1), this.resolvedRelativeTargetAt === su.timestamp && (w = !1), w) return;
      const {
        layout: x,
        layoutId: E
      } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(x || E)) return;
      Ip(this.layoutCorrected, this.layout.layoutBox);
      const C = this.treeScale.x,
        k = this.treeScale.y;
      bce(this.layoutCorrected, this.treeScale, this.path, y), h.layout && !h.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (h.target = h.layout.layoutBox, h.targetWithTransforms = il());
      const {
        target: D
      } = h;
      if (!D) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (H3(this.prevProjectionDelta.x, this.projectionDelta.x), H3(this.prevProjectionDelta.y, this.projectionDelta.y)), XT(this.projectionDelta, this.layoutCorrected, D, this.latestValues), (this.treeScale.x !== C || this.treeScale.y !== k || !Q3(this.projectionDelta.x, this.prevProjectionDelta.x) || !Q3(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", D));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(h = !0) {
      var y;
      if ((y = this.options.visualElement) == null || y.scheduleRender(), h) {
        const w = this.getStack();
        w && w.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = fE(), this.projectionDelta = fE(), this.projectionDeltaWithTransform = fE();
    }
    setAnimationOrigin(h, y = !1) {
      const w = this.snapshot,
        x = w ? w.latestValues : {},
        E = {
          ...this.latestValues
        },
        C = fE();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !y;
      const k = il(),
        D = w ? w.source : void 0,
        I = this.layout ? this.layout.source : void 0,
        L = D !== I,
        P = this.getStack(),
        N = !P || P.members.length <= 1,
        O = !!(L && !N && this.options.crossfade === !0 && !this.path.some(Qde));
      this.animationProgress = 0;
      let F;
      this.mixTargetDelta = j => {
        const V = j / 1e3;
        tU(C.x, h.x, V), tU(C.y, h.y, V), this.setTargetDelta(C), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (KT(k, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Kde(this.relativeTarget, this.relativeTargetOrigin, k, V), F && Ade(this.relativeTarget, F) && (this.isProjectionDirty = !1), F || (F = il()), Ip(F, this.relativeTarget)), L && (this.animationValues = E, Dde(E, x, this.latestValues, V, O, N)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = V;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(h) {
      var y, w, x;
      this.notifyListeners("animationStart"), (y = this.currentAnimation) == null || y.stop(), (x = (w = this.resumingFrom) == null ? void 0 : w.currentAnimation) == null || x.stop(), this.pendingAnimation && (ow(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ua.update(() => {
        KM.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = RE(0)), this.currentAnimation = Ede(this.motionValue, [0, 1e3], {
          ...h,
          velocity: 0,
          isSync: !0,
          onUpdate: E => {
            this.mixTargetDelta(E), h.onUpdate && h.onUpdate(E);
          },
          onStop: () => {},
          onComplete: () => {
            h.onComplete && h.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const h = this.getStack();
      h && h.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Nde), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const h = this.getLead();
      let {
        targetWithTransforms: y,
        target: w,
        layout: x,
        latestValues: E
      } = h;
      if (!(!y || !w || !x)) {
        if (this !== h && this.layout && x && k8(this.options.animationType, this.layout.layoutBox, x.layoutBox)) {
          w = this.target || il();
          const C = Mc(this.layout.layoutBox.x);
          w.x.min = h.target.x.min, w.x.max = w.x.min + C;
          const k = Mc(this.layout.layoutBox.y);
          w.y.min = h.target.y.min, w.y.max = w.y.min + k;
        }
        Ip(y, w), dE(y, E), XT(this.projectionDeltaWithTransform, this.layoutCorrected, y, E);
      }
    }
    registerSharedNode(h, y) {
      this.sharedNodes.has(h) || this.sharedNodes.set(h, new jde()), this.sharedNodes.get(h).add(y);
      const x = y.options.initialPromotionConfig;
      y.promote({
        transition: x ? x.transition : void 0,
        preserveFollowOpacity: x && x.shouldPreserveFollowOpacity ? x.shouldPreserveFollowOpacity(y) : void 0
      });
    }
    isLead() {
      const h = this.getStack();
      return h ? h.lead === this : !0;
    }
    getLead() {
      var y;
      const {
        layoutId: h
      } = this.options;
      return h ? ((y = this.getStack()) == null ? void 0 : y.lead) || this : this;
    }
    getPrevLead() {
      var y;
      const {
        layoutId: h
      } = this.options;
      return h ? (y = this.getStack()) == null ? void 0 : y.prevLead : void 0;
    }
    getStack() {
      const {
        layoutId: h
      } = this.options;
      if (h) return this.root.sharedNodes.get(h);
    }
    promote({
      needsReset: h,
      transition: y,
      preserveFollowOpacity: w
    } = {}) {
      const x = this.getStack();
      x && x.promote(this, w), h && (this.projectionDelta = void 0, this.needsReset = !0), y && this.setOptions({
        transition: y
      });
    }
    relegate() {
      const h = this.getStack();
      return h ? h.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const {
        visualElement: h
      } = this.options;
      if (!h) return;
      let y = !1;
      const {
        latestValues: w
      } = h;
      if ((w.z || w.rotate || w.rotateX || w.rotateY || w.rotateZ || w.skewX || w.skewY) && (y = !0), !y) return;
      const x = {};
      w.z && i2("z", h, x, this.animationValues);
      for (let E = 0; E < r2.length; E++) i2(`rotate${r2[E]}`, h, x, this.animationValues), i2(`skew${r2[E]}`, h, x, this.animationValues);
      h.render();
      for (const E in x) h.setStaticValue(E, x[E]), this.animationValues && (this.animationValues[E] = x[E]);
      h.scheduleRender();
    }
    applyProjectionStyles(h, y) {
      if (!this.instance || this.isSVG) return;
      if (!this.isVisible) {
        h.visibility = "hidden";
        return;
      }
      const w = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, h.visibility = "", h.opacity = "", h.pointerEvents = XM(y == null ? void 0 : y.pointerEvents) || "", h.transform = w ? w(this.latestValues, "") : "none";
        return;
      }
      const x = this.getLead();
      if (!this.projectionDelta || !this.layout || !x.target) {
        this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = XM(y == null ? void 0 : y.pointerEvents) || ""), this.hasProjected && !Bx(this.latestValues) && (h.transform = w ? w({}, "") : "none", this.hasProjected = !1);
        return;
      }
      h.visibility = "";
      const E = x.animationValues || x.latestValues;
      this.applyTransformsToTarget();
      let C = Fde(this.projectionDeltaWithTransform, this.treeScale, E);
      w && (C = w(E, C)), h.transform = C;
      const {
        x: k,
        y: D
      } = this.projectionDelta;
      h.transformOrigin = `${k.origin * 100}% ${D.origin * 100}% 0`, x.animationValues ? h.opacity = x === this ? E.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : E.opacityExit : h.opacity = x === this ? E.opacity !== void 0 ? E.opacity : "" : E.opacityExit !== void 0 ? E.opacityExit : 0;
      for (const I in SR) {
        if (E[I] === void 0) continue;
        const {
            correct: L,
            applyTo: P,
            isCSSVariable: N
          } = SR[I],
          O = C === "none" ? E[I] : L(E[I], x);
        if (P) {
          const F = P.length;
          for (let j = 0; j < F; j++) h[P[j]] = O;
        } else N ? this.options.visualElement.renderState.vars[I] = O : h[I] = O;
      }
      this.options.layoutId && (h.pointerEvents = x === this ? XM(y == null ? void 0 : y.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach(h => {
        var y;
        return (y = h.currentAnimation) == null ? void 0 : y.stop();
      }), this.root.nodes.forEach(Z3), this.root.sharedNodes.clear();
    }
  };
}
function Vde(t) {
  t.updateLayout();
}
function Bde(t) {
  var i;
  const e = ((i = t.resumeFrom) == null ? void 0 : i.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const {
        layoutBox: s,
        measuredBox: c
      } = t.layout,
      {
        animationType: p
      } = t.options,
      h = e.source !== t.layout.source;
    p === "size" ? Op(C => {
      const k = h ? e.measuredBox[C] : e.layoutBox[C],
        D = Mc(k);
      k.min = s[C].min, k.max = k.min + D;
    }) : k8(p, e.layoutBox, s) && Op(C => {
      const k = h ? e.measuredBox[C] : e.layoutBox[C],
        D = Mc(s[C]);
      k.max = k.min + D, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[C].max = t.relativeTarget[C].min + D);
    });
    const y = fE();
    XT(y, s, e.layoutBox);
    const w = fE();
    h ? XT(w, t.applyTransform(c, !0), e.measuredBox) : XT(w, s, e.layoutBox);
    const x = !x8(y);
    let E = !1;
    if (!t.resumeFrom) {
      const C = t.getClosestProjectingParent();
      if (C && !C.resumeFrom) {
        const {
          snapshot: k,
          layout: D
        } = C;
        if (k && D) {
          const I = il();
          KT(I, e.layoutBox, k.layoutBox);
          const L = il();
          KT(L, s, D.layoutBox), S8(I, L) || (E = !0), C.options.layoutRoot && (t.relativeTarget = L, t.relativeTargetOrigin = I, t.relativeParent = C);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: s,
      snapshot: e,
      delta: w,
      layoutDelta: y,
      hasLayoutChanged: x,
      hasRelativeLayoutChanged: E
    });
  } else if (t.isLead()) {
    const {
      onExitComplete: s
    } = t.options;
    s && s();
  }
  t.options.transition = void 0;
}
function Ude(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Hde(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function $de(t) {
  t.clearSnapshot();
}
function Z3(t) {
  t.clearMeasurements();
}
function J3(t) {
  t.isLayoutDirty = !1;
}
function Wde(t) {
  const {
    visualElement: e
  } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function eU(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function qde(t) {
  t.resolveTargetDelta();
}
function Yde(t) {
  t.calcProjection();
}
function Gde(t) {
  t.resetSkewAndRotation();
}
function Xde(t) {
  t.removeLeadSnapshot();
}
function tU(t, e, i) {
  t.translate = go(e.translate, 0, i), t.scale = go(e.scale, 1, i), t.origin = e.origin, t.originPoint = e.originPoint;
}
function nU(t, e, i, s) {
  t.min = go(e.min, i.min, s), t.max = go(e.max, i.max, s);
}
function Kde(t, e, i, s) {
  nU(t.x, e.x, i.x, s), nU(t.y, e.y, i.y, s);
}
function Qde(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Zde = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1]
  },
  rU = t => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t),
  iU = rU("applewebkit/") && !rU("chrome/") ? Math.round : Bp;
function aU(t) {
  t.min = iU(t.min), t.max = iU(t.max);
}
function Jde(t) {
  aU(t.x), aU(t.y);
}
function k8(t, e, i) {
  return t === "position" || t === "preserve-aspect" && !ade(K3(e), K3(i), 0.2);
}
function efe(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const tfe = C8({
    attachResizeListener: (t, e) => ER(t, "resize", e),
    measureScroll: () => ({
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    }),
    checkIsScrollRoot: () => !0
  }),
  a2 = {
    current: void 0
  },
  T8 = C8({
    measureScroll: t => ({
      x: t.scrollLeft,
      y: t.scrollTop
    }),
    defaultParent: () => {
      if (!a2.current) {
        const t = new tfe({});
        t.mount(window), t.setOptions({
          layoutScroll: !0
        }), a2.current = t;
      }
      return a2.current;
    },
    resetTransform: (t, e) => {
      t.style.transform = e !== void 0 ? e : "none";
    },
    checkIsScrollRoot: t => window.getComputedStyle(t).position === "fixed"
  }),
  nfe = {
    pan: {
      Feature: wde
    },
    drag: {
      Feature: bde,
      ProjectionNode: T8,
      MeasureLayout: b8
    }
  };
function oU(t, e, i) {
  const {
    props: s
  } = t;
  t.animationState && s.whileHover && t.animationState.setActive("whileHover", i === "Start");
  const c = "onHover" + i,
    p = s[c];
  p && Ua.postRender(() => p(e, YR(e)));
}
class rfe extends uw {
  mount() {
    const {
      current: e
    } = this.node;
    e && (this.unmount = Iue(e, (i, s) => (oU(this.node, s, "Start"), c => oU(this.node, c, "End"))));
  }
  unmount() {}
}
class ife extends uw {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = $R(ER(this.node.current, "focus", () => this.onFocus()), ER(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {}
}
function lU(t, e, i) {
  const {
    props: s
  } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled) return;
  t.animationState && s.whileTap && t.animationState.setActive("whileTap", i === "Start");
  const c = "onTap" + (i === "End" ? "" : i),
    p = s[c];
  p && Ua.postRender(() => p(e, YR(e)));
}
class afe extends uw {
  mount() {
    const {
      current: e
    } = this.node;
    e && (this.unmount = Pue(e, (i, s) => (lU(this.node, s, "Start"), (c, {
      success: p
    }) => lU(this.node, c, p ? "End" : "Cancel")), {
      useGlobalTarget: this.node.props.globalTapTarget
    }));
  }
  unmount() {}
}
const vF = /* @__PURE__ */new WeakMap(),
  o2 = /* @__PURE__ */new WeakMap(),
  ofe = t => {
    const e = vF.get(t.target);
    e && e(t);
  },
  lfe = t => {
    t.forEach(ofe);
  };
function sfe({
  root: t,
  ...e
}) {
  const i = t || document;
  o2.has(i) || o2.set(i, {});
  const s = o2.get(i),
    c = JSON.stringify(e);
  return s[c] || (s[c] = new IntersectionObserver(lfe, {
    root: t,
    ...e
  })), s[c];
}
function ufe(t, e, i) {
  const s = sfe(e);
  return vF.set(t, i), s.observe(t), () => {
    vF.delete(t), s.unobserve(t);
  };
}
const cfe = {
  some: 0,
  all: 1
};
class dfe extends uw {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const {
        viewport: e = {}
      } = this.node.getProps(),
      {
        root: i,
        margin: s,
        amount: c = "some",
        once: p
      } = e,
      h = {
        root: i ? i.current : void 0,
        rootMargin: s,
        threshold: typeof c == "number" ? c : cfe[c]
      },
      y = w => {
        const {
          isIntersecting: x
        } = w;
        if (this.isInView === x || (this.isInView = x, p && !x && this.hasEnteredView)) return;
        x && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", x);
        const {
            onViewportEnter: E,
            onViewportLeave: C
          } = this.node.getProps(),
          k = x ? E : C;
        k && k(w);
      };
    return ufe(this.node.current, h, y);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u") return;
    const {
      props: e,
      prevProps: i
    } = this.node;
    ["amount", "margin", "root"].some(ffe(e, i)) && this.startObserver();
  }
  unmount() {}
}
function ffe({
  viewport: t = {}
}, {
  viewport: e = {}
} = {}) {
  return i => t[i] !== e[i];
}
const pfe = {
    inView: {
      Feature: dfe
    },
    tap: {
      Feature: afe
    },
    focus: {
      Feature: ife
    },
    hover: {
      Feature: rfe
    }
  },
  hfe = {
    layout: {
      ProjectionNode: T8,
      MeasureLayout: b8
    }
  },
  mfe = {
    ...Jce,
    ...pfe,
    ...nfe,
    ...hfe
  },
  CR = /* @__PURE__ */vce(mfe, Rce);
function R8() {
  !Cz.current && a8();
  const [t] = rt(LL.current);
  return process.env.NODE_ENV !== "production" && QL(t !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), t;
}
const vfe = "_closeButton_1nq2h_1",
  gfe = "_closeMenu_1nq2h_13",
  yfe = "_title_1nq2h_19",
  kM = {
    closeButton: vfe,
    closeMenu: gfe,
    title: yfe
  },
  Tz = {
    backToHome: "Back to home",
    travelAdvisories: "Travel advisories",
    menu: "Menu",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    openGatewayMenu: "Open gateway menu",
    changeGateway: "Change gateway",
    gatewayHeader: "Gateway",
    closeModal: "Close",
    searchLabel: "Search",
    searchHotelsLabel: "Search Hotels",
    profileOpenMenu: "Open account profile menu",
    profileCloseLabel: "Close",
    profileToggleDropdown: "Toggle account profile dropdown menu",
    profileGreeting: "Hi,",
    profileMobileMenuTitle: "Account profile",
    lang: "Language preference",
    menuTitle: "Menu"
  },
  bfe = {
    label: "Calgary",
    value: "YYC"
  },
  D8 = ({
    id: t,
    title: e,
    labels: i = Tz,
    isOpen: s,
    handleClose: c
  }) => {
    const p = R8();
    return /* @__PURE__ */B.jsxs(CR.div, {
      className: kM.container,
      initial: !1,
      variants: {
        ...QQ(0.2, p)
      },
      animate: s ? "open" : "closed",
      children: [/* @__PURE__ */B.jsx("div", {
        className: kM.closeMenu,
        children: /* @__PURE__ */B.jsx("button", {
          type: "button",
          className: kM.closeButton,
          "aria-label": i.closeMenu,
          "aria-controls": t,
          onClick: c,
          children: /* @__PURE__ */B.jsx(ln, {
            name: "close",
            size: "3xl",
            title: i.closeMenu,
            hidden: !0
          })
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: kM.title,
        children: e
      })]
    });
  },
  wfe = "_menuContainer_9e536_1",
  _fe = "_backdrop_9e536_6",
  xfe = "_wrapper_9e536_17",
  Sfe = "_wrapperOpen_9e536_46",
  Efe = "_container_9e536_51",
  Cfe = "_gatewayWrapper_9e536_58",
  kfe = "_mainNav_9e536_62",
  Tfe = "_divider_9e536_73",
  Rfe = "_mainNavDivider_9e536_79",
  Dfe = "_langToggleContainer_9e536_84",
  Ife = "_iconDown_9e536_89",
  Mfe = "_iconGlobe_9e536_90",
  Lfe = "_currentLanguage_9e536_94",
  Eu = {
    menuContainer: wfe,
    backdrop: _fe,
    wrapper: xfe,
    wrapperOpen: Sfe,
    container: Efe,
    gatewayWrapper: Cfe,
    mainNav: kfe,
    divider: Tfe,
    mainNavDivider: Rfe,
    langToggleContainer: Dfe,
    iconDown: Ife,
    iconGlobe: Mfe,
    currentLanguage: Lfe
  },
  Ofe = "_subMenuContainer_ched8_1",
  Pfe = "_dropdownContainer_ched8_10",
  Afe = "_dropdownContainerOpen_ched8_17",
  jfe = "_dropdownToggle_ched8_29",
  Ffe = "_dropdownToggleLabel_ched8_44",
  Nfe = "_navLink_ched8_49",
  zfe = "_iconExternal_ched8_61",
  Vfe = "_iconChevron_ched8_62",
  Bfe = "_subNavLink_ched8_72",
  np = {
    subMenuContainer: Ofe,
    dropdownContainer: Pfe,
    dropdownContainerOpen: Afe,
    dropdownToggle: jfe,
    dropdownToggleLabel: Ffe,
    navLink: Nfe,
    iconExternal: zfe,
    iconChevron: Vfe,
    subNavLink: Bfe
  },
  Ufe = t => "href" in t || "url" in t,
  Hfe = {
    open: {
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.05
      }
    },
    closed: {
      overflow: "hidden",
      transition: {
        delay: 0.4,
        staggerChildren: 0.05,
        staggerDirection: 1
      }
    }
  },
  $fe = ({
    isMenuOpened: t,
    menuLinks: e,
    renderLinks: i
  }) => {
    const [s, c] = Nt.useState([]),
      p = h => () => {
        const y = new Set(s);
        y.has(h) ? y.delete(h) : y.add(h), c(Array.from(y));
      };
    return /* @__PURE__ */B.jsx(CR.ul, {
      className: np.subMenuContainer,
      initial: !1,
      variants: Hfe,
      animate: t ? "open" : "closed",
      children: e == null ? void 0 : e.map((h, y) => {
        var w;
        return /* @__PURE__ */B.jsx("li", {
          className: np.navList,
          children: Ufe(h) ? /* @__PURE__ */B.jsx(B.Fragment, {
            children: i == null ? void 0 : i({
              ...h,
              className: ve(h.className, np.navLink),
              children: /* @__PURE__ */B.jsxs(B.Fragment, {
                children: [h.linkText, (h == null ? void 0 : h.iconName) && /* @__PURE__ */B.jsx(ln, {
                  size: "xs",
                  name: h.iconName,
                  className: np.iconExternal
                })]
              })
            })
          }) : /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [h.displayTitle && /* @__PURE__ */B.jsxs("button", {
              type: "button",
              className: np.dropdownToggle,
              "aria-label": h.displayTitle,
              "aria-haspopup": !0,
              "aria-expanded": t,
              onClick: p(y),
              children: [/* @__PURE__ */B.jsx("span", {
                className: np.dropdownToggleLabel,
                children: h.displayTitle
              }), /* @__PURE__ */B.jsx(ln, {
                name: s.includes(y) ? "chevron-up" : "chevron-down",
                className: np.iconChevron,
                size: "3xl"
              })]
            }), /* @__PURE__ */B.jsx("ul", {
              className: ve(np.dropdownContainer, s.includes(y) && np.dropdownContainerOpen),
              children: (w = h.menuItems) == null ? void 0 : w.map((x, E) => /* @__PURE__ */B.jsx("li", {
                children: i == null ? void 0 : i({
                  ...x,
                  className: ve(x.className, np.subNavLink),
                  children: x.linkText
                })
              }, `header-menu-subnav-li-${E}`))
            })]
          })
        }, `header-menu-nav-li-${y}`);
      })
    });
  },
  Wfe = ({
    children: t,
    className: e
  }) => e ? /* @__PURE__ */B.jsx("span", {
    className: e,
    children: t
  }) : t,
  I8 = ({
    links: t,
    classNames: e,
    renderLinks: i
  }) => /* @__PURE__ */B.jsx("ul", {
    className: e == null ? void 0 : e.ul,
    children: t == null ? void 0 : t.map((s, c) => {
      var p;
      return /* @__PURE__ */B.jsx("li", {
        className: e == null ? void 0 : e.li,
        children: i == null ? void 0 : i({
          ...s,
          className: typeof (e == null ? void 0 : e.renderLink) != "string" ? (p = e == null ? void 0 : e.renderLink) == null ? void 0 : p.call(e, s) : e.renderLink,
          children: /* @__PURE__ */B.jsxs(Wfe, {
            className: e == null ? void 0 : e.linkText,
            children: [s.linkText, (s == null ? void 0 : s.iconName) && /* @__PURE__ */B.jsx(ln, {
              size: "xs",
              name: s.iconName,
              className: e == null ? void 0 : e.icon
            })]
          })
        })
      }, `nav-main-link-${c}`);
    })
  }),
  M8 = [{
    label: "AB",
    name: "Alberta",
    gateways: [{
      label: "Calgary",
      value: "YYC"
    }, {
      label: "Edmonton",
      value: "YEG"
    }, {
      label: "Fort McMurray",
      value: "YMM"
    }, {
      label: "Grande Prairie",
      value: "YQU"
    }, {
      label: "Lethbridge",
      value: "YQL"
    }, {
      label: "Medicine Hat",
      value: "YXH"
    }]
  }, {
    label: "BC",
    name: "British Columbia",
    gateways: [{
      label: "Abbotsford",
      value: "YXX"
    }, {
      label: "Comox",
      value: "YQQ"
    }, {
      label: "Cranbook",
      value: "YXC"
    }, {
      label: "Fort Saint John",
      value: "YXJ"
    }, {
      label: "Kamloops",
      value: "YKA"
    }, {
      label: "Kelowna",
      value: "YLW"
    }, {
      label: "Nanaimo",
      value: "YCD"
    }, {
      label: "Penticton",
      value: "YYF"
    }, {
      label: "Prince George",
      value: "YXS"
    }, {
      label: "Terrace",
      value: "YXT"
    }, {
      label: "Vancouver",
      value: "YVR"
    }, {
      label: "Victoria",
      value: "YYJ"
    }]
  }, {
    label: "MB",
    name: "Manitoba",
    gateways: [{
      label: "Winnipeg",
      value: "YWG"
    }]
  }, {
    label: "NL",
    name: "Newfoundland and Labrador",
    gateways: [{
      label: "St. John's",
      value: "YYT"
    }]
  }, {
    label: "NS",
    name: "Nova Scotia",
    gateways: [{
      label: "Halifax",
      value: "YHZ"
    }]
  }, {
    label: "NT",
    name: "Northwest Territories",
    gateways: [{
      label: "Yellowknife",
      value: "YZF"
    }]
  }, {
    label: "ON",
    name: "Ontario",
    gateways: [{
      label: "Hamilton",
      value: "HAM"
    }, {
      label: "London",
      value: "YXU"
    }, {
      label: "Ottawa",
      value: "YOW"
    }, {
      label: "Thunder Bay",
      value: "YQT"
    }, {
      label: "Toronto",
      value: "YYZ"
    }]
  }, {
    label: "SK",
    name: "Saskatchewan",
    gateways: [{
      label: "Regina",
      value: "YQR"
    }, {
      label: "Saskatoon",
      value: "YKE"
    }]
  }],
  qfe = "_menu_1leia_1",
  Yfe = "_menuOpen_1leia_18",
  Gfe = "_container_1leia_23",
  Xfe = "_gatewayCityContainer_1leia_39",
  Kfe = "_province_1leia_44",
  Qfe = "_provinceLabel_1leia_47",
  Zfe = "_currentGateway_1leia_69",
  W0 = {
    menu: qfe,
    menuOpen: Yfe,
    container: Gfe,
    gatewayCityContainer: Xfe,
    province: Kfe,
    provinceLabel: Qfe,
    currentGateway: Zfe
  },
  Jfe = {
    open: {
      overflow: "auto"
    },
    closed: {
      overflow: "hidden",
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    }
  },
  epe = ({
    id: t,
    labels: e,
    gatewaysGroup: i,
    currentGateway: s,
    isOpened: c,
    handleChangeGateway: p,
    handleGatewayMenu: h
  }) => {
    const [y, w] = rt(!1),
      x = () => {
        w(!1), h(!1);
      },
      E = k => {
        p(k), x();
      },
      C = R8();
    return Rt(() => {
      c && setTimeout(() => {
        w(c);
      }, 50);
    }, [c]), /* @__PURE__ */B.jsxs(GN, {
      enabled: y,
      shouldIgnore: k => !(k.id === "gatsby-focus-wrapper" && k.tabIndex === -1),
      onClickOutside: x,
      onEscapeKey: x,
      className: ve(W0.menu, c && W0.menuOpen),
      children: [/* @__PURE__ */B.jsx(D8, {
        id: t,
        title: e.gatewayHeader,
        labels: {
          closeMenu: e.closeMenu,
          closeModal: e.closeModal
        },
        isOpen: c,
        handleClose: x
      }), /* @__PURE__ */B.jsx(CR.ul, {
        className: W0.container,
        id: t,
        initial: !1,
        variants: Jfe,
        animate: c ? "open" : "closed",
        children: i.map(k => /* @__PURE__ */B.jsxs(CR.li, {
          className: W0.province,
          variants: {
            ...ZQ(C || void 0)
          },
          children: [/* @__PURE__ */B.jsx("span", {
            className: W0.provinceLabel,
            children: k.label
          }), /* @__PURE__ */B.jsx("ul", {
            className: W0.gatewayCityContainer,
            children: k.gateways.map(D => /* @__PURE__ */B.jsx("li", {
              children: s.value === D.value ? /* @__PURE__ */B.jsx("span", {
                className: W0.currentGateway,
                children: D.label
              }) : /* @__PURE__ */B.jsx("button", {
                type: "button",
                className: W0.gatewayCity,
                onClick: () => E(D),
                value: D.value,
                children: D.label
              })
            }, D.value))
          })]
        }, k.label))
      })]
    });
  },
  tpe = "_gatewaySwitcher_1m1hp_1",
  npe = "_gatewaySwitcherButton_1m1hp_7",
  rpe = "_gatewayIcon_1m1hp_24",
  l2 = {
    gatewaySwitcher: tpe,
    gatewaySwitcherButton: npe,
    gatewayIcon: rpe
  },
  ipe = ({
    labels: t,
    currentGateway: e = bfe,
    handleChangeGateway: i
  }) => {
    const s = vt(null),
      [c, p] = rt(!1),
      h = y => {
        p(y), !y && s.current && setTimeout(() => {
          var w;
          (w = s.current) == null || w.focus();
        }, 0);
      };
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsxs("div", {
        className: l2.gatewaySwitcher,
        children: [/* @__PURE__ */B.jsx("span", {
          children: e.label
        }), /* @__PURE__ */B.jsxs("button", {
          type: "button",
          className: l2.gatewaySwitcherButton,
          onClick: () => h(!0),
          "aria-label": t.openGatewayMenu,
          "aria-expanded": c,
          "aria-controls": "main-menu-gateway-nav",
          ref: s,
          children: [/* @__PURE__ */B.jsx("span", {
            children: t.changeGateway
          }), /* @__PURE__ */B.jsx(ln, {
            name: "chevron-right",
            className: l2.gatewayIcon,
            hidden: !0
          })]
        })]
      }), /* @__PURE__ */B.jsx(epe, {
        id: "main-menu-gateway-nav",
        labels: {
          closeMenu: t.closeMenu,
          gatewayHeader: t.gatewayHeader,
          closeModal: t.closeModal
        },
        gatewaysGroup: M8,
        currentGateway: e,
        isOpened: c,
        handleChangeGateway: i,
        handleGatewayMenu: h
      })]
    });
  };
function ape(t, e, i) {
  var s = i || {},
    c = s.noTrailing,
    p = c === void 0 ? !1 : c,
    h = s.noLeading,
    y = h === void 0 ? !1 : h,
    w = s.debounceMode,
    x = w === void 0 ? void 0 : w,
    E,
    C = !1,
    k = 0;
  function D() {
    E && clearTimeout(E);
  }
  function I(P) {
    var N = P || {},
      O = N.upcomingOnly,
      F = O === void 0 ? !1 : O;
    D(), C = !F;
  }
  function L() {
    for (var P = arguments.length, N = new Array(P), O = 0; O < P; O++) N[O] = arguments[O];
    var F = this,
      j = Date.now() - k;
    if (C) return;
    function V() {
      k = Date.now(), e.apply(F, N);
    }
    function K() {
      E = void 0;
    }
    !y && x && !E && V(), D(), x === void 0 && j > t ? y ? (k = Date.now(), p || (E = setTimeout(x ? K : V, t))) : V() : p !== !0 && (E = setTimeout(x ? K : V, x === void 0 ? t - j : t));
  }
  return L.cancel = I, L;
}
function ope(t, e, i) {
  var s = {},
    c = s.atBegin,
    p = c === void 0 ? !1 : c;
  return ape(t, e, {
    debounceMode: p !== !1
  });
}
const lpe = "_wrapper_fo5ch_1",
  spe = "_loading_fo5ch_5",
  upe = "_input_fo5ch_5",
  cpe = "_error_fo5ch_8",
  dpe = "_themeDefault_fo5ch_11",
  fpe = "_themeGrey_fo5ch_14",
  ppe = "_search_fo5ch_17",
  hpe = "_iconClear_fo5ch_17",
  mpe = "_iconSearch_fo5ch_20",
  vpe = "_inputWrapperDisabled_fo5ch_24",
  gpe = "_inputLabel_fo5ch_28",
  ype = "_inputIconDisabled_fo5ch_34",
  bpe = "_inputIcon_fo5ch_34",
  wpe = "_inputIconHide_fo5ch_70",
  _pe = "_inputIconShow_fo5ch_73",
  xpe = "_srOnly_fo5ch_77",
  Spe = "_border_fo5ch_107",
  Epe = "_inputError_fo5ch_117",
  Cpe = "_inputErrorText_fo5ch_123",
  kpe = "_animate_fo5ch_152",
  Tpe = "_inputLabelLoading_fo5ch_156",
  Rpe = "_inputLabelDisabled_fo5ch_160",
  Dpe = "_inputFocus_fo5ch_163",
  Ipe = "_inputLabelError_fo5ch_176",
  Mpe = "_inputIconPadding_fo5ch_179",
  Lpe = "_inputLabelIconSearch_fo5ch_182",
  Ope = "_loader_fo5ch_186",
  Ppe = "_helperText_fo5ch_194",
  Ape = "_listBox_fo5ch_206",
  jpe = "_listBoxOpen_fo5ch_218",
  Fpe = "_listItemGroup_fo5ch_221",
  Npe = "_listItem_fo5ch_221",
  zpe = "_listItemActive_fo5ch_234",
  Vpe = "_listItemSelected_fo5ch_237",
  Bpe = "_listItemHighlightedText_fo5ch_242",
  Upe = "_listHeading_fo5ch_246",
  Hpe = "_noResults_fo5ch_257",
  Ur = {
    wrapper: lpe,
    loading: spe,
    input: upe,
    error: cpe,
    themeDefault: dpe,
    themeGrey: fpe,
    search: ppe,
    iconClear: hpe,
    iconSearch: mpe,
    inputWrapperDisabled: vpe,
    inputLabel: gpe,
    inputIconDisabled: ype,
    inputIcon: bpe,
    inputIconHide: wpe,
    inputIconShow: _pe,
    srOnly: xpe,
    border: Spe,
    inputError: Epe,
    inputErrorText: Cpe,
    animate: kpe,
    inputLabelLoading: Tpe,
    inputLabelDisabled: Rpe,
    inputFocus: Dpe,
    inputLabelError: Ipe,
    inputIconPadding: Mpe,
    inputLabelIconSearch: Lpe,
    loader: Ope,
    helperText: Ppe,
    listBox: Ape,
    listBoxOpen: jpe,
    listItemGroup: Fpe,
    listItem: Npe,
    listItemActive: zpe,
    listItemSelected: Vpe,
    listItemHighlightedText: Bpe,
    listHeading: Upe,
    noResults: Hpe
  },
  $pe = ({
    id: t,
    isLoading: e,
    isReadOnly: i,
    isDisabled: s,
    isInlineMode: c,
    helperText: p,
    errorMessage: h,
    iconOptions: y,
    data: w,
    selectedItem: x,
    initialSelectedItem: E,
    environment: C,
    children: k,
    className: D,
    classNames: I,
    onFocus: L,
    onBlur: P,
    onChange: N,
    onInput: O,
    onOpenTypeahead: F,
    renderCustomListItem: j,
    label: V,
    labels: K,
    onSearch: G,
    theme: Q = "default",
    template: te = "default"
  }) => {
    const [ie, Y] = rt(!1);
    return /* @__PURE__ */B.jsx(uQ, {
      id: t,
      label: V,
      isLoading: e,
      loaderConfig: {
        strokeColor: gs.color.teal[500].value,
        trackColor: gs.color.gray[500].value
      },
      isReadOnly: i,
      isDisabled: s,
      helperText: p,
      errorMessage: h,
      iconOptions: {
        input: y == null ? void 0 : y.input,
        clear: (y == null ? void 0 : y.clear) || /* @__PURE__ */B.jsx(ln, {
          name: "close-micro"
        }),
        search: (y == null ? void 0 : y.search) || /* @__PURE__ */B.jsx(ln, {
          name: "search"
        }),
        disabled: (y == null ? void 0 : y.disabled) || /* @__PURE__ */B.jsx(ln, {
          name: "nope"
        })
      },
      data: w,
      selectedItem: x,
      initialSelectedItem: E,
      environment: C,
      children: k,
      className: ve(Ur.wrapper, Ur[`theme${oE.pascal(Q)}`], Ur[te], D),
      classNames: {
        iconClear: ve(Ur.iconClear, I == null ? void 0 : I.iconClear),
        iconSearch: ve(Ur.iconSearch, I == null ? void 0 : I.iconSearch),
        input: ve(Ur.input, I == null ? void 0 : I.input),
        inputBorder: ve(Ur.border, I == null ? void 0 : I.inputBorder),
        inputIcon: ve(Ur.inputIcon, I == null ? void 0 : I.inputIcon),
        inputIconHide: ve(Ur.inputIconHide, I == null ? void 0 : I.inputIconHide),
        inputIconShow: ve(Ur.inputIconShow, I == null ? void 0 : I.inputIconShow),
        inputIconDisabled: ve(Ur.inputIconDisabled, I == null ? void 0 : I.inputIconDisabled),
        inputLabel: ve(Ur.inputLabel, h && Ur.inputLabelError, e && Ur.inputLabelLoading, I == null ? void 0 : I.inputLabel, ie && Ur.animate),
        inputFocus: ve(Ur.inputFocus, I == null ? void 0 : I.inputFocus),
        inputError: ve(Ur.inputError, I == null ? void 0 : I.inputError),
        inputLabelIconSearch: ve(Ur.inputIconPadding, te === "search" && Ur.inputLabelIconSearch, I == null ? void 0 : I.inputLabelIconSearch),
        inputErrorText: ve(Ur.helperText, Ur.inputErrorText, I == null ? void 0 : I.inputErrorText),
        inputHelperText: ve(Ur.helperText, I == null ? void 0 : I.inputHelperText),
        inputWrapperLoading: ve(Ur.loading, I == null ? void 0 : I.inputWrapperLoading),
        inputWrapperDisabled: ve(Ur.inputWrapperDisabled, I == null ? void 0 : I.inputWrapperDisabled),
        loader: ve(Ur.loader, I == null ? void 0 : I.loader),
        listBox: ve(Ur.listBox, I == null ? void 0 : I.listBox),
        listBoxOpen: ve(Ur.listBoxOpen, I == null ? void 0 : I.listBoxOpen),
        listHeading: ve(Ur.listHeading, I == null ? void 0 : I.listHeading),
        listItem: ve(Ur.listItem, I == null ? void 0 : I.listItem),
        listItemActive: ve(Ur.listItemActive, I == null ? void 0 : I.listItemActive),
        listItemSelected: ve(Ur.listItemSelected, I == null ? void 0 : I.listItemSelected),
        listItemHighlightedText: ve(Ur.listItemHighlightedText, I == null ? void 0 : I.listItemHighlightedText),
        listItemGroup: ve(Ur.listItemGroup, I == null ? void 0 : I.listItemGroup),
        noResults: ve(Ur.noResults, I == null ? void 0 : I.noResults)
      },
      onFocus: () => {
        L == null || L(), Y(!0);
      },
      onBlur: P,
      onChange: N,
      onInput: O,
      onOpenTypeahead: F,
      renderCustomListItem: j,
      isInlineMode: c,
      labels: K,
      onSearch: G,
      template: te
    });
  },
  Wpe = "Something went wrong. Please try again.",
  qpe = "_hotelSearch_yzx1w_1",
  Ype = {
    hotelSearch: qpe
  },
  Gpe = ({
    locale: t,
    handleHotelSearch: e,
    labels: i,
    gatewayConfig: s,
    defaultErrorMessage: c = Wpe
  }) => {
    const [p, h] = rt([]),
      [y, w] = rt(!1),
      [x, E] = rt(),
      [C, k] = rt(),
      D = ope(500, async L => {
        if (L.length > 2) {
          w(!0), E(void 0);
          try {
            const P = await eZ(t, L, {
              brand: "vwq",
              ...s
            });
            h(P.map(N => ({
              label: N.HotelName,
              value: `${N.RegionName}|${N.DestinationName}`,
              id: N.HotelCode
            })));
          } catch {
            E(c);
          } finally {
            w(!1);
          }
        }
      }),
      I = L => {
        var O;
        k(L);
        const [P, N] = ((O = L == null ? void 0 : L.value) == null ? void 0 : O.split("|")) || [];
        e == null || e(oZ(t, P, N, L == null ? void 0 : L.label));
      };
    return /* @__PURE__ */B.jsx(B.Fragment, {
      children: /* @__PURE__ */B.jsx("div", {
        className: Ype.hotelSearch,
        children: /* @__PURE__ */B.jsx($pe, {
          id: "hotel-search",
          template: "search",
          iconOptions: {
            input: /* @__PURE__ */B.jsx(ln, {
              name: "hotel"
            }),
            clear: /* @__PURE__ */B.jsx(ln, {
              name: "unavailable-micro"
            }),
            search: /* @__PURE__ */B.jsx(ln, {
              name: "search"
            })
          },
          data: [{
            title: "Hotels",
            displayTitle: !1,
            items: p
          }],
          isLoading: y,
          isInlineMode: !0,
          errorMessage: x,
          label: i.searchHotelsLabel,
          labels: i,
          selectedItem: C,
          onInput: L => D(L),
          onChange: I
        })
      })
    });
  },
  Xpe = ({
    labels: t,
    locale: e,
    menuButtonProps: i,
    menuId: s = "main-menu-nav",
    menuLinks: c,
    mainLinks: p,
    defaultErrorMessage: h,
    renderLinks: y,
    altLangPages: w = [],
    renderLanguageToggle: x,
    currentGateway: E,
    handleChangeGateway: C,
    handleHotelSearch: k,
    disableHotelSearch: D,
    gatewayConfig: I,
    className: L
  }) => {
    const [P, N] = rt(!1),
      O = {
        ...Tz,
        ...t
      },
      F = () => {
        N(!P);
      };
    return /* @__PURE__ */B.jsxs("nav", {
      "aria-label": O.menuTitle,
      className: ve(Eu.menuContainer, L),
      children: [/* @__PURE__ */B.jsx("button", {
        ...i,
        type: "button",
        onClick: F,
        "aria-label": O.openMenu,
        "aria-expanded": P,
        "aria-controls": s
      }), /* @__PURE__ */B.jsx("div", {
        className: ve(P && Eu.backdrop)
      }), /* @__PURE__ */B.jsx("div", {
        id: s,
        className: ve(Eu.wrapper, P && Eu.wrapperOpen),
        children: /* @__PURE__ */B.jsxs(GN, {
          autoFocus: !1,
          enabled: P,
          shouldIgnore: j => !(j.id === "gatsby-focus-wrapper" && j.tabIndex === -1),
          onClickOutside: F,
          onEscapeKey: F,
          className: Eu.container,
          gapMode: "padding",
          children: [/* @__PURE__ */B.jsx(D8, {
            id: s,
            title: O.menuTitle,
            isOpen: P,
            handleClose: F
          }), !D && /* @__PURE__ */B.jsx(Gpe, {
            locale: e,
            handleHotelSearch: k,
            labels: O,
            defaultErrorMessage: h,
            gatewayConfig: I
          }), p && /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [/* @__PURE__ */B.jsx(I8, {
              links: p,
              renderLinks: y,
              classNames: {
                ul: Eu.mainNav,
                linkText: Eu.linkText,
                li: np.navList,
                renderLink: np.navLink,
                icon: np.iconExternal
              }
            }), /* @__PURE__ */B.jsx("span", {
              className: ve(Eu.divider, Eu.mainNavDivider)
            })]
          }), /* @__PURE__ */B.jsx($fe, {
            renderLinks: y,
            menuLinks: c,
            isMenuOpened: P
          }), /* @__PURE__ */B.jsx("span", {
            className: Eu.divider
          }), /* @__PURE__ */B.jsx(CR.div, {
            initial: !1,
            className: Eu.gatewayWrapper,
            animate: P ? "open" : "closed",
            children: /* @__PURE__ */B.jsx(ipe, {
              labels: {
                closeMenu: O.closeMenu,
                openGatewayMenu: O.openGatewayMenu,
                changeGateway: O.changeGateway,
                gatewayHeader: O.gatewayHeader,
                closeModal: O.closeModal
              },
              currentGateway: E,
              handleChangeGateway: C
            })
          }), /* @__PURE__ */B.jsx("span", {
            className: Eu.divider
          }), x && /* @__PURE__ */B.jsx("div", {
            className: Eu.langToggleContainer,
            children: x(w, {
              classNames: {
                iconDown: Eu.iconDown,
                iconGlobe: Eu.iconGlobe,
                currentLanguage: Eu.currentLanguage
              },
              locale: e,
              select: {
                label: O.lang
              }
            })
          })]
        })
      })]
    });
  },
  K_e = ({
    labels: t,
    classNames: e,
    backToHome: i,
    logoOnly: s = !1,
    logo: c,
    logoLink: p,
    renderLinkLogo: h,
    renderLanguageToggle: y,
    locale: w,
    altLangPages: x,
    links: E,
    renderLinks: C,
    menuLinks: k,
    checkActiveLink: D,
    currentGateway: I,
    handleChangeGateway: L,
    handleHotelSearch: P,
    disableHotelSearch: N,
    gatewayConfig: O,
    defaultErrorMessage: F,
    children: j
  }) => {
    const V = {
        ...Tz,
        ...t
      },
      K = sZ(j);
    return /* @__PURE__ */B.jsxs("header", {
      className: ve(ni.headerContainer, e == null ? void 0 : e.header),
      children: [(i == null ? void 0 : i.url) && /* @__PURE__ */B.jsx("div", {
        className: ve(ni.backToHome, e == null ? void 0 : e.backToHomeContainer),
        children: C({
          href: i == null ? void 0 : i.url,
          target: "_self",
          className: ni.backToHomeMessage,
          children: /* @__PURE__ */B.jsxs(B.Fragment, {
            children: [/* @__PURE__ */B.jsx(ln, {
              name: "arrow-left",
              className: ni.backToHomeIcon,
              hidden: !0
            }), /* @__PURE__ */B.jsx("span", {
              className: ni.backToHomeText,
              children: (i == null ? void 0 : i.label) || V.backToHome
            })]
          })
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: ni.headerTop,
        children: /* @__PURE__ */B.jsxs("div", {
          className: ve(ni.wrapper, e == null ? void 0 : e.headerTopWrapper),
          children: [!s && /* @__PURE__ */B.jsx(B.Fragment, {
            children: K.get("profile", G => /* @__PURE__ */B.jsx(B.Fragment, {
              children: G
            }))
          }), K.get("notifications", G => /* @__PURE__ */B.jsx(B.Fragment, {
            children: G
          }))]
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: ni.header,
        children: /* @__PURE__ */B.jsxs("div", {
          className: ve(ni.headerWrapper, e == null ? void 0 : e.headerWrapper),
          children: [p && (c == null ? void 0 : c.desktop) && h({
            href: p,
            target: "_self",
            className: ve(ni.imageContainer, ni.imageContainerDesktop, e == null ? void 0 : e.logo)
          }, {
            ...c.desktop,
            className: ve(ni.image, c.desktop.className),
            width: c.desktop.width,
            height: c.desktop.height,
            src: c.desktop.src,
            alt: c.desktop.alt
          }), !p && (c == null ? void 0 : c.desktop) && /* @__PURE__ */B.jsx("div", {
            className: ve(ni.imageContainer, ni.imageContainerDesktop, e == null ? void 0 : e.logo),
            children: /* @__PURE__ */B.jsx("img", {
              className: ve(ni.image, c.desktop.className),
              src: c.desktop.src,
              alt: c.desktop.alt,
              width: c.desktop.width,
              height: c.desktop.height
            })
          }), p && (c == null ? void 0 : c.mobile) && h({
            href: p,
            target: "_self",
            className: ve(ni.imageContainer, ni.imageContainerMobile, e == null ? void 0 : e.logoMobile)
          }, {
            ...c.mobile,
            className: ve(ni.image, ni.imageContainerMobileImage, c.mobile.className),
            width: c.mobile.width,
            height: c.mobile.height,
            src: c.mobile.src,
            alt: c.mobile.alt
          }), !p && (c == null ? void 0 : c.mobile) && /* @__PURE__ */B.jsx("div", {
            className: ve(ni.imageContainer, ni.imageContainerMobile, e == null ? void 0 : e.logoMobile),
            children: /* @__PURE__ */B.jsx("img", {
              className: ve(ni.image, ni.imageContainerMobileImage, c.mobile.className),
              src: c.mobile.src,
              alt: c.mobile.alt,
              width: c.mobile.width,
              height: c.mobile.height
            })
          }), /* @__PURE__ */B.jsx("nav", {
            className: ni.nav,
            children: !s && /* @__PURE__ */B.jsxs(B.Fragment, {
              children: [/* @__PURE__ */B.jsx(I8, {
                links: E,
                renderLinks: C,
                classNames: {
                  ul: ni.ul,
                  li: ni.li,
                  linkText: ni.navLinkText,
                  icon: ni.header__nav__link__icon,
                  renderLink: G => ve(ni.navLink, {
                    [ni.active]: D(G.href)
                  })
                }
              }), k && /* @__PURE__ */B.jsx("div", {
                className: ni.menu,
                children: /* @__PURE__ */B.jsx(Xpe, {
                  labels: V,
                  locale: w,
                  altLangPages: x,
                  defaultErrorMessage: F,
                  renderLanguageToggle: y,
                  renderLinks: C,
                  mainLinks: E,
                  menuLinks: k,
                  menuButtonProps: {
                    className: ni.menuButton,
                    children: /* @__PURE__ */B.jsx(ln, {
                      className: ni.menuIcon,
                      name: "menu"
                    })
                  },
                  currentGateway: I,
                  handleChangeGateway: L,
                  handleHotelSearch: P,
                  disableHotelSearch: N,
                  gatewayConfig: O,
                  className: e == null ? void 0 : e.menuContainer
                })
              })]
            })
          })]
        })
      }), K.get("widget", G => /* @__PURE__ */B.jsx(B.Fragment, {
        children: G
      }))]
    });
  },
  Kpe = "_container_jq81d_1",
  Qpe = "_currentLanguageLabel_jq81d_9",
  Zpe = "_currentLanguage_jq81d_9",
  Jpe = "_dropDown_jq81d_20",
  ehe = "_footerChevron_jq81d_44",
  the = "_footerLangIcon_jq81d_62",
  lb = {
    container: Kpe,
    currentLanguageLabel: Qpe,
    currentLanguage: Zpe,
    dropDown: Jpe,
    footerChevron: ehe,
    footerLangIcon: the
  },
  Q_e = ({
    altLangPages: t,
    classNames: e,
    locale: i = "en-CA",
    renderLanguageSwitcher: s,
    variant: c = "toggle",
    navigationSwitcher: p,
    select: h = {
      label: "Language preference"
    }
  }) => {
    var k;
    const y = ((k = i == null ? void 0 : i.toLowerCase()) == null ? void 0 : k.substring(0, 2)) || "en",
      [w, x] = rt(y);
    let E = null;
    const C = D => (D == null ? void 0 : D.toLowerCase()) === "fr" ? "Français" : "English";
    if (c === "drop-down") {
      const D = I => {
        const {
          path: L
        } = I.target.options[I.target.selectedIndex].dataset;
        x(I.target.value), p(L, I.target.value);
      };
      E = /* @__PURE__ */B.jsxs(B.Fragment, {
        children: [/* @__PURE__ */B.jsx("label", {
          htmlFor: h.id,
          className: lb.currentLanguageLabel,
          children: h.label
        }), /* @__PURE__ */B.jsx("select", {
          className: ve(lb.currentLanguage, lb.dropDown, e == null ? void 0 : e.currentLanguage),
          onChange: D,
          id: h.id,
          value: w,
          children: t == null ? void 0 : t.map(({
            id: I,
            path: L,
            lang: P
          }) => {
            const N = P === w;
            return /* @__PURE__ */B.jsx("option", {
              "data-path": L,
              value: P,
              selected: N,
              children: C(P)
            }, I);
          })
        }), /* @__PURE__ */B.jsx(ln, {
          name: "globe",
          className: ve(lb.footerLangIcon, lb.dropDown, e == null ? void 0 : e.iconGlobe)
        }), /* @__PURE__ */B.jsx(ln, {
          name: "chevron-down",
          className: ve(lb.footerChevron, lb.dropDown, e == null ? void 0 : e.iconDown)
        })]
      });
    } else c === "toggle" && (E = t == null ? void 0 : t.map(({
      id: D,
      path: I,
      lang: L
    }) => {
      var N, O;
      const P = C(L);
      return ((N = i == null ? void 0 : i.toLowerCase()) == null ? void 0 : N.substring(0, 2)) === ((O = L == null ? void 0 : L.toLowerCase()) == null ? void 0 : O.substring(0, 2)) ? /* @__PURE__ */B.jsx("span", {
        "data-id": D,
        className: ve(e == null ? void 0 : e.currentLanguage, lb.currentLanguage),
        children: P
      }, D) : s ? s(D, I, L, e == null ? void 0 : e.altLanguage, P) : /* @__PURE__ */B.jsx("a", {
        className: e == null ? void 0 : e.altLanguage,
        href: I,
        children: P
      }, D);
    }));
    return /* @__PURE__ */B.jsx("div", {
      className: ve(lb.container, e == null ? void 0 : e.container),
      children: E
    });
  },
  nhe = "_listContainer_7anjf_2",
  rhe = "_groupedList_7anjf_3",
  ihe = "_subList_7anjf_4",
  ahe = "_listItems_7anjf_9",
  ohe = "_sortItems_7anjf_10",
  lhe = "_subItemUrl_7anjf_26",
  she = "_chevronList_7anjf_31",
  uhe = "_bulletList_7anjf_31",
  che = "_numberedList_7anjf_31",
  dhe = "_chevronIcon_7anjf_72",
  fhe = "_groupedHeading_7anjf_108",
  q0 = {
    listContainer: nhe,
    groupedList: rhe,
    subList: ihe,
    listItems: ahe,
    sortItems: ohe,
    subItemUrl: lhe,
    chevronList: she,
    bulletList: uhe,
    numberedList: che,
    chevronIcon: dhe,
    groupedHeading: fhe
  },
  Z_e = ({
    list: t,
    listType: e = "chevron",
    renderLink: i
  }) => {
    const s = y => y.reduce((w, x) => {
        const E = x.text[0].toUpperCase();
        return w[E] ? w[E].list.push(x) : w[E] = {
          startingLetter: E,
          list: [x]
        }, w;
      }, {}),
      c = [...t].sort((y, w) => y.text.localeCompare(w.text)),
      p = e === "groupedByLetter" ? s(c) : null,
      h = e === "numbered" ? "ol" : "ul";
    return e === "groupedByLetter" && p ? /* @__PURE__ */B.jsx("ul", {
      className: q0.groupedList,
      children: Object.values(p).map(y => /* @__PURE__ */B.jsxs("li", {
        className: q0.item,
        children: [/* @__PURE__ */B.jsx(cu, {
          Tag: "h4",
          className: q0.groupedHeading,
          children: y.startingLetter
        }), /* @__PURE__ */B.jsx("ul", {
          className: q0.subList,
          children: y.list.map((w, x) => /* @__PURE__ */B.jsx("li", {
            children: /* @__PURE__ */B.jsx(dd, {
              href: w.href,
              target: w.target,
              renderLink: i,
              size: "md",
              children: w.text
            })
          }, `${w}-${x}`))
        })]
      }, y.startingLetter))
    }) : /* @__PURE__ */B.jsx(h, {
      className: ve(q0.listContainer, {
        [q0[`${e}List`]]: !0
      }),
      children: (e === "chevron" ? t : c).map((y, w) => /* @__PURE__ */B.jsx("li", {
        className: q0.listItem,
        children: /* @__PURE__ */B.jsxs(dd, {
          href: y.href,
          target: y.target,
          renderLink: i,
          size: "md",
          children: [y.text, e === "chevron" && /* @__PURE__ */B.jsx("span", {
            className: q0.chevronIcon,
            children: /* @__PURE__ */B.jsx(ln, {
              name: "chevron-right-micro",
              size: "md"
            })
          })]
        })
      }, `${y}-${w}`))
    });
  },
  phe = "_themeTransparentWrapper_7rryr_2",
  hhe = "_inputLabel_7rryr_2",
  mhe = "_inputFocus_7rryr_5",
  vhe = "_helperText_7rryr_8",
  ghe = "_themeDefaultWrapper_7rryr_12",
  yhe = "_themeGreyWrapper_7rryr_13",
  bhe = "_inputLabelError_7rryr_20",
  whe = "_container_7rryr_25",
  _he = "_error_7rryr_29",
  xhe = "_themeDefault_7rryr_12",
  She = "_themeGrey_7rryr_13",
  Ehe = "_themeTransparent_7rryr_2",
  Che = "_input_7rryr_2",
  khe = "_border_7rryr_59",
  The = "_inputError_7rryr_62",
  Rhe = "_inputButton_7rryr_65",
  Dhe = "_iconClear_7rryr_70",
  Ihe = "_inputIcon_7rryr_73",
  Mhe = "_loading_7rryr_77",
  Lhe = "_inputButtonActive_7rryr_118",
  Ohe = "_show_7rryr_155",
  Phe = "_hide_7rryr_158",
  Ahe = "_inputLabelDisabled_7rryr_195",
  jhe = "_inputLoader_7rryr_210",
  Fhe = "_textError_7rryr_231",
  jr = {
    themeTransparentWrapper: phe,
    inputLabel: hhe,
    inputFocus: mhe,
    helperText: vhe,
    themeDefaultWrapper: ghe,
    themeGreyWrapper: yhe,
    inputLabelError: bhe,
    container: whe,
    error: _he,
    themeDefault: xhe,
    themeGrey: She,
    themeTransparent: Ehe,
    input: Che,
    border: khe,
    inputError: The,
    inputButton: Rhe,
    iconClear: Dhe,
    inputIcon: Ihe,
    loading: Mhe,
    inputButtonActive: Lhe,
    show: Ohe,
    hide: Phe,
    inputLabelDisabled: Ahe,
    inputLoader: jhe,
    textError: Fhe
  },
  Nhe = Qn(({
    id: t,
    label: e,
    name: i,
    helperText: s,
    value: c,
    errorMessage: p,
    type: h = "text",
    readOnly: y,
    required: w,
    disabled: x,
    enableClearButton: E,
    displayClearLabel: C,
    labels: k,
    theme: D = "default",
    iconOptions: I,
    maskOptions: L,
    isLoading: P,
    className: N,
    classNames: O,
    onChange: F,
    onBlur: j,
    onFocus: V,
    onKeyUp: K,
    onAccept: G,
    ...Q
  }, te) => {
    const ie = vt(null),
      Y = vt(null);
    return jR(te, () => h === "mask" ? Y.current : ie.current, []), h === "mask" ? /* @__PURE__ */B.jsx(Bq, {
      ref: Y,
      type: "text",
      id: t,
      label: e,
      name: i,
      helperText: s,
      value: c,
      errorMessage: p,
      readOnly: y,
      required: w,
      disabled: x,
      enableClearButton: E,
      displayClearLabel: C,
      labels: k,
      iconOptions: {
        clear: (I == null ? void 0 : I.clear) || /* @__PURE__ */B.jsx(ln, {
          name: "close"
        }),
        disabled: (I == null ? void 0 : I.disabled) || /* @__PURE__ */B.jsx(ln, {
          name: "nope"
        })
      },
      isLoading: P,
      loaderConfig: {
        strokeColor: D === "transparent" ? gs.color.white.value : gs.color.teal[500].value,
        trackColor: D === "transparent" ? gs.color.white.value : gs.color.gray[500].value
      },
      maskOptions: L,
      onAccept: G,
      className: ve(jr.container, jr[`theme${oE.pascal(D)}`], N),
      classNames: {
        wrapper: ve(jr[`theme${oE.pascal(D)}Wrapper`], p && jr.inputLabelError, O == null ? void 0 : O.wrapper),
        input: ve(jr.input, P && jr.loading, O == null ? void 0 : O.input),
        inputBorder: ve(jr.border, O == null ? void 0 : O.inputBorder),
        inputButton: ve(jr.inputButton, O == null ? void 0 : O.inputButton),
        inputError: ve(jr.inputError, O == null ? void 0 : O.inputError),
        inputErrorText: ve(jr.textError, O == null ? void 0 : O.inputErrorText),
        inputFocus: ve(jr.inputFocus, O == null ? void 0 : O.inputFocus),
        inputHelperText: ve(jr.helperText, O == null ? void 0 : O.inputHelperText),
        inputLabel: ve(jr.inputLabel, O == null ? void 0 : O.inputLabel),
        inputLabelDisabled: ve(jr.inputLabelDisabled, O == null ? void 0 : O.inputLabelDisabled),
        iconClear: ve(jr.iconClear, O == null ? void 0 : O.iconClear),
        iconDisable: ve(jr.inputIcon, O == null ? void 0 : O.iconDisable),
        loader: ve(jr.inputLoader, O == null ? void 0 : O.loader),
        value: O == null ? void 0 : O.value
      },
      ...Q
    }) : /* @__PURE__ */B.jsx(O5, {
      ref: ie,
      id: t,
      label: e,
      name: i,
      helperText: s,
      value: c,
      errorMessage: p,
      type: h,
      readOnly: y,
      required: w,
      disabled: x,
      enableClearButton: E,
      displayClearLabel: C,
      labels: k,
      iconOptions: {
        clear: (I == null ? void 0 : I.clear) || /* @__PURE__ */B.jsx(ln, {
          name: "close"
        }),
        disabled: (I == null ? void 0 : I.disabled) || /* @__PURE__ */B.jsx(ln, {
          name: "nope"
        })
      },
      isLoading: P,
      loaderConfig: {
        strokeColor: D === "transparent" ? gs.color.white.value : gs.color.teal[500].value,
        trackColor: D === "transparent" ? gs.color.white.value : gs.color.gray[500].value
      },
      className: ve(jr.container, jr[`theme${oE.pascal(D)}`], P && jr.loading, N),
      classNames: {
        wrapper: ve(jr[`theme${oE.pascal(D)}Wrapper`], p && jr.inputLabelError, O == null ? void 0 : O.wrapper),
        input: ve(jr.input, P && jr.loading, O == null ? void 0 : O.input),
        inputBorder: ve(jr.border, O == null ? void 0 : O.inputBorder),
        inputButton: ve(jr.inputButton, O == null ? void 0 : O.inputButton),
        inputError: ve(jr.inputError, O == null ? void 0 : O.inputError),
        inputErrorText: ve(jr.textError, O == null ? void 0 : O.inputErrorText),
        inputFocus: ve(jr.inputFocus, O == null ? void 0 : O.inputFocus),
        inputHelperText: ve(jr.helperText, O == null ? void 0 : O.inputHelperText),
        inputLabel: ve(jr.inputLabel, O == null ? void 0 : O.inputLabel),
        inputLabelDisabled: ve(jr.inputLabelDisabled, O == null ? void 0 : O.inputLabelDisabled),
        iconClear: ve(jr.iconClear, O == null ? void 0 : O.iconClear),
        iconDisable: ve(jr.inputIcon, O == null ? void 0 : O.iconDisable),
        loader: ve(jr.inputLoader, O == null ? void 0 : O.loader),
        value: O == null ? void 0 : O.value
      },
      onChange: F,
      onBlur: j,
      onFocus: V,
      onKeyUp: K,
      ...Q
    });
  }),
  zhe = "_button_f18wy_134",
  Vhe = "_bookendButton_f18wy_134",
  Bhe = "_trigger_f18wy_134",
  Uhe = "_scrollButton_f18wy_134",
  Hhe = "_tabsContainer_f18wy_140",
  $he = "_tabsWrapper_f18wy_145",
  Whe = "_tabsContentWrapper_f18wy_152",
  qhe = "_tablist_f18wy_156",
  Yhe = "_triggerText_f18wy_216",
  Ghe = "_white_f18wy_250",
  Xhe = "_grey_f18wy_254",
  Khe = "_gray_f18wy_255",
  Qhe = "_bookend_f18wy_134",
  Zhe = "_bookendContent_f18wy_270",
  Jhe = "_bookendTitle_f18wy_291",
  eme = "_bookendSubtitle_f18wy_297",
  tme = "_border_f18wy_304",
  nme = "_icon_f18wy_308",
  rme = "_asNavigation_f18wy_317",
  ys = {
    button: zhe,
    bookendButton: Vhe,
    trigger: Bhe,
    scrollButton: Uhe,
    tabsContainer: Hhe,
    tabsWrapper: $he,
    tabsContentWrapper: Whe,
    tablist: qhe,
    triggerText: Yhe,
    white: Ghe,
    grey: Xhe,
    gray: Khe,
    bookend: Qhe,
    bookendContent: Zhe,
    bookendTitle: Jhe,
    bookendSubtitle: eme,
    border: tme,
    icon: nme,
    asNavigation: rme
  },
  gF = ({
    title: t,
    subTitle: e,
    ...i
  }) => /* @__PURE__ */B.jsx(la.button, {
    className: ys.bookendButton,
    "data-state": i.disabled ? "inactive" : "active",
    ...i,
    children: /* @__PURE__ */B.jsxs(la.div, {
      className: ys.bookendContent,
      children: [/* @__PURE__ */B.jsx("span", {
        className: ys.bookendTitle,
        children: t
      }), e && /* @__PURE__ */B.jsx("span", {
        className: ys.bookendSubtitle,
        children: e
      })]
    })
  }),
  ime = ({
    backgroundColor: t = "white",
    border: e = !1,
    leftTitle: i,
    leftSubHeading: s,
    rightSubHeading: c,
    rightTitle: p,
    ...h
  }) => {
    const y = zE("Tabs", h.__scopeTabs),
      [w, x] = rt(!0),
      [E, C] = rt(!1),
      k = () => {
        const L = Array.from(document.querySelectorAll(`[id^="${y.baseId}-trigger-"]`)).map(N => ({
            value: N.id.split("-").pop(),
            disabled: N.hasAttribute("disabled")
          })),
          P = L.findIndex(N => N.value === y.value);
        return {
          tabInfo: L,
          currentIndex: P
        };
      };
    Rt(() => {
      const {
          tabInfo: I,
          currentIndex: L
        } = k(),
        P = I.slice(0, L).reverse().findIndex(O => !O.disabled);
      C(P !== -1);
      const N = I.slice(L + 1).findIndex(O => !O.disabled);
      x(N !== -1);
    }, [y.value, y.baseId]);
    const D = I => {
      if (!y.value) return;
      const {
        tabInfo: L,
        currentIndex: P
      } = k();
      if (I === "next") {
        const N = L.slice(P + 1).find(O => !O.disabled);
        N && y.onValueChange(N.value);
      } else {
        const N = L.slice(0, P).reverse().find(O => !O.disabled);
        N && y.onValueChange(N.value);
      }
    };
    return /* @__PURE__ */B.jsxs(la.div, {
      ...h,
      className: ve(ys.bookend, ys[t], e && ys.border),
      children: [/* @__PURE__ */B.jsx(gF, {
        title: i,
        subTitle: s,
        onClick: () => D("previous"),
        disabled: !E
      }), /* @__PURE__ */B.jsx(gF, {
        title: p,
        subTitle: c,
        onClick: () => D("next"),
        disabled: !w
      })]
    });
  },
  ame = ({
    backgroundColor: t = "white",
    asNav: e = !1,
    label: i,
    ...s
  }) => {
    const p = dN() === "rtl",
      h = vt(null),
      [y, w] = rt(!1),
      x = zE("TabsList", s.__scopeTabs),
      [E, C] = rt(!0),
      [k, D] = rt(!1),
      I = () => {
        const P = h.current;
        if (!P) return;
        const N = P.querySelector('[data-state="active"]');
        if (!N) return;
        const O = N.offsetLeft;
        P.scrollLeft = O - (P.clientWidth - N.offsetWidth) / 2;
      };
    Rt(() => {
      const P = h.current;
      if (!P) return;
      const N = new ResizeObserver(() => {
        const O = P.scrollWidth > P.clientWidth;
        w(O), O && I();
      });
      return N.observe(P), () => N.disconnect();
    }, []), Rt(() => {
      const P = document.querySelectorAll(`[id^="${x.baseId}-trigger-"]`),
        N = Array.from(P).map(F => F.id.split(`${x.baseId}-trigger-`).pop()).filter(Boolean),
        O = N.indexOf(x.value);
      D(O > 0), C(O < N.length - 1), requestAnimationFrame(I);
    }, [x.value, x.baseId]);
    const L = P => {
      if (!x.value) return;
      const N = document.querySelectorAll(`[id^="${x.baseId}-trigger-"]`),
        O = Array.from(N).map(K => K.id.split(`${x.baseId}-trigger-`).pop()).filter(Boolean),
        F = O.indexOf(x.value),
        j = P === "next" ? Math.min(F + 1, O.length - 1) : Math.max(F - 1, 0),
        V = O[j];
      x.onValueChange(V);
    };
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(ys.tabsWrapper, ys[t], e && ys.asNavigation),
      children: [y && /* @__PURE__ */B.jsx(la.button, {
        onClick: () => L("previous"),
        className: ys.scrollButton,
        disabled: !k,
        "data-state": k ? "active" : "inactive",
        "aria-label": p ? "Next tab" : "Previous tab",
        children: /* @__PURE__ */B.jsx(ln, {
          name: p ? "chevron-right" : "chevron-left",
          "aria-hidden": !0
        })
      }), /* @__PURE__ */B.jsx(L4, {
        ...s,
        className: ys.tablist,
        ref: h,
        "aria-label": i
      }), y && /* @__PURE__ */B.jsx(la.button, {
        onClick: () => L("next"),
        className: ys.scrollButton,
        disabled: !E,
        "data-state": E ? "active" : "inactive",
        "aria-label": p ? "Previous tab" : "Next tab",
        children: /* @__PURE__ */B.jsx(ln, {
          name: p ? "chevron-left" : "chevron-right",
          "aria-hidden": !0
        })
      })]
    });
  },
  ome = ({
    children: t,
    icon: e,
    ...i
  }) => /* @__PURE__ */B.jsxs(j4, {
    ...i,
    className: ve(ys.button, ys.trigger),
    children: [e && /* @__PURE__ */B.jsx(ln, {
      name: e,
      className: ys.icon,
      "aria-hidden": !0
    }), /* @__PURE__ */B.jsx("span", {
      className: ys.triggerText,
      children: t
    })]
  }),
  lme = ({
    __scopeTabs: t,
    disableAutoScroll: e = !1,
    scrollOffset: i = "100px",
    ...s
  }) => {
    const c = zE("TabsContent", t),
      p = vt(null),
      h = vt(!0);
    return Rt(() => {
      if (h.current) {
        h.current = !1;
        return;
      }
      !c.value || !p.current || e || (p.current.style.scrollMarginTop = i, setTimeout(() => {
        var y;
        (y = p.current) == null || y.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 100));
    }, [c.value, e, i]), /* @__PURE__ */B.jsx(A4, {
      ref: p,
      ...s
    });
  },
  mb = ({
    isSticky: t = !0,
    ...e
  }) => /* @__PURE__ */B.jsx(la.div, {
    className: ys.tabsContainer,
    "data-sticky": t,
    children: /* @__PURE__ */B.jsx(T7, {
      dir: e.dir ?? "ltr",
      children: /* @__PURE__ */B.jsx(YK, {
        ...e
      })
    })
  });
mb.List = ame;
mb.Trigger = ome;
mb.Content = lme;
mb.Bookend = ime;
mb.BookendButton = gF;
var QM = {
    exports: {}
  },
  sme = QM.exports,
  sU;
function L8() {
  return sU || (sU = 1, function (t, e) {
    (function (i, s) {
      t.exports = s();
    })(sme, function () {
      var i = 1e3,
        s = 6e4,
        c = 36e5,
        p = "millisecond",
        h = "second",
        y = "minute",
        w = "hour",
        x = "day",
        E = "week",
        C = "month",
        k = "quarter",
        D = "year",
        I = "date",
        L = "Invalid Date",
        P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        N = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        O = {
          name: "en",
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          ordinal: function (ne) {
            var le = ["th", "st", "nd", "rd"],
              ce = ne % 100;
            return "[" + ne + (le[(ce - 20) % 10] || le[ce] || le[0]) + "]";
          }
        },
        F = function (ne, le, ce) {
          var W = String(ne);
          return !W || W.length >= le ? ne : "" + Array(le + 1 - W.length).join(ce) + ne;
        },
        j = {
          s: F,
          z: function (ne) {
            var le = -ne.utcOffset(),
              ce = Math.abs(le),
              W = Math.floor(ce / 60),
              $ = ce % 60;
            return (le <= 0 ? "+" : "-") + F(W, 2, "0") + ":" + F($, 2, "0");
          },
          m: function ne(le, ce) {
            if (le.date() < ce.date()) return -ne(ce, le);
            var W = 12 * (ce.year() - le.year()) + (ce.month() - le.month()),
              $ = le.clone().add(W, C),
              de = ce - $ < 0,
              H = le.clone().add(W + (de ? -1 : 1), C);
            return +(-(W + (ce - $) / (de ? $ - H : H - $)) || 0);
          },
          a: function (ne) {
            return ne < 0 ? Math.ceil(ne) || 0 : Math.floor(ne);
          },
          p: function (ne) {
            return {
              M: C,
              y: D,
              w: E,
              d: x,
              D: I,
              h: w,
              m: y,
              s: h,
              ms: p,
              Q: k
            }[ne] || String(ne || "").toLowerCase().replace(/s$/, "");
          },
          u: function (ne) {
            return ne === void 0;
          }
        },
        V = "en",
        K = {};
      K[V] = O;
      var G = "$isDayjsObject",
        Q = function (ne) {
          return ne instanceof ee || !(!ne || !ne[G]);
        },
        te = function ne(le, ce, W) {
          var $;
          if (!le) return V;
          if (typeof le == "string") {
            var de = le.toLowerCase();
            K[de] && ($ = de), ce && (K[de] = ce, $ = de);
            var H = le.split("-");
            if (!$ && H.length > 1) return ne(H[0]);
          } else {
            var se = le.name;
            K[se] = le, $ = se;
          }
          return !W && $ && (V = $), $ || !W && V;
        },
        ie = function (ne, le) {
          if (Q(ne)) return ne.clone();
          var ce = typeof le == "object" ? le : {};
          return ce.date = ne, ce.args = arguments, new ee(ce);
        },
        Y = j;
      Y.l = te, Y.i = Q, Y.w = function (ne, le) {
        return ie(ne, {
          locale: le.$L,
          utc: le.$u,
          x: le.$x,
          $offset: le.$offset
        });
      };
      var ee = function () {
          function ne(ce) {
            this.$L = te(ce.locale, null, !0), this.parse(ce), this.$x = this.$x || ce.x || {}, this[G] = !0;
          }
          var le = ne.prototype;
          return le.parse = function (ce) {
            this.$d = function (W) {
              var $ = W.date,
                de = W.utc;
              if ($ === null) return /* @__PURE__ */new Date(NaN);
              if (Y.u($)) return /* @__PURE__ */new Date();
              if ($ instanceof Date) return new Date($);
              if (typeof $ == "string" && !/Z$/i.test($)) {
                var H = $.match(P);
                if (H) {
                  var se = H[2] - 1 || 0,
                    ue = (H[7] || "0").substring(0, 3);
                  return de ? new Date(Date.UTC(H[1], se, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, ue)) : new Date(H[1], se, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, ue);
                }
              }
              return new Date($);
            }(ce), this.init();
          }, le.init = function () {
            var ce = this.$d;
            this.$y = ce.getFullYear(), this.$M = ce.getMonth(), this.$D = ce.getDate(), this.$W = ce.getDay(), this.$H = ce.getHours(), this.$m = ce.getMinutes(), this.$s = ce.getSeconds(), this.$ms = ce.getMilliseconds();
          }, le.$utils = function () {
            return Y;
          }, le.isValid = function () {
            return this.$d.toString() !== L;
          }, le.isSame = function (ce, W) {
            var $ = ie(ce);
            return this.startOf(W) <= $ && $ <= this.endOf(W);
          }, le.isAfter = function (ce, W) {
            return ie(ce) < this.startOf(W);
          }, le.isBefore = function (ce, W) {
            return this.endOf(W) < ie(ce);
          }, le.$g = function (ce, W, $) {
            return Y.u(ce) ? this[W] : this.set($, ce);
          }, le.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }, le.valueOf = function () {
            return this.$d.getTime();
          }, le.startOf = function (ce, W) {
            var $ = this,
              de = !!Y.u(W) || W,
              H = Y.p(ce),
              se = function (Le, Be) {
                var Xe = Y.w($.$u ? Date.UTC($.$y, Be, Le) : new Date($.$y, Be, Le), $);
                return de ? Xe : Xe.endOf(x);
              },
              ue = function (Le, Be) {
                return Y.w($.toDate()[Le].apply($.toDate("s"), (de ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Be)), $);
              },
              Ee = this.$W,
              Ce = this.$M,
              fe = this.$D,
              _e = "set" + (this.$u ? "UTC" : "");
            switch (H) {
              case D:
                return de ? se(1, 0) : se(31, 11);
              case C:
                return de ? se(1, Ce) : se(0, Ce + 1);
              case E:
                var Se = this.$locale().weekStart || 0,
                  be = (Ee < Se ? Ee + 7 : Ee) - Se;
                return se(de ? fe - be : fe + (6 - be), Ce);
              case x:
              case I:
                return ue(_e + "Hours", 0);
              case w:
                return ue(_e + "Minutes", 1);
              case y:
                return ue(_e + "Seconds", 2);
              case h:
                return ue(_e + "Milliseconds", 3);
              default:
                return this.clone();
            }
          }, le.endOf = function (ce) {
            return this.startOf(ce, !1);
          }, le.$set = function (ce, W) {
            var $,
              de = Y.p(ce),
              H = "set" + (this.$u ? "UTC" : ""),
              se = ($ = {}, $[x] = H + "Date", $[I] = H + "Date", $[C] = H + "Month", $[D] = H + "FullYear", $[w] = H + "Hours", $[y] = H + "Minutes", $[h] = H + "Seconds", $[p] = H + "Milliseconds", $)[de],
              ue = de === x ? this.$D + (W - this.$W) : W;
            if (de === C || de === D) {
              var Ee = this.clone().set(I, 1);
              Ee.$d[se](ue), Ee.init(), this.$d = Ee.set(I, Math.min(this.$D, Ee.daysInMonth())).$d;
            } else se && this.$d[se](ue);
            return this.init(), this;
          }, le.set = function (ce, W) {
            return this.clone().$set(ce, W);
          }, le.get = function (ce) {
            return this[Y.p(ce)]();
          }, le.add = function (ce, W) {
            var $,
              de = this;
            ce = Number(ce);
            var H = Y.p(W),
              se = function (Ce) {
                var fe = ie(de);
                return Y.w(fe.date(fe.date() + Math.round(Ce * ce)), de);
              };
            if (H === C) return this.set(C, this.$M + ce);
            if (H === D) return this.set(D, this.$y + ce);
            if (H === x) return se(1);
            if (H === E) return se(7);
            var ue = ($ = {}, $[y] = s, $[w] = c, $[h] = i, $)[H] || 1,
              Ee = this.$d.getTime() + ce * ue;
            return Y.w(Ee, this);
          }, le.subtract = function (ce, W) {
            return this.add(-1 * ce, W);
          }, le.format = function (ce) {
            var W = this,
              $ = this.$locale();
            if (!this.isValid()) return $.invalidDate || L;
            var de = ce || "YYYY-MM-DDTHH:mm:ssZ",
              H = Y.z(this),
              se = this.$H,
              ue = this.$m,
              Ee = this.$M,
              Ce = $.weekdays,
              fe = $.months,
              _e = $.meridiem,
              Se = function (Be, Xe, ge, qe) {
                return Be && (Be[Xe] || Be(W, de)) || ge[Xe].slice(0, qe);
              },
              be = function (Be) {
                return Y.s(se % 12 || 12, Be, "0");
              },
              Le = _e || function (Be, Xe, ge) {
                var qe = Be < 12 ? "AM" : "PM";
                return ge ? qe.toLowerCase() : qe;
              };
            return de.replace(N, function (Be, Xe) {
              return Xe || function (ge) {
                switch (ge) {
                  case "YY":
                    return String(W.$y).slice(-2);
                  case "YYYY":
                    return Y.s(W.$y, 4, "0");
                  case "M":
                    return Ee + 1;
                  case "MM":
                    return Y.s(Ee + 1, 2, "0");
                  case "MMM":
                    return Se($.monthsShort, Ee, fe, 3);
                  case "MMMM":
                    return Se(fe, Ee);
                  case "D":
                    return W.$D;
                  case "DD":
                    return Y.s(W.$D, 2, "0");
                  case "d":
                    return String(W.$W);
                  case "dd":
                    return Se($.weekdaysMin, W.$W, Ce, 2);
                  case "ddd":
                    return Se($.weekdaysShort, W.$W, Ce, 3);
                  case "dddd":
                    return Ce[W.$W];
                  case "H":
                    return String(se);
                  case "HH":
                    return Y.s(se, 2, "0");
                  case "h":
                    return be(1);
                  case "hh":
                    return be(2);
                  case "a":
                    return Le(se, ue, !0);
                  case "A":
                    return Le(se, ue, !1);
                  case "m":
                    return String(ue);
                  case "mm":
                    return Y.s(ue, 2, "0");
                  case "s":
                    return String(W.$s);
                  case "ss":
                    return Y.s(W.$s, 2, "0");
                  case "SSS":
                    return Y.s(W.$ms, 3, "0");
                  case "Z":
                    return H;
                }
                return null;
              }(Be) || H.replace(":", "");
            });
          }, le.utcOffset = function () {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }, le.diff = function (ce, W, $) {
            var de,
              H = this,
              se = Y.p(W),
              ue = ie(ce),
              Ee = (ue.utcOffset() - this.utcOffset()) * s,
              Ce = this - ue,
              fe = function () {
                return Y.m(H, ue);
              };
            switch (se) {
              case D:
                de = fe() / 12;
                break;
              case C:
                de = fe();
                break;
              case k:
                de = fe() / 3;
                break;
              case E:
                de = (Ce - Ee) / 6048e5;
                break;
              case x:
                de = (Ce - Ee) / 864e5;
                break;
              case w:
                de = Ce / c;
                break;
              case y:
                de = Ce / s;
                break;
              case h:
                de = Ce / i;
                break;
              default:
                de = Ce;
            }
            return $ ? de : Y.a(de);
          }, le.daysInMonth = function () {
            return this.endOf(C).$D;
          }, le.$locale = function () {
            return K[this.$L];
          }, le.locale = function (ce, W) {
            if (!ce) return this.$L;
            var $ = this.clone(),
              de = te(ce, W, !0);
            return de && ($.$L = de), $;
          }, le.clone = function () {
            return Y.w(this.$d, this);
          }, le.toDate = function () {
            return new Date(this.valueOf());
          }, le.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }, le.toISOString = function () {
            return this.$d.toISOString();
          }, le.toString = function () {
            return this.$d.toUTCString();
          }, ne;
        }(),
        ae = ee.prototype;
      return ie.prototype = ae, [["$ms", p], ["$s", h], ["$m", y], ["$H", w], ["$W", x], ["$M", C], ["$y", D], ["$D", I]].forEach(function (ne) {
        ae[ne[1]] = function (le) {
          return this.$g(le, ne[0], ne[1]);
        };
      }), ie.extend = function (ne, le) {
        return ne.$i || (ne(le, ee, ie), ne.$i = !0), ie;
      }, ie.locale = te, ie.isDayjs = Q, ie.unix = function (ne) {
        return ie(1e3 * ne);
      }, ie.en = K[V], ie.Ls = K, ie.p = {}, ie;
    });
  }(QM)), QM.exports;
}
var ume = L8();
const OL = /* @__PURE__ */KL(ume),
  cme = "_loadMore_wh702_32",
  dme = {
    loadMore: cme
  },
  fme = {
    loadAll: "Load all",
    loadMore: "Load more"
  },
  pme = ({
    labels: t,
    numberToShow: e = 6,
    moreToShow: i = 6,
    cardsPerRow: s = 3,
    children: c
  }) => {
    const [p, h] = rt(e),
      y = {
        ...fme,
        ...t
      },
      w = Nt.Children.count(c);
    Rt(() => {
      h(e);
    }, [c, e]);
    const x = w > e && p < w,
      E = w - p <= i,
      C = () => {
        const k = Math.min(p + i, w);
        h(k);
      };
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsx(NE, {
        cols: s,
        "aria-live": "polite",
        children: Nt.Children.map(c, (k, D) => {
          if (D < p) {
            const I = typeof k == "function" ? k({
              index: D,
              totalItems: w,
              isVisible: !0
            }) : k;
            return /* @__PURE__ */B.jsx(gb, {
              children: I
            }, D);
          }
          return null;
        })
      }), x && /* @__PURE__ */B.jsx(op, {
        variant: "utility",
        className: dme.loadMore,
        icon: "double-chevron-down-micro",
        iconPlacement: "right",
        onClick: C,
        "aria-controls": "cards-grid",
        "aria-label": E ? `${y.loadAll}. Showing ${p} of ${w} items.` : `${y.loadMore}. Showing ${p} of ${w} items.`,
        children: E ? y.loadAll : y.loadMore
      })]
    });
  },
  uU = {
    localeEn: "en-CA",
    localeFr: "fr-CA"
  },
  O8 = t => t ? t === "en-CA" || t === "fr-CA" ? t : t in uU ? uU[t] : (console.warn(`Invalid locale provided: ${t}. Falling back to en-CA.`), "en-CA") : "en-CA",
  hme = t => t.reduce((e, i) => {
    const {
        Destination: {
          Name: s,
          CountryName: c
        }
      } = i,
      p = {
        label: s,
        value: s,
        countryName: c
      },
      h = e.find(y => y.title === c);
    return h ? h.items.some(y => y.value === p.value) || (h.items.push(p), h.items.sort((y, w) => (y.label || "").localeCompare(w.label || ""))) : e.push({
      title: c,
      items: [p]
    }), e;
  }, []).sort((e, i) => (e.title || "").localeCompare(i.title || "")),
  mme = (t, e, i) => {
    let s = [...e];
    const c = p => {
      const h = i.find(y => y.title === p);
      return h ? h.items : [];
    };
    if (t.isGroupTitle) {
      const p = t.title;
      if (!p) return s;
      const h = c(p);
      s.filter(w => w.countryName === p && !w.isGroupTitle).length === h.length && h.length > 0 ? (s = s.filter(w => w.countryName !== p), s = s.filter(w => !(w.isGroupTitle && (w.title === p || w.label === p)))) : (s = s.filter(w => w.countryName !== p), s = s.filter(w => !(w.isGroupTitle && (w.title === p || w.label === p))), h.length > 0 ? (s.push(...h), s.push({
        label: p,
        title: p,
        value: p,
        isGroupTitle: !0
      })) : s.push({
        label: p,
        value: p,
        countryName: p
      }));
    } else if (t.countryName) {
      e.some(w => w.value === t.value) ? s = s.filter(w => w.value !== t.value) : s.push(t);
      const h = c(t.countryName),
        y = s.filter(w => w.countryName === t.countryName && !w.isGroupTitle);
      s = s.filter(w => !(w.isGroupTitle && (w.title === t.countryName || w.label === t.countryName))), y.length === h.length && h.length > 0 && s.push({
        label: t.countryName,
        title: t.countryName,
        value: t.countryName,
        isGroupTitle: !0
      });
    }
    return s;
  },
  vme = (t, e) => [...new Set(t.filter(s => {
    var c;
    return ((c = s.AccommodationInfo) == null ? void 0 : c.StarRating) != null;
  }).map(s => Math.floor(s.AccommodationInfo.StarRating)))].sort((s, c) => c - s).map(s => ({
    id: s.toString(),
    label: e === "fr-CA" ? s === 5 ? s.toString() : `${s.toString()} et en haut` : e === "en-CA" ? s === 5 ? s.toString() : `${s.toString()} & up` : s.toString(),
    value: s
  })),
  gme = t => [{
    label: t.priceLowToHigh,
    value: "priceLowToHigh",
    id: "priceLowToHigh"
  }, {
    label: t.priceHighToLow,
    value: "priceHighToLow",
    id: "priceHighToLow"
  }, {
    label: t.starRatingLowToHigh,
    value: "starRatingLowToHigh",
    id: "starRatingLowToHigh"
  }, {
    label: t.starRatingHighToLow,
    value: "starRatingHighToLow",
    id: "starRatingHighToLow"
  }, {
    label: t.hotelAz,
    value: "hotelAz",
    id: "hotelAz"
  }, {
    label: t.hotelZa,
    value: "hotelZa",
    id: "hotelZa"
  }, {
    label: t.departureEarliest,
    value: "departureEarliest",
    id: "departureEarliest"
  }],
  yme = (t, e) => {
    if (!e || e.length === 0) return t;
    const i = e.filter(s => !s.isGroupTitle);
    return i.length === 0 ? t : t.filter(({
      Destination: {
        Name: s
      }
    }) => i.some(({
      label: c
    }) => s === c));
  },
  bme = (t, e) => e ? t.filter(({
    Price: i
  }) => i >= e[0] && i <= e[1]) : t,
  wme = (t, e) => e ? t.filter(i => i.AccommodationInfo && Math.floor(i.AccommodationInfo.StarRating) >= Number(e.value)) : t,
  _me = (t, e) => {
    switch (e) {
      case "priceHighToLow":
        return t.sort((i, s) => s.Price - i.Price);
      case "starRatingLowToHigh":
        return t.filter(i => i.AccommodationInfo).sort((i, s) => i.AccommodationInfo.StarRating - s.AccommodationInfo.StarRating);
      case "starRatingHighToLow":
        return t.filter(i => i.AccommodationInfo).sort((i, s) => s.AccommodationInfo.StarRating - i.AccommodationInfo.StarRating);
      case "hotelAz":
        return t.filter(i => i.AccommodationInfo).sort((i, s) => i.AccommodationInfo.AccommodationName.localeCompare(s.AccommodationInfo.AccommodationName));
      case "hotelZa":
        return t.filter(i => i.AccommodationInfo).sort((i, s) => s.AccommodationInfo.AccommodationName.localeCompare(i.AccommodationInfo.AccommodationName));
      case "departureEarliest":
        return t.sort((i, s) => new Date(i.DepartureDate).getTime() - new Date(s.DepartureDate).getTime());
      case "priceLowToHigh":
      default:
        return t.sort((i, s) => i.Price - s.Price);
    }
  },
  P8 = t => {
    if (t) return [...t].sort((e, i) => e.Price - i.Price);
  };
var ZM = {
    exports: {}
  },
  xme = ZM.exports,
  cU;
function Sme() {
  return cU || (cU = 1, function (t, e) {
    (function (i, s) {
      t.exports = s(L8());
    })(xme, function (i) {
      function s(h) {
        return h && typeof h == "object" && "default" in h ? h : {
          default: h
        };
      }
      var c = s(i),
        p = {
          name: "fr",
          weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
          weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
          weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
          months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
          monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
          weekStart: 1,
          yearStart: 4,
          formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
          },
          relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
          },
          ordinal: function (h) {
            return "" + h + (h === 1 ? "er" : "");
          }
        };
      return c.default.locale(p, null, !0), p;
    });
  }(ZM)), ZM.exports;
}
Sme();
const Eme = t => {
    var h, y, w, x;
    const [e, i] = rt(t),
      [s, c] = rt(!1);
    let p = 0;
    return Rt(() => {
      var k, D, I, L, P, N, O, F;
      const E = {
          destinations: (e == null ? void 0 : e.destinationSelections.map(j => ({
            title: j.title,
            value: j.value,
            countryName: j.countryName
          }))) || [],
          priceValue: (e == null ? void 0 : e.priceValue) || null,
          starRating: {
            id: (k = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : k.id,
            value: (D = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : D.value
          },
          sortingOption: {
            id: (I = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : I.id,
            value: (L = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : L.value
          }
        },
        C = {
          destinations: (t == null ? void 0 : t.destinationSelections.map(j => ({
            title: j.title,
            value: j.value,
            countryName: j.countryName
          }))) || [],
          priceValue: (t == null ? void 0 : t.priceValue) || null,
          starRating: {
            id: (P = t == null ? void 0 : t.starRatingSelection) == null ? void 0 : P.id,
            value: (N = t == null ? void 0 : t.starRatingSelection) == null ? void 0 : N.value
          },
          sortingOption: {
            id: (O = t == null ? void 0 : t.sortingOptionSelection) == null ? void 0 : O.id,
            value: (F = t == null ? void 0 : t.sortingOptionSelection) == null ? void 0 : F.value
          }
        };
      JSON.stringify(E) !== JSON.stringify(C) ? c(!0) : c(!1);
    }, [e, t]), t && (t.destinationSelections.length !== 0 && JSON.stringify(t.destinationSelections) !== JSON.stringify(e == null ? void 0 : e.destinationSelections) && (p += 1), JSON.stringify(t.priceValue) !== JSON.stringify(e == null ? void 0 : e.priceValue) && (p += 1), ((h = t.starRatingSelection) == null ? void 0 : h.value) !== ((y = e == null ? void 0 : e.starRatingSelection) == null ? void 0 : y.value) && (p += 1), ((w = t.sortingOptionSelection) == null ? void 0 : w.value) !== ((x = e == null ? void 0 : e.sortingOptionSelection) == null ? void 0 : x.value) && (p += 1)), {
      hasFiltersChanged: s,
      setAppliedFilters: i,
      numberOfFilters: p,
      appliedFilters: e
    };
  },
  Cme = "_groupLabel_11as3_1",
  kme = "_description_11as3_8",
  Tme = "_errorMessage_11as3_14",
  Rme = "_inline_11as3_21",
  Dme = "_fieldset_11as3_21",
  Ime = "_wrapper_11as3_21",
  Mme = "_options_11as3_26",
  Px = {
    groupLabel: Cme,
    description: kme,
    errorMessage: Tme,
    inline: Rme,
    fieldset: Dme,
    wrapper: Ime,
    options: Mme
  },
  Lme = "_theme_1onx1_1",
  Ome = "_input_1onx1_12",
  Pme = "_error_1onx1_50",
  Ame = "_disabled_1onx1_74",
  jme = "_label_1onx1_85",
  Fme = "_helperText_1onx1_92",
  Pp = {
    theme: Lme,
    input: Ome,
    error: Pme,
    disabled: Ame,
    label: jme,
    helperText: Fme
  },
  Nme = ({
    id: t,
    name: e,
    description: i,
    displayStacked: s = !1,
    options: c,
    label: p,
    hideLabel: h = !1,
    selectedOption: y,
    errorMessage: w,
    onChange: x,
    allowDeselect: E,
    className: C,
    classNames: k,
    renderLabel: D
  }) => {
    const [I, L] = rt(y),
      P = (N, O, F) => {
        L(F), x == null || x(N, O, F);
      };
    return /* @__PURE__ */B.jsx(zK, {
      id: t,
      name: e,
      description: i,
      displayStacked: s,
      options: c,
      label: p,
      hideLabel: h,
      selectedOption: I,
      onChange: P,
      allowDeselect: E,
      errorMessage: w,
      className: ve(s ? k == null ? void 0 : k.stacked : [Px.inline, k == null ? void 0 : k.inline], C),
      classNames: {
        fieldset: ve(Px.fieldset, k == null ? void 0 : k.fieldset),
        groupLabel: ve(Px.groupLabel, k == null ? void 0 : k.groupLabel),
        description: ve(Px.description, k == null ? void 0 : k.description),
        options: ve(Px.options, k == null ? void 0 : k.options),
        errorMessage: ve(Px.errorMessage, k == null ? void 0 : k.errorMessage),
        wrapper: ve(Pp.theme, Px.wrapper, k == null ? void 0 : k.wrapper),
        label: ve(Pp.label, k == null ? void 0 : k.label),
        input: ve(Pp.input, k == null ? void 0 : k.input),
        error: ve(Pp.error, k == null ? void 0 : k.error),
        disabled: ve(Pp.disabled, k == null ? void 0 : k.disabled),
        helperText: ve(Pp.helperText, k == null ? void 0 : k.helperText)
      },
      renderLabel: D
    });
  },
  s2 = Qn(({
    id: t,
    label: e,
    value: i,
    name: s,
    isSelected: c,
    isError: p,
    isRequired: h,
    isDisabled: y,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: k,
    isInteractive: D
  }, I) => /* @__PURE__ */B.jsx(k4, {
    ref: I,
    id: t,
    label: e,
    name: s,
    value: i,
    isSelected: c,
    isError: p,
    isRequired: h,
    isDisabled: y,
    helperText: w,
    selectedOption: x,
    onChange: E,
    className: C,
    classNames: {
      wrapper: ve(Pp.theme, k == null ? void 0 : k.wrapper),
      label: ve(Pp.label, k == null ? void 0 : k.label),
      input: ve(Pp.input, k == null ? void 0 : k.input),
      error: ve(Pp.error, k == null ? void 0 : k.error),
      disabled: ve(Pp.disabled, k == null ? void 0 : k.disabled),
      helperText: ve(Pp.helperText, k == null ? void 0 : k.helperText)
    },
    isInteractive: D
  })),
  zme = "_container_cx5xx_1",
  Vme = "_inputHelperText_cx5xx_7",
  Bme = "_input_cx5xx_7",
  Ume = "_inputWrapperFocus_cx5xx_20",
  Hme = "_inputWrapperOpen_cx5xx_25",
  $me = "_listBox_cx5xx_29",
  Wme = "_inputWrapperError_cx5xx_33",
  qme = "_inputLabel_cx5xx_39",
  Yme = "_inputWrapperSelected_cx5xx_39",
  Gme = "_inputErrorText_cx5xx_43",
  Xme = "_inputWrapperDisabled_cx5xx_50",
  Kme = "_value_cx5xx_90",
  Qme = "_loader_cx5xx_98",
  Zme = "_icon_cx5xx_104",
  Jme = "_iconError_cx5xx_112",
  eve = "_iconDisabled_cx5xx_116",
  tve = "_listHeading_cx5xx_132",
  nve = "_listItem_cx5xx_138",
  rve = "_itemGroup_cx5xx_144",
  ive = "_itemActive_cx5xx_149",
  ave = "_itemDisabled_cx5xx_149",
  ove = "_noResults_cx5xx_161",
  lve = "_inputLoader_cx5xx_165",
  sve = "_labelWrapper_cx5xx_169",
  uve = "_checkboxWrapper_cx5xx_174",
  cve = "_clearAllBtn_cx5xx_178",
  ra = {
    container: zme,
    inputHelperText: Vme,
    input: Bme,
    inputWrapperFocus: Ume,
    inputWrapperOpen: Hme,
    listBox: $me,
    inputWrapperError: Wme,
    inputLabel: qme,
    inputWrapperSelected: Yme,
    inputErrorText: Gme,
    inputWrapperDisabled: Xme,
    value: Kme,
    loader: Qme,
    icon: Zme,
    iconError: Jme,
    iconDisabled: eve,
    listHeading: tve,
    listItem: nve,
    itemGroup: rve,
    itemActive: ive,
    itemDisabled: ave,
    noResults: ove,
    inputLoader: lve,
    labelWrapper: sve,
    checkboxWrapper: uve,
    clearAllBtn: cve
  },
  dve = ({
    id: t,
    data: e,
    isDisabled: i,
    errorMessage: s,
    initialSelectedItem: c,
    selectedItem: p,
    iconOptions: h,
    isAutoCloseMenu: y,
    environment: w,
    className: x,
    classNames: E,
    onFocus: C,
    onBlur: k,
    onSelectChange: D,
    onOpenDropdown: I,
    label: L,
    labels: P,
    helperText: N,
    values: O,
    onReset: F,
    clearAllOption: j,
    handleClearAll: V,
    resetTrigger: K,
    isLoading: G,
    children: Q
  }) => /* @__PURE__ */B.jsx(sY, {
    id: t,
    label: L,
    data: e,
    isDisabled: i,
    errorMessage: s,
    initialSelectedItem: c,
    selectedItem: p,
    iconOptions: {
      open: (h == null ? void 0 : h.open) || /* @__PURE__ */B.jsx(ln, {
        name: "chevron-up"
      }),
      close: (h == null ? void 0 : h.close) || /* @__PURE__ */B.jsx(ln, {
        name: "chevron-down"
      }),
      disabled: (h == null ? void 0 : h.disabled) || /* @__PURE__ */B.jsx(ln, {
        name: "nope"
      })
    },
    isAutoCloseMenu: y,
    environment: w,
    className: ve(ra.container, x),
    classNames: {
      icon: ve(ra.icon, E == null ? void 0 : E.icon),
      iconDisabled: ve(ra.iconDisabled, E == null ? void 0 : E.iconDisabled),
      iconError: ve(ra.iconError, E == null ? void 0 : E.iconError),
      inputToggleButton: ve(ra.input, E == null ? void 0 : E.inputToggleButton),
      inputWrapperFocus: ve(ra.inputWrapperFocus, E == null ? void 0 : E.inputWrapperFocus),
      inputWrapperOpen: ve(ra.inputWrapperOpen, E == null ? void 0 : E.inputWrapperOpen),
      inputWrapperSelected: ve(ra.inputWrapperSelected, E == null ? void 0 : E.inputWrapperSelected),
      inputWrapperError: ve(ra.inputWrapperError, E == null ? void 0 : E.inputWrapperError),
      inputWrapperDisabled: ve(ra.inputWrapperDisabled, E == null ? void 0 : E.inputWrapperDisabled),
      inputLabel: ve(ra.inputLabel, E == null ? void 0 : E.inputLabel),
      inputLoader: ve(ra.inputLoader, E == null ? void 0 : E.inputLoader),
      inputErrorText: ve(ra.inputErrorText, E == null ? void 0 : E.inputErrorText),
      inputHelperText: ve(ra.inputHelperText, E == null ? void 0 : E.inputHelperText),
      value: ve(ra.value, E == null ? void 0 : E.value),
      loader: ve(ra.loader, E == null ? void 0 : E.loader),
      listBox: ve(ra.listBox, E == null ? void 0 : E.listBox),
      listHeading: ve(ra.listHeading, E == null ? void 0 : E.listHeading),
      listItem: ve(ra.listItem, E == null ? void 0 : E.listItem),
      itemActive: ve(ra.itemActive, E == null ? void 0 : E.itemActive),
      itemDisabled: ve(ra.itemDisabled, E == null ? void 0 : E.itemDisabled),
      itemGroup: ve(ra.itemGroup, E == null ? void 0 : E.itemGroup),
      itemSelected: E == null ? void 0 : E.itemSelected,
      clearAllBtn: ve(ra.clearAllBtn, E == null ? void 0 : E.clearAllBtn),
      noResults: ve(ra.noResults, E == null ? void 0 : E.noResults)
    },
    onFocus: C,
    onBlur: k,
    onOpenDropdown: I,
    onSelectChange: D,
    labels: P,
    helperText: N,
    values: O,
    handleClearAll: V,
    resetTrigger: K,
    onReset: F,
    clearAllOption: j,
    isLoading: G,
    loaderConfig: {
      strokeColor: gs.color.teal[500].value,
      trackColor: gs.color.gray[500].value
    },
    renderCustomListItem: (te, ie, Y, ee) => {
      const ae = ee["aria-selected"] === !0;
      return /* @__PURE__ */B.jsx("li", {
        ...Y(ee),
        children: /* @__PURE__ */B.jsx(H2, {
          id: `${te}-checkbox`,
          className: ve(ra.checkboxWrapper),
          classNames: {
            labelWrapper: ra.labelWrapper,
            wrapper: ra.innerCheckboxWrapper
          },
          onChange: () => D && D(ie),
          isDisabled: !1,
          isSelected: ae,
          label: ie.label
        })
      }, te);
    },
    children: Q
  }),
  fve = "_container_15kve_1",
  pve = "_popover_15kve_7",
  hve = "_inputWrapperOpen_15kve_13",
  mve = "_popoverContainer_15kve_17",
  vve = "_inputContainer_15kve_63",
  gve = "_icon_15kve_70",
  yve = "_inputWrapperFocus_15kve_79",
  bve = "_inputWrapperError_15kve_89",
  wve = "_inputLabel_15kve_95",
  _ve = "_inputWrapperSelected_15kve_95",
  xve = "_inputWrapperDisabled_15kve_99",
  Sve = "_inputHelperText_15kve_106",
  Eve = "_input_15kve_13",
  Cve = "_inputErrorText_15kve_151",
  kve = "_value_15kve_158",
  Tve = "_loader_15kve_166",
  Rve = "_iconError_15kve_180",
  Dve = "_iconDisabled_15kve_184",
  rl = {
    container: fve,
    popover: pve,
    inputWrapperOpen: hve,
    popoverContainer: mve,
    inputContainer: vve,
    icon: gve,
    inputWrapperFocus: yve,
    inputWrapperError: bve,
    inputLabel: wve,
    inputWrapperSelected: _ve,
    inputWrapperDisabled: xve,
    inputHelperText: Sve,
    input: Eve,
    inputErrorText: Cve,
    value: kve,
    loader: Tve,
    iconError: Rve,
    iconDisabled: Dve
  },
  Ive = ({
    className: t,
    classNames: e,
    id: i,
    readOnly: s,
    iconOptions: c,
    value: p,
    children: h,
    onChange: y,
    onClose: w,
    defaultCloseIcon: x,
    ...E
  }) => /* @__PURE__ */B.jsx(CK, {
    ...E,
    className: ve(rl.container, t),
    classNames: {
      icon: ve(rl.icon, e == null ? void 0 : e.icon),
      iconDisabled: ve(rl.iconDisabled, e == null ? void 0 : e.iconDisabled),
      iconError: ve(rl.iconError, e == null ? void 0 : e.iconError),
      inputContainer: ve(rl.inputContainer, e == null ? void 0 : e.inputContainer),
      inputToggleButton: ve(rl.input, e == null ? void 0 : e.inputToggleButton),
      inputWrapperFocus: ve(rl.inputWrapperFocus, e == null ? void 0 : e.inputWrapperFocus),
      inputWrapperOpen: ve(rl.inputWrapperOpen, e == null ? void 0 : e.inputWrapperOpen),
      inputWrapperSelected: ve(rl.inputWrapperSelected, e == null ? void 0 : e.inputWrapperSelected),
      inputWrapperError: ve(rl.inputWrapperError, e == null ? void 0 : e.inputWrapperError),
      inputWrapperDisabled: ve(rl.inputWrapperDisabled, e == null ? void 0 : e.inputWrapperDisabled),
      inputLabel: ve(rl.inputLabel, e == null ? void 0 : e.inputLabel),
      inputLoader: ve(rl.inputLoader, e == null ? void 0 : e.inputLoader),
      inputErrorText: ve(rl.inputErrorText, e == null ? void 0 : e.inputErrorText),
      inputHelperText: ve(rl.inputHelperText, e == null ? void 0 : e.inputHelperText),
      value: ve(rl.value, e == null ? void 0 : e.value),
      loader: ve(rl.loader, e == null ? void 0 : e.loader),
      popover: ve(rl.popover, e == null ? void 0 : e.popover),
      popoverContainer: ve(rl.popoverContainer, e == null ? void 0 : e.popoverContainer),
      popoverContainerOpen: ve(rl.popoverContainerOpen, e == null ? void 0 : e.popoverContainerOpen),
      closeButton: ve(rl.closeButton, e == null ? void 0 : e.closeButton),
      ...e
    },
    id: i,
    readOnly: s,
    iconOptions: {
      open: (c == null ? void 0 : c.open) ?? /* @__PURE__ */B.jsx(ln, {
        name: "chevron-up"
      }),
      close: (c == null ? void 0 : c.close) ?? /* @__PURE__ */B.jsx(ln, {
        name: "chevron-down"
      }),
      disabled: (c == null ? void 0 : c.disabled) ?? /* @__PURE__ */B.jsx(ln, {
        name: "nope"
      })
    },
    value: p,
    children: h,
    onChange: y,
    onClose: w,
    defaultCloseIcon: x
  }),
  Mve = "_range_1hjp6_2",
  Lve = "_rangeText_1hjp6_10",
  Ove = "_rangeValue_1hjp6_13",
  kT = {
    range: Mve,
    rangeText: Lve,
    rangeValue: Ove
  },
  dU = ({
    id: t,
    className: e,
    classNames: i,
    ranges: s,
    locale: c,
    rangeText: p,
    onHandleRangeChange: h,
    value: y,
    initialValue: w
  }) => {
    const [x, E] = rt(w || [s ? s[0] : 0, s ? s[1] : 1e4]),
      C = k => {
        E(k);
        const [D, I] = k,
          L = s ? s[0] : 0,
          P = s ? s[1] : 1e4;
        return h(D, I, L, P, y);
      };
    return /* @__PURE__ */B.jsx(xG, {
      className: ve(kT.range, e),
      classNames: {
        rangeText: ve(kT.rangeText, i == null ? void 0 : i.rangeText),
        rangeValue: ve(kT.rangeValue, i == null ? void 0 : i.rangeValue),
        thumbClassName: ve(kT.thumbClassName, i == null ? void 0 : i.thumbClassName),
        trackClassName: ve(kT.trackClassName, i == null ? void 0 : i.trackClassName)
      },
      id: t,
      ranges: s,
      locale: c,
      rangeText: p,
      value: x,
      onHandleRangeChange: C
    });
  },
  Pve = "_filters_l6jdz_2",
  Ave = "_priceRange_l6jdz_34",
  jve = "_priceRangeInner_l6jdz_38",
  Fve = "_priceRangeText_l6jdz_42",
  Nve = "_filtersDropdownWrapper_l6jdz_48",
  zve = "_radioItem_l6jdz_55",
  Vve = "_radioButton_l6jdz_62",
  Bve = "_reset_l6jdz_66",
  Uve = "_starContainer_l6jdz_90",
  Hve = "_applyButton_l6jdz_98",
  $ve = "_mobileFilters_l6jdz_102",
  Wve = "_mobileFiltersWrapperInner_l6jdz_106",
  qve = "_button_l6jdz_114",
  Yve = "_buttonText_l6jdz_129",
  Gve = "_mobileFiltersWrapper_l6jdz_106",
  Xve = "_gatewayDropdown_l6jdz_142",
  Kve = "_filtersMenu_l6jdz_188",
  Qve = "_header_l6jdz_197",
  Zve = "_closeButton_l6jdz_215",
  Jve = "_inputWrapperOpen_l6jdz_241",
  ege = "_inputBorder_l6jdz_241",
  tge = "_filtersSortDropdownList_l6jdz_244",
  nge = "_inputToggleButton_l6jdz_254",
  rge = "_destinations_l6jdz_261",
  ige = "_country_l6jdz_275",
  age = "_clear_l6jdz_278",
  oge = "_rangeInput_l6jdz_304",
  lge = "_starRating_l6jdz_93",
  sge = "_formControl_l6jdz_321",
  uge = "_formControlInner_l6jdz_333",
  cge = "_apply_l6jdz_98",
  An = {
    filters: Pve,
    priceRange: Ave,
    priceRangeInner: jve,
    priceRangeText: Fve,
    filtersDropdownWrapper: Nve,
    radioItem: zve,
    radioButton: Vve,
    reset: Bve,
    starContainer: Uve,
    applyButton: Hve,
    mobileFilters: $ve,
    mobileFiltersWrapperInner: Wve,
    button: qve,
    buttonText: Yve,
    mobileFiltersWrapper: Gve,
    gatewayDropdown: Xve,
    filtersMenu: Kve,
    header: Qve,
    closeButton: Zve,
    inputWrapperOpen: Jve,
    inputBorder: ege,
    filtersSortDropdownList: tge,
    inputToggleButton: nge,
    destinations: rge,
    country: ige,
    clear: age,
    rangeInput: oge,
    starRating: lge,
    formControl: sge,
    formControlInner: uge,
    apply: cge
  },
  dge = ({
    id: t,
    offers: e,
    locale: i,
    setMatchingOffers: s,
    isMobile: c = !1,
    labels: p = {}
  }) => {
    const [h, y] = rt([]),
      [w, x] = rt(null),
      [E, C] = rt(null),
      [k, D] = rt(!1),
      [I, L] = rt(!1),
      [P, N] = rt(!1),
      [O, F] = rt(!1),
      [j, V] = rt(0),
      K = vt(null),
      G = vt(null),
      Q = Nt.useMemo(() => hme(e), [e]),
      te = (p == null ? void 0 : p.destinations) || "Destinations",
      ie = pn(ge => {
        y(mme(ge, h, Q));
      }, [h, Q]),
      Y = pn(() => {
        y([]);
      }, []),
      ee = Nt.useMemo(() => e.map(ge => ge.Price).sort((ge, qe) => ge - qe), [e]),
      ae = Nt.useMemo(() => [ee[0], ee[ee.length - 1]], [ee]),
      ne = pn((ge, qe) => {
        const Ae = [ge, qe];
        return JSON.stringify(Ae) === JSON.stringify(ae) ? (x(null), null) : (x(Ae), Ae);
      }, [ae]),
      le = pn(() => {
        x(null), C(null);
      }, []),
      ce = Nt.useMemo(() => vme(e, i), [e, i]),
      [W, $] = rt(ce[ce.length - 1]),
      de = Nt.useMemo(() => ({
        priceLowToHigh: (p == null ? void 0 : p.priceLowToHigh) || "Price low to high",
        priceHighToLow: (p == null ? void 0 : p.priceHighToLow) || "Price high to low",
        starRatingLowToHigh: (p == null ? void 0 : p.starRatingLowToHigh) || "Star rating low to high",
        starRatingHighToLow: (p == null ? void 0 : p.starRatingHighToLow) || "Star rating high to low",
        hotelAz: (p == null ? void 0 : p.hotelNameAToZ) || "Hotel name a to z",
        hotelZa: (p == null ? void 0 : p.hotelNameZToA) || "Hotel name z to a",
        departureEarliest: (p == null ? void 0 : p.departureDateEarliest) || "Departure date earliest available"
      }), [p]),
      H = Nt.useMemo(() => gme(de), [de]),
      [se, ue] = rt(H[0]),
      Ee = ge => {
        ge !== W && $(ge);
      },
      {
        hasFiltersChanged: Ce,
        setAppliedFilters: fe,
        numberOfFilters: _e
      } = Eme({
        destinationSelections: h,
        starRatingSelection: W,
        priceValue: w,
        sortingOptionSelection: se
      }),
      Se = (ge, qe) => {
        var Mt;
        let Ae = ge ? [...ge] : [];
        Ae = yme(Ae, qe.destinationSelections), Ae = bme(Ae, qe.priceValue), Ae = wme(Ae, qe.starRatingSelection), Ae = _me(Ae, ((Mt = qe.sortingOptionSelection) == null ? void 0 : Mt.id) || "priceLowToHigh"), s(Ae), C(qe.priceValue), D(!0), se.id !== H[0].id ? L(!0) : L(!1), W.id !== ce[ce.length - 1].id ? N(!0) : N(!1);
      },
      be = ge => {
        x(null), $((ce == null ? void 0 : ce[(ce == null ? void 0 : ce.length) - 1]) || {
          id: "",
          value: 0,
          label: ""
        }), N(!1), ue(H[0]), L(!1), V(qe => qe + 1), y([]), s(P8(ge) || []), D(!1), C(null);
      },
      Le = pn(() => {
        F(!1), G.current && G.current.close(), K.current && setTimeout(() => {
          var ge;
          (ge = K.current) == null || ge.focus();
        }, 0);
      }, []),
      Be = () => {
        O ? Le() : (F(!0), G.current && G.current.showModal());
      },
      Xe = ge => {
        ge.target === ge.currentTarget && Le();
      };
    return Rt(() => {
      E && x(E);
    }, [E]), Rt(() => {
      c || F(!1);
    }, [c]), c ? /* @__PURE__ */B.jsxs("div", {
      className: An.mobileFilters,
      children: [/* @__PURE__ */B.jsx("div", {
        className: An.mobileFiltersWrapper,
        children: /* @__PURE__ */B.jsx("div", {
          className: An.mobileFiltersWrapperInner,
          children: e.length > 6 && /* @__PURE__ */B.jsxs(op, {
            variant: "utility",
            className: An.button,
            onClick: Be,
            "aria-label": p == null ? void 0 : p.openMenu,
            "aria-expanded": O,
            "aria-controls": "main-menu-nav",
            ref: K,
            children: [/* @__PURE__ */B.jsx("span", {
              className: An.buttonText,
              children: p == null ? void 0 : p.sortAndFilter
            }), /* @__PURE__ */B.jsx(ln, {
              name: "filter"
            })]
          })
        })
      }), e.length > 6 && /* @__PURE__ */B.jsx("dialog", {
        "aria-label": "filters",
        className: An.filters,
        ref: G,
        onClick: Xe,
        onClose: Xe,
        children: O && /* @__PURE__ */B.jsxs("div", {
          className: An.filtersMenu,
          children: [/* @__PURE__ */B.jsxs("div", {
            className: An.header,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h4",
              color: "rock",
              children: p == null ? void 0 : p.sortAndFilter
            }), /* @__PURE__ */B.jsx("button", {
              className: An.closeButton,
              type: "button",
              "aria-label": "close",
              onClick: Le,
              children: /* @__PURE__ */B.jsx(ln, {
                name: "close"
              })
            })]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.filtersDropdownWrapper,
            children: /* @__PURE__ */B.jsx(qT, {
              id: `sortingFilter-${t}`,
              classNames: {
                listBox: An.filtersSortDropdownList,
                inputWrapperOpen: An.inputWrapperOpen,
                inputToggleButton: An.inputToggleButton,
                inputBorder: An.inputBorder
              },
              label: p.sortBy,
              renderCustomLabel: (ge, qe) => se.id === H[0].id && !I ? `${qe}: ${ge == null ? void 0 : ge.label}` : qe,
              initialSelectedItem: H[0],
              hideDisplayValue: se.id === H[0].id && !I,
              selectedItem: se ?? H[0],
              onChange: ge => {
                if (!ge) return;
                const qe = ge;
                qe !== se && ue(qe);
              },
              data: [{
                items: H
              }],
              renderCustomListItem: (ge, qe, Ae, Mt, Ft) => Ae ? /* @__PURE__ */B.jsxs("li", {
                ...Mt(Ft),
                className: ve(An.radioItem, Ft.className),
                children: [/* @__PURE__ */B.jsx(s2, {
                  id: `${ge}-radio`,
                  name: "radio-dropdown",
                  value: Ae.value !== void 0 ? Ae.value : 0,
                  isSelected: (se == null ? void 0 : se.id) === Ae.id,
                  selectedOption: se ? {
                    id: se.id,
                    value: se.value,
                    label: se.label
                  } : void 0,
                  classNames: {
                    wrapper: An.radioButton
                  },
                  isInteractive: !1
                }, `${ge}-radio`), Ae.label]
              }, ge) : null
            }, `sortingFilter-mobile-${j}`)
          }), /* @__PURE__ */B.jsxs("div", {
            className: An.destinations,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h3",
              className: An.destinationsTitle,
              children: te
            }), Q.map((ge, qe) => /* @__PURE__ */B.jsxs("div", {
              children: [/* @__PURE__ */B.jsx(H2, {
                id: ge.title || `mobile-destination-title-${qe}`,
                name: "mobile-destination",
                className: An.country,
                classNames: {
                  labelWrapper: An.labelWrapper,
                  wrapper: An.innerCheckboxWrapper
                },
                onChange: () => ie({
                  label: ge.title,
                  title: ge.title,
                  value: ge.title || "",
                  isGroupTitle: !0
                }),
                isDisabled: !1,
                isSelected: h.some(Ae => (Ae == null ? void 0 : Ae.value) === ge.title),
                label: ge.title
              }, `country-${ge.title}`), ge.items.map(Ae => {
                if ((Ae == null ? void 0 : Ae.label) !== (Ae == null ? void 0 : Ae.countryName)) return /* @__PURE__ */B.jsx(H2, {
                  id: Ae.label || "mobile-destination-label",
                  className: An.checkboxWrapper,
                  classNames: {
                    labelWrapper: An.labelWrapper,
                    wrapper: An.innerCheckboxWrapper
                  },
                  onChange: () => ie(Ae),
                  isDisabled: !1,
                  isSelected: h.some(Mt => Mt.value === Ae.value),
                  label: Ae.label
                }, `destination-${Ae.value}`);
              })]
            }, ge.title || qe)), /* @__PURE__ */B.jsx("button", {
              type: "button",
              className: An.clear,
              onClick: () => y([]),
              children: p == null ? void 0 : p.clearAll
            })]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.priceRange,
            children: /* @__PURE__ */B.jsxs("div", {
              className: An.priceRangeInner,
              children: [/* @__PURE__ */B.jsxs("div", {
                "aria-describedby": "priceRange",
                className: An.priceRangeText,
                children: [p == null ? void 0 : p.pricePerPerson, " ", i === "fr-CA" ? /* @__PURE__ */B.jsx(aE, {
                  number: "CA",
                  locale: i
                }) : /* @__PURE__ */B.jsx(aE, {
                  number: "CAD",
                  locale: i
                })]
              }), /* @__PURE__ */B.jsx("div", {
                children: /* @__PURE__ */B.jsx(dU, {
                  className: An.rangeInput,
                  id: `priceRangeInput-${t}`,
                  ranges: ae,
                  rangeText: "",
                  locale: i,
                  value: w || ae,
                  initialValue: w || void 0,
                  onHandleRangeChange: ne
                }, `priceRange-mobile-${j}`)
              })]
            })
          }), /* @__PURE__ */B.jsxs("div", {
            className: An.starRating,
            children: [/* @__PURE__ */B.jsx(cu, {
              Tag: "h3",
              className: An.starRatingTitle,
              children: p == null ? void 0 : p.starRating
            }), /* @__PURE__ */B.jsx(Nme, {
              id: `${t}-star-rating-mobile`,
              className: An.starRatingRadioButton,
              name: `${t}-star-rating-mobile`,
              label: (p == null ? void 0 : p.starRating) || "Star Rating",
              hideLabel: !0,
              renderLabel: ge => /* @__PURE__ */B.jsx(wL, {
                rating: ge.value,
                ratingText: ge == null ? void 0 : ge.label,
                classNames: {
                  container: An.starContainer
                }
              }, `star-rating-${ge.value}-rating`),
              options: ce.map(ge => ({
                label: ge.label,
                value: ge.value,
                id: ge.id
              })),
              selectedOption: W,
              onChange: (ge, qe, Ae) => {
                Ee(Ae);
              },
              allowDeselect: !1,
              classNames: {
                wrapper: An.radioButton
              }
            }, `star-rating-mobile-${j}`)]
          }), /* @__PURE__ */B.jsx("div", {
            className: An.formControl,
            children: /* @__PURE__ */B.jsxs("div", {
              className: An.formControlInner,
              children: [/* @__PURE__ */B.jsx(op, {
                variant: "action",
                className: An.apply,
                onClick: () => {
                  fe({
                    destinationSelections: h,
                    starRatingSelection: W,
                    priceValue: w,
                    sortingOptionSelection: se
                  }), Se(e, {
                    destinationSelections: h,
                    starRatingSelection: W,
                    priceValue: w,
                    sortingOptionSelection: se
                  }), Le();
                },
                disabled: !Ce,
                children: `${p == null ? void 0 : p.apply} ${_e > 0 ? `(${_e})` : ""}`
              }), /* @__PURE__ */B.jsx(op, {
                variant: "noStyle",
                onClick: () => {
                  fe({
                    destinationSelections: [],
                    starRatingSelection: ce == null ? void 0 : ce[(ce == null ? void 0 : ce.length) - 1],
                    priceValue: null,
                    sortingOptionSelection: H[0]
                  }), be(e), le();
                },
                className: An.reset,
                disabled: !k,
                children: p == null ? void 0 : p.reset
              })]
            })
          })]
        })
      })]
    }) : /* @__PURE__ */B.jsxs("div", {
      className: An.filters,
      children: [/* @__PURE__ */B.jsx(dve, {
        id: `destinations-${t}`,
        label: (p == null ? void 0 : p.destinations) || "Destinations",
        labels: p,
        data: Q,
        values: h,
        onSelectChange: ie,
        handleClearAll: Y,
        resetTrigger: j
      }), /* @__PURE__ */B.jsx(Ive, {
        defaultCloseIcon: !1,
        value: w !== null ? i === "fr-CA" ? `${w[0]} $ - ${w[1]} $` : `$${w[0]} - $${w[1]}` : "",
        label: (p == null ? void 0 : p.priceRange) || "Price Range",
        id: `priceRange-${t}`,
        className: w !== null ? An.priceRangeActive : An.priceRange,
        onChange: ge => {
          const qe = ge.split(",").map(Number);
          x(qe);
        },
        children: /* @__PURE__ */B.jsxs("div", {
          className: An.priceRangeInner,
          children: [/* @__PURE__ */B.jsxs("div", {
            "aria-describedby": "priceRange",
            className: An.priceRangeText,
            children: [p == null ? void 0 : p.pricePerPerson, " ", i === "fr-CA" ? /* @__PURE__ */B.jsx(aE, {
              number: "CA",
              locale: i
            }) : /* @__PURE__ */B.jsx(aE, {
              number: "CAD",
              locale: i
            })]
          }), /* @__PURE__ */B.jsx(dU, {
            id: `priceRangeInput-${t}`,
            ranges: ae,
            rangeText: "",
            locale: i,
            value: w || ae,
            initialValue: w || void 0,
            onHandleRangeChange: ne
          }, `priceRange-${j}`)]
        })
      }), /* @__PURE__ */B.jsx("div", {
        className: An.filtersDropdownWrapper,
        children: /* @__PURE__ */B.jsx(qT, {
          id: `starRating-${t}`,
          label: p.starRating,
          initialSelectedItem: ce[ce.length - 1],
          hideDisplayValue: W.id === ce[ce.length - 1].id && !P,
          selectedItem: W,
          onChange: ge => {
            if (!ge) return;
            const qe = ge;
            qe !== W && $(qe);
          },
          data: [{
            items: ce
          }],
          renderCustomItemContent: ge => String(ge == null ? void 0 : ge.label),
          renderCustomListItem: (ge, qe, Ae, Mt, Ft) => Ae ? /* @__PURE__ */B.jsxs("li", {
            ...Mt(Ft),
            className: ve(An.radioItem, Ft.className),
            children: [/* @__PURE__ */B.jsx(s2, {
              id: `${Ae.value}-radio`,
              name: "radio-dropdown",
              value: (Ae == null ? void 0 : Ae.value) ?? 0,
              isSelected: (W == null ? void 0 : W.id) === Ae.id,
              selectedOption: W ? {
                id: W.id,
                value: W.value,
                label: W.label
              } : void 0,
              classNames: {
                wrapper: An.radioButton
              },
              isInteractive: !1
            }, `${Ae.value}-radio`), /* @__PURE__ */B.jsx(wL, {
              rating: Ae.value,
              ratingText: Ae.label,
              classNames: {
                container: An.starContainer
              }
            }, `${Ae.value}-rating`)]
          }, `${ge}${qe}`) : null
        }, `starRating-${j}`)
      }), /* @__PURE__ */B.jsx("div", {
        className: An.filtersDropdownWrapper,
        children: /* @__PURE__ */B.jsx(qT, {
          id: `sortingFilter-${t}`,
          label: p.sortBy,
          renderCustomLabel: (ge, qe) => se.id === H[0].id && !I ? `${qe}: ${ge == null ? void 0 : ge.label}` : qe,
          initialSelectedItem: H[0],
          hideDisplayValue: se.id === H[0].id && !I,
          selectedItem: se ?? void 0,
          onChange: ge => {
            if (!ge) return;
            const qe = ge;
            qe !== se && ue(qe);
          },
          data: [{
            items: H
          }],
          renderCustomListItem: (ge, qe, Ae, Mt, Ft) => /* @__PURE__ */B.jsxs("li", {
            ...Mt(Ft),
            className: ve(An.radioItem, Ft.className),
            children: [/* @__PURE__ */B.jsx(s2, {
              id: `${Ae.value}-radio`,
              name: "radio-dropdown",
              value: Ae.value !== void 0 ? Ae.value : 0,
              isSelected: (se == null ? void 0 : se.id) === Ae.id,
              selectedOption: se ? {
                id: se.id,
                value: se.value,
                label: se.label
              } : void 0,
              classNames: {
                wrapper: An.radioButton
              },
              isInteractive: !1
            }, `${Ae.value}-radio`), Ae.label]
          }, `${ge}${qe}`)
        }, `sorting-${j}`)
      }), /* @__PURE__ */B.jsx(op, {
        className: An.applyButton,
        onClick: () => {
          const ge = {
            destinationSelections: h,
            starRatingSelection: W,
            priceValue: w,
            sortingOptionSelection: se
          };
          fe(ge), Se(e, ge);
        },
        disabled: !Ce,
        children: `${p == null ? void 0 : p.apply}${_e > 0 ? ` (${_e})` : ""}`
      }), /* @__PURE__ */B.jsx(op, {
        variant: "noStyle",
        onClick: () => {
          fe({
            destinationSelections: [],
            starRatingSelection: ce == null ? void 0 : ce[(ce == null ? void 0 : ce.length) - 1],
            priceValue: null,
            sortingOptionSelection: H[0]
          }), be(e), le();
        },
        className: An.reset,
        disabled: !k,
        children: p == null ? void 0 : p.reset
      })]
    });
  },
  fge = "_renderCards_uq13q_1",
  pge = "_disclaimer_uq13q_5",
  fU = {
    renderCards: fge,
    disclaimer: pge
  },
  A8 = t => t ? OL(t).isValid() : !1,
  hge = (t, e) => {
    if (!A8(t)) return "Date unavailable";
    const i = OL(t);
    return O8(e) === "fr-CA" ? i.locale("fr").format("D MMM YYYY") : i.format("MMM D, YYYY");
  },
  pU = ({
    id: t,
    index: e,
    offers: i,
    locale: s = "localeEn",
    labels: c,
    isMobile: p,
    numberToShow: h = 6,
    moreToShow: y = 6,
    cardsPerRow: w = 3,
    renderLink: x,
    noResults: E,
    theme: C = "light"
  }) => {
    const k = i.filter(N => A8(N.DepartureDate) ? OL(N.DepartureDate).isAfter(OL().startOf("day")) : (console.warn("Invalid departure date for offer:", N.DepartureDate), !1)),
      [D, I] = rt(P8(k)),
      L = O8(s),
      P = !D || D.length === 0;
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [(i.length > 6 || p) && /* @__PURE__ */B.jsx(dge, {
        id: `filter-${t}-${e}`,
        offers: k || [],
        locale: L,
        setMatchingOffers: I,
        isMobile: p,
        labels: c
      }), /* @__PURE__ */B.jsx("div", {
        id: `travel-deals${e !== 0 ? `-${e}` : ""}`,
        className: fU.renderCards,
        children: !P && /* @__PURE__ */B.jsx(pme, {
          numberToShow: h,
          moreToShow: y,
          cardsPerRow: w,
          labels: {
            loadAll: c == null ? void 0 : c.loadAll,
            loadMore: c == null ? void 0 : c.loadMore
          },
          children: (D || []).filter(N => N).map((N, O) => {
            var V, K, G;
            const F = N.Duration ? `${N.Duration} ${c == null ? void 0 : c.days}` : "";
            let j = N.DeepLink;
            if (p) try {
              const Q = new URL(N.DeepLink, window.location.origin);
              Q.searchParams.set("isMobile", "true"), Q.searchParams.get("alias") === "drv" && Q.searchParams.set("alias", "mrv"), j = Q.toString();
            } catch (Q) {
              console.warn("Failed to parse DeepLink URL:", N.DeepLink, Q), j = N.DeepLink;
            }
            return /* @__PURE__ */B.jsx(cee, {
              theme: C,
              header: `${N.Destination.Name}, ${N.Destination.CountryName}`,
              subheader: (V = N.AccommodationInfo) == null ? void 0 : V.AccommodationName,
              stars: (K = N.AccommodationInfo) != null && K.StarRating ? parseFloat(N.AccommodationInfo.StarRating.toString()) : void 0,
              days: F,
              regPrice: N.RegPrice,
              price: N.Price,
              save: N.SaveUpto ? `${c == null ? void 0 : c.saveUpTo} ${N.SaveUpto}%` : void 0,
              locale: L,
              labels: {
                allInc: N.MealPlan || (c == null ? void 0 : c.allInc) || "All inclusive",
                departureDate: hge(N.DepartureDate, s),
                adultsOnly: (c == null ? void 0 : c.adultsOnly) || "Adults only",
                departure: (c == null ? void 0 : c.departure) || "Dep.",
                return: (c == null ? void 0 : c.return) || "Ret.",
                perAdult: (c == null ? void 0 : c.perAdult) || "Per adult",
                taxAndFees: (c == null ? void 0 : c.taxAndFees) || "Taxes and fees incl.",
                was: (c == null ? void 0 : c.was) || "was",
                from: (c == null ? void 0 : c.from) || "From",
                dayOfWeek: (c == null ? void 0 : c.dayOfWeek) || "Day",
                returnDate: (c == null ? void 0 : c.returnDate) || "Return Date"
              },
              link: {
                href: j,
                children: "View details",
                target: "_blank"
              },
              renderLink: x,
              image: N.image || {
                source: {
                  src: "",
                  srcSet: "",
                  sizes: ""
                },
                alt: "Hotel image"
              }
            }, ((G = N.AccommodationInfo) == null ? void 0 : G.AccommodationCode) ?? O);
          })
        })
      }), P ? E : /* @__PURE__ */B.jsx("p", {
        className: fU.disclaimer,
        children: c == null ? void 0 : c.adModuleDisclaimer
      })]
    });
  },
  hU = ({
    index: t,
    gateways: e,
    defaultGateway: i,
    selectedGateway: s,
    setGateway: c,
    onGatewayChange: p,
    labels: h
  }) => {
    const y = s !== void 0,
      [w, x] = rt(i);
    Rt(() => {
      y || x(i);
    }, [i, y]);
    const E = y ? s : w,
      C = [{
        items: e ? e.map(D => ({
          id: D.Code,
          label: D.Name,
          value: D.Code
        })) : []
      }],
      k = D => {
        if (D && D.value !== (E == null ? void 0 : E.Code)) {
          const I = e == null ? void 0 : e.find(L => L.Code === D.value);
          I && (p != null && p(I.Code, I.Name) || (c(I), y || x(I)));
        }
      };
    return /* @__PURE__ */B.jsx(qT, {
      id: `gateways-${t}`,
      className: An.gatewayDropdown,
      data: C,
      label: h.from,
      selectedItem: E ? {
        id: E.Code,
        label: E.Name,
        value: E.Code
      } : void 0,
      onChange: k
    });
  },
  mge = "_cardsGatewayListContainer_1ck5m_1",
  vge = "_tabs_1ck5m_7",
  gge = "_tabGatewayListContainer_1ck5m_62",
  yge = "_gatewayList_1ck5m_72",
  bge = "_cardGatewayList_1ck5m_73",
  eE = {
    cardsGatewayListContainer: mge,
    tabs: vge,
    tabGatewayListContainer: gge,
    gatewayList: yge,
    cardGatewayList: bge
  },
  wge = {
    from: "From",
    loadAll: "Load all",
    loadMore: "Load more",
    adModuleDisclaimer: "The prices shown reflect rates of the day and are subject to change at any time without prior notice. To confirm availability and final pricing you MUST proceed to Step 3. The price shown at Step 3 constitutes the final guaranteed price and prevails over any other price.",
    days: "days",
    saveUpTo: "Save up to",
    oneWay: "One way",
    roundTrip: "Round trip",
    adultsOnly: "Adults only",
    departure: "Departure",
    return: "Return",
    perAdult: "Per adult",
    taxAndFees: "Tax and fees",
    dayOfWeek: "Day of week",
    departureDate: "Departure date",
    returnDate: "Return date",
    allInc: "All inclusive",
    was: "Was",
    apply: "Apply",
    reset: "Reset",
    sortAndFilter: "Sort and filter",
    destinations: "Destinations",
    clearAll: "Clear all",
    priceRange: "Price range",
    pricePerPerson: "Price per person",
    starRating: "Star rating",
    sortBy: "Sort by",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    starRatingLowToHigh: "Star Rating: Low to High",
    starRatingHighToLow: "Star Rating: High to Low",
    hotelNameAToZ: "Hotel Name: A to Z",
    hotelNameZToA: "Hotel Name: Z to A",
    departureDateEarliest: "Departure Date: Earliest"
  },
  Ax = M8.reduce((t, e) => [...t, ...e.gateways], []),
  J_e = ({
    labels: t = {},
    data: e,
    locale: i = "localeEn",
    numberToShow: s = 6,
    moreToShow: c = 6,
    noResults: p,
    onGatewayChange: h,
    defaultGateway: y
  }) => {
    var P, N, O;
    const w = ci(() => ({
        ...wge,
        ...t
      }), [t]),
      x = ci(() => {
        var K;
        if (!(e != null && e.length)) return {
          Code: "",
          Name: ""
        };
        if (typeof window < "u") {
          const G = window.location.pathname,
            Q = w.from.toLowerCase(),
            te = new RegExp(`\\/${Q}-([^/]+)`, "i"),
            ie = G.match(te);
          if (ie) {
            const Y = decodeURIComponent(ie[1]),
              ee = Ax.find(ae => ae.label.toLowerCase() === Y.toLowerCase());
            if (ee && e.some(ae => {
              var ne;
              return ((ne = ae == null ? void 0 : ae.Gateway) == null ? void 0 : ne.Code) === ee.value;
            })) return {
              Code: ee.value,
              Name: ee.label
            };
          }
        }
        if (y != null && y.Code && y != null && y.Name) {
          const G = Ax.some(te => te.value === y.Code),
            Q = e.some(te => {
              var ie;
              return ((ie = te == null ? void 0 : te.Gateway) == null ? void 0 : ie.Code) === y.Code;
            });
          if (G && Q) return y;
        }
        const F = Ax.find(G => G.value === "YYC" || G.label.toLowerCase().includes("calgary"));
        if (F && e.some(G => {
          var Q;
          return ((Q = G == null ? void 0 : G.Gateway) == null ? void 0 : Q.Code) === F.value;
        })) return {
          Code: F.value,
          Name: F.label
        };
        const j = (K = e[0]) == null ? void 0 : K.Gateway;
        return Ax.some(G => G.value === (j == null ? void 0 : j.Code)) ? j : {
          Code: Ax[0].value,
          Name: Ax[0].label
        };
      }, [e, y, w.from]),
      [E, C] = rt(x);
    Rt(() => {
      C(x);
    }, [x]);
    const k = ci(() => e != null && e.length ? e.filter(F => !!F).reduce((F, j) => {
        const V = Ax.find(K => {
          var G;
          return K.value === ((G = j == null ? void 0 : j.Gateway) == null ? void 0 : G.Code);
        });
        return V && !F.some(K => K.Code === V.value) && F.push({
          Code: V.value,
          Name: V.label
        }), F;
      }, []) : [], [e]),
      D = ci(() => {
        if (e != null && e.length) return e.find(F => {
          var j;
          return ((j = F == null ? void 0 : F.Gateway) == null ? void 0 : j.Code) === E.Code;
        }) || e[0];
      }, [e, E.Code]),
      I = F => {
        C(F);
      },
      L = D7();
    return (P = D == null ? void 0 : D.PromotionGroups) != null && P.length ? /* @__PURE__ */B.jsx(B.Fragment, {
      children: D.PromotionGroups.length === 1 ? /* @__PURE__ */B.jsxs("div", {
        className: eE.cardsGatewayListContainer,
        children: [/* @__PURE__ */B.jsx("div", {
          className: eE.cardGatewayList,
          children: /* @__PURE__ */B.jsx(hU, {
            index: 0,
            gateways: k,
            selectedGateway: E,
            labels: w,
            setGateway: I,
            onGatewayChange: h
          })
        }), /* @__PURE__ */B.jsx(pU, {
          id: `${D.PromotionGroups[0].title}-${(N = D == null ? void 0 : D.Gateway) == null ? void 0 : N.Code}`,
          index: 0,
          offers: (O = D.PromotionGroups[0]) == null ? void 0 : O.Offers,
          locale: i,
          labels: w,
          isMobile: L,
          numberToShow: s,
          moreToShow: c,
          cardsPerRow: 3,
          noResults: p
        }, `${D.PromotionGroups[0].title}-${E.Code}`)]
      }) : /* @__PURE__ */B.jsxs(mb, {
        defaultValue: D == null ? void 0 : D.PromotionGroups[0].title,
        className: ve(eE.tabs),
        isSticky: !1,
        children: [/* @__PURE__ */B.jsxs("div", {
          className: eE.tabGatewayListContainer,
          children: [/* @__PURE__ */B.jsx(mb.List, {
            className: eE.tabWrapper,
            backgroundColor: "grey",
            children: D.PromotionGroups.map(F => {
              var j;
              return /* @__PURE__ */B.jsx(mb.Trigger, {
                value: `${F.title}`,
                children: F.title
              }, `${F.title}-${(j = D == null ? void 0 : D.Gateway) == null ? void 0 : j.Code}`);
            })
          }), /* @__PURE__ */B.jsx("div", {
            className: eE.gatewayList,
            children: /* @__PURE__ */B.jsx(hU, {
              index: 1,
              gateways: k,
              selectedGateway: E,
              labels: w,
              setGateway: I,
              onGatewayChange: h
            })
          })]
        }), D.PromotionGroups.map((F, j) => {
          var V;
          return /* @__PURE__ */B.jsx(mb.Content, {
            value: `${F.title}`,
            children: /* @__PURE__ */B.jsx(pU, {
              id: `${F.title}-${(V = D == null ? void 0 : D.Gateway) == null ? void 0 : V.Code}`,
              index: j,
              offers: F.Offers,
              locale: i,
              labels: w,
              isMobile: L,
              numberToShow: s,
              moreToShow: c,
              cardsPerRow: 3,
              noResults: p
            })
          }, `${F.title}-${E.Code}`);
        })]
      })
    }) : p;
  };
var TM = {
    exports: {}
  },
  Y0 = {},
  RM = {
    exports: {}
  },
  Jc = {},
  DM = {
    exports: {}
  },
  u2 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mU;
function _ge() {
  return mU || (mU = 1, function (t) {
    function e($, de) {
      var H = $.length;
      $.push(de);
      e: for (; 0 < H;) {
        var se = H - 1 >>> 1,
          ue = $[se];
        if (0 < c(ue, de)) $[se] = de, $[H] = ue, H = se;else break e;
      }
    }
    function i($) {
      return $.length === 0 ? null : $[0];
    }
    function s($) {
      if ($.length === 0) return null;
      var de = $[0],
        H = $.pop();
      if (H !== de) {
        $[0] = H;
        e: for (var se = 0, ue = $.length, Ee = ue >>> 1; se < Ee;) {
          var Ce = 2 * (se + 1) - 1,
            fe = $[Ce],
            _e = Ce + 1,
            Se = $[_e];
          if (0 > c(fe, H)) _e < ue && 0 > c(Se, fe) ? ($[se] = Se, $[_e] = H, se = _e) : ($[se] = fe, $[Ce] = H, se = Ce);else if (_e < ue && 0 > c(Se, H)) $[se] = Se, $[_e] = H, se = _e;else break e;
        }
      }
      return de;
    }
    function c($, de) {
      var H = $.sortIndex - de.sortIndex;
      return H !== 0 ? H : $.id - de.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var p = performance;
      t.unstable_now = function () {
        return p.now();
      };
    } else {
      var h = Date,
        y = h.now();
      t.unstable_now = function () {
        return h.now() - y;
      };
    }
    var w = [],
      x = [],
      E = 1,
      C = null,
      k = 3,
      D = !1,
      I = !1,
      L = !1,
      P = typeof setTimeout == "function" ? setTimeout : null,
      N = typeof clearTimeout == "function" ? clearTimeout : null,
      O = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function F($) {
      for (var de = i(x); de !== null;) {
        if (de.callback === null) s(x);else if (de.startTime <= $) s(x), de.sortIndex = de.expirationTime, e(w, de);else break;
        de = i(x);
      }
    }
    function j($) {
      if (L = !1, F($), !I) if (i(w) !== null) I = !0, ce(V);else {
        var de = i(x);
        de !== null && W(j, de.startTime - $);
      }
    }
    function V($, de) {
      I = !1, L && (L = !1, N(Q), Q = -1), D = !0;
      var H = k;
      try {
        for (F(de), C = i(w); C !== null && (!(C.expirationTime > de) || $ && !Y());) {
          var se = C.callback;
          if (typeof se == "function") {
            C.callback = null, k = C.priorityLevel;
            var ue = se(C.expirationTime <= de);
            de = t.unstable_now(), typeof ue == "function" ? C.callback = ue : C === i(w) && s(w), F(de);
          } else s(w);
          C = i(w);
        }
        if (C !== null) var Ee = !0;else {
          var Ce = i(x);
          Ce !== null && W(j, Ce.startTime - de), Ee = !1;
        }
        return Ee;
      } finally {
        C = null, k = H, D = !1;
      }
    }
    var K = !1,
      G = null,
      Q = -1,
      te = 5,
      ie = -1;
    function Y() {
      return !(t.unstable_now() - ie < te);
    }
    function ee() {
      if (G !== null) {
        var $ = t.unstable_now();
        ie = $;
        var de = !0;
        try {
          de = G(!0, $);
        } finally {
          de ? ae() : (K = !1, G = null);
        }
      } else K = !1;
    }
    var ae;
    if (typeof O == "function") ae = function () {
      O(ee);
    };else if (typeof MessageChannel < "u") {
      var ne = new MessageChannel(),
        le = ne.port2;
      ne.port1.onmessage = ee, ae = function () {
        le.postMessage(null);
      };
    } else ae = function () {
      P(ee, 0);
    };
    function ce($) {
      G = $, K || (K = !0, ae());
    }
    function W($, de) {
      Q = P(function () {
        $(t.unstable_now());
      }, de);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function ($) {
      $.callback = null;
    }, t.unstable_continueExecution = function () {
      I || D || (I = !0, ce(V));
    }, t.unstable_forceFrameRate = function ($) {
      0 > $ || 125 < $ ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : te = 0 < $ ? Math.floor(1e3 / $) : 5;
    }, t.unstable_getCurrentPriorityLevel = function () {
      return k;
    }, t.unstable_getFirstCallbackNode = function () {
      return i(w);
    }, t.unstable_next = function ($) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var de = 3;
          break;
        default:
          de = k;
      }
      var H = k;
      k = de;
      try {
        return $();
      } finally {
        k = H;
      }
    }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = function () {}, t.unstable_runWithPriority = function ($, de) {
      switch ($) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          $ = 3;
      }
      var H = k;
      k = $;
      try {
        return de();
      } finally {
        k = H;
      }
    }, t.unstable_scheduleCallback = function ($, de, H) {
      var se = t.unstable_now();
      switch (typeof H == "object" && H !== null ? (H = H.delay, H = typeof H == "number" && 0 < H ? se + H : se) : H = se, $) {
        case 1:
          var ue = -1;
          break;
        case 2:
          ue = 250;
          break;
        case 5:
          ue = 1073741823;
          break;
        case 4:
          ue = 1e4;
          break;
        default:
          ue = 5e3;
      }
      return ue = H + ue, $ = {
        id: E++,
        callback: de,
        priorityLevel: $,
        startTime: H,
        expirationTime: ue,
        sortIndex: -1
      }, H > se ? ($.sortIndex = H, e(x, $), i(w) === null && $ === i(x) && (L ? (N(Q), Q = -1) : L = !0, W(j, H - se))) : ($.sortIndex = ue, e(w, $), I || D || (I = !0, ce(V))), $;
    }, t.unstable_shouldYield = Y, t.unstable_wrapCallback = function ($) {
      var de = k;
      return function () {
        var H = k;
        k = de;
        try {
          return $.apply(this, arguments);
        } finally {
          k = H;
        }
      };
    };
  }(u2)), u2;
}
var c2 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vU;
function xge() {
  return vU || (vU = 1, function (t) {
    process.env.NODE_ENV !== "production" && function () {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = !1,
        i = 5;
      function s(We, ht) {
        var Ke = We.length;
        We.push(ht), h(We, ht, Ke);
      }
      function c(We) {
        return We.length === 0 ? null : We[0];
      }
      function p(We) {
        if (We.length === 0) return null;
        var ht = We[0],
          Ke = We.pop();
        return Ke !== ht && (We[0] = Ke, y(We, Ke, 0)), ht;
      }
      function h(We, ht, Ke) {
        for (var yt = Ke; yt > 0;) {
          var je = yt - 1 >>> 1,
            at = We[je];
          if (w(at, ht) > 0) We[je] = ht, We[yt] = at, yt = je;else return;
        }
      }
      function y(We, ht, Ke) {
        for (var yt = Ke, je = We.length, at = je >>> 1; yt < at;) {
          var kt = (yt + 1) * 2 - 1,
            Bt = We[kt],
            Ht = kt + 1,
            sn = We[Ht];
          if (w(Bt, ht) < 0) Ht < je && w(sn, Bt) < 0 ? (We[yt] = sn, We[Ht] = ht, yt = Ht) : (We[yt] = Bt, We[kt] = ht, yt = kt);else if (Ht < je && w(sn, ht) < 0) We[yt] = sn, We[Ht] = ht, yt = Ht;else return;
        }
      }
      function w(We, ht) {
        var Ke = We.sortIndex - ht.sortIndex;
        return Ke !== 0 ? Ke : We.id - ht.id;
      }
      var x = 1,
        E = 2,
        C = 3,
        k = 4,
        D = 5;
      function I(We, ht) {}
      var L = typeof performance == "object" && typeof performance.now == "function";
      if (L) {
        var P = performance;
        t.unstable_now = function () {
          return P.now();
        };
      } else {
        var N = Date,
          O = N.now();
        t.unstable_now = function () {
          return N.now() - O;
        };
      }
      var F = 1073741823,
        j = -1,
        V = 250,
        K = 5e3,
        G = 1e4,
        Q = F,
        te = [],
        ie = [],
        Y = 1,
        ee = null,
        ae = C,
        ne = !1,
        le = !1,
        ce = !1,
        W = typeof setTimeout == "function" ? setTimeout : null,
        $ = typeof clearTimeout == "function" ? clearTimeout : null,
        de = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function H(We) {
        for (var ht = c(ie); ht !== null;) {
          if (ht.callback === null) p(ie);else if (ht.startTime <= We) p(ie), ht.sortIndex = ht.expirationTime, s(te, ht);else return;
          ht = c(ie);
        }
      }
      function se(We) {
        if (ce = !1, H(We), !le) if (c(te) !== null) le = !0, Et(ue);else {
          var ht = c(ie);
          ht !== null && Vt(se, ht.startTime - We);
        }
      }
      function ue(We, ht) {
        le = !1, ce && (ce = !1, Xt()), ne = !0;
        var Ke = ae;
        try {
          var yt;
          if (!e) return Ee(We, ht);
        } finally {
          ee = null, ae = Ke, ne = !1;
        }
      }
      function Ee(We, ht) {
        var Ke = ht;
        for (H(Ke), ee = c(te); ee !== null && !(ee.expirationTime > Ke && (!We || gt()));) {
          var yt = ee.callback;
          if (typeof yt == "function") {
            ee.callback = null, ae = ee.priorityLevel;
            var je = ee.expirationTime <= Ke,
              at = yt(je);
            Ke = t.unstable_now(), typeof at == "function" ? ee.callback = at : ee === c(te) && p(te), H(Ke);
          } else p(te);
          ee = c(te);
        }
        if (ee !== null) return !0;
        var kt = c(ie);
        return kt !== null && Vt(se, kt.startTime - Ke), !1;
      }
      function Ce(We, ht) {
        switch (We) {
          case x:
          case E:
          case C:
          case k:
          case D:
            break;
          default:
            We = C;
        }
        var Ke = ae;
        ae = We;
        try {
          return ht();
        } finally {
          ae = Ke;
        }
      }
      function fe(We) {
        var ht;
        switch (ae) {
          case x:
          case E:
          case C:
            ht = C;
            break;
          default:
            ht = ae;
            break;
        }
        var Ke = ae;
        ae = ht;
        try {
          return We();
        } finally {
          ae = Ke;
        }
      }
      function _e(We) {
        var ht = ae;
        return function () {
          var Ke = ae;
          ae = ht;
          try {
            return We.apply(this, arguments);
          } finally {
            ae = Ke;
          }
        };
      }
      function Se(We, ht, Ke) {
        var yt = t.unstable_now(),
          je;
        if (typeof Ke == "object" && Ke !== null) {
          var at = Ke.delay;
          typeof at == "number" && at > 0 ? je = yt + at : je = yt;
        } else je = yt;
        var kt;
        switch (We) {
          case x:
            kt = j;
            break;
          case E:
            kt = V;
            break;
          case D:
            kt = Q;
            break;
          case k:
            kt = G;
            break;
          case C:
          default:
            kt = K;
            break;
        }
        var Bt = je + kt,
          Ht = {
            id: Y++,
            callback: ht,
            priorityLevel: We,
            startTime: je,
            expirationTime: Bt,
            sortIndex: -1
          };
        return je > yt ? (Ht.sortIndex = je, s(ie, Ht), c(te) === null && Ht === c(ie) && (ce ? Xt() : ce = !0, Vt(se, je - yt))) : (Ht.sortIndex = Bt, s(te, Ht), !le && !ne && (le = !0, Et(ue))), Ht;
      }
      function be() {}
      function Le() {
        !le && !ne && (le = !0, Et(ue));
      }
      function Be() {
        return c(te);
      }
      function Xe(We) {
        We.callback = null;
      }
      function ge() {
        return ae;
      }
      var qe = !1,
        Ae = null,
        Mt = -1,
        Ft = i,
        un = -1;
      function gt() {
        var We = t.unstable_now() - un;
        return !(We < Ft);
      }
      function Pt() {}
      function St(We) {
        if (We < 0 || We > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        We > 0 ? Ft = Math.floor(1e3 / We) : Ft = i;
      }
      var Dt = function () {
          if (Ae !== null) {
            var We = t.unstable_now();
            un = We;
            var ht = !0,
              Ke = !0;
            try {
              Ke = Ae(ht, We);
            } finally {
              Ke ? Kt() : (qe = !1, Ae = null);
            }
          } else qe = !1;
        },
        Kt;
      if (typeof de == "function") Kt = function () {
        de(Dt);
      };else if (typeof MessageChannel < "u") {
        var hn = new MessageChannel(),
          Lt = hn.port2;
        hn.port1.onmessage = Dt, Kt = function () {
          Lt.postMessage(null);
        };
      } else Kt = function () {
        W(Dt, 0);
      };
      function Et(We) {
        Ae = We, qe || (qe = !0, Kt());
      }
      function Vt(We, ht) {
        Mt = W(function () {
          We(t.unstable_now());
        }, ht);
      }
      function Xt() {
        $(Mt), Mt = -1;
      }
      var vn = Pt,
        ot = null;
      t.unstable_IdlePriority = D, t.unstable_ImmediatePriority = x, t.unstable_LowPriority = k, t.unstable_NormalPriority = C, t.unstable_Profiling = ot, t.unstable_UserBlockingPriority = E, t.unstable_cancelCallback = Xe, t.unstable_continueExecution = Le, t.unstable_forceFrameRate = St, t.unstable_getCurrentPriorityLevel = ge, t.unstable_getFirstCallbackNode = Be, t.unstable_next = fe, t.unstable_pauseExecution = be, t.unstable_requestPaint = vn, t.unstable_runWithPriority = Ce, t.unstable_scheduleCallback = Se, t.unstable_shouldYield = gt, t.unstable_wrapCallback = _e, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(c2)), c2;
}
var gU;
function j8() {
  return gU || (gU = 1, process.env.NODE_ENV === "production" ? DM.exports = _ge() : DM.exports = xge()), DM.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yU;
function Sge() {
  if (yU) return Jc;
  yU = 1;
  var t = Nt,
    e = j8();
  function i(r) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, d = 1; d < arguments.length; d++) o += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + r + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var s = /* @__PURE__ */new Set(),
    c = {};
  function p(r, o) {
    h(r, o), h(r + "Capture", o);
  }
  function h(r, o) {
    for (c[r] = o, r = 0; r < o.length; r++) s.add(o[r]);
  }
  var y = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
    w = Object.prototype.hasOwnProperty,
    x = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    E = {},
    C = {};
  function k(r) {
    return w.call(C, r) ? !0 : w.call(E, r) ? !1 : x.test(r) ? C[r] = !0 : (E[r] = !0, !1);
  }
  function D(r, o, d, g) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return g ? !1 : d !== null ? !d.acceptsBooleans : (r = r.toLowerCase().slice(0, 5), r !== "data-" && r !== "aria-");
      default:
        return !1;
    }
  }
  function I(r, o, d, g) {
    if (o === null || typeof o > "u" || D(r, o, d, g)) return !0;
    if (g) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !o;
      case 4:
        return o === !1;
      case 5:
        return isNaN(o);
      case 6:
        return isNaN(o) || 1 > o;
    }
    return !1;
  }
  function L(r, o, d, g, S, R, A) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = g, this.attributeNamespace = S, this.mustUseProperty = d, this.propertyName = r, this.type = o, this.sanitizeURL = R, this.removeEmptyString = A;
  }
  var P = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (r) {
    P[r] = new L(r, 0, !1, r, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (r) {
    var o = r[0];
    P[o] = new L(o, 1, !1, r[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (r) {
    P[r] = new L(r, 2, !1, r.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (r) {
    P[r] = new L(r, 2, !1, r, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (r) {
    P[r] = new L(r, 3, !1, r.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (r) {
    P[r] = new L(r, 3, !0, r, null, !1, !1);
  }), ["capture", "download"].forEach(function (r) {
    P[r] = new L(r, 4, !1, r, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (r) {
    P[r] = new L(r, 6, !1, r, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function (r) {
    P[r] = new L(r, 5, !1, r.toLowerCase(), null, !1, !1);
  });
  var N = /[\-:]([a-z])/g;
  function O(r) {
    return r[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (r) {
    var o = r.replace(N, O);
    P[o] = new L(o, 1, !1, r, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (r) {
    P[r] = new L(r, 1, !1, r.toLowerCase(), null, !1, !1);
  }), P.xlinkHref = new L("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (r) {
    P[r] = new L(r, 1, !1, r.toLowerCase(), null, !0, !0);
  });
  function F(r, o, d, g) {
    var S = P.hasOwnProperty(o) ? P[o] : null;
    (S !== null ? S.type !== 0 : g || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (I(o, d, S, g) && (d = null), g || S === null ? k(o) && (d === null ? r.removeAttribute(o) : r.setAttribute(o, "" + d)) : S.mustUseProperty ? r[S.propertyName] = d === null ? S.type === 3 ? !1 : "" : d : (o = S.attributeName, g = S.attributeNamespace, d === null ? r.removeAttribute(o) : (S = S.type, d = S === 3 || S === 4 && d === !0 ? "" : "" + d, g ? r.setAttributeNS(g, o, d) : r.setAttribute(o, d))));
  }
  var j = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    V = Symbol.for("react.element"),
    K = Symbol.for("react.portal"),
    G = Symbol.for("react.fragment"),
    Q = Symbol.for("react.strict_mode"),
    te = Symbol.for("react.profiler"),
    ie = Symbol.for("react.provider"),
    Y = Symbol.for("react.context"),
    ee = Symbol.for("react.forward_ref"),
    ae = Symbol.for("react.suspense"),
    ne = Symbol.for("react.suspense_list"),
    le = Symbol.for("react.memo"),
    ce = Symbol.for("react.lazy"),
    W = Symbol.for("react.offscreen"),
    $ = Symbol.iterator;
  function de(r) {
    return r === null || typeof r != "object" ? null : (r = $ && r[$] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var H = Object.assign,
    se;
  function ue(r) {
    if (se === void 0) try {
      throw Error();
    } catch (d) {
      var o = d.stack.trim().match(/\n( *(at )?)/);
      se = o && o[1] || "";
    }
    return `
` + se + r;
  }
  var Ee = !1;
  function Ce(r, o) {
    if (!r || Ee) return "";
    Ee = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o) {
        if (o = function () {
          throw Error();
        }, Object.defineProperty(o.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (ye) {
            var g = ye;
          }
          Reflect.construct(r, [], o);
        } else {
          try {
            o.call();
          } catch (ye) {
            g = ye;
          }
          r.call(o.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (ye) {
          g = ye;
        }
        r();
      }
    } catch (ye) {
      if (ye && g && typeof ye.stack == "string") {
        for (var S = ye.stack.split(`
`), R = g.stack.split(`
`), A = S.length - 1, q = R.length - 1; 1 <= A && 0 <= q && S[A] !== R[q];) q--;
        for (; 1 <= A && 0 <= q; A--, q--) if (S[A] !== R[q]) {
          if (A !== 1 || q !== 1) do if (A--, q--, 0 > q || S[A] !== R[q]) {
            var re = `
` + S[A].replace(" at new ", " at ");
            return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), re;
          } while (1 <= A && 0 <= q);
          break;
        }
      }
    } finally {
      Ee = !1, Error.prepareStackTrace = d;
    }
    return (r = r ? r.displayName || r.name : "") ? ue(r) : "";
  }
  function fe(r) {
    switch (r.tag) {
      case 5:
        return ue(r.type);
      case 16:
        return ue("Lazy");
      case 13:
        return ue("Suspense");
      case 19:
        return ue("SuspenseList");
      case 0:
      case 2:
      case 15:
        return r = Ce(r.type, !1), r;
      case 11:
        return r = Ce(r.type.render, !1), r;
      case 1:
        return r = Ce(r.type, !0), r;
      default:
        return "";
    }
  }
  function _e(r) {
    if (r == null) return null;
    if (typeof r == "function") return r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case G:
        return "Fragment";
      case K:
        return "Portal";
      case te:
        return "Profiler";
      case Q:
        return "StrictMode";
      case ae:
        return "Suspense";
      case ne:
        return "SuspenseList";
    }
    if (typeof r == "object") switch (r.$$typeof) {
      case Y:
        return (r.displayName || "Context") + ".Consumer";
      case ie:
        return (r._context.displayName || "Context") + ".Provider";
      case ee:
        var o = r.render;
        return r = r.displayName, r || (r = o.displayName || o.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
      case le:
        return o = r.displayName || null, o !== null ? o : _e(r.type) || "Memo";
      case ce:
        o = r._payload, r = r._init;
        try {
          return _e(r(o));
        } catch {}
    }
    return null;
  }
  function Se(r) {
    var o = r.type;
    switch (r.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return r = o.render, r = r.displayName || r.name || "", o.displayName || (r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return _e(o);
      case 8:
        return o === Q ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function") return o.displayName || o.name || null;
        if (typeof o == "string") return o;
    }
    return null;
  }
  function be(r) {
    switch (typeof r) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return r;
      case "object":
        return r;
      default:
        return "";
    }
  }
  function Le(r) {
    var o = r.type;
    return (r = r.nodeName) && r.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function Be(r) {
    var o = Le(r) ? "checked" : "value",
      d = Object.getOwnPropertyDescriptor(r.constructor.prototype, o),
      g = "" + r[o];
    if (!r.hasOwnProperty(o) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var S = d.get,
        R = d.set;
      return Object.defineProperty(r, o, {
        configurable: !0,
        get: function () {
          return S.call(this);
        },
        set: function (A) {
          g = "" + A, R.call(this, A);
        }
      }), Object.defineProperty(r, o, {
        enumerable: d.enumerable
      }), {
        getValue: function () {
          return g;
        },
        setValue: function (A) {
          g = "" + A;
        },
        stopTracking: function () {
          r._valueTracker = null, delete r[o];
        }
      };
    }
  }
  function Xe(r) {
    r._valueTracker || (r._valueTracker = Be(r));
  }
  function ge(r) {
    if (!r) return !1;
    var o = r._valueTracker;
    if (!o) return !0;
    var d = o.getValue(),
      g = "";
    return r && (g = Le(r) ? r.checked ? "true" : "false" : r.value), r = g, r !== d ? (o.setValue(r), !0) : !1;
  }
  function qe(r) {
    if (r = r || (typeof document < "u" ? document : void 0), typeof r > "u") return null;
    try {
      return r.activeElement || r.body;
    } catch {
      return r.body;
    }
  }
  function Ae(r, o) {
    var d = o.checked;
    return H({}, o, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: d ?? r._wrapperState.initialChecked
    });
  }
  function Mt(r, o) {
    var d = o.defaultValue == null ? "" : o.defaultValue,
      g = o.checked != null ? o.checked : o.defaultChecked;
    d = be(o.value != null ? o.value : d), r._wrapperState = {
      initialChecked: g,
      initialValue: d,
      controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null
    };
  }
  function Ft(r, o) {
    o = o.checked, o != null && F(r, "checked", o, !1);
  }
  function un(r, o) {
    Ft(r, o);
    var d = be(o.value),
      g = o.type;
    if (d != null) g === "number" ? (d === 0 && r.value === "" || r.value != d) && (r.value = "" + d) : r.value !== "" + d && (r.value = "" + d);else if (g === "submit" || g === "reset") {
      r.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? Pt(r, o.type, d) : o.hasOwnProperty("defaultValue") && Pt(r, o.type, be(o.defaultValue)), o.checked == null && o.defaultChecked != null && (r.defaultChecked = !!o.defaultChecked);
  }
  function gt(r, o, d) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var g = o.type;
      if (!(g !== "submit" && g !== "reset" || o.value !== void 0 && o.value !== null)) return;
      o = "" + r._wrapperState.initialValue, d || o === r.value || (r.value = o), r.defaultValue = o;
    }
    d = r.name, d !== "" && (r.name = ""), r.defaultChecked = !!r._wrapperState.initialChecked, d !== "" && (r.name = d);
  }
  function Pt(r, o, d) {
    (o !== "number" || qe(r.ownerDocument) !== r) && (d == null ? r.defaultValue = "" + r._wrapperState.initialValue : r.defaultValue !== "" + d && (r.defaultValue = "" + d));
  }
  var St = Array.isArray;
  function Dt(r, o, d, g) {
    if (r = r.options, o) {
      o = {};
      for (var S = 0; S < d.length; S++) o["$" + d[S]] = !0;
      for (d = 0; d < r.length; d++) S = o.hasOwnProperty("$" + r[d].value), r[d].selected !== S && (r[d].selected = S), S && g && (r[d].defaultSelected = !0);
    } else {
      for (d = "" + be(d), o = null, S = 0; S < r.length; S++) {
        if (r[S].value === d) {
          r[S].selected = !0, g && (r[S].defaultSelected = !0);
          return;
        }
        o !== null || r[S].disabled || (o = r[S]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Kt(r, o) {
    if (o.dangerouslySetInnerHTML != null) throw Error(i(91));
    return H({}, o, {
      value: void 0,
      defaultValue: void 0,
      children: "" + r._wrapperState.initialValue
    });
  }
  function hn(r, o) {
    var d = o.value;
    if (d == null) {
      if (d = o.children, o = o.defaultValue, d != null) {
        if (o != null) throw Error(i(92));
        if (St(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        o = d;
      }
      o == null && (o = ""), d = o;
    }
    r._wrapperState = {
      initialValue: be(d)
    };
  }
  function Lt(r, o) {
    var d = be(o.value),
      g = be(o.defaultValue);
    d != null && (d = "" + d, d !== r.value && (r.value = d), o.defaultValue == null && r.defaultValue !== d && (r.defaultValue = d)), g != null && (r.defaultValue = "" + g);
  }
  function Et(r) {
    var o = r.textContent;
    o === r._wrapperState.initialValue && o !== "" && o !== null && (r.value = o);
  }
  function Vt(r) {
    switch (r) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Xt(r, o) {
    return r == null || r === "http://www.w3.org/1999/xhtml" ? Vt(o) : r === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r;
  }
  var vn,
    ot = function (r) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (o, d, g, S) {
        MSApp.execUnsafeLocalFunction(function () {
          return r(o, d, g, S);
        });
      } : r;
    }(function (r, o) {
      if (r.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in r) r.innerHTML = o;else {
        for (vn = vn || document.createElement("div"), vn.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = vn.firstChild; r.firstChild;) r.removeChild(r.firstChild);
        for (; o.firstChild;) r.appendChild(o.firstChild);
      }
    });
  function We(r, o) {
    if (o) {
      var d = r.firstChild;
      if (d && d === r.lastChild && d.nodeType === 3) {
        d.nodeValue = o;
        return;
      }
    }
    r.textContent = o;
  }
  var ht = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    Ke = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ht).forEach(function (r) {
    Ke.forEach(function (o) {
      o = o + r.charAt(0).toUpperCase() + r.substring(1), ht[o] = ht[r];
    });
  });
  function yt(r, o, d) {
    return o == null || typeof o == "boolean" || o === "" ? "" : d || typeof o != "number" || o === 0 || ht.hasOwnProperty(r) && ht[r] ? ("" + o).trim() : o + "px";
  }
  function je(r, o) {
    r = r.style;
    for (var d in o) if (o.hasOwnProperty(d)) {
      var g = d.indexOf("--") === 0,
        S = yt(d, o[d], g);
      d === "float" && (d = "cssFloat"), g ? r.setProperty(d, S) : r[d] = S;
    }
  }
  var at = H({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });
  function kt(r, o) {
    if (o) {
      if (at[r] && (o.children != null || o.dangerouslySetInnerHTML != null)) throw Error(i(137, r));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null) throw Error(i(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (o.style != null && typeof o.style != "object") throw Error(i(62));
    }
  }
  function Bt(r, o) {
    if (r.indexOf("-") === -1) return typeof o.is == "string";
    switch (r) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ht = null;
  function sn(r) {
    return r = r.target || r.srcElement || window, r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === 3 ? r.parentNode : r;
  }
  var en = null,
    Rr = null,
    Nr = null;
  function Hi(r) {
    if (r = pt(r)) {
      if (typeof en != "function") throw Error(i(280));
      var o = r.stateNode;
      o && (o = Gn(o), en(r.stateNode, r.type, o));
    }
  }
  function ss(r) {
    Rr ? Nr ? Nr.push(r) : Nr = [r] : Rr = r;
  }
  function yo() {
    if (Rr) {
      var r = Rr,
        o = Nr;
      if (Nr = Rr = null, Hi(r), o) for (r = 0; r < o.length; r++) Hi(o[r]);
    }
  }
  function _s(r, o) {
    return r(o);
  }
  function Mo() {}
  var bo = !1;
  function Tu(r, o, d) {
    if (bo) return r(o, d);
    bo = !0;
    try {
      return _s(r, o, d);
    } finally {
      bo = !1, (Rr !== null || Nr !== null) && (Mo(), yo());
    }
  }
  function Ha(r, o) {
    var d = r.stateNode;
    if (d === null) return null;
    var g = Gn(d);
    if (g === null) return null;
    d = g[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (g = !g.disabled) || (r = r.type, g = !(r === "button" || r === "input" || r === "select" || r === "textarea")), r = !g;
        break e;
      default:
        r = !1;
    }
    if (r) return null;
    if (d && typeof d != "function") throw Error(i(231, o, typeof d));
    return d;
  }
  var $i = !1;
  if (y) try {
    var oi = {};
    Object.defineProperty(oi, "passive", {
      get: function () {
        $i = !0;
      }
    }), window.addEventListener("test", oi, oi), window.removeEventListener("test", oi, oi);
  } catch {
    $i = !1;
  }
  function Lo(r, o, d, g, S, R, A, q, re) {
    var ye = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(d, ye);
    } catch (Oe) {
      this.onError(Oe);
    }
  }
  var $a = !1,
    Oo = null,
    Z = !1,
    Ne = null,
    Ye = {
      onError: function (r) {
        $a = !0, Oo = r;
      }
    };
  function xt(r, o, d, g, S, R, A, q, re) {
    $a = !1, Oo = null, Lo.apply(Ye, arguments);
  }
  function rn(r, o, d, g, S, R, A, q, re) {
    if (xt.apply(this, arguments), $a) {
      if ($a) {
        var ye = Oo;
        $a = !1, Oo = null;
      } else throw Error(i(198));
      Z || (Z = !0, Ne = ye);
    }
  }
  function $t(r) {
    var o = r,
      d = r;
    if (r.alternate) for (; o.return;) o = o.return;else {
      r = o;
      do o = r, (o.flags & 4098) !== 0 && (d = o.return), r = o.return; while (r);
    }
    return o.tag === 3 ? d : null;
  }
  function Ct(r) {
    if (r.tag === 13) {
      var o = r.memoizedState;
      if (o === null && (r = r.alternate, r !== null && (o = r.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function qt(r) {
    if ($t(r) !== r) throw Error(i(188));
  }
  function yr(r) {
    var o = r.alternate;
    if (!o) {
      if (o = $t(r), o === null) throw Error(i(188));
      return o !== r ? null : r;
    }
    for (var d = r, g = o;;) {
      var S = d.return;
      if (S === null) break;
      var R = S.alternate;
      if (R === null) {
        if (g = S.return, g !== null) {
          d = g;
          continue;
        }
        break;
      }
      if (S.child === R.child) {
        for (R = S.child; R;) {
          if (R === d) return qt(S), r;
          if (R === g) return qt(S), o;
          R = R.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== g.return) d = S, g = R;else {
        for (var A = !1, q = S.child; q;) {
          if (q === d) {
            A = !0, d = S, g = R;
            break;
          }
          if (q === g) {
            A = !0, g = S, d = R;
            break;
          }
          q = q.sibling;
        }
        if (!A) {
          for (q = R.child; q;) {
            if (q === d) {
              A = !0, d = R, g = S;
              break;
            }
            if (q === g) {
              A = !0, g = R, d = S;
              break;
            }
            q = q.sibling;
          }
          if (!A) throw Error(i(189));
        }
      }
      if (d.alternate !== g) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? r : o;
  }
  function Tn(r) {
    return r = yr(r), r !== null ? jn(r) : null;
  }
  function jn(r) {
    if (r.tag === 5 || r.tag === 6) return r;
    for (r = r.child; r !== null;) {
      var o = jn(r);
      if (o !== null) return o;
      r = r.sibling;
    }
    return null;
  }
  var Or = e.unstable_scheduleCallback,
    Wa = e.unstable_cancelCallback,
    Ru = e.unstable_shouldYield,
    Wi = e.unstable_requestPaint,
    yn = e.unstable_now,
    Qt = e.unstable_getCurrentPriorityLevel,
    El = e.unstable_ImmediatePriority,
    Wp = e.unstable_UserBlockingPriority,
    Du = e.unstable_NormalPriority,
    tg = e.unstable_LowPriority,
    qp = e.unstable_IdlePriority,
    Iu = null,
    qi = null;
  function ng(r) {
    if (qi && typeof qi.onCommitFiberRoot == "function") try {
      qi.onCommitFiberRoot(Iu, r, void 0, (r.current.flags & 128) === 128);
    } catch {}
  }
  var gi = Math.clz32 ? Math.clz32 : Yp,
    cw = Math.log,
    dw = Math.LN2;
  function Yp(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (cw(r) / dw | 0) | 0;
  }
  var xs = 64,
    Yi = 4194304;
  function Cl(r) {
    switch (r & -r) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return r & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return r;
    }
  }
  function kl(r, o) {
    var d = r.pendingLanes;
    if (d === 0) return 0;
    var g = 0,
      S = r.suspendedLanes,
      R = r.pingedLanes,
      A = d & 268435455;
    if (A !== 0) {
      var q = A & ~S;
      q !== 0 ? g = Cl(q) : (R &= A, R !== 0 && (g = Cl(R)));
    } else A = d & ~S, A !== 0 ? g = Cl(A) : R !== 0 && (g = Cl(R));
    if (g === 0) return 0;
    if (o !== 0 && o !== g && (o & S) === 0 && (S = g & -g, R = o & -o, S >= R || S === 16 && (R & 4194240) !== 0)) return o;
    if ((g & 4) !== 0 && (g |= d & 16), o = r.entangledLanes, o !== 0) for (r = r.entanglements, o &= g; 0 < o;) d = 31 - gi(o), S = 1 << d, g |= r[d], o &= ~S;
    return g;
  }
  function fw(r, o) {
    switch (r) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Gp(r, o) {
    for (var d = r.suspendedLanes, g = r.pingedLanes, S = r.expirationTimes, R = r.pendingLanes; 0 < R;) {
      var A = 31 - gi(R),
        q = 1 << A,
        re = S[A];
      re === -1 ? ((q & d) === 0 || (q & g) !== 0) && (S[A] = fw(q, o)) : re <= o && (r.expiredLanes |= q), R &= ~q;
    }
  }
  function Xp(r) {
    return r = r.pendingLanes & -1073741825, r !== 0 ? r : r & 1073741824 ? 1073741824 : 0;
  }
  function fd() {
    var r = xs;
    return xs <<= 1, (xs & 4194240) === 0 && (xs = 64), r;
  }
  function Kp(r) {
    for (var o = [], d = 0; 31 > d; d++) o.push(r);
    return o;
  }
  function Tl(r, o, d) {
    r.pendingLanes |= o, o !== 536870912 && (r.suspendedLanes = 0, r.pingedLanes = 0), r = r.eventTimes, o = 31 - gi(o), r[o] = d;
  }
  function pw(r, o) {
    var d = r.pendingLanes & ~o;
    r.pendingLanes = o, r.suspendedLanes = 0, r.pingedLanes = 0, r.expiredLanes &= o, r.mutableReadLanes &= o, r.entangledLanes &= o, o = r.entanglements;
    var g = r.eventTimes;
    for (r = r.expirationTimes; 0 < d;) {
      var S = 31 - gi(d),
        R = 1 << S;
      o[S] = 0, g[S] = -1, r[S] = -1, d &= ~R;
    }
  }
  function pd(r, o) {
    var d = r.entangledLanes |= o;
    for (r = r.entanglements; d;) {
      var g = 31 - gi(d),
        S = 1 << g;
      S & o | r[g] & o && (r[g] |= o), d &= ~S;
    }
  }
  var gn = 0;
  function Qp(r) {
    return r &= -r, 1 < r ? 4 < r ? (r & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var bn,
    Zp,
    Jp,
    At,
    eh,
    Pr = !1,
    Po = [],
    yi = null,
    Ao = null,
    Un = null,
    Rn = /* @__PURE__ */new Map(),
    Mu = /* @__PURE__ */new Map(),
    br = [],
    bi = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function qa(r, o) {
    switch (r) {
      case "focusin":
      case "focusout":
        yi = null;
        break;
      case "dragenter":
      case "dragleave":
        Ao = null;
        break;
      case "mouseover":
      case "mouseout":
        Un = null;
        break;
      case "pointerover":
      case "pointerout":
        Rn.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Mu.delete(o.pointerId);
    }
  }
  function Lu(r, o, d, g, S, R) {
    return r === null || r.nativeEvent !== R ? (r = {
      blockedOn: o,
      domEventName: d,
      eventSystemFlags: g,
      nativeEvent: R,
      targetContainers: [S]
    }, o !== null && (o = pt(o), o !== null && Zp(o)), r) : (r.eventSystemFlags |= g, o = r.targetContainers, S !== null && o.indexOf(S) === -1 && o.push(S), r);
  }
  function th(r, o, d, g, S) {
    switch (o) {
      case "focusin":
        return yi = Lu(yi, r, o, d, g, S), !0;
      case "dragenter":
        return Ao = Lu(Ao, r, o, d, g, S), !0;
      case "mouseover":
        return Un = Lu(Un, r, o, d, g, S), !0;
      case "pointerover":
        var R = S.pointerId;
        return Rn.set(R, Lu(Rn.get(R) || null, r, o, d, g, S)), !0;
      case "gotpointercapture":
        return R = S.pointerId, Mu.set(R, Lu(Mu.get(R) || null, r, o, d, g, S)), !0;
    }
    return !1;
  }
  function nh(r) {
    var o = Fl(r.target);
    if (o !== null) {
      var d = $t(o);
      if (d !== null) {
        if (o = d.tag, o === 13) {
          if (o = Ct(d), o !== null) {
            r.blockedOn = o, eh(r.priority, function () {
              Jp(d);
            });
            return;
          }
        } else if (o === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          r.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    r.blockedOn = null;
  }
  function Ou(r) {
    if (r.blockedOn !== null) return !1;
    for (var o = r.targetContainers; 0 < o.length;) {
      var d = md(r.domEventName, r.eventSystemFlags, o[0], r.nativeEvent);
      if (d === null) {
        d = r.nativeEvent;
        var g = new d.constructor(d.type, d);
        Ht = g, d.target.dispatchEvent(g), Ht = null;
      } else return o = pt(d), o !== null && Zp(o), r.blockedOn = d, !1;
      o.shift();
    }
    return !0;
  }
  function rg(r, o, d) {
    Ou(r) && d.delete(o);
  }
  function hw() {
    Pr = !1, yi !== null && Ou(yi) && (yi = null), Ao !== null && Ou(Ao) && (Ao = null), Un !== null && Ou(Un) && (Un = null), Rn.forEach(rg), Mu.forEach(rg);
  }
  function Pu(r, o) {
    r.blockedOn === o && (r.blockedOn = null, Pr || (Pr = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, hw)));
  }
  function jo(r) {
    function o(S) {
      return Pu(S, r);
    }
    if (0 < Po.length) {
      Pu(Po[0], r);
      for (var d = 1; d < Po.length; d++) {
        var g = Po[d];
        g.blockedOn === r && (g.blockedOn = null);
      }
    }
    for (yi !== null && Pu(yi, r), Ao !== null && Pu(Ao, r), Un !== null && Pu(Un, r), Rn.forEach(o), Mu.forEach(o), d = 0; d < br.length; d++) g = br[d], g.blockedOn === r && (g.blockedOn = null);
    for (; 0 < br.length && (d = br[0], d.blockedOn === null);) nh(d), d.blockedOn === null && br.shift();
  }
  var Rl = j.ReactCurrentBatchConfig,
    Dl = !0;
  function ig(r, o, d, g) {
    var S = gn,
      R = Rl.transition;
    Rl.transition = null;
    try {
      gn = 1, hd(r, o, d, g);
    } finally {
      gn = S, Rl.transition = R;
    }
  }
  function ag(r, o, d, g) {
    var S = gn,
      R = Rl.transition;
    Rl.transition = null;
    try {
      gn = 4, hd(r, o, d, g);
    } finally {
      gn = S, Rl.transition = R;
    }
  }
  function hd(r, o, d, g) {
    if (Dl) {
      var S = md(r, o, d, g);
      if (S === null) Od(r, o, g, Au, d), qa(r, g);else if (th(S, r, o, d, g)) g.stopPropagation();else if (qa(r, g), o & 4 && -1 < bi.indexOf(r)) {
        for (; S !== null;) {
          var R = pt(S);
          if (R !== null && bn(R), R = md(r, o, d, g), R === null && Od(r, o, g, Au, d), R === S) break;
          S = R;
        }
        S !== null && g.stopPropagation();
      } else Od(r, o, g, null, d);
    }
  }
  var Au = null;
  function md(r, o, d, g) {
    if (Au = null, r = sn(g), r = Fl(r), r !== null) if (o = $t(r), o === null) r = null;else if (d = o.tag, d === 13) {
      if (r = Ct(o), r !== null) return r;
      r = null;
    } else if (d === 3) {
      if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
      r = null;
    } else o !== r && (r = null);
    return Au = r, null;
  }
  function vd(r) {
    switch (r) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Qt()) {
          case El:
            return 1;
          case Wp:
            return 4;
          case Du:
          case tg:
            return 16;
          case qp:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ya = null,
    gd = null,
    Ss = null;
  function rh() {
    if (Ss) return Ss;
    var r,
      o = gd,
      d = o.length,
      g,
      S = "value" in Ya ? Ya.value : Ya.textContent,
      R = S.length;
    for (r = 0; r < d && o[r] === S[r]; r++);
    var A = d - r;
    for (g = 1; g <= A && o[d - g] === S[R - g]; g++);
    return Ss = S.slice(r, 1 < g ? 1 - g : void 0);
  }
  function yd(r) {
    var o = r.keyCode;
    return "charCode" in r ? (r = r.charCode, r === 0 && o === 13 && (r = 13)) : r = o, r === 10 && (r = 13), 32 <= r || r === 13 ? r : 0;
  }
  function bd() {
    return !0;
  }
  function wd() {
    return !1;
  }
  function $r(r) {
    function o(d, g, S, R, A) {
      this._reactName = d, this._targetInst = S, this.type = g, this.nativeEvent = R, this.target = A, this.currentTarget = null;
      for (var q in r) r.hasOwnProperty(q) && (d = r[q], this[q] = d ? d(R) : R[q]);
      return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? bd : wd, this.isPropagationStopped = wd, this;
    }
    return H(o.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var d = this.nativeEvent;
        d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = bd);
      },
      stopPropagation: function () {
        var d = this.nativeEvent;
        d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = bd);
      },
      persist: function () {},
      isPersistent: bd
    }), o;
  }
  var Il = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (r) {
        return r.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    _d = $r(Il),
    Es = H({}, Il, {
      view: 0,
      detail: 0
    }),
    mw = $r(Es),
    ih,
    wr,
    Ml,
    ju = H({}, Es, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: uh,
      button: 0,
      buttons: 0,
      relatedTarget: function (r) {
        return r.relatedTarget === void 0 ? r.fromElement === r.srcElement ? r.toElement : r.fromElement : r.relatedTarget;
      },
      movementX: function (r) {
        return "movementX" in r ? r.movementX : (r !== Ml && (Ml && r.type === "mousemove" ? (ih = r.screenX - Ml.screenX, wr = r.screenY - Ml.screenY) : wr = ih = 0, Ml = r), ih);
      },
      movementY: function (r) {
        return "movementY" in r ? r.movementY : wr;
      }
    }),
    ah = $r(ju),
    vw = H({}, ju, {
      dataTransfer: 0
    }),
    Cs = $r(vw),
    oh = H({}, Es, {
      relatedTarget: 0
    }),
    xd = $r(oh),
    gw = H({}, Il, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    yw = $r(gw),
    bw = H({}, Il, {
      clipboardData: function (r) {
        return "clipboardData" in r ? r.clipboardData : window.clipboardData;
      }
    }),
    og = $r(bw),
    lh = H({}, Il, {
      data: 0
    }),
    sh = $r(lh),
    lg = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    sg = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    ww = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function Ga(r) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(r) : (r = ww[r]) ? !!o[r] : !1;
  }
  function uh() {
    return Ga;
  }
  var ch = H({}, Es, {
      key: function (r) {
        if (r.key) {
          var o = lg[r.key] || r.key;
          if (o !== "Unidentified") return o;
        }
        return r.type === "keypress" ? (r = yd(r), r === 13 ? "Enter" : String.fromCharCode(r)) : r.type === "keydown" || r.type === "keyup" ? sg[r.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: uh,
      charCode: function (r) {
        return r.type === "keypress" ? yd(r) : 0;
      },
      keyCode: function (r) {
        return r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      },
      which: function (r) {
        return r.type === "keypress" ? yd(r) : r.type === "keydown" || r.type === "keyup" ? r.keyCode : 0;
      }
    }),
    dh = $r(ch),
    fh = H({}, ju, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }),
    ug = $r(fh),
    Sd = H({}, Es, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: uh
    }),
    cg = $r(Sd),
    Wr = H({}, Il, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }),
    Xa = $r(Wr),
    er = H({}, ju, {
      deltaX: function (r) {
        return "deltaX" in r ? r.deltaX : "wheelDeltaX" in r ? -r.wheelDeltaX : 0;
      },
      deltaY: function (r) {
        return "deltaY" in r ? r.deltaY : "wheelDeltaY" in r ? -r.wheelDeltaY : "wheelDelta" in r ? -r.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }),
    Ka = $r(er),
    ph = [9, 13, 27, 32],
    ks = y && "CompositionEvent" in window,
    Fu = null;
  y && "documentMode" in document && (Fu = document.documentMode);
  var Nu = y && "TextEvent" in window && !Fu,
    dg = y && (!ks || Fu && 8 < Fu && 11 >= Fu),
    fg = " ",
    Ed = !1;
  function pg(r, o) {
    switch (r) {
      case "keyup":
        return ph.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hg(r) {
    return r = r.detail, typeof r == "object" && "data" in r ? r.data : null;
  }
  var Ts = !1;
  function mg(r, o) {
    switch (r) {
      case "compositionend":
        return hg(o);
      case "keypress":
        return o.which !== 32 ? null : (Ed = !0, fg);
      case "textInput":
        return r = o.data, r === fg && Ed ? null : r;
      default:
        return null;
    }
  }
  function _w(r, o) {
    if (Ts) return r === "compositionend" || !ks && pg(r, o) ? (r = rh(), Ss = gd = Ya = null, Ts = !1, r) : null;
    switch (r) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length) return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return dg && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var xw = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function vg(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o === "input" ? !!xw[r.type] : o === "textarea";
  }
  function hh(r, o, d, g) {
    ss(g), o = $u(o, "onChange"), 0 < o.length && (d = new _d("onChange", "change", null, d, g), r.push({
      event: d,
      listeners: o
    }));
  }
  var pa = null,
    Ll = null;
  function gg(r) {
    Al(r, 0);
  }
  function zu(r) {
    var o = Xi(r);
    if (ge(o)) return r;
  }
  function Sw(r, o) {
    if (r === "change") return o;
  }
  var yg = !1;
  if (y) {
    var mh;
    if (y) {
      var vh = "oninput" in document;
      if (!vh) {
        var bg = document.createElement("div");
        bg.setAttribute("oninput", "return;"), vh = typeof bg.oninput == "function";
      }
      mh = vh;
    } else mh = !1;
    yg = mh && (!document.documentMode || 9 < document.documentMode);
  }
  function wg() {
    pa && (pa.detachEvent("onpropertychange", _g), Ll = pa = null);
  }
  function _g(r) {
    if (r.propertyName === "value" && zu(Ll)) {
      var o = [];
      hh(o, Ll, r, sn(r)), Tu(gg, o);
    }
  }
  function Ew(r, o, d) {
    r === "focusin" ? (wg(), pa = o, Ll = d, pa.attachEvent("onpropertychange", _g)) : r === "focusout" && wg();
  }
  function xg(r) {
    if (r === "selectionchange" || r === "keyup" || r === "keydown") return zu(Ll);
  }
  function Cw(r, o) {
    if (r === "click") return zu(o);
  }
  function Sg(r, o) {
    if (r === "input" || r === "change") return zu(o);
  }
  function kw(r, o) {
    return r === o && (r !== 0 || 1 / r === 1 / o) || r !== r && o !== o;
  }
  var Gi = typeof Object.is == "function" ? Object.is : kw;
  function Vu(r, o) {
    if (Gi(r, o)) return !0;
    if (typeof r != "object" || r === null || typeof o != "object" || o === null) return !1;
    var d = Object.keys(r),
      g = Object.keys(o);
    if (d.length !== g.length) return !1;
    for (g = 0; g < d.length; g++) {
      var S = d[g];
      if (!w.call(o, S) || !Gi(r[S], o[S])) return !1;
    }
    return !0;
  }
  function Eg(r) {
    for (; r && r.firstChild;) r = r.firstChild;
    return r;
  }
  function Cd(r, o) {
    var d = Eg(r);
    r = 0;
    for (var g; d;) {
      if (d.nodeType === 3) {
        if (g = r + d.textContent.length, r <= o && g >= o) return {
          node: d,
          offset: o - r
        };
        r = g;
      }
      e: {
        for (; d;) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = Eg(d);
    }
  }
  function Fo(r, o) {
    return r && o ? r === o ? !0 : r && r.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Fo(r, o.parentNode) : "contains" in r ? r.contains(o) : r.compareDocumentPosition ? !!(r.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function Bu() {
    for (var r = window, o = qe(); o instanceof r.HTMLIFrameElement;) {
      try {
        var d = typeof o.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) r = o.contentWindow;else break;
      o = qe(r.document);
    }
    return o;
  }
  function kd(r) {
    var o = r && r.nodeName && r.nodeName.toLowerCase();
    return o && (o === "input" && (r.type === "text" || r.type === "search" || r.type === "tel" || r.type === "url" || r.type === "password") || o === "textarea" || r.contentEditable === "true");
  }
  function Rs(r) {
    var o = Bu(),
      d = r.focusedElem,
      g = r.selectionRange;
    if (o !== d && d && d.ownerDocument && Fo(d.ownerDocument.documentElement, d)) {
      if (g !== null && kd(d)) {
        if (o = g.start, r = g.end, r === void 0 && (r = o), "selectionStart" in d) d.selectionStart = o, d.selectionEnd = Math.min(r, d.value.length);else if (r = (o = d.ownerDocument || document) && o.defaultView || window, r.getSelection) {
          r = r.getSelection();
          var S = d.textContent.length,
            R = Math.min(g.start, S);
          g = g.end === void 0 ? R : Math.min(g.end, S), !r.extend && R > g && (S = g, g = R, R = S), S = Cd(d, R);
          var A = Cd(d, g);
          S && A && (r.rangeCount !== 1 || r.anchorNode !== S.node || r.anchorOffset !== S.offset || r.focusNode !== A.node || r.focusOffset !== A.offset) && (o = o.createRange(), o.setStart(S.node, S.offset), r.removeAllRanges(), R > g ? (r.addRange(o), r.extend(A.node, A.offset)) : (o.setEnd(A.node, A.offset), r.addRange(o)));
        }
      }
      for (o = [], r = d; r = r.parentNode;) r.nodeType === 1 && o.push({
        element: r,
        left: r.scrollLeft,
        top: r.scrollTop
      });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < o.length; d++) r = o[d], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
    }
  }
  var Tw = y && "documentMode" in document && 11 >= document.documentMode,
    Ds = null,
    gh = null,
    Uu = null,
    yh = !1;
  function bh(r, o, d) {
    var g = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    yh || Ds == null || Ds !== qe(g) || (g = Ds, "selectionStart" in g && kd(g) ? g = {
      start: g.selectionStart,
      end: g.selectionEnd
    } : (g = (g.ownerDocument && g.ownerDocument.defaultView || window).getSelection(), g = {
      anchorNode: g.anchorNode,
      anchorOffset: g.anchorOffset,
      focusNode: g.focusNode,
      focusOffset: g.focusOffset
    }), Uu && Vu(Uu, g) || (Uu = g, g = $u(gh, "onSelect"), 0 < g.length && (o = new _d("onSelect", "select", null, o, d), r.push({
      event: o,
      listeners: g
    }), o.target = Ds)));
  }
  function Td(r, o) {
    var d = {};
    return d[r.toLowerCase()] = o.toLowerCase(), d["Webkit" + r] = "webkit" + o, d["Moz" + r] = "moz" + o, d;
  }
  var Ol = {
      animationend: Td("Animation", "AnimationEnd"),
      animationiteration: Td("Animation", "AnimationIteration"),
      animationstart: Td("Animation", "AnimationStart"),
      transitionend: Td("Transition", "TransitionEnd")
    },
    _r = {},
    wh = {};
  y && (wh = document.createElement("div").style, "AnimationEvent" in window || (delete Ol.animationend.animation, delete Ol.animationiteration.animation, delete Ol.animationstart.animation), "TransitionEvent" in window || delete Ol.transitionend.transition);
  function Rd(r) {
    if (_r[r]) return _r[r];
    if (!Ol[r]) return r;
    var o = Ol[r],
      d;
    for (d in o) if (o.hasOwnProperty(d) && d in wh) return _r[r] = o[d];
    return r;
  }
  var Cg = Rd("animationend"),
    kg = Rd("animationiteration"),
    Tg = Rd("animationstart"),
    Rg = Rd("transitionend"),
    _h = /* @__PURE__ */new Map(),
    Dd = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function wi(r, o) {
    _h.set(r, o), p(o, [r]);
  }
  for (var xh = 0; xh < Dd.length; xh++) {
    var Pl = Dd[xh],
      Rw = Pl.toLowerCase(),
      Dw = Pl[0].toUpperCase() + Pl.slice(1);
    wi(Rw, "on" + Dw);
  }
  wi(Cg, "onAnimationEnd"), wi(kg, "onAnimationIteration"), wi(Tg, "onAnimationStart"), wi("dblclick", "onDoubleClick"), wi("focusin", "onFocus"), wi("focusout", "onBlur"), wi(Rg, "onTransitionEnd"), h("onMouseEnter", ["mouseout", "mouseover"]), h("onMouseLeave", ["mouseout", "mouseover"]), h("onPointerEnter", ["pointerout", "pointerover"]), h("onPointerLeave", ["pointerout", "pointerover"]), p("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), p("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), p("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), p("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), p("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Hu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Sh = new Set("cancel close invalid load scroll toggle".split(" ").concat(Hu));
  function Id(r, o, d) {
    var g = r.type || "unknown-event";
    r.currentTarget = d, rn(g, o, void 0, r), r.currentTarget = null;
  }
  function Al(r, o) {
    o = (o & 4) !== 0;
    for (var d = 0; d < r.length; d++) {
      var g = r[d],
        S = g.event;
      g = g.listeners;
      e: {
        var R = void 0;
        if (o) for (var A = g.length - 1; 0 <= A; A--) {
          var q = g[A],
            re = q.instance,
            ye = q.currentTarget;
          if (q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Id(S, q, ye), R = re;
        } else for (A = 0; A < g.length; A++) {
          if (q = g[A], re = q.instance, ye = q.currentTarget, q = q.listener, re !== R && S.isPropagationStopped()) break e;
          Id(S, q, ye), R = re;
        }
      }
    }
    if (Z) throw r = Ne, Z = !1, Ne = null, r;
  }
  function mn(r, o) {
    var d = o[Yu];
    d === void 0 && (d = o[Yu] = /* @__PURE__ */new Set());
    var g = r + "__bubble";
    d.has(g) || (Dg(o, r, 2, !1), d.add(g));
  }
  function Md(r, o, d) {
    var g = 0;
    o && (g |= 4), Dg(d, r, g, o);
  }
  var Ld = "_reactListening" + Math.random().toString(36).slice(2);
  function Is(r) {
    if (!r[Ld]) {
      r[Ld] = !0, s.forEach(function (d) {
        d !== "selectionchange" && (Sh.has(d) || Md(d, !1, r), Md(d, !0, r));
      });
      var o = r.nodeType === 9 ? r : r.ownerDocument;
      o === null || o[Ld] || (o[Ld] = !0, Md("selectionchange", !1, o));
    }
  }
  function Dg(r, o, d, g) {
    switch (vd(o)) {
      case 1:
        var S = ig;
        break;
      case 4:
        S = ag;
        break;
      default:
        S = hd;
    }
    d = S.bind(null, o, d, r), S = void 0, !$i || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (S = !0), g ? S !== void 0 ? r.addEventListener(o, d, {
      capture: !0,
      passive: S
    }) : r.addEventListener(o, d, !0) : S !== void 0 ? r.addEventListener(o, d, {
      passive: S
    }) : r.addEventListener(o, d, !1);
  }
  function Od(r, o, d, g, S) {
    var R = g;
    if ((o & 1) === 0 && (o & 2) === 0 && g !== null) e: for (;;) {
      if (g === null) return;
      var A = g.tag;
      if (A === 3 || A === 4) {
        var q = g.stateNode.containerInfo;
        if (q === S || q.nodeType === 8 && q.parentNode === S) break;
        if (A === 4) for (A = g.return; A !== null;) {
          var re = A.tag;
          if ((re === 3 || re === 4) && (re = A.stateNode.containerInfo, re === S || re.nodeType === 8 && re.parentNode === S)) return;
          A = A.return;
        }
        for (; q !== null;) {
          if (A = Fl(q), A === null) return;
          if (re = A.tag, re === 5 || re === 6) {
            g = R = A;
            continue e;
          }
          q = q.parentNode;
        }
      }
      g = g.return;
    }
    Tu(function () {
      var ye = R,
        Oe = sn(d),
        ze = [];
      e: {
        var Me = _h.get(r);
        if (Me !== void 0) {
          var et = _d,
            it = r;
          switch (r) {
            case "keypress":
              if (yd(d) === 0) break e;
            case "keydown":
            case "keyup":
              et = dh;
              break;
            case "focusin":
              it = "focus", et = xd;
              break;
            case "focusout":
              it = "blur", et = xd;
              break;
            case "beforeblur":
            case "afterblur":
              et = xd;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              et = ah;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              et = Cs;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              et = cg;
              break;
            case Cg:
            case kg:
            case Tg:
              et = yw;
              break;
            case Rg:
              et = Xa;
              break;
            case "scroll":
              et = mw;
              break;
            case "wheel":
              et = Ka;
              break;
            case "copy":
            case "cut":
            case "paste":
              et = og;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              et = ug;
          }
          var lt = (o & 4) !== 0,
            Kn = !lt && r === "scroll",
            pe = lt ? Me !== null ? Me + "Capture" : null : Me;
          lt = [];
          for (var oe = ye, he; oe !== null;) {
            he = oe;
            var He = he.stateNode;
            if (he.tag === 5 && He !== null && (he = He, pe !== null && (He = Ha(oe, pe), He != null && lt.push(Ms(oe, He, he)))), Kn) break;
            oe = oe.return;
          }
          0 < lt.length && (Me = new et(Me, it, null, d, Oe), ze.push({
            event: Me,
            listeners: lt
          }));
        }
      }
      if ((o & 7) === 0) {
        e: {
          if (Me = r === "mouseover" || r === "pointerover", et = r === "mouseout" || r === "pointerout", Me && d !== Ht && (it = d.relatedTarget || d.fromElement) && (Fl(it) || it[Qa])) break e;
          if ((et || Me) && (Me = Oe.window === Oe ? Oe : (Me = Oe.ownerDocument) ? Me.defaultView || Me.parentWindow : window, et ? (it = d.relatedTarget || d.toElement, et = ye, it = it ? Fl(it) : null, it !== null && (Kn = $t(it), it !== Kn || it.tag !== 5 && it.tag !== 6) && (it = null)) : (et = null, it = ye), et !== it)) {
            if (lt = ah, He = "onMouseLeave", pe = "onMouseEnter", oe = "mouse", (r === "pointerout" || r === "pointerover") && (lt = ug, He = "onPointerLeave", pe = "onPointerEnter", oe = "pointer"), Kn = et == null ? Me : Xi(et), he = it == null ? Me : Xi(it), Me = new lt(He, oe + "leave", et, d, Oe), Me.target = Kn, Me.relatedTarget = he, He = null, Fl(Oe) === ye && (lt = new lt(pe, oe + "enter", it, d, Oe), lt.target = he, lt.relatedTarget = Kn, He = lt), Kn = He, et && it) t: {
              for (lt = et, pe = it, oe = 0, he = lt; he; he = No(he)) oe++;
              for (he = 0, He = pe; He; He = No(He)) he++;
              for (; 0 < oe - he;) lt = No(lt), oe--;
              for (; 0 < he - oe;) pe = No(pe), he--;
              for (; oe--;) {
                if (lt === pe || pe !== null && lt === pe.alternate) break t;
                lt = No(lt), pe = No(pe);
              }
              lt = null;
            } else lt = null;
            et !== null && Ig(ze, Me, et, lt, !1), it !== null && Kn !== null && Ig(ze, Kn, it, lt, !0);
          }
        }
        e: {
          if (Me = ye ? Xi(ye) : window, et = Me.nodeName && Me.nodeName.toLowerCase(), et === "select" || et === "input" && Me.type === "file") var ut = Sw;else if (vg(Me)) {
            if (yg) ut = Sg;else {
              ut = xg;
              var bt = Ew;
            }
          } else (et = Me.nodeName) && et.toLowerCase() === "input" && (Me.type === "checkbox" || Me.type === "radio") && (ut = Cw);
          if (ut && (ut = ut(r, ye))) {
            hh(ze, ut, d, Oe);
            break e;
          }
          bt && bt(r, Me, ye), r === "focusout" && (bt = Me._wrapperState) && bt.controlled && Me.type === "number" && Pt(Me, "number", Me.value);
        }
        switch (bt = ye ? Xi(ye) : window, r) {
          case "focusin":
            (vg(bt) || bt.contentEditable === "true") && (Ds = bt, gh = ye, Uu = null);
            break;
          case "focusout":
            Uu = gh = Ds = null;
            break;
          case "mousedown":
            yh = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            yh = !1, bh(ze, d, Oe);
            break;
          case "selectionchange":
            if (Tw) break;
          case "keydown":
          case "keyup":
            bh(ze, d, Oe);
        }
        var wt;
        if (ks) e: {
          switch (r) {
            case "compositionstart":
              var It = "onCompositionStart";
              break e;
            case "compositionend":
              It = "onCompositionEnd";
              break e;
            case "compositionupdate":
              It = "onCompositionUpdate";
              break e;
          }
          It = void 0;
        } else Ts ? pg(r, d) && (It = "onCompositionEnd") : r === "keydown" && d.keyCode === 229 && (It = "onCompositionStart");
        It && (dg && d.locale !== "ko" && (Ts || It !== "onCompositionStart" ? It === "onCompositionEnd" && Ts && (wt = rh()) : (Ya = Oe, gd = "value" in Ya ? Ya.value : Ya.textContent, Ts = !0)), bt = $u(ye, It), 0 < bt.length && (It = new sh(It, r, null, d, Oe), ze.push({
          event: It,
          listeners: bt
        }), wt ? It.data = wt : (wt = hg(d), wt !== null && (It.data = wt)))), (wt = Nu ? mg(r, d) : _w(r, d)) && (ye = $u(ye, "onBeforeInput"), 0 < ye.length && (Oe = new sh("onBeforeInput", "beforeinput", null, d, Oe), ze.push({
          event: Oe,
          listeners: ye
        }), Oe.data = wt));
      }
      Al(ze, o);
    });
  }
  function Ms(r, o, d) {
    return {
      instance: r,
      listener: o,
      currentTarget: d
    };
  }
  function $u(r, o) {
    for (var d = o + "Capture", g = []; r !== null;) {
      var S = r,
        R = S.stateNode;
      S.tag === 5 && R !== null && (S = R, R = Ha(r, d), R != null && g.unshift(Ms(r, R, S)), R = Ha(r, o), R != null && g.push(Ms(r, R, S))), r = r.return;
    }
    return g;
  }
  function No(r) {
    if (r === null) return null;
    do r = r.return; while (r && r.tag !== 5);
    return r || null;
  }
  function Ig(r, o, d, g, S) {
    for (var R = o._reactName, A = []; d !== null && d !== g;) {
      var q = d,
        re = q.alternate,
        ye = q.stateNode;
      if (re !== null && re === g) break;
      q.tag === 5 && ye !== null && (q = ye, S ? (re = Ha(d, R), re != null && A.unshift(Ms(d, re, q))) : S || (re = Ha(d, R), re != null && A.push(Ms(d, re, q)))), d = d.return;
    }
    A.length !== 0 && r.push({
      event: o,
      listeners: A
    });
  }
  var Mg = /\r\n?/g,
    Iw = /\u0000|\uFFFD/g;
  function Lg(r) {
    return (typeof r == "string" ? r : "" + r).replace(Mg, `
`).replace(Iw, "");
  }
  function Pd(r, o, d) {
    if (o = Lg(o), Lg(r) !== o && d) throw Error(i(425));
  }
  function zo() {}
  var Wu = null,
    jl = null;
  function Ad(r, o) {
    return r === "textarea" || r === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var jd = typeof setTimeout == "function" ? setTimeout : void 0,
    Eh = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Og = typeof Promise == "function" ? Promise : void 0,
    Ls = typeof queueMicrotask == "function" ? queueMicrotask : typeof Og < "u" ? function (r) {
      return Og.resolve(null).then(r).catch(Fd);
    } : jd;
  function Fd(r) {
    setTimeout(function () {
      throw r;
    });
  }
  function Os(r, o) {
    var d = o,
      g = 0;
    do {
      var S = d.nextSibling;
      if (r.removeChild(d), S && S.nodeType === 8) if (d = S.data, d === "/$") {
        if (g === 0) {
          r.removeChild(S), jo(o);
          return;
        }
        g--;
      } else d !== "$" && d !== "$?" && d !== "$!" || g++;
      d = S;
    } while (d);
    jo(o);
  }
  function ha(r) {
    for (; r != null; r = r.nextSibling) {
      var o = r.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = r.data, o === "$" || o === "$!" || o === "$?") break;
        if (o === "/$") return null;
      }
    }
    return r;
  }
  function Pg(r) {
    r = r.previousSibling;
    for (var o = 0; r;) {
      if (r.nodeType === 8) {
        var d = r.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (o === 0) return r;
          o--;
        } else d === "/$" && o++;
      }
      r = r.previousSibling;
    }
    return null;
  }
  var Vo = Math.random().toString(36).slice(2),
    ma = "__reactFiber$" + Vo,
    qu = "__reactProps$" + Vo,
    Qa = "__reactContainer$" + Vo,
    Yu = "__reactEvents$" + Vo,
    Ps = "__reactListeners$" + Vo,
    Mw = "__reactHandles$" + Vo;
  function Fl(r) {
    var o = r[ma];
    if (o) return o;
    for (var d = r.parentNode; d;) {
      if (o = d[Qa] || d[ma]) {
        if (d = o.alternate, o.child !== null || d !== null && d.child !== null) for (r = Pg(r); r !== null;) {
          if (d = r[ma]) return d;
          r = Pg(r);
        }
        return o;
      }
      r = d, d = r.parentNode;
    }
    return null;
  }
  function pt(r) {
    return r = r[ma] || r[Qa], !r || r.tag !== 5 && r.tag !== 6 && r.tag !== 13 && r.tag !== 3 ? null : r;
  }
  function Xi(r) {
    if (r.tag === 5 || r.tag === 6) return r.stateNode;
    throw Error(i(33));
  }
  function Gn(r) {
    return r[qu] || null;
  }
  var tn = [],
    _i = -1;
  function Ki(r) {
    return {
      current: r
    };
  }
  function Sn(r) {
    0 > _i || (r.current = tn[_i], tn[_i] = null, _i--);
  }
  function ft(r, o) {
    _i++, tn[_i] = r.current, r.current = o;
  }
  var qr = {},
    Hn = Ki(qr),
    or = Ki(!1),
    Yr = qr;
  function xi(r, o) {
    var d = r.type.contextTypes;
    if (!d) return qr;
    var g = r.stateNode;
    if (g && g.__reactInternalMemoizedUnmaskedChildContext === o) return g.__reactInternalMemoizedMaskedChildContext;
    var S = {},
      R;
    for (R in d) S[R] = o[R];
    return g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = o, r.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function tr(r) {
    return r = r.childContextTypes, r != null;
  }
  function As() {
    Sn(or), Sn(Hn);
  }
  function Ag(r, o, d) {
    if (Hn.current !== qr) throw Error(i(168));
    ft(Hn, o), ft(or, d);
  }
  function Gu(r, o, d) {
    var g = r.stateNode;
    if (o = o.childContextTypes, typeof g.getChildContext != "function") return d;
    g = g.getChildContext();
    for (var S in g) if (!(S in o)) throw Error(i(108, Se(r) || "Unknown", S));
    return H({}, d, g);
  }
  function Gr(r) {
    return r = (r = r.stateNode) && r.__reactInternalMemoizedMergedChildContext || qr, Yr = Hn.current, ft(Hn, r), ft(or, or.current), !0;
  }
  function Nd(r, o, d) {
    var g = r.stateNode;
    if (!g) throw Error(i(169));
    d ? (r = Gu(r, o, Yr), g.__reactInternalMemoizedMergedChildContext = r, Sn(or), Sn(Hn), ft(Hn, r)) : Sn(or), ft(or, d);
  }
  var va = null,
    js = !1,
    Za = !1;
  function zd(r) {
    va === null ? va = [r] : va.push(r);
  }
  function Bo(r) {
    js = !0, zd(r);
  }
  function ga() {
    if (!Za && va !== null) {
      Za = !0;
      var r = 0,
        o = gn;
      try {
        var d = va;
        for (gn = 1; r < d.length; r++) {
          var g = d[r];
          do g = g(!0); while (g !== null);
        }
        va = null, js = !1;
      } catch (S) {
        throw va !== null && (va = va.slice(r + 1)), Or(El, ga), S;
      } finally {
        gn = o, Za = !1;
      }
    }
    return null;
  }
  var Uo = [],
    Ho = 0,
    $o = null,
    Ja = 0,
    nr = [],
    Si = 0,
    li = null,
    ya = 1,
    ba = "";
  function Nl(r, o) {
    Uo[Ho++] = Ja, Uo[Ho++] = $o, $o = r, Ja = o;
  }
  function jg(r, o, d) {
    nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = li, li = r;
    var g = ya;
    r = ba;
    var S = 32 - gi(g) - 1;
    g &= ~(1 << S), d += 1;
    var R = 32 - gi(o) + S;
    if (30 < R) {
      var A = S - S % 5;
      R = (g & (1 << A) - 1).toString(32), g >>= A, S -= A, ya = 1 << 32 - gi(o) + S | d << S | g, ba = R + r;
    } else ya = 1 << R | d << S | g, ba = r;
  }
  function Vd(r) {
    r.return !== null && (Nl(r, 1), jg(r, 1, 0));
  }
  function Bd(r) {
    for (; r === $o;) $o = Uo[--Ho], Uo[Ho] = null, Ja = Uo[--Ho], Uo[Ho] = null;
    for (; r === li;) li = nr[--Si], nr[Si] = null, ba = nr[--Si], nr[Si] = null, ya = nr[--Si], nr[Si] = null;
  }
  var Xr = null,
    Kr = null,
    In = !1,
    Ei = null;
  function Ch(r, o) {
    var d = Oi(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = o, d.return = r, o = r.deletions, o === null ? (r.deletions = [d], r.flags |= 16) : o.push(d);
  }
  function Fg(r, o) {
    switch (r.tag) {
      case 5:
        var d = r.type;
        return o = o.nodeType !== 1 || d.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = ha(o.firstChild), !0) : !1;
      case 6:
        return o = r.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (r.stateNode = o, Xr = r, Kr = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (d = li !== null ? {
          id: ya,
          overflow: ba
        } : null, r.memoizedState = {
          dehydrated: o,
          treeContext: d,
          retryLane: 1073741824
        }, d = Oi(18, null, null, 0), d.stateNode = o, d.return = r, r.child = d, Xr = r, Kr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function kh(r) {
    return (r.mode & 1) !== 0 && (r.flags & 128) === 0;
  }
  function Th(r) {
    if (In) {
      var o = Kr;
      if (o) {
        var d = o;
        if (!Fg(r, o)) {
          if (kh(r)) throw Error(i(418));
          o = ha(d.nextSibling);
          var g = Xr;
          o && Fg(r, o) ? Ch(g, d) : (r.flags = r.flags & -4097 | 2, In = !1, Xr = r);
        }
      } else {
        if (kh(r)) throw Error(i(418));
        r.flags = r.flags & -4097 | 2, In = !1, Xr = r;
      }
    }
  }
  function lr(r) {
    for (r = r.return; r !== null && r.tag !== 5 && r.tag !== 3 && r.tag !== 13;) r = r.return;
    Xr = r;
  }
  function Ud(r) {
    if (r !== Xr) return !1;
    if (!In) return lr(r), In = !0, !1;
    var o;
    if ((o = r.tag !== 3) && !(o = r.tag !== 5) && (o = r.type, o = o !== "head" && o !== "body" && !Ad(r.type, r.memoizedProps)), o && (o = Kr)) {
      if (kh(r)) throw Xu(), Error(i(418));
      for (; o;) Ch(r, o), o = ha(o.nextSibling);
    }
    if (lr(r), r.tag === 13) {
      if (r = r.memoizedState, r = r !== null ? r.dehydrated : null, !r) throw Error(i(317));
      e: {
        for (r = r.nextSibling, o = 0; r;) {
          if (r.nodeType === 8) {
            var d = r.data;
            if (d === "/$") {
              if (o === 0) {
                Kr = ha(r.nextSibling);
                break e;
              }
              o--;
            } else d !== "$" && d !== "$!" && d !== "$?" || o++;
          }
          r = r.nextSibling;
        }
        Kr = null;
      }
    } else Kr = Xr ? ha(r.stateNode.nextSibling) : null;
    return !0;
  }
  function Xu() {
    for (var r = Kr; r;) r = ha(r.nextSibling);
  }
  function Wo() {
    Kr = Xr = null, In = !1;
  }
  function eo(r) {
    Ei === null ? Ei = [r] : Ei.push(r);
  }
  var Lw = j.ReactCurrentBatchConfig;
  function si(r, o) {
    if (r && r.defaultProps) {
      o = H({}, o), r = r.defaultProps;
      for (var d in r) o[d] === void 0 && (o[d] = r[d]);
      return o;
    }
    return o;
  }
  var Hd = Ki(null),
    $d = null,
    Qi = null,
    dr = null;
  function Ge() {
    dr = Qi = $d = null;
  }
  function Ci(r) {
    var o = Hd.current;
    Sn(Hd), r._currentValue = o;
  }
  function ui(r, o, d) {
    for (; r !== null;) {
      var g = r.alternate;
      if ((r.childLanes & o) !== o ? (r.childLanes |= o, g !== null && (g.childLanes |= o)) : g !== null && (g.childLanes & o) !== o && (g.childLanes |= o), r === d) break;
      r = r.return;
    }
  }
  function Fs(r, o) {
    $d = r, dr = Qi = null, r = r.dependencies, r !== null && r.firstContext !== null && ((r.lanes & o) !== 0 && (Dr = !0), r.firstContext = null);
  }
  function ki(r) {
    var o = r._currentValue;
    if (dr !== r) if (r = {
      context: r,
      memoizedValue: o,
      next: null
    }, Qi === null) {
      if ($d === null) throw Error(i(308));
      Qi = r, $d.dependencies = {
        lanes: 0,
        firstContext: r
      };
    } else Qi = Qi.next = r;
    return o;
  }
  var zl = null;
  function Rh(r) {
    zl === null ? zl = [r] : zl.push(r);
  }
  function Ng(r, o, d, g) {
    var S = o.interleaved;
    return S === null ? (d.next = d, Rh(o)) : (d.next = S.next, S.next = d), o.interleaved = d, En(r, g);
  }
  function En(r, o) {
    r.lanes |= o;
    var d = r.alternate;
    for (d !== null && (d.lanes |= o), d = r, r = r.return; r !== null;) r.childLanes |= o, d = r.alternate, d !== null && (d.childLanes |= o), d = r, r = r.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var qo = !1;
  function Dh(r) {
    r.updateQueue = {
      baseState: r.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        interleaved: null,
        lanes: 0
      },
      effects: null
    };
  }
  function zg(r, o) {
    r = r.updateQueue, o.updateQueue === r && (o.updateQueue = {
      baseState: r.baseState,
      firstBaseUpdate: r.firstBaseUpdate,
      lastBaseUpdate: r.lastBaseUpdate,
      shared: r.shared,
      effects: r.effects
    });
  }
  function wa(r, o) {
    return {
      eventTime: r,
      lane: o,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function Ti(r, o, d) {
    var g = r.updateQueue;
    if (g === null) return null;
    if (g = g.shared, (on & 2) !== 0) {
      var S = g.pending;
      return S === null ? o.next = o : (o.next = S.next, S.next = o), g.pending = o, En(r, d);
    }
    return S = g.interleaved, S === null ? (o.next = o, Rh(g)) : (o.next = S.next, S.next = o), g.interleaved = o, En(r, d);
  }
  function to(r, o, d) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (d & 4194240) !== 0)) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, pd(r, d);
    }
  }
  function Vg(r, o) {
    var d = r.updateQueue,
      g = r.alternate;
    if (g !== null && (g = g.updateQueue, d === g)) {
      var S = null,
        R = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var A = {
            eventTime: d.eventTime,
            lane: d.lane,
            tag: d.tag,
            payload: d.payload,
            callback: d.callback,
            next: null
          };
          R === null ? S = R = A : R = R.next = A, d = d.next;
        } while (d !== null);
        R === null ? S = R = o : R = R.next = o;
      } else S = R = o;
      d = {
        baseState: g.baseState,
        firstBaseUpdate: S,
        lastBaseUpdate: R,
        shared: g.shared,
        effects: g.effects
      }, r.updateQueue = d;
      return;
    }
    r = d.lastBaseUpdate, r === null ? d.firstBaseUpdate = o : r.next = o, d.lastBaseUpdate = o;
  }
  function Wd(r, o, d, g) {
    var S = r.updateQueue;
    qo = !1;
    var R = S.firstBaseUpdate,
      A = S.lastBaseUpdate,
      q = S.shared.pending;
    if (q !== null) {
      S.shared.pending = null;
      var re = q,
        ye = re.next;
      re.next = null, A === null ? R = ye : A.next = ye, A = re;
      var Oe = r.alternate;
      Oe !== null && (Oe = Oe.updateQueue, q = Oe.lastBaseUpdate, q !== A && (q === null ? Oe.firstBaseUpdate = ye : q.next = ye, Oe.lastBaseUpdate = re));
    }
    if (R !== null) {
      var ze = S.baseState;
      A = 0, Oe = ye = re = null, q = R;
      do {
        var Me = q.lane,
          et = q.eventTime;
        if ((g & Me) === Me) {
          Oe !== null && (Oe = Oe.next = {
            eventTime: et,
            lane: 0,
            tag: q.tag,
            payload: q.payload,
            callback: q.callback,
            next: null
          });
          e: {
            var it = r,
              lt = q;
            switch (Me = o, et = d, lt.tag) {
              case 1:
                if (it = lt.payload, typeof it == "function") {
                  ze = it.call(et, ze, Me);
                  break e;
                }
                ze = it;
                break e;
              case 3:
                it.flags = it.flags & -65537 | 128;
              case 0:
                if (it = lt.payload, Me = typeof it == "function" ? it.call(et, ze, Me) : it, Me == null) break e;
                ze = H({}, ze, Me);
                break e;
              case 2:
                qo = !0;
            }
          }
          q.callback !== null && q.lane !== 0 && (r.flags |= 64, Me = S.effects, Me === null ? S.effects = [q] : Me.push(q));
        } else et = {
          eventTime: et,
          lane: Me,
          tag: q.tag,
          payload: q.payload,
          callback: q.callback,
          next: null
        }, Oe === null ? (ye = Oe = et, re = ze) : Oe = Oe.next = et, A |= Me;
        if (q = q.next, q === null) {
          if (q = S.shared.pending, q === null) break;
          Me = q, q = Me.next, Me.next = null, S.lastBaseUpdate = Me, S.shared.pending = null;
        }
      } while (!0);
      if (Oe === null && (re = ze), S.baseState = re, S.firstBaseUpdate = ye, S.lastBaseUpdate = Oe, o = S.shared.interleaved, o !== null) {
        S = o;
        do A |= S.lane, S = S.next; while (S !== o);
      } else R === null && (S.shared.lanes = 0);
      xo |= A, r.lanes = A, r.memoizedState = ze;
    }
  }
  function Bg(r, o, d) {
    if (r = o.effects, o.effects = null, r !== null) for (o = 0; o < r.length; o++) {
      var g = r[o],
        S = g.callback;
      if (S !== null) {
        if (g.callback = null, g = d, typeof S != "function") throw Error(i(191, S));
        S.call(g);
      }
    }
  }
  var Ug = new t.Component().refs;
  function Ih(r, o, d, g) {
    o = r.memoizedState, d = d(g, o), d = d == null ? o : H({}, o, d), r.memoizedState = d, r.lanes === 0 && (r.updateQueue.baseState = d);
  }
  var qd = {
    isMounted: function (r) {
      return (r = r._reactInternals) ? $t(r) === r : !1;
    },
    enqueueSetState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Li(o, r, S, g), to(o, r, S));
    },
    enqueueReplaceState: function (r, o, d) {
      r = r._reactInternals;
      var g = hr(),
        S = Ca(r),
        R = wa(g, S);
      R.tag = 1, R.payload = o, d != null && (R.callback = d), o = Ti(r, R, S), o !== null && (Li(o, r, S, g), to(o, r, S));
    },
    enqueueForceUpdate: function (r, o) {
      r = r._reactInternals;
      var d = hr(),
        g = Ca(r),
        S = wa(d, g);
      S.tag = 2, o != null && (S.callback = o), o = Ti(r, S, g), o !== null && (Li(o, r, g, d), to(o, r, g));
    }
  };
  function Mh(r, o, d, g, S, R, A) {
    return r = r.stateNode, typeof r.shouldComponentUpdate == "function" ? r.shouldComponentUpdate(g, R, A) : o.prototype && o.prototype.isPureReactComponent ? !Vu(d, g) || !Vu(S, R) : !0;
  }
  function Lh(r, o, d) {
    var g = !1,
      S = qr,
      R = o.contextType;
    return typeof R == "object" && R !== null ? R = ki(R) : (S = tr(o) ? Yr : Hn.current, g = o.contextTypes, R = (g = g != null) ? xi(r, S) : qr), o = new o(d, R), r.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = qd, r.stateNode = o, o._reactInternals = r, g && (r = r.stateNode, r.__reactInternalMemoizedUnmaskedChildContext = S, r.__reactInternalMemoizedMaskedChildContext = R), o;
  }
  function Hg(r, o, d, g) {
    r = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(d, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(d, g), o.state !== r && qd.enqueueReplaceState(o, o.state, null);
  }
  function Oh(r, o, d, g) {
    var S = r.stateNode;
    S.props = d, S.state = r.memoizedState, S.refs = Ug, Dh(r);
    var R = o.contextType;
    typeof R == "object" && R !== null ? S.context = ki(R) : (R = tr(o) ? Yr : Hn.current, S.context = xi(r, R)), S.state = r.memoizedState, R = o.getDerivedStateFromProps, typeof R == "function" && (Ih(r, o, R, d), S.state = r.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (o = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), o !== S.state && qd.enqueueReplaceState(S, S.state, null), Wd(r, d, S, g), S.state = r.memoizedState), typeof S.componentDidMount == "function" && (r.flags |= 4194308);
  }
  function Ku(r, o, d) {
    if (r = d.ref, r !== null && typeof r != "function" && typeof r != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var g = d.stateNode;
        }
        if (!g) throw Error(i(147, r));
        var S = g,
          R = "" + r;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === R ? o.ref : (o = function (A) {
          var q = S.refs;
          q === Ug && (q = S.refs = {}), A === null ? delete q[R] : q[R] = A;
        }, o._stringRef = R, o);
      }
      if (typeof r != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, r));
    }
    return r;
  }
  function Yd(r, o) {
    throw r = Object.prototype.toString.call(o), Error(i(31, r === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : r));
  }
  function $g(r) {
    var o = r._init;
    return o(r._payload);
  }
  function Wg(r) {
    function o(pe, oe) {
      if (r) {
        var he = pe.deletions;
        he === null ? (pe.deletions = [oe], pe.flags |= 16) : he.push(oe);
      }
    }
    function d(pe, oe) {
      if (!r) return null;
      for (; oe !== null;) o(pe, oe), oe = oe.sibling;
      return null;
    }
    function g(pe, oe) {
      for (pe = /* @__PURE__ */new Map(); oe !== null;) oe.key !== null ? pe.set(oe.key, oe) : pe.set(oe.index, oe), oe = oe.sibling;
      return pe;
    }
    function S(pe, oe) {
      return pe = La(pe, oe), pe.index = 0, pe.sibling = null, pe;
    }
    function R(pe, oe, he) {
      return pe.index = he, r ? (he = pe.alternate, he !== null ? (he = he.index, he < oe ? (pe.flags |= 2, oe) : he) : (pe.flags |= 2, oe)) : (pe.flags |= 1048576, oe);
    }
    function A(pe) {
      return r && pe.alternate === null && (pe.flags |= 2), pe;
    }
    function q(pe, oe, he, He) {
      return oe === null || oe.tag !== 6 ? (oe = gf(he, pe.mode, He), oe.return = pe, oe) : (oe = S(oe, he), oe.return = pe, oe);
    }
    function re(pe, oe, he, He) {
      var ut = he.type;
      return ut === G ? Oe(pe, oe, he.props.children, He, he.key) : oe !== null && (oe.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ce && $g(ut) === oe.type) ? (He = S(oe, he.props), He.ref = Ku(pe, oe, he), He.return = pe, He) : (He = Jl(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, oe, he), He.return = pe, He);
    }
    function ye(pe, oe, he, He) {
      return oe === null || oe.tag !== 4 || oe.stateNode.containerInfo !== he.containerInfo || oe.stateNode.implementation !== he.implementation ? (oe = yf(he, pe.mode, He), oe.return = pe, oe) : (oe = S(oe, he.children || []), oe.return = pe, oe);
    }
    function Oe(pe, oe, he, He, ut) {
      return oe === null || oe.tag !== 7 ? (oe = oo(he, pe.mode, He, ut), oe.return = pe, oe) : (oe = S(oe, he), oe.return = pe, oe);
    }
    function ze(pe, oe, he) {
      if (typeof oe == "string" && oe !== "" || typeof oe == "number") return oe = gf("" + oe, pe.mode, he), oe.return = pe, oe;
      if (typeof oe == "object" && oe !== null) {
        switch (oe.$$typeof) {
          case V:
            return he = Jl(oe.type, oe.key, oe.props, null, pe.mode, he), he.ref = Ku(pe, null, oe), he.return = pe, he;
          case K:
            return oe = yf(oe, pe.mode, he), oe.return = pe, oe;
          case ce:
            var He = oe._init;
            return ze(pe, He(oe._payload), he);
        }
        if (St(oe) || de(oe)) return oe = oo(oe, pe.mode, he, null), oe.return = pe, oe;
        Yd(pe, oe);
      }
      return null;
    }
    function Me(pe, oe, he, He) {
      var ut = oe !== null ? oe.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number") return ut !== null ? null : q(pe, oe, "" + he, He);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            return he.key === ut ? re(pe, oe, he, He) : null;
          case K:
            return he.key === ut ? ye(pe, oe, he, He) : null;
          case ce:
            return ut = he._init, Me(pe, oe, ut(he._payload), He);
        }
        if (St(he) || de(he)) return ut !== null ? null : Oe(pe, oe, he, He, null);
        Yd(pe, he);
      }
      return null;
    }
    function et(pe, oe, he, He, ut) {
      if (typeof He == "string" && He !== "" || typeof He == "number") return pe = pe.get(he) || null, q(oe, pe, "" + He, ut);
      if (typeof He == "object" && He !== null) {
        switch (He.$$typeof) {
          case V:
            return pe = pe.get(He.key === null ? he : He.key) || null, re(oe, pe, He, ut);
          case K:
            return pe = pe.get(He.key === null ? he : He.key) || null, ye(oe, pe, He, ut);
          case ce:
            var bt = He._init;
            return et(pe, oe, he, bt(He._payload), ut);
        }
        if (St(He) || de(He)) return pe = pe.get(he) || null, Oe(oe, pe, He, ut, null);
        Yd(oe, He);
      }
      return null;
    }
    function it(pe, oe, he, He) {
      for (var ut = null, bt = null, wt = oe, It = oe = 0, mr = null; wt !== null && It < he.length; It++) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var cn = Me(pe, wt, he[It], He);
        if (cn === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && cn.alternate === null && o(pe, wt), oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn, wt = mr;
      }
      if (It === he.length) return d(pe, wt), In && Nl(pe, It), ut;
      if (wt === null) {
        for (; It < he.length; It++) wt = ze(pe, he[It], He), wt !== null && (oe = R(wt, oe, It), bt === null ? ut = wt : bt.sibling = wt, bt = wt);
        return In && Nl(pe, It), ut;
      }
      for (wt = g(pe, wt); It < he.length; It++) mr = et(wt, pe, It, he[It], He), mr !== null && (r && mr.alternate !== null && wt.delete(mr.key === null ? It : mr.key), oe = R(mr, oe, It), bt === null ? ut = mr : bt.sibling = mr, bt = mr);
      return r && wt.forEach(function (lo) {
        return o(pe, lo);
      }), In && Nl(pe, It), ut;
    }
    function lt(pe, oe, he, He) {
      var ut = de(he);
      if (typeof ut != "function") throw Error(i(150));
      if (he = ut.call(he), he == null) throw Error(i(151));
      for (var bt = ut = null, wt = oe, It = oe = 0, mr = null, cn = he.next(); wt !== null && !cn.done; It++, cn = he.next()) {
        wt.index > It ? (mr = wt, wt = null) : mr = wt.sibling;
        var lo = Me(pe, wt, cn.value, He);
        if (lo === null) {
          wt === null && (wt = mr);
          break;
        }
        r && wt && lo.alternate === null && o(pe, wt), oe = R(lo, oe, It), bt === null ? ut = lo : bt.sibling = lo, bt = lo, wt = mr;
      }
      if (cn.done) return d(pe, wt), In && Nl(pe, It), ut;
      if (wt === null) {
        for (; !cn.done; It++, cn = he.next()) cn = ze(pe, cn.value, He), cn !== null && (oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
        return In && Nl(pe, It), ut;
      }
      for (wt = g(pe, wt); !cn.done; It++, cn = he.next()) cn = et(wt, pe, It, cn.value, He), cn !== null && (r && cn.alternate !== null && wt.delete(cn.key === null ? It : cn.key), oe = R(cn, oe, It), bt === null ? ut = cn : bt.sibling = cn, bt = cn);
      return r && wt.forEach(function (Pb) {
        return o(pe, Pb);
      }), In && Nl(pe, It), ut;
    }
    function Kn(pe, oe, he, He) {
      if (typeof he == "object" && he !== null && he.type === G && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case V:
            e: {
              for (var ut = he.key, bt = oe; bt !== null;) {
                if (bt.key === ut) {
                  if (ut = he.type, ut === G) {
                    if (bt.tag === 7) {
                      d(pe, bt.sibling), oe = S(bt, he.props.children), oe.return = pe, pe = oe;
                      break e;
                    }
                  } else if (bt.elementType === ut || typeof ut == "object" && ut !== null && ut.$$typeof === ce && $g(ut) === bt.type) {
                    d(pe, bt.sibling), oe = S(bt, he.props), oe.ref = Ku(pe, bt, he), oe.return = pe, pe = oe;
                    break e;
                  }
                  d(pe, bt);
                  break;
                } else o(pe, bt);
                bt = bt.sibling;
              }
              he.type === G ? (oe = oo(he.props.children, pe.mode, He, he.key), oe.return = pe, pe = oe) : (He = Jl(he.type, he.key, he.props, null, pe.mode, He), He.ref = Ku(pe, oe, he), He.return = pe, pe = He);
            }
            return A(pe);
          case K:
            e: {
              for (bt = he.key; oe !== null;) {
                if (oe.key === bt) {
                  if (oe.tag === 4 && oe.stateNode.containerInfo === he.containerInfo && oe.stateNode.implementation === he.implementation) {
                    d(pe, oe.sibling), oe = S(oe, he.children || []), oe.return = pe, pe = oe;
                    break e;
                  } else {
                    d(pe, oe);
                    break;
                  }
                } else o(pe, oe);
                oe = oe.sibling;
              }
              oe = yf(he, pe.mode, He), oe.return = pe, pe = oe;
            }
            return A(pe);
          case ce:
            return bt = he._init, Kn(pe, oe, bt(he._payload), He);
        }
        if (St(he)) return it(pe, oe, he, He);
        if (de(he)) return lt(pe, oe, he, He);
        Yd(pe, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" ? (he = "" + he, oe !== null && oe.tag === 6 ? (d(pe, oe.sibling), oe = S(oe, he), oe.return = pe, pe = oe) : (d(pe, oe), oe = gf(he, pe.mode, He), oe.return = pe, pe = oe), A(pe)) : d(pe, oe);
    }
    return Kn;
  }
  var Vl = Wg(!0),
    qg = Wg(!1),
    Ns = {},
    _a = Ki(Ns),
    Qu = Ki(Ns),
    Bl = Ki(Ns);
  function dt(r) {
    if (r === Ns) throw Error(i(174));
    return r;
  }
  function Wt(r, o) {
    switch (ft(Bl, o), ft(Qu, r), ft(_a, Ns), r = o.nodeType, r) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : Xt(null, "");
        break;
      default:
        r = r === 8 ? o.parentNode : o, o = r.namespaceURI || null, r = r.tagName, o = Xt(o, r);
    }
    Sn(_a), ft(_a, o);
  }
  function nn() {
    Sn(_a), Sn(Qu), Sn(Bl);
  }
  function Xn(r) {
    dt(Bl.current);
    var o = dt(_a.current),
      d = Xt(o, r.type);
    o !== d && (ft(Qu, r), ft(_a, d));
  }
  function Ri(r) {
    Qu.current === r && (Sn(_a), Sn(Qu));
  }
  var Mn = Ki(0);
  function Gd(r) {
    for (var o = r; o !== null;) {
      if (o.tag === 13) {
        var d = o.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if ((o.flags & 128) !== 0) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === r) break;
      for (; o.sibling === null;) {
        if (o.return === null || o.return === r) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Ph = [];
  function Ah() {
    for (var r = 0; r < Ph.length; r++) Ph[r]._workInProgressVersionPrimary = null;
    Ph.length = 0;
  }
  var zs = j.ReactCurrentDispatcher,
    Re = j.ReactCurrentBatchConfig,
    Ln = 0,
    Je = null,
    On = null,
    Cn = null,
    xa = !1,
    Qr = !1,
    no = 0,
    Vs = 0;
  function rr() {
    throw Error(i(321));
  }
  function Zu(r, o) {
    if (o === null) return !1;
    for (var d = 0; d < o.length && d < r.length; d++) if (!Gi(r[d], o[d])) return !1;
    return !0;
  }
  function Ju(r, o, d, g, S, R) {
    if (Ln = R, Je = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, zs.current = r === null || r.memoizedState === null ? Pw : Fh, r = d(g, S), Qr) {
      R = 0;
      do {
        if (Qr = !1, no = 0, 25 <= R) throw Error(i(301));
        R += 1, Cn = On = null, o.updateQueue = null, zs.current = Qg, r = d(g, S);
      } while (Qr);
    }
    if (zs.current = qs, o = On !== null && On.next !== null, Ln = 0, Cn = On = Je = null, xa = !1, o) throw Error(i(300));
    return r;
  }
  function ec() {
    var r = no !== 0;
    return no = 0, r;
  }
  function Di() {
    var r = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r, Cn;
  }
  function Zr() {
    if (On === null) {
      var r = Je.alternate;
      r = r !== null ? r.memoizedState : null;
    } else r = On.next;
    var o = Cn === null ? Je.memoizedState : Cn.next;
    if (o !== null) Cn = o, On = r;else {
      if (r === null) throw Error(i(310));
      On = r, r = {
        memoizedState: On.memoizedState,
        baseState: On.baseState,
        baseQueue: On.baseQueue,
        queue: On.queue,
        next: null
      }, Cn === null ? Je.memoizedState = Cn = r : Cn = Cn.next = r;
    }
    return Cn;
  }
  function Ul(r, o) {
    return typeof o == "function" ? o(r) : o;
  }
  function tc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = On,
      S = g.baseQueue,
      R = d.pending;
    if (R !== null) {
      if (S !== null) {
        var A = S.next;
        S.next = R.next, R.next = A;
      }
      g.baseQueue = S = R, d.pending = null;
    }
    if (S !== null) {
      R = S.next, g = g.baseState;
      var q = A = null,
        re = null,
        ye = R;
      do {
        var Oe = ye.lane;
        if ((Ln & Oe) === Oe) re !== null && (re = re.next = {
          lane: 0,
          action: ye.action,
          hasEagerState: ye.hasEagerState,
          eagerState: ye.eagerState,
          next: null
        }), g = ye.hasEagerState ? ye.eagerState : r(g, ye.action);else {
          var ze = {
            lane: Oe,
            action: ye.action,
            hasEagerState: ye.hasEagerState,
            eagerState: ye.eagerState,
            next: null
          };
          re === null ? (q = re = ze, A = g) : re = re.next = ze, Je.lanes |= Oe, xo |= Oe;
        }
        ye = ye.next;
      } while (ye !== null && ye !== R);
      re === null ? A = g : re.next = q, Gi(g, o.memoizedState) || (Dr = !0), o.memoizedState = g, o.baseState = A, o.baseQueue = re, d.lastRenderedState = g;
    }
    if (r = d.interleaved, r !== null) {
      S = r;
      do R = S.lane, Je.lanes |= R, xo |= R, S = S.next; while (S !== r);
    } else S === null && (d.lanes = 0);
    return [o.memoizedState, d.dispatch];
  }
  function nc(r) {
    var o = Zr(),
      d = o.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = r;
    var g = d.dispatch,
      S = d.pending,
      R = o.memoizedState;
    if (S !== null) {
      d.pending = null;
      var A = S = S.next;
      do R = r(R, A.action), A = A.next; while (A !== S);
      Gi(R, o.memoizedState) || (Dr = !0), o.memoizedState = R, o.baseQueue === null && (o.baseState = R), d.lastRenderedState = R;
    }
    return [R, g];
  }
  function Xd() {}
  function Kd(r, o) {
    var d = Je,
      g = Zr(),
      S = o(),
      R = !Gi(g.memoizedState, S);
    if (R && (g.memoizedState = S, Dr = !0), g = g.queue, af(Jd.bind(null, d, g, r), [r]), g.getSnapshot !== o || R || Cn !== null && Cn.memoizedState.tag & 1) {
      if (d.flags |= 2048, Sa(9, Zd.bind(null, d, g, S, o), void 0, null), pr === null) throw Error(i(349));
      (Ln & 30) !== 0 || Qd(d, o, S);
    }
    return S;
  }
  function Qd(r, o, d) {
    r.flags |= 16384, r = {
      getSnapshot: o,
      value: d
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.stores = [r]) : (d = o.stores, d === null ? o.stores = [r] : d.push(r));
  }
  function Zd(r, o, d, g) {
    o.value = d, o.getSnapshot = g, ef(o) && tf(r);
  }
  function Jd(r, o, d) {
    return d(function () {
      ef(o) && tf(r);
    });
  }
  function ef(r) {
    var o = r.getSnapshot;
    r = r.value;
    try {
      var d = o();
      return !Gi(r, d);
    } catch {
      return !0;
    }
  }
  function tf(r) {
    var o = En(r, 1);
    o !== null && Li(o, r, 1, -1);
  }
  function rc(r) {
    var o = Di();
    return typeof r == "function" && (r = r()), o.memoizedState = o.baseState = r, r = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Ul,
      lastRenderedState: r
    }, o.queue = r, r = r.dispatch = Ow.bind(null, Je, r), [o.memoizedState, r];
  }
  function Sa(r, o, d, g) {
    return r = {
      tag: r,
      create: o,
      destroy: d,
      deps: g,
      next: null
    }, o = Je.updateQueue, o === null ? (o = {
      lastEffect: null,
      stores: null
    }, Je.updateQueue = o, o.lastEffect = r.next = r) : (d = o.lastEffect, d === null ? o.lastEffect = r.next = r : (g = d.next, d.next = r, r.next = g, o.lastEffect = r)), r;
  }
  function nf() {
    return Zr().memoizedState;
  }
  function Bs(r, o, d, g) {
    var S = Di();
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, void 0, g === void 0 ? null : g);
  }
  function Us(r, o, d, g) {
    var S = Zr();
    g = g === void 0 ? null : g;
    var R = void 0;
    if (On !== null) {
      var A = On.memoizedState;
      if (R = A.destroy, g !== null && Zu(g, A.deps)) {
        S.memoizedState = Sa(o, d, R, g);
        return;
      }
    }
    Je.flags |= r, S.memoizedState = Sa(1 | o, d, R, g);
  }
  function rf(r, o) {
    return Bs(8390656, 8, r, o);
  }
  function af(r, o) {
    return Us(2048, 8, r, o);
  }
  function Hs(r, o) {
    return Us(4, 2, r, o);
  }
  function jh(r, o) {
    return Us(4, 4, r, o);
  }
  function $s(r, o) {
    if (typeof o == "function") return r = r(), o(r), function () {
      o(null);
    };
    if (o != null) return r = r(), o.current = r, function () {
      o.current = null;
    };
  }
  function Yo(r, o, d) {
    return d = d != null ? d.concat([r]) : null, Us(4, 4, $s.bind(null, o, r), d);
  }
  function Jr() {}
  function Yg(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (d.memoizedState = [r, o], r);
  }
  function wn(r, o) {
    var d = Zr();
    o = o === void 0 ? null : o;
    var g = d.memoizedState;
    return g !== null && o !== null && Zu(o, g[1]) ? g[0] : (r = r(), d.memoizedState = [r, o], r);
  }
  function ic(r, o, d) {
    return (Ln & 21) === 0 ? (r.baseState && (r.baseState = !1, Dr = !0), r.memoizedState = d) : (Gi(d, o) || (d = fd(), Je.lanes |= d, xo |= d, r.baseState = !0), o);
  }
  function of(r, o) {
    var d = gn;
    gn = d !== 0 && 4 > d ? d : 4, r(!0);
    var g = Re.transition;
    Re.transition = {};
    try {
      r(!1), o();
    } finally {
      gn = d, Re.transition = g;
    }
  }
  function Ws() {
    return Zr().memoizedState;
  }
  function lf(r, o, d) {
    var g = Ca(r);
    if (d = {
      lane: g,
      action: d,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Gg(r)) Xg(o, d);else if (d = Ng(r, o, d, g), d !== null) {
      var S = hr();
      Li(d, r, g, S), Kg(d, o, g);
    }
  }
  function Ow(r, o, d) {
    var g = Ca(r),
      S = {
        lane: g,
        action: d,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
    if (Gg(r)) Xg(o, S);else {
      var R = r.alternate;
      if (r.lanes === 0 && (R === null || R.lanes === 0) && (R = o.lastRenderedReducer, R !== null)) try {
        var A = o.lastRenderedState,
          q = R(A, d);
        if (S.hasEagerState = !0, S.eagerState = q, Gi(q, A)) {
          var re = o.interleaved;
          re === null ? (S.next = S, Rh(o)) : (S.next = re.next, re.next = S), o.interleaved = S;
          return;
        }
      } catch {} finally {}
      d = Ng(r, o, S, g), d !== null && (S = hr(), Li(d, r, g, S), Kg(d, o, g));
    }
  }
  function Gg(r) {
    var o = r.alternate;
    return r === Je || o !== null && o === Je;
  }
  function Xg(r, o) {
    Qr = xa = !0;
    var d = r.pending;
    d === null ? o.next = o : (o.next = d.next, d.next = o), r.pending = o;
  }
  function Kg(r, o, d) {
    if ((d & 4194240) !== 0) {
      var g = o.lanes;
      g &= r.pendingLanes, d |= g, o.lanes = d, pd(r, d);
    }
  }
  var qs = {
      readContext: ki,
      useCallback: rr,
      useContext: rr,
      useEffect: rr,
      useImperativeHandle: rr,
      useInsertionEffect: rr,
      useLayoutEffect: rr,
      useMemo: rr,
      useReducer: rr,
      useRef: rr,
      useState: rr,
      useDebugValue: rr,
      useDeferredValue: rr,
      useTransition: rr,
      useMutableSource: rr,
      useSyncExternalStore: rr,
      useId: rr,
      unstable_isNewReconciler: !1
    },
    Pw = {
      readContext: ki,
      useCallback: function (r, o) {
        return Di().memoizedState = [r, o === void 0 ? null : o], r;
      },
      useContext: ki,
      useEffect: rf,
      useImperativeHandle: function (r, o, d) {
        return d = d != null ? d.concat([r]) : null, Bs(4194308, 4, $s.bind(null, o, r), d);
      },
      useLayoutEffect: function (r, o) {
        return Bs(4194308, 4, r, o);
      },
      useInsertionEffect: function (r, o) {
        return Bs(4, 2, r, o);
      },
      useMemo: function (r, o) {
        var d = Di();
        return o = o === void 0 ? null : o, r = r(), d.memoizedState = [r, o], r;
      },
      useReducer: function (r, o, d) {
        var g = Di();
        return o = d !== void 0 ? d(o) : o, g.memoizedState = g.baseState = o, r = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: r,
          lastRenderedState: o
        }, g.queue = r, r = r.dispatch = lf.bind(null, Je, r), [g.memoizedState, r];
      },
      useRef: function (r) {
        var o = Di();
        return r = {
          current: r
        }, o.memoizedState = r;
      },
      useState: rc,
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        return Di().memoizedState = r;
      },
      useTransition: function () {
        var r = rc(!1),
          o = r[0];
        return r = of.bind(null, r[1]), Di().memoizedState = r, [o, r];
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (r, o, d) {
        var g = Je,
          S = Di();
        if (In) {
          if (d === void 0) throw Error(i(407));
          d = d();
        } else {
          if (d = o(), pr === null) throw Error(i(349));
          (Ln & 30) !== 0 || Qd(g, o, d);
        }
        S.memoizedState = d;
        var R = {
          value: d,
          getSnapshot: o
        };
        return S.queue = R, rf(Jd.bind(null, g, R, r), [r]), g.flags |= 2048, Sa(9, Zd.bind(null, g, R, d, o), void 0, null), d;
      },
      useId: function () {
        var r = Di(),
          o = pr.identifierPrefix;
        if (In) {
          var d = ba,
            g = ya;
          d = (g & ~(1 << 32 - gi(g) - 1)).toString(32) + d, o = ":" + o + "R" + d, d = no++, 0 < d && (o += "H" + d.toString(32)), o += ":";
        } else d = Vs++, o = ":" + o + "r" + d.toString(32) + ":";
        return r.memoizedState = o;
      },
      unstable_isNewReconciler: !1
    },
    Fh = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: af,
      useImperativeHandle: Yo,
      useInsertionEffect: Hs,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: tc,
      useRef: nf,
      useState: function () {
        return tc(Ul);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return ic(o, On.memoizedState, r);
      },
      useTransition: function () {
        var r = tc(Ul)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Xd,
      useSyncExternalStore: Kd,
      useId: Ws,
      unstable_isNewReconciler: !1
    },
    Qg = {
      readContext: ki,
      useCallback: Yg,
      useContext: ki,
      useEffect: af,
      useImperativeHandle: Yo,
      useInsertionEffect: Hs,
      useLayoutEffect: jh,
      useMemo: wn,
      useReducer: nc,
      useRef: nf,
      useState: function () {
        return nc(Ul);
      },
      useDebugValue: Jr,
      useDeferredValue: function (r) {
        var o = Zr();
        return On === null ? o.memoizedState = r : ic(o, On.memoizedState, r);
      },
      useTransition: function () {
        var r = nc(Ul)[0],
          o = Zr().memoizedState;
        return [r, o];
      },
      useMutableSource: Xd,
      useSyncExternalStore: Kd,
      useId: Ws,
      unstable_isNewReconciler: !1
    };
  function Ys(r, o) {
    try {
      var d = "",
        g = o;
      do d += fe(g), g = g.return; while (g);
      var S = d;
    } catch (R) {
      S = `
Error generating stack: ` + R.message + `
` + R.stack;
    }
    return {
      value: r,
      source: o,
      stack: S,
      digest: null
    };
  }
  function Nh(r, o, d) {
    return {
      value: r,
      source: null,
      stack: d ?? null,
      digest: o ?? null
    };
  }
  function Gs(r, o) {
    try {
      console.error(o.value);
    } catch (d) {
      setTimeout(function () {
        throw d;
      });
    }
  }
  var Aw = typeof WeakMap == "function" ? WeakMap : Map;
  function zh(r, o, d) {
    d = wa(-1, d), d.tag = 3, d.payload = {
      element: null
    };
    var g = o.value;
    return d.callback = function () {
      Ks || (Ks = !0, Yh = g), Gs(r, o);
    }, d;
  }
  function Vh(r, o, d) {
    d = wa(-1, d), d.tag = 3;
    var g = r.type.getDerivedStateFromError;
    if (typeof g == "function") {
      var S = o.value;
      d.payload = function () {
        return g(S);
      }, d.callback = function () {
        Gs(r, o);
      };
    }
    var R = r.stateNode;
    return R !== null && typeof R.componentDidCatch == "function" && (d.callback = function () {
      Gs(r, o), typeof g != "function" && (So === null ? So = /* @__PURE__ */new Set([this]) : So.add(this));
      var A = o.stack;
      this.componentDidCatch(o.value, {
        componentStack: A !== null ? A : ""
      });
    }), d;
  }
  function Zg(r, o, d) {
    var g = r.pingCache;
    if (g === null) {
      g = r.pingCache = new Aw();
      var S = /* @__PURE__ */new Set();
      g.set(o, S);
    } else S = g.get(o), S === void 0 && (S = /* @__PURE__ */new Set(), g.set(o, S));
    S.has(d) || (S.add(d), r = Nw.bind(null, r, o, d), o.then(r, r));
  }
  function Go(r) {
    do {
      var o;
      if ((o = r.tag === 13) && (o = r.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o) return r;
      r = r.return;
    } while (r !== null);
    return null;
  }
  function Xs(r, o, d, g, S) {
    return (r.mode & 1) === 0 ? (r === o ? r.flags |= 65536 : (r.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (o = wa(-1, 1), o.tag = 2, Ti(d, o, 1))), d.lanes |= 1), r) : (r.flags |= 65536, r.lanes = S, r);
  }
  var Hl = j.ReactCurrentOwner,
    Dr = !1;
  function _n(r, o, d, g) {
    o.child = r === null ? qg(o, null, d, g) : Vl(o, r.child, d, g);
  }
  function $l(r, o, d, g, S) {
    d = d.render;
    var R = o.ref;
    return Fs(o, S), g = Ju(r, o, d, g, R, S), d = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && d && Vd(o), o.flags |= 1, _n(r, o, g, S), o.child);
  }
  function jt(r, o, d, g, S) {
    if (r === null) {
      var R = d.type;
      return typeof R == "function" && !Zh(R) && R.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (o.tag = 15, o.type = R, ac(r, o, R, g, S)) : (r = Jl(d.type, null, g, o, o.mode, S), r.ref = o.ref, r.return = o, o.child = r);
    }
    if (R = r.child, (r.lanes & S) === 0) {
      var A = R.memoizedProps;
      if (d = d.compare, d = d !== null ? d : Vu, d(A, g) && r.ref === o.ref) return Ir(r, o, S);
    }
    return o.flags |= 1, r = La(R, g), r.ref = o.ref, r.return = o, o.child = r;
  }
  function ac(r, o, d, g, S) {
    if (r !== null) {
      var R = r.memoizedProps;
      if (Vu(R, g) && r.ref === o.ref) if (Dr = !1, o.pendingProps = g = R, (r.lanes & S) !== 0) (r.flags & 131072) !== 0 && (Dr = !0);else return o.lanes = r.lanes, Ir(r, o, S);
    }
    return sf(r, o, d, g, S);
  }
  function Bh(r, o, d) {
    var g = o.pendingProps,
      S = g.children,
      R = r !== null ? r.memoizedState : null;
    if (g.mode === "hidden") {
      if ((o.mode & 1) === 0) o.memoizedState = {
        baseLanes: 0,
        cachePool: null,
        transitions: null
      }, ft(Yl, ei), ei |= d;else {
        if ((d & 1073741824) === 0) return r = R !== null ? R.baseLanes | d : d, o.lanes = o.childLanes = 1073741824, o.memoizedState = {
          baseLanes: r,
          cachePool: null,
          transitions: null
        }, o.updateQueue = null, ft(Yl, ei), ei |= r, null;
        o.memoizedState = {
          baseLanes: 0,
          cachePool: null,
          transitions: null
        }, g = R !== null ? R.baseLanes : d, ft(Yl, ei), ei |= g;
      }
    } else R !== null ? (g = R.baseLanes | d, o.memoizedState = null) : g = d, ft(Yl, ei), ei |= g;
    return _n(r, o, S, d), o.child;
  }
  function Sb(r, o) {
    var d = o.ref;
    (r === null && d !== null || r !== null && r.ref !== d) && (o.flags |= 512, o.flags |= 2097152);
  }
  function sf(r, o, d, g, S) {
    var R = tr(d) ? Yr : Hn.current;
    return R = xi(o, R), Fs(o, S), d = Ju(r, o, d, g, R, S), g = ec(), r !== null && !Dr ? (o.updateQueue = r.updateQueue, o.flags &= -2053, r.lanes &= ~S, Ir(r, o, S)) : (In && g && Vd(o), o.flags |= 1, _n(r, o, d, S), o.child);
  }
  function oc(r, o, d, g, S) {
    if (tr(d)) {
      var R = !0;
      Gr(o);
    } else R = !1;
    if (Fs(o, S), o.stateNode === null) ll(r, o), Lh(o, d, g), Oh(o, d, g, S), g = !0;else if (r === null) {
      var A = o.stateNode,
        q = o.memoizedProps;
      A.props = q;
      var re = A.context,
        ye = d.contextType;
      typeof ye == "object" && ye !== null ? ye = ki(ye) : (ye = tr(d) ? Yr : Hn.current, ye = xi(o, ye));
      var Oe = d.getDerivedStateFromProps,
        ze = typeof Oe == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      ze || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== g || re !== ye) && Hg(o, A, g, ye), qo = !1;
      var Me = o.memoizedState;
      A.state = Me, Wd(o, g, A, S), re = o.memoizedState, q !== g || Me !== re || or.current || qo ? (typeof Oe == "function" && (Ih(o, d, Oe, g), re = o.memoizedState), (q = qo || Mh(o, d, q, g, Me, re, ye)) ? (ze || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = g, o.memoizedState = re), A.props = g, A.state = re, A.context = ye, g = q) : (typeof A.componentDidMount == "function" && (o.flags |= 4194308), g = !1);
    } else {
      A = o.stateNode, zg(r, o), q = o.memoizedProps, ye = o.type === o.elementType ? q : si(o.type, q), A.props = ye, ze = o.pendingProps, Me = A.context, re = d.contextType, typeof re == "object" && re !== null ? re = ki(re) : (re = tr(d) ? Yr : Hn.current, re = xi(o, re));
      var et = d.getDerivedStateFromProps;
      (Oe = typeof et == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (q !== ze || Me !== re) && Hg(o, A, g, re), qo = !1, Me = o.memoizedState, A.state = Me, Wd(o, g, A, S);
      var it = o.memoizedState;
      q !== ze || Me !== it || or.current || qo ? (typeof et == "function" && (Ih(o, d, et, g), it = o.memoizedState), (ye = qo || Mh(o, d, ye, g, Me, it, re) || !1) ? (Oe || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(g, it, re), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(g, it, re)), typeof A.componentDidUpdate == "function" && (o.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 1024), o.memoizedProps = g, o.memoizedState = it), A.props = g, A.state = it, A.context = re, g = ye) : (typeof A.componentDidUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || q === r.memoizedProps && Me === r.memoizedState || (o.flags |= 1024), g = !1);
    }
    return lc(r, o, d, g, R, S);
  }
  function lc(r, o, d, g, S, R) {
    Sb(r, o);
    var A = (o.flags & 128) !== 0;
    if (!g && !A) return S && Nd(o, d, !1), Ir(r, o, R);
    g = o.stateNode, Hl.current = o;
    var q = A && typeof d.getDerivedStateFromError != "function" ? null : g.render();
    return o.flags |= 1, r !== null && A ? (o.child = Vl(o, r.child, null, R), o.child = Vl(o, null, q, R)) : _n(r, o, q, R), o.memoizedState = g.state, S && Nd(o, d, !0), o.child;
  }
  function Km(r) {
    var o = r.stateNode;
    o.pendingContext ? Ag(r, o.pendingContext, o.pendingContext !== o.context) : o.context && Ag(r, o.context, !1), Wt(r, o.containerInfo);
  }
  function Qm(r, o, d, g, S) {
    return Wo(), eo(S), o.flags |= 256, _n(r, o, d, g), o.child;
  }
  var uf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
  };
  function cf(r) {
    return {
      baseLanes: r,
      cachePool: null,
      transitions: null
    };
  }
  function Zm(r, o, d) {
    var g = o.pendingProps,
      S = Mn.current,
      R = !1,
      A = (o.flags & 128) !== 0,
      q;
    if ((q = A) || (q = r !== null && r.memoizedState === null ? !1 : (S & 2) !== 0), q ? (R = !0, o.flags &= -129) : (r === null || r.memoizedState !== null) && (S |= 1), ft(Mn, S & 1), r === null) return Th(o), r = o.memoizedState, r !== null && (r = r.dehydrated, r !== null) ? ((o.mode & 1) === 0 ? o.lanes = 1 : r.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824, null) : (A = g.children, r = g.fallback, R ? (g = o.mode, R = o.child, A = {
      mode: "hidden",
      children: A
    }, (g & 1) === 0 && R !== null ? (R.childLanes = 0, R.pendingProps = A) : R = jc(A, g, 0, null), r = oo(r, g, d, null), R.return = o, r.return = o, R.sibling = r, o.child = R, o.child.memoizedState = cf(d), o.memoizedState = uf, r) : df(o, A));
    if (S = r.memoizedState, S !== null && (q = S.dehydrated, q !== null)) return al(r, o, A, g, q, S, d);
    if (R) {
      R = g.fallback, A = o.mode, S = r.child, q = S.sibling;
      var re = {
        mode: "hidden",
        children: g.children
      };
      return (A & 1) === 0 && o.child !== S ? (g = o.child, g.childLanes = 0, g.pendingProps = re, o.deletions = null) : (g = La(S, re), g.subtreeFlags = S.subtreeFlags & 14680064), q !== null ? R = La(q, R) : (R = oo(R, A, d, null), R.flags |= 2), R.return = o, g.return = o, g.sibling = R, o.child = g, g = R, R = o.child, A = r.child.memoizedState, A = A === null ? cf(d) : {
        baseLanes: A.baseLanes | d,
        cachePool: null,
        transitions: A.transitions
      }, R.memoizedState = A, R.childLanes = r.childLanes & ~d, o.memoizedState = uf, g;
    }
    return R = r.child, r = R.sibling, g = La(R, {
      mode: "visible",
      children: g.children
    }), (o.mode & 1) === 0 && (g.lanes = d), g.return = o, g.sibling = null, r !== null && (d = o.deletions, d === null ? (o.deletions = [r], o.flags |= 16) : d.push(r)), o.child = g, o.memoizedState = null, g;
  }
  function df(r, o) {
    return o = jc({
      mode: "visible",
      children: o
    }, r.mode, 0, null), o.return = r, r.child = o;
  }
  function sc(r, o, d, g) {
    return g !== null && eo(g), Vl(o, r.child, null, d), r = df(o, o.pendingProps.children), r.flags |= 2, o.memoizedState = null, r;
  }
  function al(r, o, d, g, S, R, A) {
    if (d) return o.flags & 256 ? (o.flags &= -257, g = Nh(Error(i(422))), sc(r, o, A, g)) : o.memoizedState !== null ? (o.child = r.child, o.flags |= 128, null) : (R = g.fallback, S = o.mode, g = jc({
      mode: "visible",
      children: g.children
    }, S, 0, null), R = oo(R, S, A, null), R.flags |= 2, g.return = o, R.return = o, g.sibling = R, o.child = g, (o.mode & 1) !== 0 && Vl(o, r.child, null, A), o.child.memoizedState = cf(A), o.memoizedState = uf, R);
    if ((o.mode & 1) === 0) return sc(r, o, A, null);
    if (S.data === "$!") {
      if (g = S.nextSibling && S.nextSibling.dataset, g) var q = g.dgst;
      return g = q, R = Error(i(419)), g = Nh(R, g, void 0), sc(r, o, A, g);
    }
    if (q = (A & r.childLanes) !== 0, Dr || q) {
      if (g = pr, g !== null) {
        switch (A & -A) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = (S & (g.suspendedLanes | A)) !== 0 ? 0 : S, S !== 0 && S !== R.retryLane && (R.retryLane = S, En(r, S), Li(g, r, S, -1));
      }
      return Kh(), g = Nh(Error(i(421))), sc(r, o, A, g);
    }
    return S.data === "$?" ? (o.flags |= 128, o.child = r.child, o = Rb.bind(null, r), S._reactRetry = o, null) : (r = R.treeContext, Kr = ha(S.nextSibling), Xr = o, In = !0, Ei = null, r !== null && (nr[Si++] = ya, nr[Si++] = ba, nr[Si++] = li, ya = r.id, ba = r.overflow, li = o), o = df(o, g.children), o.flags |= 4096, o);
  }
  function Ii(r, o, d) {
    r.lanes |= o;
    var g = r.alternate;
    g !== null && (g.lanes |= o), ui(r.return, o, d);
  }
  function Zi(r, o, d, g, S) {
    var R = r.memoizedState;
    R === null ? r.memoizedState = {
      isBackwards: o,
      rendering: null,
      renderingStartTime: 0,
      last: g,
      tail: d,
      tailMode: S
    } : (R.isBackwards = o, R.rendering = null, R.renderingStartTime = 0, R.last = g, R.tail = d, R.tailMode = S);
  }
  function ol(r, o, d) {
    var g = o.pendingProps,
      S = g.revealOrder,
      R = g.tail;
    if (_n(r, o, g.children, d), g = Mn.current, (g & 2) !== 0) g = g & 1 | 2, o.flags |= 128;else {
      if (r !== null && (r.flags & 128) !== 0) e: for (r = o.child; r !== null;) {
        if (r.tag === 13) r.memoizedState !== null && Ii(r, d, o);else if (r.tag === 19) Ii(r, d, o);else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === o) break e;
        for (; r.sibling === null;) {
          if (r.return === null || r.return === o) break e;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      g &= 1;
    }
    if (ft(Mn, g), (o.mode & 1) === 0) o.memoizedState = null;else switch (S) {
      case "forwards":
        for (d = o.child, S = null; d !== null;) r = d.alternate, r !== null && Gd(r) === null && (S = d), d = d.sibling;
        d = S, d === null ? (S = o.child, o.child = null) : (S = d.sibling, d.sibling = null), Zi(o, !1, S, d, R);
        break;
      case "backwards":
        for (d = null, S = o.child, o.child = null; S !== null;) {
          if (r = S.alternate, r !== null && Gd(r) === null) {
            o.child = S;
            break;
          }
          r = S.sibling, S.sibling = d, d = S, S = r;
        }
        Zi(o, !0, d, null, R);
        break;
      case "together":
        Zi(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function ll(r, o) {
    (o.mode & 1) === 0 && r !== null && (r.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function Ir(r, o, d) {
    if (r !== null && (o.dependencies = r.dependencies), xo |= o.lanes, (d & o.childLanes) === 0) return null;
    if (r !== null && o.child !== r.child) throw Error(i(153));
    if (o.child !== null) {
      for (r = o.child, d = La(r, r.pendingProps), o.child = d, d.return = o; r.sibling !== null;) r = r.sibling, d = d.sibling = La(r, r.pendingProps), d.return = o;
      d.sibling = null;
    }
    return o.child;
  }
  function zr(r, o, d) {
    switch (o.tag) {
      case 3:
        Km(o), Wo();
        break;
      case 5:
        Xn(o);
        break;
      case 1:
        tr(o.type) && Gr(o);
        break;
      case 4:
        Wt(o, o.stateNode.containerInfo);
        break;
      case 10:
        var g = o.type._context,
          S = o.memoizedProps.value;
        ft(Hd, g._currentValue), g._currentValue = S;
        break;
      case 13:
        if (g = o.memoizedState, g !== null) return g.dehydrated !== null ? (ft(Mn, Mn.current & 1), o.flags |= 128, null) : (d & o.child.childLanes) !== 0 ? Zm(r, o, d) : (ft(Mn, Mn.current & 1), r = Ir(r, o, d), r !== null ? r.sibling : null);
        ft(Mn, Mn.current & 1);
        break;
      case 19:
        if (g = (d & o.childLanes) !== 0, (r.flags & 128) !== 0) {
          if (g) return ol(r, o, d);
          o.flags |= 128;
        }
        if (S = o.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), ft(Mn, Mn.current), g) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Bh(r, o, d);
    }
    return Ir(r, o, d);
  }
  var sa, Uh, Jg, Hh;
  sa = function (r, o) {
    for (var d = o.child; d !== null;) {
      if (d.tag === 5 || d.tag === 6) r.appendChild(d.stateNode);else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === o) break;
      for (; d.sibling === null;) {
        if (d.return === null || d.return === o) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, Uh = function () {}, Jg = function (r, o, d, g) {
    var S = r.memoizedProps;
    if (S !== g) {
      r = o.stateNode, dt(_a.current);
      var R = null;
      switch (d) {
        case "input":
          S = Ae(r, S), g = Ae(r, g), R = [];
          break;
        case "select":
          S = H({}, S, {
            value: void 0
          }), g = H({}, g, {
            value: void 0
          }), R = [];
          break;
        case "textarea":
          S = Kt(r, S), g = Kt(r, g), R = [];
          break;
        default:
          typeof S.onClick != "function" && typeof g.onClick == "function" && (r.onclick = zo);
      }
      kt(d, g);
      var A;
      d = null;
      for (ye in S) if (!g.hasOwnProperty(ye) && S.hasOwnProperty(ye) && S[ye] != null) if (ye === "style") {
        var q = S[ye];
        for (A in q) q.hasOwnProperty(A) && (d || (d = {}), d[A] = "");
      } else ye !== "dangerouslySetInnerHTML" && ye !== "children" && ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && ye !== "autoFocus" && (c.hasOwnProperty(ye) ? R || (R = []) : (R = R || []).push(ye, null));
      for (ye in g) {
        var re = g[ye];
        if (q = S != null ? S[ye] : void 0, g.hasOwnProperty(ye) && re !== q && (re != null || q != null)) if (ye === "style") {
          if (q) {
            for (A in q) !q.hasOwnProperty(A) || re && re.hasOwnProperty(A) || (d || (d = {}), d[A] = "");
            for (A in re) re.hasOwnProperty(A) && q[A] !== re[A] && (d || (d = {}), d[A] = re[A]);
          } else d || (R || (R = []), R.push(ye, d)), d = re;
        } else ye === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, q = q ? q.__html : void 0, re != null && q !== re && (R = R || []).push(ye, re)) : ye === "children" ? typeof re != "string" && typeof re != "number" || (R = R || []).push(ye, "" + re) : ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && (c.hasOwnProperty(ye) ? (re != null && ye === "onScroll" && mn("scroll", r), R || q === re || (R = [])) : (R = R || []).push(ye, re));
      }
      d && (R = R || []).push("style", d);
      var ye = R;
      (o.updateQueue = ye) && (o.flags |= 4);
    }
  }, Hh = function (r, o, d, g) {
    d !== g && (o.flags |= 4);
  };
  function us(r, o) {
    if (!In) switch (r.tailMode) {
      case "hidden":
        o = r.tail;
        for (var d = null; o !== null;) o.alternate !== null && (d = o), o = o.sibling;
        d === null ? r.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = r.tail;
        for (var g = null; d !== null;) d.alternate !== null && (g = d), d = d.sibling;
        g === null ? o || r.tail === null ? r.tail = null : r.tail.sibling = null : g.sibling = null;
    }
  }
  function fr(r) {
    var o = r.alternate !== null && r.alternate.child === r.child,
      d = 0,
      g = 0;
    if (o) for (var S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags & 14680064, g |= S.flags & 14680064, S.return = r, S = S.sibling;else for (S = r.child; S !== null;) d |= S.lanes | S.childLanes, g |= S.subtreeFlags, g |= S.flags, S.return = r, S = S.sibling;
    return r.subtreeFlags |= g, r.childLanes = d, o;
  }
  function $h(r, o, d) {
    var g = o.pendingProps;
    switch (Bd(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return fr(o), null;
      case 1:
        return tr(o.type) && As(), fr(o), null;
      case 3:
        return g = o.stateNode, nn(), Sn(or), Sn(Hn), Ah(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), (r === null || r.child === null) && (Ud(o) ? o.flags |= 4 : r === null || r.memoizedState.isDehydrated && (o.flags & 256) === 0 || (o.flags |= 1024, Ei !== null && (Pc(Ei), Ei = null))), Uh(r, o), fr(o), null;
      case 5:
        Ri(o);
        var S = dt(Bl.current);
        if (d = o.type, r !== null && o.stateNode != null) Jg(r, o, d, g, S), r.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);else {
          if (!g) {
            if (o.stateNode === null) throw Error(i(166));
            return fr(o), null;
          }
          if (r = dt(_a.current), Ud(o)) {
            g = o.stateNode, d = o.type;
            var R = o.memoizedProps;
            switch (g[ma] = o, g[qu] = R, r = (o.mode & 1) !== 0, d) {
              case "dialog":
                mn("cancel", g), mn("close", g);
                break;
              case "iframe":
              case "object":
              case "embed":
                mn("load", g);
                break;
              case "video":
              case "audio":
                for (S = 0; S < Hu.length; S++) mn(Hu[S], g);
                break;
              case "source":
                mn("error", g);
                break;
              case "img":
              case "image":
              case "link":
                mn("error", g), mn("load", g);
                break;
              case "details":
                mn("toggle", g);
                break;
              case "input":
                Mt(g, R), mn("invalid", g);
                break;
              case "select":
                g._wrapperState = {
                  wasMultiple: !!R.multiple
                }, mn("invalid", g);
                break;
              case "textarea":
                hn(g, R), mn("invalid", g);
            }
            kt(d, R), S = null;
            for (var A in R) if (R.hasOwnProperty(A)) {
              var q = R[A];
              A === "children" ? typeof q == "string" ? g.textContent !== q && (R.suppressHydrationWarning !== !0 && Pd(g.textContent, q, r), S = ["children", q]) : typeof q == "number" && g.textContent !== "" + q && (R.suppressHydrationWarning !== !0 && Pd(g.textContent, q, r), S = ["children", "" + q]) : c.hasOwnProperty(A) && q != null && A === "onScroll" && mn("scroll", g);
            }
            switch (d) {
              case "input":
                Xe(g), gt(g, R, !0);
                break;
              case "textarea":
                Xe(g), Et(g);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof R.onClick == "function" && (g.onclick = zo);
            }
            g = S, o.updateQueue = g, g !== null && (o.flags |= 4);
          } else {
            A = S.nodeType === 9 ? S : S.ownerDocument, r === "http://www.w3.org/1999/xhtml" && (r = Vt(d)), r === "http://www.w3.org/1999/xhtml" ? d === "script" ? (r = A.createElement("div"), r.innerHTML = "<script><\/script>", r = r.removeChild(r.firstChild)) : typeof g.is == "string" ? r = A.createElement(d, {
              is: g.is
            }) : (r = A.createElement(d), d === "select" && (A = r, g.multiple ? A.multiple = !0 : g.size && (A.size = g.size))) : r = A.createElementNS(r, d), r[ma] = o, r[qu] = g, sa(r, o, !1, !1), o.stateNode = r;
            e: {
              switch (A = Bt(d, g), d) {
                case "dialog":
                  mn("cancel", r), mn("close", r), S = g;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  mn("load", r), S = g;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < Hu.length; S++) mn(Hu[S], r);
                  S = g;
                  break;
                case "source":
                  mn("error", r), S = g;
                  break;
                case "img":
                case "image":
                case "link":
                  mn("error", r), mn("load", r), S = g;
                  break;
                case "details":
                  mn("toggle", r), S = g;
                  break;
                case "input":
                  Mt(r, g), S = Ae(r, g), mn("invalid", r);
                  break;
                case "option":
                  S = g;
                  break;
                case "select":
                  r._wrapperState = {
                    wasMultiple: !!g.multiple
                  }, S = H({}, g, {
                    value: void 0
                  }), mn("invalid", r);
                  break;
                case "textarea":
                  hn(r, g), S = Kt(r, g), mn("invalid", r);
                  break;
                default:
                  S = g;
              }
              kt(d, S), q = S;
              for (R in q) if (q.hasOwnProperty(R)) {
                var re = q[R];
                R === "style" ? je(r, re) : R === "dangerouslySetInnerHTML" ? (re = re ? re.__html : void 0, re != null && ot(r, re)) : R === "children" ? typeof re == "string" ? (d !== "textarea" || re !== "") && We(r, re) : typeof re == "number" && We(r, "" + re) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (c.hasOwnProperty(R) ? re != null && R === "onScroll" && mn("scroll", r) : re != null && F(r, R, re, A));
              }
              switch (d) {
                case "input":
                  Xe(r), gt(r, g, !1);
                  break;
                case "textarea":
                  Xe(r), Et(r);
                  break;
                case "option":
                  g.value != null && r.setAttribute("value", "" + be(g.value));
                  break;
                case "select":
                  r.multiple = !!g.multiple, R = g.value, R != null ? Dt(r, !!g.multiple, R, !1) : g.defaultValue != null && Dt(r, !!g.multiple, g.defaultValue, !0);
                  break;
                default:
                  typeof S.onClick == "function" && (r.onclick = zo);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  g = !!g.autoFocus;
                  break e;
                case "img":
                  g = !0;
                  break e;
                default:
                  g = !1;
              }
            }
            g && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return fr(o), null;
      case 6:
        if (r && o.stateNode != null) Hh(r, o, r.memoizedProps, g);else {
          if (typeof g != "string" && o.stateNode === null) throw Error(i(166));
          if (d = dt(Bl.current), dt(_a.current), Ud(o)) {
            if (g = o.stateNode, d = o.memoizedProps, g[ma] = o, (R = g.nodeValue !== d) && (r = Xr, r !== null)) switch (r.tag) {
              case 3:
                Pd(g.nodeValue, d, (r.mode & 1) !== 0);
                break;
              case 5:
                r.memoizedProps.suppressHydrationWarning !== !0 && Pd(g.nodeValue, d, (r.mode & 1) !== 0);
            }
            R && (o.flags |= 4);
          } else g = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(g), g[ma] = o, o.stateNode = g;
        }
        return fr(o), null;
      case 13:
        if (Sn(Mn), g = o.memoizedState, r === null || r.memoizedState !== null && r.memoizedState.dehydrated !== null) {
          if (In && Kr !== null && (o.mode & 1) !== 0 && (o.flags & 128) === 0) Xu(), Wo(), o.flags |= 98560, R = !1;else if (R = Ud(o), g !== null && g.dehydrated !== null) {
            if (r === null) {
              if (!R) throw Error(i(318));
              if (R = o.memoizedState, R = R !== null ? R.dehydrated : null, !R) throw Error(i(317));
              R[ma] = o;
            } else Wo(), (o.flags & 128) === 0 && (o.memoizedState = null), o.flags |= 4;
            fr(o), R = !1;
          } else Ei !== null && (Pc(Ei), Ei = null), R = !0;
          if (!R) return o.flags & 65536 ? o : null;
        }
        return (o.flags & 128) !== 0 ? (o.lanes = d, o) : (g = g !== null, g !== (r !== null && r.memoizedState !== null) && g && (o.child.flags |= 8192, (o.mode & 1) !== 0 && (r === null || (Mn.current & 1) !== 0 ? Zn === 0 && (Zn = 3) : Kh())), o.updateQueue !== null && (o.flags |= 4), fr(o), null);
      case 4:
        return nn(), Uh(r, o), r === null && Is(o.stateNode.containerInfo), fr(o), null;
      case 10:
        return Ci(o.type._context), fr(o), null;
      case 17:
        return tr(o.type) && As(), fr(o), null;
      case 19:
        if (Sn(Mn), R = o.memoizedState, R === null) return fr(o), null;
        if (g = (o.flags & 128) !== 0, A = R.rendering, A === null) {
          if (g) us(R, !1);else {
            if (Zn !== 0 || r !== null && (r.flags & 128) !== 0) for (r = o.child; r !== null;) {
              if (A = Gd(r), A !== null) {
                for (o.flags |= 128, us(R, !1), g = A.updateQueue, g !== null && (o.updateQueue = g, o.flags |= 4), o.subtreeFlags = 0, g = d, d = o.child; d !== null;) R = d, r = g, R.flags &= 14680066, A = R.alternate, A === null ? (R.childLanes = 0, R.lanes = r, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = A.childLanes, R.lanes = A.lanes, R.child = A.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = A.memoizedProps, R.memoizedState = A.memoizedState, R.updateQueue = A.updateQueue, R.type = A.type, r = A.dependencies, R.dependencies = r === null ? null : {
                  lanes: r.lanes,
                  firstContext: r.firstContext
                }), d = d.sibling;
                return ft(Mn, Mn.current & 1 | 2), o.child;
              }
              r = r.sibling;
            }
            R.tail !== null && yn() > ao && (o.flags |= 128, g = !0, us(R, !1), o.lanes = 4194304);
          }
        } else {
          if (!g) if (r = Gd(A), r !== null) {
            if (o.flags |= 128, g = !0, d = r.updateQueue, d !== null && (o.updateQueue = d, o.flags |= 4), us(R, !0), R.tail === null && R.tailMode === "hidden" && !A.alternate && !In) return fr(o), null;
          } else 2 * yn() - R.renderingStartTime > ao && d !== 1073741824 && (o.flags |= 128, g = !0, us(R, !1), o.lanes = 4194304);
          R.isBackwards ? (A.sibling = o.child, o.child = A) : (d = R.last, d !== null ? d.sibling = A : o.child = A, R.last = A);
        }
        return R.tail !== null ? (o = R.tail, R.rendering = o, R.tail = o.sibling, R.renderingStartTime = yn(), o.sibling = null, d = Mn.current, ft(Mn, g ? d & 1 | 2 : d & 1), o) : (fr(o), null);
      case 22:
      case 23:
        return vf(), g = o.memoizedState !== null, r !== null && r.memoizedState !== null !== g && (o.flags |= 8192), g && (o.mode & 1) !== 0 ? (ei & 1073741824) !== 0 && (fr(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : fr(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function Eb(r, o) {
    switch (Bd(o), o.tag) {
      case 1:
        return tr(o.type) && As(), r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 3:
        return nn(), Sn(or), Sn(Hn), Ah(), r = o.flags, (r & 65536) !== 0 && (r & 128) === 0 ? (o.flags = r & -65537 | 128, o) : null;
      case 5:
        return Ri(o), null;
      case 13:
        if (Sn(Mn), r = o.memoizedState, r !== null && r.dehydrated !== null) {
          if (o.alternate === null) throw Error(i(340));
          Wo();
        }
        return r = o.flags, r & 65536 ? (o.flags = r & -65537 | 128, o) : null;
      case 19:
        return Sn(Mn), null;
      case 4:
        return nn(), null;
      case 10:
        return Ci(o.type._context), null;
      case 22:
      case 23:
        return vf(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var ff = !1,
    xr = !1,
    ey = typeof WeakSet == "function" ? WeakSet : Set,
    tt = null;
  function cs(r, o) {
    var d = r.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (g) {
      $n(r, o, g);
    } else d.current = null;
  }
  function Wh(r, o, d) {
    try {
      d();
    } catch (g) {
      $n(r, o, g);
    }
  }
  var Jm = !1;
  function Cb(r, o) {
    if (Wu = Dl, r = Bu(), kd(r)) {
      if ("selectionStart" in r) var d = {
        start: r.selectionStart,
        end: r.selectionEnd
      };else e: {
        d = (d = r.ownerDocument) && d.defaultView || window;
        var g = d.getSelection && d.getSelection();
        if (g && g.rangeCount !== 0) {
          d = g.anchorNode;
          var S = g.anchorOffset,
            R = g.focusNode;
          g = g.focusOffset;
          try {
            d.nodeType, R.nodeType;
          } catch {
            d = null;
            break e;
          }
          var A = 0,
            q = -1,
            re = -1,
            ye = 0,
            Oe = 0,
            ze = r,
            Me = null;
          t: for (;;) {
            for (var et; ze !== d || S !== 0 && ze.nodeType !== 3 || (q = A + S), ze !== R || g !== 0 && ze.nodeType !== 3 || (re = A + g), ze.nodeType === 3 && (A += ze.nodeValue.length), (et = ze.firstChild) !== null;) Me = ze, ze = et;
            for (;;) {
              if (ze === r) break t;
              if (Me === d && ++ye === S && (q = A), Me === R && ++Oe === g && (re = A), (et = ze.nextSibling) !== null) break;
              ze = Me, Me = ze.parentNode;
            }
            ze = et;
          }
          d = q === -1 || re === -1 ? null : {
            start: q,
            end: re
          };
        } else d = null;
      }
      d = d || {
        start: 0,
        end: 0
      };
    } else d = null;
    for (jl = {
      focusedElem: r,
      selectionRange: d
    }, Dl = !1, tt = o; tt !== null;) if (o = tt, r = o.child, (o.subtreeFlags & 1028) !== 0 && r !== null) r.return = o, tt = r;else for (; tt !== null;) {
      o = tt;
      try {
        var it = o.alternate;
        if ((o.flags & 1024) !== 0) switch (o.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (it !== null) {
              var lt = it.memoizedProps,
                Kn = it.memoizedState,
                pe = o.stateNode,
                oe = pe.getSnapshotBeforeUpdate(o.elementType === o.type ? lt : si(o.type, lt), Kn);
              pe.__reactInternalSnapshotBeforeUpdate = oe;
            }
            break;
          case 3:
            var he = o.stateNode.containerInfo;
            he.nodeType === 1 ? he.textContent = "" : he.nodeType === 9 && he.documentElement && he.removeChild(he.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (He) {
        $n(o, o.return, He);
      }
      if (r = o.sibling, r !== null) {
        r.return = o.return, tt = r;
        break;
      }
      tt = o.return;
    }
    return it = Jm, Jm = !1, it;
  }
  function du(r, o, d) {
    var g = o.updateQueue;
    if (g = g !== null ? g.lastEffect : null, g !== null) {
      var S = g = g.next;
      do {
        if ((S.tag & r) === r) {
          var R = S.destroy;
          S.destroy = void 0, R !== void 0 && Wh(o, d, R);
        }
        S = S.next;
      } while (S !== g);
    }
  }
  function uc(r, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var d = o = o.next;
      do {
        if ((d.tag & r) === r) {
          var g = d.create;
          d.destroy = g();
        }
        d = d.next;
      } while (d !== o);
    }
  }
  function fu(r) {
    var o = r.ref;
    if (o !== null) {
      var d = r.stateNode;
      switch (r.tag) {
        case 5:
          r = d;
          break;
        default:
          r = d;
      }
      typeof o == "function" ? o(r) : o.current = r;
    }
  }
  function Wl(r) {
    var o = r.alternate;
    o !== null && (r.alternate = null, Wl(o)), r.child = null, r.deletions = null, r.sibling = null, r.tag === 5 && (o = r.stateNode, o !== null && (delete o[ma], delete o[qu], delete o[Yu], delete o[Ps], delete o[Mw])), r.stateNode = null, r.return = null, r.dependencies = null, r.memoizedProps = null, r.memoizedState = null, r.pendingProps = null, r.stateNode = null, r.updateQueue = null;
  }
  function ro(r) {
    return r.tag === 5 || r.tag === 3 || r.tag === 4;
  }
  function io(r) {
    e: for (;;) {
      for (; r.sibling === null;) {
        if (r.return === null || ro(r.return)) return null;
        r = r.return;
      }
      for (r.sibling.return = r.return, r = r.sibling; r.tag !== 5 && r.tag !== 6 && r.tag !== 18;) {
        if (r.flags & 2 || r.child === null || r.tag === 4) continue e;
        r.child.return = r, r = r.child;
      }
      if (!(r.flags & 2)) return r.stateNode;
    }
  }
  function wo(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.nodeType === 8 ? d.parentNode.insertBefore(r, o) : d.insertBefore(r, o) : (d.nodeType === 8 ? (o = d.parentNode, o.insertBefore(r, d)) : (o = d, o.appendChild(r)), d = d._reactRootContainer, d != null || o.onclick !== null || (o.onclick = zo));else if (g !== 4 && (r = r.child, r !== null)) for (wo(r, o, d), r = r.sibling; r !== null;) wo(r, o, d), r = r.sibling;
  }
  function ql(r, o, d) {
    var g = r.tag;
    if (g === 5 || g === 6) r = r.stateNode, o ? d.insertBefore(r, o) : d.appendChild(r);else if (g !== 4 && (r = r.child, r !== null)) for (ql(r, o, d), r = r.sibling; r !== null;) ql(r, o, d), r = r.sibling;
  }
  var Nn = null,
    Vr = !1;
  function Xo(r, o, d) {
    for (d = d.child; d !== null;) ty(r, o, d), d = d.sibling;
  }
  function ty(r, o, d) {
    if (qi && typeof qi.onCommitFiberUnmount == "function") try {
      qi.onCommitFiberUnmount(Iu, d);
    } catch {}
    switch (d.tag) {
      case 5:
        xr || cs(d, o);
      case 6:
        var g = Nn,
          S = Vr;
        Nn = null, Xo(r, o, d), Nn = g, Vr = S, Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? r.parentNode.removeChild(d) : r.removeChild(d)) : Nn.removeChild(d.stateNode));
        break;
      case 18:
        Nn !== null && (Vr ? (r = Nn, d = d.stateNode, r.nodeType === 8 ? Os(r.parentNode, d) : r.nodeType === 1 && Os(r, d), jo(r)) : Os(Nn, d.stateNode));
        break;
      case 4:
        g = Nn, S = Vr, Nn = d.stateNode.containerInfo, Vr = !0, Xo(r, o, d), Nn = g, Vr = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!xr && (g = d.updateQueue, g !== null && (g = g.lastEffect, g !== null))) {
          S = g = g.next;
          do {
            var R = S,
              A = R.destroy;
            R = R.tag, A !== void 0 && ((R & 2) !== 0 || (R & 4) !== 0) && Wh(d, o, A), S = S.next;
          } while (S !== g);
        }
        Xo(r, o, d);
        break;
      case 1:
        if (!xr && (cs(d, o), g = d.stateNode, typeof g.componentWillUnmount == "function")) try {
          g.props = d.memoizedProps, g.state = d.memoizedState, g.componentWillUnmount();
        } catch (q) {
          $n(d, o, q);
        }
        Xo(r, o, d);
        break;
      case 21:
        Xo(r, o, d);
        break;
      case 22:
        d.mode & 1 ? (xr = (g = xr) || d.memoizedState !== null, Xo(r, o, d), xr = g) : Xo(r, o, d);
        break;
      default:
        Xo(r, o, d);
    }
  }
  function ev(r) {
    var o = r.updateQueue;
    if (o !== null) {
      r.updateQueue = null;
      var d = r.stateNode;
      d === null && (d = r.stateNode = new ey()), o.forEach(function (g) {
        var S = zw.bind(null, r, g);
        d.has(g) || (d.add(g), g.then(S, S));
      });
    }
  }
  function ri(r, o) {
    var d = o.deletions;
    if (d !== null) for (var g = 0; g < d.length; g++) {
      var S = d[g];
      try {
        var R = r,
          A = o,
          q = A;
        e: for (; q !== null;) {
          switch (q.tag) {
            case 5:
              Nn = q.stateNode, Vr = !1;
              break e;
            case 3:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
            case 4:
              Nn = q.stateNode.containerInfo, Vr = !0;
              break e;
          }
          q = q.return;
        }
        if (Nn === null) throw Error(i(160));
        ty(R, A, S), Nn = null, Vr = !1;
        var re = S.alternate;
        re !== null && (re.return = null), S.return = null;
      } catch (ye) {
        $n(S, o, ye);
      }
    }
    if (o.subtreeFlags & 12854) for (o = o.child; o !== null;) pf(o, r), o = o.sibling;
  }
  function pf(r, o) {
    var d = r.alternate,
      g = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ri(o, r), ua(r), g & 4) {
          try {
            du(3, r, r.return), uc(3, r);
          } catch (lt) {
            $n(r, r.return, lt);
          }
          try {
            du(5, r, r.return);
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 1:
        ri(o, r), ua(r), g & 512 && d !== null && cs(d, d.return);
        break;
      case 5:
        if (ri(o, r), ua(r), g & 512 && d !== null && cs(d, d.return), r.flags & 32) {
          var S = r.stateNode;
          try {
            We(S, "");
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        if (g & 4 && (S = r.stateNode, S != null)) {
          var R = r.memoizedProps,
            A = d !== null ? d.memoizedProps : R,
            q = r.type,
            re = r.updateQueue;
          if (r.updateQueue = null, re !== null) try {
            q === "input" && R.type === "radio" && R.name != null && Ft(S, R), Bt(q, A);
            var ye = Bt(q, R);
            for (A = 0; A < re.length; A += 2) {
              var Oe = re[A],
                ze = re[A + 1];
              Oe === "style" ? je(S, ze) : Oe === "dangerouslySetInnerHTML" ? ot(S, ze) : Oe === "children" ? We(S, ze) : F(S, Oe, ze, ye);
            }
            switch (q) {
              case "input":
                un(S, R);
                break;
              case "textarea":
                Lt(S, R);
                break;
              case "select":
                var Me = S._wrapperState.wasMultiple;
                S._wrapperState.wasMultiple = !!R.multiple;
                var et = R.value;
                et != null ? Dt(S, !!R.multiple, et, !1) : Me !== !!R.multiple && (R.defaultValue != null ? Dt(S, !!R.multiple, R.defaultValue, !0) : Dt(S, !!R.multiple, R.multiple ? [] : "", !1));
            }
            S[qu] = R;
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 6:
        if (ri(o, r), ua(r), g & 4) {
          if (r.stateNode === null) throw Error(i(162));
          S = r.stateNode, R = r.memoizedProps;
          try {
            S.nodeValue = R;
          } catch (lt) {
            $n(r, r.return, lt);
          }
        }
        break;
      case 3:
        if (ri(o, r), ua(r), g & 4 && d !== null && d.memoizedState.isDehydrated) try {
          jo(o.containerInfo);
        } catch (lt) {
          $n(r, r.return, lt);
        }
        break;
      case 4:
        ri(o, r), ua(r);
        break;
      case 13:
        ri(o, r), ua(r), S = r.child, S.flags & 8192 && (R = S.memoizedState !== null, S.stateNode.isHidden = R, !R || S.alternate !== null && S.alternate.memoizedState !== null || (fc = yn())), g & 4 && ev(r);
        break;
      case 22:
        if (Oe = d !== null && d.memoizedState !== null, r.mode & 1 ? (xr = (ye = xr) || Oe, ri(o, r), xr = ye) : ri(o, r), ua(r), g & 8192) {
          if (ye = r.memoizedState !== null, (r.stateNode.isHidden = ye) && !Oe && (r.mode & 1) !== 0) for (tt = r, Oe = r.child; Oe !== null;) {
            for (ze = tt = Oe; tt !== null;) {
              switch (Me = tt, et = Me.child, Me.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  du(4, Me, Me.return);
                  break;
                case 1:
                  cs(Me, Me.return);
                  var it = Me.stateNode;
                  if (typeof it.componentWillUnmount == "function") {
                    g = Me, d = Me.return;
                    try {
                      o = g, it.props = o.memoizedProps, it.state = o.memoizedState, it.componentWillUnmount();
                    } catch (lt) {
                      $n(g, d, lt);
                    }
                  }
                  break;
                case 5:
                  cs(Me, Me.return);
                  break;
                case 22:
                  if (Me.memoizedState !== null) {
                    tv(ze);
                    continue;
                  }
              }
              et !== null ? (et.return = Me, tt = et) : tv(ze);
            }
            Oe = Oe.sibling;
          }
          e: for (Oe = null, ze = r;;) {
            if (ze.tag === 5) {
              if (Oe === null) {
                Oe = ze;
                try {
                  S = ze.stateNode, ye ? (R = S.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (q = ze.stateNode, re = ze.memoizedProps.style, A = re != null && re.hasOwnProperty("display") ? re.display : null, q.style.display = yt("display", A));
                } catch (lt) {
                  $n(r, r.return, lt);
                }
              }
            } else if (ze.tag === 6) {
              if (Oe === null) try {
                ze.stateNode.nodeValue = ye ? "" : ze.memoizedProps;
              } catch (lt) {
                $n(r, r.return, lt);
              }
            } else if ((ze.tag !== 22 && ze.tag !== 23 || ze.memoizedState === null || ze === r) && ze.child !== null) {
              ze.child.return = ze, ze = ze.child;
              continue;
            }
            if (ze === r) break e;
            for (; ze.sibling === null;) {
              if (ze.return === null || ze.return === r) break e;
              Oe === ze && (Oe = null), ze = ze.return;
            }
            Oe === ze && (Oe = null), ze.sibling.return = ze.return, ze = ze.sibling;
          }
        }
        break;
      case 19:
        ri(o, r), ua(r), g & 4 && ev(r);
        break;
      case 21:
        break;
      default:
        ri(o, r), ua(r);
    }
  }
  function ua(r) {
    var o = r.flags;
    if (o & 2) {
      try {
        e: {
          for (var d = r.return; d !== null;) {
            if (ro(d)) {
              var g = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (g.tag) {
          case 5:
            var S = g.stateNode;
            g.flags & 32 && (We(S, ""), g.flags &= -33);
            var R = io(r);
            ql(r, R, S);
            break;
          case 3:
          case 4:
            var A = g.stateNode.containerInfo,
              q = io(r);
            wo(r, q, A);
            break;
          default:
            throw Error(i(161));
        }
      } catch (re) {
        $n(r, r.return, re);
      }
      r.flags &= -3;
    }
    o & 4096 && (r.flags &= -4097);
  }
  function kb(r, o, d) {
    tt = r, cp(r);
  }
  function cp(r, o, d) {
    for (var g = (r.mode & 1) !== 0; tt !== null;) {
      var S = tt,
        R = S.child;
      if (S.tag === 22 && g) {
        var A = S.memoizedState !== null || ff;
        if (!A) {
          var q = S.alternate,
            re = q !== null && q.memoizedState !== null || xr;
          q = ff;
          var ye = xr;
          if (ff = A, (xr = re) && !ye) for (tt = S; tt !== null;) A = tt, re = A.child, A.tag === 22 && A.memoizedState !== null ? mf(S) : re !== null ? (re.return = A, tt = re) : mf(S);
          for (; R !== null;) tt = R, cp(R), R = R.sibling;
          tt = S, ff = q, xr = ye;
        }
        hf(r);
      } else (S.subtreeFlags & 8772) !== 0 && R !== null ? (R.return = S, tt = R) : hf(r);
    }
  }
  function hf(r) {
    for (; tt !== null;) {
      var o = tt;
      if ((o.flags & 8772) !== 0) {
        var d = o.alternate;
        try {
          if ((o.flags & 8772) !== 0) switch (o.tag) {
            case 0:
            case 11:
            case 15:
              xr || uc(5, o);
              break;
            case 1:
              var g = o.stateNode;
              if (o.flags & 4 && !xr) if (d === null) g.componentDidMount();else {
                var S = o.elementType === o.type ? d.memoizedProps : si(o.type, d.memoizedProps);
                g.componentDidUpdate(S, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
              }
              var R = o.updateQueue;
              R !== null && Bg(o, R, g);
              break;
            case 3:
              var A = o.updateQueue;
              if (A !== null) {
                if (d = null, o.child !== null) switch (o.child.tag) {
                  case 5:
                    d = o.child.stateNode;
                    break;
                  case 1:
                    d = o.child.stateNode;
                }
                Bg(o, A, d);
              }
              break;
            case 5:
              var q = o.stateNode;
              if (d === null && o.flags & 4) {
                d = q;
                var re = o.memoizedProps;
                switch (o.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    re.autoFocus && d.focus();
                    break;
                  case "img":
                    re.src && (d.src = re.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (o.memoizedState === null) {
                var ye = o.alternate;
                if (ye !== null) {
                  var Oe = ye.memoizedState;
                  if (Oe !== null) {
                    var ze = Oe.dehydrated;
                    ze !== null && jo(ze);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          xr || o.flags & 512 && fu(o);
        } catch (Me) {
          $n(o, o.return, Me);
        }
      }
      if (o === r) {
        tt = null;
        break;
      }
      if (d = o.sibling, d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function tv(r) {
    for (; tt !== null;) {
      var o = tt;
      if (o === r) {
        tt = null;
        break;
      }
      var d = o.sibling;
      if (d !== null) {
        d.return = o.return, tt = d;
        break;
      }
      tt = o.return;
    }
  }
  function mf(r) {
    for (; tt !== null;) {
      var o = tt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var d = o.return;
            try {
              uc(4, o);
            } catch (re) {
              $n(o, d, re);
            }
            break;
          case 1:
            var g = o.stateNode;
            if (typeof g.componentDidMount == "function") {
              var S = o.return;
              try {
                g.componentDidMount();
              } catch (re) {
                $n(o, S, re);
              }
            }
            var R = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, R, re);
            }
            break;
          case 5:
            var A = o.return;
            try {
              fu(o);
            } catch (re) {
              $n(o, A, re);
            }
        }
      } catch (re) {
        $n(o, o.return, re);
      }
      if (o === r) {
        tt = null;
        break;
      }
      var q = o.sibling;
      if (q !== null) {
        q.return = o.return, tt = q;
        break;
      }
      tt = o.return;
    }
  }
  var cc = Math.ceil,
    _o = j.ReactCurrentDispatcher,
    ds = j.ReactCurrentOwner,
    ii = j.ReactCurrentBatchConfig,
    on = 0,
    pr = null,
    ir = null,
    Sr = 0,
    ei = 0,
    Yl = Ki(0),
    Zn = 0,
    sl = null,
    xo = 0,
    Oc = 0,
    qh = 0,
    dc = null,
    ti = null,
    fc = 0,
    ao = 1 / 0,
    Mi = null,
    Ks = !1,
    Yh = null,
    So = null,
    pc = !1,
    Ea = null,
    Gl = 0,
    Xl = 0,
    Ma = null,
    di = -1,
    ul = 0;
  function hr() {
    return (on & 6) !== 0 ? yn() : di !== -1 ? di : di = yn();
  }
  function Ca(r) {
    return (r.mode & 1) === 0 ? 1 : (on & 2) !== 0 && Sr !== 0 ? Sr & -Sr : Lw.transition !== null ? (ul === 0 && (ul = fd()), ul) : (r = gn, r !== 0 || (r = window.event, r = r === void 0 ? 16 : vd(r.type)), r);
  }
  function Li(r, o, d, g) {
    if (50 < Xl) throw Xl = 0, Ma = null, Error(i(185));
    Tl(r, d, g), ((on & 2) === 0 || r !== pr) && (r === pr && ((on & 2) === 0 && (Oc |= d), Zn === 4 && Eo(r, Sr)), Mr(r, g), d === 1 && on === 0 && (o.mode & 1) === 0 && (ao = yn() + 500, js && ga()));
  }
  function Mr(r, o) {
    var d = r.callbackNode;
    Gp(r, o);
    var g = kl(r, r === pr ? Sr : 0);
    if (g === 0) d !== null && Wa(d), r.callbackNode = null, r.callbackPriority = 0;else if (o = g & -g, r.callbackPriority !== o) {
      if (d != null && Wa(d), o === 1) r.tag === 0 ? Bo(ny.bind(null, r)) : zd(ny.bind(null, r)), Ls(function () {
        (on & 6) === 0 && ga();
      }), d = null;else {
        switch (Qp(g)) {
          case 1:
            d = El;
            break;
          case 4:
            d = Wp;
            break;
          case 16:
            d = Du;
            break;
          case 536870912:
            d = qp;
            break;
          default:
            d = Du;
        }
        d = sy(d, hc.bind(null, r));
      }
      r.callbackPriority = o, r.callbackNode = d;
    }
  }
  function hc(r, o) {
    if (di = -1, ul = 0, (on & 6) !== 0) throw Error(i(327));
    var d = r.callbackNode;
    if (Zl() && r.callbackNode !== d) return null;
    var g = kl(r, r === pr ? Sr : 0);
    if (g === 0) return null;
    if ((g & 30) !== 0 || (g & r.expiredLanes) !== 0 || o) o = Ac(r, g);else {
      o = g;
      var S = on;
      on |= 2;
      var R = iy();
      (pr !== r || Sr !== o) && (Mi = null, ao = yn() + 500, Kl(r, o));
      do try {
        jw();
        break;
      } catch (q) {
        ry(r, q);
      } while (!0);
      Ge(), _o.current = R, on = S, ir !== null ? o = 0 : (pr = null, Sr = 0, o = Zn);
    }
    if (o !== 0) {
      if (o === 2 && (S = Xp(r), S !== 0 && (g = S, o = mc(r, S))), o === 1) throw d = sl, Kl(r, 0), Eo(r, g), Mr(r, yn()), d;
      if (o === 6) Eo(r, g);else {
        if (S = r.current.alternate, (g & 30) === 0 && !Gh(S) && (o = Ac(r, g), o === 2 && (R = Xp(r), R !== 0 && (g = R, o = mc(r, R))), o === 1)) throw d = sl, Kl(r, 0), Eo(r, g), Mr(r, yn()), d;
        switch (r.finishedWork = S, r.finishedLanes = g, o) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            Ql(r, ti, Mi);
            break;
          case 3:
            if (Eo(r, g), (g & 130023424) === g && (o = fc + 500 - yn(), 10 < o)) {
              if (kl(r, 0) !== 0) break;
              if (S = r.suspendedLanes, (S & g) !== g) {
                hr(), r.pingedLanes |= r.suspendedLanes & S;
                break;
              }
              r.timeoutHandle = jd(Ql.bind(null, r, ti, Mi), o);
              break;
            }
            Ql(r, ti, Mi);
            break;
          case 4:
            if (Eo(r, g), (g & 4194240) === g) break;
            for (o = r.eventTimes, S = -1; 0 < g;) {
              var A = 31 - gi(g);
              R = 1 << A, A = o[A], A > S && (S = A), g &= ~R;
            }
            if (g = S, g = yn() - g, g = (120 > g ? 120 : 480 > g ? 480 : 1080 > g ? 1080 : 1920 > g ? 1920 : 3e3 > g ? 3e3 : 4320 > g ? 4320 : 1960 * cc(g / 1960)) - g, 10 < g) {
              r.timeoutHandle = jd(Ql.bind(null, r, ti, Mi), g);
              break;
            }
            Ql(r, ti, Mi);
            break;
          case 5:
            Ql(r, ti, Mi);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return Mr(r, yn()), r.callbackNode === d ? hc.bind(null, r) : null;
  }
  function mc(r, o) {
    var d = dc;
    return r.current.memoizedState.isDehydrated && (Kl(r, o).flags |= 256), r = Ac(r, o), r !== 2 && (o = ti, ti = d, o !== null && Pc(o)), r;
  }
  function Pc(r) {
    ti === null ? ti = r : ti.push.apply(ti, r);
  }
  function Gh(r) {
    for (var o = r;;) {
      if (o.flags & 16384) {
        var d = o.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var g = 0; g < d.length; g++) {
          var S = d[g],
            R = S.getSnapshot;
          S = S.value;
          try {
            if (!Gi(R(), S)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = o.child, o.subtreeFlags & 16384 && d !== null) d.return = o, o = d;else {
        if (o === r) break;
        for (; o.sibling === null;) {
          if (o.return === null || o.return === r) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function Eo(r, o) {
    for (o &= ~qh, o &= ~Oc, r.suspendedLanes |= o, r.pingedLanes &= ~o, r = r.expirationTimes; 0 < o;) {
      var d = 31 - gi(o),
        g = 1 << d;
      r[d] = -1, o &= ~g;
    }
  }
  function ny(r) {
    if ((on & 6) !== 0) throw Error(i(327));
    Zl();
    var o = kl(r, 0);
    if ((o & 1) === 0) return Mr(r, yn()), null;
    var d = Ac(r, o);
    if (r.tag !== 0 && d === 2) {
      var g = Xp(r);
      g !== 0 && (o = g, d = mc(r, g));
    }
    if (d === 1) throw d = sl, Kl(r, 0), Eo(r, o), Mr(r, yn()), d;
    if (d === 6) throw Error(i(345));
    return r.finishedWork = r.current.alternate, r.finishedLanes = o, Ql(r, ti, Mi), Mr(r, yn()), null;
  }
  function Xh(r, o) {
    var d = on;
    on |= 1;
    try {
      return r(o);
    } finally {
      on = d, on === 0 && (ao = yn() + 500, js && ga());
    }
  }
  function Ko(r) {
    Ea !== null && Ea.tag === 0 && (on & 6) === 0 && Zl();
    var o = on;
    on |= 1;
    var d = ii.transition,
      g = gn;
    try {
      if (ii.transition = null, gn = 1, r) return r();
    } finally {
      gn = g, ii.transition = d, on = o, (on & 6) === 0 && ga();
    }
  }
  function vf() {
    ei = Yl.current, Sn(Yl);
  }
  function Kl(r, o) {
    r.finishedWork = null, r.finishedLanes = 0;
    var d = r.timeoutHandle;
    if (d !== -1 && (r.timeoutHandle = -1, Eh(d)), ir !== null) for (d = ir.return; d !== null;) {
      var g = d;
      switch (Bd(g), g.tag) {
        case 1:
          g = g.type.childContextTypes, g != null && As();
          break;
        case 3:
          nn(), Sn(or), Sn(Hn), Ah();
          break;
        case 5:
          Ri(g);
          break;
        case 4:
          nn();
          break;
        case 13:
          Sn(Mn);
          break;
        case 19:
          Sn(Mn);
          break;
        case 10:
          Ci(g.type._context);
          break;
        case 22:
        case 23:
          vf();
      }
      d = d.return;
    }
    if (pr = r, ir = r = La(r.current, null), Sr = ei = o, Zn = 0, sl = null, qh = Oc = xo = 0, ti = dc = null, zl !== null) {
      for (o = 0; o < zl.length; o++) if (d = zl[o], g = d.interleaved, g !== null) {
        d.interleaved = null;
        var S = g.next,
          R = d.pending;
        if (R !== null) {
          var A = R.next;
          R.next = S, g.next = A;
        }
        d.pending = g;
      }
      zl = null;
    }
    return r;
  }
  function ry(r, o) {
    do {
      var d = ir;
      try {
        if (Ge(), zs.current = qs, xa) {
          for (var g = Je.memoizedState; g !== null;) {
            var S = g.queue;
            S !== null && (S.pending = null), g = g.next;
          }
          xa = !1;
        }
        if (Ln = 0, Cn = On = Je = null, Qr = !1, no = 0, ds.current = null, d === null || d.return === null) {
          Zn = 1, sl = o, ir = null;
          break;
        }
        e: {
          var R = r,
            A = d.return,
            q = d,
            re = o;
          if (o = Sr, q.flags |= 32768, re !== null && typeof re == "object" && typeof re.then == "function") {
            var ye = re,
              Oe = q,
              ze = Oe.tag;
            if ((Oe.mode & 1) === 0 && (ze === 0 || ze === 11 || ze === 15)) {
              var Me = Oe.alternate;
              Me ? (Oe.updateQueue = Me.updateQueue, Oe.memoizedState = Me.memoizedState, Oe.lanes = Me.lanes) : (Oe.updateQueue = null, Oe.memoizedState = null);
            }
            var et = Go(A);
            if (et !== null) {
              et.flags &= -257, Xs(et, A, q, R, o), et.mode & 1 && Zg(R, ye, o), o = et, re = ye;
              var it = o.updateQueue;
              if (it === null) {
                var lt = /* @__PURE__ */new Set();
                lt.add(re), o.updateQueue = lt;
              } else it.add(re);
              break e;
            } else {
              if ((o & 1) === 0) {
                Zg(R, ye, o), Kh();
                break e;
              }
              re = Error(i(426));
            }
          } else if (In && q.mode & 1) {
            var Kn = Go(A);
            if (Kn !== null) {
              (Kn.flags & 65536) === 0 && (Kn.flags |= 256), Xs(Kn, A, q, R, o), eo(Ys(re, q));
              break e;
            }
          }
          R = re = Ys(re, q), Zn !== 4 && (Zn = 2), dc === null ? dc = [R] : dc.push(R), R = A;
          do {
            switch (R.tag) {
              case 3:
                R.flags |= 65536, o &= -o, R.lanes |= o;
                var pe = zh(R, re, o);
                Vg(R, pe);
                break e;
              case 1:
                q = re;
                var oe = R.type,
                  he = R.stateNode;
                if ((R.flags & 128) === 0 && (typeof oe.getDerivedStateFromError == "function" || he !== null && typeof he.componentDidCatch == "function" && (So === null || !So.has(he)))) {
                  R.flags |= 65536, o &= -o, R.lanes |= o;
                  var He = Vh(R, q, o);
                  Vg(R, He);
                  break e;
                }
            }
            R = R.return;
          } while (R !== null);
        }
        oy(d);
      } catch (ut) {
        o = ut, ir === d && d !== null && (ir = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function iy() {
    var r = _o.current;
    return _o.current = qs, r === null ? qs : r;
  }
  function Kh() {
    (Zn === 0 || Zn === 3 || Zn === 2) && (Zn = 4), pr === null || (xo & 268435455) === 0 && (Oc & 268435455) === 0 || Eo(pr, Sr);
  }
  function Ac(r, o) {
    var d = on;
    on |= 2;
    var g = iy();
    (pr !== r || Sr !== o) && (Mi = null, Kl(r, o));
    do try {
      Tb();
      break;
    } catch (S) {
      ry(r, S);
    } while (!0);
    if (Ge(), on = d, _o.current = g, ir !== null) throw Error(i(261));
    return pr = null, Sr = 0, Zn;
  }
  function Tb() {
    for (; ir !== null;) ay(ir);
  }
  function jw() {
    for (; ir !== null && !Ru();) ay(ir);
  }
  function ay(r) {
    var o = ly(r.alternate, r, ei);
    r.memoizedProps = r.pendingProps, o === null ? oy(r) : ir = o, ds.current = null;
  }
  function oy(r) {
    var o = r;
    do {
      var d = o.alternate;
      if (r = o.return, (o.flags & 32768) === 0) {
        if (d = $h(d, o, ei), d !== null) {
          ir = d;
          return;
        }
      } else {
        if (d = Eb(d, o), d !== null) {
          d.flags &= 32767, ir = d;
          return;
        }
        if (r !== null) r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null;else {
          Zn = 6, ir = null;
          return;
        }
      }
      if (o = o.sibling, o !== null) {
        ir = o;
        return;
      }
      ir = o = r;
    } while (o !== null);
    Zn === 0 && (Zn = 5);
  }
  function Ql(r, o, d) {
    var g = gn,
      S = ii.transition;
    try {
      ii.transition = null, gn = 1, Fw(r, o, d, g);
    } finally {
      ii.transition = S, gn = g;
    }
    return null;
  }
  function Fw(r, o, d, g) {
    do Zl(); while (Ea !== null);
    if ((on & 6) !== 0) throw Error(i(327));
    d = r.finishedWork;
    var S = r.finishedLanes;
    if (d === null) return null;
    if (r.finishedWork = null, r.finishedLanes = 0, d === r.current) throw Error(i(177));
    r.callbackNode = null, r.callbackPriority = 0;
    var R = d.lanes | d.childLanes;
    if (pw(r, R), r === pr && (ir = pr = null, Sr = 0), (d.subtreeFlags & 2064) === 0 && (d.flags & 2064) === 0 || pc || (pc = !0, sy(Du, function () {
      return Zl(), null;
    })), R = (d.flags & 15990) !== 0, (d.subtreeFlags & 15990) !== 0 || R) {
      R = ii.transition, ii.transition = null;
      var A = gn;
      gn = 1;
      var q = on;
      on |= 4, ds.current = null, Cb(r, d), pf(d, r), Rs(jl), Dl = !!Wu, jl = Wu = null, r.current = d, kb(d), Wi(), on = q, gn = A, ii.transition = R;
    } else r.current = d;
    if (pc && (pc = !1, Ea = r, Gl = S), R = r.pendingLanes, R === 0 && (So = null), ng(d.stateNode), Mr(r, yn()), o !== null) for (g = r.onRecoverableError, d = 0; d < o.length; d++) S = o[d], g(S.value, {
      componentStack: S.stack,
      digest: S.digest
    });
    if (Ks) throw Ks = !1, r = Yh, Yh = null, r;
    return (Gl & 1) !== 0 && r.tag !== 0 && Zl(), R = r.pendingLanes, (R & 1) !== 0 ? r === Ma ? Xl++ : (Xl = 0, Ma = r) : Xl = 0, ga(), null;
  }
  function Zl() {
    if (Ea !== null) {
      var r = Qp(Gl),
        o = ii.transition,
        d = gn;
      try {
        if (ii.transition = null, gn = 16 > r ? 16 : r, Ea === null) var g = !1;else {
          if (r = Ea, Ea = null, Gl = 0, (on & 6) !== 0) throw Error(i(331));
          var S = on;
          for (on |= 4, tt = r.current; tt !== null;) {
            var R = tt,
              A = R.child;
            if ((tt.flags & 16) !== 0) {
              var q = R.deletions;
              if (q !== null) {
                for (var re = 0; re < q.length; re++) {
                  var ye = q[re];
                  for (tt = ye; tt !== null;) {
                    var Oe = tt;
                    switch (Oe.tag) {
                      case 0:
                      case 11:
                      case 15:
                        du(8, Oe, R);
                    }
                    var ze = Oe.child;
                    if (ze !== null) ze.return = Oe, tt = ze;else for (; tt !== null;) {
                      Oe = tt;
                      var Me = Oe.sibling,
                        et = Oe.return;
                      if (Wl(Oe), Oe === ye) {
                        tt = null;
                        break;
                      }
                      if (Me !== null) {
                        Me.return = et, tt = Me;
                        break;
                      }
                      tt = et;
                    }
                  }
                }
                var it = R.alternate;
                if (it !== null) {
                  var lt = it.child;
                  if (lt !== null) {
                    it.child = null;
                    do {
                      var Kn = lt.sibling;
                      lt.sibling = null, lt = Kn;
                    } while (lt !== null);
                  }
                }
                tt = R;
              }
            }
            if ((R.subtreeFlags & 2064) !== 0 && A !== null) A.return = R, tt = A;else e: for (; tt !== null;) {
              if (R = tt, (R.flags & 2048) !== 0) switch (R.tag) {
                case 0:
                case 11:
                case 15:
                  du(9, R, R.return);
              }
              var pe = R.sibling;
              if (pe !== null) {
                pe.return = R.return, tt = pe;
                break e;
              }
              tt = R.return;
            }
          }
          var oe = r.current;
          for (tt = oe; tt !== null;) {
            A = tt;
            var he = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && he !== null) he.return = A, tt = he;else e: for (A = oe; tt !== null;) {
              if (q = tt, (q.flags & 2048) !== 0) try {
                switch (q.tag) {
                  case 0:
                  case 11:
                  case 15:
                    uc(9, q);
                }
              } catch (ut) {
                $n(q, q.return, ut);
              }
              if (q === A) {
                tt = null;
                break e;
              }
              var He = q.sibling;
              if (He !== null) {
                He.return = q.return, tt = He;
                break e;
              }
              tt = q.return;
            }
          }
          if (on = S, ga(), qi && typeof qi.onPostCommitFiberRoot == "function") try {
            qi.onPostCommitFiberRoot(Iu, r);
          } catch {}
          g = !0;
        }
        return g;
      } finally {
        gn = d, ii.transition = o;
      }
    }
    return !1;
  }
  function Qh(r, o, d) {
    o = Ys(d, o), o = zh(r, o, 1), r = Ti(r, o, 1), o = hr(), r !== null && (Tl(r, 1, o), Mr(r, o));
  }
  function $n(r, o, d) {
    if (r.tag === 3) Qh(r, r, d);else for (; o !== null;) {
      if (o.tag === 3) {
        Qh(o, r, d);
        break;
      } else if (o.tag === 1) {
        var g = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && (So === null || !So.has(g))) {
          r = Ys(d, r), r = Vh(o, r, 1), o = Ti(o, r, 1), r = hr(), o !== null && (Tl(o, 1, r), Mr(o, r));
          break;
        }
      }
      o = o.return;
    }
  }
  function Nw(r, o, d) {
    var g = r.pingCache;
    g !== null && g.delete(o), o = hr(), r.pingedLanes |= r.suspendedLanes & d, pr === r && (Sr & d) === d && (Zn === 4 || Zn === 3 && (Sr & 130023424) === Sr && 500 > yn() - fc ? Kl(r, 0) : qh |= d), Mr(r, o);
  }
  function nv(r, o) {
    o === 0 && ((r.mode & 1) === 0 ? o = 1 : (o = Yi, Yi <<= 1, (Yi & 130023424) === 0 && (Yi = 4194304)));
    var d = hr();
    r = En(r, o), r !== null && (Tl(r, o, d), Mr(r, d));
  }
  function Rb(r) {
    var o = r.memoizedState,
      d = 0;
    o !== null && (d = o.retryLane), nv(r, d);
  }
  function zw(r, o) {
    var d = 0;
    switch (r.tag) {
      case 13:
        var g = r.stateNode,
          S = r.memoizedState;
        S !== null && (d = S.retryLane);
        break;
      case 19:
        g = r.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    g !== null && g.delete(o), nv(r, d);
  }
  var ly;
  ly = function (r, o, d) {
    if (r !== null) {
      if (r.memoizedProps !== o.pendingProps || or.current) Dr = !0;else {
        if ((r.lanes & d) === 0 && (o.flags & 128) === 0) return Dr = !1, zr(r, o, d);
        Dr = (r.flags & 131072) !== 0;
      }
    } else Dr = !1, In && (o.flags & 1048576) !== 0 && jg(o, Ja, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var g = o.type;
        ll(r, o), r = o.pendingProps;
        var S = xi(o, Hn.current);
        Fs(o, d), S = Ju(null, o, g, r, S, d);
        var R = ec();
        return o.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, tr(g) ? (R = !0, Gr(o)) : R = !1, o.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, Dh(o), S.updater = qd, o.stateNode = S, S._reactInternals = o, Oh(o, g, r, d), o = lc(null, o, g, !0, R, d)) : (o.tag = 0, In && R && Vd(o), _n(null, o, S, d), o = o.child), o;
      case 16:
        g = o.elementType;
        e: {
          switch (ll(r, o), r = o.pendingProps, S = g._init, g = S(g._payload), o.type = g, S = o.tag = Db(g), r = si(g, r), S) {
            case 0:
              o = sf(null, o, g, r, d);
              break e;
            case 1:
              o = oc(null, o, g, r, d);
              break e;
            case 11:
              o = $l(null, o, g, r, d);
              break e;
            case 14:
              o = jt(null, o, g, si(g.type, r), d);
              break e;
          }
          throw Error(i(306, g, ""));
        }
        return o;
      case 0:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), sf(r, o, g, S, d);
      case 1:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), oc(r, o, g, S, d);
      case 3:
        e: {
          if (Km(o), r === null) throw Error(i(387));
          g = o.pendingProps, R = o.memoizedState, S = R.element, zg(r, o), Wd(o, g, null, d);
          var A = o.memoizedState;
          if (g = A.element, R.isDehydrated) {
            if (R = {
              element: g,
              isDehydrated: !1,
              cache: A.cache,
              pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
              transitions: A.transitions
            }, o.updateQueue.baseState = R, o.memoizedState = R, o.flags & 256) {
              S = Ys(Error(i(423)), o), o = Qm(r, o, g, d, S);
              break e;
            } else if (g !== S) {
              S = Ys(Error(i(424)), o), o = Qm(r, o, g, d, S);
              break e;
            } else for (Kr = ha(o.stateNode.containerInfo.firstChild), Xr = o, In = !0, Ei = null, d = qg(o, null, g, d), o.child = d; d;) d.flags = d.flags & -3 | 4096, d = d.sibling;
          } else {
            if (Wo(), g === S) {
              o = Ir(r, o, d);
              break e;
            }
            _n(r, o, g, d);
          }
          o = o.child;
        }
        return o;
      case 5:
        return Xn(o), r === null && Th(o), g = o.type, S = o.pendingProps, R = r !== null ? r.memoizedProps : null, A = S.children, Ad(g, S) ? A = null : R !== null && Ad(g, R) && (o.flags |= 32), Sb(r, o), _n(r, o, A, d), o.child;
      case 6:
        return r === null && Th(o), null;
      case 13:
        return Zm(r, o, d);
      case 4:
        return Wt(o, o.stateNode.containerInfo), g = o.pendingProps, r === null ? o.child = Vl(o, null, g, d) : _n(r, o, g, d), o.child;
      case 11:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), $l(r, o, g, S, d);
      case 7:
        return _n(r, o, o.pendingProps, d), o.child;
      case 8:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 12:
        return _n(r, o, o.pendingProps.children, d), o.child;
      case 10:
        e: {
          if (g = o.type._context, S = o.pendingProps, R = o.memoizedProps, A = S.value, ft(Hd, g._currentValue), g._currentValue = A, R !== null) if (Gi(R.value, A)) {
            if (R.children === S.children && !or.current) {
              o = Ir(r, o, d);
              break e;
            }
          } else for (R = o.child, R !== null && (R.return = o); R !== null;) {
            var q = R.dependencies;
            if (q !== null) {
              A = R.child;
              for (var re = q.firstContext; re !== null;) {
                if (re.context === g) {
                  if (R.tag === 1) {
                    re = wa(-1, d & -d), re.tag = 2;
                    var ye = R.updateQueue;
                    if (ye !== null) {
                      ye = ye.shared;
                      var Oe = ye.pending;
                      Oe === null ? re.next = re : (re.next = Oe.next, Oe.next = re), ye.pending = re;
                    }
                  }
                  R.lanes |= d, re = R.alternate, re !== null && (re.lanes |= d), ui(R.return, d, o), q.lanes |= d;
                  break;
                }
                re = re.next;
              }
            } else if (R.tag === 10) A = R.type === o.type ? null : R.child;else if (R.tag === 18) {
              if (A = R.return, A === null) throw Error(i(341));
              A.lanes |= d, q = A.alternate, q !== null && (q.lanes |= d), ui(A, d, o), A = R.sibling;
            } else A = R.child;
            if (A !== null) A.return = R;else for (A = R; A !== null;) {
              if (A === o) {
                A = null;
                break;
              }
              if (R = A.sibling, R !== null) {
                R.return = A.return, A = R;
                break;
              }
              A = A.return;
            }
            R = A;
          }
          _n(r, o, S.children, d), o = o.child;
        }
        return o;
      case 9:
        return S = o.type, g = o.pendingProps.children, Fs(o, d), S = ki(S), g = g(S), o.flags |= 1, _n(r, o, g, d), o.child;
      case 14:
        return g = o.type, S = si(g, o.pendingProps), S = si(g.type, S), jt(r, o, g, S, d);
      case 15:
        return ac(r, o, o.type, o.pendingProps, d);
      case 17:
        return g = o.type, S = o.pendingProps, S = o.elementType === g ? S : si(g, S), ll(r, o), o.tag = 1, tr(g) ? (r = !0, Gr(o)) : r = !1, Fs(o, d), Lh(o, g, S), Oh(o, g, S, d), lc(null, o, g, !0, r, d);
      case 19:
        return ol(r, o, d);
      case 22:
        return Bh(r, o, d);
    }
    throw Error(i(156, o.tag));
  };
  function sy(r, o) {
    return Or(r, o);
  }
  function Vw(r, o, d, g) {
    this.tag = r, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = g, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Oi(r, o, d, g) {
    return new Vw(r, o, d, g);
  }
  function Zh(r) {
    return r = r.prototype, !(!r || !r.isReactComponent);
  }
  function Db(r) {
    if (typeof r == "function") return Zh(r) ? 1 : 0;
    if (r != null) {
      if (r = r.$$typeof, r === ee) return 11;
      if (r === le) return 14;
    }
    return 2;
  }
  function La(r, o) {
    var d = r.alternate;
    return d === null ? (d = Oi(r.tag, o, r.key, r.mode), d.elementType = r.elementType, d.type = r.type, d.stateNode = r.stateNode, d.alternate = r, r.alternate = d) : (d.pendingProps = o, d.type = r.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = r.flags & 14680064, d.childLanes = r.childLanes, d.lanes = r.lanes, d.child = r.child, d.memoizedProps = r.memoizedProps, d.memoizedState = r.memoizedState, d.updateQueue = r.updateQueue, o = r.dependencies, d.dependencies = o === null ? null : {
      lanes: o.lanes,
      firstContext: o.firstContext
    }, d.sibling = r.sibling, d.index = r.index, d.ref = r.ref, d;
  }
  function Jl(r, o, d, g, S, R) {
    var A = 2;
    if (g = r, typeof r == "function") Zh(r) && (A = 1);else if (typeof r == "string") A = 5;else e: switch (r) {
      case G:
        return oo(d.children, S, R, o);
      case Q:
        A = 8, S |= 8;
        break;
      case te:
        return r = Oi(12, d, o, S | 2), r.elementType = te, r.lanes = R, r;
      case ae:
        return r = Oi(13, d, o, S), r.elementType = ae, r.lanes = R, r;
      case ne:
        return r = Oi(19, d, o, S), r.elementType = ne, r.lanes = R, r;
      case W:
        return jc(d, S, R, o);
      default:
        if (typeof r == "object" && r !== null) switch (r.$$typeof) {
          case ie:
            A = 10;
            break e;
          case Y:
            A = 9;
            break e;
          case ee:
            A = 11;
            break e;
          case le:
            A = 14;
            break e;
          case ce:
            A = 16, g = null;
            break e;
        }
        throw Error(i(130, r == null ? r : typeof r, ""));
    }
    return o = Oi(A, d, o, S), o.elementType = r, o.type = g, o.lanes = R, o;
  }
  function oo(r, o, d, g) {
    return r = Oi(7, r, g, o), r.lanes = d, r;
  }
  function jc(r, o, d, g) {
    return r = Oi(22, r, g, o), r.elementType = W, r.lanes = d, r.stateNode = {
      isHidden: !1
    }, r;
  }
  function gf(r, o, d) {
    return r = Oi(6, r, null, o), r.lanes = d, r;
  }
  function yf(r, o, d) {
    return o = Oi(4, r.children !== null ? r.children : [], r.key, o), o.lanes = d, o.stateNode = {
      containerInfo: r.containerInfo,
      pendingChildren: null,
      implementation: r.implementation
    }, o;
  }
  function Ib(r, o, d, g, S) {
    this.tag = o, this.containerInfo = r, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Kp(0), this.expirationTimes = Kp(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kp(0), this.identifierPrefix = g, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function dp(r, o, d, g, S, R, A, q, re) {
    return r = new Ib(r, o, d, q, re), o === 1 ? (o = 1, R === !0 && (o |= 8)) : o = 0, R = Oi(3, null, null, o), r.current = R, R.stateNode = r, R.memoizedState = {
      element: g,
      isDehydrated: d,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null
    }, Dh(R), r;
  }
  function Mb(r, o, d) {
    var g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: K,
      key: g == null ? null : "" + g,
      children: r,
      containerInfo: o,
      implementation: d
    };
  }
  function uy(r) {
    if (!r) return qr;
    r = r._reactInternals;
    e: {
      if ($t(r) !== r || r.tag !== 1) throw Error(i(170));
      var o = r;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (tr(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(i(171));
    }
    if (r.tag === 1) {
      var d = r.type;
      if (tr(d)) return Gu(r, d, o);
    }
    return o;
  }
  function cy(r, o, d, g, S, R, A, q, re) {
    return r = dp(d, g, !0, r, S, R, A, q, re), r.context = uy(null), d = r.current, g = hr(), S = Ca(d), R = wa(g, S), R.callback = o ?? null, Ti(d, R, S), r.current.lanes = S, Tl(r, S, g), Mr(r, g), r;
  }
  function Fc(r, o, d, g) {
    var S = o.current,
      R = hr(),
      A = Ca(S);
    return d = uy(d), o.context === null ? o.context = d : o.pendingContext = d, o = wa(R, A), o.payload = {
      element: r
    }, g = g === void 0 ? null : g, g !== null && (o.callback = g), r = Ti(S, o, A), r !== null && (Li(r, S, A, R), to(r, S, A)), A;
  }
  function vc(r) {
    if (r = r.current, !r.child) return null;
    switch (r.child.tag) {
      case 5:
        return r.child.stateNode;
      default:
        return r.child.stateNode;
    }
  }
  function Jh(r, o) {
    if (r = r.memoizedState, r !== null && r.dehydrated !== null) {
      var d = r.retryLane;
      r.retryLane = d !== 0 && d < o ? d : o;
    }
  }
  function Qs(r, o) {
    Jh(r, o), (r = r.alternate) && Jh(r, o);
  }
  function fp() {
    return null;
  }
  var dy = typeof reportError == "function" ? reportError : function (r) {
    console.error(r);
  };
  function em(r) {
    this._internalRoot = r;
  }
  bf.prototype.render = em.prototype.render = function (r) {
    var o = this._internalRoot;
    if (o === null) throw Error(i(409));
    Fc(r, o, null, null);
  }, bf.prototype.unmount = em.prototype.unmount = function () {
    var r = this._internalRoot;
    if (r !== null) {
      this._internalRoot = null;
      var o = r.containerInfo;
      Ko(function () {
        Fc(null, r, null, null);
      }), o[Qa] = null;
    }
  };
  function bf(r) {
    this._internalRoot = r;
  }
  bf.prototype.unstable_scheduleHydration = function (r) {
    if (r) {
      var o = At();
      r = {
        blockedOn: null,
        target: r,
        priority: o
      };
      for (var d = 0; d < br.length && o !== 0 && o < br[d].priority; d++);
      br.splice(d, 0, r), d === 0 && nh(r);
    }
  };
  function tm(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11);
  }
  function wf(r) {
    return !(!r || r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11 && (r.nodeType !== 8 || r.nodeValue !== " react-mount-point-unstable "));
  }
  function rv() {}
  function Lb(r, o, d, g, S) {
    if (S) {
      if (typeof g == "function") {
        var R = g;
        g = function () {
          var ye = vc(A);
          R.call(ye);
        };
      }
      var A = cy(o, g, r, 0, null, !1, !1, "", rv);
      return r._reactRootContainer = A, r[Qa] = A.current, Is(r.nodeType === 8 ? r.parentNode : r), Ko(), A;
    }
    for (; S = r.lastChild;) r.removeChild(S);
    if (typeof g == "function") {
      var q = g;
      g = function () {
        var ye = vc(re);
        q.call(ye);
      };
    }
    var re = dp(r, 0, !1, null, null, !1, !1, "", rv);
    return r._reactRootContainer = re, r[Qa] = re.current, Is(r.nodeType === 8 ? r.parentNode : r), Ko(function () {
      Fc(o, re, d, g);
    }), re;
  }
  function _f(r, o, d, g, S) {
    var R = d._reactRootContainer;
    if (R) {
      var A = R;
      if (typeof S == "function") {
        var q = S;
        S = function () {
          var re = vc(A);
          q.call(re);
        };
      }
      Fc(o, A, r, S);
    } else A = Lb(d, o, r, S, g);
    return vc(A);
  }
  bn = function (r) {
    switch (r.tag) {
      case 3:
        var o = r.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var d = Cl(o.pendingLanes);
          d !== 0 && (pd(o, d | 1), Mr(o, yn()), (on & 6) === 0 && (ao = yn() + 500, ga()));
        }
        break;
      case 13:
        Ko(function () {
          var g = En(r, 1);
          if (g !== null) {
            var S = hr();
            Li(g, r, 1, S);
          }
        }), Qs(r, 1);
    }
  }, Zp = function (r) {
    if (r.tag === 13) {
      var o = En(r, 134217728);
      if (o !== null) {
        var d = hr();
        Li(o, r, 134217728, d);
      }
      Qs(r, 134217728);
    }
  }, Jp = function (r) {
    if (r.tag === 13) {
      var o = Ca(r),
        d = En(r, o);
      if (d !== null) {
        var g = hr();
        Li(d, r, o, g);
      }
      Qs(r, o);
    }
  }, At = function () {
    return gn;
  }, eh = function (r, o) {
    var d = gn;
    try {
      return gn = r, o();
    } finally {
      gn = d;
    }
  }, en = function (r, o, d) {
    switch (o) {
      case "input":
        if (un(r, d), o = d.name, d.type === "radio" && o != null) {
          for (d = r; d.parentNode;) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < d.length; o++) {
            var g = d[o];
            if (g !== r && g.form === r.form) {
              var S = Gn(g);
              if (!S) throw Error(i(90));
              ge(g), un(g, S);
            }
          }
        }
        break;
      case "textarea":
        Lt(r, d);
        break;
      case "select":
        o = d.value, o != null && Dt(r, !!d.multiple, o, !1);
    }
  }, _s = Xh, Mo = Ko;
  var Ob = {
      usingClientEntryPoint: !1,
      Events: [pt, Xi, Gn, ss, yo, Xh]
    },
    cl = {
      findFiberByHostInstance: Fl,
      bundleType: 0,
      version: "18.2.0",
      rendererPackageName: "react-dom"
    },
    gc = {
      bundleType: cl.bundleType,
      version: cl.version,
      rendererPackageName: cl.rendererPackageName,
      rendererConfig: cl.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: j.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (r) {
        return r = Tn(r), r === null ? null : r.stateNode;
      },
      findFiberByHostInstance: cl.findFiberByHostInstance || fp,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
    };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Zs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Zs.isDisabled && Zs.supportsFiber) try {
      Iu = Zs.inject(gc), qi = Zs;
    } catch {}
  }
  return Jc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ob, Jc.createPortal = function (r, o) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tm(o)) throw Error(i(200));
    return Mb(r, o, null, d);
  }, Jc.createRoot = function (r, o) {
    if (!tm(r)) throw Error(i(299));
    var d = !1,
      g = "",
      S = dy;
    return o != null && (o.unstable_strictMode === !0 && (d = !0), o.identifierPrefix !== void 0 && (g = o.identifierPrefix), o.onRecoverableError !== void 0 && (S = o.onRecoverableError)), o = dp(r, 1, !1, null, null, d, !1, g, S), r[Qa] = o.current, Is(r.nodeType === 8 ? r.parentNode : r), new em(o);
  }, Jc.findDOMNode = function (r) {
    if (r == null) return null;
    if (r.nodeType === 1) return r;
    var o = r._reactInternals;
    if (o === void 0) throw typeof r.render == "function" ? Error(i(188)) : (r = Object.keys(r).join(","), Error(i(268, r)));
    return r = Tn(o), r = r === null ? null : r.stateNode, r;
  }, Jc.flushSync = function (r) {
    return Ko(r);
  }, Jc.hydrate = function (r, o, d) {
    if (!wf(o)) throw Error(i(200));
    return _f(null, r, o, !0, d);
  }, Jc.hydrateRoot = function (r, o, d) {
    if (!tm(r)) throw Error(i(405));
    var g = d != null && d.hydratedSources || null,
      S = !1,
      R = "",
      A = dy;
    if (d != null && (d.unstable_strictMode === !0 && (S = !0), d.identifierPrefix !== void 0 && (R = d.identifierPrefix), d.onRecoverableError !== void 0 && (A = d.onRecoverableError)), o = cy(o, null, r, 1, d ?? null, S, !1, R, A), r[Qa] = o.current, Is(r), g) for (r = 0; r < g.length; r++) d = g[r], S = d._getVersion, S = S(d._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [d, S] : o.mutableSourceEagerHydrationData.push(d, S);
    return new bf(o);
  }, Jc.render = function (r, o, d) {
    if (!wf(o)) throw Error(i(200));
    return _f(null, r, o, !1, d);
  }, Jc.unmountComponentAtNode = function (r) {
    if (!wf(r)) throw Error(i(40));
    return r._reactRootContainer ? (Ko(function () {
      _f(null, null, r, !1, function () {
        r._reactRootContainer = null, r[Qa] = null;
      });
    }), !0) : !1;
  }, Jc.unstable_batchedUpdates = Xh, Jc.unstable_renderSubtreeIntoContainer = function (r, o, d, g) {
    if (!wf(d)) throw Error(i(200));
    if (r == null || r._reactInternals === void 0) throw Error(i(38));
    return _f(r, o, d, !1, g);
  }, Jc.version = "18.2.0-next-9e3b772b8-20220608", Jc;
}
var ed = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bU;
function Ege() {
  return bU || (bU = 1, process.env.NODE_ENV !== "production" && function () {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Nt,
      e = j8(),
      i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      s = !1;
    function c(n) {
      s = n;
    }
    function p(n) {
      if (!s) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), m = 1; m < a; m++) f[m - 1] = arguments[m];
        y("warn", n, f);
      }
    }
    function h(n) {
      if (!s) {
        for (var a = arguments.length, f = new Array(a > 1 ? a - 1 : 0), m = 1; m < a; m++) f[m - 1] = arguments[m];
        y("error", n, f);
      }
    }
    function y(n, a, f) {
      {
        var m = i.ReactDebugCurrentFrame,
          b = m.getStackAddendum();
        b !== "" && (a += "%s", f = f.concat([b]));
        var T = f.map(function (M) {
          return String(M);
        });
        T.unshift("Warning: " + a), Function.prototype.apply.call(console[n], console, T);
      }
    }
    var w = 0,
      x = 1,
      E = 2,
      C = 3,
      k = 4,
      D = 5,
      I = 6,
      L = 7,
      P = 8,
      N = 9,
      O = 10,
      F = 11,
      j = 12,
      V = 13,
      K = 14,
      G = 15,
      Q = 16,
      te = 17,
      ie = 18,
      Y = 19,
      ee = 21,
      ae = 22,
      ne = 23,
      le = 24,
      ce = 25,
      W = !0,
      $ = !1,
      de = !1,
      H = !1,
      se = !1,
      ue = !1,
      Ee = !0,
      Ce = !0,
      fe = !0,
      _e = /* @__PURE__ */new Set(),
      Se = {},
      be = {};
    function Le(n, a) {
      Be(n, a), Be(n + "Capture", a);
    }
    function Be(n, a) {
      Se[n] && h("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", n), Se[n] = a;
      {
        var f = n.toLowerCase();
        be[f] = n, n === "onDoubleClick" && (be.ondblclick = n);
      }
      for (var m = 0; m < a.length; m++) _e.add(a[m]);
    }
    var Xe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u",
      ge = Object.prototype.hasOwnProperty;
    function qe(n) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag,
          f = a && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return f;
      }
    }
    function Ae(n) {
      try {
        return Mt(n), !1;
      } catch {
        return !0;
      }
    }
    function Mt(n) {
      return "" + n;
    }
    function Ft(n, a) {
      if (Ae(n)) return h("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function un(n) {
      if (Ae(n)) return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    function gt(n, a) {
      if (Ae(n)) return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function Pt(n, a) {
      if (Ae(n)) return h("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", a, qe(n)), Mt(n);
    }
    function St(n) {
      if (Ae(n)) return h("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    function Dt(n) {
      if (Ae(n)) return h("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", qe(n)), Mt(n);
    }
    var Kt = 0,
      hn = 1,
      Lt = 2,
      Et = 3,
      Vt = 4,
      Xt = 5,
      vn = 6,
      ot = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
      We = ot + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
      ht = new RegExp("^[" + ot + "][" + We + "]*$"),
      Ke = {},
      yt = {};
    function je(n) {
      return ge.call(yt, n) ? !0 : ge.call(Ke, n) ? !1 : ht.test(n) ? (yt[n] = !0, !0) : (Ke[n] = !0, h("Invalid attribute name: `%s`", n), !1);
    }
    function at(n, a, f) {
      return a !== null ? a.type === Kt : f ? !1 : n.length > 2 && (n[0] === "o" || n[0] === "O") && (n[1] === "n" || n[1] === "N");
    }
    function kt(n, a, f, m) {
      if (f !== null && f.type === Kt) return !1;
      switch (typeof a) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean":
          {
            if (m) return !1;
            if (f !== null) return !f.acceptsBooleans;
            var b = n.toLowerCase().slice(0, 5);
            return b !== "data-" && b !== "aria-";
          }
        default:
          return !1;
      }
    }
    function Bt(n, a, f, m) {
      if (a === null || typeof a > "u" || kt(n, a, f, m)) return !0;
      if (m) return !1;
      if (f !== null) switch (f.type) {
        case Et:
          return !a;
        case Vt:
          return a === !1;
        case Xt:
          return isNaN(a);
        case vn:
          return isNaN(a) || a < 1;
      }
      return !1;
    }
    function Ht(n) {
      return en.hasOwnProperty(n) ? en[n] : null;
    }
    function sn(n, a, f, m, b, T, M) {
      this.acceptsBooleans = a === Lt || a === Et || a === Vt, this.attributeName = m, this.attributeNamespace = b, this.mustUseProperty = f, this.propertyName = n, this.type = a, this.sanitizeURL = T, this.removeEmptyString = M;
    }
    var en = {},
      Rr = ["children", "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning", "suppressHydrationWarning", "style"];
    Rr.forEach(function (n) {
      en[n] = new sn(n, Kt, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (n) {
      var a = n[0],
        f = n[1];
      en[a] = new sn(a, hn, !1,
      // mustUseProperty
      f,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (n) {
      en[n] = new sn(n, Lt, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (n) {
      en[n] = new sn(n, Lt, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["allowFullScreen", "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus", "autoPlay", "controls", "default", "defer", "disabled", "disablePictureInPicture", "disableRemotePlayback", "formNoValidate", "hidden", "loop", "noModule", "noValidate", "open", "playsInline", "readOnly", "required", "reversed", "scoped", "seamless",
    // Microdata
    "itemScope"].forEach(function (n) {
      en[n] = new sn(n, Et, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple", "muted", "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new sn(n, Et, !0,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["capture", "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new sn(n, Vt, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["cols", "rows", "size", "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      en[n] = new sn(n, vn, !1,
      // mustUseProperty
      n,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["rowSpan", "start"].forEach(function (n) {
      en[n] = new sn(n, Xt, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var Nr = /[\-\:]([a-z])/g,
      Hi = function (n) {
        return n[1].toUpperCase();
      };
    ["accent-height", "alignment-baseline", "arabic-form", "baseline-shift", "cap-height", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "dominant-baseline", "enable-background", "fill-opacity", "fill-rule", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "glyph-name", "glyph-orientation-horizontal", "glyph-orientation-vertical", "horiz-adv-x", "horiz-origin-x", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "overline-position", "overline-thickness", "paint-order", "panose-1", "pointer-events", "rendering-intent", "shape-rendering", "stop-color", "stop-opacity", "strikethrough-position", "strikethrough-thickness", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-rendering", "underline-position", "underline-thickness", "unicode-bidi", "unicode-range", "units-per-em", "v-alphabetic", "v-hanging", "v-ideographic", "v-mathematical", "vector-effect", "vert-adv-y", "vert-origin-x", "vert-origin-y", "word-spacing", "writing-mode", "xmlns:xlink", "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new sn(a, hn, !1,
      // mustUseProperty
      n, null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    }), ["xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new sn(a, hn, !1,
      // mustUseProperty
      n, "http://www.w3.org/1999/xlink", !1,
      // sanitizeURL
      !1);
    }), ["xml:base", "xml:lang", "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
    ].forEach(function (n) {
      var a = n.replace(Nr, Hi);
      en[a] = new sn(a, hn, !1,
      // mustUseProperty
      n, "http://www.w3.org/XML/1998/namespace", !1,
      // sanitizeURL
      !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (n) {
      en[n] = new sn(n, hn, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1);
    });
    var ss = "xlinkHref";
    en[ss] = new sn("xlinkHref", hn, !1,
    // mustUseProperty
    "xlink:href", "http://www.w3.org/1999/xlink", !0,
    // sanitizeURL
    !1), ["src", "href", "action", "formAction"].forEach(function (n) {
      en[n] = new sn(n, hn, !1,
      // mustUseProperty
      n.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0);
    });
    var yo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
      _s = !1;
    function Mo(n) {
      !_s && yo.test(n) && (_s = !0, h("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    function bo(n, a, f, m) {
      if (m.mustUseProperty) {
        var b = m.propertyName;
        return n[b];
      } else {
        Ft(f, a), m.sanitizeURL && Mo("" + f);
        var T = m.attributeName,
          M = null;
        if (m.type === Vt) {
          if (n.hasAttribute(T)) {
            var z = n.getAttribute(T);
            return z === "" ? !0 : Bt(a, f, m, !1) ? z : z === "" + f ? f : z;
          }
        } else if (n.hasAttribute(T)) {
          if (Bt(a, f, m, !1)) return n.getAttribute(T);
          if (m.type === Et) return f;
          M = n.getAttribute(T);
        }
        return Bt(a, f, m, !1) ? M === null ? f : M : M === "" + f ? f : M;
      }
    }
    function Tu(n, a, f, m) {
      {
        if (!je(a)) return;
        if (!n.hasAttribute(a)) return f === void 0 ? void 0 : null;
        var b = n.getAttribute(a);
        return Ft(f, a), b === "" + f ? f : b;
      }
    }
    function Ha(n, a, f, m) {
      var b = Ht(a);
      if (!at(a, b, m)) {
        if (Bt(a, f, b, m) && (f = null), m || b === null) {
          if (je(a)) {
            var T = a;
            f === null ? n.removeAttribute(T) : (Ft(f, a), n.setAttribute(T, "" + f));
          }
          return;
        }
        var M = b.mustUseProperty;
        if (M) {
          var z = b.propertyName;
          if (f === null) {
            var U = b.type;
            n[z] = U === Et ? !1 : "";
          } else n[z] = f;
          return;
        }
        var X = b.attributeName,
          J = b.attributeNamespace;
        if (f === null) n.removeAttribute(X);else {
          var me = b.type,
            xe;
          me === Et || me === Vt && f === !0 ? xe = "" : (Ft(f, X), xe = "" + f, b.sanitizeURL && Mo(xe.toString())), J ? n.setAttributeNS(J, X, xe) : n.setAttribute(X, xe);
        }
      }
    }
    var $i = Symbol.for("react.element"),
      oi = Symbol.for("react.portal"),
      Lo = Symbol.for("react.fragment"),
      $a = Symbol.for("react.strict_mode"),
      Oo = Symbol.for("react.profiler"),
      Z = Symbol.for("react.provider"),
      Ne = Symbol.for("react.context"),
      Ye = Symbol.for("react.forward_ref"),
      xt = Symbol.for("react.suspense"),
      rn = Symbol.for("react.suspense_list"),
      $t = Symbol.for("react.memo"),
      Ct = Symbol.for("react.lazy"),
      qt = Symbol.for("react.scope"),
      yr = Symbol.for("react.debug_trace_mode"),
      Tn = Symbol.for("react.offscreen"),
      jn = Symbol.for("react.legacy_hidden"),
      Or = Symbol.for("react.cache"),
      Wa = Symbol.for("react.tracing_marker"),
      Ru = Symbol.iterator,
      Wi = "@@iterator";
    function yn(n) {
      if (n === null || typeof n != "object") return null;
      var a = Ru && n[Ru] || n[Wi];
      return typeof a == "function" ? a : null;
    }
    var Qt = Object.assign,
      El = 0,
      Wp,
      Du,
      tg,
      qp,
      Iu,
      qi,
      ng;
    function gi() {}
    gi.__reactDisabledLog = !0;
    function cw() {
      {
        if (El === 0) {
          Wp = console.log, Du = console.info, tg = console.warn, qp = console.error, Iu = console.group, qi = console.groupCollapsed, ng = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: gi,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        El++;
      }
    }
    function dw() {
      {
        if (El--, El === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Qt({}, n, {
              value: Wp
            }),
            info: Qt({}, n, {
              value: Du
            }),
            warn: Qt({}, n, {
              value: tg
            }),
            error: Qt({}, n, {
              value: qp
            }),
            group: Qt({}, n, {
              value: Iu
            }),
            groupCollapsed: Qt({}, n, {
              value: qi
            }),
            groupEnd: Qt({}, n, {
              value: ng
            })
          });
        }
        El < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Yp = i.ReactCurrentDispatcher,
      xs;
    function Yi(n, a, f) {
      {
        if (xs === void 0) try {
          throw Error();
        } catch (b) {
          var m = b.stack.trim().match(/\n( *(at )?)/);
          xs = m && m[1] || "";
        }
        return `
` + xs + n;
      }
    }
    var Cl = !1,
      kl;
    {
      var fw = typeof WeakMap == "function" ? WeakMap : Map;
      kl = new fw();
    }
    function Gp(n, a) {
      if (!n || Cl) return "";
      {
        var f = kl.get(n);
        if (f !== void 0) return f;
      }
      var m;
      Cl = !0;
      var b = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Yp.current, Yp.current = null, cw();
      try {
        if (a) {
          var M = function () {
            throw Error();
          };
          if (Object.defineProperty(M.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(M, []);
            } catch (Pe) {
              m = Pe;
            }
            Reflect.construct(n, [], M);
          } else {
            try {
              M.call();
            } catch (Pe) {
              m = Pe;
            }
            n.call(M.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pe) {
            m = Pe;
          }
          n();
        }
      } catch (Pe) {
        if (Pe && m && typeof Pe.stack == "string") {
          for (var z = Pe.stack.split(`
`), U = m.stack.split(`
`), X = z.length - 1, J = U.length - 1; X >= 1 && J >= 0 && z[X] !== U[J];) J--;
          for (; X >= 1 && J >= 0; X--, J--) if (z[X] !== U[J]) {
            if (X !== 1 || J !== 1) do if (X--, J--, J < 0 || z[X] !== U[J]) {
              var me = `
` + z[X].replace(" at new ", " at ");
              return n.displayName && me.includes("<anonymous>") && (me = me.replace("<anonymous>", n.displayName)), typeof n == "function" && kl.set(n, me), me;
            } while (X >= 1 && J >= 0);
            break;
          }
        }
      } finally {
        Cl = !1, Yp.current = T, dw(), Error.prepareStackTrace = b;
      }
      var xe = n ? n.displayName || n.name : "",
        Ie = xe ? Yi(xe) : "";
      return typeof n == "function" && kl.set(n, Ie), Ie;
    }
    function Xp(n, a, f) {
      return Gp(n, !0);
    }
    function fd(n, a, f) {
      return Gp(n, !1);
    }
    function Kp(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function Tl(n, a, f) {
      if (n == null) return "";
      if (typeof n == "function") return Gp(n, Kp(n));
      if (typeof n == "string") return Yi(n);
      switch (n) {
        case xt:
          return Yi("Suspense");
        case rn:
          return Yi("SuspenseList");
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case Ye:
          return fd(n.render);
        case $t:
          return Tl(n.type, a, f);
        case Ct:
          {
            var m = n,
              b = m._payload,
              T = m._init;
            try {
              return Tl(T(b), a, f);
            } catch {}
          }
      }
      return "";
    }
    function pw(n) {
      switch (n._debugOwner && n._debugOwner.type, n._debugSource, n.tag) {
        case D:
          return Yi(n.type);
        case Q:
          return Yi("Lazy");
        case V:
          return Yi("Suspense");
        case Y:
          return Yi("SuspenseList");
        case w:
        case E:
        case G:
          return fd(n.type);
        case F:
          return fd(n.type.render);
        case x:
          return Xp(n.type);
        default:
          return "";
      }
    }
    function pd(n) {
      try {
        var a = "",
          f = n;
        do a += pw(f), f = f.return; while (f);
        return a;
      } catch (m) {
        return `
Error generating stack: ` + m.message + `
` + m.stack;
      }
    }
    function gn(n, a, f) {
      var m = n.displayName;
      if (m) return m;
      var b = a.displayName || a.name || "";
      return b !== "" ? f + "(" + b + ")" : f;
    }
    function Qp(n) {
      return n.displayName || "Context";
    }
    function bn(n) {
      if (n == null) return null;
      if (typeof n.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function") return n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case Lo:
          return "Fragment";
        case oi:
          return "Portal";
        case Oo:
          return "Profiler";
        case $a:
          return "StrictMode";
        case xt:
          return "Suspense";
        case rn:
          return "SuspenseList";
      }
      if (typeof n == "object") switch (n.$$typeof) {
        case Ne:
          var a = n;
          return Qp(a) + ".Consumer";
        case Z:
          var f = n;
          return Qp(f._context) + ".Provider";
        case Ye:
          return gn(n, n.render, "ForwardRef");
        case $t:
          var m = n.displayName || null;
          return m !== null ? m : bn(n.type) || "Memo";
        case Ct:
          {
            var b = n,
              T = b._payload,
              M = b._init;
            try {
              return bn(M(T));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    function Zp(n, a, f) {
      var m = a.displayName || a.name || "";
      return n.displayName || (m !== "" ? f + "(" + m + ")" : f);
    }
    function Jp(n) {
      return n.displayName || "Context";
    }
    function At(n) {
      var a = n.tag,
        f = n.type;
      switch (a) {
        case le:
          return "Cache";
        case N:
          var m = f;
          return Jp(m) + ".Consumer";
        case O:
          var b = f;
          return Jp(b._context) + ".Provider";
        case ie:
          return "DehydratedFragment";
        case F:
          return Zp(f, f.render, "ForwardRef");
        case L:
          return "Fragment";
        case D:
          return f;
        case k:
          return "Portal";
        case C:
          return "Root";
        case I:
          return "Text";
        case Q:
          return bn(f);
        case P:
          return f === $a ? "StrictMode" : "Mode";
        case ae:
          return "Offscreen";
        case j:
          return "Profiler";
        case ee:
          return "Scope";
        case V:
          return "Suspense";
        case Y:
          return "SuspenseList";
        case ce:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case x:
        case w:
        case te:
        case E:
        case K:
        case G:
          if (typeof f == "function") return f.displayName || f.name || null;
          if (typeof f == "string") return f;
          break;
      }
      return null;
    }
    var eh = i.ReactDebugCurrentFrame,
      Pr = null,
      Po = !1;
    function yi() {
      {
        if (Pr === null) return null;
        var n = Pr._debugOwner;
        if (n !== null && typeof n < "u") return At(n);
      }
      return null;
    }
    function Ao() {
      return Pr === null ? "" : pd(Pr);
    }
    function Un() {
      eh.getCurrentStack = null, Pr = null, Po = !1;
    }
    function Rn(n) {
      eh.getCurrentStack = n === null ? null : Ao, Pr = n, Po = !1;
    }
    function Mu() {
      return Pr;
    }
    function br(n) {
      Po = n;
    }
    function bi(n) {
      return "" + n;
    }
    function qa(n) {
      switch (typeof n) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return Dt(n), n;
        default:
          return "";
      }
    }
    var Lu = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function th(n, a) {
      Lu[a.type] || a.onChange || a.onInput || a.readOnly || a.disabled || a.value == null || h("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), a.onChange || a.readOnly || a.disabled || a.checked == null || h("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function nh(n) {
      var a = n.type,
        f = n.nodeName;
      return f && f.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
    }
    function Ou(n) {
      return n._valueTracker;
    }
    function rg(n) {
      n._valueTracker = null;
    }
    function hw(n) {
      var a = "";
      return n && (nh(n) ? a = n.checked ? "true" : "false" : a = n.value), a;
    }
    function Pu(n) {
      var a = nh(n) ? "checked" : "value",
        f = Object.getOwnPropertyDescriptor(n.constructor.prototype, a);
      Dt(n[a]);
      var m = "" + n[a];
      if (!(n.hasOwnProperty(a) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var b = f.get,
          T = f.set;
        Object.defineProperty(n, a, {
          configurable: !0,
          get: function () {
            return b.call(this);
          },
          set: function (z) {
            Dt(z), m = "" + z, T.call(this, z);
          }
        }), Object.defineProperty(n, a, {
          enumerable: f.enumerable
        });
        var M = {
          getValue: function () {
            return m;
          },
          setValue: function (z) {
            Dt(z), m = "" + z;
          },
          stopTracking: function () {
            rg(n), delete n[a];
          }
        };
        return M;
      }
    }
    function jo(n) {
      Ou(n) || (n._valueTracker = Pu(n));
    }
    function Rl(n) {
      if (!n) return !1;
      var a = Ou(n);
      if (!a) return !0;
      var f = a.getValue(),
        m = hw(n);
      return m !== f ? (a.setValue(m), !0) : !1;
    }
    function Dl(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    var ig = !1,
      ag = !1,
      hd = !1,
      Au = !1;
    function md(n) {
      var a = n.type === "checkbox" || n.type === "radio";
      return a ? n.checked != null : n.value != null;
    }
    function vd(n, a) {
      var f = n,
        m = a.checked,
        b = Qt({}, a, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: m ?? f._wrapperState.initialChecked
        });
      return b;
    }
    function Ya(n, a) {
      th("input", a), a.checked !== void 0 && a.defaultChecked !== void 0 && !ag && (h("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", a.type), ag = !0), a.value !== void 0 && a.defaultValue !== void 0 && !ig && (h("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component", a.type), ig = !0);
      var f = n,
        m = a.defaultValue == null ? "" : a.defaultValue;
      f._wrapperState = {
        initialChecked: a.checked != null ? a.checked : a.defaultChecked,
        initialValue: qa(a.value != null ? a.value : m),
        controlled: md(a)
      };
    }
    function gd(n, a) {
      var f = n,
        m = a.checked;
      m != null && Ha(f, "checked", m, !1);
    }
    function Ss(n, a) {
      var f = n;
      {
        var m = md(a);
        !f._wrapperState.controlled && m && !Au && (h("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Au = !0), f._wrapperState.controlled && !m && !hd && (h("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), hd = !0);
      }
      gd(n, a);
      var b = qa(a.value),
        T = a.type;
      if (b != null) T === "number" ? (b === 0 && f.value === "" ||
      // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      f.value != b) && (f.value = bi(b)) : f.value !== bi(b) && (f.value = bi(b));else if (T === "submit" || T === "reset") {
        f.removeAttribute("value");
        return;
      }
      a.hasOwnProperty("value") ? wd(f, a.type, b) : a.hasOwnProperty("defaultValue") && wd(f, a.type, qa(a.defaultValue)), a.checked == null && a.defaultChecked != null && (f.defaultChecked = !!a.defaultChecked);
    }
    function rh(n, a, f) {
      var m = n;
      if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
        var b = a.type,
          T = b === "submit" || b === "reset";
        if (T && (a.value === void 0 || a.value === null)) return;
        var M = bi(m._wrapperState.initialValue);
        f || M !== m.value && (m.value = M), m.defaultValue = M;
      }
      var z = m.name;
      z !== "" && (m.name = ""), m.defaultChecked = !m.defaultChecked, m.defaultChecked = !!m._wrapperState.initialChecked, z !== "" && (m.name = z);
    }
    function yd(n, a) {
      var f = n;
      Ss(f, a), bd(f, a);
    }
    function bd(n, a) {
      var f = a.name;
      if (a.type === "radio" && f != null) {
        for (var m = n; m.parentNode;) m = m.parentNode;
        Ft(f, "name");
        for (var b = m.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), T = 0; T < b.length; T++) {
          var M = b[T];
          if (!(M === n || M.form !== n.form)) {
            var z = vS(M);
            if (!z) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Rl(M), Ss(M, z);
          }
        }
      }
    }
    function wd(n, a, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (a !== "number" || Dl(n.ownerDocument) !== n) && (f == null ? n.defaultValue = bi(n._wrapperState.initialValue) : n.defaultValue !== bi(f) && (n.defaultValue = bi(f)));
    }
    var $r = !1,
      Il = !1,
      _d = !1;
    function Es(n, a) {
      a.value == null && (typeof a.children == "object" && a.children !== null ? t.Children.forEach(a.children, function (f) {
        f != null && (typeof f == "string" || typeof f == "number" || Il || (Il = !0, h("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : a.dangerouslySetInnerHTML != null && (_d || (_d = !0, h("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), a.selected != null && !$r && (h("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), $r = !0);
    }
    function mw(n, a) {
      a.value != null && n.setAttribute("value", bi(qa(a.value)));
    }
    var ih = Array.isArray;
    function wr(n) {
      return ih(n);
    }
    var Ml;
    Ml = !1;
    function ju() {
      var n = yi();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    var ah = ["value", "defaultValue"];
    function vw(n) {
      {
        th("select", n);
        for (var a = 0; a < ah.length; a++) {
          var f = ah[a];
          if (n[f] != null) {
            var m = wr(n[f]);
            n.multiple && !m ? h("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, ju()) : !n.multiple && m && h("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, ju());
          }
        }
      }
    }
    function Cs(n, a, f, m) {
      var b = n.options;
      if (a) {
        for (var T = f, M = {}, z = 0; z < T.length; z++) M["$" + T[z]] = !0;
        for (var U = 0; U < b.length; U++) {
          var X = M.hasOwnProperty("$" + b[U].value);
          b[U].selected !== X && (b[U].selected = X), X && m && (b[U].defaultSelected = !0);
        }
      } else {
        for (var J = bi(qa(f)), me = null, xe = 0; xe < b.length; xe++) {
          if (b[xe].value === J) {
            b[xe].selected = !0, m && (b[xe].defaultSelected = !0);
            return;
          }
          me === null && !b[xe].disabled && (me = b[xe]);
        }
        me !== null && (me.selected = !0);
      }
    }
    function oh(n, a) {
      return Qt({}, a, {
        value: void 0
      });
    }
    function xd(n, a) {
      var f = n;
      vw(a), f._wrapperState = {
        wasMultiple: !!a.multiple
      }, a.value !== void 0 && a.defaultValue !== void 0 && !Ml && (h("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ml = !0);
    }
    function gw(n, a) {
      var f = n;
      f.multiple = !!a.multiple;
      var m = a.value;
      m != null ? Cs(f, !!a.multiple, m, !1) : a.defaultValue != null && Cs(f, !!a.multiple, a.defaultValue, !0);
    }
    function yw(n, a) {
      var f = n,
        m = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!a.multiple;
      var b = a.value;
      b != null ? Cs(f, !!a.multiple, b, !1) : m !== !!a.multiple && (a.defaultValue != null ? Cs(f, !!a.multiple, a.defaultValue, !0) : Cs(f, !!a.multiple, a.multiple ? [] : "", !1));
    }
    function bw(n, a) {
      var f = n,
        m = a.value;
      m != null && Cs(f, !!a.multiple, m, !1);
    }
    var og = !1;
    function lh(n, a) {
      var f = n;
      if (a.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var m = Qt({}, a, {
        value: void 0,
        defaultValue: void 0,
        children: bi(f._wrapperState.initialValue)
      });
      return m;
    }
    function sh(n, a) {
      var f = n;
      th("textarea", a), a.value !== void 0 && a.defaultValue !== void 0 && !og && (h("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", yi() || "A component"), og = !0);
      var m = a.value;
      if (m == null) {
        var b = a.children,
          T = a.defaultValue;
        if (b != null) {
          h("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (T != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (wr(b)) {
              if (b.length > 1) throw new Error("<textarea> can only have at most one child.");
              b = b[0];
            }
            T = b;
          }
        }
        T == null && (T = ""), m = T;
      }
      f._wrapperState = {
        initialValue: qa(m)
      };
    }
    function lg(n, a) {
      var f = n,
        m = qa(a.value),
        b = qa(a.defaultValue);
      if (m != null) {
        var T = bi(m);
        T !== f.value && (f.value = T), a.defaultValue == null && f.defaultValue !== T && (f.defaultValue = T);
      }
      b != null && (f.defaultValue = bi(b));
    }
    function sg(n, a) {
      var f = n,
        m = f.textContent;
      m === f._wrapperState.initialValue && m !== "" && m !== null && (f.value = m);
    }
    function ww(n, a) {
      lg(n, a);
    }
    var Ga = "http://www.w3.org/1999/xhtml",
      uh = "http://www.w3.org/1998/Math/MathML",
      ch = "http://www.w3.org/2000/svg";
    function dh(n) {
      switch (n) {
        case "svg":
          return ch;
        case "math":
          return uh;
        default:
          return Ga;
      }
    }
    function fh(n, a) {
      return n == null || n === Ga ? dh(a) : n === ch && a === "foreignObject" ? Ga : n;
    }
    var ug = function (n) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (a, f, m, b) {
          MSApp.execUnsafeLocalFunction(function () {
            return n(a, f, m, b);
          });
        } : n;
      },
      Sd,
      cg = ug(function (n, a) {
        if (n.namespaceURI === ch && !("innerHTML" in n)) {
          Sd = Sd || document.createElement("div"), Sd.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>";
          for (var f = Sd.firstChild; n.firstChild;) n.removeChild(n.firstChild);
          for (; f.firstChild;) n.appendChild(f.firstChild);
          return;
        }
        n.innerHTML = a;
      }),
      Wr = 1,
      Xa = 3,
      er = 8,
      Ka = 9,
      ph = 11,
      ks = function (n, a) {
        if (a) {
          var f = n.firstChild;
          if (f && f === n.lastChild && f.nodeType === Xa) {
            f.nodeValue = a;
            return;
          }
        }
        n.textContent = a;
      },
      Fu = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      },
      Nu = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
    function dg(n, a) {
      return n + a.charAt(0).toUpperCase() + a.substring(1);
    }
    var fg = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Nu).forEach(function (n) {
      fg.forEach(function (a) {
        Nu[dg(a, n)] = Nu[n];
      });
    });
    function Ed(n, a, f) {
      var m = a == null || typeof a == "boolean" || a === "";
      return m ? "" : !f && typeof a == "number" && a !== 0 && !(Nu.hasOwnProperty(n) && Nu[n]) ? a + "px" : (Pt(a, n), ("" + a).trim());
    }
    var pg = /([A-Z])/g,
      hg = /^ms-/;
    function Ts(n) {
      return n.replace(pg, "-$1").toLowerCase().replace(hg, "-ms-");
    }
    var mg = function () {};
    {
      var _w = /^(?:webkit|moz|o)[A-Z]/,
        xw = /^-ms-/,
        vg = /-(.)/g,
        hh = /;\s*$/,
        pa = {},
        Ll = {},
        gg = !1,
        zu = !1,
        Sw = function (n) {
          return n.replace(vg, function (a, f) {
            return f.toUpperCase();
          });
        },
        yg = function (n) {
          pa.hasOwnProperty(n) && pa[n] || (pa[n] = !0, h("Unsupported style property %s. Did you mean %s?", n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Sw(n.replace(xw, "ms-"))));
        },
        mh = function (n) {
          pa.hasOwnProperty(n) && pa[n] || (pa[n] = !0, h("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
        },
        vh = function (n, a) {
          Ll.hasOwnProperty(a) && Ll[a] || (Ll[a] = !0, h(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, a.replace(hh, "")));
        },
        bg = function (n, a) {
          gg || (gg = !0, h("`NaN` is an invalid value for the `%s` css style property.", n));
        },
        wg = function (n, a) {
          zu || (zu = !0, h("`Infinity` is an invalid value for the `%s` css style property.", n));
        };
      mg = function (n, a) {
        n.indexOf("-") > -1 ? yg(n) : _w.test(n) ? mh(n) : hh.test(a) && vh(n, a), typeof a == "number" && (isNaN(a) ? bg(n, a) : isFinite(a) || wg(n, a));
      };
    }
    var _g = mg;
    function Ew(n) {
      {
        var a = "",
          f = "";
        for (var m in n) if (n.hasOwnProperty(m)) {
          var b = n[m];
          if (b != null) {
            var T = m.indexOf("--") === 0;
            a += f + (T ? m : Ts(m)) + ":", a += Ed(m, b, T), f = ";";
          }
        }
        return a || null;
      }
    }
    function xg(n, a) {
      var f = n.style;
      for (var m in a) if (a.hasOwnProperty(m)) {
        var b = m.indexOf("--") === 0;
        b || _g(m, a[m]);
        var T = Ed(m, a[m], b);
        m === "float" && (m = "cssFloat"), b ? f.setProperty(m, T) : f[m] = T;
      }
    }
    function Cw(n) {
      return n == null || typeof n == "boolean" || n === "";
    }
    function Sg(n) {
      var a = {};
      for (var f in n) for (var m = Fu[f] || [f], b = 0; b < m.length; b++) a[m[b]] = f;
      return a;
    }
    function kw(n, a) {
      {
        if (!a) return;
        var f = Sg(n),
          m = Sg(a),
          b = {};
        for (var T in f) {
          var M = f[T],
            z = m[T];
          if (z && M !== z) {
            var U = M + "," + z;
            if (b[U]) continue;
            b[U] = !0, h("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Cw(n[M]) ? "Removing" : "Updating", M, z);
          }
        }
      }
    }
    var Gi = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      },
      Vu = Qt({
        menuitem: !0
      }, Gi),
      Eg = "__html";
    function Cd(n, a) {
      if (a) {
        if (Vu[n] && (a.children != null || a.dangerouslySetInnerHTML != null)) throw new Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (a.dangerouslySetInnerHTML != null) {
          if (a.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof a.dangerouslySetInnerHTML != "object" || !(Eg in a.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!a.suppressContentEditableWarning && a.contentEditable && a.children != null && h("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), a.style != null && typeof a.style != "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Fo(n, a) {
      if (n.indexOf("-") === -1) return typeof a.is == "string";
      switch (n) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Bu = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      },
      kd = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      },
      Rs = {},
      Tw = new RegExp("^(aria)-[" + We + "]*$"),
      Ds = new RegExp("^(aria)[A-Z][" + We + "]*$");
    function gh(n, a) {
      {
        if (ge.call(Rs, a) && Rs[a]) return !0;
        if (Ds.test(a)) {
          var f = "aria-" + a.slice(4).toLowerCase(),
            m = kd.hasOwnProperty(f) ? f : null;
          if (m == null) return h("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", a), Rs[a] = !0, !0;
          if (a !== m) return h("Invalid ARIA attribute `%s`. Did you mean `%s`?", a, m), Rs[a] = !0, !0;
        }
        if (Tw.test(a)) {
          var b = a.toLowerCase(),
            T = kd.hasOwnProperty(b) ? b : null;
          if (T == null) return Rs[a] = !0, !1;
          if (a !== T) return h("Unknown ARIA attribute `%s`. Did you mean `%s`?", a, T), Rs[a] = !0, !0;
        }
      }
      return !0;
    }
    function Uu(n, a) {
      {
        var f = [];
        for (var m in a) {
          var b = gh(n, m);
          b || f.push(m);
        }
        var T = f.map(function (M) {
          return "`" + M + "`";
        }).join(", ");
        f.length === 1 ? h("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", T, n) : f.length > 1 && h("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", T, n);
      }
    }
    function yh(n, a) {
      Fo(n, a) || Uu(n, a);
    }
    var bh = !1;
    function Td(n, a) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select") return;
        a != null && a.value === null && !bh && (bh = !0, n === "select" && a.multiple ? h("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : h("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Ol = function () {};
    {
      var _r = {},
        wh = /^on./,
        Rd = /^on[^A-Z]/,
        Cg = new RegExp("^(aria)-[" + We + "]*$"),
        kg = new RegExp("^(aria)[A-Z][" + We + "]*$");
      Ol = function (n, a, f, m) {
        if (ge.call(_r, a) && _r[a]) return !0;
        var b = a.toLowerCase();
        if (b === "onfocusin" || b === "onfocusout") return h("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _r[a] = !0, !0;
        if (m != null) {
          var T = m.registrationNameDependencies,
            M = m.possibleRegistrationNames;
          if (T.hasOwnProperty(a)) return !0;
          var z = M.hasOwnProperty(b) ? M[b] : null;
          if (z != null) return h("Invalid event handler property `%s`. Did you mean `%s`?", a, z), _r[a] = !0, !0;
          if (wh.test(a)) return h("Unknown event handler property `%s`. It will be ignored.", a), _r[a] = !0, !0;
        } else if (wh.test(a)) return Rd.test(a) && h("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", a), _r[a] = !0, !0;
        if (Cg.test(a) || kg.test(a)) return !0;
        if (b === "innerhtml") return h("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _r[a] = !0, !0;
        if (b === "aria") return h("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _r[a] = !0, !0;
        if (b === "is" && f !== null && f !== void 0 && typeof f != "string") return h("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), _r[a] = !0, !0;
        if (typeof f == "number" && isNaN(f)) return h("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", a), _r[a] = !0, !0;
        var U = Ht(a),
          X = U !== null && U.type === Kt;
        if (Bu.hasOwnProperty(b)) {
          var J = Bu[b];
          if (J !== a) return h("Invalid DOM property `%s`. Did you mean `%s`?", a, J), _r[a] = !0, !0;
        } else if (!X && a !== b) return h("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", a, b), _r[a] = !0, !0;
        return typeof f == "boolean" && kt(a, f, U, !1) ? (f ? h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, a, a, f, a) : h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, a, a, f, a, a, a), _r[a] = !0, !0) : X ? !0 : kt(a, f, U, !1) ? (_r[a] = !0, !1) : ((f === "false" || f === "true") && U !== null && U.type === Et && (h("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, a, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', a, f), _r[a] = !0), !0);
      };
    }
    var Tg = function (n, a, f) {
      {
        var m = [];
        for (var b in a) {
          var T = Ol(n, b, a[b], f);
          T || m.push(b);
        }
        var M = m.map(function (z) {
          return "`" + z + "`";
        }).join(", ");
        m.length === 1 ? h("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, n) : m.length > 1 && h("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", M, n);
      }
    };
    function Rg(n, a, f) {
      Fo(n, a) || Tg(n, a, f);
    }
    var _h = 1,
      Dd = 2,
      wi = 4,
      xh = _h | Dd | wi,
      Pl = null;
    function Rw(n) {
      Pl !== null && h("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Pl = n;
    }
    function Dw() {
      Pl === null && h("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Pl = null;
    }
    function Hu(n) {
      return n === Pl;
    }
    function Sh(n) {
      var a = n.target || n.srcElement || window;
      return a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === Xa ? a.parentNode : a;
    }
    var Id = null,
      Al = null,
      mn = null;
    function Md(n) {
      var a = Sf(n);
      if (a) {
        if (typeof Id != "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = a.stateNode;
        if (f) {
          var m = vS(f);
          Id(a.stateNode, a.type, m);
        }
      }
    }
    function Ld(n) {
      Id = n;
    }
    function Is(n) {
      Al ? mn ? mn.push(n) : mn = [n] : Al = n;
    }
    function Dg() {
      return Al !== null || mn !== null;
    }
    function Od() {
      if (Al) {
        var n = Al,
          a = mn;
        if (Al = null, mn = null, Md(n), a) for (var f = 0; f < a.length; f++) Md(a[f]);
      }
    }
    var Ms = function (n, a) {
        return n(a);
      },
      $u = function () {},
      No = !1;
    function Ig() {
      var n = Dg();
      n && ($u(), Od());
    }
    function Mg(n, a, f) {
      if (No) return n(a, f);
      No = !0;
      try {
        return Ms(n, a, f);
      } finally {
        No = !1, Ig();
      }
    }
    function Iw(n, a, f) {
      Ms = n, $u = f;
    }
    function Lg(n) {
      return n === "button" || n === "input" || n === "select" || n === "textarea";
    }
    function Pd(n, a, f) {
      switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Lg(a));
        default:
          return !1;
      }
    }
    function zo(n, a) {
      var f = n.stateNode;
      if (f === null) return null;
      var m = vS(f);
      if (m === null) return null;
      var b = m[a];
      if (Pd(a, n.type, m)) return null;
      if (b && typeof b != "function") throw new Error("Expected `" + a + "` listener to be a function, instead got a value of `" + typeof b + "` type.");
      return b;
    }
    var Wu = !1;
    if (Xe) try {
      var jl = {};
      Object.defineProperty(jl, "passive", {
        get: function () {
          Wu = !0;
        }
      }), window.addEventListener("test", jl, jl), window.removeEventListener("test", jl, jl);
    } catch {
      Wu = !1;
    }
    function Ad(n, a, f, m, b, T, M, z, U) {
      var X = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(f, X);
      } catch (J) {
        this.onError(J);
      }
    }
    var jd = Ad;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Eh = document.createElement("react");
      jd = function (a, f, m, b, T, M, z, U, X) {
        if (typeof document > "u" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var J = document.createEvent("Event"),
          me = !1,
          xe = !0,
          Ie = window.event,
          Pe = Object.getOwnPropertyDescriptor(window, "event");
        function $e() {
          Eh.removeEventListener(Fe, Te, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Ie);
        }
        var mt = Array.prototype.slice.call(arguments, 3);
        function Te() {
          me = !0, $e(), f.apply(m, mt), xe = !1;
        }
        var Ue,
          Ve = !1,
          nt = !1;
        function ke(De) {
          if (Ue = De.error, Ve = !0, Ue === null && De.colno === 0 && De.lineno === 0 && (nt = !0), De.defaultPrevented && Ue != null && typeof Ue == "object") try {
            Ue._suppressLogging = !0;
          } catch {}
        }
        var Fe = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", ke), Eh.addEventListener(Fe, Te, !1), J.initEvent(Fe, !1, !1), Eh.dispatchEvent(J), Pe && Object.defineProperty(window, "event", Pe), me && xe && (Ve ? nt && (Ue = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ue = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ue)), window.removeEventListener("error", ke), !me) return $e(), Ad.apply(this, arguments);
      };
    }
    var Og = jd,
      Ls = !1,
      Fd = null,
      Os = !1,
      ha = null,
      Pg = {
        onError: function (n) {
          Ls = !0, Fd = n;
        }
      };
    function Vo(n, a, f, m, b, T, M, z, U) {
      Ls = !1, Fd = null, Og.apply(Pg, arguments);
    }
    function ma(n, a, f, m, b, T, M, z, U) {
      if (Vo.apply(this, arguments), Ls) {
        var X = Yu();
        Os || (Os = !0, ha = X);
      }
    }
    function qu() {
      if (Os) {
        var n = ha;
        throw Os = !1, ha = null, n;
      }
    }
    function Qa() {
      return Ls;
    }
    function Yu() {
      if (Ls) {
        var n = Fd;
        return Ls = !1, Fd = null, n;
      } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ps(n) {
      return n._reactInternals;
    }
    function Mw(n) {
      return n._reactInternals !== void 0;
    }
    function Fl(n, a) {
      n._reactInternals = a;
    }
    var pt = /*                      */
      0,
      Xi = /*                */
      1,
      Gn = /*                    */
      2,
      tn = /*                       */
      4,
      _i = /*                */
      16,
      Ki = /*                 */
      32,
      Sn = /*                     */
      64,
      ft = /*                   */
      128,
      qr = /*            */
      256,
      Hn = /*                          */
      512,
      or = /*                     */
      1024,
      Yr = /*                      */
      2048,
      xi = /*                    */
      4096,
      tr = /*                   */
      8192,
      As = /*             */
      16384,
      Ag = /*               */
      32767,
      Gu = /*                   */
      32768,
      Gr = /*                */
      65536,
      Nd = /* */
      131072,
      va = /*                       */
      1048576,
      js = /*                    */
      2097152,
      Za = /*                 */
      4194304,
      zd = /*                */
      8388608,
      Bo = /*               */
      16777216,
      ga = /*              */
      33554432,
      Uo =
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tn | or | 0,
      Ho = Gn | tn | _i | Ki | Hn | xi | tr,
      $o = tn | Sn | Hn | tr,
      Ja = Yr | _i,
      nr = Za | zd | js,
      Si = i.ReactCurrentOwner;
    function li(n) {
      var a = n,
        f = n;
      if (n.alternate) for (; a.return;) a = a.return;else {
        var m = a;
        do a = m, (a.flags & (Gn | xi)) !== pt && (f = a.return), m = a.return; while (m);
      }
      return a.tag === C ? f : null;
    }
    function ya(n) {
      if (n.tag === V) {
        var a = n.memoizedState;
        if (a === null) {
          var f = n.alternate;
          f !== null && (a = f.memoizedState);
        }
        if (a !== null) return a.dehydrated;
      }
      return null;
    }
    function ba(n) {
      return n.tag === C ? n.stateNode.containerInfo : null;
    }
    function Nl(n) {
      return li(n) === n;
    }
    function jg(n) {
      {
        var a = Si.current;
        if (a !== null && a.tag === x) {
          var f = a,
            m = f.stateNode;
          m._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", At(f) || "A component"), m._warnedAboutRefsInRender = !0;
        }
      }
      var b = Ps(n);
      return b ? li(b) === b : !1;
    }
    function Vd(n) {
      if (li(n) !== n) throw new Error("Unable to find node on an unmounted component.");
    }
    function Bd(n) {
      var a = n.alternate;
      if (!a) {
        var f = li(n);
        if (f === null) throw new Error("Unable to find node on an unmounted component.");
        return f !== n ? null : n;
      }
      for (var m = n, b = a;;) {
        var T = m.return;
        if (T === null) break;
        var M = T.alternate;
        if (M === null) {
          var z = T.return;
          if (z !== null) {
            m = b = z;
            continue;
          }
          break;
        }
        if (T.child === M.child) {
          for (var U = T.child; U;) {
            if (U === m) return Vd(T), n;
            if (U === b) return Vd(T), a;
            U = U.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (m.return !== b.return) m = T, b = M;else {
          for (var X = !1, J = T.child; J;) {
            if (J === m) {
              X = !0, m = T, b = M;
              break;
            }
            if (J === b) {
              X = !0, b = T, m = M;
              break;
            }
            J = J.sibling;
          }
          if (!X) {
            for (J = M.child; J;) {
              if (J === m) {
                X = !0, m = M, b = T;
                break;
              }
              if (J === b) {
                X = !0, b = M, m = T;
                break;
              }
              J = J.sibling;
            }
            if (!X) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (m.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (m.tag !== C) throw new Error("Unable to find node on an unmounted component.");
      return m.stateNode.current === m ? n : a;
    }
    function Xr(n) {
      var a = Bd(n);
      return a !== null ? Kr(a) : null;
    }
    function Kr(n) {
      if (n.tag === D || n.tag === I) return n;
      for (var a = n.child; a !== null;) {
        var f = Kr(a);
        if (f !== null) return f;
        a = a.sibling;
      }
      return null;
    }
    function In(n) {
      var a = Bd(n);
      return a !== null ? Ei(a) : null;
    }
    function Ei(n) {
      if (n.tag === D || n.tag === I) return n;
      for (var a = n.child; a !== null;) {
        if (a.tag !== k) {
          var f = Ei(a);
          if (f !== null) return f;
        }
        a = a.sibling;
      }
      return null;
    }
    var Ch = e.unstable_scheduleCallback,
      Fg = e.unstable_cancelCallback,
      kh = e.unstable_shouldYield,
      Th = e.unstable_requestPaint,
      lr = e.unstable_now,
      Ud = e.unstable_getCurrentPriorityLevel,
      Xu = e.unstable_ImmediatePriority,
      Wo = e.unstable_UserBlockingPriority,
      eo = e.unstable_NormalPriority,
      Lw = e.unstable_LowPriority,
      si = e.unstable_IdlePriority,
      Hd = e.unstable_yieldValue,
      $d = e.unstable_setDisableYieldValue,
      Qi = null,
      dr = null,
      Ge = null,
      Ci = !1,
      ui = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Fs(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled) return !0;
      if (!a.supportsFiber) return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        Ee && (n = Qt({}, n, {
          getLaneLabelMap: Dh,
          injectProfilingHooks: qo
        })), Qi = a.inject(n), dr = a;
      } catch (f) {
        h("React instrumentation encountered an error: %s.", f);
      }
      return !!a.checkDCE;
    }
    function ki(n, a) {
      if (dr && typeof dr.onScheduleFiberRoot == "function") try {
        dr.onScheduleFiberRoot(Qi, n, a);
      } catch (f) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", f));
      }
    }
    function zl(n, a) {
      if (dr && typeof dr.onCommitFiberRoot == "function") try {
        var f = (n.current.flags & ft) === ft;
        if (Ce) {
          var m;
          switch (a) {
            case Ii:
              m = Xu;
              break;
            case Zi:
              m = Wo;
              break;
            case ol:
              m = eo;
              break;
            case ll:
              m = si;
              break;
            default:
              m = eo;
              break;
          }
          dr.onCommitFiberRoot(Qi, n, m, f);
        }
      } catch (b) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", b));
      }
    }
    function Rh(n) {
      if (dr && typeof dr.onPostCommitFiberRoot == "function") try {
        dr.onPostCommitFiberRoot(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function Ng(n) {
      if (dr && typeof dr.onCommitFiberUnmount == "function") try {
        dr.onCommitFiberUnmount(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function En(n) {
      if (typeof Hd == "function" && ($d(n), c(n)), dr && typeof dr.setStrictMode == "function") try {
        dr.setStrictMode(Qi, n);
      } catch (a) {
        Ci || (Ci = !0, h("React instrumentation encountered an error: %s", a));
      }
    }
    function qo(n) {
      Ge = n;
    }
    function Dh() {
      {
        for (var n = /* @__PURE__ */new Map(), a = 1, f = 0; f < zs; f++) {
          var m = Yg(a);
          n.set(a, m), a *= 2;
        }
        return n;
      }
    }
    function zg(n) {
      Ge !== null && typeof Ge.markCommitStarted == "function" && Ge.markCommitStarted(n);
    }
    function wa() {
      Ge !== null && typeof Ge.markCommitStopped == "function" && Ge.markCommitStopped();
    }
    function Ti(n) {
      Ge !== null && typeof Ge.markComponentRenderStarted == "function" && Ge.markComponentRenderStarted(n);
    }
    function to() {
      Ge !== null && typeof Ge.markComponentRenderStopped == "function" && Ge.markComponentRenderStopped();
    }
    function Vg(n) {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStarted == "function" && Ge.markComponentPassiveEffectMountStarted(n);
    }
    function Wd() {
      Ge !== null && typeof Ge.markComponentPassiveEffectMountStopped == "function" && Ge.markComponentPassiveEffectMountStopped();
    }
    function Bg(n) {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStarted == "function" && Ge.markComponentPassiveEffectUnmountStarted(n);
    }
    function Ug() {
      Ge !== null && typeof Ge.markComponentPassiveEffectUnmountStopped == "function" && Ge.markComponentPassiveEffectUnmountStopped();
    }
    function Ih(n) {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStarted == "function" && Ge.markComponentLayoutEffectMountStarted(n);
    }
    function qd() {
      Ge !== null && typeof Ge.markComponentLayoutEffectMountStopped == "function" && Ge.markComponentLayoutEffectMountStopped();
    }
    function Mh(n) {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStarted == "function" && Ge.markComponentLayoutEffectUnmountStarted(n);
    }
    function Lh() {
      Ge !== null && typeof Ge.markComponentLayoutEffectUnmountStopped == "function" && Ge.markComponentLayoutEffectUnmountStopped();
    }
    function Hg(n, a, f) {
      Ge !== null && typeof Ge.markComponentErrored == "function" && Ge.markComponentErrored(n, a, f);
    }
    function Oh(n, a, f) {
      Ge !== null && typeof Ge.markComponentSuspended == "function" && Ge.markComponentSuspended(n, a, f);
    }
    function Ku(n) {
      Ge !== null && typeof Ge.markLayoutEffectsStarted == "function" && Ge.markLayoutEffectsStarted(n);
    }
    function Yd() {
      Ge !== null && typeof Ge.markLayoutEffectsStopped == "function" && Ge.markLayoutEffectsStopped();
    }
    function $g(n) {
      Ge !== null && typeof Ge.markPassiveEffectsStarted == "function" && Ge.markPassiveEffectsStarted(n);
    }
    function Wg() {
      Ge !== null && typeof Ge.markPassiveEffectsStopped == "function" && Ge.markPassiveEffectsStopped();
    }
    function Vl(n) {
      Ge !== null && typeof Ge.markRenderStarted == "function" && Ge.markRenderStarted(n);
    }
    function qg() {
      Ge !== null && typeof Ge.markRenderYielded == "function" && Ge.markRenderYielded();
    }
    function Ns() {
      Ge !== null && typeof Ge.markRenderStopped == "function" && Ge.markRenderStopped();
    }
    function _a(n) {
      Ge !== null && typeof Ge.markRenderScheduled == "function" && Ge.markRenderScheduled(n);
    }
    function Qu(n, a) {
      Ge !== null && typeof Ge.markForceUpdateScheduled == "function" && Ge.markForceUpdateScheduled(n, a);
    }
    function Bl(n, a) {
      Ge !== null && typeof Ge.markStateUpdateScheduled == "function" && Ge.markStateUpdateScheduled(n, a);
    }
    var dt = /*                         */
      0,
      Wt = /*                 */
      1,
      nn = /*                    */
      2,
      Xn = /*               */
      8,
      Ri = /*              */
      16,
      Mn = Math.clz32 ? Math.clz32 : Ah,
      Gd = Math.log,
      Ph = Math.LN2;
    function Ah(n) {
      var a = n >>> 0;
      return a === 0 ? 32 : 31 - (Gd(a) / Ph | 0) | 0;
    }
    var zs = 31,
      Re = /*                        */
      0,
      Ln = /*                          */
      0,
      Je = /*                        */
      1,
      On = /*    */
      2,
      Cn = /*             */
      4,
      xa = /*            */
      8,
      Qr = /*                     */
      16,
      no = /*                */
      32,
      Vs = /*                       */
      4194240,
      rr = /*                        */
      64,
      Zu = /*                        */
      128,
      Ju = /*                        */
      256,
      ec = /*                        */
      512,
      Di = /*                        */
      1024,
      Zr = /*                        */
      2048,
      Ul = /*                        */
      4096,
      tc = /*                        */
      8192,
      nc = /*                        */
      16384,
      Xd = /*                       */
      32768,
      Kd = /*                       */
      65536,
      Qd = /*                       */
      131072,
      Zd = /*                       */
      262144,
      Jd = /*                       */
      524288,
      ef = /*                       */
      1048576,
      tf = /*                       */
      2097152,
      rc = /*                            */
      130023424,
      Sa = /*                             */
      4194304,
      nf = /*                             */
      8388608,
      Bs = /*                             */
      16777216,
      Us = /*                             */
      33554432,
      rf = /*                             */
      67108864,
      af = Sa,
      Hs = /*          */
      134217728,
      jh = /*                          */
      268435455,
      $s = /*               */
      268435456,
      Yo = /*                        */
      536870912,
      Jr = /*                   */
      1073741824;
    function Yg(n) {
      {
        if (n & Je) return "Sync";
        if (n & On) return "InputContinuousHydration";
        if (n & Cn) return "InputContinuous";
        if (n & xa) return "DefaultHydration";
        if (n & Qr) return "Default";
        if (n & no) return "TransitionHydration";
        if (n & Vs) return "Transition";
        if (n & rc) return "Retry";
        if (n & Hs) return "SelectiveHydration";
        if (n & $s) return "IdleHydration";
        if (n & Yo) return "Idle";
        if (n & Jr) return "Offscreen";
      }
    }
    var wn = -1,
      ic = rr,
      of = Sa;
    function Ws(n) {
      switch (Go(n)) {
        case Je:
          return Je;
        case On:
          return On;
        case Cn:
          return Cn;
        case xa:
          return xa;
        case Qr:
          return Qr;
        case no:
          return no;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
          return n & Vs;
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          return n & rc;
        case Hs:
          return Hs;
        case $s:
          return $s;
        case Yo:
          return Yo;
        case Jr:
          return Jr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function lf(n, a) {
      var f = n.pendingLanes;
      if (f === Re) return Re;
      var m = Re,
        b = n.suspendedLanes,
        T = n.pingedLanes,
        M = f & jh;
      if (M !== Re) {
        var z = M & ~b;
        if (z !== Re) m = Ws(z);else {
          var U = M & T;
          U !== Re && (m = Ws(U));
        }
      } else {
        var X = f & ~b;
        X !== Re ? m = Ws(X) : T !== Re && (m = Ws(T));
      }
      if (m === Re) return Re;
      if (a !== Re && a !== m &&
      // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & b) === Re) {
        var J = Go(m),
          me = Go(a);
        if (
        // Tests whether the next lane is equal or lower priority than the wip
        // one. This works because the bits decrease in priority as you go left.
        J >= me ||
        // Default priority updates should not interrupt transition updates. The
        // only difference between default updates and transition updates is that
        // default updates do not support refresh transitions.
        J === Qr && (me & Vs) !== Re) return a;
      }
      (m & Cn) !== Re && (m |= f & Qr);
      var xe = n.entangledLanes;
      if (xe !== Re) for (var Ie = n.entanglements, Pe = m & xe; Pe > 0;) {
        var $e = Hl(Pe),
          mt = 1 << $e;
        m |= Ie[$e], Pe &= ~mt;
      }
      return m;
    }
    function Ow(n, a) {
      for (var f = n.eventTimes, m = wn; a > 0;) {
        var b = Hl(a),
          T = 1 << b,
          M = f[b];
        M > m && (m = M), a &= ~T;
      }
      return m;
    }
    function Gg(n, a) {
      switch (n) {
        case Je:
        case On:
        case Cn:
          return a + 250;
        case xa:
        case Qr:
        case no:
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
          return a + 5e3;
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          return wn;
        case Hs:
        case $s:
        case Yo:
        case Jr:
          return wn;
        default:
          return h("Should have found matching lanes. This is a bug in React."), wn;
      }
    }
    function Xg(n, a) {
      for (var f = n.pendingLanes, m = n.suspendedLanes, b = n.pingedLanes, T = n.expirationTimes, M = f; M > 0;) {
        var z = Hl(M),
          U = 1 << z,
          X = T[z];
        X === wn ? ((U & m) === Re || (U & b) !== Re) && (T[z] = Gg(U, a)) : X <= a && (n.expiredLanes |= U), M &= ~U;
      }
    }
    function Kg(n) {
      return Ws(n.pendingLanes);
    }
    function qs(n) {
      var a = n.pendingLanes & -1073741825;
      return a !== Re ? a : a & Jr ? Jr : Re;
    }
    function Pw(n) {
      return (n & Je) !== Re;
    }
    function Fh(n) {
      return (n & jh) !== Re;
    }
    function Qg(n) {
      return (n & rc) === n;
    }
    function Ys(n) {
      var a = Je | Cn | Qr;
      return (n & a) === Re;
    }
    function Nh(n) {
      return (n & Vs) === n;
    }
    function Gs(n, a) {
      var f = On | Cn | xa | Qr;
      return (a & f) !== Re;
    }
    function Aw(n, a) {
      return (a & n.expiredLanes) !== Re;
    }
    function zh(n) {
      return (n & Vs) !== Re;
    }
    function Vh() {
      var n = ic;
      return ic <<= 1, (ic & Vs) === Re && (ic = rr), n;
    }
    function Zg() {
      var n = of;
      return of <<= 1, (of & rc) === Re && (of = Sa), n;
    }
    function Go(n) {
      return n & -n;
    }
    function Xs(n) {
      return Go(n);
    }
    function Hl(n) {
      return 31 - Mn(n);
    }
    function Dr(n) {
      return Hl(n);
    }
    function _n(n, a) {
      return (n & a) !== Re;
    }
    function $l(n, a) {
      return (n & a) === a;
    }
    function jt(n, a) {
      return n | a;
    }
    function ac(n, a) {
      return n & ~a;
    }
    function Bh(n, a) {
      return n & a;
    }
    function Sb(n) {
      return n;
    }
    function sf(n, a) {
      return n !== Ln && n < a ? n : a;
    }
    function oc(n) {
      for (var a = [], f = 0; f < zs; f++) a.push(n);
      return a;
    }
    function lc(n, a, f) {
      n.pendingLanes |= a, a !== Yo && (n.suspendedLanes = Re, n.pingedLanes = Re);
      var m = n.eventTimes,
        b = Dr(a);
      m[b] = f;
    }
    function Km(n, a) {
      n.suspendedLanes |= a, n.pingedLanes &= ~a;
      for (var f = n.expirationTimes, m = a; m > 0;) {
        var b = Hl(m),
          T = 1 << b;
        f[b] = wn, m &= ~T;
      }
    }
    function Qm(n, a, f) {
      n.pingedLanes |= n.suspendedLanes & a;
    }
    function uf(n, a) {
      var f = n.pendingLanes & ~a;
      n.pendingLanes = a, n.suspendedLanes = Re, n.pingedLanes = Re, n.expiredLanes &= a, n.mutableReadLanes &= a, n.entangledLanes &= a;
      for (var m = n.entanglements, b = n.eventTimes, T = n.expirationTimes, M = f; M > 0;) {
        var z = Hl(M),
          U = 1 << z;
        m[z] = Re, b[z] = wn, T[z] = wn, M &= ~U;
      }
    }
    function cf(n, a) {
      for (var f = n.entangledLanes |= a, m = n.entanglements, b = f; b;) {
        var T = Hl(b),
          M = 1 << T;
        // Is this one of the newly entangled lanes?
        M & a |
        // Is this lane transitively entangled with the newly entangled lanes?
        m[T] & a && (m[T] |= a), b &= ~M;
      }
    }
    function Zm(n, a) {
      var f = Go(a),
        m;
      switch (f) {
        case Cn:
          m = On;
          break;
        case Qr:
          m = xa;
          break;
        case rr:
        case Zu:
        case Ju:
        case ec:
        case Di:
        case Zr:
        case Ul:
        case tc:
        case nc:
        case Xd:
        case Kd:
        case Qd:
        case Zd:
        case Jd:
        case ef:
        case tf:
        case Sa:
        case nf:
        case Bs:
        case Us:
        case rf:
          m = no;
          break;
        case Yo:
          m = $s;
          break;
        default:
          m = Ln;
          break;
      }
      return (m & (n.suspendedLanes | a)) !== Ln ? Ln : m;
    }
    function df(n, a, f) {
      if (ui) for (var m = n.pendingUpdatersLaneMap; f > 0;) {
        var b = Dr(f),
          T = 1 << b,
          M = m[b];
        M.add(a), f &= ~T;
      }
    }
    function sc(n, a) {
      if (ui) for (var f = n.pendingUpdatersLaneMap, m = n.memoizedUpdaters; a > 0;) {
        var b = Dr(a),
          T = 1 << b,
          M = f[b];
        M.size > 0 && (M.forEach(function (z) {
          var U = z.alternate;
          (U === null || !m.has(U)) && m.add(z);
        }), M.clear()), a &= ~T;
      }
    }
    function al(n, a) {
      return null;
    }
    var Ii = Je,
      Zi = Cn,
      ol = Qr,
      ll = Yo,
      Ir = Ln;
    function zr() {
      return Ir;
    }
    function sa(n) {
      Ir = n;
    }
    function Uh(n, a) {
      var f = Ir;
      try {
        return Ir = n, a();
      } finally {
        Ir = f;
      }
    }
    function Jg(n, a) {
      return n !== 0 && n < a ? n : a;
    }
    function Hh(n, a) {
      return n > a ? n : a;
    }
    function us(n, a) {
      return n !== 0 && n < a;
    }
    function fr(n) {
      var a = Go(n);
      return us(Ii, a) ? us(Zi, a) ? Fh(a) ? ol : ll : Zi : Ii;
    }
    function $h(n) {
      var a = n.current.memoizedState;
      return a.isDehydrated;
    }
    var Eb;
    function ff(n) {
      Eb = n;
    }
    function xr(n) {
      Eb(n);
    }
    var ey;
    function tt(n) {
      ey = n;
    }
    var cs;
    function Wh(n) {
      cs = n;
    }
    var Jm;
    function Cb(n) {
      Jm = n;
    }
    var du;
    function uc(n) {
      du = n;
    }
    var fu = !1,
      Wl = [],
      ro = null,
      io = null,
      wo = null,
      ql = /* @__PURE__ */new Map(),
      Nn = /* @__PURE__ */new Map(),
      Vr = [],
      Xo = ["mousedown", "mouseup", "touchcancel", "touchend", "touchstart", "auxclick", "dblclick", "pointercancel", "pointerdown", "pointerup", "dragend", "dragstart", "drop", "compositionend", "compositionstart", "keydown", "keypress", "keyup", "input", "textInput",
      // Intentionally camelCase
      "copy", "cut", "paste", "click", "change", "contextmenu", "reset", "submit"];
    function ty(n) {
      return Xo.indexOf(n) > -1;
    }
    function ev(n, a, f, m, b) {
      return {
        blockedOn: n,
        domEventName: a,
        eventSystemFlags: f,
        nativeEvent: b,
        targetContainers: [m]
      };
    }
    function ri(n, a) {
      switch (n) {
        case "focusin":
        case "focusout":
          ro = null;
          break;
        case "dragenter":
        case "dragleave":
          io = null;
          break;
        case "mouseover":
        case "mouseout":
          wo = null;
          break;
        case "pointerover":
        case "pointerout":
          {
            var f = a.pointerId;
            ql.delete(f);
            break;
          }
        case "gotpointercapture":
        case "lostpointercapture":
          {
            var m = a.pointerId;
            Nn.delete(m);
            break;
          }
      }
    }
    function pf(n, a, f, m, b, T) {
      if (n === null || n.nativeEvent !== T) {
        var M = ev(a, f, m, b, T);
        if (a !== null) {
          var z = Sf(a);
          z !== null && ey(z);
        }
        return M;
      }
      n.eventSystemFlags |= m;
      var U = n.targetContainers;
      return b !== null && U.indexOf(b) === -1 && U.push(b), n;
    }
    function ua(n, a, f, m, b) {
      switch (a) {
        case "focusin":
          {
            var T = b;
            return ro = pf(ro, n, a, f, m, T), !0;
          }
        case "dragenter":
          {
            var M = b;
            return io = pf(io, n, a, f, m, M), !0;
          }
        case "mouseover":
          {
            var z = b;
            return wo = pf(wo, n, a, f, m, z), !0;
          }
        case "pointerover":
          {
            var U = b,
              X = U.pointerId;
            return ql.set(X, pf(ql.get(X) || null, n, a, f, m, U)), !0;
          }
        case "gotpointercapture":
          {
            var J = b,
              me = J.pointerId;
            return Nn.set(me, pf(Nn.get(me) || null, n, a, f, m, J)), !0;
          }
      }
      return !1;
    }
    function kb(n) {
      var a = zc(n.target);
      if (a !== null) {
        var f = li(a);
        if (f !== null) {
          var m = f.tag;
          if (m === V) {
            var b = ya(f);
            if (b !== null) {
              n.blockedOn = b, du(n.priority, function () {
                cs(f);
              });
              return;
            }
          } else if (m === C) {
            var T = f.stateNode;
            if ($h(T)) {
              n.blockedOn = ba(f);
              return;
            }
          }
        }
      }
      n.blockedOn = null;
    }
    function cp(n) {
      for (var a = Jm(), f = {
          blockedOn: null,
          target: n,
          priority: a
        }, m = 0; m < Vr.length && us(a, Vr[m].priority); m++);
      Vr.splice(m, 0, f), m === 0 && kb(f);
    }
    function hf(n) {
      if (n.blockedOn !== null) return !1;
      for (var a = n.targetContainers; a.length > 0;) {
        var f = a[0],
          m = xo(n.domEventName, n.eventSystemFlags, f, n.nativeEvent);
        if (m === null) {
          var b = n.nativeEvent,
            T = new b.constructor(b.type, b);
          Rw(T), b.target.dispatchEvent(T), Dw();
        } else {
          var M = Sf(m);
          return M !== null && ey(M), n.blockedOn = m, !1;
        }
        a.shift();
      }
      return !0;
    }
    function tv(n, a, f) {
      hf(n) && f.delete(a);
    }
    function mf() {
      fu = !1, ro !== null && hf(ro) && (ro = null), io !== null && hf(io) && (io = null), wo !== null && hf(wo) && (wo = null), ql.forEach(tv), Nn.forEach(tv);
    }
    function cc(n, a) {
      n.blockedOn === a && (n.blockedOn = null, fu || (fu = !0, e.unstable_scheduleCallback(e.unstable_NormalPriority, mf)));
    }
    function _o(n) {
      if (Wl.length > 0) {
        cc(Wl[0], n);
        for (var a = 1; a < Wl.length; a++) {
          var f = Wl[a];
          f.blockedOn === n && (f.blockedOn = null);
        }
      }
      ro !== null && cc(ro, n), io !== null && cc(io, n), wo !== null && cc(wo, n);
      var m = function (z) {
        return cc(z, n);
      };
      ql.forEach(m), Nn.forEach(m);
      for (var b = 0; b < Vr.length; b++) {
        var T = Vr[b];
        T.blockedOn === n && (T.blockedOn = null);
      }
      for (; Vr.length > 0;) {
        var M = Vr[0];
        if (M.blockedOn !== null) break;
        kb(M), M.blockedOn === null && Vr.shift();
      }
    }
    var ds = i.ReactCurrentBatchConfig,
      ii = !0;
    function on(n) {
      ii = !!n;
    }
    function pr() {
      return ii;
    }
    function ir(n, a, f) {
      var m = Oc(a),
        b;
      switch (m) {
        case Ii:
          b = Sr;
          break;
        case Zi:
          b = ei;
          break;
        case ol:
        default:
          b = Yl;
          break;
      }
      return b.bind(null, a, f, n);
    }
    function Sr(n, a, f, m) {
      var b = zr(),
        T = ds.transition;
      ds.transition = null;
      try {
        sa(Ii), Yl(n, a, f, m);
      } finally {
        sa(b), ds.transition = T;
      }
    }
    function ei(n, a, f, m) {
      var b = zr(),
        T = ds.transition;
      ds.transition = null;
      try {
        sa(Zi), Yl(n, a, f, m);
      } finally {
        sa(b), ds.transition = T;
      }
    }
    function Yl(n, a, f, m) {
      ii && Zn(n, a, f, m);
    }
    function Zn(n, a, f, m) {
      var b = xo(n, a, f, m);
      if (b === null) {
        my(n, a, m, sl, f), ri(n, m);
        return;
      }
      if (ua(b, n, a, f, m)) {
        m.stopPropagation();
        return;
      }
      if (ri(n, m), a & wi && ty(n)) {
        for (; b !== null;) {
          var T = Sf(b);
          T !== null && xr(T);
          var M = xo(n, a, f, m);
          if (M === null && my(n, a, m, sl, f), M === b) break;
          b = M;
        }
        b !== null && m.stopPropagation();
        return;
      }
      my(n, a, m, null, f);
    }
    var sl = null;
    function xo(n, a, f, m) {
      sl = null;
      var b = Sh(m),
        T = zc(b);
      if (T !== null) {
        var M = li(T);
        if (M === null) T = null;else {
          var z = M.tag;
          if (z === V) {
            var U = ya(M);
            if (U !== null) return U;
            T = null;
          } else if (z === C) {
            var X = M.stateNode;
            if ($h(X)) return ba(M);
            T = null;
          } else M !== T && (T = null);
        }
      }
      return sl = T, null;
    }
    function Oc(n) {
      switch (n) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ii;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Zi;
        case "message":
          {
            var a = Ud();
            switch (a) {
              case Xu:
                return Ii;
              case Wo:
                return Zi;
              case eo:
              case Lw:
                return ol;
              case si:
                return ll;
              default:
                return ol;
            }
          }
        default:
          return ol;
      }
    }
    function qh(n, a, f) {
      return n.addEventListener(a, f, !1), f;
    }
    function dc(n, a, f) {
      return n.addEventListener(a, f, !0), f;
    }
    function ti(n, a, f, m) {
      return n.addEventListener(a, f, {
        capture: !0,
        passive: m
      }), f;
    }
    function fc(n, a, f, m) {
      return n.addEventListener(a, f, {
        passive: m
      }), f;
    }
    var ao = null,
      Mi = null,
      Ks = null;
    function Yh(n) {
      return ao = n, Mi = Ea(), !0;
    }
    function So() {
      ao = null, Mi = null, Ks = null;
    }
    function pc() {
      if (Ks) return Ks;
      var n,
        a = Mi,
        f = a.length,
        m,
        b = Ea(),
        T = b.length;
      for (n = 0; n < f && a[n] === b[n]; n++);
      var M = f - n;
      for (m = 1; m <= M && a[f - m] === b[T - m]; m++);
      var z = m > 1 ? 1 - m : void 0;
      return Ks = b.slice(n, z), Ks;
    }
    function Ea() {
      return "value" in ao ? ao.value : ao.textContent;
    }
    function Gl(n) {
      var a,
        f = n.keyCode;
      return "charCode" in n ? (a = n.charCode, a === 0 && f === 13 && (a = 13)) : a = f, a === 10 && (a = 13), a >= 32 || a === 13 ? a : 0;
    }
    function Xl() {
      return !0;
    }
    function Ma() {
      return !1;
    }
    function di(n) {
      function a(f, m, b, T, M) {
        this._reactName = f, this._targetInst = b, this.type = m, this.nativeEvent = T, this.target = M, this.currentTarget = null;
        for (var z in n) if (n.hasOwnProperty(z)) {
          var U = n[z];
          U ? this[z] = U(T) : this[z] = T[z];
        }
        var X = T.defaultPrevented != null ? T.defaultPrevented : T.returnValue === !1;
        return X ? this.isDefaultPrevented = Xl : this.isDefaultPrevented = Ma, this.isPropagationStopped = Ma, this;
      }
      return Qt(a.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = Xl);
        },
        stopPropagation: function () {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = Xl);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function () {},
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Xl
      }), a;
    }
    var ul = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (n) {
          return n.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      },
      hr = di(ul),
      Ca = Qt({}, ul, {
        view: 0,
        detail: 0
      }),
      Li = di(Ca),
      Mr,
      hc,
      mc;
    function Pc(n) {
      n !== mc && (mc && n.type === "mousemove" ? (Mr = n.screenX - mc.screenX, hc = n.screenY - mc.screenY) : (Mr = 0, hc = 0), mc = n);
    }
    var Gh = Qt({}, Ca, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: Qh,
        button: 0,
        buttons: 0,
        relatedTarget: function (n) {
          return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
        },
        movementX: function (n) {
          return "movementX" in n ? n.movementX : (Pc(n), Mr);
        },
        movementY: function (n) {
          return "movementY" in n ? n.movementY : hc;
        }
      }),
      Eo = di(Gh),
      ny = Qt({}, Gh, {
        dataTransfer: 0
      }),
      Xh = di(ny),
      Ko = Qt({}, Ca, {
        relatedTarget: 0
      }),
      vf = di(Ko),
      Kl = Qt({}, ul, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      ry = di(Kl),
      iy = Qt({}, ul, {
        clipboardData: function (n) {
          return "clipboardData" in n ? n.clipboardData : window.clipboardData;
        }
      }),
      Kh = di(iy),
      Ac = Qt({}, ul, {
        data: 0
      }),
      Tb = di(Ac),
      jw = Tb,
      ay = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      oy = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
    function Ql(n) {
      if (n.key) {
        var a = ay[n.key] || n.key;
        if (a !== "Unidentified") return a;
      }
      if (n.type === "keypress") {
        var f = Gl(n);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return n.type === "keydown" || n.type === "keyup" ? oy[n.keyCode] || "Unidentified" : "";
    }
    var Fw = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Zl(n) {
      var a = this,
        f = a.nativeEvent;
      if (f.getModifierState) return f.getModifierState(n);
      var m = Fw[n];
      return m ? !!f[m] : !1;
    }
    function Qh(n) {
      return Zl;
    }
    var $n = Qt({}, Ca, {
        key: Ql,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: Qh,
        // Legacy Interface
        charCode: function (n) {
          return n.type === "keypress" ? Gl(n) : 0;
        },
        keyCode: function (n) {
          return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        },
        which: function (n) {
          return n.type === "keypress" ? Gl(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
        }
      }),
      Nw = di($n),
      nv = Qt({}, Gh, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }),
      Rb = di(nv),
      zw = Qt({}, Ca, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: Qh
      }),
      ly = di(zw),
      sy = Qt({}, ul, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }),
      Vw = di(sy),
      Oi = Qt({}, Gh, {
        deltaX: function (n) {
          return "deltaX" in n ? n.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
        },
        deltaY: function (n) {
          return "deltaY" in n ? n.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in n ? -n.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          "wheelDelta" in n ? -n.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }),
      Zh = di(Oi),
      Db = [9, 13, 27, 32],
      La = 229,
      Jl = Xe && "CompositionEvent" in window,
      oo = null;
    Xe && "documentMode" in document && (oo = document.documentMode);
    var jc = Xe && "TextEvent" in window && !oo,
      gf = Xe && (!Jl || oo && oo > 8 && oo <= 11),
      yf = 32,
      Ib = String.fromCharCode(yf);
    function dp() {
      Le("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Le("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Le("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Le("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Mb = !1;
    function uy(n) {
      return (n.ctrlKey || n.altKey || n.metaKey) &&
      // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(n.ctrlKey && n.altKey);
    }
    function cy(n) {
      switch (n) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Fc(n, a) {
      return n === "keydown" && a.keyCode === La;
    }
    function vc(n, a) {
      switch (n) {
        case "keyup":
          return Db.indexOf(a.keyCode) !== -1;
        case "keydown":
          return a.keyCode !== La;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Jh(n) {
      var a = n.detail;
      return typeof a == "object" && "data" in a ? a.data : null;
    }
    function Qs(n) {
      return n.locale === "ko";
    }
    var fp = !1;
    function dy(n, a, f, m, b) {
      var T, M;
      if (Jl ? T = cy(a) : fp ? vc(a, m) && (T = "onCompositionEnd") : Fc(a, m) && (T = "onCompositionStart"), !T) return null;
      gf && !Qs(m) && (!fp && T === "onCompositionStart" ? fp = Yh(b) : T === "onCompositionEnd" && fp && (M = pc()));
      var z = im(f, T);
      if (z.length > 0) {
        var U = new Tb(T, a, null, m, b);
        if (n.push({
          event: U,
          listeners: z
        }), M) U.data = M;else {
          var X = Jh(m);
          X !== null && (U.data = X);
        }
      }
    }
    function em(n, a) {
      switch (n) {
        case "compositionend":
          return Jh(a);
        case "keypress":
          var f = a.which;
          return f !== yf ? null : (Mb = !0, Ib);
        case "textInput":
          var m = a.data;
          return m === Ib && Mb ? null : m;
        default:
          return null;
      }
    }
    function bf(n, a) {
      if (fp) {
        if (n === "compositionend" || !Jl && vc(n, a)) {
          var f = pc();
          return So(), fp = !1, f;
        }
        return null;
      }
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!uy(a)) {
            if (a.char && a.char.length > 1) return a.char;
            if (a.which) return String.fromCharCode(a.which);
          }
          return null;
        case "compositionend":
          return gf && !Qs(a) ? null : a.data;
        default:
          return null;
      }
    }
    function tm(n, a, f, m, b) {
      var T;
      if (jc ? T = em(a, m) : T = bf(a, m), !T) return null;
      var M = im(f, "onBeforeInput");
      if (M.length > 0) {
        var z = new jw("onBeforeInput", "beforeinput", null, m, b);
        n.push({
          event: z,
          listeners: M
        }), z.data = T;
      }
    }
    function wf(n, a, f, m, b, T, M) {
      dy(n, a, f, m, b), tm(n, a, f, m, b);
    }
    var rv = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Lb(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a === "input" ? !!rv[n.type] : a === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function _f(n) {
      if (!Xe) return !1;
      var a = "on" + n,
        f = a in document;
      if (!f) {
        var m = document.createElement("div");
        m.setAttribute(a, "return;"), f = typeof m[a] == "function";
      }
      return f;
    }
    function Ob() {
      Le("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function cl(n, a, f, m) {
      Is(m);
      var b = im(a, "onChange");
      if (b.length > 0) {
        var T = new hr("onChange", "change", null, f, m);
        n.push({
          event: T,
          listeners: b
        });
      }
    }
    var gc = null,
      Zs = null;
    function r(n) {
      var a = n.nodeName && n.nodeName.toLowerCase();
      return a === "select" || a === "input" && n.type === "file";
    }
    function o(n) {
      var a = [];
      cl(a, Zs, n, Sh(n)), Mg(d, a);
    }
    function d(n) {
      nD(n, 0);
    }
    function g(n) {
      var a = mv(n);
      if (Rl(a)) return n;
    }
    function S(n, a) {
      if (n === "change") return a;
    }
    var R = !1;
    Xe && (R = _f("input") && (!document.documentMode || document.documentMode > 9));
    function A(n, a) {
      gc = n, Zs = a, gc.attachEvent("onpropertychange", re);
    }
    function q() {
      gc && (gc.detachEvent("onpropertychange", re), gc = null, Zs = null);
    }
    function re(n) {
      n.propertyName === "value" && g(Zs) && o(n);
    }
    function ye(n, a, f) {
      n === "focusin" ? (q(), A(a, f)) : n === "focusout" && q();
    }
    function Oe(n, a) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown") return g(Zs);
    }
    function ze(n) {
      var a = n.nodeName;
      return a && a.toLowerCase() === "input" && (n.type === "checkbox" || n.type === "radio");
    }
    function Me(n, a) {
      if (n === "click") return g(a);
    }
    function et(n, a) {
      if (n === "input" || n === "change") return g(a);
    }
    function it(n) {
      var a = n._wrapperState;
      !a || !a.controlled || n.type !== "number" || wd(n, "number", n.value);
    }
    function lt(n, a, f, m, b, T, M) {
      var z = f ? mv(f) : window,
        U,
        X;
      if (r(z) ? U = S : Lb(z) ? R ? U = et : (U = Oe, X = ye) : ze(z) && (U = Me), U) {
        var J = U(a, f);
        if (J) {
          cl(n, J, m, b);
          return;
        }
      }
      X && X(a, z, f), a === "focusout" && it(z);
    }
    function Kn() {
      Be("onMouseEnter", ["mouseout", "mouseover"]), Be("onMouseLeave", ["mouseout", "mouseover"]), Be("onPointerEnter", ["pointerout", "pointerover"]), Be("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function pe(n, a, f, m, b, T, M) {
      var z = a === "mouseover" || a === "pointerover",
        U = a === "mouseout" || a === "pointerout";
      if (z && !Hu(m)) {
        var X = m.relatedTarget || m.fromElement;
        if (X && (zc(X) || Nc(X))) return;
      }
      if (!(!U && !z)) {
        var J;
        if (b.window === b) J = b;else {
          var me = b.ownerDocument;
          me ? J = me.defaultView || me.parentWindow : J = window;
        }
        var xe, Ie;
        if (U) {
          var Pe = m.relatedTarget || m.toElement;
          if (xe = f, Ie = Pe ? zc(Pe) : null, Ie !== null) {
            var $e = li(Ie);
            (Ie !== $e || Ie.tag !== D && Ie.tag !== I) && (Ie = null);
          }
        } else xe = null, Ie = f;
        if (xe !== Ie) {
          var mt = Eo,
            Te = "onMouseLeave",
            Ue = "onMouseEnter",
            Ve = "mouse";
          (a === "pointerout" || a === "pointerover") && (mt = Rb, Te = "onPointerLeave", Ue = "onPointerEnter", Ve = "pointer");
          var nt = xe == null ? J : mv(xe),
            ke = Ie == null ? J : mv(Ie),
            Fe = new mt(Te, Ve + "leave", xe, m, b);
          Fe.target = nt, Fe.relatedTarget = ke;
          var De = null,
            Qe = zc(b);
          if (Qe === f) {
            var Tt = new mt(Ue, Ve + "enter", Ie, m, b);
            Tt.target = ke, Tt.relatedTarget = nt, De = Tt;
          }
          bO(n, Fe, De, xe, Ie);
        }
      }
    }
    function oe(n, a) {
      return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
    }
    var he = typeof Object.is == "function" ? Object.is : oe;
    function He(n, a) {
      if (he(n, a)) return !0;
      if (typeof n != "object" || n === null || typeof a != "object" || a === null) return !1;
      var f = Object.keys(n),
        m = Object.keys(a);
      if (f.length !== m.length) return !1;
      for (var b = 0; b < f.length; b++) {
        var T = f[b];
        if (!ge.call(a, T) || !he(n[T], a[T])) return !1;
      }
      return !0;
    }
    function ut(n) {
      for (; n && n.firstChild;) n = n.firstChild;
      return n;
    }
    function bt(n) {
      for (; n;) {
        if (n.nextSibling) return n.nextSibling;
        n = n.parentNode;
      }
    }
    function wt(n, a) {
      for (var f = ut(n), m = 0, b = 0; f;) {
        if (f.nodeType === Xa) {
          if (b = m + f.textContent.length, m <= a && b >= a) return {
            node: f,
            offset: a - m
          };
          m = b;
        }
        f = ut(bt(f));
      }
    }
    function It(n) {
      var a = n.ownerDocument,
        f = a && a.defaultView || window,
        m = f.getSelection && f.getSelection();
      if (!m || m.rangeCount === 0) return null;
      var b = m.anchorNode,
        T = m.anchorOffset,
        M = m.focusNode,
        z = m.focusOffset;
      try {
        b.nodeType, M.nodeType;
      } catch {
        return null;
      }
      return mr(n, b, T, M, z);
    }
    function mr(n, a, f, m, b) {
      var T = 0,
        M = -1,
        z = -1,
        U = 0,
        X = 0,
        J = n,
        me = null;
      e: for (;;) {
        for (var xe = null; J === a && (f === 0 || J.nodeType === Xa) && (M = T + f), J === m && (b === 0 || J.nodeType === Xa) && (z = T + b), J.nodeType === Xa && (T += J.nodeValue.length), (xe = J.firstChild) !== null;) me = J, J = xe;
        for (;;) {
          if (J === n) break e;
          if (me === a && ++U === f && (M = T), me === m && ++X === b && (z = T), (xe = J.nextSibling) !== null) break;
          J = me, me = J.parentNode;
        }
        J = xe;
      }
      return M === -1 || z === -1 ? null : {
        start: M,
        end: z
      };
    }
    function cn(n, a) {
      var f = n.ownerDocument || document,
        m = f && f.defaultView || window;
      if (m.getSelection) {
        var b = m.getSelection(),
          T = n.textContent.length,
          M = Math.min(a.start, T),
          z = a.end === void 0 ? M : Math.min(a.end, T);
        if (!b.extend && M > z) {
          var U = z;
          z = M, M = U;
        }
        var X = wt(n, M),
          J = wt(n, z);
        if (X && J) {
          if (b.rangeCount === 1 && b.anchorNode === X.node && b.anchorOffset === X.offset && b.focusNode === J.node && b.focusOffset === J.offset) return;
          var me = f.createRange();
          me.setStart(X.node, X.offset), b.removeAllRanges(), M > z ? (b.addRange(me), b.extend(J.node, J.offset)) : (me.setEnd(J.node, J.offset), b.addRange(me));
        }
      }
    }
    function lo(n) {
      return n && n.nodeType === Xa;
    }
    function Pb(n, a) {
      return !n || !a ? !1 : n === a ? !0 : lo(n) ? !1 : lo(a) ? Pb(n, a.parentNode) : "contains" in n ? n.contains(a) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(a) & 16) : !1;
    }
    function cO(n) {
      return n && n.ownerDocument && Pb(n.ownerDocument.documentElement, n);
    }
    function QR(n) {
      try {
        return typeof n.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function iS() {
      for (var n = window, a = Dl(); a instanceof n.HTMLIFrameElement;) {
        if (QR(a)) n = a.contentWindow;else return a;
        a = Dl(n.document);
      }
      return a;
    }
    function WE(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a && (a === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || a === "textarea" || n.contentEditable === "true");
    }
    function dO() {
      var n = iS();
      return {
        focusedElem: n,
        selectionRange: WE(n) ? pO(n) : null
      };
    }
    function fO(n) {
      var a = iS(),
        f = n.focusedElem,
        m = n.selectionRange;
      if (a !== f && cO(f)) {
        m !== null && WE(f) && hO(f, m);
        for (var b = [], T = f; T = T.parentNode;) T.nodeType === Wr && b.push({
          element: T,
          left: T.scrollLeft,
          top: T.scrollTop
        });
        typeof f.focus == "function" && f.focus();
        for (var M = 0; M < b.length; M++) {
          var z = b[M];
          z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
        }
      }
    }
    function pO(n) {
      var a;
      return "selectionStart" in n ? a = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : a = It(n), a || {
        start: 0,
        end: 0
      };
    }
    function hO(n, a) {
      var f = a.start,
        m = a.end;
      m === void 0 && (m = f), "selectionStart" in n ? (n.selectionStart = f, n.selectionEnd = Math.min(m, n.value.length)) : cn(n, a);
    }
    var mO = Xe && "documentMode" in document && document.documentMode <= 11;
    function Ab() {
      Le("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var iv = null,
      fy = null,
      py = null,
      qE = !1;
    function vO(n) {
      if ("selectionStart" in n && WE(n)) return {
        start: n.selectionStart,
        end: n.selectionEnd
      };
      var a = n.ownerDocument && n.ownerDocument.defaultView || window,
        f = a.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function ZR(n) {
      return n.window === n ? n.document : n.nodeType === Ka ? n : n.ownerDocument;
    }
    function JR(n, a, f) {
      var m = ZR(f);
      if (!(qE || iv == null || iv !== Dl(m))) {
        var b = vO(iv);
        if (!py || !He(py, b)) {
          py = b;
          var T = im(fy, "onSelect");
          if (T.length > 0) {
            var M = new hr("onSelect", "select", null, a, f);
            n.push({
              event: M,
              listeners: T
            }), M.target = iv;
          }
        }
      }
    }
    function aS(n, a, f, m, b, T, M) {
      var z = f ? mv(f) : window;
      switch (a) {
        // Track the input node that has focus.
        case "focusin":
          (Lb(z) || z.contentEditable === "true") && (iv = z, fy = f, py = null);
          break;
        case "focusout":
          iv = null, fy = null, py = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          qE = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          qE = !1, JR(n, m, b);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (mO) break;
        // falls through
        case "keydown":
        case "keyup":
          JR(n, m, b);
      }
    }
    function nm(n, a) {
      var f = {};
      return f[n.toLowerCase()] = a.toLowerCase(), f["Webkit" + n] = "webkit" + a, f["Moz" + n] = "moz" + a, f;
    }
    var av = {
        animationend: nm("Animation", "AnimationEnd"),
        animationiteration: nm("Animation", "AnimationIteration"),
        animationstart: nm("Animation", "AnimationStart"),
        transitionend: nm("Transition", "TransitionEnd")
      },
      oS = {},
      Bw = {};
    Xe && (Bw = document.createElement("div").style, "AnimationEvent" in window || (delete av.animationend.animation, delete av.animationiteration.animation, delete av.animationstart.animation), "TransitionEvent" in window || delete av.transitionend.transition);
    function Uw(n) {
      if (oS[n]) return oS[n];
      if (!av[n]) return n;
      var a = av[n];
      for (var f in a) if (a.hasOwnProperty(f) && f in Bw) return oS[n] = a[f];
      return n;
    }
    var YE = Uw("animationend"),
      GE = Uw("animationiteration"),
      XE = Uw("animationstart"),
      KE = Uw("transitionend"),
      QE = /* @__PURE__ */new Map(),
      rm = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function ov(n, a) {
      QE.set(n, a), Le(a, [n]);
    }
    function gO() {
      for (var n = 0; n < rm.length; n++) {
        var a = rm[n],
          f = a.toLowerCase(),
          m = a[0].toUpperCase() + a.slice(1);
        ov(f, "on" + m);
      }
      ov(YE, "onAnimationEnd"), ov(GE, "onAnimationIteration"), ov(XE, "onAnimationStart"), ov("dblclick", "onDoubleClick"), ov("focusin", "onFocus"), ov("focusout", "onBlur"), ov(KE, "onTransitionEnd");
    }
    function yO(n, a, f, m, b, T, M) {
      var z = QE.get(a);
      if (z !== void 0) {
        var U = hr,
          X = a;
        switch (a) {
          case "keypress":
            if (Gl(m) === 0) return;
          /* falls through */
          case "keydown":
          case "keyup":
            U = Nw;
            break;
          case "focusin":
            X = "focus", U = vf;
            break;
          case "focusout":
            X = "blur", U = vf;
            break;
          case "beforeblur":
          case "afterblur":
            U = vf;
            break;
          case "click":
            if (m.button === 2) return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            U = Eo;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            U = Xh;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            U = ly;
            break;
          case YE:
          case GE:
          case XE:
            U = ry;
            break;
          case KE:
            U = Vw;
            break;
          case "scroll":
            U = Li;
            break;
          case "wheel":
            U = Zh;
            break;
          case "copy":
          case "cut":
          case "paste":
            U = Kh;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            U = Rb;
            break;
        }
        var J = (T & wi) !== 0;
        {
          var me = !J &&
            // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            a === "scroll",
            xe = uS(f, z, m.type, J, me);
          if (xe.length > 0) {
            var Ie = new U(z, X, null, m, b);
            n.push({
              event: Ie,
              listeners: xe
            });
          }
        }
      }
    }
    gO(), Kn(), Ob(), Ab(), dp();
    function Hw(n, a, f, m, b, T, M) {
      yO(n, a, f, m, b, T);
      var z = (T & xh) === 0;
      z && (pe(n, a, f, m, b), lt(n, a, f, m, b), aS(n, a, f, m, b), wf(n, a, f, m, b));
    }
    var hy = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"],
      lS = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(hy));
    function eD(n, a, f) {
      var m = n.type || "unknown-event";
      n.currentTarget = f, ma(m, a, void 0, n), n.currentTarget = null;
    }
    function tD(n, a, f) {
      var m;
      if (f) for (var b = a.length - 1; b >= 0; b--) {
        var T = a[b],
          M = T.instance,
          z = T.currentTarget,
          U = T.listener;
        if (M !== m && n.isPropagationStopped()) return;
        eD(n, U, z), m = M;
      } else for (var X = 0; X < a.length; X++) {
        var J = a[X],
          me = J.instance,
          xe = J.currentTarget,
          Ie = J.listener;
        if (me !== m && n.isPropagationStopped()) return;
        eD(n, Ie, xe), m = me;
      }
    }
    function nD(n, a) {
      for (var f = (a & wi) !== 0, m = 0; m < n.length; m++) {
        var b = n[m],
          T = b.event,
          M = b.listeners;
        tD(T, M, f);
      }
      qu();
    }
    function Ji(n, a, f, m, b) {
      var T = Sh(f),
        M = [];
      Hw(M, n, m, f, T, a), nD(M, a);
    }
    function Pi(n, a) {
      lS.has(n) || h('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', n);
      var f = !1,
        m = wD(a),
        b = pu(n);
      m.has(b) || (ZE(a, n, Dd, f), m.add(b));
    }
    function jb(n, a, f) {
      lS.has(n) && !a && h('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', n);
      var m = 0;
      a && (m |= wi), ZE(f, n, m, a);
    }
    var lv = "_reactListening" + Math.random().toString(36).slice(2);
    function Fb(n) {
      if (!n[lv]) {
        n[lv] = !0, _e.forEach(function (f) {
          f !== "selectionchange" && (lS.has(f) || jb(f, !1, n), jb(f, !0, n));
        });
        var a = n.nodeType === Ka ? n : n.ownerDocument;
        a !== null && (a[lv] || (a[lv] = !0, jb("selectionchange", !1, a)));
      }
    }
    function ZE(n, a, f, m, b) {
      var T = ir(n, a, f),
        M = void 0;
      Wu && (a === "touchstart" || a === "touchmove" || a === "wheel") && (M = !0), n = n, m ? M !== void 0 ? ti(n, a, T, M) : dc(n, a, T) : M !== void 0 ? fc(n, a, T, M) : qh(n, a, T);
    }
    function sS(n, a) {
      return n === a || n.nodeType === er && n.parentNode === a;
    }
    function my(n, a, f, m, b) {
      var T = m;
      if ((a & _h) === 0 && (a & Dd) === 0) {
        var M = b;
        if (m !== null) {
          var z = m;
          e: for (;;) {
            if (z === null) return;
            var U = z.tag;
            if (U === C || U === k) {
              var X = z.stateNode.containerInfo;
              if (sS(X, M)) break;
              if (U === k) for (var J = z.return; J !== null;) {
                var me = J.tag;
                if (me === C || me === k) {
                  var xe = J.stateNode.containerInfo;
                  if (sS(xe, M)) return;
                }
                J = J.return;
              }
              for (; X !== null;) {
                var Ie = zc(X);
                if (Ie === null) return;
                var Pe = Ie.tag;
                if (Pe === D || Pe === I) {
                  z = T = Ie;
                  continue e;
                }
                X = X.parentNode;
              }
            }
            z = z.return;
          }
        }
      }
      Mg(function () {
        return Ji(n, a, f, T);
      });
    }
    function $w(n, a, f) {
      return {
        instance: n,
        listener: a,
        currentTarget: f
      };
    }
    function uS(n, a, f, m, b, T) {
      for (var M = a !== null ? a + "Capture" : null, z = m ? M : a, U = [], X = n, J = null; X !== null;) {
        var me = X,
          xe = me.stateNode,
          Ie = me.tag;
        if (Ie === D && xe !== null && (J = xe, z !== null)) {
          var Pe = zo(X, z);
          Pe != null && U.push($w(X, Pe, J));
        }
        if (b) break;
        X = X.return;
      }
      return U;
    }
    function im(n, a) {
      for (var f = a + "Capture", m = [], b = n; b !== null;) {
        var T = b,
          M = T.stateNode,
          z = T.tag;
        if (z === D && M !== null) {
          var U = M,
            X = zo(b, f);
          X != null && m.unshift($w(b, X, U));
          var J = zo(b, a);
          J != null && m.push($w(b, J, U));
        }
        b = b.return;
      }
      return m;
    }
    function Nb(n) {
      if (n === null) return null;
      do n = n.return; while (n && n.tag !== D);
      return n || null;
    }
    function rD(n, a) {
      for (var f = n, m = a, b = 0, T = f; T; T = Nb(T)) b++;
      for (var M = 0, z = m; z; z = Nb(z)) M++;
      for (; b - M > 0;) f = Nb(f), b--;
      for (; M - b > 0;) m = Nb(m), M--;
      for (var U = b; U--;) {
        if (f === m || m !== null && f === m.alternate) return f;
        f = Nb(f), m = Nb(m);
      }
      return null;
    }
    function iD(n, a, f, m, b) {
      for (var T = a._reactName, M = [], z = f; z !== null && z !== m;) {
        var U = z,
          X = U.alternate,
          J = U.stateNode,
          me = U.tag;
        if (X !== null && X === m) break;
        if (me === D && J !== null) {
          var xe = J;
          if (b) {
            var Ie = zo(z, T);
            Ie != null && M.unshift($w(z, Ie, xe));
          } else if (!b) {
            var Pe = zo(z, T);
            Pe != null && M.push($w(z, Pe, xe));
          }
        }
        z = z.return;
      }
      M.length !== 0 && n.push({
        event: a,
        listeners: M
      });
    }
    function bO(n, a, f, m, b) {
      var T = m && b ? rD(m, b) : null;
      m !== null && iD(n, a, m, T, !1), b !== null && f !== null && iD(n, f, b, T, !0);
    }
    function pu(n, a) {
      return n + "__bubble";
    }
    var dl = !1,
      sv = "dangerouslySetInnerHTML",
      xf = "suppressContentEditableWarning",
      am = "suppressHydrationWarning",
      uv = "autoFocus",
      yc = "children",
      pp = "style",
      zb = "__html",
      Vb,
      cv,
      Bb,
      Ww,
      qw,
      JE,
      aD;
    Vb = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, cv = function (n, a) {
      yh(n, a), Td(n, a), Rg(n, a, {
        registrationNameDependencies: Se,
        possibleRegistrationNames: be
      });
    }, JE = Xe && !document.documentMode, Bb = function (n, a, f) {
      if (!dl) {
        var m = vy(f),
          b = vy(a);
        b !== m && (dl = !0, h("Prop `%s` did not match. Server: %s Client: %s", n, JSON.stringify(b), JSON.stringify(m)));
      }
    }, Ww = function (n) {
      if (!dl) {
        dl = !0;
        var a = [];
        n.forEach(function (f) {
          a.push(f);
        }), h("Extra attributes from the server: %s", a);
      }
    }, qw = function (n, a) {
      a === !1 ? h("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, n, n) : h("Expected `%s` listener to be a function, instead got a value of `%s` type.", n, typeof a);
    }, aD = function (n, a) {
      var f = n.namespaceURI === Ga ? n.ownerDocument.createElement(n.tagName) : n.ownerDocument.createElementNS(n.namespaceURI, n.tagName);
      return f.innerHTML = a, f.innerHTML;
    };
    var wO = /\r\n?/g,
      cS = /\u0000|\uFFFD/g;
    function vy(n) {
      St(n);
      var a = typeof n == "string" ? n : "" + n;
      return a.replace(wO, `
`).replace(cS, "");
    }
    function Yw(n, a, f, m) {
      var b = vy(a),
        T = vy(n);
      if (T !== b && (m && (dl || (dl = !0, h('Text content did not match. Server: "%s" Client: "%s"', T, b))), f && W)) throw new Error("Text content does not match server-rendered HTML.");
    }
    function oD(n) {
      return n.nodeType === Ka ? n : n.ownerDocument;
    }
    function dS() {}
    function fS(n) {
      n.onclick = dS;
    }
    function _O(n, a, f, m, b) {
      for (var T in m) if (m.hasOwnProperty(T)) {
        var M = m[T];
        if (T === pp) M && Object.freeze(M), xg(a, M);else if (T === sv) {
          var z = M ? M[zb] : void 0;
          z != null && cg(a, z);
        } else if (T === yc) {
          if (typeof M == "string") {
            var U = n !== "textarea" || M !== "";
            U && ks(a, M);
          } else typeof M == "number" && ks(a, "" + M);
        } else T === xf || T === am || T === uv || (Se.hasOwnProperty(T) ? M != null && (typeof M != "function" && qw(T, M), T === "onScroll" && Pi("scroll", a)) : M != null && Ha(a, T, M, b));
      }
    }
    function xO(n, a, f, m) {
      for (var b = 0; b < a.length; b += 2) {
        var T = a[b],
          M = a[b + 1];
        T === pp ? xg(n, M) : T === sv ? cg(n, M) : T === yc ? ks(n, M) : Ha(n, T, M, m);
      }
    }
    function SO(n, a, f, m) {
      var b,
        T = oD(f),
        M,
        z = m;
      if (z === Ga && (z = dh(n)), z === Ga) {
        if (b = Fo(n, a), !b && n !== n.toLowerCase() && h("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", n), n === "script") {
          var U = T.createElement("div");
          U.innerHTML = "<script><\/script>";
          var X = U.firstChild;
          M = U.removeChild(X);
        } else if (typeof a.is == "string") M = T.createElement(n, {
          is: a.is
        });else if (M = T.createElement(n), n === "select") {
          var J = M;
          a.multiple ? J.multiple = !0 : a.size && (J.size = a.size);
        }
      } else M = T.createElementNS(z, n);
      return z === Ga && !b && Object.prototype.toString.call(M) === "[object HTMLUnknownElement]" && !ge.call(Vb, n) && (Vb[n] = !0, h("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", n)), M;
    }
    function EO(n, a) {
      return oD(a).createTextNode(n);
    }
    function CO(n, a, f, m) {
      var b = Fo(a, f);
      cv(a, f);
      var T;
      switch (a) {
        case "dialog":
          Pi("cancel", n), Pi("close", n), T = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          Pi("load", n), T = f;
          break;
        case "video":
        case "audio":
          for (var M = 0; M < hy.length; M++) Pi(hy[M], n);
          T = f;
          break;
        case "source":
          Pi("error", n), T = f;
          break;
        case "img":
        case "image":
        case "link":
          Pi("error", n), Pi("load", n), T = f;
          break;
        case "details":
          Pi("toggle", n), T = f;
          break;
        case "input":
          Ya(n, f), T = vd(n, f), Pi("invalid", n);
          break;
        case "option":
          Es(n, f), T = f;
          break;
        case "select":
          xd(n, f), T = oh(n, f), Pi("invalid", n);
          break;
        case "textarea":
          sh(n, f), T = lh(n, f), Pi("invalid", n);
          break;
        default:
          T = f;
      }
      switch (Cd(a, T), _O(a, n, m, T, b), a) {
        case "input":
          jo(n), rh(n, f, !1);
          break;
        case "textarea":
          jo(n), sg(n);
          break;
        case "option":
          mw(n, f);
          break;
        case "select":
          gw(n, f);
          break;
        default:
          typeof T.onClick == "function" && fS(n);
          break;
      }
    }
    function kO(n, a, f, m, b) {
      cv(a, m);
      var T = null,
        M,
        z;
      switch (a) {
        case "input":
          M = vd(n, f), z = vd(n, m), T = [];
          break;
        case "select":
          M = oh(n, f), z = oh(n, m), T = [];
          break;
        case "textarea":
          M = lh(n, f), z = lh(n, m), T = [];
          break;
        default:
          M = f, z = m, typeof M.onClick != "function" && typeof z.onClick == "function" && fS(n);
          break;
      }
      Cd(a, z);
      var U,
        X,
        J = null;
      for (U in M) if (!(z.hasOwnProperty(U) || !M.hasOwnProperty(U) || M[U] == null)) if (U === pp) {
        var me = M[U];
        for (X in me) me.hasOwnProperty(X) && (J || (J = {}), J[X] = "");
      } else U === sv || U === yc || U === xf || U === am || U === uv || (Se.hasOwnProperty(U) ? T || (T = []) : (T = T || []).push(U, null));
      for (U in z) {
        var xe = z[U],
          Ie = M != null ? M[U] : void 0;
        if (!(!z.hasOwnProperty(U) || xe === Ie || xe == null && Ie == null)) if (U === pp) {
          if (xe && Object.freeze(xe), Ie) {
            for (X in Ie) Ie.hasOwnProperty(X) && (!xe || !xe.hasOwnProperty(X)) && (J || (J = {}), J[X] = "");
            for (X in xe) xe.hasOwnProperty(X) && Ie[X] !== xe[X] && (J || (J = {}), J[X] = xe[X]);
          } else J || (T || (T = []), T.push(U, J)), J = xe;
        } else if (U === sv) {
          var Pe = xe ? xe[zb] : void 0,
            $e = Ie ? Ie[zb] : void 0;
          Pe != null && $e !== Pe && (T = T || []).push(U, Pe);
        } else U === yc ? (typeof xe == "string" || typeof xe == "number") && (T = T || []).push(U, "" + xe) : U === xf || U === am || (Se.hasOwnProperty(U) ? (xe != null && (typeof xe != "function" && qw(U, xe), U === "onScroll" && Pi("scroll", n)), !T && Ie !== xe && (T = [])) : (T = T || []).push(U, xe));
      }
      return J && (kw(J, z[pp]), (T = T || []).push(pp, J)), T;
    }
    function TO(n, a, f, m, b) {
      f === "input" && b.type === "radio" && b.name != null && gd(n, b);
      var T = Fo(f, m),
        M = Fo(f, b);
      switch (xO(n, a, T, M), f) {
        case "input":
          Ss(n, b);
          break;
        case "textarea":
          lg(n, b);
          break;
        case "select":
          yw(n, b);
          break;
      }
    }
    function RO(n) {
      {
        var a = n.toLowerCase();
        return Bu.hasOwnProperty(a) && Bu[a] || null;
      }
    }
    function DO(n, a, f, m, b, T, M) {
      var z, U;
      switch (z = Fo(a, f), cv(a, f), a) {
        case "dialog":
          Pi("cancel", n), Pi("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Pi("load", n);
          break;
        case "video":
        case "audio":
          for (var X = 0; X < hy.length; X++) Pi(hy[X], n);
          break;
        case "source":
          Pi("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Pi("error", n), Pi("load", n);
          break;
        case "details":
          Pi("toggle", n);
          break;
        case "input":
          Ya(n, f), Pi("invalid", n);
          break;
        case "option":
          Es(n, f);
          break;
        case "select":
          xd(n, f), Pi("invalid", n);
          break;
        case "textarea":
          sh(n, f), Pi("invalid", n);
          break;
      }
      Cd(a, f);
      {
        U = /* @__PURE__ */new Set();
        for (var J = n.attributes, me = 0; me < J.length; me++) {
          var xe = J[me].name.toLowerCase();
          switch (xe) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              U.add(J[me].name);
          }
        }
      }
      var Ie = null;
      for (var Pe in f) if (f.hasOwnProperty(Pe)) {
        var $e = f[Pe];
        if (Pe === yc) typeof $e == "string" ? n.textContent !== $e && (f[am] !== !0 && Yw(n.textContent, $e, T, M), Ie = [yc, $e]) : typeof $e == "number" && n.textContent !== "" + $e && (f[am] !== !0 && Yw(n.textContent, $e, T, M), Ie = [yc, "" + $e]);else if (Se.hasOwnProperty(Pe)) $e != null && (typeof $e != "function" && qw(Pe, $e), Pe === "onScroll" && Pi("scroll", n));else if (M &&
        // Convince Flow we've calculated it (it's DEV-only in this method.)
        typeof z == "boolean") {
          var mt = void 0,
            Te = Ht(Pe);
          if (f[am] !== !0) {
            if (!(Pe === xf || Pe === am ||
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            Pe === "value" || Pe === "checked" || Pe === "selected")) {
              if (Pe === sv) {
                var Ue = n.innerHTML,
                  Ve = $e ? $e[zb] : void 0;
                if (Ve != null) {
                  var nt = aD(n, Ve);
                  nt !== Ue && Bb(Pe, Ue, nt);
                }
              } else if (Pe === pp) {
                if (U.delete(Pe), JE) {
                  var ke = Ew($e);
                  mt = n.getAttribute("style"), ke !== mt && Bb(Pe, mt, ke);
                }
              } else if (z) U.delete(Pe.toLowerCase()), mt = Tu(n, Pe, $e), $e !== mt && Bb(Pe, mt, $e);else if (!at(Pe, Te, z) && !Bt(Pe, $e, Te, z)) {
                var Fe = !1;
                if (Te !== null) U.delete(Te.attributeName), mt = bo(n, Pe, $e, Te);else {
                  var De = m;
                  if (De === Ga && (De = dh(a)), De === Ga) U.delete(Pe.toLowerCase());else {
                    var Qe = RO(Pe);
                    Qe !== null && Qe !== Pe && (Fe = !0, U.delete(Qe)), U.delete(Pe);
                  }
                  mt = Tu(n, Pe, $e);
                }
                var Tt = se;
                !Tt && $e !== mt && !Fe && Bb(Pe, mt, $e);
              }
            }
          }
        }
      }
      switch (M &&
      // $FlowFixMe - Should be inferred as not undefined.
      U.size > 0 && f[am] !== !0 && Ww(U), a) {
        case "input":
          jo(n), rh(n, f, !0);
          break;
        case "textarea":
          jo(n), sg(n);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && fS(n);
          break;
      }
      return Ie;
    }
    function eC(n, a, f) {
      var m = n.nodeValue !== a;
      return m;
    }
    function Gw(n, a) {
      {
        if (dl) return;
        dl = !0, h("Did not expect server HTML to contain a <%s> in <%s>.", a.nodeName.toLowerCase(), n.nodeName.toLowerCase());
      }
    }
    function Xw(n, a) {
      {
        if (dl) return;
        dl = !0, h('Did not expect server HTML to contain the text node "%s" in <%s>.', a.nodeValue, n.nodeName.toLowerCase());
      }
    }
    function Kw(n, a, f) {
      {
        if (dl) return;
        dl = !0, h("Expected server HTML to contain a matching <%s> in <%s>.", a, n.nodeName.toLowerCase());
      }
    }
    function tC(n, a) {
      {
        if (a === "" || dl) return;
        dl = !0, h('Expected server HTML to contain a matching text node for "%s" in <%s>.', a, n.nodeName.toLowerCase());
      }
    }
    function Qw(n, a, f) {
      switch (a) {
        case "input":
          yd(n, f);
          return;
        case "textarea":
          ww(n, f);
          return;
        case "select":
          bw(n, f);
          return;
      }
    }
    var om = function () {},
      Zw = function () {};
    {
      var lD = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"],
        sD = ["applet", "caption", "html", "table", "td", "th", "marquee", "object", "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject", "desc", "title"],
        IO = sD.concat(["button"]),
        uD = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
        cD = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
      Zw = function (n, a) {
        var f = Qt({}, n || cD),
          m = {
            tag: a
          };
        return sD.indexOf(a) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), IO.indexOf(a) !== -1 && (f.pTagInButtonScope = null), lD.indexOf(a) !== -1 && a !== "address" && a !== "div" && a !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = m, a === "form" && (f.formTag = m), a === "a" && (f.aTagInScope = m), a === "button" && (f.buttonTagInScope = m), a === "nobr" && (f.nobrTagInScope = m), a === "p" && (f.pTagInButtonScope = m), a === "li" && (f.listItemTagAutoclosing = m), (a === "dd" || a === "dt") && (f.dlItemTagAutoclosing = m), f;
      };
      var MO = function (n, a) {
          switch (a) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return n === "option" || n === "optgroup" || n === "#text";
            case "optgroup":
              return n === "option" || n === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return n === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return n === "tr" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return n === "col" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return n === "head" || n === "body" || n === "frameset";
            case "frameset":
              return n === "frame";
            case "#document":
              return n === "html";
          }
          switch (n) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return a !== "h1" && a !== "h2" && a !== "h3" && a !== "h4" && a !== "h5" && a !== "h6";
            case "rp":
            case "rt":
              return uD.indexOf(a) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return a == null;
          }
          return !0;
        },
        dD = function (n, a) {
          switch (n) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return a.pTagInButtonScope;
            case "form":
              return a.formTag || a.pTagInButtonScope;
            case "li":
              return a.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return a.dlItemTagAutoclosing;
            case "button":
              return a.buttonTagInScope;
            case "a":
              return a.aTagInScope;
            case "nobr":
              return a.nobrTagInScope;
          }
          return null;
        },
        Jw = {};
      om = function (n, a, f) {
        f = f || cD;
        var m = f.current,
          b = m && m.tag;
        a != null && (n != null && h("validateDOMNesting: when childText is passed, childTag should be null"), n = "#text");
        var T = MO(n, b) ? null : m,
          M = T ? null : dD(n, f),
          z = T || M;
        if (z) {
          var U = z.tag,
            X = !!T + "|" + n + "|" + U;
          if (!Jw[X]) {
            Jw[X] = !0;
            var J = n,
              me = "";
            if (n === "#text" ? /\S/.test(a) ? J = "Text nodes" : (J = "Whitespace text nodes", me = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : J = "<" + n + ">", T) {
              var xe = "";
              U === "table" && n === "tr" && (xe += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), h("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", J, U, me, xe);
            } else h("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", J, U);
          }
        }
      };
    }
    var gy = "suppressHydrationWarning",
      yy = "$",
      dv = "/$",
      lm = "$?",
      e_ = "$!",
      nC = "style",
      t_ = null,
      rC = null;
    function LO(n) {
      var a,
        f,
        m = n.nodeType;
      switch (m) {
        case Ka:
        case ph:
          {
            a = m === Ka ? "#document" : "#fragment";
            var b = n.documentElement;
            f = b ? b.namespaceURI : fh(null, "");
            break;
          }
        default:
          {
            var T = m === er ? n.parentNode : n,
              M = T.namespaceURI || null;
            a = T.tagName, f = fh(M, a);
            break;
          }
      }
      {
        var z = a.toLowerCase(),
          U = Zw(null, z);
        return {
          namespace: f,
          ancestorInfo: U
        };
      }
    }
    function OO(n, a, f) {
      {
        var m = n,
          b = fh(m.namespace, a),
          T = Zw(m.ancestorInfo, a);
        return {
          namespace: b,
          ancestorInfo: T
        };
      }
    }
    function $z(n) {
      return n;
    }
    function PO(n) {
      t_ = pr(), rC = dO();
      var a = null;
      return on(!1), a;
    }
    function AO(n) {
      fO(rC), on(t_), t_ = null, rC = null;
    }
    function jO(n, a, f, m, b) {
      var T;
      {
        var M = m;
        if (om(n, null, M.ancestorInfo), typeof a.children == "string" || typeof a.children == "number") {
          var z = "" + a.children,
            U = Zw(M.ancestorInfo, n);
          om(null, z, U);
        }
        T = M.namespace;
      }
      var X = SO(n, a, f, T);
      return $b(b, X), gS(X, a), X;
    }
    function FO(n, a) {
      n.appendChild(a);
    }
    function iC(n, a, f, m, b) {
      switch (CO(n, a, f, m), a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function NO(n, a, f, m, b, T) {
      {
        var M = T;
        if (typeof m.children != typeof f.children && (typeof m.children == "string" || typeof m.children == "number")) {
          var z = "" + m.children,
            U = Zw(M.ancestorInfo, a);
          om(null, z, U);
        }
      }
      return kO(n, a, f, m);
    }
    function aC(n, a) {
      return n === "textarea" || n === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
    }
    function oC(n, a, f, m) {
      {
        var b = f;
        om(null, n, b.ancestorInfo);
      }
      var T = EO(n, a);
      return $b(m, T), T;
    }
    function zO() {
      var n = window.event;
      return n === void 0 ? ol : Oc(n.type);
    }
    var n_ = typeof setTimeout == "function" ? setTimeout : void 0,
      fD = typeof clearTimeout == "function" ? clearTimeout : void 0,
      lC = -1,
      pD = typeof Promise == "function" ? Promise : void 0,
      VO = typeof queueMicrotask == "function" ? queueMicrotask : typeof pD < "u" ? function (n) {
        return pD.resolve(null).then(n).catch(BO);
      } : n_;
    function BO(n) {
      setTimeout(function () {
        throw n;
      });
    }
    function hD(n, a, f, m) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && n.focus();
          return;
        case "img":
          {
            f.src && (n.src = f.src);
            return;
          }
      }
    }
    function UO(n, a, f, m, b, T) {
      TO(n, a, f, m, b), gS(n, b);
    }
    function mD(n) {
      ks(n, "");
    }
    function HO(n, a, f) {
      n.nodeValue = f;
    }
    function $O(n, a) {
      n.appendChild(a);
    }
    function WO(n, a) {
      var f;
      n.nodeType === er ? (f = n.parentNode, f.insertBefore(a, n)) : (f = n, f.appendChild(a));
      var m = n._reactRootContainer;
      m == null && f.onclick === null && fS(f);
    }
    function qO(n, a, f) {
      n.insertBefore(a, f);
    }
    function YO(n, a, f) {
      n.nodeType === er ? n.parentNode.insertBefore(a, f) : n.insertBefore(a, f);
    }
    function sC(n, a) {
      n.removeChild(a);
    }
    function GO(n, a) {
      n.nodeType === er ? n.parentNode.removeChild(a) : n.removeChild(a);
    }
    function uC(n, a) {
      var f = a,
        m = 0;
      do {
        var b = f.nextSibling;
        if (n.removeChild(f), b && b.nodeType === er) {
          var T = b.data;
          if (T === dv) {
            if (m === 0) {
              n.removeChild(b), _o(a);
              return;
            } else m--;
          } else (T === yy || T === lm || T === e_) && m++;
        }
        f = b;
      } while (f);
      _o(a);
    }
    function XO(n, a) {
      n.nodeType === er ? uC(n.parentNode, a) : n.nodeType === Wr && uC(n, a), _o(n);
    }
    function KO(n) {
      n = n;
      var a = n.style;
      typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function QO(n) {
      n.nodeValue = "";
    }
    function ZO(n, a) {
      n = n;
      var f = a[nC],
        m = f != null && f.hasOwnProperty("display") ? f.display : null;
      n.style.display = Ed("display", m);
    }
    function JO(n, a) {
      n.nodeValue = a;
    }
    function eP(n) {
      n.nodeType === Wr ? n.textContent = "" : n.nodeType === Ka && n.documentElement && n.removeChild(n.documentElement);
    }
    function tP(n, a, f) {
      return n.nodeType !== Wr || a.toLowerCase() !== n.nodeName.toLowerCase() ? null : n;
    }
    function vD(n, a) {
      return a === "" || n.nodeType !== Xa ? null : n;
    }
    function cC(n) {
      return n.nodeType !== er ? null : n;
    }
    function gD(n) {
      return n.data === lm;
    }
    function dC(n) {
      return n.data === e_;
    }
    function pS(n) {
      var a = n.nextSibling && n.nextSibling.dataset,
        f,
        m,
        b;
      return a && (f = a.dgst, m = a.msg, b = a.stck), {
        message: m,
        digest: f,
        stack: b
      };
    }
    function r_(n, a) {
      n._reactRetry = a;
    }
    function hS(n) {
      for (; n != null; n = n.nextSibling) {
        var a = n.nodeType;
        if (a === Wr || a === Xa) break;
        if (a === er) {
          var f = n.data;
          if (f === yy || f === e_ || f === lm) break;
          if (f === dv) return null;
        }
      }
      return n;
    }
    function i_(n) {
      return hS(n.nextSibling);
    }
    function nP(n) {
      return hS(n.firstChild);
    }
    function rP(n) {
      return hS(n.firstChild);
    }
    function iP(n) {
      return hS(n.nextSibling);
    }
    function aP(n, a, f, m, b, T, M) {
      $b(T, n), gS(n, f);
      var z;
      {
        var U = b;
        z = U.namespace;
      }
      var X = (T.mode & Wt) !== dt;
      return DO(n, a, f, z, m, X, M);
    }
    function oP(n, a, f, m) {
      return $b(f, n), f.mode & Wt, eC(n, a);
    }
    function yD(n, a) {
      $b(a, n);
    }
    function lP(n) {
      for (var a = n.nextSibling, f = 0; a;) {
        if (a.nodeType === er) {
          var m = a.data;
          if (m === dv) {
            if (f === 0) return i_(a);
            f--;
          } else (m === yy || m === e_ || m === lm) && f++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function bD(n) {
      for (var a = n.previousSibling, f = 0; a;) {
        if (a.nodeType === er) {
          var m = a.data;
          if (m === yy || m === e_ || m === lm) {
            if (f === 0) return a;
            f--;
          } else m === dv && f++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function sP(n) {
      _o(n);
    }
    function uP(n) {
      _o(n);
    }
    function cP(n) {
      return n !== "head" && n !== "body";
    }
    function dP(n, a, f, m) {
      var b = !0;
      Yw(a.nodeValue, f, m, b);
    }
    function fP(n, a, f, m, b, T) {
      if (a[gy] !== !0) {
        var M = !0;
        Yw(m.nodeValue, b, T, M);
      }
    }
    function pP(n, a) {
      a.nodeType === Wr ? Gw(n, a) : a.nodeType === er || Xw(n, a);
    }
    function hP(n, a) {
      {
        var f = n.parentNode;
        f !== null && (a.nodeType === Wr ? Gw(f, a) : a.nodeType === er || Xw(f, a));
      }
    }
    function mP(n, a, f, m, b) {
      (b || a[gy] !== !0) && (m.nodeType === Wr ? Gw(f, m) : m.nodeType === er || Xw(f, m));
    }
    function vP(n, a, f) {
      Kw(n, a);
    }
    function gP(n, a) {
      tC(n, a);
    }
    function yP(n, a, f) {
      {
        var m = n.parentNode;
        m !== null && Kw(m, a);
      }
    }
    function bP(n, a) {
      {
        var f = n.parentNode;
        f !== null && tC(f, a);
      }
    }
    function wP(n, a, f, m, b, T) {
      (T || a[gy] !== !0) && Kw(f, m);
    }
    function _P(n, a, f, m, b) {
      (b || a[gy] !== !0) && tC(f, m);
    }
    function Ub(n) {
      h("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", n.nodeName.toLowerCase());
    }
    function Hb(n) {
      Fb(n);
    }
    var fv = Math.random().toString(36).slice(2),
      hp = "__reactFiber$" + fv,
      a_ = "__reactProps$" + fv,
      o_ = "__reactContainer$" + fv,
      fC = "__reactEvents$" + fv,
      xP = "__reactListeners$" + fv,
      l_ = "__reactHandles$" + fv;
    function mS(n) {
      delete n[hp], delete n[a_], delete n[fC], delete n[xP], delete n[l_];
    }
    function $b(n, a) {
      a[hp] = n;
    }
    function pv(n, a) {
      a[o_] = n;
    }
    function hv(n) {
      n[o_] = null;
    }
    function Nc(n) {
      return !!n[o_];
    }
    function zc(n) {
      var a = n[hp];
      if (a) return a;
      for (var f = n.parentNode; f;) {
        if (a = f[o_] || f[hp], a) {
          var m = a.alternate;
          if (a.child !== null || m !== null && m.child !== null) for (var b = bD(n); b !== null;) {
            var T = b[hp];
            if (T) return T;
            b = bD(b);
          }
          return a;
        }
        n = f, f = n.parentNode;
      }
      return null;
    }
    function Sf(n) {
      var a = n[hp] || n[o_];
      return a && (a.tag === D || a.tag === I || a.tag === V || a.tag === C) ? a : null;
    }
    function mv(n) {
      if (n.tag === D || n.tag === I) return n.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function vS(n) {
      return n[a_] || null;
    }
    function gS(n, a) {
      n[a_] = a;
    }
    function wD(n) {
      var a = n[fC];
      return a === void 0 && (a = n[fC] = /* @__PURE__ */new Set()), a;
    }
    var s_ = {},
      Vc = i.ReactDebugCurrentFrame;
    function Wb(n) {
      if (n) {
        var a = n._owner,
          f = Tl(n.type, n._source, a ? a.type : null);
        Vc.setExtraStackFrame(f);
      } else Vc.setExtraStackFrame(null);
    }
    function hu(n, a, f, m, b) {
      {
        var T = Function.call.bind(ge);
        for (var M in n) if (T(n, M)) {
          var z = void 0;
          try {
            if (typeof n[M] != "function") {
              var U = Error((m || "React class") + ": " + f + " type `" + M + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[M] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw U.name = "Invariant Violation", U;
            }
            z = n[M](a, M, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (X) {
            z = X;
          }
          z && !(z instanceof Error) && (Wb(b), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, M, typeof z), Wb(null)), z instanceof Error && !(z.message in s_) && (s_[z.message] = !0, Wb(b), h("Failed %s type: %s", f, z.message), Wb(null));
        }
      }
    }
    var Ef = [],
      Cf;
    Cf = [];
    var ca = -1;
    function ka(n) {
      return {
        current: n
      };
    }
    function fl(n, a) {
      if (ca < 0) {
        h("Unexpected pop.");
        return;
      }
      a !== Cf[ca] && h("Unexpected Fiber popped."), n.current = Ef[ca], Ef[ca] = null, Cf[ca] = null, ca--;
    }
    function fi(n, a, f) {
      ca++, Ef[ca] = n.current, Cf[ca] = f, n.current = a;
    }
    var kf;
    kf = {};
    var Oa = {};
    Object.freeze(Oa);
    var Tf = ka(Oa),
      Js = ka(!1),
      yS = Oa;
    function Rf(n, a, f) {
      return f && Bc(a) ? yS : Tf.current;
    }
    function u_(n, a, f) {
      {
        var m = n.stateNode;
        m.__reactInternalMemoizedUnmaskedChildContext = a, m.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function eu(n, a) {
      {
        var f = n.type,
          m = f.contextTypes;
        if (!m) return Oa;
        var b = n.stateNode;
        if (b && b.__reactInternalMemoizedUnmaskedChildContext === a) return b.__reactInternalMemoizedMaskedChildContext;
        var T = {};
        for (var M in m) T[M] = a[M];
        {
          var z = At(n) || "Unknown";
          hu(m, T, "context", z);
        }
        return b && u_(n, a, T), T;
      }
    }
    function by() {
      return Js.current;
    }
    function Bc(n) {
      {
        var a = n.childContextTypes;
        return a != null;
      }
    }
    function c_(n) {
      fl(Js, n), fl(Tf, n);
    }
    function bS(n) {
      fl(Js, n), fl(Tf, n);
    }
    function d_(n, a, f) {
      {
        if (Tf.current !== Oa) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        fi(Tf, a, n), fi(Js, f, n);
      }
    }
    function pC(n, a, f) {
      {
        var m = n.stateNode,
          b = a.childContextTypes;
        if (typeof m.getChildContext != "function") {
          {
            var T = At(n) || "Unknown";
            kf[T] || (kf[T] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", T, T));
          }
          return f;
        }
        var M = m.getChildContext();
        for (var z in M) if (!(z in b)) throw new Error((At(n) || "Unknown") + '.getChildContext(): key "' + z + '" is not defined in childContextTypes.');
        {
          var U = At(n) || "Unknown";
          hu(b, M, "child context", U);
        }
        return Qt({}, f, M);
      }
    }
    function wS(n) {
      {
        var a = n.stateNode,
          f = a && a.__reactInternalMemoizedMergedChildContext || Oa;
        return yS = Tf.current, fi(Tf, f, n), fi(Js, Js.current, n), !0;
      }
    }
    function sm(n, a, f) {
      {
        var m = n.stateNode;
        if (!m) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var b = pC(n, a, yS);
          m.__reactInternalMemoizedMergedChildContext = b, fl(Js, n), fl(Tf, n), fi(Tf, b, n), fi(Js, f, n);
        } else fl(Js, n), fi(Js, f, n);
      }
    }
    function _S(n) {
      {
        if (!Nl(n) || n.tag !== x) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = n;
        do {
          switch (a.tag) {
            case C:
              return a.stateNode.context;
            case x:
              {
                var f = a.type;
                if (Bc(f)) return a.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var fs = 0,
      qb = 1,
      Df = null,
      xS = !1,
      hC = !1;
    function mC(n) {
      Df === null ? Df = [n] : Df.push(n);
    }
    function vv(n) {
      xS = !0, mC(n);
    }
    function wy() {
      xS && bc();
    }
    function bc() {
      if (!hC && Df !== null) {
        hC = !0;
        var n = 0,
          a = zr();
        try {
          var f = !0,
            m = Df;
          for (sa(Ii); n < m.length; n++) {
            var b = m[n];
            do b = b(f); while (b !== null);
          }
          Df = null, xS = !1;
        } catch (T) {
          throw Df !== null && (Df = Df.slice(n + 1)), Ch(Xu, bc), T;
        } finally {
          sa(a), hC = !1;
        }
      }
      return null;
    }
    var um = [],
      cm = 0,
      tu = null,
      nu = 0,
      pl = [],
      Co = 0,
      ru = null,
      dm = 1,
      fm = "";
    function SP(n) {
      return hl(), (n.flags & va) !== pt;
    }
    function _y(n) {
      return hl(), nu;
    }
    function _D() {
      var n = fm,
        a = dm,
        f = a & ~EP(a);
      return f.toString(32) + n;
    }
    function pm(n, a) {
      hl(), um[cm++] = nu, um[cm++] = tu, tu = n, nu = a;
    }
    function f_(n, a, f) {
      hl(), pl[Co++] = dm, pl[Co++] = fm, pl[Co++] = ru, ru = n;
      var m = dm,
        b = fm,
        T = Yb(m) - 1,
        M = m & ~(1 << T),
        z = f + 1,
        U = Yb(a) + T;
      if (U > 30) {
        var X = T - T % 5,
          J = (1 << X) - 1,
          me = (M & J).toString(32),
          xe = M >> X,
          Ie = T - X,
          Pe = Yb(a) + Ie,
          $e = z << Ie,
          mt = $e | xe,
          Te = me + b;
        dm = 1 << Pe | mt, fm = Te;
      } else {
        var Ue = z << T,
          Ve = Ue | M,
          nt = b;
        dm = 1 << U | Ve, fm = nt;
      }
    }
    function vC(n) {
      hl();
      var a = n.return;
      if (a !== null) {
        var f = 1,
          m = 0;
        pm(n, f), f_(n, f, m);
      }
    }
    function Yb(n) {
      return 32 - Mn(n);
    }
    function EP(n) {
      return 1 << Yb(n) - 1;
    }
    function gC(n) {
      for (; n === tu;) tu = um[--cm], um[cm] = null, nu = um[--cm], um[cm] = null;
      for (; n === ru;) ru = pl[--Co], pl[Co] = null, fm = pl[--Co], pl[Co] = null, dm = pl[--Co], pl[Co] = null;
    }
    function xy() {
      return hl(), ru !== null ? {
        id: dm,
        overflow: fm
      } : null;
    }
    function es(n, a) {
      hl(), pl[Co++] = dm, pl[Co++] = fm, pl[Co++] = ru, dm = a.id, fm = a.overflow, ru = n;
    }
    function hl() {
      ts() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Ai = null,
      ml = null,
      vl = !1,
      Sy = !1,
      hm = null;
    function CP() {
      vl && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function xD() {
      Sy = !0;
    }
    function kP() {
      return Sy;
    }
    function SD(n) {
      var a = n.stateNode.containerInfo;
      return ml = rP(a), Ai = n, vl = !0, hm = null, Sy = !1, !0;
    }
    function ED(n, a, f) {
      return ml = iP(a), Ai = n, vl = !0, hm = null, Sy = !1, f !== null && es(n, f), !0;
    }
    function SS(n, a) {
      switch (n.tag) {
        case C:
          {
            pP(n.stateNode.containerInfo, a);
            break;
          }
        case D:
          {
            var f = (n.mode & Wt) !== dt;
            mP(n.type, n.memoizedProps, n.stateNode, a,
            // TODO: Delete this argument when we remove the legacy root API.
            f);
            break;
          }
        case V:
          {
            var m = n.memoizedState;
            m.dehydrated !== null && hP(m.dehydrated, a);
            break;
          }
      }
    }
    function yC(n, a) {
      SS(n, a);
      var f = UA();
      f.stateNode = a, f.return = n;
      var m = n.deletions;
      m === null ? (n.deletions = [f], n.flags |= _i) : m.push(f);
    }
    function ES(n, a) {
      {
        if (Sy) return;
        switch (n.tag) {
          case C:
            {
              var f = n.stateNode.containerInfo;
              switch (a.tag) {
                case D:
                  var m = a.type;
                  a.pendingProps, vP(f, m);
                  break;
                case I:
                  var b = a.pendingProps;
                  gP(f, b);
                  break;
              }
              break;
            }
          case D:
            {
              var T = n.type,
                M = n.memoizedProps,
                z = n.stateNode;
              switch (a.tag) {
                case D:
                  {
                    var U = a.type,
                      X = a.pendingProps,
                      J = (n.mode & Wt) !== dt;
                    wP(T, M, z, U, X,
                    // TODO: Delete this argument when we remove the legacy root API.
                    J);
                    break;
                  }
                case I:
                  {
                    var me = a.pendingProps,
                      xe = (n.mode & Wt) !== dt;
                    _P(T, M, z, me,
                    // TODO: Delete this argument when we remove the legacy root API.
                    xe);
                    break;
                  }
              }
              break;
            }
          case V:
            {
              var Ie = n.memoizedState,
                Pe = Ie.dehydrated;
              if (Pe !== null) switch (a.tag) {
                case D:
                  var $e = a.type;
                  a.pendingProps, yP(Pe, $e);
                  break;
                case I:
                  var mt = a.pendingProps;
                  bP(Pe, mt);
                  break;
              }
              break;
            }
          default:
            return;
        }
      }
    }
    function CS(n, a) {
      a.flags = a.flags & -4097 | Gn, ES(n, a);
    }
    function kS(n, a) {
      switch (n.tag) {
        case D:
          {
            var f = n.type;
            n.pendingProps;
            var m = tP(a, f);
            return m !== null ? (n.stateNode = m, Ai = n, ml = nP(m), !0) : !1;
          }
        case I:
          {
            var b = n.pendingProps,
              T = vD(a, b);
            return T !== null ? (n.stateNode = T, Ai = n, ml = null, !0) : !1;
          }
        case V:
          {
            var M = cC(a);
            if (M !== null) {
              var z = {
                dehydrated: M,
                treeContext: xy(),
                retryLane: Jr
              };
              n.memoizedState = z;
              var U = NI(M);
              return U.return = n, n.child = U, Ai = n, ml = null, !0;
            }
            return !1;
          }
        default:
          return !1;
      }
    }
    function p_(n) {
      return (n.mode & Wt) !== dt && (n.flags & ft) === pt;
    }
    function bC(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function wC(n) {
      if (vl) {
        var a = ml;
        if (!a) {
          p_(n) && (ES(Ai, n), bC()), CS(Ai, n), vl = !1, Ai = n;
          return;
        }
        var f = a;
        if (!kS(n, a)) {
          p_(n) && (ES(Ai, n), bC()), a = i_(f);
          var m = Ai;
          if (!a || !kS(n, a)) {
            CS(Ai, n), vl = !1, Ai = n;
            return;
          }
          yC(m, f);
        }
      }
    }
    function TP(n, a, f) {
      var m = n.stateNode,
        b = !Sy,
        T = aP(m, n.type, n.memoizedProps, a, f, n, b);
      return n.updateQueue = T, T !== null;
    }
    function RP(n) {
      var a = n.stateNode,
        f = n.memoizedProps,
        m = oP(a, f, n);
      if (m) {
        var b = Ai;
        if (b !== null) switch (b.tag) {
          case C:
            {
              var T = b.stateNode.containerInfo,
                M = (b.mode & Wt) !== dt;
              dP(T, a, f,
              // TODO: Delete this argument when we remove the legacy root API.
              M);
              break;
            }
          case D:
            {
              var z = b.type,
                U = b.memoizedProps,
                X = b.stateNode,
                J = (b.mode & Wt) !== dt;
              fP(z, U, X, a, f,
              // TODO: Delete this argument when we remove the legacy root API.
              J);
              break;
            }
        }
      }
      return m;
    }
    function CD(n) {
      var a = n.memoizedState,
        f = a !== null ? a.dehydrated : null;
      if (!f) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      yD(f, n);
    }
    function TS(n) {
      var a = n.memoizedState,
        f = a !== null ? a.dehydrated : null;
      if (!f) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return lP(f);
    }
    function kD(n) {
      for (var a = n.return; a !== null && a.tag !== D && a.tag !== C && a.tag !== V;) a = a.return;
      Ai = a;
    }
    function h_(n) {
      if (n !== Ai) return !1;
      if (!vl) return kD(n), vl = !0, !1;
      if (n.tag !== C && (n.tag !== D || cP(n.type) && !aC(n.type, n.memoizedProps))) {
        var a = ml;
        if (a) if (p_(n)) _C(n), bC();else for (; a;) yC(n, a), a = i_(a);
      }
      return kD(n), n.tag === V ? ml = TS(n) : ml = Ai ? i_(n.stateNode) : null, !0;
    }
    function Gb() {
      return vl && ml !== null;
    }
    function _C(n) {
      for (var a = ml; a;) SS(n, a), a = i_(a);
    }
    function Pa() {
      Ai = null, ml = null, vl = !1, Sy = !1;
    }
    function RS() {
      hm !== null && (Rk(hm), hm = null);
    }
    function ts() {
      return vl;
    }
    function xC(n) {
      hm === null ? hm = [n] : hm.push(n);
    }
    var DP = i.ReactCurrentBatchConfig,
      If = null;
    function IP() {
      return DP.transition;
    }
    var ns = {
      recordUnsafeLifecycleWarnings: function (n, a) {},
      flushPendingUnsafeLifecycleWarnings: function () {},
      recordLegacyContextWarning: function (n, a) {},
      flushLegacyContextWarning: function () {},
      discardPendingWarnings: function () {}
    };
    {
      var m_ = function (n) {
          for (var a = null, f = n; f !== null;) f.mode & Xn && (a = f), f = f.return;
          return a;
        },
        Mf = function (n) {
          var a = [];
          return n.forEach(function (f) {
            a.push(f);
          }), a.sort().join(", ");
        },
        mm = [],
        vm = [],
        gm = [],
        ym = [],
        Lf = [],
        gv = [],
        yv = /* @__PURE__ */new Set();
      ns.recordUnsafeLifecycleWarnings = function (n, a) {
        yv.has(n.type) || (typeof a.componentWillMount == "function" &&
        // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && mm.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillMount == "function" && vm.push(n), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && gm.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillReceiveProps == "function" && ym.push(n), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && Lf.push(n), n.mode & Xn && typeof a.UNSAFE_componentWillUpdate == "function" && gv.push(n));
      }, ns.flushPendingUnsafeLifecycleWarnings = function () {
        var n = /* @__PURE__ */new Set();
        mm.length > 0 && (mm.forEach(function (xe) {
          n.add(At(xe) || "Component"), yv.add(xe.type);
        }), mm = []);
        var a = /* @__PURE__ */new Set();
        vm.length > 0 && (vm.forEach(function (xe) {
          a.add(At(xe) || "Component"), yv.add(xe.type);
        }), vm = []);
        var f = /* @__PURE__ */new Set();
        gm.length > 0 && (gm.forEach(function (xe) {
          f.add(At(xe) || "Component"), yv.add(xe.type);
        }), gm = []);
        var m = /* @__PURE__ */new Set();
        ym.length > 0 && (ym.forEach(function (xe) {
          m.add(At(xe) || "Component"), yv.add(xe.type);
        }), ym = []);
        var b = /* @__PURE__ */new Set();
        Lf.length > 0 && (Lf.forEach(function (xe) {
          b.add(At(xe) || "Component"), yv.add(xe.type);
        }), Lf = []);
        var T = /* @__PURE__ */new Set();
        if (gv.length > 0 && (gv.forEach(function (xe) {
          T.add(At(xe) || "Component"), yv.add(xe.type);
        }), gv = []), a.size > 0) {
          var M = Mf(a);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, M);
        }
        if (m.size > 0) {
          var z = Mf(m);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, z);
        }
        if (T.size > 0) {
          var U = Mf(T);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, U);
        }
        if (n.size > 0) {
          var X = Mf(n);
          p(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, X);
        }
        if (f.size > 0) {
          var J = Mf(f);
          p(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, J);
        }
        if (b.size > 0) {
          var me = Mf(b);
          p(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, me);
        }
      };
      var mu = /* @__PURE__ */new Map(),
        DS = /* @__PURE__ */new Set();
      ns.recordLegacyContextWarning = function (n, a) {
        var f = m_(n);
        if (f === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!DS.has(n.type)) {
          var m = mu.get(f);
          (n.type.contextTypes != null || n.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (m === void 0 && (m = [], mu.set(f, m)), m.push(n));
        }
      }, ns.flushLegacyContextWarning = function () {
        mu.forEach(function (n, a) {
          if (n.length !== 0) {
            var f = n[0],
              m = /* @__PURE__ */new Set();
            n.forEach(function (T) {
              m.add(At(T) || "Component"), DS.add(T.type);
            });
            var b = Mf(m);
            try {
              Rn(f), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b);
            } finally {
              Un();
            }
          }
        });
      }, ns.discardPendingWarnings = function () {
        mm = [], vm = [], gm = [], ym = [], Lf = [], gv = [], mu = /* @__PURE__ */new Map();
      };
    }
    function wc(n, a) {
      if (n && n.defaultProps) {
        var f = Qt({}, a),
          m = n.defaultProps;
        for (var b in m) f[b] === void 0 && (f[b] = m[b]);
        return f;
      }
      return a;
    }
    var Xb = ka(null),
      bv;
    bv = {};
    var Kb = null,
      bm = null,
      Qb = null,
      v_ = !1;
    function g_() {
      Kb = null, bm = null, Qb = null, v_ = !1;
    }
    function SC() {
      v_ = !0;
    }
    function IS() {
      v_ = !1;
    }
    function MS(n, a, f) {
      fi(Xb, a._currentValue, n), a._currentValue = f, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== bv && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = bv;
    }
    function EC(n, a) {
      var f = Xb.current;
      fl(Xb, a), n._currentValue = f;
    }
    function CC(n, a, f) {
      for (var m = n; m !== null;) {
        var b = m.alternate;
        if ($l(m.childLanes, a) ? b !== null && !$l(b.childLanes, a) && (b.childLanes = jt(b.childLanes, a)) : (m.childLanes = jt(m.childLanes, a), b !== null && (b.childLanes = jt(b.childLanes, a))), m === f) break;
        m = m.return;
      }
      m !== f && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Zb(n, a, f) {
      ko(n, a, f);
    }
    function ko(n, a, f) {
      var m = n.child;
      for (m !== null && (m.return = n); m !== null;) {
        var b = void 0,
          T = m.dependencies;
        if (T !== null) {
          b = m.child;
          for (var M = T.firstContext; M !== null;) {
            if (M.context === a) {
              if (m.tag === x) {
                var z = Xs(f),
                  U = Hc(wn, z);
                U.tag = Cy;
                var X = m.updateQueue;
                if (X !== null) {
                  var J = X.shared,
                    me = J.pending;
                  me === null ? U.next = U : (U.next = me.next, me.next = U), J.pending = U;
                }
              }
              m.lanes = jt(m.lanes, f);
              var xe = m.alternate;
              xe !== null && (xe.lanes = jt(xe.lanes, f)), CC(m.return, f, n), T.lanes = jt(T.lanes, f);
              break;
            }
            M = M.next;
          }
        } else if (m.tag === O) b = m.type === n.type ? null : m.child;else if (m.tag === ie) {
          var Ie = m.return;
          if (Ie === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Ie.lanes = jt(Ie.lanes, f);
          var Pe = Ie.alternate;
          Pe !== null && (Pe.lanes = jt(Pe.lanes, f)), CC(Ie, f, n), b = m.sibling;
        } else b = m.child;
        if (b !== null) b.return = m;else for (b = m; b !== null;) {
          if (b === n) {
            b = null;
            break;
          }
          var $e = b.sibling;
          if ($e !== null) {
            $e.return = b.return, b = $e;
            break;
          }
          b = b.return;
        }
        m = b;
      }
    }
    function Uc(n, a) {
      Kb = n, bm = null, Qb = null;
      var f = n.dependencies;
      if (f !== null) {
        var m = f.firstContext;
        m !== null && (_n(f.lanes, a) && Hy(), f.firstContext = null);
      }
    }
    function Aa(n) {
      v_ && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = n._currentValue;
      if (Qb !== n) {
        var f = {
          context: n,
          memoizedValue: a,
          next: null
        };
        if (bm === null) {
          if (Kb === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          bm = f, Kb.dependencies = {
            lanes: Re,
            firstContext: f
          };
        } else bm = bm.next = f;
      }
      return a;
    }
    var Ey = null;
    function LS(n) {
      Ey === null ? Ey = [n] : Ey.push(n);
    }
    function MP() {
      if (Ey !== null) {
        for (var n = 0; n < Ey.length; n++) {
          var a = Ey[n],
            f = a.interleaved;
          if (f !== null) {
            a.interleaved = null;
            var m = f.next,
              b = a.pending;
            if (b !== null) {
              var T = b.next;
              b.next = m, f.next = T;
            }
            a.pending = f;
          }
        }
        Ey = null;
      }
    }
    function TD(n, a, f, m) {
      var b = a.interleaved;
      return b === null ? (f.next = f, LS(a)) : (f.next = b.next, b.next = f), a.interleaved = f, y_(n, m);
    }
    function vu(n, a, f, m) {
      var b = a.interleaved;
      b === null ? (f.next = f, LS(a)) : (f.next = b.next, b.next = f), a.interleaved = f;
    }
    function LP(n, a, f, m) {
      var b = a.interleaved;
      return b === null ? (f.next = f, LS(a)) : (f.next = b.next, b.next = f), a.interleaved = f, y_(n, m);
    }
    function rs(n, a) {
      return y_(n, a);
    }
    var RD = y_;
    function y_(n, a) {
      n.lanes = jt(n.lanes, a);
      var f = n.alternate;
      f !== null && (f.lanes = jt(f.lanes, a)), f === null && (n.flags & (Gn | xi)) !== pt && R1(n);
      for (var m = n, b = n.return; b !== null;) b.childLanes = jt(b.childLanes, a), f = b.alternate, f !== null ? f.childLanes = jt(f.childLanes, a) : (b.flags & (Gn | xi)) !== pt && R1(n), m = b, b = b.return;
      if (m.tag === C) {
        var T = m.stateNode;
        return T;
      } else return null;
    }
    var b_ = 0,
      OS = 1,
      Cy = 2,
      w_ = 3,
      ky = !1,
      __,
      x_;
    __ = !1, x_ = null;
    function Of(n) {
      var a = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Re
        },
        effects: null
      };
      n.updateQueue = a;
    }
    function wm(n, a) {
      var f = a.updateQueue,
        m = n.updateQueue;
      if (f === m) {
        var b = {
          baseState: m.baseState,
          firstBaseUpdate: m.firstBaseUpdate,
          lastBaseUpdate: m.lastBaseUpdate,
          shared: m.shared,
          effects: m.effects
        };
        a.updateQueue = b;
      }
    }
    function Hc(n, a) {
      var f = {
        eventTime: n,
        lane: a,
        tag: b_,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function mp(n, a, f) {
      var m = n.updateQueue;
      if (m === null) return null;
      var b = m.shared;
      if (x_ === b && !__ && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), __ = !0), _I()) {
        var T = b.pending;
        return T === null ? a.next = a : (a.next = T.next, T.next = a), b.pending = a, RD(n, f);
      } else return LP(n, b, a, f);
    }
    function PS(n, a, f) {
      var m = a.updateQueue;
      if (m !== null) {
        var b = m.shared;
        if (zh(f)) {
          var T = b.lanes;
          T = Bh(T, n.pendingLanes);
          var M = jt(T, f);
          b.lanes = M, cf(n, M);
        }
      }
    }
    function Jb(n, a) {
      var f = n.updateQueue,
        m = n.alternate;
      if (m !== null) {
        var b = m.updateQueue;
        if (f === b) {
          var T = null,
            M = null,
            z = f.firstBaseUpdate;
          if (z !== null) {
            var U = z;
            do {
              var X = {
                eventTime: U.eventTime,
                lane: U.lane,
                tag: U.tag,
                payload: U.payload,
                callback: U.callback,
                next: null
              };
              M === null ? T = M = X : (M.next = X, M = X), U = U.next;
            } while (U !== null);
            M === null ? T = M = a : (M.next = a, M = a);
          } else T = M = a;
          f = {
            baseState: b.baseState,
            firstBaseUpdate: T,
            lastBaseUpdate: M,
            shared: b.shared,
            effects: b.effects
          }, n.updateQueue = f;
          return;
        }
      }
      var J = f.lastBaseUpdate;
      J === null ? f.firstBaseUpdate = a : J.next = a, f.lastBaseUpdate = a;
    }
    function OP(n, a, f, m, b, T) {
      switch (f.tag) {
        case OS:
          {
            var M = f.payload;
            if (typeof M == "function") {
              SC();
              var z = M.call(T, m, b);
              {
                if (n.mode & Xn) {
                  En(!0);
                  try {
                    M.call(T, m, b);
                  } finally {
                    En(!1);
                  }
                }
                IS();
              }
              return z;
            }
            return M;
          }
        case w_:
          n.flags = n.flags & -65537 | ft;
        // Intentional fallthrough
        case b_:
          {
            var U = f.payload,
              X;
            if (typeof U == "function") {
              SC(), X = U.call(T, m, b);
              {
                if (n.mode & Xn) {
                  En(!0);
                  try {
                    U.call(T, m, b);
                  } finally {
                    En(!1);
                  }
                }
                IS();
              }
            } else X = U;
            return X == null ? m : Qt({}, m, X);
          }
        case Cy:
          return ky = !0, m;
      }
      return m;
    }
    function S_(n, a, f, m) {
      var b = n.updateQueue;
      ky = !1, x_ = b.shared;
      var T = b.firstBaseUpdate,
        M = b.lastBaseUpdate,
        z = b.shared.pending;
      if (z !== null) {
        b.shared.pending = null;
        var U = z,
          X = U.next;
        U.next = null, M === null ? T = X : M.next = X, M = U;
        var J = n.alternate;
        if (J !== null) {
          var me = J.updateQueue,
            xe = me.lastBaseUpdate;
          xe !== M && (xe === null ? me.firstBaseUpdate = X : xe.next = X, me.lastBaseUpdate = U);
        }
      }
      if (T !== null) {
        var Ie = b.baseState,
          Pe = Re,
          $e = null,
          mt = null,
          Te = null,
          Ue = T;
        do {
          var Ve = Ue.lane,
            nt = Ue.eventTime;
          if ($l(m, Ve)) {
            if (Te !== null) {
              var Fe = {
                eventTime: nt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ln,
                tag: Ue.tag,
                payload: Ue.payload,
                callback: Ue.callback,
                next: null
              };
              Te = Te.next = Fe;
            }
            Ie = OP(n, b, Ue, Ie, a, f);
            var De = Ue.callback;
            if (De !== null &&
            // If the update was already committed, we should not queue its
            // callback again.
            Ue.lane !== Ln) {
              n.flags |= Sn;
              var Qe = b.effects;
              Qe === null ? b.effects = [Ue] : Qe.push(Ue);
            }
          } else {
            var ke = {
              eventTime: nt,
              lane: Ve,
              tag: Ue.tag,
              payload: Ue.payload,
              callback: Ue.callback,
              next: null
            };
            Te === null ? (mt = Te = ke, $e = Ie) : Te = Te.next = ke, Pe = jt(Pe, Ve);
          }
          if (Ue = Ue.next, Ue === null) {
            if (z = b.shared.pending, z === null) break;
            var Tt = z,
              _t = Tt.next;
            Tt.next = null, Ue = _t, b.lastBaseUpdate = Tt, b.shared.pending = null;
          }
        } while (!0);
        Te === null && ($e = Ie), b.baseState = $e, b.firstBaseUpdate = mt, b.lastBaseUpdate = Te;
        var an = b.shared.interleaved;
        if (an !== null) {
          var Gt = an;
          do Pe = jt(Pe, Gt.lane), Gt = Gt.next; while (Gt !== an);
        } else T === null && (b.shared.lanes = Re);
        Sx(Pe), n.lanes = Pe, n.memoizedState = Ie;
      }
      x_ = null;
    }
    function AS(n, a) {
      if (typeof n != "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(a);
    }
    function kC() {
      ky = !1;
    }
    function e0() {
      return ky;
    }
    function TC(n, a, f) {
      var m = a.effects;
      if (a.effects = null, m !== null) for (var b = 0; b < m.length; b++) {
        var T = m[b],
          M = T.callback;
        M !== null && (T.callback = null, AS(M, f));
      }
    }
    var E_ = {},
      jS = new t.Component().refs,
      C_,
      k_,
      T_,
      FS,
      t0,
      NS,
      n0,
      R_,
      zS,
      D_;
    {
      C_ = /* @__PURE__ */new Set(), k_ = /* @__PURE__ */new Set(), T_ = /* @__PURE__ */new Set(), FS = /* @__PURE__ */new Set(), R_ = /* @__PURE__ */new Set(), t0 = /* @__PURE__ */new Set(), zS = /* @__PURE__ */new Set(), D_ = /* @__PURE__ */new Set();
      var VS = /* @__PURE__ */new Set();
      n0 = function (n, a) {
        if (!(n === null || typeof n == "function")) {
          var f = a + "_" + n;
          VS.has(f) || (VS.add(f), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n));
        }
      }, NS = function (n, a) {
        if (a === void 0) {
          var f = bn(n) || "Component";
          t0.has(f) || (t0.add(f), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(E_, "_processChildContext", {
        enumerable: !1,
        value: function () {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(E_);
    }
    function BS(n, a, f, m) {
      var b = n.memoizedState,
        T = f(m, b);
      {
        if (n.mode & Xn) {
          En(!0);
          try {
            T = f(m, b);
          } finally {
            En(!1);
          }
        }
        NS(a, T);
      }
      var M = T == null ? b : Qt({}, b, T);
      if (n.memoizedState = M, n.lanes === Re) {
        var z = n.updateQueue;
        z.baseState = M;
      }
    }
    var RC = {
      isMounted: jg,
      enqueueSetState: function (n, a, f) {
        var m = Ps(n),
          b = au(),
          T = jv(m),
          M = Hc(b, T);
        M.payload = a, f != null && (n0(f, "setState"), M.callback = f);
        var z = mp(m, M, T);
        z !== null && (To(z, m, T, b), PS(z, m, T)), Bl(m, T);
      },
      enqueueReplaceState: function (n, a, f) {
        var m = Ps(n),
          b = au(),
          T = jv(m),
          M = Hc(b, T);
        M.tag = OS, M.payload = a, f != null && (n0(f, "replaceState"), M.callback = f);
        var z = mp(m, M, T);
        z !== null && (To(z, m, T, b), PS(z, m, T)), Bl(m, T);
      },
      enqueueForceUpdate: function (n, a) {
        var f = Ps(n),
          m = au(),
          b = jv(f),
          T = Hc(m, b);
        T.tag = Cy, a != null && (n0(a, "forceUpdate"), T.callback = a);
        var M = mp(f, T, b);
        M !== null && (To(M, f, b, m), PS(M, f, b)), Qu(f, b);
      }
    };
    function DC(n, a, f, m, b, T, M) {
      var z = n.stateNode;
      if (typeof z.shouldComponentUpdate == "function") {
        var U = z.shouldComponentUpdate(m, T, M);
        {
          if (n.mode & Xn) {
            En(!0);
            try {
              U = z.shouldComponentUpdate(m, T, M);
            } finally {
              En(!1);
            }
          }
          U === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", bn(a) || "Component");
        }
        return U;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !He(f, m) || !He(b, T) : !0;
    }
    function DD(n, a, f) {
      var m = n.stateNode;
      {
        var b = bn(a) || "Component",
          T = m.render;
        T || (a.prototype && typeof a.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", b) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", b)), m.getInitialState && !m.getInitialState.isReactClassApproved && !m.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", b), m.getDefaultProps && !m.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", b), m.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", b), m.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", b), m.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", b), a.contextType && a.contextTypes && !zS.has(a) && (zS.add(a), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", b)), typeof m.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", b), a.prototype && a.prototype.isPureReactComponent && typeof m.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", bn(a) || "A pure component"), typeof m.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", b), typeof m.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", b), typeof m.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", b), typeof m.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", b);
        var M = m.props !== f;
        m.props !== void 0 && M && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", b, b), m.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", b, b), typeof m.getSnapshotBeforeUpdate == "function" && typeof m.componentDidUpdate != "function" && !T_.has(a) && (T_.add(a), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", bn(a))), typeof m.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof m.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof a.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", b);
        var z = m.state;
        z && (typeof z != "object" || wr(z)) && h("%s.state: must be set to an object or null", b), typeof m.getChildContext == "function" && typeof a.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", b);
      }
    }
    function ID(n, a) {
      a.updater = RC, n.stateNode = a, Fl(a, n), a._reactInternalInstance = E_;
    }
    function IC(n, a, f) {
      var m = !1,
        b = Oa,
        T = Oa,
        M = a.contextType;
      if ("contextType" in a) {
        var z =
        // Allow null for conditional declaration
        M === null || M !== void 0 && M.$$typeof === Ne && M._context === void 0;
        if (!z && !D_.has(a)) {
          D_.add(a);
          var U = "";
          M === void 0 ? U = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof M != "object" ? U = " However, it is set to a " + typeof M + "." : M.$$typeof === Z ? U = " Did you accidentally pass the Context.Provider instead?" : M._context !== void 0 ? U = " Did you accidentally pass the Context.Consumer instead?" : U = " However, it is set to an object with keys {" + Object.keys(M).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", bn(a) || "Component", U);
        }
      }
      if (typeof M == "object" && M !== null) T = Aa(M);else {
        b = Rf(n, a, !0);
        var X = a.contextTypes;
        m = X != null, T = m ? eu(n, b) : Oa;
      }
      var J = new a(f, T);
      if (n.mode & Xn) {
        En(!0);
        try {
          J = new a(f, T);
        } finally {
          En(!1);
        }
      }
      var me = n.memoizedState = J.state !== null && J.state !== void 0 ? J.state : null;
      ID(n, J);
      {
        if (typeof a.getDerivedStateFromProps == "function" && me === null) {
          var xe = bn(a) || "Component";
          k_.has(xe) || (k_.add(xe), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", xe, J.state === null ? "null" : "undefined", xe));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof J.getSnapshotBeforeUpdate == "function") {
          var Ie = null,
            Pe = null,
            $e = null;
          if (typeof J.componentWillMount == "function" && J.componentWillMount.__suppressDeprecationWarning !== !0 ? Ie = "componentWillMount" : typeof J.UNSAFE_componentWillMount == "function" && (Ie = "UNSAFE_componentWillMount"), typeof J.componentWillReceiveProps == "function" && J.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Pe = "componentWillReceiveProps" : typeof J.UNSAFE_componentWillReceiveProps == "function" && (Pe = "UNSAFE_componentWillReceiveProps"), typeof J.componentWillUpdate == "function" && J.componentWillUpdate.__suppressDeprecationWarning !== !0 ? $e = "componentWillUpdate" : typeof J.UNSAFE_componentWillUpdate == "function" && ($e = "UNSAFE_componentWillUpdate"), Ie !== null || Pe !== null || $e !== null) {
            var mt = bn(a) || "Component",
              Te = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            FS.has(mt) || (FS.add(mt), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, mt, Te, Ie !== null ? `
  ` + Ie : "", Pe !== null ? `
  ` + Pe : "", $e !== null ? `
  ` + $e : ""));
          }
        }
      }
      return m && u_(n, b, T), J;
    }
    function MC(n, a) {
      var f = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), f !== a.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", At(n) || "Component"), RC.enqueueReplaceState(a, a.state, null));
    }
    function MD(n, a, f, m) {
      var b = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(f, m), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(f, m), a.state !== b) {
        {
          var T = At(n) || "Component";
          C_.has(T) || (C_.add(T), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", T));
        }
        RC.enqueueReplaceState(a, a.state, null);
      }
    }
    function LC(n, a, f, m) {
      DD(n, a, f);
      var b = n.stateNode;
      b.props = f, b.state = n.memoizedState, b.refs = jS, Of(n);
      var T = a.contextType;
      if (typeof T == "object" && T !== null) b.context = Aa(T);else {
        var M = Rf(n, a, !0);
        b.context = eu(n, M);
      }
      {
        if (b.state === f) {
          var z = bn(a) || "Component";
          R_.has(z) || (R_.add(z), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", z));
        }
        n.mode & Xn && ns.recordLegacyContextWarning(n, b), ns.recordUnsafeLifecycleWarnings(n, b);
      }
      b.state = n.memoizedState;
      var U = a.getDerivedStateFromProps;
      if (typeof U == "function" && (BS(n, a, U, f), b.state = n.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (MC(n, b), S_(n, f, b, m), b.state = n.memoizedState), typeof b.componentDidMount == "function") {
        var X = tn;
        X |= Za, (n.mode & Ri) !== dt && (X |= Bo), n.flags |= X;
      }
    }
    function OC(n, a, f, m) {
      var b = n.stateNode,
        T = n.memoizedProps;
      b.props = T;
      var M = b.context,
        z = a.contextType,
        U = Oa;
      if (typeof z == "object" && z !== null) U = Aa(z);else {
        var X = Rf(n, a, !0);
        U = eu(n, X);
      }
      var J = a.getDerivedStateFromProps,
        me = typeof J == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      !me && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (T !== f || M !== U) && MD(n, b, f, U), kC();
      var xe = n.memoizedState,
        Ie = b.state = xe;
      if (S_(n, f, b, m), Ie = n.memoizedState, T === f && xe === Ie && !by() && !e0()) {
        if (typeof b.componentDidMount == "function") {
          var Pe = tn;
          Pe |= Za, (n.mode & Ri) !== dt && (Pe |= Bo), n.flags |= Pe;
        }
        return !1;
      }
      typeof J == "function" && (BS(n, a, J, f), Ie = n.memoizedState);
      var $e = e0() || DC(n, a, T, f, xe, Ie, U);
      if ($e) {
        if (!me && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount()), typeof b.componentDidMount == "function") {
          var mt = tn;
          mt |= Za, (n.mode & Ri) !== dt && (mt |= Bo), n.flags |= mt;
        }
      } else {
        if (typeof b.componentDidMount == "function") {
          var Te = tn;
          Te |= Za, (n.mode & Ri) !== dt && (Te |= Bo), n.flags |= Te;
        }
        n.memoizedProps = f, n.memoizedState = Ie;
      }
      return b.props = f, b.state = Ie, b.context = U, $e;
    }
    function PC(n, a, f, m, b) {
      var T = a.stateNode;
      wm(n, a);
      var M = a.memoizedProps,
        z = a.type === a.elementType ? M : wc(a.type, M);
      T.props = z;
      var U = a.pendingProps,
        X = T.context,
        J = f.contextType,
        me = Oa;
      if (typeof J == "object" && J !== null) me = Aa(J);else {
        var xe = Rf(a, f, !0);
        me = eu(a, xe);
      }
      var Ie = f.getDerivedStateFromProps,
        Pe = typeof Ie == "function" || typeof T.getSnapshotBeforeUpdate == "function";
      !Pe && (typeof T.UNSAFE_componentWillReceiveProps == "function" || typeof T.componentWillReceiveProps == "function") && (M !== U || X !== me) && MD(a, T, m, me), kC();
      var $e = a.memoizedState,
        mt = T.state = $e;
      if (S_(a, m, T, b), mt = a.memoizedState, M === U && $e === mt && !by() && !e0()) return typeof T.componentDidUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= or), !1;
      typeof Ie == "function" && (BS(a, f, Ie, m), mt = a.memoizedState);
      var Te = e0() || DC(a, f, z, m, $e, mt, me) ||
      // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      de;
      return Te ? (!Pe && (typeof T.UNSAFE_componentWillUpdate == "function" || typeof T.componentWillUpdate == "function") && (typeof T.componentWillUpdate == "function" && T.componentWillUpdate(m, mt, me), typeof T.UNSAFE_componentWillUpdate == "function" && T.UNSAFE_componentWillUpdate(m, mt, me)), typeof T.componentDidUpdate == "function" && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (a.flags |= or)) : (typeof T.componentDidUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= tn), typeof T.getSnapshotBeforeUpdate == "function" && (M !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= or), a.memoizedProps = m, a.memoizedState = mt), T.props = m, T.state = mt, T.context = me, Te;
    }
    var I_,
      M_,
      L_,
      US,
      Ty,
      O_ = function (n, a) {};
    I_ = !1, M_ = !1, L_ = {}, US = {}, Ty = {}, O_ = function (n, a) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var f = At(a) || "Component";
        US[f] || (US[f] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function wv(n, a, f) {
      var m = f.ref;
      if (m !== null && typeof m != "function" && typeof m != "object") {
        if ((n.mode & Xn || ue) &&
        // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var b = At(n) || "Component";
          L_[b] || (h('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', m), L_[b] = !0);
        }
        if (f._owner) {
          var T = f._owner,
            M;
          if (T) {
            var z = T;
            if (z.tag !== x) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            M = z.stateNode;
          }
          if (!M) throw new Error("Missing owner for string ref " + m + ". This error is likely caused by a bug in React. Please file an issue.");
          var U = M;
          gt(m, "ref");
          var X = "" + m;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === X) return a.ref;
          var J = function (me) {
            var xe = U.refs;
            xe === jS && (xe = U.refs = {}), me === null ? delete xe[X] : xe[X] = me;
          };
          return J._stringRef = X, J;
        } else {
          if (typeof m != "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner) throw new Error("Element ref was specified as a string (" + m + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return m;
    }
    function P_(n, a) {
      var f = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function A_(n) {
      {
        var a = At(n) || "Component";
        if (Ty[a]) return;
        Ty[a] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Ry(n) {
      var a = n._payload,
        f = n._init;
      return f(a);
    }
    function AC(n) {
      function a(ke, Fe) {
        if (n) {
          var De = ke.deletions;
          De === null ? (ke.deletions = [Fe], ke.flags |= _i) : De.push(Fe);
        }
      }
      function f(ke, Fe) {
        if (!n) return null;
        for (var De = Fe; De !== null;) a(ke, De), De = De.sibling;
        return null;
      }
      function m(ke, Fe) {
        for (var De = /* @__PURE__ */new Map(), Qe = Fe; Qe !== null;) Qe.key !== null ? De.set(Qe.key, Qe) : De.set(Qe.index, Qe), Qe = Qe.sibling;
        return De;
      }
      function b(ke, Fe) {
        var De = Lm(ke, Fe);
        return De.index = 0, De.sibling = null, De;
      }
      function T(ke, Fe, De) {
        if (ke.index = De, !n) return ke.flags |= va, Fe;
        var Qe = ke.alternate;
        if (Qe !== null) {
          var Tt = Qe.index;
          return Tt < Fe ? (ke.flags |= Gn, Fe) : Tt;
        } else return ke.flags |= Gn, Fe;
      }
      function M(ke) {
        return n && ke.alternate === null && (ke.flags |= Gn), ke;
      }
      function z(ke, Fe, De, Qe) {
        if (Fe === null || Fe.tag !== I) {
          var Tt = L1(De, ke.mode, Qe);
          return Tt.return = ke, Tt;
        } else {
          var _t = b(Fe, De);
          return _t.return = ke, _t;
        }
      }
      function U(ke, Fe, De, Qe) {
        var Tt = De.type;
        if (Tt === Lo) return J(ke, Fe, De.props.children, Qe, De.key);
        if (Fe !== null && (Fe.elementType === Tt ||
        // Keep this check inline so it only runs on the false path:
        I1(Fe, De) ||
        // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Tt == "object" && Tt !== null && Tt.$$typeof === Ct && Ry(Tt) === Fe.type)) {
          var _t = b(Fe, De.props);
          return _t.ref = wv(ke, Fe, De), _t.return = ke, _t._debugSource = De._source, _t._debugOwner = De._owner, _t;
        }
        var an = Wk(De, ke.mode, Qe);
        return an.ref = wv(ke, Fe, De), an.return = ke, an;
      }
      function X(ke, Fe, De, Qe) {
        if (Fe === null || Fe.tag !== k || Fe.stateNode.containerInfo !== De.containerInfo || Fe.stateNode.implementation !== De.implementation) {
          var Tt = Dx(De, ke.mode, Qe);
          return Tt.return = ke, Tt;
        } else {
          var _t = b(Fe, De.children || []);
          return _t.return = ke, _t;
        }
      }
      function J(ke, Fe, De, Qe, Tt) {
        if (Fe === null || Fe.tag !== L) {
          var _t = Om(De, ke.mode, Qe, Tt);
          return _t.return = ke, _t;
        } else {
          var an = b(Fe, De);
          return an.return = ke, an;
        }
      }
      function me(ke, Fe, De) {
        if (typeof Fe == "string" && Fe !== "" || typeof Fe == "number") {
          var Qe = L1("" + Fe, ke.mode, De);
          return Qe.return = ke, Qe;
        }
        if (typeof Fe == "object" && Fe !== null) {
          switch (Fe.$$typeof) {
            case $i:
              {
                var Tt = Wk(Fe, ke.mode, De);
                return Tt.ref = wv(ke, null, Fe), Tt.return = ke, Tt;
              }
            case oi:
              {
                var _t = Dx(Fe, ke.mode, De);
                return _t.return = ke, _t;
              }
            case Ct:
              {
                var an = Fe._payload,
                  Gt = Fe._init;
                return me(ke, Gt(an), De);
              }
          }
          if (wr(Fe) || yn(Fe)) {
            var Pn = Om(Fe, ke.mode, De, null);
            return Pn.return = ke, Pn;
          }
          P_(ke, Fe);
        }
        return typeof Fe == "function" && A_(ke), null;
      }
      function xe(ke, Fe, De, Qe) {
        var Tt = Fe !== null ? Fe.key : null;
        if (typeof De == "string" && De !== "" || typeof De == "number") return Tt !== null ? null : z(ke, Fe, "" + De, Qe);
        if (typeof De == "object" && De !== null) {
          switch (De.$$typeof) {
            case $i:
              return De.key === Tt ? U(ke, Fe, De, Qe) : null;
            case oi:
              return De.key === Tt ? X(ke, Fe, De, Qe) : null;
            case Ct:
              {
                var _t = De._payload,
                  an = De._init;
                return xe(ke, Fe, an(_t), Qe);
              }
          }
          if (wr(De) || yn(De)) return Tt !== null ? null : J(ke, Fe, De, Qe, null);
          P_(ke, De);
        }
        return typeof De == "function" && A_(ke), null;
      }
      function Ie(ke, Fe, De, Qe, Tt) {
        if (typeof Qe == "string" && Qe !== "" || typeof Qe == "number") {
          var _t = ke.get(De) || null;
          return z(Fe, _t, "" + Qe, Tt);
        }
        if (typeof Qe == "object" && Qe !== null) {
          switch (Qe.$$typeof) {
            case $i:
              {
                var an = ke.get(Qe.key === null ? De : Qe.key) || null;
                return U(Fe, an, Qe, Tt);
              }
            case oi:
              {
                var Gt = ke.get(Qe.key === null ? De : Qe.key) || null;
                return X(Fe, Gt, Qe, Tt);
              }
            case Ct:
              var Pn = Qe._payload,
                Fn = Qe._init;
              return Ie(ke, Fe, De, Fn(Pn), Tt);
          }
          if (wr(Qe) || yn(Qe)) {
            var kr = ke.get(De) || null;
            return J(Fe, kr, Qe, Tt, null);
          }
          P_(Fe, Qe);
        }
        return typeof Qe == "function" && A_(Fe), null;
      }
      function Pe(ke, Fe, De) {
        {
          if (typeof ke != "object" || ke === null) return Fe;
          switch (ke.$$typeof) {
            case $i:
            case oi:
              O_(ke, De);
              var Qe = ke.key;
              if (typeof Qe != "string") break;
              if (Fe === null) {
                Fe = /* @__PURE__ */new Set(), Fe.add(Qe);
                break;
              }
              if (!Fe.has(Qe)) {
                Fe.add(Qe);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Qe);
              break;
            case Ct:
              var Tt = ke._payload,
                _t = ke._init;
              Pe(_t(Tt), Fe, De);
              break;
          }
        }
        return Fe;
      }
      function $e(ke, Fe, De, Qe) {
        for (var Tt = null, _t = 0; _t < De.length; _t++) {
          var an = De[_t];
          Tt = Pe(an, Tt, ke);
        }
        for (var Gt = null, Pn = null, Fn = Fe, kr = 0, qn = 0, Tr = null; Fn !== null && qn < De.length; qn++) {
          Fn.index > qn ? (Tr = Fn, Fn = null) : Tr = Fn.sibling;
          var ai = xe(ke, Fn, De[qn], Qe);
          if (ai === null) {
            Fn === null && (Fn = Tr);
            break;
          }
          n && Fn && ai.alternate === null && a(ke, Fn), kr = T(ai, kr, qn), Pn === null ? Gt = ai : Pn.sibling = ai, Pn = ai, Fn = Tr;
        }
        if (qn === De.length) {
          if (f(ke, Fn), ts()) {
            var Br = qn;
            pm(ke, Br);
          }
          return Gt;
        }
        if (Fn === null) {
          for (; qn < De.length; qn++) {
            var ho = me(ke, De[qn], Qe);
            ho !== null && (kr = T(ho, kr, qn), Pn === null ? Gt = ho : Pn.sibling = ho, Pn = ho);
          }
          if (ts()) {
            var Ro = qn;
            pm(ke, Ro);
          }
          return Gt;
        }
        for (var nl = m(ke, Fn); qn < De.length; qn++) {
          var ta = Ie(nl, ke, qn, De[qn], Qe);
          ta !== null && (n && ta.alternate !== null && nl.delete(ta.key === null ? qn : ta.key), kr = T(ta, kr, qn), Pn === null ? Gt = ta : Pn.sibling = ta, Pn = ta);
        }
        if (n && nl.forEach(function (z0) {
          return a(ke, z0);
        }), ts()) {
          var Pm = qn;
          pm(ke, Pm);
        }
        return Gt;
      }
      function mt(ke, Fe, De, Qe) {
        var Tt = yn(De);
        if (typeof Tt != "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" &&
          // $FlowFixMe Flow doesn't know about toStringTag
          De[Symbol.toStringTag] === "Generator" && (M_ || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), M_ = !0), De.entries === Tt && (I_ || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), I_ = !0);
          var _t = Tt.call(De);
          if (_t) for (var an = null, Gt = _t.next(); !Gt.done; Gt = _t.next()) {
            var Pn = Gt.value;
            an = Pe(Pn, an, ke);
          }
        }
        var Fn = Tt.call(De);
        if (Fn == null) throw new Error("An iterable object provided no iterator.");
        for (var kr = null, qn = null, Tr = Fe, ai = 0, Br = 0, ho = null, Ro = Fn.next(); Tr !== null && !Ro.done; Br++, Ro = Fn.next()) {
          Tr.index > Br ? (ho = Tr, Tr = null) : ho = Tr.sibling;
          var nl = xe(ke, Tr, Ro.value, Qe);
          if (nl === null) {
            Tr === null && (Tr = ho);
            break;
          }
          n && Tr && nl.alternate === null && a(ke, Tr), ai = T(nl, ai, Br), qn === null ? kr = nl : qn.sibling = nl, qn = nl, Tr = ho;
        }
        if (Ro.done) {
          if (f(ke, Tr), ts()) {
            var ta = Br;
            pm(ke, ta);
          }
          return kr;
        }
        if (Tr === null) {
          for (; !Ro.done; Br++, Ro = Fn.next()) {
            var Pm = me(ke, Ro.value, Qe);
            Pm !== null && (ai = T(Pm, ai, Br), qn === null ? kr = Pm : qn.sibling = Pm, qn = Pm);
          }
          if (ts()) {
            var z0 = Br;
            pm(ke, z0);
          }
          return kr;
        }
        for (var mT = m(ke, Tr); !Ro.done; Br++, Ro = Fn.next()) {
          var Bv = Ie(mT, ke, Br, Ro.value, Qe);
          Bv !== null && (n && Bv.alternate !== null && mT.delete(Bv.key === null ? Br : Bv.key), ai = T(Bv, ai, Br), qn === null ? kr = Bv : qn.sibling = Bv, qn = Bv);
        }
        if (n && mT.forEach(function (IW) {
          return a(ke, IW);
        }), ts()) {
          var DW = Br;
          pm(ke, DW);
        }
        return kr;
      }
      function Te(ke, Fe, De, Qe) {
        if (Fe !== null && Fe.tag === I) {
          f(ke, Fe.sibling);
          var Tt = b(Fe, De);
          return Tt.return = ke, Tt;
        }
        f(ke, Fe);
        var _t = L1(De, ke.mode, Qe);
        return _t.return = ke, _t;
      }
      function Ue(ke, Fe, De, Qe) {
        for (var Tt = De.key, _t = Fe; _t !== null;) {
          if (_t.key === Tt) {
            var an = De.type;
            if (an === Lo) {
              if (_t.tag === L) {
                f(ke, _t.sibling);
                var Gt = b(_t, De.props.children);
                return Gt.return = ke, Gt._debugSource = De._source, Gt._debugOwner = De._owner, Gt;
              }
            } else if (_t.elementType === an ||
            // Keep this check inline so it only runs on the false path:
            I1(_t, De) ||
            // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof an == "object" && an !== null && an.$$typeof === Ct && Ry(an) === _t.type) {
              f(ke, _t.sibling);
              var Pn = b(_t, De.props);
              return Pn.ref = wv(ke, _t, De), Pn.return = ke, Pn._debugSource = De._source, Pn._debugOwner = De._owner, Pn;
            }
            f(ke, _t);
            break;
          } else a(ke, _t);
          _t = _t.sibling;
        }
        if (De.type === Lo) {
          var Fn = Om(De.props.children, ke.mode, Qe, De.key);
          return Fn.return = ke, Fn;
        } else {
          var kr = Wk(De, ke.mode, Qe);
          return kr.ref = wv(ke, Fe, De), kr.return = ke, kr;
        }
      }
      function Ve(ke, Fe, De, Qe) {
        for (var Tt = De.key, _t = Fe; _t !== null;) {
          if (_t.key === Tt) {
            if (_t.tag === k && _t.stateNode.containerInfo === De.containerInfo && _t.stateNode.implementation === De.implementation) {
              f(ke, _t.sibling);
              var an = b(_t, De.children || []);
              return an.return = ke, an;
            } else {
              f(ke, _t);
              break;
            }
          } else a(ke, _t);
          _t = _t.sibling;
        }
        var Gt = Dx(De, ke.mode, Qe);
        return Gt.return = ke, Gt;
      }
      function nt(ke, Fe, De, Qe) {
        var Tt = typeof De == "object" && De !== null && De.type === Lo && De.key === null;
        if (Tt && (De = De.props.children), typeof De == "object" && De !== null) {
          switch (De.$$typeof) {
            case $i:
              return M(Ue(ke, Fe, De, Qe));
            case oi:
              return M(Ve(ke, Fe, De, Qe));
            case Ct:
              var _t = De._payload,
                an = De._init;
              return nt(ke, Fe, an(_t), Qe);
          }
          if (wr(De)) return $e(ke, Fe, De, Qe);
          if (yn(De)) return mt(ke, Fe, De, Qe);
          P_(ke, De);
        }
        return typeof De == "string" && De !== "" || typeof De == "number" ? M(Te(ke, Fe, "" + De, Qe)) : (typeof De == "function" && A_(ke), f(ke, Fe));
      }
      return nt;
    }
    var r0 = AC(!0),
      LD = AC(!1);
    function j_(n, a) {
      if (n !== null && a.child !== n.child) throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var f = a.child,
          m = Lm(f, f.pendingProps);
        for (a.child = m, m.return = a; f.sibling !== null;) f = f.sibling, m = m.sibling = Lm(f, f.pendingProps), m.return = a;
        m.sibling = null;
      }
    }
    function _v(n, a) {
      for (var f = n.child; f !== null;) zv(f, a), f = f.sibling;
    }
    var _m = {},
      Pf = ka(_m),
      xv = ka(_m),
      F_ = ka(_m);
    function i0(n) {
      if (n === _m) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function Dy() {
      var n = i0(F_.current);
      return n;
    }
    function N_(n, a) {
      fi(F_, a, n), fi(xv, n, n), fi(Pf, _m, n);
      var f = LO(a);
      fl(Pf, n), fi(Pf, f, n);
    }
    function Iy(n) {
      fl(Pf, n), fl(xv, n), fl(F_, n);
    }
    function z_() {
      var n = i0(Pf.current);
      return n;
    }
    function OD(n) {
      i0(F_.current);
      var a = i0(Pf.current),
        f = OO(a, n.type);
      a !== f && (fi(xv, n, n), fi(Pf, f, n));
    }
    function HS(n) {
      xv.current === n && (fl(Pf, n), fl(xv, n));
    }
    var PD = 0,
      a0 = 1,
      $c = 1,
      My = 2,
      ps = ka(PD);
    function V_(n, a) {
      return (n & a) !== 0;
    }
    function o0(n) {
      return n & a0;
    }
    function vp(n, a) {
      return n & a0 | a;
    }
    function l0(n, a) {
      return n | a;
    }
    function Sv(n, a) {
      fi(ps, a, n);
    }
    function xm(n) {
      fl(ps, n);
    }
    function gu(n, a) {
      var f = n.memoizedState;
      return f !== null ? f.dehydrated !== null : (n.memoizedProps, !0);
    }
    function ja(n) {
      for (var a = n; a !== null;) {
        if (a.tag === V) {
          var f = a.memoizedState;
          if (f !== null) {
            var m = f.dehydrated;
            if (m === null || gD(m) || dC(m)) return a;
          }
        } else if (a.tag === Y &&
        // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var b = (a.flags & ft) !== pt;
          if (b) return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === n) return null;
        for (; a.sibling === null;) {
          if (a.return === null || a.return === n) return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var Ta = /*   */
      0,
      Er = /* */
      1,
      Ui = /*  */
      2,
      so = /*    */
      4,
      Qo = /*   */
      8,
      jC = [];
    function Zt() {
      for (var n = 0; n < jC.length; n++) {
        var a = jC[n];
        a._workInProgressVersionPrimary = null;
      }
      jC.length = 0;
    }
    function B_(n, a) {
      var f = a._getVersion,
        m = f(a._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [a, m] : n.mutableSourceEagerHydrationData.push(a, m);
    }
    var Jt = i.ReactCurrentDispatcher,
      gp = i.ReactCurrentBatchConfig,
      Sm,
      Lr;
    Sm = /* @__PURE__ */new Set();
    var ea = Re,
      zn = null,
      Fa = null,
      Ra = null,
      Ev = !1,
      U_ = !1,
      H_ = 0,
      ct = 0,
      Wc = 25,
      st = null,
      yu = null,
      vr = -1,
      Ut = !1;
    function Cr() {
      {
        var n = st;
        yu === null ? yu = [n] : yu.push(n);
      }
    }
    function Yt() {
      {
        var n = st;
        yu !== null && (vr++, yu[vr] !== n && FC(n));
      }
    }
    function uo(n) {
      n != null && !wr(n) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", st, typeof n);
    }
    function FC(n) {
      {
        var a = At(zn);
        if (!Sm.has(a) && (Sm.add(a), yu !== null)) {
          for (var f = "", m = 30, b = 0; b <= vr; b++) {
            for (var T = yu[b], M = b === vr ? n : T, z = b + 1 + ". " + T; z.length < m;) z += " ";
            z += M + `
`, f += z;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, f);
        }
      }
    }
    function co() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Cv(n, a) {
      if (Ut) return !1;
      if (a === null) return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", st), !1;
      n.length !== a.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, st, "[" + a.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var f = 0; f < a.length && f < n.length; f++) if (!he(n[f], a[f])) return !1;
      return !0;
    }
    function Ly(n, a, f, m, b, T) {
      ea = T, zn = a, yu = n !== null ? n._debugHookTypes : null, vr = -1, Ut = n !== null && n.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = Re, n !== null && n.memoizedState !== null ? Jt.current = ix : yu !== null ? Jt.current = qc : Jt.current = Ff;
      var M = f(m, b);
      if (U_) {
        var z = 0;
        do {
          if (U_ = !1, H_ = 0, z >= Wc) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          z += 1, Ut = !1, Fa = null, Ra = null, a.updateQueue = null, vr = -1, Jt.current = e1, M = f(m, b);
        } while (U_);
      }
      Jt.current = rx, a._debugHookTypes = yu;
      var U = Fa !== null && Fa.next !== null;
      if (ea = Re, zn = null, Fa = null, Ra = null, st = null, yu = null, vr = -1, n !== null && (n.flags & nr) !== (a.flags & nr) &&
      // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & Wt) !== dt && h("Internal React error: Expected static flag was missing. Please notify the React team."), Ev = !1, U) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return M;
    }
    function Oy() {
      var n = H_ !== 0;
      return H_ = 0, n;
    }
    function Af(n, a, f) {
      a.updateQueue = n.updateQueue, (a.mode & Ri) !== dt ? a.flags &= -50333701 : a.flags &= -2053, n.lanes = ac(n.lanes, f);
    }
    function _c() {
      if (Jt.current = rx, Ev) {
        for (var n = zn.memoizedState; n !== null;) {
          var a = n.queue;
          a !== null && (a.pending = null), n = n.next;
        }
        Ev = !1;
      }
      ea = Re, zn = null, Fa = null, Ra = null, yu = null, vr = -1, st = null, jD = !1, U_ = !1, H_ = 0;
    }
    function jf() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ra === null ? zn.memoizedState = Ra = n : Ra = Ra.next = n, Ra;
    }
    function bu() {
      var n;
      if (Fa === null) {
        var a = zn.alternate;
        a !== null ? n = a.memoizedState : n = null;
      } else n = Fa.next;
      var f;
      if (Ra === null ? f = zn.memoizedState : f = Ra.next, f !== null) Ra = f, f = Ra.next, Fa = n;else {
        if (n === null) throw new Error("Rendered more hooks than during the previous render.");
        Fa = n;
        var m = {
          memoizedState: Fa.memoizedState,
          baseState: Fa.baseState,
          baseQueue: Fa.baseQueue,
          queue: Fa.queue,
          next: null
        };
        Ra === null ? zn.memoizedState = Ra = m : Ra = Ra.next = m;
      }
      return Ra;
    }
    function $S() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function $_(n, a) {
      return typeof a == "function" ? a(n) : a;
    }
    function W_(n, a, f) {
      var m = jf(),
        b;
      f !== void 0 ? b = f(a) : b = a, m.memoizedState = m.baseState = b;
      var T = {
        pending: null,
        interleaved: null,
        lanes: Re,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: b
      };
      m.queue = T;
      var M = T.dispatch = FD.bind(null, zn, T);
      return [m.memoizedState, M];
    }
    function q_(n, a, f) {
      var m = bu(),
        b = m.queue;
      if (b === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var T = Fa,
        M = T.baseQueue,
        z = b.pending;
      if (z !== null) {
        if (M !== null) {
          var U = M.next,
            X = z.next;
          M.next = X, z.next = U;
        }
        T.baseQueue !== M && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), T.baseQueue = M = z, b.pending = null;
      }
      if (M !== null) {
        var J = M.next,
          me = T.baseState,
          xe = null,
          Ie = null,
          Pe = null,
          $e = J;
        do {
          var mt = $e.lane;
          if ($l(ea, mt)) {
            if (Pe !== null) {
              var Ue = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ln,
                action: $e.action,
                hasEagerState: $e.hasEagerState,
                eagerState: $e.eagerState,
                next: null
              };
              Pe = Pe.next = Ue;
            }
            if ($e.hasEagerState) me = $e.eagerState;else {
              var Ve = $e.action;
              me = n(me, Ve);
            }
          } else {
            var Te = {
              lane: mt,
              action: $e.action,
              hasEagerState: $e.hasEagerState,
              eagerState: $e.eagerState,
              next: null
            };
            Pe === null ? (Ie = Pe = Te, xe = me) : Pe = Pe.next = Te, zn.lanes = jt(zn.lanes, mt), Sx(mt);
          }
          $e = $e.next;
        } while ($e !== null && $e !== J);
        Pe === null ? xe = me : Pe.next = Ie, he(me, m.memoizedState) || Hy(), m.memoizedState = me, m.baseState = xe, m.baseQueue = Pe, b.lastRenderedState = me;
      }
      var nt = b.interleaved;
      if (nt !== null) {
        var ke = nt;
        do {
          var Fe = ke.lane;
          zn.lanes = jt(zn.lanes, Fe), Sx(Fe), ke = ke.next;
        } while (ke !== nt);
      } else M === null && (b.lanes = Re);
      var De = b.dispatch;
      return [m.memoizedState, De];
    }
    function s0(n, a, f) {
      var m = bu(),
        b = m.queue;
      if (b === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var T = b.dispatch,
        M = b.pending,
        z = m.memoizedState;
      if (M !== null) {
        b.pending = null;
        var U = M.next,
          X = U;
        do {
          var J = X.action;
          z = n(z, J), X = X.next;
        } while (X !== U);
        he(z, m.memoizedState) || Hy(), m.memoizedState = z, m.baseQueue === null && (m.baseState = z), b.lastRenderedState = z;
      }
      return [z, T];
    }
    function PP(n, a, f) {}
    function AP(n, a, f) {}
    function WS(n, a, f) {
      var m = zn,
        b = jf(),
        T,
        M = ts();
      if (M) {
        if (f === void 0) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        T = f(), Lr || T !== f() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), Lr = !0);
      } else {
        if (T = a(), !Lr) {
          var z = a();
          he(T, z) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Lr = !0);
        }
        var U = Ba();
        if (U === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gs(U, ea) || NC(m, a, T);
      }
      b.memoizedState = T;
      var X = {
        value: T,
        getSnapshot: a
      };
      return b.queue = X, p0(qS.bind(null, m, X, n), [n]), m.flags |= Yr, kv(Er | Qo, G_.bind(null, m, X, T, a), void 0, null), T;
    }
    function Y_(n, a, f) {
      var m = zn,
        b = bu(),
        T = a();
      if (!Lr) {
        var M = a();
        he(T, M) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Lr = !0);
      }
      var z = b.memoizedState,
        U = !he(z, T);
      U && (b.memoizedState = T, Hy());
      var X = b.queue;
      if (Rv(qS.bind(null, m, X, n), [n]), X.getSnapshot !== a || U ||
      // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ra !== null && Ra.memoizedState.tag & Er) {
        m.flags |= Yr, kv(Er | Qo, G_.bind(null, m, X, T, a), void 0, null);
        var J = Ba();
        if (J === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Gs(J, ea) || NC(m, a, T);
      }
      return T;
    }
    function NC(n, a, f) {
      n.flags |= As;
      var m = {
          getSnapshot: a,
          value: f
        },
        b = zn.updateQueue;
      if (b === null) b = $S(), zn.updateQueue = b, b.stores = [m];else {
        var T = b.stores;
        T === null ? b.stores = [m] : T.push(m);
      }
    }
    function G_(n, a, f, m) {
      a.value = f, a.getSnapshot = m, YS(a) && u0(n);
    }
    function qS(n, a, f) {
      var m = function () {
        YS(a) && u0(n);
      };
      return f(m);
    }
    function YS(n) {
      var a = n.getSnapshot,
        f = n.value;
      try {
        var m = a();
        return !he(f, m);
      } catch {
        return !0;
      }
    }
    function u0(n) {
      var a = rs(n, Je);
      a !== null && To(a, n, Je, wn);
    }
    function c0(n) {
      var a = jf();
      typeof n == "function" && (n = n()), a.memoizedState = a.baseState = n;
      var f = {
        pending: null,
        interleaved: null,
        lanes: Re,
        dispatch: null,
        lastRenderedReducer: $_,
        lastRenderedState: n
      };
      a.queue = f;
      var m = f.dispatch = ND.bind(null, zn, f);
      return [a.memoizedState, m];
    }
    function d0(n) {
      return q_($_);
    }
    function Py(n) {
      return s0($_);
    }
    function kv(n, a, f, m) {
      var b = {
          tag: n,
          create: a,
          destroy: f,
          deps: m,
          // Circular
          next: null
        },
        T = zn.updateQueue;
      if (T === null) T = $S(), zn.updateQueue = T, T.lastEffect = b.next = b;else {
        var M = T.lastEffect;
        if (M === null) T.lastEffect = b.next = b;else {
          var z = M.next;
          M.next = b, b.next = z, T.lastEffect = b;
        }
      }
      return b;
    }
    function f0(n) {
      var a = jf();
      {
        var f = {
          current: n
        };
        return a.memoizedState = f, f;
      }
    }
    function Tv(n) {
      var a = bu();
      return a.memoizedState;
    }
    function Ay(n, a, f, m) {
      var b = jf(),
        T = m === void 0 ? null : m;
      zn.flags |= n, b.memoizedState = kv(Er | a, f, void 0, T);
    }
    function jy(n, a, f, m) {
      var b = bu(),
        T = m === void 0 ? null : m,
        M = void 0;
      if (Fa !== null) {
        var z = Fa.memoizedState;
        if (M = z.destroy, T !== null) {
          var U = z.deps;
          if (Cv(T, U)) {
            b.memoizedState = kv(a, f, M, T);
            return;
          }
        }
      }
      zn.flags |= n, b.memoizedState = kv(Er | a, f, M, T);
    }
    function p0(n, a) {
      return (zn.mode & Ri) !== dt ? Ay(ga | Yr | zd, Qo, n, a) : Ay(Yr | zd, Qo, n, a);
    }
    function Rv(n, a) {
      return jy(Yr, Qo, n, a);
    }
    function GS(n, a) {
      return Ay(tn, Ui, n, a);
    }
    function h0(n, a) {
      return jy(tn, Ui, n, a);
    }
    function m0(n, a) {
      var f = tn;
      return f |= Za, (zn.mode & Ri) !== dt && (f |= Bo), Ay(f, so, n, a);
    }
    function XS(n, a) {
      return jy(tn, so, n, a);
    }
    function X_(n, a) {
      if (typeof a == "function") {
        var f = a,
          m = n();
        return f(m), function () {
          f(null);
        };
      } else if (a != null) {
        var b = a;
        b.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(b).join(", ") + "}");
        var T = n();
        return b.current = T, function () {
          b.current = null;
        };
      }
    }
    function K_(n, a, f) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var m = f != null ? f.concat([n]) : null,
        b = tn;
      return b |= Za, (zn.mode & Ri) !== dt && (b |= Bo), Ay(b, so, X_.bind(null, a, n), m);
    }
    function Fy(n, a, f) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var m = f != null ? f.concat([n]) : null;
      return jy(tn, so, X_.bind(null, a, n), m);
    }
    function zC(n, a) {}
    var Ny = zC;
    function Q_(n, a) {
      var f = jf(),
        m = a === void 0 ? null : a;
      return f.memoizedState = [n, m], n;
    }
    function Z_(n, a) {
      var f = bu(),
        m = a === void 0 ? null : a,
        b = f.memoizedState;
      if (b !== null && m !== null) {
        var T = b[1];
        if (Cv(m, T)) return b[0];
      }
      return f.memoizedState = [n, m], n;
    }
    function KS(n, a) {
      var f = jf(),
        m = a === void 0 ? null : a,
        b = n();
      return f.memoizedState = [b, m], b;
    }
    function J_(n, a) {
      var f = bu(),
        m = a === void 0 ? null : a,
        b = f.memoizedState;
      if (b !== null && m !== null) {
        var T = b[1];
        if (Cv(m, T)) return b[0];
      }
      var M = n();
      return f.memoizedState = [M, m], M;
    }
    function VC(n) {
      var a = jf();
      return a.memoizedState = n, n;
    }
    function QS(n) {
      var a = bu(),
        f = Fa,
        m = f.memoizedState;
      return UC(a, m, n);
    }
    function BC(n) {
      var a = bu();
      if (Fa === null) return a.memoizedState = n, n;
      var f = Fa.memoizedState;
      return UC(a, f, n);
    }
    function UC(n, a, f) {
      var m = !Ys(ea);
      if (m) {
        if (!he(f, a)) {
          var b = Vh();
          zn.lanes = jt(zn.lanes, b), Sx(b), n.baseState = !0;
        }
        return a;
      } else return n.baseState && (n.baseState = !1, Hy()), n.memoizedState = f, f;
    }
    function AD(n, a, f) {
      var m = zr();
      sa(Jg(m, Zi)), n(!0);
      var b = gp.transition;
      gp.transition = {};
      var T = gp.transition;
      gp.transition._updatedFibers = /* @__PURE__ */new Set();
      try {
        n(!1), a();
      } finally {
        if (sa(m), gp.transition = b, b === null && T._updatedFibers) {
          var M = T._updatedFibers.size;
          M > 10 && p("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), T._updatedFibers.clear();
        }
      }
    }
    function HC() {
      var n = c0(!1),
        a = n[0],
        f = n[1],
        m = AD.bind(null, f),
        b = jf();
      return b.memoizedState = m, [a, m];
    }
    function ZS() {
      var n = d0(),
        a = n[0],
        f = bu(),
        m = f.memoizedState;
      return [a, m];
    }
    function ex() {
      var n = Py(),
        a = n[0],
        f = bu(),
        m = f.memoizedState;
      return [a, m];
    }
    var jD = !1;
    function jP() {
      return jD;
    }
    function JS() {
      var n = jf(),
        a = Ba(),
        f = a.identifierPrefix,
        m;
      if (ts()) {
        var b = _D();
        m = ":" + f + "R" + b;
        var T = H_++;
        T > 0 && (m += "H" + T.toString(32)), m += ":";
      } else {
        var M = ct++;
        m = ":" + f + "r" + M.toString(32) + ":";
      }
      return n.memoizedState = m, m;
    }
    function tx() {
      var n = bu(),
        a = n.memoizedState;
      return a;
    }
    function FD(n, a, f) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var m = jv(n),
        b = {
          lane: m,
          action: f,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (nx(n)) $C(a, b);else {
        var T = TD(n, a, b, m);
        if (T !== null) {
          var M = au();
          To(T, n, m, M), WC(T, a, m);
        }
      }
      qC(n, m);
    }
    function ND(n, a, f) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var m = jv(n),
        b = {
          lane: m,
          action: f,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
      if (nx(n)) $C(a, b);else {
        var T = n.alternate;
        if (n.lanes === Re && (T === null || T.lanes === Re)) {
          var M = a.lastRenderedReducer;
          if (M !== null) {
            var z;
            z = Jt.current, Jt.current = gl;
            try {
              var U = a.lastRenderedState,
                X = M(U, f);
              if (b.hasEagerState = !0, b.eagerState = X, he(X, U)) {
                vu(n, a, b, m);
                return;
              }
            } catch {} finally {
              Jt.current = z;
            }
          }
        }
        var J = TD(n, a, b, m);
        if (J !== null) {
          var me = au();
          To(J, n, m, me), WC(J, a, m);
        }
      }
      qC(n, m);
    }
    function nx(n) {
      var a = n.alternate;
      return n === zn || a !== null && a === zn;
    }
    function $C(n, a) {
      U_ = Ev = !0;
      var f = n.pending;
      f === null ? a.next = a : (a.next = f.next, f.next = a), n.pending = a;
    }
    function WC(n, a, f) {
      if (zh(f)) {
        var m = a.lanes;
        m = Bh(m, n.pendingLanes);
        var b = jt(m, f);
        a.lanes = b, cf(n, b);
      }
    }
    function qC(n, a, f) {
      Bl(n, a);
    }
    var rx = {
        readContext: Aa,
        useCallback: co,
        useContext: co,
        useEffect: co,
        useImperativeHandle: co,
        useInsertionEffect: co,
        useLayoutEffect: co,
        useMemo: co,
        useReducer: co,
        useRef: co,
        useState: co,
        useDebugValue: co,
        useDeferredValue: co,
        useTransition: co,
        useMutableSource: co,
        useSyncExternalStore: co,
        useId: co,
        unstable_isNewReconciler: $
      },
      Ff = null,
      qc = null,
      ix = null,
      e1 = null,
      xn = null,
      gl = null,
      ax = null;
    {
      var v0 = function () {
          h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        },
        Dn = function () {
          h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
      Ff = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Cr(), uo(a), Q_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Cr(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Cr(), uo(a), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Cr(), uo(f), K_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Cr(), uo(a), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Cr(), uo(a), m0(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Cr(), uo(a);
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Cr();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return W_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Cr(), f0(n);
        },
        useState: function (n) {
          st = "useState", Cr();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Cr(), void 0;
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Cr(), VC(n);
        },
        useTransition: function () {
          return st = "useTransition", Cr(), HC();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Cr(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Cr(), WS(n, a, f);
        },
        useId: function () {
          return st = "useId", Cr(), JS();
        },
        unstable_isNewReconciler: $
      }, qc = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Yt(), Q_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Yt(), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Yt(), K_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Yt(), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Yt(), m0(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return W_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Yt(), f0(n);
        },
        useState: function (n) {
          st = "useState", Yt();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Yt(), void 0;
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Yt(), VC(n);
        },
        useTransition: function () {
          return st = "useTransition", Yt(), HC();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Yt(), WS(n, a, f);
        },
        useId: function () {
          return st = "useId", Yt(), JS();
        },
        unstable_isNewReconciler: $
      }, ix = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Yt(), Z_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = gl;
          try {
            return J_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = gl;
          try {
            return q_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Yt(), Tv();
        },
        useState: function (n) {
          st = "useState", Yt();
          var a = Jt.current;
          Jt.current = gl;
          try {
            return d0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Yt(), QS(n);
        },
        useTransition: function () {
          return st = "useTransition", Yt(), ZS();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Yt(), Y_(n, a);
        },
        useId: function () {
          return st = "useId", Yt(), tx();
        },
        unstable_isNewReconciler: $
      }, e1 = {
        readContext: function (n) {
          return Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Yt(), Z_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Yt();
          var f = Jt.current;
          Jt.current = ax;
          try {
            return J_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Yt();
          var m = Jt.current;
          Jt.current = ax;
          try {
            return s0(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Yt(), Tv();
        },
        useState: function (n) {
          st = "useState", Yt();
          var a = Jt.current;
          Jt.current = ax;
          try {
            return Py(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Yt(), BC(n);
        },
        useTransition: function () {
          return st = "useTransition", Yt(), ex();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Yt(), Y_(n, a);
        },
        useId: function () {
          return st = "useId", Yt(), tx();
        },
        unstable_isNewReconciler: $
      }, xn = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Dn(), Cr(), Q_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Dn(), Cr(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Dn(), Cr(), p0(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Dn(), Cr(), K_(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Dn(), Cr(), GS(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Dn(), Cr(), m0(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Dn(), Cr();
          var f = Jt.current;
          Jt.current = xn;
          try {
            return KS(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Dn(), Cr();
          var m = Jt.current;
          Jt.current = xn;
          try {
            return W_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Dn(), Cr(), f0(n);
        },
        useState: function (n) {
          st = "useState", Dn(), Cr();
          var a = Jt.current;
          Jt.current = xn;
          try {
            return c0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Dn(), Cr(), void 0;
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Dn(), Cr(), VC(n);
        },
        useTransition: function () {
          return st = "useTransition", Dn(), Cr(), HC();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Dn(), Cr(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Dn(), Cr(), WS(n, a, f);
        },
        useId: function () {
          return st = "useId", Dn(), Cr(), JS();
        },
        unstable_isNewReconciler: $
      }, gl = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Dn(), Yt(), Z_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Dn(), Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Dn(), Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Dn(), Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Dn(), Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Dn(), Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Dn(), Yt();
          var f = Jt.current;
          Jt.current = gl;
          try {
            return J_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Dn(), Yt();
          var m = Jt.current;
          Jt.current = gl;
          try {
            return q_(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Dn(), Yt(), Tv();
        },
        useState: function (n) {
          st = "useState", Dn(), Yt();
          var a = Jt.current;
          Jt.current = gl;
          try {
            return d0(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Dn(), Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Dn(), Yt(), QS(n);
        },
        useTransition: function () {
          return st = "useTransition", Dn(), Yt(), ZS();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Dn(), Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Dn(), Yt(), Y_(n, a);
        },
        useId: function () {
          return st = "useId", Dn(), Yt(), tx();
        },
        unstable_isNewReconciler: $
      }, ax = {
        readContext: function (n) {
          return v0(), Aa(n);
        },
        useCallback: function (n, a) {
          return st = "useCallback", Dn(), Yt(), Z_(n, a);
        },
        useContext: function (n) {
          return st = "useContext", Dn(), Yt(), Aa(n);
        },
        useEffect: function (n, a) {
          return st = "useEffect", Dn(), Yt(), Rv(n, a);
        },
        useImperativeHandle: function (n, a, f) {
          return st = "useImperativeHandle", Dn(), Yt(), Fy(n, a, f);
        },
        useInsertionEffect: function (n, a) {
          return st = "useInsertionEffect", Dn(), Yt(), h0(n, a);
        },
        useLayoutEffect: function (n, a) {
          return st = "useLayoutEffect", Dn(), Yt(), XS(n, a);
        },
        useMemo: function (n, a) {
          st = "useMemo", Dn(), Yt();
          var f = Jt.current;
          Jt.current = gl;
          try {
            return J_(n, a);
          } finally {
            Jt.current = f;
          }
        },
        useReducer: function (n, a, f) {
          st = "useReducer", Dn(), Yt();
          var m = Jt.current;
          Jt.current = gl;
          try {
            return s0(n, a, f);
          } finally {
            Jt.current = m;
          }
        },
        useRef: function (n) {
          return st = "useRef", Dn(), Yt(), Tv();
        },
        useState: function (n) {
          st = "useState", Dn(), Yt();
          var a = Jt.current;
          Jt.current = gl;
          try {
            return Py(n);
          } finally {
            Jt.current = a;
          }
        },
        useDebugValue: function (n, a) {
          return st = "useDebugValue", Dn(), Yt(), Ny();
        },
        useDeferredValue: function (n) {
          return st = "useDeferredValue", Dn(), Yt(), BC(n);
        },
        useTransition: function () {
          return st = "useTransition", Dn(), Yt(), ex();
        },
        useMutableSource: function (n, a, f) {
          return st = "useMutableSource", Dn(), Yt(), void 0;
        },
        useSyncExternalStore: function (n, a, f) {
          return st = "useSyncExternalStore", Dn(), Yt(), Y_(n, a);
        },
        useId: function () {
          return st = "useId", Dn(), Yt(), tx();
        },
        unstable_isNewReconciler: $
      };
    }
    var Nf = e.unstable_now,
      t1 = 0,
      zy = -1,
      g0 = -1,
      n1 = -1,
      YC = !1,
      r1 = !1;
    function GC() {
      return YC;
    }
    function zD() {
      r1 = !0;
    }
    function XC() {
      YC = !1, r1 = !1;
    }
    function VD() {
      YC = r1, r1 = !1;
    }
    function ox() {
      return t1;
    }
    function zf() {
      t1 = Nf();
    }
    function lx(n) {
      g0 = Nf(), n.actualStartTime < 0 && (n.actualStartTime = Nf());
    }
    function Vf(n) {
      g0 = -1;
    }
    function y0(n, a) {
      if (g0 >= 0) {
        var f = Nf() - g0;
        n.actualDuration += f, a && (n.selfBaseDuration = f), g0 = -1;
      }
    }
    function Yc(n) {
      if (zy >= 0) {
        var a = Nf() - zy;
        zy = -1;
        for (var f = n.return; f !== null;) {
          switch (f.tag) {
            case C:
              var m = f.stateNode;
              m.effectDuration += a;
              return;
            case j:
              var b = f.stateNode;
              b.effectDuration += a;
              return;
          }
          f = f.return;
        }
      }
    }
    function Em(n) {
      if (n1 >= 0) {
        var a = Nf() - n1;
        n1 = -1;
        for (var f = n.return; f !== null;) {
          switch (f.tag) {
            case C:
              var m = f.stateNode;
              m !== null && (m.passiveEffectDuration += a);
              return;
            case j:
              var b = f.stateNode;
              b !== null && (b.passiveEffectDuration += a);
              return;
          }
          f = f.return;
        }
      }
    }
    function Gc() {
      zy = Nf();
    }
    function KC() {
      n1 = Nf();
    }
    function sx(n) {
      for (var a = n.child; a;) n.actualDuration += a.actualDuration, a = a.sibling;
    }
    function Vy(n, a) {
      return {
        value: n,
        source: a,
        stack: pd(a),
        digest: null
      };
    }
    function i1(n, a, f) {
      return {
        value: n,
        source: null,
        stack: f ?? null,
        digest: a ?? null
      };
    }
    function QC(n, a) {
      return !0;
    }
    function a1(n, a) {
      try {
        var f = QC(n, a);
        if (f === !1) return;
        var m = a.value,
          b = a.source,
          T = a.stack,
          M = T !== null ? T : "";
        if (m != null && m._suppressLogging) {
          if (n.tag === x) return;
          console.error(m);
        }
        var z = b ? At(b) : null,
          U = z ? "The above error occurred in the <" + z + "> component:" : "The above error occurred in one of your React components:",
          X;
        if (n.tag === C) X = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;else {
          var J = At(n) || "Anonymous";
          X = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + J + ".");
        }
        var me = U + `
` + M + `

` + ("" + X);
        console.error(me);
      } catch (xe) {
        setTimeout(function () {
          throw xe;
        });
      }
    }
    var FP = typeof WeakMap == "function" ? WeakMap : Map;
    function BD(n, a, f) {
      var m = Hc(wn, f);
      m.tag = w_, m.payload = {
        element: null
      };
      var b = a.value;
      return m.callback = function () {
        RI(b), a1(n, a);
      }, m;
    }
    function o1(n, a, f) {
      var m = Hc(wn, f);
      m.tag = w_;
      var b = n.type.getDerivedStateFromError;
      if (typeof b == "function") {
        var T = a.value;
        m.payload = function () {
          return b(T);
        }, m.callback = function () {
          AI(n), a1(n, a);
        };
      }
      var M = n.stateNode;
      return M !== null && typeof M.componentDidCatch == "function" && (m.callback = function () {
        AI(n), a1(n, a), typeof b != "function" && Fi(this);
        var U = a.value,
          X = a.stack;
        this.componentDidCatch(U, {
          componentStack: X !== null ? X : ""
        }), typeof b != "function" && (_n(n.lanes, Je) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", At(n) || "Unknown"));
      }), m;
    }
    function ZC(n, a, f) {
      var m = n.pingCache,
        b;
      if (m === null ? (m = n.pingCache = new FP(), b = /* @__PURE__ */new Set(), m.set(a, b)) : (b = m.get(a), b === void 0 && (b = /* @__PURE__ */new Set(), m.set(a, b))), !b.has(f)) {
        b.add(f);
        var T = LA.bind(null, n, a, f);
        ui && P0(n, f), a.then(T, T);
      }
    }
    function NP(n, a, f, m) {
      var b = n.updateQueue;
      if (b === null) {
        var T = /* @__PURE__ */new Set();
        T.add(f), n.updateQueue = T;
      } else b.add(f);
    }
    function zP(n, a) {
      var f = n.tag;
      if ((n.mode & Wt) === dt && (f === w || f === F || f === G)) {
        var m = n.alternate;
        m ? (n.updateQueue = m.updateQueue, n.memoizedState = m.memoizedState, n.lanes = m.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function b0(n) {
      var a = n;
      do {
        if (a.tag === V && gu(a)) return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function Xc(n, a, f, m, b) {
      if ((n.mode & Wt) === dt) {
        if (n === a) n.flags |= Gr;else {
          if (n.flags |= ft, f.flags |= Nd, f.flags &= -52805, f.tag === x) {
            var T = f.alternate;
            if (T === null) f.tag = te;else {
              var M = Hc(wn, Je);
              M.tag = Cy, mp(f, M, Je);
            }
          }
          f.lanes = jt(f.lanes, Je);
        }
        return n;
      }
      return n.flags |= Gr, n.lanes = b, n;
    }
    function JC(n, a, f, m, b) {
      if (f.flags |= Gu, ui && P0(n, b), m !== null && typeof m == "object" && typeof m.then == "function") {
        var T = m;
        zP(f), ts() && f.mode & Wt && xD();
        var M = b0(a);
        if (M !== null) {
          M.flags &= -257, Xc(M, a, f, n, b), M.mode & Wt && ZC(n, T, b), NP(M, n, T);
          return;
        } else {
          if (!Pw(b)) {
            ZC(n, T, b), Lk();
            return;
          }
          var z = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          m = z;
        }
      } else if (ts() && f.mode & Wt) {
        xD();
        var U = b0(a);
        if (U !== null) {
          (U.flags & Gr) === pt && (U.flags |= qr), Xc(U, a, f, n, b), xC(Vy(m, f));
          return;
        }
      }
      m = Vy(m, f), kA(m);
      var X = a;
      do {
        switch (X.tag) {
          case C:
            {
              var J = m;
              X.flags |= Gr;
              var me = Xs(b);
              X.lanes = jt(X.lanes, me);
              var xe = BD(X, J, me);
              Jb(X, xe);
              return;
            }
          case x:
            var Ie = m,
              Pe = X.type,
              $e = X.stateNode;
            if ((X.flags & ft) === pt && (typeof Pe.getDerivedStateFromError == "function" || $e !== null && typeof $e.componentDidCatch == "function" && !Ok($e))) {
              X.flags |= Gr;
              var mt = Xs(b);
              X.lanes = jt(X.lanes, mt);
              var Te = o1(X, Ie, mt);
              Jb(X, Te);
              return;
            }
            break;
        }
        X = X.return;
      } while (X !== null);
    }
    function ux() {
      return null;
    }
    var By = i.ReactCurrentOwner,
      xc = !1,
      cx,
      Bf,
      dx,
      w0,
      is,
      Uy,
      l1,
      fx;
    cx = {}, Bf = {}, dx = {}, w0 = {}, is = {}, Uy = !1, l1 = {}, fx = {};
    function hs(n, a, f, m) {
      n === null ? a.child = LD(a, null, f, m) : a.child = r0(a, n.child, f, m);
    }
    function UD(n, a, f, m) {
      a.child = r0(a, n.child, null, m), a.child = r0(a, null, f, m);
    }
    function HD(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = f.propTypes;
        T && hu(T, m,
        // Resolved props
        "prop", bn(f));
      }
      var M = f.render,
        z = a.ref,
        U,
        X;
      Uc(a, b), Ti(a);
      {
        if (By.current = a, br(!0), U = Ly(n, a, M, m, z, b), X = Oy(), a.mode & Xn) {
          En(!0);
          try {
            U = Ly(n, a, M, m, z, b), X = Oy();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), n !== null && !xc ? (Af(n, a, b), bp(n, a, b)) : (ts() && X && vC(a), a.flags |= Xi, hs(n, a, U, b), a.child);
    }
    function $D(n, a, f, m, b) {
      if (n === null) {
        var T = f.type;
        if (NA(T) && f.compare === null &&
        // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var M = T;
          return M = nb(T), a.tag = G, a.type = M, ck(a, T), WD(n, a, M, m, b);
        }
        {
          var z = T.propTypes;
          z && hu(z, m,
          // Resolved props
          "prop", bn(T));
        }
        var U = $k(f.type, null, m, a, a.mode, b);
        return U.ref = a.ref, U.return = a, a.child = U, U;
      }
      {
        var X = f.type,
          J = X.propTypes;
        J && hu(J, m,
        // Resolved props
        "prop", bn(X));
      }
      var me = n.child,
        xe = d1(n, b);
      if (!xe) {
        var Ie = me.memoizedProps,
          Pe = f.compare;
        if (Pe = Pe !== null ? Pe : He, Pe(Ie, m) && n.ref === a.ref) return bp(n, a, b);
      }
      a.flags |= Xi;
      var $e = Lm(me, m);
      return $e.ref = a.ref, $e.return = a, a.child = $e, $e;
    }
    function WD(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = a.elementType;
        if (T.$$typeof === Ct) {
          var M = T,
            z = M._payload,
            U = M._init;
          try {
            T = U(z);
          } catch {
            T = null;
          }
          var X = T && T.propTypes;
          X && hu(X, m,
          // Resolved (SimpleMemoComponent has no defaultProps)
          "prop", bn(T));
        }
      }
      if (n !== null) {
        var J = n.memoizedProps;
        if (He(J, m) && n.ref === a.ref &&
        // Prevent bailout if the implementation changed due to hot reload.
        a.type === n.type) if (xc = !1, a.pendingProps = m = J, d1(n, b)) (n.flags & Nd) !== pt && (xc = !0);else return a.lanes = n.lanes, bp(n, a, b);
      }
      return ik(n, a, f, m, b);
    }
    function ek(n, a, f) {
      var m = a.pendingProps,
        b = m.children,
        T = n !== null ? n.memoizedState : null;
      if (m.mode === "hidden" || H) {
        if ((a.mode & Wt) === dt) {
          var M = {
            baseLanes: Re,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = M, xx(a, f);
        } else if (_n(f, Jr)) {
          var me = {
            baseLanes: Re,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = me;
          var xe = T !== null ? T.baseLanes : f;
          xx(a, xe);
        } else {
          var z = null,
            U;
          if (T !== null) {
            var X = T.baseLanes;
            U = jt(X, f);
          } else U = f;
          a.lanes = a.childLanes = Jr;
          var J = {
            baseLanes: U,
            cachePool: z,
            transitions: null
          };
          return a.memoizedState = J, a.updateQueue = null, xx(a, U), null;
        }
      } else {
        var Ie;
        T !== null ? (Ie = jt(T.baseLanes, f), a.memoizedState = null) : Ie = f, xx(a, Ie);
      }
      return hs(n, a, b, f), a.child;
    }
    function tk(n, a, f) {
      var m = a.pendingProps;
      return hs(n, a, m, f), a.child;
    }
    function qD(n, a, f) {
      var m = a.pendingProps.children;
      return hs(n, a, m, f), a.child;
    }
    function nk(n, a, f) {
      {
        a.flags |= tn;
        {
          var m = a.stateNode;
          m.effectDuration = 0, m.passiveEffectDuration = 0;
        }
      }
      var b = a.pendingProps,
        T = b.children;
      return hs(n, a, T, f), a.child;
    }
    function rk(n, a) {
      var f = a.ref;
      (n === null && f !== null || n !== null && n.ref !== f) && (a.flags |= Hn, a.flags |= js);
    }
    function ik(n, a, f, m, b) {
      if (a.type !== a.elementType) {
        var T = f.propTypes;
        T && hu(T, m,
        // Resolved props
        "prop", bn(f));
      }
      var M;
      {
        var z = Rf(a, f, !0);
        M = eu(a, z);
      }
      var U, X;
      Uc(a, b), Ti(a);
      {
        if (By.current = a, br(!0), U = Ly(n, a, f, m, M, b), X = Oy(), a.mode & Xn) {
          En(!0);
          try {
            U = Ly(n, a, f, m, M, b), X = Oy();
          } finally {
            En(!1);
          }
        }
        br(!1);
      }
      return to(), n !== null && !xc ? (Af(n, a, b), bp(n, a, b)) : (ts() && X && vC(a), a.flags |= Xi, hs(n, a, U, b), a.child);
    }
    function ak(n, a, f, m, b) {
      {
        switch (HI(a)) {
          case !1:
            {
              var T = a.stateNode,
                M = a.type,
                z = new M(a.memoizedProps, T.context),
                U = z.state;
              T.updater.enqueueSetState(T, U, null);
              break;
            }
          case !0:
            {
              a.flags |= ft, a.flags |= Gr;
              var X = new Error("Simulated error coming from DevTools"),
                J = Xs(b);
              a.lanes = jt(a.lanes, J);
              var me = o1(a, Vy(X, a), J);
              Jb(a, me);
              break;
            }
        }
        if (a.type !== a.elementType) {
          var xe = f.propTypes;
          xe && hu(xe, m,
          // Resolved props
          "prop", bn(f));
        }
      }
      var Ie;
      Bc(f) ? (Ie = !0, wS(a)) : Ie = !1, Uc(a, b);
      var Pe = a.stateNode,
        $e;
      Pe === null ? (c1(n, a), IC(a, f, m), LC(a, f, m, b), $e = !0) : n === null ? $e = OC(a, f, m, b) : $e = PC(n, a, f, m, b);
      var mt = ok(n, a, f, $e, Ie, b);
      {
        var Te = a.stateNode;
        $e && Te.props !== m && (Uy || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", At(a) || "a component"), Uy = !0);
      }
      return mt;
    }
    function ok(n, a, f, m, b, T) {
      rk(n, a);
      var M = (a.flags & ft) !== pt;
      if (!m && !M) return b && sm(a, f, !1), bp(n, a, T);
      var z = a.stateNode;
      By.current = a;
      var U;
      if (M && typeof f.getDerivedStateFromError != "function") U = null, Vf();else {
        Ti(a);
        {
          if (br(!0), U = z.render(), a.mode & Xn) {
            En(!0);
            try {
              z.render();
            } finally {
              En(!1);
            }
          }
          br(!1);
        }
        to();
      }
      return a.flags |= Xi, n !== null && M ? UD(n, a, U, T) : hs(n, a, U, T), a.memoizedState = z.state, b && sm(a, f, !0), a.child;
    }
    function YD(n) {
      var a = n.stateNode;
      a.pendingContext ? d_(n, a.pendingContext, a.pendingContext !== a.context) : a.context && d_(n, a.context, !1), N_(n, a.containerInfo);
    }
    function VP(n, a, f) {
      if (YD(a), n === null) throw new Error("Should have a current fiber. This is a bug in React.");
      var m = a.pendingProps,
        b = a.memoizedState,
        T = b.element;
      wm(n, a), S_(a, m, null, f);
      var M = a.memoizedState;
      a.stateNode;
      var z = M.element;
      if (b.isDehydrated) {
        var U = {
            element: z,
            isDehydrated: !1,
            cache: M.cache,
            pendingSuspenseBoundaries: M.pendingSuspenseBoundaries,
            transitions: M.transitions
          },
          X = a.updateQueue;
        if (X.baseState = U, a.memoizedState = U, a.flags & qr) {
          var J = Vy(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return GD(n, a, z, f, J);
        } else if (z !== T) {
          var me = Vy(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return GD(n, a, z, f, me);
        } else {
          SD(a);
          var xe = LD(a, null, z, f);
          a.child = xe;
          for (var Ie = xe; Ie;) Ie.flags = Ie.flags & -3 | xi, Ie = Ie.sibling;
        }
      } else {
        if (Pa(), z === T) return bp(n, a, f);
        hs(n, a, z, f);
      }
      return a.child;
    }
    function GD(n, a, f, m, b) {
      return Pa(), xC(b), a.flags |= qr, hs(n, a, f, m), a.child;
    }
    function BP(n, a, f) {
      OD(a), n === null && wC(a);
      var m = a.type,
        b = a.pendingProps,
        T = n !== null ? n.memoizedProps : null,
        M = b.children,
        z = aC(m, b);
      return z ? M = null : T !== null && aC(m, T) && (a.flags |= Ki), rk(n, a), hs(n, a, M, f), a.child;
    }
    function lk(n, a) {
      return n === null && wC(a), null;
    }
    function sk(n, a, f, m) {
      c1(n, a);
      var b = a.pendingProps,
        T = f,
        M = T._payload,
        z = T._init,
        U = z(M);
      a.type = U;
      var X = a.tag = Hk(U),
        J = wc(U, b),
        me;
      switch (X) {
        case w:
          return ck(a, U), a.type = U = nb(U), me = ik(null, a, U, J, m), me;
        case x:
          return a.type = U = Fk(U), me = ak(null, a, U, J, m), me;
        case F:
          return a.type = U = Nk(U), me = HD(null, a, U, J, m), me;
        case K:
          {
            if (a.type !== a.elementType) {
              var xe = U.propTypes;
              xe && hu(xe, J,
              // Resolved for outer only
              "prop", bn(U));
            }
            return me = $D(null, a, U, wc(U.type, J),
            // The inner type can have defaults too
            m), me;
          }
      }
      var Ie = "";
      throw U !== null && typeof U == "object" && U.$$typeof === Ct && (Ie = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + U + ". " + ("Lazy element type must resolve to a class or function." + Ie));
    }
    function uk(n, a, f, m, b) {
      c1(n, a), a.tag = x;
      var T;
      return Bc(f) ? (T = !0, wS(a)) : T = !1, Uc(a, b), IC(a, f, m), LC(a, f, m, b), ok(null, a, f, !0, T, b);
    }
    function UP(n, a, f, m) {
      c1(n, a);
      var b = a.pendingProps,
        T;
      {
        var M = Rf(a, f, !1);
        T = eu(a, M);
      }
      Uc(a, m);
      var z, U;
      Ti(a);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var X = bn(f) || "Unknown";
          cx[X] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", X, X), cx[X] = !0);
        }
        a.mode & Xn && ns.recordLegacyContextWarning(a, null), br(!0), By.current = a, z = Ly(null, a, f, b, T, m), U = Oy(), br(!1);
      }
      if (to(), a.flags |= Xi, typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        var J = bn(f) || "Unknown";
        Bf[J] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", J, J, J), Bf[J] = !0);
      }
      if (
      // Run these checks in production only if the flag is off.
      // Eventually we'll delete this branch altogether.
      typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        {
          var me = bn(f) || "Unknown";
          Bf[me] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", me, me, me), Bf[me] = !0);
        }
        a.tag = x, a.memoizedState = null, a.updateQueue = null;
        var xe = !1;
        return Bc(f) ? (xe = !0, wS(a)) : xe = !1, a.memoizedState = z.state !== null && z.state !== void 0 ? z.state : null, Of(a), ID(a, z), LC(a, f, b, m), ok(null, a, f, !0, xe, m);
      } else {
        if (a.tag = w, a.mode & Xn) {
          En(!0);
          try {
            z = Ly(null, a, f, b, T, m), U = Oy();
          } finally {
            En(!1);
          }
        }
        return ts() && U && vC(a), hs(null, a, z, m), ck(a, f), a.child;
      }
    }
    function ck(n, a) {
      {
        if (a && a.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), n.ref !== null) {
          var f = "",
            m = yi();
          m && (f += `

Check the render method of \`` + m + "`.");
          var b = m || "",
            T = n._debugSource;
          T && (b = T.fileName + ":" + T.lineNumber), is[b] || (is[b] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var M = bn(a) || "Unknown";
          w0[M] || (h("%s: Function components do not support getDerivedStateFromProps.", M), w0[M] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var z = bn(a) || "Unknown";
          dx[z] || (h("%s: Function components do not support contextType.", z), dx[z] = !0);
        }
      }
    }
    var dk = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ln
    };
    function s1(n) {
      return {
        baseLanes: n,
        cachePool: ux(),
        transitions: null
      };
    }
    function fk(n, a) {
      var f = null;
      return {
        baseLanes: jt(n.baseLanes, a),
        cachePool: f,
        transitions: n.transitions
      };
    }
    function HP(n, a, f, m) {
      if (a !== null) {
        var b = a.memoizedState;
        if (b === null) return !1;
      }
      return V_(n, My);
    }
    function pk(n, a) {
      return ac(n.childLanes, a);
    }
    function hk(n, a, f) {
      var m = a.pendingProps;
      $I(a) && (a.flags |= ft);
      var b = ps.current,
        T = !1,
        M = (a.flags & ft) !== pt;
      if (M || HP(b, n) ? (T = !0, a.flags &= -129) : (n === null || n.memoizedState !== null) && (b = l0(b, $c)), b = o0(b), Sv(a, b), n === null) {
        wC(a);
        var z = a.memoizedState;
        if (z !== null) {
          var U = z.dehydrated;
          if (U !== null) return GP(a, U);
        }
        var X = m.children,
          J = m.fallback;
        if (T) {
          var me = $P(a, X, J, f),
            xe = a.child;
          return xe.memoizedState = s1(f), a.memoizedState = dk, me;
        } else return mk(a, X);
      } else {
        var Ie = n.memoizedState;
        if (Ie !== null) {
          var Pe = Ie.dehydrated;
          if (Pe !== null) return XP(n, a, M, m, Pe, Ie, f);
        }
        if (T) {
          var $e = m.fallback,
            mt = m.children,
            Te = qP(n, a, mt, $e, f),
            Ue = a.child,
            Ve = n.child.memoizedState;
          return Ue.memoizedState = Ve === null ? s1(f) : fk(Ve, f), Ue.childLanes = pk(n, f), a.memoizedState = dk, Te;
        } else {
          var nt = m.children,
            ke = WP(n, a, nt, f);
          return a.memoizedState = null, ke;
        }
      }
    }
    function mk(n, a, f) {
      var m = n.mode,
        b = {
          mode: "visible",
          children: a
        },
        T = _0(b, m);
      return T.return = n, n.child = T, T;
    }
    function $P(n, a, f, m) {
      var b = n.mode,
        T = n.child,
        M = {
          mode: "hidden",
          children: a
        },
        z,
        U;
      return (b & Wt) === dt && T !== null ? (z = T, z.childLanes = Re, z.pendingProps = M, n.mode & nn && (z.actualDuration = 0, z.actualStartTime = -1, z.selfBaseDuration = 0, z.treeBaseDuration = 0), U = Om(f, b, m, null)) : (z = _0(M, b), U = Om(f, b, m, null)), z.return = n, U.return = n, z.sibling = U, n.child = z, U;
    }
    function _0(n, a, f) {
      return M1(n, a, Re, null);
    }
    function XD(n, a) {
      return Lm(n, a);
    }
    function WP(n, a, f, m) {
      var b = n.child,
        T = b.sibling,
        M = XD(b, {
          mode: "visible",
          children: f
        });
      if ((a.mode & Wt) === dt && (M.lanes = m), M.return = a, M.sibling = null, T !== null) {
        var z = a.deletions;
        z === null ? (a.deletions = [T], a.flags |= _i) : z.push(T);
      }
      return a.child = M, M;
    }
    function qP(n, a, f, m, b) {
      var T = a.mode,
        M = n.child,
        z = M.sibling,
        U = {
          mode: "hidden",
          children: f
        },
        X;
      if (
      // In legacy mode, we commit the primary tree as if it successfully
      // completed, even though it's in an inconsistent state.
      (T & Wt) === dt &&
      // Make sure we're on the second pass, i.e. the primary child fragment was
      // already cloned. In legacy mode, the only case where this isn't true is
      // when DevTools forces us to display a fallback; we skip the first render
      // pass entirely and go straight to rendering the fallback. (In Concurrent
      // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
      // only codepath.)
      a.child !== M) {
        var J = a.child;
        X = J, X.childLanes = Re, X.pendingProps = U, a.mode & nn && (X.actualDuration = 0, X.actualStartTime = -1, X.selfBaseDuration = M.selfBaseDuration, X.treeBaseDuration = M.treeBaseDuration), a.deletions = null;
      } else X = XD(M, U), X.subtreeFlags = M.subtreeFlags & nr;
      var me;
      return z !== null ? me = Lm(z, m) : (me = Om(m, T, b, null), me.flags |= Gn), me.return = a, X.return = a, X.sibling = me, a.child = X, me;
    }
    function px(n, a, f, m) {
      m !== null && xC(m), r0(a, n.child, null, f);
      var b = a.pendingProps,
        T = b.children,
        M = mk(a, T);
      return M.flags |= Gn, a.memoizedState = null, M;
    }
    function YP(n, a, f, m, b) {
      var T = a.mode,
        M = {
          mode: "visible",
          children: f
        },
        z = _0(M, T),
        U = Om(m, T, b, null);
      return U.flags |= Gn, z.return = a, U.return = a, z.sibling = U, a.child = z, (a.mode & Wt) !== dt && r0(a, n.child, null, b), U;
    }
    function GP(n, a, f) {
      return (n.mode & Wt) === dt ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = Je) : dC(a) ? n.lanes = xa : n.lanes = Jr, null;
    }
    function XP(n, a, f, m, b, T, M) {
      if (f) {
        if (a.flags & qr) {
          a.flags &= -257;
          var ke = i1(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return px(n, a, M, ke);
        } else {
          if (a.memoizedState !== null) return a.child = n.child, a.flags |= ft, null;
          var Fe = m.children,
            De = m.fallback,
            Qe = YP(n, a, Fe, De, M),
            Tt = a.child;
          return Tt.memoizedState = s1(M), a.memoizedState = dk, Qe;
        }
      } else {
        if (CP(), (a.mode & Wt) === dt) return px(n, a, M,
        // TODO: When we delete legacy mode, we should make this error argument
        // required — every concurrent mode path that causes hydration to
        // de-opt to client rendering should have an error message.
        null);
        if (dC(b)) {
          var z, U, X;
          {
            var J = pS(b);
            z = J.digest, U = J.message, X = J.stack;
          }
          var me;
          U ? me = new Error(U) : me = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var xe = i1(me, z, X);
          return px(n, a, M, xe);
        }
        var Ie = _n(M, n.childLanes);
        if (xc || Ie) {
          var Pe = Ba();
          if (Pe !== null) {
            var $e = Zm(Pe, M);
            if ($e !== Ln && $e !== T.retryLane) {
              T.retryLane = $e;
              var mt = wn;
              rs(n, $e), To(Pe, n, $e, mt);
            }
          }
          Lk();
          var Te = i1(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return px(n, a, M, Te);
        } else if (gD(b)) {
          a.flags |= ft, a.child = n.child;
          var Ue = OA.bind(null, n);
          return r_(b, Ue), null;
        } else {
          ED(a, b, T.treeContext);
          var Ve = m.children,
            nt = mk(a, Ve);
          return nt.flags |= xi, nt;
        }
      }
    }
    function KD(n, a, f) {
      n.lanes = jt(n.lanes, a);
      var m = n.alternate;
      m !== null && (m.lanes = jt(m.lanes, a)), CC(n.return, a, f);
    }
    function QD(n, a, f) {
      for (var m = a; m !== null;) {
        if (m.tag === V) {
          var b = m.memoizedState;
          b !== null && KD(m, f, n);
        } else if (m.tag === Y) KD(m, f, n);else if (m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === n) return;
        for (; m.sibling === null;) {
          if (m.return === null || m.return === n) return;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
    }
    function KP(n) {
      for (var a = n, f = null; a !== null;) {
        var m = a.alternate;
        m !== null && ja(m) === null && (f = a), a = a.sibling;
      }
      return f;
    }
    function vk(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !l1[n]) if (l1[n] = !0, typeof n == "string") switch (n.toLowerCase()) {
        case "together":
        case "forwards":
        case "backwards":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
            break;
          }
        case "forward":
        case "backward":
          {
            h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
            break;
          }
        default:
          h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
          break;
      } else h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function ZD(n, a) {
      n !== void 0 && !fx[n] && (n !== "collapsed" && n !== "hidden" ? (fx[n] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : a !== "forwards" && a !== "backwards" && (fx[n] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function JD(n, a) {
      {
        var f = wr(n),
          m = !f && typeof yn(n) == "function";
        if (f || m) {
          var b = f ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", b, a, b), !1;
        }
      }
      return !0;
    }
    function eI(n, a) {
      if ((a === "forwards" || a === "backwards") && n !== void 0 && n !== null && n !== !1) if (wr(n)) {
        for (var f = 0; f < n.length; f++) if (!JD(n[f], f)) return;
      } else {
        var m = yn(n);
        if (typeof m == "function") {
          var b = m.call(n);
          if (b) for (var T = b.next(), M = 0; !T.done; T = b.next()) {
            if (!JD(T.value, M)) return;
            M++;
          }
        } else h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
      }
    }
    function gk(n, a, f, m, b) {
      var T = n.memoizedState;
      T === null ? n.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: m,
        tail: f,
        tailMode: b
      } : (T.isBackwards = a, T.rendering = null, T.renderingStartTime = 0, T.last = m, T.tail = f, T.tailMode = b);
    }
    function yk(n, a, f) {
      var m = a.pendingProps,
        b = m.revealOrder,
        T = m.tail,
        M = m.children;
      vk(b), ZD(T, b), eI(M, b), hs(n, a, M, f);
      var z = ps.current,
        U = V_(z, My);
      if (U) z = vp(z, My), a.flags |= ft;else {
        var X = n !== null && (n.flags & ft) !== pt;
        X && QD(a, a.child, f), z = o0(z);
      }
      if (Sv(a, z), (a.mode & Wt) === dt) a.memoizedState = null;else switch (b) {
        case "forwards":
          {
            var J = KP(a.child),
              me;
            J === null ? (me = a.child, a.child = null) : (me = J.sibling, J.sibling = null), gk(a, !1,
            // isBackwards
            me, J, T);
            break;
          }
        case "backwards":
          {
            var xe = null,
              Ie = a.child;
            for (a.child = null; Ie !== null;) {
              var Pe = Ie.alternate;
              if (Pe !== null && ja(Pe) === null) {
                a.child = Ie;
                break;
              }
              var $e = Ie.sibling;
              Ie.sibling = xe, xe = Ie, Ie = $e;
            }
            gk(a, !0,
            // isBackwards
            xe, null,
            // last
            T);
            break;
          }
        case "together":
          {
            gk(a, !1,
            // isBackwards
            null,
            // tail
            null,
            // last
            void 0);
            break;
          }
        default:
          a.memoizedState = null;
      }
      return a.child;
    }
    function QP(n, a, f) {
      N_(a, a.stateNode.containerInfo);
      var m = a.pendingProps;
      return n === null ? a.child = r0(a, null, m, f) : hs(n, a, m, f), a.child;
    }
    var x0 = !1;
    function u1(n, a, f) {
      var m = a.type,
        b = m._context,
        T = a.pendingProps,
        M = a.memoizedProps,
        z = T.value;
      {
        "value" in T || x0 || (x0 = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var U = a.type.propTypes;
        U && hu(U, T, "prop", "Context.Provider");
      }
      if (MS(a, b, z), M !== null) {
        var X = M.value;
        if (he(X, z)) {
          if (M.children === T.children && !by()) return bp(n, a, f);
        } else Zb(a, b, f);
      }
      var J = T.children;
      return hs(n, a, J, f), a.child;
    }
    var yp = !1;
    function ZP(n, a, f) {
      var m = a.type;
      m._context === void 0 ? m !== m.Consumer && (yp || (yp = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : m = m._context;
      var b = a.pendingProps,
        T = b.children;
      typeof T != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Uc(a, f);
      var M = Aa(m);
      Ti(a);
      var z;
      return By.current = a, br(!0), z = T(M), br(!1), to(), a.flags |= Xi, hs(n, a, z, f), a.child;
    }
    function Hy() {
      xc = !0;
    }
    function c1(n, a) {
      (a.mode & Wt) === dt && n !== null && (n.alternate = null, a.alternate = null, a.flags |= Gn);
    }
    function bp(n, a, f) {
      return n !== null && (a.dependencies = n.dependencies), Vf(), Sx(a.lanes), _n(f, a.childLanes) ? (j_(n, a), a.child) : null;
    }
    function S0(n, a, f) {
      {
        var m = a.return;
        if (m === null) throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, a.alternate = null, f.index = a.index, f.sibling = a.sibling, f.return = a.return, f.ref = a.ref, a === m.child) m.child = f;else {
          var b = m.child;
          if (b === null) throw new Error("Expected parent to have a child.");
          for (; b.sibling !== a;) if (b = b.sibling, b === null) throw new Error("Expected to find the previous sibling.");
          b.sibling = f;
        }
        var T = m.deletions;
        return T === null ? (m.deletions = [n], m.flags |= _i) : T.push(n), f.flags |= Gn, f;
      }
    }
    function d1(n, a) {
      var f = n.lanes;
      return !!_n(f, a);
    }
    function tI(n, a, f) {
      switch (a.tag) {
        case C:
          YD(a), a.stateNode, Pa();
          break;
        case D:
          OD(a);
          break;
        case x:
          {
            var m = a.type;
            Bc(m) && wS(a);
            break;
          }
        case k:
          N_(a, a.stateNode.containerInfo);
          break;
        case O:
          {
            var b = a.memoizedProps.value,
              T = a.type._context;
            MS(a, T, b);
            break;
          }
        case j:
          {
            var M = _n(f, a.childLanes);
            M && (a.flags |= tn);
            {
              var z = a.stateNode;
              z.effectDuration = 0, z.passiveEffectDuration = 0;
            }
          }
          break;
        case V:
          {
            var U = a.memoizedState;
            if (U !== null) {
              if (U.dehydrated !== null) return Sv(a, o0(ps.current)), a.flags |= ft, null;
              var X = a.child,
                J = X.childLanes;
              if (_n(f, J)) return hk(n, a, f);
              Sv(a, o0(ps.current));
              var me = bp(n, a, f);
              return me !== null ? me.sibling : null;
            } else Sv(a, o0(ps.current));
            break;
          }
        case Y:
          {
            var xe = (n.flags & ft) !== pt,
              Ie = _n(f, a.childLanes);
            if (xe) {
              if (Ie) return yk(n, a, f);
              a.flags |= ft;
            }
            var Pe = a.memoizedState;
            if (Pe !== null && (Pe.rendering = null, Pe.tail = null, Pe.lastEffect = null), Sv(a, ps.current), Ie) break;
            return null;
          }
        case ae:
        case ne:
          return a.lanes = Re, ek(n, a, f);
      }
      return bp(n, a, f);
    }
    function f1(n, a, f) {
      if (a._debugNeedsRemount && n !== null) return S0(n, a, $k(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (n !== null) {
        var m = n.memoizedProps,
          b = a.pendingProps;
        if (m !== b || by() ||
        // Force a re-render if the implementation changed due to hot reload:
        a.type !== n.type) xc = !0;else {
          var T = d1(n, f);
          if (!T &&
          // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & ft) === pt) return xc = !1, tI(n, a, f);
          (n.flags & Nd) !== pt ? xc = !0 : xc = !1;
        }
      } else if (xc = !1, ts() && SP(a)) {
        var M = a.index,
          z = _y();
        f_(a, z, M);
      }
      switch (a.lanes = Re, a.tag) {
        case E:
          return UP(n, a, a.type, f);
        case Q:
          {
            var U = a.elementType;
            return sk(n, a, U, f);
          }
        case w:
          {
            var X = a.type,
              J = a.pendingProps,
              me = a.elementType === X ? J : wc(X, J);
            return ik(n, a, X, me, f);
          }
        case x:
          {
            var xe = a.type,
              Ie = a.pendingProps,
              Pe = a.elementType === xe ? Ie : wc(xe, Ie);
            return ak(n, a, xe, Pe, f);
          }
        case C:
          return VP(n, a, f);
        case D:
          return BP(n, a, f);
        case I:
          return lk(n, a);
        case V:
          return hk(n, a, f);
        case k:
          return QP(n, a, f);
        case F:
          {
            var $e = a.type,
              mt = a.pendingProps,
              Te = a.elementType === $e ? mt : wc($e, mt);
            return HD(n, a, $e, Te, f);
          }
        case L:
          return tk(n, a, f);
        case P:
          return qD(n, a, f);
        case j:
          return nk(n, a, f);
        case O:
          return u1(n, a, f);
        case N:
          return ZP(n, a, f);
        case K:
          {
            var Ue = a.type,
              Ve = a.pendingProps,
              nt = wc(Ue, Ve);
            if (a.type !== a.elementType) {
              var ke = Ue.propTypes;
              ke && hu(ke, nt,
              // Resolved for outer only
              "prop", bn(Ue));
            }
            return nt = wc(Ue.type, nt), $D(n, a, Ue, nt, f);
          }
        case G:
          return WD(n, a, a.type, a.pendingProps, f);
        case te:
          {
            var Fe = a.type,
              De = a.pendingProps,
              Qe = a.elementType === Fe ? De : wc(Fe, De);
            return uk(n, a, Fe, Qe, f);
          }
        case Y:
          return yk(n, a, f);
        case ee:
          break;
        case ae:
          return ek(n, a, f);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function $y(n) {
      n.flags |= tn;
    }
    function bk(n) {
      n.flags |= Hn, n.flags |= js;
    }
    var E0, Zo, nI, wk;
    E0 = function (n, a, f, m) {
      for (var b = a.child; b !== null;) {
        if (b.tag === D || b.tag === I) FO(n, b.stateNode);else if (b.tag !== k) {
          if (b.child !== null) {
            b.child.return = b, b = b.child;
            continue;
          }
        }
        if (b === a) return;
        for (; b.sibling === null;) {
          if (b.return === null || b.return === a) return;
          b = b.return;
        }
        b.sibling.return = b.return, b = b.sibling;
      }
    }, Zo = function (n, a) {}, nI = function (n, a, f, m, b) {
      var T = n.memoizedProps;
      if (T !== m) {
        var M = a.stateNode,
          z = z_(),
          U = NO(M, f, T, m, b, z);
        a.updateQueue = U, U && $y(a);
      }
    }, wk = function (n, a, f, m) {
      f !== m && $y(a);
    };
    function hx(n, a) {
      if (!ts()) switch (n.tailMode) {
        case "hidden":
          {
            for (var f = n.tail, m = null; f !== null;) f.alternate !== null && (m = f), f = f.sibling;
            m === null ? n.tail = null : m.sibling = null;
            break;
          }
        case "collapsed":
          {
            for (var b = n.tail, T = null; b !== null;) b.alternate !== null && (T = b), b = b.sibling;
            T === null ? !a && n.tail !== null ? n.tail.sibling = null : n.tail = null : T.sibling = null;
            break;
          }
      }
    }
    function yl(n) {
      var a = n.alternate !== null && n.alternate.child === n.child,
        f = Re,
        m = pt;
      if (a) {
        if ((n.mode & nn) !== dt) {
          for (var U = n.selfBaseDuration, X = n.child; X !== null;) f = jt(f, jt(X.lanes, X.childLanes)), m |= X.subtreeFlags & nr, m |= X.flags & nr, U += X.treeBaseDuration, X = X.sibling;
          n.treeBaseDuration = U;
        } else for (var J = n.child; J !== null;) f = jt(f, jt(J.lanes, J.childLanes)), m |= J.subtreeFlags & nr, m |= J.flags & nr, J.return = n, J = J.sibling;
        n.subtreeFlags |= m;
      } else {
        if ((n.mode & nn) !== dt) {
          for (var b = n.actualDuration, T = n.selfBaseDuration, M = n.child; M !== null;) f = jt(f, jt(M.lanes, M.childLanes)), m |= M.subtreeFlags, m |= M.flags, b += M.actualDuration, T += M.treeBaseDuration, M = M.sibling;
          n.actualDuration = b, n.treeBaseDuration = T;
        } else for (var z = n.child; z !== null;) f = jt(f, jt(z.lanes, z.childLanes)), m |= z.subtreeFlags, m |= z.flags, z.return = n, z = z.sibling;
        n.subtreeFlags |= m;
      }
      return n.childLanes = f, a;
    }
    function rI(n, a, f) {
      if (Gb() && (a.mode & Wt) !== dt && (a.flags & ft) === pt) return _C(a), Pa(), a.flags |= qr | Gu | Gr, !1;
      var m = h_(a);
      if (f !== null && f.dehydrated !== null) {
        if (n === null) {
          if (!m) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (CD(a), yl(a), (a.mode & nn) !== dt) {
            var b = f !== null;
            if (b) {
              var T = a.child;
              T !== null && (a.treeBaseDuration -= T.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Pa(), (a.flags & ft) === pt && (a.memoizedState = null), a.flags |= tn, yl(a), (a.mode & nn) !== dt) {
            var M = f !== null;
            if (M) {
              var z = a.child;
              z !== null && (a.treeBaseDuration -= z.treeBaseDuration);
            }
          }
          return !1;
        }
      } else return RS(), !0;
    }
    function mx(n, a, f) {
      var m = a.pendingProps;
      switch (gC(a), a.tag) {
        case E:
        case Q:
        case G:
        case w:
        case F:
        case L:
        case P:
        case j:
        case N:
        case K:
          return yl(a), null;
        case x:
          {
            var b = a.type;
            return Bc(b) && c_(a), yl(a), null;
          }
        case C:
          {
            var T = a.stateNode;
            if (Iy(a), bS(a), Zt(), T.pendingContext && (T.context = T.pendingContext, T.pendingContext = null), n === null || n.child === null) {
              var M = h_(a);
              if (M) $y(a);else if (n !== null) {
                var z = n.memoizedState;
                // Check if this is a client root
                (!z.isDehydrated ||
                // Check if we reverted to client rendering (e.g. due to an error)
                (a.flags & qr) !== pt) && (a.flags |= or, RS());
              }
            }
            return Zo(n, a), yl(a), null;
          }
        case D:
          {
            HS(a);
            var U = Dy(),
              X = a.type;
            if (n !== null && a.stateNode != null) nI(n, a, X, m, U), n.ref !== a.ref && bk(a);else {
              if (!m) {
                if (a.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return yl(a), null;
              }
              var J = z_(),
                me = h_(a);
              if (me) TP(a, U, J) && $y(a);else {
                var xe = jO(X, m, U, J, a);
                E0(xe, a, !1, !1), a.stateNode = xe, iC(xe, X, m, U) && $y(a);
              }
              a.ref !== null && bk(a);
            }
            return yl(a), null;
          }
        case I:
          {
            var Ie = m;
            if (n && a.stateNode != null) {
              var Pe = n.memoizedProps;
              wk(n, a, Pe, Ie);
            } else {
              if (typeof Ie != "string" && a.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var $e = Dy(),
                mt = z_(),
                Te = h_(a);
              Te ? RP(a) && $y(a) : a.stateNode = oC(Ie, $e, mt, a);
            }
            return yl(a), null;
          }
        case V:
          {
            xm(a);
            var Ue = a.memoizedState;
            if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
              var Ve = rI(n, a, Ue);
              if (!Ve) return a.flags & Gr ? a : null;
            }
            if ((a.flags & ft) !== pt) return a.lanes = f, (a.mode & nn) !== dt && sx(a), a;
            var nt = Ue !== null,
              ke = n !== null && n.memoizedState !== null;
            if (nt !== ke && nt) {
              var Fe = a.child;
              if (Fe.flags |= tr, (a.mode & Wt) !== dt) {
                var De = n === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                De || V_(ps.current, $c) ? S1() : Lk();
              }
            }
            var Qe = a.updateQueue;
            if (Qe !== null && (a.flags |= tn), yl(a), (a.mode & nn) !== dt && nt) {
              var Tt = a.child;
              Tt !== null && (a.treeBaseDuration -= Tt.treeBaseDuration);
            }
            return null;
          }
        case k:
          return Iy(a), Zo(n, a), n === null && Hb(a.stateNode.containerInfo), yl(a), null;
        case O:
          var _t = a.type._context;
          return EC(_t, a), yl(a), null;
        case te:
          {
            var an = a.type;
            return Bc(an) && c_(a), yl(a), null;
          }
        case Y:
          {
            xm(a);
            var Gt = a.memoizedState;
            if (Gt === null) return yl(a), null;
            var Pn = (a.flags & ft) !== pt,
              Fn = Gt.rendering;
            if (Fn === null) {
              if (Pn) hx(Gt, !1);else {
                var kr = TA() && (n === null || (n.flags & ft) === pt);
                if (!kr) for (var qn = a.child; qn !== null;) {
                  var Tr = ja(qn);
                  if (Tr !== null) {
                    Pn = !0, a.flags |= ft, hx(Gt, !1);
                    var ai = Tr.updateQueue;
                    return ai !== null && (a.updateQueue = ai, a.flags |= tn), a.subtreeFlags = pt, _v(a, f), Sv(a, vp(ps.current, My)), a.child;
                  }
                  qn = qn.sibling;
                }
                Gt.tail !== null && lr() > Lv() && (a.flags |= ft, Pn = !0, hx(Gt, !1), a.lanes = af);
              }
            } else {
              if (!Pn) {
                var Br = ja(Fn);
                if (Br !== null) {
                  a.flags |= ft, Pn = !0;
                  var ho = Br.updateQueue;
                  if (ho !== null && (a.updateQueue = ho, a.flags |= tn), hx(Gt, !0), Gt.tail === null && Gt.tailMode === "hidden" && !Fn.alternate && !ts()) return yl(a), null;
                } else
                  // The time it took to render last row is greater than the remaining
                  // time we have to render. So rendering one more row would likely
                  // exceed it.
                  lr() * 2 - Gt.renderingStartTime > Lv() && f !== Jr && (a.flags |= ft, Pn = !0, hx(Gt, !1), a.lanes = af);
              }
              if (Gt.isBackwards) Fn.sibling = a.child, a.child = Fn;else {
                var Ro = Gt.last;
                Ro !== null ? Ro.sibling = Fn : a.child = Fn, Gt.last = Fn;
              }
            }
            if (Gt.tail !== null) {
              var nl = Gt.tail;
              Gt.rendering = nl, Gt.tail = nl.sibling, Gt.renderingStartTime = lr(), nl.sibling = null;
              var ta = ps.current;
              return Pn ? ta = vp(ta, My) : ta = o0(ta), Sv(a, ta), nl;
            }
            return yl(a), null;
          }
        case ee:
          break;
        case ae:
        case ne:
          {
            _1(a);
            var Pm = a.memoizedState,
              z0 = Pm !== null;
            if (n !== null) {
              var mT = n.memoizedState,
                Bv = mT !== null;
              Bv !== z0 && (a.flags |= tr);
            }
            return !z0 || (a.mode & Wt) === dt ? yl(a) : _n(Ec, Jr) && (yl(a), a.subtreeFlags & (Gn | tn) && (a.flags |= tr)), null;
          }
        case le:
          return null;
        case ce:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function as(n, a, f) {
      switch (gC(a), a.tag) {
        case x:
          {
            var m = a.type;
            Bc(m) && c_(a);
            var b = a.flags;
            return b & Gr ? (a.flags = b & -65537 | ft, (a.mode & nn) !== dt && sx(a), a) : null;
          }
        case C:
          {
            a.stateNode, Iy(a), bS(a), Zt();
            var T = a.flags;
            return (T & Gr) !== pt && (T & ft) === pt ? (a.flags = T & -65537 | ft, a) : null;
          }
        case D:
          return HS(a), null;
        case V:
          {
            xm(a);
            var M = a.memoizedState;
            if (M !== null && M.dehydrated !== null) {
              if (a.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              Pa();
            }
            var z = a.flags;
            return z & Gr ? (a.flags = z & -65537 | ft, (a.mode & nn) !== dt && sx(a), a) : null;
          }
        case Y:
          return xm(a), null;
        case k:
          return Iy(a), null;
        case O:
          var U = a.type._context;
          return EC(U, a), null;
        case ae:
        case ne:
          return _1(a), null;
        case le:
          return null;
        default:
          return null;
      }
    }
    function iI(n, a, f) {
      switch (gC(a), a.tag) {
        case x:
          {
            var m = a.type.childContextTypes;
            m != null && c_(a);
            break;
          }
        case C:
          {
            a.stateNode, Iy(a), bS(a), Zt();
            break;
          }
        case D:
          {
            HS(a);
            break;
          }
        case k:
          Iy(a);
          break;
        case V:
          xm(a);
          break;
        case Y:
          xm(a);
          break;
        case O:
          var b = a.type._context;
          EC(b, a);
          break;
        case ae:
        case ne:
          _1(a);
          break;
      }
    }
    var dn = null;
    dn = /* @__PURE__ */new Set();
    var Cm = !1,
      Na = !1,
      JP = typeof WeakSet == "function" ? WeakSet : Set,
      fn = null,
      Wy = null,
      Dv = null;
    function eA(n) {
      Vo(null, function () {
        throw n;
      }), Yu();
    }
    var aI = function (n, a) {
      if (a.props = n.memoizedProps, a.state = n.memoizedState, n.mode & nn) try {
        Gc(), a.componentWillUnmount();
      } finally {
        Yc(n);
      } else a.componentWillUnmount();
    };
    function qy(n, a) {
      try {
        Mv(so, n);
      } catch (f) {
        Ni(n, a, f);
      }
    }
    function C0(n, a, f) {
      try {
        aI(n, f);
      } catch (m) {
        Ni(n, a, m);
      }
    }
    function oI(n, a, f) {
      try {
        f.componentDidMount();
      } catch (m) {
        Ni(n, a, m);
      }
    }
    function lI(n, a) {
      try {
        _k(n);
      } catch (f) {
        Ni(n, a, f);
      }
    }
    function k0(n, a) {
      var f = n.ref;
      if (f !== null) if (typeof f == "function") {
        var m;
        try {
          if (Ce && fe && n.mode & nn) try {
            Gc(), m = f(null);
          } finally {
            Yc(n);
          } else m = f(null);
        } catch (b) {
          Ni(n, a, b);
        }
        typeof m == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(n));
      } else f.current = null;
    }
    function p1(n, a, f) {
      try {
        f();
      } catch (m) {
        Ni(n, a, m);
      }
    }
    var sI = !1;
    function Uf(n, a) {
      PO(n.containerInfo), fn = a, Iv();
      var f = sI;
      return sI = !1, f;
    }
    function Iv() {
      for (; fn !== null;) {
        var n = fn,
          a = n.child;
        (n.subtreeFlags & Uo) !== pt && a !== null ? (a.return = n, fn = a) : tA();
      }
    }
    function tA() {
      for (; fn !== null;) {
        var n = fn;
        Rn(n);
        try {
          nA(n);
        } catch (f) {
          Ni(n, n.return, f);
        }
        Un();
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, fn = a;
          return;
        }
        fn = n.return;
      }
    }
    function nA(n) {
      var a = n.alternate,
        f = n.flags;
      if ((f & or) !== pt) {
        switch (Rn(n), n.tag) {
          case w:
          case F:
          case G:
            break;
          case x:
            {
              if (a !== null) {
                var m = a.memoizedProps,
                  b = a.memoizedState,
                  T = n.stateNode;
                n.type === n.elementType && !Uy && (T.props !== n.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(n) || "instance"), T.state !== n.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(n) || "instance"));
                var M = T.getSnapshotBeforeUpdate(n.elementType === n.type ? m : wc(n.type, m), b);
                {
                  var z = dn;
                  M === void 0 && !z.has(n.type) && (z.add(n.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", At(n)));
                }
                T.__reactInternalSnapshotBeforeUpdate = M;
              }
              break;
            }
          case C:
            {
              {
                var U = n.stateNode;
                eP(U.containerInfo);
              }
              break;
            }
          case D:
          case I:
          case k:
          case te:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Un();
      }
    }
    function Hf(n, a, f) {
      var m = a.updateQueue,
        b = m !== null ? m.lastEffect : null;
      if (b !== null) {
        var T = b.next,
          M = T;
        do {
          if ((M.tag & n) === n) {
            var z = M.destroy;
            M.destroy = void 0, z !== void 0 && ((n & Qo) !== Ta ? Bg(a) : (n & so) !== Ta && Mh(a), (n & Ui) !== Ta && kp(!0), p1(a, f, z), (n & Ui) !== Ta && kp(!1), (n & Qo) !== Ta ? Ug() : (n & so) !== Ta && Lh());
          }
          M = M.next;
        } while (M !== T);
      }
    }
    function Mv(n, a) {
      var f = a.updateQueue,
        m = f !== null ? f.lastEffect : null;
      if (m !== null) {
        var b = m.next,
          T = b;
        do {
          if ((T.tag & n) === n) {
            (n & Qo) !== Ta ? Vg(a) : (n & so) !== Ta && Ih(a);
            var M = T.create;
            (n & Ui) !== Ta && kp(!0), T.destroy = M(), (n & Ui) !== Ta && kp(!1), (n & Qo) !== Ta ? Wd() : (n & so) !== Ta && qd();
            {
              var z = T.destroy;
              if (z !== void 0 && typeof z != "function") {
                var U = void 0;
                (T.tag & so) !== pt ? U = "useLayoutEffect" : (T.tag & Ui) !== pt ? U = "useInsertionEffect" : U = "useEffect";
                var X = void 0;
                z === null ? X = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof z.then == "function" ? X = `

It looks like you wrote ` + U + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + U + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : X = " You returned: " + z, h("%s must not return anything besides a function, which is used for clean-up.%s", U, X);
              }
            }
          }
          T = T.next;
        } while (T !== b);
      }
    }
    function uI(n, a) {
      if ((a.flags & tn) !== pt) switch (a.tag) {
        case j:
          {
            var f = a.stateNode.passiveEffectDuration,
              m = a.memoizedProps,
              b = m.id,
              T = m.onPostCommit,
              M = ox(),
              z = a.alternate === null ? "mount" : "update";
            GC() && (z = "nested-update"), typeof T == "function" && T(b, z, f, M);
            var U = a.return;
            e: for (; U !== null;) {
              switch (U.tag) {
                case C:
                  var X = U.stateNode;
                  X.passiveEffectDuration += f;
                  break e;
                case j:
                  var J = U.stateNode;
                  J.passiveEffectDuration += f;
                  break e;
              }
              U = U.return;
            }
            break;
          }
      }
    }
    function rA(n, a, f, m) {
      if ((f.flags & $o) !== pt) switch (f.tag) {
        case w:
        case F:
        case G:
          {
            if (!Na) if (f.mode & nn) try {
              Gc(), Mv(so | Er, f);
            } finally {
              Yc(f);
            } else Mv(so | Er, f);
            break;
          }
        case x:
          {
            var b = f.stateNode;
            if (f.flags & tn && !Na) if (a === null) {
              if (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), f.mode & nn) try {
                Gc(), b.componentDidMount();
              } finally {
                Yc(f);
              } else b.componentDidMount();
            } else {
              var T = f.elementType === f.type ? a.memoizedProps : wc(f.type, a.memoizedProps),
                M = a.memoizedState;
              if (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), f.mode & nn) try {
                Gc(), b.componentDidUpdate(T, M, b.__reactInternalSnapshotBeforeUpdate);
              } finally {
                Yc(f);
              } else b.componentDidUpdate(T, M, b.__reactInternalSnapshotBeforeUpdate);
            }
            var z = f.updateQueue;
            z !== null && (f.type === f.elementType && !Uy && (b.props !== f.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", At(f) || "instance"), b.state !== f.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", At(f) || "instance")), TC(f, z, b));
            break;
          }
        case C:
          {
            var U = f.updateQueue;
            if (U !== null) {
              var X = null;
              if (f.child !== null) switch (f.child.tag) {
                case D:
                  X = f.child.stateNode;
                  break;
                case x:
                  X = f.child.stateNode;
                  break;
              }
              TC(f, U, X);
            }
            break;
          }
        case D:
          {
            var J = f.stateNode;
            if (a === null && f.flags & tn) {
              var me = f.type,
                xe = f.memoizedProps;
              hD(J, me, xe);
            }
            break;
          }
        case I:
          break;
        case k:
          break;
        case j:
          {
            {
              var Ie = f.memoizedProps,
                Pe = Ie.onCommit,
                $e = Ie.onRender,
                mt = f.stateNode.effectDuration,
                Te = ox(),
                Ue = a === null ? "mount" : "update";
              GC() && (Ue = "nested-update"), typeof $e == "function" && $e(f.memoizedProps.id, Ue, f.actualDuration, f.treeBaseDuration, f.actualStartTime, Te);
              {
                typeof Pe == "function" && Pe(f.memoizedProps.id, Ue, mt, Te), DA(f);
                var Ve = f.return;
                e: for (; Ve !== null;) {
                  switch (Ve.tag) {
                    case C:
                      var nt = Ve.stateNode;
                      nt.effectDuration += mt;
                      break e;
                    case j:
                      var ke = Ve.stateNode;
                      ke.effectDuration += mt;
                      break e;
                  }
                  Ve = Ve.return;
                }
              }
            }
            break;
          }
        case V:
          {
            hI(n, f);
            break;
          }
        case Y:
        case te:
        case ee:
        case ae:
        case ne:
        case ce:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      Na || f.flags & Hn && _k(f);
    }
    function cI(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            if (n.mode & nn) try {
              Gc(), qy(n, n.return);
            } finally {
              Yc(n);
            } else qy(n, n.return);
            break;
          }
        case x:
          {
            var a = n.stateNode;
            typeof a.componentDidMount == "function" && oI(n, n.return, a), lI(n, n.return);
            break;
          }
        case D:
          {
            lI(n, n.return);
            break;
          }
      }
    }
    function iA(n, a) {
      for (var f = null, m = n;;) {
        if (m.tag === D) {
          if (f === null) {
            f = m;
            try {
              var b = m.stateNode;
              a ? KO(b) : ZO(m.stateNode, m.memoizedProps);
            } catch (M) {
              Ni(n, n.return, M);
            }
          }
        } else if (m.tag === I) {
          if (f === null) try {
            var T = m.stateNode;
            a ? QO(T) : JO(T, m.memoizedProps);
          } catch (M) {
            Ni(n, n.return, M);
          }
        } else if (!((m.tag === ae || m.tag === ne) && m.memoizedState !== null && m !== n)) {
          if (m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
        }
        if (m === n) return;
        for (; m.sibling === null;) {
          if (m.return === null || m.return === n) return;
          f === m && (f = null), m = m.return;
        }
        f === m && (f = null), m.sibling.return = m.return, m = m.sibling;
      }
    }
    function _k(n) {
      var a = n.ref;
      if (a !== null) {
        var f = n.stateNode,
          m;
        switch (n.tag) {
          case D:
            m = f;
            break;
          default:
            m = f;
        }
        if (typeof a == "function") {
          var b;
          if (n.mode & nn) try {
            Gc(), b = a(m);
          } finally {
            Yc(n);
          } else b = a(m);
          typeof b == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", At(n));
        } else a.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", At(n)), a.current = m;
      }
    }
    function dI(n) {
      var a = n.alternate;
      a !== null && (a.return = null), n.return = null;
    }
    function fI(n) {
      var a = n.alternate;
      a !== null && (n.alternate = null, fI(a));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === D) {
          var f = n.stateNode;
          f !== null && mS(f);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function xk(n) {
      for (var a = n.return; a !== null;) {
        if (h1(a)) return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function h1(n) {
      return n.tag === D || n.tag === C || n.tag === k;
    }
    function bl(n) {
      var a = n;
      e: for (;;) {
        for (; a.sibling === null;) {
          if (a.return === null || h1(a.return)) return null;
          a = a.return;
        }
        for (a.sibling.return = a.return, a = a.sibling; a.tag !== D && a.tag !== I && a.tag !== ie;) {
          if (a.flags & Gn || a.child === null || a.tag === k) continue e;
          a.child.return = a, a = a.child;
        }
        if (!(a.flags & Gn)) return a.stateNode;
      }
    }
    function $f(n) {
      var a = xk(n);
      switch (a.tag) {
        case D:
          {
            var f = a.stateNode;
            a.flags & Ki && (mD(f), a.flags &= -33);
            var m = bl(n);
            wp(n, m, f);
            break;
          }
        case C:
        case k:
          {
            var b = a.stateNode.containerInfo,
              T = bl(n);
            Sk(n, T, b);
            break;
          }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Sk(n, a, f) {
      var m = n.tag,
        b = m === D || m === I;
      if (b) {
        var T = n.stateNode;
        a ? YO(f, T, a) : WO(f, T);
      } else if (m !== k) {
        var M = n.child;
        if (M !== null) {
          Sk(M, a, f);
          for (var z = M.sibling; z !== null;) Sk(z, a, f), z = z.sibling;
        }
      }
    }
    function wp(n, a, f) {
      var m = n.tag,
        b = m === D || m === I;
      if (b) {
        var T = n.stateNode;
        a ? qO(f, T, a) : $O(f, T);
      } else if (m !== k) {
        var M = n.child;
        if (M !== null) {
          wp(M, a, f);
          for (var z = M.sibling; z !== null;) wp(z, a, f), z = z.sibling;
        }
      }
    }
    var wl = null,
      Wf = !1;
    function aA(n, a, f) {
      {
        var m = a;
        e: for (; m !== null;) {
          switch (m.tag) {
            case D:
              {
                wl = m.stateNode, Wf = !1;
                break e;
              }
            case C:
              {
                wl = m.stateNode.containerInfo, Wf = !0;
                break e;
              }
            case k:
              {
                wl = m.stateNode.containerInfo, Wf = !0;
                break e;
              }
          }
          m = m.return;
        }
        if (wl === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        pI(n, a, f), wl = null, Wf = !1;
      }
      dI(f);
    }
    function km(n, a, f) {
      for (var m = f.child; m !== null;) pI(n, a, m), m = m.sibling;
    }
    function pI(n, a, f) {
      switch (Ng(f), f.tag) {
        case D:
          Na || k0(f, a);
        // eslint-disable-next-line-no-fallthrough
        case I:
          {
            {
              var m = wl,
                b = Wf;
              wl = null, km(n, a, f), wl = m, Wf = b, wl !== null && (Wf ? GO(wl, f.stateNode) : sC(wl, f.stateNode));
            }
            return;
          }
        case ie:
          {
            wl !== null && (Wf ? XO(wl, f.stateNode) : uC(wl, f.stateNode));
            return;
          }
        case k:
          {
            {
              var T = wl,
                M = Wf;
              wl = f.stateNode.containerInfo, Wf = !0, km(n, a, f), wl = T, Wf = M;
            }
            return;
          }
        case w:
        case F:
        case K:
        case G:
          {
            if (!Na) {
              var z = f.updateQueue;
              if (z !== null) {
                var U = z.lastEffect;
                if (U !== null) {
                  var X = U.next,
                    J = X;
                  do {
                    var me = J,
                      xe = me.destroy,
                      Ie = me.tag;
                    xe !== void 0 && ((Ie & Ui) !== Ta ? p1(f, a, xe) : (Ie & so) !== Ta && (Mh(f), f.mode & nn ? (Gc(), p1(f, a, xe), Yc(f)) : p1(f, a, xe), Lh())), J = J.next;
                  } while (J !== X);
                }
              }
            }
            km(n, a, f);
            return;
          }
        case x:
          {
            if (!Na) {
              k0(f, a);
              var Pe = f.stateNode;
              typeof Pe.componentWillUnmount == "function" && C0(f, a, Pe);
            }
            km(n, a, f);
            return;
          }
        case ee:
          {
            km(n, a, f);
            return;
          }
        case ae:
          {
            if (
            // TODO: Remove this dead flag
            f.mode & Wt) {
              var $e = Na;
              Na = $e || f.memoizedState !== null, km(n, a, f), Na = $e;
            } else km(n, a, f);
            break;
          }
        default:
          {
            km(n, a, f);
            return;
          }
      }
    }
    function qf(n) {
      n.memoizedState;
    }
    function hI(n, a) {
      var f = a.memoizedState;
      if (f === null) {
        var m = a.alternate;
        if (m !== null) {
          var b = m.memoizedState;
          if (b !== null) {
            var T = b.dehydrated;
            T !== null && uP(T);
          }
        }
      }
    }
    function Yf(n) {
      var a = n.updateQueue;
      if (a !== null) {
        n.updateQueue = null;
        var f = n.stateNode;
        f === null && (f = n.stateNode = new JP()), a.forEach(function (m) {
          var b = MI.bind(null, n, m);
          if (!f.has(m)) {
            if (f.add(m), ui) if (Wy !== null && Dv !== null) P0(Dv, Wy);else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            m.then(b, b);
          }
        });
      }
    }
    function oA(n, a, f) {
      Wy = f, Dv = n, Rn(a), m1(a, n), Rn(a), Wy = null, Dv = null;
    }
    function Kc(n, a, f) {
      var m = a.deletions;
      if (m !== null) for (var b = 0; b < m.length; b++) {
        var T = m[b];
        try {
          aA(n, a, T);
        } catch (U) {
          Ni(T, a, U);
        }
      }
      var M = Mu();
      if (a.subtreeFlags & Ho) for (var z = a.child; z !== null;) Rn(z), m1(z, n), z = z.sibling;
      Rn(M);
    }
    function m1(n, a, f) {
      var m = n.alternate,
        b = n.flags;
      switch (n.tag) {
        case w:
        case F:
        case K:
        case G:
          {
            if (Kc(a, n), _p(n), b & tn) {
              try {
                Hf(Ui | Er, n, n.return), Mv(Ui | Er, n);
              } catch (an) {
                Ni(n, n.return, an);
              }
              if (n.mode & nn) {
                try {
                  Gc(), Hf(so | Er, n, n.return);
                } catch (an) {
                  Ni(n, n.return, an);
                }
                Yc(n);
              } else try {
                Hf(so | Er, n, n.return);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case x:
          {
            Kc(a, n), _p(n), b & Hn && m !== null && k0(m, m.return);
            return;
          }
        case D:
          {
            Kc(a, n), _p(n), b & Hn && m !== null && k0(m, m.return);
            {
              if (n.flags & Ki) {
                var T = n.stateNode;
                try {
                  mD(T);
                } catch (an) {
                  Ni(n, n.return, an);
                }
              }
              if (b & tn) {
                var M = n.stateNode;
                if (M != null) {
                  var z = n.memoizedProps,
                    U = m !== null ? m.memoizedProps : z,
                    X = n.type,
                    J = n.updateQueue;
                  if (n.updateQueue = null, J !== null) try {
                    UO(M, J, X, U, z, n);
                  } catch (an) {
                    Ni(n, n.return, an);
                  }
                }
              }
            }
            return;
          }
        case I:
          {
            if (Kc(a, n), _p(n), b & tn) {
              if (n.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var me = n.stateNode,
                xe = n.memoizedProps,
                Ie = m !== null ? m.memoizedProps : xe;
              try {
                HO(me, Ie, xe);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case C:
          {
            if (Kc(a, n), _p(n), b & tn && m !== null) {
              var Pe = m.memoizedState;
              if (Pe.isDehydrated) try {
                sP(a.containerInfo);
              } catch (an) {
                Ni(n, n.return, an);
              }
            }
            return;
          }
        case k:
          {
            Kc(a, n), _p(n);
            return;
          }
        case V:
          {
            Kc(a, n), _p(n);
            var $e = n.child;
            if ($e.flags & tr) {
              var mt = $e.stateNode,
                Te = $e.memoizedState,
                Ue = Te !== null;
              if (mt.isHidden = Ue, Ue) {
                var Ve = $e.alternate !== null && $e.alternate.memoizedState !== null;
                Ve || CA();
              }
            }
            if (b & tn) {
              try {
                qf(n);
              } catch (an) {
                Ni(n, n.return, an);
              }
              Yf(n);
            }
            return;
          }
        case ae:
          {
            var nt = m !== null && m.memoizedState !== null;
            if (
            // TODO: Remove this dead flag
            n.mode & Wt) {
              var ke = Na;
              Na = ke || nt, Kc(a, n), Na = ke;
            } else Kc(a, n);
            if (_p(n), b & tr) {
              var Fe = n.stateNode,
                De = n.memoizedState,
                Qe = De !== null,
                Tt = n;
              if (Fe.isHidden = Qe, Qe && !nt && (Tt.mode & Wt) !== dt) {
                fn = Tt;
                for (var _t = Tt.child; _t !== null;) fn = _t, lA(_t), _t = _t.sibling;
              }
              iA(Tt, Qe);
            }
            return;
          }
        case Y:
          {
            Kc(a, n), _p(n), b & tn && Yf(n);
            return;
          }
        case ee:
          return;
        default:
          {
            Kc(a, n), _p(n);
            return;
          }
      }
    }
    function _p(n) {
      var a = n.flags;
      if (a & Gn) {
        try {
          $f(n);
        } catch (f) {
          Ni(n, n.return, f);
        }
        n.flags &= -3;
      }
      a & xi && (n.flags &= -4097);
    }
    function mI(n, a, f) {
      Wy = f, Dv = a, fn = n, vI(n, a, f), Wy = null, Dv = null;
    }
    function vI(n, a, f) {
      for (var m = (n.mode & Wt) !== dt; fn !== null;) {
        var b = fn,
          T = b.child;
        if (b.tag === ae && m) {
          var M = b.memoizedState !== null,
            z = M || Cm;
          if (z) {
            v1(n, a, f);
            continue;
          } else {
            var U = b.alternate,
              X = U !== null && U.memoizedState !== null,
              J = X || Na,
              me = Cm,
              xe = Na;
            Cm = z, Na = J, Na && !xe && (fn = b, sA(b));
            for (var Ie = T; Ie !== null;) fn = Ie, vI(Ie,
            // New root; bubble back up to here and stop.
            a, f), Ie = Ie.sibling;
            fn = b, Cm = me, Na = xe, v1(n, a, f);
            continue;
          }
        }
        (b.subtreeFlags & $o) !== pt && T !== null ? (T.return = b, fn = T) : v1(n, a, f);
      }
    }
    function v1(n, a, f) {
      for (; fn !== null;) {
        var m = fn;
        if ((m.flags & $o) !== pt) {
          var b = m.alternate;
          Rn(m);
          try {
            rA(a, b, m, f);
          } catch (M) {
            Ni(m, m.return, M);
          }
          Un();
        }
        if (m === n) {
          fn = null;
          return;
        }
        var T = m.sibling;
        if (T !== null) {
          T.return = m.return, fn = T;
          return;
        }
        fn = m.return;
      }
    }
    function lA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.child;
        switch (a.tag) {
          case w:
          case F:
          case K:
          case G:
            {
              if (a.mode & nn) try {
                Gc(), Hf(so, a, a.return);
              } finally {
                Yc(a);
              } else Hf(so, a, a.return);
              break;
            }
          case x:
            {
              k0(a, a.return);
              var m = a.stateNode;
              typeof m.componentWillUnmount == "function" && C0(a, a.return, m);
              break;
            }
          case D:
            {
              k0(a, a.return);
              break;
            }
          case ae:
            {
              var b = a.memoizedState !== null;
              if (b) {
                gI(n);
                continue;
              }
              break;
            }
        }
        f !== null ? (f.return = a, fn = f) : gI(n);
      }
    }
    function gI(n) {
      for (; fn !== null;) {
        var a = fn;
        if (a === n) {
          fn = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, fn = f;
          return;
        }
        fn = a.return;
      }
    }
    function sA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.child;
        if (a.tag === ae) {
          var m = a.memoizedState !== null;
          if (m) {
            yI(n);
            continue;
          }
        }
        f !== null ? (f.return = a, fn = f) : yI(n);
      }
    }
    function yI(n) {
      for (; fn !== null;) {
        var a = fn;
        Rn(a);
        try {
          cI(a);
        } catch (m) {
          Ni(a, a.return, m);
        }
        if (Un(), a === n) {
          fn = null;
          return;
        }
        var f = a.sibling;
        if (f !== null) {
          f.return = a.return, fn = f;
          return;
        }
        fn = a.return;
      }
    }
    function uA(n, a, f, m) {
      fn = a, cA(a, n, f, m);
    }
    function cA(n, a, f, m) {
      for (; fn !== null;) {
        var b = fn,
          T = b.child;
        (b.subtreeFlags & Ja) !== pt && T !== null ? (T.return = b, fn = T) : dA(n, a, f, m);
      }
    }
    function dA(n, a, f, m) {
      for (; fn !== null;) {
        var b = fn;
        if ((b.flags & Yr) !== pt) {
          Rn(b);
          try {
            fA(a, b, f, m);
          } catch (M) {
            Ni(b, b.return, M);
          }
          Un();
        }
        if (b === n) {
          fn = null;
          return;
        }
        var T = b.sibling;
        if (T !== null) {
          T.return = b.return, fn = T;
          return;
        }
        fn = b.return;
      }
    }
    function fA(n, a, f, m) {
      switch (a.tag) {
        case w:
        case F:
        case G:
          {
            if (a.mode & nn) {
              KC();
              try {
                Mv(Qo | Er, a);
              } finally {
                Em(a);
              }
            } else Mv(Qo | Er, a);
            break;
          }
      }
    }
    function pA(n) {
      fn = n, hA();
    }
    function hA() {
      for (; fn !== null;) {
        var n = fn,
          a = n.child;
        if ((fn.flags & _i) !== pt) {
          var f = n.deletions;
          if (f !== null) {
            for (var m = 0; m < f.length; m++) {
              var b = f[m];
              fn = b, gA(b, n);
            }
            {
              var T = n.alternate;
              if (T !== null) {
                var M = T.child;
                if (M !== null) {
                  T.child = null;
                  do {
                    var z = M.sibling;
                    M.sibling = null, M = z;
                  } while (M !== null);
                }
              }
            }
            fn = n;
          }
        }
        (n.subtreeFlags & Ja) !== pt && a !== null ? (a.return = n, fn = a) : mA();
      }
    }
    function mA() {
      for (; fn !== null;) {
        var n = fn;
        (n.flags & Yr) !== pt && (Rn(n), vA(n), Un());
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, fn = a;
          return;
        }
        fn = n.return;
      }
    }
    function vA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            n.mode & nn ? (KC(), Hf(Qo | Er, n, n.return), Em(n)) : Hf(Qo | Er, n, n.return);
            break;
          }
      }
    }
    function gA(n, a) {
      for (; fn !== null;) {
        var f = fn;
        Rn(f), bA(f, a), Un();
        var m = f.child;
        m !== null ? (m.return = f, fn = m) : yA(n);
      }
    }
    function yA(n) {
      for (; fn !== null;) {
        var a = fn,
          f = a.sibling,
          m = a.return;
        if (fI(a), a === n) {
          fn = null;
          return;
        }
        if (f !== null) {
          f.return = m, fn = f;
          return;
        }
        fn = m;
      }
    }
    function bA(n, a) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            n.mode & nn ? (KC(), Hf(Qo, n, a), Em(n)) : Hf(Qo, n, a);
            break;
          }
      }
    }
    function vx(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Mv(so | Er, n);
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
        case x:
          {
            var a = n.stateNode;
            try {
              a.componentDidMount();
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
      }
    }
    function wA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Mv(Qo | Er, n);
            } catch (a) {
              Ni(n, n.return, a);
            }
            break;
          }
      }
    }
    function _A(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          {
            try {
              Hf(so | Er, n, n.return);
            } catch (f) {
              Ni(n, n.return, f);
            }
            break;
          }
        case x:
          {
            var a = n.stateNode;
            typeof a.componentWillUnmount == "function" && C0(n, n.return, a);
            break;
          }
      }
    }
    function xA(n) {
      switch (n.tag) {
        case w:
        case F:
        case G:
          try {
            Hf(Qo | Er, n, n.return);
          } catch (a) {
            Ni(n, n.return, a);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var gx = Symbol.for;
      gx("selector.component"), gx("selector.has_pseudo_class"), gx("selector.role"), gx("selector.test_id"), gx("selector.text");
    }
    var bI = [];
    function SA() {
      bI.forEach(function (n) {
        return n();
      });
    }
    var Ek = i.ReactCurrentActQueue;
    function Ck(n) {
      {
        var a =
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
          f = typeof jest < "u";
        return f && a !== !1;
      }
    }
    function _l() {
      {
        var n =
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
        return !n && Ek.current !== null && h("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var Gf = Math.ceil,
      fo = i.ReactCurrentDispatcher,
      g1 = i.ReactCurrentOwner,
      Ar = i.ReactCurrentBatchConfig,
      za = i.ReactCurrentActQueue,
      ji = /*             */
      0,
      T0 = /*               */
      1,
      Da = /*                */
      2,
      iu = /*                */
      4,
      Sc = 0,
      R0 = 1,
      Tm = 2,
      cr = 3,
      Jo = 4,
      da = 5,
      po = 6,
      Wn = ji,
      os = null,
      sr = null,
      Ia = Re,
      Ec = Re,
      Yy = ka(Re),
      Va = Sc,
      Rm = null,
      ls = Re,
      Gy = Re,
      yx = Re,
      D0 = null,
      wu = null,
      Xf = 0,
      I0 = 500,
      kk = 1 / 0,
      y1 = 500,
      Kf = null;
    function xp() {
      kk = lr() + y1;
    }
    function Lv() {
      return kk;
    }
    var Qf = !1,
      Xy = null,
      Ov = null,
      Dm = !1,
      Pv = null,
      Im = Re,
      bx = [],
      wx = null,
      b1 = 50,
      _x = 0,
      Av = null,
      M0 = !1,
      Ky = !1,
      w1 = 50,
      Qy = 0,
      Zy = null,
      el = wn,
      Zf = Re,
      wI = !1;
    function Ba() {
      return os;
    }
    function au() {
      return (Wn & (Da | iu)) !== ji ? lr() : (el !== wn || (el = lr()), el);
    }
    function jv(n) {
      var a = n.mode;
      if ((a & Wt) === dt) return Je;
      if ((Wn & Da) !== ji && Ia !== Re) return Xs(Ia);
      var f = IP() !== If;
      if (f) {
        if (Ar.transition !== null) {
          var m = Ar.transition;
          m._updatedFibers || (m._updatedFibers = /* @__PURE__ */new Set()), m._updatedFibers.add(n);
        }
        return Zf === Ln && (Zf = Vh()), Zf;
      }
      var b = zr();
      if (b !== Ln) return b;
      var T = zO();
      return T;
    }
    function _u(n) {
      var a = n.mode;
      return (a & Wt) === dt ? Je : Zg();
    }
    function To(n, a, f, m) {
      C1(), wI && h("useInsertionEffect must not schedule updates."), M0 && (Ky = !0), lc(n, f, m), (Wn & Da) !== Re && n === os ? OI(a) : (ui && df(n, a, f), j0(a), n === os && ((Wn & Da) === ji && (Gy = jt(Gy, f)), Va === Jo && Fv(n, Ia)), xu(n, m), f === Je && Wn === ji && (a.mode & Wt) === dt &&
      // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !za.isBatchingLegacy && (xp(), wy()));
    }
    function Tk(n, a, f) {
      var m = n.current;
      m.lanes = a, lc(n, a, f), xu(n, f);
    }
    function _I(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Wn & Da) !== ji
      );
    }
    function xu(n, a) {
      var f = n.callbackNode;
      Xg(n, a);
      var m = lf(n, n === os ? Ia : Re);
      if (m === Re) {
        f !== null && A0(f), n.callbackNode = null, n.callbackPriority = Ln;
        return;
      }
      var b = Go(m),
        T = n.callbackPriority;
      if (T === b &&
      // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(za.current !== null && f !== Ak)) {
        f == null && T !== Je && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && A0(f);
      var M;
      if (b === Je) n.tag === fs ? (za.isBatchingLegacy !== null && (za.didScheduleLegacyUpdate = !0), vv(Ep.bind(null, n))) : mC(Ep.bind(null, n)), za.current !== null ? za.current.push(bc) : VO(function () {
        (Wn & (Da | iu)) === ji && bc();
      }), M = null;else {
        var z;
        switch (fr(m)) {
          case Ii:
            z = Xu;
            break;
          case Zi:
            z = Wo;
            break;
          case ol:
            z = eo;
            break;
          case ll:
            z = si;
            break;
          default:
            z = eo;
            break;
        }
        M = jk(z, xI.bind(null, n));
      }
      n.callbackPriority = b, n.callbackNode = M;
    }
    function xI(n, a) {
      if (XC(), el = wn, Zf = Re, (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      var f = n.callbackNode,
        m = Mm();
      if (m && n.callbackNode !== f) return null;
      var b = lf(n, n === os ? Ia : Re);
      if (b === Re) return null;
      var T = !Gs(n, b) && !Aw(n, b) && !a,
        M = T ? eb(n, b) : Ex(n, b);
      if (M !== Sc) {
        if (M === Tm) {
          var z = qs(n);
          z !== Re && (b = z, M = Sp(n, z));
        }
        if (M === R0) {
          var U = Rm;
          throw Jy(n, Re), Fv(n, b), xu(n, lr()), U;
        }
        if (M === po) Fv(n, b);else {
          var X = !Gs(n, b),
            J = n.current.alternate;
          if (X && !Dk(J)) {
            if (M = Ex(n, b), M === Tm) {
              var me = qs(n);
              me !== Re && (b = me, M = Sp(n, me));
            }
            if (M === R0) {
              var xe = Rm;
              throw Jy(n, Re), Fv(n, b), xu(n, lr()), xe;
            }
          }
          n.finishedWork = J, n.finishedLanes = b, EA(n, M, b);
        }
      }
      return xu(n, lr()), n.callbackNode === f ? xI.bind(null, n) : null;
    }
    function Sp(n, a) {
      var f = D0;
      if ($h(n)) {
        var m = Jy(n, a);
        m.flags |= qr, Ub(n.containerInfo);
      }
      var b = Ex(n, a);
      if (b !== Tm) {
        var T = wu;
        wu = f, T !== null && Rk(T);
      }
      return b;
    }
    function Rk(n) {
      wu === null ? wu = n : wu.push.apply(wu, n);
    }
    function EA(n, a, f) {
      switch (a) {
        case Sc:
        case R0:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Tm:
          {
            tb(n, wu, Kf);
            break;
          }
        case cr:
          {
            if (Fv(n, f), Qg(f) &&
            // do not delay if we're inside an act() scope
            !Cc()) {
              var m = Xf + I0 - lr();
              if (m > 10) {
                var b = lf(n, Re);
                if (b !== Re) break;
                var T = n.suspendedLanes;
                if (!$l(T, f)) {
                  au(), Qm(n, T);
                  break;
                }
                n.timeoutHandle = n_(tb.bind(null, n, wu, Kf), m);
                break;
              }
            }
            tb(n, wu, Kf);
            break;
          }
        case Jo:
          {
            if (Fv(n, f), Nh(f)) break;
            if (!Cc()) {
              var M = Ow(n, f),
                z = M,
                U = lr() - z,
                X = E1(U) - U;
              if (X > 10) {
                n.timeoutHandle = n_(tb.bind(null, n, wu, Kf), X);
                break;
              }
            }
            tb(n, wu, Kf);
            break;
          }
        case da:
          {
            tb(n, wu, Kf);
            break;
          }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function Dk(n) {
      for (var a = n;;) {
        if (a.flags & As) {
          var f = a.updateQueue;
          if (f !== null) {
            var m = f.stores;
            if (m !== null) for (var b = 0; b < m.length; b++) {
              var T = m[b],
                M = T.getSnapshot,
                z = T.value;
              try {
                if (!he(M(), z)) return !1;
              } catch {
                return !1;
              }
            }
          }
        }
        var U = a.child;
        if (a.subtreeFlags & As && U !== null) {
          U.return = a, a = U;
          continue;
        }
        if (a === n) return !0;
        for (; a.sibling === null;) {
          if (a.return === null || a.return === n) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function Fv(n, a) {
      a = ac(a, yx), a = ac(a, Gy), Km(n, a);
    }
    function Ep(n) {
      if (VD(), (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      Mm();
      var a = lf(n, Re);
      if (!_n(a, Je)) return xu(n, lr()), null;
      var f = Ex(n, a);
      if (n.tag !== fs && f === Tm) {
        var m = qs(n);
        m !== Re && (a = m, f = Sp(n, m));
      }
      if (f === R0) {
        var b = Rm;
        throw Jy(n, Re), Fv(n, a), xu(n, lr()), b;
      }
      if (f === po) throw new Error("Root did not complete. This is a bug in React.");
      var T = n.current.alternate;
      return n.finishedWork = T, n.finishedLanes = a, tb(n, wu, Kf), xu(n, lr()), null;
    }
    function SI(n, a) {
      a !== Re && (cf(n, jt(a, Je)), xu(n, lr()), (Wn & (Da | iu)) === ji && (xp(), bc()));
    }
    function L0(n, a) {
      var f = Wn;
      Wn |= T0;
      try {
        return n(a);
      } finally {
        Wn = f, Wn === ji &&
        // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !za.isBatchingLegacy && (xp(), wy());
      }
    }
    function Ik(n, a, f, m, b) {
      var T = zr(),
        M = Ar.transition;
      try {
        return Ar.transition = null, sa(Ii), n(a, f, m, b);
      } finally {
        sa(T), Ar.transition = M, Wn === ji && xp();
      }
    }
    function ou(n) {
      Pv !== null && Pv.tag === fs && (Wn & (Da | iu)) === ji && Mm();
      var a = Wn;
      Wn |= T0;
      var f = Ar.transition,
        m = zr();
      try {
        return Ar.transition = null, sa(Ii), n ? n() : void 0;
      } finally {
        sa(m), Ar.transition = f, Wn = a, (Wn & (Da | iu)) === ji && bc();
      }
    }
    function Mk() {
      return (Wn & (Da | iu)) !== ji;
    }
    function xx(n, a) {
      fi(Yy, Ec, n), Ec = jt(Ec, a);
    }
    function _1(n) {
      Ec = Yy.current, fl(Yy, n);
    }
    function Jy(n, a) {
      n.finishedWork = null, n.finishedLanes = Re;
      var f = n.timeoutHandle;
      if (f !== lC && (n.timeoutHandle = lC, fD(f)), sr !== null) for (var m = sr.return; m !== null;) {
        var b = m.alternate;
        iI(b, m), m = m.return;
      }
      os = n;
      var T = Lm(n.current, null);
      return sr = T, Ia = Ec = a, Va = Sc, Rm = null, ls = Re, Gy = Re, yx = Re, D0 = null, wu = null, MP(), ns.discardPendingWarnings(), T;
    }
    function O0(n, a) {
      do {
        var f = sr;
        try {
          if (g_(), _c(), Un(), g1.current = null, f === null || f.return === null) {
            Va = R0, Rm = a, sr = null;
            return;
          }
          if (Ce && f.mode & nn && y0(f, !0), Ee) if (to(), a !== null && typeof a == "object" && typeof a.then == "function") {
            var m = a;
            Oh(f, m, Ia);
          } else Hg(f, a, Ia);
          JC(n, f.return, f, a, Ia), kI(f);
        } catch (b) {
          a = b, sr === f && f !== null ? (f = f.return, sr = f) : f = sr;
          continue;
        }
        return;
      } while (!0);
    }
    function EI() {
      var n = fo.current;
      return fo.current = rx, n === null ? rx : n;
    }
    function x1(n) {
      fo.current = n;
    }
    function CA() {
      Xf = lr();
    }
    function Sx(n) {
      ls = jt(n, ls);
    }
    function S1() {
      Va === Sc && (Va = cr);
    }
    function Lk() {
      (Va === Sc || Va === cr || Va === Tm) && (Va = Jo), os !== null && (Fh(ls) || Fh(Gy)) && Fv(os, Ia);
    }
    function kA(n) {
      Va !== Jo && (Va = Tm), D0 === null ? D0 = [n] : D0.push(n);
    }
    function TA() {
      return Va === Sc;
    }
    function Ex(n, a) {
      var f = Wn;
      Wn |= Da;
      var m = EI();
      if (os !== n || Ia !== a) {
        if (ui) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (P0(n, Ia), b.clear()), sc(n, a);
        }
        Kf = al(), Jy(n, a);
      }
      Vl(a);
      do try {
        CI();
        break;
      } catch (T) {
        O0(n, T);
      } while (!0);
      if (g_(), Wn = f, x1(m), sr !== null) throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Ns(), os = null, Ia = Re, Va;
    }
    function CI() {
      for (; sr !== null;) Cp(sr);
    }
    function eb(n, a) {
      var f = Wn;
      Wn |= Da;
      var m = EI();
      if (os !== n || Ia !== a) {
        if (ui) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (P0(n, Ia), b.clear()), sc(n, a);
        }
        Kf = al(), xp(), Jy(n, a);
      }
      Vl(a);
      do try {
        RA();
        break;
      } catch (T) {
        O0(n, T);
      } while (!0);
      return g_(), x1(m), Wn = f, sr !== null ? (qg(), Sc) : (Ns(), os = null, Ia = Re, Va);
    }
    function RA() {
      for (; sr !== null && !kh();) Cp(sr);
    }
    function Cp(n) {
      var a = n.alternate;
      Rn(n);
      var f;
      (n.mode & nn) !== dt ? (lx(n), f = Pk(a, n, Ec), y0(n, !0)) : f = Pk(a, n, Ec), Un(), n.memoizedProps = n.pendingProps, f === null ? kI(n) : sr = f, g1.current = null;
    }
    function kI(n) {
      var a = n;
      do {
        var f = a.alternate,
          m = a.return;
        if ((a.flags & Gu) === pt) {
          Rn(a);
          var b = void 0;
          if ((a.mode & nn) === dt ? b = mx(f, a, Ec) : (lx(a), b = mx(f, a, Ec), y0(a, !1)), Un(), b !== null) {
            sr = b;
            return;
          }
        } else {
          var T = as(f, a);
          if (T !== null) {
            T.flags &= Ag, sr = T;
            return;
          }
          if ((a.mode & nn) !== dt) {
            y0(a, !1);
            for (var M = a.actualDuration, z = a.child; z !== null;) M += z.actualDuration, z = z.sibling;
            a.actualDuration = M;
          }
          if (m !== null) m.flags |= Gu, m.subtreeFlags = pt, m.deletions = null;else {
            Va = po, sr = null;
            return;
          }
        }
        var U = a.sibling;
        if (U !== null) {
          sr = U;
          return;
        }
        a = m, sr = a;
      } while (a !== null);
      Va === Sc && (Va = da);
    }
    function tb(n, a, f) {
      var m = zr(),
        b = Ar.transition;
      try {
        Ar.transition = null, sa(Ii), TI(n, a, f, m);
      } finally {
        Ar.transition = b, sa(m);
      }
      return null;
    }
    function TI(n, a, f, m) {
      do Mm(); while (Pv !== null);
      if (LI(), (Wn & (Da | iu)) !== ji) throw new Error("Should not already be working.");
      var b = n.finishedWork,
        T = n.finishedLanes;
      if (zg(T), b === null) return wa(), null;
      if (T === Re && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = Re, b === n.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = Ln;
      var M = jt(b.lanes, b.childLanes);
      uf(n, M), n === os && (os = null, sr = null, Ia = Re), ((b.subtreeFlags & Ja) !== pt || (b.flags & Ja) !== pt) && (Dm || (Dm = !0, wx = f, jk(eo, function () {
        return Mm(), null;
      })));
      var z = (b.subtreeFlags & (Uo | Ho | $o | Ja)) !== pt,
        U = (b.flags & (Uo | Ho | $o | Ja)) !== pt;
      if (z || U) {
        var X = Ar.transition;
        Ar.transition = null;
        var J = zr();
        sa(Ii);
        var me = Wn;
        Wn |= iu, g1.current = null, Uf(n, b), zf(), oA(n, b, T), AO(n.containerInfo), n.current = b, Ku(T), mI(b, n, T), Yd(), Th(), Wn = me, sa(J), Ar.transition = X;
      } else n.current = b, zf();
      var xe = Dm;
      if (Dm ? (Dm = !1, Pv = n, Im = T) : (Qy = 0, Zy = null), M = n.pendingLanes, M === Re && (Ov = null), xe || k1(n.current, !1), zl(b.stateNode, m), ui && n.memoizedUpdaters.clear(), SA(), xu(n, lr()), a !== null) for (var Ie = n.onRecoverableError, Pe = 0; Pe < a.length; Pe++) {
        var $e = a[Pe],
          mt = $e.stack,
          Te = $e.digest;
        Ie($e.value, {
          componentStack: mt,
          digest: Te
        });
      }
      if (Qf) {
        Qf = !1;
        var Ue = Xy;
        throw Xy = null, Ue;
      }
      return _n(Im, Je) && n.tag !== fs && Mm(), M = n.pendingLanes, _n(M, Je) ? (zD(), n === Av ? _x++ : (_x = 0, Av = n)) : _x = 0, bc(), wa(), null;
    }
    function Mm() {
      if (Pv !== null) {
        var n = fr(Im),
          a = Hh(ol, n),
          f = Ar.transition,
          m = zr();
        try {
          return Ar.transition = null, sa(a), IA();
        } finally {
          sa(m), Ar.transition = f;
        }
      }
      return !1;
    }
    function DA(n) {
      bx.push(n), Dm || (Dm = !0, jk(eo, function () {
        return Mm(), null;
      }));
    }
    function IA() {
      if (Pv === null) return !1;
      var n = wx;
      wx = null;
      var a = Pv,
        f = Im;
      if (Pv = null, Im = Re, (Wn & (Da | iu)) !== ji) throw new Error("Cannot flush passive effects while already rendering.");
      M0 = !0, Ky = !1, $g(f);
      var m = Wn;
      Wn |= iu, pA(a.current), uA(a, a.current, f, n);
      {
        var b = bx;
        bx = [];
        for (var T = 0; T < b.length; T++) {
          var M = b[T];
          uI(a, M);
        }
      }
      Wg(), k1(a.current, !0), Wn = m, bc(), Ky ? a === Zy ? Qy++ : (Qy = 0, Zy = a) : Qy = 0, M0 = !1, Ky = !1, Rh(a);
      {
        var z = a.current.stateNode;
        z.effectDuration = 0, z.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Ok(n) {
      return Ov !== null && Ov.has(n);
    }
    function Fi(n) {
      Ov === null ? Ov = /* @__PURE__ */new Set([n]) : Ov.add(n);
    }
    function MA(n) {
      Qf || (Qf = !0, Xy = n);
    }
    var RI = MA;
    function DI(n, a, f) {
      var m = Vy(f, a),
        b = BD(n, m, Je),
        T = mp(n, b, Je),
        M = au();
      T !== null && (lc(T, Je, M), xu(T, M));
    }
    function Ni(n, a, f) {
      if (eA(f), kp(!1), n.tag === C) {
        DI(n, n, f);
        return;
      }
      var m = null;
      for (m = a; m !== null;) {
        if (m.tag === C) {
          DI(m, n, f);
          return;
        } else if (m.tag === x) {
          var b = m.type,
            T = m.stateNode;
          if (typeof b.getDerivedStateFromError == "function" || typeof T.componentDidCatch == "function" && !Ok(T)) {
            var M = Vy(f, n),
              z = o1(m, M, Je),
              U = mp(m, z, Je),
              X = au();
            U !== null && (lc(U, Je, X), xu(U, X));
            return;
          }
        }
        m = m.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function LA(n, a, f) {
      var m = n.pingCache;
      m !== null && m.delete(a);
      var b = au();
      Qm(n, f), PA(n), os === n && $l(Ia, f) && (Va === Jo || Va === cr && Qg(Ia) && lr() - Xf < I0 ? Jy(n, Re) : yx = jt(yx, f)), xu(n, b);
    }
    function II(n, a) {
      a === Ln && (a = _u(n));
      var f = au(),
        m = rs(n, a);
      m !== null && (lc(m, a, f), xu(m, f));
    }
    function OA(n) {
      var a = n.memoizedState,
        f = Ln;
      a !== null && (f = a.retryLane), II(n, f);
    }
    function MI(n, a) {
      var f = Ln,
        m;
      switch (n.tag) {
        case V:
          m = n.stateNode;
          var b = n.memoizedState;
          b !== null && (f = b.retryLane);
          break;
        case Y:
          m = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      m !== null && m.delete(a), II(n, f);
    }
    function E1(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : Gf(n / 1960) * 1960;
    }
    function C1() {
      if (_x > b1) throw _x = 0, Av = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Qy > w1 && (Qy = 0, Zy = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function LI() {
      ns.flushLegacyContextWarning(), ns.flushPendingUnsafeLifecycleWarnings();
    }
    function k1(n, a) {
      Rn(n), T1(n, Bo, _A), a && T1(n, ga, xA), T1(n, Bo, vx), a && T1(n, ga, wA), Un();
    }
    function T1(n, a, f) {
      for (var m = n, b = null; m !== null;) {
        var T = m.subtreeFlags & a;
        m !== b && m.child !== null && T !== pt ? m = m.child : ((m.flags & a) !== pt && f(m), m.sibling !== null ? m = m.sibling : m = b = m.return);
      }
    }
    var Cx = null;
    function R1(n) {
      {
        if ((Wn & Da) !== ji || !(n.mode & Wt)) return;
        var a = n.tag;
        if (a !== E && a !== C && a !== x && a !== w && a !== F && a !== K && a !== G) return;
        var f = At(n) || "ReactComponent";
        if (Cx !== null) {
          if (Cx.has(f)) return;
          Cx.add(f);
        } else Cx = /* @__PURE__ */new Set([f]);
        var m = Pr;
        try {
          Rn(n), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          m ? Rn(n) : Un();
        }
      }
    }
    var Pk;
    {
      var kx = null;
      Pk = function (n, a, f) {
        var m = zI(kx, a);
        try {
          return f1(n, a, f);
        } catch (T) {
          if (kP() || T !== null && typeof T == "object" && typeof T.then == "function") throw T;
          if (g_(), _c(), iI(n, a), zI(a, m), a.mode & nn && lx(a), Vo(null, f1, null, n, a, f), Qa()) {
            var b = Yu();
            typeof b == "object" && b !== null && b._suppressLogging && typeof T == "object" && T !== null && !T._suppressLogging && (T._suppressLogging = !0);
          }
          throw T;
        }
      };
    }
    var D1 = !1,
      Tx;
    Tx = /* @__PURE__ */new Set();
    function OI(n) {
      if (Po && !jP()) switch (n.tag) {
        case w:
        case F:
        case G:
          {
            var a = sr && At(sr) || "Unknown",
              f = a;
            if (!Tx.has(f)) {
              Tx.add(f);
              var m = At(n) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", m, a, a);
            }
            break;
          }
        case x:
          {
            D1 || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), D1 = !0);
            break;
          }
      }
    }
    function P0(n, a) {
      if (ui) {
        var f = n.memoizedUpdaters;
        f.forEach(function (m) {
          df(n, m, a);
        });
      }
    }
    var Ak = {};
    function jk(n, a) {
      {
        var f = za.current;
        return f !== null ? (f.push(a), Ak) : Ch(n, a);
      }
    }
    function A0(n) {
      if (n !== Ak) return Fg(n);
    }
    function Cc() {
      return za.current !== null;
    }
    function j0(n) {
      {
        if (n.mode & Wt) {
          if (!_l()) return;
        } else if (!Ck() || Wn !== ji || n.tag !== w && n.tag !== F && n.tag !== G) return;
        if (za.current === null) {
          var a = Pr;
          try {
            Rn(n), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, At(n));
          } finally {
            a ? Rn(n) : Un();
          }
        }
      }
    }
    function PA(n) {
      n.tag !== fs && _l() && za.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function kp(n) {
      wI = n;
    }
    var Su = null,
      Nv = null,
      PI = function (n) {
        Su = n;
      };
    function nb(n) {
      {
        if (Su === null) return n;
        var a = Su(n);
        return a === void 0 ? n : a.current;
      }
    }
    function Fk(n) {
      return nb(n);
    }
    function Nk(n) {
      {
        if (Su === null) return n;
        var a = Su(n);
        if (a === void 0) {
          if (n != null && typeof n.render == "function") {
            var f = nb(n.render);
            if (n.render !== f) {
              var m = {
                $$typeof: Ye,
                render: f
              };
              return n.displayName !== void 0 && (m.displayName = n.displayName), m;
            }
          }
          return n;
        }
        return a.current;
      }
    }
    function I1(n, a) {
      {
        if (Su === null) return !1;
        var f = n.elementType,
          m = a.type,
          b = !1,
          T = typeof m == "object" && m !== null ? m.$$typeof : null;
        switch (n.tag) {
          case x:
            {
              typeof m == "function" && (b = !0);
              break;
            }
          case w:
            {
              (typeof m == "function" || T === Ct) && (b = !0);
              break;
            }
          case F:
            {
              (T === Ye || T === Ct) && (b = !0);
              break;
            }
          case K:
          case G:
            {
              (T === $t || T === Ct) && (b = !0);
              break;
            }
          default:
            return !1;
        }
        if (b) {
          var M = Su(f);
          if (M !== void 0 && M === Su(m)) return !0;
        }
        return !1;
      }
    }
    function AI(n) {
      {
        if (Su === null || typeof WeakSet != "function") return;
        Nv === null && (Nv = /* @__PURE__ */new WeakSet()), Nv.add(n);
      }
    }
    var zk = function (n, a) {
        {
          if (Su === null) return;
          var f = a.staleFamilies,
            m = a.updatedFamilies;
          Mm(), ou(function () {
            Vk(n.current, m, f);
          });
        }
      },
      AA = function (n, a) {
        {
          if (n.context !== Oa) return;
          Mm(), ou(function () {
            rb(a, n, null, null);
          });
        }
      };
    function Vk(n, a, f) {
      {
        var m = n.alternate,
          b = n.child,
          T = n.sibling,
          M = n.tag,
          z = n.type,
          U = null;
        switch (M) {
          case w:
          case G:
          case x:
            U = z;
            break;
          case F:
            U = z.render;
            break;
        }
        if (Su === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var X = !1,
          J = !1;
        if (U !== null) {
          var me = Su(U);
          me !== void 0 && (f.has(me) ? J = !0 : a.has(me) && (M === x ? J = !0 : X = !0));
        }
        if (Nv !== null && (Nv.has(n) || m !== null && Nv.has(m)) && (J = !0), J && (n._debugNeedsRemount = !0), J || X) {
          var xe = rs(n, Je);
          xe !== null && To(xe, n, Je, wn);
        }
        b !== null && !J && Vk(b, a, f), T !== null && Vk(T, a, f);
      }
    }
    var Bk = function (n, a) {
      {
        var f = /* @__PURE__ */new Set(),
          m = new Set(a.map(function (b) {
            return b.current;
          }));
        return jI(n.current, m, f), f;
      }
    };
    function jI(n, a, f) {
      {
        var m = n.child,
          b = n.sibling,
          T = n.tag,
          M = n.type,
          z = null;
        switch (T) {
          case w:
          case G:
          case x:
            z = M;
            break;
          case F:
            z = M.render;
            break;
        }
        var U = !1;
        z !== null && a.has(z) && (U = !0), U ? jA(n, f) : m !== null && jI(m, a, f), b !== null && jI(b, a, f);
      }
    }
    function jA(n, a) {
      {
        var f = kc(n, a);
        if (f) return;
        for (var m = n;;) {
          switch (m.tag) {
            case D:
              a.add(m.stateNode);
              return;
            case k:
              a.add(m.stateNode.containerInfo);
              return;
            case C:
              a.add(m.stateNode.containerInfo);
              return;
          }
          if (m.return === null) throw new Error("Expected to reach root first.");
          m = m.return;
        }
      }
    }
    function kc(n, a) {
      for (var f = n, m = !1;;) {
        if (f.tag === D) m = !0, a.add(f.stateNode);else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === n) return m;
        for (; f.sibling === null;) {
          if (f.return === null || f.return === n) return m;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var Rx;
    {
      Rx = !1;
      try {
        var FI = Object.preventExtensions({});
      } catch {
        Rx = !0;
      }
    }
    function FA(n, a, f, m) {
      this.tag = n, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = m, this.flags = pt, this.subtreeFlags = pt, this.deletions = null, this.lanes = Re, this.childLanes = Re, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Rx && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var tl = function (n, a, f, m) {
      return new FA(n, a, f, m);
    };
    function Uk(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function NA(n) {
      return typeof n == "function" && !Uk(n) && n.defaultProps === void 0;
    }
    function Hk(n) {
      if (typeof n == "function") return Uk(n) ? x : w;
      if (n != null) {
        var a = n.$$typeof;
        if (a === Ye) return F;
        if (a === $t) return K;
      }
      return E;
    }
    function Lm(n, a) {
      var f = n.alternate;
      f === null ? (f = tl(n.tag, a, n.key, n.mode), f.elementType = n.elementType, f.type = n.type, f.stateNode = n.stateNode, f._debugSource = n._debugSource, f._debugOwner = n._debugOwner, f._debugHookTypes = n._debugHookTypes, f.alternate = n, n.alternate = f) : (f.pendingProps = a, f.type = n.type, f.flags = pt, f.subtreeFlags = pt, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = n.flags & nr, f.childLanes = n.childLanes, f.lanes = n.lanes, f.child = n.child, f.memoizedProps = n.memoizedProps, f.memoizedState = n.memoizedState, f.updateQueue = n.updateQueue;
      var m = n.dependencies;
      switch (f.dependencies = m === null ? null : {
        lanes: m.lanes,
        firstContext: m.firstContext
      }, f.sibling = n.sibling, f.index = n.index, f.ref = n.ref, f.selfBaseDuration = n.selfBaseDuration, f.treeBaseDuration = n.treeBaseDuration, f._debugNeedsRemount = n._debugNeedsRemount, f.tag) {
        case E:
        case w:
        case G:
          f.type = nb(n.type);
          break;
        case x:
          f.type = Fk(n.type);
          break;
        case F:
          f.type = Nk(n.type);
          break;
      }
      return f;
    }
    function zv(n, a) {
      n.flags &= nr | Gn;
      var f = n.alternate;
      if (f === null) n.childLanes = Re, n.lanes = a, n.child = null, n.subtreeFlags = pt, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;else {
        n.childLanes = f.childLanes, n.lanes = f.lanes, n.child = f.child, n.subtreeFlags = pt, n.deletions = null, n.memoizedProps = f.memoizedProps, n.memoizedState = f.memoizedState, n.updateQueue = f.updateQueue, n.type = f.type;
        var m = f.dependencies;
        n.dependencies = m === null ? null : {
          lanes: m.lanes,
          firstContext: m.firstContext
        }, n.selfBaseDuration = f.selfBaseDuration, n.treeBaseDuration = f.treeBaseDuration;
      }
      return n;
    }
    function zA(n, a, f) {
      var m;
      return n === qb ? (m = Wt, a === !0 && (m |= Xn, m |= Ri)) : m = dt, ui && (m |= nn), tl(C, null, null, m);
    }
    function $k(n, a, f, m, b, T) {
      var M = E,
        z = n;
      if (typeof n == "function") Uk(n) ? (M = x, z = Fk(z)) : z = nb(z);else if (typeof n == "string") M = D;else e: switch (n) {
        case Lo:
          return Om(f.children, b, T, a);
        case $a:
          M = P, b |= Xn, (b & Wt) !== dt && (b |= Ri);
          break;
        case Oo:
          return qk(f, b, T, a);
        case xt:
          return VA(f, b, T, a);
        case rn:
          return BA(f, b, T, a);
        case Tn:
          return M1(f, b, T, a);
        case jn:
        // eslint-disable-next-line no-fallthrough
        case qt:
        // eslint-disable-next-line no-fallthrough
        case Or:
        // eslint-disable-next-line no-fallthrough
        case Wa:
        // eslint-disable-next-line no-fallthrough
        case yr:
        // eslint-disable-next-line no-fallthrough
        default:
          {
            if (typeof n == "object" && n !== null) switch (n.$$typeof) {
              case Z:
                M = O;
                break e;
              case Ne:
                M = N;
                break e;
              case Ye:
                M = F, z = Nk(z);
                break e;
              case $t:
                M = K;
                break e;
              case Ct:
                M = Q, z = null;
                break e;
            }
            var U = "";
            {
              (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var X = m ? At(m) : null;
              X && (U += `

Check the render method of \`` + X + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + U));
          }
      }
      var J = tl(M, f, a, b);
      return J.elementType = n, J.type = z, J.lanes = T, J._debugOwner = m, J;
    }
    function Wk(n, a, f) {
      var m = null;
      m = n._owner;
      var b = n.type,
        T = n.key,
        M = n.props,
        z = $k(b, T, M, m, a, f);
      return z._debugSource = n._source, z._debugOwner = n._owner, z;
    }
    function Om(n, a, f, m) {
      var b = tl(L, n, m, a);
      return b.lanes = f, b;
    }
    function qk(n, a, f, m) {
      typeof n.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var b = tl(j, n, m, a | nn);
      return b.elementType = Oo, b.lanes = f, b.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, b;
    }
    function VA(n, a, f, m) {
      var b = tl(V, n, m, a);
      return b.elementType = xt, b.lanes = f, b;
    }
    function BA(n, a, f, m) {
      var b = tl(Y, n, m, a);
      return b.elementType = rn, b.lanes = f, b;
    }
    function M1(n, a, f, m) {
      var b = tl(ae, n, m, a);
      b.elementType = Tn, b.lanes = f;
      var T = {
        isHidden: !1
      };
      return b.stateNode = T, b;
    }
    function L1(n, a, f) {
      var m = tl(I, n, null, a);
      return m.lanes = f, m;
    }
    function UA() {
      var n = tl(D, null, null, dt);
      return n.elementType = "DELETED", n;
    }
    function NI(n) {
      var a = tl(ie, null, null, dt);
      return a.stateNode = n, a;
    }
    function Dx(n, a, f) {
      var m = n.children !== null ? n.children : [],
        b = tl(k, m, n.key, a);
      return b.lanes = f, b.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, b;
    }
    function zI(n, a) {
      return n === null && (n = tl(E, null, null, dt)), n.tag = a.tag, n.key = a.key, n.elementType = a.elementType, n.type = a.type, n.stateNode = a.stateNode, n.return = a.return, n.child = a.child, n.sibling = a.sibling, n.index = a.index, n.ref = a.ref, n.pendingProps = a.pendingProps, n.memoizedProps = a.memoizedProps, n.updateQueue = a.updateQueue, n.memoizedState = a.memoizedState, n.dependencies = a.dependencies, n.mode = a.mode, n.flags = a.flags, n.subtreeFlags = a.subtreeFlags, n.deletions = a.deletions, n.lanes = a.lanes, n.childLanes = a.childLanes, n.alternate = a.alternate, n.actualDuration = a.actualDuration, n.actualStartTime = a.actualStartTime, n.selfBaseDuration = a.selfBaseDuration, n.treeBaseDuration = a.treeBaseDuration, n._debugSource = a._debugSource, n._debugOwner = a._debugOwner, n._debugNeedsRemount = a._debugNeedsRemount, n._debugHookTypes = a._debugHookTypes, n;
    }
    function Yk(n, a, f, m, b) {
      this.tag = a, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = lC, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ln, this.eventTimes = oc(Re), this.expirationTimes = oc(wn), this.pendingLanes = Re, this.suspendedLanes = Re, this.pingedLanes = Re, this.expiredLanes = Re, this.mutableReadLanes = Re, this.finishedLanes = Re, this.entangledLanes = Re, this.entanglements = oc(Re), this.identifierPrefix = m, this.onRecoverableError = b, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */new Set();
        for (var T = this.pendingUpdatersLaneMap = [], M = 0; M < zs; M++) T.push(/* @__PURE__ */new Set());
      }
      switch (a) {
        case qb:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case fs:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function O1(n, a, f, m, b, T, M, z, U, X) {
      var J = new Yk(n, a, f, z, U),
        me = zA(a, T);
      J.current = me, me.stateNode = J;
      {
        var xe = {
          element: m,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        me.memoizedState = xe;
      }
      return Of(me), J;
    }
    var P1 = "18.2.0";
    function HA(n, a, f) {
      var m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return un(m), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: oi,
        key: m == null ? null : "" + m,
        children: n,
        containerInfo: a,
        implementation: f
      };
    }
    var A1, j1;
    A1 = !1, j1 = {};
    function F0(n) {
      if (!n) return Oa;
      var a = Ps(n),
        f = _S(a);
      if (a.tag === x) {
        var m = a.type;
        if (Bc(m)) return pC(a, m, f);
      }
      return f;
    }
    function F1(n, a) {
      {
        var f = Ps(n);
        if (f === void 0) {
          if (typeof n.render == "function") throw new Error("Unable to find node on an unmounted component.");
          var m = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + m);
        }
        var b = Xr(f);
        if (b === null) return null;
        if (b.mode & Xn) {
          var T = At(f) || "Component";
          if (!j1[T]) {
            j1[T] = !0;
            var M = Pr;
            try {
              Rn(b), f.mode & Xn ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, T) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, T);
            } finally {
              M ? Rn(M) : Un();
            }
          }
        }
        return b.stateNode;
      }
    }
    function VI(n, a, f, m, b, T, M, z) {
      var U = !1,
        X = null;
      return O1(n, a, U, X, f, m, b, T, M);
    }
    function Gk(n, a, f, m, b, T, M, z, U, X) {
      var J = !0,
        me = O1(f, m, J, n, b, T, M, z, U);
      me.context = F0(null);
      var xe = me.current,
        Ie = au(),
        Pe = jv(xe),
        $e = Hc(Ie, Pe);
      return $e.callback = a ?? null, mp(xe, $e, Pe), Tk(me, Pe, Ie), me;
    }
    function rb(n, a, f, m) {
      ki(a, n);
      var b = a.current,
        T = au(),
        M = jv(b);
      _a(M);
      var z = F0(f);
      a.context === null ? a.context = z : a.pendingContext = z, Po && Pr !== null && !A1 && (A1 = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, At(Pr) || "Unknown"));
      var U = Hc(T, M);
      U.payload = {
        element: n
      }, m = m === void 0 ? null : m, m !== null && (typeof m != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", m), U.callback = m);
      var X = mp(b, U, M);
      return X !== null && (To(X, b, M, T), PS(X, b, M)), M;
    }
    function N1(n) {
      var a = n.current;
      if (!a.child) return null;
      switch (a.child.tag) {
        case D:
          return a.child.stateNode;
        default:
          return a.child.stateNode;
      }
    }
    function $A(n) {
      switch (n.tag) {
        case C:
          {
            var a = n.stateNode;
            if ($h(a)) {
              var f = Kg(a);
              SI(a, f);
            }
            break;
          }
        case V:
          {
            ou(function () {
              var b = rs(n, Je);
              if (b !== null) {
                var T = au();
                To(b, n, Je, T);
              }
            });
            var m = Je;
            z1(n, m);
            break;
          }
      }
    }
    function Xk(n, a) {
      var f = n.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = sf(f.retryLane, a));
    }
    function z1(n, a) {
      Xk(n, a);
      var f = n.alternate;
      f && Xk(f, a);
    }
    function WA(n) {
      if (n.tag === V) {
        var a = Hs,
          f = rs(n, a);
        if (f !== null) {
          var m = au();
          To(f, n, a, m);
        }
        z1(n, a);
      }
    }
    function BI(n) {
      if (n.tag === V) {
        var a = jv(n),
          f = rs(n, a);
        if (f !== null) {
          var m = au();
          To(f, n, a, m);
        }
        z1(n, a);
      }
    }
    function UI(n) {
      var a = In(n);
      return a === null ? null : a.stateNode;
    }
    var Kk = function (n) {
      return null;
    };
    function HI(n) {
      return Kk(n);
    }
    var Qk = function (n) {
      return !1;
    };
    function $I(n) {
      return Qk(n);
    }
    var Zk = null,
      Jk = null,
      eT = null,
      tT = null,
      nT = null,
      rT = null,
      iT = null,
      aT = null,
      oT = null;
    {
      var lT = function (n, a, f) {
          var m = a[f],
            b = wr(n) ? n.slice() : Qt({}, n);
          return f + 1 === a.length ? (wr(b) ? b.splice(m, 1) : delete b[m], b) : (b[m] = lT(n[m], a, f + 1), b);
        },
        sT = function (n, a) {
          return lT(n, a, 0);
        },
        V1 = function (n, a, f, m) {
          var b = a[m],
            T = wr(n) ? n.slice() : Qt({}, n);
          if (m + 1 === a.length) {
            var M = f[m];
            T[M] = T[b], wr(T) ? T.splice(b, 1) : delete T[b];
          } else T[b] = V1(
          // $FlowFixMe number or string is fine here
          n[b], a, f, m + 1);
          return T;
        },
        WI = function (n, a, f) {
          if (a.length !== f.length) {
            p("copyWithRename() expects paths of the same length");
            return;
          } else for (var m = 0; m < f.length - 1; m++) if (a[m] !== f[m]) {
            p("copyWithRename() expects paths to be the same except for the deepest key");
            return;
          }
          return V1(n, a, f, 0);
        },
        qI = function (n, a, f, m) {
          if (f >= a.length) return m;
          var b = a[f],
            T = wr(n) ? n.slice() : Qt({}, n);
          return T[b] = qI(n[b], a, f + 1, m), T;
        },
        YI = function (n, a, f) {
          return qI(n, a, 0, f);
        },
        uT = function (n, a) {
          for (var f = n.memoizedState; f !== null && a > 0;) f = f.next, a--;
          return f;
        };
      Zk = function (n, a, f, m) {
        var b = uT(n, a);
        if (b !== null) {
          var T = YI(b.memoizedState, f, m);
          b.memoizedState = T, b.baseState = T, n.memoizedProps = Qt({}, n.memoizedProps);
          var M = rs(n, Je);
          M !== null && To(M, n, Je, wn);
        }
      }, Jk = function (n, a, f) {
        var m = uT(n, a);
        if (m !== null) {
          var b = sT(m.memoizedState, f);
          m.memoizedState = b, m.baseState = b, n.memoizedProps = Qt({}, n.memoizedProps);
          var T = rs(n, Je);
          T !== null && To(T, n, Je, wn);
        }
      }, eT = function (n, a, f, m) {
        var b = uT(n, a);
        if (b !== null) {
          var T = WI(b.memoizedState, f, m);
          b.memoizedState = T, b.baseState = T, n.memoizedProps = Qt({}, n.memoizedProps);
          var M = rs(n, Je);
          M !== null && To(M, n, Je, wn);
        }
      }, tT = function (n, a, f) {
        n.pendingProps = YI(n.memoizedProps, a, f), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var m = rs(n, Je);
        m !== null && To(m, n, Je, wn);
      }, nT = function (n, a) {
        n.pendingProps = sT(n.memoizedProps, a), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var f = rs(n, Je);
        f !== null && To(f, n, Je, wn);
      }, rT = function (n, a, f) {
        n.pendingProps = WI(n.memoizedProps, a, f), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var m = rs(n, Je);
        m !== null && To(m, n, Je, wn);
      }, iT = function (n) {
        var a = rs(n, Je);
        a !== null && To(a, n, Je, wn);
      }, aT = function (n) {
        Kk = n;
      }, oT = function (n) {
        Qk = n;
      };
    }
    function GI(n) {
      var a = Xr(n);
      return a === null ? null : a.stateNode;
    }
    function cT(n) {
      return null;
    }
    function qA() {
      return Pr;
    }
    function B1(n) {
      var a = n.findFiberByHostInstance,
        f = i.ReactCurrentDispatcher;
      return Fs({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: Zk,
        overrideHookStateDeletePath: Jk,
        overrideHookStateRenamePath: eT,
        overrideProps: tT,
        overridePropsDeletePath: nT,
        overridePropsRenamePath: rT,
        setErrorHandler: aT,
        setSuspenseHandler: oT,
        scheduleUpdate: iT,
        currentDispatcherRef: f,
        findHostInstanceByFiber: GI,
        findFiberByHostInstance: a || cT,
        // React Refresh
        findHostInstancesForRefresh: Bk,
        scheduleRefresh: zk,
        scheduleRoot: AA,
        setRefreshHandler: PI,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: qA,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: P1
      });
    }
    var XI = typeof reportError == "function" ?
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : function (n) {
      console.error(n);
    };
    function dT(n) {
      this._internalRoot = n;
    }
    Vv.prototype.render = dT.prototype.render = function (n) {
      var a = this._internalRoot;
      if (a === null) throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? h("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Ix(arguments[1]) ? h("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && h("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = a.containerInfo;
        if (f.nodeType !== er) {
          var m = UI(a.current);
          m && m.parentNode !== f && h("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      rb(n, a, null, null);
    }, Vv.prototype.unmount = dT.prototype.unmount = function () {
      typeof arguments[0] == "function" && h("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var n = this._internalRoot;
      if (n !== null) {
        this._internalRoot = null;
        var a = n.containerInfo;
        Mk() && h("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), ou(function () {
          rb(null, n, null, null);
        }), hv(a);
      }
    };
    function U1(n, a) {
      if (!Ix(n)) throw new Error("createRoot(...): Target container is not a DOM element.");
      fT(n);
      var f = !1,
        m = !1,
        b = "",
        T = XI;
      a != null && (a.hydrate ? p("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof a == "object" && a !== null && a.$$typeof === $i && h(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), a.unstable_strictMode === !0 && (f = !0), a.identifierPrefix !== void 0 && (b = a.identifierPrefix), a.onRecoverableError !== void 0 && (T = a.onRecoverableError), a.transitionCallbacks !== void 0 && a.transitionCallbacks);
      var M = VI(n, qb, null, f, m, b, T);
      pv(M.current, n);
      var z = n.nodeType === er ? n.parentNode : n;
      return Fb(z), new dT(M);
    }
    function Vv(n) {
      this._internalRoot = n;
    }
    function KI(n) {
      n && cp(n);
    }
    Vv.prototype.unstable_scheduleHydration = KI;
    function YA(n, a, f) {
      if (!Ix(n)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      fT(n), a === void 0 && h("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var m = f ?? null,
        b = f != null && f.hydratedSources || null,
        T = !1,
        M = !1,
        z = "",
        U = XI;
      f != null && (f.unstable_strictMode === !0 && (T = !0), f.identifierPrefix !== void 0 && (z = f.identifierPrefix), f.onRecoverableError !== void 0 && (U = f.onRecoverableError));
      var X = Gk(a, null, n, qb, m, T, M, z, U);
      if (pv(X.current, n), Fb(n), b) for (var J = 0; J < b.length; J++) {
        var me = b[J];
        B_(X, me);
      }
      return new Vv(X);
    }
    function Ix(n) {
      return !!(n && (n.nodeType === Wr || n.nodeType === Ka || n.nodeType === ph));
    }
    function ib(n) {
      return !!(n && (n.nodeType === Wr || n.nodeType === Ka || n.nodeType === ph || n.nodeType === er && n.nodeValue === " react-mount-point-unstable "));
    }
    function fT(n) {
      n.nodeType === Wr && n.tagName && n.tagName.toUpperCase() === "BODY" && h("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Nc(n) && (n._reactRootContainer ? h("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : h("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var GA = i.ReactCurrentOwner,
      QI;
    QI = function (n) {
      if (n._reactRootContainer && n.nodeType !== er) {
        var a = UI(n._reactRootContainer.current);
        a && a.parentNode !== n && h("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!n._reactRootContainer,
        m = N0(n),
        b = !!(m && Sf(m));
      b && !f && h("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), n.nodeType === Wr && n.tagName && n.tagName.toUpperCase() === "BODY" && h("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function N0(n) {
      return n ? n.nodeType === Ka ? n.documentElement : n.firstChild : null;
    }
    function ZI() {}
    function XA(n, a, f, m, b) {
      if (b) {
        if (typeof m == "function") {
          var T = m;
          m = function () {
            var xe = N1(M);
            T.call(xe);
          };
        }
        var M = Gk(a, m, n, fs, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        ZI);
        n._reactRootContainer = M, pv(M.current, n);
        var z = n.nodeType === er ? n.parentNode : n;
        return Fb(z), ou(), M;
      } else {
        for (var U; U = n.lastChild;) n.removeChild(U);
        if (typeof m == "function") {
          var X = m;
          m = function () {
            var xe = N1(J);
            X.call(xe);
          };
        }
        var J = VI(n, fs, null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        ZI);
        n._reactRootContainer = J, pv(J.current, n);
        var me = n.nodeType === er ? n.parentNode : n;
        return Fb(me), ou(function () {
          rb(a, J, f, m);
        }), J;
      }
    }
    function KA(n, a) {
      n !== null && typeof n != "function" && h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n);
    }
    function H1(n, a, f, m, b) {
      QI(f), KA(b === void 0 ? null : b, "render");
      var T = f._reactRootContainer,
        M;
      if (!T) M = XA(f, a, n, b, m);else {
        if (M = T, typeof b == "function") {
          var z = b;
          b = function () {
            var U = N1(M);
            z.call(U);
          };
        }
        rb(a, M, n, b);
      }
      return N1(M);
    }
    function QA(n) {
      {
        var a = GA.current;
        if (a !== null && a.stateNode !== null) {
          var f = a.stateNode._warnedAboutRefsInRender;
          f || h("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", bn(a.type) || "A component"), a.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return n == null ? null : n.nodeType === Wr ? n : F1(n, "findDOMNode");
    }
    function ZA(n, a, f) {
      if (h("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(a)) throw new Error("Target container is not a DOM element.");
      {
        var m = Nc(a) && a._reactRootContainer === void 0;
        m && h("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return H1(null, n, a, !0, f);
    }
    function JA(n, a, f) {
      if (h("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(a)) throw new Error("Target container is not a DOM element.");
      {
        var m = Nc(a) && a._reactRootContainer === void 0;
        m && h("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return H1(null, n, a, !1, f);
    }
    function pT(n, a, f, m) {
      if (h("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !ib(f)) throw new Error("Target container is not a DOM element.");
      if (n == null || !Mw(n)) throw new Error("parentComponent must be a valid React Component");
      return H1(n, a, f, !1, m);
    }
    function ej(n) {
      if (!ib(n)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var a = Nc(n) && n._reactRootContainer === void 0;
        a && h("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (n._reactRootContainer) {
        {
          var f = N0(n),
            m = f && !Sf(f);
          m && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return ou(function () {
          H1(null, null, n, !1, function () {
            n._reactRootContainer = null, hv(n);
          });
        }), !0;
      } else {
        {
          var b = N0(n),
            T = !!(b && Sf(b)),
            M = n.nodeType === Wr && ib(n.parentNode) && !!n.parentNode._reactRootContainer;
          T && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", M ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    ff($A), tt(WA), Wh(BI), Cb(zr), uc(Uh), (typeof Map != "function" ||
    // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" ||
    // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && h("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ld(Qw), Iw(L0, Ik, ou);
    function tj(n, a) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Ix(a)) throw new Error("Target container is not a DOM element.");
      return HA(n, a, null, f);
    }
    function nj(n, a, f, m) {
      return pT(n, a, f, m);
    }
    var hT = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Sf, mv, vS, Is, Od, L0]
    };
    function JI(n, a) {
      return hT.usingClientEntryPoint || h('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), U1(n, a);
    }
    function l(n, a, f) {
      return hT.usingClientEntryPoint || h('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), YA(n, a, f);
    }
    function u(n) {
      return Mk() && h("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), ou(n);
    }
    var v = B1({
      findFiberByHostInstance: zc,
      bundleType: 1,
      version: P1,
      rendererPackageName: "react-dom"
    });
    if (!v && Xe && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var _ = window.location.protocol;
      /^(https?|file):$/.test(_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (_ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ed.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = hT, ed.createPortal = tj, ed.createRoot = JI, ed.findDOMNode = QA, ed.flushSync = u, ed.hydrate = ZA, ed.hydrateRoot = l, ed.render = JA, ed.unmountComponentAtNode = ej, ed.unstable_batchedUpdates = L0, ed.unstable_renderSubtreeIntoContainer = nj, ed.version = P1, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ed;
}
var wU;
function F8() {
  if (wU) return RM.exports;
  wU = 1;
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production") throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (t(), RM.exports = Sge()) : RM.exports = Ege(), RM.exports;
}
var IM = {
    exports: {}
  },
  Mp = {},
  MM = {
    exports: {}
  },
  _U;
function N8() {
  return _U || (_U = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = E;
    /*!
     * Adapted from jQuery UI core
     *
     * http://jqueryui.com
     *
     * Copyright 2014 jQuery Foundation and other contributors
     * Released under the MIT license.
     * http://jquery.org/license
     *
     * http://api.jqueryui.com/category/ui-core/
     */
    var i = "none",
      s = "contents",
      c = /^(input|select|textarea|button|object|iframe)$/;
    function p(C, k) {
      return k.getPropertyValue("overflow") !== "visible" ||
      // if 'overflow: visible' set, check if there is actually any overflow
      C.scrollWidth <= 0 && C.scrollHeight <= 0;
    }
    function h(C) {
      var k = C.offsetWidth <= 0 && C.offsetHeight <= 0;
      if (k && !C.innerHTML) return !0;
      try {
        var D = window.getComputedStyle(C),
          I = D.getPropertyValue("display");
        return k ? I !== s && p(C, D) : I === i;
      } catch {
        return console.warn("Failed to inspect element style"), !1;
      }
    }
    function y(C) {
      for (var k = C, D = C.getRootNode && C.getRootNode(); k && k !== document.body;) {
        if (D && k === D && (k = D.host.parentNode), h(k)) return !1;
        k = k.parentNode;
      }
      return !0;
    }
    function w(C, k) {
      var D = C.nodeName.toLowerCase(),
        I = c.test(D) && !C.disabled || D === "a" && C.href || k;
      return I && y(C);
    }
    function x(C) {
      var k = C.getAttribute("tabindex");
      k === null && (k = void 0);
      var D = isNaN(k);
      return (D || k >= 0) && w(C, !D);
    }
    function E(C) {
      var k = [].slice.call(C.querySelectorAll("*"), 0).reduce(function (D, I) {
        return D.concat(I.shadowRoot ? E(I.shadowRoot) : [I]);
      }, []);
      return k.filter(x);
    }
    t.exports = e.default;
  }(MM, MM.exports)), MM.exports;
}
var xU;
function Cge() {
  if (xU) return Mp;
  xU = 1, Object.defineProperty(Mp, "__esModule", {
    value: !0
  }), Mp.resetState = h, Mp.log = y, Mp.handleBlur = w, Mp.handleFocus = x, Mp.markForFocusLater = E, Mp.returnFocus = C, Mp.popWithoutFocus = k, Mp.setupScopedFocus = D, Mp.teardownScopedFocus = I;
  var t = N8(),
    e = i(t);
  function i(L) {
    return L && L.__esModule ? L : {
      default: L
    };
  }
  var s = [],
    c = null,
    p = !1;
  function h() {
    s = [];
  }
  function y() {
    process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), s.forEach(function (L) {
      var P = L || {};
      console.log(P.nodeName, P.className, P.id);
    }), console.log("end focusManager ----------"));
  }
  function w() {
    p = !0;
  }
  function x() {
    if (p) {
      if (p = !1, !c) return;
      setTimeout(function () {
        if (!c.contains(document.activeElement)) {
          var L = (0, e.default)(c)[0] || c;
          L.focus();
        }
      }, 0);
    }
  }
  function E() {
    s.push(document.activeElement);
  }
  function C() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1,
      P = null;
    try {
      s.length !== 0 && (P = s.pop(), P.focus({
        preventScroll: L
      }));
      return;
    } catch {
      console.warn(["You tried to return focus to", P, "but it is not in the DOM anymore"].join(" "));
    }
  }
  function k() {
    s.length > 0 && s.pop();
  }
  function D(L) {
    c = L, window.addEventListener ? (window.addEventListener("blur", w, !1), document.addEventListener("focus", x, !0)) : (window.attachEvent("onBlur", w), document.attachEvent("onFocus", x));
  }
  function I() {
    c = null, window.addEventListener ? (window.removeEventListener("blur", w), document.removeEventListener("focus", x)) : (window.detachEvent("onBlur", w), document.detachEvent("onFocus", x));
  }
  return Mp;
}
var LM = {
    exports: {}
  },
  SU;
function kge() {
  return SU || (SU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = h;
    var i = N8(),
      s = c(i);
    function c(y) {
      return y && y.__esModule ? y : {
        default: y
      };
    }
    function p() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
      return y.activeElement.shadowRoot ? p(y.activeElement.shadowRoot) : y.activeElement;
    }
    function h(y, w) {
      var x = (0, s.default)(y);
      if (!x.length) {
        w.preventDefault();
        return;
      }
      var E = void 0,
        C = w.shiftKey,
        k = x[0],
        D = x[x.length - 1],
        I = p();
      if (y === I) {
        if (!C) return;
        E = D;
      }
      if (D === I && !C && (E = k), k === I && C && (E = D), E) {
        w.preventDefault(), E.focus();
        return;
      }
      var L = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent),
        P = L != null && L[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
      if (P) {
        var N = x.indexOf(I);
        if (N > -1 && (N += C ? -1 : 1), E = x[N], typeof E > "u") {
          w.preventDefault(), E = C ? D : k, E.focus();
          return;
        }
        w.preventDefault(), E.focus();
      }
    }
    t.exports = e.default;
  }(LM, LM.exports)), LM.exports;
}
var zm = {},
  d2,
  EU;
function Tge() {
  if (EU) return d2;
  EU = 1;
  var t = process.env.NODE_ENV !== "production",
    e = function () {};
  if (t) {
    var i = function (c, p) {
      var h = arguments.length;
      p = new Array(h > 1 ? h - 1 : 0);
      for (var y = 1; y < h; y++) p[y - 1] = arguments[y];
      var w = 0,
        x = "Warning: " + c.replace(/%s/g, function () {
          return p[w++];
        });
      typeof console < "u" && console.error(x);
      try {
        throw new Error(x);
      } catch {}
    };
    e = function (s, c, p) {
      var h = arguments.length;
      p = new Array(h > 2 ? h - 2 : 0);
      for (var y = 2; y < h; y++) p[y - 2] = arguments[y];
      if (c === void 0) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      s || i.apply(null, [c].concat(p));
    };
  }
  return d2 = e, d2;
}
var Hv = {},
  f2 = {
    exports: {}
  };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var CU;
function Rge() {
  return CU || (CU = 1, function (t) {
    (function () {
      var e = !!(typeof window < "u" && window.document && window.document.createElement),
        i = {
          canUseDOM: e,
          canUseWorkers: typeof Worker < "u",
          canUseEventListeners: e && !!(window.addEventListener || window.attachEvent),
          canUseViewport: e && !!window.screen
        };
      t.exports ? t.exports = i : window.ExecutionEnvironment = i;
    })();
  }(f2)), f2.exports;
}
var kU;
function Rz() {
  if (kU) return Hv;
  kU = 1, Object.defineProperty(Hv, "__esModule", {
    value: !0
  }), Hv.canUseDOM = Hv.SafeNodeList = Hv.SafeHTMLCollection = void 0;
  var t = Rge(),
    e = i(t);
  function i(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  var s = e.default,
    c = s.canUseDOM ? window.HTMLElement : {};
  return Hv.SafeHTMLCollection = s.canUseDOM ? window.HTMLCollection : {}, Hv.SafeNodeList = s.canUseDOM ? window.NodeList : {}, Hv.canUseDOM = s.canUseDOM, Hv.default = c, Hv;
}
var TU;
function z8() {
  if (TU) return zm;
  TU = 1, Object.defineProperty(zm, "__esModule", {
    value: !0
  }), zm.resetState = p, zm.log = h, zm.assertNodeList = y, zm.setElement = w, zm.validateElement = x, zm.hide = E, zm.show = C, zm.documentNotReadyOrSSRTesting = k;
  var t = Tge(),
    e = s(t),
    i = Rz();
  function s(D) {
    return D && D.__esModule ? D : {
      default: D
    };
  }
  var c = null;
  function p() {
    c && (c.removeAttribute ? c.removeAttribute("aria-hidden") : c.length != null ? c.forEach(function (D) {
      return D.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(c).forEach(function (D) {
      return D.removeAttribute("aria-hidden");
    })), c = null;
  }
  function h() {
    if (process.env.NODE_ENV !== "production") {
      var D = c || {};
      console.log("ariaAppHider ----------"), console.log(D.nodeName, D.className, D.id), console.log("end ariaAppHider ----------");
    }
  }
  function y(D, I) {
    if (!D || !D.length) throw new Error("react-modal: No elements were found for selector " + I + ".");
  }
  function w(D) {
    var I = D;
    if (typeof I == "string" && i.canUseDOM) {
      var L = document.querySelectorAll(I);
      y(L, I), I = L;
    }
    return c = I || c, c;
  }
  function x(D) {
    var I = D || c;
    return I ? Array.isArray(I) || I instanceof HTMLCollection || I instanceof NodeList ? I : [I] : ((0, e.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }
  function E(D) {
    var I = !0,
      L = !1,
      P = void 0;
    try {
      for (var N = x(D)[Symbol.iterator](), O; !(I = (O = N.next()).done); I = !0) {
        var F = O.value;
        F.setAttribute("aria-hidden", "true");
      }
    } catch (j) {
      L = !0, P = j;
    } finally {
      try {
        !I && N.return && N.return();
      } finally {
        if (L) throw P;
      }
    }
  }
  function C(D) {
    var I = !0,
      L = !1,
      P = void 0;
    try {
      for (var N = x(D)[Symbol.iterator](), O; !(I = (O = N.next()).done); I = !0) {
        var F = O.value;
        F.removeAttribute("aria-hidden");
      }
    } catch (j) {
      L = !0, P = j;
    } finally {
      try {
        !I && N.return && N.return();
      } finally {
        if (L) throw P;
      }
    }
  }
  function k() {
    c = null;
  }
  return zm;
}
var jx = {},
  RU;
function Dge() {
  if (RU) return jx;
  RU = 1, Object.defineProperty(jx, "__esModule", {
    value: !0
  }), jx.resetState = s, jx.log = c;
  var t = {},
    e = {};
  function i(x, E) {
    x.classList.remove(E);
  }
  function s() {
    var x = document.getElementsByTagName("html")[0];
    for (var E in t) i(x, t[E]);
    var C = document.body;
    for (var k in e) i(C, e[k]);
    t = {}, e = {};
  }
  function c() {
    if (process.env.NODE_ENV !== "production") {
      var x = document.getElementsByTagName("html")[0].className,
        E = `Show tracked classes:

`;
      E += "<html /> (" + x + `):
  `;
      for (var C in t) E += "  " + C + " " + t[C] + `
  `;
      x = document.body.className, E += `

doc.body (` + x + `):
  `;
      for (var k in e) E += "  " + k + " " + e[k] + `
  `;
      E += `
`, console.log(E);
    }
  }
  var p = function (E, C) {
      return E[C] || (E[C] = 0), E[C] += 1, C;
    },
    h = function (E, C) {
      return E[C] && (E[C] -= 1), C;
    },
    y = function (E, C, k) {
      k.forEach(function (D) {
        p(C, D), E.add(D);
      });
    },
    w = function (E, C, k) {
      k.forEach(function (D) {
        h(C, D), C[D] === 0 && E.remove(D);
      });
    };
  return jx.add = function (E, C) {
    return y(E.classList, E.nodeName.toLowerCase() == "html" ? t : e, C.split(" "));
  }, jx.remove = function (E, C) {
    return w(E.classList, E.nodeName.toLowerCase() == "html" ? t : e, C.split(" "));
  }, jx;
}
var tE = {},
  DU;
function V8() {
  if (DU) return tE;
  DU = 1, Object.defineProperty(tE, "__esModule", {
    value: !0
  }), tE.log = s, tE.resetState = c;
  function t(p, h) {
    if (!(p instanceof h)) throw new TypeError("Cannot call a class as a function");
  }
  var e = function p() {
      var h = this;
      t(this, p), this.register = function (y) {
        if (h.openInstances.indexOf(y) !== -1) {
          process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
          return;
        }
        h.openInstances.push(y), h.emit("register");
      }, this.deregister = function (y) {
        var w = h.openInstances.indexOf(y);
        if (w === -1) {
          process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + y + " as it was never registered");
          return;
        }
        h.openInstances.splice(w, 1), h.emit("deregister");
      }, this.subscribe = function (y) {
        h.subscribers.push(y);
      }, this.emit = function (y) {
        h.subscribers.forEach(function (w) {
          return w(y,
          // shallow copy to avoid accidental mutation
          h.openInstances.slice());
        });
      }, this.openInstances = [], this.subscribers = [];
    },
    i = new e();
  function s() {
    console.log("portalOpenInstances ----------"), console.log(i.openInstances.length), i.openInstances.forEach(function (p) {
      return console.log(p);
    }), console.log("end portalOpenInstances ----------");
  }
  function c() {
    i = new e();
  }
  return tE.default = i, tE;
}
var TT = {},
  IU;
function Ige() {
  if (IU) return TT;
  IU = 1, Object.defineProperty(TT, "__esModule", {
    value: !0
  }), TT.resetState = h, TT.log = y;
  var t = V8(),
    e = i(t);
  function i(E) {
    return E && E.__esModule ? E : {
      default: E
    };
  }
  var s = void 0,
    c = void 0,
    p = [];
  function h() {
    for (var E = [s, c], C = 0; C < E.length; C++) {
      var k = E[C];
      k && k.parentNode && k.parentNode.removeChild(k);
    }
    s = c = null, p = [];
  }
  function y() {
    console.log("bodyTrap ----------"), console.log(p.length);
    for (var E = [s, c], C = 0; C < E.length; C++) {
      var k = E[C],
        D = k || {};
      console.log(D.nodeName, D.className, D.id);
    }
    console.log("edn bodyTrap ----------");
  }
  function w() {
    if (p.length === 0) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
      return;
    }
    p[p.length - 1].focusContent();
  }
  function x(E, C) {
    !s && !c && (s = document.createElement("div"), s.setAttribute("data-react-modal-body-trap", ""), s.style.position = "absolute", s.style.opacity = "0", s.setAttribute("tabindex", "0"), s.addEventListener("focus", w), c = s.cloneNode(), c.addEventListener("focus", w)), p = C, p.length > 0 ? (document.body.firstChild !== s && document.body.insertBefore(s, document.body.firstChild), document.body.lastChild !== c && document.body.appendChild(c)) : (s.parentElement && s.parentElement.removeChild(s), c.parentElement && c.parentElement.removeChild(c));
  }
  return e.default.subscribe(x), TT;
}
var MU;
function Mge() {
  return MU || (MU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = Object.assign || function (ne) {
        for (var le = 1; le < arguments.length; le++) {
          var ce = arguments[le];
          for (var W in ce) Object.prototype.hasOwnProperty.call(ce, W) && (ne[W] = ce[W]);
        }
        return ne;
      },
      s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (ne) {
        return typeof ne;
      } : function (ne) {
        return ne && typeof Symbol == "function" && ne.constructor === Symbol && ne !== Symbol.prototype ? "symbol" : typeof ne;
      },
      c = /* @__PURE__ */function () {
        function ne(le, ce) {
          for (var W = 0; W < ce.length; W++) {
            var $ = ce[W];
            $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(le, $.key, $);
          }
        }
        return function (le, ce, W) {
          return ce && ne(le.prototype, ce), W && ne(le, W), le;
        };
      }(),
      p = Nt,
      h = /* @__PURE__ */AN(),
      y = V(h),
      w = Cge(),
      x = j(w),
      E = kge(),
      C = V(E),
      k = z8(),
      D = j(k),
      I = Dge(),
      L = j(I),
      P = Rz(),
      N = V(P),
      O = V8(),
      F = V(O);
    Ige();
    function j(ne) {
      if (ne && ne.__esModule) return ne;
      var le = {};
      if (ne != null) for (var ce in ne) Object.prototype.hasOwnProperty.call(ne, ce) && (le[ce] = ne[ce]);
      return le.default = ne, le;
    }
    function V(ne) {
      return ne && ne.__esModule ? ne : {
        default: ne
      };
    }
    function K(ne, le) {
      if (!(ne instanceof le)) throw new TypeError("Cannot call a class as a function");
    }
    function G(ne, le) {
      if (!ne) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return le && (typeof le == "object" || typeof le == "function") ? le : ne;
    }
    function Q(ne, le) {
      if (typeof le != "function" && le !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof le);
      ne.prototype = Object.create(le && le.prototype, {
        constructor: {
          value: ne,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), le && (Object.setPrototypeOf ? Object.setPrototypeOf(ne, le) : ne.__proto__ = le);
    }
    var te = {
        overlay: "ReactModal__Overlay",
        content: "ReactModal__Content"
      },
      ie = function (le) {
        return le.code === "Tab" || le.keyCode === 9;
      },
      Y = function (le) {
        return le.code === "Escape" || le.keyCode === 27;
      },
      ee = 0,
      ae = function (ne) {
        Q(le, ne);
        function le(ce) {
          K(this, le);
          var W = G(this, (le.__proto__ || Object.getPrototypeOf(le)).call(this, ce));
          return W.setOverlayRef = function ($) {
            W.overlay = $, W.props.overlayRef && W.props.overlayRef($);
          }, W.setContentRef = function ($) {
            W.content = $, W.props.contentRef && W.props.contentRef($);
          }, W.afterClose = function () {
            var $ = W.props,
              de = $.appElement,
              H = $.ariaHideApp,
              se = $.htmlOpenClassName,
              ue = $.bodyOpenClassName,
              Ee = $.parentSelector,
              Ce = Ee && Ee().ownerDocument || document;
            ue && L.remove(Ce.body, ue), se && L.remove(Ce.getElementsByTagName("html")[0], se), H && ee > 0 && (ee -= 1, ee === 0 && D.show(de)), W.props.shouldFocusAfterRender && (W.props.shouldReturnFocusAfterClose ? (x.returnFocus(W.props.preventScroll), x.teardownScopedFocus()) : x.popWithoutFocus()), W.props.onAfterClose && W.props.onAfterClose(), F.default.deregister(W);
          }, W.open = function () {
            W.beforeOpen(), W.state.afterOpen && W.state.beforeClose ? (clearTimeout(W.closeTimer), W.setState({
              beforeClose: !1
            })) : (W.props.shouldFocusAfterRender && (x.setupScopedFocus(W.node), x.markForFocusLater()), W.setState({
              isOpen: !0
            }, function () {
              W.openAnimationFrame = requestAnimationFrame(function () {
                W.setState({
                  afterOpen: !0
                }), W.props.isOpen && W.props.onAfterOpen && W.props.onAfterOpen({
                  overlayEl: W.overlay,
                  contentEl: W.content
                });
              });
            }));
          }, W.close = function () {
            W.props.closeTimeoutMS > 0 ? W.closeWithTimeout() : W.closeWithoutTimeout();
          }, W.focusContent = function () {
            return W.content && !W.contentHasFocus() && W.content.focus({
              preventScroll: !0
            });
          }, W.closeWithTimeout = function () {
            var $ = Date.now() + W.props.closeTimeoutMS;
            W.setState({
              beforeClose: !0,
              closesAt: $
            }, function () {
              W.closeTimer = setTimeout(W.closeWithoutTimeout, W.state.closesAt - Date.now());
            });
          }, W.closeWithoutTimeout = function () {
            W.setState({
              beforeClose: !1,
              isOpen: !1,
              afterOpen: !1,
              closesAt: null
            }, W.afterClose);
          }, W.handleKeyDown = function ($) {
            ie($) && (0, C.default)(W.content, $), W.props.shouldCloseOnEsc && Y($) && ($.stopPropagation(), W.requestClose($));
          }, W.handleOverlayOnClick = function ($) {
            W.shouldClose === null && (W.shouldClose = !0), W.shouldClose && W.props.shouldCloseOnOverlayClick && (W.ownerHandlesClose() ? W.requestClose($) : W.focusContent()), W.shouldClose = null;
          }, W.handleContentOnMouseUp = function () {
            W.shouldClose = !1;
          }, W.handleOverlayOnMouseDown = function ($) {
            !W.props.shouldCloseOnOverlayClick && $.target == W.overlay && $.preventDefault();
          }, W.handleContentOnClick = function () {
            W.shouldClose = !1;
          }, W.handleContentOnMouseDown = function () {
            W.shouldClose = !1;
          }, W.requestClose = function ($) {
            return W.ownerHandlesClose() && W.props.onRequestClose($);
          }, W.ownerHandlesClose = function () {
            return W.props.onRequestClose;
          }, W.shouldBeClosed = function () {
            return !W.state.isOpen && !W.state.beforeClose;
          }, W.contentHasFocus = function () {
            return document.activeElement === W.content || W.content.contains(document.activeElement);
          }, W.buildClassName = function ($, de) {
            var H = (typeof de > "u" ? "undefined" : s(de)) === "object" ? de : {
                base: te[$],
                afterOpen: te[$] + "--after-open",
                beforeClose: te[$] + "--before-close"
              },
              se = H.base;
            return W.state.afterOpen && (se = se + " " + H.afterOpen), W.state.beforeClose && (se = se + " " + H.beforeClose), typeof de == "string" && de ? se + " " + de : se;
          }, W.attributesFromObject = function ($, de) {
            return Object.keys(de).reduce(function (H, se) {
              return H[$ + "-" + se] = de[se], H;
            }, {});
          }, W.state = {
            afterOpen: !1,
            beforeClose: !1
          }, W.shouldClose = null, W.moveFromContentToOverlay = null, W;
        }
        return c(le, [{
          key: "componentDidMount",
          value: function () {
            this.props.isOpen && this.open();
          }
        }, {
          key: "componentDidUpdate",
          value: function (W, $) {
            process.env.NODE_ENV !== "production" && (W.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), W.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !W.isOpen ? this.open() : !this.props.isOpen && W.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !$.isOpen && this.focusContent();
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
          }
        }, {
          key: "beforeOpen",
          value: function () {
            var W = this.props,
              $ = W.appElement,
              de = W.ariaHideApp,
              H = W.htmlOpenClassName,
              se = W.bodyOpenClassName,
              ue = W.parentSelector,
              Ee = ue && ue().ownerDocument || document;
            se && L.add(Ee.body, se), H && L.add(Ee.getElementsByTagName("html")[0], H), de && (ee += 1, D.hide($)), F.default.register(this);
          }
          // Don't steal focus from inner elements
        }, {
          key: "render",
          value: function () {
            var W = this.props,
              $ = W.id,
              de = W.className,
              H = W.overlayClassName,
              se = W.defaultStyles,
              ue = W.children,
              Ee = de ? {} : se.content,
              Ce = H ? {} : se.overlay;
            if (this.shouldBeClosed()) return null;
            var fe = {
                ref: this.setOverlayRef,
                className: this.buildClassName("overlay", H),
                style: i({}, Ce, this.props.style.overlay),
                onClick: this.handleOverlayOnClick,
                onMouseDown: this.handleOverlayOnMouseDown
              },
              _e = i({
                id: $,
                ref: this.setContentRef,
                style: i({}, Ee, this.props.style.content),
                className: this.buildClassName("content", de),
                tabIndex: "-1",
                onKeyDown: this.handleKeyDown,
                onMouseDown: this.handleContentOnMouseDown,
                onMouseUp: this.handleContentOnMouseUp,
                onClick: this.handleContentOnClick,
                role: this.props.role,
                "aria-label": this.props.contentLabel
              }, this.attributesFromObject("aria", i({
                modal: !0
              }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                "data-testid": this.props.testId
              }),
              Se = this.props.contentElement(_e, ue);
            return this.props.overlayElement(fe, Se);
          }
        }]), le;
      }(p.Component);
    ae.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    }, ae.propTypes = {
      isOpen: y.default.bool.isRequired,
      defaultStyles: y.default.shape({
        content: y.default.object,
        overlay: y.default.object
      }),
      style: y.default.shape({
        content: y.default.object,
        overlay: y.default.object
      }),
      className: y.default.oneOfType([y.default.string, y.default.object]),
      overlayClassName: y.default.oneOfType([y.default.string, y.default.object]),
      parentSelector: y.default.func,
      bodyOpenClassName: y.default.string,
      htmlOpenClassName: y.default.string,
      ariaHideApp: y.default.bool,
      appElement: y.default.oneOfType([y.default.instanceOf(N.default), y.default.instanceOf(P.SafeHTMLCollection), y.default.instanceOf(P.SafeNodeList), y.default.arrayOf(y.default.instanceOf(N.default))]),
      onAfterOpen: y.default.func,
      onAfterClose: y.default.func,
      onRequestClose: y.default.func,
      closeTimeoutMS: y.default.number,
      shouldFocusAfterRender: y.default.bool,
      shouldCloseOnOverlayClick: y.default.bool,
      shouldReturnFocusAfterClose: y.default.bool,
      preventScroll: y.default.bool,
      role: y.default.string,
      contentLabel: y.default.string,
      aria: y.default.object,
      data: y.default.object,
      children: y.default.node,
      shouldCloseOnEsc: y.default.bool,
      overlayRef: y.default.func,
      contentRef: y.default.func,
      id: y.default.string,
      overlayElement: y.default.func,
      contentElement: y.default.func,
      testId: y.default.string
    }, e.default = ae, t.exports = e.default;
  }(IM, IM.exports)), IM.exports;
}
function B8() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  t != null && this.setState(t);
}
function U8(t) {
  function e(i) {
    var s = this.constructor.getDerivedStateFromProps(t, i);
    return s ?? null;
  }
  this.setState(e.bind(this));
}
function H8(t, e) {
  try {
    var i = this.props,
      s = this.state;
    this.props = t, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(i, s);
  } finally {
    this.props = i, this.state = s;
  }
}
B8.__suppressDeprecationWarning = !0;
U8.__suppressDeprecationWarning = !0;
H8.__suppressDeprecationWarning = !0;
function Lge(t) {
  var e = t.prototype;
  if (!e || !e.isReactComponent) throw new Error("Can only polyfill class components");
  if (typeof t.getDerivedStateFromProps != "function" && typeof e.getSnapshotBeforeUpdate != "function") return t;
  var i = null,
    s = null,
    c = null;
  if (typeof e.componentWillMount == "function" ? i = "componentWillMount" : typeof e.UNSAFE_componentWillMount == "function" && (i = "UNSAFE_componentWillMount"), typeof e.componentWillReceiveProps == "function" ? s = "componentWillReceiveProps" : typeof e.UNSAFE_componentWillReceiveProps == "function" && (s = "UNSAFE_componentWillReceiveProps"), typeof e.componentWillUpdate == "function" ? c = "componentWillUpdate" : typeof e.UNSAFE_componentWillUpdate == "function" && (c = "UNSAFE_componentWillUpdate"), i !== null || s !== null || c !== null) {
    var p = t.displayName || t.name,
      h = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

` + p + " uses " + h + " but also contains the following legacy lifecycles:" + (i !== null ? `
  ` + i : "") + (s !== null ? `
  ` + s : "") + (c !== null ? `
  ` + c : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`);
  }
  if (typeof t.getDerivedStateFromProps == "function" && (e.componentWillMount = B8, e.componentWillReceiveProps = U8), typeof e.getSnapshotBeforeUpdate == "function") {
    if (typeof e.componentDidUpdate != "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    e.componentWillUpdate = H8;
    var y = e.componentDidUpdate;
    e.componentDidUpdate = function (x, E, C) {
      var k = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : C;
      y.call(this, x, E, k);
    };
  }
  return t;
}
const Oge = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    polyfill: Lge
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  Pge = /* @__PURE__ */cQ(Oge);
var LU;
function Age() {
  if (LU) return Y0;
  LU = 1, Object.defineProperty(Y0, "__esModule", {
    value: !0
  }), Y0.bodyOpenClassName = Y0.portalClassName = void 0;
  var t = Object.assign || function (Y) {
      for (var ee = 1; ee < arguments.length; ee++) {
        var ae = arguments[ee];
        for (var ne in ae) Object.prototype.hasOwnProperty.call(ae, ne) && (Y[ne] = ae[ne]);
      }
      return Y;
    },
    e = /* @__PURE__ */function () {
      function Y(ee, ae) {
        for (var ne = 0; ne < ae.length; ne++) {
          var le = ae[ne];
          le.enumerable = le.enumerable || !1, le.configurable = !0, "value" in le && (le.writable = !0), Object.defineProperty(ee, le.key, le);
        }
      }
      return function (ee, ae, ne) {
        return ae && Y(ee.prototype, ae), ne && Y(ee, ne), ee;
      };
    }(),
    i = Nt,
    s = P(i),
    c = F8(),
    p = P(c),
    h = /* @__PURE__ */AN(),
    y = P(h),
    w = Mge(),
    x = P(w),
    E = z8(),
    C = L(E),
    k = Rz(),
    D = P(k),
    I = Pge;
  function L(Y) {
    if (Y && Y.__esModule) return Y;
    var ee = {};
    if (Y != null) for (var ae in Y) Object.prototype.hasOwnProperty.call(Y, ae) && (ee[ae] = Y[ae]);
    return ee.default = Y, ee;
  }
  function P(Y) {
    return Y && Y.__esModule ? Y : {
      default: Y
    };
  }
  function N(Y, ee) {
    if (!(Y instanceof ee)) throw new TypeError("Cannot call a class as a function");
  }
  function O(Y, ee) {
    if (!Y) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ee && (typeof ee == "object" || typeof ee == "function") ? ee : Y;
  }
  function F(Y, ee) {
    if (typeof ee != "function" && ee !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof ee);
    Y.prototype = Object.create(ee && ee.prototype, {
      constructor: {
        value: Y,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ee && (Object.setPrototypeOf ? Object.setPrototypeOf(Y, ee) : Y.__proto__ = ee);
  }
  var j = Y0.portalClassName = "ReactModalPortal",
    V = Y0.bodyOpenClassName = "ReactModal__Body--open",
    K = k.canUseDOM && p.default.createPortal !== void 0,
    G = function (ee) {
      return document.createElement(ee);
    },
    Q = function () {
      return K ? p.default.createPortal : p.default.unstable_renderSubtreeIntoContainer;
    };
  function te(Y) {
    return Y();
  }
  var ie = function (Y) {
    F(ee, Y);
    function ee() {
      var ae, ne, le, ce;
      N(this, ee);
      for (var W = arguments.length, $ = Array(W), de = 0; de < W; de++) $[de] = arguments[de];
      return ce = (ne = (le = O(this, (ae = ee.__proto__ || Object.getPrototypeOf(ee)).call.apply(ae, [this].concat($))), le), le.removePortal = function () {
        !K && p.default.unmountComponentAtNode(le.node);
        var H = te(le.props.parentSelector);
        H && H.contains(le.node) ? H.removeChild(le.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }, le.portalRef = function (H) {
        le.portal = H;
      }, le.renderPortal = function (H) {
        var se = Q(),
          ue = se(le, s.default.createElement(x.default, t({
            defaultStyles: ee.defaultStyles
          }, H)), le.node);
        le.portalRef(ue);
      }, ne), O(le, ce);
    }
    return e(ee, [{
      key: "componentDidMount",
      value: function () {
        if (k.canUseDOM) {
          K || (this.node = G("div")), this.node.className = this.props.portalClassName;
          var ne = te(this.props.parentSelector);
          ne.appendChild(this.node), !K && this.renderPortal(this.props);
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function (ne) {
        var le = te(ne.parentSelector),
          ce = te(this.props.parentSelector);
        return {
          prevParent: le,
          nextParent: ce
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function (ne, le, ce) {
        if (k.canUseDOM) {
          var W = this.props,
            $ = W.isOpen,
            de = W.portalClassName;
          ne.portalClassName !== de && (this.node.className = de);
          var H = ce.prevParent,
            se = ce.nextParent;
          se !== H && (H.removeChild(this.node), se.appendChild(this.node)), !(!ne.isOpen && !$) && !K && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        if (!(!k.canUseDOM || !this.node || !this.portal)) {
          var ne = this.portal.state,
            le = Date.now(),
            ce = ne.isOpen && this.props.closeTimeoutMS && (ne.closesAt || le + this.props.closeTimeoutMS);
          ce ? (ne.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, ce - le)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function () {
        if (!k.canUseDOM || !K) return null;
        !this.node && K && (this.node = G("div"));
        var ne = Q();
        return ne(s.default.createElement(x.default, t({
          ref: this.portalRef,
          defaultStyles: ee.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function (ne) {
        C.setElement(ne);
      }
      /* eslint-disable react/no-unused-prop-types */
      /* eslint-enable react/no-unused-prop-types */
    }]), ee;
  }(i.Component);
  return ie.propTypes = {
    isOpen: y.default.bool.isRequired,
    style: y.default.shape({
      content: y.default.object,
      overlay: y.default.object
    }),
    portalClassName: y.default.string,
    bodyOpenClassName: y.default.string,
    htmlOpenClassName: y.default.string,
    className: y.default.oneOfType([y.default.string, y.default.shape({
      base: y.default.string.isRequired,
      afterOpen: y.default.string.isRequired,
      beforeClose: y.default.string.isRequired
    })]),
    overlayClassName: y.default.oneOfType([y.default.string, y.default.shape({
      base: y.default.string.isRequired,
      afterOpen: y.default.string.isRequired,
      beforeClose: y.default.string.isRequired
    })]),
    appElement: y.default.oneOfType([y.default.instanceOf(D.default), y.default.instanceOf(k.SafeHTMLCollection), y.default.instanceOf(k.SafeNodeList), y.default.arrayOf(y.default.instanceOf(D.default))]),
    onAfterOpen: y.default.func,
    onRequestClose: y.default.func,
    closeTimeoutMS: y.default.number,
    ariaHideApp: y.default.bool,
    shouldFocusAfterRender: y.default.bool,
    shouldCloseOnOverlayClick: y.default.bool,
    shouldReturnFocusAfterClose: y.default.bool,
    preventScroll: y.default.bool,
    parentSelector: y.default.func,
    aria: y.default.object,
    data: y.default.object,
    role: y.default.string,
    contentLabel: y.default.string,
    shouldCloseOnEsc: y.default.bool,
    overlayRef: y.default.func,
    contentRef: y.default.func,
    id: y.default.string,
    overlayElement: y.default.func,
    contentElement: y.default.func
  }, ie.defaultProps = {
    isOpen: !1,
    portalClassName: j,
    bodyOpenClassName: V,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    preventScroll: !1,
    parentSelector: function () {
      return document.body;
    },
    overlayElement: function (ee, ae) {
      return s.default.createElement("div", ee, ae);
    },
    contentElement: function (ee, ae) {
      return s.default.createElement("div", ee, ae);
    }
  }, ie.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, I.polyfill)(ie), process.env.NODE_ENV !== "production" && (ie.setCreateHTMLElement = function (Y) {
    return G = Y;
  }), Y0.default = ie, Y0;
}
var OU;
function jge() {
  return OU || (OU = 1, function (t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = Age(),
      s = c(i);
    function c(p) {
      return p && p.__esModule ? p : {
        default: p
      };
    }
    e.default = s.default, t.exports = e.default;
  }(TM, TM.exports)), TM.exports;
}
var Fge = jge();
const Nge = /* @__PURE__ */KL(Fge);
function zge(t) {
  if (Array.isArray(t)) {
    for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
    return i;
  } else return Array.from(t);
}
var Dz = !1;
if (typeof window < "u") {
  var PU = {
    get passive() {
      Dz = !0;
    }
  };
  window.addEventListener("testPassive", null, PU), window.removeEventListener("testPassive", null, PU);
}
var $8 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1),
  ew = [],
  PL = !1,
  W8 = -1,
  QT = void 0,
  ZT = void 0,
  q8 = function (e) {
    return ew.some(function (i) {
      return !!(i.options.allowTouchMove && i.options.allowTouchMove(e));
    });
  },
  AL = function (e) {
    var i = e || window.event;
    return q8(i.target) || i.touches.length > 1 ? !0 : (i.preventDefault && i.preventDefault(), !1);
  },
  Vge = function (e) {
    if (ZT === void 0) {
      var i = !!e && e.reserveScrollBarGap === !0,
        s = window.innerWidth - document.documentElement.clientWidth;
      i && s > 0 && (ZT = document.body.style.paddingRight, document.body.style.paddingRight = s + "px");
    }
    QT === void 0 && (QT = document.body.style.overflow, document.body.style.overflow = "hidden");
  },
  Bge = function () {
    ZT !== void 0 && (document.body.style.paddingRight = ZT, ZT = void 0), QT !== void 0 && (document.body.style.overflow = QT, QT = void 0);
  },
  Uge = function (e) {
    return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
  },
  Hge = function (e, i) {
    var s = e.targetTouches[0].clientY - W8;
    return q8(e.target) ? !1 : i && i.scrollTop === 0 && s > 0 || Uge(i) && s < 0 ? AL(e) : (e.stopPropagation(), !0);
  },
  $ge = function (e, i) {
    if (!e) {
      console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
      return;
    }
    if (!ew.some(function (c) {
      return c.targetElement === e;
    })) {
      var s = {
        targetElement: e,
        options: i || {}
      };
      ew = [].concat(zge(ew), [s]), $8 ? (e.ontouchstart = function (c) {
        c.targetTouches.length === 1 && (W8 = c.targetTouches[0].clientY);
      }, e.ontouchmove = function (c) {
        c.targetTouches.length === 1 && Hge(c, e);
      }, PL || (document.addEventListener("touchmove", AL, Dz ? {
        passive: !1
      } : void 0), PL = !0)) : Vge(i);
    }
  },
  AU = function (e) {
    if (!e) {
      console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
      return;
    }
    ew = ew.filter(function (i) {
      return i.targetElement !== e;
    }), $8 ? (e.ontouchstart = null, e.ontouchmove = null, PL && ew.length === 0 && (document.removeEventListener("touchmove", AL, Dz ? {
      passive: !1
    } : void 0), PL = !1)) : ew.length || Bge();
  };
const Wge = "_scrim_1fq8u_1",
  qge = "_dark_1fq8u_19",
  Yge = "_light_1fq8u_22",
  Gge = "_mobileFullScreen_1fq8u_26",
  Xge = "_modal_1fq8u_33",
  Kge = "_modalOpen_1fq8u_54",
  Qge = "_md_1fq8u_58",
  Zge = "_lg_1fq8u_61",
  Jge = "_modalTitle_1fq8u_72",
  eye = "_modalHeader_1fq8u_80",
  tye = "_modalCloseButton_1fq8u_87",
  nye = "_content_1fq8u_113",
  xl = {
    scrim: Wge,
    dark: qge,
    light: Yge,
    mobileFullScreen: Gge,
    modal: Xge,
    modalOpen: Kge,
    md: Qge,
    lg: Zge,
    modalTitle: Jge,
    modalHeader: eye,
    modalCloseButton: tye,
    content: nye
  },
  jU = {
    content: "Modal",
    close: "Close"
  },
  rye = ({
    appElement: t,
    children: e,
    title: i,
    header: s,
    className: c,
    classNames: p,
    labels: h = jU,
    size: y = "sm",
    variant: w = "dark",
    mobileFullScreen: x = !1,
    isOpen: E,
    onClose: C,
    isDismissible: k = !0,
    withoutContentWrapper: D = !1,
    ...I
  }) => {
    const L = {
        ...jU,
        ...h
      },
      P = vt(null),
      N = vt(null),
      O = () => {
        var K;
        P.current && $ge(P.current, {
          reserveScrollBarGap: !0
        }), (K = N.current) == null || K.focus();
      },
      F = () => {
        P.current && AU(P.current);
      },
      j = () => {
        P.current && AU(P.current), C == null || C();
      },
      V = k ? /* @__PURE__ */B.jsx("button", {
        type: "button",
        ref: N,
        className: ve(xl.modalCloseButton, p == null ? void 0 : p.closeButton),
        "aria-label": L.close,
        onClick: j,
        children: /* @__PURE__ */B.jsx(ln, {
          name: "close",
          hidden: !0
        })
      }) : null;
    return /* @__PURE__ */B.jsxs(Nge, {
      appElement: t,
      className: ve(c, xl.modal, y && xl[y], E && xl.modalOpen, x && xl.mobileFullScreen),
      overlayClassName: ve(xl.scrim, p == null ? void 0 : p.scrim, x && xl.mobileFullScreen, xl[w]),
      contentLabel: L.content,
      isOpen: E,
      onAfterOpen: O,
      onAfterClose: F,
      onRequestClose: j,
      contentRef: K => {
        K && (P.current = K);
      },
      shouldCloseOnOverlayClick: k,
      shouldCloseOnEsc: k,
      ...I,
      children: [i && /* @__PURE__ */B.jsxs("div", {
        className: ve(xl.modalHeader),
        children: [/* @__PURE__ */B.jsx("div", {
          className: ve(xl.modalTitle, p == null ? void 0 : p.title),
          children: i
        }), V]
      }), !i && V, s && /* @__PURE__ */B.jsx("div", {
        className: ve(xl.modalHeader),
        children: s
      }), D ? e : /* @__PURE__ */B.jsx("div", {
        className: ve(xl.content, p == null ? void 0 : p.content),
        children: e
      })]
    });
  },
  FU = {
    content: "Modal",
    close: "Close"
  },
  iye = ({
    isOpen: t = !1,
    isDismissible: e = !0,
    onClose: i = () => !0,
    className: s,
    classNames: c,
    size: p = "sm",
    variant: h = "dark",
    withoutContentWrapper: y = !1,
    mobileFullScreen: w = !1,
    children: x,
    title: E,
    header: C,
    labels: k = FU
  }) => {
    const D = vt(null),
      I = vt(!1),
      L = {
        ...FU,
        ...k
      },
      P = j => {
        j && j.stopPropagation();
        let V = !1;
        if (typeof i == "function" ? i() !== !1 && (V = !0) : V = !0, V) {
          const K = D.current;
          K && K.open && K.close();
        }
      },
      N = j => {
        j.key === "Escape" && (e ? P() : (j.preventDefault(), j.stopPropagation()));
      },
      O = (j, V) => {
        const K = D.current;
        if (!K || !e) return;
        const G = K.getBoundingClientRect(),
          Q = j.clientX >= G.left && j.clientX <= G.right && j.clientY >= G.top && j.clientY <= G.bottom;
        V === "down" ? I.current = Q : V === "up" && !I.current && !Q && P(j);
      };
    Rt(() => {
      D.current && (t ? D.current.showModal() : P());
    }, [t]);
    const F = e ? /* @__PURE__ */B.jsx("button", {
      type: "button",
      className: ve(xl.modalCloseButton, c == null ? void 0 : c.closeButton),
      "aria-label": L.close,
      onClick: P,
      children: /* @__PURE__ */B.jsx(ln, {
        name: "close",
        hidden: !0
      })
    }) : null;
    return /* @__PURE__ */B.jsxs("dialog", {
      ref: D,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": L.content,
      "data-theme": h,
      className: ve(xl.modal, c == null ? void 0 : c.scrim, p && xl[p], w && xl.mobileFullScreen, s),
      "data-modal": !0,
      onKeyDown: N,
      onMouseDown: j => O(j, "down"),
      onMouseUp: j => O(j, "up"),
      children: [E && /* @__PURE__ */B.jsxs("div", {
        className: ve(xl.modalHeader),
        children: [E && /* @__PURE__ */B.jsx("div", {
          className: ve(xl.modalTitle, c == null ? void 0 : c.title),
          children: E
        }), F]
      }), !E && F, C && /* @__PURE__ */B.jsx("div", {
        className: ve(xl.modalHeader),
        children: C
      }), y ? x : /* @__PURE__ */B.jsx("div", {
        className: ve(xl.content, c == null ? void 0 : c.content),
        children: x
      })]
    });
  },
  exe = ({
    implementation: t,
    ...e
  }) => t === "react" ? /* @__PURE__ */B.jsx(rye, {
    ...e
  }) : /* @__PURE__ */B.jsx(iye, {
    ...e
  }),
  txe = {
    sm: "sm",
    md: "md",
    lg: "lg"
  },
  nxe = {
    light: "light",
    dark: "dark",
    custom: "custom"
  },
  aye = "_container_jjqkc_1",
  oye = "_gridImages_jjqkc_5",
  lye = "_gridItem_jjqkc_13",
  sye = "_threeQuarters_jjqkc_18",
  uye = "_twoThirds_jjqkc_18",
  cye = "_fullWidth_jjqkc_22",
  dye = "_logo_jjqkc_34",
  fye = "_topLeft_jjqkc_50",
  pye = "_topRight_jjqkc_51",
  hye = "_btmLeft_jjqkc_55",
  mye = "_btmRight_jjqkc_56",
  Vm = {
    container: aye,
    gridImages: oye,
    gridItem: lye,
    threeQuarters: sye,
    twoThirds: uye,
    fullWidth: cye,
    logo: dye,
    topLeft: fye,
    topRight: pye,
    btmLeft: hye,
    btmRight: mye
  },
  RT = {
    topLeft: "top-left",
    topRight: "top-right",
    bottomLeft: "bottom-left",
    bottomRight: "bottom-right"
  },
  p2 = {
    oneHalf: "1/2",
    twoThirds: "2/3",
    threeQuarters: "3/4"
  },
  rxe = ({
    className: t,
    images: e,
    logo: i,
    logoPosition: s = RT.topLeft,
    populateImagesRightToLeft: c,
    populateImagesAsRows: p,
    columnProportions: h = p2.oneHalf,
    photoCredit: y,
    renderImage: w = x => /* @__PURE__ */B.jsx("img", {
      ...x
    })
  }) => {
    const x = ve(Vm.gridItem, {
      [Vm.fullWidth]: p,
      [Vm.threeQuarters]: h === p2.threeQuarters,
      [Vm.twoThirds]: h === p2.twoThirds
    });
    return c && e.reverse(), /* @__PURE__ */B.jsxs("div", {
      className: t,
      children: [/* @__PURE__ */B.jsxs("div", {
        className: Vm.container,
        children: [i && /* @__PURE__ */B.jsx("div", {
          className: ve(Vm.logo, {
            [Vm.topLeft]: s === RT.topLeft,
            [Vm.topRight]: s === RT.topRight,
            [Vm.btmLeft]: s === RT.bottomLeft,
            [Vm.btmRight]: s === RT.bottomRight
          }),
          children: w(i)
        }), /* @__PURE__ */B.jsx("div", {
          className: ve(Vm.gridImages),
          children: e.map(E => /* @__PURE__ */B.jsx("div", {
            className: x,
            children: w(E)
          }, E.id))
        })]
      }), y && /* @__PURE__ */B.jsx("p", {
        children: y
      })]
    });
  },
  vye = "_notifications_bl1sf_1",
  gye = "_menuWrapper_bl1sf_15",
  yye = "_menuItem_bl1sf_19",
  bye = "_active_bl1sf_27",
  wye = "_icon_bl1sf_30",
  _ye = "_type_bl1sf_33",
  xye = "_listBody_bl1sf_40",
  Sye = "_listContainer_bl1sf_44",
  Eye = "_listHeader_bl1sf_51",
  Cye = "_listHeading_bl1sf_55",
  kye = "_listClose_bl1sf_61",
  Tye = "_listCloseButton_bl1sf_64",
  Rye = "_listContent_bl1sf_77",
  Dye = "_missingNotifications_bl1sf_80",
  Iye = "_listFooter_bl1sf_86",
  Mye = "_listFooterLink_bl1sf_91",
  Lye = "_listItemWrapper_bl1sf_94",
  Oye = "_listItemMessage_bl1sf_109",
  Pye = "_listItemHeader_bl1sf_114",
  Aye = "_listItemHeading_bl1sf_123",
  jye = "_listItemIcon_bl1sf_126",
  Fye = "_listItemTitle_bl1sf_135",
  Nye = "_listItemDate_bl1sf_145",
  zye = "_listItemSubHeading_bl1sf_151",
  Vye = "_listItemAnchor_bl1sf_173",
  Bye = "_desktop_bl1sf_186",
  Uye = "_mobile_bl1sf_189",
  Hye = "_auto_bl1sf_205",
  $ye = "_srOnly_bl1sf_228",
  Bi = {
    notifications: vye,
    menuWrapper: gye,
    menuItem: yye,
    active: bye,
    icon: wye,
    type: _ye,
    listBody: xye,
    listContainer: Sye,
    listHeader: Eye,
    listHeading: Cye,
    listClose: kye,
    listCloseButton: Tye,
    listContent: Rye,
    missingNotifications: Dye,
    listFooter: Iye,
    listFooterLink: Mye,
    listItemWrapper: Lye,
    listItemMessage: Oye,
    listItemHeader: Pye,
    listItemHeading: Aye,
    listItemIcon: jye,
    listItemTitle: Fye,
    listItemDate: Nye,
    listItemSubHeading: zye,
    listItemAnchor: Vye,
    desktop: Bye,
    mobile: Uye,
    auto: Hye,
    srOnly: $ye
  },
  ixe = ({
    storageId: t,
    locale: e = "en-CA",
    labels: i,
    data: s,
    triggerElement: c,
    menuSettings: p,
    template: h = "auto",
    onGetActiveTotal: y,
    renderCloseIcon: w,
    renderMenuIcon: x,
    renderFilterLink: E,
    renderNotificationLink: C,
    renderNotificationIcon: k,
    className: D,
    classNames: I
  }) => /* @__PURE__ */B.jsx(cG, {
    storageId: t,
    locale: e,
    labels: i,
    data: s,
    triggerElement: c,
    menuSettings: p,
    onGetActiveTotal: y,
    renderCloseIcon: w,
    renderMenuIcon: x,
    renderFilterLink: E ?? ((L, P) => /* @__PURE__ */B.jsx(dd, {
      className: P,
      href: L.filterLink,
      icon: "chevron-right-micro",
      children: L.filterLinkText
    })),
    renderNotificationLink: C,
    renderNotificationIcon: k,
    className: ve(Bi.notifications, Bi == null ? void 0 : Bi[h], D),
    classNames: {
      // Menu extensions
      menuWrapper: ve(Bi.menuWrapper, I == null ? void 0 : I.menuWrapper),
      menuContainer: ve(I == null ? void 0 : I.menuContainer),
      menuItem: ve(Bi.menuItem, I == null ? void 0 : I.menuItem),
      menuItemActive: ve(Bi.active, I == null ? void 0 : I.menuItemActive),
      menuItemIcon: ve(Bi.icon, I == null ? void 0 : I.menuItemIcon),
      menuItemType: ve(Bi.type, I == null ? void 0 : I.menuItemType),
      // List extensions
      listBody: ve(Bi.listBody, I == null ? void 0 : I.listBody),
      listContainer: ve(Bi.listContainer, I == null ? void 0 : I.listContainer),
      listHeader: ve(Bi.listHeader, I == null ? void 0 : I.listHeader),
      listHeading: ve(Bi.listHeading, I == null ? void 0 : I.listHeading),
      listClose: ve(Bi.listClose, I == null ? void 0 : I.listClose),
      listCloseButton: ve(Bi.listCloseButton, I == null ? void 0 : I.listCloseButton),
      listContent: ve(Bi.listContent, I == null ? void 0 : I.listContent),
      listFooter: ve(Bi.listFooter, I == null ? void 0 : I.listFooter),
      listFooterLink: ve(Bi.listFooterLink, I == null ? void 0 : I.listFooterLink),
      // List Items
      listItemWrapper: ve(Bi.listItemWrapper, I == null ? void 0 : I.listItemWrapper),
      listItemActive: ve(Bi.active, I == null ? void 0 : I.listItemActive),
      listItemHeader: ve(Bi.listItemHeader, I == null ? void 0 : I.listItemHeader),
      listItemHeading: ve(Bi.listItemHeading, I == null ? void 0 : I.listItemHeading),
      listItemAnchor: ve(Bi.listItemAnchor, I == null ? void 0 : I.listItemAnchor),
      listItemDate: ve(Bi.listItemDate, I == null ? void 0 : I.listItemDate),
      listItemIcon: ve(Bi.listItemIcon, I == null ? void 0 : I.listItemIcon),
      listItemMessage: ve(Bi.listItemMessage, I == null ? void 0 : I.listItemMessage),
      listItemSubHeading: ve(Bi.listItemSubHeading, I == null ? void 0 : I.listItemSubHeading),
      listItemTitle: ve(Bi.listItemTitle, I == null ? void 0 : I.listItemTitle),
      // Missing message
      listMissing: ve(Bi.missingNotifications, I == null ? void 0 : I.listMissing)
    }
  }),
  Wye = "_messageContainer_oxxbr_1",
  qye = {
    messageContainer: Wye
  },
  axe = ({
    align: t,
    size: e,
    status: i,
    responsive: s,
    disableLarge: c,
    message: p,
    title: h,
    theme: y,
    className: w,
    classNames: x
  }) => {
    let E = gs.color.white.value,
      C = gs.color.white.value;
    return y === "teal" && (E = gs.color.gray[400].value, C = gs.color.teal[500].value), /* @__PURE__ */B.jsx(FE, {
      align: t,
      size: e,
      status: i,
      responsive: s,
      disableLarge: c,
      message: p,
      trackColor: E,
      strokeColor: C,
      title: h,
      className: w,
      classNames: {
        messageContainer: ve(qye.messageContainer, x == null ? void 0 : x.messageContainer),
        title: x == null ? void 0 : x.title,
        message: x == null ? void 0 : x.message
      }
    });
  };
function OM(t, e) {
  const i = vt(t),
    s = vt();
  return Rt(() => {
    i.current = t;
  }, [t]), Rt(() => () => {
    s.current && clearTimeout(s.current);
  }, []), pn((...c) => {
    s.current && clearTimeout(s.current), s.current = setTimeout(() => {
      i.current(...c);
    }, e);
  }, [e]);
}
const Yye = "_tabsWrapper_1enm5_1",
  Gye = "_tablist_1enm5_13",
  Xye = "_trigger_1enm5_30",
  Kye = "_triggerText_1enm5_43",
  Qye = "_scrollButton_1enm5_77",
  Zye = "_icon_1enm5_98",
  fb = {
    tabsWrapper: Yye,
    tablist: Gye,
    trigger: Xye,
    triggerText: Kye,
    scrollButton: Qye,
    icon: Zye
  },
  Jye = 100,
  PM = 50,
  ebe = 65,
  tbe = ({
    sections: t,
    offset: e = ebe,
    ...i
  }) => {
    var G;
    const s = vt(null),
      [c, p] = rt(!1),
      [h, y] = rt(!1),
      [w, x] = rt(!1),
      [E, C] = rt(((G = t[0]) == null ? void 0 : G.cardKey) ?? ""),
      k = pn(Q => {
        s.current && (s.current.scrollLeft += Q);
      }, []),
      D = pn(() => {
        const Q = s.current;
        if (!Q) return;
        const {
          scrollLeft: te,
          scrollWidth: ie,
          clientWidth: Y
        } = Q;
        y(te > 0), x(te < ie - Y - 1);
      }, []),
      I = pn(() => {
        const Q = s.current;
        Q && (p(Q.scrollWidth > Q.clientWidth), D());
      }, [D]),
      L = pn(Q => {
        const te = s.current;
        if (!te) return;
        const ie = te.querySelector(`[data-value="${Q}"]`);
        if (!ie) return;
        const Y = te.getBoundingClientRect(),
          ee = ie.getBoundingClientRect();
        if (!(ee.left >= Y.left && ee.right <= Y.right)) {
          const ne = ie.offsetLeft - Y.width / 2 + ee.width / 2;
          te.scrollTo({
            left: ne,
            behavior: "smooth"
          });
        }
      }, []),
      P = pn(Q => {
        const te = document.getElementById(Q.id);
        if (!te) return;
        const ie = te.offsetTop - e;
        window.scrollTo({
          top: ie,
          behavior: "smooth"
        });
      }, [e]),
      N = pn(() => {
        const Q = window.scrollY + e,
          te = window.scrollY + window.innerHeight,
          ie = document.documentElement.scrollHeight;
        if (Math.abs(te - ie) < 10) {
          const ee = t[t.length - 1];
          C(ee.cardKey), V(ee.cardKey);
          return;
        }
        const Y = t.find(ee => ee.cardKey === E);
        if (Y) {
          const ee = document.getElementById(Y.id);
          if (ee) {
            const ae = ee.offsetTop - e,
              ne = ae + ee.offsetHeight;
            if (ae <= Q && ne >= Q) return;
          }
        }
        for (let ee = t.length - 1; ee >= 0; ee--) {
          const ae = t[ee],
            ne = document.getElementById(ae.id);
          if (!ne) continue;
          if (ne.offsetTop - e <= Q) {
            C(ae.cardKey), V(ae.cardKey);
            return;
          }
        }
        C(t[0].cardKey), V(t[0].cardKey);
      }, [t, e, E]),
      O = pn(Q => {
        const te = t.find(ie => ie.cardKey === Q);
        te && (C(Q), P(te), L(Q));
      }, [t, P, L]),
      F = OM(D, PM),
      j = OM(I, PM),
      V = OM(Q => {
        typeof Q == "string" && L(Q);
      }, PM),
      K = OM(N, PM);
    return Rt(() => {
      const Q = s.current;
      if (!Q) return;
      const te = new ResizeObserver(j);
      return te.observe(Q), () => te.disconnect();
    }, [j]), Rt(() => {
      const Q = s.current;
      if (Q) return F(), Q.addEventListener("scroll", F), window.addEventListener("resize", j), () => {
        Q.removeEventListener("scroll", F), window.removeEventListener("resize", j);
      };
    }, [F, j]), Rt(() => (window.addEventListener("scroll", K), N(), () => window.removeEventListener("scroll", K)), [N, K]), /* @__PURE__ */B.jsxs(la.div, {
      className: fb.tabsWrapper,
      children: [c && /* @__PURE__ */B.jsx(la.button, {
        className: fb.scrollButton,
        onClick: () => k(-100),
        disabled: !h,
        "aria-label": "Scroll left",
        children: /* @__PURE__ */B.jsx(ln, {
          name: "chevron-left",
          "aria-hidden": !0
        })
      }), /* @__PURE__ */B.jsx(oY, {
        id: "navlist",
        className: fb.tablist,
        ref: s,
        value: E,
        onValueChange: O,
        ...i
      }), c && /* @__PURE__ */B.jsx(la.button, {
        className: fb.scrollButton,
        onClick: () => k(Jye),
        disabled: !w,
        "aria-label": "Scroll right",
        children: /* @__PURE__ */B.jsx(ln, {
          name: "chevron-right",
          "aria-hidden": !0
        })
      })]
    });
  },
  nbe = ({
    children: t,
    value: e,
    icon: i
  }) => /* @__PURE__ */B.jsxs(aY, {
    className: ve(fb == null ? void 0 : fb.trigger),
    value: e,
    "data-value": e,
    children: [i && /* @__PURE__ */B.jsx(ln, {
      name: i,
      className: fb.icon,
      "aria-hidden": !0
    }), /* @__PURE__ */B.jsx("span", {
      className: fb.triggerText,
      children: t
    })]
  });
tbe.Item = nbe;
const rbe = {
    breakpoint: {
      sm: {
        value: "576px"
      }
    }
  },
  kR = parseInt(rbe.breakpoint.sm.value, 10),
  ibe = -100,
  abe = "^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$",
  tO = {
    mobileImage: "https://placehold.co/351x140",
    desktopLargeImage: "https://placehold.co/570x486",
    desktopSmallImage: "https://placehold.co/386x547",
    title: "Subscribe now",
    subtitle: "Sign up to be one of the first to hear about the latest offers from WestJet Vacations and for vacation planning inspiration.",
    submit: "Submit",
    confirmTitle: "Thank you",
    confirmMessage: "Lorem ipsum dolor sit amet consectetur. Fermentum sed suspendisse eu etiam faucibus. Etiam pulvinar quis habitant eu ultricies risus cursus donec.",
    inputFieldLabel: "Email",
    dropdownFieldLabel: "Preferred departure city",
    dropdownFieldErrorMissing: "Please select a departure city",
    optInMessage: "I want emails from WestJet Vacations Inc. on exclusive offers, promotions and vacation inspiration, including special offers from WestJet Vacations’ travel partners. You may unsubscribe at anytime by clicking the link in any marketing email we send you.",
    optInPrivacyLink: "https://www.westjet.com/en/privacy-policy",
    optInPrivacyLabel: "Privacy policy",
    optInContactLink: "https://www.westjet.com/en/contact-us",
    optInContactLabel: "Contact us",
    optInA11yMessage: " (opens in a new tab)",
    validityMessages: {
      valueMissing: "Please enter an email address",
      typeMismatch: "That doesn't look like a valid email.",
      patternMismatch: "Please use a full domain (e.g. name@example.com)."
    },
    errorUnknown: "An unexpected error occurred"
  };
var Iz = XR(),
  ur = t => GR(t, Iz),
  Mz = XR();
ur.write = t => GR(t, Mz);
var nO = XR();
ur.onStart = t => GR(t, nO);
var Lz = XR();
ur.onFrame = t => GR(t, Lz);
var Oz = XR();
ur.onFinish = t => GR(t, Oz);
var bE = [];
ur.setTimeout = (t, e) => {
  const i = ur.now() + e,
    s = () => {
      const p = bE.findIndex(h => h.cancel == s);
      ~p && bE.splice(p, 1), nw -= ~p ? 1 : 0;
    },
    c = {
      time: i,
      handler: t,
      cancel: s
    };
  return bE.splice(Y8(i), 0, c), nw += 1, G8(), c;
};
var Y8 = t => ~(~bE.findIndex(e => e.time > t) || ~bE.length);
ur.cancel = t => {
  nO.delete(t), Lz.delete(t), Oz.delete(t), Iz.delete(t), Mz.delete(t);
};
ur.sync = t => {
  yF = !0, ur.batchedUpdates(t), yF = !1;
};
ur.throttle = t => {
  let e;
  function i() {
    try {
      t(...e);
    } finally {
      e = null;
    }
  }
  function s(...c) {
    e = c, ur.onStart(i);
  }
  return s.handler = t, s.cancel = () => {
    nO.delete(i), e = null;
  }, s;
};
var Pz = typeof window < "u" ? window.requestAnimationFrame :
// eslint-disable-next-line @typescript-eslint/no-empty-function
() => {};
ur.use = t => Pz = t;
ur.now = typeof performance < "u" ? () => performance.now() : Date.now;
ur.batchedUpdates = t => t();
ur.catch = console.error;
ur.frameLoop = "always";
ur.advance = () => {
  ur.frameLoop !== "demand" ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : K8();
};
var tw = -1,
  nw = 0,
  yF = !1;
function GR(t, e) {
  yF ? (e.delete(t), t(0)) : (e.add(t), G8());
}
function G8() {
  tw < 0 && (tw = 0, ur.frameLoop !== "demand" && Pz(X8));
}
function obe() {
  tw = -1;
}
function X8() {
  ~tw && (Pz(X8), ur.batchedUpdates(K8));
}
function K8() {
  const t = tw;
  tw = ur.now();
  const e = Y8(tw);
  if (e && (Q8(bE.splice(0, e), i => i.handler()), nw -= e), !nw) {
    obe();
    return;
  }
  nO.flush(), Iz.flush(t ? Math.min(64, tw - t) : 16.667), Lz.flush(), Mz.flush(), Oz.flush();
}
function XR() {
  let t = /* @__PURE__ */new Set(),
    e = t;
  return {
    add(i) {
      nw += e == t && !t.has(i) ? 1 : 0, t.add(i);
    },
    delete(i) {
      return nw -= e == t && t.has(i) ? 1 : 0, t.delete(i);
    },
    flush(i) {
      e.size && (t = /* @__PURE__ */new Set(), nw -= e.size, Q8(e, s => s(i) && t.add(s)), nw += t.size, e = t);
    }
  };
}
function Q8(t, e) {
  t.forEach(i => {
    try {
      e(i);
    } catch (s) {
      ur.catch(s);
    }
  });
}
var lbe = Object.defineProperty,
  sbe = (t, e) => {
    for (var i in e) lbe(t, i, {
      get: e[i],
      enumerable: !0
    });
  },
  Xm = {};
sbe(Xm, {
  assign: () => cbe,
  colors: () => iw,
  createStringInterpolator: () => jz,
  skipAnimation: () => J8,
  to: () => Z8,
  willAdvance: () => Fz
});
function bF() {}
var ube = (t, e, i) => Object.defineProperty(t, e, {
    value: i,
    writable: !0,
    configurable: !0
  }),
  zt = {
    arr: Array.isArray,
    obj: t => !!t && t.constructor.name === "Object",
    fun: t => typeof t == "function",
    str: t => typeof t == "string",
    num: t => typeof t == "number",
    und: t => t === void 0
  };
function db(t, e) {
  if (zt.arr(t)) {
    if (!zt.arr(e) || t.length !== e.length) return !1;
    for (let i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
    return !0;
  }
  return t === e;
}
var Fr = (t, e) => t.forEach(e);
function Jv(t, e, i) {
  if (zt.arr(t)) {
    for (let s = 0; s < t.length; s++) e.call(i, t[s], `${s}`);
    return;
  }
  for (const s in t) t.hasOwnProperty(s) && e.call(i, t[s], s);
}
var lp = t => zt.und(t) ? [] : zt.arr(t) ? t : [t];
function JT(t, e) {
  if (t.size) {
    const i = Array.from(t);
    t.clear(), Fr(i, e);
  }
}
var PT = (t, ...e) => JT(t, i => i(...e)),
  Az = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent),
  jz,
  Z8,
  iw = null,
  J8 = !1,
  Fz = bF,
  cbe = t => {
    t.to && (Z8 = t.to), t.now && (ur.now = t.now), t.colors !== void 0 && (iw = t.colors), t.skipAnimation != null && (J8 = t.skipAnimation), t.createStringInterpolator && (jz = t.createStringInterpolator), t.requestAnimationFrame && ur.use(t.requestAnimationFrame), t.batchedUpdates && (ur.batchedUpdates = t.batchedUpdates), t.willAdvance && (Fz = t.willAdvance), t.frameLoop && (ur.frameLoop = t.frameLoop);
  },
  eR = /* @__PURE__ */new Set(),
  Fp = [],
  h2 = [],
  jL = 0,
  rO = {
    get idle() {
      return !eR.size && !Fp.length;
    },
    /** Advance the given animation on every frame until idle. */
    start(t) {
      jL > t.priority ? (eR.add(t), ur.onStart(dbe)) : (eW(t), ur(wF));
    },
    /** Advance all animations by the given time. */
    advance: wF,
    /** Call this when an animation's priority changes. */
    sort(t) {
      if (jL) ur.onFrame(() => rO.sort(t));else {
        const e = Fp.indexOf(t);
        ~e && (Fp.splice(e, 1), tW(t));
      }
    },
    /**
     * Clear all animations. For testing purposes.
     *
     * ☠️ Never call this from within the frameloop.
     */
    clear() {
      Fp = [], eR.clear();
    }
  };
function dbe() {
  eR.forEach(eW), eR.clear(), ur(wF);
}
function eW(t) {
  Fp.includes(t) || tW(t);
}
function tW(t) {
  Fp.splice(fbe(Fp, e => e.priority > t.priority), 0, t);
}
function wF(t) {
  const e = h2;
  for (let i = 0; i < Fp.length; i++) {
    const s = Fp[i];
    jL = s.priority, s.idle || (Fz(s), s.advance(t), s.idle || e.push(s));
  }
  return jL = 0, h2 = Fp, h2.length = 0, Fp = e, Fp.length > 0;
}
function fbe(t, e) {
  const i = t.findIndex(e);
  return i < 0 ? t.length : i;
}
var pbe = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  },
  Wm = "[-+]?\\d*\\.?\\d+",
  FL = Wm + "%";
function iO(...t) {
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var hbe = new RegExp("rgb" + iO(Wm, Wm, Wm)),
  mbe = new RegExp("rgba" + iO(Wm, Wm, Wm, Wm)),
  vbe = new RegExp("hsl" + iO(Wm, FL, FL)),
  gbe = new RegExp("hsla" + iO(Wm, FL, FL, Wm)),
  ybe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  bbe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  wbe = /^#([0-9a-fA-F]{6})$/,
  _be = /^#([0-9a-fA-F]{8})$/;
function xbe(t) {
  let e;
  return typeof t == "number" ? t >>> 0 === t && t >= 0 && t <= 4294967295 ? t : null : (e = wbe.exec(t)) ? parseInt(e[1] + "ff", 16) >>> 0 : iw && iw[t] !== void 0 ? iw[t] : (e = hbe.exec(t)) ? (nE(e[1]) << 24 |
  // r
  nE(e[2]) << 16 |
  // g
  nE(e[3]) << 8 |
  // b
  255) >>>
  // a
  0 : (e = mbe.exec(t)) ? (nE(e[1]) << 24 |
  // r
  nE(e[2]) << 16 |
  // g
  nE(e[3]) << 8 |
  // b
  VU(e[4])) >>>
  // a
  0 : (e = ybe.exec(t)) ? parseInt(e[1] + e[1] +
  // r
  e[2] + e[2] +
  // g
  e[3] + e[3] +
  // b
  "ff",
  // a
  16) >>> 0 : (e = _be.exec(t)) ? parseInt(e[1], 16) >>> 0 : (e = bbe.exec(t)) ? parseInt(e[1] + e[1] +
  // r
  e[2] + e[2] +
  // g
  e[3] + e[3] +
  // b
  e[4] + e[4],
  // a
  16) >>> 0 : (e = vbe.exec(t)) ? (NU(zU(e[1]),
  // h
  AM(e[2]),
  // s
  AM(e[3])
  // l
  ) | 255) >>>
  // a
  0 : (e = gbe.exec(t)) ? (NU(zU(e[1]),
  // h
  AM(e[2]),
  // s
  AM(e[3])
  // l
  ) | VU(e[4])) >>>
  // a
  0 : null;
}
function m2(t, e, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + (e - t) * 6 * i : i < 1 / 2 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
function NU(t, e, i) {
  const s = i < 0.5 ? i * (1 + e) : i + e - i * e,
    c = 2 * i - s,
    p = m2(c, s, t + 1 / 3),
    h = m2(c, s, t),
    y = m2(c, s, t - 1 / 3);
  return Math.round(p * 255) << 24 | Math.round(h * 255) << 16 | Math.round(y * 255) << 8;
}
function nE(t) {
  const e = parseInt(t, 10);
  return e < 0 ? 0 : e > 255 ? 255 : e;
}
function zU(t) {
  return (parseFloat(t) % 360 + 360) % 360 / 360;
}
function VU(t) {
  const e = parseFloat(t);
  return e < 0 ? 0 : e > 1 ? 255 : Math.round(e * 255);
}
function AM(t) {
  const e = parseFloat(t);
  return e < 0 ? 0 : e > 100 ? 1 : e / 100;
}
function BU(t) {
  let e = xbe(t);
  if (e === null) return t;
  e = e || 0;
  const i = (e & 4278190080) >>> 24,
    s = (e & 16711680) >>> 16,
    c = (e & 65280) >>> 8,
    p = (e & 255) / 255;
  return `rgba(${i}, ${s}, ${c}, ${p})`;
}
var TR = (t, e, i) => {
  if (zt.fun(t)) return t;
  if (zt.arr(t)) return TR({
    range: t,
    output: e,
    extrapolate: i
  });
  if (zt.str(t.output[0])) return jz(t);
  const s = t,
    c = s.output,
    p = s.range || [0, 1],
    h = s.extrapolateLeft || s.extrapolate || "extend",
    y = s.extrapolateRight || s.extrapolate || "extend",
    w = s.easing || (x => x);
  return x => {
    const E = Ebe(x, p);
    return Sbe(x, p[E], p[E + 1], c[E], c[E + 1], w, h, y, s.map);
  };
};
function Sbe(t, e, i, s, c, p, h, y, w) {
  let x = w ? w(t) : t;
  if (x < e) {
    if (h === "identity") return x;
    h === "clamp" && (x = e);
  }
  if (x > i) {
    if (y === "identity") return x;
    y === "clamp" && (x = i);
  }
  return s === c ? s : e === i ? t <= e ? s : c : (e === -1 / 0 ? x = -x : i === 1 / 0 ? x = x - e : x = (x - e) / (i - e), x = p(x), s === -1 / 0 ? x = -x : c === 1 / 0 ? x = x + s : x = x * (c - s) + s, x);
}
function Ebe(t, e) {
  for (var i = 1; i < e.length - 1 && !(e[i] >= t); ++i);
  return i - 1;
}
var Cbe = {
    linear: t => t
  },
  RR = Symbol.for("FluidValue.get"),
  IE = Symbol.for("FluidValue.observers"),
  Ap = t => !!(t && t[RR]),
  ad = t => t && t[RR] ? t[RR]() : t,
  UU = t => t[IE] || null;
function kbe(t, e) {
  t.eventObserved ? t.eventObserved(e) : t(e);
}
function DR(t, e) {
  const i = t[IE];
  i && i.forEach(s => {
    kbe(s, e);
  });
}
var nW = class {
    constructor(t) {
      if (!t && !(t = this.get)) throw Error("Unknown getter");
      Tbe(this, t);
    }
  },
  Tbe = (t, e) => rW(t, RR, e);
function $E(t, e) {
  if (t[RR]) {
    let i = t[IE];
    i || rW(t, IE, i = /* @__PURE__ */new Set()), i.has(e) || (i.add(e), t.observerAdded && t.observerAdded(i.size, e));
  }
  return e;
}
function IR(t, e) {
  const i = t[IE];
  if (i && i.has(e)) {
    const s = i.size - 1;
    s ? i.delete(e) : t[IE] = null, t.observerRemoved && t.observerRemoved(s, e);
  }
}
var rW = (t, e, i) => Object.defineProperty(t, e, {
    value: i,
    writable: !0,
    configurable: !0
  }),
  JM = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
  Rbe = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
  HU = new RegExp(`(${JM.source})(%|[a-z]+)`, "i"),
  Dbe = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi,
  aO = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/,
  iW = t => {
    const [e, i] = Ibe(t);
    if (!e || Az()) return t;
    const s = window.getComputedStyle(document.documentElement).getPropertyValue(e);
    if (s) return s.trim();
    if (i && i.startsWith("--")) {
      const c = window.getComputedStyle(document.documentElement).getPropertyValue(i);
      return c || t;
    } else {
      if (i && aO.test(i)) return iW(i);
      if (i) return i;
    }
    return t;
  },
  Ibe = t => {
    const e = aO.exec(t);
    if (!e) return [,];
    const [, i, s] = e;
    return [i, s];
  },
  v2,
  Mbe = (t, e, i, s, c) => `rgba(${Math.round(e)}, ${Math.round(i)}, ${Math.round(s)}, ${c})`,
  aW = t => {
    v2 || (v2 = iw ?
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(iw).join("|")})(?!\\w)`, "g") :
    // never match
    /^\b$/);
    const e = t.output.map(p => ad(p).replace(aO, iW).replace(Rbe, BU).replace(v2, BU)),
      i = e.map(p => p.match(JM).map(Number)),
      c = i[0].map((p, h) => i.map(y => {
        if (!(h in y)) throw Error('The arity of each "output" value must be equal');
        return y[h];
      })).map(p => TR({
        ...t,
        output: p
      }));
    return p => {
      var w;
      const h = !HU.test(e[0]) && ((w = e.find(x => HU.test(x))) == null ? void 0 : w.replace(JM, ""));
      let y = 0;
      return e[0].replace(JM, () => `${c[y++](p)}${h || ""}`).replace(Dbe, Mbe);
    };
  },
  Nz = "react-spring: ",
  oW = t => {
    const e = t;
    let i = !1;
    if (typeof e != "function") throw new TypeError(`${Nz}once requires a function parameter`);
    return (...s) => {
      i || (e(...s), i = !0);
    };
  },
  Lbe = oW(console.warn);
function Obe() {
  Lbe(`${Nz}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var Pbe = oW(console.warn);
function Abe() {
  Pbe(`${Nz}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function oO(t) {
  return zt.str(t) && (t[0] == "#" || /\d/.test(t) ||
  // Do not identify a CSS variable as an AnimatedString if its SSR
  !Az() && aO.test(t) || t in (iw || {}));
}
var zz = Az() ? Rt : NR,
  jbe = () => {
    const t = vt(!1);
    return zz(() => (t.current = !0, () => {
      t.current = !1;
    }), []), t;
  };
function lW() {
  const t = rt()[1],
    e = jbe();
  return () => {
    e.current && t(Math.random());
  };
}
function Fbe(t, e) {
  const [i] = rt(() => ({
      inputs: e,
      result: t()
    })),
    s = vt(),
    c = s.current;
  let p = c;
  return p ? e && p.inputs && Nbe(e, p.inputs) || (p = {
    inputs: e,
    result: t()
  }) : p = i, Rt(() => {
    s.current = p, c == i && (i.inputs = i.result = void 0);
  }, [p]), p.result;
}
function Nbe(t, e) {
  if (t.length !== e.length) return !1;
  for (let i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
  return !0;
}
var sW = t => Rt(t, zbe),
  zbe = [];
function $U(t) {
  const e = vt();
  return Rt(() => {
    e.current = t;
  }), e.current;
}
var MR = Symbol.for("Animated:node"),
  Vbe = t => !!t && t[MR] === t,
  $v = t => t && t[MR],
  Vz = (t, e) => ube(t, MR, e),
  lO = t => t && t[MR] && t[MR].getPayload(),
  uW = class {
    constructor() {
      Vz(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */
    getPayload() {
      return this.payload || [];
    }
  },
  KR = class extends uW {
    constructor(t) {
      super(), this._value = t, this.done = !0, this.durationProgress = 0, zt.num(this._value) && (this.lastPosition = this._value);
    }
    /** @internal */
    static create(t) {
      return new KR(t);
    }
    getPayload() {
      return [this];
    }
    getValue() {
      return this._value;
    }
    setValue(t, e) {
      return zt.num(t) && (this.lastPosition = t, e && (t = Math.round(t / e) * e, this.done && (this.lastPosition = t))), this._value === t ? !1 : (this._value = t, !0);
    }
    reset() {
      const {
        done: t
      } = this;
      this.done = !1, zt.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, t && (this.lastVelocity = null), this.v0 = null);
    }
  },
  LR = class extends KR {
    constructor(t) {
      super(0), this._string = null, this._toString = TR({
        output: [t, t]
      });
    }
    /** @internal */
    static create(t) {
      return new LR(t);
    }
    getValue() {
      const t = this._string;
      return t ?? (this._string = this._toString(this._value));
    }
    setValue(t) {
      if (zt.str(t)) {
        if (t == this._string) return !1;
        this._string = t, this._value = 1;
      } else if (super.setValue(t)) this._string = null;else return !1;
      return !0;
    }
    reset(t) {
      t && (this._toString = TR({
        output: [this.getValue(), t]
      })), this._value = 0, super.reset();
    }
  },
  NL = {
    dependencies: null
  },
  sO = class extends uW {
    constructor(t) {
      super(), this.source = t, this.setValue(t);
    }
    getValue(t) {
      const e = {};
      return Jv(this.source, (i, s) => {
        Vbe(i) ? e[s] = i.getValue(t) : Ap(i) ? e[s] = ad(i) : t || (e[s] = i);
      }), e;
    }
    /** Replace the raw object data */
    setValue(t) {
      this.source = t, this.payload = this._makePayload(t);
    }
    reset() {
      this.payload && Fr(this.payload, t => t.reset());
    }
    /** Create a payload set. */
    _makePayload(t) {
      if (t) {
        const e = /* @__PURE__ */new Set();
        return Jv(t, this._addToPayload, e), Array.from(e);
      }
    }
    /** Add to a payload set. */
    _addToPayload(t) {
      NL.dependencies && Ap(t) && NL.dependencies.add(t);
      const e = lO(t);
      e && Fr(e, i => this.add(i));
    }
  },
  cW = class extends sO {
    constructor(t) {
      super(t);
    }
    /** @internal */
    static create(t) {
      return new cW(t);
    }
    getValue() {
      return this.source.map(t => t.getValue());
    }
    setValue(t) {
      const e = this.getPayload();
      return t.length == e.length ? e.map((i, s) => i.setValue(t[s])).some(Boolean) : (super.setValue(t.map(Bbe)), !0);
    }
  };
function Bbe(t) {
  return (oO(t) ? LR : KR).create(t);
}
function _F(t) {
  const e = $v(t);
  return e ? e.constructor : zt.arr(t) ? cW : oO(t) ? LR : KR;
}
var WU = (t, e) => {
    const i =
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !zt.fun(t) || t.prototype && t.prototype.isReactComponent;
    return Qn((s, c) => {
      const p = vt(null),
        h = i &&
        // eslint-disable-next-line react-hooks/rules-of-hooks
        pn(I => {
          p.current = $be(c, I);
        }, [c]),
        [y, w] = Hbe(s, e),
        x = lW(),
        E = () => {
          const I = p.current;
          if (i && !I) return;
          (I ? e.applyAnimatedValues(I, y.getValue(!0)) : !1) === !1 && x();
        },
        C = new Ube(E, w),
        k = vt();
      zz(() => (k.current = C, Fr(w, I => $E(I, C)), () => {
        k.current && (Fr(k.current.deps, I => IR(I, k.current)), ur.cancel(k.current.update));
      })), Rt(E, []), sW(() => () => {
        const I = k.current;
        Fr(I.deps, L => IR(L, I));
      });
      const D = e.getComponentProps(y.getValue());
      return /* @__PURE__ */Bn.createElement(t, {
        ...D,
        ref: h
      });
    });
  },
  Ube = class {
    constructor(t, e) {
      this.update = t, this.deps = e;
    }
    eventObserved(t) {
      t.type == "change" && ur.write(this.update);
    }
  };
function Hbe(t, e) {
  const i = /* @__PURE__ */new Set();
  return NL.dependencies = i, t.style && (t = {
    ...t,
    style: e.createAnimatedStyle(t.style)
  }), t = new sO(t), NL.dependencies = null, [t, i];
}
function $be(t, e) {
  return t && (zt.fun(t) ? t(e) : t.current = e), e;
}
var qU = Symbol.for("AnimatedComponent"),
  Wbe = (t, {
    applyAnimatedValues: e = () => !1,
    createAnimatedStyle: i = c => new sO(c),
    getComponentProps: s = c => c
  } = {}) => {
    const c = {
        applyAnimatedValues: e,
        createAnimatedStyle: i,
        getComponentProps: s
      },
      p = h => {
        const y = YU(h) || "Anonymous";
        return zt.str(h) ? h = p[h] || (p[h] = WU(h, c)) : h = h[qU] || (h[qU] = WU(h, c)), h.displayName = `Animated(${y})`, h;
      };
    return Jv(t, (h, y) => {
      zt.arr(t) && (y = YU(h)), p[y] = p(h);
    }), {
      animated: p
    };
  },
  YU = t => zt.str(t) ? t : t && zt.str(t.displayName) ? t.displayName : zt.fun(t) && t.name || null;
function Ux(t, ...e) {
  return zt.fun(t) ? t(...e) : t;
}
var tR = (t, e) => t === !0 || !!(e && t && (zt.fun(t) ? t(e) : lp(t).includes(e))),
  dW = (t, e) => zt.obj(t) ? e && t[e] : t,
  fW = (t, e) => t.default === !0 ? t[e] : t.default ? t.default[e] : void 0,
  qbe = t => t,
  Bz = (t, e = qbe) => {
    let i = Ybe;
    t.default && t.default !== !0 && (t = t.default, i = Object.keys(t));
    const s = {};
    for (const c of i) {
      const p = e(t[c], c);
      zt.und(p) || (s[c] = p);
    }
    return s;
  },
  Ybe = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
  Gbe = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
  };
function Xbe(t) {
  const e = {};
  let i = 0;
  if (Jv(t, (s, c) => {
    Gbe[c] || (e[c] = s, i++);
  }), i) return e;
}
function pW(t) {
  const e = Xbe(t);
  if (e) {
    const i = {
      to: e
    };
    return Jv(t, (s, c) => c in e || (i[c] = s)), i;
  }
  return {
    ...t
  };
}
function OR(t) {
  return t = ad(t), zt.arr(t) ? t.map(OR) : oO(t) ? Xm.createStringInterpolator({
    range: [0, 1],
    output: [t, t]
  })(1) : t;
}
function Kbe(t) {
  for (const e in t) return !0;
  return !1;
}
function xF(t) {
  return zt.fun(t) || zt.arr(t) && zt.obj(t[0]);
}
function Qbe(t, e) {
  var i;
  (i = t.ref) == null || i.delete(t), e == null || e.delete(t);
}
function Zbe(t, e) {
  var i;
  e && t.ref !== e && ((i = t.ref) == null || i.delete(t), e.add(t), t.ref = e);
}
var Jbe = {
    default: {
      tension: 170,
      friction: 26
    }
  },
  SF = {
    ...Jbe.default,
    mass: 1,
    damping: 1,
    easing: Cbe.linear,
    clamp: !1
  },
  e0e = class {
    constructor() {
      this.velocity = 0, Object.assign(this, SF);
    }
  };
function t0e(t, e, i) {
  i && (i = {
    ...i
  }, GU(i, e), e = {
    ...i,
    ...e
  }), GU(t, e), Object.assign(t, e);
  for (const h in SF) t[h] == null && (t[h] = SF[h]);
  let {
    frequency: s,
    damping: c
  } = t;
  const {
    mass: p
  } = t;
  return zt.und(s) || (s < 0.01 && (s = 0.01), c < 0 && (c = 0), t.tension = Math.pow(2 * Math.PI / s, 2) * p, t.friction = 4 * Math.PI * c * p / s), t;
}
function GU(t, e) {
  if (!zt.und(e.decay)) t.duration = void 0;else {
    const i = !zt.und(e.tension) || !zt.und(e.friction);
    (i || !zt.und(e.frequency) || !zt.und(e.damping) || !zt.und(e.mass)) && (t.duration = void 0, t.decay = void 0), i && (t.frequency = void 0);
  }
}
var XU = [],
  n0e = class {
    constructor() {
      this.changed = !1, this.values = XU, this.toValues = null, this.fromValues = XU, this.config = new e0e(), this.immediate = !1;
    }
  };
function hW(t, {
  key: e,
  props: i,
  defaultProps: s,
  state: c,
  actions: p
}) {
  return new Promise((h, y) => {
    let w,
      x,
      E = tR(i.cancel ?? (s == null ? void 0 : s.cancel), e);
    if (E) D();else {
      zt.und(i.pause) || (c.paused = tR(i.pause, e));
      let I = s == null ? void 0 : s.pause;
      I !== !0 && (I = c.paused || tR(I, e)), w = Ux(i.delay || 0, e), I ? (c.resumeQueue.add(k), p.pause()) : (p.resume(), k());
    }
    function C() {
      c.resumeQueue.add(k), c.timeouts.delete(x), x.cancel(), w = x.time - ur.now();
    }
    function k() {
      w > 0 && !Xm.skipAnimation ? (c.delayed = !0, x = ur.setTimeout(D, w), c.pauseQueue.add(C), c.timeouts.add(x)) : D();
    }
    function D() {
      c.delayed && (c.delayed = !1), c.pauseQueue.delete(C), c.timeouts.delete(x), t <= (c.cancelId || 0) && (E = !0);
      try {
        p.start({
          ...i,
          callId: t,
          cancel: E
        }, h);
      } catch (I) {
        y(I);
      }
    }
  });
}
var Uz = (t, e) => e.length == 1 ? e[0] : e.some(i => i.cancelled) ? wE(t.get()) : e.every(i => i.noop) ? mW(t.get()) : Hm(t.get(), e.every(i => i.finished)),
  mW = t => ({
    value: t,
    noop: !0,
    finished: !0,
    cancelled: !1
  }),
  Hm = (t, e, i = !1) => ({
    value: t,
    finished: e,
    cancelled: i
  }),
  wE = t => ({
    value: t,
    cancelled: !0,
    finished: !1
  });
function vW(t, e, i, s) {
  const {
      callId: c,
      parentId: p,
      onRest: h
    } = e,
    {
      asyncTo: y,
      promise: w
    } = i;
  return !p && t === y && !e.reset ? w : i.promise = (async () => {
    i.asyncId = c, i.asyncTo = t;
    const x = Bz(e, (P, N) =>
    // The `onRest` prop is only called when the `runAsync` promise is resolved.
    N === "onRest" ? void 0 : P);
    let E, C;
    const k = new Promise((P, N) => (E = P, C = N)),
      D = P => {
        const N =
        // The `cancel` prop or `stop` method was used.
        c <= (i.cancelId || 0) && wE(s) ||
        // The async `to` prop was replaced.
        c !== i.asyncId && Hm(s, !1);
        if (N) throw P.result = N, C(P), P;
      },
      I = (P, N) => {
        const O = new KU(),
          F = new QU();
        return (async () => {
          if (Xm.skipAnimation) throw PR(i), F.result = Hm(s, !1), C(F), F;
          D(O);
          const j = zt.obj(P) ? {
            ...P
          } : {
            ...N,
            to: P
          };
          j.parentId = c, Jv(x, (K, G) => {
            zt.und(j[G]) && (j[G] = K);
          });
          const V = await s.start(j);
          return D(O), i.paused && (await new Promise(K => {
            i.resumeQueue.add(K);
          })), V;
        })();
      };
    let L;
    if (Xm.skipAnimation) return PR(i), Hm(s, !1);
    try {
      let P;
      zt.arr(t) ? P = (async N => {
        for (const O of N) await I(O);
      })(t) : P = Promise.resolve(t(I, s.stop.bind(s))), await Promise.all([P.then(E), k]), L = Hm(s.get(), !0, !1);
    } catch (P) {
      if (P instanceof KU) L = P.result;else if (P instanceof QU) L = P.result;else throw P;
    } finally {
      c == i.asyncId && (i.asyncId = p, i.asyncTo = p ? y : void 0, i.promise = p ? w : void 0);
    }
    return zt.fun(h) && ur.batchedUpdates(() => {
      h(L, s, s.item);
    }), L;
  })();
}
function PR(t, e) {
  JT(t.timeouts, i => i.cancel()), t.pauseQueue.clear(), t.resumeQueue.clear(), t.asyncId = t.asyncTo = t.promise = void 0, e && (t.cancelId = e);
}
var KU = class extends Error {
    constructor() {
      super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
  },
  QU = class extends Error {
    constructor() {
      super("SkipAnimationSignal");
    }
  },
  EF = t => t instanceof Hz,
  r0e = 1,
  Hz = class extends nW {
    constructor() {
      super(...arguments), this.id = r0e++, this._priority = 0;
    }
    get priority() {
      return this._priority;
    }
    set priority(t) {
      this._priority != t && (this._priority = t, this._onPriorityChange(t));
    }
    /** Get the current value */
    get() {
      const t = $v(this);
      return t && t.getValue();
    }
    /** Create a spring that maps our value to another value */
    to(...t) {
      return Xm.to(this, t);
    }
    /** @deprecated Use the `to` method instead. */
    interpolate(...t) {
      return Obe(), Xm.to(this, t);
    }
    toJSON() {
      return this.get();
    }
    observerAdded(t) {
      t == 1 && this._attach();
    }
    observerRemoved(t) {
      t == 0 && this._detach();
    }
    /** Called when the first child is added. */
    _attach() {}
    /** Called when the last child is removed. */
    _detach() {}
    /** Tell our children about our new value */
    _onChange(t, e = !1) {
      DR(this, {
        type: "change",
        parent: this,
        value: t,
        idle: e
      });
    }
    /** Tell our children about our new priority */
    _onPriorityChange(t) {
      this.idle || rO.sort(this), DR(this, {
        type: "priority",
        parent: this,
        priority: t
      });
    }
  },
  nS = Symbol.for("SpringPhase"),
  gW = 1,
  yW = 2,
  bW = 4,
  g2 = t => (t[nS] & gW) > 0,
  G0 = t => (t[nS] & yW) > 0,
  DT = t => (t[nS] & bW) > 0,
  ZU = (t, e) => e ? t[nS] |= yW | gW : t[nS] &= -3,
  JU = (t, e) => e ? t[nS] |= bW : t[nS] &= -5,
  i0e = class extends Hz {
    constructor(t, e) {
      if (super(), this.animation = new n0e(), this.defaultProps = {}, this._state = {
        paused: !1,
        delayed: !1,
        pauseQueue: /* @__PURE__ */new Set(),
        resumeQueue: /* @__PURE__ */new Set(),
        timeouts: /* @__PURE__ */new Set()
      }, this._pendingCalls = /* @__PURE__ */new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !zt.und(t) || !zt.und(e)) {
        const i = zt.obj(t) ? {
          ...t
        } : {
          ...e,
          from: t
        };
        zt.und(i.default) && (i.default = !0), this.start(i);
      }
    }
    /** Equals true when not advancing on each frame. */
    get idle() {
      return !(G0(this) || this._state.asyncTo) || DT(this);
    }
    get goal() {
      return ad(this.animation.to);
    }
    get velocity() {
      const t = $v(this);
      return t instanceof KR ? t.lastVelocity || 0 : t.getPayload().map(e => e.lastVelocity || 0);
    }
    /**
     * When true, this value has been animated at least once.
     */
    get hasAnimated() {
      return g2(this);
    }
    /**
     * When true, this value has an unfinished animation,
     * which is either active or paused.
     */
    get isAnimating() {
      return G0(this);
    }
    /**
     * When true, all current and future animations are paused.
     */
    get isPaused() {
      return DT(this);
    }
    /**
     *
     *
     */
    get isDelayed() {
      return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */
    advance(t) {
      let e = !0,
        i = !1;
      const s = this.animation;
      let {
        toValues: c
      } = s;
      const {
          config: p
        } = s,
        h = lO(s.to);
      !h && Ap(s.to) && (c = lp(ad(s.to))), s.values.forEach((x, E) => {
        if (x.done) return;
        const C =
        // Animated strings always go from 0 to 1.
        x.constructor == LR ? 1 : h ? h[E].lastPosition : c[E];
        let k = s.immediate,
          D = C;
        if (!k) {
          if (D = x.lastPosition, p.tension <= 0) {
            x.done = !0;
            return;
          }
          let I = x.elapsedTime += t;
          const L = s.fromValues[E],
            P = x.v0 != null ? x.v0 : x.v0 = zt.arr(p.velocity) ? p.velocity[E] : p.velocity;
          let N;
          const O = p.precision || (L == C ? 5e-3 : Math.min(1, Math.abs(C - L) * 1e-3));
          if (zt.und(p.duration)) {
            if (p.decay) {
              const F = p.decay === !0 ? 0.998 : p.decay,
                j = Math.exp(-(1 - F) * I);
              D = L + P / (1 - F) * (1 - j), k = Math.abs(x.lastPosition - D) <= O, N = P * j;
            } else {
              N = x.lastVelocity == null ? P : x.lastVelocity;
              const F = p.restVelocity || O / 10,
                j = p.clamp ? 0 : p.bounce,
                V = !zt.und(j),
                K = L == C ? x.v0 > 0 : L < C;
              let G,
                Q = !1;
              const te = 1,
                ie = Math.ceil(t / te);
              for (let Y = 0; Y < ie && (G = Math.abs(N) > F, !(!G && (k = Math.abs(C - D) <= O, k))); ++Y) {
                V && (Q = D == C || D > C == K, Q && (N = -N * j, D = C));
                const ee = -p.tension * 1e-6 * (D - C),
                  ae = -p.friction * 1e-3 * N,
                  ne = (ee + ae) / p.mass;
                N = N + ne * te, D = D + N * te;
              }
            }
          } else {
            let F = 1;
            p.duration > 0 && (this._memoizedDuration !== p.duration && (this._memoizedDuration = p.duration, x.durationProgress > 0 && (x.elapsedTime = p.duration * x.durationProgress, I = x.elapsedTime += t)), F = (p.progress || 0) + I / this._memoizedDuration, F = F > 1 ? 1 : F < 0 ? 0 : F, x.durationProgress = F), D = L + p.easing(F) * (C - L), N = (D - x.lastPosition) / t, k = F == 1;
          }
          x.lastVelocity = N, Number.isNaN(D) && (console.warn("Got NaN while animating:", this), k = !0);
        }
        h && !h[E].done && (k = !1), k ? x.done = !0 : e = !1, x.setValue(D, p.round) && (i = !0);
      });
      const y = $v(this),
        w = y.getValue();
      if (e) {
        const x = ad(s.to);
        (w !== x || i) && !p.decay ? (y.setValue(x), this._onChange(x)) : i && p.decay && this._onChange(w), this._stop();
      } else i && this._onChange(w);
    }
    /** Set the current value, while stopping the current animation */
    set(t) {
      return ur.batchedUpdates(() => {
        this._stop(), this._focus(t), this._set(t);
      }), this;
    }
    /**
     * Freeze the active animation in time, as well as any updates merged
     * before `resume` is called.
     */
    pause() {
      this._update({
        pause: !0
      });
    }
    /** Resume the animation if paused. */
    resume() {
      this._update({
        pause: !1
      });
    }
    /** Skip to the end of the current animation. */
    finish() {
      if (G0(this)) {
        const {
          to: t,
          config: e
        } = this.animation;
        ur.batchedUpdates(() => {
          this._onStart(), e.decay || this._set(t, !1), this._stop();
        });
      }
      return this;
    }
    /** Push props into the pending queue. */
    update(t) {
      return (this.queue || (this.queue = [])).push(t), this;
    }
    start(t, e) {
      let i;
      return zt.und(t) ? (i = this.queue || [], this.queue = []) : i = [zt.obj(t) ? t : {
        ...e,
        to: t
      }], Promise.all(i.map(s => this._update(s))).then(s => Uz(this, s));
    }
    /**
     * Stop the current animation, and cancel any delayed updates.
     *
     * Pass `true` to call `onRest` with `cancelled: true`.
     */
    stop(t) {
      const {
        to: e
      } = this.animation;
      return this._focus(this.get()), PR(this._state, t && this._lastCallId), ur.batchedUpdates(() => this._stop(e, t)), this;
    }
    /** Restart the animation. */
    reset() {
      this._update({
        reset: !0
      });
    }
    /** @internal */
    eventObserved(t) {
      t.type == "change" ? this._start() : t.type == "priority" && (this.priority = t.priority + 1);
    }
    /**
     * Parse the `to` and `from` range from the given `props` object.
     *
     * This also ensures the initial value is available to animated components
     * during the render phase.
     */
    _prepareNode(t) {
      const e = this.key || "";
      let {
        to: i,
        from: s
      } = t;
      i = zt.obj(i) ? i[e] : i, (i == null || xF(i)) && (i = void 0), s = zt.obj(s) ? s[e] : s, s == null && (s = void 0);
      const c = {
        to: i,
        from: s
      };
      return g2(this) || (t.reverse && ([i, s] = [s, i]), s = ad(s), zt.und(s) ? $v(this) || this._set(i) : this._set(s)), c;
    }
    /** Every update is processed by this method before merging. */
    _update({
      ...t
    }, e) {
      const {
        key: i,
        defaultProps: s
      } = this;
      t.default && Object.assign(s, Bz(t, (h, y) => /^on/.test(y) ? dW(h, i) : h)), tH(this, t, "onProps"), MT(this, "onProps", t, this);
      const c = this._prepareNode(t);
      if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
      const p = this._state;
      return hW(++this._lastCallId, {
        key: i,
        props: t,
        defaultProps: s,
        state: p,
        actions: {
          pause: () => {
            DT(this) || (JU(this, !0), PT(p.pauseQueue), MT(this, "onPause", Hm(this, IT(this, this.animation.to)), this));
          },
          resume: () => {
            DT(this) && (JU(this, !1), G0(this) && this._resume(), PT(p.resumeQueue), MT(this, "onResume", Hm(this, IT(this, this.animation.to)), this));
          },
          start: this._merge.bind(this, c)
        }
      }).then(h => {
        if (t.loop && h.finished && !(e && h.noop)) {
          const y = wW(t);
          if (y) return this._update(y, !0);
        }
        return h;
      });
    }
    /** Merge props into the current animation */
    _merge(t, e, i) {
      if (e.cancel) return this.stop(!0), i(wE(this));
      const s = !zt.und(t.to),
        c = !zt.und(t.from);
      if (s || c) if (e.callId > this._lastToId) this._lastToId = e.callId;else return i(wE(this));
      const {
          key: p,
          defaultProps: h,
          animation: y
        } = this,
        {
          to: w,
          from: x
        } = y;
      let {
        to: E = w,
        from: C = x
      } = t;
      c && !s && (!e.default || zt.und(E)) && (E = C), e.reverse && ([E, C] = [C, E]);
      const k = !db(C, x);
      k && (y.from = C), C = ad(C);
      const D = !db(E, w);
      D && this._focus(E);
      const I = xF(e.to),
        {
          config: L
        } = y,
        {
          decay: P,
          velocity: N
        } = L;
      (s || c) && (L.velocity = 0), e.config && !I && t0e(L, Ux(e.config, p),
      // Avoid calling the same "config" prop twice.
      e.config !== h.config ? Ux(h.config, p) : void 0);
      let O = $v(this);
      if (!O || zt.und(E)) return i(Hm(this, !0));
      const F =
        // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        zt.und(e.reset) ? c && !e.default : !zt.und(C) && tR(e.reset, p),
        j = F ? C : this.get(),
        V = OR(E),
        K = zt.num(V) || zt.arr(V) || oO(V),
        G = !I && (!K || tR(h.immediate || e.immediate, p));
      if (D) {
        const Y = _F(E);
        if (Y !== O.constructor) if (G) O = this._set(V);else throw Error(`Cannot animate between ${O.constructor.name} and ${Y.name}, as the "to" prop suggests`);
      }
      const Q = O.constructor;
      let te = Ap(E),
        ie = !1;
      if (!te) {
        const Y = F || !g2(this) && k;
        (D || Y) && (ie = db(OR(j), V), te = !ie), (!db(y.immediate, G) && !G || !db(L.decay, P) || !db(L.velocity, N)) && (te = !0);
      }
      if (ie && G0(this) && (y.changed && !F ? te = !0 : te || this._stop(w)), !I && ((te || Ap(w)) && (y.values = O.getPayload(), y.toValues = Ap(E) ? null : Q == LR ? [1] : lp(V)), y.immediate != G && (y.immediate = G, !G && !F && this._set(w)), te)) {
        const {
          onRest: Y
        } = y;
        Fr(o0e, ae => tH(this, e, ae));
        const ee = Hm(this, IT(this, w));
        PT(this._pendingCalls, ee), this._pendingCalls.add(i), y.changed && ur.batchedUpdates(() => {
          var ae;
          y.changed = !F, Y == null || Y(ee, this), F ? Ux(h.onRest, ee) : (ae = y.onStart) == null || ae.call(y, ee, this);
        });
      }
      F && this._set(j), I ? i(vW(e.to, e, this._state, this)) : te ? this._start() : G0(this) && !D ? this._pendingCalls.add(i) : i(mW(j));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */
    _focus(t) {
      const e = this.animation;
      t !== e.to && (UU(this) && this._detach(), e.to = t, UU(this) && this._attach());
    }
    _attach() {
      let t = 0;
      const {
        to: e
      } = this.animation;
      Ap(e) && ($E(e, this), EF(e) && (t = e.priority + 1)), this.priority = t;
    }
    _detach() {
      const {
        to: t
      } = this.animation;
      Ap(t) && IR(t, this);
    }
    /**
     * Update the current value from outside the frameloop,
     * and return the `Animated` node.
     */
    _set(t, e = !0) {
      const i = ad(t);
      if (!zt.und(i)) {
        const s = $v(this);
        if (!s || !db(i, s.getValue())) {
          const c = _F(i);
          !s || s.constructor != c ? Vz(this, c.create(i)) : s.setValue(i), s && ur.batchedUpdates(() => {
            this._onChange(i, e);
          });
        }
      }
      return $v(this);
    }
    _onStart() {
      const t = this.animation;
      t.changed || (t.changed = !0, MT(this, "onStart", Hm(this, IT(this, t.to)), this));
    }
    _onChange(t, e) {
      e || (this._onStart(), Ux(this.animation.onChange, t, this)), Ux(this.defaultProps.onChange, t, this), super._onChange(t, e);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
      const t = this.animation;
      $v(this).reset(ad(t.to)), t.immediate || (t.fromValues = t.values.map(e => e.lastPosition)), G0(this) || (ZU(this, !0), DT(this) || this._resume());
    }
    _resume() {
      Xm.skipAnimation ? this.finish() : rO.start(this);
    }
    /**
     * Exit the frameloop and notify `onRest` listeners.
     *
     * Always wrap `_stop` calls with `batchedUpdates`.
     */
    _stop(t, e) {
      if (G0(this)) {
        ZU(this, !1);
        const i = this.animation;
        Fr(i.values, c => {
          c.done = !0;
        }), i.toValues && (i.onChange = i.onPause = i.onResume = void 0), DR(this, {
          type: "idle",
          parent: this
        });
        const s = e ? wE(this.get()) : Hm(this.get(), IT(this, t ?? i.to));
        PT(this._pendingCalls, s), i.changed && (i.changed = !1, MT(this, "onRest", s, this));
      }
    }
  };
function IT(t, e) {
  const i = OR(e),
    s = OR(t.get());
  return db(s, i);
}
function wW(t, e = t.loop, i = t.to) {
  const s = Ux(e);
  if (s) {
    const c = s !== !0 && pW(s),
      p = (c || t).reverse,
      h = !c || c.reset;
    return AR({
      ...t,
      loop: e,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !p || xF(i) ? i : void 0,
      // Ignore the "from" prop except on reset.
      from: h ? t.from : void 0,
      reset: h,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...c
    });
  }
}
function AR(t) {
  const {
      to: e,
      from: i
    } = t = pW(t),
    s = /* @__PURE__ */new Set();
  return zt.obj(e) && eH(e, s), zt.obj(i) && eH(i, s), t.keys = s.size ? Array.from(s) : null, t;
}
function a0e(t) {
  const e = AR(t);
  return zt.und(e.default) && (e.default = Bz(e)), e;
}
function eH(t, e) {
  Jv(t, (i, s) => i != null && e.add(s));
}
var o0e = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function tH(t, e, i) {
  t.animation[i] = e[i] !== fW(e, i) ? dW(e[i], t.key) : void 0;
}
function MT(t, e, ...i) {
  var s, c, p, h;
  (c = (s = t.animation)[e]) == null || c.call(s, ...i), (h = (p = t.defaultProps)[e]) == null || h.call(p, ...i);
}
var l0e = ["onStart", "onChange", "onRest"],
  s0e = 1,
  u0e = class {
    constructor(t, e) {
      this.id = s0e++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */new Set(), this._changed = /* @__PURE__ */new Set(), this._started = !1, this._state = {
        paused: !1,
        pauseQueue: /* @__PURE__ */new Set(),
        resumeQueue: /* @__PURE__ */new Set(),
        timeouts: /* @__PURE__ */new Set()
      }, this._events = {
        onStart: /* @__PURE__ */new Map(),
        onChange: /* @__PURE__ */new Map(),
        onRest: /* @__PURE__ */new Map()
      }, this._onFrame = this._onFrame.bind(this), e && (this._flush = e), t && this.start({
        default: !0,
        ...t
      });
    }
    /**
     * Equals `true` when no spring values are in the frameloop, and
     * no async animation is currently active.
     */
    get idle() {
      return !this._state.asyncTo && Object.values(this.springs).every(t => t.idle && !t.isDelayed && !t.isPaused);
    }
    get item() {
      return this._item;
    }
    set item(t) {
      this._item = t;
    }
    /** Get the current values of our springs */
    get() {
      const t = {};
      return this.each((e, i) => t[i] = e.get()), t;
    }
    /** Set the current values without animating. */
    set(t) {
      for (const e in t) {
        const i = t[e];
        zt.und(i) || this.springs[e].set(i);
      }
    }
    /** Push an update onto the queue of each value. */
    update(t) {
      return t && this.queue.push(AR(t)), this;
    }
    /**
     * Start the queued animations for every spring, and resolve the returned
     * promise once all queued animations have finished or been cancelled.
     *
     * When you pass a queue (instead of nothing), that queue is used instead of
     * the queued animations added with the `update` method, which are left alone.
     */
    start(t) {
      let {
        queue: e
      } = this;
      return t ? e = lp(t).map(AR) : this.queue = [], this._flush ? this._flush(this, e) : (CW(this, e), CF(this, e));
    }
    /** @internal */
    stop(t, e) {
      if (t !== !!t && (e = t), e) {
        const i = this.springs;
        Fr(lp(e), s => i[s].stop(!!t));
      } else PR(this._state, this._lastAsyncId), this.each(i => i.stop(!!t));
      return this;
    }
    /** Freeze the active animation in time */
    pause(t) {
      if (zt.und(t)) this.start({
        pause: !0
      });else {
        const e = this.springs;
        Fr(lp(t), i => e[i].pause());
      }
      return this;
    }
    /** Resume the animation if paused. */
    resume(t) {
      if (zt.und(t)) this.start({
        pause: !1
      });else {
        const e = this.springs;
        Fr(lp(t), i => e[i].resume());
      }
      return this;
    }
    /** Call a function once per spring value */
    each(t) {
      Jv(this.springs, t);
    }
    /** @internal Called at the end of every animation frame */
    _onFrame() {
      const {
          onStart: t,
          onChange: e,
          onRest: i
        } = this._events,
        s = this._active.size > 0,
        c = this._changed.size > 0;
      (s && !this._started || c && !this._started) && (this._started = !0, JT(t, ([y, w]) => {
        w.value = this.get(), y(w, this, this._item);
      }));
      const p = !s && this._started,
        h = c || p && i.size ? this.get() : null;
      c && e.size && JT(e, ([y, w]) => {
        w.value = h, y(w, this, this._item);
      }), p && (this._started = !1, JT(i, ([y, w]) => {
        w.value = h, y(w, this, this._item);
      }));
    }
    /** @internal */
    eventObserved(t) {
      if (t.type == "change") this._changed.add(t.parent), t.idle || this._active.add(t.parent);else if (t.type == "idle") this._active.delete(t.parent);else return;
      ur.onFrame(this._onFrame);
    }
  };
function CF(t, e) {
  return Promise.all(e.map(i => _W(t, i))).then(i => Uz(t, i));
}
async function _W(t, e, i) {
  const {
      keys: s,
      to: c,
      from: p,
      loop: h,
      onRest: y,
      onResolve: w
    } = e,
    x = zt.obj(e.default) && e.default;
  h && (e.loop = !1), c === !1 && (e.to = null), p === !1 && (e.from = null);
  const E = zt.arr(c) || zt.fun(c) ? c : void 0;
  E ? (e.to = void 0, e.onRest = void 0, x && (x.onRest = void 0)) : Fr(l0e, L => {
    const P = e[L];
    if (zt.fun(P)) {
      const N = t._events[L];
      e[L] = ({
        finished: O,
        cancelled: F
      }) => {
        const j = N.get(P);
        j ? (O || (j.finished = !1), F && (j.cancelled = !0)) : N.set(P, {
          value: null,
          finished: O || !1,
          cancelled: F || !1
        });
      }, x && (x[L] = e[L]);
    }
  });
  const C = t._state;
  e.pause === !C.paused ? (C.paused = e.pause, PT(e.pause ? C.pauseQueue : C.resumeQueue)) : C.paused && (e.pause = !0);
  const k = (s || Object.keys(t.springs)).map(L => t.springs[L].start(e)),
    D = e.cancel === !0 || fW(e, "cancel") === !0;
  (E || D && C.asyncId) && k.push(hW(++t._lastAsyncId, {
    props: e,
    state: C,
    actions: {
      pause: bF,
      resume: bF,
      start(L, P) {
        D ? (PR(C, t._lastAsyncId), P(wE(t))) : (L.onRest = y, P(vW(E, L, C, t)));
      }
    }
  })), C.paused && (await new Promise(L => {
    C.resumeQueue.add(L);
  }));
  const I = Uz(t, await Promise.all(k));
  if (h && I.finished && !(i && I.noop)) {
    const L = wW(e, h, c);
    if (L) return CW(t, [L]), _W(t, L, !0);
  }
  return w && ur.batchedUpdates(() => w(I, t, t.item)), I;
}
function nH(t, e) {
  const i = {
    ...t.springs
  };
  return e && Fr(lp(e), s => {
    zt.und(s.keys) && (s = AR(s)), zt.obj(s.to) || (s = {
      ...s,
      to: void 0
    }), EW(i, s, c => SW(c));
  }), xW(t, i), i;
}
function xW(t, e) {
  Jv(e, (i, s) => {
    t.springs[s] || (t.springs[s] = i, $E(i, t));
  });
}
function SW(t, e) {
  const i = new i0e();
  return i.key = t, e && $E(i, e), i;
}
function EW(t, e, i) {
  e.keys && Fr(e.keys, s => {
    (t[s] || (t[s] = i(s)))._prepareNode(e);
  });
}
function CW(t, e) {
  Fr(e, i => {
    EW(t.springs, i, s => SW(s, t));
  });
}
var uO = ({
    children: t,
    ...e
  }) => {
    const i = bs(zL),
      s = e.pause || !!i.pause,
      c = e.immediate || !!i.immediate;
    e = Fbe(() => ({
      pause: s,
      immediate: c
    }), [s, c]);
    const {
      Provider: p
    } = zL;
    return /* @__PURE__ */Bn.createElement(p, {
      value: e
    }, t);
  },
  zL = c0e(uO, {});
uO.Provider = zL.Provider;
uO.Consumer = zL.Consumer;
function c0e(t, e) {
  return Object.assign(t, Bn.createContext(e)), t.Provider._context = t, t.Consumer._context = t, t;
}
var d0e = () => {
  const t = [],
    e = function (s) {
      Abe();
      const c = [];
      return Fr(t, (p, h) => {
        if (zt.und(s)) c.push(p.start());else {
          const y = i(s, p, h);
          y && c.push(p.start(y));
        }
      }), c;
    };
  e.current = t, e.add = function (s) {
    t.includes(s) || t.push(s);
  }, e.delete = function (s) {
    const c = t.indexOf(s);
    ~c && t.splice(c, 1);
  }, e.pause = function () {
    return Fr(t, s => s.pause(...arguments)), this;
  }, e.resume = function () {
    return Fr(t, s => s.resume(...arguments)), this;
  }, e.set = function (s) {
    Fr(t, (c, p) => {
      const h = zt.fun(s) ? s(p, c) : s;
      h && c.set(h);
    });
  }, e.start = function (s) {
    const c = [];
    return Fr(t, (p, h) => {
      if (zt.und(s)) c.push(p.start());else {
        const y = this._getProps(s, p, h);
        y && c.push(p.start(y));
      }
    }), c;
  }, e.stop = function () {
    return Fr(t, s => s.stop(...arguments)), this;
  }, e.update = function (s) {
    return Fr(t, (c, p) => c.update(this._getProps(s, c, p))), this;
  };
  const i = function (s, c, p) {
    return zt.fun(s) ? s(p, c) : s;
  };
  return e._getProps = i, e;
};
function f0e(t, e, i) {
  const s = zt.fun(e) && e;
  s && !i && (i = []);
  const c = ci(() => s || arguments.length == 3 ? d0e() : void 0, []),
    p = vt(0),
    h = lW(),
    y = ci(() => ({
      ctrls: [],
      queue: [],
      flush(N, O) {
        const F = nH(N, O);
        return p.current > 0 && !y.queue.length && !Object.keys(F).some(V => !N.springs[V]) ? CF(N, O) : new Promise(V => {
          xW(N, F), y.queue.push(() => {
            V(CF(N, O));
          }), h();
        });
      }
    }), []),
    w = vt([...y.ctrls]),
    x = [],
    E = $U(t) || 0;
  ci(() => {
    Fr(w.current.slice(t, E), N => {
      Qbe(N, c), N.stop(!0);
    }), w.current.length = t, C(E, t);
  }, [t]), ci(() => {
    C(0, Math.min(E, t));
  }, i);
  function C(N, O) {
    for (let F = N; F < O; F++) {
      const j = w.current[F] || (w.current[F] = new u0e(null, y.flush)),
        V = s ? s(F, j) : e[F];
      V && (x[F] = a0e(V));
    }
  }
  const k = w.current.map((N, O) => nH(N, x[O])),
    D = bs(uO),
    I = $U(D),
    L = D !== I && Kbe(D);
  zz(() => {
    p.current++, y.ctrls = w.current;
    const {
      queue: N
    } = y;
    N.length && (y.queue = [], Fr(N, O => O())), Fr(w.current, (O, F) => {
      c == null || c.add(O), L && O.start({
        default: D
      });
      const j = x[F];
      j && (Zbe(O, j.ref), O.ref ? O.queue.push(j) : O.start(j));
    });
  }), sW(() => () => {
    Fr(y.ctrls, N => N.stop(!0));
  });
  const P = k.map(N => ({
    ...N
  }));
  return c ? [P, c] : P;
}
function p0e(t, e) {
  const i = zt.fun(t),
    [[s], c] = f0e(1, i ? t : [t], i ? [] : e);
  return i || arguments.length == 2 ? [s, c] : s;
}
var h0e = class extends Hz {
  constructor(t, e) {
    super(), this.source = t, this.idle = !0, this._active = /* @__PURE__ */new Set(), this.calc = TR(...e);
    const i = this._get(),
      s = _F(i);
    Vz(this, s.create(i));
  }
  advance(t) {
    const e = this._get(),
      i = this.get();
    db(e, i) || ($v(this).setValue(e), this._onChange(e, this.idle)), !this.idle && rH(this._active) && y2(this);
  }
  _get() {
    const t = zt.arr(this.source) ? this.source.map(ad) : lp(ad(this.source));
    return this.calc(...t);
  }
  _start() {
    this.idle && !rH(this._active) && (this.idle = !1, Fr(lO(this), t => {
      t.done = !1;
    }), Xm.skipAnimation ? (ur.batchedUpdates(() => this.advance()), y2(this)) : rO.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let t = 1;
    Fr(lp(this.source), e => {
      Ap(e) && $E(e, this), EF(e) && (e.idle || this._active.add(e), t = Math.max(t, e.priority + 1));
    }), this.priority = t, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    Fr(lp(this.source), t => {
      Ap(t) && IR(t, this);
    }), this._active.clear(), y2(this);
  }
  /** @internal */
  eventObserved(t) {
    t.type == "change" ? t.idle ? this.advance() : (this._active.add(t.parent), this._start()) : t.type == "idle" ? this._active.delete(t.parent) : t.type == "priority" && (this.priority = lp(this.source).reduce((e, i) => Math.max(e, (EF(i) ? i.priority : 0) + 1), 0));
  }
};
function m0e(t) {
  return t.idle !== !1;
}
function rH(t) {
  return !t.size || Array.from(t).every(m0e);
}
function y2(t) {
  t.idle || (t.idle = !0, Fr(lO(t), e => {
    e.done = !0;
  }), DR(t, {
    type: "idle",
    parent: t
  }));
}
Xm.assign({
  createStringInterpolator: aW,
  to: (t, e) => new h0e(t, e)
});
var v0e = F8(),
  kW = /^--/;
function g0e(t, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e == "number" && e !== 0 && !kW.test(t) && !(nR.hasOwnProperty(t) && nR[t]) ? e + "px" : ("" + e).trim();
}
var iH = {};
function y0e(t, e) {
  if (!t.nodeType || !t.setAttribute) return !1;
  const i = t.nodeName === "filter" || t.parentNode && t.parentNode.nodeName === "filter",
    {
      className: s,
      style: c,
      children: p,
      scrollTop: h,
      scrollLeft: y,
      viewBox: w,
      ...x
    } = e,
    E = Object.values(x),
    C = Object.keys(x).map(k => i || t.hasAttribute(k) ? k : iH[k] || (iH[k] = k.replace(/([A-Z])/g,
    // Attributes are written in dash case
    D => "-" + D.toLowerCase())));
  p !== void 0 && (t.textContent = p);
  for (const k in c) if (c.hasOwnProperty(k)) {
    const D = g0e(k, c[k]);
    kW.test(k) ? t.style.setProperty(k, D) : t.style[k] = D;
  }
  C.forEach((k, D) => {
    t.setAttribute(k, E[D]);
  }), s !== void 0 && (t.className = s), h !== void 0 && (t.scrollTop = h), y !== void 0 && (t.scrollLeft = y), w !== void 0 && t.setAttribute("viewBox", w);
}
var nR = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    // SVG-related properties
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  b0e = (t, e) => t + e.charAt(0).toUpperCase() + e.substring(1),
  w0e = ["Webkit", "Ms", "Moz", "O"];
nR = Object.keys(nR).reduce((t, e) => (w0e.forEach(i => t[b0e(i, e)] = t[e]), t), nR);
var _0e = /^(matrix|translate|scale|rotate|skew)/,
  x0e = /^(translate)/,
  S0e = /^(rotate|skew)/,
  b2 = (t, e) => zt.num(t) && t !== 0 ? t + e : t,
  eL = (t, e) => zt.arr(t) ? t.every(i => eL(i, e)) : zt.num(t) ? t === e : parseFloat(t) === e,
  E0e = class extends sO {
    constructor({
      x: t,
      y: e,
      z: i,
      ...s
    }) {
      const c = [],
        p = [];
      (t || e || i) && (c.push([t || 0, e || 0, i || 0]), p.push(h => [`translate3d(${h.map(y => b2(y, "px")).join(",")})`,
      // prettier-ignore
      eL(h, 0)])), Jv(s, (h, y) => {
        if (y === "transform") c.push([h || ""]), p.push(w => [w, w === ""]);else if (_0e.test(y)) {
          if (delete s[y], zt.und(h)) return;
          const w = x0e.test(y) ? "px" : S0e.test(y) ? "deg" : "";
          c.push(lp(h)), p.push(y === "rotate3d" ? ([x, E, C, k]) => [`rotate3d(${x},${E},${C},${b2(k, w)})`, eL(k, 0)] : x => [`${y}(${x.map(E => b2(E, w)).join(",")})`, eL(x, y.startsWith("scale") ? 1 : 0)]);
        }
      }), c.length && (s.transform = new C0e(c, p)), super(s);
    }
  },
  C0e = class extends nW {
    constructor(t, e) {
      super(), this.inputs = t, this.transforms = e, this._value = null;
    }
    get() {
      return this._value || (this._value = this._get());
    }
    _get() {
      let t = "",
        e = !0;
      return Fr(this.inputs, (i, s) => {
        const c = ad(i[0]),
          [p, h] = this.transforms[s](zt.arr(c) ? c : i.map(ad));
        t += " " + p, e = e && h;
      }), e ? "none" : t;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(t) {
      t == 1 && Fr(this.inputs, e => Fr(e, i => Ap(i) && $E(i, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(t) {
      t == 0 && Fr(this.inputs, e => Fr(e, i => Ap(i) && IR(i, this)));
    }
    eventObserved(t) {
      t.type == "change" && (this._value = null), DR(this, t);
    }
  },
  k0e = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr",
  // SVG
  "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
Xm.assign({
  batchedUpdates: v0e.unstable_batchedUpdates,
  createStringInterpolator: aW,
  colors: pbe
});
var T0e = Wbe(k0e, {
    applyAnimatedValues: y0e,
    createAnimatedStyle: t => new E0e(t),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({
      scrollTop: t,
      scrollLeft: e,
      ...i
    }) => i
  }),
  R0e = T0e.animated;
const D0e = "_formSection_a9tuc_1",
  I0e = "_formWrapper_a9tuc_11",
  M0e = "_imageBanner_a9tuc_19",
  L0e = "_formContainer_a9tuc_40",
  O0e = "_formElements_a9tuc_44",
  P0e = "_subtitle_a9tuc_47",
  A0e = "_inputContainer_a9tuc_52",
  j0e = "_emailInput_a9tuc_55",
  F0e = "_dropdownContainer_a9tuc_58",
  N0e = "_submitButton_a9tuc_61",
  z0e = "_button_a9tuc_66",
  V0e = "_legal_a9tuc_70",
  B0e = "_message_a9tuc_70",
  U0e = "_optInMessage_a9tuc_73",
  H0e = "_links_a9tuc_79",
  $0e = "_divider_a9tuc_83",
  W0e = "_link_a9tuc_79",
  q0e = "_errorAlert_a9tuc_99",
  Y0e = "_srOnly_a9tuc_106",
  G0e = "_closeIcon_a9tuc_117",
  X0e = "_confirmation_a9tuc_134",
  K0e = "_confirmIcon_a9tuc_150",
  Q0e = "_heading_a9tuc_154",
  Z0e = "_title_a9tuc_172",
  J0e = "_hiddenFields_a9tuc_179",
  Hr = {
    formSection: D0e,
    formWrapper: I0e,
    imageBanner: M0e,
    formContainer: L0e,
    formElements: O0e,
    subtitle: P0e,
    inputContainer: A0e,
    emailInput: j0e,
    dropdownContainer: F0e,
    submitButton: N0e,
    button: z0e,
    legal: V0e,
    message: B0e,
    optInMessage: U0e,
    links: H0e,
    divider: $0e,
    link: W0e,
    errorAlert: q0e,
    srOnly: Y0e,
    closeIcon: G0e,
    confirmation: X0e,
    confirmIcon: K0e,
    heading: Q0e,
    title: Z0e,
    hiddenFields: J0e,
    "inline-horizontal": "_inline-horizontal_a9tuc_192"
  },
  TW = Qn(({
    id: t,
    type: e,
    labels: i,
    mode: s,
    setWidgetOpen: c,
    userEmail: p,
    setUserEmail: h,
    userGateway: y,
    setUserGateway: w,
    setRegistered: x,
    isRegistered: E,
    setHasSubmitted: C = () => {},
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: L,
    emailError: P,
    setEmailError: N,
    gatewayError: O,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V
  }, K) => {
    const {
        isSm: G
      } = WL(),
      Q = t ?? "email-subscription",
      [te, ie] = rt(!1),
      Y = vt(`email-${Q}`),
      [ee, ae] = rt(!1),
      ne = vt(null),
      [le, ce] = rt(),
      W = vt(null),
      $ = fe => {
        fe != null && fe.statusCode && fe != null && fe.errorMessage ? (console.error(`Error: onSubmitForm: Failed with statusCode: ${fe == null ? void 0 : fe.statusCode}: ${fe.errorMessage}`), V(fe.errorMessage)) : (console.error("Error: onSubmitForm: An unknown error occured"), i != null && i.errorUnknown && V(i.errorUnknown)), setTimeout(() => {
          C(!0);
        }, 10);
      },
      de = async fe => {
        fe.preventDefault(), ae(!0), V("");
        const _e = fe.target.querySelector(`#${Y.current}`),
          Se = _e == null ? void 0 : _e.validity,
          be = Ce(p, void 0, Se),
          Le = se(y);
        if (p && y && !be && !Le) try {
          const Be = await (D == null ? void 0 : D(p, y));
          (Be == null ? void 0 : Be.statusCode) && Be.statusCode >= 200 && Be.statusCode <= 299 ? (s === "desktop" && ne != null && ne.current && ce(ne.current.getBoundingClientRect().height), ie(!0), x(!0), h(""), w(void 0)) : $(Be);
        } catch (Be) {
          $(Be);
        }
        ae(!1);
      },
      H = fe => {
        se(fe), fe && w(fe);
      },
      se = fe => {
        let _e = !1;
        return fe != null && fe.value || y != null && y.value ? F("") : (i != null && i.dropdownFieldErrorMissing && F(i.dropdownFieldErrorMissing), _e = !0), C(!0), _e;
      },
      ue = fe => {
        h(fe.target.value), Ce(fe.currentTarget.value, fe);
      },
      Ee = fe => {
        var be, Le, Be;
        const _e = {
          valueMissing: (be = i == null ? void 0 : i.validityMessages) == null ? void 0 : be.valueMissing,
          typeMismatch: (Le = i == null ? void 0 : i.validityMessages) == null ? void 0 : Le.typeMismatch,
          patternMismatch: (Be = i == null ? void 0 : i.validityMessages) == null ? void 0 : Be.patternMismatch
        };
        let Se = !1;
        return i != null && i.validityMessages && Object.keys(i.validityMessages).forEach(Xe => {
          if (fe[Xe]) {
            const ge = _e[Xe];
            typeof ge == "string" && (N(ge), Se = !0);
            return;
          }
        }), Se || N(""), Se;
      },
      Ce = (fe, _e, Se) => {
        let be = !1;
        if (typeof k == "function") {
          const Le = k == null ? void 0 : k(fe);
          typeof Le == "string" ? (N(Le), be = !!Le) : _e != null && _e.target.validity.valid || Se != null && Se.valid ? N("") : be = !0;
        } else _e != null && _e.target.validity ? be = Ee(_e.target.validity) : Se && (be = Ee(Se));
        return C(!0), be;
      };
    return Rt(() => {
      var fe;
      j && W != null && W.current && ((fe = W.current) == null || fe.focus());
    }, [j]), /* @__PURE__ */B.jsx("div", {
      className: ve(Hr.formSection, s === "desktop" && (Hr == null ? void 0 : Hr[e])),
      ref: K,
      children: /* @__PURE__ */B.jsxs("div", {
        className: Hr.formWrapper,
        children: [/* @__PURE__ */B.jsx("div", {
          className: Hr.imageBanner,
          children: (i.desktopSmallImage || i.desktopLargeImage) && /* @__PURE__ */B.jsx("img", {
            src: G ? i.desktopSmallImage : i.desktopLargeImage,
            alt: ""
          })
        }), /* @__PURE__ */B.jsxs("div", {
          className: Hr.formContainer,
          children: [!E && /* @__PURE__ */B.jsx("form", {
            acceptCharset: "utf-8",
            noValidate: !0,
            onSubmit: de,
            ref: ne,
            children: /* @__PURE__ */B.jsxs("div", {
              className: Hr.formElements,
              children: [s === "mobile" && /* @__PURE__ */B.jsx(op, {
                onClick: fe => {
                  fe.preventDefault(), c(!1);
                },
                defaultStyle: !0,
                iconPlacement: "left",
                icon: "close",
                disabled: ee,
                className: Hr.closeIcon
              }), i.title && /* @__PURE__ */B.jsx("h2", {
                className: Hr.heading,
                children: i.title
              }), i.subtitle && /* @__PURE__ */B.jsx("div", {
                className: Hr.subtitle,
                children: i.subtitle
              }), j && /* @__PURE__ */B.jsx(U4, {
                ref: W,
                dismissible: !1,
                heading: j,
                variant: "error",
                headingAs: "p",
                className: Hr.errorAlert,
                children: null,
                tabIndex: -1
              }), /* @__PURE__ */B.jsxs("div", {
                className: Hr.inputContainer,
                children: [/* @__PURE__ */B.jsx("div", {
                  className: Hr.emailInput,
                  children: /* @__PURE__ */B.jsx(Nhe, {
                    label: i.inputFieldLabel,
                    type: "email",
                    pattern: typeof k != "function" ? abe : void 0,
                    value: p,
                    required: !0,
                    theme: "grey",
                    onChange: ue,
                    errorMessage: P,
                    id: `email-${Q}`,
                    name: `email-${Q}`,
                    disabled: ee
                  })
                }), /* @__PURE__ */B.jsx("div", {
                  className: Hr.dropdownContainer,
                  children: /* @__PURE__ */B.jsx(qT, {
                    className: Hr.dropdownInput,
                    label: i.dropdownFieldLabel,
                    theme: "grey",
                    data: L,
                    onChange: H,
                    errorMessage: O,
                    selectedItem: y,
                    initialSelectedItem: y,
                    id: `gateway-${Q}`,
                    isDisabled: ee
                  })
                }), /* @__PURE__ */B.jsx("div", {
                  className: Hr.submitButton,
                  children: /* @__PURE__ */B.jsx(op, {
                    className: Hr.button,
                    type: "submit",
                    variant: "primary",
                    disabled: ee,
                    children: i.submit
                  })
                })]
              }), /* @__PURE__ */B.jsxs("div", {
                className: ve(Hr.legal, (i == null ? void 0 : i.optInMessage) && Hr.message),
                children: [(i == null ? void 0 : i.optInMessage) && /* @__PURE__ */B.jsx("p", {
                  className: Hr.optInMessage,
                  children: i.optInMessage
                }), /* @__PURE__ */B.jsxs("div", {
                  className: Hr.links,
                  children: [(i == null ? void 0 : i.optInPrivacyLabel) && (i == null ? void 0 : i.optInPrivacyLink) && /* @__PURE__ */B.jsxs(dd, {
                    renderLink: I,
                    rel: "noopener",
                    href: i.optInPrivacyLink,
                    className: Hr.link,
                    target: "_blank",
                    children: [i.optInPrivacyLabel, i.optInA11yMessage && /* @__PURE__ */B.jsx("span", {
                      className: Hr.srOnly,
                      children: i.optInA11yMessage
                    })]
                  }), (i == null ? void 0 : i.optInPrivacyLink) && (i == null ? void 0 : i.optInContactLink) && /* @__PURE__ */B.jsx("span", {
                    className: Hr.divider,
                    children: "|"
                  }), (i == null ? void 0 : i.optInContactLabel) && (i == null ? void 0 : i.optInContactLink) && /* @__PURE__ */B.jsxs(dd, {
                    renderLink: I,
                    rel: "noopener noreferrer",
                    href: i.optInContactLink,
                    className: Hr.link,
                    target: "_blank",
                    children: [i.optInContactLabel, i.optInA11yMessage && /* @__PURE__ */B.jsx("span", {
                      className: Hr.srOnly,
                      children: i.optInA11yMessage
                    })]
                  })]
                })]
              })]
            })
          }), (E || te) && /* @__PURE__ */B.jsx("div", {
            className: Hr.confirmation,
            style: {
              minHeight: le || `${le}px`
            },
            children: /* @__PURE__ */B.jsxs("section", {
              children: [s === "mobile" && /* @__PURE__ */B.jsx(op, {
                onClick: fe => {
                  fe.preventDefault(), c(!1), (te || E) && (x(!1), ie(!1));
                },
                defaultStyle: !0,
                iconPlacement: "left",
                icon: "close",
                disabled: ee,
                className: Hr.closeIcon
              }), /* @__PURE__ */B.jsx("h2", {
                className: Hr.heading,
                children: i.title
              }), /* @__PURE__ */B.jsxs("div", {
                className: Hr.subtitle,
                children: [/* @__PURE__ */B.jsx(ln, {
                  name: "success-solid",
                  hidden: !0,
                  className: Hr.confirmIcon
                }), /* @__PURE__ */B.jsx("span", {
                  className: Hr.title,
                  children: i.confirmTitle
                })]
              }), /* @__PURE__ */B.jsx("div", {
                className: Hr.message,
                children: i.confirmMessage
              })]
            })
          })]
        })]
      })
    });
  }),
  ewe = "_mobileWidgetWrapper_1oda1_1",
  twe = "_open_1oda1_11",
  nwe = "_container_1oda1_22",
  rwe = "_formContents_1oda1_49",
  iwe = "_formContainer_1oda1_54",
  LT = {
    mobileWidgetWrapper: ewe,
    open: twe,
    container: nwe,
    formContents: rwe,
    formContainer: iwe
  },
  awe = ({
    id: t,
    type: e,
    config: i,
    labels: s,
    mode: c,
    isWidgetOpen: p,
    setWidgetOpen: h,
    userEmail: y,
    setUserEmail: w,
    userGateway: x,
    setUserGateway: E,
    setRegistered: C,
    isRegistered: k,
    onValidateEmail: D,
    onSubmitForm: I,
    gatewayData: L,
    emailError: P,
    setEmailError: N,
    gatewayError: O,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    mobileButtonRef: K
  }) => {
    var Se, be, Le, Be, Xe, ge;
    const G = {
        marginBottom: ibe
      },
      Q = vt(p),
      [te, ie] = rt(null),
      [Y, ee] = rt(null),
      [ae, ne] = rt(p ? null : G),
      le = vt(!1),
      ce = vt(!1),
      W = vt(null),
      $ = vt(null),
      [de, H] = rt(!1),
      se = vt(null),
      ue = vt(!0),
      Ee = {
        title: ((Le = (be = (Se = i == null ? void 0 : i.content) == null ? void 0 : Se[e]) == null ? void 0 : be.mobileWidget) == null ? void 0 : Le.title) ?? s.title,
        subtitle: ((ge = (Xe = (Be = i == null ? void 0 : i.content) == null ? void 0 : Be[e]) == null ? void 0 : Xe.mobileWidget) == null ? void 0 : ge.subtitle) ?? s.subtitle
      };
    s = {
      ...tO,
      ...s,
      ...Ee
    };
    const [Ce, fe] = p0e(() => ({
        height: "0px",
        transition: "height 0.25s ease-out",
        onRest(qe) {
          qe.value.height === "0px" && setTimeout(() => {
            var Ae;
            (Ae = K == null ? void 0 : K.current) == null || Ae.focus();
          }, 10);
        }
      })),
      _e = pn(() => {
        if (W != null && W.current && $ != null && $.current && Q.current && (ce.current = $.current.getBoundingClientRect().height !== W.current.getBoundingClientRect().height, ce.current)) {
          const qe = W.current.getBoundingClientRect().height;
          fe.start({
            height: `${qe}px`
          }), ne(null);
        }
        le.current = !0, ie(window.innerWidth || document.documentElement.clientWidth), ee(window.innerHeight || document.documentElement.clientHeight);
      }, []);
    return Rt(() => (window.addEventListener("resize", _e, !1), ue.current = !1, _e(), () => {
      window.removeEventListener("resize", _e);
    }), []), Rt(() => {
      !p && $ != null && $.current ? (Q.current = !1, document.getElementsByTagName("body")[0].style.overflow = "", fe.start({
        height: "0px"
      })) : p && $ != null && $.current && (Q.current = !0, _e());
    }, [k, p, kR, te, Y]), Rt(() => {
      if ($ != null && $.current || $ != null && $.current && ce.current) {
        ce.current = !1;
        const qe = W != null && W.current ? W.current.scrollHeight : 0;
        fe.start({
          height: `${p ? qe : 0}px`
        });
      }
    }, [p]), Rt(() => {
      if ((e === "inline-split" || e === "inline-horizontal") && W != null && W.current && k) {
        ce.current = !0;
        const qe = W.current.getBoundingClientRect().height;
        (p || k) && fe.start({
          height: `${qe}px`
        }), !p && (e === "inline-split" || e === "inline-horizontal") && k && h(!0);
      }
    }, [e, k, p, te]), Rt(() => {
      if (de && W != null && W.current && p) {
        const qe = W.current.getBoundingClientRect().height;
        fe.start({
          height: `${qe}px`
        }), H(!1);
      }
    }, [de]), /* @__PURE__ */B.jsx(B.Fragment, {
      children: te && te < kR && !ue.current && /* @__PURE__ */B.jsx("div", {
        ref: se,
        className: ve(LT.mobileWidgetWrapper, p ? LT.open : null),
        style: (e === "inline-split" || e === "inline-horizontal") && !p ? G : ae ?? void 0,
        children: /* @__PURE__ */B.jsx("div", {
          className: LT.container,
          children: /* @__PURE__ */B.jsx("div", {
            className: LT.formContents,
            children: /* @__PURE__ */B.jsx(R0e.div, {
              className: LT.formContainer,
              ref: $,
              style: {
                ...Ce
              },
              children: /* @__PURE__ */B.jsx(TW, {
                ref: W,
                id: t,
                type: e,
                labels: s,
                mode: c,
                setWidgetOpen: h,
                userEmail: y,
                setUserEmail: w,
                userGateway: x,
                setUserGateway: E,
                setRegistered: C,
                isRegistered: k,
                setHasSubmitted: H,
                onValidateEmail: D,
                onSubmitForm: I,
                gatewayData: L,
                emailError: P,
                setEmailError: N,
                gatewayError: O,
                setGatewayError: F,
                submitError: j,
                setSubmitError: V,
                mobileButtonRef: K
              })
            })
          })
        })
      })
    });
  },
  owe = ({
    id: t,
    type: e,
    config: i,
    labels: s,
    mode: c,
    isWidgetOpen: p,
    setWidgetOpen: h,
    userEmail: y,
    setUserEmail: w,
    userGateway: x,
    setUserGateway: E,
    setRegistered: C,
    isRegistered: k,
    onValidateEmail: D,
    onSubmitForm: I,
    gatewayData: L,
    emailError: P,
    setEmailError: N,
    gatewayError: O,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V
  }) => {
    let K = null;
    return c === "mobile" && (K = /* @__PURE__ */B.jsx(awe, {
      id: t,
      type: e,
      config: i,
      labels: s,
      mode: c,
      isWidgetOpen: p,
      setWidgetOpen: h,
      userEmail: y,
      setUserEmail: w,
      userGateway: x,
      setUserGateway: E,
      setRegistered: C,
      isRegistered: k,
      onValidateEmail: D,
      onSubmitForm: I,
      gatewayData: L,
      emailError: P,
      setEmailError: N,
      gatewayError: O,
      setGatewayError: F,
      submitError: j,
      setSubmitError: V
    })), K;
  },
  lwe = "_formSection_55pyy_1",
  swe = "_formWrapper_55pyy_6",
  uwe = "_imageBanner_55pyy_10",
  cwe = "_formContainer_55pyy_29",
  dwe = "_formElements_55pyy_34",
  fwe = "_heading_55pyy_38",
  pwe = "_subtitle_55pyy_45",
  hwe = "_inputContainer_55pyy_50",
  mwe = "_submitButton_55pyy_53",
  sb = {
    formSection: lwe,
    formWrapper: swe,
    imageBanner: uwe,
    formContainer: cwe,
    formElements: dwe,
    heading: fwe,
    subtitle: pwe,
    inputContainer: hwe,
    submitButton: mwe
  },
  vwe = ({
    id: t,
    type: e,
    embed: i,
    config: s,
    labels: c,
    mode: p,
    isWidgetOpen: h,
    setWidgetOpen: y,
    userEmail: w,
    setUserEmail: x,
    userGateway: E,
    setUserGateway: C,
    setRegistered: k,
    isRegistered: D,
    onValidateEmail: I,
    onSubmitForm: L,
    gatewayData: P,
    emailError: N,
    setEmailError: O,
    gatewayError: F,
    setGatewayError: j,
    submitError: V,
    setSubmitError: K,
    mobileButtonRef: G,
    className: Q
  }) => {
    var ae, ne, le, ce, W, $, de, H, se;
    const te = () => {
        y(!0);
      },
      ie = {
        image: ((le = (ne = (ae = s == null ? void 0 : s.content) == null ? void 0 : ae[e]) == null ? void 0 : ne.mobileBanner) == null ? void 0 : le.image) ?? c.mobileImage,
        title: (($ = (W = (ce = s == null ? void 0 : s.content) == null ? void 0 : ce[e]) == null ? void 0 : W.mobileBanner) == null ? void 0 : $.title) ?? c.title,
        subtitle: ((se = (H = (de = s == null ? void 0 : s.content) == null ? void 0 : de[e]) == null ? void 0 : H.mobileBanner) == null ? void 0 : se.subtitle) ?? c.subtitle
      },
      Y = {
        ...tO,
        ...c,
        ...ie
      },
      ee = /* @__PURE__ */B.jsx("div", {
        className: sb.formSection,
        children: /* @__PURE__ */B.jsxs("div", {
          className: sb.formWrapper,
          children: [/* @__PURE__ */B.jsx(gb, {
            className: sb.imageBanner,
            children: /* @__PURE__ */B.jsx("img", {
              src: Y.image,
              alt: ""
            })
          }), /* @__PURE__ */B.jsx(gb, {
            className: sb.formContainer,
            children: /* @__PURE__ */B.jsx(NE, {
              cols: 1,
              className: sb.formElements,
              children: /* @__PURE__ */B.jsx(gb, {
                children: /* @__PURE__ */B.jsxs("section", {
                  children: [/* @__PURE__ */B.jsx("div", {
                    className: sb.heading,
                    children: Y.title
                  }), /* @__PURE__ */B.jsx("div", {
                    className: sb.subtitle,
                    children: Y.subtitle
                  }), /* @__PURE__ */B.jsx("div", {
                    className: sb.inputContainer,
                    children: /* @__PURE__ */B.jsx(op, {
                      ref: G,
                      className: sb.submitButton,
                      type: "button",
                      variant: "primary",
                      onClick: () => te(),
                      children: Y.submit
                    })
                  })]
                })
              })
            })
          })]
        })
      });
    return /* @__PURE__ */B.jsxs(B.Fragment, {
      children: [/* @__PURE__ */B.jsx("section", {
        className: Q,
        children: ee
      }), /* @__PURE__ */B.jsx(GN, {
        autoFocus: !0,
        enabled: h,
        scrollLock: h && p === "mobile",
        children: /* @__PURE__ */B.jsx(owe, {
          id: t,
          type: e,
          embed: i,
          config: s,
          mode: p,
          labels: c,
          isWidgetOpen: h,
          setWidgetOpen: y,
          userEmail: w,
          setUserEmail: x,
          userGateway: E,
          setUserGateway: C,
          setRegistered: k,
          isRegistered: D,
          onValidateEmail: I,
          onSubmitForm: L,
          gatewayData: P,
          emailError: N,
          setEmailError: O,
          gatewayError: F,
          setGatewayError: j,
          submitError: V,
          setSubmitError: K
        })
      })]
    });
  },
  gwe = ({
    id: t,
    type: e,
    config: i,
    labels: s,
    mode: c,
    setWidgetOpen: p,
    userEmail: h,
    setUserEmail: y,
    userGateway: w,
    setUserGateway: x,
    setRegistered: E,
    isRegistered: C,
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: L,
    emailError: P,
    setEmailError: N,
    gatewayError: O,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    className: K
  }) => {
    var Y, ee, ae, ne, le, ce, W, $, de, H, se, ue;
    const [G, Q] = rt(null),
      te = {
        desktopLargeImage: ((ae = (ee = (Y = i == null ? void 0 : i.content) == null ? void 0 : Y[e]) == null ? void 0 : ee.desktopWidget) == null ? void 0 : ae.imageLarge) ?? s.desktopLargeImage,
        desktopSmallImage: ((ce = (le = (ne = i == null ? void 0 : i.content) == null ? void 0 : ne[e]) == null ? void 0 : le.desktopWidget) == null ? void 0 : ce.imageSmall) ?? s.desktopSmallImage,
        title: ((de = ($ = (W = i == null ? void 0 : i.content) == null ? void 0 : W[e]) == null ? void 0 : $.desktopWidget) == null ? void 0 : de.title) ?? s.title,
        subtitle: ((ue = (se = (H = i == null ? void 0 : i.content) == null ? void 0 : H[e]) == null ? void 0 : se.desktopWidget) == null ? void 0 : ue.subtitle) ?? s.subtitle
      };
    s = {
      ...tO,
      ...s,
      ...te
    };
    const ie = () => {
      Q(window.innerWidth || document.documentElement.clientWidth);
    };
    return Rt(() => (window.addEventListener("resize", ie, !1), ie(), () => {
      window.removeEventListener("resize", ie);
    }), []), G && G >= kR ? /* @__PURE__ */B.jsx("section", {
      className: K,
      children: /* @__PURE__ */B.jsx(TW, {
        id: t,
        type: e,
        mode: c,
        labels: s,
        setWidgetOpen: p,
        userEmail: h,
        setUserEmail: y,
        userGateway: w,
        setUserGateway: x,
        setRegistered: E,
        isRegistered: C,
        onValidateEmail: k,
        onSubmitForm: D,
        renderLink: I,
        gatewayData: L,
        emailError: P,
        setEmailError: N,
        gatewayError: O,
        setGatewayError: F,
        submitError: j,
        setSubmitError: V
      })
    }) : null;
  },
  ywe = ({
    id: t,
    type: e,
    config: i,
    labels: s,
    isWidgetOpen: c,
    setWidgetOpen: p,
    userEmail: h,
    setUserEmail: y,
    userGateway: w,
    setUserGateway: x,
    setRegistered: E,
    isRegistered: C,
    onValidateEmail: k,
    onSubmitForm: D,
    renderLink: I,
    gatewayData: L,
    emailError: P,
    setEmailError: N,
    gatewayError: O,
    setGatewayError: F,
    submitError: j,
    setSubmitError: V,
    className: K
  }) => {
    const [G, Q] = rt(null),
      te = vt(null);
    let ie = null;
    const Y = () => {
      Q(window.innerWidth || document.documentElement.clientWidth);
    };
    return Rt(() => (window.addEventListener("resize", Y, !1), Y(), () => {
      window.removeEventListener("resize", Y);
    }), []), G && (G < kR ? ie = /* @__PURE__ */B.jsx(vwe, {
      id: t,
      type: e,
      embed: !0,
      config: i,
      mode: "mobile",
      labels: s,
      isWidgetOpen: c,
      setWidgetOpen: p,
      userEmail: h,
      setUserEmail: y,
      userGateway: w,
      setUserGateway: x,
      setRegistered: E,
      isRegistered: C,
      onValidateEmail: k,
      onSubmitForm: D,
      renderLink: I,
      gatewayData: L,
      emailError: P,
      setEmailError: N,
      gatewayError: O,
      setGatewayError: F,
      submitError: j,
      setSubmitError: V,
      mobileButtonRef: te,
      className: K
    }) : G >= kR && (ie = /* @__PURE__ */B.jsx(B.Fragment, {
      children: /* @__PURE__ */B.jsx(gwe, {
        id: t,
        type: e,
        embed: !0,
        config: i,
        mode: "desktop",
        labels: s,
        isWidgetOpen: c,
        setWidgetOpen: p,
        userEmail: h,
        setUserEmail: y,
        userGateway: w,
        setUserGateway: x,
        setRegistered: E,
        isRegistered: C,
        onValidateEmail: k,
        onSubmitForm: D,
        renderLink: I,
        gatewayData: L,
        emailError: P,
        setEmailError: N,
        gatewayError: O,
        setGatewayError: F,
        submitError: j,
        setSubmitError: V,
        className: K
      })
    }))), ie;
  },
  oxe = ({
    id: t,
    type: e,
    config: i,
    gatewayData: s,
    labels: c = {},
    onValidateEmail: p,
    onSubmitForm: h,
    renderLink: y,
    className: w
  }) => {
    const x = {
        ...tO,
        ...c
      },
      [E, C] = rt(!1),
      [k, D] = rt(""),
      [I, L] = rt(void 0),
      [P, N] = rt(),
      [O, F] = rt(""),
      [j, V] = rt(""),
      [K, G] = rt("");
    return e === "inline-split" || e === "inline-horizontal" ? /* @__PURE__ */B.jsx(ywe, {
      id: t,
      type: e,
      config: i,
      gatewayData: s,
      labels: x,
      userEmail: k,
      setUserEmail: D,
      isWidgetOpen: E,
      setWidgetOpen: C,
      userGateway: I,
      setUserGateway: L,
      setRegistered: N,
      isRegistered: P,
      onValidateEmail: p,
      onSubmitForm: h,
      renderLink: y,
      emailError: O,
      setEmailError: F,
      gatewayError: j,
      setGatewayError: V,
      submitError: K,
      setSubmitError: G,
      className: w
    }) : null;
  },
  bwe = "_tableWrapper_1dcgv_1",
  wwe = "_table_1dcgv_1",
  _we = "_rowHeading_1dcgv_19",
  xwe = "_headerBorderBottom_1dcgv_28",
  Swe = "_header_1dcgv_28",
  Ewe = "_tableHeading_1dcgv_38",
  Cwe = "_tableHeadingText_1dcgv_46",
  kwe = "_headerCellEyebrow_1dcgv_53",
  Twe = "_row_1dcgv_19",
  Rwe = "_actionRow_1dcgv_65",
  Dwe = "_pricingRow_1dcgv_65",
  Iwe = "_cell_1dcgv_69",
  Mwe = "_actionCell_1dcgv_69",
  Lwe = "_pricingCell_1dcgv_69",
  Owe = "_cellIconGreen_1dcgv_79",
  Pwe = "_cellIconRed_1dcgv_84",
  Awe = "_pricingCellPrice_1dcgv_114",
  jwe = "_pricingCellPriceText_1dcgv_119",
  Fwe = "_pricingCellPricePlusSign_1dcgv_124",
  Nwe = "_pricingIcon_1dcgv_135",
  zwe = "_right_1dcgv_156",
  Io = {
    tableWrapper: bwe,
    table: wwe,
    rowHeading: _we,
    headerBorderBottom: xwe,
    header: Swe,
    tableHeading: Ewe,
    tableHeadingText: Cwe,
    headerCellEyebrow: kwe,
    row: Twe,
    actionRow: Rwe,
    pricingRow: Dwe,
    cell: Iwe,
    actionCell: Mwe,
    pricingCell: Lwe,
    cellIconGreen: Owe,
    cellIconRed: Pwe,
    pricingCellPrice: Awe,
    pricingCellPriceText: jwe,
    pricingCellPricePlusSign: Fwe,
    pricingIcon: Nwe,
    right: zwe
  },
  Lc = ({
    children: t,
    className: e,
    caption: i,
    ...s
  }) => /* @__PURE__ */B.jsx("div", {
    className: ve(Io.tableWrapper, e),
    children: /* @__PURE__ */B.jsxs("table", {
      className: Io.table,
      ...s,
      children: [i && /* @__PURE__ */B.jsx("caption", {
        children: i
      }), t]
    })
  }),
  Vwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("thead", {
    className: Io.headerBorderBottom,
    ...i,
    children: /* @__PURE__ */B.jsx("tr", {
      className: ve(Io.header, e),
      children: t
    })
  }),
  Bwe = ({
    eyebrow: t,
    title: e,
    span: i = 1,
    className: s = "",
    scope: c = "col",
    ...p
  }) => /* @__PURE__ */B.jsxs("th", {
    colSpan: i > 1 ? i : void 0,
    scope: c,
    className: ve(Io.tableHeading, s),
    ...p,
    children: [t && /* @__PURE__ */B.jsx(RW, {
      children: t
    }), /* @__PURE__ */B.jsx("h3", {
      className: Io.tableHeadingText,
      children: e
    })]
  }),
  RW = ({
    children: t
  }) => /* @__PURE__ */B.jsx("span", {
    className: Io.headerCellEyebrow,
    children: t
  }),
  Uwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("tbody", {
    className: e,
    ...i,
    children: t
  }),
  Hwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx(B.Fragment, {
    children: Nt.Children.map(t, (i, s) => Nt.isValidElement(i) ? Nt.cloneElement(i, {
      key: i.key || s,
      ...e
    }) : i)
  }),
  $we = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("tr", {
    className: ve(Io.row, e),
    ...i,
    children: t
  }),
  Wwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx("tr", {
    className: Io.pricingRow,
    ...e,
    children: t
  }),
  qwe = ({
    children: t,
    ...e
  }) => /* @__PURE__ */B.jsx("tr", {
    className: Io.actionRow,
    ...e,
    children: t
  }),
  Ywe = ({
    children: t,
    span: e = 1,
    className: i = "",
    scope: s = "row",
    ...c
  }) => /* @__PURE__ */B.jsx("th", {
    rowSpan: e > 1 ? e : void 0,
    scope: s,
    className: ve(Io.rowHeading, i),
    ...c,
    children: t
  }),
  Gwe = ({
    children: t,
    span: e = 1,
    className: i,
    icon: s,
    ...c
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: e > 1 ? e : void 0,
    className: i,
    ...c,
    children: /* @__PURE__ */B.jsxs("div", {
      className: Io.cell,
      children: [s && /* @__PURE__ */B.jsx(ln, {
        name: s,
        className: s === "checkmark" ? Io.cellIconGreen : Io.cellIconRed
      }), t]
    })
  }),
  Xwe = ({
    align: t,
    children: e,
    className: i,
    ...s
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: 1,
    className: ve(i),
    ...s,
    children: /* @__PURE__ */B.jsx("div", {
      className: ve(Io.pricingCell, t && Io[t]),
      children: e
    })
  }),
  Kwe = ({
    children: t
  }) => /* @__PURE__ */B.jsx("div", {
    children: t
  }),
  Qwe = ({
    children: t,
    className: e
  }) => /* @__PURE__ */B.jsx("div", {
    className: ve(Io.pricingCellBody, e),
    children: t
  }),
  Zwe = ({
    icon: t,
    price: e
  }) => {
    const i = e && dR(e);
    return /* @__PURE__ */B.jsxs("div", {
      className: Io.pricingCellPrice,
      children: [t && /* @__PURE__ */B.jsx(ln, {
        name: t,
        className: Io.pricingIcon
      }), /* @__PURE__ */B.jsxs(cu, {
        size: "md",
        Tag: "h3",
        children: [/* @__PURE__ */B.jsx("span", {
          className: Io.pricingCellPricePlusSign,
          children: "+"
        }), /* @__PURE__ */B.jsx("span", {
          className: Io.pricingCellPriceText,
          children: i
        })]
      })]
    });
  },
  Jwe = ({
    children: t,
    className: e,
    ...i
  }) => /* @__PURE__ */B.jsx("td", {
    colSpan: 1,
    className: ve(e),
    ...i,
    children: /* @__PURE__ */B.jsx("div", {
      className: Io.actionCell,
      children: t
    })
  });
Lc.Header = Vwe;
Lc.Body = Uwe;
Lc.Item = Hwe;
Lc.Row = $we;
Lc.PricingRow = Wwe;
Lc.ActionRow = qwe;
Lc.Cell = Gwe;
Lc.HeaderCell = Bwe;
Lc.HeaderCellEyebrow = RW;
Lc.RowHeaderCell = Ywe;
Lc.PricingCell = Xwe;
Lc.PricingCellEyebrow = Kwe;
Lc.PricingCellBody = Qwe;
Lc.PricingCellPrice = Zwe;
Lc.ActionCell = Jwe;
const e_e = "_wrapper_td2nq_1",
  t_e = "_input_td2nq_5",
  n_e = "_border_td2nq_20",
  r_e = "_inputError_td2nq_30",
  i_e = "_inputIcon_td2nq_42",
  a_e = "_icon_td2nq_57",
  o_e = "_inputLabel_td2nq_64",
  l_e = "_inputLabelDisabled_td2nq_75",
  s_e = "_inputFocus_td2nq_78",
  u_e = "_helperText_td2nq_82",
  c_e = "_textError_td2nq_93",
  Lp = {
    wrapper: e_e,
    input: t_e,
    border: n_e,
    inputError: r_e,
    inputIcon: i_e,
    icon: a_e,
    inputLabel: o_e,
    inputLabelDisabled: l_e,
    inputFocus: s_e,
    helperText: u_e,
    textError: c_e
  },
  lxe = Qn(({
    className: t,
    classNames: e,
    rows: i = 4,
    ...s
  }, c) => {
    const p = vt(null);
    return jR(c, () => p.current, []), /* @__PURE__ */B.jsx(JK, {
      ref: p,
      className: ve(Lp.wrapper, t),
      classNames: {
        input: ve(Lp.input, e == null ? void 0 : e.input),
        inputBorder: ve(Lp.border, e == null ? void 0 : e.inputBorder),
        inputError: ve(Lp.inputError, e == null ? void 0 : e.inputError),
        inputErrorText: ve(Lp.helperText, Lp.textError, e == null ? void 0 : e.inputErrorText),
        inputFocus: ve(Lp.inputFocus, e == null ? void 0 : e.inputFocus),
        inputHelperText: ve(Lp.helperText, e == null ? void 0 : e.inputHelperText),
        inputLabel: ve(Lp.inputLabel, e == null ? void 0 : e.inputLabel),
        inputLabelDisabled: ve(Lp.inputLabelDisabled, e == null ? void 0 : e.inputLabelDisabled),
        iconDisable: ve(Lp.inputIcon, e == null ? void 0 : e.iconDisable),
        value: e == null ? void 0 : e.value
      },
      iconOptions: {
        disabled: /* @__PURE__ */B.jsx(ln, {
          className: Lp.icon,
          name: "nope"
        })
      },
      rows: i,
      ...s
    });
  }),
  d_e = "_topTileCard_1gjdl_1",
  f_e = "_topTileCardHeading_1gjdl_30",
  p_e = "_cardButton_1gjdl_50",
  h_e = "_topTileCardDesc_1gjdl_60",
  jM = {
    topTileCard: d_e,
    topTileCardHeading: f_e,
    cardButton: p_e,
    topTileCardDesc: h_e
  },
  m_e = ({
    header: t,
    headerAs: e = "h1",
    children: i,
    button: s,
    className: c,
    renderLink: p
  }) => /* @__PURE__ */B.jsxs("div", {
    className: ve(jM.topTileCard, c),
    children: [/* @__PURE__ */B.jsx(cu, {
      className: jM.topTileCardHeading,
      Tag: e,
      children: t.length >= 50 ? `${t.substring(0, 50)}…` : t
    }), /* @__PURE__ */B.jsx("div", {
      className: jM.topTileCardDesc,
      children: i
    }), /* @__PURE__ */B.jsx(op, {
      className: jM.cardButton,
      as: "a",
      href: s.href,
      renderLink: p,
      children: s.children
    })]
  }),
  v_e = "_topTileContainer_csvuy_1",
  g_e = "_topTileImage_csvuy_15",
  aH = {
    topTileContainer: v_e,
    topTileImage: g_e
  },
  sxe = ({
    image: t,
    className: e,
    classNames: i,
    theme: s = "light",
    header: c,
    headerAs: p,
    children: h,
    button: y,
    renderLink: w
  }) => {
    var x, E, C;
    return /* @__PURE__ */B.jsxs("div", {
      className: ve(aH.topTileContainer, e),
      "data-theme": s,
      children: [/* @__PURE__ */B.jsx(m_e, {
        header: c,
        headerAs: p,
        children: h,
        button: y,
        renderLink: w,
        className: i == null ? void 0 : i.card
      }), /* @__PURE__ */B.jsx("div", {
        className: aH.topTileImage,
        children: /* @__PURE__ */B.jsx(Ym, {
          src: (x = t == null ? void 0 : t.source) == null ? void 0 : x.src,
          srcSet: (E = t == null ? void 0 : t.source) == null ? void 0 : E.srcSet,
          sizes: (C = t == null ? void 0 : t.source) == null ? void 0 : C.sizes,
          alt: t.alt,
          source: t.source,
          loading: "lazy"
        })
      })]
    });
  },
  y_e = "_link_1xyzf_9",
  b_e = "_refreshLink_1xyzf_27",
  w_e = "_refreshText_1xyzf_27",
  __e = "_linkTop_1xyzf_35",
  x_e = "_updatedTitle_1xyzf_48",
  S_e = "_updatedDate_1xyzf_53",
  E_e = "_refreshLinkSpin_1xyzf_76",
  Fx = {
    link: y_e,
    refreshLink: b_e,
    refreshText: w_e,
    linkTop: __e,
    updatedTitle: x_e,
    updatedDate: S_e,
    refreshLinkSpin: E_e
  },
  uxe = ({
    labels: t,
    date: e,
    icon: i,
    isUpdating: s,
    className: c,
    refreshTimestamp: p
  }) => /* @__PURE__ */B.jsxs("button", {
    type: "button",
    onClick: p,
    "aria-label": s ? t.updating : t.refresh,
    className: ve(Fx.link, c),
    children: [/* @__PURE__ */B.jsxs("div", {
      className: Fx.linkTop,
      children: [/* @__PURE__ */B.jsx("p", {
        className: Fx.updatedTitle,
        children: s ? t.updating : t == null ? void 0 : t.lastUpdated
      }), /* @__PURE__ */B.jsx("p", {
        className: Fx.updatedDate,
        children: e
      })]
    }), /* @__PURE__ */B.jsxs("div", {
      className: Fx.refreshLink,
      children: [/* @__PURE__ */B.jsx("p", {
        className: Fx.refreshText,
        children: s ? t.updating : t.refresh
      }), /* @__PURE__ */B.jsx("div", {
        className: s ? Fx.refreshLinkSpin : "",
        children: i || /* @__PURE__ */B.jsx(ln, {
          name: "refresh-micro",
          size: "3xl"
        })
      })]
    })]
  });
export { nxe as $, rS as A, op as B, A_e as C, q_e as D, qT as E, G_e as F, Xne as G, cu as H, ln as I, H_e as J, K_e as K, z_e as L, exe as M, R_e as N, D_e as O, V_e as P, P_e as Q, $_e as R, Y_e as S, Q_e as T, dd as U, T_e as V, Z_e as W, M_e as X, Nhe as Y, J_e as Z, txe as _, U0 as a, RT as a0, p2 as a1, rxe as a2, ixe as a3, Bre as a4, axe as a5, Nme as a6, s2 as a7, wL as a8, tbe as a9, oxe as aa, Lc as ab, mb as ac, GJ as ad, lxe as ae, sxe as af, uxe as ag, $pe as ah, Ene as b, Fee as c, EN as d, ve as e, hB as f, Ym as g, NE as h, gb as i, B as j, N4 as k, M8 as l, O_e as m, PQ as n, U4 as o, j_e as p, F_e as q, LJ as r, tp as s, N_e as t, cee as u, B_e as v, pB as w, U_e as x, H2 as y, W_e as z };